// @ts-nocheck
import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client/react';
// Apollo v4 compatibility: MutationFunction and BaseMutationOptions moved out of /react
type ApolloMutationFunction<TData, TVariables> = import('@apollo/client').MutationFunction<
  TData,
  TVariables
>;
type ApolloBaseMutationOptions<
  TData,
  TVariables,
  TContext = Apollo.DefaultContext,
> = import('@apollo/client').BaseMutationOptions<TData, TVariables>;

import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: { input: string; output: string };
  /** A scalar that can represent any JSON value. */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
  /** A scalar that can represent any JSON Object value. */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown> };
  /**
   * ISO 8601 calendar date without timezone.
   * Format: %Y-%m-%d
   *
   * # Examples
   *
   * * `1994-11-13`
   * * `2000-02-24`
   */
  NaiveDate: { input: string; output: string };
};

/** GraphQL output type for AI decision statistics. */
export type AiDecisionStats = {
  __typename?: 'AIDecisionStats';
  /** Average confidence score */
  avgConfidence: Scalars['Float']['output'];
  /** Average tokens per decision */
  avgTokensPerDecision: Scalars['Int']['output'];
  /** High confidence count (>0.9) */
  highConfidenceCount: Scalars['Int']['output'];
  /** Low confidence count (<0.7) */
  lowConfidenceCount: Scalars['Int']['output'];
  /** Medium confidence count (0.7-0.9) */
  mediumConfidenceCount: Scalars['Int']['output'];
  /** Total AI decisions */
  totalDecisions: Scalars['Int']['output'];
  /** Total tokens used */
  totalTokensUsed: Scalars['Int']['output'];
  /** Workflow instance ID */
  workflowInstanceId: Scalars['String']['output'];
};

/** AI-generated suggestion for journey next steps. */
export type AiSuggestion = {
  __typename?: 'AISuggestion';
  /** Optional action data (task ID, form fields, etc.) */
  actionData?: Maybe<Scalars['JSON']['output']>;
  /** Optional action type if suggestion is actionable */
  actionType?: Maybe<Scalars['String']['output']>;
  /** Confidence score (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** Detailed description */
  description: Scalars['String']['output'];
  /** Unique suggestion ID */
  id: Scalars['String']['output'];
  /** Priority: "high", "medium", "low" */
  priority: Scalars['String']['output'];
  /** Suggestion type: "action", "insight", "warning", "reminder" */
  suggestionType: Scalars['String']['output'];
  /** Short title for the suggestion */
  title: Scalars['String']['output'];
};

/** Input for accepting a settlement proposal with counterparty reconciliation */
export type AcceptSettlementProposalInput = {
  /** Settlement proposal ID to accept */
  proposalId: Scalars['String']['input'];
  /** Blake3 hash of the counterparty's aggregated transaction data */
  reconciliationHash: Scalars['String']['input'];
};

/** Document access level (RBAC) - matches backend AccessLevel */
export const AccessLevel = {
  /** Only creator can access */
  OWNER: 'OWNER',
  /** Anyone can access */
  PUBLIC: 'PUBLIC',
  /** Only team members (requires team_id) */
  TEAM: 'TEAM',
  /** Any user in tenant */
  TENANT: 'TENANT',
} as const;

export type AccessLevel = (typeof AccessLevel)[keyof typeof AccessLevel];
export const AccessLevelGql = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
  TENANT: 'TENANT',
} as const;

export type AccessLevelGql = (typeof AccessLevelGql)[keyof typeof AccessLevelGql];
/** Accumulation status for GraphQL */
export const AccumulationStatusGql = {
  ACTIVE: 'ACTIVE',
  INITIALIZING: 'INITIALIZING',
  PAUSED: 'PAUSED',
  REBUILDING: 'REBUILDING',
} as const;

export type AccumulationStatusGql =
  (typeof AccumulationStatusGql)[keyof typeof AccumulationStatusGql];
/** Accumulator summary for GraphQL */
export type AccumulatorSummaryGql = {
  __typename?: 'AccumulatorSummaryGql';
  avgConfidence: Scalars['Float']['output'];
  daysSinceAssessment: Scalars['Int']['output'];
  fieldsWithDrift: Scalars['Int']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  majorDriftFields: Scalars['Int']['output'];
  residentId: Scalars['String']['output'];
  status: AccumulationStatusGql | '%future added value';
  totalFields: Scalars['Int']['output'];
};

/** A participant in a ruleset acknowledgment signing ceremony. */
export type AcknowledgmentParticipantInput = {
  /** Participant's email address (for ceremony invitation) */
  email: Scalars['String']['input'];
  /** Participant's full name (displayed on signature line) */
  name: Scalars['String']['input'];
  /** Role in the acknowledgment: "reviewer", "approver", or "administrator" */
  role: Scalars['String']['input'];
};

/**
 * Represents an available action (mutation) that can be performed on a workflow
 *
 * ## Design Principles
 *
 * - **Server-Driven**: Actions are determined by backend based on:
 * - Current workflow state (FSM)
 * - User permissions (RBAC)
 * - Business rules (from DynamoDB config)
 *
 * - **Frontend Rendering**: Frontend simply renders what backend provides
 * - No hardcoded action logic in UI
 * - Same component works for ALL workflow types
 *
 * ## Example
 *
 * ```json
 * {
 * "name": "cancelNotification",
 * "description": "Cancel this scheduled notification",
 * "mutation": "cancelNotification",
 * "requiresConfirmation": true,
 * "requiresPermission": ["tax_notifications:cancel"],
 * "icon": "cancel",
 * "variant": "danger"
 * }
 * ```
 */
export type Action = {
  __typename?: 'Action';
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Optional icon name for UI rendering */
  icon?: Maybe<Scalars['String']['output']>;
  /** GraphQL mutation name to execute */
  mutation: Scalars['String']['output'];
  /** Action name (used as button label) */
  name: Scalars['String']['output'];
  /** Prerequisites that must be met before action can be executed */
  prerequisites: Array<ActionPrerequisite>;
  /** Whether to show confirmation dialog before executing */
  requiresConfirmation: Scalars['Boolean']['output'];
  /** Required permissions to execute this action */
  requiresPermission: Array<Scalars['String']['output']>;
  /** Button variant (primary, secondary, danger, success) */
  variant?: Maybe<Scalars['String']['output']>;
};

/** Action Count (GraphQL output) */
export type ActionCount = {
  __typename?: 'ActionCount';
  /** Action type */
  action: Scalars['String']['output'];
  /** Count */
  count: Scalars['Int']['output'];
};

/** Action definition for workflow automation. */
export type ActionDefinition = {
  __typename?: 'ActionDefinition';
  /** Type of action */
  actionType: GqlActionType | '%future added value';
  /** Action-specific configuration (JSON) */
  configuration: Scalars['JSON']['output'];
};

/** Action entry (key-value pair for HashMap). */
export type ActionEntry = {
  __typename?: 'ActionEntry';
  /** Action definition (value) */
  definition: ActionDefinition;
  /** Action name (key) */
  name: Scalars['String']['output'];
};

/**
 * Represents a prerequisite condition that must be met before an action can be executed
 *
 * ## Use Cases
 *
 * - **Life-Critical Workflows**: "Dual control required" (2+ approvals)
 * - **Compliance**: "HIPAA training completed"
 * - **Business Logic**: "Confidence score >= 0.95"
 *
 * ## Example
 *
 * ```json
 * {
 * "field": "confidence.overall",
 * "operator": "greater_than",
 * "value": "0.95",
 * "description": "High confidence required for auto-approval"
 * }
 * ```
 */
export type ActionPrerequisite = {
  __typename?: 'ActionPrerequisite';
  /** Human-readable description of prerequisite */
  description: Scalars['String']['output'];
  /** Field to check (e.g., "confidence.overall", "approval_count") */
  field: Scalars['String']['output'];
  /** Comparison operator (equals, not_equals, greater_than, less_than, contains, regex) */
  operator: Scalars['String']['output'];
  /** Value to compare against */
  value: Scalars['String']['output'];
};

/** A work item that needs action. */
export type ActionableItem = {
  __typename?: 'ActionableItem';
  /** Reason action is needed */
  actionReason: Scalars['String']['output'];
  /** The work item */
  item: ShiftWorkItem;
  /** Suggested action */
  suggestedAction?: Maybe<Scalars['String']['output']>;
  /** Time remaining before escalation (seconds, if applicable) */
  timeUntilEscalation?: Maybe<Scalars['Int']['output']>;
  /** Urgency level (1-5, 1 = most urgent) */
  urgency: Scalars['Int']['output'];
};

/** Input for activating a definition */
export type ActivateDefinitionInput = {
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/**
 * Result of activating features (subgraphs) for a tenant.
 *
 * Returned by the `activateFeatures` mutation.
 */
export type ActivateFeaturesResult = {
  __typename?: 'ActivateFeaturesResult';
  /** Feature IDs that were activated */
  activatedFeatures: Array<Scalars['String']['output']>;
  /** Any errors encountered during activation */
  errors: Array<Scalars['String']['output']>;
  /** Whether a product bundle was also applied */
  productApplied: Scalars['Boolean']['output'];
  /** Whether the activation completed successfully */
  success: Scalars['Boolean']['output'];
};

/** DRR-172: A coverage gap found during product activation. */
export type ActivationCoverageGap = {
  __typename?: 'ActivationCoverageGap';
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Rule with no downstream config */
  ruleId: Scalars['String']['output'];
  /** Rule name */
  ruleName: Scalars['String']['output'];
  /** Ruleset containing the uncovered rule */
  rulesetId: Scalars['String']['output'];
  /** Statute section reference */
  sectionRef?: Maybe<Scalars['String']['output']>;
};

/** Active lens configuration for a tenant/setting. */
export type ActiveLens = {
  __typename?: 'ActiveLens';
  /** Lens ID */
  lensId: Scalars['String']['output'];
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Which phase this lens operates in */
  phase: LensPhase | '%future added value';
  /** Safety level */
  safetyLevel: LensSafetyLevel | '%future added value';
  /** Vertical this lens applies to */
  vertical: Scalars['String']['output'];
};

/** Activity domain within a plan (ADL, Billable Matter, Work Package, Cost Center) */
export type ActivityDomain = {
  __typename?: 'ActivityDomain';
  /** Category for grouping (e.g., "daily_living", "mobility") */
  category?: Maybe<Scalars['String']['output']>;
  /** Domain identifier */
  domainId: Scalars['String']['output'];
  /** Domain display name */
  domainName: Scalars['String']['output'];
  /** Observations or notes for this domain */
  observations: Array<Scalars['String']['output']>;
};

export type Actor = {
  __typename?: 'Actor';
  accessLevel?: Maybe<Scalars['String']['output']>;
  accuracyOnTestSet?: Maybe<Scalars['Float']['output']>;
  active: Scalars['Boolean']['output'];
  /**
   * Composite user ID from ferp-identity registry (e.g., "0_2" = tenant 0, user 2).
   * DRR-124: Internal ID — sequential format embeds tenant_num.
   */
  actorGlobalId?: Maybe<Scalars['String']['output']>;
  actorType: GqlActorType | '%future added value';
  assignedTaskIds: Array<Scalars['String']['output']>;
  auditVersion: Scalars['Int']['output'];
  /**
   * Auth user ID — external auth system reference.
   * In dev: "17-ald-001". In prod: Authentik UUID.
   * Used by FhirClinicalPanel for subject matching (Patient/{authUserId}).
   * Safe to expose: in production this is an opaque Authentik UUID.
   */
  authUserId?: Maybe<Scalars['String']['output']>;
  autonomyLevel?: Maybe<Scalars['String']['output']>;
  available: Scalars['Boolean']['output'];
  averageConfidence?: Maybe<Scalars['Float']['output']>;
  avgCompletionTimeSeconds?: Maybe<Scalars['Int']['output']>;
  avgTaskResolutionMinutes?: Maybe<Scalars['Int']['output']>;
  avgTaskResponseMinutes?: Maybe<Scalars['Int']['output']>;
  backoffMultiplier?: Maybe<Scalars['Float']['output']>;
  backoffSeconds?: Maybe<Scalars['Int']['output']>;
  capabilities: Array<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  certifications: Array<Scalars['String']['output']>;
  circuitBreakerFailureCount: Scalars['Int']['output'];
  circuitBreakerOpen: Scalars['Boolean']['output'];
  circuitBreakerOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  circuitBreakerResetCount: Scalars['Int']['output'];
  circuitBreakerThreshold: Scalars['Int']['output'];
  circuitBreakerTimeoutSeconds?: Maybe<Scalars['Int']['output']>;
  completedTasksLast24h: Scalars['Int']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this actor.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  configuration: Scalars['JSON']['output'];
  contactInfo?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  criticalityLevel?: Maybe<Scalars['String']['output']>;
  currentTaskId?: Maybe<Scalars['String']['output']>;
  currentWorkflowId?: Maybe<Scalars['String']['output']>;
  deprecated: Scalars['Boolean']['output'];
  deprecationDate?: Maybe<Scalars['DateTime']['output']>;
  deprecationReason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  dualControlCapable: Scalars['Boolean']['output'];
  expertTier?: Maybe<Scalars['String']['output']>;
  failedTasksLast24h: Scalars['Int']['output'];
  formulaParticipation: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instanceName?: Maybe<Scalars['String']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  lastAssignedBy?: Maybe<Scalars['String']['output']>;
  lastAssignmentType?: Maybe<Scalars['String']['output']>;
  lastModifiedReason?: Maybe<Scalars['String']['output']>;
  lastStatusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusChangeReason?: Maybe<Scalars['String']['output']>;
  licenseJurisdiction?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  maxBackoffSeconds?: Maybe<Scalars['Int']['output']>;
  maxCapacity: Scalars['Int']['output'];
  maxConcurrency?: Maybe<Scalars['Int']['output']>;
  maxRetries?: Maybe<Scalars['Int']['output']>;
  metadata: Scalars['JSON']['output'];
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Stable ID across all versions (append-only tracking) */
  originalId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  peakWorkload: Scalars['Int']['output'];
  preferences?: Maybe<Scalars['JSON']['output']>;
  primaryRoleId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  queueIds: Array<Scalars['String']['output']>;
  /** Numeric version for append-only tracking */
  recordVersion: Scalars['Int']['output'];
  regulatoryClearance: Array<Scalars['String']['output']>;
  regulatoryTags: Array<Scalars['String']['output']>;
  requiredPermissions: Array<Scalars['String']['output']>;
  requiresDualControl?: Maybe<Scalars['Boolean']['output']>;
  requiresHumanOversight: Scalars['Boolean']['output'];
  requiresSupervision: Scalars['Boolean']['output'];
  /**
   * DRR-103: Resolved scopes from Actor's role_ids via RoleScopeMap.
   *
   * Resolves the Actor → role_ids → Role YAML configs → scopes chain.
   * Returns deduplicated list of all scopes granted by the actor's assigned roles.
   *
   * This is the runtime scope resolution chain:
   * 1. Actor has role_ids: ["uap-alf", "billing-alf"]
   * 2. RoleScopeMap looks up each role in loaded YAML configs
   * 3. Returns merged, deduplicated scopes
   * DRR-103: Guarded — requires staff:manage scope to enumerate another actor's scopes.
   * Prevents privilege escalation discovery (e.g., CNA learning billing-alf has claims:submit).
   */
  resolvedScopes: Array<Scalars['String']['output']>;
  retentionYears?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  /**
   * DRR-103: Multiple Role config IDs for scope resolution.
   * Maps to Role YAML configs (e.g., ["uap-alf", "billing-alf"]).
   */
  roleIds: Array<Scalars['String']['output']>;
  specializations: Array<Scalars['String']['output']>;
  status: GqlActorStatus | '%future added value';
  successRate?: Maybe<Scalars['Float']['output']>;
  supervisedByActorId?: Maybe<Scalars['String']['output']>;
  supervisorId?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  taskCompletionRate?: Maybe<Scalars['Float']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  /** DRR-124: Internal ID — hidden from default views, visible to platform architects only. */
  tenantId: Scalars['String']['output'];
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
  totalTasksCompleted: Scalars['Int']['output'];
  totalTasksFailed: Scalars['Int']['output'];
  totalTimeActiveSeconds: Scalars['Int']['output'];
  totalTimeIdleSeconds: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
  workflowInstanceId?: Maybe<Scalars['String']['output']>;
  workload: Scalars['Int']['output'];
  yearsExperience?: Maybe<Scalars['Int']['output']>;
};

/**
 * Result type for Actor archive operation
 *
 * Returned by `archiveActor` mutation. Contains full audit metadata
 * for compliance (HIPAA, SOX, SOC2).
 *
 * # Issue #671: Append-Only Architecture
 *
 * This replaces `deleteActor` to ensure complete audit trails.
 */
export type ActorArchiveResult = {
  __typename?: 'ActorArchiveResult';
  /** Actor ID that was archived */
  actorId: Scalars['String']['output'];
  /** Timestamp when the actor was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** User ID who performed the archive */
  archivedBy: Scalars['String']['output'];
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Mandatory reason for archiving (audit compliance) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Input Types for Actor Management */
export type ActorConfig = {
  /** Actor type identifier */
  actorType: ActorType | '%future added value';
  /** Configuration parameters */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Drop oldest messages when mailbox full */
  dropOldest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable persistent snapshots */
  enableSnapshots?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mailbox capacity */
  mailboxCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Actor instance name/identifier */
  name: Scalars['String']['input'];
  /** Resource limits */
  resourceLimits?: InputMaybe<ActorResourceLimits>;
  /** Snapshot interval in seconds */
  snapshotIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Supervision strategy */
  supervision?: InputMaybe<SupervisionStrategyInput>;
  /** Tenant context */
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A single constellation the actor participates in, with their ring + edge type.
 * Returned by constellationsByActor — enables an actor to discover which constellations
 * they are a member of without querying all constellations.
 *
 * DRR-102: Backend-computed membership — actor cannot fake their ring position.
 */
export type ActorConstellationMembership = {
  __typename?: 'ActorConstellationMembership';
  /** Constellation instance ID */
  constellationId: Scalars['String']['output'];
  /** Edge type (e.g., "COORDINATED_BY", "PARTICIPATES", "AUTHORIZED_BY") */
  edgeType: Scalars['String']['output'];
  /** Ring number the actor belongs to (1=participants, 2=authorities, 3=deliverables, 4=regulatory) */
  ring: Scalars['Int']['output'];
  /** Actor's role in this constellation (e.g., "DON", "CNA", "ALD") */
  role: Scalars['String']['output'];
};

/**
 * All constellations an actor participates in, organized by ring.
 * Used to surface the actor's constellation context at login / dashboard load.
 */
export type ActorConstellationMemberships = {
  __typename?: 'ActorConstellationMemberships';
  /** Actor whose memberships these are */
  actorId: Scalars['String']['output'];
  /** Convenience: constellation IDs only (for loading task summaries) */
  constellationIds: Array<Scalars['String']['output']>;
  /** All constellations where this actor appears in any ring */
  memberships: Array<ActorConstellationMembership>;
};

export type ActorDeploymentResult = {
  __typename?: 'ActorDeploymentResult';
  actorId: Scalars['String']['output'];
  configurationApplied: Scalars['Boolean']['output'];
  deployedAt: Scalars['DateTime']['output'];
  deploymentId: Scalars['String']['output'];
  deploymentTimeMs: Scalars['Int']['output'];
  healthCheckPassed: Scalars['Boolean']['output'];
  resultMessage?: Maybe<Scalars['String']['output']>;
  snapshotRestored: Scalars['Boolean']['output'];
  status: DeploymentStatus | '%future added value';
};

/** Actor filter input */
export type ActorFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  actorType?: InputMaybe<Scalars['String']['input']>;
  availabilityStatus?: InputMaybe<Scalars['String']['input']>;
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  expertTier?: InputMaybe<Scalars['String']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  minCapacity?: InputMaybe<Scalars['Int']['input']>;
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Actor primitive from FERP 16-type system - for expert management */
export type ActorGql = {
  __typename?: 'ActorGql';
  active: Scalars['Boolean']['output'];
  actorType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Output Types for Actor Management */
export type ActorInfo = {
  __typename?: 'ActorInfo';
  actorId: Scalars['String']['output'];
  actorType: ActorType | '%future added value';
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  resourceUsage?: Maybe<ActorResourceUsage>;
  snapshotInfo?: Maybe<ActorSnapshotInfo>;
  stats: ActorStatsResult;
  status: ActorStatus | '%future added value';
  supervision: SupervisionStrategyResult;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type ActorMessage = {
  /** Target actor ID */
  actorId: Scalars['String']['input'];
  /** Message expiration time */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Message payload as JSON */
  payload: Scalars['JSON']['input'];
  /** Message priority (0-10, higher = more priority) */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type ActorMetrics = {
  __typename?: 'ActorMetrics';
  actorId: Scalars['String']['output'];
  cpuUsagePercent: Scalars['Float']['output'];
  errorCount: Scalars['Int']['output'];
  mailboxSize: Scalars['Int']['output'];
  memoryUsageBytes: Scalars['Int']['output'];
  messagesProcessed: Scalars['Int']['output'];
  processingTimeMs: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ActorResourceLimits = {
  /** Maximum CPU percentage (0-100) */
  maxCpuPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum memory usage in bytes */
  maxMemoryBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum message processing rate per second */
  maxMessagesPerSecond?: InputMaybe<Scalars['Int']['input']>;
  /** Timeout for message processing in milliseconds */
  messageTimeoutMs?: InputMaybe<Scalars['Int']['input']>;
};

export type ActorResourceUsage = {
  __typename?: 'ActorResourceUsage';
  cpuPercent: Scalars['Float']['output'];
  diskBytesRead: Scalars['Int']['output'];
  diskBytesWritten: Scalars['Int']['output'];
  lastMeasuredAt: Scalars['DateTime']['output'];
  memoryBytes: Scalars['Int']['output'];
  networkBytesReceived: Scalars['Int']['output'];
  networkBytesSent: Scalars['Int']['output'];
};

/** Actor Security Information - Life-Critical Access Control */
export type ActorSecurity = {
  __typename?: 'ActorSecurity';
  /** Actor unique identifier */
  actorId: Scalars['String']['output'];
  /** Biometric verification enabled */
  biometricEnabled: Scalars['Boolean']['output'];
  /** Biometric verified timestamp */
  biometricVerifiedAt?: Maybe<Scalars['String']['output']>;
  /** Certification level */
  certificationLevel: Scalars['String']['output'];
  /** Emergency access enabled */
  emergencyAccess: Scalars['Boolean']['output'];
  /** Emergency access log entries */
  emergencyAccessLog: Array<EmergencyAccessEvent>;
  /** Last security review timestamp */
  lastSecurityReview: Scalars['String']['output'];
  /** MFA enabled */
  mfaEnabled: Scalars['Boolean']['output'];
  /** MFA verified timestamp */
  mfaVerifiedAt?: Maybe<Scalars['String']['output']>;
  /** Security level (standard, elevated, life-critical) */
  securityLevel: Scalars['String']['output'];
};

export type ActorSnapshotInfo = {
  __typename?: 'ActorSnapshotInfo';
  enabled: Scalars['Boolean']['output'];
  lastSnapshotAt?: Maybe<Scalars['DateTime']['output']>;
  snapshotIntervalSeconds: Scalars['Int']['output'];
  snapshotSizeBytes?: Maybe<Scalars['Int']['output']>;
  snapshotSuccessRate: Scalars['Float']['output'];
  totalSnapshots: Scalars['Int']['output'];
};

export type ActorStatsGql = {
  __typename?: 'ActorStatsGql';
  backoffBaseMs?: Maybe<Scalars['Int']['output']>;
  blockedUntilMs?: Maybe<Scalars['Int']['output']>;
  capacity: Scalars['Int']['output'];
  dropOldest: Scalars['Boolean']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  mailboxLen: Scalars['Int']['output'];
  maxRestarts?: Maybe<Scalars['Int']['output']>;
  restartCount: Scalars['Int']['output'];
  snapshotSize?: Maybe<Scalars['Int']['output']>;
  snapshotTsMs?: Maybe<Scalars['Int']['output']>;
  stopped: Scalars['Boolean']['output'];
  strategy: Scalars['String']['output'];
};

export type ActorStatsResult = {
  __typename?: 'ActorStatsResult';
  averageProcessingTimeMs: Scalars['Float']['output'];
  blockedUntilMs?: Maybe<Scalars['Int']['output']>;
  capacity: Scalars['Int']['output'];
  dropOldest: Scalars['Boolean']['output'];
  errorRate: Scalars['Float']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  mailboxLen: Scalars['Int']['output'];
  messagesPerSecond: Scalars['Float']['output'];
  restartCount: Scalars['Int']['output'];
  stopped: Scalars['Boolean']['output'];
  totalMessagesProcessed: Scalars['Int']['output'];
  uptimeSeconds: Scalars['Int']['output'];
};

export const ActorStatus = {
  /** Actor is blocked/waiting */
  blocked: 'blocked',
  /** Actor is in error state */
  error: 'error',
  /** Actor is in maintenance mode */
  maintenance: 'maintenance',
  /** Actor is being restarted */
  restarting: 'restarting',
  /** Actor is running normally */
  running: 'running',
  /** Actor is starting up */
  starting: 'starting',
  /** Actor has stopped */
  stopped: 'stopped',
  /** Actor is stopping */
  stopping: 'stopping',
} as const;

export type ActorStatus = (typeof ActorStatus)[keyof typeof ActorStatus];
/** Subscription event types */
export type ActorStatusEvent = {
  __typename?: 'ActorStatusEvent';
  actorId: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  newStatus: ActorStatus | '%future added value';
  oldStatus: ActorStatus | '%future added value';
  reason?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

/**
 * Lightweight actor reference for user-facing display (DRR-124).
 *
 * Replaces raw actor ID strings (`2_2`, `17-ald-001`) in GraphQL responses
 * with human-readable summaries. Used by Task.assignedActor, Task.createdByActor, etc.
 *
 * ## Usage
 * ```rust
 * use crate::shared_graphql_types::GqlActorSummary;
 * ```
 */
export type ActorSummary = {
  __typename?: 'ActorSummary';
  /** Human-readable actor name (e.g., "Ald Tenantsson") */
  displayName: Scalars['String']['output'];
  /** Opaque Snowflake ID (safe to display) */
  id: Scalars['String']['output'];
  /** Actor's primary role (e.g., "Administrator", "Director of Nursing") */
  role?: Maybe<Scalars['String']['output']>;
};

export type ActorSystemHealth = {
  __typename?: 'ActorSystemHealth';
  cpuUsagePercent: Scalars['Float']['output'];
  errorActors: Scalars['Int']['output'];
  lastCheckAt: Scalars['DateTime']['output'];
  memoryUsageBytes: Scalars['Int']['output'];
  messagesPerSecond: Scalars['Float']['output'];
  performanceMetrics: ActorSystemPerformance;
  restartingActors: Scalars['Int']['output'];
  runningActors: Scalars['Int']['output'];
  stoppedActors: Scalars['Int']['output'];
  systemUptimeSeconds: Scalars['Int']['output'];
  totalActors: Scalars['Int']['output'];
  totalMessagesProcessed: Scalars['Int']['output'];
};

export type ActorSystemPerformance = {
  __typename?: 'ActorSystemPerformance';
  averageMailboxSize: Scalars['Float']['output'];
  errorRate: Scalars['Float']['output'];
  latencyP50Ms: Scalars['Float']['output'];
  latencyP95Ms: Scalars['Float']['output'];
  latencyP99Ms: Scalars['Float']['output'];
  maxMailboxSize: Scalars['Int']['output'];
  throughputMessagesPerSecond: Scalars['Float']['output'];
  totalRestarts: Scalars['Int']['output'];
};

export const ActorType = {
  /** Audit log processor actor */
  auditProcessor: 'auditProcessor',
  /** Broadcast handler actor */
  broadcastHandler: 'broadcastHandler',
  /** Custom business logic actor */
  customBusinessLogic: 'customBusinessLogic',
  /** Integration connector actor */
  integrationConnector: 'integrationConnector',
  /** JSON logging actor for debugging */
  jsonLog: 'jsonLog',
  /** Metrics collection actor */
  metricsCollector: 'metricsCollector',
  /** Persistence handler actor */
  persistenceHandler: 'persistenceHandler',
  /** Snapshot management actor */
  snapshotManager: 'snapshotManager',
  /** Workflow execution actor */
  workflowTick: 'workflowTick',
} as const;

export type ActorType = (typeof ActorType)[keyof typeof ActorType];
/** Actor view */
export type ActorView = {
  __typename?: 'ActorView';
  actorType: Scalars['String']['output'];
  capabilities: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ActorsRuntimeInfoGql = {
  __typename?: 'ActorsRuntimeInfoGql';
  hostingEnabled: Scalars['Boolean']['output'];
  pollerLagMs: Scalars['Int']['output'];
  tickBatch: Scalars['Int']['output'];
};

/** Input for adding a component reference to a workflow definition */
export type AddComponentInput = {
  componentType: Scalars['String']['input'];
  config?: InputMaybe<Scalars['JSON']['input']>;
  executionMode: Scalars['String']['input'];
  inputMap?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  outputMap?: InputMaybe<Scalars['JSON']['input']>;
  versionPin: Scalars['String']['input'];
  workflowId: Scalars['ID']['input'];
};

/** Input for adding a provider to track */
export type AddProviderInput = {
  fax?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  providerName: Scalars['String']['input'];
  providerType: Scalars['String']['input'];
  trackerId: Scalars['String']['input'];
};

/** Input for adding a scope edge. */
export type AddScopeEdgeInput = {
  /** Relationship type */
  edgeType: ScopeEdgeType | '%future added value';
  /**
   * Optional edge metadata — DRR-179: spatial coordinates `{x, y, floor}` for LOCATED_AT edges.
   * Stored as JSON on the DDB edge record. Null for edges without metadata.
   */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Source actor ID (parent) */
  sourceActorId: Scalars['String']['input'];
  /** Target actor ID (child) */
  targetActorId: Scalars['String']['input'];
};

/** Add feature to subgraph input */
export type AddSubgraphFeatureInput = {
  /** Feature to enable */
  feature: Scalars['String']['input'];
  /** Subgraph identifier */
  subgraphName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Primitive that was added by auto-fix */
export type AddedPrimitive = {
  __typename?: 'AddedPrimitive';
  /** What it was linked to (if applicable) */
  linkedTo?: Maybe<Scalars['String']['output']>;
  /** Generated ID for the new primitive */
  primitiveId: Scalars['String']['output'];
  /** Type of primitive added */
  primitiveType: Scalars['String']['output'];
};

/** Dosage information for medication administration */
export type AdministrationDosage = {
  __typename?: 'AdministrationDosage';
  /** Dose unit */
  doseUnit?: Maybe<Scalars['String']['output']>;
  /** Dose value */
  doseValue?: Maybe<Scalars['Float']['output']>;
  /** Route of administration */
  route?: Maybe<Scalars['String']['output']>;
  /** Human-readable dosage text */
  text?: Maybe<Scalars['String']['output']>;
};

/** Adoption chain showing how regulations flow from federal to state. */
export type AdoptionChain = {
  __typename?: 'AdoptionChain';
  /** Administrative rule that implements */
  adminRule?: Maybe<Scalars['String']['output']>;
  /** Description of the adoption mechanism */
  adoptionMechanism?: Maybe<Scalars['String']['output']>;
  /** Federal CFR being adopted */
  federalCfr?: Maybe<Scalars['String']['output']>;
  /** Reference to the federal survey form */
  federalFormRef?: Maybe<Scalars['String']['output']>;
  /** Federal survey instrument (e.g., "CMS Appendix Z") */
  federalInstrument?: Maybe<Scalars['String']['output']>;
  /** State statute that adopts the CFR */
  stateStatute?: Maybe<Scalars['String']['output']>;
};

/** Input for adopting or dismissing a recommendation. */
export type AdoptionDecisionInput = {
  /** Actor ID of the person making the decision. */
  decidedBy: Scalars['String']['input'];
  /** Decision: ADOPTED or DISMISSED. */
  decision: GqlAdoptionStatus | '%future added value';
  /** Reason for dismissal (required when decision = DISMISSED). */
  dismissReason?: InputMaybe<Scalars['String']['input']>;
  /** Advisory RuleSet config ID (e.g., "rs-4-16-001"). */
  practiceRef: Scalars['String']['input'];
  /** Tenant number making the decision. */
  tenantNum: Scalars['Int']['input'];
};

/** Result of an adoption decision. */
export type AdoptionDecisionResult = {
  __typename?: 'AdoptionDecisionResult';
  /** Audit event ID for traceability. */
  auditEventId?: Maybe<Scalars['String']['output']>;
  /** The decision that was recorded. */
  decision: GqlAdoptionStatus | '%future added value';
  /** The practice that was decided on. */
  practiceRef: Scalars['String']['output'];
  /** Whether the decision was recorded. */
  success: Scalars['Boolean']['output'];
};

/**
 * Anonymized adoption insights for a practice (DRR-156 Phase 5 / DRR-148).
 *
 * System-level aggregation with k-anonymity. No tenant identifiers.
 * Industry-agnostic: segment derived from Product industry+jurisdiction.
 */
export type AdoptionInsights = {
  __typename?: 'AdoptionInsights';
  /** Number of tenants that adopted this practice. */
  adoptionCount: Scalars['Int']['output'];
  /** Adoption rate (0.0 - 1.0). None if suppressed by k-anonymity. */
  adoptionRate?: Maybe<Scalars['Float']['output']>;
  /** Minimum segment size for results (DRR-148: k >= 5). */
  kThreshold: Scalars['Int']['output'];
  /**
   * Average outcome improvement for adopters (e.g., "15% fewer falls").
   * None if insufficient data or suppressed.
   */
  outcomeImprovement?: Maybe<Scalars['String']['output']>;
  /** Advisory RuleSet config ID. */
  practiceRef: Scalars['String']['output'];
  /** Human-readable segment description (e.g., "MN Assisted Living facilities"). */
  segmentDescription: Scalars['String']['output'];
  /** Number of tenants in this segment with the practice available. */
  segmentSize: Scalars['Int']['output'];
  /** True if results suppressed because segment_size < k_threshold. */
  suppressedByKAnonymity: Scalars['Boolean']['output'];
};

/** Impact of an advisory on an existing statutory definition. */
export type AdvisoryImpact = {
  __typename?: 'AdvisoryImpact';
  /** Context (e.g., "dementia_care") */
  context?: Maybe<Scalars['String']['output']>;
  /** Current display term */
  currentDisplay?: Maybe<Scalars['String']['output']>;
  /** Definition affected (tag:def:* ID) */
  definitionRef?: Maybe<Scalars['String']['output']>;
  /** Impact type (e.g., "expanded_scope", "additional_requirement") */
  impactType?: Maybe<Scalars['String']['output']>;
  /** Rationale for the recommendation */
  rationale?: Maybe<Scalars['String']['output']>;
  /** Suggested replacement term */
  suggestedDisplay?: Maybe<Scalars['String']['output']>;
};

/** An LLM-generated advisory recommendation. */
export type AdvisoryRecommendation = {
  __typename?: 'AdvisoryRecommendation';
  /** Source authority */
  authority?: Maybe<Scalars['String']['output']>;
  /** Category: terminology_trend, legislative_forecast, regulatory_forecast */
  category: Scalars['String']['output'];
  /** Confidence score (0.0–1.0) */
  confidence: Scalars['Float']['output'];
  /** Description of the recommendation */
  description: Scalars['String']['output'];
  /** Source document reference */
  document?: Maybe<Scalars['String']['output']>;
  /** When the recommendation takes effect (null = not yet law) */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Advisory ID (e.g., "tag:advisory:cms-person-centered-language") */
  id: Scalars['String']['output'];
  /** Impacts on existing definitions */
  impacts: Array<AdvisoryImpact>;
  /** Human-readable label */
  label: Scalars['String']['output'];
  /** When the source was published */
  publishedDate?: Maybe<Scalars['String']['output']>;
  /** Status: draft, architect_review, approved, expired */
  status: Scalars['String']['output'];
};

/**
 * T2 Advocacy aggregate — system partition (`PK = ~0`).
 *
 * ## NEVER ALLOW (DRR-148 NEVER ALLOW rule)
 *
 * - DO NOT add `String` fields to this struct — enum and u32 only
 * - DO NOT add `tenant_id`, `actor_id`, `narrative`, or any tenant-identifying field
 * - This struct IS the T1/T2 type firewall (H3) — the Rust compiler enforces it
 *
 * ## Fields
 *
 * Every field is either an enum variant or a u32 count. No String fields.
 * No narrative. No identifying information. This struct cannot carry tenant data
 * by construction — not by policy.
 */
export type AdvocacyDocument = {
  __typename?: 'AdvocacyDocument';
  /** Impact severity — enum, not free-text (H3) */
  impactSeverity: Scalars['String']['output'];
  /** Impact area — enum, not free-text (H3) */
  impactType: Scalars['String']['output'];
  /** Regulation/RuleSet identifier (e.g., "rs-4-1-005") */
  regulationId: Scalars['String']['output'];
  /** Whether this specific bucket was suppressed due to k-anonymity */
  suppressed: Scalars['Boolean']['output'];
  /**
   * Number of buckets suppressed across this regulation due to insufficient cohort size.
   * Discloses THAT suppression occurred, not WHICH buckets were suppressed.
   */
  suppressedBucketCount: Scalars['Int']['output'];
  /** Number of opt-in tenants contributing to this bucket (≥ K_ANONYMITY_THRESHOLD) */
  tenantCount: Scalars['Int']['output'];
};

/** Aggregate result of `generateAdvocacyPosition` — returned to the caller. */
export type AdvocacyPosition = {
  __typename?: 'AdvocacyPosition';
  /** Number of opt-in tenants whose feedback was considered */
  contributingTenantCount: Scalars['Int']['output'];
  /** Whether all buckets were suppressed (no publishable positions) */
  fullySuppressed: Scalars['Boolean']['output'];
  /** Published advocacy positions (k-anonymity satisfied) */
  positions: Array<AdvocacyDocument>;
  /** The RuleSet ID that was aggregated */
  rulesetId: Scalars['String']['output'];
  /** Number of buckets suppressed (k-anonymity, insufficient cohort size) */
  suppressedBucketCount: Scalars['Int']['output'];
};

/** Affected entity (patient, account, document, workflow, etc.) */
export type AffectedEntity = {
  __typename?: 'AffectedEntity';
  /** Entity ID */
  entityId: Scalars['String']['output'];
  /** Entity type (Patient, Account, Document, Workflow, Transaction, etc.) */
  entityType: Scalars['String']['output'];
  /** Impact level on this entity (Critical, High, Medium, Low) */
  impactLevel: Scalars['String']['output'];
  /** Additional entity-specific metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
};

/** Input for affected entity tracking (comprehensive for life-critical compliance) */
export type AffectedEntityInput = {
  /** Entity ID (Snowflake ID from backend) */
  entityId: Scalars['String']['input'];
  /**
   * Entity type (Patient, Account, Document, Workflow, Transaction, etc.)
   * Data-driven from tenant configuration, not hardcoded
   */
  entityType: Scalars['String']['input'];
  /**
   * Impact level on this entity (Critical, High, Medium, Low)
   * Determines regulatory reporting requirements
   */
  impactLevel: Scalars['String']['input'];
  /**
   * Additional entity-specific metadata (domain-agnostic JSON)
   * Examples: MRN, account number, document classification, workflow stage
   */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** Agent service health status. */
export type AgentServiceHealth = {
  __typename?: 'AgentServiceHealth';
  anthropicConfigured: Scalars['Boolean']['output'];
  serviceJwtConfigured: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

/** Token usage for a compose turn. */
export type AgentUsageInfo = {
  __typename?: 'AgentUsageInfo';
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
};

/** Aggregation type */
export const AggregationType = {
  AVERAGE: 'AVERAGE',
  COUNT: 'COUNT',
  DISTINCT_COUNT: 'DISTINCT_COUNT',
  MAX: 'MAX',
  MEDIAN: 'MEDIAN',
  MIN: 'MIN',
  PERCENTILE: 'PERCENTILE',
  RATE: 'RATE',
  STANDARD_DEVIATION: 'STANDARD_DEVIATION',
  SUM: 'SUM',
  VARIANCE: 'VARIANCE',
} as const;

export type AggregationType = (typeof AggregationType)[keyof typeof AggregationType];
/**
 * Scope-filtered navigation result (DRR-102 Phase 2, DRR-103 Phase 1)
 *
 * Returns only the routes, nav items, and entity types the current user
 * is authorized to see, based on their scopes from seeded role YAML configs.
 */
export type AllowedNavigation = {
  __typename?: 'AllowedNavigation';
  /**
   * Entity types the user can see (filtered by EntityPermissions.read vs scopes)
   * DRR-103: Stops CNA from seeing Claims tab — no fhir:claim:read scope.
   */
  allowedEntityTypes: Array<SubgraphEntityType>;
  /** Navigation items the user can see (filtered by scope) */
  navItems: Array<SubgraphNavItem>;
  /** Routes the user can access (filtered by scope) */
  routes: Array<SubgraphRoute>;
  /** The user's resolved scopes (for debugging/frontend display) */
  userScopes: Array<Scalars['String']['output']>;
};

/** A panel slot in the ambient dashboard layout. */
export type AmbientDashboardPanel = {
  __typename?: 'AmbientDashboardPanel';
  dimension: Scalars['String']['output'];
  renderer: Scalars['String']['output'];
  slot: Scalars['String']['output'];
};

/**
 * Backend-driven ambient display configuration from st-0-2.yaml.
 * Replaces hardcoded frontend defaults with backend setting values.
 */
export type AmbientDisplayConfig = {
  __typename?: 'AmbientDisplayConfig';
  alertSeverityThreshold: Scalars['String']['output'];
  criticalOverlayDismissSeconds: Scalars['Int']['output'];
  dashboardPanels: Array<AmbientDashboardPanel>;
  defaultDimension: Scalars['String']['output'];
  defaultRenderer: Scalars['String']['output'];
  defaultTraversalLens: Scalars['String']['output'];
  displayMode: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  fontScale: Scalars['Float']['output'];
  inactivityTimeoutMinutes: Scalars['Int']['output'];
  refreshIntervalSeconds: Scalars['Int']['output'];
  rotationIntervalSeconds: Scalars['Int']['output'];
  rotationRenderers: Array<Scalars['String']['output']>;
};

export type AnalysisEvidenceGql = {
  __typename?: 'AnalysisEvidenceGql';
  data: Scalars['JSON']['output'];
  evidenceType: EvidenceType | '%future added value';
  source: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

/**
 * Analytics primitive - metrics collection and business intelligence
 *
 * Tracks performance, adoption, business, system, and compliance metrics
 * with aggregation, thresholds, alerting, and trend analysis.
 *
 * All 49 fields exposed (identity:5, formula:6, metric config:12, aggregation:8, state:9, thresholds:6, lifecycle:6)
 */
export type Analytics = {
  __typename?: 'Analytics';
  actorPoolIds: Array<Scalars['String']['output']>;
  aggregationType: AggregationType | '%future added value';
  aggregationWindowMinutes: Scalars['Int']['output'];
  alertOnThresholdBreach: Scalars['Boolean']['output'];
  analyticsCode: Scalars['String']['output'];
  analyticsId: Scalars['String']['output'];
  analyticsName: Scalars['String']['output'];
  anomalyDetectionConfigJson: Scalars['JSON']['output'];
  averageValue: Scalars['Float']['output'];
  baselineCalculation: Scalars['String']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this analytics.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  cooldownMinutes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this analytics metric */
  createdByActor?: Maybe<ActorSummary>;
  criticalThreshold?: Maybe<Scalars['Float']['output']>;
  currentValue: Scalars['Float']['output'];
  derivedMetricsJson: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  enableRealTime: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  excludePatterns: Array<Scalars['String']['output']>;
  filterConditionsJson: Scalars['JSON']['output'];
  groupByDimensions: Array<Scalars['String']['output']>;
  lastCalculatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  maxCardinality: Scalars['Int']['output'];
  maxValue: Scalars['Float']['output'];
  metadata: Scalars['JSON']['output'];
  metricCategory: MetricCategory | '%future added value';
  metricName: Scalars['String']['output'];
  metricType: MetricType | '%future added value';
  metricUnit: MetricUnit | '%future added value';
  minValue: Scalars['Float']['output'];
  notificationActorIds: Array<Scalars['String']['output']>;
  nullHandling: Scalars['String']['output'];
  outlierTreatment: Scalars['String']['output'];
  percentileTargets?: Maybe<Array<Scalars['Float']['output']>>;
  previousValue: Scalars['Float']['output'];
  queueIds: Array<Scalars['String']['output']>;
  retentionDays: Scalars['Int']['output'];
  rollupRetentionDays: Scalars['Int']['output'];
  sampleRate: Scalars['Float']['output'];
  sourcePrimitiveIds: Array<Scalars['String']['output']>;
  sourcePrimitiveType: Scalars['String']['output'];
  standardDeviation: Scalars['Float']['output'];
  thresholdDirection: ThresholdDirection | '%future added value';
  trendDirection: TrendDirection | '%future added value';
  trendPercentage: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  warningThreshold?: Maybe<Scalars['Float']['output']>;
  workflowInstanceIds: Array<Scalars['String']['output']>;
};

/**
 * Analytics Archive Result (FERP Append-Only Architecture)
 *
 * Returned by `archiveAnalytics` mutation. Contains full audit metadata
 * for compliance (HIPAA, SOX, SOC2).
 *
 * FERP Principle: No DELETE operations - use archive instead.
 */
export type AnalyticsArchiveResult = {
  __typename?: 'AnalyticsArchiveResult';
  /** Analytics ID that was archived */
  analyticsId: Scalars['String']['output'];
  /** Analytics name that was archived */
  analyticsName: Scalars['String']['output'];
  /** Timestamp when the analytics was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** User ID who performed the archive */
  archivedBy: Scalars['String']['output'];
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Mandatory reason for archiving (audit compliance) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Paginated connection for analytics */
export type AnalyticsConnection = {
  __typename?: 'AnalyticsConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Analytics>;
  totalCount: Scalars['Int']['output'];
};

/** Analytics cost estimate */
export type AnalyticsCostEstimate = {
  __typename?: 'AnalyticsCostEstimate';
  /** Cost breakdown */
  breakdown: CostBreakdown;
  /** Warning if budget would be exceeded */
  budgetWarning?: Maybe<Scalars['String']['output']>;
  /** Confidence level (0.0-1.0) */
  confidenceLevel: Scalars['Float']['output'];
  /** Estimated data transfer in bytes */
  estimatedBytesTransferred: Scalars['String']['output'];
  /** Estimated cost in dollars */
  estimatedCostDollars: Scalars['Float']['output'];
  /** Estimated query duration in seconds */
  estimatedDurationSeconds: Scalars['Float']['output'];
  /** Files that would be accessed */
  estimatedFilesAccessed: Scalars['Int']['output'];
  /** Row groups that would be read */
  estimatedRowGroupsRead: Scalars['Int']['output'];
};

/** Analytics dashboard summary */
export type AnalyticsDashboard = {
  __typename?: 'AnalyticsDashboard';
  adoptionMetrics: Array<Analytics>;
  alertsTriggered: Scalars['Int']['output'];
  businessMetrics: Array<Analytics>;
  complianceMetrics: Array<Analytics>;
  lastUpdated: Scalars['DateTime']['output'];
  performanceMetrics: Array<Analytics>;
  systemMetrics: Array<Analytics>;
  tenantId: Scalars['String']['output'];
  trendsNegative: Scalars['Int']['output'];
  trendsPositive: Scalars['Int']['output'];
};

/** Date range for analytics index queries */
export type AnalyticsDateRange = {
  __typename?: 'AnalyticsDateRange';
  endDate: Scalars['NaiveDate']['output'];
  startDate: Scalars['NaiveDate']['output'];
};

/** Manifest status response */
export type AnalyticsManifestStatusResponse = {
  __typename?: 'AnalyticsManifestStatusResponse';
  /** When manifest was last built */
  builtAt?: Maybe<Scalars['DateTime']['output']>;
  /** Cache hit rate (if cached) */
  cacheHitRate?: Maybe<Scalars['Float']['output']>;
  /** Date range covered */
  dateRangeCovered?: Maybe<AnalyticsDateRange>;
  /** TTL expiration time */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of files indexed */
  filesIndexed: Scalars['Int']['output'];
  /** Last export pipeline run */
  lastExportRun?: Maybe<ExportRunSummary>;
  /** Current manifest status */
  status: ManifestStatus | '%future added value';
  /** Subgraph coverage */
  subgraphsCovered: Array<Scalars['String']['output']>;
  /** Tenant coverage (IDs indexed) */
  tenantsCovered: Array<Scalars['String']['output']>;
  /** Total rows across all files */
  totalRowsIndexed: Scalars['String']['output'];
  /** Total archive size in bytes */
  totalSizeBytes: Scalars['String']['output'];
  /** Manifest version */
  version?: Maybe<Scalars['String']['output']>;
};

/** Analytics Summary (GraphQL Output) */
export type AnalyticsSummary = {
  __typename?: 'AnalyticsSummary';
  /** Average execution time (milliseconds) */
  avgExecutionTimeMs: Scalars['Float']['output'];
  /** Generated timestamp */
  generatedAt: Scalars['DateTime']['output'];
  /** Overall cache hit rate */
  overallCacheHitRate: Scalars['Float']['output'];
  /** Overall effectiveness */
  overallEffectiveness: Scalars['Float']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Total errors */
  totalErrors: Scalars['Int']['output'];
  /** Total evaluations */
  totalEvaluations: Scalars['Int']['output'];
  /** Total matched */
  totalMatched: Scalars['Int']['output'];
  /** Total number of policies */
  totalPolicies: Scalars['Int']['output'];
};

/** Analytics Time Range (GraphQL Enum) */
export const AnalyticsTimeRange = {
  /** All time */
  ALL_TIME: 'ALL_TIME',
  /** Last 24 hours */
  DAY: 'DAY',
  /** Last hour */
  HOUR: 'HOUR',
  /** Last 30 days */
  MONTH: 'MONTH',
  /** Last 7 days */
  WEEK: 'WEEK',
} as const;

export type AnalyticsTimeRange = (typeof AnalyticsTimeRange)[keyof typeof AnalyticsTimeRange];
/** Input for LLM-assisted document analysis. */
export type AnalyzePublicationInput = {
  /** Association tag (e.g., "tag:association:leading-age"). */
  associationRef: Scalars['String']['input'];
  /** The document content to analyze (text extracted from PDF/web). */
  documentText: Scalars['String']['input'];
  /**
   * Industry context (e.g., "assisted_living", "financial", "construction").
   * Used to scope the LLM's vocabulary context.
   */
  industry: Scalars['String']['input'];
  /** Jurisdiction context (e.g., "MN", "federal"). */
  jurisdiction: Scalars['String']['input'];
  /** Publication title for reference. */
  publicationTitle: Scalars['String']['input'];
  /** Year of publication. */
  publicationYear: Scalars['Int']['input'];
};

/** Anti-pattern warning from detection rule */
export type AntiPatternWarning = {
  __typename?: 'AntiPatternWarning';
  /** Warning message */
  message: Scalars['String']['output'];
  /** Missing primitive that caused the warning */
  missingPrimitive?: Maybe<Scalars['String']['output']>;
  /** Which formula this anti-pattern relates to */
  relatedFormula?: Maybe<Scalars['Int']['output']>;
  /** The anti-pattern rule that fired */
  ruleId: Scalars['String']['output'];
  /** Warning severity */
  severity: WarningSeverity | '%future added value';
  /** Present primitives that triggered the check */
  triggeringPrimitives: Array<Scalars['String']['output']>;
};

export type AppendTransitionInput = {
  at?: InputMaybe<Scalars['Int']['input']>;
  by: Scalars['String']['input'];
  /** Optional idempotency key to prevent duplicate appends */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  instanceId: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
  tenant: Scalars['String']['input'];
  transition: Scalars['String']['input'];
};

/** Result of applying an anti-pattern auto-fix */
export type AppliedAutoFixResult = {
  __typename?: 'AppliedAutoFixResult';
  /** Primitives that were added */
  addedPrimitives: Array<AddedPrimitive>;
  /** The anti-pattern that was fixed */
  antiPatternId: Scalars['String']['output'];
  /** Primitives that were modified */
  modifiedPrimitives: Array<ModifiedPrimitive>;
  /** Any remaining warnings after the fix */
  remainingWarnings: Array<AntiPatternWarning>;
  /** Primitives that were removed */
  removedPrimitives: Array<Scalars['String']['output']>;
  /** Whether the workflow now passes validation */
  validationPassed: Scalars['Boolean']['output'];
};

/** Applied edit in history */
export type AppliedEdit = {
  __typename?: 'AppliedEdit';
  /** Timestamp when applied */
  appliedAt: Scalars['String']['output'];
  /** Who applied it */
  appliedBy: Scalars['String']['output'];
  /** Definition after the change */
  definitionAfter: Scalars['String']['output'];
  /** Definition before the change (for undo) */
  definitionBefore: Scalars['String']['output'];
  /** Suggestion that was applied */
  suggestionId: Scalars['String']['output'];
};

/** Applied Rule */
export type AppliedRule = {
  __typename?: 'AppliedRule';
  constraint: Scalars['JSON']['output'];
  fieldPath: Scalars['String']['output'];
  ruleId: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  sourcePack: Scalars['String']['output'];
};

/** Input for applying an anti-pattern auto-fix */
export type ApplyAutoFixInput = {
  /** Anti-pattern ID to fix (e.g., "formula_1_no_notification") */
  antiPatternId: Scalars['String']['input'];
  /** Primitive types currently present in the workflow */
  primitives: Array<Scalars['String']['input']>;
  /** Tenant identifier */
  tenantId: Scalars['String']['input'];
  /** Optional workflow ID for linking new primitives */
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of applying fixes */
export type ApplyFixResult = {
  __typename?: 'ApplyFixResult';
  /** Number of fixes applied */
  fixesApplied: Scalars['Int']['output'];
  /** Remaining violations (if any) */
  remainingViolations: Array<Scalars['String']['output']>;
  /** Updated template ID */
  templateId: Scalars['String']['output'];
  /** Updated template (if validation passed) */
  updatedTemplate?: Maybe<Scalars['String']['output']>;
  /** Validation passed after applying fixes */
  validationPassed: Scalars['Boolean']['output'];
};

/** Input for applying a suggestion */
export type ApplyFormSchemaSuggestionInput = {
  /** The draft being edited */
  draftId: Scalars['String']['input'];
  /** The suggestion ID to apply */
  suggestionId: Scalars['String']['input'];
};

/** Input for applying LLM fixes */
export type ApplyLlmFixInput = {
  /** User applying fixes (for audit trail) */
  appliedBy: Scalars['String']['input'];
  /** Indices of fixes to apply (if empty, apply all) */
  fixIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Recommendation ID to apply */
  recommendationId: Scalars['String']['input'];
  /** Template ID */
  templateId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Apply Standards Pack Input */
export type ApplyStandardsPackInput = {
  actor: Scalars['String']['input'];
  forceOverrideConflicts: Scalars['Boolean']['input'];
  packId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** Apply Standards Pack Result */
export type ApplyStandardsPackResult = {
  __typename?: 'ApplyStandardsPackResult';
  appliedAt: Scalars['String']['output'];
  appliedBy: Scalars['String']['output'];
  appliedRules: Array<AppliedRule>;
  conflictsDetected: Array<RuleConflict>;
  packId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

/** Input for applying a suggestion */
export type ApplySuggestionInput = {
  /** Draft ID */
  draftId: Scalars['String']['input'];
  /** Suggestion ID to apply */
  suggestionId: Scalars['String']['input'];
};

/** Result of applying a suggestion */
export type ApplySuggestionResult = {
  __typename?: 'ApplySuggestionResult';
  draft: FormSchemaDraftOutput;
  message: Scalars['String']['output'];
};

/**
 * GraphQL output type for Approval primitive.
 *
 * 52 fields across 7 categories for complete approval workflow tracking.
 */
export type Approval = {
  __typename?: 'Approval';
  aiRecommendation?: Maybe<Scalars['String']['output']>;
  approvalLimits?: Maybe<GqlApprovalLimits>;
  approvalName: Scalars['String']['output'];
  approvalStrategy: GqlApprovalStrategy | '%future added value';
  approvalType: GqlApprovalType | '%future added value';
  /** WHO is the approver */
  approverActor?: Maybe<ActorSummary>;
  approverRole: Scalars['String']['output'];
  approvers: Array<GqlActorApproval>;
  archived: Scalars['Boolean']['output'];
  attachments: Array<Scalars['String']['output']>;
  changeReason: Scalars['String']['output'];
  changedBy: Scalars['String']['output'];
  comments: Array<GqlApprovalComment>;
  complianceFrameworks: Array<Scalars['String']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this approval.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['JSON']['output']>;
  confidenceThreshold: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this approval */
  createdByActor?: Maybe<ActorSummary>;
  currentApprovalCount: Scalars['Int']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decision?: Maybe<GqlApprovalDecision | '%future added value'>;
  decisionHistory: Array<GqlApprovalDecisionEvent>;
  decisionReason?: Maybe<Scalars['String']['output']>;
  delegatable: Scalars['Boolean']['output'];
  entityType?: Maybe<Scalars['String']['output']>;
  escalationCount: Scalars['Int']['output'];
  evidenceUrls: Array<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalSystemRefs: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  originalId?: Maybe<Scalars['String']['output']>;
  overrideAllowed: Scalars['Boolean']['output'];
  overrideJustification?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  policyEvaluationResult?: Maybe<Scalars['JSON']['output']>;
  policyViolations: Array<Scalars['String']['output']>;
  priority: GqlApprovalPriority | '%future added value';
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requiredApprovals: Scalars['Int']['output'];
  requiredApprovers: Array<Scalars['String']['output']>;
  requiresComment: Scalars['Boolean']['output'];
  retentionPolicy?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionCount: Scalars['Int']['output'];
  revisionRequestedReason?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: GqlApprovalStatus | '%future added value';
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  validationResult?: Maybe<Scalars['JSON']['output']>;
};

/** Approval Decision (GraphQL output) */
export type ApprovalDecision = {
  __typename?: 'ApprovalDecision';
  /** Approver details */
  approverId: Scalars['String']['output'];
  approverName: Scalars['String']['output'];
  approverRole: Scalars['String']['output'];
  /** Comments */
  comments?: Maybe<Scalars['String']['output']>;
  /** Decision timestamp */
  decidedAt: Scalars['DateTime']['output'];
  /** Decision ID */
  decisionId: Scalars['String']['output'];
  /** Decision type */
  decisionType: DecisionType | '%future added value';
  /** Revision items */
  revisionItems: Array<RevisionItem>;
};

export type ApprovalDecisionGql = {
  approved: Scalars['Boolean']['input'];
  approverRole: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  recommendationId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/**
 * Approval decision event for real-time subscriptions.
 * Note: Renamed to avoid collision with approval_model::GqlApprovalDecisionEvent (Issue #581)
 */
export type ApprovalDecisionSubscriptionEvent = {
  __typename?: 'ApprovalDecisionSubscriptionEvent';
  /** Actor who made decision */
  actorId: Scalars['String']['output'];
  /** Approval ID */
  approvalId: Scalars['String']['output'];
  /** Decision made (APPROVE, REJECT, etc.) */
  decision: Scalars['String']['output'];
  /** Optional reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** Timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
};

/** GraphQL output type for ApprovalLimits. */
export type ApprovalLimits = {
  __typename?: 'ApprovalLimits';
  /** Maximum document size (MB) this role can handle */
  maxDocumentSizeMb?: Maybe<Scalars['Int']['output']>;
  /** Maximum number of parallel approvals */
  maxParallelApprovals?: Maybe<Scalars['Int']['output']>;
  /** Maximum transaction amount this role can approve */
  maxTransactionAmount?: Maybe<Scalars['Float']['output']>;
};

/** Approval Progress (GraphQL output) */
export type ApprovalProgress = {
  __typename?: 'ApprovalProgress';
  /** Completed approvals */
  completed: Scalars['Int']['output'];
  /** Required approvals (e.g., 2 for dual control) */
  required: Scalars['Int']['output'];
};

/** Approval Queue Filter (GraphQL input) */
export type ApprovalQueueFilter = {
  /** Criticality level filter (String - from tenant approval policy) */
  criticalityLevel?: InputMaybe<Scalars['String']['input']>;
  /** Deadline urgency filter (String - from tenant approval policy) */
  deadline?: InputMaybe<Scalars['String']['input']>;
  /** Domain filter */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Status filter (String - from approval workflow status) */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Submitter ID filter */
  submitterId?: InputMaybe<Scalars['String']['input']>;
};

export type ApprovalQueueInstance = {
  __typename?: 'ApprovalQueueInstance';
  /** Approval progress */
  approvalProgress: ApprovalProgress;
  /**
   * Available actions for current state
   *
   * Backend-driven: Actions from WorkflowConfigRepository based on status
   */
  availableActions: Array<Action>;
  /** Criticality level */
  criticalityLevel: Scalars['String']['output'];
  /** Deadline */
  deadline: Scalars['DateTime']['output'];
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /**
   * Next possible states from current state
   *
   * Backend-driven: State transitions from WorkflowConfigRepository
   */
  nextStates: Array<StateTransition>;
  /**
   * Related resources
   *
   * Backend-driven: Links to template, validation results, approvers
   */
  relatedResources: Array<ResourceLink>;
  /** Required approvers */
  requiredApprovers: Array<ApproverInfo>;
  /** Current status */
  status: Scalars['String']['output'];
  /** Submission info */
  submittedAt: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  submitterName: Scalars['String']['output'];
  templateDomain: Scalars['String']['output'];
  /** Template being approved */
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Validation summary */
  validationSummary: ValidationSummary;
  /**
   * Workflow context for AI agents
   *
   * Backend-driven: Structured metadata for autonomous decision-making
   */
  workflowContext: WorkflowContext;
};

/** Approval Queue Response (GraphQL output) */
export type ApprovalQueueResponse = {
  __typename?: 'ApprovalQueueResponse';
  /** Critical priority count */
  criticalCount: Scalars['Int']['output'];
  /** Approval workflow instances */
  instances: Array<ApprovalQueueInstance>;
  /** Life-critical priority count */
  lifeCriticalCount: Scalars['Int']['output'];
  /** Overdue approvals count */
  overdueCount: Scalars['Int']['output'];
  /** Total pending approvals */
  totalPending: Scalars['Int']['output'];
};

export type ApprovalRequirementGql = {
  __typename?: 'ApprovalRequirementGql';
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
};

/** Approval Status (GraphQL enum) */
export const ApprovalStatus = {
  APPROVED: 'APPROVED',
  EXPIRED: 'EXPIRED',
  PENDING_REVIEW: 'PENDING_REVIEW',
  REJECTED: 'REJECTED',
  REVISION_REQUESTED: 'REVISION_REQUESTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
} as const;

export type ApprovalStatus = (typeof ApprovalStatus)[keyof typeof ApprovalStatus];
/** Approval Workflow Instance (GraphQL output) */
export type ApprovalWorkflowInstance = {
  __typename?: 'ApprovalWorkflowInstance';
  /** Audit trail */
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Criticality */
  criticality: Scalars['String']['output'];
  /** Deadline */
  deadline: Scalars['DateTime']['output'];
  /** Approval decisions */
  decisions: Array<ApprovalDecision>;
  domain: Scalars['String']['output'];
  /** Dual control required flag */
  dualControlRequired: Scalars['Boolean']['output'];
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /** Required approvers */
  requiredApprovers: Array<ApproverSpec>;
  /** Current status */
  status: ApprovalStatus | '%future added value';
  /** Template being approved */
  templateId: Scalars['String']['output'];
  templateVersion: Scalars['String']['output'];
  /** Tenant context */
  tenant: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** Input for approving JIT request */
export type ApproveJitRequestInput = {
  approverEmail: Scalars['String']['input'];
  approverId: Scalars['String']['input'];
  /** Optional: Reduce duration from requested (minutes) */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  requestId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Response for approve JIT request mutation */
export type ApproveJitRequestResult = {
  __typename?: 'ApproveJITRequestResult';
  expiresAt: Scalars['String']['output'];
  message: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

/** Input for approving a config proposal. */
export type ApproveProposalInput = {
  /** Optional product to add this config to. */
  addToProduct?: InputMaybe<Scalars['String']['input']>;
  /** Actor ID of the architect approving. */
  approvedBy: Scalars['String']['input'];
  /** Proposal ID (filename in proposals/ directory). */
  proposalId: Scalars['String']['input'];
};

/** Result of config proposal approval. */
export type ApproveProposalResult = {
  __typename?: 'ApproveProposalResult';
  /** Audit event ID for traceability. */
  auditEventId?: Maybe<Scalars['String']['output']>;
  /** Where the config was moved to. */
  movedTo: Scalars['String']['output'];
  /** The proposal that was approved. */
  proposalId: Scalars['String']['output'];
  /** Whether the approval was recorded. */
  success: Scalars['Boolean']['output'];
};

/** Input for approving a rule from the review queue */
export type ApproveRuleInput = {
  /** Optional comment from reviewer */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Reviewer ID (user approving) */
  reviewerId: Scalars['String']['input'];
  /** Rule ID to approve */
  ruleId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Approver Info (GraphQL output) */
export type ApproverInfo = {
  __typename?: 'ApproverInfo';
  /** Approval timestamp (if approved) */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Expertise areas */
  expertise: Array<Scalars['String']['output']>;
  /** Has approved flag */
  hasApproved: Scalars['Boolean']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Role */
  role: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['String']['output'];
};

/** Approver Specification (GraphQL output) */
export type ApproverSpec = {
  __typename?: 'ApproverSpec';
  /** Required count */
  requiredCount: Scalars['Int']['output'];
  /** Approver role */
  role: Scalars['String']['output'];
};

/**
 * Architect Proposal entity (DRR-227)
 *
 * Note: Named "ArchitectProposal" in GraphQL to avoid collision with
 * ConfigProposal from DRR-156 recommendation API.
 */
export type ArchitectProposal = {
  __typename?: 'ArchitectProposal';
  /** When activated (if approved and activated) */
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Target config ID (existing config to modify, or new ID) */
  configId: Scalars['String']['output'];
  /** Config type being proposed */
  configType: ConfigProposalType | '%future added value';
  /** Description of the change */
  description: Scalars['String']['output'];
  /** Unique proposal ID */
  id: Scalars['String']['output'];
  /** Is this a new config or modification? */
  isNew: Scalars['Boolean']['output'];
  /** When proposed */
  proposedAt: Scalars['DateTime']['output'];
  /** Who proposed this change */
  proposedBy: Scalars['String']['output'];
  /** Rejection reason (if rejected) */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** When reviewed */
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who reviewed (approved/rejected) */
  reviewedBy?: Maybe<Scalars['String']['output']>;
  /** Simulation results (if simulation has run) */
  simulation?: Maybe<ArchitectProposalSimulation>;
  /** Proposal status */
  status: ProposalStatus | '%future added value';
  /** Tenant ID (proposals are tenant-scoped) */
  tenantId: Scalars['String']['output'];
  /** Human-readable title */
  title: Scalars['String']['output'];
  /** Last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Simulation result summary for architect proposals (DRR-227) */
export type ArchitectProposalSimulation = {
  __typename?: 'ArchitectProposalSimulation';
  /** Number of errors (blocking) */
  errorCount: Scalars['Int']['output'];
  /** Error messages */
  errors: Array<Scalars['String']['output']>;
  /** Did simulation pass? */
  passed: Scalars['Boolean']['output'];
  /** Simulation run timestamp */
  simulatedAt: Scalars['DateTime']['output'];
  /** Number of warnings (non-blocking) */
  warningCount: Scalars['Int']['output'];
  /** Warning messages */
  warnings: Array<Scalars['String']['output']>;
};

/**
 * Archive Policy Rule Input (FERP Append-Only Architecture)
 *
 * REPLACES: DeletePolicyRuleInput (removed for append-only compliance)
 */
export type ArchivePolicyRuleInput = {
  /** Policy ID */
  policyId: Scalars['String']['input'];
  /** Mandatory archival reason for audit trail */
  reason: Scalars['String']['input'];
  /** Tenant ID (for validation) */
  tenantId: Scalars['String']['input'];
};

/** Result of an archive operation */
export type ArchiveResult = {
  __typename?: 'ArchiveResult';
  /** When the archive occurred (if successful) */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who performed the archive (user ID) */
  archivedBy?: Maybe<Scalars['String']['output']>;
  /** Human-readable result message */
  message: Scalars['String']['output'];
  /** Reason provided for archiving */
  reason?: Maybe<Scalars['String']['output']>;
  /** The subgraph ID that was archived */
  subgraphId: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Archive workflow graph input (Issue #659: Append-only architecture) */
export type ArchiveWorkflowGraphInput = {
  graphId: Scalars['String']['input'];
  /** Mandatory reason for archiving (audit compliance) */
  reason?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Archived workflow graph result (Issue #659: Append-only architecture) */
export type ArchivedWorkflowGraph = {
  __typename?: 'ArchivedWorkflowGraph';
  /** Timestamp when the graph was archived (legacy: deleted_at) */
  archivedAt: Scalars['String']['output'];
  /** User who performed the archive (optional for repository compatibility) */
  archivedBy?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  /** Reason for archiving (audit compliance) */
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * A single assessment criterion for competency verification (DRR-209).
 * Used in ULP competency task groups from Care Providers of MN content.
 */
export type AssessmentCriterion = {
  __typename?: 'AssessmentCriterion';
  /** Human-readable description of the skill/criterion */
  description: Scalars['String']['output'];
  /** Unique criterion identifier */
  id: Scalars['String']['output'];
  /** Whether this is a safety-critical criterion */
  safetyCritical?: Maybe<Scalars['Boolean']['output']>;
  /** Threshold value for pass/fail (if applicable) */
  threshold?: Maybe<Scalars['String']['output']>;
};

/** Assessment section enum for GraphQL */
export const AssessmentSectionGql = {
  SECTION_A: 'SECTION_A',
  SECTION_B: 'SECTION_B',
  SECTION_C: 'SECTION_C',
} as const;

export type AssessmentSectionGql = (typeof AssessmentSectionGql)[keyof typeof AssessmentSectionGql];
/** Input for assigning driver */
export type AssignDriverInput = {
  driverId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

/** Assign Role Input */
export type AssignRoleInput = {
  /** Optional expiration (for temporary access) */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Role ID */
  roleId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** User ID (from Cognito/Medplum) */
  userId: Scalars['String']['input'];
};

/**
 * Shared input for assigning a task to an actor.
 *
 * **Used By:**
 * - task_api: Direct task assignment
 * - queue_api: Queue-based task assignment
 *
 * **Formula Integration:**
 * - Formula #1 (Time-Bound Assignment): SLA + Task + Actor + Notification
 * - Formula #6 (Load-Balanced Queue): Queue assigns tasks to eligible actors
 */
export type AssignTaskInput = {
  /** ID of the actor (worker) to assign the task to */
  actorId: Scalars['String']['input'];
  /** ID of the task to assign */
  taskId: Scalars['String']['input'];
};

/** Assignment rationale for transparency */
export type AssignmentRationale = {
  __typename?: 'AssignmentRationale';
  /** Acuity contribution to score */
  acuityContribution: Scalars['Int']['output'];
  /** Continuity contribution */
  continuityContribution: Scalars['Int']['output'];
  /** Deadline contribution */
  deadlineContribution: Scalars['Int']['output'];
  /** Any overrides applied */
  overrides: Array<Scalars['String']['output']>;
  /** Resource contribution */
  resourceContribution: Scalars['Int']['output'];
  /** Sequence contribution */
  sequenceContribution: Scalars['Int']['output'];
};

/**
 * Scope categories the admin can request context for.
 *
 * Defaults to all scopes. The assistant only answers within the
 * scopes requested — prevents over-disclosure.
 */
export const AssistantContextScope = {
  /** Active workflow instance states + pending events */
  COMPLIANCE: 'COMPLIANCE',
  /** Upcoming compliance deadlines (days until) from active RuleSets */
  DEADLINES: 'DEADLINES',
  /** Task backlog: counts by status, overdue flag, priority distribution */
  TASKS: 'TASKS',
  /** Active policy violations from the PolicyRegistry */
  VIOLATIONS: 'VIOLATIONS',
} as const;

export type AssistantContextScope =
  (typeof AssistantContextScope)[keyof typeof AssistantContextScope];
/** Input for the assistantQuery mutation. */
export type AssistantQueryInput = {
  /** Active RuleSet config IDs in force for this tenant. */
  activeRulesetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pre-fetched active violation summaries. */
  activeViolations?: InputMaybe<Array<ViolationInput>>;
  /** The admin's question or request (plain text; Presidio-scrubbed before LLM). */
  question: Scalars['String']['input'];
  /** Which context scopes to inject. Defaults to all scopes when empty. */
  scopes?: Array<AssistantContextScope | '%future added value'>;
  /**
   * Pre-fetched task summary counts (populated by frontend from usePrimitiveData).
   * Avoids an extra round-trip DDB query inside the mutation.
   */
  taskSummary?: InputMaybe<TaskSummaryInput>;
  /** Pre-fetched upcoming deadlines. */
  upcomingDeadlines?: InputMaybe<Array<DeadlineInput>>;
  /** Active workflow state names (from the frontend's live instance data). */
  workflowStates?: InputMaybe<Array<WorkflowStateInput>>;
};

/** Response from the assistantQuery mutation. */
export type AssistantQueryResponse = {
  __typename?: 'AssistantQueryResponse';
  /**
   * Whether the response was escalated to the human supervisor.
   * True when confidence is below threshold or scope was out of range.
   */
  escalatedToSupervisor: Scalars['Boolean']['output'];
  /** Interaction ID for audit trail reference (T2, 1yr). */
  interactionId: Scalars['String']['output'];
  /** The assistant's response (plain text; no PHI by design). */
  response: Scalars['String']['output'];
};

/** Attach evidence input (DRR-137 Phase 3) */
export type AttachEvidenceInput = {
  attachedBy: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EvidenceEntityType | '%future added value';
  notes?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
};

/** Input for attestProvision mutation. */
export type AttestProvisionInput = {
  /** Description of the evidence. */
  description?: Scalars['String']['input'];
  /** Document IDs attached as evidence artifacts. */
  documentIds?: Array<Scalars['String']['input']>;
  /** Evidence type: observation, document, certification, witness. */
  evidenceType: Scalars['String']['input'];
  /** Member rule ID being attested (e.g., "rl-4-0-037"). */
  provisionRef: Scalars['String']['input'];
  /** Ruleset ID this provision belongs to. */
  rulesetId: Scalars['String']['input'];
  /** Optional expiry date (ISO 8601) — for licenses, certifications with renewal. */
  validUntil?: InputMaybe<Scalars['String']['input']>;
};

/** Result of attestProvision mutation. */
export type AttestProvisionResult = {
  __typename?: 'AttestProvisionResult';
  /** Attestation record ID for reference. */
  attestationId: Scalars['String']['output'];
  /** Confirmation message. */
  message: Scalars['String']['output'];
  /** Whether the attestation was recorded. */
  success: Scalars['Boolean']['output'];
};

/** Attestation status */
export const AttestationStatus = {
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING: 'PENDING',
} as const;

export type AttestationStatus = (typeof AttestationStatus)[keyof typeof AttestationStatus];
export type AuditArchiveResultQl = {
  __typename?: 'AuditArchiveResultQL';
  archivedAt: Scalars['String']['output'];
  archivedBy: Scalars['String']['output'];
  auditAction: Scalars['String']['output'];
  auditId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A single checkpoint in a survey form — one thing surveyors verify. */
export type AuditCheckpoint = {
  __typename?: 'AuditCheckpoint';
  /** CMS guidance or interpretation */
  cmsGuidance?: Maybe<Scalars['String']['output']>;
  /** Historical deficiency rate (0.0 - 1.0) */
  deficiencyRate?: Maybe<Scalars['Float']['output']>;
  /** Checkpoint identifier (e.g., "E-0001", "HIPAA-P-001") */
  id: Scalars['String']['output'];
  /** Cross-reference to related rule ID */
  mapsToRule?: Maybe<Scalars['String']['output']>;
  /** Maps to specific statute section */
  mapsToStatute?: Maybe<Scalars['String']['output']>;
  /** Additional notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Priority level */
  priority: CheckpointPriority | '%future added value';
  /** The compliance question being assessed */
  question: Scalars['String']['output'];
  /** Section reference (e.g., "§483.73(a)(1)") */
  section: Scalars['String']['output'];
  /** What the surveyor actually asks/looks for */
  surveyorAsks?: Maybe<Scalars['String']['output']>;
  /** Tag/code (e.g., "E-0001", "ADMIN-001") */
  tag?: Maybe<Scalars['String']['output']>;
};

export const AuditComplianceStatus = {
  APPROVED: 'APPROVED',
  COMPLIANT: 'COMPLIANT',
  UNDER_REVIEW: 'UNDER_REVIEW',
  VIOLATIONS: 'VIOLATIONS',
} as const;

export type AuditComplianceStatus =
  (typeof AuditComplianceStatus)[keyof typeof AuditComplianceStatus];
export type AuditConfigInput = {
  /** Compliance settings */
  complianceLevel?: InputMaybe<Scalars['String']['input']>;
  /** Enable audit logging */
  enabled: Scalars['Boolean']['input'];
  /** Audit event filters */
  eventFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Audit log retention days */
  retentionDays: Scalars['Int']['input'];
};

/** Date Range Input (GraphQL input) */
export type AuditDateRangeInput = {
  /** End date (ISO 8601) */
  endDate: Scalars['DateTime']['input'];
  /** Start date (ISO 8601) */
  startDate: Scalars['DateTime']['input'];
};

/** Audit event for compliance monitoring */
export type AuditEvent = {
  __typename?: 'AuditEvent';
  action: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  actorType: Scalars['String']['output'];
  auditId: Scalars['String']['output'];
  complianceTags: Array<Scalars['String']['output']>;
  details: Scalars['JSON']['output'];
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  immutableHash: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AuditEventGql = {
  __typename?: 'AuditEventGql';
  actor: Scalars['String']['output'];
  details: Scalars['JSON']['output'];
  eventType: AuditEventType | '%future added value';
  timestamp: Scalars['String']['output'];
};

export const AuditEventType = {
  approved: 'approved',
  created: 'created',
  deleted: 'deleted',
  implemented: 'implemented',
  rejected: 'rejected',
  statusChanged: 'statusChanged',
} as const;

export type AuditEventType = (typeof AuditEventType)[keyof typeof AuditEventType];
/**
 * A Audit Form — regulatory inspection checklist with checkpoints.
 *
 * DRR-246: Audit-form-driven compliance content generation.
 * Auditors use these instruments to verify compliance.
 */
export type AuditForm = {
  __typename?: 'AuditForm';
  /** Adoption chain showing how state law adopts federal requirements */
  adoptionChain?: Maybe<AdoptionChain>;
  /** CFR or statute this survey form assesses */
  assessesRegulation?: Maybe<Scalars['String']['output']>;
  /** Average deficiency rate across all checkpoints */
  avgDeficiencyRate?: Maybe<Scalars['Float']['output']>;
  /** Total number of checkpoints */
  checkpointCount: Scalars['Int']['output'];
  /** Inspection checkpoints (the actual survey questions) */
  checkpoints: Array<AuditCheckpoint>;
  /** Number of critical priority checkpoints */
  criticalCount: Scalars['Int']['output'];
  /** Summary of most-cited deficiencies */
  deficiencySummary?: Maybe<DeficiencySummary>;
  /** Human-readable display name (e.g., "CMS Appendix Z - Emergency Preparedness") */
  displayName: Scalars['String']['output'];
  /** When this version became effective */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Facility context - how this applies to specific facility types */
  facilityContext?: Maybe<Scalars['String']['output']>;
  /** Unique identifier (e.g., "0-3-001") */
  formId: Scalars['String']['output'];
  /** Official form number (e.g., "CMS-20054", "OSHA 300") */
  formNumber?: Maybe<Scalars['String']['output']>;
  /** Jurisdiction (e.g., "federal", "MN") */
  jurisdiction: Scalars['String']['output'];
  /** Machine-readable name (e.g., "cms_appendix_z") */
  name: Scalars['String']['output'];
  /** Regulatory body that owns this instrument (e.g., "CMS", "OSHA", "HHS_OCR") */
  regulatoryBody: Scalars['String']['output'];
  /** URL to official source document */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Version identifier */
  version?: Maybe<Scalars['String']['output']>;
};

export type AuditListResultQl = {
  __typename?: 'AuditListResultQL';
  audits: Array<AuditQl>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** Audit log created event */
export type AuditLogCreatedEvent = {
  __typename?: 'AuditLogCreatedEvent';
  /** Audit log entry */
  auditLog: AuditLogEntry;
  /** Integration ID */
  integrationId: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Event timestamp */
  timestamp: Scalars['String']['output'];
};

/** Audit log entry (66+ fields for life-critical compliance) */
export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  /** Alert severity (if triggered) */
  alertSeverity?: Maybe<Scalars['String']['output']>;
  /** Alert triggered flag */
  alertTriggered: Scalars['Boolean']['output'];
  /** Authentication method */
  authMethod: Scalars['String']['output'];
  /** Compliance frameworks */
  complianceFrameworks: Array<ComplianceFramework | '%future added value'>;
  /** Compliance violation detected */
  complianceViolation: Scalars['Boolean']['output'];
  /** Data classification level */
  dataClassification: DataClassification | '%future added value';
  /** Duration in milliseconds */
  durationMs: Scalars['Int']['output'];
  /** Encryption used */
  encryptionUsed: Scalars['Boolean']['output'];
  /** Error code */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Error stack trace */
  errorStackTrace?: Maybe<Scalars['String']['output']>;
  /** Geolocation (city, country) */
  geolocation?: Maybe<Scalars['String']['output']>;
  /** SHA-256 hash of log entry */
  hash: Scalars['String']['output'];
  /** Integration ID */
  integrationId: Scalars['String']['output'];
  /** IP address */
  ipAddress: Scalars['String']['output'];
  /** Legal hold flag */
  legalHold: Scalars['Boolean']['output'];
  /** Log ID */
  logId: Scalars['String']['output'];
  /** Merkle tree root (for batch verification) */
  merkleRoot?: Maybe<Scalars['String']['output']>;
  /** Additional metadata */
  metadata: Scalars['JSON']['output'];
  /** MFA verified */
  mfaVerified: Scalars['Boolean']['output'];
  /** Operation status (success, failure, pending) */
  operationStatus: Scalars['String']['output'];
  /** Operation type (patient_create, invoice_generate, etc.) */
  operationType: Scalars['String']['output'];
  /** Parent log ID (for correlation) */
  parentLogId?: Maybe<Scalars['String']['output']>;
  /** PHI redacted flag */
  phiRedacted: Scalars['Boolean']['output'];
  /** PII redacted flag */
  piiRedacted: Scalars['Boolean']['output'];
  /** SHA-256 hash of previous entry (blockchain chain) */
  previousHash: Scalars['String']['output'];
  /** Remediation steps taken */
  remediationSteps?: Maybe<Array<Scalars['String']['output']>>;
  /** Request headers (sensitive data redacted) */
  requestHeaders: Scalars['JSON']['output'];
  /** HTTP method */
  requestMethod: Scalars['String']['output'];
  /** Request payload (PII/PHI redacted) */
  requestPayload: Scalars['JSON']['output'];
  /** Request URL */
  requestUrl: Scalars['String']['output'];
  /** Response data (PII/PHI redacted) */
  responseData: Scalars['JSON']['output'];
  /** Response latency in milliseconds */
  responseLatencyMs: Scalars['Int']['output'];
  /** Response size in bytes */
  responseSizeBytes: Scalars['Int']['output'];
  /** Response status code */
  responseStatus: Scalars['Int']['output'];
  /** Retention period days */
  retentionPeriodDays: Scalars['Int']['output'];
  /** SAGA transaction ID (if distributed transaction) */
  sagaTransactionId?: Maybe<Scalars['String']['output']>;
  /** Security clearance level */
  securityClearance: Scalars['String']['output'];
  /** Session ID */
  sessionId: Scalars['String']['output'];
  /** Digital signature for verification */
  signature: Scalars['String']['output'];
  /** Step ID within workflow */
  stepId?: Maybe<Scalars['String']['output']>;
  /** Tags for categorization */
  tags: Array<Scalars['String']['output']>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Timestamp (ISO 8601 with millisecond precision) */
  timestamp: Scalars['String']['output'];
  /** Trace ID (distributed tracing) */
  traceId: Scalars['String']['output'];
  /** User ID who performed the action */
  userId: Scalars['String']['output'];
  /** User permissions */
  userPermissions: Array<Scalars['String']['output']>;
  /** User role */
  userRole: Scalars['String']['output'];
  /** Workflow ID (if part of workflow) */
  workflowId?: Maybe<Scalars['String']['output']>;
  /** Workflow instance ID */
  workflowInstanceId?: Maybe<Scalars['String']['output']>;
};

export type AuditQl = {
  __typename?: 'AuditQL';
  accessPatterns: Scalars['JSON']['output'];
  actionTypes: Array<Scalars['String']['output']>;
  adoptionRatePercent: Scalars['Float']['output'];
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  aiGenerated: Scalars['Boolean']['output'];
  approvalRequired: Scalars['Boolean']['output'];
  approvalWorkflowId?: Maybe<Scalars['String']['output']>;
  approvedByUserId?: Maybe<Scalars['String']['output']>;
  auditCode: Scalars['String']['output'];
  auditName: Scalars['String']['output'];
  chaosExtractionId?: Maybe<Scalars['String']['output']>;
  compliancePeriodEnd: Scalars['String']['output'];
  compliancePeriodStart: Scalars['String']['output'];
  complianceStatus: AuditComplianceStatus | '%future added value';
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['String']['output'];
  dataLineage: Scalars['JSON']['output'];
  eventCount: Scalars['Int']['output'];
  eventIds: Array<Scalars['String']['output']>;
  featuresUnused: Array<Scalars['String']['output']>;
  featuresUsed: Array<Scalars['String']['output']>;
  findingsSummary: Scalars['String']['output'];
  frameworkType: GqlAuditFrameworkType | '%future added value';
  generatedByUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  immutabilityRequired: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  lastValidationTimestamp?: Maybe<Scalars['String']['output']>;
  navigationPaths: Array<Array<Scalars['String']['output']>>;
  originalId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  previousAuditId?: Maybe<Scalars['String']['output']>;
  primitiveTypesAccessed: Array<Scalars['String']['output']>;
  regulatoryFrameworks: Array<Scalars['String']['output']>;
  regulatoryQuestion: Scalars['String']['output'];
  reportFormat: GqlReportFormat | '%future added value';
  reportS3Url?: Maybe<Scalars['String']['output']>;
  reportTemplateId: Scalars['String']['output'];
  retentionExpiresAt: Scalars['String']['output'];
  retentionYears: Scalars['Int']['output'];
  signatureRequired: Scalars['Boolean']['output'];
  subgraphReferences: Scalars['JSON']['output'];
  timeSpentSeconds: Array<Scalars['String']['output']>;
  uniqueActors: Scalars['Int']['output'];
  uniqueEntities: Scalars['Int']['output'];
  uniqueEventTypes: Array<Scalars['String']['output']>;
  uniqueWorkflows: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  userActionCount: Scalars['Int']['output'];
  userIds: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  violationsDetected: Scalars['Int']['output'];
};

/** Individual audit record from Parquet archive */
export type AuditRecord = {
  __typename?: 'AuditRecord';
  /** Actor who performed the action */
  actorId: Scalars['String']['output'];
  /** Archive URL for full record retrieval */
  archiveUrl?: Maybe<Scalars['String']['output']>;
  /** Event type */
  eventType: Scalars['String']['output'];
  /** Event payload (JSON) */
  payload?: Maybe<Scalars['JSON']['output']>;
  /** Record ID (Snowflake) */
  recordId: Scalars['String']['output'];
  /** Resource ID affected */
  resourceId?: Maybe<Scalars['String']['output']>;
  /** Resource type affected */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Subgraph ID */
  subgraphId?: Maybe<Scalars['String']['output']>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Event timestamp */
  timestamp: Scalars['DateTime']['output'];
};

export type AuditReportQl = {
  __typename?: 'AuditReportQL';
  auditId: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  reportFormat: GqlReportFormat | '%future added value';
  reportId: Scalars['String']['output'];
  reportUrl: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
};

/** Regulatory audit requirement with compliance status. */
export type AuditRequirement = {
  __typename?: 'AuditRequirement';
  /** Regulatory citation (e.g., "144G.60 Subd 4") */
  citation: Scalars['String']['output'];
  /** Requirement description */
  description: Scalars['String']['output'];
  /** Count of evidence items supporting this requirement */
  evidenceCount: Scalars['Int']['output'];
  /** Requirement ID */
  id: Scalars['String']['output'];
  /** Additional notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Status: "complete", "partial", "missing", "not_applicable" */
  status: Scalars['String']['output'];
};

/** Audit section grouping related requirements. */
export type AuditSection = {
  __typename?: 'AuditSection';
  /** Section description */
  description: Scalars['String']['output'];
  /** Section ID */
  id: Scalars['String']['output'];
  /** Section name (e.g., "Assessment Requirements") */
  name: Scalars['String']['output'];
  /** Requirements within this section */
  requirements: Array<AuditRequirement>;
};

/** Audit Statistics (GraphQL output) */
export type AuditStatistics = {
  __typename?: 'AuditStatistics';
  /** Actions by type */
  actionsByType: Array<ActionCount>;
  /** Compliance violations count */
  complianceViolationsCount: Scalars['Int']['output'];
  /** Critical actions count */
  criticalActionsCount: Scalars['Int']['output'];
  /** Tamper detection count */
  tamperDetectionCount: Scalars['Int']['output'];
  /** Total actions in date range */
  totalActions: Scalars['Int']['output'];
  /** User activity */
  userActivity: Array<UserActivity>;
};

/** Summary statistics for audit report */
export type AuditSummary = {
  __typename?: 'AuditSummary';
  /** Date range covered */
  dateRangeCovered: AnalyticsDateRange;
  /** Records by event type */
  recordsByEventType: Array<CountByKey>;
  /** Records by subgraph */
  recordsBySubgraph: Array<CountByKey>;
  /** Records by tenant */
  recordsByTenant: Array<CountByKey>;
  /** Total records matching query */
  totalRecords: Scalars['Int']['output'];
};

/** Audit tracking metadata */
export type AuditTracking = {
  __typename?: 'AuditTracking';
  auditLevel: Scalars['String']['output'];
  complianceFrameworks: Array<Scalars['String']['output']>;
  phiField: Scalars['Boolean']['output'];
};

/** Audit tracking input */
export type AuditTrackingInput = {
  auditLevel: Scalars['String']['input'];
  complianceFrameworks: Array<Scalars['String']['input']>;
  phiField: Scalars['Boolean']['input'];
};

/** Audit Trail Entry (GraphQL output) */
export type AuditTrailEntry = {
  __typename?: 'AuditTrailEntry';
  /** Action */
  action: Scalars['String']['output'];
  afterValue?: Maybe<Scalars['JSON']['output']>;
  /** Audit ID (backend Snowflake ID) */
  auditId: Scalars['String']['output'];
  /** Value tracking (SOX §404 requirement) */
  beforeValue?: Maybe<Scalars['JSON']['output']>;
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Integrity fields */
  cryptographicHash: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  /** Entity info */
  entityType: Scalars['String']['output'];
  /** Security fields */
  ipAddress: Scalars['String']['output'];
  /** Additional metadata */
  metadata: Scalars['JSON']['output'];
  sessionId: Scalars['String']['output'];
  /** Compliance fields */
  severity: Scalars['String']['output'];
  tamperDetected: Scalars['Boolean']['output'];
  /** Tenant context */
  tenantId: Scalars['String']['output'];
  /** Timestamp (ISO 8601) */
  timestamp: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  /** User info */
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
  userRole: Scalars['String']['output'];
};

/** Audit Trail Filter (GraphQL input) */
export type AuditTrailFilter = {
  /** Action filter */
  action?: InputMaybe<Scalars['String']['input']>;
  /** End date (ISO 8601) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Entity ID filter */
  entityId?: InputMaybe<Scalars['String']['input']>;
  /** Entity type filter */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** Pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Search query */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Severity filter */
  severity?: InputMaybe<Scalars['String']['input']>;
  /** Start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Show only tampered entries */
  tamperDetectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tenant ID (REQUIRED - multi-tenant isolation) */
  tenantId: Scalars['String']['input'];
  /** User ID filter */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Audit Trail Response (GraphQL output) */
export type AuditTrailResponse = {
  __typename?: 'AuditTrailResponse';
  /** Audit entries */
  entries: Array<AuditTrailEntry>;
  /** Pagination flags */
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Tamper alerts */
  tamperAlerts: Array<TamperAlert>;
  /** Total count */
  totalCount: Scalars['Int']['output'];
};

/** Authentication type for integration */
export const AuthenticationType = {
  API_KEY: 'API_KEY',
  BASIC: 'BASIC',
  BEARER: 'BEARER',
  CUSTOM: 'CUSTOM',
  HMAC: 'HMAC',
  MTLS: 'MTLS',
  NONE: 'NONE',
  OAUTH2: 'OAUTH2',
} as const;

export type AuthenticationType = (typeof AuthenticationType)[keyof typeof AuthenticationType];
/** Anti-pattern definition with available auto-fix */
export type AvailableAntiPatternFix = {
  __typename?: 'AvailableAntiPatternFix';
  /** Description of the auto-fix (if available) */
  autoFixDescription?: Maybe<Scalars['String']['output']>;
  /** Description of why this is an anti-pattern */
  description: Scalars['String']['output'];
  /** Whether an auto-fix is available */
  hasAutoFix: Scalars['Boolean']['output'];
  /** Primitives that must be present to trigger this check */
  hasPrimitives: Array<Scalars['String']['output']>;
  /** Unique identifier for this anti-pattern */
  id: Scalars['String']['output'];
  /** Warning message to display */
  message: Scalars['String']['output'];
  /** Primitives that must be missing for this to be an anti-pattern */
  missingPrimitives: Array<Scalars['String']['output']>;
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Related formula number (if applicable) */
  relatedFormula?: Maybe<Scalars['Int']['output']>;
  /** Whether the fix requires confirmation (e.g., critical changes) */
  requiresConfirmation: Scalars['Boolean']['output'];
  /** Warning severity */
  severity: WarningSeverity | '%future added value';
};

/** Available industry term for adoption. */
export type AvailableIndustryTerm = {
  __typename?: 'AvailableIndustryTerm';
  /** Abbreviation (e.g., "DON") */
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** Industry term ID (tag:industry:*) */
  id: Scalars['String']['output'];
  /** Industries where this term is used */
  industries: Array<Scalars['String']['output']>;
  /** Whether the tenant has already adopted this term */
  isAdopted: Scalars['Boolean']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** Statutory definition it maps to */
  mapsToStatutory: Scalars['String']['output'];
  /** Statutory label for reference */
  statutoryLabel: Scalars['String']['output'];
};

/** Result of backfilling training instances. */
export type BackfillTrainingResult = {
  __typename?: 'BackfillTrainingResult';
  /** Number of new training instances created */
  createdCount: Scalars['Int']['output'];
  /** Actor IDs that failed to get training instances */
  failedActorIds: Array<Scalars['String']['output']>;
  /** Number of actors that already had training instances (skipped) */
  skippedCount: Scalars['Int']['output'];
  /** Total HUMAN actors in the tenant */
  totalHumanActors: Scalars['Int']['output'];
};

/** Retry backoff strategy */
export const BackoffType = {
  CONSTANT: 'CONSTANT',
  EXPONENTIAL: 'EXPONENTIAL',
  EXPONENTIAL_WITH_JITTER: 'EXPONENTIAL_WITH_JITTER',
  LINEAR: 'LINEAR',
} as const;

export type BackoffType = (typeof BackoffType)[keyof typeof BackoffType];
/** Input for completing enrollment step */
export type BasicCompleteEnrollmentStepInput = {
  flowId: Scalars['String']['input'];
  prfOutput?: InputMaybe<Scalars['String']['input']>;
  resultData?: InputMaybe<Scalars['String']['input']>;
  stepId: Scalars['Int']['input'];
};

/** Enrollment flow */
export type BasicEnrollmentFlow = {
  __typename?: 'BasicEnrollmentFlow';
  createdAt: Scalars['String']['output'];
  currentStep: Scalars['Int']['output'];
  flowId: Scalars['String']['output'];
  status: BasicEnrollmentFlowStatus | '%future added value';
  steps: Array<BasicEnrollmentStep>;
  trigger: BasicEnrollmentPromptType | '%future added value';
  updatedAt: Scalars['String']['output'];
};

/** Enrollment flow status */
export const BasicEnrollmentFlowStatus = {
  /** Flow abandoned */
  ABANDONED: 'ABANDONED',
  /** Flow completed */
  COMPLETED: 'COMPLETED',
  /** Flow in progress */
  IN_PROGRESS: 'IN_PROGRESS',
  /** Flow not started */
  NOT_STARTED: 'NOT_STARTED',
} as const;

export type BasicEnrollmentFlowStatus =
  (typeof BasicEnrollmentFlowStatus)[keyof typeof BasicEnrollmentFlowStatus];
/** Enrollment prompt */
export type BasicEnrollmentPrompt = {
  __typename?: 'BasicEnrollmentPrompt';
  canSkip: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  promptType: BasicEnrollmentPromptType | '%future added value';
  skipReason?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Enrollment prompt type */
export const BasicEnrollmentPromptType = {
  /** First login - prompt to enroll */
  FIRST_LOGIN: 'FIRST_LOGIN',
  /** Periodic reminder */
  REMINDER: 'REMINDER',
  /** Sensitive action - require enrollment */
  SENSITIVE_ACTION: 'SENSITIVE_ACTION',
} as const;

export type BasicEnrollmentPromptType =
  (typeof BasicEnrollmentPromptType)[keyof typeof BasicEnrollmentPromptType];
/** Enrollment step */
export type BasicEnrollmentStep = {
  __typename?: 'BasicEnrollmentStep';
  canSkip: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  status: BasicEnrollmentStepStatus | '%future added value';
  stepNumber: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Enrollment step status */
export const BasicEnrollmentStepStatus = {
  /** Step completed */
  COMPLETED: 'COMPLETED',
  /** Step in progress */
  IN_PROGRESS: 'IN_PROGRESS',
  /** Step not started */
  PENDING: 'PENDING',
  /** Step skipped */
  SKIPPED: 'SKIPPED',
} as const;

export type BasicEnrollmentStepStatus =
  (typeof BasicEnrollmentStepStatus)[keyof typeof BasicEnrollmentStepStatus];
/** Input for skipping enrollment entirely */
export type BasicSkipEnrollmentInput = {
  reason: Scalars['String']['input'];
};

/** Input for skipping enrollment step */
export type BasicSkipEnrollmentStepInput = {
  flowId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  stepId: Scalars['Int']['input'];
};

/** Input for starting enrollment */
export type BasicStartEnrollmentInput = {
  trigger: BasicEnrollmentPromptType | '%future added value';
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** Result of a batch ceremony creation (D4). */
export type BatchCeremonyError = {
  __typename?: 'BatchCeremonyError';
  documentId: Scalars['String']['output'];
  error: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

/** One item in a batch ceremony creation request (D4). */
export type BatchCeremonyItem = {
  documentId: Scalars['String']['input'];
  overrideDocumentName?: InputMaybe<Scalars['String']['input']>;
  /** Ordered emails matching template participant slots. */
  participantEmails: Array<Scalars['String']['input']>;
};

/** Result of a batch ceremony creation (D4). */
export type BatchCeremonyResult = {
  __typename?: 'BatchCeremonyResult';
  created: Array<SigningCeremony>;
  errors: Array<BatchCeremonyError>;
  totalCreated: Scalars['Int']['output'];
  totalRequested: Scalars['Int']['output'];
};

/** Input for batch compression */
export type BatchCompressInput = {
  /** Counters for each primitive type (per ID) */
  countersPerId: Array<Array<Scalars['Int']['input']>>;
  /** Primitive types present (same for all IDs in batch) */
  primitiveTypes: Array<PrimitiveType | '%future added value'>;
  /** List of Snowflake IDs to compress */
  snowflakeIds: Array<Scalars['String']['input']>;
};

/** Result of batch compression */
export type BatchCompressResult = {
  __typename?: 'BatchCompressResult';
  /** Average compression ratio */
  averageCompressionRatio: Scalars['Float']['output'];
  /** Failed compressions with error messages */
  failed: Array<CompressionError>;
  /** Failure count */
  failureCount: Scalars['Int']['output'];
  /** Success count */
  successCount: Scalars['Int']['output'];
  /** Successfully compressed IDs */
  successful: Array<CompressIdResult>;
  /** Total count */
  totalCount: Scalars['Int']['output'];
  /** Total storage savings (bytes) */
  totalStorageSavings: Scalars['Int']['output'];
};

/** Input for batch ceremony creation from a template (D4). */
export type BatchCreateCeremonyFromTemplateInput = {
  initiatorActorId: Scalars['String']['input'];
  /** Maximum 50 items per batch. */
  items: Array<BatchCeremonyItem>;
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Input for batch decompression */
export type BatchDecompressInput = {
  /** List of compressed IDs to decompress */
  compressedIds: Array<Scalars['String']['input']>;
};

/** Result of batch decompression */
export type BatchDecompressResult = {
  __typename?: 'BatchDecompressResult';
  /** Failed decompressions with error messages */
  failed: Array<DecompressionError>;
  /** Failure count */
  failureCount: Scalars['Int']['output'];
  /** Success count */
  successCount: Scalars['Int']['output'];
  /** Successfully decompressed IDs */
  successful: Array<DecompressIdResult>;
  /** Total count */
  totalCount: Scalars['Int']['output'];
};

/** Result of a single PDF in a batch */
export type BatchPdfItem = {
  __typename?: 'BatchPdfItem';
  /** Error message if generation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Row index (0-based) */
  index: Scalars['Int']['output'];
  /** S3 key where the PDF was uploaded */
  s3Key?: Maybe<Scalars['String']['output']>;
  /** PDF file size in bytes */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  /** Whether this PDF was generated successfully */
  success: Scalars['Boolean']['output'];
};

/** Batch Status Enum */
export const BatchStatus = {
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
} as const;

export type BatchStatus = (typeof BatchStatus)[keyof typeof BatchStatus];
/**
 * A BLE beacon device — either fixed in a zone or worn by a resident.
 *
 * DRR-100/108: Entity code 8B (wearables subgraph).
 * Key: `PK=~{tenant_num}, SK=8B{minor}`
 */
export type Beacon = {
  __typename?: 'Beacon';
  /** Actor ID of assigned resident (wearable beacons only) */
  assignedActorId?: Maybe<Scalars['String']['output']>;
  /** Last known battery voltage in millivolts */
  batteryMv?: Maybe<Scalars['Int']['output']>;
  /** Beacon identifier (e.g., "17-bcn-101") */
  beaconId: Scalars['String']['output'];
  /** Beacon type: STAFF (fixed) or RESIDENT (wearable) */
  beaconType: BeaconType | '%future added value';
  /** iBeacon UUID (shared across facility) */
  beaconUuid: Scalars['String']['output'];
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** Last known RSSI (received signal strength indicator) */
  lastRssi?: Maybe<Scalars['Int']['output']>;
  /** ISO 8601 timestamp of last beacon event */
  lastSeen?: Maybe<Scalars['String']['output']>;
  /** Physical location note for maintenance */
  locationNote?: Maybe<Scalars['String']['output']>;
  /** iBeacon major value (zone type grouping) */
  major: Scalars['Int']['output'];
  /** iBeacon minor value (unique per beacon) */
  minor: Scalars['Int']['output'];
  /** Hardware model (e.g., "BC021") */
  model: Scalars['String']['output'];
  /** Operational status */
  status: BeaconStatus | '%future added value';
  /** Tenant number */
  tenantNum: Scalars['Int']['output'];
  /** Zone this beacon is deployed in (null for wearable beacons) */
  zoneId?: Maybe<Scalars['String']['output']>;
};

/**
 * A beacon proximity event — recorded when a scanner detects a beacon.
 *
 * DRR-100 Tier 1/4: Phone scan or MQTT bridge event.
 * Key: `PK=~{tenant_num}, SK=PROX#{timestamp}#{beacon_id}`
 */
export type BeaconEvent = {
  __typename?: 'BeaconEvent';
  /** Beacon that was detected */
  beaconId: Scalars['String']['output'];
  /** Estimated distance in meters (from RSSI + path loss model) */
  estimatedDistanceM?: Maybe<Scalars['Float']['output']>;
  /** RSSI value at time of detection */
  rssi: Scalars['Int']['output'];
  /** Actor ID of the scanner operator (staff doing rounds) */
  scannerActorId?: Maybe<Scalars['String']['output']>;
  /** Scanner device ID (phone UDID or Pi broker ID) */
  scannerId: Scalars['String']['output'];
  /** Event source tier (1=phone, 2=ESP32, 3=Pi, 4=cloud) */
  sourceTier: Scalars['Int']['output'];
  /** Tenant number */
  tenantNum: Scalars['Int']['output'];
  /** ISO 8601 timestamp of the event */
  timestamp: Scalars['String']['output'];
  /** Zone where detection occurred (resolved from fixed beacon proximity) */
  zoneId?: Maybe<Scalars['String']['output']>;
};

/** Result of a beacon registration mutation. */
export type BeaconRegistrationResult = {
  __typename?: 'BeaconRegistrationResult';
  beacon?: Maybe<Beacon>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Beacon operational status. */
export const BeaconStatus = {
  /** Beacon is active and transmitting */
  ACTIVE: 'ACTIVE',
  /** Beacon is decommissioned */
  DECOMMISSIONED: 'DECOMMISSIONED',
  /** Beacon is inactive (powered off or out of range) */
  INACTIVE: 'INACTIVE',
  /** Beacon battery is low (< 2700 mV) */
  LOW_BATTERY: 'LOW_BATTERY',
} as const;

export type BeaconStatus = (typeof BeaconStatus)[keyof typeof BeaconStatus];
/** Beacon hardware type — fixed (in zone) or wearable (on person). */
export const BeaconType = {
  /** Fixed beacon deployed in a zone (ceiling/wall mount) */
  STAFF: 'STAFF',
  /** Wearable beacon worn by a subject (wrist/pendant) */
  SUBJECT: 'SUBJECT',
} as const;

export type BeaconType = (typeof BeaconType)[keyof typeof BeaconType];
/**
 * A single best practice recommendation (DRR-156).
 *
 * Industry-agnostic — all domain specificity comes from the advisory
 * RuleSet YAML's edges (PUBLISHED_BY, RECOMMENDS, IMPROVES, MITIGATES).
 */
export type BestPracticeRecommendation = {
  __typename?: 'BestPracticeRecommendation';
  /** Tenant's current adoption status. */
  adoptionStatus: GqlAdoptionStatus | '%future added value';
  /** Description from the advisory RuleSet. */
  description: Scalars['String']['output'];
  /** QoL outcomes this practice improves (from IMPROVES edge targets). */
  improves: Array<Scalars['String']['output']>;
  /** Intelligence layer that surfaced this recommendation. */
  intelligenceLayer: GqlIntelligenceLayer | '%future added value';
  /** Risks this practice mitigates (from MITIGATES edge targets). */
  mitigates: Array<Scalars['String']['output']>;
  /** Advisory RuleSet config ID (e.g., "rs-4-16-001"). */
  practiceRef: Scalars['String']['output'];
  /** Config IDs this practice recommends adopting (from RECOMMENDS edges). */
  recommendsConfigs: Array<Scalars['String']['output']>;
  /** Safety level (always "advisory" for best practice recommendations). */
  safetyLevel: Scalars['String']['output'];
  /** Source channel (curated, LLM, peer). */
  source: GqlRecommendationSource | '%future added value';
  /** Association that published this practice (from PUBLISHED_BY edge target). */
  sourceAssociation: Scalars['String']['output'];
  /** Association display name (resolved from care-vocabulary). */
  sourceAssociationLabel: Scalars['String']['output'];
  /** Human-readable recommendation title from the advisory RuleSet. */
  title: Scalars['String']['output'];
};

/** GraphQL output for authentication challenge */
export type BiometricAuthenticationChallenge = {
  __typename?: 'BiometricAuthenticationChallenge';
  /**
   * JSON-encoded PublicKeyCredentialRequestOptions
   * Frontend passes this to @simplewebauthn/browser startAuthentication()
   */
  challenge: Scalars['String']['output'];
  /** Expiration timestamp (5 minutes from now) */
  expiresAt: Scalars['String']['output'];
  /** Session ID for state tracking */
  sessionId: Scalars['String']['output'];
};

/** GraphQL output for successful authentication */
export type BiometricAuthenticationSuccess = {
  __typename?: 'BiometricAuthenticationSuccess';
  /** Token expiration timestamp */
  expiresAt: Scalars['String']['output'];
  /** Success status */
  success: Scalars['Boolean']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** JWT token for subsequent API requests (8-hour expiry) */
  token: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['String']['output'];
};

/** GraphQL output for biometric registration challenge */
export type BiometricRegistrationChallenge = {
  __typename?: 'BiometricRegistrationChallenge';
  /**
   * JSON-encoded PublicKeyCredentialCreationOptions
   * Frontend passes this to @simplewebauthn/browser startRegistration()
   */
  challenge: Scalars['String']['output'];
  /** Expiration timestamp (5 minutes from now) */
  expiresAt: Scalars['String']['output'];
  /** User ID for session tracking */
  userId: Scalars['String']['output'];
};

/** GraphQL output for successful registration */
export type BiometricRegistrationSuccess = {
  __typename?: 'BiometricRegistrationSuccess';
  /** Credential ID (for reference) */
  credentialId: Scalars['String']['output'];
  /** Device name */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** Registration timestamp */
  registeredAt: Scalars['String']['output'];
  /** Success status */
  success: Scalars['Boolean']['output'];
};

/**
 * A scope bounds violation detected during scope resolution.
 *
 * DRR-283: Statutory floor/ceiling enforcement. When a role config violates
 * bounds defined by the underlying statutory role, this is surfaced to the
 * architect/admin for remediation.
 */
export type BoundsViolation = {
  __typename?: 'BoundsViolation';
  /** Human-readable message explaining the violation */
  message: Scalars['String']['output'];
  /** Role ID that has this violation */
  roleId: Scalars['String']['output'];
  /** The scope involved in the violation */
  scope: Scalars['String']['output'];
  /** Statutory reference that defines the bounds (e.g., "MN 144G.08 Subd 30") */
  statuteRef?: Maybe<Scalars['String']['output']>;
  /** Type of violation */
  violationType: BoundsViolationType | '%future added value';
};

/** Type of scope bounds violation. */
export const BoundsViolationType = {
  /** Role has an unauthorized scope (exceeds statutory ceiling, filtered out) */
  CEILING_EXCEEDED: 'CEILING_EXCEEDED',
  /** Role is missing a required floor scope (statutory minimum not met) */
  FLOOR_MISSING: 'FLOOR_MISSING',
} as const;

export type BoundsViolationType = (typeof BoundsViolationType)[keyof typeof BoundsViolationType];
export type BrandConfigGql = {
  __typename?: 'BrandConfigGql';
  logoUrl?: Maybe<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type BrandConfigInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

/** Input for break-glass emergency wall override. */
export type BreakGlassOverrideInput = {
  /** Emergency justification (required, audited) */
  justification: Scalars['String']['input'];
  /** Target scope being accessed (e.g., "billing:read" for clinical wall user) */
  targetScope: Scalars['String']['input'];
  /** Witness actor ID (for Tier 4 fresh witness verification) */
  witnessActorId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of a break-glass override. */
export type BreakGlassOverrideResult = {
  __typename?: 'BreakGlassOverrideResult';
  /** Audit event ID for this override */
  auditEventId: Scalars['String']['output'];
  /** Denial reason (if not granted) */
  denialReason?: Maybe<Scalars['String']['output']>;
  /** Expiry of the override */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the override was granted */
  granted: Scalars['Boolean']['output'];
  /** Notification sent to review roles */
  notificationSent: Scalars['Boolean']['output'];
  /** Time-limited override token (expires per break_glass.review_window) */
  overrideToken?: Maybe<Scalars['String']['output']>;
};

/** Briefing template metadata surfaced from YAML configs. */
export type BriefingTemplate = {
  __typename?: 'BriefingTemplate';
  /** Config ID (e.g., "ast-brief-daily-digest-001") */
  briefingId: Scalars['String']['output'];
  /** Number of context variables in the template */
  contextVariableCount: Scalars['Int']['output'];
  /** Delivery channels (e.g., ["dashboard", "sms"]) */
  deliveryChannels: Array<Scalars['String']['output']>;
  /** Description of the briefing */
  description: Scalars['String']['output'];
  /** Human-readable display name */
  displayName: Scalars['String']['output'];
  /** Internal name */
  name: Scalars['String']['output'];
  /** Number of sections in the template */
  sectionCount: Scalars['Int']['output'];
  /** Workflow event that triggers this briefing */
  triggerEvent: Scalars['String']['output'];
};

/** Bulk Operation Output */
export type BulkOperation = {
  __typename?: 'BulkOperation';
  /** Batch ID */
  batchId: Scalars['String']['output'];
  /** Completed timestamp */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Error summary */
  errorSummary?: Maybe<Scalars['String']['output']>;
  /** Failure count */
  failureCount: Scalars['Int']['output'];
  /** Filename */
  filename: Scalars['String']['output'];
  /** Is rollbackable (within time window) */
  isRollbackable: Scalars['Boolean']['output'];
  /** User who processed */
  processedBy: Scalars['String']['output'];
  /** Individual row results */
  results: Array<RowResult>;
  /** Started timestamp */
  startedAt: Scalars['DateTime']['output'];
  /** Batch status */
  status: BatchStatus | '%future added value';
  /** Success count */
  successCount: Scalars['Int']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Total rows in batch */
  totalRows: Scalars['Int']['output'];
};

/** Input for bulk-verifying high-confidence extractions */
export type BulkVerifyInput = {
  /** Minimum confidence threshold (default: 0.9) */
  confidenceThreshold?: Scalars['Float']['input'];
  mappingId: Scalars['String']['input'];
  reviewerId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Business metadata */
export type BusinessMetadata = {
  __typename?: 'BusinessMetadata';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

/** Business metadata input */
export type BusinessMetadataInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

/** Business metadata output */
export type BusinessMetadataOutput = {
  __typename?: 'BusinessMetadataOutput';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

/**
 * Business process type for workflow complexity tracking
 * LIFE-CRITICAL: Process duration and safety validation
 */
export type BusinessProcessTypeGql = {
  __typename?: 'BusinessProcessTypeGql';
  category: Scalars['String']['output'];
  complexityLevel: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  processType: Scalars['String']['output'];
  typicalDuration: Scalars['String']['output'];
};

/** Input for cancelling an Encounter */
export type CancelEncounterInput = {
  /** Dual control approvals (required if entered_in_error = true) */
  approvals?: Array<DualControlApprovalInput>;
  /** If true, marks as "entered-in-error" (requires dual control approval) */
  enteredInError?: Scalars['Boolean']['input'];
  /** Encounter ID to cancel */
  id: Scalars['String']['input'];
  /** Reason for cancellation (required for audit trail) */
  reason: Scalars['String']['input'];
};

/** Input for cancelling an Observation */
export type CancelObservationInput = {
  /** Dual control approvals (required if entered_in_error = true) */
  approvals?: Array<DualControlApprovalInput>;
  /** If true, marks as "entered-in-error" (requires dual control approval) */
  enteredInError?: Scalars['Boolean']['input'];
  /** Observation ID to cancel */
  id: Scalars['String']['input'];
  /** Reason for cancellation (required for audit trail) */
  reason: Scalars['String']['input'];
};

/** Input for cancelling a Procedure */
export type CancelProcedureInput = {
  /** Dual control approvals (required if entered_in_error = true) */
  approvals?: Array<DualControlApprovalInput>;
  /** If true, marks as "entered-in-error" (requires dual control approval) */
  enteredInError?: Scalars['Boolean']['input'];
  /** Procedure ID to cancel */
  id: Scalars['String']['input'];
  /** Reason for cancellation (required for audit trail) */
  reason: Scalars['String']['input'];
};

/** Capabilities for an entity type. */
export type Capabilities = {
  __typename?: 'Capabilities';
  /** Can approve instances (for workflows) */
  canApprove: Scalars['Boolean']['output'];
  /** Can create new instances */
  canCreate: Scalars['Boolean']['output'];
  /** Can delegate capabilities to others */
  canDelegate: Scalars['Boolean']['output'];
  /** Can delete instances */
  canDelete: Scalars['Boolean']['output'];
  /** Can read instances */
  canRead: Scalars['Boolean']['output'];
  /** Can update instances */
  canUpdate: Scalars['Boolean']['output'];
  /** Custom actions beyond CRUD */
  customActions: Array<CustomActionCapability>;
  /** Entity type this applies to */
  entityType: Scalars['String']['output'];
};

/** Context for capability resolution. */
export type CapabilityContext = {
  /** Optional entity ID for instance-level capabilities */
  entityId?: InputMaybe<Scalars['String']['input']>;
  /** Entity type (e.g., "policy", "task", "fhir_patient", "gl_account") */
  entityType: Scalars['String']['input'];
  /** Optional jurisdiction override (uses auth context default otherwise) */
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  /** Optional subgraph override (inferred from entityType if not provided) */
  subgraph?: InputMaybe<Scalars['String']['input']>;
};

/** Care assessment */
export type CareCircleAssessment = {
  __typename?: 'CareCircleAssessment';
  careLevel?: Maybe<CareCircleCareLevel | '%future added value'>;
  createdAt: Scalars['DateTime']['output'];
  familyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  matchedFacilityCount: Scalars['Int']['output'];
  maxBudget?: Maybe<Scalars['Int']['output']>;
  maxDistanceMiles?: Maybe<Scalars['Int']['output']>;
  medicaidEligible: Scalars['Boolean']['output'];
  mobility?: Maybe<CareCircleMobility | '%future added value'>;
  moveInTimeline?: Maybe<CareCircleMoveInTimeline | '%future added value'>;
  specificLanguages: Array<Scalars['String']['output']>;
  vaBenefits: Scalars['Boolean']['output'];
  wantsPharmacist: Scalars['Boolean']['output'];
  wantsPsychologist: Scalars['Boolean']['output'];
  wantsRn247: Scalars['Boolean']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Current availability */
export type CareCircleAvailability = {
  __typename?: 'CareCircleAvailability';
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  memoryCareBeds?: Maybe<Scalars['Int']['output']>;
  privateRooms?: Maybe<Scalars['Int']['output']>;
  semiPrivateRooms?: Maybe<Scalars['Int']['output']>;
  waitlistMonths?: Maybe<Scalars['Int']['output']>;
};

/** Care level needed */
export const CareCircleCareLevel = {
  ASSISTED_LIVING: 'ASSISTED_LIVING',
  HOSPICE: 'HOSPICE',
  INDEPENDENT: 'INDEPENDENT',
  MEMORY_CARE: 'MEMORY_CARE',
  SKILLED_NURSING: 'SKILLED_NURSING',
} as const;

export type CareCircleCareLevel = (typeof CareCircleCareLevel)[keyof typeof CareCircleCareLevel];
/** Care recipient info */
export type CareCircleCareRecipient = {
  __typename?: 'CareCircleCareRecipient';
  currentLivingSituation?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['NaiveDate']['output']>;
  name: Scalars['String']['output'];
  primaryDiagnosis?: Maybe<Scalars['String']['output']>;
};

/** Care types offered */
export type CareCircleCareTypes = {
  __typename?: 'CareCircleCareTypes';
  assistedLiving: Scalars['Boolean']['output'];
  bariatricCapable: Scalars['Boolean']['output'];
  hospiceFriendly: Scalars['Boolean']['output'];
  memoryCare: Scalars['Boolean']['output'];
  respiteCare: Scalars['Boolean']['output'];
  skilledNursing: Scalars['Boolean']['output'];
  ventilatorCapable: Scalars['Boolean']['output'];
};

/** Cultural features at a facility */
export type CareCircleCulturalFeatures = {
  __typename?: 'CareCircleCulturalFeatures';
  culturalFoodOptions: Array<Scalars['String']['output']>;
  hmongSpeakingStaff: Scalars['Boolean']['output'];
  languagesSpoken: Array<Scalars['String']['output']>;
  religiousServices: Array<Scalars['String']['output']>;
};

/** Facility listing */
export type CareCircleFacility = {
  __typename?: 'CareCircleFacility';
  acceptsMedicaid: Scalars['Boolean']['output'];
  acceptsMedicare: Scalars['Boolean']['output'];
  acceptsVa: Scalars['Boolean']['output'];
  address: Scalars['String']['output'];
  careTypes: CareCircleCareTypes;
  city: Scalars['String']['output'];
  cmsHealthInspection?: Maybe<Scalars['Int']['output']>;
  cmsOverallRating?: Maybe<Scalars['Int']['output']>;
  cmsQuality?: Maybe<Scalars['Int']['output']>;
  cmsStaffing?: Maybe<Scalars['Int']['output']>;
  culturalFeatures: CareCircleCulturalFeatures;
  currentAvailability: CareCircleAvailability;
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isFerpManaged: Scalars['Boolean']['output'];
  matchReasons: Array<Scalars['String']['output']>;
  matchScore?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  privatePayRange: CareCirclePriceRange;
  staffFeatures: CareCircleStaffFeatures;
  state: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

/** Family entity */
export type CareCircleFamily = {
  __typename?: 'CareCircleFamily';
  careRecipient?: Maybe<CareCircleCareRecipient>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  marketingAuthorized: Scalars['Boolean']['output'];
  members: Array<CareCircleFamilyMember>;
  preferredLanguage: CareCircleLanguage | '%future added value';
};

/** Family member in the care circle */
export type CareCircleFamilyMember = {
  __typename?: 'CareCircleFamilyMember';
  email?: Maybe<Scalars['String']['output']>;
  isPrimaryContact: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferredLanguage: CareCircleLanguage | '%future added value';
  relationship: Scalars['String']['output'];
};

/** Language preference */
export const CareCircleLanguage = {
  ENGLISH: 'ENGLISH',
  HMONG: 'HMONG',
  KAREN: 'KAREN',
  OTHER: 'OTHER',
  SOMALI: 'SOMALI',
  SPANISH: 'SPANISH',
  VIETNAMESE: 'VIETNAMESE',
} as const;

export type CareCircleLanguage = (typeof CareCircleLanguage)[keyof typeof CareCircleLanguage];
/** Lead to a facility */
export type CareCircleLead = {
  __typename?: 'CareCircleLead';
  careRecipientName: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  facilityId: Scalars['String']['output'];
  facilityName: Scalars['String']['output'];
  familyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastContactedAt?: Maybe<Scalars['DateTime']['output']>;
  moveInTimeline?: Maybe<CareCircleMoveInTimeline | '%future added value'>;
  status: CareCircleLeadStatus | '%future added value';
};

/** Lead status */
export const CareCircleLeadStatus = {
  ADMITTED: 'ADMITTED',
  APPLIED: 'APPLIED',
  CONTACTED: 'CONTACTED',
  DECLINED: 'DECLINED',
  LOST: 'LOST',
  NEW: 'NEW',
  TOUR_COMPLETED: 'TOUR_COMPLETED',
  TOUR_SCHEDULED: 'TOUR_SCHEDULED',
} as const;

export type CareCircleLeadStatus = (typeof CareCircleLeadStatus)[keyof typeof CareCircleLeadStatus];
/** Mobility level */
export const CareCircleMobility = {
  BEDBOUND: 'BEDBOUND',
  INDEPENDENT: 'INDEPENDENT',
  WALKER: 'WALKER',
  WHEELCHAIR: 'WHEELCHAIR',
} as const;

export type CareCircleMobility = (typeof CareCircleMobility)[keyof typeof CareCircleMobility];
/** Move-in timeline */
export const CareCircleMoveInTimeline = {
  EXPLORING: 'EXPLORING',
  IMMEDIATE: 'IMMEDIATE',
  ONE_MONTH: 'ONE_MONTH',
  SIX_MONTHS: 'SIX_MONTHS',
  THREE_MONTHS: 'THREE_MONTHS',
} as const;

export type CareCircleMoveInTimeline =
  (typeof CareCircleMoveInTimeline)[keyof typeof CareCircleMoveInTimeline];
/** Price range */
export type CareCirclePriceRange = {
  __typename?: 'CareCirclePriceRange';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

/** Provider record tracking */
export type CareCircleProviderRecord = {
  __typename?: 'CareCircleProviderRecord';
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  providerType: Scalars['String']['output'];
  receivedDate?: Maybe<Scalars['NaiveDate']['output']>;
  requestedDate?: Maybe<Scalars['NaiveDate']['output']>;
  status: CareCircleRecordStatus | '%future added value';
};

/** Raffle action type */
export const CareCircleRaffleAction = {
  COMPLETE_ASSESSMENT: 'COMPLETE_ASSESSMENT',
  COMPLETE_PROFILE: 'COMPLETE_PROFILE',
  REFER_FRIEND: 'REFER_FRIEND',
  SCHEDULE_TOUR: 'SCHEDULE_TOUR',
  SIGNUP: 'SIGNUP',
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
} as const;

export type CareCircleRaffleAction =
  (typeof CareCircleRaffleAction)[keyof typeof CareCircleRaffleAction];
/** Info about a raffle action (for UI display) */
export type CareCircleRaffleActionInfo = {
  __typename?: 'CareCircleRaffleActionInfo';
  action: CareCircleRaffleAction | '%future added value';
  description: Scalars['String']['output'];
  isOneTime: Scalars['Boolean']['output'];
  maxPerMonth?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
};

/** Raffle entry */
export type CareCircleRaffleEntry = {
  __typename?: 'CareCircleRaffleEntry';
  claimed: Scalars['Boolean']['output'];
  entryMonth: Scalars['String']['output'];
  familyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  prize?: Maybe<Scalars['String']['output']>;
  selectedAsWinner: Scalars['Boolean']['output'];
  totalPoints: Scalars['Int']['output'];
};

/** Raffle status for current month */
export type CareCircleRaffleStatus = {
  __typename?: 'CareCircleRaffleStatus';
  currentMonth: Scalars['String']['output'];
  drawingDate: Scalars['NaiveDate']['output'];
  myPoints: Scalars['Int']['output'];
  prizeDescription: Scalars['String']['output'];
  prizeValue: Scalars['Int']['output'];
  totalEntries: Scalars['Int']['output'];
};

/** Record status */
export const CareCircleRecordStatus = {
  NEEDED: 'NEEDED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  RECEIVED: 'RECEIVED',
  REQUESTED: 'REQUESTED',
  UPLOADED: 'UPLOADED',
} as const;

export type CareCircleRecordStatus =
  (typeof CareCircleRecordStatus)[keyof typeof CareCircleRecordStatus];
/** Record tracker for a family */
export type CareCircleRecordTracker = {
  __typename?: 'CareCircleRecordTracker';
  careRecipientName: Scalars['String']['output'];
  completionPercentage: Scalars['Float']['output'];
  familyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  providers: Array<CareCircleProviderRecord>;
  recordsReceived: Scalars['Int']['output'];
  totalProviders: Scalars['Int']['output'];
};

/** Staff features at a facility */
export type CareCircleStaffFeatures = {
  __typename?: 'CareCircleStaffFeatures';
  dietitian: Scalars['Boolean']['output'];
  lpnOnStaff: Scalars['Boolean']['output'];
  otOnSite: Scalars['Boolean']['output'];
  pharmacistOnStaff: Scalars['Boolean']['output'];
  psychologistOnStaff: Scalars['Boolean']['output'];
  ptOnSite: Scalars['Boolean']['output'];
  rn247: Scalars['Boolean']['output'];
  socialWorker: Scalars['Boolean']['output'];
  speechTherapy: Scalars['Boolean']['output'];
};

/** Pattern-prefix rule for auto-categorizing entity types */
export type CategoryRule = {
  __typename?: 'CategoryRule';
  /** Category ID to assign */
  category: Scalars['String']['output'];
  /** Entity name prefix to match */
  patternPrefix: Scalars['String']['output'];
  /** Tier to assign */
  tier: Scalars['String']['output'];
};

/** Custom branding configuration for the public signing page (D6). */
export type CeremonyBranding = {
  __typename?: 'CeremonyBranding';
  /** Company name shown as the page title instead of "Sign Document". */
  companyName?: Maybe<Scalars['String']['output']>;
  /** URL to a logo image shown at the top of the signing page. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Hex primary color applied to the Sign button, e.g. "#1a73e8". */
  primaryColor?: Maybe<Scalars['String']['output']>;
};

/** Custom branding input for the public signing page (D6). */
export type CeremonyBrandingInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Hex primary color e.g. "#1a73e8". */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
};

/** Result of requesting a presigned download URL for a ceremony document. */
export type CeremonyDocumentUrl = {
  __typename?: 'CeremonyDocumentUrl';
  downloadUrl: Scalars['String']['output'];
  expiresInSeconds: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
};

/** Input for a placed field on the PDF for step-through signing. */
export type CeremonyFieldInput = {
  /** Type of field. */
  fieldType: SignatureFieldType | '%future added value';
  /** Height (relative 0–1). */
  height: Scalars['Float']['input'];
  /** Page number (1-indexed). */
  page: Scalars['Int']['input'];
  /** Which participant this field belongs to (index into participants array). */
  participantIndex: Scalars['Int']['input'];
  /** Width (relative 0–1). */
  width: Scalars['Float']['input'];
  /** Left edge (relative 0–1, origin top-left). */
  x: Scalars['Float']['input'];
  /** Top edge (relative 0–1, origin top-left). */
  y: Scalars['Float']['input'];
};

export type CeremonyParticipant = {
  __typename?: 'CeremonyParticipant';
  declineReason?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  fieldHeight?: Maybe<Scalars['Float']['output']>;
  fieldName: Scalars['String']['output'];
  /** Placed field page (1-indexed, relative coords, B1). */
  fieldPage?: Maybe<Scalars['Int']['output']>;
  /** Field type placed by the sender (B1). */
  fieldType?: Maybe<SignatureFieldType | '%future added value'>;
  fieldWidth?: Maybe<Scalars['Float']['output']>;
  fieldX?: Maybe<Scalars['Float']['output']>;
  fieldY?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /**
   * Masked phone number for SMS notifications (D2). Last 4 digits only, e.g. "••••••0123".
   * None if no phone was registered.
   */
  phone?: Maybe<Scalars['String']['output']>;
  role: SignerRole | '%future added value';
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ParticipantStatus | '%future added value';
};

/**
 * A placed field on the PDF that a participant must complete during step-through signing.
 *
 * Multiple fields per participant enable a DocuSign-like guided signing experience:
 * signature on page 1, initials on page 3, date on page 5, etc.
 */
export type CeremonyPlacedField = {
  __typename?: 'CeremonyPlacedField';
  /** Whether this field has been completed. */
  completed: Scalars['Boolean']['output'];
  /** Index of the field in the ceremony's field list. */
  fieldIndex: Scalars['Int']['output'];
  /** Type of field to complete. */
  fieldType: SignatureFieldType | '%future added value';
  /** Height (relative 0–1). */
  height: Scalars['Float']['output'];
  /** Page number (1-indexed). */
  page: Scalars['Int']['output'];
  /** Which participant this field belongs to (index into participants array). */
  participantIndex: Scalars['Int']['output'];
  /** Width (relative 0–1). */
  width: Scalars['Float']['output'];
  /** Left edge (relative 0–1, origin top-left). */
  x: Scalars['Float']['output'];
  /** Top edge (relative 0–1, origin top-left). */
  y: Scalars['Float']['output'];
};

/** Ceremony-level signature verification report (D5). */
export type CeremonySignatureVerification = {
  __typename?: 'CeremonySignatureVerification';
  allValid: Scalars['Boolean']['output'];
  ceremonyId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  signatures: Array<SignatureVerificationResult>;
  verifiedAt: Scalars['String']['output'];
};

export const CeremonyStatus = {
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
  DRAFT: 'DRAFT',
  EXPIRED: 'EXPIRED',
  SENT: 'SENT',
  SIGNING: 'SIGNING',
  /** Sender cancelled the ceremony (C1). */
  VOIDED: 'VOIDED',
} as const;

export type CeremonyStatus = (typeof CeremonyStatus)[keyof typeof CeremonyStatus];
export type CeremonyTemplateGql = {
  __typename?: 'CeremonyTemplateGql';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentName: Scalars['String']['output'];
  expiryHours?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ordering: Scalars['String']['output'];
  padesProfile?: Maybe<Scalars['String']['output']>;
  participants: Array<CeremonyTemplateParticipantGql>;
  pdfTemplateId?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageCount: Scalars['Int']['output'];
};

export type CeremonyTemplateParticipantGql = {
  __typename?: 'CeremonyTemplateParticipantGql';
  appearanceReason?: Maybe<Scalars['String']['output']>;
  fieldHeight?: Maybe<Scalars['Float']['output']>;
  fieldPage?: Maybe<Scalars['Int']['output']>;
  /** Field type (Signature, Initials, DateSigned, TextField). None = invisible. */
  fieldType?: Maybe<Scalars['String']['output']>;
  fieldWidth?: Maybe<Scalars['Float']['output']>;
  fieldX?: Maybe<Scalars['Float']['output']>;
  fieldY?: Maybe<Scalars['Float']['output']>;
  required: Scalars['Boolean']['output'];
  roleName: Scalars['String']['output'];
  /** Signing role: Signer, Approver, CarbonCopy, Witness */
  signingRole: Scalars['String']['output'];
};

/** Result of myCertificationGaps query. */
export type CertificationGapsResult = {
  __typename?: 'CertificationGapsResult';
  /** Actor ID */
  actorId: Scalars['String']['output'];
  /** Certifications expiring soon (sorted by urgency) */
  expiringCertifications: Array<ExpiringCertification>;
  /** Total certifications needing attention */
  totalExpiring: Scalars['Int']['output'];
};

export type CertificationGql = {
  __typename?: 'CertificationGql';
  certificationNumber?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  fdaApproved?: Maybe<Scalars['Boolean']['output']>;
  issuingAuthority?: Maybe<Scalars['String']['output']>;
};

export type CertificationInput = {
  certificationNumber?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  fdaApproved?: InputMaybe<Scalars['Boolean']['input']>;
  issuingAuthority?: InputMaybe<Scalars['String']['input']>;
};

/** Urgency level for certification expiration. */
export const CertificationUrgency = {
  /** Expiring within 30 days - urgent */
  CRITICAL: 'CRITICAL',
  /** Already expired - scopes currently blocked */
  EXPIRED: 'EXPIRED',
  /** Expiring within 90 days - plan ahead */
  NOTICE: 'NOTICE',
  /** Expiring within 60 days - needs attention */
  WARNING: 'WARNING',
} as const;

export type CertificationUrgency = (typeof CertificationUrgency)[keyof typeof CertificationUrgency];
/** A single chain entry from a device */
export type ChainEntryInput = {
  /** Event data as JSON */
  data: Scalars['JSON']['input'];
  /** Type of event */
  eventType: GqlSyncEventType | '%future added value';
  /** Blake3 hash hex string */
  hash: Scalars['String']['input'];
  /** Previous entry's hash (GENESIS_SEED hash for entry 0) */
  prevHash: Scalars['String']['input'];
  /** Sequence number in the chain (0-indexed) */
  sequence: Scalars['Int']['input'];
  /** When this event occurred on the device */
  timestamp: Scalars['DateTime']['input'];
};

/** Chain verification result (returned by chainVerification query) */
export type ChainVerificationResult = {
  __typename?: 'ChainVerificationResult';
  /** Total chain length */
  chainLength: Scalars['Int']['output'];
  /** Number of entries verified */
  entriesVerified: Scalars['Int']['output'];
  /** First broken link index (null if valid) */
  firstBrokenLink?: Maybe<Scalars['Int']['output']>;
  /** Actor ID from genesis entry */
  genesisActorId: Scalars['String']['output'];
  /** Device ID from genesis entry */
  genesisDeviceId: Scalars['String']['output'];
  /** Timestamp of genesis entry */
  genesisTimestamp: Scalars['DateTime']['output'];
  /** Whether the entire chain is valid */
  valid: Scalars['Boolean']['output'];
};

export const ChangeType = {
  policyUpdate: 'policyUpdate',
  resourceReallocation: 'resourceReallocation',
  stateOptimization: 'stateOptimization',
  transitionImprovement: 'transitionImprovement',
} as const;

export type ChangeType = (typeof ChangeType)[keyof typeof ChangeType];
/** Chaos Document (GraphQL output) */
export type ChaosDocument = {
  __typename?: 'ChaosDocument';
  /** Document ID */
  documentId: Scalars['String']['output'];
  /** Upload URL expiration timestamp (ISO 8601) */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** File size */
  fileSize: Scalars['Int']['output'];
  /** Filename */
  filename: Scalars['String']['output'];
  /** Intake target — what this document should be converted into (DRR-137) */
  intakeTarget: IntakeTarget | '%future added value';
  /** Latest conversion (if exists) */
  latestConversion?: Maybe<ConversionReference>;
  /** MIME type */
  mimeType: Scalars['String']['output'];
  /** Document status */
  status: ChaosDocumentStatus | '%future added value';
  /** Tenant */
  tenant: Scalars['String']['output'];
  /**
   * Presigned S3 upload URL (only populated on upload mutation)
   * Frontend uses this to PUT file directly to S3/MinIO
   */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Upload metadata */
  uploadedAt: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
};

/** Chaos Document Details (GraphQL output) */
export type ChaosDocumentDetails = {
  __typename?: 'ChaosDocumentDetails';
  /** Conversion history */
  conversionHistory: Array<ConversionHistoryEntry>;
  /** Document ID */
  documentId: Scalars['String']['output'];
  /** Extracted metadata (if analyzed) */
  extractedMetadata?: Maybe<ExtractedMetadata>;
  /** File size */
  fileSize: Scalars['Int']['output'];
  /** Filename */
  filename: Scalars['String']['output'];
  /** Latest conversion (if exists) */
  latestConversion?: Maybe<ConversionReference>;
  /** MIME type */
  mimeType: Scalars['String']['output'];
  /** S3 location */
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  /** Document status */
  status: ChaosDocumentStatus | '%future added value';
  /** Tenant */
  tenant: Scalars['String']['output'];
  /** Upload metadata */
  uploadedAt: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
};

/**
 * Chaos Document Processing Status (GraphQL enum)
 *
 * Tracks the status of document processing through the Chaos-to-DSL pipeline.
 * Different from DocumentStatus which tracks document lifecycle (draft, approval, published).
 */
export const ChaosDocumentStatus = {
  ANALYZED: 'ANALYZED',
  ANALYZING: 'ANALYZING',
  ARCHIVED: 'ARCHIVED',
  CONVERTED: 'CONVERTED',
  CONVERTING: 'CONVERTING',
  FAILED: 'FAILED',
  UPLOADED: 'UPLOADED',
} as const;

export type ChaosDocumentStatus = (typeof ChaosDocumentStatus)[keyof typeof ChaosDocumentStatus];
/** Extraction result summary */
export type ChaosExtractionResult = {
  __typename?: 'ChaosExtractionResult';
  actorCount: Scalars['Int']['output'];
  complexity: Scalars['String']['output'];
  complianceIndicators: Array<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  decisionCount: Scalars['Int']['output'];
  detectedDomain: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  fieldCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stepCount: Scalars['Int']['output'];
};

/** Select option for Chaos-to-DSL conversion */
export type ChaosSelectOption = {
  __typename?: 'ChaosSelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ChaosUploadUrlResult = {
  __typename?: 'ChaosUploadUrlResult';
  contentType: Scalars['String']['output'];
  expiresInSeconds: Scalars['Int']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** Check Framework Compliance Input */
export type CheckFrameworkComplianceInput = {
  actor: Scalars['String']['input'];
  framework: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** GraphQL output type for Checkpoint primitive. */
export type Checkpoint = {
  __typename?: 'Checkpoint';
  /** Times used for rollback */
  accessCount: Scalars['Int']['output'];
  /** Archive timestamp */
  autoArchiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether rollback is allowed */
  canRollback: Scalars['Boolean']['output'];
  /** Display name for this checkpoint */
  checkpointName: Scalars['String']['output'];
  /** Checkpoint type */
  checkpointType: GqlCheckpointType | '%future added value';
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this checkpoint.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Compression efficiency */
  compressionRatio: Scalars['Float']['output'];
  /** When created */
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this checkpoint */
  createdByActor?: Maybe<ActorSummary>;
  /** Current checkpoint status */
  currentStatus: GqlCheckpointStatus | '%future added value';
  /** Delta from previous checkpoint (for optimization) */
  deltaFromPrevious?: Maybe<Scalars['JSON']['output']>;
  /** Entity type this checkpoint belongs to (Task, Workflow, etc.) */
  entityType: Scalars['String']['output'];
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Whether checkpoint is active (false = archived/soft-deleted) */
  isActive: Scalars['Boolean']['output'];
  /** Last time checkpoint was used for rollback/resume */
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last rollback timestamp */
  lastRollbackAt?: Maybe<Scalars['DateTime']['output']>;
  /** Rollback reason */
  lastRollbackReason?: Maybe<Scalars['String']['output']>;
  /** Maximum retries */
  maxResumeAttempts: Scalars['Int']['output'];
  /** Tenant-specific extensions */
  metadata: Scalars['JSON']['output'];
  /** Original checkpoint ID (stable across all versions) */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Parent checkpoint ID (for amendment/correction chain) */
  parentId?: Maybe<Scalars['String']['output']>;
  /** WHO initiated recovery from this checkpoint */
  recoveredByActor?: Maybe<ActorSummary>;
  /** Last recovery attempt timestamp */
  recoveryAttemptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Recovery result */
  recoverySuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Can resume from this checkpoint */
  resumeEnabled: Scalars['Boolean']['output'];
  /** Timeout before failure (seconds) */
  resumeTimeoutSeconds: Scalars['Int']['output'];
  /** How long to keep (30/365/2555 days) */
  retentionDays: Scalars['Int']['output'];
  /** Times rolled back */
  rollbackCount: Scalars['Int']['output'];
  /** Order in rollback chain */
  rollbackOrder: Scalars['Int']['output'];
  /** Rollback strategy */
  rollbackStrategy: GqlRollbackStrategy | '%future added value';
  /** Checkpoint order (1, 2, 3...) */
  sequenceNumber: Scalars['Int']['output'];
  /** Time to create snapshot (milliseconds) */
  serializationDurationMs: Scalars['Int']['output'];
  /** SHA-256 checksum for tamper detection */
  snapshotChecksum: Scalars['String']['output'];
  /** PII/PHI encryption flag */
  snapshotEncrypted: Scalars['Boolean']['output'];
  /** Snapshot format */
  snapshotFormat: GqlSnapshotFormat | '%future added value';
  /** Size of state snapshot in bytes */
  snapshotSizeBytes: Scalars['Int']['output'];
  /** Complete state snapshot (JSON) */
  stateSnapshot: Scalars['JSON']['output'];
  /** When last modified */
  updatedAt: Scalars['DateTime']['output'];
};

/** Priority level for a checkpoint. */
export const CheckpointPriority = {
  /** Life-safety or immediate jeopardy */
  CRITICAL: 'CRITICAL',
  /** Significant compliance gap */
  HIGH: 'HIGH',
  /** Minor or documentation-only */
  LOW: 'LOW',
  /** Standard compliance item */
  MEDIUM: 'MEDIUM',
} as const;

export type CheckpointPriority = (typeof CheckpointPriority)[keyof typeof CheckpointPriority];
/** Checkpoint validation result */
export type CheckpointValidationResult = {
  __typename?: 'CheckpointValidationResult';
  checksumMatch: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
  snapshotIntact: Scalars['Boolean']['output'];
  valid: Scalars['Boolean']['output'];
};

/** A child task template within a task group. */
export type ChildTask = {
  __typename?: 'ChildTask';
  /** Assessment method details (e.g., "checklist_14_steps") */
  assessment?: Maybe<Scalars['String']['output']>;
  /** Assessment criteria for competency verification (DRR-209) */
  assessmentCriteria?: Maybe<Array<AssessmentCriterion>>;
  /** Role that performs this task (e.g., "cna", "lpn", "rn") */
  assigneeRole?: Maybe<Scalars['String']['output']>;
  /** Assist levels as JSON string (for ADL tasks) */
  assistLevels?: Maybe<Scalars['String']['output']>;
  /** How many instances are created */
  cardinality: ChildTaskCardinality | '%future added value';
  /** Data source for cardinality expansion (e.g., "MAR", "census") */
  cardinalitySource?: Maybe<Scalars['String']['output']>;
  /** 144G.61 competency area this module belongs to (e.g., "transfer_mobility") */
  competencyArea?: Maybe<Scalars['String']['output']>;
  /** Applicable compliance frameworks */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Conditional expression for when this task applies */
  condition?: Maybe<Scalars['String']['output']>;
  /** Deadline in hours from hire for this specific module */
  deadlineHoursFromHire?: Maybe<Scalars['Int']['output']>;
  /** IDs of sibling tasks that must complete first */
  dependsOn: Array<Scalars['String']['output']>;
  /** Estimated time to complete in minutes */
  estimatedDurationMinutes?: Maybe<Scalars['Int']['output']>;
  /** Unique child task identifier within the group */
  id: Scalars['String']['output'];
  /** Whether this specific child task is life-critical */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Task display name */
  name: Scalars['String']['output'];
  /** Additional notes */
  note?: Maybe<Scalars['String']['output']>;
  /** Priority level */
  priority: ChildTaskPriority | '%future added value';
  /** Whether this child must complete for group completion */
  required: Scalars['Boolean']['output'];
  /** Roles that must complete this module (e.g., ["direct_care_staff", "delegated_staff"]) */
  requiredRole: Array<Scalars['String']['output']>;
  /** Whether this module requires RN delegation to perform */
  requiresDelegation: Scalars['Boolean']['output'];
  /** Execution order (1-based) */
  sequenceOrder: Scalars['Int']['output'];
  /** Source training document reference */
  sourceDocument?: Maybe<Scalars['String']['output']>;
  /** Type of task */
  taskType: ChildTaskType | '%future added value';
  /** Verification method required (e.g., "practical_demonstration_pass_fail") */
  verification?: Maybe<Scalars['String']['output']>;
  /** CNA registry verification can waive this module */
  waivableWith?: Maybe<Scalars['String']['output']>;
};

/** Cardinality of a child task (how many instances are created). */
export const ChildTaskCardinality = {
  /** One instance per medication in MAR */
  PER_MEDICATION: 'PER_MEDICATION',
  /** One instance per active order */
  PER_ORDER: 'PER_ORDER',
  /** One instance per resident in census */
  PER_RESIDENT: 'PER_RESIDENT',
  /** Exactly one instance */
  SINGLE: 'SINGLE',
} as const;

export type ChildTaskCardinality = (typeof ChildTaskCardinality)[keyof typeof ChildTaskCardinality];
/** Task priority level. */
export const ChildTaskPriority = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  URGENT: 'URGENT',
} as const;

export type ChildTaskPriority = (typeof ChildTaskPriority)[keyof typeof ChildTaskPriority];
/** Type of child task. */
export const ChildTaskType = {
  /** Requires approval gate */
  APPROVAL: 'APPROVAL',
  /** System-automated task */
  SYSTEM: 'SYSTEM',
  /** Human-performed task */
  USER: 'USER',
  /** Verification/audit step */
  VERIFICATION: 'VERIFICATION',
} as const;

export type ChildTaskType = (typeof ChildTaskType)[keyof typeof ChildTaskType];
/** Circuit breaker state */
export const CircuitBreakerState = {
  CLOSED: 'CLOSED',
  HALF_OPEN: 'HALF_OPEN',
  OPEN: 'OPEN',
} as const;

export type CircuitBreakerState = (typeof CircuitBreakerState)[keyof typeof CircuitBreakerState];
/** Circular dependency detection result. */
export type CircularDependencyResult = {
  __typename?: 'CircularDependencyResult';
  /** Total cycle count */
  cycleCount: Scalars['Int']['output'];
  /** List of cycles (if any) */
  cycles: Array<Array<Scalars['String']['output']>>;
  /** Has cycles detected */
  hasCycles: Scalars['Boolean']['output'];
};

/** A frequently cited checkpoint with its citation rate. */
export type CitedCheckpoint = {
  __typename?: 'CitedCheckpoint';
  /** Citation rate (0.0 - 1.0) */
  citationRate: Scalars['Float']['output'];
  /** Description of the deficiency */
  description: Scalars['String']['output'];
  /** Checkpoint tag (e.g., "E-0007") */
  tag: Scalars['String']['output'];
};

/** Code information from terminology service */
export type CodeInfo = {
  __typename?: 'CodeInfo';
  /** The code value */
  code: Scalars['String']['output'];
  /** Full definition (if available) */
  definition?: Maybe<Scalars['String']['output']>;
  /** Human-readable display name */
  display: Scalars['String']['output'];
  /** When the code became effective */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** When the code expires/expired */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Code status (active, deprecated, etc.) */
  status: CodeStatusEnum | '%future added value';
  /** Alternative names/synonyms */
  synonyms: Array<Scalars['String']['output']>;
  /** Code system (ICD10CM, SNOMED_CT, etc.) */
  system: CodeSystemEnum | '%future added value';
};

/** Code mapping between systems */
export type CodeMapping = {
  __typename?: 'CodeMapping';
  /** Additional notes about the mapping */
  comment?: Maybe<Scalars['String']['output']>;
  /** Mapping equivalence level */
  equivalence: MappingEquivalenceEnum | '%future added value';
  /** Source code */
  sourceCode: Scalars['String']['output'];
  /** Source code system */
  sourceSystem: CodeSystemEnum | '%future added value';
  /** Target code */
  targetCode: Scalars['String']['output'];
  /** Target code system */
  targetSystem: CodeSystemEnum | '%future added value';
};

/** Code search results */
export type CodeSearchResult = {
  __typename?: 'CodeSearchResult';
  /** Matching codes */
  codes: Array<CodeInfo>;
  /** Whether more results are available */
  hasMore: Scalars['Boolean']['output'];
  /** Total matching codes */
  totalCount: Scalars['Int']['output'];
};

/** Status of a code in its code system */
export const CodeStatusEnum = {
  /** Code is active and valid for use */
  ACTIVE: 'ACTIVE',
  /** Code has been deprecated but may be valid for historical data */
  DEPRECATED: 'DEPRECATED',
  /** Code is pending activation */
  PENDING: 'PENDING',
  /** Code has been retired and should not be used */
  RETIRED: 'RETIRED',
} as const;

export type CodeStatusEnum = (typeof CodeStatusEnum)[keyof typeof CodeStatusEnum];
/** Medical code system identifier */
export const CodeSystemEnum = {
  /** CPT - Procedure codes */
  CPT: 'CPT',
  /** CVX - Vaccine codes */
  CVX: 'CVX',
  /** HCPCS - Healthcare procedure codes */
  HCPCS: 'HCPCS',
  /** ICD-10-CM - Diagnosis codes */
  ICD10CM: 'ICD10CM',
  /** ICD-10-PCS - Inpatient procedure codes */
  ICD10PCS: 'ICD10PCS',
  /** LOINC - Lab observation codes */
  LOINC: 'LOINC',
  /** NDC - National Drug Code */
  NDC: 'NDC',
  /** NUCC - Provider taxonomy */
  NUCC: 'NUCC',
  /** RxNorm - Drug names */
  RXNORM: 'RXNORM',
  /** SNOMED CT - Clinical terminology */
  SNOMED_CT: 'SNOMED_CT',
} as const;

export type CodeSystemEnum = (typeof CodeSystemEnum)[keyof typeof CodeSystemEnum];
/** Code system metadata */
export type CodeSystemInfo = {
  __typename?: 'CodeSystemInfo';
  /** FHIR canonical URL */
  fhirUri: Scalars['String']['output'];
  /** When last updated */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** OID identifier */
  oid: Scalars['String']['output'];
  /** Source organization */
  source: Scalars['String']['output'];
  /** Code system identifier */
  system: CodeSystemEnum | '%future added value';
  /** Total codes in system */
  totalCodes: Scalars['Int']['output'];
  /** How often updates are released */
  updateFrequency: Scalars['String']['output'];
  /** Current version */
  version: Scalars['String']['output'];
};

export type CodeUsage = {
  __typename?: 'CodeUsage';
  atMs: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  entityRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Code validation result */
export type CodeValidationResult = {
  __typename?: 'CodeValidationResult';
  /** The code that was validated */
  code: Scalars['String']['output'];
  /** Validation message (if invalid) */
  message?: Maybe<Scalars['String']['output']>;
  /** Suggested alternative codes (if invalid) */
  suggestedCodes: Array<CodeInfo>;
  /** The code system */
  system: CodeSystemEnum | '%future added value';
  /** Whether the code is valid */
  valid: Scalars['Boolean']['output'];
};

/**
 * A communication/contact log entry.
 * Used by QP supervision and contact tracking.
 */
export type CommunicationLog = {
  __typename?: 'CommunicationLog';
  /** Type of contact (e.g., "phone", "in-person", "email") */
  contactType: Scalars['String']['output'];
  /** When the log was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the log */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Duration in minutes (optional) */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Unique log ID */
  id: Scalars['String']['output'];
  /** Outcome of the contact */
  outcome?: Maybe<Scalars['String']['output']>;
  /** Participant/subject ID */
  participantId: Scalars['String']['output'];
  /** Summary of the communication */
  summary: Scalars['String']['output'];
};

/** Input for comparing lens evaluations across roles. */
export type CompareLensInput = {
  /** List of role sets to compare (e.g., [["ald-alf"], ["uap-alf"], ["don-alf"]]) */
  roleSets: Array<RoleSetInput>;
};

/** SAGA compensation request input */
export type CompensateSagaInput = {
  /** Optional compensation context */
  compensationContext?: InputMaybe<Scalars['JSON']['input']>;
  /** Reason for compensation (for audit trail) */
  compensationReason: Scalars['String']['input'];
  /** Execution ID of the SAGA to compensate */
  executionId: Scalars['String']['input'];
};

/** Input for DSL compilation */
export type CompileDslInput = {
  /** Optional custom actions to validate against */
  knownActions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional custom fields to validate against */
  knownFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** DSL source code to compile */
  source: Scalars['String']['input'];
};

/** Input for completing attestation */
export type CompleteAttestationInput = {
  attestationId: Scalars['String']['input'];
  recordsImported: Scalars['Int']['input'];
};

/** Result of completing attestation */
export type CompleteAttestationResult = {
  __typename?: 'CompleteAttestationResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for completing a single field during step-through signing. */
export type CompleteCeremonyFieldInput = {
  ceremonyId: Scalars['String']['input'];
  /** Index of the field to complete (from ceremony's fields array). */
  fieldIndex: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
  /**
   * Captured value: PNG data URL for Signature/Initials, text for TextField,
   * ISO date string for DateSigned. Optional for DateSigned (auto-filled).
   */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Input for completing a witness request */
export type CompleteWitnessRequestInput = {
  /** Completion token from verifyWitnessRequest */
  completionToken: Scalars['String']['input'];
  /** Request ID to complete */
  requestId: Scalars['String']['input'];
};

/** Complete workflow data */
export type CompleteWorkflowData = {
  __typename?: 'CompleteWorkflowData';
  actors: Array<ActorView>;
  componentEdges: Array<ComponentEdgeGql>;
  components: Array<ComponentRefGql>;
  definition?: Maybe<WorkflowDefinitionView>;
  instances: Array<WorkflowInstanceView>;
  timeline: Array<TimelineEvent>;
};

/** Completion gap — actor who hasn't completed a required template */
export type CompletionGap = {
  __typename?: 'CompletionGap';
  /** Actor ID who needs to complete */
  actorId: Scalars['String']['output'];
  /** Template ref that needs completion */
  templateRef: Scalars['String']['output'];
};

/** Completion progress entry */
export type CompletionProgress = {
  __typename?: 'CompletionProgress';
  /** When it was completed */
  completedAt: Scalars['DateTime']['output'];
  /** Outcome (completed, failed, etc.) */
  outcome?: Maybe<Scalars['String']['output']>;
  /** Template ref that was completed */
  templateRef: Scalars['String']['output'];
};

/** How a task group determines completion. */
export const CompletionStrategy = {
  /** All children must complete */
  ALL_CHILDREN: 'ALL_CHILDREN',
  /** Any one child completes the group */
  ANY_CHILD: 'ANY_CHILD',
  /** A percentage threshold of children must complete */
  PERCENTAGE_THRESHOLD: 'PERCENTAGE_THRESHOLD',
} as const;

export type CompletionStrategy = (typeof CompletionStrategy)[keyof typeof CompletionStrategy];
/** Compliance Certification */
export type ComplianceCertification = {
  __typename?: 'ComplianceCertification';
  certificationDate?: Maybe<Scalars['String']['output']>;
  certified: Scalars['Boolean']['output'];
  certifyingAuthority?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  framework: Scalars['String']['output'];
};

/** Compliance check configuration */
export type ComplianceCheck = {
  __typename?: 'ComplianceCheck';
  checkType: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

/**
 * One filterable dimension in the compliance browser.
 *
 * Each dimension maps to a Valkey SET index: `idx:cfg:rs:{dimension}:{value}`.
 * Multi-select across a dimension = Valkey SINTER. Unrelated dimensions
 * are independent filters (AND logic).
 */
export type ComplianceFilterDimension = {
  __typename?: 'ComplianceFilterDimension';
  /**
   * Dimension identifier passed to `ruleSetsByDimensions` filter fields
   * (e.g., "jurisdiction", "safety_level", "facility_type", "applies_when")
   */
  dimension: Scalars['String']['output'];
  /** Whether multiple values can be selected simultaneously (always true) */
  isMultiSelect: Scalars['Boolean']['output'];
  /** Display label for the filter row label (e.g., "Jurisdiction", "Facility Type") */
  label: Scalars['String']['output'];
  /** UI hint: "chips" (badge multi-toggle, ≤8 values) or "multiselect" (dropdown) */
  renderAs: Scalars['String']['output'];
  /** Available filter values ordered by count descending */
  values: Array<ComplianceFilterValue>;
};

/**
 * Full filter dimension response — returned by `complianceFilterDimensions` query.
 *
 * The frontend renders filter chips purely from this response. No hardcoded
 * dimension lists, industry names, or jurisdiction hierarchies in the UI.
 * DRR-055/074: dumb frontend, backend authority.
 */
export type ComplianceFilterDimensions = {
  __typename?: 'ComplianceFilterDimensions';
  /** All filterable dimensions in display order */
  dimensions: Array<ComplianceFilterDimension>;
  /** Total ruleset count before any filter applied */
  totalCount: Scalars['Int']['output'];
};

/**
 * One value within a filter dimension, with its display label and cardinality.
 *
 * Used by the compliance filter bar — chips are built from backend-returned
 * values, never hardcoded in the frontend.
 */
export type ComplianceFilterValue = {
  __typename?: 'ComplianceFilterValue';
  /** Number of currently-effective rulesets matching this value */
  count: Scalars['Int']['output'];
  /** Human-readable label (e.g., "Minnesota", "Critical") */
  label: Scalars['String']['output'];
  /** Machine value used in `ruleSetsByDimensions` filter (e.g., "MN", "critical") */
  value: Scalars['String']['output'];
};

/** Compliance framework */
export const ComplianceFramework = {
  /** CCPA (California Consumer Privacy Act) */
  CCPA: 'CCPA',
  /** FDA 21 CFR Part 11 (Electronic Records/Signatures) */
  FDA_21_CFR_PART_11: 'FDA_21_CFR_PART_11',
  /** GDPR (General Data Protection Regulation) */
  GDPR: 'GDPR',
  /** HIPAA (Healthcare Insurance Portability and Accountability Act) */
  HIPAA: 'HIPAA',
  /** ISO 27001 (Information Security Management) */
  ISO_27001: 'ISO_27001',
  /** PCI DSS (Payment Card Industry Data Security Standard) */
  PCI_DSS: 'PCI_DSS',
  /** SOC 2 (Service Organization Control 2) */
  SOC_2: 'SOC_2',
  /** SOX (Sarbanes-Oxley Act) */
  SOX: 'SOX',
} as const;

export type ComplianceFramework = (typeof ComplianceFramework)[keyof typeof ComplianceFramework];
/**
 * Compliance framework for dynamic configuration showcase
 * LIFE-CRITICAL: Zero hardcoded values architecture
 */
export type ComplianceFrameworkGql = {
  __typename?: 'ComplianceFrameworkGql';
  applicableDomains: Array<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  frameworkId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regulatoryAuthority?: Maybe<Scalars['String']['output']>;
  severityLevel: Scalars['Int']['output'];
};

export const ComplianceLevelGql = {
  FDA_REGULATED: 'FDA_REGULATED',
  LIFE_CRITICAL: 'LIFE_CRITICAL',
  NONE: 'NONE',
  REGULATED: 'REGULATED',
  STANDARD: 'STANDARD',
} as const;

export type ComplianceLevelGql = (typeof ComplianceLevelGql)[keyof typeof ComplianceLevelGql];
/** Compliance metadata */
export type ComplianceMetadata = {
  __typename?: 'ComplianceMetadata';
  auditLevel: Scalars['String']['output'];
  frameworks: Array<Scalars['String']['output']>;
};

/** Compliance metadata input */
export type ComplianceMetadataInput = {
  auditLevel: Scalars['String']['input'];
  frameworks: Array<Scalars['String']['input']>;
};

/** Compliance metadata output */
export type ComplianceMetadataOutput = {
  __typename?: 'ComplianceMetadataOutput';
  auditLevel: Scalars['String']['output'];
  frameworks: Array<Scalars['String']['output']>;
};

/** Per-provision compliance status for a ruleset. */
export type ComplianceStatus = {
  __typename?: 'ComplianceStatus';
  /** Overall compliance percentage */
  compliancePercent: Scalars['Int']['output'];
  /** Provisions with evidence (task completions or manual attestations) */
  evidencedCount: Scalars['Int']['output'];
  /** Provisions with no evidence */
  gapCount: Scalars['Int']['output'];
  /** Provisions with config coverage but no execution evidence yet */
  pendingCount: Scalars['Int']['output'];
  /** Per-provision breakdown */
  provisions: Array<ProvisionStatus>;
  /** Ruleset display name */
  rulesetDisplayName: Scalars['String']['output'];
  /** Ruleset ID */
  rulesetId: Scalars['String']['output'];
  /** Total provisions in this ruleset */
  totalProvisions: Scalars['Int']['output'];
};

/** Compliance Violation */
export type ComplianceViolation = {
  __typename?: 'ComplianceViolation';
  fieldPath: Scalars['String']['output'];
  framework: Scalars['String']['output'];
  message: Scalars['String']['output'];
  remediation?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['String']['output'];
  severity: GqlComplianceSeverity | '%future added value';
  violationId: Scalars['String']['output'];
};

/** Edge linking parent and child components in a composition graph */
export type ComponentEdgeGql = {
  __typename?: 'ComponentEdgeGql';
  childComponentId: Scalars['ID']['output'];
  condition?: Maybe<Scalars['String']['output']>;
  fanoutGroup?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentComponentId: Scalars['ID']['output'];
  relationship?: Maybe<Scalars['String']['output']>;
};

/** A reference to a composed component within a workflow definition */
export type ComponentRefGql = {
  __typename?: 'ComponentRefGql';
  componentType: Scalars['String']['output'];
  config?: Maybe<Scalars['JSON']['output']>;
  executionMode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputMap: Scalars['JSON']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  outputMap: Scalars['JSON']['output'];
  versionPin?: Maybe<Scalars['String']['output']>;
};

/** Result of composing a workflow from atomic parts. */
export type ComposeFromPartsResult = {
  __typename?: 'ComposeFromPartsResult';
  /** Error message if any */
  error?: Maybe<Scalars['String']['output']>;
  /** Number of states in the composed workflow */
  stateCount: Scalars['Int']['output'];
  /** Whether composition was successful */
  success: Scalars['Boolean']['output'];
  /** Generated workflow definition for architect review */
  workflowDefinition: Scalars['String']['output'];
  /** Generated workflow ID */
  workflowId: Scalars['String']['output'];
};

/** Input for the composeWorkflow mutation. */
export type ComposeWorkflowInput = {
  /** Natural language workflow composition request. */
  prompt: Scalars['String']['input'];
  /**
   * Previous session messages for multi-turn conversations.
   * Pass the sessionMessages from the previous response to continue.
   */
  sessionMessages?: InputMaybe<Scalars['JSON']['input']>;
  /** Existing workflow ID to modify (omit for new composition). */
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

/** Response from the AI workflow composer. */
export type ComposeWorkflowResponse = {
  __typename?: 'ComposeWorkflowResponse';
  /** Processing time in milliseconds. */
  processingTimeMs: Scalars['Float']['output'];
  /** The agent's text response with suggestions and explanations. */
  response: Scalars['String']['output'];
  /** Conversation history — pass back as session_messages to continue. */
  sessionMessages: Scalars['JSON']['output'];
  /** Why the agent stopped: "end_turn", "max_tokens", or "max_turns". */
  stopReason: Scalars['String']['output'];
  /** Number of agent turns used in this request. */
  turnCount: Scalars['Int']['output'];
  /** Token usage for this turn. */
  usage: AgentUsageInfo;
};

export type ComposedMetadataGql = {
  __typename?: 'ComposedMetadataGql';
  cacheKey: Scalars['String']['output'];
  composed: Scalars['JSON']['output'];
  compositionLayers: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

/** Engine type for workflow execution */
export const CompositionEngineType = {
  /** Actor-based async message passing */
  ACTOR_RUNTIME: 'ACTOR_RUNTIME',
  /** DAG-based parallel execution */
  DAG_WORKFLOW: 'DAG_WORKFLOW',
  /** Saga with compensation for distributed transactions */
  SAGA_STATE_MACHINE: 'SAGA_STATE_MACHINE',
  /** Simple sequential state machine */
  STATE_MACHINE: 'STATE_MACHINE',
} as const;

export type CompositionEngineType =
  (typeof CompositionEngineType)[keyof typeof CompositionEngineType];
/** Input for composition evaluation */
export type CompositionInput = {
  /** Optional confidence score (0.0-1.0) */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  /** Primitive types present in the workflow */
  primitives: Array<Scalars['String']['input']>;
  /** Tenant identifier */
  tenantId: Scalars['String']['input'];
  /** Optional workflow ID for action targeting */
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of composition preview */
export type CompositionPreviewResult = {
  __typename?: 'CompositionPreviewResult';
  /** Estimated duration in days */
  estimatedDurationDays: Scalars['Int']['output'];
  /** Whether any workflow is life-critical */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Rules that matched */
  matchedRules: Array<Scalars['String']['output']>;
  /** Recommended engine type */
  recommendedEngine: CompositionEngineType | '%future added value';
  /** Total number of rules evaluated */
  rulesEvaluated: Scalars['Int']['output'];
  /** Sub-workflow details (if atomics could be loaded) */
  subWorkflows: Array<SubWorkflowInfo>;
  /** Total state count */
  totalStates: Scalars['Int']['output'];
  /** Workflow IDs that would be included */
  workflowIds: Array<Scalars['String']['output']>;
};

/** Result of composition evaluation */
export type CompositionResult = {
  __typename?: 'CompositionResult';
  /** Anti-pattern warnings for missing primitives */
  antiPatternWarnings: Array<AntiPatternWarning>;
  /** Evaluation time in milliseconds */
  evaluationMs: Scalars['Int']['output'];
  /** Formula suggestions based on matched patterns */
  formulaSuggestions: Array<FormulaSuggestion>;
  /** Which formulas were matched (for analytics) */
  matchedFormulas: Array<Scalars['Int']['output']>;
  /** Actions triggered by formula activation */
  triggeredActions: Array<TriggeredAction>;
};

/** Result of compressing a Snowflake ID */
export type CompressIdResult = {
  __typename?: 'CompressIdResult';
  /** Timestamp when compressed */
  compressedAt: Scalars['DateTime']['output'];
  /** Compressed ID */
  compressedId: Scalars['String']['output'];
  /** Compression ratio (e.g., 0.67 = 67% compression) */
  compressionRatio: Scalars['Float']['output'];
  /** Original Snowflake ID */
  snowflakeId: Scalars['String']['output'];
  /** Storage savings (bytes) */
  storageSavings: Scalars['Int']['output'];
};

/** Compression error */
export type CompressionError = {
  __typename?: 'CompressionError';
  /** Error message */
  error: Scalars['String']['output'];
  /** Error code (for frontend handling) */
  errorCode: Scalars['String']['output'];
  /** Snowflake ID that failed */
  snowflakeId: Scalars['String']['output'];
};

/** Compression statistics for a tenant */
export type CompressionStats = {
  __typename?: 'CompressionStats';
  /** Average compression ratio */
  averageCompressionRatio: Scalars['Float']['output'];
  /** Cache hit rate (0.0-1.0) */
  cacheHitRate: Scalars['Float']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Most used primitive types */
  topPrimitiveTypes: Array<PrimitiveTypeUsage>;
  /** Total compressed IDs */
  totalCompressed: Scalars['Int']['output'];
  /** Total storage savings (bytes) */
  totalStorageSavings: Scalars['Int']['output'];
  /** Statistics updated at */
  updatedAt: Scalars['DateTime']['output'];
};

/** Computation tier determines where the expression is evaluated */
export const ComputationTier = {
  /** Evaluated in browser (arithmetic only: +, -, *, /, SUM, COUNT) */
  CLIENT: 'CLIENT',
  /** Evaluated server-side, result cached via Valkey */
  SERVER_CACHED: 'SERVER_CACHED',
  /** Evaluated server-side on every request */
  SERVER_LIVE: 'SERVER_LIVE',
} as const;

export type ComputationTier = (typeof ComputationTier)[keyof typeof ComputationTier];
/** Input for server-side field computation. */
export type ComputeFieldValueInput = {
  computationTier: ComputationTier | '%future added value';
  displayFormat?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
  expression: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  formValues: Scalars['JSON']['input'];
  subgraph: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Configuration for COMPUTED field type */
export type ComputedFieldConfig = {
  __typename?: 'ComputedFieldConfig';
  /** Where the computation runs */
  computationTier: ComputationTier | '%future added value';
  /** Field names this computation depends on */
  dependencies: Array<Scalars['String']['output']>;
  /** Display format (e.g., "currency", "percentage", "number") */
  displayFormat?: Maybe<Scalars['String']['output']>;
  /** Expression to evaluate (simple arithmetic for CLIENT tier, Zen/CEL for SERVER) */
  expression: Scalars['String']['output'];
};

/** Input version of ComputedFieldConfig */
export type ComputedFieldConfigInput = {
  computationTier: ComputationTier | '%future added value';
  dependencies: Array<Scalars['String']['input']>;
  displayFormat?: InputMaybe<Scalars['String']['input']>;
  expression: Scalars['String']['input'];
};

/** Condition connection */
export type ConditionConnection = {
  __typename?: 'ConditionConnection';
  edges: Array<ConditionEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Condition edge */
export type ConditionEdge = {
  __typename?: 'ConditionEdge';
  cursor: Scalars['String']['output'];
  node: FhirCondition;
};

/** Condition Evaluation Result */
export type ConditionEvaluation = {
  __typename?: 'ConditionEvaluation';
  /** Condition that was evaluated */
  condition: PolicyCondition;
  /** Did this condition match? */
  matched: Scalars['Boolean']['output'];
  /** Reason for match/no-match */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Operators for field visibility/disabled conditions */
export const ConditionOperator = {
  CONTAINS: 'CONTAINS',
  EQ: 'EQ',
  GT: 'GT',
  GTE: 'GTE',
  IN: 'IN',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY',
  LT: 'LT',
  LTE: 'LTE',
  NE: 'NE',
  NOT_IN: 'NOT_IN',
} as const;

export type ConditionOperator = (typeof ConditionOperator)[keyof typeof ConditionOperator];
/** GraphQL enum for condition resolution (mirrors ConditionResolution) */
export const ConditionResolutionInput = {
  /** Condition no longer active (clinicalStatus = "inactive") */
  INACTIVE: 'INACTIVE',
  /** Condition in remission (clinicalStatus = "remission") */
  REMISSION: 'REMISSION',
  /** Condition resolved completely (clinicalStatus = "resolved") */
  RESOLVED: 'RESOLVED',
} as const;

export type ConditionResolutionInput =
  (typeof ConditionResolutionInput)[keyof typeof ConditionResolutionInput];
/** Confidence Distribution Statistics */
export type ConfidenceDistribution = {
  __typename?: 'ConfidenceDistribution';
  /** Average confidence across all fields */
  averageConfidence: Scalars['Float']['output'];
  /** Count of high-confidence fields (>= 0.85) */
  highConfidenceCount: Scalars['Int']['output'];
  /** Count of low-confidence fields (< 0.60) */
  lowConfidenceCount: Scalars['Int']['output'];
  /** Count of medium-confidence fields (0.60-0.84) */
  mediumConfidenceCount: Scalars['Int']['output'];
};

/** Confidence Metrics (GraphQL output) */
export type ConfidenceMetrics = {
  __typename?: 'ConfidenceMetrics';
  /** Business metadata confidence */
  business: Scalars['Float']['output'];
  /** Compliance confidence */
  compliance: Scalars['Float']['output'];
  /** Mapping confidence */
  mappings: Scalars['Float']['output'];
  /** Overall confidence (0.0-1.0) */
  overall: Scalars['Float']['output'];
  /** Primitive synthesis confidence */
  primitives: Scalars['Float']['output'];
  /** UI metadata confidence */
  ui: Scalars['Float']['output'];
};

/** Confidence Metrics Input */
export type ConfidenceMetricsInput = {
  /** Overall confidence */
  overall: Scalars['Float']['input'];
};

/** A typed edge between two config nodes (DRR-110). */
export type ConfigEdge = {
  __typename?: 'ConfigEdge';
  /** Forward edge type (e.g., `MANDATED_BY`) */
  edgeType: Scalars['String']['output'];
  /** Inverse edge type (e.g., `MANDATES`) */
  inverseType: Scalars['String']['output'];
  /** Constellation ring number (1=Regulatory, 2=Outcomes, 3=Operations, 4=Evidence) */
  ring: Scalars['Int']['output'];
  /** Source config ID (e.g., `tg-4-3-001`) */
  sourceId: Scalars['String']['output'];
  /** Target config ID or tag (e.g., `rs-4-1-004`, `tag:qol:dignity`) */
  targetId: Scalars['String']['output'];
};

/**
 * Impact analysis result for a config change.
 * Shows what primitives would be affected.
 */
export type ConfigImpactResult = {
  __typename?: 'ConfigImpactResult';
  /** Approval IDs created by this config */
  approvalIds: Array<Scalars['String']['output']>;
  /** Document IDs created by this config */
  documentIds: Array<Scalars['String']['output']>;
  /** Instance IDs created by this config */
  instanceIds: Array<Scalars['String']['output']>;
  /** Task IDs created by this config */
  taskIds: Array<Scalars['String']['output']>;
  /** Total count of affected primitives */
  totalCount: Scalars['Int']['output'];
};

/** A config proposal awaiting architect review. */
export type ConfigProposal = {
  __typename?: 'ConfigProposal';
  /** Config type: "task-groups" or "workflows" */
  configType: Scalars['String']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Human-readable display name */
  displayName: Scalars['String']['output'];
  /** File path for reference */
  filePath: Scalars['String']['output'];
  /** When this proposal was generated (ISO 8601) */
  generatedAt: Scalars['String']['output'];
  /** Proposal identifier (filename stem) */
  proposalId: Scalars['String']['output'];
  /** Rule ID that generated this proposal */
  sourceRule: Scalars['String']['output'];
  /** Status: draft, approved, rejected */
  status: Scalars['String']['output'];
};

/** Config type being proposed */
export const ConfigProposalType = {
  /** Form schema override (fso-*) */
  FORM_SCHEMA_OVERRIDE: 'FORM_SCHEMA_OVERRIDE',
  /** Navigation override (nvo-*) */
  NAVIGATION_OVERRIDE: 'NAVIGATION_OVERRIDE',
  /** Setting override */
  SETTING: 'SETTING',
  /** Task group (tg-*) */
  TASK_GROUP: 'TASK_GROUP',
  /** Template (tpl-*) */
  TEMPLATE: 'TEMPLATE',
  /** Workflow definition (wf-*) */
  WORKFLOW: 'WORKFLOW',
} as const;

export type ConfigProposalType = (typeof ConfigProposalType)[keyof typeof ConfigProposalType];
/** Conflict resolution result */
export type ConflictResolution = {
  __typename?: 'ConflictResolution';
  /** Conflict ID that was resolved */
  conflictId: Scalars['String']['output'];
  /** When it was resolved */
  resolvedAt: Scalars['DateTime']['output'];
  /** Who resolved it */
  resolvedBy: Scalars['String']['output'];
  /** New status after resolution */
  status: GqlConflictStatus | '%future added value';
};

/** Input for connecting two components with an edge */
export type ConnectComponentsInput = {
  childComponentId: Scalars['ID']['input'];
  condition?: InputMaybe<Scalars['String']['input']>;
  fanoutGroup?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentComponentId: Scalars['ID']['input'];
  relationship?: InputMaybe<Scalars['String']['input']>;
};

/** Center node of a hub-and-spoke constellation. */
export type ConstellationCenter = {
  __typename?: 'ConstellationCenter';
  /** Actor subtype (e.g., "subject" per DRR-075) */
  actorType?: Maybe<Scalars['String']['output']>;
  /** Description of the center node */
  description?: Maybe<Scalars['String']['output']>;
  /** Template for center node label (e.g., "{recipient}'s {plan_type}") */
  labelTemplate: Scalars['String']['output'];
  /** FERP primitive type at center (usually "Actor") */
  primitiveType: Scalars['String']['output'];
};

/** A context profile for situation-based field highlighting. */
export type ConstellationContextProfile = {
  __typename?: 'ConstellationContextProfile';
  /** Unique context identifier (e.g., "healthcare-discharge") */
  contextId: Scalars['String']['output'];
  /** When and why to use this context */
  description?: Maybe<Scalars['String']['output']>;
  /** Ring IDs to visually emphasize */
  highlightRings: Array<Scalars['String']['output']>;
  /** Reference to a lens YAML lens_id */
  lensRef?: Maybe<Scalars['String']['output']>;
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Field names to highlight when active */
  promotedFields: Array<Scalars['String']['output']>;
  /** Industry verticals this context applies to */
  verticals: Array<Scalars['String']['output']>;
};

/**
 * A definition-mode node in Ring 3 (Deliverables) of a constellation template.
 * Maps a department's task group config (tg-*) to its generating workflow (wf-*).
 * DRR-126: Definition mode = village operating manual. No separate master workflow YAML.
 */
export type ConstellationDefinitionNode = {
  __typename?: 'ConstellationDefinitionNode';
  /** Department responsible (e.g., "clinical", "administrative", "direct_care") */
  department?: Maybe<Scalars['String']['output']>;
  /** Brief description shown on hover in definition mode */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable label for the node in definition mode */
  label?: Maybe<Scalars['String']['output']>;
  /** Role that owns this deliverable (e.g., "DON", "ALD", "CHARGE_RN") */
  ownerRole?: Maybe<Scalars['String']['output']>;
  /** Task group config ID that defines the work (e.g., "tg-4-12-001") */
  taskGroupRef: Scalars['String']['output'];
  /** Workflow config ID that generates this deliverable (e.g., "wf-4-0-034") */
  workflowRef: Scalars['String']['output'];
};

/** A field node in the constellation visualization. */
export type ConstellationFieldNode = {
  __typename?: 'ConstellationFieldNode';
  /** Field purpose and usage context */
  description?: Maybe<Scalars['String']['output']>;
  /** Allowed values for enum fields */
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  /** Rust struct field name (snake_case) */
  fieldName: Scalars['String']['output'];
  /** Simplified field type for visualization */
  fieldType: Scalars['String']['output'];
  /** Which formulas reference this field */
  formulaRefs?: Maybe<Array<Scalars['String']['output']>>;
  /** Human-readable label */
  label: Scalars['String']['output'];
  /** PII data classification level */
  piiClassification?: Maybe<Scalars['String']['output']>;
  /** Whether this field is promoted in the active context */
  promoted: Scalars['Boolean']['output'];
  /** Whether the field is required on the Rust struct */
  required: Scalars['Boolean']['output'];
};

/** A single constellation mode (definition or instance). */
export type ConstellationMode = {
  __typename?: 'ConstellationMode';
  /** Data source: "config" (YAML/DDB definitions) or "live" (DDB instance records) */
  centerSource: Scalars['String']['output'];
  /** Human-readable description of this mode */
  description: Scalars['String']['output'];
  /** Data source for ring nodes */
  ringSource: Scalars['String']['output'];
  /** Primitive symbol case: "uppercase" (W, E, D+) or "lowercase" (w, e, d+) */
  symbolCase: Scalars['String']['output'];
};

/**
 * Definition vs Instance mode configuration.
 *
 * Definition mode (uppercase symbols): shows all possible connections for an entity TYPE.
 * Instance mode (lowercase symbols): shows actual connections for a specific entity RECORD.
 */
export type ConstellationModes = {
  __typename?: 'ConstellationModes';
  /** Definition mode config */
  definition: ConstellationMode;
  /** Instance mode config */
  instance: ConstellationMode;
};

/** Result of a constellation participant update. */
export type ConstellationParticipantResult = {
  __typename?: 'ConstellationParticipantResult';
  constellationId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * A ring in the constellation visualization.
 * Each ring groups related fields at the same distance from center.
 */
export type ConstellationRing = {
  __typename?: 'ConstellationRing';
  /** Hex color for ring nodes (e.g., "#7048e8") */
  color?: Maybe<Scalars['String']['output']>;
  /** Tooltip description */
  description?: Maybe<Scalars['String']['output']>;
  /** Number of fields in this ring */
  fieldCount: Scalars['Int']['output'];
  /** Fields in this ring */
  fields: Array<ConstellationFieldNode>;
  /** Whether this ring is highlighted in the active context */
  highlighted: Scalars['Boolean']['output'];
  /** Display label for the ring category node */
  label: Scalars['String']['output'];
  /** Unique ring identifier (e.g., "identity", "execution") */
  ringId: Scalars['String']['output'];
  /** Distance from center (1=closest, 5=outermost) */
  ringNumber: Scalars['Int']['output'];
  /** Cytoscape.js node shape */
  shape?: Maybe<Scalars['String']['output']>;
};

/** A ring label override for a specific scope binding. */
export type ConstellationRingLabel = {
  __typename?: 'ConstellationRingLabel';
  /** Industry-specific label for the ring */
  label: Scalars['String']['output'];
  /** Ring ID this label applies to */
  ringId: Scalars['String']['output'];
};

/** Scope binding — maps constellation to industry verticals. */
export type ConstellationScopeBinding = {
  __typename?: 'ConstellationScopeBinding';
  /** Industry-specific center label (e.g., "Service Plan", "Case Plan") */
  centerLabel: Scalars['String']['output'];
  /** Industries this binding applies to */
  industries: Array<Scalars['String']['output']>;
  /** Industry-specific ring labels */
  ringLabels?: Maybe<Array<ConstellationRingLabel>>;
  /** Scope identifier (e.g., "care", "legal", "staffing") */
  scope: Scalars['String']['output'];
  /** Subject type (e.g., "person", "case", "order") */
  subjectType?: Maybe<Scalars['String']['output']>;
};

/**
 * Hub-and-spoke constellation template (DRR-085 config type #12).
 *
 * Defines a cross-primitive relationship pattern with concentric rings.
 * Used for Service Plans (care), Case Plans (legal), etc.
 * Distinct from `FieldConstellation` which is per-primitive field visualization.
 */
export type ConstellationTemplate = {
  __typename?: 'ConstellationTemplate';
  /** Scope bindings — maps pattern to industries */
  appliesTo: Array<ConstellationScopeBinding>;
  /** Center node definition */
  center: ConstellationCenter;
  /** Unique constellation identifier (matches filename — DRR-084) */
  constellationId: Scalars['String']['output'];
  /** Description of the pattern */
  description?: Maybe<Scalars['String']['output']>;
  /** Definition vs instance mode support */
  modes?: Maybe<ConstellationModes>;
  /** Human-readable name (e.g., "Service Plan Constellation") */
  name: Scalars['String']['output'];
  /** Concentric rings around the center */
  rings: Array<ConstellationTemplateRing>;
  /** Semantic version */
  version: Scalars['String']['output'];
};

/** A ring in a hub-and-spoke constellation template. */
export type ConstellationTemplateRing = {
  __typename?: 'ConstellationTemplateRing';
  /** Hex color for ring visualization */
  color?: Maybe<Scalars['String']['output']>;
  /**
   * DRR-126: Definition mode nodes for Ring 3 (Deliverables).
   * Maps departments to their task groups and generating workflow configs.
   * Empty for rings other than deliverables (ring_number != 3).
   */
  definitionNodes: Array<ConstellationDefinitionNode>;
  /** What definition mode shows for this ring (entity types) */
  definitionShows?: Maybe<Scalars['String']['output']>;
  /** Ring purpose description */
  description?: Maybe<Scalars['String']['output']>;
  /** Edge types connecting center to ring nodes */
  edgeTypes: Array<Scalars['String']['output']>;
  /** What instance mode shows for this ring (actual entities) */
  instanceShows?: Maybe<Scalars['String']['output']>;
  /** Status fields available in instance mode */
  instanceStatusFields: Array<Scalars['String']['output']>;
  /** Display label */
  label: Scalars['String']['output'];
  /** Onboarding instruction for this ring */
  onboardingAction?: Maybe<Scalars['String']['output']>;
  /** Provisioning status: "draft" (customizable) or "locked" (accept-only) */
  provisioning?: Maybe<Scalars['String']['output']>;
  /** Unique ring identifier (e.g., "participants", "authorities") */
  ringId: Scalars['String']['output'];
  /** Distance from center (1=closest, 4=outermost) */
  ringNumber: Scalars['Int']['output'];
  /** Cytoscape.js node shape */
  shape?: Maybe<Scalars['String']['output']>;
};

export type Constraint = {
  __typename?: 'Constraint';
  active: Scalars['Boolean']['output'];
  auditVersion: Scalars['Int']['output'];
  autoDisableThreshold?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this constraint.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  constrainedEntity: Scalars['String']['output'];
  constraintType: GqlConstraintType | '%future added value';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser: Scalars['String']['output'];
  currentStatus: GqlConstraintStatus | '%future added value';
  currentUsage: Scalars['Float']['output'];
  customFormula?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Domain context for domain-agnostic constraints. Format: "{domain}:{subtype}" */
  domainContext?: Maybe<Scalars['String']['output']>;
  effectiveDates?: Maybe<ConstraintDateRange>;
  enforcementPhase: Array<GqlEnforcementPhase | '%future added value'>;
  entitySubtype?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSystemConstraint: Scalars['Boolean']['output'];
  lastResetAt?: Maybe<Scalars['DateTime']['output']>;
  lastViolation?: Maybe<GqlViolationRecord>;
  limitValue: Scalars['Float']['output'];
  metadata: Scalars['JSON']['output'];
  monitoredEntityId?: Maybe<Scalars['String']['output']>;
  monitoredEntityType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notificationActorIds: Array<Scalars['String']['output']>;
  notificationAtPercent: Array<Scalars['Int']['output']>;
  notificationChannels: Array<Scalars['String']['output']>;
  operator: GqlConstraintOperator | '%future added value';
  originalId?: Maybe<Scalars['String']['output']>;
  overrideAllowedBy: Array<Scalars['String']['output']>;
  overrideApprovalWorkflowId?: Maybe<Scalars['String']['output']>;
  overrideRequiresReason: Scalars['Boolean']['output'];
  parameters: Scalars['JSON']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  peakUsage: Scalars['Float']['output'];
  periodViolationCount: Scalars['Int']['output'];
  recordVersion: Scalars['Int']['output'];
  scope: GqlConstraintScope;
  secondaryLimit?: Maybe<Scalars['Float']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  timeWindow?: Maybe<GqlTimeWindow | '%future added value'>;
  totalViolationCount: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  usagePercent?: Maybe<Scalars['Float']['output']>;
  userCustomizable: Scalars['Boolean']['output'];
  violationAction: GqlViolationAction | '%future added value';
  violationHistory: Array<GqlViolationRecord>;
};

/** Date range for constraint effective period */
export type ConstraintDateRange = {
  __typename?: 'ConstraintDateRange';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
};

export type ConstraintDateRangeInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};

/** DRR-188: Context banner configuration from Setting YAML. */
export type ContextBannerConfig = {
  __typename?: 'ContextBannerConfig';
  /** Show on all pages (true) or dashboard only (false) */
  alwaysVisible: Scalars['Boolean']['output'];
  /** Whether the context banner is enabled for this setting */
  enabled: Scalars['Boolean']['output'];
  /** Maximum number of urgent groups to display */
  maxGroups: Scalars['Int']['output'];
  /** Polling interval in seconds for count refresh */
  pollIntervalSeconds: Scalars['Int']['output'];
};

/** Contextual information item */
export type ContextualInfoOutput = {
  __typename?: 'ContextualInfoOutput';
  /** Info key/label */
  key: Scalars['String']['output'];
  /** Source of this info */
  source: Scalars['String']['output'];
  /** Info value */
  value: Scalars['String']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  breachCount: Scalars['String']['output'];
  complianceRate: Scalars['Float']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this contract.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentStatus: GqlContractStatus | '%future added value';
  elapsedMinutes?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  escalateAfterMinutes: Scalars['String']['output'];
  escalationChain: Array<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastBreachAt?: Maybe<Scalars['DateTime']['output']>;
  lastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  metadata: Scalars['JSON']['output'];
  notificationActorIds: Array<Scalars['String']['output']>;
  notificationAtPercent: Array<Scalars['Int']['output']>;
  notificationChannels: Array<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  resolutionTimeMinutes: Scalars['String']['output'];
  responseTimeMinutes: Scalars['String']['output'];
  slaName: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  warningThresholdPercent: Scalars['Int']['output'];
  workflowInstanceId: Scalars['String']['output'];
};

/**
 * Result of archiving a contract (FERP Append-Only Architecture).
 *
 * FERP Principle: Immutable history for life-critical workflows.
 * No physical deletion - archive creates immutable audit trail.
 */
export type ContractArchiveResult = {
  __typename?: 'ContractArchiveResult';
  /** When the contract was archived (ISO 8601) */
  archivedAt: Scalars['DateTime']['output'];
  /** Who archived the contract */
  archivedBy: Scalars['String']['output'];
  /** ID of the archived contract */
  contractId: Scalars['String']['output'];
  /** Name of the archived contract */
  contractName: Scalars['String']['output'];
  /** Human-readable result message */
  message: Scalars['String']['output'];
  /** Mandatory reason for archival (audit trail) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/**
 * A controlled/regulated inventory item.
 * Domain-agnostic representation of items requiring special handling.
 */
export type ControlledItem = {
  __typename?: 'ControlledItem';
  /** Constraint/classification identifier */
  constraintId: Scalars['String']['output'];
  /** Constraint display name (e.g., "Schedule II", "IOLTA", "Class 3 Hazmat") */
  constraintName: Scalars['String']['output'];
  /** Unique item identifier */
  itemId: Scalars['String']['output'];
  /** Last verification timestamp (Unix ms) */
  lastVerifiedAt?: Maybe<Scalars['Int']['output']>;
  /** Actor who last verified */
  lastVerifiedBy?: Maybe<Scalars['String']['output']>;
  /** Location identifier */
  locationId?: Maybe<Scalars['String']['output']>;
  /** Location display name */
  locationName?: Maybe<Scalars['String']['output']>;
  /** Item name */
  name: Scalars['String']['output'];
  /** Next required verification timestamp (Unix ms) */
  nextVerificationDue?: Maybe<Scalars['Int']['output']>;
  /** Current quantity */
  quantity: Scalars['Float']['output'];
  /** Status of the item */
  status: ControlledItemStatus | '%future added value';
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Unit of measure */
  unit: Scalars['String']['output'];
};

/** Count verification for a constraint category. */
export type ControlledItemCount = {
  __typename?: 'ControlledItemCount';
  /** Actual count from last verification */
  actualCount: Scalars['Float']['output'];
  /** Constraint/classification identifier */
  constraintId: Scalars['String']['output'];
  /** Constraint display name */
  constraintName: Scalars['String']['output'];
  /** Expected count based on records */
  expectedCount: Scalars['Float']['output'];
  /** Items in this category */
  itemCount: Scalars['Int']['output'];
  /** Last verification timestamp (Unix ms) */
  lastVerifiedAt?: Maybe<Scalars['Int']['output']>;
  /** Location identifier (if location-specific) */
  locationId?: Maybe<Scalars['String']['output']>;
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Tolerance threshold */
  tolerance: Scalars['Float']['output'];
  /** Variance (actual - expected) */
  variance: Scalars['Float']['output'];
  /** Actor who last verified */
  verifiedBy?: Maybe<Scalars['String']['output']>;
  /** Whether variance is within acceptable range */
  withinTolerance: Scalars['Boolean']['output'];
};

/** Status of a controlled item */
export const ControlledItemStatus = {
  /** Active and in inventory */
  ACTIVE: 'ACTIVE',
  /** Depleted or exhausted */
  DEPLETED: 'DEPLETED',
  /** Disposed of properly */
  DISPOSED: 'DISPOSED',
  /** Expired */
  EXPIRED: 'EXPIRED',
  /** Quarantined pending investigation */
  QUARANTINED: 'QUARANTINED',
} as const;

export type ControlledItemStatus = (typeof ControlledItemStatus)[keyof typeof ControlledItemStatus];
/** Conversion History Entry (GraphQL output) */
export type ConversionHistoryEntry = {
  __typename?: 'ConversionHistoryEntry';
  confidence: Scalars['Float']['output'];
  conversionId: Scalars['String']['output'];
  convertedAt: Scalars['String']['output'];
  convertedBy: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  primitivesCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
  templateVersion?: Maybe<Scalars['String']['output']>;
  violationsCount: Scalars['Int']['output'];
};

/** Conversion Reference (GraphQL output) */
export type ConversionReference = {
  __typename?: 'ConversionReference';
  confidence: Scalars['Float']['output'];
  conversionId: Scalars['String']['output'];
  convertedAt: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  templateVersion: Scalars['String']['output'];
};

/** Conversion Result Input */
export type ConversionResultInput = {
  /** Confidence metrics */
  confidence: ConfidenceMetricsInput;
  /** Template ID */
  templateId: Scalars['String']['input'];
  /** Template version */
  templateVersion: Scalars['String']['input'];
  /** Tenant */
  tenant: Scalars['String']['input'];
};

/** Conversion Status (GraphQL output) */
export type ConversionStatus = {
  __typename?: 'ConversionStatus';
  conversionHistory: Array<ConversionHistoryEntry>;
  documentId: Scalars['String']['output'];
  latestConversion?: Maybe<ConversionReference>;
  status: ChaosDocumentStatus | '%future added value';
};

/** Convert Chaos to DSL Input */
export type ConvertChaosToDslInput = {
  /** Creator/converter ID */
  createdBy: Scalars['String']['input'];
  /** Document ID (from uploaded chaos document) */
  documentId: Scalars['String']['input'];
  /** Include evidence flag */
  includeEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Strict validation flag */
  strictValidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target domain (optional - will auto-detect if not specified) */
  targetDomain?: InputMaybe<Scalars['String']['input']>;
  /** Tenant context */
  tenant: Scalars['String']['input'];
};

/** Coordination weights (read-only view) */
export type CoordinationWeights = {
  __typename?: 'CoordinationWeights';
  /** Cognitive continuity enabled */
  cognitiveContinuityEnabled: Scalars['Boolean']['output'];
  /** Staffing floors (immutable) */
  staffingFloors: StaffingFloors;
  /** Target continuity percentage */
  targetContinuityPercent: Scalars['Int']['output'];
  /** Task priority weights */
  taskPriorityWeights: TaskPriorityWeights;
  /** Two-person assist enabled */
  twoPersonAssistEnabled: Scalars['Boolean']['output'];
};

/** Correlated event pair */
export type CorrelatedEventPair = {
  __typename?: 'CorrelatedEventPair';
  /** Primary event ID */
  primaryEventId: Scalars['String']['output'];
  /** Secondary event ID */
  secondaryEventId: Scalars['String']['output'];
  /** Shared entity ID (if entity correlation) */
  sharedEntityId?: Maybe<Scalars['String']['output']>;
  /** Time delta in milliseconds */
  timeDeltaMs: Scalars['Int']['output'];
};

/** Cost breakdown by component */
export type CostBreakdown = {
  __typename?: 'CostBreakdown';
  /** API request cost */
  apiRequestCost: Scalars['Float']['output'];
  /** Cache miss penalty */
  cacheMissCost: Scalars['Float']['output'];
  /** Compute cost (Lambda/ECS) */
  computeCost: Scalars['Float']['output'];
  /** Data transfer cost (Wasabi egress) */
  dataTransferCost: Scalars['Float']['output'];
};

export type CostImpactGql = {
  __typename?: 'CostImpactGql';
  annualSavingsUsd: Scalars['Float']['output'];
  implementationCostUsd: Scalars['Float']['output'];
  roiMonths: Scalars['Int']['output'];
};

/** Key-value count pair */
export type CountByKey = {
  __typename?: 'CountByKey';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

/** A single coverage gap — a rule with no downstream config. */
export type CoverageGap = {
  __typename?: 'CoverageGap';
  /** Rule description */
  description: Scalars['String']['output'];
  /** Number of downstream configs referencing this rule (always 0 for gaps) */
  downstreamConfigCount: Scalars['Int']['output'];
  /** Config types that are missing for this rule (what needs to be created) */
  missingConfigs: Array<MissingConfig>;
  /** Rule identifier */
  ruleId: Scalars['String']['output'];
  /** Machine-readable rule name */
  ruleName: Scalars['String']['output'];
  /** Statute section reference */
  sectionRef?: Maybe<Scalars['String']['output']>;
};

/** Report of downstream config coverage for a ruleset's member rules. */
export type CoverageGapReport = {
  __typename?: 'CoverageGapReport';
  /** Coverage percentage (0-100) */
  coveragePercent: Scalars['Int']['output'];
  /** Rules with at least one downstream config (task group or workflow) */
  coveredRules: Scalars['Int']['output'];
  /** List of uncovered rules (the gaps) */
  gaps: Array<CoverageGap>;
  /** RuleSet that was analyzed */
  rulesetId: Scalars['String']['output'];
  /** Total number of member rules in the ruleset */
  totalRules: Scalars['Int']['output'];
  /** Rules with NO downstream config */
  uncoveredRules: Scalars['Int']['output'];
};

/** Actor creation input */
export type CreateActorInputGql = {
  actorType: Scalars['String']['input'];
  email: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

/** GraphQL input type for creating a role. */
export type CreateActorRoleInput = {
  /** Role purpose and responsibilities */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional validity period */
  effectiveDateRange?: InputMaybe<DateRangeInput>;
  /** Parent role IDs (multiple inheritance) */
  inheritsFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Extensible metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Permission evaluation mode */
  permissionMode: GqlPermissionMode | '%future added value';
  /** Granted permissions */
  permissions: Array<PermissionInput>;
  /** Resource-level constraints */
  resourceScopes?: InputMaybe<Array<ResourceScopeInput>>;
  /** Organizational category */
  roleCategory: GqlRoleCategory | '%future added value';
  /** Role name (UNIQUE within tenant) */
  roleName: Scalars['String']['input'];
  /** Searchable tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for creating a new analytics metric */
export type CreateAnalyticsInput = {
  aggregationType: AggregationType | '%future added value';
  aggregationWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  alertOnThresholdBreach?: InputMaybe<Scalars['Boolean']['input']>;
  analyticsCode: Scalars['String']['input'];
  analyticsName: Scalars['String']['input'];
  criticalThreshold?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  metricCategory: MetricCategory | '%future added value';
  metricName: Scalars['String']['input'];
  metricType: MetricType | '%future added value';
  metricUnit: MetricUnit | '%future added value';
  notificationActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcePrimitiveIds: Array<Scalars['String']['input']>;
  sourcePrimitiveType: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  thresholdDirection?: InputMaybe<ThresholdDirection | '%future added value'>;
  warningThreshold?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for creating a new anti-pattern */
export type CreateAntiPatternInput = {
  /** Auto-fix configuration (JSON string) */
  autoFixJson?: InputMaybe<Scalars['String']['input']>;
  /** Description of why this is an anti-pattern */
  description: Scalars['String']['input'];
  /** Primitives that must be present to trigger this check */
  hasPrimitives: Array<Scalars['String']['input']>;
  /** Unique anti-pattern identifier */
  id: Scalars['String']['input'];
  /** Warning message to display */
  message: Scalars['String']['input'];
  /** Primitives that must be missing for this to be an anti-pattern */
  missingPrimitives: Array<Scalars['String']['input']>;
  /** Human-readable name */
  name: Scalars['String']['input'];
  /** Related formula number (optional) */
  relatedFormula?: InputMaybe<Scalars['Int']['input']>;
  /** Severity level */
  severity: WarningSeverity | '%future added value';
  /** Tenant ID (use "system" for system-wide patterns) */
  tenantId: Scalars['String']['input'];
};

/** Input for creating a new architect proposal (DRR-227) */
export type CreateArchitectProposalInput = {
  /** Target config ID (leave empty for auto-generated ID) */
  configId?: InputMaybe<Scalars['String']['input']>;
  /** Config type being proposed */
  configType: ConfigProposalType | '%future added value';
  /** Description of the change */
  description: Scalars['String']['input'];
  /** Proposed config content (JSON string) */
  proposedContent: Scalars['String']['input'];
  /** Human-readable title */
  title: Scalars['String']['input'];
};

/** Input for creating an attestation */
export type CreateAttestationInput = {
  /** Actor ID who is attesting */
  attestedByActorId: Scalars['String']['input'];
  /** Role of the attesting actor */
  attestedByRole: Scalars['String']['input'];
  /** Entity types in this batch */
  entityTypes: Array<PiiEntityType | '%future added value'>;
  /** SHA-256 hash of the source file */
  fileHash: Scalars['String']['input'];
  /** Number of records to be imported */
  recordCount: Scalars['Int']['input'];
  /** Source IP address */
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Result of creating an attestation */
export type CreateAttestationResult = {
  __typename?: 'CreateAttestationResult';
  attestationId?: Maybe<Scalars['String']['output']>;
  batchId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateAuditInput = {
  auditCode: Scalars['String']['input'];
  auditName: Scalars['String']['input'];
  compliancePeriodEnd: Scalars['DateTime']['input'];
  compliancePeriodStart: Scalars['DateTime']['input'];
  frameworkType: GqlAuditFrameworkType | '%future added value';
  generatedByUserId: Scalars['String']['input'];
  regulatoryQuestion: Scalars['String']['input'];
  reportFormat: GqlReportFormat | '%future added value';
  reportTemplateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CreateCeremonyFromTemplateInput = {
  documentId: Scalars['String']['input'];
  /** Parallel to template.participants order. Empty string = skip optional slot. */
  participantEmails: Array<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CreateCeremonyTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentName: Scalars['String']['input'];
  expiryHours?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** "Parallel" (default) or "Sequential" */
  ordering?: InputMaybe<Scalars['String']['input']>;
  participants: Array<CreateCeremonyTemplateParticipantInput>;
  tenantId: Scalars['String']['input'];
};

export type CreateCeremonyTemplateParticipantInput = {
  required: Scalars['Boolean']['input'];
  roleName: Scalars['String']['input'];
  /** Signing role: "Signer", "Approver", "CarbonCopy", "Witness" */
  signingRole: Scalars['String']['input'];
};

/** Input for creating a communication log. */
export type CreateCommunicationLogInput = {
  /** Type of contact */
  contactType: Scalars['String']['input'];
  /** Duration in minutes (optional) */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Outcome of the contact */
  outcome?: InputMaybe<Scalars['String']['input']>;
  /** Participant/subject ID */
  participantId: Scalars['String']['input'];
  /** Summary of the communication */
  summary: Scalars['String']['input'];
};

export type CreateConditionInput = {
  clinicalStatus?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};

/** Input for creating a dependency. */
export type CreateDependencyInput = {
  /** Created by user ID */
  createdBy: Scalars['String']['input'];
  /** Dependency type */
  dependencyType: GqlDependencyType | '%future added value';
  /** Optional description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Dependency name */
  name: Scalars['String']['input'];
  /** Predecessor task ID */
  predecessorId: Scalars['String']['input'];
  /** Successor task ID */
  successorId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** Workflow ID */
  workflowId: Scalars['String']['input'];
};

/** Input for creating a new document */
export type CreateDocumentInput = {
  accessLevel: AccessLevel | '%future added value';
  category: Scalars['String']['input'];
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentName: Scalars['String']['input'];
  documentType: DocumentType | '%future added value';
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  fileSizeBytes: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  storageType: StorageType | '%future added value';
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Input for creating a new document version */
export type CreateDocumentVersionInput = {
  changeDescription: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  newContent?: InputMaybe<Scalars['String']['input']>;
  newS3Key?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type CreateDomainMetadataInput = {
  access: AccessLevelGql | '%future added value';
  certification?: InputMaybe<CertificationInput>;
  complianceLevel: ComplianceLevelGql | '%future added value';
  createdBy: Scalars['String']['input'];
  domainType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  version: Scalars['String']['input'];
};

/** Input for creating a new draft */
export type CreateDraftInput = {
  /** Optional certification context */
  certification?: InputMaybe<Scalars['String']['input']>;
  /** Optional industry context */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Optional program variant context */
  programVariant?: InputMaybe<Scalars['String']['input']>;
  /** Optional state context */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** Workflow to create draft from */
  workflowName: Scalars['String']['input'];
};

export type CreateEncounterInput = {
  classCode: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating entities */
export type CreateEntityInput = {
  /** Configuration */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Entity description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Entity type */
  entityType: Scalars['String']['input'];
  /** Domain-specific metadata */
  metadata: Scalars['JSON']['input'];
  /** Entity name */
  name: Scalars['String']['input'];
  /** Priority */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Schema reference */
  schemaRef: Scalars['String']['input'];
  /** Tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for creating a family */
export type CreateFamilyInput = {
  careRecipientName?: InputMaybe<Scalars['String']['input']>;
  marketingAuthorized: Scalars['Boolean']['input'];
  preferredLanguage: CareCircleLanguage | '%future added value';
  primaryContactEmail: Scalars['String']['input'];
  primaryContactName: Scalars['String']['input'];
  primaryContactPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a FHIR resource via dual-write pipeline */
export type CreateFhirResourceGqlInput = {
  /** Who is creating this resource */
  createdBy: Scalars['String']['input'];
  /** FHIR JSON payload as string */
  fhirJson: Scalars['String']['input'];
  /** Resource ID (must be generated by backend Snowflake) */
  resourceId: Scalars['String']['input'];
  /** FHIR resource type (e.g., "Patient", "Encounter") */
  resourceType: Scalars['String']['input'];
  /** Tenant number */
  tenantNum: Scalars['Int']['input'];
};

/** Input for creating a new FHIR resource in DynamoDB */
export type CreateFhirStoredResourceInput = {
  /** Audit: operation description */
  auditOperation: Scalars['String']['input'];
  /** Full FHIR R4 JSON payload (as string) */
  fhirJson: Scalars['String']['input'];
  /** Resource ID (must be generated by backend Snowflake) */
  resourceId: Scalars['String']['input'];
  /** FHIR resource type */
  resourceType: FhirStorageResourceType | '%future added value';
};

/** Input for creating a new draft */
export type CreateFormSchemaDraftInput = {
  /** Entity type (e.g., "JournalEntry") */
  entityType: Scalars['String']['input'];
  /** UI mode context */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** Subgraph/module (e.g., "accounting") */
  subgraph: Scalars['String']['input'];
};

export type CreateFromTemplateInput = {
  createdBy: Scalars['String']['input'];
  overrideValues?: InputMaybe<Scalars['JSON']['input']>;
  templateId: Scalars['String']['input'];
  templateVersion: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};

/** Input for creating an incident report. */
export type CreateIncidentInput = {
  /** Description of the incident */
  description: Scalars['String']['input'];
  /** Severity level */
  severity: Scalars['String']['input'];
  /** Type of incident */
  type: Scalars['String']['input'];
};

/** Input for creating a new integration */
export type CreateIntegrationInput = {
  authConfigJson: Scalars['JSON']['input'];
  authType: AuthenticationType | '%future added value';
  baseUrl: Scalars['String']['input'];
  description: Scalars['String']['input'];
  extendedMetadata?: InputMaybe<Scalars['JSON']['input']>;
  integrationCode: Scalars['String']['input'];
  integrationName: Scalars['String']['input'];
  integrationType: IntegrationType | '%future added value';
  maxConnections?: InputMaybe<Scalars['Int']['input']>;
  protocol: Protocol | '%future added value';
  tenantId: Scalars['String']['input'];
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a journey audit event. */
export type CreateJourneyAuditEventInput = {
  /** If true, create a 24-hour review task */
  createReviewTask: Scalars['Boolean']['input'];
  /** Event type: "emergency_override", "break_glass", "witness_verification" */
  eventType: Scalars['String']['input'];
  /** Instance ID this event relates to */
  instanceId: Scalars['String']['input'];
  /** Justification/reason for the event */
  reason: Scalars['String']['input'];
};

/** Input for recording a MedicationAdministration */
export type CreateMedicationAdministrationInput = {
  /** Dose administered */
  doseQuantity: Scalars['Float']['input'];
  /** Dose unit */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Encounter ID if administered during encounter */
  encounterId?: InputMaybe<Scalars['String']['input']>;
  /** MedicationRequest ID being administered */
  medicationRequestId: Scalars['String']['input'];
  /** Administration notes */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Patient ID */
  patientId: Scalars['String']['input'];
  /** Performer who administered */
  performerId?: InputMaybe<Scalars['String']['input']>;
  /** Administration route (oral, IV, etc.) */
  route?: InputMaybe<Scalars['String']['input']>;
  /** Site of administration */
  site?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a MedicationDispense (fill/refill) */
export type CreateMedicationDispenseInput = {
  /** Days supply dispensed */
  daysSupply?: InputMaybe<Scalars['Int']['input']>;
  /** MedicationRequest ID this dispense fulfills */
  medicationRequestId: Scalars['String']['input'];
  /** Patient ID (FERP or Medplum ID) */
  patientId: Scalars['String']['input'];
  /** Dispenser/Pharmacist who filled */
  performerId?: InputMaybe<Scalars['String']['input']>;
  /** Quantity dispensed */
  quantity: Scalars['Float']['input'];
  /** Unit for quantity */
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  /** Substitution reason if applicable */
  substitutionReason?: InputMaybe<Scalars['String']['input']>;
  /** Whether a substitution was made */
  wasSubstituted?: Scalars['Boolean']['input'];
};

/** Input for creating a MedicationRequest (prescription) */
export type CreateMedicationRequestInput = {
  /** Days supply per fill */
  daysSupply?: InputMaybe<Scalars['Int']['input']>;
  /** Quantity to dispense per fill */
  dispenseQuantity?: InputMaybe<Scalars['Float']['input']>;
  /** Unit for quantity (tablets, ml, etc.) */
  dispenseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Dosage instructions (sig) */
  dosageInstruction?: InputMaybe<Scalars['String']['input']>;
  /** Intent: proposal | plan | order | original-order | reflex-order | filler-order | instance-order | option */
  intent?: Scalars['String']['input'];
  /** Medication code (RxNorm, NDC, etc.) */
  medicationCode: Scalars['String']['input'];
  /** Medication display name */
  medicationDisplay?: InputMaybe<Scalars['String']['input']>;
  /** Number of refills allowed (0 = no refills, original fill only) */
  numberOfRepeatsAllowed?: Scalars['Int']['input'];
  /** Patient ID (FERP or Medplum ID) */
  patientId: Scalars['String']['input'];
};

export type CreateObservationInput = {
  code: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  valueQuantity?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
  valueUnit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrchestrationPatternInput = {
  defaultConfig?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orchestrationSteps: Array<OrchestrationStepInput>;
  patternType: Scalars['String']['input'];
  ruleTags: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrchestrationRuleInput = {
  actions: Scalars['JSON']['input'];
  appliesToDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  appliesToEntityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  conditions: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  inputSchema?: InputMaybe<Scalars['JSON']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  outputSchema?: InputMaybe<Scalars['JSON']['input']>;
  prerequisites?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  purpose: Scalars['String']['input'];
  regulatoryFramework?: InputMaybe<Array<Scalars['String']['input']>>;
  semanticMeaning: Scalars['String']['input'];
  sourcePrimitive: Scalars['String']['input'];
  sourcePrimitiveId?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Input for creating a new order */
export type CreateOrderInput = {
  /** Virtual brand (e.g., "Thai Kitchen", "Burger House") */
  brand: Scalars['String']['input'];
  /** Customer name for delivery */
  customerName: Scalars['String']['input'];
  /** Customer phone (optional) */
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Delivery address */
  deliveryAddress: Scalars['String']['input'];
  /** Order items */
  items: Array<CreateOrderItemInput>;
  /** Special instructions */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
};

/** Item within a create order input */
export type CreateOrderItemInput = {
  /** Modifications (e.g., "no onions", "extra sauce") */
  modifications?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Menu item name */
  name: Scalars['String']['input'];
  /** Quantity */
  quantity: Scalars['Int']['input'];
  /** Station assignment (derived from menu item) */
  station: FoodServiceStation | '%future added value';
};

export type CreatePatientInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  givenName: Scalars['String']['input'];
  mrn?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a policy. */
export type CreatePolicyInput = {
  /** Audit level */
  auditLevel?: InputMaybe<GqlAuditLevel | '%future added value'>;
  /** Created by user ID */
  createdBy: Scalars['String']['input'];
  /** Policy implementation engine */
  implementation?: InputMaybe<GqlPolicyImplementation | '%future added value'>;
  /** Policy name */
  name: Scalars['String']['input'];
  /** Policy type */
  policyType: GqlPolicyType | '%future added value';
  /** Policy rules */
  rules: Array<PolicyRuleInput>;
  /** Policy scope */
  scope: GqlPolicyScope | '%future added value';
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Create Policy Rule Input */
export type CreatePolicyRuleInput = {
  /** Actions to execute */
  actions: Array<PolicyActionInput>;
  /** Conditions (AND logic) */
  conditions: Array<PolicyConditionInput>;
  /** Enabled flag */
  enabled: Scalars['Boolean']['input'];
  /** Policy name */
  policyName: Scalars['String']['input'];
  /** Policy type */
  policyType: Scalars['String']['input'];
  /** Priority (1-100, higher executes first) */
  priority: Scalars['Int']['input'];
  /** Tenant ID (from auth context) */
  tenantId: Scalars['String']['input'];
};

export type CreateProcedureInput = {
  code: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Create Role Input */
export type CreateRoleInput = {
  /** Capabilities (semantic actions) */
  capabilities: Array<Scalars['String']['input']>;
  /** Role description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name (user-friendly, e.g., "System Administrator") */
  displayName: Scalars['String']['input'];
  /** Enabled flag */
  enabled: Scalars['Boolean']['input'];
  /** Parent roles (for inheritance) */
  inheritsFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Role name (unique per tenant, e.g., "admin", "custom_analyst") */
  roleName: Scalars['String']['input'];
  /** Scopes (from auth/perms.rs constants) */
  scopes: Array<Scalars['String']['input']>;
  /** Tenant ID (from auth context) */
  tenantId: Scalars['String']['input'];
};

export type CreateRoleTemplateInput = {
  category: Scalars['String']['input'];
  complianceFrameworks: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  roleDefinition: TemplateRoleDefinitionInput;
  templateName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Comprehensive input for creating safety events (40+ fields for life-critical compliance) */
export type CreateSafetyEventInput = {
  /** Actor descriptor ID if actor-based execution */
  actorDescriptorId?: InputMaybe<Scalars['String']['input']>;
  /**
   * List of affected entities (patients, accounts, documents, workflows)
   * Comprehensive tracking for HIPAA/SOX/legal compliance
   */
  affectedEntities?: Array<AffectedEntityInput>;
  /**
   * Event category (PatientSafety, FinancialFraud, LegalPrivilege, DataBreach, SystemFailure)
   * From tenant Policy metadata (data-driven, not hardcoded)
   */
  category: Scalars['String']['input'];
  /** Human-readable event description (audit trail documentation) */
  description: Scalars['String']['input'];
  /** Whether emergency contacts were notified (life-critical events only) */
  emergencyContactsNotified?: Scalars['Boolean']['input'];
  /** List of user IDs escalated to (from Actor repository) */
  escalatedTo?: Array<Scalars['String']['input']>;
  /**
   * Current escalation level (L1, L2, L3, Emergency)
   * From tenant Policy metadata (data-driven)
   */
  escalationLevel?: InputMaybe<Scalars['String']['input']>;
  /** Escalation path ID (from tenant Policy metadata) */
  escalationPathId?: InputMaybe<Scalars['String']['input']>;
  /** Whether escalation was triggered (life-critical event flag) */
  escalationTriggered?: Scalars['Boolean']['input'];
  /**
   * Specific event type (SafetyViolation, ThresholdExceeded, UnauthorizedAccess, etc.)
   * From tenant Policy metadata (domain-agnostic)
   */
  eventType: Scalars['String']['input'];
  /**
   * Evidence data (screenshots, logs, transaction details)
   * Domain-agnostic JSON for flexible evidence capture
   */
  evidence?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Additional metadata (domain-specific context)
   * Examples: patient vitals, transaction amounts, document classifications
   */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Parent event ID (for event hierarchies) */
  parentEventId?: InputMaybe<Scalars['String']['input']>;
  /** Specific primitive instance ID */
  primitiveInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Primitive type involved (one of 16: wfl, ins, sig, exe, mon, gov, pol, esc, not, met, aud, rep, ana, opt, rel, lif) */
  primitiveType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Related event IDs (correlation for cascade failures)
   * Links multiple events for root cause analysis
   */
  relatedEventIds?: Array<Scalars['String']['input']>;
  /**
   * Deadline for remediation completion (regulatory requirement)
   * Calculated from severity and tenant Policy metadata
   */
  remediationDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** Remediation notes and action log (audit trail) */
  remediationNotes?: InputMaybe<Scalars['String']['input']>;
  /** User ID assigned to remediate this event (from Actor repository) */
  remediationOwner?: InputMaybe<Scalars['String']['input']>;
  /** Whether remediation action is required (regulatory compliance flag) */
  remediationRequired?: Scalars['Boolean']['input'];
  /**
   * Rule ID that triggered this event (from tenant Policy metadata)
   * Links to specific regulatory compliance rule
   */
  ruleId: Scalars['String']['input'];
  /**
   * Current safety score (0.0-100.0)
   * Backend calculates delta from previous score
   */
  safetyScore: Scalars['Float']['input'];
  /** SAGA execution ID if event occurred during distributed transaction */
  sagaExecutionId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID for user action correlation (from authentication context) */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Severity level (Critical, High, Medium, Low, Info)
   * Determines escalation path and response time requirements
   */
  severity: Scalars['String']['input'];
  /** Source IP address (security audit requirement, from request context) */
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  /** Source system that generated the event (from backend configuration) */
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID for multi-tenant isolation (from authentication context) */
  tenantId: Scalars['String']['input'];
  /** Event occurrence timestamp (ISO 8601) - when the safety event actually occurred */
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** User ID who triggered the event (from authentication context, or "system" if automated) */
  userId: Scalars['String']['input'];
  /** Workflow instance ID if event occurred during workflow execution */
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for creating a saga transaction (Formula #4)
 * NOTE: tenant_id comes from AuthCtx (not GraphQL parameter)
 */
export type CreateSagaTransactionInput = {
  totalSteps: Scalars['Int']['input'];
  transactionName: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

export type CreateSigningCeremonyInput = {
  /** Custom branding for the public signing page (D6). */
  branding?: InputMaybe<CeremonyBrandingInput>;
  /** Days until the consent expires from signing date. Default: 365. */
  consentExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Constellation ID of the subject's care plan (required with subject_actor_id). */
  constellationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
  expiryHours?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Placed fields for step-through signing. When provided, the signing UI walks
   * signers through each field one at a time (like DocuSign). Each field references
   * a participant by index and has its own type (signature, initials, date, text).
   */
  fields?: InputMaybe<Array<CeremonyFieldInput>>;
  /**
   * KBA (Knowledge-Based Authentication) config (DRR-091 Phase 3).
   * When present, signing-role participants must verify identity before signing.
   */
  kba?: InputMaybe<KbaConfigInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  padesProfile: PadesProfile | '%future added value';
  participants: Array<ParticipantInput>;
  /** Post-signing redirect URL (D3). After signing the signer is redirected here. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  signingOrder: SigningOrder | '%future added value';
  subject?: InputMaybe<Scalars['String']['input']>;
  /**
   * Subject actor ID this consent covers (resident/patient sequential ID).
   * When set, a DRR-149 enrichment record is written on ceremony.completed
   * so the task spawner knows the consent is signed and its expiry date.
   */
  subjectActorId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Input for creating a system tenant */
export type CreateSystemTenantInput = {
  /** Compliance frameworks */
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Domain slug (must be unique) */
  domain: Scalars['String']['input'];
  /** Industry vertical */
  industry: Scalars['String']['input'];
  /** Display name */
  name: Scalars['String']['input'];
  /** Primary contact email */
  primaryContactEmail: Scalars['String']['input'];
  /** Primary contact name */
  primaryContactName: Scalars['String']['input'];
  /** Subscription tier */
  subscriptionTier?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a system user */
export type CreateSystemUserInput = {
  /** Authentik UUID (from SSO) */
  authentikUuid: Scalars['String']['input'];
  /** Email address */
  email: Scalars['String']['input'];
  /** Initial global roles */
  globalRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Initial tenant IDs */
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Username (display name) */
  username: Scalars['String']['input'];
};

/** Create template metadata input */
export type CreateTemplateMetadataInput = {
  createdBy: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  metadata: TemplateMetadataContentInput;
  templateId: Scalars['String']['input'];
  templateType: Scalars['String']['input'];
  templateVersion: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Create Tenant Branding Input */
export type CreateTenantBrandingInput = {
  /** Accent color (hex) */
  accentColor: Scalars['String']['input'];
  /** Accreditations and certifications */
  accreditations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Physical address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Company name */
  companyName: Scalars['String']['input'];
  /** Company tagline (optional) */
  companyTagline?: InputMaybe<Scalars['String']['input']>;
  /** Custom domain (optional) */
  customDomain?: InputMaybe<Scalars['String']['input']>;
  /** Favicon URL (optional) */
  faviconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Font family */
  fontFamily: Scalars['String']['input'];
  /** Hide FERP branding */
  hideFerpBranding: Scalars['Boolean']['input'];
  /** Business hours */
  hours?: InputMaybe<Scalars['String']['input']>;
  /** License type (e.g., "MN 144G Assisted Living") */
  licenseType?: InputMaybe<Scalars['String']['input']>;
  /** Logo URL (optional) */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Primary color (hex) */
  primaryColor: Scalars['String']['input'];
  /** Secondary color (hex) */
  secondaryColor: Scalars['String']['input'];
  /** Services offered */
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Show help center */
  showHelpCenter: Scalars['Boolean']['input'];
  /** Show support chat */
  showSupportChat: Scalars['Boolean']['input'];
  /** Subdomain (required, unique) */
  subdomain: Scalars['String']['input'];
  /** Support email (optional) */
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  /** Support phone (optional) */
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID (from auth context) */
  tenantId: Scalars['String']['input'];
  /** Terminology mapping (FERP term → Industry term) */
  terminology: Scalars['JSON']['input'];
  /** Public website slug (URL-safe, e.g., "hillside-harmony") */
  websiteSlug?: InputMaybe<Scalars['String']['input']>;
  /** Website URL (optional) */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTenantMetadataInput = {
  brandConfig: BrandConfigInput;
  businessRules: Scalars['JSON']['input'];
  extends: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  tenantId: Scalars['String']['input'];
  updatedBy: Scalars['String']['input'];
};

/** Result of creating tenant workflows */
export type CreateTenantWorkflowsResult = {
  __typename?: 'CreateTenantWorkflowsResult';
  /** Error message if any */
  error?: Maybe<Scalars['String']['output']>;
  /** Instance ID (if created) */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** Whether creation was successful */
  success: Scalars['Boolean']['output'];
  /** Total task count */
  taskCount: Scalars['Int']['output'];
  /** Master workflow ID */
  workflowId: Scalars['String']['output'];
};

/** GraphQL input type for creating a trace. */
export type CreateTraceInput = {
  /** Actor performing this operation (human, AI, system) */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** Alternative options considered */
  alternativeOptions?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** OpenTelemetry attributes (key-value pairs) */
  attributes?: InputMaybe<Scalars['JSONObject']['input']>;
  /** W3C Baggage (cross-cutting concerns) */
  baggage?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Cache hits (Redis) */
  cacheHits?: InputMaybe<Scalars['Int']['input']>;
  /** Cache misses (Redis) */
  cacheMisses?: InputMaybe<Scalars['Int']['input']>;
  /** CPU usage percentage */
  cpuPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Creator user ID */
  createdBy: Scalars['String']['input'];
  /** Confidence score for AI decisions (0.0-1.0) */
  decisionConfidence?: InputMaybe<Scalars['Float']['input']>;
  /** Human-readable reasoning (for AI decisions) */
  decisionReasoning?: InputMaybe<Scalars['String']['input']>;
  /** Duration in milliseconds (derived from started_at - ended_at) */
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  /** When this span ended (None if still running) */
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Error code (if failed) */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Error message (if failed) */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Error stack trace (if failed) */
  errorStackTrace?: InputMaybe<Scalars['String']['input']>;
  /** Evidence sources supporting decision */
  evidenceSources?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Memory usage in MB */
  memoryMb?: InputMaybe<Scalars['Float']['input']>;
  /** Additional structured metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Network bytes transferred */
  networkBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Human-readable operation name */
  operationName: Scalars['String']['input'];
  /** Parent span ID (for nested operations) */
  parentSpanId?: InputMaybe<Scalars['String']['input']>;
  /** Zen Engine policy evaluation results */
  policyEvaluationResults?: InputMaybe<Scalars['JSON']['input']>;
  /** Service/component name (for distributed systems) */
  serviceName: Scalars['String']['input'];
  /** OpenTelemetry-compatible span ID (64-bit, hex-encoded) */
  spanId: Scalars['String']['input'];
  /** Type of span */
  spanType: GqlTraceSpanType | '%future added value';
  /** When this span started (ISO 8601) */
  startedAt: Scalars['DateTime']['input'];
  /** Trace status */
  status: GqlTraceStatus | '%future added value';
  /** Tags for filtering/grouping */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Task being executed (if applicable) */
  taskId?: InputMaybe<Scalars['String']['input']>;
  /** Multi-tenant isolation */
  tenantId: Scalars['String']['input'];
  /** AI tokens used (for cost tracking) */
  tokensUsed?: InputMaybe<Scalars['Int']['input']>;
  /** W3C Trace Context (traceparent header value) */
  traceContext?: InputMaybe<Scalars['String']['input']>;
  /** OpenTelemetry-compatible trace ID (128-bit, hex-encoded) */
  traceId: Scalars['String']['input'];
  /** Entity that triggered this trace */
  triggerEntityId?: InputMaybe<Scalars['String']['input']>;
  /** Type of triggering entity */
  triggerEntityType?: InputMaybe<Scalars['String']['input']>;
  /** Validation rule results */
  validationResults?: InputMaybe<Scalars['JSON']['input']>;
  /** Workflow instance this trace belongs to */
  workflowInstanceId: Scalars['String']['input'];
};

/** Input for creating a witness request */
export type CreateWitnessRequestInput = {
  /** Custom operation type name (required if operation_type is CUSTOM) */
  customOperationType?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable description of the action */
  description: Scalars['String']['input'];
  /** Entity being operated on (e.g., patient_id, account_id) */
  entityId: Scalars['String']['input'];
  /** Entity type (e.g., "Patient", "Account") */
  entityType: Scalars['String']['input'];
  /** Optional metadata (JSON string) */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Type of operation requiring witness */
  operationType: WitnessOperationTypeGql | '%future added value';
  /** Custom timeout in seconds (max 300) */
  timeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Payload for createWitnessRequest mutation */
export type CreateWitnessRequestPayload = {
  __typename?: 'CreateWitnessRequestPayload';
  /** Pub/sub channel for notifications */
  notificationChannel: Scalars['String']['output'];
  /** The created request */
  request: WitnessRequestGql;
};

/** Create workflow graph input */
export type CreateWorkflowGraphInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  edges: Array<WorkflowEdgeInput>;
  graphName: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  nodes: Array<WorkflowNodeInput>;
  tenantId: Scalars['String']['input'];
};

/** Critical path analysis result. */
export type CriticalPathResult = {
  __typename?: 'CriticalPathResult';
  /** Critical path task IDs (in order) */
  criticalPath: Array<Scalars['String']['output']>;
  /** Tasks on critical path */
  criticalTasks: Array<CriticalTask>;
  /** Total duration (arbitrary units) */
  totalDuration: Scalars['Int']['output'];
};

/** Task on critical path. */
export type CriticalTask = {
  __typename?: 'CriticalTask';
  /** Earliest start time */
  earliestStart: Scalars['Int']['output'];
  /** Task ID */
  id: Scalars['String']['output'];
  /** Latest start time */
  latestStart: Scalars['Int']['output'];
  /** Task name */
  name: Scalars['String']['output'];
  /** Slack time (0 for critical tasks) */
  slack: Scalars['Int']['output'];
};

export type CriticalityConfigInput = {
  appliesToTypes: Array<Scalars['String']['input']>;
  criticalityLevel: Scalars['String']['input'];
  deduplicationFields: Array<Scalars['String']['input']>;
  duplicateWindowMinutes: Scalars['Int']['input'];
  offlineConfig: OfflineConfigInput;
  requiredWitnesses: Scalars['Int']['input'];
  requiresExclusiveLock: Scalars['Boolean']['input'];
  ruleId: Scalars['String']['input'];
  validationRules: Array<ValidationRuleInput>;
};

/** Cross-tenant audit report result */
export type CrossTenantAuditReport = {
  __typename?: 'CrossTenantAuditReport';
  /** Actual cost in dollars */
  actualCostDollars: Scalars['Float']['output'];
  /** Data transferred in bytes */
  bytesTransferred: Scalars['String']['output'];
  /** Files accessed (for cost tracking) */
  filesAccessed: Scalars['Int']['output'];
  /** Query execution metadata */
  queryMetadata: QueryMetadata;
  /** Audit records matching query */
  records: Array<AuditRecord>;
  /** Row groups read */
  rowGroupsRead: Scalars['Int']['output'];
  /** Summary statistics */
  summary: AuditSummary;
};

/** Input for cross-tenant audit report query */
export type CrossTenantAuditReportInput = {
  /** Actor IDs to filter */
  actorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Budget limit in dollars (query fails if estimate exceeds) */
  budgetLimit?: InputMaybe<Scalars['Float']['input']>;
  /** End date for audit window */
  endDate: Scalars['NaiveDate']['input'];
  /** Event types to include */
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum records to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Start date for audit window */
  startDate: Scalars['NaiveDate']['input'];
  /** Subgraph IDs to filter */
  subgraphIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tenant IDs to include (ADMIN only: can query across tenants) */
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrossTenantAuth = {
  __typename?: 'CrossTenantAuth';
  authorizationDocumentId?: Maybe<Scalars['String']['output']>;
  authorizationType: Scalars['String']['output'];
  authorizedAt: Scalars['DateTime']['output'];
  authorizedBy: Scalars['String']['output'];
  expiration?: Maybe<Scalars['DateTime']['output']>;
  revoked: Scalars['Boolean']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
};

/** Custom action capability. */
export type CustomActionCapability = {
  __typename?: 'CustomActionCapability';
  /** Action name (e.g., "sign", "delegate", "escalate") */
  action: Scalars['String']['output'];
  /** Whether the action is granted */
  granted: Scalars['Boolean']['output'];
  /** Optional reason (for audit/debugging) */
  reason?: Maybe<Scalars['String']['output']>;
};

/** DAG edge (dependency). */
export type DagEdge = {
  __typename?: 'DAGEdge';
  /** Dependency type */
  dependencyType: GqlDependencyType | '%future added value';
  /** Source task ID */
  from: Scalars['String']['output'];
  /** Dependency ID */
  id: Scalars['String']['output'];
  /** Target task ID */
  to: Scalars['String']['output'];
};

/** DAG node (task). */
export type DagNode = {
  __typename?: 'DAGNode';
  /** Task ID */
  id: Scalars['String']['output'];
  /** Incoming dependency count */
  incomingDependencies: Scalars['Int']['output'];
  /** Task name */
  name: Scalars['String']['output'];
  /** Outgoing dependency count */
  outgoingDependencies: Scalars['Int']['output'];
};

export const DagcriticalityEnum = {
  complianceCritical: 'complianceCritical',
  financiallySignificant: 'financiallySignificant',
  lifeCritical: 'lifeCritical',
  operational: 'operational',
  patientImpact: 'patientImpact',
} as const;

export type DagcriticalityEnum = (typeof DagcriticalityEnum)[keyof typeof DagcriticalityEnum];
export type DagedgeGql = {
  __typename?: 'DagedgeGQL';
  condition?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Human-readable label for the edge */
  label?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type DagedgeInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

export type DagexecutionResponse = {
  __typename?: 'DagexecutionResponse';
  executionId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  result?: Maybe<DagexecutionResultGql>;
  success: Scalars['Boolean']['output'];
};

export type DagexecutionResultGql = {
  __typename?: 'DagexecutionResultGQL';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedNodes: Scalars['Int']['output'];
  executionId: Scalars['String']['output'];
  failedNodes: Scalars['Int']['output'];
  outputData?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: DagexecutionStatusEnum | '%future added value';
  totalDurationMs?: Maybe<Scalars['Int']['output']>;
  totalNodes: Scalars['Int']['output'];
  workflowId: Scalars['String']['output'];
};

export type DagexecutionStatus = {
  __typename?: 'DagexecutionStatus';
  activeNodes: Array<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedNodes: Scalars['Int']['output'];
  executionId: Scalars['String']['output'];
  failedNodes: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: DagexecutionStatusEnum | '%future added value';
  totalNodes: Scalars['Int']['output'];
};

export const DagexecutionStatusEnum = {
  cancelled: 'cancelled',
  completed: 'completed',
  failed: 'failed',
  paused: 'paused',
  pending: 'pending',
  running: 'running',
} as const;

export type DagexecutionStatusEnum =
  (typeof DagexecutionStatusEnum)[keyof typeof DagexecutionStatusEnum];
export type DagexecutionSummary = {
  __typename?: 'DagexecutionSummary';
  durationMs?: Maybe<Scalars['Int']['output']>;
  executionId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: DagexecutionStatusEnum | '%future added value';
  success: Scalars['Boolean']['output'];
  workflowName: Scalars['String']['output'];
};

export type DagnodeGql = {
  __typename?: 'DagnodeGQL';
  criticality: DagcriticalityEnum | '%future added value';
  /** Depends-on step IDs (for edge generation) */
  dependsOn: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nodeType: DagnodeTypeEnum | '%future added value';
  /** Phase this node belongs to (for phase-grouped layout) */
  phaseId?: Maybe<Scalars['String']['output']>;
  /** Phase display name */
  phaseName?: Maybe<Scalars['String']['output']>;
  /** Phase ordering (0-based) */
  phaseOrder?: Maybe<Scalars['Int']['output']>;
  /** Required role for human nodes */
  requiredRole?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DagnodeStatusEnum | '%future added value'>;
  /** Timeout in milliseconds */
  timeoutMs?: Maybe<Scalars['Int']['output']>;
};

export type DagnodeInput = {
  criticality: DagcriticalityEnum | '%future added value';
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  metadata?: InputMaybe<Array<KeyValueInput>>;
  nodeType: DagnodeTypeEnum | '%future added value';
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
};

export const DagnodeStatusEnum = {
  completed: 'completed',
  failed: 'failed',
  paused: 'paused',
  pending: 'pending',
  requiresHuman: 'requiresHuman',
  running: 'running',
  skipped: 'skipped',
} as const;

export type DagnodeStatusEnum = (typeof DagnodeStatusEnum)[keyof typeof DagnodeStatusEnum];
export type DagnodeTransitionResponse = {
  __typename?: 'DagnodeTransitionResponse';
  executionId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  newStatus: DagnodeStatusEnum | '%future added value';
  nodeId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export const DagnodeTypeEnum = {
  actorDispatch: 'actorDispatch',
  autonomous: 'autonomous',
  condition: 'condition',
  decision: 'decision',
  factSnapshot: 'factSnapshot',
  human: 'human',
  integration: 'integration',
  policyEvaluation: 'policyEvaluation',
  sagaActivation: 'sagaActivation',
  subWorkflow: 'subWorkflow',
  task: 'task',
  validation: 'validation',
} as const;

export type DagnodeTypeEnum = (typeof DagnodeTypeEnum)[keyof typeof DagnodeTypeEnum];
export type DagperformanceMetrics = {
  __typename?: 'DagperformanceMetrics';
  bottleneckNodes: Array<Scalars['String']['output']>;
  complianceScore: Scalars['Float']['output'];
  executionId: Scalars['String']['output'];
  nodesExecuted: Scalars['Int']['output'];
  nodesPerSecond: Scalars['Float']['output'];
  parallelEfficiency: Scalars['Float']['output'];
  totalDurationMs: Scalars['Int']['output'];
};

export type DagscenarioResponse = {
  __typename?: 'DagscenarioResponse';
  message: Scalars['String']['output'];
  result?: Maybe<DagexecutionResultGql>;
  scenarioId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DagstateTransitionResponse = {
  __typename?: 'DagstateTransitionResponse';
  executionId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  newStatus: DagexecutionStatusEnum | '%future added value';
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type DagworkflowGql = {
  __typename?: 'DagworkflowGQL';
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  edges: Array<DagedgeGql>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nodes: Array<DagnodeGql>;
  phases: Array<DagworkflowPhaseGql>;
  safetyLevel?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type DagworkflowInput = {
  edges: Array<DagedgeInput>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  name: Scalars['String']['input'];
  nodes: Array<DagnodeInput>;
  version: Scalars['String']['input'];
};

export type DagworkflowPhaseGql = {
  __typename?: 'DagworkflowPhaseGQL';
  description?: Maybe<Scalars['String']['output']>;
  engine: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  phaseId: Scalars['String']['output'];
};

/** Data classification level */
export const DataClassification = {
  /** Confidential data */
  CONFIDENTIAL: 'CONFIDENTIAL',
  /** Internal use only */
  INTERNAL: 'INTERNAL',
  /** Life-critical data */
  LIFE_CRITICAL: 'LIFE_CRITICAL',
  /** Public data */
  PUBLIC: 'PUBLIC',
  /** Restricted data (PII/PHI) */
  RESTRICTED: 'RESTRICTED',
} as const;

export type DataClassification = (typeof DataClassification)[keyof typeof DataClassification];
/** Data source for select/dropdown fields */
export type DataSource = {
  __typename?: 'DataSource';
  graphqlQuery?: Maybe<Scalars['String']['output']>;
  parameterName?: Maybe<Scalars['String']['output']>;
  /** Source type (static, parameter, graphql) */
  sourceType: Scalars['String']['output'];
  staticOptions?: Maybe<Array<ChaosSelectOption>>;
};

/** Data source input */
export type DataSourceInput = {
  graphqlQuery?: InputMaybe<Scalars['String']['input']>;
  parameterName?: InputMaybe<Scalars['String']['input']>;
  staticOptions?: InputMaybe<Array<WorkflowSelectOptionInput>>;
  type: Scalars['String']['input'];
};

/**
 * Shared date range input for filtering by date/time period.
 *
 * **Used By:**
 * - audit_api: Filtering audit trail records
 * - validation_api: Date constraint validation
 * - constraint_api: Time-bound constraints
 * - role_api: Role validity periods
 * - schedule_api: Scheduling windows
 */
export type DateRangeInput = {
  /** End of the date range (exclusive, optional for open-ended ranges) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start of the date range (inclusive) */
  startDate: Scalars['DateTime']['input'];
};

/** Input for deactivating a Patient (Patient.active = false) */
export type DeactivatePatientInput = {
  /** Patient ID to deactivate */
  id: Scalars['String']['input'];
  /** Reason for deactivation (required for audit trail) */
  reason: Scalars['String']['input'];
};

export type DeadlineInput = {
  daysUntil: Scalars['Int']['input'];
  deadlineType: Scalars['String']['input'];
  rulesetId: Scalars['String']['input'];
};

export type DecisionInput = {
  decision: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionModelJson = {
  __typename?: 'DecisionModelJson';
  active: Scalars['Boolean']['output'];
  modelJson: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Decision Type (GraphQL enum) */
export const DecisionType = {
  APPROVED: 'APPROVED',
  APPROVED_WITH_SUGGESTIONS: 'APPROVED_WITH_SUGGESTIONS',
  REJECTED: 'REJECTED',
  REVISION_REQUESTED: 'REVISION_REQUESTED',
} as const;

export type DecisionType = (typeof DecisionType)[keyof typeof DecisionType];
export type DeclineCeremonyInput = {
  ceremonyId: Scalars['String']['input'];
  participantIndex: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Result of decoding a scope-encoded filename. */
export type DecodedFilename = {
  __typename?: 'DecodedFilename';
  /** Resolved config type name (e.g., "workflow") */
  configType?: Maybe<Scalars['String']['output']>;
  /** Error message if decoding failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Original filename input */
  filename: Scalars['String']['output'];
  /** Filename prefix (e.g., "wf") */
  prefix?: Maybe<Scalars['String']['output']>;
  /** Decoded dimension segments */
  segments: Array<DecodedFilenameSegment>;
  /** Config type symbol (e.g., "A") */
  symbol?: Maybe<Scalars['String']['output']>;
  /** Whether decoding succeeded */
  valid: Scalars['Boolean']['output'];
};

/** A decoded segment of a scope-encoded filename. */
export type DecodedFilenameSegment = {
  __typename?: 'DecodedFilenameSegment';
  /** Decoded human-readable value (e.g., "erp", "doc") */
  decodedValue?: Maybe<Scalars['String']['output']>;
  /** Dimension name (e.g., "subgraph", "category") */
  dimension: Scalars['String']['output'];
  /** Raw code from filename (e.g., "2", "0") */
  rawCode: Scalars['String']['output'];
};

/** Input for decompressing a compressed ID */
export type DecompressIdInput = {
  /** Compressed ID to decompress */
  compressedId: Scalars['String']['input'];
};

/** Result of decompressing a compressed ID */
export type DecompressIdResult = {
  __typename?: 'DecompressIdResult';
  /** Original compressed ID */
  compressedId: Scalars['String']['output'];
  /** Counters for each primitive */
  counters: Array<Scalars['Int']['output']>;
  /** Timestamp when decompressed */
  decompressedAt: Scalars['DateTime']['output'];
  /** Primitive types present */
  primitiveTypes: Array<PrimitiveType | '%future added value'>;
  /** Decompressed Snowflake ID */
  snowflakeId: Scalars['String']['output'];
};

/** Decompression error */
export type DecompressionError = {
  __typename?: 'DecompressionError';
  /** Compressed ID that failed */
  compressedId: Scalars['String']['output'];
  /** Error message */
  error: Scalars['String']['output'];
  /** Error code (for frontend handling) */
  errorCode: Scalars['String']['output'];
};

export type DecryptDocumentInput = {
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type DecryptDocumentResult = {
  __typename?: 'DecryptDocumentResult';
  decryptedS3Key?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Summary of most-cited deficiencies from this survey form. */
export type DeficiencySummary = {
  __typename?: 'DeficiencySummary';
  /** Data source for deficiency statistics */
  dataSource?: Maybe<Scalars['String']['output']>;
  /** Most commonly cited checkpoints */
  mostCited: Array<CitedCheckpoint>;
};

/** Definition list item */
export type DefinitionListItem = {
  __typename?: 'DefinitionListItem';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for deleting a draft */
export type DeleteDraftInput = {
  key: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Input for deleting many drafts */
export type DeleteDraftManyInput = {
  keys: Array<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Delete Tenant Branding Input */
export type DeleteTenantBrandingInput = {
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/**
 * Department configuration for organizational structure
 * LIFE-CRITICAL: Safety escalation hierarchy
 */
export type DepartmentConfigurationGql = {
  __typename?: 'DepartmentConfigurationGql';
  departments: Array<DepartmentGql>;
  organizationalStructure: OrganizationalStructureGql;
};

/** Department information */
export type DepartmentGql = {
  __typename?: 'DepartmentGql';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentDepartment?: Maybe<Scalars['String']['output']>;
};

/** GraphQL output type for Dependency primitive. */
export type Dependency = {
  __typename?: 'Dependency';
  /** Active flag */
  active: Scalars['Boolean']['output'];
  /** Approval level required for bypass */
  bypassApprovalRequired?: Maybe<Scalars['String']['output']>;
  /** Bypass reason (if bypassed) */
  bypassReason?: Maybe<Scalars['String']['output']>;
  /** Can this dependency be bypassed? */
  canBypass: Scalars['Boolean']['output'];
  /** Compressed ID format (lazy-loaded from cache/DynamoDB) */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Condition expression (JSON) */
  condition?: Maybe<Scalars['JSON']['output']>;
  /** Created timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Created by actor ID */
  createdBy: Scalars['String']['output'];
  /** Which formulas' critical paths include this dependency */
  criticalPathFormulas: Array<Scalars['String']['output']>;
  /** Extended dependency metadata (JSON) */
  dependencyMetadata?: Maybe<Scalars['JSON']['output']>;
  /** Dependency type (FS, SS, FF, SF) */
  dependencyType: GqlDependencyType | '%future added value';
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Total evaluation count */
  evaluationCount: Scalars['Int']['output'];
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Whether this is the active version */
  isActive: Scalars['Boolean']['output'];
  /** Has conditional logic */
  isConditional: Scalars['Boolean']['output'];
  /** Is this dependency on the critical path? */
  isCriticalPath: Scalars['Boolean']['output'];
  /** Lag configuration (JSON) */
  lagConfiguration?: Maybe<Scalars['JSON']['output']>;
  /** When dependency was last evaluated */
  lastEvaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Extensible JSON metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Dependency name */
  name: Scalars['String']['output'];
  /** Original root ID (append-only chain) */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Parent version ID (append-only chain) */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Record version (append-only) */
  recordVersion: Scalars['Int']['output'];
  /** Satisfaction criteria (JSON) */
  satisfactionCriteria?: Maybe<Scalars['JSON']['output']>;
  /** Current runtime status */
  status: GqlDependencyStatus | '%future added value';
  /** Which formulas this dependency enables */
  targetFormulas: Array<Scalars['String']['output']>;
  /** Last updated timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Last updated by actor ID */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Audit version */
  version: Scalars['Int']['output'];
};

/**
 * Dependency Archive Result (FERP Append-Only Architecture)
 *
 * Returned by `archiveDependency` mutation. Contains full audit metadata
 * for compliance (HIPAA, SOX, SOC2).
 *
 * FERP Principle: No DELETE operations - use archive instead.
 */
export type DependencyArchiveResult = {
  __typename?: 'DependencyArchiveResult';
  /** Timestamp when the dependency was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** User ID who performed the archive */
  archivedBy: Scalars['String']['output'];
  /** Dependency ID that was archived */
  dependencyId: Scalars['String']['output'];
  /** Dependency name that was archived */
  dependencyName: Scalars['String']['output'];
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Mandatory reason for archiving (audit compliance) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** A single dependency check result */
export type DependencyCheck = {
  __typename?: 'DependencyCheck';
  /** Type of dependency */
  dependencyType: DependencyType | '%future added value';
  /** Error message if check failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether config exists in YAML files */
  existsInYaml: Scalars['Boolean']['output'];
  /** Whether action handler is implemented (for SubgraphAction) */
  handlerImplemented: Scalars['Boolean']['output'];
  /** Reference ID (e.g., "tg-4-1-001") */
  refId: Scalars['String']['output'];
  /** Whether config is seeded to DDB */
  seededToDdb: Scalars['Boolean']['output'];
};

/** Paginated dependency results. */
export type DependencyConnection = {
  __typename?: 'DependencyConnection';
  /** Has more results */
  hasMore: Scalars['Boolean']['output'];
  /** List of dependencies */
  items: Array<Dependency>;
  /** Next page cursor */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Dependency types that a workflow can reference */
export const DependencyType = {
  /** Constellation reference */
  CONSTELLATION: 'CONSTELLATION',
  /** Enrichment pipeline source */
  ENRICHMENT: 'ENRICHMENT',
  /** Form schema reference (fs-*) */
  FORM_SCHEMA: 'FORM_SCHEMA',
  /** Policy/RuleSet reference (rs-*) */
  POLICY_REF: 'POLICY_REF',
  /** Role reference (role-*) */
  ROLE: 'ROLE',
  /** Subgraph action handler */
  SUBGRAPH_ACTION: 'SUBGRAPH_ACTION',
  /** Task group reference (tg-*) */
  TASK_GROUP: 'TASK_GROUP',
} as const;

export type DependencyType = (typeof DependencyType)[keyof typeof DependencyType];
export const DeploymentStatus = {
  failed: 'failed',
  inProgress: 'inProgress',
  rolledBack: 'rolledBack',
  success: 'success',
} as const;

export type DeploymentStatus = (typeof DeploymentStatus)[keyof typeof DeploymentStatus];
/** Input for depositing funds */
export type DepositFundsInput = {
  actorId: Scalars['String']['input'];
  amountCents: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

export const DeviceTypeGql = {
  DESKTOP: 'DESKTOP',
  KIOSK: 'KIOSK',
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
} as const;

export type DeviceTypeGql = (typeof DeviceTypeGql)[keyof typeof DeviceTypeGql];
/** Diff result */
export type DiffResult = {
  __typename?: 'DiffResult';
  added: Scalars['Int']['output'];
  diff: Scalars['JSON']['output'];
  modified: Scalars['Int']['output'];
  removed: Scalars['Int']['output'];
};

/** 5W1H dimension check result */
export type DimensionCheck = {
  __typename?: 'DimensionCheck';
  /** Dimension name (WHO, WHAT, WHY, WHERE, WHEN, HOW) */
  dimension: Scalars['String']['output'];
  /** Missing field if not resolvable */
  missingField?: Maybe<Scalars['String']['output']>;
  /** Resolution path (e.g., "constellation.center.location") */
  resolutionPath?: Maybe<Scalars['String']['output']>;
  /** Whether dimension is resolvable */
  resolvable: Scalars['Boolean']['output'];
};

/** Input for dismissing alert */
export type DismissAlertInput = {
  fieldId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Dispense request details for a prescription */
export type DispenseRequest = {
  __typename?: 'DispenseRequest';
  /** Expected supply duration in days */
  expectedSupplyDays?: Maybe<Scalars['Float']['output']>;
  /** Number of refills allowed */
  numberOfRepeatsAllowed?: Maybe<Scalars['Int']['output']>;
  /** Quantity to dispense per fill */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Quantity unit */
  quantityUnit?: Maybe<Scalars['String']['output']>;
  /** Validity period end */
  validityEnd?: Maybe<Scalars['String']['output']>;
  /** Validity period start */
  validityStart?: Maybe<Scalars['String']['output']>;
};

/**
 * Document primitive - document management with versioning and approval
 *
 * Manages documents including workflow definitions, policy documents,
 * compliance evidence, and Chaos-to-DSL generated templates.
 */
export type Document = {
  __typename?: 'Document';
  accessLevel: AccessLevel | '%future added value';
  approvalProgressJson: Scalars['JSON']['output'];
  category: Scalars['String']['output'];
  complianceFrameworks: Array<Scalars['String']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this document.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this document */
  createdByActor?: Maybe<ActorSummary>;
  /** How this document was created */
  createdBySource: DocumentCreatedBySource | '%future added value';
  currentStatus: DocumentStatus | '%future added value';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  documentName: Scalars['String']['output'];
  documentType: DocumentType | '%future added value';
  dynamodbContent?: Maybe<Scalars['String']['output']>;
  encoding?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  extractionConfidence?: Maybe<Scalars['Float']['output']>;
  extractionEvidence: Array<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileSizeBytes: Scalars['String']['output'];
  /** DRR-133: True when this document was generated using an offline-resolved PDF template. */
  generatedOffline: Scalars['Boolean']['output'];
  /** Active/archived flag (preserves audit trail) */
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isLatest: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  /** Original document ID (stable across all versions) */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Parent document ID (for modification history) */
  parentVersionId?: Maybe<Scalars['String']['output']>;
  previousVersionId?: Maybe<Scalars['String']['output']>;
  /** Record version number (increments with modifications) */
  recordVersion: Scalars['Int']['output'];
  regulatoryDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Evidence requirement name being satisfied (matches rule.structured.evidence[].name) */
  regulatoryEvidenceName?: Maybe<Scalars['String']['output']>;
  /** IDs of regulatory rules this document serves as evidence for */
  regulatoryRuleIds: Array<Scalars['String']['output']>;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  sourceChaosDocumentId?: Maybe<Scalars['String']['output']>;
  statusUpdatedAt: Scalars['DateTime']['output'];
  /** WHO updated the status */
  statusUpdatedByActor?: Maybe<ActorSummary>;
  storageType: StorageType | '%future added value';
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** WHO last updated this document */
  updatedByActor?: Maybe<ActorSummary>;
  validationResultsJson: Scalars['JSON']['output'];
  version: Scalars['String']['output'];
  versionChangeDescription?: Maybe<Scalars['String']['output']>;
  versionCreatedAt: Scalars['DateTime']['output'];
  /** WHO created this version */
  versionCreatedByActor?: Maybe<ActorSummary>;
  versionHistoryIds: Array<Scalars['String']['output']>;
};

/**
 * Document Archive Result (FERP Append-Only Architecture)
 *
 * Returned by `archiveDocumentWithReason` mutation. Contains full audit metadata
 * for compliance (HIPAA, SOX, SOC2).
 *
 * FERP Principle: No DELETE operations - use archive instead.
 */
export type DocumentArchiveResult = {
  __typename?: 'DocumentArchiveResult';
  /** Timestamp when the document was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** User ID who performed the archive */
  archivedBy: Scalars['String']['output'];
  /** Document ID that was archived */
  documentId: Scalars['String']['output'];
  /** Document title that was archived */
  documentTitle: Scalars['String']['output'];
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Mandatory reason for archiving (audit compliance) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Paginated connection for documents */
export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Document>;
  totalCount: Scalars['Int']['output'];
};

/** Document creation source (matches backend DocumentCreatedBySource) */
export const DocumentCreatedBySource = {
  /** Zen Engine rule `create_document` action */
  RULE_ENGINE: 'RULE_ENGINE',
  /** Tenant mutation via `createDocument` API */
  TENANT_DECISION: 'TENANT_DECISION',
  /** Workflow `SpawnDocumentsFromTemplates` on self-loop state */
  WORKFLOW_OPERATION: 'WORKFLOW_OPERATION',
} as const;

export type DocumentCreatedBySource =
  (typeof DocumentCreatedBySource)[keyof typeof DocumentCreatedBySource];
/** Result of requesting a pre-signed download URL */
export type DocumentDownloadUrlResult = {
  __typename?: 'DocumentDownloadUrlResult';
  /** Document name (for display) */
  documentName: Scalars['String']['output'];
  /** Pre-signed S3 GetObject URL (expires in 60 minutes) */
  downloadUrl: Scalars['String']['output'];
  /** URL expiration in seconds */
  expiresInSeconds: Scalars['Int']['output'];
  /** MIME type of the document */
  mimeType: Scalars['String']['output'];
};

/** Filter input for listing documents */
export type DocumentFilterInput = {
  /** Filter by document type */
  documentType?: InputMaybe<GqlGeneratedDocumentType | '%future added value'>;
  /** Filter by status */
  status?: InputMaybe<GqlGeneratedDocumentStatus | '%future added value'>;
  /** Filter by tax year */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Document lifecycle status - matches backend DocumentStatus */
export const DocumentStatus = {
  /** Approved by all required approvers */
  APPROVED: 'APPROVED',
  /** Archived (removed from active use) */
  ARCHIVED: 'ARCHIVED',
  /** Initial state */
  DRAFT: 'DRAFT',
  /** Awaiting approval */
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  /** Awaiting validation check */
  PENDING_VALIDATION: 'PENDING_VALIDATION',
  /** Final state (approved + published) */
  PUBLISHED: 'PUBLISHED',
  /** Rejected by any approver */
  REJECTED: 'REJECTED',
} as const;

export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus];
/** Document type classification (matches backend DocumentType) */
export const DocumentType = {
  /** Attachment file */
  ATTACHMENT: 'ATTACHMENT',
  /** Audit document */
  AUDIT: 'AUDIT',
  /** Contract document */
  CONTRACT: 'CONTRACT',
  /** Evidence artifact from chaos-to-DSL */
  EVIDENCE: 'EVIDENCE',
  /** Binary file (PDF, DOCX, image, etc.) */
  FILE: 'FILE',
  /** Form document */
  FORM: 'FORM',
  /** Policy document */
  POLICY: 'POLICY',
  /** Procedure document */
  PROCEDURE: 'PROCEDURE',
  /** Structured data record (database row) */
  RECORD: 'RECORD',
  /** Generated report (analytics, compliance) */
  REPORT: 'REPORT',
  /** JSON/CSV data (not a file) */
  STRUCTURED_DATA: 'STRUCTURED_DATA',
  /** Template document */
  TEMPLATE: 'TEMPLATE',
} as const;

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];
/** Result of generating a pre-signed upload URL */
export type DocumentUploadUrlResult = {
  __typename?: 'DocumentUploadUrlResult';
  /** Enforced Content-Type (client MUST use this in the PUT request) */
  contentType: Scalars['String']['output'];
  /** URL expiration in seconds */
  expiresInSeconds: Scalars['Int']['output'];
  /** S3 bucket name */
  s3Bucket: Scalars['String']['output'];
  /** S3 key where the document will be stored */
  s3Key: Scalars['String']['output'];
  /** Pre-signed S3 PutObject URL (expires in 15 minutes) */
  uploadUrl: Scalars['String']['output'];
};

/** Document version info */
export type DocumentVersionInfo = {
  __typename?: 'DocumentVersionInfo';
  changeDescription: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  isLatest: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type DomainMetadataConnection = {
  __typename?: 'DomainMetadataConnection';
  edges: Array<DomainMetadataGql>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DomainMetadataGql = {
  __typename?: 'DomainMetadataGql';
  access: AccessLevelGql | '%future added value';
  certification?: Maybe<CertificationGql>;
  complianceLevel: ComplianceLevelGql | '%future added value';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  domainType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  immutable: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  version: Scalars['String']['output'];
};

/** * Domain-specific metric (tenant-configured) */
export type DomainMetricOutput = {
  __typename?: 'DomainMetricOutput';
  /** Domain identifier (e.g., "healthcare", "financial", "legal") */
  domain: Scalars['String']['output'];
  /** Human-readable metric name */
  name: Scalars['String']['output'];
  /** Metric status relative to target */
  status: MetricStatusOutput | '%future added value';
  /** Target metric value (0.0-100.0) */
  target: Scalars['Float']['output'];
  /** Trend delta from previous period */
  trend: Scalars['Float']['output'];
  /** Current metric value (0.0-100.0) */
  value: Scalars['Float']['output'];
};

export type DraftChangeEvent = {
  __typename?: 'DraftChangeEvent';
  action: Scalars['String']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

/** Draft list item */
export type DraftListItem = {
  __typename?: 'DraftListItem';
  data?: Maybe<Scalars['JSON']['output']>;
  deleted: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  updatedMs: Scalars['Int']['output'];
};

/** Draft metadata */
export type DraftMetadata = {
  __typename?: 'DraftMetadata';
  /** Auto-save enabled */
  autoSave: Scalars['Boolean']['output'];
  /** When draft was created */
  createdAt: Scalars['String']['output'];
  /** Who created the draft */
  createdBy: Scalars['String']['output'];
  /** Session ID for real-time sync */
  sessionId?: Maybe<Scalars['String']['output']>;
  /** Draft status */
  status: DraftStatus | '%future added value';
  /** When draft was last modified */
  updatedAt: Scalars['String']['output'];
};

/** Response for draft operations */
export type DraftOperationResponse = {
  __typename?: 'DraftOperationResponse';
  /** Definition representation of current state */
  currentDefinition: Scalars['String']['output'];
  /** Updated draft */
  draft: WorkflowDraft;
  /** Success message */
  message: Scalars['String']['output'];
};

/** Draft result */
export type DraftResult = {
  __typename?: 'DraftResult';
  draft: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
};

/** Draft status */
export const DraftStatus = {
  /** Draft is being actively edited */
  ACTIVE: 'ACTIVE',
  /** Draft has been approved */
  APPROVED: 'APPROVED',
  /** Draft has been discarded */
  DISCARDED: 'DISCARDED',
  /** Draft is paused (can be resumed) */
  PAUSED: 'PAUSED',
  /** Draft is ready for review */
  PENDING_REVIEW: 'PENDING_REVIEW',
  /** Draft has been published */
  PUBLISHED: 'PUBLISHED',
  /** Draft has been rejected */
  REJECTED: 'REJECTED',
} as const;

export type DraftStatus = (typeof DraftStatus)[keyof typeof DraftStatus];
/** Draft summary for listing */
export type DraftSummary = {
  __typename?: 'DraftSummary';
  createdAt: Scalars['String']['output'];
  draftId: Scalars['String']['output'];
  editCount: Scalars['Int']['output'];
  status: DraftStatus | '%future added value';
  updatedAt: Scalars['String']['output'];
  workflowName: Scalars['String']['output'];
};

/** Drift alert for GraphQL */
export type DriftAlertGql = {
  __typename?: 'DriftAlertGql';
  assessedLabel: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  consistentDays: Scalars['Int']['output'];
  driftSeverity: DriftSeverityGql | '%future added value';
  fieldId: Scalars['String']['output'];
  fieldLabel: Scalars['String']['output'];
  observedLabel: Scalars['String']['output'];
};

/** Drift direction for GraphQL */
export const DriftDirectionGql = {
  DECREASED: 'DECREASED',
  INCREASED: 'INCREASED',
  STABLE: 'STABLE',
} as const;

export type DriftDirectionGql = (typeof DriftDirectionGql)[keyof typeof DriftDirectionGql];
/** Drift severity for GraphQL */
export const DriftSeverityGql = {
  MAJOR: 'MAJOR',
  MINOR: 'MINOR',
  NONE: 'NONE',
} as const;

export type DriftSeverityGql = (typeof DriftSeverityGql)[keyof typeof DriftSeverityGql];
/** Input for dry run guard */
export type DryRunGuardInput = {
  guardExpression?: InputMaybe<Scalars['String']['input']>;
  instanceData: Scalars['JSON']['input'];
  signalData: Scalars['JSON']['input'];
  tenant: Scalars['String']['input'];
};

/** Dry run guard result */
export type DryRunGuardResult = {
  __typename?: 'DryRunGuardResult';
  allow: Scalars['Boolean']['output'];
  matchedRuleIndex?: Maybe<Scalars['Int']['output']>;
  modelVersion?: Maybe<Scalars['String']['output']>;
};

/** Dry Run Policy Input */
export type DryRunPolicyInput = {
  /** Policy ID */
  policyId: Scalars['String']['input'];
  /** Tenant ID (for validation) */
  tenantId: Scalars['String']['input'];
  /** Test data (JSON object) */
  testData: Scalars['JSON']['input'];
};

/** Dry Run Result Output */
export type DryRunResult = {
  __typename?: 'DryRunResult';
  /** Actions that would execute */
  actionsToExecute: Array<PolicyAction>;
  /** Condition evaluations */
  conditionsEvaluated: Array<ConditionEvaluation>;
  /** Did conditions match? */
  matched: Scalars['Boolean']['output'];
  /** Policy ID */
  policyId: Scalars['String']['output'];
  /** Zen DSL generated (for debugging) */
  zenDsl: Scalars['String']['output'];
};

/** DSL availability check result */
export type DslAvailability = {
  __typename?: 'DslAvailability';
  /** Whether DSL compiler is available */
  available: Scalars['Boolean']['output'];
  /** Feature flag name */
  feature: Scalars['String']['output'];
  /** Message explaining availability */
  message: Scalars['String']['output'];
};

/** Result of DSL compilation */
export type DslCompilationResult = {
  __typename?: 'DslCompilationResult';
  /** Parsed AST as JSON (for debugging) */
  ast?: Maybe<Scalars['String']['output']>;
  /** Compilation errors */
  errors: Array<GqlCompileError>;
  /** Extracted input fields */
  inputFields: Array<Scalars['String']['output']>;
  /** Compiled JDM JSON (null if failed) */
  jdm?: Maybe<Scalars['String']['output']>;
  /** Number of rules parsed */
  ruleCount: Scalars['Int']['output'];
  /** Whether compilation succeeded */
  success: Scalars['Boolean']['output'];
};

/** DSL syntax help and examples */
export type DslSyntaxHelp = {
  __typename?: 'DslSyntaxHelp';
  /** Built-in actions */
  builtinActions: Array<Scalars['String']['output']>;
  /** Built-in fields */
  builtinFields: Array<Scalars['String']['output']>;
  /** Example rules */
  examples: Array<GqlDslExample>;
  /** Supported operators */
  operators: Array<GqlOperatorInfo>;
  /** Full syntax reference */
  syntaxReference: Scalars['String']['output'];
  /** DSL version */
  version: Scalars['String']['output'];
};

/** Result of DSL validation */
export type DslValidationResult = {
  __typename?: 'DslValidationResult';
  /** Validation errors */
  errors: Array<GqlCompileError>;
  /** Number of rules found */
  ruleCount: Scalars['Int']['output'];
  /** Parsed rules summary (names and actions) */
  rulesSummary: Array<GqlRuleSummary>;
  /** Whether validation passed */
  valid: Scalars['Boolean']['output'];
  /** Validation warnings */
  warnings: Array<Scalars['String']['output']>;
};

export type DualControl = {
  __typename?: 'DualControl';
  required: Scalars['Boolean']['output'];
  roles: Array<Scalars['String']['output']>;
};

/** Dual control approval input for entered-in-error operations */
export type DualControlApprovalInput = {
  /** Approver user ID */
  approverId: Scalars['String']['input'];
  /** Approver role (e.g., "physician", "supervisor") */
  approverRole: Scalars['String']['input'];
  /** Optional comment/justification */
  comment?: InputMaybe<Scalars['String']['input']>;
};

/** Edge metadata */
export type EdgeMetadata = {
  __typename?: 'EdgeMetadata';
  comment?: Maybe<Scalars['String']['output']>;
};

/** Result of saving or submitting an EDI claim. */
export type EdiClaimResult = {
  __typename?: 'EdiClaimResult';
  /** Timestamp of the operation */
  createdAt: Scalars['String']['output'];
  /** Human-readable status message */
  message: Scalars['String']['output'];
  /** Current status: "CREATED" (draft) or "ACTIVE" (submitted/in-progress) */
  status: Scalars['String']['output'];
  /** Transaction ID (use to poll status or resume draft) */
  transactionId: Scalars['String']['output'];
};

/** Input for the editFormSchema mutation. */
export type EditFormSchemaInput = {
  entityType?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  sessionMessages?: InputMaybe<Scalars['JSON']['input']>;
  subgraph?: Scalars['String']['input'];
};

/** GraphQL output type for effective permissions. */
export type EffectivePermissions = {
  __typename?: 'EffectivePermissions';
  /** All effective permissions (merged) */
  effectivePermissions: Array<Permission>;
  /** Inherited permissions */
  inheritedPermissions: Array<Permission>;
  /** Own permissions */
  ownPermissions: Array<Permission>;
  /** Role ID */
  roleId: Scalars['String']['output'];
  /** Total permission count */
  totalCount: Scalars['Int']['output'];
};

/** Effective Role Output (with inheritance computed) */
export type EffectiveRole = {
  __typename?: 'EffectiveRole';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Effective capabilities (including inherited) */
  effectiveCapabilities: Array<Scalars['String']['output']>;
  /** Effective scopes (including inherited) */
  effectiveScopes: Array<Scalars['String']['output']>;
  /** Inheritance chain (from root to leaf) */
  inheritanceChain: Array<Scalars['String']['output']>;
  /** Role ID */
  roleId: Scalars['String']['output'];
  /** Role name */
  roleName: Scalars['String']['output'];
};

/** Eligibility configuration for a program */
export type EligibilityConfig = {
  __typename?: 'EligibilityConfig';
  developmentalDisability?: Maybe<Scalars['String']['output']>;
  financialEligibility?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  nursingFacilityLevel?: Maybe<Scalars['String']['output']>;
};

/**
 * An elopement alert — triggered when a subject beacon crosses a boundary.
 *
 * DRR-100: Life-critical safety alert.
 * Key: `PK=~{tenant_num}, SK=ALERT#ELOP#{timestamp}`
 */
export type ElopementAlert = {
  __typename?: 'ElopementAlert';
  /** Whether the alert has been acknowledged */
  acknowledged: Scalars['Boolean']['output'];
  /** ISO 8601 timestamp of acknowledgement */
  acknowledgedAt?: Maybe<Scalars['String']['output']>;
  /** Actor ID who acknowledged the alert */
  acknowledgedBy?: Maybe<Scalars['String']['output']>;
  /** Alert identifier */
  alertId: Scalars['String']['output'];
  /** Beacon ID that triggered the alert */
  beaconId: Scalars['String']['output'];
  /** ISO 8601 timestamp of alert creation */
  createdAt: Scalars['String']['output'];
  /** Last known safe zone before alert */
  lastSafeZoneId?: Maybe<Scalars['String']['output']>;
  /** Alert severity */
  severity: ElopementSeverity | '%future added value';
  /** Subject actor ID */
  subjectActorId: Scalars['String']['output'];
  /** Tenant number */
  tenantNum: Scalars['Int']['output'];
  /** Zone where the alert was triggered */
  triggerZoneId: Scalars['String']['output'];
};

/** Elopement alert severity. */
export const ElopementSeverity = {
  /** Resident crossed boundary (parking, exit) */
  CRITICAL: 'CRITICAL',
  /** Resident missing from all zones > threshold */
  EMERGENCY: 'EMERGENCY',
  /** Resident near boundary (garden, outdoor) */
  WARNING: 'WARNING',
} as const;

export type ElopementSeverity = (typeof ElopementSeverity)[keyof typeof ElopementSeverity];
/** Emergency Access Event - Audit Trail for Life-Critical Access */
export type EmergencyAccessEvent = {
  __typename?: 'EmergencyAccessEvent';
  /** Access timestamp */
  accessedAt: Scalars['String']['output'];
  /** Duration of access in minutes */
  duration: Scalars['Int']['output'];
  /** Event unique identifier */
  eventId: Scalars['String']['output'];
  /** Reason for emergency access */
  reason: Scalars['String']['output'];
  /** Systems accessed during emergency */
  systemsAccessed: Array<Scalars['String']['output']>;
};

/** Emergency Access Request Input (GraphQL input) */
export type EmergencyAccessInput = {
  /** Duration in hours (validated against tenant's emergency access policy) */
  durationHours: Scalars['Int']['input'];
  /** Justification (validation rules from tenant's emergency access policy) */
  justification: Scalars['String']['input'];
  /** Emergency scenario (String - validated against tenant's emergency access policy) */
  scenario: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** User requesting access */
  userId: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

/** Emergency Access Token (GraphQL output) */
export type EmergencyAccessToken = {
  __typename?: 'EmergencyAccessToken';
  /** Access token (time-limited) */
  accessToken: Scalars['String']['output'];
  /** Audit trail ID */
  auditTrailId: Scalars['String']['output'];
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Duration in hours */
  durationHours: Scalars['Int']['output'];
  /** Expiration timestamp */
  expiresAt: Scalars['DateTime']['output'];
  /** Incident ID (for revocation and audit) */
  incidentId: Scalars['String']['output'];
  /** Justification provided */
  justification: Scalars['String']['output'];
  /** Emergency scenario */
  scenario: Scalars['String']['output'];
  /** Security team notification status */
  securityNotificationSent: Scalars['Boolean']['output'];
  /** Tenant context */
  tenantId: Scalars['String']['output'];
  /** User who requested access */
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type EmergencyActionResult = {
  __typename?: 'EmergencyActionResult';
  actionId: Scalars['String']['output'];
  actionType: EmergencyActionType | '%future added value';
  affectedComponents: Array<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  initiatedAt: Scalars['DateTime']['output'];
  initiatedBy: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  resultMessage?: Maybe<Scalars['String']['output']>;
  status: EmergencyActionStatus | '%future added value';
};

export const EmergencyActionStatus = {
  cancelled: 'cancelled',
  completed: 'completed',
  failed: 'failed',
  inProgress: 'inProgress',
  initiated: 'initiated',
} as const;

export type EmergencyActionStatus =
  (typeof EmergencyActionStatus)[keyof typeof EmergencyActionStatus];
export const EmergencyActionType = {
  /** Clear all caches */
  clearCaches: 'clearCaches',
  /** Disable new workflow creation */
  disableWorkflows: 'disableWorkflows',
  /** Emergency stop (immediate) */
  emergencyStop: 'emergencyStop',
  /** Force garbage collection */
  forceGC: 'forceGC',
  /** Graceful shutdown of all services */
  gracefulShutdown: 'gracefulShutdown',
  /** Enable maintenance mode */
  maintenanceMode: 'maintenanceMode',
  /** Enable read-only mode */
  readOnlyMode: 'readOnlyMode',
  /** Reset rate limits */
  resetRateLimits: 'resetRateLimits',
} as const;

export type EmergencyActionType = (typeof EmergencyActionType)[keyof typeof EmergencyActionType];
export type EmergencyControlInput = {
  /** Type of emergency action */
  actionType: EmergencyActionType | '%future added value';
  /** Duration in minutes (for temporary actions) */
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Reason for emergency action */
  reason: Scalars['String']['input'];
  /** Target components (empty = all) */
  targetComponents?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Emergency override input */
export type EmergencyOverrideInput = {
  approvedBy?: InputMaybe<Scalars['String']['input']>;
  expectedDurationHours: Scalars['Int']['input'];
  frameworkId: Scalars['String']['input'];
  justification: Scalars['String']['input'];
  numericValue: Scalars['Float']['input'];
  tenant: Scalars['String']['input'];
  thresholdType: Scalars['String']['input'];
};

/**
 * Employee federation entity - **projection of Actor primitive (actor_type = HUMAN)**
 *
 * This is NOT a separate type - it's a view of the Actor primitive optimized for federation.
 * The underlying data comes from ActorRepository where actor_type = ActorType::Human.
 * Subgraphs like Payroll extend this entity with additional fields.
 *
 * # FERP Architecture Mapping
 *
 * | Employee Field | Actor Field | Notes |
 * |----------------|-------------|-------|
 * | id | id | Snowflake ID |
 * | tenantId | tenant_id | Multi-tenant isolation |
 * | name | name | Display name |
 * | status | status | ActorStatus enum as string |
 * | email | email | Contact email |
 * | teamId | team_id | Optional team reference |
 * | role | role | Primary role |
 * | capabilities | capabilities | What actor can do |
 *
 * # Federation Key
 * `@key(fields: "id")` - resolved by ID lookup via FederationEntityQuery
 *
 * # Example Extension (in payroll subgraph)
 * ```graphql
 * extend type Employee @key(fields: "id") {
 * id: ID! @external
 * payrollHistory: [PayrollRun!]!
 * currentYtd: EmployeeYtdSummary
 * }
 * ```
 */
export type Employee = {
  __typename?: 'Employee';
  /** Capabilities - maps to Actor.capabilities */
  capabilities: Array<Scalars['String']['output']>;
  /** Email address - maps to Actor.email (from contact fields) */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier (federation @key) - maps to Actor.id (Snowflake ID) */
  id: Scalars['ID']['output'];
  /** Employee name - maps to Actor.name */
  name: Scalars['String']['output'];
  /** Primary role - maps to Actor.role */
  role?: Maybe<Scalars['String']['output']>;
  /** Employee status - maps to Actor.status (ActorStatus enum as string) */
  status: Scalars['String']['output'];
  /** Department/team ID - maps to Actor.team_id */
  teamId?: Maybe<Scalars['String']['output']>;
  /** Tenant this employee belongs to - maps to Actor.tenant_id */
  tenantId: Scalars['ID']['output'];
};

/** Encounter connection */
export type EncounterConnection = {
  __typename?: 'EncounterConnection';
  edges: Array<EncounterEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Federation-aware detail reference for FHIR Encounter */
export type EncounterDetailRef = {
  __typename?: 'EncounterDetailRef';
  /** Encounter ID (federation key) */
  id: Scalars['ID']['output'];
};

/** Encounter edge */
export type EncounterEdge = {
  __typename?: 'EncounterEdge';
  cursor: Scalars['String']['output'];
  node: FhirEncounter;
};

export type EncryptDocumentInput = {
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type EncryptDocumentResult = {
  __typename?: 'EncryptDocumentResult';
  encryptedS3Key?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Enhanced field definition */
export type EnhancedField = {
  __typename?: 'EnhancedField';
  conditional?: Maybe<Scalars['JSON']['output']>;
  dependencies: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldType: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  validation?: Maybe<Scalars['JSON']['output']>;
  widget?: Maybe<Scalars['JSON']['output']>;
};

/** Enhanced form schema with full metadata */
export type EnhancedFormSchema = {
  __typename?: 'EnhancedFormSchema';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<EnhancedField>;
  i18N?: Maybe<Scalars['JSON']['output']>;
  kind: Scalars['String']['output'];
  layout: FormsLayoutOutput;
  name: Scalars['String']['output'];
  performance?: Maybe<PerformanceConfig>;
  submission: SubmissionConfig;
  theme?: Maybe<Scalars['JSON']['output']>;
  validation: FormValidation;
  version: Scalars['String']['output'];
  workflow?: Maybe<WorkflowConfig>;
};

/** Entity category for grouping entity types in the management UI */
export type EntityCategory = {
  __typename?: 'EntityCategory';
  /** Description */
  description: Scalars['String']['output'];
  /** Human-readable display name */
  displayName: Scalars['String']['output'];
  /** Mantine icon name */
  icon: Scalars['String']['output'];
  /** Unique category identifier */
  id: Scalars['String']['output'];
  /** Sort order in UI */
  sortOrder: Scalars['Int']['output'];
};

/** * Input for entityDetails query */
export type EntityDetailsInput = {
  /** Entity unique identifier (Snowflake ID) */
  entityId: Scalars['String']['input'];
  /** Entity type (one of 16 primitives) */
  entityType: EntityType | '%future added value';
  /** Include evidence attribution if AI-generated (default: true) */
  includeEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include primitive composition (default: true) */
  includePrimitives?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include related entities (default: true) */
  includeRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include timeline events (default: true) */
  includeTimeline?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional tenant filter */
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** * Complete entity details response (DOMAIN-AGNOSTIC) */
export type EntityDetailsOutput = {
  __typename?: 'EntityDetailsOutput';
  /** Creation timestamp (Unix milliseconds) */
  createdAt: Scalars['Int']['output'];
  /** Created by user ID */
  createdBy: Scalars['String']['output'];
  /** Entity unique identifier */
  entityId: Scalars['String']['output'];
  /** Entity type from 16 primitives */
  entityType: Scalars['String']['output'];
  /** AI evidence attribution (if AI-generated) */
  evidenceAttribution?: Maybe<EvidenceAttributionOutput>;
  /** Entity-specific metadata (domain-agnostic JSON) */
  metadata: Scalars['JSONObject']['output'];
  /** Human-readable entity name */
  name: Scalars['String']['output'];
  /** Primitive type composition */
  primitiveComposition: Array<PrimitiveInstanceOutput>;
  /** Related entities (relationships) */
  relatedEntities: Array<RelatedEntityOutput>;
  /** Current state or status */
  status: Scalars['String']['output'];
  /** Timeline events for this entity */
  timelineEvents: Array<TimelineEventOutput>;
  /** Last update timestamp (Unix milliseconds) */
  updatedAt: Scalars['Int']['output'];
};

/** Input for filtering entities */
export type EntityFilter = {
  /** Filter by entity type */
  entityType?: InputMaybe<Scalars['String']['input']>;
  maxPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by metadata (JsonLogic expression) */
  metadataFilter?: InputMaybe<Scalars['JSON']['input']>;
  /** Filter by priority range */
  minPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Search in name/description */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by status */
  status?: InputMaybe<EntityStatus | '%future added value'>;
  /** Filter by tags (any of these tags) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** CRUD permissions */
export type EntityPermissions = {
  __typename?: 'EntityPermissions';
  create: Scalars['String']['output'];
  delete: Scalars['String']['output'];
  list: Scalars['String']['output'];
  read: Scalars['String']['output'];
  update: Scalars['String']['output'];
};

/** Entity preset — a named bundle of entity codes for progressive disclosure */
export type EntityPreset = {
  __typename?: 'EntityPreset';
  /** Description */
  description: Scalars['String']['output'];
  /** Human-readable name */
  displayName: Scalars['String']['output'];
  /** Entity codes included (empty = ALL) */
  entityCodes: Array<Scalars['String']['output']>;
  /** Mantine icon name */
  icon: Scalars['String']['output'];
  /** Unique preset identifier */
  id: Scalars['String']['output'];
  /** Industry vertical */
  industry: Scalars['String']['output'];
  /** Whether this is the default preset */
  isDefault: Scalars['Boolean']['output'];
  /** Sort order */
  sortOrder: Scalars['Int']['output'];
};

/** Entity preview result (for hover cards) */
export type EntityPreview = {
  __typename?: 'EntityPreview';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayValue: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isLifeCritical: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Search input */
export type EntitySearchInput = {
  /** Optional constellation ID for explicit scoping (overrides auto-inference) */
  constellationId?: InputMaybe<Scalars['String']['input']>;
  /** Entity type to search (e.g., "Actor", "FhirPatient") */
  entityType: Scalars['String']['input'];
  /** Optional role/type filter */
  filterRole?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Max results (default 20) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text search query */
  query: Scalars['String']['input'];
  /** Subgraph containing the entity (e.g., "core", "fhir", "payroll") */
  subgraph: Scalars['String']['input'];
};

/** Search result item — generic across all entity types */
export type EntitySearchResult = {
  __typename?: 'EntitySearchResult';
  /** Display label (name, display_name, etc.) */
  displayName: Scalars['String']['output'];
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Entity ID (actor_global_id, FHIR id, etc.) */
  id: Scalars['String']['output'];
  /** Secondary label (role, type, etc.) */
  secondary?: Maybe<Scalars['String']['output']>;
  /** Source subgraph */
  subgraph: Scalars['String']['output'];
};

/** Entity status enumeration */
export const EntityStatus = {
  /** Entity is active and operational */
  ACTIVE: 'ACTIVE',
  /** Entity has completed its lifecycle */
  COMPLETED: 'COMPLETED',
  /** Entity is disabled */
  DISABLED: 'DISABLED',
  /** Entity has failed/errored */
  FAILED: 'FAILED',
  /** Entity is being initialized */
  INITIALIZING: 'INITIALIZING',
  /** Entity is in maintenance mode */
  MAINTENANCE: 'MAINTENANCE',
  /** Entity is paused/suspended */
  PAUSED: 'PAUSED',
} as const;

export type EntityStatus = (typeof EntityStatus)[keyof typeof EntityStatus];
/** * Entity type enumeration (16 FERP primitives) */
export const EntityType = {
  ACTOR_DESCRIPTOR: 'ACTOR_DESCRIPTOR',
  ALIAS: 'ALIAS',
  BROADCAST: 'BROADCAST',
  CONTEXT: 'CONTEXT',
  DECISION: 'DECISION',
  ESCALATION: 'ESCALATION',
  INTEGRATION: 'INTEGRATION',
  MFA_PROVIDER: 'MFA_PROVIDER',
  NOTIFICATION: 'NOTIFICATION',
  POLICY: 'POLICY',
  RESOURCE: 'RESOURCE',
  SCHEDULE: 'SCHEDULE',
  SERVICE_DESCRIPTOR: 'SERVICE_DESCRIPTOR',
  TRANSITION: 'TRANSITION',
  WEBHOOK: 'WEBHOOK',
  WORKFLOW_DEFINITION: 'WORKFLOW_DEFINITION',
} as const;

export type EntityType = (typeof EntityType)[keyof typeof EntityType];
/** Metadata for a subgraph entity type */
export type EntityTypeMetadata = {
  __typename?: 'EntityTypeMetadata';
  /** Entity code (variable-width: e.g., "PAT", "GL") */
  code: Scalars['String']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** List of field names on this entity */
  fields: Array<Scalars['String']['output']>;
  /** GraphQL query name (e.g., "patient", "glAccount") */
  graphqlQuery: Scalars['String']['output'];
  /** GraphQL type name (with subgraph prefix if applicable) */
  graphqlTypeName: Scalars['String']['output'];
  /** Custom metadata as JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Entity type name (e.g., "Patient", "GlAccount") */
  name: Scalars['String']['output'];
  /** Safety level for this entity type */
  safetyLevel: Scalars['String']['output'];
};

/** Escalation timestamp record for audit trail */
export type EscalationTimestamp = {
  __typename?: 'EscalationTimestamp';
  /** Escalation action (NotificationSent, AcknowledgmentReceived, ActionTaken, Resolved) */
  action: Scalars['String']['output'];
  /** Notes about the escalation action */
  notes?: Maybe<Scalars['String']['output']>;
  /** Timestamp of escalation action */
  timestamp: Scalars['DateTime']['output'];
  /** User ID who performed the action */
  userId: Scalars['String']['output'];
};

/** Input for escalation timestamp audit trail (immutable compliance record) */
export type EscalationTimestampInput = {
  /**
   * Escalation action (NotificationSent, AcknowledgmentReceived, ActionTaken, Resolved)
   * From tenant Policy metadata, not hardcoded
   */
  action: Scalars['String']['input'];
  /** Notes about the escalation action (audit trail documentation) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * Timestamp of escalation action (ISO 8601)
   * Backend-generated for audit trail integrity
   */
  timestamp: Scalars['DateTime']['input'];
  /** User ID who performed the action (from authentication context) */
  userId: Scalars['String']['input'];
};

/** Input for analytics cost estimation */
export type EstimateAnalyticsCostInput = {
  /** End date for query window */
  endDate: Scalars['NaiveDate']['input'];
  /** Start date for query window */
  startDate: Scalars['NaiveDate']['input'];
  /** Subgraph IDs to filter */
  subgraphIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tenant IDs to include */
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for evaluating a lens chain. */
export type EvaluateLensInput = {
  /** Actor ID whose view to evaluate */
  actorId: Scalars['String']['input'];
  /** Optional: break-glass justification (enables Phase 4 widening) */
  breakGlassJustification?: InputMaybe<Scalars['String']['input']>;
  /** Entity IDs to check visibility for (empty/omitted = evaluate all) */
  entityIds?: Array<Scalars['String']['input']>;
  /** Optional: limit to specific phases */
  phases?: InputMaybe<Array<LensPhase | '%future added value'>>;
};

/** Input for policy evaluation. */
export type EvaluatePolicyInput = {
  /** Evaluation context (JSON string) */
  context: Scalars['String']['input'];
  /** Policy ID to evaluate */
  policyId: Scalars['String']['input'];
};

/** Event primitive - Immutable audit trail for workflow state changes */
export type Event = {
  __typename?: 'Event';
  action: GqlEventAction | '%future added value';
  archived: Scalars['Boolean']['output'];
  category: GqlEventCategory | '%future added value';
  chainVerified: Scalars['Boolean']['output'];
  changeSummary: Scalars['String']['output'];
  complianceFrameworks: Array<Scalars['String']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this event.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entityType: Scalars['String']['output'];
  eventName: Scalars['String']['output'];
  eventType: GqlEventType | '%future added value';
  hash: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  /** On behalf of WHO */
  onBehalfOfActor?: Maybe<ActorSummary>;
  originalId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['DateTime']['output'];
  /** WHO performed this event */
  performedByActor?: Maybe<ActorSummary>;
  previousEventHash?: Maybe<Scalars['String']['output']>;
  processingDurationMs?: Maybe<Scalars['String']['output']>;
  retentionUntil?: Maybe<Scalars['DateTime']['output']>;
  retryCount: Scalars['Int']['output'];
  severity: GqlEventSeverity | '%future added value';
  signature?: Maybe<Scalars['String']['output']>;
  source: GqlEventSource | '%future added value';
  tags: Array<Scalars['String']['output']>;
};

/** Evidence attachment result (DRR-137 Phase 3) */
export type EvidenceAttachment = {
  __typename?: 'EvidenceAttachment';
  attachedAt: Scalars['String']['output'];
  attachedBy: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityType: EvidenceEntityType | '%future added value';
  notes?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
};

/** * Evidence attribution for AI-generated entities */
export type EvidenceAttributionOutput = {
  __typename?: 'EvidenceAttributionOutput';
  /** AI confidence score (0.0-1.0) */
  confidence: Scalars['Float']['output'];
  /** Extraction metadata */
  extractionMetadata: Scalars['JSONObject']['output'];
  /** LLM provider used (e.g., "Claude", "GPT-4") */
  llmProvider?: Maybe<Scalars['String']['output']>;
  /** Source document ID (if from Chaos ingestion) */
  sourceDocumentId?: Maybe<Scalars['String']['output']>;
  /** Source document name */
  sourceDocumentName?: Maybe<Scalars['String']['output']>;
};

/** Entity types that can receive evidence via EVIDENCED_BY edges (DRR-110) */
export const EvidenceEntityType = {
  INSTANCE: 'INSTANCE',
  ISSUE: 'ISSUE',
  TASK: 'TASK',
  WORKFLOW: 'WORKFLOW',
} as const;

export type EvidenceEntityType = (typeof EvidenceEntityType)[keyof typeof EvidenceEntityType];
/** Evidence Map (GraphQL output) */
export type EvidenceMap = {
  __typename?: 'EvidenceMap';
  /** Business metadata evidence */
  businessEvidence: Scalars['JSON']['output'];
  /** Complete extraction context */
  extractionContext: Scalars['JSON']['output'];
  /** Field evidence mapping */
  fieldEvidence: Scalars['JSON']['output'];
  /** Primitive evidence mapping */
  primitiveEvidence: Scalars['JSON']['output'];
};

/** Evidence report for GraphQL */
export type EvidenceReportGql = {
  __typename?: 'EvidenceReportGql';
  assessmentDate: Scalars['String']['output'];
  coverageDisclosure: Scalars['String']['output'];
  evidenceEndDate: Scalars['String']['output'];
  evidenceStartDate: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  generatedBy: Scalars['String']['output'];
  recommendation: ReportRecommendationGql | '%future added value';
  reportDate: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  residentId: Scalars['String']['output'];
  residentName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** An evidence requirement declared on a provision. */
export type EvidenceRequirement = {
  __typename?: 'EvidenceRequirement';
  /** What this evidence should demonstrate */
  description: Scalars['String']['output'];
  /** Evidence type: task, observation, document, certification, witness */
  evidenceType: Scalars['String']['output'];
  /** Renewal frequency: annual, quarterly, monthly, per_enrollment, per_hire, per_issuance, per_event */
  renewal: Scalars['String']['output'];
};

/** Evidence requirement definition from YAML metadata (DRR-176). */
export type EvidenceRequirementDef = {
  __typename?: 'EvidenceRequirementDef';
  /** What this evidence should demonstrate */
  description: Scalars['String']['output'];
  /** Evidence type: task, observation, document, certification, witness */
  evidenceType: Scalars['String']['output'];
  /** Renewal frequency: annual, quarterly, monthly, per_enrollment, per_hire, per_issuance */
  renewal: Scalars['String']['output'];
};

export const EvidenceType = {
  bottleneck: 'bottleneck',
  complianceGap: 'complianceGap',
  errorPattern: 'errorPattern',
  performanceMetric: 'performanceMetric',
} as const;

export type EvidenceType = (typeof EvidenceType)[keyof typeof EvidenceType];
/** EVV configuration */
export type EvvConfig = {
  __typename?: 'EvvConfig';
  enabled: Scalars['Boolean']['output'];
  gracePeriodMinutes?: Maybe<Scalars['Int']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

/** Consent record for a single step in the chain-of-command */
export type ExchangeConsentRecord = {
  __typename?: 'ExchangeConsentRecord';
  /** Actor who approved */
  actorId: Scalars['String']['output'];
  /** Auth tier at time of approval */
  authTier: Scalars['Int']['output'];
  /** When consent was given */
  consentedAt: Scalars['DateTime']['output'];
  /** Which consent step */
  step: ExchangeConsentStep | '%future added value';
  /** Tenant that provided consent */
  tenantId: Scalars['String']['output'];
  /** Whether a fresh witness was provided (steps 3, 6) */
  witnessVerified: Scalars['Boolean']['output'];
};

/** Consent step in chain-of-command approval */
export const ExchangeConsentStep = {
  /** Step 2: Tenant A administrator approves */
  A_ADMIN_APPROVES: 'A_ADMIN_APPROVES',
  /** Step 1: Tenant A staff initiates */
  A_INITIATES: 'A_INITIATES',
  /** Step 3: Tenant A owner confirms (Tier 4 + witness) */
  A_OWNER_CONFIRMS: 'A_OWNER_CONFIRMS',
  /** Step 5: Tenant B administrator approves */
  B_ADMIN_APPROVES: 'B_ADMIN_APPROVES',
  /** Step 6: Tenant B owner confirms (Tier 4 + witness) */
  B_OWNER_CONFIRMS: 'B_OWNER_CONFIRMS',
  /** Step 4: Tenant B staff reviews */
  B_REVIEWS: 'B_REVIEWS',
} as const;

export type ExchangeConsentStep = (typeof ExchangeConsentStep)[keyof typeof ExchangeConsentStep];
/** Exchange document metadata — NEVER contains document content */
export type ExchangeDocument = {
  __typename?: 'ExchangeDocument';
  /** Unique document ID within exchange */
  documentId: Scalars['String']['output'];
  /** Whether the recipient has downloaded this document */
  downloaded: Scalars['Boolean']['output'];
  /** When the recipient first downloaded (if ever) */
  downloadedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the document expires (90-day TTL) */
  expiresAt: Scalars['DateTime']['output'];
  /** Original filename */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSizeBytes: Scalars['Int']['output'];
  /** MIME type (application/pdf, text/csv, etc.) */
  fileType: Scalars['String']['output'];
  /** When the document was pushed */
  pushedAt: Scalars['DateTime']['output'];
  /** Relationship this document belongs to */
  relationshipId: Scalars['String']['output'];
  /** Actor who uploaded */
  senderActorId: Scalars['String']['output'];
  /** Sender display name */
  senderName?: Maybe<Scalars['String']['output']>;
  /** Tenant that pushed the document */
  senderTenantId: Scalars['String']['output'];
};

/** Result of presigned download URL generation */
export type ExchangeDownloadUrlResult = {
  __typename?: 'ExchangeDownloadUrlResult';
  /** MIME type */
  contentType: Scalars['String']['output'];
  /** Presigned GET URL for direct Wasabi → browser download */
  downloadUrl: Scalars['String']['output'];
  /** Seconds until the presigned URL expires (60 min) */
  expiresInSeconds: Scalars['Int']['output'];
  /** Original filename */
  fileName: Scalars['String']['output'];
};

/** Exchange relationship between two tenants */
export type ExchangeRelationship = {
  __typename?: 'ExchangeRelationship';
  /** Number of approvals received (0-6) */
  approvalCount: Scalars['Int']['output'];
  /** Consent records for this relationship (loaded on demand) */
  consentRecords: Array<ExchangeConsentRecord>;
  /** Number of documents exchanged */
  documentCount: Scalars['Int']['output'];
  /** When the relationship was established */
  establishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the relationship expires (TTL) */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Tenant A (initiator) identifier */
  fromTenantId: Scalars['String']['output'];
  /** Tenant A display name */
  fromTenantName?: Maybe<Scalars['String']['output']>;
  /**
   * Per-relationship KMS key ARN (created on activation, disabled on revocation)
   * FERP service role CANNOT use this key to decrypt — only participant tenants can.
   */
  kmsKeyArn?: Maybe<Scalars['String']['output']>;
  /** Relationship ID (e.g., "rel-011") */
  relationshipId: Scalars['String']['output'];
  /** Underlying tenant-relationships.yaml type */
  relationshipType: Scalars['String']['output'];
  /** Total approvals required (always 6) */
  requiredApprovals: Scalars['Int']['output'];
  /** Current relationship status */
  status: ExchangeRelationshipStatus | '%future added value';
  /** Tenant B (recipient) identifier */
  toTenantId: Scalars['String']['output'];
  /** Tenant B display name */
  toTenantName?: Maybe<Scalars['String']['output']>;
};

/** Exchange relationship status */
export const ExchangeRelationshipStatus = {
  /** All 6 approvals received, channel active */
  ACTIVE: 'ACTIVE',
  /** Expired (90-day TTL) */
  EXPIRED: 'EXPIRED',
  /** Tenant A has initiated, awaiting approvals */
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  /** Owner revoked — KMS key disabled, IAM removed */
  REVOKED: 'REVOKED',
} as const;

export type ExchangeRelationshipStatus =
  (typeof ExchangeRelationshipStatus)[keyof typeof ExchangeRelationshipStatus];
/** Result of presigned upload URL generation */
export type ExchangeUploadUrlResult = {
  __typename?: 'ExchangeUploadUrlResult';
  /** Content-Type that must be sent with the upload */
  contentType: Scalars['String']['output'];
  /** Document ID assigned (for tracking) */
  documentId: Scalars['String']['output'];
  /** Seconds until the presigned URL expires (15 min) */
  expiresInSeconds: Scalars['Int']['output'];
  /**
   * PII entity types detected in metadata (filename, description) by Presidio.
   * Empty if no PII detected. Non-empty = warning to uploader.
   * FERP scans METADATA only — never document bytes (presigned URL constraint).
   */
  piiEntitiesDetected: Array<Scalars['String']['output']>;
  /** Bucket name */
  s3Bucket: Scalars['String']['output'];
  /** S3 key where the document will be stored */
  s3Key: Scalars['String']['output'];
  /** Presigned PUT URL for direct browser → Wasabi upload */
  uploadUrl: Scalars['String']['output'];
};

export type ExecuteDagWorkflowInput = {
  createdBy: Scalars['String']['input'];
  workflow: DagworkflowInput;
};

/** Execution mode for sub-workflows */
export const ExecutionMode = {
  /** Execute asynchronously, parent continues */
  ASYNC: 'ASYNC',
  /** Execute inline, block parent until complete */
  INLINE: 'INLINE',
  /** Execute in parallel with other sub-workflows */
  PARALLEL: 'PARALLEL',
} as const;

export type ExecutionMode = (typeof ExecutionMode)[keyof typeof ExecutionMode];
/** * Executive safety metrics output (DOMAIN-AGNOSTIC) */
export type ExecutiveSafetyMetricsOutput = {
  __typename?: 'ExecutiveSafetyMetricsOutput';
  /** Audit trail integrity score (0.0-100.0) */
  auditTrailIntegrity: Scalars['Float']['output'];
  /** Dynamic domain-specific metrics (tenant-configured) */
  domainMetrics: Array<DomainMetricOutput>;
  /** Emergency response time in milliseconds */
  emergencyResponseTime: Scalars['Int']['output'];
  /** @deprecated: Use domain_metrics instead - Fraud prevention rate for financial tenants */
  financialFraudPrevention: Scalars['Float']['output'];
  /** Last metrics update timestamp (ISO 8601) */
  lastUpdated: Scalars['String']['output'];
  /** @deprecated: Use domain_metrics instead - Legal privilege protection for legal tenants */
  legalPrivilegeProtection: Scalars['Float']['output'];
  /** Overall safety score (0.0-100.0) */
  overallSafetyScore: Scalars['Float']['output'];
  /** @deprecated: Use domain_metrics instead - Patient safety index for healthcare tenants */
  patientSafetyIndex: Scalars['Float']['output'];
  /** Regulatory compliance score (0.0-100.0) */
  regulatoryCompliance: Scalars['Float']['output'];
  /** Risk level (Low, Medium, High, Critical) */
  riskLevel: RiskLevelOutput | '%future added value';
  /** Safety trend (Improving, Stable, Declining) */
  trend: SafetyTrendOutput | '%future added value';
};

/** Expert requirements for validation (GraphQL Input) */
export type ExpertRequirementsInput = {
  complianceFrameworks: Array<Scalars['String']['input']>;
  maxCapacity: Scalars['Float']['input'];
  minSuccessRate: Scalars['Float']['input'];
  requiredCertifications: Array<Scalars['String']['input']>;
};

/** Expert validation result */
export type ExpertValidationResult = {
  __typename?: 'ExpertValidationResult';
  issues: Array<Scalars['String']['output']>;
  recommendations: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

/** A certification that is expiring soon. */
export type ExpiringCertification = {
  __typename?: 'ExpiringCertification';
  /** Scopes that will be blocked when this cert expires */
  affectedScopes: Array<Scalars['String']['output']>;
  /** Certification type (e.g., "osha-crane-operator", "servsafe-handler") */
  certType: Scalars['String']['output'];
  /** Days until expiration (negative if already expired) */
  daysUntilExpiration: Scalars['Int']['output'];
  /** Expiration date (ISO 8601) */
  expiresAt: Scalars['String']['output'];
  /** Urgency level based on days remaining */
  urgency: CertificationUrgency | '%future added value';
};

/** Expiring credential entry */
export type ExpiringCredentialEntry = {
  __typename?: 'ExpiringCredentialEntry';
  /** Actor ID whose credential is expiring */
  actorId: Scalars['String']['output'];
  /** When the credential expires */
  expiresAt: Scalars['DateTime']['output'];
  /** Template ref for the credential type */
  templateRef?: Maybe<Scalars['String']['output']>;
};

/** Subgraph expiring soon (output type for expiring subgraphs query) */
export type ExpiringSubgraph = {
  __typename?: 'ExpiringSubgraph';
  /** Days until expiration */
  daysUntilExpiration: Scalars['Int']['output'];
  /** Subgraph identifier */
  subgraphName: Scalars['String']['output'];
};

/** Input for the explainConfigProposal mutation. */
export type ExplainProposalInput = {
  /**
   * Structured proposal summary for the LLM to explain.
   * This should be a human-readable description of the proposal fields,
   * NOT raw config content. The frontend builds this from GraphQL fields.
   */
  proposalSummary: Scalars['String']['input'];
};

/** Export Audit Trail Input (GraphQL input) */
export type ExportAuditTrailInput = {
  /** Filter */
  filter: AuditTrailFilter;
  /** Export format */
  format: ExportFormat | '%future added value';
  /** Include metadata */
  includeMetadata: Scalars['Boolean']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Export Audit Trail Result (GraphQL output) */
export type ExportAuditTrailResult = {
  __typename?: 'ExportAuditTrailResult';
  /** Download URL (S3 presigned URL) */
  downloadUrl: Scalars['String']['output'];
  /** Expiration timestamp */
  expiresAt: Scalars['DateTime']['output'];
  /** Export ID (backend Snowflake ID) */
  exportId: Scalars['String']['output'];
  /** Export format */
  format: Scalars['String']['output'];
  /** Record count */
  recordCount: Scalars['Int']['output'];
};

/** Response for export operation */
export type ExportDraftResponse = {
  __typename?: 'ExportDraftResponse';
  /** Definition content */
  definition: Scalars['String']['output'];
  /** Suggested filename */
  filename: Scalars['String']['output'];
  /** Suggested inheritance level */
  suggestedLevel: Scalars['String']['output'];
};

/** Export Format (GraphQL enum) */
export const ExportFormat = {
  /** CSV format */
  CSV: 'CSV',
  /** JSON format */
  JSON: 'JSON',
  /** PDF format */
  PDF: 'PDF',
} as const;

export type ExportFormat = (typeof ExportFormat)[keyof typeof ExportFormat];
/** Export Metadata */
export type ExportMetadata = {
  __typename?: 'ExportMetadata';
  /** Checksum for integrity verification */
  checksum: Scalars['String']['output'];
  /** Exported at timestamp */
  exportedAt: Scalars['DateTime']['output'];
  /** Exported by (user ID) */
  exportedBy: Scalars['String']['output'];
  /** Source tenant ID */
  sourceTenant: Scalars['String']['output'];
  /** Template version exported */
  templateVersion: Scalars['String']['output'];
};

/** Export RBAC Audit Input (GraphQL input) */
export type ExportRbacAuditInput = {
  filter: RbacAuditFilter;
  format: GqlExportFormat | '%future added value';
  includeMetadata: Scalars['Boolean']['input'];
};

/** Export run summary */
export type ExportRunSummary = {
  __typename?: 'ExportRunSummary';
  /** When export completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Duration in seconds */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Errors encountered */
  errors: Array<Scalars['String']['output']>;
  /** Files created */
  filesCreated: Scalars['Int']['output'];
  /** Records exported */
  recordsExported: Scalars['Int']['output'];
  /** Export run ID */
  runId: Scalars['String']['output'];
  /** When export started */
  startedAt: Scalars['DateTime']['output'];
  /** Export status */
  status: ExportStatus | '%future added value';
};

/** Export pipeline status */
export const ExportStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PARTIAL: 'PARTIAL',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
} as const;

export type ExportStatus = (typeof ExportStatus)[keyof typeof ExportStatus];
/** Export Template Input */
export type ExportTemplateInput = {
  /** Include evidence data */
  includeEvidence: Scalars['Boolean']['input'];
  /** Include export metadata */
  includeMetadata: Scalars['Boolean']['input'];
  /** Template ID to export */
  templateId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** Template version (None = latest) */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Input for extending JIT session */
export type ExtendJitSessionInput = {
  additionalMinutes: Scalars['Int']['input'];
  justification: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Response for extend JIT session mutation */
export type ExtendJitSessionResult = {
  __typename?: 'ExtendJITSessionResult';
  message: Scalars['String']['output'];
  newExpiresAt: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type ExtendRetentionInput = {
  additionalYears: Scalars['Int']['input'];
  authorizedBy: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Input for extracting PII from an image */
export type ExtractImagePiiInput = {
  /** Document ID for audit trail */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded image data (JPEG, PNG) */
  imageBase64: Scalars['String']['input'];
  /** Language code for OCR (default: en) */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Whether to store in vault (false for preview only) */
  storeInVault: Scalars['Boolean']['input'];
  /** Subject ID for vault storage (optional for preview) */
  subjectId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of image PII extraction */
export type ExtractImagePiiResult = {
  __typename?: 'ExtractImagePiiResult';
  /** Detected document type (SSN_CARD, DRIVERS_LICENSE, etc.) */
  documentType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Extracted PII fields */
  extractedFields: Array<ExtractedImagePiiField>;
  /** Mapping ID for deanonymization (if needed) */
  mappingId?: Maybe<Scalars['String']['output']>;
  /** Full OCR text with PII masked */
  ocrTextMasked?: Maybe<Scalars['String']['output']>;
  /** Processing time in milliseconds */
  processingTimeMs: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

/** Input for extracting industry terms from a document. */
export type ExtractIndustryTermsInput = {
  /** Document text content (from PDF extraction or manual input) */
  documentText: Scalars['String']['input'];
  /** Document title or reference */
  documentTitle?: InputMaybe<Scalars['String']['input']>;
  /** Industry vertical: "healthcare", "construction", "finance", "legal" */
  industry: Scalars['String']['input'];
  /** Publication date if known (YYYY-MM-DD) */
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  /** Source organization (e.g., "Care Providers of Minnesota", "AHA", "OSHA") */
  sourceOrganization: Scalars['String']['input'];
};

/** Result of industry term extraction. */
export type ExtractIndustryTermsResult = {
  __typename?: 'ExtractIndustryTermsResult';
  /** Generated advisory entries (YAML format for review) */
  advisoryYaml?: Maybe<Scalars['String']['output']>;
  /** Number of statutory definitions analyzed for mapping */
  definitionsAnalyzed: Scalars['Int']['output'];
  /** Whether extraction succeeded */
  success: Scalars['Boolean']['output'];
  /** LLM-generated summary of findings */
  summary: Scalars['String']['output'];
  /** Number of industry terms discovered */
  termsDiscovered: Scalars['Int']['output'];
  /** Number of terms with valid statutory mappings */
  termsMapped: Scalars['Int']['output'];
};

/** Input for extractStatuteMetadata mutation. */
export type ExtractStatuteMetadataInput = {
  /** Raw document text (optional — used if URL is not provided or as supplement). */
  documentText?: InputMaybe<Scalars['String']['input']>;
  /** URL to a statute page (optional — will be fetched by the LLM). */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

/** A single field extracted from intake text. */
export type ExtractedField = {
  __typename?: 'ExtractedField';
  /** Extraction confidence (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** FormSchema field name */
  fieldName: Scalars['String']['output'];
  /** Extracted value */
  value: Scalars['String']['output'];
};

/** Extracted PII field from image */
export type ExtractedImagePiiField = {
  __typename?: 'ExtractedImagePiiField';
  /** Detection confidence (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** Entity type (US_SSN, US_DRIVER_LICENSE, etc.) */
  entityType: Scalars['String']['output'];
  /** Masked value for display (***-**-6789) */
  maskedValue: Scalars['String']['output'];
  /** Vault token (only if store_in_vault=true) */
  token?: Maybe<Scalars['String']['output']>;
};

/** Extracted Metadata (GraphQL output) */
export type ExtractedMetadata = {
  __typename?: 'ExtractedMetadata';
  analyzedAt: Scalars['String']['output'];
  complexity: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  detectedDomain: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  engineVersion: Scalars['String']['output'];
  fieldCount: Scalars['Int']['output'];
  sectionCount: Scalars['Int']['output'];
  textPreview?: Maybe<Scalars['String']['output']>;
};

/**
 * Extraction metadata for AI-generated templates
 *
 * High-level metadata about the Chaos→DSL conversion process.
 */
export type ExtractionMetadataOutput = {
  __typename?: 'ExtractionMetadataOutput';
  /** Approval status (if template went through approval workflow) */
  approvalStatus?: Maybe<Scalars['String']['output']>;
  /** Extraction timestamp */
  extractedAt: Scalars['String']['output'];
  /** Extraction ID (for traceability) */
  extractionId: Scalars['String']['output'];
  /** LLM ensemble used (multi-LLM validation) */
  llmEnsemble: Array<Scalars['String']['output']>;
  /** Overall confidence score (0.0 - 1.0) */
  overallConfidence: Scalars['Float']['output'];
  /** Requires human review flag */
  requiresHumanReview: Scalars['Boolean']['output'];
  /** Source document IDs (multiple documents may contribute to one template) */
  sourceDocuments: Array<Scalars['String']['output']>;
};

/** Input for facility search */
export type FacilitySearchInput = {
  acceptsMedicaid?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsVa?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentId?: InputMaybe<Scalars['String']['input']>;
  careLevel?: InputMaybe<CareCircleCareLevel | '%future added value'>;
  city?: InputMaybe<Scalars['String']['input']>;
  hasHmongStaff?: InputMaybe<Scalars['Boolean']['input']>;
  hasPharmacist?: InputMaybe<Scalars['Boolean']['input']>;
  hasPsychologist?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDistanceMiles?: InputMaybe<Scalars['Int']['input']>;
  minRating?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Failure handling mode for sub-workflows */
export const FailureMode = {
  /** Execute compensation/rollback */
  COMPENSATE: 'COMPENSATE',
  /** Failure in child fails the parent workflow */
  FAIL_PARENT: 'FAIL_PARENT',
  /** Retry the child workflow */
  RETRY_CHILD: 'RETRY_CHILD',
  /** Skip failed child and continue parent */
  SKIP_AND_CONTINUE: 'SKIP_AND_CONTINUE',
} as const;

export type FailureMode = (typeof FailureMode)[keyof typeof FailureMode];
/**
 * Feature definition for setup wizard (derived from subgraph metadata YAMLs).
 *
 * Each feature maps 1:1 to a subgraph. The setup wizard displays these
 * to let tenants choose which modules to enable.
 *
 * Source: `common/configs/seed/subgraphs/*.yaml` — `feature:` section.
 */
export type FeatureDefinition = {
  __typename?: 'FeatureDefinition';
  /** Feature category (e.g., "infrastructure", "healthcare", "operations") */
  category: Scalars['String']['output'];
  /** Mantine color (e.g., "red", "green") */
  color: Scalars['String']['output'];
  /** Regulatory compliance frameworks (e.g., ["HIPAA", "SOX"]) */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Feature IDs this feature depends on (must be activated first) */
  dependencies: Array<Scalars['String']['output']>;
  /** Full description from subgraph YAML */
  description: Scalars['String']['output'];
  /** Unique feature ID (same as subgraph_id) */
  featureId: Scalars['String']['output'];
  /** Tabler icon name (e.g., "IconHeartbeat") */
  icon: Scalars['String']['output'];
  /** Whether this feature is always-on (cannot be deselected) */
  isCore: Scalars['Boolean']['output'];
  /** Whether this feature handles life-critical data */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Human-readable display name */
  name: Scalars['String']['output'];
  /** Short one-liner for setup wizard cards */
  shortDescription: Scalars['String']['output'];
  /** Subgraph ID (same as feature_id, for explicit cross-reference) */
  subgraphId: Scalars['String']['output'];
  /** Descriptive tags for grouping/filtering */
  tags: Array<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  /** Flag configuration/metadata */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Enable/disable flag */
  enabled: Scalars['Boolean']['input'];
  /** Expiration date (optional) */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Flag identifier */
  flag: Scalars['String']['input'];
  /** Rollout percentage (0-100) */
  rolloutPercentage?: InputMaybe<Scalars['Int']['input']>;
};

export type FederationState = {
  __typename?: 'FederationState';
  subgraphs: Array<SubgraphInfo>;
  updatedMs: Scalars['Int']['output'];
};

/**
 * FerpApproval federation entity - **projection of Approval primitive**
 *
 * This provides the Approval primitive to subgraphs via Apollo Federation.
 * Subgraphs like Payroll can reference approvals (e.g., PayrollException.ferpApproval).
 *
 * # FERP Architecture Mapping
 *
 * | FerpApproval Field | Approval Field | Notes |
 * |--------------------|----------------|-------|
 * | id | id | Snowflake ID |
 * | tenantId | tenant | Multi-tenant isolation |
 * | name | approval_name | Display name |
 * | approvalType | approval_type | Sequential, Parallel, Conditional, Hierarchical |
 * | status | status | Pending, InReview, Approved, Rejected, etc. |
 * | requestedBy | requested_by | Actor who requested approval |
 * | currentApprover | current_approver | Actor currently assigned |
 *
 * # Federation Key
 * `@key(fields: "id")` - resolved by ID lookup via FederationEntityQuery
 *
 * # Example Extension (in payroll subgraph)
 * ```graphql
 * type PayrollException {
 * ferpApproval: FerpApproval
 * }
 * ```
 */
export type FerpApproval = {
  __typename?: 'FerpApproval';
  /** Approval type - maps to Approval.approval_type */
  approvalType: Scalars['String']['output'];
  /** Actor who approves - maps to Approval.approver_id */
  approverId: Scalars['String']['output'];
  /** Actor ID if delegated - maps to Approval.delegated_to */
  delegatedTo?: Maybe<Scalars['String']['output']>;
  /** External ID for external systems */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier (federation @key) - maps to Approval.id (Snowflake ID) */
  id: Scalars['ID']['output'];
  /** Approval display name - maps to Approval.approval_name */
  name: Scalars['String']['output'];
  /** Approval status - maps to Approval.status */
  status: Scalars['String']['output'];
  /** Tenant this approval belongs to - maps to Approval.tenant */
  tenantId: Scalars['ID']['output'];
};

/**
 * FerpDocument federation entity - **projection of Document primitive**
 *
 * This provides the Document primitive to subgraphs via Apollo Federation.
 * Subgraphs like Payroll can reference documents (e.g., W-4 forms, tax documents).
 *
 * # FERP Architecture Mapping
 *
 * | FerpDocument Field | Document Field | Notes |
 * |--------------------|----------------|-------|
 * | id | id | Snowflake ID |
 * | tenantId | tenant | Multi-tenant isolation |
 * | name | document_name | Display name |
 * | documentType | document_type | File, Record, Evidence, Report, StructuredData |
 * | mimeType | mime_type | MIME type (application/pdf, etc.) |
 * | status | status | Draft, Active, Archived, etc. |
 *
 * # Federation Key
 * `@key(fields: "id")` - resolved by ID lookup via FederationEntityQuery
 */
export type FerpDocument = {
  __typename?: 'FerpDocument';
  /** Document description */
  description?: Maybe<Scalars['String']['output']>;
  /** Document type - maps to Document.document_type */
  documentType: Scalars['String']['output'];
  /** File extension */
  fileExtension?: Maybe<Scalars['String']['output']>;
  /** Unique identifier (federation @key) - maps to Document.id (Snowflake ID) */
  id: Scalars['ID']['output'];
  /** MIME type - maps to Document.mime_type */
  mimeType: Scalars['String']['output'];
  /** Document display name - maps to Document.document_name */
  name: Scalars['String']['output'];
  /** Document status - maps to Document.current_status */
  status: Scalars['String']['output'];
  /** Tenant this document belongs to - maps to Document.tenant */
  tenantId: Scalars['ID']['output'];
};

/**
 * FerpPolicy federation entity - **projection of Policy primitive**
 *
 * This provides the Policy primitive to subgraphs via Apollo Federation.
 * Subgraphs can reference policies for authorization and validation.
 *
 * # FERP Architecture Mapping
 *
 * | FerpPolicy Field | Policy Field | Notes |
 * |------------------|--------------|-------|
 * | id | id | Snowflake ID |
 * | tenantId | tenant_id | Multi-tenant isolation |
 * | name | name | Display name |
 * | policyType | policy_type | Authorization, Validation, BusinessRule, etc. |
 * | scope | scope | Global, Tenant, Workflow, Entity |
 * | enabled | enabled | Whether policy is active |
 *
 * # Federation Key
 * `@key(fields: "id")` - resolved by ID lookup via FederationEntityQuery
 */
export type FerpPolicy = {
  __typename?: 'FerpPolicy';
  /** Whether policy is active - maps to Policy.active */
  active: Scalars['Boolean']['output'];
  /** Whether policy is enabled - maps to Policy.enabled */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier (federation @key) - maps to Policy.id (Snowflake ID) */
  id: Scalars['ID']['output'];
  /** Policy display name - maps to Policy.name */
  name: Scalars['String']['output'];
  /** Policy type - maps to Policy.policy_type */
  policyType: Scalars['String']['output'];
  /** Policy scope - maps to Policy.scope */
  scope: Scalars['String']['output'];
  /** Tenant this policy belongs to - maps to Policy.tenant_id */
  tenantId: Scalars['ID']['output'];
};

/** GraphQL representation of FHIR R4 Condition (from Medplum) */
export type FhirCondition = {
  __typename?: 'FhirCondition';
  /** Clinical status */
  clinicalStatus?: Maybe<Scalars['String']['output']>;
  /** Condition code */
  code?: Maybe<Scalars['String']['output']>;
  /** Code display text */
  codeDisplay?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1C42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Onset datetime */
  onsetDatetime?: Maybe<Scalars['String']['output']>;
  /** Patient reference */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Recorded date */
  recordedDate?: Maybe<Scalars['String']['output']>;
  /** Verification status */
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

/** Discrepancy summary for DRR-080 parallel-run monitoring */
export type FhirDiscrepancySummaryType = {
  __typename?: 'FhirDiscrepancySummaryType';
  /** Number of discrepancies detected */
  discrepancyCount: Scalars['Int']['output'];
  /** Discrepancy rate as percentage (target: <0.01%) */
  discrepancyRatePercent: Scalars['Float']['output'];
  /** Whether the current rate is within the target */
  isWithinTarget: Scalars['Boolean']['output'];
  /** Most recent discrepancy timestamp (if any) */
  lastDiscrepancyAt?: Maybe<Scalars['String']['output']>;
  /** Most recent discrepancy resource ID (if any) */
  lastDiscrepancyResourceId?: Maybe<Scalars['String']['output']>;
  /** Most recent discrepancy resource type (if any) */
  lastDiscrepancyResourceType?: Maybe<Scalars['String']['output']>;
  /** Target rate (0.01%) */
  targetRatePercent: Scalars['Float']['output'];
  /** Total read comparisons performed */
  totalReads: Scalars['Int']['output'];
};

/** Current dual-write mode information */
export type FhirDualWriteStatusType = {
  __typename?: 'FhirDualWriteStatusType';
  /** Discrepancy metrics */
  discrepancy: FhirDiscrepancySummaryType;
  /** Current mode: medplum_primary, dynamodb_primary, or dynamodb_only */
  mode: Scalars['String']['output'];
};

/** GraphQL representation of FHIR R4 Encounter (from Medplum) */
export type FhirEncounter = {
  __typename?: 'FhirEncounter';
  /** Encounter class code */
  classCode: Scalars['String']['output'];
  /** Encounter class display */
  classDisplay?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1E42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Patient reference */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Period end */
  periodEnd?: Maybe<Scalars['String']['output']>;
  /** Period start */
  periodStart?: Maybe<Scalars['String']['output']>;
  /** Service type */
  serviceType?: Maybe<Scalars['String']['output']>;
  /** Encounter status */
  status: Scalars['String']['output'];
};

/** GraphQL representation of FHIR R4 Medication (drug definition) */
export type FhirMedication = {
  __typename?: 'FhirMedication';
  /** Medication code (e.g., RxNorm, NDC) */
  code?: Maybe<Scalars['String']['output']>;
  /** Medication display name */
  display?: Maybe<Scalars['String']['output']>;
  /** Batch expiration date */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1M42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Medication form (tablet, capsule, injection, etc.) */
  form?: Maybe<Scalars['String']['output']>;
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Batch lot number */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Manufacturer reference */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Status (active, inactive, entered-in-error) */
  status?: Maybe<Scalars['String']['output']>;
};

/** GraphQL representation of FHIR R4 MedicationAdministration */
export type FhirMedicationAdministration = {
  __typename?: 'FhirMedicationAdministration';
  /** Dosage information */
  dosage?: Maybe<AdministrationDosage>;
  /** When administered (datetime) */
  effectiveDatetime?: Maybe<Scalars['String']['output']>;
  /** When administered (period end) */
  effectivePeriodEnd?: Maybe<Scalars['String']['output']>;
  /** When administered (period start) */
  effectivePeriodStart?: Maybe<Scalars['String']['output']>;
  /** Encounter/context reference */
  encounterId?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1A42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Medication code */
  medicationCode?: Maybe<Scalars['String']['output']>;
  /** Medication display name */
  medicationDisplay?: Maybe<Scalars['String']['output']>;
  /** Medication reference (if using Medication resource) */
  medicationReference?: Maybe<Scalars['String']['output']>;
  /** Patient reference */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Performer (who administered) */
  performer?: Maybe<Scalars['String']['output']>;
  /** Related prescription (MedicationRequest) reference */
  requestId?: Maybe<Scalars['String']['output']>;
  /** Status (in-progress, not-done, on-hold, completed, etc.) */
  status: Scalars['String']['output'];
};

/** GraphQL representation of FHIR R4 MedicationDispense (fill/refill) */
export type FhirMedicationDispense = {
  __typename?: 'FhirMedicationDispense';
  /** Days supply */
  daysSupply?: Maybe<Scalars['Float']['output']>;
  /** FERP compressed ID (e.g., `$2!1D42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Medication code */
  medicationCode?: Maybe<Scalars['String']['output']>;
  /** Medication display name */
  medicationDisplay?: Maybe<Scalars['String']['output']>;
  /** Medication reference (if using Medication resource) */
  medicationReference?: Maybe<Scalars['String']['output']>;
  /** Patient reference */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Performer (pharmacist) reference */
  performer?: Maybe<Scalars['String']['output']>;
  /** Authorizing prescription reference */
  prescriptionId?: Maybe<Scalars['String']['output']>;
  /** Quantity dispensed */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Quantity unit */
  quantityUnit?: Maybe<Scalars['String']['output']>;
  /** Status (preparation, in-progress, cancelled, on-hold, completed, etc.) */
  status: Scalars['String']['output'];
  /** Whether substitution was made */
  wasSubstituted?: Maybe<Scalars['Boolean']['output']>;
  /** When handed over to patient */
  whenHandedOver?: Maybe<Scalars['String']['output']>;
  /** When prepared */
  whenPrepared?: Maybe<Scalars['String']['output']>;
};

/** GraphQL representation of FHIR R4 MedicationRequest (prescription) */
export type FhirMedicationRequest = {
  __typename?: 'FhirMedicationRequest';
  /** When the prescription was authored */
  authoredOn?: Maybe<Scalars['String']['output']>;
  /** Dispense request details */
  dispenseRequest?: Maybe<DispenseRequest>;
  /** Dosage instructions (human readable) */
  dosageInstruction?: Maybe<Scalars['String']['output']>;
  /** Encounter reference */
  encounterId?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1RX42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Intent (proposal, plan, order, etc.) */
  intent: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Medication code */
  medicationCode?: Maybe<Scalars['String']['output']>;
  /** Medication display name */
  medicationDisplay?: Maybe<Scalars['String']['output']>;
  /** Medication reference (if using Medication resource) */
  medicationReference?: Maybe<Scalars['String']['output']>;
  /** Patient reference */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Number of refills remaining (calculated) */
  refillsRemaining?: Maybe<Scalars['Int']['output']>;
  /** Requester (prescriber) reference */
  requester?: Maybe<Scalars['String']['output']>;
  /** Status (active, on-hold, cancelled, completed, etc.) */
  status: Scalars['String']['output'];
};

/** Medication shift plan grouped by time window */
export type FhirMedicationShiftPlan = {
  __typename?: 'FhirMedicationShiftPlan';
  /** Actor ID of the medication aide */
  actorId: Scalars['String']['output'];
  /** Date of the shift (YYYY-MM-DD) */
  date: Scalars['String']['output'];
  /** Tasks grouped by time window */
  timeWindows: Array<FhirTimeWindowGroup>;
  /** Total task count */
  totalTasks: Scalars['Int']['output'];
};

/** A medication task in the shift plan */
export type FhirMedicationTask = {
  __typename?: 'FhirMedicationTask';
  /** DEA schedule (II, III, IV, V) if controlled */
  deaSchedule?: Maybe<Scalars['String']['output']>;
  /** Dose (e.g., "10mg") */
  dose?: Maybe<Scalars['String']['output']>;
  /** Drug name from FHIR MedicationRequest */
  drugName?: Maybe<Scalars['String']['output']>;
  /** Due time (ISO 8601) */
  dueAt?: Maybe<Scalars['String']['output']>;
  /** Whether this is a controlled substance */
  isControlled: Scalars['Boolean']['output'];
  /** Regulatory mandate reference (e.g., "rs-4-1-004") */
  mandateRef?: Maybe<Scalars['String']['output']>;
  /** Task name (e.g., "Administer Lisinopril 10mg") */
  name: Scalars['String']['output'];
  /** Task priority */
  priority: Scalars['String']['output'];
  /** Whether administration requires a witness */
  requiresWitness: Scalars['Boolean']['output'];
  /** Route (e.g., "oral", "IV") */
  route?: Maybe<Scalars['String']['output']>;
  /** Task status */
  status: Scalars['String']['output'];
  /** Resident/subject actor ID */
  subjectActorId?: Maybe<Scalars['String']['output']>;
  /** Task ID */
  taskId: Scalars['String']['output'];
};

/** Controlled substance count result */
export type FhirNarcoticCount = {
  __typename?: 'FhirNarcoticCount';
  /** Total doses administered */
  administeredTotal: Scalars['Float']['output'];
  /** DEA schedule */
  deaSchedule?: Maybe<Scalars['String']['output']>;
  /** Total quantity dispensed to this location */
  dispensedTotal: Scalars['Float']['output'];
  /** Drug name for display */
  drugName?: Maybe<Scalars['String']['output']>;
  /** Expected remaining count */
  expectedRemaining: Scalars['Float']['output'];
  /** Prescription/MedicationRequest ID */
  prescriptionId: Scalars['String']['output'];
  /** Whether count discrepancy requires investigation */
  requiresInvestigation: Scalars['Boolean']['output'];
  /** Resident/subject actor ID */
  subjectActorId: Scalars['String']['output'];
};

/** GraphQL representation of FHIR R4 Observation (from Medplum) */
export type FhirObservation = {
  __typename?: 'FhirObservation';
  /** Code (LOINC or other) */
  code: Scalars['String']['output'];
  /** Code display text */
  codeDisplay?: Maybe<Scalars['String']['output']>;
  /** Effective datetime */
  effectiveDatetime?: Maybe<Scalars['String']['output']>;
  /** Encounter reference */
  encounterId?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1O42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Patient reference */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Observation status */
  status: Scalars['String']['output'];
  /** Numeric value */
  valueQuantity?: Maybe<Scalars['Float']['output']>;
  /** String value */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Value unit */
  valueUnit?: Maybe<Scalars['String']['output']>;
};

/** Pagination info for connections */
export type FhirPageInfo = {
  __typename?: 'FhirPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

/** GraphQL representation of FHIR R4 Patient (from Medplum) */
export type FhirPatient = {
  __typename?: 'FhirPatient';
  /** Whether patient is active */
  active: Scalars['Boolean']['output'];
  /** Date of birth (ISO 8601) */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Full display name */
  displayName: Scalars['String']['output'];
  /** Patient family name */
  familyName?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1P42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** Patient given name(s) */
  givenName?: Maybe<Scalars['String']['output']>;
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Medical Record Number (MRN) - first identifier */
  mrn?: Maybe<Scalars['String']['output']>;
};

/** Prescription that needs refill */
export type FhirPrescriptionRefillNeeded = {
  __typename?: 'FhirPrescriptionRefillNeeded';
  /** Days of supply remaining */
  daysSupplyRemaining: Scalars['Int']['output'];
  /** Drug name */
  drugName: Scalars['String']['output'];
  /** Prescription/MedicationRequest ID */
  prescriptionId: Scalars['String']['output'];
  /** Number of refills remaining */
  refillsRemaining: Scalars['Int']['output'];
  /** Urgency level ("critical" if <= 3 days, "routine" otherwise) */
  urgency: Scalars['String']['output'];
};

/** GraphQL representation of FHIR R4 Procedure (from Medplum) */
export type FhirProcedure = {
  __typename?: 'FhirProcedure';
  /** Procedure code */
  code?: Maybe<Scalars['String']['output']>;
  /** Code display text */
  codeDisplay?: Maybe<Scalars['String']['output']>;
  /** Encounter reference */
  encounterId?: Maybe<Scalars['String']['output']>;
  /** FERP compressed ID (e.g., `$2!1R42`) - only set for mutation results */
  ferpId?: Maybe<Scalars['String']['output']>;
  /** Raw FHIR resource ID from Medplum (use for API calls) */
  fhirId: Scalars['String']['output'];
  /** Federated ID: `{tenant_id}:{fhir_id}` for cross-tenant uniqueness */
  id: Scalars['String']['output'];
  /** Last updated timestamp */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Patient reference */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Performed datetime */
  performedDatetime?: Maybe<Scalars['String']['output']>;
  /** Performed period end */
  performedPeriodEnd?: Maybe<Scalars['String']['output']>;
  /** Performed period start */
  performedPeriodStart?: Maybe<Scalars['String']['output']>;
  /** Procedure status */
  status: Scalars['String']['output'];
};

/** List of prescriptions needing refill */
export type FhirRefillNeededList = {
  __typename?: 'FhirRefillNeededList';
  /** Total count */
  count: Scalars['Int']['output'];
  /** Prescriptions that need refill */
  prescriptionsNeedingRefill: Array<FhirPrescriptionRefillNeeded>;
  /** Resident/subject actor ID */
  subjectActorId: Scalars['String']['output'];
  /** Threshold days used for this query */
  thresholdDays: Scalars['Int']['output'];
};

/** Version history for a FHIR resource */
export type FhirResourceVersionHistory = {
  __typename?: 'FhirResourceVersionHistory';
  /** Current (latest) version number */
  currentVersion: Scalars['Int']['output'];
  /** Resource ID */
  resourceId: Scalars['String']['output'];
  /** Resource type */
  resourceType: FhirStorageResourceType | '%future added value';
  /** All versions (newest first) */
  versions: Array<FhirStoredResource>;
};

/** FHIR resource types supported for direct storage (DRR-080) */
export const FhirStorageResourceType = {
  ADVERSE_EVENT: 'ADVERSE_EVENT',
  ALLERGY_INTOLERANCE: 'ALLERGY_INTOLERANCE',
  CARE_PLAN: 'CARE_PLAN',
  CARE_TEAM: 'CARE_TEAM',
  /** FHIR R4 Claim — RCM billing cycle (DRR-080) */
  CLAIM: 'CLAIM',
  /** FHIR R4 ClaimResponse — payer adjudication result (DRR-080) */
  CLAIM_RESPONSE: 'CLAIM_RESPONSE',
  CONDITION: 'CONDITION',
  DIAGNOSTIC_REPORT: 'DIAGNOSTIC_REPORT',
  ENCOUNTER: 'ENCOUNTER',
  GOAL: 'GOAL',
  IMMUNIZATION: 'IMMUNIZATION',
  MEDICATION: 'MEDICATION',
  MEDICATION_ADMINISTRATION: 'MEDICATION_ADMINISTRATION',
  /** FHIR R4 MedicationDispense — pharmacy fill/refill records */
  MEDICATION_DISPENSE: 'MEDICATION_DISPENSE',
  MEDICATION_REQUEST: 'MEDICATION_REQUEST',
  MEDICATION_STATEMENT: 'MEDICATION_STATEMENT',
  MEDICINAL_PRODUCT_INTERACTION: 'MEDICINAL_PRODUCT_INTERACTION',
  OBSERVATION: 'OBSERVATION',
  PATIENT: 'PATIENT',
  PRACTITIONER: 'PRACTITIONER',
  PROCEDURE: 'PROCEDURE',
  SERVICE_REQUEST: 'SERVICE_REQUEST',
} as const;

export type FhirStorageResourceType =
  (typeof FhirStorageResourceType)[keyof typeof FhirStorageResourceType];
/**
 * A FHIR resource stored in DynamoDB (DRR-080)
 *
 * Contains the full FHIR R4 JSON payload plus FERP audit metadata.
 */
export type FhirStoredResource = {
  __typename?: 'FhirStoredResource';
  /** Audit: operation that created this version */
  auditOperation: Scalars['String']['output'];
  /** Audit: when this version was created (ISO 8601) */
  createdAt: Scalars['String']['output'];
  /** Audit: who created this version */
  createdBy: Scalars['String']['output'];
  /** Full FHIR R4 JSON payload (as string for GraphQL transport) */
  fhirJson: Scalars['String']['output'];
  /** Whether this is the latest version */
  isLatest: Scalars['Boolean']['output'];
  /** Resource ID (Snowflake) */
  resourceId: Scalars['String']['output'];
  /** Resource type */
  resourceType: FhirStorageResourceType | '%future added value';
  /** Version number (1-based) */
  version: Scalars['Int']['output'];
  /** Reference to original resource ID (for versioned resources) */
  versionOf?: Maybe<Scalars['String']['output']>;
};

/** Connection type for paginated FHIR stored resources */
export type FhirStoredResourceConnection = {
  __typename?: 'FhirStoredResourceConnection';
  /** List of stored resources */
  items: Array<FhirStoredResource>;
  /** Total count (if available) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A FHIR resource stored in the dual-write system (DRR-080) */
export type FhirStoredResourceType = {
  __typename?: 'FhirStoredResourceType';
  auditOperation: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  fhirJson: Scalars['String']['output'];
  isLatest: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  tenantNum: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versionOf?: Maybe<Scalars['String']['output']>;
};

/** Group of medication tasks in a time window */
export type FhirTimeWindowGroup = {
  __typename?: 'FhirTimeWindowGroup';
  /** Tasks in this window */
  tasks: Array<FhirMedicationTask>;
  /** Time window identifier (e.g., "08:00", "12:00") */
  timeWindow: Scalars['String']['output'];
};

/** A field with different access levels across roles. */
export type FieldAccessDiff = {
  __typename?: 'FieldAccessDiff';
  /** Field name */
  fieldName: Scalars['String']['output'];
  /** Which role labels have this field hidden */
  hiddenFrom: Array<Scalars['String']['output']>;
  /** Which role labels can see this field */
  visibleTo: Array<Scalars['String']['output']>;
};

/** Condition for field visibility or disabled state */
export type FieldCondition = {
  __typename?: 'FieldCondition';
  /** Field name to check (can use dot notation for nested) */
  field: Scalars['String']['output'];
  /** Comparison operator */
  operator: ConditionOperator | '%future added value';
  /** Value to compare against (JSON-encoded for complex values) */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input version of FieldCondition */
export type FieldConditionInput = {
  field: Scalars['String']['input'];
  operator: ConditionOperator | '%future added value';
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Field Consensus Analysis */
export type FieldConsensus = {
  __typename?: 'FieldConsensus';
  /** Number of providers that agreed */
  agreedProviders: Scalars['Int']['output'];
  /** Consensus value (most common extraction) */
  consensusValue: Scalars['JSON']['output'];
  /** Field name/path */
  fieldName: Scalars['String']['output'];
  /** Outlier values (providers that disagreed) */
  outliers: Array<OutlierValue>;
  /** Total providers analyzed */
  totalProviders: Scalars['Int']['output'];
};

/**
 * Complete field constellation for a FERP primitive.
 * Loaded from field-constellations/{primitive_type}.yaml and enriched
 * with FormSchema metadata (label, type, PII classification).
 */
export type FieldConstellation = {
  __typename?: 'FieldConstellation';
  /** Active context profile ID (if one was applied) */
  activeContextId?: Maybe<Scalars['String']['output']>;
  /** Unique constellation identifier (e.g., "task-field-constellation") */
  constellationId: Scalars['String']['output'];
  /** Available context profiles for situation-based highlighting */
  contextProfiles: Array<ConstellationContextProfile>;
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** Primitive type (e.g., "Task", "Workflow") */
  primitiveType: Scalars['String']['output'];
  /** Promoted field count (only set when context_id is active) */
  promotedFieldCount: Scalars['Int']['output'];
  /** Concentric ring definitions with fields */
  rings: Array<ConstellationRing>;
  /** Total field count across all rings */
  totalFieldCount: Scalars['Int']['output'];
  /** Semantic version of this constellation definition */
  version: Scalars['String']['output'];
};

/** Field drift result for GraphQL */
export type FieldDriftResultGql = {
  __typename?: 'FieldDriftResultGql';
  assessedLabel: Scalars['String']['output'];
  assessedValue: Scalars['Int']['output'];
  confidence: Scalars['Float']['output'];
  consistentDays: Scalars['Int']['output'];
  driftAmount: Scalars['Float']['output'];
  driftDirection: DriftDirectionGql | '%future added value';
  driftSeverity: DriftSeverityGql | '%future added value';
  fieldId: Scalars['String']['output'];
  fieldLabel: Scalars['String']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  observedLabel: Scalars['String']['output'];
  observedValue: Scalars['Float']['output'];
  section: AssessmentSectionGql | '%future added value';
};

/** Field Extraction from LLM */
export type FieldExtraction = {
  __typename?: 'FieldExtraction';
  /** Confidence for this specific field */
  confidence: Scalars['Float']['output'];
  /** Field name/path */
  fieldName: Scalars['String']['output'];
  /** Extracted value (JSON) */
  value: Scalars['JSON']['output'];
};

/** Field mapping summary for GraphQL */
export type FieldMappingGql = {
  __typename?: 'FieldMappingGql';
  assessedPath: Scalars['String']['output'];
  fieldId: Scalars['String']['output'];
  fieldNumber: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  majorThreshold: Scalars['Int']['output'];
  minorThreshold: Scalars['Int']['output'];
  section: AssessmentSectionGql | '%future added value';
};

/** A single AI-suggested field with reasoning. */
export type FieldSuggestion = {
  __typename?: 'FieldSuggestion';
  /** Whether this field is critical for the stated goal */
  critical: Scalars['Boolean']['output'];
  /** The field_name from the constellation YAML */
  fieldName: Scalars['String']['output'];
  /** Why the AI recommends this field for the user's goal */
  reasoning: Scalars['String']['output'];
  /** Relevance score (0.0-1.0) */
  relevance: Scalars['Float']['output'];
  /** Ring this field belongs to */
  ringId: Scalars['String']['output'];
};

/** Input for requesting AI field suggestions. */
export type FieldSuggestionInput = {
  /** Optional context profile to scope suggestions (e.g., "healthcare-discharge") */
  contextId?: InputMaybe<Scalars['String']['input']>;
  /** Primitive type (e.g., "Task", "Workflow") */
  primitiveType: Scalars['String']['input'];
  /** What the user is trying to accomplish (free-text) */
  userGoal: Scalars['String']['input'];
  /** Industry vertical hint (e.g., "healthcare", "financial") */
  vertical?: InputMaybe<Scalars['String']['input']>;
};

/** Response from the suggestFields mutation. */
export type FieldSuggestionResponse = {
  __typename?: 'FieldSuggestionResponse';
  /** Context profile used (if any) */
  contextId?: Maybe<Scalars['String']['output']>;
  /** Primitive type the suggestions apply to */
  primitiveType: Scalars['String']['output'];
  /** LLM provider that generated suggestions (for audit trail) */
  provider: Scalars['String']['output'];
  /** Ordered list of suggested fields (highest relevance first) */
  suggestions: Array<FieldSuggestion>;
  /** Total fields considered from the constellation */
  totalFieldsConsidered: Scalars['Int']['output'];
};

/** Input for the fillStateForm mutation. */
export type FillStateFormInput = {
  /**
   * Context identifier — typically a workflow instance ID or entity ID
   * that provides the data context for field resolution.
   */
  contextId: Scalars['String']['input'];
  /**
   * Optional: pre-resolved field values. If provided, these override
   * values resolved from the context. Keys are AcroForm field names.
   */
  fieldOverrides?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * If true, output is a flat PDF (no XFA, no Adobe Reader needed).
   * The filled form is rendered as standard PDF text/graphics.
   * Default: false (returns filled XFA PDF).
   */
  flatten?: Scalars['Boolean']['input'];
  /** Form field map config ID (e.g., "ffm-mn-dhs6790-001"). */
  formFieldMapId: Scalars['String']['input'];
  /**
   * Lock pre-filled fields as read-only (default: false).
   * Care coordinator can still edit unfilled (manual) fields.
   */
  lockFilledFields?: Scalars['Boolean']['input'];
};

/** Result of a form fill operation. */
export type FillStateFormResult = {
  __typename?: 'FillStateFormResult';
  /** AcroForm fields left blank (manual or no data available). */
  blankFields: Array<Scalars['String']['output']>;
  /** Document primitive ID for the filled PDF copy. */
  documentId: Scalars['String']['output'];
  /** Fields that were auto-filled from FERP data. */
  filledFields: Array<Scalars['String']['output']>;
  /** Non-fatal warnings (missing data, type mismatches, etc.). */
  warnings: Array<Scalars['String']['output']>;
};

/**
 * Filter configuration for zero hardcoded values
 * LIFE-CRITICAL: Dynamic UI configuration
 */
export type FilterConfigurationGql = {
  __typename?: 'FilterConfigurationGql';
  availableValues: Array<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  defaultValues: Array<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  filterType: Scalars['String']['output'];
  isMultiSelect: Scalars['Boolean']['output'];
  isSearchable: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
};

/**
 * A constellation template with lens filters applied.
 *
 * This is the result of `constellationWithLens(constellationId, lensId)` —
 * the constellation structure annotated with highlight/de-emphasize markers
 * from the lens's `ring_filters`.
 */
export type FilteredConstellation = {
  __typename?: 'FilteredConstellation';
  /** Onboarding checklist from the lens (if present) */
  checklist: Array<LensChecklistStep>;
  /** The underlying constellation */
  constellationId: Scalars['String']['output'];
  constellationName: Scalars['String']['output'];
  /** The lens applied */
  lensId: Scalars['String']['output'];
  lensName: Scalars['String']['output'];
  /** Active mode */
  mode: Scalars['String']['output'];
  /** Filtered rings with highlight/de-emphasize annotations */
  rings: Array<FilteredRing>;
};

/** A constellation ring with lens filter annotations applied. */
export type FilteredRing = {
  __typename?: 'FilteredRing';
  color?: Maybe<Scalars['String']['output']>;
  /** Config IDs de-emphasized by the lens (should be visually dimmed) */
  deEmphasized: Array<Scalars['String']['output']>;
  /** Sections to expand (for regulatory rings) */
  expandSections: Array<Scalars['String']['output']>;
  /** Fields the lens wants hidden for this ring */
  hideFields: Array<Scalars['String']['output']>;
  /** Config IDs highlighted by the lens (should be visually prominent) */
  highlighted: Array<Scalars['String']['output']>;
  /** Instance status fields (for instance mode) */
  instanceStatusFields: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** What this ring shows in the current mode */
  modeDescription?: Maybe<Scalars['String']['output']>;
  /** Onboarding instruction */
  onboardingAction?: Maybe<Scalars['String']['output']>;
  /** Provisioning status from constellation (draft/locked) */
  provisioning?: Maybe<Scalars['String']['output']>;
  /** Ring identity */
  ringId: Scalars['String']['output'];
  ringNumber: Scalars['Int']['output'];
  shape?: Maybe<Scalars['String']['output']>;
  /** Fields the lens wants shown for this ring */
  showFields: Array<Scalars['String']['output']>;
};

/** GraphQL input for finishing biometric authentication */
export type FinishBiometricAuthenticationInput = {
  /** JSON-encoded PublicKeyCredential assertion from frontend */
  assertionJson: Scalars['String']['input'];
  /** Session ID from start_biometric_authentication */
  sessionId: Scalars['String']['input'];
  /** Tenant ID for backend routing (GitHub Issue #378) */
  tenantId: Scalars['String']['input'];
};

/** GraphQL input for finishing biometric registration */
export type FinishBiometricRegistrationInput = {
  /** JSON-encoded RegisteredPublicKeyCredential from frontend */
  credentialJson: Scalars['String']['input'];
  /**
   * Optional human-readable device name
   * Examples: "iPhone 14 Pro", "MacBook Pro Touch ID", "YubiKey Bio"
   */
  deviceName?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID for multi-tenant isolation (FERP requirement) */
  tenantId: Scalars['String']['input'];
  /** User ID completing registration */
  userId: Scalars['String']['input'];
};

/** Result of an XFA preview flatten operation. */
export type FlattenXfaPreviewResult = {
  __typename?: 'FlattenXfaPreviewResult';
  /** Document primitive ID for the flattened PDF. */
  documentId: Scalars['String']['output'];
  /** Number of fillable fields detected in the XFA template. */
  fieldCount: Scalars['Int']['output'];
  /** Non-fatal warnings from the flatten process. */
  warnings: Array<Scalars['String']['output']>;
};

/** Activity bucket for temporal heatmap */
export type FlowMapActivityBucket = {
  __typename?: 'FlowMapActivityBucket';
  /** Actor ID */
  actorId: Scalars['String']['output'];
  /** Hour of day (0-23) */
  hourOfDay: Scalars['Int']['output'];
  /** Intersection count (tasks shared with other actors) */
  intersectionCount: Scalars['Int']['output'];
  /** Task count in this bucket */
  taskCount: Scalars['Int']['output'];
};

/** Date range input for flow map queries */
export type FlowMapDateRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

/** Workflow intersection point */
export type FlowMapIntersection = {
  __typename?: 'FlowMapIntersection';
  /** Actor IDs who share this instance */
  actorIds: Array<Scalars['String']['output']>;
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /** When the intersection occurred */
  timestamp: Scalars['DateTime']['output'];
};

/** Performer (staff member) in the flow map */
export type FlowMapPerformer = {
  __typename?: 'FlowMapPerformer';
  /** Actor ID */
  actorId: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Role (ULP, RN, etc.) */
  role: Scalars['String']['output'];
  /** Task count by source */
  taskCountBySource: Array<TaskCountBySource>;
  /** Task count by subject */
  taskCountBySubject: Array<TaskCountBySubject>;
};

/** Source of work in the flow map (regulation, care plan, training requirement) */
export type FlowMapSource = {
  __typename?: 'FlowMapSource';
  /** Source ID (config ID like rs-4-1-001) */
  id: Scalars['String']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** Source type */
  sourceType: FlowMapSourceType | '%future added value';
  /** Total task count from this source */
  taskCount: Scalars['Int']['output'];
};

/** Types of sources in the flow map */
export const FlowMapSourceType = {
  /** Care plan requirement */
  CARE_PLAN: 'CARE_PLAN',
  /** Compliance requirement */
  COMPLIANCE: 'COMPLIANCE',
  /** Regulatory requirement (144G, etc.) */
  REGULATION: 'REGULATION',
  /** Training requirement */
  TRAINING_REQ: 'TRAINING_REQ',
} as const;

export type FlowMapSourceType = (typeof FlowMapSourceType)[keyof typeof FlowMapSourceType];
/** Subject (resident, project, case) in the flow map */
export type FlowMapSubject = {
  __typename?: 'FlowMapSubject';
  /** Actor ID */
  actorId: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Task count by performer */
  taskCountByPerformer: Array<TaskCountByPerformer>;
};

/**
 * Persistent focus state for "I'm working on actor X" across page navigation.
 * Stored in Valkey with 8-hour TTL (shift length). Per-device, not cross-device.
 * CRITICAL events from non-focused subjects break through the focus filter.
 */
export type FocusContext = {
  __typename?: 'FocusContext';
  /** When focus expires (ISO 8601) */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Focus perspective: "subject" (work FOR this actor) or "performer" (work BY this actor) */
  perspective: Scalars['String']['output'];
  /** When focus was set (ISO 8601) */
  setAt?: Maybe<Scalars['DateTime']['output']>;
  /** The subject actor being focused on (or null if no focus) */
  subjectActorId?: Maybe<Scalars['String']['output']>;
  /** Display name of the focused subject (resolved from actor) */
  subjectDisplayName?: Maybe<Scalars['String']['output']>;
};

export type FoodServiceBrandCount = {
  __typename?: 'FoodServiceBrandCount';
  brand: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

/** A delivery assignment */
export type FoodServiceDelivery = {
  __typename?: 'FoodServiceDelivery';
  brand: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerPhone?: Maybe<Scalars['String']['output']>;
  deliveryAddress: Scalars['String']['output'];
  estimatedArrivalMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  items: Array<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  pickedUpAt?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
};

/** Dish execution status (per-item workflow state) */
export const FoodServiceDishStatus = {
  COOKING: 'COOKING',
  PLATING: 'PLATING',
  PREP: 'PREP',
  QUEUED: 'QUEUED',
  READY: 'READY',
} as const;

export type FoodServiceDishStatus =
  (typeof FoodServiceDishStatus)[keyof typeof FoodServiceDishStatus];
/** Driver assignment info */
export type FoodServiceDriver = {
  __typename?: 'FoodServiceDriver';
  currentDeliveryId?: Maybe<Scalars['String']['output']>;
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  locationLat?: Maybe<Scalars['Float']['output']>;
  locationLng?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  status: FoodServiceDriverStatus | '%future added value';
};

/** Driver's daily statistics */
export type FoodServiceDriverDailyStats = {
  __typename?: 'FoodServiceDriverDailyStats';
  actorId: Scalars['String']['output'];
  avgDeliveryMinutes: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  deliveriesCompleted: Scalars['Int']['output'];
  milesDriven: Scalars['Float']['output'];
  tipsCents: Scalars['Int']['output'];
};

/** Driver availability status */
export const FoodServiceDriverStatus = {
  AVAILABLE: 'AVAILABLE',
  OFFLINE: 'OFFLINE',
  ON_DELIVERY: 'ON_DELIVERY',
} as const;

export type FoodServiceDriverStatus =
  (typeof FoodServiceDriverStatus)[keyof typeof FoodServiceDriverStatus];
/** HACCP compliance report for a date range */
export type FoodServiceHaccpReport = {
  __typename?: 'FoodServiceHaccpReport';
  correctiveActionsTaken: Scalars['Int']['output'];
  criticalViolations: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  sanitationComplianceRate: Scalars['Float']['output'];
  sanitationRecords: Array<FoodServiceSanitationRecord>;
  startDate: Scalars['Int']['output'];
  tempLogComplianceRate: Scalars['Float']['output'];
  tempLogs: Array<FoodServiceTempLog>;
};

/** Kitchen metrics for manager dashboard */
export type FoodServiceKitchenMetrics = {
  __typename?: 'FoodServiceKitchenMetrics';
  avgPrepTimeMinutes: Scalars['Float']['output'];
  ordersByBrand: Array<FoodServiceBrandCount>;
  ordersInProgress: Scalars['Int']['output'];
  ordersToday: Scalars['Int']['output'];
  stationUtilization: Array<FoodServiceStationMetric>;
};

/** An order in the kitchen system */
export type FoodServiceOrder = {
  __typename?: 'FoodServiceOrder';
  brand: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  elapsedSeconds: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  items: Array<FoodServiceOrderItem>;
  orderNumber: Scalars['String']['output'];
  slaTargetMinutes: Scalars['Int']['output'];
  specialInstructions?: Maybe<Scalars['String']['output']>;
  station?: Maybe<FoodServiceStation | '%future added value'>;
  status: FoodServiceOrderStatus | '%future added value';
};

/** An item within an order */
export type FoodServiceOrderItem = {
  __typename?: 'FoodServiceOrderItem';
  elapsedSeconds: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  modifications: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  station: FoodServiceStation | '%future added value';
  status: FoodServiceDishStatus | '%future added value';
  targetSeconds: Scalars['Int']['output'];
};

/** Order status in the fulfillment workflow */
export const FoodServiceOrderStatus = {
  CANCELLED: 'CANCELLED',
  DELIVERED: 'DELIVERED',
  DISPATCHED: 'DISPATCHED',
  IN_PREP: 'IN_PREP',
  QUALITY_CHECK: 'QUALITY_CHECK',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  RECEIVED: 'RECEIVED',
} as const;

export type FoodServiceOrderStatus =
  (typeof FoodServiceOrderStatus)[keyof typeof FoodServiceOrderStatus];
/** Daily sanitation completion record */
export type FoodServiceSanitationRecord = {
  __typename?: 'FoodServiceSanitationRecord';
  completedAt?: Maybe<Scalars['Int']['output']>;
  completedByActorId?: Maybe<Scalars['String']['output']>;
  completedTasks: Scalars['Int']['output'];
  completionPercentage: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  taskGroupName: Scalars['String']['output'];
  taskGroupRef: Scalars['String']['output'];
  totalTasks: Scalars['Int']['output'];
};

/** Kitchen station identifier */
export const FoodServiceStation = {
  COLD_PREP: 'COLD_PREP',
  EXPO: 'EXPO',
  FRYER: 'FRYER',
  GRILL: 'GRILL',
  PIZZA_OVEN: 'PIZZA_OVEN',
  WOK: 'WOK',
} as const;

export type FoodServiceStation = (typeof FoodServiceStation)[keyof typeof FoodServiceStation];
/** Cook's station assignment from actor metadata */
export type FoodServiceStationAssignment = {
  __typename?: 'FoodServiceStationAssignment';
  actorId: Scalars['String']['output'];
  assignedAt?: Maybe<Scalars['Int']['output']>;
  station?: Maybe<FoodServiceStation | '%future added value'>;
  stationName: Scalars['String']['output'];
};

export type FoodServiceStationMetric = {
  __typename?: 'FoodServiceStationMetric';
  avgTimeSeconds: Scalars['Int']['output'];
  ordersInQueue: Scalars['Int']['output'];
  station: FoodServiceStation | '%future added value';
};

/** Temperature log entry for HACCP compliance */
export type FoodServiceTempLog = {
  __typename?: 'FoodServiceTempLog';
  correctiveAction?: Maybe<Scalars['String']['output']>;
  equipmentId: Scalars['String']['output'];
  equipmentName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inRange: Scalars['Boolean']['output'];
  recordedAt: Scalars['Int']['output'];
  recordedByActorId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  temperatureF: Scalars['Float']['output'];
};

/** Form action button configuration */
export type FormAction = {
  __typename?: 'FormAction';
  /** Confirmation message before action */
  confirmMessage?: Maybe<Scalars['String']['output']>;
  /** Action identifier */
  id: Scalars['String']['output'];
  /** Whether this is the primary action */
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** Button label */
  label: Scalars['String']['output'];
  /** GraphQL mutation name to execute */
  mutation?: Maybe<Scalars['String']['output']>;
  /** Button variant (primary, secondary, danger) */
  variant?: Maybe<Scalars['String']['output']>;
};

export type FormActionInput = {
  confirmMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  mutation?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldConfigInput = {
  component: Scalars['String']['input'];
  customRendererProps?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rendererKey?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  visibleWhen?: InputMaybe<Scalars['String']['input']>;
  widgetProps?: InputMaybe<Scalars['String']['input']>;
};

/** Complete definition of a form field */
export type FormFieldDefinition = {
  __typename?: 'FormFieldDefinition';
  /** Whether changes to this field must be audited */
  auditRequired: Scalars['Boolean']['output'];
  /** Compliance frameworks applicable to this field (e.g., ["HIPAA", "SOX"]) */
  complianceFrameworks?: Maybe<Array<Scalars['String']['output']>>;
  /** Nested form schema for COMPOSITE fields */
  compositeFields?: Maybe<Array<FormFieldDefinition>>;
  /** Configuration for COMPUTED fields (derived values) */
  computedConfig?: Maybe<ComputedFieldConfig>;
  /** Zen Engine rule ID for custom validation */
  customValidation?: Maybe<Scalars['String']['output']>;
  /** Default value (JSON-encoded) */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /**
   * Statutory definition reference for this field's subject concept.
   * Points to a `tag:def:*` entry in care-vocabulary.yaml.
   * When present, `label`, `help_text`, `description`, and `placeholder`
   * may contain `$def:` expressions resolved from the definition registry.
   * Also enables the [§] tooltip showing full statutory definition in UI.
   * Example: `"tag:def:144g-ulp"` links this field to the MN 144G.08 Subd 3
   * definition of Unlicensed Personnel.
   */
  definitionRef?: Maybe<Scalars['String']['output']>;
  /** Disable field when condition is met */
  disabledWhen?: Maybe<FieldCondition>;
  /** Field type determines rendering component */
  fieldType: FormFieldType | '%future added value';
  /** Configuration for GRID fields (inline table editor) */
  gridConfig?: Maybe<GridConfig>;
  /**
   * Whether this field can be used as a group-by key in table views.
   * Set true for fields with low-cardinality, human-readable values
   * (e.g., status, priority, taskGroupRef). Frontend reads this via
   * useTableColumns().groupableFields — no hardcoded per-primitive lists.
   */
  groupable: Scalars['Boolean']['output'];
  /** Help text displayed below field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** Configuration for HIERARCHICAL_SELECT fields (tree picker) */
  hierarchicalConfig?: Maybe<HierarchicalConfig>;
  /** Display label */
  label: Scalars['String']['output'];
  /**
   * LLM transit gate (DRR-169): what the edge server does before sending to Claude.
   * Strip = never sent, Safe = passed through, Scan = Presidio NER before transit.
   * Defaults to Strip (fail-closed) for backward compatibility with existing DDB records.
   */
  llmGate: LlmGateClassification | '%future added value';
  /** Whether to mask value on display (for SSN, etc.) */
  maskOnDisplay: Scalars['Boolean']['output'];
  /** Configuration for MASTER_DETAIL fields (cascading selects) */
  masterDetailConfig?: Maybe<MasterDetailConfig>;
  max?: Maybe<Scalars['Float']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  /**
   * Minimum tier required to see this field (None = all tiers).
   * Uses lenient deserialization — unknown tier values (e.g. stale DDB data)
   * are treated as None rather than crashing the form.
   */
  minimumTier?: Maybe<ModuleTier | '%future added value'>;
  /** Unique field identifier (used as form field name) */
  name: Scalars['String']['output'];
  /** Options for SELECT/MULTISELECT fields */
  options?: Maybe<Array<SelectOption>>;
  /** Display order within section (lower = earlier) */
  order?: Maybe<Scalars['Int']['output']>;
  /** JSONPath to the data location (e.g., "name.given[0]", "address.line1") */
  path: Scalars['String']['output'];
  /** Regex pattern for validation */
  pattern?: Maybe<Scalars['String']['output']>;
  /** Error message for pattern validation */
  patternMessage?: Maybe<Scalars['String']['output']>;
  /** PII classification for audit and masking */
  piiClassification: PiiDataClassification | '%future added value';
  /** Placeholder text */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Make field read-only when condition is met */
  readonlyWhen?: Maybe<FieldCondition>;
  /** Configuration for REFERENCE fields */
  referenceConfig?: Maybe<ReferenceConfig>;
  /** Whether field is required */
  required: Scalars['Boolean']['output'];
  /**
   * Scope required to see this field (None = visible to all scopes).
   * If user lacks this scope, field is filtered from the response.
   * Example: "clinical:full" → only RN/ALD see SSN/diagnosis fields.
   */
  requiredScope?: Maybe<Scalars['String']['output']>;
  /** Show field only when condition is met */
  visibleWhen?: Maybe<FieldCondition>;
  /** Field width in grid (1-12, or "full", "half", "third", "quarter") */
  width?: Maybe<Scalars['String']['output']>;
};

/** Input version of FormFieldDefinition */
export type FormFieldDefinitionInput = {
  auditRequired: Scalars['Boolean']['input'];
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  computedConfig?: InputMaybe<ComputedFieldConfigInput>;
  customValidation?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** DRR-189: Statutory definition reference (tag:def:* from care-vocabulary.yaml). */
  definitionRef?: InputMaybe<Scalars['String']['input']>;
  disabledWhen?: InputMaybe<FieldConditionInput>;
  fieldType: FormFieldType | '%future added value';
  gridConfig?: InputMaybe<GridConfigInput>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  hierarchicalConfig?: InputMaybe<HierarchicalConfigInput>;
  label: Scalars['String']['input'];
  /** LLM transit gate (DRR-169). Defaults to Strip (fail-closed). */
  llmGate: LlmGateClassification | '%future added value';
  maskOnDisplay: Scalars['Boolean']['input'];
  masterDetailConfig?: InputMaybe<MasterDetailConfigInput>;
  max?: InputMaybe<Scalars['Float']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum tier required to see this field (DRR-045) */
  minimumTier?: InputMaybe<ModuleTier | '%future added value'>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<SelectOptionInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  path: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  patternMessage?: InputMaybe<Scalars['String']['input']>;
  piiClassification: PiiDataClassification | '%future added value';
  placeholder?: InputMaybe<Scalars['String']['input']>;
  readonlyWhen?: InputMaybe<FieldConditionInput>;
  referenceConfig?: InputMaybe<ReferenceConfigInput>;
  required: Scalars['Boolean']['input'];
  /** Scope required to see this field (DRR-103). None = visible to all. */
  requiredScope?: InputMaybe<Scalars['String']['input']>;
  visibleWhen?: InputMaybe<FieldConditionInput>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Supported field types for schema-driven forms.
 * Maps to frontend FieldType in renderer/types.ts
 */
export const FormFieldType = {
  /** Structured address input */
  ADDRESS: 'ADDRESS',
  /** Checkbox (true/false) */
  BOOLEAN: 'BOOLEAN',
  /** Code editor with syntax highlighting */
  CODE: 'CODE',
  /** Nested/composite form fields */
  COMPOSITE: 'COMPOSITE',
  /** Computed/derived field (read-only, value from expression) */
  COMPUTED: 'COMPUTED',
  /** Currency input with formatting */
  CURRENCY: 'CURRENCY',
  /** Date picker (no time) */
  DATE: 'DATE',
  /** Date and time picker */
  DATETIME: 'DATETIME',
  /** Email with validation */
  EMAIL: 'EMAIL',
  /** File upload */
  FILE: 'FILE',
  /** Editable data grid (inline table editing) */
  GRID: 'GRID',
  /** Hidden field (carries data, not displayed) */
  HIDDEN: 'HIDDEN',
  /** Hierarchical tree selection (e.g., chart of accounts, org chart) */
  HIERARCHICAL_SELECT: 'HIERARCHICAL_SELECT',
  /** Image/photo display field. Value: Wasabi S3 URL or base64 data URI. */
  IMAGE: 'IMAGE',
  /** JSON editor */
  JSON: 'JSON',
  /** Master-detail linked selects (parent drives child options) */
  MASTER_DETAIL: 'MASTER_DETAIL',
  /** Medical Record Number */
  MRN: 'MRN',
  /** Multi-select dropdown */
  MULTISELECT: 'MULTISELECT',
  /** National Provider Identifier */
  NPI: 'NPI',
  /** Numeric input */
  NUMBER: 'NUMBER',
  /** Phone number with formatting */
  PHONE: 'PHONE',
  /** Rating input (stars, etc.) */
  RATING: 'RATING',
  /** Read-only display field */
  READONLY: 'READONLY',
  /** Entity reference lookup (e.g., select a Patient) */
  REFERENCE: 'REFERENCE',
  /** Rich text editor */
  RICH_TEXT: 'RICH_TEXT',
  /** Single-select dropdown */
  SELECT: 'SELECT',
  /** Signature capture */
  SIGNATURE: 'SIGNATURE',
  /** Social Security Number (masked) */
  SSN: 'SSN',
  /** Single-line text input */
  TEXT: 'TEXT',
  /** Multi-line text area */
  TEXTAREA: 'TEXTAREA',
  /** Time picker (no date) */
  TIME: 'TIME',
  /** Toggle switch */
  TOGGLE: 'TOGGLE',
} as const;

export type FormFieldType = (typeof FormFieldType)[keyof typeof FormFieldType];
/** Form layout configuration */
export type FormLayout = {
  __typename?: 'FormLayout';
  /** Cancel button label */
  cancelLabel?: Maybe<Scalars['String']['output']>;
  /** Layout type: "single-page", "stepper", "tabs", "accordion" */
  layoutType: Scalars['String']['output'];
  /** Sections in the form */
  sections: Array<FormSection>;
  /** Whether to show progress indicator (for stepper) */
  showProgress?: Maybe<Scalars['Boolean']['output']>;
  /** Submit button label */
  submitLabel?: Maybe<Scalars['String']['output']>;
};

/** Input version of FormLayout */
export type FormLayoutInput = {
  cancelLabel?: InputMaybe<Scalars['String']['input']>;
  layoutType: Scalars['String']['input'];
  sections: Array<FormSectionInput>;
  showProgress?: InputMaybe<Scalars['Boolean']['input']>;
  submitLabel?: InputMaybe<Scalars['String']['input']>;
};

/** Form schema pattern metadata */
export type FormPatternMetadata = {
  __typename?: 'FormPatternMetadata';
  /** Description of when to use this pattern */
  description?: Maybe<Scalars['String']['output']>;
  /** Layout type constant (e.g., "SINGLE_PAGE", "WIZARD") */
  layoutType: Scalars['String']['output'];
  /** Pattern name (e.g., "SinglePage", "Wizard") */
  name: Scalars['String']['output'];
};

/**
 * Safety level determines UI behavior for form submission.
 * CRITICAL and LIFE_CRITICAL require confirmation dialogs.
 */
export const FormSafetyLevel = {
  /** Significant impact, requires confirmation */
  CRITICAL: 'CRITICAL',
  /** Requires attention but not immediately dangerous */
  ELEVATED: 'ELEVATED',
  /** Patient harm or financial loss risk, dual approval may be required */
  LIFE_CRITICAL: 'LIFE_CRITICAL',
  /** Normal business operations */
  STANDARD: 'STANDARD',
} as const;

export type FormSafetyLevel = (typeof FormSafetyLevel)[keyof typeof FormSafetyLevel];
/** Complete form schema for a subgraph entity */
export type FormSchema = {
  __typename?: 'FormSchema';
  /** GraphQL mutation for create */
  createMutation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Description of what this form is for */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name for the form */
  displayName: Scalars['String']['output'];
  /** Entity type (e.g., "Patient", "Worker", "Invoice") */
  entityType: Scalars['String']['output'];
  /** GraphQL query for fetching entity */
  fetchQuery?: Maybe<Scalars['String']['output']>;
  /** All field definitions */
  fields: Array<FormFieldDefinition>;
  /** Layout configuration */
  layout: FormLayout;
  /** Safety level determines confirmation requirements */
  safetyLevel: FormSafetyLevel | '%future added value';
  /** Subgraph this schema belongs to (e.g., "fhir", "payroll", "ofbiz") */
  subgraph: Scalars['String']['output'];
  /** GraphQL mutation for update */
  updateMutation?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Cross-field validation rules */
  validations?: Maybe<Array<FormValidationRule>>;
  /** Schema version (semver) */
  version: Scalars['String']['output'];
  /**
   * Detail panel view configuration (DRR-165: FormSchema-driven detail tabs).
   * JSON structure: `{ "detail_tabs": [{ "id", "label", "icon", "renderer", "order", "props" }] }`
   * When null, frontend uses default hardcoded tabs.
   */
  views?: Maybe<Scalars['JSON']['output']>;
};

/** GraphQL output for applied edit history */
export type FormSchemaAppliedEditOutput = {
  __typename?: 'FormSchemaAppliedEditOutput';
  appliedAt: Scalars['String']['output'];
  appliedBy: Scalars['String']['output'];
  jsonAfter: Scalars['String']['output'];
  jsonBefore: Scalars['String']['output'];
  suggestionId: Scalars['String']['output'];
};

/** GraphQL output type for draft */
export type FormSchemaDraftOutput = {
  __typename?: 'FormSchemaDraftOutput';
  createdAt: Scalars['String']['output'];
  currentJson: Scalars['String']['output'];
  draftId: Scalars['String']['output'];
  editHistory: Array<FormSchemaAppliedEditOutput>;
  entityType: Scalars['String']['output'];
  pendingSuggestions: Array<FormSchemaEditSuggestionOutput>;
  status: Scalars['String']['output'];
  subgraph: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** GraphQL output for draft summary (list view) */
export type FormSchemaDraftSummaryOutput = {
  __typename?: 'FormSchemaDraftSummaryOutput';
  createdAt: Scalars['String']['output'];
  draftId: Scalars['String']['output'];
  editCount: Scalars['Int']['output'];
  entityType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subgraph: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** GraphQL output type for edit suggestion */
export type FormSchemaEditSuggestionOutput = {
  __typename?: 'FormSchemaEditSuggestionOutput';
  affectedFields: Array<Scalars['String']['output']>;
  complianceImpact: Scalars['Boolean']['output'];
  confidence: Scalars['Float']['output'];
  explanation: Scalars['String']['output'];
  jsonPatch: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  piiClassification?: Maybe<Scalars['String']['output']>;
  safetyLevelChange?: Maybe<Scalars['String']['output']>;
  suggestionId: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/**
 * FormSchema filtered for LLM transit (DRR-169).
 *
 * Wraps a filtered `GqlFormSchema` (Strip fields removed) with a summary
 * showing which fields fall in each LLM gate category.
 */
export type FormSchemaForLlm = {
  __typename?: 'FormSchemaForLlm';
  /**
   * Summary of fields by LLM gate classification (before filtering).
   * Shows stripped field names so the caller knows what was excluded.
   */
  fieldSummary: LlmGateFieldSummary;
  /** The form schema with Strip fields removed. Only Safe + Scan fields remain. */
  schema: FormSchema;
};

/** Input for creating/updating a form schema */
export type FormSchemaInput = {
  createMutation?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  fetchQuery?: InputMaybe<Scalars['String']['input']>;
  fields: Array<FormFieldDefinitionInput>;
  layout: FormLayoutInput;
  safetyLevel: FormSafetyLevel | '%future added value';
  subgraph: Scalars['String']['input'];
  updateMutation?: InputMaybe<Scalars['String']['input']>;
  validations?: InputMaybe<Array<FormValidationRuleInput>>;
  version: Scalars['String']['input'];
};

/** Tenant-specific override for a form schema */
export type FormSchemaOverride = {
  __typename?: 'FormSchemaOverride';
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Custom fields to add (appended to base schema) */
  customFields?: Maybe<Array<FormFieldDefinition>>;
  /** Custom validation rules */
  customValidations?: Maybe<Array<FormValidationRule>>;
  /** Override description (lever 7 — DRR-160) */
  description?: Maybe<Scalars['String']['output']>;
  /** Override display name (lever 6 — DRR-160) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Fields to hide */
  hiddenFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Field label overrides (field_name -> new_label) */
  labelOverrides?: Maybe<Scalars['String']['output']>;
  /** Fields to make read-only */
  readonlyFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Subgraph */
  subgraph: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Input for tenant override */
export type FormSchemaOverrideInput = {
  customFields?: InputMaybe<Array<FormFieldDefinitionInput>>;
  customValidations?: InputMaybe<Array<FormValidationRuleInput>>;
  /** Override description (lever 7 — DRR-160) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Override display name (lever 6 — DRR-160) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
  hiddenFields?: InputMaybe<Array<Scalars['String']['input']>>;
  labelOverrides?: InputMaybe<Scalars['String']['input']>;
  readonlyFields?: InputMaybe<Array<Scalars['String']['input']>>;
  subgraph: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/**
 * DRR-207: Summary of a FormSchemaOverride for list views.
 * Lighter than full GqlFormSchemaOverride — just counts, not full field data.
 */
export type FormSchemaOverrideSummary = {
  __typename?: 'FormSchemaOverrideSummary';
  /** Number of custom fields added */
  customFieldCount: Scalars['Int']['output'];
  /** Entity type (e.g., "FhirPatient") */
  entityType: Scalars['String']['output'];
  /** Number of hidden fields */
  hiddenFieldCount: Scalars['Int']['output'];
  /** Number of label overrides */
  labelOverrideCount: Scalars['Int']['output'];
  /** Whether this override is mandatory for compliance in the jurisdiction */
  mandatory: Scalars['Boolean']['output'];
  /** Number of readonly fields */
  readonlyFieldCount: Scalars['Int']['output'];
  /** Statute reference requiring this override (e.g., "MN 144G.67") */
  statuteRef?: Maybe<Scalars['String']['output']>;
  /** Subgraph (e.g., "fhir") */
  subgraph: Scalars['String']['output'];
};

/** Section within a form (groups related fields) */
export type FormSection = {
  __typename?: 'FormSection';
  /** Initial collapsed state */
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether section can be collapsed */
  collapsible?: Maybe<Scalars['Boolean']['output']>;
  /** Number of columns (1, 2, or 3) */
  columns?: Maybe<Scalars['Int']['output']>;
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Field names in this section */
  fields: Array<Scalars['String']['output']>;
  /** Section identifier */
  id: Scalars['String']['output'];
  /** Minimum tier required to see this section (DRR-045) */
  minimumTier?: Maybe<ModuleTier | '%future added value'>;
  /** Display order */
  order?: Maybe<Scalars['Int']['output']>;
  /** Safety warning displayed at top of section */
  safetyWarning?: Maybe<Scalars['String']['output']>;
  /** Section title */
  title: Scalars['String']['output'];
};

/** Input version of FormSection */
export type FormSectionInput = {
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  collapsible?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** Minimum tier required to see this section (DRR-045) */
  minimumTier?: InputMaybe<ModuleTier | '%future added value'>;
  order?: InputMaybe<Scalars['Int']['input']>;
  safetyWarning?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Form validation configuration */
export type FormValidation = {
  __typename?: 'FormValidation';
  customValidators: Array<Scalars['JSON']['output']>;
  mode: Scalars['String']['output'];
  scrollToError?: Maybe<Scalars['Boolean']['output']>;
  showErrors: Scalars['String']['output'];
  validateOnBlur?: Maybe<Scalars['Boolean']['output']>;
  validateOnChange?: Maybe<Scalars['Boolean']['output']>;
};

/** Cross-field or form-level validation rule */
export type FormValidationRule = {
  __typename?: 'FormValidationRule';
  /** CEL expression or Zen Engine rule ID */
  expression: Scalars['String']['output'];
  /** Fields involved in this validation */
  fields: Array<Scalars['String']['output']>;
  /** Rule identifier */
  id: Scalars['String']['output'];
  /** Error message when validation fails */
  message: Scalars['String']['output'];
  /** Severity: "error", "warning", "info" */
  severity?: Maybe<Scalars['String']['output']>;
};

/** Input version of FormValidationRule */
export type FormValidationRuleInput = {
  expression: Scalars['String']['input'];
  fields: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  message: Scalars['String']['input'];
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Form layout configuration (forms_api) */
export type FormsLayoutOutput = {
  __typename?: 'FormsLayoutOutput';
  columns?: Maybe<Scalars['Int']['output']>;
  layoutType: Scalars['String']['output'];
  navigation?: Maybe<Scalars['JSON']['output']>;
  responsive?: Maybe<Scalars['JSON']['output']>;
  sections: Array<FormsSectionOutput>;
};

/** Form section (forms_api) */
export type FormsSectionOutput = {
  __typename?: 'FormsSectionOutput';
  collapsible?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiallyCollapsed?: Maybe<Scalars['Boolean']['output']>;
  layout?: Maybe<Scalars['JSON']['output']>;
  title: Scalars['String']['output'];
};

/** Task priority levels */
export const FormsTaskPriority = {
  critical: 'critical',
  high: 'high',
  low: 'low',
  normal: 'normal',
  urgent: 'urgent',
} as const;

export type FormsTaskPriority = (typeof FormsTaskPriority)[keyof typeof FormsTaskPriority];
/** Task status lifecycle */
export const FormsTaskStatus = {
  blocked: 'blocked',
  cancelled: 'cancelled',
  completed: 'completed',
  failed: 'failed',
  inProgress: 'inProgress',
  overdue: 'overdue',
  pending: 'pending',
} as const;

export type FormsTaskStatus = (typeof FormsTaskStatus)[keyof typeof FormsTaskStatus];
/**
 * Validation result
 * Renamed to FormsValidationResult to avoid collision with metadata_api::template_import_export::ValidationResult
 */
export type FormsValidationResult = {
  __typename?: 'FormsValidationResult';
  errors: Array<Scalars['String']['output']>;
  issues: Array<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Formula duration entry (key-value pair for HashMap). */
export type FormulaDurationEntry = {
  __typename?: 'FormulaDurationEntry';
  /** Duration in seconds */
  durationSeconds: Scalars['Int']['output'];
  /** Formula name (key) */
  formulaName: Scalars['String']['output'];
};

/** Formula information */
export type FormulaInfo = {
  __typename?: 'FormulaInfo';
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable name */
  formulaName: Scalars['String']['output'];
  /** Formula number */
  formulaNumber: Scalars['Int']['output'];
  /** Required primitive types */
  primitiveTypes: Array<Scalars['String']['output']>;
  /** Historical success rate (0.0-1.0) */
  successRate: Scalars['Float']['output'];
  /** Number of times this formula has been used */
  usageCount: Scalars['Int']['output'];
};

/** Formula metric entry (key-value pair for HashMap). */
export type FormulaMetricEntry = {
  __typename?: 'FormulaMetricEntry';
  /** Formula name (key) */
  formulaName: Scalars['String']['output'];
  /** Metric value */
  value: Scalars['Float']['output'];
};

/** Formula state count entry (key-value pair for HashMap). */
export type FormulaStateCountEntry = {
  __typename?: 'FormulaStateCountEntry';
  /** Formula name (key) */
  formulaName: Scalars['String']['output'];
  /** State count */
  stateCount: Scalars['Int']['output'];
};

/** Formula strategy entry (key-value pair for HashMap). */
export type FormulaStrategyEntry = {
  __typename?: 'FormulaStrategyEntry';
  /** Formula name (key) */
  formulaName: Scalars['String']['output'];
  /** Recommended execution strategy */
  strategy: Scalars['String']['output'];
};

/** Formula suggestion from activation rule */
export type FormulaSuggestion = {
  __typename?: 'FormulaSuggestion';
  /** Human-readable formula name */
  formulaName: Scalars['String']['output'];
  /** Formula number (1-6 for system, 100+ for tenant) */
  formulaNumber: Scalars['Int']['output'];
  /** Primitives that matched */
  matchedPrimitives: Array<Scalars['String']['output']>;
  /** Primitives that are missing (optional for this formula) */
  missingPrimitives: Array<Scalars['String']['output']>;
  /** Why this formula was suggested */
  reason: Scalars['String']['output'];
  /** The activation rule that fired */
  ruleId: Scalars['String']['output'];
  /** Suggestion score (higher = more confident) */
  score: Scalars['Float']['output'];
};

/** Framework Compliance Result */
export type FrameworkComplianceResult = {
  __typename?: 'FrameworkComplianceResult';
  checkedAt: Scalars['String']['output'];
  checkedBy: Scalars['String']['output'];
  framework: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
  score: Scalars['Float']['output'];
  violations: Array<ComplianceViolation>;
  workflowId: Scalars['String']['output'];
};

/** Framework Score */
export type FrameworkScore = {
  __typename?: 'FrameworkScore';
  framework: Scalars['String']['output'];
  passing: Scalars['Boolean']['output'];
  requiredScore: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

export type Freeze = {
  __typename?: 'Freeze';
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  period: Scalars['String']['output'];
};

/** Result of a ruleset acknowledgment PDF generation (may include ceremony) */
export type GenerateAcknowledgmentResult = {
  __typename?: 'GenerateAcknowledgmentResult';
  /** Ceremony ID (populated when `initiateCeremony` was true) */
  ceremonyId?: Maybe<Scalars['String']['output']>;
  /** Document primitive ID */
  documentId: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** S3 key where the PDF is stored */
  s3Key?: Maybe<Scalars['String']['output']>;
  /** PDF file size in bytes */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  /** Whether the PDF was generated successfully */
  success: Scalars['Boolean']['output'];
};

/**
 * Input for ALF admission document PDF generation (MN 144G.09 / 144G.12 / 144G.43 / 144G.70)
 *
 * Renders one admission document from a template + data context and writes a
 * Document primitive (type: File, status: Pending — awaits resident/representative signing).
 * The document is linked to the workflow instance so it appears in the instance's
 * document list and can be tracked through the signing workflow.
 */
export type GenerateAdmissionPdfInput = {
  /**
   * Template variable context as a JSON object string.
   * Keys map to `{{variable}}` placeholders in the template.
   * Build this from the facility Actor metadata + admission record fields.
   */
  dataContextJson: Scalars['String']['input'];
  /**
   * Human-readable document name stored on the Document primitive
   * (e.g. "MN 144G.12 Admission Agreement — Watermelon Shang — 2026-03-14")
   */
  documentName: Scalars['String']['input'];
  /**
   * Regulatory rule IDs this document satisfies (e.g. ["rl-4-0-146"]).
   * Linked as evidence in the DocumentRepository.
   */
  regulatoryRuleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Task ID of the admission task that triggered this generation (optional). */
  taskId?: InputMaybe<Scalars['String']['input']>;
  /** PDF template ID (e.g. "pdf-tpl-hc-alf-admission-agreement-001") */
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  /**
   * Workflow instance ID — links the Document primitive to the admission workflow.
   * Required so the document appears in the instance's document list.
   */
  workflowInstanceId: Scalars['String']['input'];
};

/** Input for generating an advisory recommendation via LLM. */
export type GenerateAdvisoryInput = {
  /** Category: "terminology_trend", "legislative_forecast", "regulatory_forecast", "best_practice" */
  category: Scalars['String']['input'];
  /** Context for the LLM (e.g., "MN 2025 legislative session", "CMS proposed rules") */
  context: Scalars['String']['input'];
  /** Specific definitions to analyze (tag:def:* IDs). Empty = analyze all. */
  definitionIds: Array<Scalars['String']['input']>;
  /** Optional source URL or document reference */
  sourceReference?: InputMaybe<Scalars['String']['input']>;
};

/** Result of advisory generation. */
export type GenerateAdvisoryResult = {
  __typename?: 'GenerateAdvisoryResult';
  /** Generated advisory content (YAML format for review) */
  advisoryYaml?: Maybe<Scalars['String']['output']>;
  /** Definitions analyzed */
  definitionsAnalyzed: Scalars['Int']['output'];
  /** Number of impacts identified */
  impactsIdentified: Scalars['Int']['output'];
  /** Whether generation succeeded */
  success: Scalars['Boolean']['output'];
  /** LLM-generated summary */
  summary: Scalars['String']['output'];
};

/** Input for batch PDF generation */
export type GenerateBatchPdfsInput = {
  /** Optional shared context variables (applied to all rows) */
  contextJson?: InputMaybe<Scalars['String']['input']>;
  /**
   * Data rows as JSON array string (each row is a key-value map)
   * Example: `[{"name": "Alice", "amount": "100"}, {"name": "Bob", "amount": "200"}]`
   */
  dataRowsJson: Scalars['String']['input'];
  /** Maximum concurrent PDF renders (default: 10) */
  maxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  /** Template ID to use for generation */
  templateId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Result of batch PDF generation */
export type GenerateBatchPdfsResult = {
  __typename?: 'GenerateBatchPdfsResult';
  /** Number of failed PDFs */
  failureCount: Scalars['Int']['output'];
  /** Per-row results */
  items: Array<BatchPdfItem>;
  /** Human-readable summary message */
  message: Scalars['String']['output'];
  /** S3 prefix where batch PDFs are stored */
  s3Prefix: Scalars['String']['output'];
  /** Whether the batch completed (may have partial failures) */
  success: Scalars['Boolean']['output'];
  /** Number of successful PDFs */
  successCount: Scalars['Int']['output'];
  /** Total rows processed */
  totalRows: Scalars['Int']['output'];
};

/**
 * Input for generating a printable daily shift task sheet.
 *
 * Fetches active tasks for a team actor on a given date + shift,
 * renders `pdf-tpl-hc-daily-task-sheet-001`, uploads to S3, and returns
 * a pre-signed download URL so staff can print and carry the sheet.
 *
 * Per DRR-128: individual staff attribution is NOT printed by default.
 * Tasks are grouped by team actor. The sheet has a QR code in the footer
 * linking to `/attest/{shift_token}` for bulk completion attestation.
 */
export type GenerateDailyTaskSheetInput = {
  /** Which shift period to generate (AM / PM / NOC) */
  shift: ShiftPeriod | '%future added value';
  /** Shift date in ISO 8601 format: "2026-03-16" */
  shiftDate: Scalars['String']['input'];
  /**
   * Team actor ID whose tasks appear on the sheet.
   * Per DRR-128: team-level attribution, not individual staff.
   */
  teamActorId: Scalars['String']['input'];
  /** Override the template (default: pdf-tpl-hc-daily-task-sheet-001) */
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Input for generating a document */
export type GenerateDocumentInput = {
  /** Correlation ID for tracing */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /** Document type to generate */
  documentType: GqlGeneratedDocumentType | '%future added value';
  /** Additional options as JSON */
  options?: InputMaybe<Scalars['String']['input']>;
  /** Target user who will own the document */
  ownerUserId: Scalars['String']['input'];
  /** Source entity ID (e.g., employee ID) */
  sourceId: Scalars['String']['input'];
  /** Source type (e.g., "payroll.w2") */
  sourceType: Scalars['String']['input'];
  /** Tax year (for W-2, 1099) */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for generating a pre-signed document upload URL
 *
 * DRR-081: The generated URL enforces Content-Type at the S3 level,
 * so clients MUST upload with the declared MIME type or the upload will fail.
 */
export type GenerateDocumentUploadUrlInput = {
  /** Document filename (used for S3 key generation) */
  fileName: Scalars['String']['input'];
  /** File size in bytes (for Content-Length validation) */
  fileSizeBytes: Scalars['Int']['input'];
  /** MIME type of the file (must be in DRR-081 allowlist) */
  mimeType: Scalars['String']['input'];
  /** Tenant ID for tenant-isolated S3 key prefix */
  tenantId: Scalars['String']['input'];
};

/** Result of EP Manual generation */
export type GenerateEpManualResult = {
  __typename?: 'GenerateEpManualResult';
  /** Number of E-tag checkpoints covered */
  checkpointsCovered: Scalars['Int']['output'];
  /** Document ID of the generated PDF */
  documentId: Scalars['String']['output'];
  /** Pre-signed download URL (valid for 1 hour) */
  downloadUrl: Scalars['String']['output'];
  /** When the PDF was generated */
  generatedAt: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Page count */
  pageCount: Scalars['Int']['output'];
  /** Ruleset ID used for generation */
  rulesetId: Scalars['String']['output'];
  /** S3 key where the PDF is stored */
  s3Key: Scalars['String']['output'];
  /** File size in bytes */
  sizeBytes: Scalars['Int']['output'];
  /** Whether generation succeeded */
  success: Scalars['Boolean']['output'];
  /** Survey forms used */
  surveyForms: Array<Scalars['String']['output']>;
  /** Task groups included */
  taskGroups: Array<Scalars['String']['output']>;
};

/** Input for generating evidence report (MnCHOICES drift) */
export type GenerateEvidenceReportInput = {
  residentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Input for generating form schema edit suggestions */
export type GenerateFormSchemaSuggestionsInput = {
  /** Existing draft ID to continue editing */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Entity type being edited (e.g., "JournalEntry", "Patient") */
  entityType: Scalars['String']['input'];
  /** UI mode context (CREATE, EDIT, APPROVE, etc.) */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** Natural language prompt describing the desired change */
  prompt: Scalars['String']['input'];
  /** Subgraph/module (e.g., "accounting", "fhir") */
  subgraph: Scalars['String']['input'];
  /** Optional target field name for field-specific edits */
  targetFieldName?: InputMaybe<Scalars['String']['input']>;
};

/** Input for ID generation request */
export type GenerateIdInput = {
  /** Number of IDs to generate (default: 1, max: 100) */
  count?: Scalars['Int']['input'];
  /** Entity type for ID generation (maps to 16 primitive types) */
  entityType: IdBrokerEntityType | '%future added value';
};

/** ID generation result */
export type GenerateIdResult = {
  __typename?: 'GenerateIdResult';
  /** Entity type used for generation */
  entityType: IdBrokerEntityType | '%future added value';
  /** ID format (always "snowflake" for new generation) */
  format: Scalars['String']['output'];
  /** Generation timestamp */
  generatedAt: Scalars['DateTime']['output'];
  /** Generated Snowflake IDs */
  ids: Array<Scalars['String']['output']>;
};

/** Input for generating config proposals from coverage gaps. */
export type GenerateProposalsInput = {
  /**
   * Config types to generate proposals for.
   * Default: all types (task_group, workflow).
   */
  configTypes?: Array<ProposalConfigType | '%future added value'>;
  /** Optional product context — scopes gap detection to product's configs. */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** RuleSet to analyze for coverage gaps (e.g., "rs-4-1-004"). */
  rulesetId: Scalars['String']['input'];
};

/**
 * Result of config proposal generation.
 *
 * Returns structured proposals — the config storage format is an
 * implementation detail that NEVER crosses the GraphQL boundary.
 */
export type GenerateProposalsResult = {
  __typename?: 'GenerateProposalsResult';
  /** Number of draft proposals generated. */
  draftCount: Scalars['Int']['output'];
  /** Gap IDs that were addressed by proposals. */
  gapIds: Array<Scalars['String']['output']>;
  /** Structured proposals (parsed server-side from config format). */
  proposals: Array<PendingProposal>;
  /** Whether generation completed successfully. */
  success: Scalars['Boolean']['output'];
  /** Warning messages. */
  warnings: Array<Scalars['String']['output']>;
};

export type GenerateReportInput = {
  includeEvidence: Scalars['Boolean']['input'];
  includeValidationDetails: Scalars['Boolean']['input'];
  reportFormat: GqlReportFormat | '%future added value';
  requestedBy: Scalars['String']['input'];
};

/** Result of an on-demand PDF report generation (DRR-131 Phase 1) */
export type GenerateReportPdfResult = {
  __typename?: 'GenerateReportPdfResult';
  /** Document primitive ID (SK = n{id}) */
  documentId: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** S3 key where the PDF is stored */
  s3Key?: Maybe<Scalars['String']['output']>;
  /** PDF file size in bytes */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  /** Whether the PDF was generated and Document primitive was written successfully */
  success: Scalars['Boolean']['output'];
};

/**
 * Input for generating a formal ruleset compliance acknowledgment PDF
 * with signature blocks for sign-off. Optionally initiates a signing ceremony.
 *
 * The acknowledgment document uses the same rich data context as the compliance
 * report but adds attestation text and signature fields for reviewer, approver,
 * and administrator. The document is created with `PendingApproval` status —
 * it requires signing before it becomes valid regulatory evidence.
 */
export type GenerateRulesetAcknowledgmentInput = {
  /** Name of the facility administrator (appears on signature line) */
  administratorName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the approving authority (appears on signature line) */
  approverName?: InputMaybe<Scalars['String']['input']>;
  /** Participants for the signing ceremony (required when `initiateCeremony` is true) */
  ceremonyParticipants?: InputMaybe<Array<AcknowledgmentParticipantInput>>;
  /**
   * If true, a signing ceremony is created after PDF generation.
   * Requires `ceremonyParticipants` to be provided.
   */
  initiateCeremony?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the compliance reviewer (appears on signature line) */
  reviewerName?: InputMaybe<Scalars['String']['input']>;
  rulesetId: Scalars['String']['input'];
  /** Template ID (default: pdf-tpl-core-ruleset-acknowledgment-001) */
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Input for ruleset compliance report generation */
export type GenerateRulesetReportInput = {
  rulesetId: Scalars['String']['input'];
  /** Template ID (default: pdf-tpl-core-ruleset-report-001) */
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Result of individual staff competency record generation (surveyor-ready) */
export type GenerateStaffCompetencyRecordResult = {
  __typename?: 'GenerateStaffCompetencyRecordResult';
  /** Competency area name */
  competencyName: Scalars['String']['output'];
  /** Completion date (ISO 8601) */
  completionDate: Scalars['String']['output'];
  /** Number of assessment criteria verified */
  criteriaCount: Scalars['Int']['output'];
  /** Document primitive ID for the generated PDF */
  documentId: Scalars['String']['output'];
  /** Pre-signed download URL (valid for 1 hour) */
  downloadUrl: Scalars['String']['output'];
  /** Evaluator name */
  evaluatorName: Scalars['String']['output'];
  /** When the PDF was generated */
  generatedAt: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** S3 key where the PDF is stored */
  s3Key: Scalars['String']['output'];
  /** Number of safety-critical criteria */
  safetyCriticalCount: Scalars['Int']['output'];
  /** PDF file size in bytes */
  sizeBytes: Scalars['Int']['output'];
  /** Staff member's actor ID */
  staffActorId: Scalars['String']['output'];
  /** Staff member's name */
  staffName: Scalars['String']['output'];
  /** Whether generation succeeded */
  success: Scalars['Boolean']['output'];
  /** Task group ID for this competency */
  taskGroupId: Scalars['String']['output'];
};

/** Input for generating a batch of subgraph IDs */
export type GenerateSubgraphIdBatchInput = {
  /** Optional correlation ID for tracing */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /** Number of IDs to generate (max 1000) */
  count: Scalars['Int']['input'];
  /** Primitive name */
  primitive: Scalars['String']['input'];
  /** Subgraph name */
  subgraph: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for generating a single subgraph ID */
export type GenerateSubgraphIdInput = {
  /** Optional correlation ID for tracing */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /** Primitive name within the subgraph (e.g., "payroll_run", "pay_stub") */
  primitive: Scalars['String']['input'];
  /** Subgraph name (e.g., "payroll", "website", "fhir") */
  subgraph: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** DRR-189: Input for per-subject care summary PDF generation. */
export type GenerateSubjectCareSummaryInput = {
  /** Optional date range filter (ISO 8601) */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Subject actor ID (resident/patient/client) */
  subjectActorId: Scalars['String']['input'];
  /** Template ID (default: pdf-tpl-core-care-summary-001) */
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating LLM edit suggestions */
export type GenerateSuggestionsInput = {
  /** Optional certification context */
  certification?: InputMaybe<Scalars['String']['input']>;
  /** Optional industry context */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Optional hint about operation type */
  operationHint?: InputMaybe<WorkflowEditOperation | '%future added value'>;
  /** Optional program variant context */
  programVariant?: InputMaybe<Scalars['String']['input']>;
  /** Natural language description of the desired change */
  prompt: Scalars['String']['input'];
  /** Optional state context */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Optional specific node to modify */
  targetNodeId?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** Workflow to edit */
  workflowName: Scalars['String']['input'];
};

/** Response for suggestion generation */
export type GenerateSuggestionsResponse = {
  __typename?: 'GenerateSuggestionsResponse';
  /** Current workflow state (for reference) */
  currentWorkflow: WorkflowDefinition;
  /** Draft ID (auto-created if not existing) */
  draftId: Scalars['String']['output'];
  /** Generated suggestions */
  suggestions: Array<LlmEditSuggestion>;
};

/** Result of generating suggestions */
export type GenerateSuggestionsResult = {
  __typename?: 'GenerateSuggestionsResult';
  draft: FormSchemaDraftOutput;
  suggestions: Array<FormSchemaEditSuggestionOutput>;
};

/** Input for generating task guidance */
export type GenerateTaskGuidanceInput = {
  /** User preferences for guidance style */
  preferences?: InputMaybe<UserPreferencesInput>;
  /** Additional task context (inputData, metadata) */
  taskContext?: InputMaybe<Scalars['JSON']['input']>;
  /** Task ID to generate guidance for */
  taskId: Scalars['String']['input'];
  /** Tenant ID for isolation */
  tenantId: Scalars['String']['input'];
  /** User's role for context-aware guidance */
  userRole?: InputMaybe<Scalars['String']['input']>;
};

/** Result of generating task guidance */
export type GenerateTaskGuidanceResult = {
  __typename?: 'GenerateTaskGuidanceResult';
  /** Generated guidance */
  guidance: TaskGuidanceOutput;
  /** Optional organization suggestions */
  organizationSuggestions?: Maybe<OrganizationSuggestionOutput>;
};

/** Input for task instructions PDF generation */
export type GenerateTaskInstructionsInput = {
  taskId: Scalars['String']['input'];
  /** Template ID (default: pdf-tpl-core-task-instructions-001) */
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  /** Workflow instance ID that owns this task (required for DDB lookup) */
  workflowInstanceId: Scalars['String']['input'];
};

/** Result of training curriculum generation (living manual from rules) */
export type GenerateTrainingCurriculumResult = {
  __typename?: 'GenerateTrainingCurriculumResult';
  /** Document primitive ID for the generated PDF */
  documentId: Scalars['String']['output'];
  /** Pre-signed download URL (valid for 1 hour) */
  downloadUrl: Scalars['String']['output'];
  /** When the curriculum was generated */
  generatedAt: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Number of pages in the generated PDF */
  pageCount: Scalars['Int']['output'];
  /** Source ruleset ID */
  rulesetId: Scalars['String']['output'];
  /** S3 key where the PDF is stored */
  s3Key: Scalars['String']['output'];
  /** PDF file size in bytes */
  sizeBytes: Scalars['Int']['output'];
  /** Rules that contributed to this curriculum */
  sourceRules: Array<Scalars['String']['output']>;
  /** Whether generation succeeded */
  success: Scalars['Boolean']['output'];
  /** Task groups included in this curriculum */
  taskGroups: Array<Scalars['String']['output']>;
};

/** Input for workflow execution summary PDF generation */
export type GenerateWorkflowSummaryInput = {
  instanceId: Scalars['String']['input'];
  /** Template ID (default: pdf-tpl-core-workflow-summary-001) */
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  /** Workflow definition ID (required for DDB lookup — part of Instance PK) */
  workflowDefinitionId: Scalars['String']['input'];
};

/** Generation Metadata (GraphQL output) */
export type GenerationMetadata = {
  __typename?: 'GenerationMetadata';
  /** Generation timestamp */
  generatedAt: Scalars['DateTime']['output'];
  /** Model used */
  model: Scalars['String']['output'];
  /** Processing time (ms) */
  processingTimeMs?: Maybe<Scalars['Int']['output']>;
  /** Total tokens used */
  tokensUsed?: Maybe<Scalars['Int']['output']>;
};

/**
 * * Domain-Agnostic Management API
 *  *
 *  * PRODUCTION GATE: Universal management interface for life-critical workflow entities.
 *  * This API provides domain-agnostic management capabilities that work across all domains
 *  * (healthcare, financial, legal, etc.) through metadata-driven configuration.
 *  *
 *  * Features:
 *  * - Generic entity management (escalations, resources, schedules, policies, integrations)
 *  * - Metadata-driven schema validation
 *  * - Domain-specific behavior through configuration
 *  * - Life-critical safety validation
 *  * - Immutable audit trails
 *  * - Real-time monitoring and alerting
 *  *
 *  * @module ManagementAPI
 *  * @critical Life-critical system component with zero-tolerance for data loss
 * Generic entity that can represent any domain-specific resource
 */
export type GenericEntity = {
  __typename?: 'GenericEntity';
  /** Configuration specific to entity type */
  configuration: Scalars['JSON']['output'];
  /** Created timestamp */
  createdAt: Scalars['String']['output'];
  /** Created by user ID */
  createdBy: Scalars['String']['output'];
  /** Entity description */
  description?: Maybe<Scalars['String']['output']>;
  /** Entity type (escalation, resource, schedule, policy, integration) */
  entityType: Scalars['String']['output'];
  /** Unique entity identifier */
  id: Scalars['ID']['output'];
  /** Domain-specific metadata (JSON) */
  metadata: Scalars['JSON']['output'];
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Priority level (1-10, 10 being highest) */
  priority: Scalars['Int']['output'];
  /** Runtime state (current values, counters, etc.) */
  runtimeState: Scalars['JSON']['output'];
  /** Schema reference for validation */
  schemaRef: Scalars['String']['output'];
  /** Current status */
  status: EntityStatus | '%future added value';
  /** Tags for categorization */
  tags: Array<Scalars['String']['output']>;
  /** Tenant ID for multi-tenancy */
  tenant: Scalars['String']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['String']['output'];
  /** Updated by user ID */
  updatedBy: Scalars['String']['output'];
  /** Version for optimistic locking */
  version: Scalars['Int']['output'];
};

/** Connection type for pagination */
export type GenericEntityConnection = {
  __typename?: 'GenericEntityConnection';
  /** Cursor for next page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more results */
  hasNextPage: Scalars['Boolean']['output'];
  /** List of entities */
  nodes: Array<GenericEntity>;
  /** Total count */
  totalCount: Scalars['Int']['output'];
};

/** Input for getting a draft */
export type GetDraftInput = {
  key: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Input for getting drift results */
export type GetDriftResultsInput = {
  residentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Input for getting enhanced form schema */
export type GetEnhancedFormSchemaInput = {
  kind: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Input for getting a form schema */
export type GetFormSchemaInput = {
  kind: Scalars['String']['input'];
};

export type GetNotificationsInput = {
  /** Company identifier */
  companyId: Scalars['String']['input'];
  /** Optional pagination limit */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Optional pagination token */
  nextToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional filter by status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Tenant identifier (for multi-tenancy) */
  tenantId: Scalars['String']['input'];
};

/** Input for the getTaskGuidance mutation. */
export type GetTaskGuidanceInput = {
  prompt: Scalars['String']['input'];
  sessionMessages?: InputMaybe<Scalars['JSON']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

/** Access action for audit */
export const GqlAccessAction = {
  /** User downloaded file */
  DOWNLOAD: 'DOWNLOAD',
  /** Auto-expired */
  EXPIRE: 'EXPIRE',
  /** PDF opened */
  OPEN: 'OPEN',
  /** Admin revoked */
  REVOKE: 'REVOKE',
  /** Decryption key returned */
  UNLOCK: 'UNLOCK',
} as const;

export type GqlAccessAction = (typeof GqlAccessAction)[keyof typeof GqlAccessAction];
export type GqlAchFile = {
  __typename?: 'GqlAchFile';
  /** Number of batches in file (typically 1) */
  batchCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  effectiveDate: Scalars['NaiveDate']['output'];
  /** Number of entry detail records */
  entryCount: Scalars['Int']['output'];
  /** SHA-256 hash of file content for integrity verification */
  fileHash: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Date until which file must be retained (7 years for SOX compliance) */
  retentionUntil: Scalars['DateTime']['output'];
  /** S3 bucket where file is stored */
  s3Bucket: Scalars['String']['output'];
  /** S3 key (path) for the file */
  s3Key: Scalars['String']['output'];
  secCode: GqlAchSecCode | '%future added value';
  sourceId: Scalars['ID']['output'];
  sourceType: GqlAchSourceType | '%future added value';
  /** Current processing status */
  status: GqlAchFileStatus | '%future added value';
  tenantId: Scalars['ID']['output'];
  /** Total credit amount in cents */
  totalCreditCents: Scalars['Int']['output'];
  /** Formatted total credit amount (e.g., "$123,456.78") */
  totalCreditFormatted: Scalars['String']['output'];
  /** Total debit amount in cents (0 for credit-only files like payroll) */
  totalDebitCents: Scalars['Int']['output'];
  transmittedAt?: Maybe<Scalars['DateTime']['output']>;
  transmittedBy?: Maybe<Scalars['ID']['output']>;
};

/** Paginated list of ACH files */
export type GqlAchFileConnection = {
  __typename?: 'GqlAchFileConnection';
  /** List of ACH files */
  nodes: Array<GqlAchFile>;
  /** Total count of matching files */
  totalCount: Scalars['Int']['output'];
};

/** ACH file processing status */
export const GqlAchFileStatus = {
  /** Bank acknowledged receipt */
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  /** Processing failed */
  FAILED: 'FAILED',
  /** File generated and stored in S3 */
  GENERATED: 'GENERATED',
  /** One or more entries returned */
  RETURNED: 'RETURNED',
  /** Funds settled */
  SETTLED: 'SETTLED',
  /** File transmitted to bank/processor */
  TRANSMITTED: 'TRANSMITTED',
} as const;

export type GqlAchFileStatus = (typeof GqlAchFileStatus)[keyof typeof GqlAchFileStatus];
/** ACH Standard Entry Class Code */
export const GqlAchSecCode = {
  /** Corporate Credit or Debit (vendor payments) */
  CCD: 'CCD',
  /** Prearranged Payment and Deposit (payroll direct deposit) */
  PPD: 'PPD',
  /** Telephone-initiated payment */
  TEL: 'TEL',
  /** Internet-initiated payment (customer refunds) */
  WEB: 'WEB',
} as const;

export type GqlAchSecCode = (typeof GqlAchSecCode)[keyof typeof GqlAchSecCode];
/** Payment source type */
export const GqlAchSourceType = {
  /** Customer refund batch - AR credits */
  CUSTOMER_REFUND_BATCH: 'CUSTOMER_REFUND_BATCH',
  /** Payroll run - employee direct deposits */
  PAYROLL_RUN: 'PAYROLL_RUN',
  /** Vendor payment batch - AP disbursements */
  VENDOR_PAYMENT_BATCH: 'VENDOR_PAYMENT_BATCH',
} as const;

export type GqlAchSourceType = (typeof GqlAchSourceType)[keyof typeof GqlAchSourceType];
/** Input for creating an action definition. */
export type GqlActionDefinitionInput = {
  actionType: GqlActionType | '%future added value';
  configuration: Scalars['JSON']['input'];
};

/** Input for action entry (key-value pair). */
export type GqlActionEntryInput = {
  definition: GqlActionDefinitionInput;
  name: Scalars['String']['input'];
};

/** Action type for workflow automation. */
export const GqlActionType = {
  /** DRR-129 G2 + G-NEW-C: Evaluate a Constraint primitive on state entry. */
  CHECK_CONSTRAINT: 'CHECK_CONSTRAINT',
  /** DRR-130: Create a Task primitive inline from a workflow entry action. */
  CREATE_TASK: 'CREATE_TASK',
  CUSTOM: 'CUSTOM',
  DATABASE_QUERY: 'DATABASE_QUERY',
  DEDUPLICATE: 'DEDUPLICATE',
  DOCUMENT_RECONCILIATION: 'DOCUMENT_RECONCILIATION',
  /** DRR-131: Emit proactive briefing to tenant AI assistant actor. */
  EMIT_ASSISTANT_BRIEFING: 'EMIT_ASSISTANT_BRIEFING',
  EMIT_DEFERRED_EVENT: 'EMIT_DEFERRED_EVENT',
  EMIT_FHIR_RESOURCE: 'EMIT_FHIR_RESOURCE',
  /** DRR-130: Evaluate Zen Engine regulatory rules for the current workflow event. */
  EVALUATE_POLICY: 'EVALUATE_POLICY',
  /** DRR-143: Evaluate SLA breaches at heartbeat before spawning new tasks. */
  EVALUATE_SLA_BREACHES: 'EVALUATE_SLA_BREACHES',
  /** DRR-035: Execute a Saga for cross-subgraph coordination with compensation. */
  EXECUTE_SAGA: 'EXECUTE_SAGA',
  FILL_STATE_FORM: 'FILL_STATE_FORM',
  FINALIZE_LIST: 'FINALIZE_LIST',
  HTTP_CALL: 'HTTP_CALL',
  IDENTIFY_DISCREPANCIES: 'IDENTIFY_DISCREPANCIES',
  /** DRR-153: Map HL7 v2 ADT/ORU segments to FHIR R4 resources. */
  MAP_HL7_TO_FHIR: 'MAP_HL7_TO_FHIR',
  NORMALIZE_MEDICATIONS: 'NORMALIZE_MEDICATIONS',
  QUERY_SOURCES: 'QUERY_SOURCES',
  ROUTE_FOR_REVIEW: 'ROUTE_FOR_REVIEW',
  /** DRR-153: Route an HL7 ADT event to the subject's active operational workflow instance. */
  ROUTE_HL7_TO_INSTANCE: 'ROUTE_HL7_TO_INSTANCE',
  SCHEDULE_FOLLOWUP: 'SCHEDULE_FOLLOWUP',
  SEND_EMAIL: 'SEND_EMAIL',
  /** DRR-153: Send an outbound HL7 v2 message to a downstream EHR or HIS. */
  SEND_HL7_MESSAGE: 'SEND_HL7_MESSAGE',
  SPAWN_TASKS_FROM_GROUPS: 'SPAWN_TASKS_FROM_GROUPS',
  /** DRR-153: Store pre-mapped FHIR resources via the enrichment pipeline. */
  STORE_FHIR_RESOURCES: 'STORE_FHIR_RESOURCES',
  UPDATE_MEDICATION_LIST: 'UPDATE_MEDICATION_LIST',
} as const;

export type GqlActionType = (typeof GqlActionType)[keyof typeof GqlActionType];
/** Individual approver's decision. */
export type GqlActorApproval = {
  __typename?: 'GqlActorApproval';
  actorId: Scalars['String']['output'];
  actorName: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  decidedAt: Scalars['DateTime']['output'];
  decision: GqlApprovalDecision | '%future added value';
  role: Scalars['String']['output'];
  signature?: Maybe<Scalars['String']['output']>;
};

export type GqlActorConnection = {
  __typename?: 'GqlActorConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Actor>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/** Actor presence information (DRR-061). */
export type GqlActorPresence = {
  __typename?: 'GqlActorPresence';
  actorId: Scalars['String']['output'];
  lastSeen?: Maybe<Scalars['String']['output']>;
  status: GqlPresenceStatus | '%future added value';
};

export type GqlActorStatistics = {
  __typename?: 'GqlActorStatistics';
  actorId: Scalars['String']['output'];
  avgTaskResponseMinutes?: Maybe<Scalars['Int']['output']>;
  circuitBreakerOpen: Scalars['Boolean']['output'];
  maxCapacity: Scalars['Int']['output'];
  successRate?: Maybe<Scalars['Float']['output']>;
  utilizationPercent: Scalars['Float']['output'];
  workload: Scalars['Int']['output'];
};

export const GqlActorStatus = {
  ACTIVE: 'ACTIVE',
  BUSY: 'BUSY',
  FAILED: 'FAILED',
  IDLE: 'IDLE',
  SUSPENDED: 'SUSPENDED',
  TERMINATED: 'TERMINATED',
} as const;

export type GqlActorStatus = (typeof GqlActorStatus)[keyof typeof GqlActorStatus];
/** Current traversal mode with override flag. */
export type GqlActorTraversalMode = {
  __typename?: 'GqlActorTraversalMode';
  /** True when the actor has set a personal override (vs. role default). */
  isActorOverride: Scalars['Boolean']['output'];
  mode: GqlTraversalMode | '%future added value';
};

export const GqlActorType = {
  AI: 'AI',
  COMPOSITE: 'COMPOSITE',
  CUSTOM: 'CUSTOM',
  DEVICE: 'DEVICE',
  EXTERNAL: 'EXTERNAL',
  HUMAN: 'HUMAN',
  SUBJECT: 'SUBJECT',
  SYSTEM: 'SYSTEM',
} as const;

export type GqlActorType = (typeof GqlActorType)[keyof typeof GqlActorType];
/** Input for adding a comment to an Approval. */
export type GqlAddCommentInput = {
  actorId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for adding a stakeholder to a team. */
export type GqlAddStakeholderInput = {
  /** Team code */
  code: Scalars['String']['input'];
  /** Stakeholder ID to add */
  stakeholderId: Scalars['String']['input'];
};

/** Tenant's decision on a recommendation. */
export const GqlAdoptionStatus = {
  /** Tenant adopted the recommendation. */
  ADOPTED: 'ADOPTED',
  /** Tenant dismissed the recommendation (with reason). */
  DISMISSED: 'DISMISSED',
  /** Not yet reviewed by tenant. */
  PENDING: 'PENDING',
} as const;

export type GqlAdoptionStatus = (typeof GqlAdoptionStatus)[keyof typeof GqlAdoptionStatus];
/** Aggregated progress across all child workflows. */
export type GqlAggregatedProgress = {
  __typename?: 'GqlAggregatedProgress';
  /** Individual child progress (optional, for detailed view) */
  children: Array<GqlChildWorkflowProgress>;
  /** Completed child workflows */
  completedChildren: Scalars['Int']['output'];
  /** Completed tasks across all children */
  completedTasks: Scalars['Int']['output'];
  /** Failed child workflows */
  failedChildren: Scalars['Int']['output'];
  /** Last update timestamp */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Overall progress percentage (0.0 - 100.0) */
  overallProgressPercent: Scalars['Float']['output'];
  /** Parent instance ID */
  parentInstanceId: Scalars['String']['output'];
  /** Pending child workflows */
  pendingChildren: Scalars['Int']['output'];
  /** Running child workflows */
  runningChildren: Scalars['Int']['output'];
  /** Total child workflows */
  totalChildren: Scalars['Int']['output'];
  /** Total tasks across all children */
  totalTasks: Scalars['Int']['output'];
};

/** Annotation entity — contextual comment or threaded conversation on a FERP entity. */
export type GqlAnnotation = {
  __typename?: 'GqlAnnotation';
  /** Unique Snowflake ID */
  annotationId: Scalars['String']['output'];
  /** Annotation classification */
  annotationType: GqlAnnotationType | '%future added value';
  /** Archive status */
  archived: Scalars['Boolean']['output'];
  /** Archive reason */
  archivedReason?: Maybe<Scalars['String']['output']>;
  /** Markdown content */
  body: Scalars['String']['output'];
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Author actor ID */
  createdBy: Scalars['String']['output'];
  /** Nesting depth (0 = top-level) */
  depth: Scalars['Int']['output'];
  /** Target entity ID */
  entityId: Scalars['String']['output'];
  /** Target entity type */
  entityType: Scalars['String']['output'];
  /** Active status */
  isActive: Scalars['Boolean']['output'];
  /** @mentioned actor IDs */
  mentions: Array<Scalars['String']['output']>;
  /** Parent annotation ID (None = top-level) */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Cross-referenced entity IDs */
  relatedEntityIds: Array<Scalars['String']['output']>;
  /** Number of replies (top-level only) */
  replyCount: Scalars['Int']['output'];
  /** Safety level inherited from entity */
  safetyLevel?: Maybe<Scalars['String']['output']>;
  /** Tenant ID */
  tenant: Scalars['String']['output'];
  /** Thread root annotation ID */
  threadRootId?: Maybe<Scalars['String']['output']>;
  /** Last modification time */
  updatedAt: Scalars['DateTime']['output'];
  /** Last modifier */
  updatedBy: Scalars['String']['output'];
  /** Append-only version */
  version: Scalars['Int']['output'];
  /** Visibility level */
  visibility: GqlAnnotationVisibility | '%future added value';
  /** Linked workflow instance */
  workflowInstanceId?: Maybe<Scalars['String']['output']>;
};

/** Result of archiving an annotation. */
export type GqlAnnotationArchiveResult = {
  __typename?: 'GqlAnnotationArchiveResult';
  /** Annotation ID that was archived */
  annotationId: Scalars['String']['output'];
  /** When the annotation was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** Who archived it */
  archivedBy: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Archive reason */
  reason: Scalars['String']['output'];
  /** Whether the archive succeeded */
  success: Scalars['Boolean']['output'];
};

/** Paginated annotation connection. */
export type GqlAnnotationConnection = {
  __typename?: 'GqlAnnotationConnection';
  /** Whether more pages exist */
  hasMore: Scalars['Boolean']['output'];
  /** Annotations in this page */
  items: Array<GqlAnnotation>;
  /** Cursor for next page */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Total count (if available) */
  total: Scalars['Int']['output'];
};

/** Subscription event for new annotations. */
export type GqlAnnotationCreatedEvent = {
  __typename?: 'GqlAnnotationCreatedEvent';
  /** New annotation ID */
  annotationId: Scalars['String']['output'];
  /** Annotation classification */
  annotationType: GqlAnnotationType | '%future added value';
  /** Author actor ID */
  authorActorId: Scalars['String']['output'];
  /** When the annotation was created */
  createdAt: Scalars['DateTime']['output'];
  /** Target entity ID */
  entityId: Scalars['String']['output'];
  /** Target entity type */
  entityType: Scalars['String']['output'];
};

/** Annotation type classification */
export const GqlAnnotationType = {
  /** General comment on an entity */
  COMMENT: 'COMMENT',
  /** Decision record (approval/rejection rationale) */
  DECISION: 'DECISION',
  /** Escalation request requiring attention */
  ESCALATION: 'ESCALATION',
  /** Formal note (clinical note, review note) */
  NOTE: 'NOTE',
} as const;

export type GqlAnnotationType = (typeof GqlAnnotationType)[keyof typeof GqlAnnotationType];
/** Annotation visibility level */
export const GqlAnnotationVisibility = {
  /** Visible to external parties (e.g., patients, clients) */
  EXTERNAL: 'EXTERNAL',
  /** Visible to all tenant members with entity access */
  INTERNAL: 'INTERNAL',
  /** Visible only to specified roles/actors */
  RESTRICTED: 'RESTRICTED',
} as const;

export type GqlAnnotationVisibility =
  (typeof GqlAnnotationVisibility)[keyof typeof GqlAnnotationVisibility];
/** Comment on approval request. */
export type GqlApprovalComment = {
  __typename?: 'GqlApprovalComment';
  actorId: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  commentId: Scalars['String']['output'];
  parentCommentId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

/** Connection type for paginated Approval results. */
export type GqlApprovalConnection = {
  __typename?: 'GqlApprovalConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Approval>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/** GraphQL enum for ApprovalDecision (4 values). */
export const GqlApprovalDecision = {
  APPROVE: 'APPROVE',
  ESCALATE: 'ESCALATE',
  REJECT: 'REJECT',
  REQUEST_REVISION: 'REQUEST_REVISION',
} as const;

export type GqlApprovalDecision = (typeof GqlApprovalDecision)[keyof typeof GqlApprovalDecision];
/** Approval decision event for audit trail. */
export type GqlApprovalDecisionEvent = {
  __typename?: 'GqlApprovalDecisionEvent';
  actorId: Scalars['String']['output'];
  decision: GqlApprovalDecision | '%future added value';
  eventId: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

/** Role-based approval limits. */
export type GqlApprovalLimits = {
  __typename?: 'GqlApprovalLimits';
  currency?: Maybe<Scalars['String']['output']>;
  dualControlThreshold?: Maybe<Scalars['Float']['output']>;
  maxAmount?: Maybe<Scalars['Float']['output']>;
  requiresDualControl: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
};

/** GraphQL enum for ApprovalPriority (4 values). */
export const GqlApprovalPriority = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
} as const;

export type GqlApprovalPriority = (typeof GqlApprovalPriority)[keyof typeof GqlApprovalPriority];
/** GraphQL enum for ApprovalStatus (7 values). */
export const GqlApprovalStatus = {
  APPROVED: 'APPROVED',
  ESCALATED: 'ESCALATED',
  EXPIRED: 'EXPIRED',
  IN_REVIEW: 'IN_REVIEW',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  REVISION_REQUESTED: 'REVISION_REQUESTED',
} as const;

export type GqlApprovalStatus = (typeof GqlApprovalStatus)[keyof typeof GqlApprovalStatus];
/** Approval status change event. */
export type GqlApprovalStatusChange = {
  __typename?: 'GqlApprovalStatusChange';
  /** Approval ID */
  approvalId: Scalars['String']['output'];
  /** New status */
  newStatus: GqlApprovalStatus | '%future added value';
  /** Previous status */
  previousStatus: GqlApprovalStatus | '%future added value';
  /** Timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
};

/** GraphQL enum for ApprovalStrategy (4 values). */
export const GqlApprovalStrategy = {
  ALL_REQUIRED: 'ALL_REQUIRED',
  ANY_ONE: 'ANY_ONE',
  MAJORITY: 'MAJORITY',
  UNANIMOUS: 'UNANIMOUS',
} as const;

export type GqlApprovalStrategy = (typeof GqlApprovalStrategy)[keyof typeof GqlApprovalStrategy];
/** GraphQL enum for ApprovalType (4 values). */
export const GqlApprovalType = {
  AUTOMATED: 'AUTOMATED',
  CONDITIONAL: 'CONDITIONAL',
  HIERARCHICAL: 'HIERARCHICAL',
  MANUAL: 'MANUAL',
  PARALLEL: 'PARALLEL',
  SEQUENTIAL: 'SEQUENTIAL',
} as const;

export type GqlApprovalType = (typeof GqlApprovalType)[keyof typeof GqlApprovalType];
export type GqlAssignTaskToActorInput = {
  assignedBy: Scalars['String']['input'];
  assignmentType?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};

export const GqlAssignmentStrategy = {
  LEAST_LOADED: 'LEAST_LOADED',
  RANDOM: 'RANDOM',
  ROUND_ROBIN: 'ROUND_ROBIN',
  SKILL_AWARE_LEAST_LOADED: 'SKILL_AWARE_LEAST_LOADED',
  STICKY: 'STICKY',
} as const;

export type GqlAssignmentStrategy =
  (typeof GqlAssignmentStrategy)[keyof typeof GqlAssignmentStrategy];
export const GqlAuditFrameworkType = {
  FDA: 'FDA',
  GDPR: 'GDPR',
  HIPAA: 'HIPAA',
  PCI_DSS: 'PCI_DSS',
  SOX: 'SOX',
} as const;

export type GqlAuditFrameworkType =
  (typeof GqlAuditFrameworkType)[keyof typeof GqlAuditFrameworkType];
/** GraphQL enum for AuditLevel. */
export const GqlAuditLevel = {
  /** Basic audit (policy execution) */
  BASIC: 'BASIC',
  /** Complete audit (full context) */
  COMPLETE: 'COMPLETE',
  /** Detailed audit (conditions + actions) */
  DETAILED: 'DETAILED',
  /** No audit logging */
  NONE: 'NONE',
} as const;

export type GqlAuditLevel = (typeof GqlAuditLevel)[keyof typeof GqlAuditLevel];
/** Result of audit query */
export type GqlAuditQueryResult = {
  __typename?: 'GqlAuditQueryResult';
  /** Total count (if available) */
  count?: Maybe<Scalars['Int']['output']>;
  /** Retrieved events */
  events: Array<GqlIdAuditEvent>;
  /** Next page token (None if no more results) */
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** Available workflow transition from the current state. */
export type GqlAvailableTransition = {
  __typename?: 'GqlAvailableTransition';
  /** Human-readable display name (e.g., "Inquiry Complete") */
  displayName: Scalars['String']['output'];
  /** Event name to fire (e.g., "inquiry_complete") */
  event: Scalars['String']['output'];
  /** Guard condition names, if any (e.g., "all_tasks_completed, meets_care_criteria") */
  guard?: Maybe<Scalars['String']['output']>;
  /**
   * DRR-189: Whether the guard evaluation passed.
   * true = transition is available, false = blocked by guard.
   * Frontend should enable/disable buttons based on this.
   */
  guardPassed: Scalars['Boolean']['output'];
  /** Target state name (e.g., "pre_admission_assessment") */
  toState: Scalars['String']['output'];
};

/** Result of batch ID generation */
export type GqlBatchIdGenerationResult = {
  __typename?: 'GqlBatchIdGenerationResult';
  /** Total count generated */
  count: Scalars['Int']['output'];
  /** Generation time in milliseconds */
  generationTimeMs: Scalars['Float']['output'];
  /** Generated IDs */
  ids: Array<GqlIdGenerationResult>;
};

/** Result of batch rule import */
export type GqlBatchImportResult = {
  __typename?: 'GqlBatchImportResult';
  /** Number of rules auto-approved */
  autoApprovedCount: Scalars['Int']['output'];
  /** Number of rules that failed validation */
  failedCount: Scalars['Int']['output'];
  /** Number of rules successfully imported */
  importedCount: Scalars['Int']['output'];
  /** Individual results per rule */
  results: Array<GqlRuleImportResult>;
  /** Number of rules routed to human review */
  reviewRequiredCount: Scalars['Int']['output'];
  /** Batch-level warnings */
  warnings: Array<Scalars['String']['output']>;
};

/** An atomic reusable part from the config catalog. */
export type GqlCatalogPart = {
  __typename?: 'GqlCatalogPart';
  /** Category (intake, assessment, financial, etc.) */
  category: Scalars['String']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Human-readable name */
  displayName: Scalars['String']['output'];
  /** Config ID (e.g., tg-4-0-001, fs-4-adl-assessment) */
  id: Scalars['String']['output'];
  /** Part type: TASK_GROUP, FORM_FRAGMENT, WORKFLOW_FRAGMENT */
  partType: Scalars['String']['output'];
  /** Edge relationship to the query target */
  relationship: Scalars['String']['output'];
};

/** Checkpoint statistics */
export type GqlCheckpointStatistics = {
  __typename?: 'GqlCheckpointStatistics';
  availableCheckpoints: Scalars['Int']['output'];
  averageRollbackCount: Scalars['Float']['output'];
  averageSnapshotSize: Scalars['Float']['output'];
  rolledBackCheckpoints: Scalars['Int']['output'];
  totalCheckpoints: Scalars['Int']['output'];
  totalStorageBytes: Scalars['Int']['output'];
};

export const GqlCheckpointStatus = {
  ARCHIVED: 'ARCHIVED',
  AVAILABLE: 'AVAILABLE',
  CORRUPTED: 'CORRUPTED',
  EXPIRED: 'EXPIRED',
  ROLLED_BACK: 'ROLLED_BACK',
} as const;

export type GqlCheckpointStatus = (typeof GqlCheckpointStatus)[keyof typeof GqlCheckpointStatus];
export const GqlCheckpointType = {
  COMPENSATION_POINT: 'COMPENSATION_POINT',
  RESUME_POINT: 'RESUME_POINT',
  SNAPSHOT: 'SNAPSHOT',
} as const;

export type GqlCheckpointType = (typeof GqlCheckpointType)[keyof typeof GqlCheckpointType];
/** Connection type for paginated child workflow results. */
export type GqlChildWorkflowConnection = {
  __typename?: 'GqlChildWorkflowConnection';
  /** Has more results? */
  hasMore: Scalars['Boolean']['output'];
  /** List of child instances */
  items: Array<GqlChildWorkflowProgress>;
  /** Next page cursor (optional) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Total count */
  total: Scalars['Int']['output'];
};

/** Input for querying sub-workflows of a parent instance. */
export type GqlChildWorkflowFilterInput = {
  /** Include only active (non-terminal) children */
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by status */
  status?: InputMaybe<GqlInstanceStatus | '%future added value'>;
  /** Filter by workflow name */
  workflowName?: InputMaybe<Scalars['String']['input']>;
};

/** Progress tracking for a single child workflow. */
export type GqlChildWorkflowProgress = {
  __typename?: 'GqlChildWorkflowProgress';
  /** Timestamp when child completed (if terminal) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Completed tasks in this child workflow */
  completedTasks: Scalars['Int']['output'];
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Child instance ID */
  instanceId: Scalars['String']['output'];
  /** Progress percentage (0.0 - 100.0) */
  progressPercent: Scalars['Float']['output'];
  /** Timestamp when child was started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status */
  status: GqlInstanceStatus | '%future added value';
  /** Total tasks in this child workflow */
  totalTasks: Scalars['Int']['output'];
  /** Workflow definition name */
  workflowName: Scalars['String']['output'];
  /** Workflow definition version */
  workflowVersion: Scalars['String']['output'];
};

/** Rule classification */
export type GqlClassification = {
  __typename?: 'GqlClassification';
  /** Compliance domain */
  complianceDomain: GqlComplianceDomain | '%future added value';
  /** Whether rule involves PII */
  piiImpact: Scalars['Boolean']['output'];
  /** Safety level */
  safetyLevel: GqlSafetyLevel | '%future added value';
  /** Classification tags */
  tags: Array<Scalars['String']['output']>;
};

/**
 * A single co-responder — an actor who has a task in the same workflow instance.
 * Returned by coRespondersForInstance to surface Ring 1 peer task status.
 * Detail level is role-scoped: operational status only (no clinical data exposed).
 */
export type GqlCoResponder = {
  __typename?: 'GqlCoResponder';
  /** Actor ID of the co-responder (sequential format: `{tenant_num}_{user_num}`) */
  actorId: Scalars['String']['output'];
  /** Whether this co-responder is the current actor (self-reference for UI) */
  isSelf: Scalars['Boolean']['output'];
  /** Aggregate task status for this actor in this instance */
  status: Scalars['String']['output'];
  /** Task ID assigned to this co-responder */
  taskId: Scalars['String']['output'];
  /** Task name for display */
  taskName: Scalars['String']['output'];
  /** Task type (e.g., "care", "environmental", "clinical") */
  taskType: Scalars['String']['output'];
};

/**
 * Co-responder list for a specific workflow instance within a constellation.
 * Groups all actors who have tasks for the same instance (same event response).
 * Used by Ring 1 nodes in constellation instance mode to show peer awareness.
 */
export type GqlCoResponderList = {
  __typename?: 'GqlCoResponderList';
  /** All actors with tasks in this instance (Ring 1 co-responders) */
  coResponders: Array<GqlCoResponder>;
  constellationId: Scalars['String']['output'];
  instanceId: Scalars['String']['output'];
};

export const GqlCompensationStrategy = {
  AUTOMATIC: 'AUTOMATIC',
  CONDITIONAL: 'CONDITIONAL',
  MANUAL: 'MANUAL',
} as const;

export type GqlCompensationStrategy =
  (typeof GqlCompensationStrategy)[keyof typeof GqlCompensationStrategy];
/** Compilation error in GraphQL format */
export type GqlCompileError = {
  __typename?: 'GqlCompileError';
  /** Column number (1-indexed) */
  column?: Maybe<Scalars['Int']['output']>;
  /** FERP error code (e.g., "FERP-4008") */
  ferpCode: Scalars['String']['output'];
  /** Error kind */
  kind: GqlCompileErrorKind | '%future added value';
  /** Line number (1-indexed) */
  line?: Maybe<Scalars['Int']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

/** Error kind enum for GraphQL */
export const GqlCompileErrorKind = {
  INVALID_ACTION: 'INVALID_ACTION',
  INVALID_OPERATOR: 'INVALID_OPERATOR',
  INVALID_VALUE: 'INVALID_VALUE',
  PARSE_ERROR: 'PARSE_ERROR',
  SEMANTIC_ERROR: 'SEMANTIC_ERROR',
  UNKNOWN_FIELD: 'UNKNOWN_FIELD',
} as const;

export type GqlCompileErrorKind = (typeof GqlCompileErrorKind)[keyof typeof GqlCompileErrorKind];
export type GqlCompleteTaskInput = {
  actualCost?: InputMaybe<Scalars['Float']['input']>;
  outputData: Scalars['JSON']['input'];
  taskId: Scalars['String']['input'];
};

/** Completeness score result */
export type GqlCompletenessScore = {
  __typename?: 'GqlCompletenessScore';
  matchingFormulaName?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
};

/** Compliance domain for rule classification */
export const GqlComplianceDomain = {
  FINANCE: 'FINANCE',
  GENERAL: 'GENERAL',
  HEALTHCARE: 'HEALTHCARE',
  HR: 'HR',
  LEGAL: 'LEGAL',
  MANUFACTURING: 'MANUFACTURING',
  OPERATIONS: 'OPERATIONS',
  OTHER: 'OTHER',
  PRIVACY: 'PRIVACY',
  SAFETY: 'SAFETY',
} as const;

export type GqlComplianceDomain = (typeof GqlComplianceDomain)[keyof typeof GqlComplianceDomain];
/** Compliance Severity */
export const GqlComplianceSeverity = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
} as const;

export type GqlComplianceSeverity =
  (typeof GqlComplianceSeverity)[keyof typeof GqlComplianceSeverity];
export const GqlComplianceStatus = {
  COMPLIANT: 'COMPLIANT',
  EXPIRED: 'EXPIRED',
  NON_COMPLIANT: 'NON_COMPLIANT',
  PENDING_REVIEW: 'PENDING_REVIEW',
} as const;

export type GqlComplianceStatus = (typeof GqlComplianceStatus)[keyof typeof GqlComplianceStatus];
/** A suggested workflow composition from catalog traversal. */
export type GqlCompositionSuggestion = {
  __typename?: 'GqlCompositionSuggestion';
  /** Explanation of why these parts were selected */
  explanation: Scalars['String']['output'];
  /** Suggested workflow name */
  name: Scalars['String']['output'];
  /** Which rulesets this composition satisfies */
  satisfiesRulesets: Array<Scalars['String']['output']>;
  /** Ordered list of task group IDs */
  taskGroupIds: Array<Scalars['String']['output']>;
};

/** Result of ID compression */
export type GqlCompressResult = {
  __typename?: 'GqlCompressResult';
  /** Compressed ID */
  compressedId: Scalars['String']['output'];
  /** Original hydrated ID */
  hydratedId: Scalars['String']['output'];
};

/** Result of a server-side field computation. */
export type GqlComputedResult = {
  __typename?: 'GqlComputedResult';
  cacheHit: Scalars['Boolean']['output'];
  computedAt: Scalars['String']['output'];
  displayValue?: Maybe<Scalars['String']['output']>;
  value: Scalars['JSON']['output'];
};

/** Reason for a sync conflict */
export const GqlConflictReason = {
  /** Same entity edited concurrently by multiple offline devices */
  CONCURRENT_EDIT: 'CONCURRENT_EDIT',
  /** Same event submitted from multiple devices */
  DUPLICATE_EVENT: 'DUPLICATE_EVENT',
  /** Pre-synced entity not found on hub (deleted or never existed) */
  ENTITY_NOT_FOUND: 'ENTITY_NOT_FOUND',
  /** Medication dosage conflict — NEVER auto-resolve (LIFE-CRITICAL) */
  MED_DOSAGE: 'MED_DOSAGE',
  /** Device schema version doesn't match hub schema version */
  SCHEMA_VERSION_MISMATCH: 'SCHEMA_VERSION_MISMATCH',
} as const;

export type GqlConflictReason = (typeof GqlConflictReason)[keyof typeof GqlConflictReason];
export const GqlConflictResolution = {
  AUCTION: 'AUCTION',
  FIRST_COME_FIRST_SERVE: 'FIRST_COME_FIRST_SERVE',
  PRIORITY: 'PRIORITY',
} as const;

export type GqlConflictResolution =
  (typeof GqlConflictResolution)[keyof typeof GqlConflictResolution];
/** Status of a sync conflict */
export const GqlConflictStatus = {
  /** Escalated to supervisor */
  ESCALATED: 'ESCALATED',
  /** Under active review */
  IN_REVIEW: 'IN_REVIEW',
  /** Awaiting human review */
  PENDING: 'PENDING',
  /** Resolved — one value accepted */
  RESOLVED: 'RESOLVED',
} as const;

export type GqlConflictStatus = (typeof GqlConflictStatus)[keyof typeof GqlConflictStatus];
/**
 * Aggregated task status summary for an entire constellation instance.
 * One entry per unique workflow instance found in the constellation's tasks.
 * Used by Ring 3 status overlays in CareTeamConstellationView (DRR-126 Phase 2).
 */
export type GqlConstellationTaskSummary = {
  __typename?: 'GqlConstellationTaskSummary';
  /** Per-workflow-instance breakdown (one entry per Ring 3 node) */
  byInstance: Array<GqlInstanceTaskSummary>;
  completed: Scalars['Int']['output'];
  constellationId: Scalars['String']['output'];
  inProgress: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GqlConstraintConnection = {
  __typename?: 'GqlConstraintConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Constraint>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export const GqlConstraintOperator = {
  BETWEEN: 'BETWEEN',
  EQUAL: 'EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
} as const;

export type GqlConstraintOperator =
  (typeof GqlConstraintOperator)[keyof typeof GqlConstraintOperator];
export type GqlConstraintScope = {
  __typename?: 'GqlConstraintScope';
  scopeId?: Maybe<Scalars['String']['output']>;
  scopeType: Scalars['String']['output'];
};

export type GqlConstraintScopeInput = {
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType: Scalars['String']['input'];
};

export const GqlConstraintStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  VIOLATED: 'VIOLATED',
  WARNING: 'WARNING',
} as const;

export type GqlConstraintStatus = (typeof GqlConstraintStatus)[keyof typeof GqlConstraintStatus];
export const GqlConstraintType = {
  BUSINESS_RULE: 'BUSINESS_RULE',
  CAPACITY: 'CAPACITY',
  /**
   * Use with domainContext for domain-specific constraints.
   * Examples: "healthcare:patient", "finance:payment", "legal:deadline"
   */
  CUSTOM: 'CUSTOM',
  FINANCIAL: 'FINANCIAL',
  QUOTA: 'QUOTA',
  RATE_LIMIT: 'RATE_LIMIT',
  REGULATORY: 'REGULATORY',
  /** HOW dimension enforcement — required method for task completion (DRR-129 G-NEW-C). */
  REQUIRED_METHOD: 'REQUIRED_METHOD',
  RESOURCE: 'RESOURCE',
  TEMPORAL: 'TEMPORAL',
} as const;

export type GqlConstraintType = (typeof GqlConstraintType)[keyof typeof GqlConstraintType];
export type GqlContractConnection = {
  __typename?: 'GqlContractConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Contract>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export const GqlContractStatus = {
  ACTIVE: 'ACTIVE',
  /**
   * Contract archived (FERP Append-Only Architecture - soft delete).
   * FERP Principle: Immutable history for life-critical workflows.
   */
  ARCHIVED: 'ARCHIVED',
  BREACHED: 'BREACHED',
  MET: 'MET',
  PAUSED: 'PAUSED',
  WARNING: 'WARNING',
} as const;

export type GqlContractStatus = (typeof GqlContractStatus)[keyof typeof GqlContractStatus];
/** Core primitive types from FERP (5 phases × 5 primitives = 25 total) */
export const GqlCorePrimitive = {
  ACTOR: 'ACTOR',
  ACTOR_DESCRIPTOR: 'ACTOR_DESCRIPTOR',
  ALERT: 'ALERT',
  AUDIT_TRAIL: 'AUDIT_TRAIL',
  BASELINE: 'BASELINE',
  CONTEXT: 'CONTEXT',
  DASHBOARD: 'DASHBOARD',
  DEPENDENCY: 'DEPENDENCY',
  DOCUMENT: 'DOCUMENT',
  EVENT: 'EVENT',
  EXPERIMENT: 'EXPERIMENT',
  HEALTH_CHECK: 'HEALTH_CHECK',
  INSIGHT: 'INSIGHT',
  METRIC: 'METRIC',
  NOTIFICATION: 'NOTIFICATION',
  QUEUE: 'QUEUE',
  RECOMMENDATION: 'RECOMMENDATION',
  REPORT: 'REPORT',
  RESOURCE: 'RESOURCE',
  RULE: 'RULE',
  SLA: 'SLA',
  TASK: 'TASK',
  TASK_DESCRIPTOR: 'TASK_DESCRIPTOR',
  WORKFLOW_DEFINITION: 'WORKFLOW_DEFINITION',
  WORKFLOW_INSTANCE: 'WORKFLOW_INSTANCE',
} as const;

export type GqlCorePrimitive = (typeof GqlCorePrimitive)[keyof typeof GqlCorePrimitive];
export type GqlCreateActorInput = {
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  actorType: GqlActorType | '%future added value';
  /**
   * Auth user ID for HUMAN actors. Links actor to ferp-identity user registry.
   * When provided for HUMAN actors, auto-registers in ferp-identity with
   * sequential user_num and sets actor_global_id to composite_user_id.
   */
  authUserId?: InputMaybe<Scalars['String']['input']>;
  autonomyLevel?: InputMaybe<Scalars['String']['input']>;
  capabilities: Array<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  contactInfo?: InputMaybe<Scalars['JSON']['input']>;
  criticalityLevel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  dualControlCapable?: InputMaybe<Scalars['Boolean']['input']>;
  expertTier?: InputMaybe<Scalars['String']['input']>;
  instanceName?: InputMaybe<Scalars['String']['input']>;
  licenseJurisdiction?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  primaryRoleId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  regulatoryClearance?: InputMaybe<Array<Scalars['String']['input']>>;
  regulatoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  requiresDualControl?: InputMaybe<Scalars['Boolean']['input']>;
  requiresHumanOversight?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSupervision?: InputMaybe<Scalars['Boolean']['input']>;
  retentionYears?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** DRR-103: Multiple Role config IDs for Actor->Role->Scope resolution. */
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisedByActorId?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a new annotation. */
export type GqlCreateAnnotationInput = {
  /** Annotation classification (defaults to COMMENT) */
  annotationType?: InputMaybe<GqlAnnotationType | '%future added value'>;
  /** Markdown content of the annotation */
  body: Scalars['String']['input'];
  /** Target entity Snowflake ID */
  entityId: Scalars['String']['input'];
  /** Target entity type (e.g., "task", "approval", "workflow") */
  entityType: Scalars['String']['input'];
  /** Actor IDs to @mention (triggers notifications) */
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Parent annotation ID for replies (omit for top-level comment) */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** Cross-references to other related entity IDs */
  relatedEntityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Visibility level (defaults to INTERNAL) */
  visibility?: InputMaybe<GqlAnnotationVisibility | '%future added value'>;
  /** Linked workflow instance ID (optional) */
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new Approval. */
export type GqlCreateApprovalInput = {
  approvalName: Scalars['String']['input'];
  approvalStrategy?: InputMaybe<GqlApprovalStrategy | '%future added value'>;
  approvalType: GqlApprovalType | '%future added value';
  approverId: Scalars['String']['input'];
  approverRole: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  policyId: Scalars['String']['input'];
  priority?: InputMaybe<GqlApprovalPriority | '%future added value'>;
  requiredApprovals?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  workflowInstanceId: Scalars['String']['input'];
};

/** Input for creating a new checkpoint */
export type GqlCreateCheckpointInput = {
  checkpointName: Scalars['String']['input'];
  checkpointType: GqlCheckpointType | '%future added value';
  compensationTaskId?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
  parentCheckpointId?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber: Scalars['Int']['input'];
  stateSnapshot: Scalars['JSON']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  workflowInstanceId: Scalars['String']['input'];
};

export type GqlCreateConstraintInput = {
  autoDisableThreshold?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  constrainedEntity: Scalars['String']['input'];
  constraintType: GqlConstraintType | '%future added value';
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Domain context for domain-agnostic constraints. Use with constraintType=CUSTOM.
   * Format: "{domain}:{subtype}" (e.g., "healthcare:patient", "finance:payment")
   */
  domainContext?: InputMaybe<Scalars['String']['input']>;
  effectiveDates?: InputMaybe<ConstraintDateRangeInput>;
  enforcementPhase: Array<GqlEnforcementPhase | '%future added value'>;
  entitySubtype?: InputMaybe<Scalars['String']['input']>;
  limitValue: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  notificationActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationAtPercent?: InputMaybe<Array<Scalars['Int']['input']>>;
  notificationChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  operator: GqlConstraintOperator | '%future added value';
  overrideAllowedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  overrideRequiresReason?: InputMaybe<Scalars['Boolean']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  scope: GqlConstraintScopeInput;
  secondaryLimit?: InputMaybe<Scalars['Float']['input']>;
  timeWindow?: InputMaybe<GqlTimeWindow | '%future added value'>;
  unit: Scalars['String']['input'];
  violationAction: GqlViolationAction | '%future added value';
};

export type GqlCreateContractInput = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  escalationChain?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  resolutionTimeMinutes: Scalars['Int']['input'];
  responseTimeMinutes: Scalars['Int']['input'];
  slaName: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

export type GqlCreateEventInput = {
  action: GqlEventAction | '%future added value';
  category: GqlEventCategory | '%future added value';
  changeSummary: Scalars['String']['input'];
  checkpointId?: InputMaybe<Scalars['String']['input']>;
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  eventType: GqlEventType | '%future added value';
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  newValue?: InputMaybe<Scalars['JSON']['input']>;
  oldValue?: InputMaybe<Scalars['JSON']['input']>;
  onBehalfOf?: InputMaybe<Scalars['String']['input']>;
  processingDurationMs?: InputMaybe<Scalars['String']['input']>;
  severity: GqlEventSeverity | '%future added value';
  source: GqlEventSource | '%future added value';
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  workflowInstanceId: Scalars['String']['input'];
};

/** Create formula input */
export type GqlCreateFormulaInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discoveryMethod?: InputMaybe<GqlDiscoveryMethod | '%future added value'>;
  formulaId: Scalars['String']['input'];
  interactions: Array<GqlFormulaInteractionInput>;
  name: Scalars['String']['input'];
  primitives: Array<GqlPrimitiveType | '%future added value'>;
  successRate?: InputMaybe<Scalars['Float']['input']>;
  tenantId: Scalars['String']['input'];
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Input for creating a new Instance.
 *
 * Creates workflow execution context from WorkflowDefinition template.
 */
export type GqlCreateInstanceInput = {
  /**
   * DRR-140: Constellation config ID this lifecycle instance is coordinated by.
   * Required when workflow_definition_id = "wf-0-12-001" (universal subject lifecycle).
   * e.g., "constellation-care-service-plan"
   */
  constellationRef?: InputMaybe<Scalars['String']['input']>;
  /** Initial context variables (optional) */
  contextVariables?: InputMaybe<Scalars['JSON']['input']>;
  /** Cross-system tracing ID (optional) */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /** Business deadline (optional) */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** Input payload for workflow execution */
  inputData: Scalars['JSON']['input'];
  /** Human-readable instance name (optional) */
  instanceName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum retry attempts (default: 3) */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Additional metadata (optional) */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Queue priority (0-255, default: 50) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Scheduled execution start time (optional) */
  scheduledStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * DRR-141: Sequential actor ID of the SUBJECT this lifecycle instance belongs to.
   * Set at createInstance when the subject is known (e.g., admit_resident knows the resident ID).
   * Enables listSubjectsWithLifecycle to map subject → phase without a constellation lookup.
   * None for non-subject-lifecycle workflow instances.
   */
  subjectActorId?: InputMaybe<Scalars['String']['input']>;
  /** Categorization tags (optional) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum execution time in milliseconds (optional) */
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  /** WorkflowDefinition ID to execute */
  workflowDefinitionId: Scalars['String']['input'];
};

/** Input for creating a journey edge. */
export type GqlCreateJourneyEdgeInput = {
  /** Optional description of the relationship */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Edge type (SPAWNED_BY, AFFECTS, BLOCKS, REQUIRES) */
  edgeType: GqlJourneyEdgeType | '%future added value';
  /** Source instance ID */
  sourceInstanceId: Scalars['String']['input'];
  /** Target instance ID */
  targetInstanceId: Scalars['String']['input'];
};

/** Input for creating a new Notification. */
export type GqlCreateNotificationInput = {
  bccActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ccActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  channels: Array<GqlNotificationChannel | '%future added value'>;
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  messageTemplate: Scalars['String']['input'];
  notificationTitle: Scalars['String']['input'];
  notificationType: GqlNotificationTriggerType | '%future added value';
  priority: GqlNotificationPriority | '%future added value';
  recipientActorIds: Array<Scalars['String']['input']>;
  relatedApprovalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedSlaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  triggerEntityId: Scalars['String']['input'];
  triggerEntityType: Scalars['String']['input'];
  triggerEventId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

export type GqlCreateQueueInput = {
  assignmentStrategy?: InputMaybe<GqlAssignmentStrategy | '%future added value'>;
  capacity: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  eligibleActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  overflowStrategy?: InputMaybe<GqlOverflowStrategy | '%future added value'>;
  queueName: Scalars['String']['input'];
  queueType?: InputMaybe<GqlQueueType | '%future added value'>;
  slaId?: InputMaybe<Scalars['String']['input']>;
  workflowInstanceId: Scalars['String']['input'];
};

/** Input for creating a new Resource */
export type GqlCreateResourceInput = {
  isConsumable: Scalars['Boolean']['input'];
  isLifeCriticalResource: Scalars['Boolean']['input'];
  isPhysical: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  resourceCategory: Scalars['String']['input'];
  resourceCode: Scalars['String']['input'];
  resourceName: Scalars['String']['input'];
  resourceSubcategory?: InputMaybe<Scalars['String']['input']>;
  resourceType: GqlResourceType | '%future added value';
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  totalCapacity: Scalars['Int']['input'];
  unitOfMeasure: Scalars['String']['input'];
};

export type GqlCreateScheduleInput = {
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  isLifeCritical?: InputMaybe<Scalars['Boolean']['input']>;
  notificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleCode: Scalars['String']['input'];
  scheduleName: Scalars['String']['input'];
  scheduleType: GqlScheduleType | '%future added value';
  startDatetime: Scalars['DateTime']['input'];
  targetTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateTaskInput = {
  assignedActorId?: InputMaybe<Scalars['String']['input']>;
  /** Constellation instance ID (DRR-118) */
  constellationId?: InputMaybe<Scalars['String']['input']>;
  constraintIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  /** SLA deadline for this task */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedCost?: InputMaybe<Scalars['Float']['input']>;
  estimatedDurationMs?: InputMaybe<Scalars['String']['input']>;
  failureStrategy?: InputMaybe<GqlFailureStrategy | '%future added value'>;
  inputData?: InputMaybe<Scalars['JSON']['input']>;
  /** WHY — Mandating regulation config ID (DRR-117) */
  mandateRef?: InputMaybe<Scalars['String']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notificationActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<GqlTaskPriority | '%future added value'>;
  queueId?: InputMaybe<Scalars['String']['input']>;
  /** Planned end time for scheduling (DRR-116) */
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Planned start time for scheduling (DRR-116) */
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  slaId?: InputMaybe<Scalars['String']['input']>;
  /** Subject actor — WHO this task is about (patient/client/resident) */
  subjectActorId?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<GqlTaskType | '%future added value'>;
  workflowInstanceId: Scalars['String']['input'];
};

/** Input for creating a new Team. */
export type GqlCreateTeamInput = {
  /** Budget allocation (optional) */
  budgetAllocated?: InputMaybe<Scalars['Float']['input']>;
  /** Short code (alphanumeric + hyphens/underscores) */
  code: Scalars['String']['input'];
  /** Contact information (optional) */
  contacts?: InputMaybe<GqlTeamContactsInput>;
  /** Cost center code (optional) */
  costCenter?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata (optional) */
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Deputy leader ID (optional) */
  deputyLeadId?: InputMaybe<Scalars['String']['input']>;
  /** Team purpose (optional) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Effective date (optional, defaults to now) */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Display name */
  name: Scalars['String']['input'];
  /** Parent team ID (optional, for hierarchy) */
  parentTeamId?: InputMaybe<Scalars['String']['input']>;
  /** Resource quotas (optional) */
  quotaLimits?: InputMaybe<GqlQuotaLimitsInput>;
  /** Searchable tags (optional) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Team leader ID (optional) */
  teamLeadId?: InputMaybe<Scalars['String']['input']>;
  /** Team type classification */
  teamType: GqlTeamType | '%future added value';
};

/** Input for creating a template */
export type GqlCreateTemplateInput = {
  auditRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  businessLayer: Scalars['JSON']['input'];
  category: Scalars['String']['input'];
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  criticality: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  jurisdictionalScope?: InputMaybe<Array<Scalars['String']['input']>>;
  mappingsLayer: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  primitiveLayer: Scalars['JSON']['input'];
  riskClassification?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetFormulas?: InputMaybe<Array<Scalars['String']['input']>>;
  uiLayer: Scalars['JSON']['input'];
  version: Scalars['String']['input'];
};

/** Input for creating a new Validation. */
export type GqlCreateValidationInput = {
  /** Unique code within tenant */
  code: Scalars['String']['input'];
  /** Regulatory frameworks (optional) */
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional conditional expression (optional) */
  conditionalLogic?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata (optional) */
  customMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Validation codes this depends on (optional) */
  dependsOn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Human-readable description (optional) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Date range when validation is effective (optional) */
  effectiveDates?: InputMaybe<ValidationDateRangeInput>;
  /** User-facing error message */
  errorMessage: Scalars['String']['input'];
  /** When to execute validation */
  executionPhase: Array<GqlExecutionPhase | '%future added value'>;
  /** Dot-notation path to field */
  fieldPath: Scalars['String']['input'];
  /** Optional suggestion to fix error (optional) */
  fixSuggestion?: InputMaybe<Scalars['String']['input']>;
  /** Does error block submission? (optional, auto-set from severity) */
  isBlocking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name for UI */
  name: Scalars['String']['input'];
  /** Additional rule parameters (optional) */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** Validation rule specification */
  rule: GqlValidationRuleInput;
  /** Error severity level */
  severity: GqlValidationSeverity | '%future added value';
  /** Searchable tags (optional) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of validation */
  validationType: GqlValidationType | '%future added value';
};

/**
 * Input for creating a workflow.
 * NOTE: tenant_id and created_by come from AuthCtx (not GraphQL parameter)
 */
export type GqlCreateWorkflowInput = {
  /** Action registry */
  actions: Array<GqlActionEntryInput>;
  /** Is this workflow version active? */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required audit actions */
  auditRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Regulatory authority ID */
  authorityId?: InputMaybe<Scalars['String']['input']>;
  /** Compliance frameworks */
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Compliance level */
  complianceLevel?: InputMaybe<Scalars['String']['input']>;
  /** Criticality level */
  criticality?: InputMaybe<Scalars['String']['input']>;
  /** Optional description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Effective date (ISO 8601) */
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  /** Execution strategy */
  executionStrategy?: InputMaybe<Scalars['String']['input']>;
  /** Expiration date (ISO 8601) */
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  /** Guard registry */
  guards: Array<GqlGuardEntryInput>;
  /** Starting state name */
  initialState: Scalars['String']['input'];
  /** Jurisdictional scope */
  jurisdictionalScope?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom metadata (JSON) */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Workflow name */
  name: Scalars['String']['input'];
  /** Regulatory requirements */
  regulations?: InputMaybe<Array<GqlRegulationInput>>;
  /** Retry configuration */
  retryPolicy?: InputMaybe<GqlRetryPolicyInput>;
  /** Risk classification */
  riskClassification?: InputMaybe<Scalars['String']['input']>;
  /** State definitions */
  states: Array<GqlWorkflowStateInput>;
  /** Target formulas (v1.1) */
  targetFormulas?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Overall workflow timeout in seconds */
  timeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Transition rules */
  transitions: Array<GqlStateTransitionInput>;
  /** Semantic version */
  version: Scalars['String']['input'];
};

/** Data-driven formula for GraphQL */
export type GqlDataDrivenFormula = {
  __typename?: 'GqlDataDrivenFormula';
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  discoveryMethod: GqlDiscoveryMethod | '%future added value';
  enabled: Scalars['Boolean']['output'];
  formulaId: Scalars['String']['output'];
  interactions: Array<GqlFormulaInteraction>;
  name: Scalars['String']['output'];
  primitives: Array<GqlPrimitiveType | '%future added value'>;
  successRate: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
  useCases: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** GraphQL enum for data tier */
export const GqlDataTier = {
  T1: 'T1',
  T2: 'T2',
  T3: 'T3',
  T4: 'T4',
} as const;

export type GqlDataTier = (typeof GqlDataTier)[keyof typeof GqlDataTier];
/** Input for delegating an Approval. */
export type GqlDelegateApprovalInput = {
  delegateTo: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** GraphQL enum for DependencyStatus. */
export const GqlDependencyStatus = {
  /** Dependency bypassed */
  BYPASSED: 'BYPASSED',
  /** Dependency failed */
  FAILED: 'FAILED',
  /** Predecessor in progress */
  IN_PROGRESS: 'IN_PROGRESS',
  /** Dependency not yet evaluated */
  PENDING: 'PENDING',
  /** Dependency satisfied */
  SATISFIED: 'SATISFIED',
} as const;

export type GqlDependencyStatus = (typeof GqlDependencyStatus)[keyof typeof GqlDependencyStatus];
/** GraphQL enum for DependencyType. */
export const GqlDependencyType = {
  /** Finish-to-Finish: Successor finishes when predecessor finishes */
  FINISH_TO_FINISH: 'FINISH_TO_FINISH',
  /** Finish-to-Start: Successor starts after predecessor finishes */
  FINISH_TO_START: 'FINISH_TO_START',
  /** Start-to-Finish: Successor finishes when predecessor starts (rare) */
  START_TO_FINISH: 'START_TO_FINISH',
  /** Start-to-Start: Successor starts when predecessor starts */
  START_TO_START: 'START_TO_START',
} as const;

export type GqlDependencyType = (typeof GqlDependencyType)[keyof typeof GqlDependencyType];
export const GqlDepreciationMethod = {
  DECLINING_BALANCE: 'DECLINING_BALANCE',
  NONE: 'NONE',
  STRAIGHT_LINE: 'STRAIGHT_LINE',
  SUM_OF_YEARS: 'SUM_OF_YEARS',
} as const;

export type GqlDepreciationMethod =
  (typeof GqlDepreciationMethod)[keyof typeof GqlDepreciationMethod];
/** Discovery method for GraphQL */
export const GqlDiscoveryMethod = {
  MACHINE_LEARNING: 'MACHINE_LEARNING',
  MANUAL: 'MANUAL',
  SYSTEM_RECOMMENDED: 'SYSTEM_RECOMMENDED',
  USAGE_ANALYSIS: 'USAGE_ANALYSIS',
} as const;

export type GqlDiscoveryMethod = (typeof GqlDiscoveryMethod)[keyof typeof GqlDiscoveryMethod];
/** Document access log entry */
export type GqlDocumentAccessLog = {
  __typename?: 'GqlDocumentAccessLog';
  /** Access action */
  action: GqlAccessAction | '%future added value';
  /** Document ID */
  documentId: Scalars['String']['output'];
  /** Document type */
  documentType: GqlGeneratedDocumentType | '%future added value';
  /** Failure reason if applicable */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** Geo location */
  geoLocation?: Maybe<Scalars['String']['output']>;
  /** Log entry ID */
  id: Scalars['String']['output'];
  /** IP address */
  ipAddress: Scalars['String']['output'];
  /** Session ID */
  sessionId: Scalars['String']['output'];
  /** Whether action succeeded */
  success: Scalars['Boolean']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
  /** User agent */
  userAgent: Scalars['String']['output'];
  /** User who performed action */
  userId: Scalars['String']['output'];
};

/** Connection type for pagination */
export type GqlDocumentConnection = {
  __typename?: 'GqlDocumentConnection';
  /** Cursor for next page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Has more pages */
  hasNextPage: Scalars['Boolean']['output'];
  /** Document entries */
  nodes: Array<GqlDocumentRegistryEntry>;
  /** Total count */
  totalCount: Scalars['Int']['output'];
};

/** Document generation job */
export type GqlDocumentJob = {
  __typename?: 'GqlDocumentJob';
  /** Completion timestamp (ISO 8601) */
  completedAt?: Maybe<Scalars['String']['output']>;
  /** Correlation ID for tracing */
  correlationId?: Maybe<Scalars['String']['output']>;
  /** Generated document ID (on success) */
  documentId?: Maybe<Scalars['String']['output']>;
  /** Document type being generated */
  documentType: GqlGeneratedDocumentType | '%future added value';
  /** Error code (on failure) */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Estimated completion (ISO 8601) */
  estimatedCompletion?: Maybe<Scalars['String']['output']>;
  /** Job ID */
  id: Scalars['String']['output'];
  /** Progress 0-100 */
  progress: Scalars['Int']['output'];
  /** Request timestamp (ISO 8601) */
  requestedAt: Scalars['String']['output'];
  /** User who requested */
  requestedBy: Scalars['String']['output'];
  /** Source entity ID */
  sourceId: Scalars['String']['output'];
  /** Source type */
  sourceType: Scalars['String']['output'];
  /** Start timestamp (ISO 8601) */
  startedAt?: Maybe<Scalars['String']['output']>;
  /** Job status */
  status: GqlJobStatus | '%future added value';
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Worker type */
  workerType: Scalars['String']['output'];
};

/** Generated document metadata */
export type GqlDocumentRegistryEntry = {
  __typename?: 'GqlDocumentRegistryEntry';
  /** Access count */
  accessCount: Scalars['Int']['output'];
  /** Max opens allowed */
  allowedOpenCount?: Maybe<Scalars['Int']['output']>;
  /** Whether auth-to-open is required */
  authRequired: Scalars['Boolean']['output'];
  /** Creation timestamp (ISO 8601) */
  createdAt: Scalars['String']['output'];
  /** Created by user ID */
  createdByUserId: Scalars['String']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Document type */
  documentType: GqlGeneratedDocumentType | '%future added value';
  /** Expiration timestamp (ISO 8601) */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** File size in bytes */
  fileSizeBytes: Scalars['Int']['output'];
  /** Snowflake ID */
  id: Scalars['String']['output'];
  /** Job ID that generated this */
  jobId?: Maybe<Scalars['String']['output']>;
  /** Last access timestamp (ISO 8601) */
  lastAccessedAt?: Maybe<Scalars['String']['output']>;
  /** MIME type */
  mimeType: Scalars['String']['output'];
  /** Owner user ID */
  ownerUserId: Scalars['String']['output'];
  /** Whether revoked */
  revoked: Scalars['Boolean']['output'];
  /** Revocation timestamp (ISO 8601) */
  revokedAt?: Maybe<Scalars['String']['output']>;
  /** Who revoked */
  revokedBy?: Maybe<Scalars['String']['output']>;
  /** Revocation reason */
  revokedReason?: Maybe<Scalars['String']['output']>;
  /** Source entity ID */
  sourceEntityId: Scalars['String']['output'];
  /** Source entity type */
  sourceEntityType: Scalars['String']['output'];
  /** Source subgraph */
  sourceSubgraph: Scalars['String']['output'];
  /** Current status */
  status: GqlGeneratedDocumentStatus | '%future added value';
  /** Searchable tags */
  tags: Array<Scalars['String']['output']>;
  /** Tax year (for W-2, 1099) */
  taxYear?: Maybe<Scalars['Int']['output']>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Display title */
  title: Scalars['String']['output'];
  /** Last update timestamp (ISO 8601) */
  updatedAt: Scalars['String']['output'];
};

/** DRR-182: Result of createDraftInstance. */
export type GqlDraftInstanceResult = {
  __typename?: 'GqlDraftInstanceResult';
  created: Scalars['Boolean']['output'];
  draftId?: Maybe<Scalars['String']['output']>;
  existingId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** DSL example with description */
export type GqlDslExample = {
  __typename?: 'GqlDslExample';
  /** Example description */
  description: Scalars['String']['output'];
  /** Example name */
  name: Scalars['String']['output'];
  /** DSL source code */
  source: Scalars['String']['output'];
};

/** X12-specific context (nullable — non-EDI maps omit this) */
export type GqlEdiContext = {
  __typename?: 'GqlEdiContext';
  element?: Maybe<Scalars['String']['output']>;
  loop?: Maybe<Scalars['String']['output']>;
  qualifier?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
};

export const GqlEnforcementPhase = {
  POST_EXECUTION: 'POST_EXECUTION',
  PRE_APPROVAL: 'PRE_APPROVAL',
  PRE_ASSIGNMENT: 'PRE_ASSIGNMENT',
  PRE_EXECUTION: 'PRE_EXECUTION',
  RUNTIME: 'RUNTIME',
} as const;

export type GqlEnforcementPhase = (typeof GqlEnforcementPhase)[keyof typeof GqlEnforcementPhase];
export type GqlEnqueueTaskInput = {
  priority?: InputMaybe<Scalars['Int']['input']>;
  taskId: Scalars['String']['input'];
};

/** Result of an enrollActor mutation. */
export type GqlEnrollmentResult = {
  __typename?: 'GqlEnrollmentResult';
  /** Created actor ID */
  actorId?: Maybe<Scalars['String']['output']>;
  /** Provisioned constellation ID */
  constellationId?: Maybe<Scalars['String']['output']>;
  /** Error message if enrollment failed */
  error?: Maybe<Scalars['String']['output']>;
  /** First task ID (for immediate navigation) */
  firstTaskId?: Maybe<Scalars['String']['output']>;
  /** Created workflow instance ID */
  instanceId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * Complete entity journey graph for N selected actors.
 *
 * DRR-126 Phase 5: Returned by `entityJourneyGraph(actorIds)`. Contains all
 * nodes (tasks) and edges (temporal + intersection) for the requested actors.
 * Frontend `NeuralJourneyGraph.tsx` renders this as a 3D force-directed graph
 * using react-force-graph-3d (Three.js/WebGL).
 *
 * Data tier: T2 (operational). No clinical content — only task metadata.
 * Backend enforces per DRR-102 (role-scoped) + DRR-114 (T2 only).
 */
export type GqlEntityJourneyGraph = {
  __typename?: 'GqlEntityJourneyGraph';
  /** Actor display names (resolved from DDB — never raw sequential IDs, DRR-105) */
  actorNames: Array<Scalars['String']['output']>;
  /** All edges (temporal + intersection) */
  edges: Array<GqlJourneyEdge>;
  /** Instance IDs that appear for 2+ actors — these are intersection points */
  intersectionInstanceIds: Array<Scalars['String']['output']>;
  /** All journey nodes (one per task per actor) */
  nodes: Array<GqlJourneyNode>;
  /** Total task count across all actors */
  totalNodes: Scalars['Int']['output'];
};

/** Input for escalating an Approval. */
export type GqlEscalateApprovalInput = {
  escalateTo: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export const GqlEventAction = {
  APPROVED: 'APPROVED',
  ASSIGNED: 'ASSIGNED',
  CANCELLED: 'CANCELLED',
  CHECKPOINT_CREATED: 'CHECKPOINT_CREATED',
  CLAIMED: 'CLAIMED',
  COMMITTED: 'COMMITTED',
  COMPLETED: 'COMPLETED',
  CREATED: 'CREATED',
  CUSTOM: 'CUSTOM',
  DELEGATED: 'DELEGATED',
  DELETED: 'DELETED',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OUT: 'LOGGED_OUT',
  LOGIN_FAILED: 'LOGIN_FAILED',
  MFA_DISABLED: 'MFA_DISABLED',
  MFA_ENABLED: 'MFA_ENABLED',
  MFA_VERIFIED: 'MFA_VERIFIED',
  PASSWORD_CHANGED: 'PASSWORD_CHANGED',
  PASSWORD_RESET_REQUESTED: 'PASSWORD_RESET_REQUESTED',
  PAUSED: 'PAUSED',
  READ: 'READ',
  READ_ACTION: 'READ_ACTION',
  REJECTED: 'REJECTED',
  RELEASED: 'RELEASED',
  RESUMED: 'RESUMED',
  ROLLED_BACK: 'ROLLED_BACK',
  SENT: 'SENT',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  SESSION_REFRESHED: 'SESSION_REFRESHED',
  STARTED: 'STARTED',
  STATE_TRANSITIONED: 'STATE_TRANSITIONED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  UNASSIGNED: 'UNASSIGNED',
  UPDATED: 'UPDATED',
} as const;

export type GqlEventAction = (typeof GqlEventAction)[keyof typeof GqlEventAction];
export const GqlEventCategory = {
  BEHAVIORAL_PATTERN: 'BEHAVIORAL_PATTERN',
  CARE: 'CARE',
  COMPLIANCE: 'COMPLIANCE',
  DATA: 'DATA',
  INTERVENTION: 'INTERVENTION',
  MED_EVENT: 'MED_EVENT',
  OBSERVATION: 'OBSERVATION',
  PERFORMANCE: 'PERFORMANCE',
  SECURITY: 'SECURITY',
  SELF_REPORT: 'SELF_REPORT',
  SYSTEM: 'SYSTEM',
  USER: 'USER',
  VISITOR: 'VISITOR',
  WORKFLOW: 'WORKFLOW',
} as const;

export type GqlEventCategory = (typeof GqlEventCategory)[keyof typeof GqlEventCategory];
export type GqlEventChainIntegrity = {
  __typename?: 'GqlEventChainIntegrity';
  chainValid: Scalars['Boolean']['output'];
  invalidEvents: Array<Scalars['String']['output']>;
  lastVerifiedAt: Scalars['DateTime']['output'];
  totalEvents: Scalars['Int']['output'];
};

export type GqlEventConnection = {
  __typename?: 'GqlEventConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Event>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type GqlEventFilterInput = {
  action?: InputMaybe<GqlEventAction | '%future added value'>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<GqlEventCategory | '%future added value'>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<GqlEventType | '%future added value'>;
  performedBy?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<GqlEventSeverity | '%future added value'>;
  source?: InputMaybe<GqlEventSource | '%future added value'>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

export const GqlEventSeverity = {
  CRITICAL: 'CRITICAL',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING',
} as const;

export type GqlEventSeverity = (typeof GqlEventSeverity)[keyof typeof GqlEventSeverity];
export const GqlEventSource = {
  AI: 'AI',
  API: 'API',
  INTEGRATION: 'INTEGRATION',
  SCHEDULER: 'SCHEDULER',
  SENSOR: 'SENSOR',
  SYSTEM: 'SYSTEM',
  USER: 'USER',
} as const;

export type GqlEventSource = (typeof GqlEventSource)[keyof typeof GqlEventSource];
export const GqlEventType = {
  AI_DECISION: 'AI_DECISION',
  COMPLIANCE_EVENT: 'COMPLIANCE_EVENT',
  ERROR_EVENT: 'ERROR_EVENT',
  INTEGRATION_EVENT: 'INTEGRATION_EVENT',
  PERFORMANCE_EVENT: 'PERFORMANCE_EVENT',
  SECURITY_EVENT: 'SECURITY_EVENT',
  STATE_CHANGE: 'STATE_CHANGE',
  SYSTEM_EVENT: 'SYSTEM_EVENT',
  USER_ACTION: 'USER_ACTION',
} as const;

export type GqlEventType = (typeof GqlEventType)[keyof typeof GqlEventType];
/** Evidence requirement for a rule */
export type GqlEvidence = {
  __typename?: 'GqlEvidence';
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Suggested FHIR resource type if applicable */
  fhirResource?: Maybe<Scalars['String']['output']>;
  /** Evidence name (e.g., "EVV_GPS_COORDINATES") */
  name: Scalars['String']['output'];
  /** Whether this evidence is mandatory */
  required: Scalars['Boolean']['output'];
};

/** A single evidence requirement that is missing (a gap) */
export type GqlEvidenceGap = {
  __typename?: 'GqlEvidenceGap';
  /** MDH survey citation count (DRR-250) — higher = more surveyor focus */
  citationCount?: Maybe<Scalars['Int']['output']>;
  /** Description of what evidence is needed */
  evidenceDescription: Scalars['String']['output'];
  /** Name of the required evidence (from rule.structured.evidence[].name) */
  evidenceName: Scalars['String']['output'];
  /** Documents found that satisfy this evidence (empty if gap) */
  foundDocumentIds: Array<Scalars['String']['output']>;
  /** Whether this evidence is required (vs optional) */
  required: Scalars['Boolean']['output'];
  /** Rule ID that requires this evidence */
  ruleId: Scalars['String']['output'];
  /** Human-readable rule text excerpt */
  ruleText: Scalars['String']['output'];
  /** Safety level of the rule */
  safetyLevel: GqlSafetyLevel | '%future added value';
};

/** Exception condition for a rule */
export type GqlException = {
  __typename?: 'GqlException';
  /** Alternative action when exception applies */
  alternativeAction?: Maybe<Scalars['String']['output']>;
  /** Condition when exception applies */
  condition: Scalars['String']['output'];
};

/**
 * GraphQL enum for ExecutionEngine (4 engines total).
 *
 * Determines which FERP runtime engine executes the instance.
 */
export const GqlExecutionEngine = {
  /** Actor-based message passing */
  ACTOR_RUNTIME: 'ACTOR_RUNTIME',
  /** Parallel execution with dependency resolution */
  DAG_WORKFLOW_ENGINE: 'DAG_WORKFLOW_ENGINE',
  /** Distributed FSM with compensation (Saga pattern) */
  SAGA_STATE_MACHINE: 'SAGA_STATE_MACHINE',
  /** Sequential FSM execution */
  STATE_MACHINE: 'STATE_MACHINE',
} as const;

export type GqlExecutionEngine = (typeof GqlExecutionEngine)[keyof typeof GqlExecutionEngine];
/** GraphQL enum for ExecutionPhase (7 phases). */
export const GqlExecutionPhase = {
  /** On approval request */
  APPROVAL_REQUEST: 'APPROVAL_REQUEST',
  /** On document upload */
  DOCUMENT_UPLOAD: 'DOCUMENT_UPLOAD',
  /** On form field blur */
  ON_BLUR: 'ON_BLUR',
  /** On form field change (real-time feedback) */
  ON_CHANGE: 'ON_CHANGE',
  /** On form submission */
  ON_SUBMIT: 'ON_SUBMIT',
  /** On task completion */
  TASK_COMPLETE: 'TASK_COMPLETE',
  /** On workflow start */
  WORKFLOW_START: 'WORKFLOW_START',
} as const;

export type GqlExecutionPhase = (typeof GqlExecutionPhase)[keyof typeof GqlExecutionPhase];
export type GqlExistsRule = {
  __typename?: 'GqlExistsRule';
  /** Entity type to check (e.g., "User", "Patient") */
  entityType: Scalars['String']['output'];
  /** ID field name (e.g., "userId", "patientId") */
  idField: Scalars['String']['output'];
};

export type GqlExistsRuleInput = {
  entityType: Scalars['String']['input'];
  idField: Scalars['String']['input'];
};

/** Export Format (GraphQL enum) */
export const GqlExportFormat = {
  CSV: 'CSV',
  JSON: 'JSON',
  PDF: 'PDF',
} as const;

export type GqlExportFormat = (typeof GqlExportFormat)[keyof typeof GqlExportFormat];
export type GqlExpressionRule = {
  __typename?: 'GqlExpressionRule';
  /** Expression to evaluate (Zen DSL, JavaScript, etc.) */
  expression: Scalars['String']['output'];
  /** Expression language (zen, javascript, python) */
  language: Scalars['String']['output'];
};

export type GqlExpressionRuleInput = {
  expression: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

/** Extracted value from the source document */
export type GqlExtractedValue = {
  __typename?: 'GqlExtractedValue';
  ediContext?: Maybe<GqlEdiContext>;
  field: Scalars['String']['output'];
  /** Value serialized as JSON string for GraphQL compatibility */
  value: Scalars['String']['output'];
  valueType?: Maybe<Scalars['String']['output']>;
};

/** A single extraction with all context */
export type GqlExtraction = {
  __typename?: 'GqlExtraction';
  annotationColor?: Maybe<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  correctionNote?: Maybe<Scalars['String']['output']>;
  extracted: GqlExtractedValue;
  id: Scalars['String']['output'];
  source: GqlSourceCoordinates;
  target: GqlTargetMapping;
  verificationStatus: GqlVerificationStatus | '%future added value';
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

/** LLM extraction metadata */
export type GqlExtractionMetadata = {
  __typename?: 'GqlExtractionMetadata';
  /** Extraction confidence (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** Confidence as percentage for display */
  confidencePercentage: Scalars['Float']['output'];
  /** When extraction occurred */
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Which LLM/tool performed extraction */
  extractor?: Maybe<Scalars['String']['output']>;
  /** When review occurred */
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human reviewer ID (if reviewed) */
  reviewedBy?: Maybe<Scalars['String']['output']>;
};

/** Summary statistics */
export type GqlExtractionSummary = {
  __typename?: 'GqlExtractionSummary';
  averageConfidence: Scalars['Float']['output'];
  rejectedCount: Scalars['Int']['output'];
  totalExtractions: Scalars['Int']['output'];
  unverifiedCount: Scalars['Int']['output'];
  verifiedCount: Scalars['Int']['output'];
};

/** Extractor metadata */
export type GqlExtractorInfo = {
  __typename?: 'GqlExtractorInfo';
  model: Scalars['String']['output'];
  processingTimeMs?: Maybe<Scalars['Int']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  tokensUsed?: Maybe<Scalars['Int']['output']>;
};

export type GqlFailTaskInput = {
  errorMessage: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export const GqlFailureStrategy = {
  COMPENSATE: 'COMPENSATE',
  FAIL: 'FAIL',
  RETRY: 'RETRY',
  SKIP: 'SKIP',
} as const;

export type GqlFailureStrategy = (typeof GqlFailureStrategy)[keyof typeof GqlFailureStrategy];
/** GraphQL type for form override reference */
export type GqlFormOverrideRef = {
  __typename?: 'GqlFormOverrideRef';
  baseSchemaId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  overrideType: Scalars['String']['output'];
};

/** Formula interaction for GraphQL */
export type GqlFormulaInteraction = {
  __typename?: 'GqlFormulaInteraction';
  description: Scalars['String']['output'];
  fromPrimitive: GqlPrimitiveType | '%future added value';
  interactionType: GqlInteractionType | '%future added value';
  toPrimitive: GqlPrimitiveType | '%future added value';
};

/** Formula interaction input */
export type GqlFormulaInteractionInput = {
  description: Scalars['String']['input'];
  fromPrimitive: GqlPrimitiveType | '%future added value';
  interactionType: GqlInteractionType | '%future added value';
  toPrimitive: GqlPrimitiveType | '%future added value';
};

/** Formula recommendation for GraphQL */
export type GqlFormulaRecommendation = {
  __typename?: 'GqlFormulaRecommendation';
  confidenceScore: Scalars['Float']['output'];
  formula: GqlDataDrivenFormula;
  matchPercentage: Scalars['Float']['output'];
  missingPrimitives: Array<GqlPrimitiveType | '%future added value'>;
};

/** Input for generating an ACH file */
export type GqlGenerateAchFileInput = {
  /** Effective date for ACH settlement (defaults to today) */
  effectiveDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  /** File ID modifier for multiple files per day (A-Z, 0-9) */
  fileIdModifier?: InputMaybe<Scalars['String']['input']>;
  /** Idempotency key for retry-safe operations */
  idempotencyKey: Scalars['String']['input'];
  /** ACH Standard Entry Class Code */
  secCode: GqlAchSecCode | '%future added value';
  /** Source entity ID (e.g., payroll_run_id, vendor_payment_batch_id) */
  sourceId: Scalars['ID']['input'];
  /** Payment source type (determines which subgraph to query) */
  sourceType: GqlAchSourceType | '%future added value';
};

/** Document lifecycle status */
export const GqlGeneratedDocumentStatus = {
  /** Available for access */
  ACTIVE: 'ACTIVE',
  /** Past expiration */
  EXPIRED: 'EXPIRED',
  /** Generation in progress */
  GENERATING: 'GENERATING',
  /** Access revoked */
  REVOKED: 'REVOKED',
} as const;

export type GqlGeneratedDocumentStatus =
  (typeof GqlGeneratedDocumentStatus)[keyof typeof GqlGeneratedDocumentStatus];
/** Type of generated document */
export const GqlGeneratedDocumentType = {
  /** Benefits summary */
  BENEFITS_SUMMARY: 'BENEFITS_SUMMARY',
  /** Custom/ad-hoc report */
  CUSTOM_REPORT: 'CUSTOM_REPORT',
  /** Direct deposit authorization form */
  DIRECT_DEPOSIT_FORM: 'DIRECT_DEPOSIT_FORM',
  /** Employment verification letter */
  EMPLOYMENT_VERIFICATION: 'EMPLOYMENT_VERIFICATION',
  /** IRS Form 1099-MISC */
  FORM_1099_MISC: 'FORM_1099_MISC',
  /** IRS Form 1099-NEC */
  FORM_1099_NEC: 'FORM_1099_NEC',
  /** Payroll register */
  PAYROLL_REGISTER: 'PAYROLL_REGISTER',
  /** Pay stub / earnings statement */
  PAY_STUB: 'PAY_STUB',
  /** State unemployment insurance filing */
  STATE_UI_FILING: 'STATE_UI_FILING',
  /** Tax liability report */
  TAX_LIABILITY_REPORT: 'TAX_LIABILITY_REPORT',
  /** IRS Form W-2 */
  W2: 'W2',
  /** Corrected W-2 */
  W2_CORRECTION: 'W2_CORRECTION',
} as const;

export type GqlGeneratedDocumentType =
  (typeof GqlGeneratedDocumentType)[keyof typeof GqlGeneratedDocumentType];
/** Generated instances from template execution */
export type GqlGeneratedInstances = {
  __typename?: 'GqlGeneratedInstances';
  generatedAt: Scalars['DateTime']['output'];
  generatedBy: Scalars['String']['output'];
  instances: Scalars['JSON']['output'];
  templateId: Scalars['String']['output'];
  templateVersion: Scalars['String']['output'];
};

/** Input for guard entry (key-value pair). */
export type GqlGuardEntryInput = {
  expression: GqlGuardExpressionInput;
  name: Scalars['String']['input'];
};

/** Input for creating a guard expression. */
export type GqlGuardExpressionInput = {
  expression: Scalars['String']['input'];
  guardType: GqlGuardType | '%future added value';
};

/** Guard expression language type. */
export const GqlGuardType = {
  CEDAR: 'CEDAR',
  JAVASCRIPT: 'JAVASCRIPT',
  JSON_LOGIC: 'JSON_LOGIC',
} as const;

export type GqlGuardType = (typeof GqlGuardType)[keyof typeof GqlGuardType];
/** Result of ID hydration */
export type GqlHydrateResult = {
  __typename?: 'GqlHydrateResult';
  /** Original compressed ID */
  compressedId: Scalars['String']['output'];
  /** Parsed counter */
  counter: Scalars['String']['output'];
  /** Hydrated ID */
  hydratedId: Scalars['String']['output'];
  /** Parsed primitive */
  primitive: Scalars['String']['output'];
  /** Parsed subgraph */
  subgraph: Scalars['String']['output'];
  /** Parsed tenant ID */
  tenantId: Scalars['String']['output'];
};

/** Audit event for ID operations */
export type GqlIdAuditEvent = {
  __typename?: 'GqlIdAuditEvent';
  /** Compressed ID (if applicable) */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Correlation ID for tracing */
  correlationId?: Maybe<Scalars['String']['output']>;
  /** Additional details */
  details?: Maybe<Scalars['String']['output']>;
  /** Event ID */
  eventId: Scalars['ID']['output'];
  /** Event type */
  eventType: Scalars['String']['output'];
  /** Hydrated ID (if applicable) */
  hydratedId?: Maybe<Scalars['String']['output']>;
  /** Primitive name (if applicable) */
  primitive?: Maybe<Scalars['String']['output']>;
  /** Severity level */
  severity: Scalars['String']['output'];
  /** Subgraph name */
  subgraph: Scalars['String']['output'];
  /** Tenant ID (if applicable) */
  tenantId?: Maybe<Scalars['String']['output']>;
  /** Timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
};

/** Result of ID generation */
export type GqlIdGenerationResult = {
  __typename?: 'GqlIdGenerationResult';
  /** Compressed ID for storage (e.g., "pay!1R156") */
  compressedId: Scalars['String']['output'];
  /** Core primitive type this maps to */
  corePrimitive: GqlCorePrimitive | '%future added value';
  /** Sequence counter */
  counter: Scalars['String']['output'];
  /** Hydrated ID for API responses (e.g., "tenant-123#payroll_run-156") */
  hydratedId: Scalars['String']['output'];
  /** Whether this primitive is life-critical */
  lifeCritical: Scalars['Boolean']['output'];
  /** Primitive name */
  primitive: Scalars['String']['output'];
  /** Subgraph name */
  subgraph: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
};

/** Connection type for paginated Instance results. */
export type GqlInstanceConnection = {
  __typename?: 'GqlInstanceConnection';
  /** Has more results? */
  hasMore: Scalars['Boolean']['output'];
  /** List of instances */
  items: Array<Instance>;
  /** Next page cursor (optional) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Total count */
  total: Scalars['Int']['output'];
};

/** Instance event for real-time subscriptions. */
export type GqlInstanceEvent = {
  __typename?: 'GqlInstanceEvent';
  /** Event type (status_changed, progress_updated, error_occurred, etc.) */
  eventType: Scalars['String']['output'];
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /** Event payload */
  payload: Scalars['JSON']['output'];
  /** Event timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
};

/** Filter options for querying Instances. */
export type GqlInstanceFilterInput = {
  /** Filter by created after timestamp */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by created before timestamp */
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by engine type */
  engineType?: InputMaybe<GqlExecutionEngine | '%future added value'>;
  /** Filter by has error */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by priority (maximum) */
  maxPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by priority (minimum) */
  minPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by status */
  status?: InputMaybe<GqlInstanceStatus | '%future added value'>;
  /** Filter by tags (any match) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by workflow definition ID */
  workflowDefinitionId?: InputMaybe<Scalars['String']['input']>;
};

/** Event emitted when instance hierarchy changes. */
export type GqlInstanceHierarchyEvent = {
  __typename?: 'GqlInstanceHierarchyEvent';
  /** Event type (child_added, child_completed, child_failed, etc.) */
  eventType: Scalars['String']['output'];
  /** Updated hierarchy (from root) */
  hierarchy: GqlInstanceHierarchyNode;
  /** Instance that changed */
  instanceId: Scalars['String']['output'];
  /** Root instance ID */
  rootInstanceId: Scalars['String']['output'];
  /** Timestamp of event */
  timestamp: Scalars['DateTime']['output'];
};

/** Instance hierarchy node for visualization. */
export type GqlInstanceHierarchyNode = {
  __typename?: 'GqlInstanceHierarchyNode';
  /** Child nodes (for tree structure) */
  children: Array<GqlInstanceHierarchyNode>;
  /** Depth in hierarchy (0 for root) */
  depth: Scalars['Int']['output'];
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /** Human-readable instance name */
  instanceName?: Maybe<Scalars['String']['output']>;
  /** Parent instance ID (None for root) */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Progress percentage */
  progressPercent: Scalars['Float']['output'];
  /** Root instance ID (same as instanceId for root) */
  rootInstanceId: Scalars['String']['output'];
  /** Current status */
  status: GqlInstanceStatus | '%future added value';
  /** Workflow definition name */
  workflowName: Scalars['String']['output'];
};

/**
 * Instance state change event for DRR-309 JourneyView subscriptions.
 * Matches frontend INSTANCE_STATE_CHANGED subscription expectations.
 */
export type GqlInstanceStateChange = {
  __typename?: 'GqlInstanceStateChange';
  /** Execution context metadata */
  context?: Maybe<Scalars['JSON']['output']>;
  /** Current state name */
  currentState: Scalars['String']['output'];
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /** Additional metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Previous state name */
  previousState: Scalars['String']['output'];
  /** Instance status */
  status: Scalars['String']['output'];
  /** Timestamp of change (ISO 8601) */
  timestamp: Scalars['String']['output'];
  /** What triggered the change (event name or system) */
  triggeredBy?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL enum for InstanceStatus (9 statuses total).
 *
 * Tracks the lifecycle state of a workflow instance execution.
 */
export const GqlInstanceStatus = {
  /** Cancelled by user/system */
  CANCELLED: 'CANCELLED',
  /** Saga compensation completed */
  COMPENSATED: 'COMPENSATED',
  /** Saga compensation in progress */
  COMPENSATING: 'COMPENSATING',
  /** Successfully completed */
  COMPLETED: 'COMPLETED',
  /** Failed with error */
  FAILED: 'FAILED',
  /** Temporarily paused (can resume) */
  PAUSED: 'PAUSED',
  /** Waiting to start execution */
  PENDING: 'PENDING',
  /** Currently executing */
  RUNNING: 'RUNNING',
  /** Exceeded timeout limit */
  TIMED_OUT: 'TIMED_OUT',
} as const;

export type GqlInstanceStatus = (typeof GqlInstanceStatus)[keyof typeof GqlInstanceStatus];
/** Instance status change event. */
export type GqlInstanceStatusChange = {
  __typename?: 'GqlInstanceStatusChange';
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /** New status */
  newStatus: GqlInstanceStatus | '%future added value';
  /** Previous status */
  previousStatus: GqlInstanceStatus | '%future added value';
  /** Timestamp of change (ISO 8601) */
  timestamp: Scalars['String']['output'];
};

/**
 * Task status counts for a single workflow instance (Ring 3 deliverable node).
 * Used to drive status overlays in the constellation instance view.
 */
export type GqlInstanceTaskSummary = {
  __typename?: 'GqlInstanceTaskSummary';
  /** Derived aggregate status: "completed" | "in_progress" | "overdue" | "pending" */
  aggregateStatus: Scalars['String']['output'];
  completed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  /** Workflow instance ID (matches ring_3_deliverables.instance_id in constellation YAML) */
  instanceId: Scalars['String']['output'];
  overdue: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
};

/** Intelligence layer that produced this recommendation. */
export const GqlIntelligenceLayer = {
  /** Layer 1: Tenant is missing a recommended config from their Product. */
  CONFIG_GAP: 'CONFIG_GAP',
  /** Layer 2: Advisory rule matched against tenant's T3 QAPI metrics. */
  OUTCOME_DRIVEN: 'OUTCOME_DRIVEN',
  /** Layer 3: Similar tenants adopted this practice with better outcomes. */
  PEER_LEARNING: 'PEER_LEARNING',
} as const;

export type GqlIntelligenceLayer = (typeof GqlIntelligenceLayer)[keyof typeof GqlIntelligenceLayer];
/** Interaction type for GraphQL */
export const GqlInteractionType = {
  ASSIGNED_TO: 'ASSIGNED_TO',
  ENHANCES: 'ENHANCES',
  MONITORS: 'MONITORS',
  REQUIRES: 'REQUIRES',
  TRIGGERS: 'TRIGGERS',
  VALIDATES: 'VALIDATES',
} as const;

export type GqlInteractionType = (typeof GqlInteractionType)[keyof typeof GqlInteractionType];
export const GqlIsolationLevel = {
  READ_COMMITTED: 'READ_COMMITTED',
  READ_UNCOMMITTED: 'READ_UNCOMMITTED',
  REPEATABLE_READ: 'REPEATABLE_READ',
  SERIALIZABLE: 'SERIALIZABLE',
} as const;

export type GqlIsolationLevel = (typeof GqlIsolationLevel)[keyof typeof GqlIsolationLevel];
/** Connection type for job pagination */
export type GqlJobConnection = {
  __typename?: 'GqlJobConnection';
  /** Cursor for next page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Has more pages */
  hasNextPage: Scalars['Boolean']['output'];
  /** Job entries */
  nodes: Array<GqlDocumentJob>;
  /** Total count */
  totalCount: Scalars['Int']['output'];
};

/** Job status for async generation */
export const GqlJobStatus = {
  /** Successfully completed */
  COMPLETED: 'COMPLETED',
  /** Error occurred */
  FAILED: 'FAILED',
  /** In queue */
  PENDING: 'PENDING',
  /** Worker processing */
  PROCESSING: 'PROCESSING',
} as const;

export type GqlJobStatus = (typeof GqlJobStatus)[keyof typeof GqlJobStatus];
/**
 * A directed edge between two nodes in the journey graph.
 *
 * Edges represent temporal sequence ("A happened then B") or co-occurrence
 * ("A and B occurred in the same care event"). Intersection edges appear when
 * two entities share the same constellation instance.
 */
export type GqlJourneyEdge = {
  __typename?: 'GqlJourneyEdge';
  /** Edge type: "temporal" (same actor, time sequence) | "intersection" (shared event) */
  edgeType: Scalars['String']['output'];
  sourceNodeId: Scalars['String']['output'];
  targetNodeId: Scalars['String']['output'];
  /** Edge weight: 1.0 for temporal, elevated for high-frequency intersections */
  weight: Scalars['Float']['output'];
};

/**
 * Valid edge types for journey/instance linking.
 * These represent relationships between workflow instances.
 */
export const GqlJourneyEdgeType = {
  /** Instance affects another (causal relationship) */
  AFFECTS: 'AFFECTS',
  /** Instance blocks another from progressing */
  BLOCKS: 'BLOCKS',
  /** Instance requires another to complete first */
  REQUIRES: 'REQUIRES',
  /** Child instance was spawned by parent instance (primary hierarchy) */
  SPAWNED_BY: 'SPAWNED_BY',
} as const;

export type GqlJourneyEdgeType = (typeof GqlJourneyEdgeType)[keyof typeof GqlJourneyEdgeType];
/**
 * A single node in the entity journey graph — one task/event for one entity.
 *
 * DRR-126 Phase 5: Each node represents a task that an entity (resident or staff)
 * was involved in, either as subject (resident) or performer (staff actor).
 * Temporal position is derived from `created_at` / `due_at`.
 */
export type GqlJourneyNode = {
  __typename?: 'GqlJourneyNode';
  /** Actor display name — never a raw sequential ID (DRR-105) */
  actorName: Scalars['String']['output'];
  /** "subject" or "performer" — how this actor relates to the task */
  actorRole: Scalars['String']['output'];
  /** Constellation instance ID — links to care event context (may be empty) */
  constellationId: Scalars['String']['output'];
  /** Instance/event ID — used to detect intersection nodes (shared events) */
  instanceId: Scalars['String']['output'];
  /** Unique node ID (task_id or "{actor_id}:{task_id}") */
  nodeId: Scalars['String']['output'];
  /** Task status: pending | in_progress | completed | overdue */
  status: Scalars['String']['output'];
  /** Task ID */
  taskId: Scalars['String']['output'];
  /** Task name for display label */
  taskName: Scalars['String']['output'];
  /** Task type (used for icon/shape in renderer) */
  taskType: Scalars['String']['output'];
  /** ISO 8601 timestamp — temporal position (Z-axis in 3D renderer) */
  timestamp: Scalars['String']['output'];
};

/**
 * Full chronological journey timeline for a subject actor.
 *
 * DRR-126 Phase 6: All past + present constellation instances for a resident
 * (or any subject_actor_id). Sorted newest-first. Frontend renders as a
 * vertical timeline with status-colored cards and constellation links.
 */
export type GqlJourneyTimeline = {
  __typename?: 'GqlJourneyTimeline';
  activeEventCount: Scalars['Int']['output'];
  events: Array<GqlJourneyTimelineEvent>;
  totalEvents: Scalars['Int']['output'];
};

/** they were involved in, when it happened, and its outcome. */
export type GqlJourneyTimelineEvent = {
  __typename?: 'GqlJourneyTimelineEvent';
  /** Constellation template ID (e.g., "constellation-care-service-plan") */
  constellationId: Scalars['String']['output'];
  /**
   * Human-readable constellation name derived from constellation_id
   * (e.g., "constellation-care-service-plan" → "Care Service Plan")
   */
  constellationName: Scalars['String']['output'];
  /** Constellation instance ID (or "{constellation_id}:{instance_id}" compound key) */
  eventId: Scalars['String']['output'];
  /** Workflow instance ID within the constellation */
  instanceId: Scalars['String']['output'];
  /** Whether this event is linked to a regulatory mandate (DRR-117: no config ID exposed) */
  isRegulated: Scalars['Boolean']['output'];
  /** ISO 8601 timestamp of most recent task (event last activity) */
  lastActivityAt: Scalars['String']['output'];
  /** Number of staff who performed tasks for this subject in this event (DRR-128: no IDs) */
  performerCount: Scalars['Int']['output'];
  /** ISO 8601 timestamp of earliest task in this event (event start) */
  startedAt: Scalars['String']['output'];
  /** Aggregate status: "in_progress" | "completed" | "overdue" | "pending" */
  status: Scalars['String']['output'];
  /** Number of tasks in this constellation instance for this subject */
  taskCount: Scalars['Int']['output'];
  /** Summary of task types present (e.g., ["clinical", "environmental"]) */
  taskTypes: Array<Scalars['String']['output']>;
};

/**
 * DRR-309: Journey track status for multi-track workflows.
 *
 * Represents a parallel fragment instance running as part of a parent workflow.
 * Track data stored in Valkey `idx:instance:{parent_id}:tracks` hash.
 */
export type GqlJourneyTrack = {
  __typename?: 'GqlJourneyTrack';
  /** Current state within the fragment workflow */
  currentState?: Maybe<Scalars['String']['output']>;
  /** Human-readable track name from fragment YAML display_name */
  displayName: Scalars['String']['output'];
  /** Fragment definition ID (e.g., "frag-0-7-001") */
  fragmentId: Scalars['String']['output'];
  /** Fragment instance ID executing this track */
  instanceId: Scalars['String']['output'];
  /** Whether track is paused at a split-phase stop point */
  isPaused: Scalars['Boolean']['output'];
  /** State where track paused (for split-phase tracks) */
  pausedAtState?: Maybe<Scalars['String']['output']>;
  /** Track execution phase (e.g., "pre_admission", "post_admission") */
  phase?: Maybe<Scalars['String']['output']>;
  /** Progress percentage (0-100) */
  progressPercent: Scalars['Float']['output'];
  /** When track started */
  startedAt?: Maybe<Scalars['String']['output']>;
  /** Track status: "not_started", "running", "paused", "completed", "failed" */
  status: Scalars['String']['output'];
  /** Track identifier (e.g., "clinical", "financial", "housing") */
  trackId: Scalars['String']['output'];
};

export type GqlLengthRule = {
  __typename?: 'GqlLengthRule';
  /** Maximum length (optional) */
  max?: Maybe<Scalars['Int']['output']>;
  /** Minimum length (optional) */
  min?: Maybe<Scalars['Int']['output']>;
};

export type GqlLengthRuleInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Current lifecycle phase for a subject's constellation lifecycle workflow.
 *
 * Derived from `Instance.current_state` for the subject's wf-0-12-001 instance.
 * Phase IDs match wf-0-12-001 state names: onboarding, active, exiting, closed.
 *
 * DRR-140: The lifecycle phase IS the workflow instance state. No separate storage needed.
 */
export type GqlLifecyclePhase = {
  __typename?: 'GqlLifecyclePhase';
  /** Constellation config ID this phase belongs to */
  constellationConfigId: Scalars['String']['output'];
  /** Whether this is a terminal phase (no further advancement) */
  isTerminal: Scalars['Boolean']['output'];
  /** Human-readable label from constellation lifecycle.phases config */
  label: Scalars['String']['output'];
  /** Phase identifier — matches wf-0-12-001 state name (onboarding, active, exiting, closed) */
  phaseId: Scalars['String']['output'];
};

/** An instance linked to another via a journey edge. */
export type GqlLinkedInstance = {
  __typename?: 'GqlLinkedInstance';
  /** Optional edge description */
  description?: Maybe<Scalars['String']['output']>;
  /** Direction: "outgoing" (source→target) or "incoming" (target→source) */
  direction: Scalars['String']['output'];
  /** The edge type connecting them */
  edgeType: Scalars['String']['output'];
  /** The linked instance */
  instance: Instance;
};

/** Input for moving a team to a new parent. */
export type GqlMoveTeamInput = {
  /** Team code to move */
  code: Scalars['String']['input'];
  /** New parent team ID (None = move to root) */
  newParentId?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL type for navigation group reference */
export type GqlNavGroupRef = {
  __typename?: 'GqlNavGroupRef';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  routes: Array<Scalars['String']['output']>;
};

/** New notification event for recipients. */
export type GqlNewNotificationEvent = {
  __typename?: 'GqlNewNotificationEvent';
  /** Notification ID */
  notificationId: Scalars['String']['output'];
  /** Priority */
  priority: Scalars['String']['output'];
  /** Timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
  /** Notification title */
  title: Scalars['String']['output'];
  /** Trigger type */
  triggerType: Scalars['String']['output'];
};

/** NotificationChannel (8 values) */
export const GqlNotificationChannel = {
  DASHBOARD: 'DASHBOARD',
  EMAIL: 'EMAIL',
  OVERHEAD_PAGER: 'OVERHEAD_PAGER',
  PHONE_CALL: 'PHONE_CALL',
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  SLACK: 'SLACK',
  SMS: 'SMS',
  WEBHOOK: 'WEBHOOK',
} as const;

export type GqlNotificationChannel =
  (typeof GqlNotificationChannel)[keyof typeof GqlNotificationChannel];
export type GqlNotificationConnection = {
  __typename?: 'GqlNotificationConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Notification>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/** Notification delivery event for real-time subscriptions. */
export type GqlNotificationDeliveryEvent = {
  __typename?: 'GqlNotificationDeliveryEvent';
  /** Channel that delivered */
  channel?: Maybe<Scalars['String']['output']>;
  /** Notification ID */
  notificationId: Scalars['String']['output'];
  /** New status */
  status: GqlNotificationStatus | '%future added value';
  /** Timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
};

/** NotificationPriority (5 values) */
export const GqlNotificationPriority = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  INFO: 'INFO',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
} as const;

export type GqlNotificationPriority =
  (typeof GqlNotificationPriority)[keyof typeof GqlNotificationPriority];
/** NotificationStatus (6 values) */
export const GqlNotificationStatus = {
  CANCELLED: 'CANCELLED',
  DELIVERED: 'DELIVERED',
  DISMISSED: 'DISMISSED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  READ: 'READ',
  SENT: 'SENT',
} as const;

export type GqlNotificationStatus =
  (typeof GqlNotificationStatus)[keyof typeof GqlNotificationStatus];
/** NotificationTriggerType (17 values) */
export const GqlNotificationTriggerType = {
  APPROVAL_DECISION: 'APPROVAL_DECISION',
  BEST_PRACTICE_ADOPTED: 'BEST_PRACTICE_ADOPTED',
  BEST_PRACTICE_DISMISSED: 'BEST_PRACTICE_DISMISSED',
  BEST_PRACTICE_RECOMMENDATION: 'BEST_PRACTICE_RECOMMENDATION',
  COMPLIANCE_ALERT: 'COMPLIANCE_ALERT',
  DOCUMENT_EXCHANGE: 'DOCUMENT_EXCHANGE',
  METRIC_THRESHOLD: 'METRIC_THRESHOLD',
  RESOURCE_DEGRADED: 'RESOURCE_DEGRADED',
  RESOURCE_UNAVAILABLE: 'RESOURCE_UNAVAILABLE',
  SLA_BREACH: 'SLA_BREACH',
  SLA_ESCALATION: 'SLA_ESCALATION',
  SLA_THRESHOLD: 'SLA_THRESHOLD',
  SYSTEM_ALERT: 'SYSTEM_ALERT',
  TASK_ASSIGNED: 'TASK_ASSIGNED',
  TASK_COMPLETED: 'TASK_COMPLETED',
  TASK_OVERDUE: 'TASK_OVERDUE',
  TRANSACTION_FAILURE: 'TRANSACTION_FAILURE',
  TRANSACTION_ROLLBACK: 'TRANSACTION_ROLLBACK',
  VALIDATION_FAILURE: 'VALIDATION_FAILURE',
  WORKFLOW_COMPLETED: 'WORKFLOW_COMPLETED',
  WORKFLOW_STARTED: 'WORKFLOW_STARTED',
} as const;

export type GqlNotificationTriggerType =
  (typeof GqlNotificationTriggerType)[keyof typeof GqlNotificationTriggerType];
/** GraphQL enum for onboarding status */
export const GqlOnboardingStatus = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  PENDING: 'PENDING',
  SUSPENDED: 'SUSPENDED',
} as const;

export type GqlOnboardingStatus = (typeof GqlOnboardingStatus)[keyof typeof GqlOnboardingStatus];
export type GqlOneOfRule = {
  __typename?: 'GqlOneOfRule';
  /** Allowed values */
  allowedValues: Array<Scalars['String']['output']>;
};

export type GqlOneOfRuleInput = {
  allowedValues: Array<Scalars['String']['input']>;
};

/** Operator information */
export type GqlOperatorInfo = {
  __typename?: 'GqlOperatorInfo';
  /** Example usage */
  example: Scalars['String']['output'];
  /** Operator name (e.g., "Greater than or equal") */
  name: Scalars['String']['output'];
  /** Operator symbol (e.g., ">=") */
  symbol: Scalars['String']['output'];
};

export const GqlOverflowStrategy = {
  BLOCK: 'BLOCK',
  DROP: 'DROP',
  REDIRECT: 'REDIRECT',
} as const;

export type GqlOverflowStrategy = (typeof GqlOverflowStrategy)[keyof typeof GqlOverflowStrategy];
/** GraphQL enum for PermissionMode. */
export const GqlPermissionMode = {
  /** Allow listed permissions (whitelist - default) */
  ALLOW: 'ALLOW',
  /** Deny listed permissions (blacklist - use for restrictions) */
  DENY: 'DENY',
} as const;

export type GqlPermissionMode = (typeof GqlPermissionMode)[keyof typeof GqlPermissionMode];
/** GraphQL enum for PermissionScope. */
export const GqlPermissionScope = {
  /** Department resources (same department) */
  DEPARTMENT: 'DEPARTMENT',
  /** Global (cross-tenant - for system admins only) */
  GLOBAL: 'GLOBAL',
  /** Organization-wide resources (all within tenant) */
  ORGANIZATION: 'ORGANIZATION',
  /** Own resources only (user's own data) */
  OWN: 'OWN',
  /** Team resources (same team as user) */
  TEAM: 'TEAM',
} as const;

export type GqlPermissionScope = (typeof GqlPermissionScope)[keyof typeof GqlPermissionScope];
/** GraphQL enum for PolicyImplementation. */
export const GqlPolicyImplementation = {
  /** AWS Cedar policy language */
  CEDAR: 'CEDAR',
  /** Google Common Expression Language */
  CEL: 'CEL',
  /** JsonLogic policy engine */
  JSON_LOGIC: 'JSON_LOGIC',
  /** FERP Zen Engine (default) */
  ZEN: 'ZEN',
} as const;

export type GqlPolicyImplementation =
  (typeof GqlPolicyImplementation)[keyof typeof GqlPolicyImplementation];
/** GraphQL enum for PolicyScope. */
export const GqlPolicyScope = {
  /** Approval-level policy */
  APPROVAL: 'APPROVAL',
  /** Global policy */
  GLOBAL: 'GLOBAL',
  /** Task-level policy */
  TASK: 'TASK',
  /** Workflow-level policy */
  WORKFLOW: 'WORKFLOW',
} as const;

export type GqlPolicyScope = (typeof GqlPolicyScope)[keyof typeof GqlPolicyScope];
/** GraphQL enum for PolicyType. */
export const GqlPolicyType = {
  /** Approval routing policies */
  APPROVAL: 'APPROVAL',
  /** Compliance policies */
  COMPLIANCE: 'COMPLIANCE',
  /** Notification rules */
  NOTIFICATION: 'NOTIFICATION',
  /** Security policies */
  SECURITY: 'SECURITY',
  /** Validation rules */
  VALIDATION: 'VALIDATION',
} as const;

export type GqlPolicyType = (typeof GqlPolicyType)[keyof typeof GqlPolicyType];
/**
 * Presence status for actors (DRR-061).
 *
 * Ephemeral status tracked via Valkey with TTL.
 */
export const GqlPresenceStatus = {
  AWAY: 'AWAY',
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
} as const;

export type GqlPresenceStatus = (typeof GqlPresenceStatus)[keyof typeof GqlPresenceStatus];
/** Primitive definition in a subgraph */
export type GqlPrimitiveDefinition = {
  __typename?: 'GqlPrimitiveDefinition';
  /** Core primitive type this maps to */
  corePrimitive: GqlCorePrimitive | '%future added value';
  /** Current counter value */
  currentCounter?: Maybe<Scalars['String']['output']>;
  /** Description */
  description: Scalars['String']['output'];
  /** Whether this primitive is life-critical */
  lifeCritical: Scalars['Boolean']['output'];
  /** Max counter before overflow */
  maxCounter: Scalars['String']['output'];
  /** Primitive name (e.g., "payroll_run") */
  name: Scalars['String']['output'];
  /** Symbol for compression (e.g., 'R') */
  symbol: Scalars['String']['output'];
};

/** Primitive type for GraphQL (31 primitives aligned with FERP architecture) */
export const GqlPrimitiveType = {
  ACTOR: 'ACTOR',
  ACTOR_DESCRIPTOR: 'ACTOR_DESCRIPTOR',
  ANALYTICS: 'ANALYTICS',
  APPROVAL: 'APPROVAL',
  AUDIT: 'AUDIT',
  CHECKPOINT: 'CHECKPOINT',
  CONSTRAINT: 'CONSTRAINT',
  CONTEXT: 'CONTEXT',
  CONTRACT: 'CONTRACT',
  DEPENDENCY: 'DEPENDENCY',
  DOCUMENT: 'DOCUMENT',
  EVENT: 'EVENT',
  INSTANCE: 'INSTANCE',
  INTEGRATION: 'INTEGRATION',
  METRIC: 'METRIC',
  NOTIFICATION: 'NOTIFICATION',
  POLICY: 'POLICY',
  QUEUE: 'QUEUE',
  RESOURCE: 'RESOURCE',
  ROLE: 'ROLE',
  SCHEDULE: 'SCHEDULE',
  SLA: 'SLA',
  TASK: 'TASK',
  TEAM: 'TEAM',
  TEMPLATE: 'TEMPLATE',
  TRACE: 'TRACE',
  TRANSACTION: 'TRANSACTION',
  VALIDATION: 'VALIDATION',
  WORKFLOW_DEFINITION: 'WORKFLOW_DEFINITION',
  WORKFLOW_EDGE: 'WORKFLOW_EDGE',
  WORKFLOW_NODE: 'WORKFLOW_NODE',
} as const;

export type GqlPrimitiveType = (typeof GqlPrimitiveType)[keyof typeof GqlPrimitiveType];
/** GraphQL type for a product definition (DRR-095/096). */
export type GqlProductDefinition = {
  __typename?: 'GqlProductDefinition';
  activatesConstellations: Array<Scalars['String']['output']>;
  activatesOverrides: Array<Scalars['String']['output']>;
  activatesSettings: Array<Scalars['String']['output']>;
  /**
   * DRR-172 Phase 6: Task groups bundled with this product.
   * When tenant activates product, these task groups are available.
   */
  activatesTaskGroups: Array<Scalars['String']['output']>;
  activatesWorkflows: Array<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** DRR-174: Enrollment action — creates Actor + Instance + Constellation */
  enrollment?: Maybe<GqlProductEnrollment>;
  industry: Scalars['String']['output'];
  jurisdiction: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onboardingLenses: Array<Scalars['String']['output']>;
  /** Primary RuleSet — program-defining regulation for form override selection (DRR-162) */
  primaryRuleset?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  provisioningStatus: Scalars['String']['output'];
  /**
   * Advisory rulesets recommended by this product (DRR-156).
   * Unlike required_rulesets, these are surfaced as suggestions, not enforced.
   */
  recommendedRulesets: Array<Scalars['String']['output']>;
  requiredRulesets: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subgraphs: Array<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

/** DRR-174: Product enrollment configuration. */
export type GqlProductEnrollment = {
  __typename?: 'GqlProductEnrollment';
  actorType: Scalars['String']['output'];
  constellationRef: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  label: Scalars['String']['output'];
  requiredScope: Scalars['String']['output'];
  workflowRef: Scalars['String']['output'];
};

export type GqlQueueConnection = {
  __typename?: 'GqlQueueConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Queue>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type GqlQueueStatistics = {
  __typename?: 'GqlQueueStatistics';
  avgWaitTimeSeconds: Scalars['Int']['output'];
  currentSize: Scalars['Int']['output'];
  isOverThreshold: Scalars['Boolean']['output'];
  processingRatePerHour: Scalars['Int']['output'];
  queueId: Scalars['String']['output'];
  slaBreachCount: Scalars['Int']['output'];
  utilizationPercent: Scalars['Float']['output'];
};

/** Statistics about review queues */
export type GqlQueueStats = {
  __typename?: 'GqlQueueStats';
  /** Rules auto-approved */
  autoApproved: Scalars['Int']['output'];
  /** Rules in confidence review */
  confidenceReview: Scalars['Int']['output'];
  /** Rules in conflict review */
  conflictReview: Scalars['Int']['output'];
  /** Percentage requiring human review */
  humanReviewPercentage: Scalars['Float']['output'];
  /** Rules in safety review */
  safetyReview: Scalars['Int']['output'];
  /** Total rules in queues */
  total: Scalars['Int']['output'];
};

export const GqlQueueType = {
  FAIR: 'FAIR',
  FIFO: 'FIFO',
  LIFO: 'LIFO',
  PRIORITY: 'PRIORITY',
} as const;

export type GqlQueueType = (typeof GqlQueueType)[keyof typeof GqlQueueType];
/** GraphQL type for QuotaLimits. */
export type GqlQuotaLimits = {
  __typename?: 'GqlQuotaLimits';
  /** Tenant-specific custom quota limits */
  custom: Scalars['JSON']['output'];
  /** Maximum API calls per day */
  maxApiCallsPerDay?: Maybe<Scalars['Int']['output']>;
  /** Maximum team members */
  maxMembers?: Maybe<Scalars['Int']['output']>;
  /** Maximum storage in GB */
  maxStorageGb?: Maybe<Scalars['Float']['output']>;
  /** Maximum active workflows */
  maxWorkflows?: Maybe<Scalars['Int']['output']>;
};

/** GraphQL input type for QuotaLimits. */
export type GqlQuotaLimitsInput = {
  /** Tenant-specific custom quota limits */
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Maximum API calls per day */
  maxApiCallsPerDay?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum team members */
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum storage in GB */
  maxStorageGb?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum active workflows */
  maxWorkflows?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlRangeRule = {
  __typename?: 'GqlRangeRule';
  /** Include boundary values? */
  inclusive: Scalars['Boolean']['output'];
  /** Maximum value (optional) */
  max?: Maybe<Scalars['Float']['output']>;
  /** Minimum value (optional) */
  min?: Maybe<Scalars['Float']['output']>;
};

export type GqlRangeRuleInput = {
  inclusive: Scalars['Boolean']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** Readiness score for a tenant's regulatory compliance */
export type GqlReadinessScore = {
  __typename?: 'GqlReadinessScore';
  /** Critical rules fully evidenced */
  criticalRulesEvidenced: Scalars['Int']['output'];
  /** Breakdown by safety level */
  criticalRulesTotal: Scalars['Int']['output'];
  /** Number of rules with all required evidence linked */
  fullyEvidencedRules: Scalars['Int']['output'];
  /** Evidence gaps (rules with missing evidence) */
  gaps: Array<GqlEvidenceGap>;
  /** High-priority rules fully evidenced */
  highRulesEvidenced: Scalars['Int']['output'];
  /** High-priority rules total */
  highRulesTotal: Scalars['Int']['output'];
  /** Number of rules with at least some evidence linked */
  partiallyEvidencedRules: Scalars['Int']['output'];
  /** Readiness percentage (0-100) */
  scorePct: Scalars['Float']['output'];
  /** Total evidence items that have been linked to documents */
  totalEvidenceFound: Scalars['Int']['output'];
  /** Total required evidence items across all rules */
  totalEvidenceRequired: Scalars['Int']['output'];
  /** Total approved rules for this tenant */
  totalRules: Scalars['Int']['output'];
};

/** Source channel that discovered this recommendation. */
export const GqlRecommendationSource = {
  /** Architect-curated advisory RuleSet (Channel 1). */
  CURATED_LIBRARY: 'CURATED_LIBRARY',
  /** LLM-extracted from association publication, architect-approved (Channel 2). */
  LLM_EXTRACTED: 'LLM_EXTRACTED',
  /** Derived from anonymized peer adoption + outcome data (Channel 4). */
  PEER_OBSERVATION: 'PEER_OBSERVATION',
} as const;

export type GqlRecommendationSource =
  (typeof GqlRecommendationSource)[keyof typeof GqlRecommendationSource];
/** Input for recording a decision on an Approval. */
export type GqlRecordDecisionInput = {
  actorId: Scalars['String']['input'];
  actorName: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  decision: GqlApprovalDecision | '%future added value';
  reason?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

/** Input for recording an error on an Instance. */
export type GqlRecordErrorInput = {
  /** Machine-readable error code (optional) */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Detailed error information (optional) */
  errorDetails?: InputMaybe<Scalars['JSON']['input']>;
  /** Human-readable error message */
  errorMessage: Scalars['String']['input'];
  /** ID of task that caused failure (optional) */
  failedTaskId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlRecordViolationInput = {
  attemptedValue: Scalars['Float']['input'];
  context?: InputMaybe<Scalars['JSON']['input']>;
  violatedBy: Scalars['String']['input'];
};

export type GqlRegexRule = {
  __typename?: 'GqlRegexRule';
  /** Optional regex flags (e.g., "i" for case-insensitive) */
  flags?: Maybe<Scalars['String']['output']>;
  /** Regex pattern */
  pattern: Scalars['String']['output'];
};

export type GqlRegexRuleInput = {
  flags?: InputMaybe<Scalars['String']['input']>;
  pattern: Scalars['String']['input'];
};

/** Result of subgraph registration */
export type GqlRegisterSubgraphResult = {
  __typename?: 'GqlRegisterSubgraphResult';
  /** Error message (if failed) */
  error?: Maybe<Scalars['String']['output']>;
  /** Registered subgraph definition (if successful) */
  subgraph?: Maybe<GqlSubgraphDefinition>;
  /** Whether registration succeeded */
  success: Scalars['Boolean']['output'];
  /** Validation warnings (if any) */
  warnings: Array<Scalars['String']['output']>;
};

/** Input for creating a regulation. */
export type GqlRegulationInput = {
  framework: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requirement: Scalars['String']['input'];
  verificationMethod: Scalars['String']['input'];
};

/** A single regulatory node suggestion from LLM enrichment */
export type GqlRegulatoryNodeSuggestion = {
  __typename?: 'GqlRegulatoryNodeSuggestion';
  /** Whether applicability is conditional */
  conditional: Scalars['Boolean']['output'];
  /** Confidence score 0-1 */
  confidence: Scalars['Float']['output'];
  /** Edge type: REGULATED_BY or GOVERNED_BY */
  edgeType: Scalars['String']['output'];
  /** Jurisdiction level (federal, state, payer, standard) */
  jurisdiction: Scalars['String']['output'];
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Regulatory node ID (must match regulatory-nodes/*.yaml) */
  nodeId: Scalars['String']['output'];
  /** Additional notes from LLM */
  notes?: Maybe<Scalars['String']['output']>;
  /** Primary regulatory body flag */
  priority?: Maybe<Scalars['String']['output']>;
  /** Human-readable reason for suggesting this node */
  reason: Scalars['String']['output'];
};

/** Complete regulatory rule */
export type GqlRegulatoryRule = {
  __typename?: 'GqlRegulatoryRule';
  /** Changelog for this version */
  changelog?: Maybe<Scalars['String']['output']>;
  /** Classification */
  classification: GqlClassification;
  /** IDs of conflicting rules */
  conflictingRuleIds: Array<Scalars['String']['output']>;
  /** When this rule was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who imported this rule */
  createdBy: Scalars['String']['output'];
  /** Extraction metadata */
  extraction: GqlExtractionMetadata;
  /** Unique rule identifier */
  id: Scalars['String']['output'];
  /** Review queue assignment */
  queue: GqlReviewQueue | '%future added value';
  /** Rejection reason (if rejected) */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Whether this rule requires human review */
  requiresHumanReview: Scalars['Boolean']['output'];
  /** Review comment */
  reviewComment?: Maybe<Scalars['String']['output']>;
  /** When reviewed */
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reviewer ID (if reviewed) */
  reviewerId?: Maybe<Scalars['String']['output']>;
  /** Source information */
  source: GqlRuleSource;
  /** Current status */
  status: GqlRuleStatus | '%future added value';
  /** Structured rule components */
  structured: GqlStructuredRule;
  /** ID of rule this supersedes (if any) */
  supersedes?: Maybe<Scalars['String']['output']>;
  /** Original rule text */
  text: Scalars['String']['output'];
  /** Version number (monotonically increasing) */
  version: Scalars['Int']['output'];
};

/** Input for removing a stakeholder from a team. */
export type GqlRemoveStakeholderInput = {
  /** Team code */
  code: Scalars['String']['input'];
  /** Stakeholder ID to remove */
  stakeholderId: Scalars['String']['input'];
};

export const GqlReportFormat = {
  CSV: 'CSV',
  HTML: 'HTML',
  JSON: 'JSON',
  PDF: 'PDF',
} as const;

export type GqlReportFormat = (typeof GqlReportFormat)[keyof typeof GqlReportFormat];
/**
 * Input for rescheduling a task (drag-and-drop in calendar).
 *
 * Updates scheduled_start and scheduled_end times.
 * Life-critical tasks require override confirmation.
 */
export type GqlRescheduleTaskInput = {
  /** Required for life-critical tasks — confirms user acknowledges safety implications */
  lifeCriticalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** New scheduled end time */
  scheduledEnd: Scalars['DateTime']['input'];
  /** New scheduled start time */
  scheduledStart: Scalars['DateTime']['input'];
  /** Task ID to reschedule */
  taskId: Scalars['String']['input'];
};

/** Paginated connection for Resource queries */
export type GqlResourceConnection = {
  __typename?: 'GqlResourceConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Resource>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export const GqlResourceLifecycleStage = {
  ACQUISITION: 'ACQUISITION',
  ACTIVE: 'ACTIVE',
  DEPLOYMENT: 'DEPLOYMENT',
  DEPRECIATION: 'DEPRECIATION',
  DISPOSAL: 'DISPOSAL',
  DISPOSED: 'DISPOSED',
  MAINTENANCE: 'MAINTENANCE',
  PROCUREMENT: 'PROCUREMENT',
  RETIRED: 'RETIRED',
} as const;

export type GqlResourceLifecycleStage =
  (typeof GqlResourceLifecycleStage)[keyof typeof GqlResourceLifecycleStage];
export const GqlResourceStatus = {
  AVAILABLE: 'AVAILABLE',
  DECOMMISSIONED: 'DECOMMISSIONED',
  DEPLETED: 'DEPLETED',
  IN_USE: 'IN_USE',
  MAINTENANCE: 'MAINTENANCE',
  QUARANTINED: 'QUARANTINED',
  RESERVED: 'RESERVED',
  RETIRED: 'RETIRED',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export type GqlResourceStatus = (typeof GqlResourceStatus)[keyof typeof GqlResourceStatus];
export const GqlResourceType = {
  CONSUMABLE: 'CONSUMABLE',
  DIGITAL: 'DIGITAL',
  FINANCIAL: 'FINANCIAL',
  HUMAN: 'HUMAN',
  PHYSICAL: 'PHYSICAL',
  SHARED: 'SHARED',
} as const;

export type GqlResourceType = (typeof GqlResourceType)[keyof typeof GqlResourceType];
/** Utilization report for a Resource */
export type GqlResourceUtilizationReport = {
  __typename?: 'GqlResourceUtilizationReport';
  idlePercent: Scalars['Float']['output'];
  peakHour: Scalars['Int']['output'];
  reportGeneratedAt: Scalars['DateTime']['output'];
  resourceId: Scalars['String']['output'];
  totalUsageCount: Scalars['String']['output'];
  utilizationPercent: Scalars['Float']['output'];
};

/** Input for creating a retry policy. */
export type GqlRetryPolicyInput = {
  backoffMultiplier: Scalars['Float']['input'];
  backoffSeconds: Scalars['Int']['input'];
  maxAttempts: Scalars['Int']['input'];
};

/** Review queue assignment */
export const GqlReviewQueue = {
  /** Auto-approved (>90% confidence, not life-critical) */
  AUTO: 'AUTO',
  /** Needs human review due to low confidence */
  CONFIDENCE: 'CONFIDENCE',
  /** Conflicts with existing rule(s) */
  CONFLICT: 'CONFLICT',
  /** Life-critical rule (always human review) */
  SAFETY: 'SAFETY',
} as const;

export type GqlReviewQueue = (typeof GqlReviewQueue)[keyof typeof GqlReviewQueue];
/** Map-level review status */
export const GqlReviewStatus = {
  IN_REVIEW: 'IN_REVIEW',
  PENDING_REVIEW: 'PENDING_REVIEW',
  REJECTED: 'REJECTED',
  SUPERSEDED: 'SUPERSEDED',
  VERIFIED: 'VERIFIED',
} as const;

export type GqlReviewStatus = (typeof GqlReviewStatus)[keyof typeof GqlReviewStatus];
/** GraphQL enum for RoleCategory. */
export const GqlRoleCategory = {
  /** Administrative staff (billing, scheduling, HR) */
  ADMINISTRATIVE: 'ADMINISTRATIVE',
  /** Clinical staff (doctors, nurses, medical professionals) */
  CLINICAL: 'CLINICAL',
  /** Executive leadership (C-suite, VPs, directors) */
  EXECUTIVE: 'EXECUTIVE',
  /** External parties (auditors, consultants, vendors) */
  EXTERNAL: 'EXTERNAL',
  /** System-level roles (automation, integrations) */
  SYSTEM: 'SYSTEM',
  /** Technical staff (IT, data analysts, system admins) */
  TECHNICAL: 'TECHNICAL',
} as const;

export type GqlRoleCategory = (typeof GqlRoleCategory)[keyof typeof GqlRoleCategory];
export const GqlRollbackStrategy = {
  COMPENSATE: 'COMPENSATE',
  FAIL: 'FAIL',
  IGNORE: 'IGNORE',
} as const;

export type GqlRollbackStrategy = (typeof GqlRollbackStrategy)[keyof typeof GqlRollbackStrategy];
/** GraphQL type for route constraints */
export type GqlRouteConstraints = {
  __typename?: 'GqlRouteConstraints';
  authTier?: Maybe<Scalars['Int']['output']>;
  dataTier?: Maybe<GqlDataTier | '%future added value'>;
  requiredScopes: Array<Scalars['String']['output']>;
  safetyLevel?: Maybe<ViewContextSafetyLevel | '%future added value'>;
};

/** Routing decision for a rule */
export type GqlRouteDecision = {
  __typename?: 'GqlRouteDecision';
  /** Confidence score at decision time */
  confidence: Scalars['Float']['output'];
  /** IDs of conflicting rules (if any) */
  conflictingRuleIds: Array<Scalars['String']['output']>;
  /** Were conflicts detected? */
  conflictsDetected: Scalars['Boolean']['output'];
  /** Which queue the rule is routed to */
  queue: GqlReviewQueue | '%future added value';
  /** Explanation of why this queue was chosen */
  reason: Scalars['String']['output'];
  /** Was safety override triggered? */
  safetyOverride: Scalars['Boolean']['output'];
};

/** Result of importing a single rule */
export type GqlRuleImportResult = {
  __typename?: 'GqlRuleImportResult';
  /** Validation errors (if any) */
  errors: Array<GqlValidationError>;
  /** Routing decision (if valid rule) */
  routeDecision?: Maybe<GqlRouteDecision>;
  /** Rule ID (if successfully parsed) */
  ruleId?: Maybe<Scalars['String']['output']>;
  /** Whether import succeeded */
  success: Scalars['Boolean']['output'];
  /** Warning messages */
  warnings: Array<Scalars['String']['output']>;
};

/** Full RuleSet import input — core fields for a new RuleSet or new version. */
export type GqlRuleSetInput = {
  /** Workflow IDs affected by this RuleSet */
  affectsWorkflows: Array<Scalars['String']['input']>;
  /** Industries this ruleset applies to */
  appliesToIndustries: Array<Scalars['String']['input']>;
  /** Category / subgraph owner (e.g., "compliance", "fhir") */
  category: Scalars['String']['input'];
  /** Compliance framework tags (e.g., ["MN_MDH_ALF"]) */
  complianceFrameworks: Array<Scalars['String']['input']>;
  /** Description of this legislation bundle */
  description: Scalars['String']['input'];
  /** Human-readable display name shown in the UI */
  displayName: Scalars['String']['input'];
  /** ISO 8601 date when this RuleSet becomes effective (DRR-096) */
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  /** Whether this contains life-critical rules (determines QAPI + L4 guards) */
  isLifeCritical: Scalars['Boolean']['input'];
  /** Jurisdiction code (e.g., "MN", "WI", "federal") */
  jurisdiction: Scalars['String']['input'];
  /** Machine-readable name (used internally and in backend policies) */
  name: Scalars['String']['input'];
  /** Member rule IDs in this bundle */
  ruleIds: Array<Scalars['String']['input']>;
  /** Config ID (e.g., "rs-4-1-005"). Must follow DRR-089 scope-encoded format. */
  rulesetId: Scalars['String']['input'];
  /** Safety level: "standard", "high", or "critical" */
  safetyLevel: Scalars['String']['input'];
  /** Setting context (e.g., "general", "assisted_living") */
  setting: Scalars['String']['input'];
  /** Source legislation citation */
  sourceLegislation?: InputMaybe<GqlSourceLegislationInput>;
  /** Semantic version (e.g., "1.0", "2.0") */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Metadata-only update input — patches display_name / description / safety_level. */
export type GqlRuleSetMetadataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isLifeCritical?: InputMaybe<Scalars['Boolean']['input']>;
  safetyLevel?: InputMaybe<Scalars['String']['input']>;
  visibilityScope?: InputMaybe<Scalars['String']['input']>;
};

/** Rule source information */
export type GqlRuleSource = {
  __typename?: 'GqlRuleSource';
  /** Source document */
  document: GqlSourceDocument;
  /** When the rule becomes effective */
  effectiveDate: Scalars['String']['output'];
  /** Location within document */
  location: GqlSourceLocation;
  /** When the rule expires (if applicable) */
  sunsetDate?: Maybe<Scalars['String']['output']>;
};

/** Rule lifecycle status */
export const GqlRuleStatus = {
  /** Approved and active */
  APPROVED: 'APPROVED',
  /** Expired (past sunset date) */
  EXPIRED: 'EXPIRED',
  /** Human review in progress */
  IN_REVIEW: 'IN_REVIEW',
  /** Awaiting review */
  PENDING_REVIEW: 'PENDING_REVIEW',
  /** Rejected (with reason) */
  REJECTED: 'REJECTED',
  /** Superseded by newer version */
  SUPERSEDED: 'SUPERSEDED',
} as const;

export type GqlRuleStatus = (typeof GqlRuleStatus)[keyof typeof GqlRuleStatus];
/** Summary of a parsed rule */
export type GqlRuleSummary = {
  __typename?: 'GqlRuleSummary';
  /** Action names in THEN clause */
  actions: Array<Scalars['String']['output']>;
  /** Condition count */
  conditionCount: Scalars['Int']['output'];
  /** Deadline in seconds (if specified) */
  deadlineSeconds?: Maybe<Scalars['Int']['output']>;
  /** Optional rule name */
  name?: Maybe<Scalars['String']['output']>;
  /** Priority (if specified) */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Whether rule is terminal */
  terminal: Scalars['Boolean']['output'];
};

/** Safety level for rules - determines review requirements */
export const GqlSafetyLevel = {
  /** Life-threatening if violated (ALWAYS requires human review) */
  CRITICAL: 'CRITICAL',
  /** Significant compliance impact (review for confidence <95%) */
  HIGH: 'HIGH',
  /** Informational or advisory (may auto-approve at lower threshold) */
  LOW: 'LOW',
  /** Standard compliance rule (review for confidence <90%) */
  STANDARD: 'STANDARD',
} as const;

export type GqlSafetyLevel = (typeof GqlSafetyLevel)[keyof typeof GqlSafetyLevel];
/** Input for saga compensation checkpoint (Formula #4) */
export type GqlSagaCompensationCheckpointInput = {
  checkpointName: Scalars['String']['input'];
  compensationTaskId: Scalars['String']['input'];
  sequenceNumber: Scalars['Int']['input'];
  stateSnapshot: Scalars['JSON']['input'];
  taskId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

export type GqlScheduleConnection = {
  __typename?: 'GqlScheduleConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Schedule>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type GqlScheduleExecutionSummary = {
  __typename?: 'GqlScheduleExecutionSummary';
  averageExecutionTimeMs: Scalars['Int']['output'];
  failedExecutions: Scalars['Int']['output'];
  missedExecutions: Scalars['Int']['output'];
  scheduleId: Scalars['String']['output'];
  successfulExecutions: Scalars['Int']['output'];
  totalExecutions: Scalars['Int']['output'];
};

export const GqlSchedulePriority = {
  HIGH: 'HIGH',
  LIFE_CRITICAL: 'LIFE_CRITICAL',
  LOW: 'LOW',
  NORMAL: 'NORMAL',
} as const;

export type GqlSchedulePriority = (typeof GqlSchedulePriority)[keyof typeof GqlSchedulePriority];
export const GqlScheduleStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  PAUSED: 'PAUSED',
} as const;

export type GqlScheduleStatus = (typeof GqlScheduleStatus)[keyof typeof GqlScheduleStatus];
export const GqlScheduleType = {
  ADAPTIVE: 'ADAPTIVE',
  CRON: 'CRON',
  EVENT_DRIVEN: 'EVENT_DRIVEN',
  INTERVAL: 'INTERVAL',
  ONE_TIME: 'ONE_TIME',
} as const;

export type GqlScheduleType = (typeof GqlScheduleType)[keyof typeof GqlScheduleType];
/** GraphQL type for scope dimension */
export type GqlScopeDimension = {
  __typename?: 'GqlScopeDimension';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  renderer: Scalars['String']['output'];
};

/** Seed result */
export type GqlSeedFormulasResult = {
  __typename?: 'GqlSeedFormulasResult';
  seededCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export const GqlSignatureType = {
  BIOMETRIC: 'BIOMETRIC',
  BLOCKCHAIN_NOTARIZED: 'BLOCKCHAIN_NOTARIZED',
  DIGITAL: 'DIGITAL',
  WET: 'WET',
} as const;

export type GqlSignatureType = (typeof GqlSignatureType)[keyof typeof GqlSignatureType];
/** GraphQL output for a simulation session. */
export type GqlSimulationSession = {
  __typename?: 'GqlSimulationSession';
  currentState: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  stepCount: Scalars['Int']['output'];
  workflowId: Scalars['String']['output'];
};

export const GqlSnapshotFormat = {
  BINARY: 'BINARY',
  COMPRESSED: 'COMPRESSED',
  JSON: 'JSON',
} as const;

export type GqlSnapshotFormat = (typeof GqlSnapshotFormat)[keyof typeof GqlSnapshotFormat];
/** Complete source coordinate map */
export type GqlSourceCoordinateMap = {
  __typename?: 'GqlSourceCoordinateMap';
  extractions: Array<GqlExtraction>;
  extractor: GqlExtractorInfo;
  ingestedAt: Scalars['String']['output'];
  mappingId: Scalars['String']['output'];
  reviewStatus: GqlReviewStatus | '%future added value';
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  sourceDocument: SourceMapDocument;
  summary: GqlExtractionSummary;
  supersedes?: Maybe<Scalars['String']['output']>;
};

/** Source coordinates in the document */
export type GqlSourceCoordinates = {
  __typename?: 'GqlSourceCoordinates';
  bboxH?: Maybe<Scalars['Float']['output']>;
  bboxW?: Maybe<Scalars['Float']['output']>;
  bboxX?: Maybe<Scalars['Float']['output']>;
  bboxY?: Maybe<Scalars['Float']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  quotedText: Scalars['String']['output'];
  sectionHeading?: Maybe<Scalars['String']['output']>;
  textSpanEnd?: Maybe<Scalars['Int']['output']>;
  textSpanStart?: Maybe<Scalars['Int']['output']>;
};

/** Source document reference */
export type GqlSourceDocument = {
  __typename?: 'GqlSourceDocument';
  /** Document identifier */
  id: Scalars['String']['output'];
  /** Document title */
  title: Scalars['String']['output'];
  /** URL to original document */
  url?: Maybe<Scalars['String']['output']>;
  /** Document version */
  version?: Maybe<Scalars['String']['output']>;
};

/** Source legislation input for import/supersede. */
export type GqlSourceLegislationInput = {
  authority: Scalars['String']['input'];
  lastAmended?: InputMaybe<Scalars['String']['input']>;
  regnodeRef?: InputMaybe<Scalars['String']['input']>;
  sections: Array<Scalars['String']['input']>;
  shortCite: Scalars['String']['input'];
  statute: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Source location within a document */
export type GqlSourceLocation = {
  __typename?: 'GqlSourceLocation';
  /** Page number */
  page?: Maybe<Scalars['Int']['output']>;
  /** Paragraph (e.g., "A", "3") */
  paragraph?: Maybe<Scalars['String']['output']>;
  /** Section number (e.g., "9505.0185") */
  section: Scalars['String']['output'];
  /** Subdivision (e.g., "Subp. 3") */
  subdivision?: Maybe<Scalars['String']['output']>;
};

/** Statistics across all source maps for a tenant */
export type GqlSourceMapStats = {
  __typename?: 'GqlSourceMapStats';
  averageConfidence: Scalars['Float']['output'];
  pendingReview: Scalars['Int']['output'];
  totalExtractions: Scalars['Int']['output'];
  totalMaps: Scalars['Int']['output'];
  verified: Scalars['Int']['output'];
  verifiedExtractions: Scalars['Int']['output'];
};

export type GqlStandardRule = {
  __typename?: 'GqlStandardRule';
  /** Optional profile (e.g., "US Core" for FHIR) */
  profile?: Maybe<Scalars['String']['output']>;
  /** Standard name (FHIR, X12, ISO20022, etc.) */
  standard: Scalars['String']['output'];
  /** Standard version */
  version: Scalars['String']['output'];
};

export type GqlStandardRuleInput = {
  profile?: InputMaybe<Scalars['String']['input']>;
  standard: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Standards Pack Kind (GraphQL enum) */
export const GqlStandardsPackKind = {
  INTEGRATION: 'INTEGRATION',
  POLICY: 'POLICY',
  SCHEMA: 'SCHEMA',
  TERMINOLOGY: 'TERMINOLOGY',
} as const;

export type GqlStandardsPackKind = (typeof GqlStandardsPackKind)[keyof typeof GqlStandardsPackKind];
/**
 * Input for starting a sub-workflow from a parent workflow.
 *
 * Creates a child instance linked to the parent via parent_id.
 */
export type GqlStartSubWorkflowInput = {
  /** Correlation ID for distributed tracing (inherited from parent if not provided) */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /** Execution mode (Inline, Async, Parallel) */
  executionMode: GqlSubWorkflowExecutionMode | '%future added value';
  /** Failure handling mode */
  failureMode: GqlSubWorkflowFailureMode | '%future added value';
  /** Input payload for the sub-workflow */
  inputData: Scalars['JSON']['input'];
  /** Human-readable name for the sub-workflow instance */
  instanceName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum retry attempts (only used with RetryChild failure mode) */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Parallel group ID (only used with Parallel execution mode) */
  parallelGroup?: InputMaybe<Scalars['String']['input']>;
  /** Parent instance ID (the calling workflow) */
  parentInstanceId: Scalars['String']['input'];
  /** Timeout in milliseconds (optional) */
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  /** Workflow definition name to instantiate */
  workflowName: Scalars['String']['input'];
  /** Workflow definition version (optional, defaults to "latest") */
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Result of starting a sub-workflow. */
export type GqlStartSubWorkflowResult = {
  __typename?: 'GqlStartSubWorkflowResult';
  /** The child instance ID (if successful) */
  childInstanceId?: Maybe<Scalars['String']['output']>;
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The execution mode used */
  executionMode: GqlSubWorkflowExecutionMode | '%future added value';
  /** For Inline mode: the completion result (if available) */
  inlineResult?: Maybe<Scalars['JSON']['output']>;
  /** Whether the sub-workflow was started successfully */
  success: Scalars['Boolean']['output'];
};

/** Input for creating a state transition. */
export type GqlStateTransitionInput = {
  actions: Array<Scalars['String']['input']>;
  event: Scalars['String']['input'];
  fromState: Scalars['String']['input'];
  guards: Array<Scalars['String']['input']>;
  toState: Scalars['String']['input'];
};

/** State type in workflow state machine. */
export const GqlStateType = {
  CHOICE: 'CHOICE',
  FINAL: 'FINAL',
  INITIAL: 'INITIAL',
  NORMAL: 'NORMAL',
  PARALLEL: 'PARALLEL',
} as const;

export type GqlStateType = (typeof GqlStateType)[keyof typeof GqlStateType];
/** Structured rule components (WHO/WHAT/WHEN/EVIDENCE) */
export type GqlStructuredRule = {
  __typename?: 'GqlStructuredRule';
  /** WHAT - Required action (e.g., "submit_evv_record") */
  action: Scalars['String']['output'];
  /** WHO - Actor responsible (e.g., "home_care_provider") */
  actor: Scalars['String']['output'];
  /** DEADLINE - Time constraint (ISO 8601 duration, e.g., "PT24H") */
  deadline?: Maybe<Scalars['String']['output']>;
  /** Required evidence items */
  evidence: Array<GqlEvidence>;
  /** Exception conditions */
  exceptions: Array<GqlException>;
  /** WHEN - Triggering event (e.g., "upon_service_delivery") */
  trigger?: Maybe<Scalars['String']['output']>;
};

/**
 * Execution mode for sub-workflows.
 *
 * Determines how the parent workflow waits for child completion.
 */
export const GqlSubWorkflowExecutionMode = {
  /** Execute asynchronously (non-blocking, parent continues) */
  ASYNC: 'ASYNC',
  /** Execute synchronously and wait for completion (blocking) */
  INLINE: 'INLINE',
  /** Execute in parallel with other sub-workflows in same group */
  PARALLEL: 'PARALLEL',
} as const;

export type GqlSubWorkflowExecutionMode =
  (typeof GqlSubWorkflowExecutionMode)[keyof typeof GqlSubWorkflowExecutionMode];
/**
 * Failure handling mode for sub-workflows.
 *
 * Determines parent workflow behavior when child fails.
 */
export const GqlSubWorkflowFailureMode = {
  /** Trigger SAGA compensation in parent */
  COMPENSATE: 'COMPENSATE',
  /** Fail the parent workflow immediately */
  FAIL_PARENT: 'FAIL_PARENT',
  /** Retry the sub-workflow up to max_retries times */
  RETRY_CHILD: 'RETRY_CHILD',
  /** Skip the failed sub-workflow and continue */
  SKIP_AND_CONTINUE: 'SKIP_AND_CONTINUE',
} as const;

export type GqlSubWorkflowFailureMode =
  (typeof GqlSubWorkflowFailureMode)[keyof typeof GqlSubWorkflowFailureMode];
/** Event emitted when sub-workflow progress changes. */
export type GqlSubWorkflowProgressEvent = {
  __typename?: 'GqlSubWorkflowProgressEvent';
  /** Updated aggregated progress */
  aggregatedProgress: GqlAggregatedProgress;
  /** Child instance ID that changed */
  childInstanceId: Scalars['String']['output'];
  /** Event type (started, progress_updated, completed, failed, etc.) */
  eventType: Scalars['String']['output'];
  /** Parent instance ID */
  parentInstanceId: Scalars['String']['output'];
  /** Timestamp of event */
  timestamp: Scalars['DateTime']['output'];
};

/** Subgraph definition */
export type GqlSubgraphDefinition = {
  __typename?: 'GqlSubgraphDefinition';
  /** Created timestamp */
  createdAt: Scalars['String']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Subgraph name */
  name: Scalars['String']['output'];
  /** ID prefix (e.g., "pay") */
  prefix: Scalars['String']['output'];
  /** Primitive definitions */
  primitives: Array<GqlPrimitiveDefinition>;
  /** Updated timestamp */
  updatedAt: Scalars['String']['output'];
  /** Version */
  version: Scalars['String']['output'];
};

/**
 * A SUBJECT actor with their current lifecycle phase (DRR-141).
 *
 * Returned by `listSubjectsWithLifecycle` query.
 * Actor names are NOT included — use frontend `resolveActorName` / `ActorNameContext`.
 */
export type GqlSubjectWithLifecycle = {
  __typename?: 'GqlSubjectWithLifecycle';
  /** Sequential actor ID (e.g., "2_42") */
  actorId: Scalars['String']['output'];
  /**
   * Current lifecycle phase derived from the subject's wf-0-12-001 Instance.current_state.
   * Values: "onboarding" | "active" | "exiting" | "closed" | None (no lifecycle instance yet).
   */
  lifecyclePhase?: Maybe<Scalars['String']['output']>;
};

/** Result of regulatory node suggestion */
export type GqlSuggestRegulatoryNodesResult = {
  __typename?: 'GqlSuggestRegulatoryNodesResult';
  /** Processing time in milliseconds */
  processingTimeMs: Scalars['Int']['output'];
  /** Suggested regulatory nodes */
  suggestions: Array<GqlRegulatoryNodeSuggestion>;
};

/** Type of event recorded during offline session */
export const GqlSyncEventType = {
  /** Approval/confirmation given offline */
  APPROVAL_GIVEN: 'APPROVAL_GIVEN',
  /** Document attached to an entity */
  DOCUMENT_ATTACHED: 'DOCUMENT_ATTACHED',
  /** Medication administered to a resident (LIFE-CRITICAL) */
  MED_ADMINISTERED: 'MED_ADMINISTERED',
  /** Note/observation added */
  NOTE_ADDED: 'NOTE_ADDED',
  /** Clinical observation recorded (FHIR pathway) */
  OBSERVATION_RECORDED: 'OBSERVATION_RECORDED',
  /** Task marked as completed */
  TASK_COMPLETED: 'TASK_COMPLETED',
  /** Vitals recorded for a resident */
  VITALS_RECORDED: 'VITALS_RECORDED',
} as const;

export type GqlSyncEventType = (typeof GqlSyncEventType)[keyof typeof GqlSyncEventType];
/** Status of a sync session */
export const GqlSyncStatus = {
  /** Conflicts detected, awaiting human resolution */
  CONFLICT: 'CONFLICT',
  /** Sync in progress (saga executing) */
  IN_PROGRESS: 'IN_PROGRESS',
  /** Some entries grafted, some conflicts pending review */
  PARTIAL: 'PARTIAL',
  /** All entries quarantined due to broken chain */
  QUARANTINED: 'QUARANTINED',
  /** Chain verification failed — entire session rejected */
  REJECTED: 'REJECTED',
  /** All entries verified and grafted successfully */
  SUCCESS: 'SUCCESS',
} as const;

export type GqlSyncStatus = (typeof GqlSyncStatus)[keyof typeof GqlSyncStatus];
/** Where the extracted value landed in FERP config layers */
export type GqlTargetMapping = {
  __typename?: 'GqlTargetMapping';
  createdByIngestion?: Maybe<Scalars['Boolean']['output']>;
  layer: Scalars['String']['output'];
  sourceFile: Scalars['String']['output'];
  sourceLine?: Maybe<Scalars['Int']['output']>;
  sourcePath: Scalars['String']['output'];
};

/**
 * A single event in the subject's journey timeline.
 *
 * DRR-126 Phase 6: One timeline entry per constellation instance the subject
 * appears in (grouped from tasks with matching `subject_actor_id`). Provides
 * the "past / present" view of a resident's care journey: every care event
 * 4-hop breadcrumb chain for a task. DRR-126 Phase 8.
 *
 * Chain: Task → TaskGroup (tg-*) → Constellation → Mandate (rs-*)
 * Hop 3 (workflow_ref) is derived from constellation definition_nodes
 * and is optional (null if not found in config).
 *
 * Data tier: T2. No clinical content. DRR-114 compliant.
 */
export type GqlTaskBreadcrumb = {
  __typename?: 'GqlTaskBreadcrumb';
  /**
   * Hop 3 — Constellation config (constellation-*)
   * Which care coordination constellation owns this task.
   */
  constellationId?: Maybe<Scalars['String']['output']>;
  /**
   * Hop 4 — Mandate / RuleSet (rs-*)
   * WHY this task exists — the regulatory mandate that requires it.
   */
  mandateRef?: Maybe<Scalars['String']['output']>;
  /**
   * Hop 1 — Task group config (tg-*)
   * Which category of work this task belongs to.
   */
  taskGroupRef?: Maybe<Scalars['String']['output']>;
  /** Hop 0 — The task itself */
  taskId: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
  taskStatus: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
  /**
   * Hop 2 — Workflow config (wf-*)
   * Which workflow config generated this task group.
   * Derived from constellation Ring 3 definition_nodes; null if not indexed.
   */
  workflowRef?: Maybe<Scalars['String']['output']>;
};

export type GqlTaskConnection = {
  __typename?: 'GqlTaskConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Task>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/** DRR-130: Task creation pathway — stamps HOW the task came to exist. */
export const GqlTaskCreatedBySource = {
  /** Zen Engine rule `create_task` action — regulatory mandate */
  RULE_ENGINE: 'RULE_ENGINE',
  /** Tenant `createTask` API/UI — triggers ViolationCheck before write */
  TENANT_DECISION: 'TENANT_DECISION',
  /** Workflow `SpawnTasksFromGroups` on self-loop state — operational recurrence */
  WORKFLOW_OPERATION: 'WORKFLOW_OPERATION',
} as const;

export type GqlTaskCreatedBySource =
  (typeof GqlTaskCreatedBySource)[keyof typeof GqlTaskCreatedBySource];
export const GqlTaskNotificationEvent = {
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED',
  DEADLINE_APPROACHING: 'DEADLINE_APPROACHING',
  FAILED: 'FAILED',
  REASSIGNED: 'REASSIGNED',
  STARTED: 'STARTED',
} as const;

export type GqlTaskNotificationEvent =
  (typeof GqlTaskNotificationEvent)[keyof typeof GqlTaskNotificationEvent];
/** Specifies an entity to auto-create when a task is completed. */
export type GqlTaskOutputSpec = {
  __typename?: 'GqlTaskOutputSpec';
  /** Entity type to create (e.g., "FhirObservation", "Document") */
  entityType: Scalars['String']['output'];
  /** Target subgraph (e.g., "fhir", "core") */
  subgraph: Scalars['String']['output'];
};

export const GqlTaskPriority = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  NORMAL: 'NORMAL',
} as const;

export type GqlTaskPriority = (typeof GqlTaskPriority)[keyof typeof GqlTaskPriority];
export type GqlTaskStatistics = {
  __typename?: 'GqlTaskStatistics';
  avgDurationMs?: Maybe<Scalars['String']['output']>;
  avgProgressPercent: Scalars['Float']['output'];
  completedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  inProgressCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  /** Tasks within 24h of their due_at deadline */
  slaApproachingCount: Scalars['Int']['output'];
  /** Tasks past their due_at deadline */
  slaBreachedCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  totalTasks: Scalars['Int']['output'];
};

export const GqlTaskStatus = {
  ASSIGNED: 'ASSIGNED',
  BLOCKED: 'BLOCKED',
  CANCELLED: 'CANCELLED',
  COMPENSATED: 'COMPENSATED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  PAUSED: 'PAUSED',
  PENDING: 'PENDING',
  PENDING_EXTERNAL: 'PENDING_EXTERNAL',
  READY: 'READY',
} as const;

export type GqlTaskStatus = (typeof GqlTaskStatus)[keyof typeof GqlTaskStatus];
export const GqlTaskType = {
  AI_DECISION: 'AI_DECISION',
  APPROVAL: 'APPROVAL',
  AUTOMATED: 'AUTOMATED',
  CUSTOM: 'CUSTOM',
  MANUAL: 'MANUAL',
  SYSTEM: 'SYSTEM',
} as const;

export type GqlTaskType = (typeof GqlTaskType)[keyof typeof GqlTaskType];
/** GraphQL type for TeamContacts. */
export type GqlTeamContacts = {
  __typename?: 'GqlTeamContacts';
  /** Team calendar URL */
  calendarUrl?: Maybe<Scalars['String']['output']>;
  /** Chat channel URL (Slack, Teams, Discord) */
  chatChannel?: Maybe<Scalars['String']['output']>;
  /** Tenant-specific custom contact methods */
  custom: Scalars['JSON']['output'];
  /** Team email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Wiki or documentation URL */
  wikiUrl?: Maybe<Scalars['String']['output']>;
};

/** GraphQL input type for TeamContacts. */
export type GqlTeamContactsInput = {
  /** Calendar URL */
  calendarUrl?: InputMaybe<Scalars['String']['input']>;
  /** Chat channel URL */
  chatChannel?: InputMaybe<Scalars['String']['input']>;
  /** Custom contact methods */
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Team email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Wiki URL */
  wikiUrl?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL enum for TeamType (6 types total). */
export const GqlTeamType = {
  /** Tenant-defined custom team type (100 members) */
  CUSTOM: 'CUSTOM',
  /** Top-level department (50 members typical) */
  DEPARTMENT: 'DEPARTMENT',
  /** Large division (200 members) */
  DIVISION: 'DIVISION',
  /** Cross-functional group (20 members) */
  GROUP: 'GROUP',
  /** Temporary project team (15 members) */
  PROJECT: 'PROJECT',
  /** Small focused team - Scrum/Agile size (8 members) */
  SQUAD: 'SQUAD',
} as const;

export type GqlTeamType = (typeof GqlTeamType)[keyof typeof GqlTeamType];
/**
 * Aggregated team workspace data (DRR-061).
 *
 * Single query combining team info, members, presence, tasks, and queue status.
 * Avoids N+1 queries from the frontend.
 */
export type GqlTeamWorkspaceData = {
  __typename?: 'GqlTeamWorkspaceData';
  memberCount: Scalars['Int']['output'];
  members: Array<Actor>;
  onlineCount: Scalars['Int']['output'];
  presence: Array<GqlActorPresence>;
  teamDescription?: Maybe<Scalars['String']['output']>;
  teamName: Scalars['String']['output'];
  teamType?: Maybe<Scalars['String']['output']>;
};

/** Template approval configuration */
export type GqlTemplateApprovalConfig = {
  __typename?: 'GqlTemplateApprovalConfig';
  additionalReviewReason?: Maybe<Scalars['String']['output']>;
  additionalReviewRequired: Scalars['Boolean']['output'];
  confidenceThreshold: Scalars['Float']['output'];
  currentConfidence: Scalars['Float']['output'];
  deadlineHours: Scalars['Int']['output'];
  requiredApprovals: Scalars['Int']['output'];
  requiresApproval: Scalars['Boolean']['output'];
  roles: Array<Scalars['String']['output']>;
};

/** Pagination connection for templates */
export type GqlTemplateConnection = {
  __typename?: 'GqlTemplateConnection';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Template>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/** Template status enum */
export const GqlTemplateStatus = {
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PUBLISHED: 'PUBLISHED',
} as const;

export type GqlTemplateStatus = (typeof GqlTemplateStatus)[keyof typeof GqlTemplateStatus];
/** Template validation result */
export type GqlTemplateValidationResult = {
  __typename?: 'GqlTemplateValidationResult';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  validatedAt: Scalars['DateTime']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/**
 * Feature flags for a tenant, read from constellation-facility-meta.yaml
 * (CFG#CONSTELLATION#constellation-facility-meta in DDB).
 *
 * Toggle features per tenant by updating the `features:` section in the YAML
 * and re-running ferp-seed. No code changes required.
 */
export type GqlTenantFeatureFlags = {
  __typename?: 'GqlTenantFeatureFlags';
  /** Beacon alert management (MN 626.557) */
  beaconDashboard: Scalars['Boolean']['output'];
  /** Care Journey timeline + Neural Graph (DRR-126) */
  careJourney: Scalars['Boolean']['output'];
  /** QAPI quality dashboard (also requires qapi:view scope) */
  qapiDashboard: Scalars['Boolean']['output'];
  /** Regulatory standards pack viewer */
  standardsPack: Scalars['Boolean']['output'];
  /** Cross-tenant sync session management */
  syncDashboard: Scalars['Boolean']['output'];
  /** Witness signature queue */
  witnessQueue: Scalars['Boolean']['output'];
};

export const GqlTimeWindow = {
  PER_DAY: 'PER_DAY',
  PER_HOUR: 'PER_HOUR',
  PER_MINUTE: 'PER_MINUTE',
  PER_MONTH: 'PER_MONTH',
  PER_QUARTER: 'PER_QUARTER',
  PER_SECOND: 'PER_SECOND',
  PER_WEEK: 'PER_WEEK',
  PER_YEAR: 'PER_YEAR',
} as const;

export type GqlTimeWindow = (typeof GqlTimeWindow)[keyof typeof GqlTimeWindow];
/** GraphQL enum for TraceSpanType. */
export const GqlTraceSpanType = {
  AI_DECISION: 'AI_DECISION',
  CACHE_OPERATION: 'CACHE_OPERATION',
  COMPENSATION_TASK: 'COMPENSATION_TASK',
  DATABASE_QUERY: 'DATABASE_QUERY',
  ERROR_HANDLING: 'ERROR_HANDLING',
  EXTERNAL_API_CALL: 'EXTERNAL_API_CALL',
  HUMAN_REVIEW: 'HUMAN_REVIEW',
  NOTIFICATION_SEND: 'NOTIFICATION_SEND',
  PERFORMANCE_CHECK: 'PERFORMANCE_CHECK',
  POLICY_EVALUATION: 'POLICY_EVALUATION',
  RESOURCE_ALLOCATION: 'RESOURCE_ALLOCATION',
  ROLLBACK: 'ROLLBACK',
  TASK_EXECUTION: 'TASK_EXECUTION',
  TRANSITION_EXECUTION: 'TRANSITION_EXECUTION',
  VALIDATION_CHECK: 'VALIDATION_CHECK',
  WORKFLOW_END: 'WORKFLOW_END',
  WORKFLOW_START: 'WORKFLOW_START',
} as const;

export type GqlTraceSpanType = (typeof GqlTraceSpanType)[keyof typeof GqlTraceSpanType];
/** GraphQL enum for TraceStatus. */
export const GqlTraceStatus = {
  CANCELLED: 'CANCELLED',
  FAILURE: 'FAILURE',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
} as const;

export type GqlTraceStatus = (typeof GqlTraceStatus)[keyof typeof GqlTraceStatus];
export const GqlTransactionStatus = {
  ABORTED: 'ABORTED',
  ACTIVE: 'ACTIVE',
  COMMITTED: 'COMMITTED',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  ROLLED_BACK: 'ROLLED_BACK',
} as const;

export type GqlTransactionStatus = (typeof GqlTransactionStatus)[keyof typeof GqlTransactionStatus];
/**
 * Input for transitioning instance state (pure append-only).
 *
 * Creates a new instance version with updated state, preserving complete
 * audit trail via parent_id linkage.
 */
export type GqlTransitionInstanceInput = {
  /** New workflow state name */
  newState: Scalars['String']['input'];
  /** New status for this transition */
  newStatus: GqlInstanceStatus | '%future added value';
  /** What triggered this transition (e.g., "user_action", "timeout", "event_received") */
  trigger: Scalars['String']['input'];
};

/**
 * Input for transitioning task state (pure append-only).
 *
 * **Pure Append-Only Architecture**:
 * - Creates new task version with updated state
 * - Preserves complete audit trail via parent_id linkage
 * - Handles reassignment tracking automatically
 */
export type GqlTransitionTaskInput = {
  /** Actor ID if transitioning to ASSIGNED status (optional) */
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  /** New status for this transition */
  newStatus: GqlTaskStatus | '%future added value';
  /** What triggered this transition (e.g., "user_action", "timeout", "dependency_completed") */
  trigger: Scalars['String']['input'];
};

/** User-switchable traversal lens mode (DRR-135). */
export const GqlTraversalMode = {
  /** Start from people (SUBJECT actors) and expand to their world. */
  PERSON_CENTERED: 'PERSON_CENTERED',
  /** Start from tasks and filter to the current user's work. */
  TASK_CENTRIC: 'TASK_CENTRIC',
} as const;

export type GqlTraversalMode = (typeof GqlTraversalMode)[keyof typeof GqlTraversalMode];
export const GqlTrendDirection = {
  DECREASING: 'DECREASING',
  ERRATIC: 'ERRATIC',
  INCREASING: 'INCREASING',
  STABLE: 'STABLE',
} as const;

export type GqlTrendDirection = (typeof GqlTrendDirection)[keyof typeof GqlTrendDirection];
/**
 * UI pattern for workflow state rendering (DRR-309).
 * Determines which frontend component pattern to use.
 */
export const GqlUiPattern = {
  /** Approval workflow with decision buttons */
  APPROVAL_GATE: 'APPROVAL_GATE',
  /** Multi-section assessment with scoring */
  ASSESSMENT_WIZARD: 'ASSESSMENT_WIZARD',
  /** Task checklist with checkboxes */
  CHECKLIST: 'CHECKLIST',
  /** Document review and signature collection */
  DOCUMENT_SIGNING: 'DOCUMENT_SIGNING',
  /** Sequential form wizard with step indicator */
  GUIDED_FORM: 'GUIDED_FORM',
  /** Minimal status display (default fallback) */
  STATUS_ONLY: 'STATUS_ONLY',
  /** Historical timeline of completed states */
  TIMELINE_VIEW: 'TIMELINE_VIEW',
  /** Multi-track progress overview (parallel fragments) */
  TRACK_DASHBOARD: 'TRACK_DASHBOARD',
} as const;

export type GqlUiPattern = (typeof GqlUiPattern)[keyof typeof GqlUiPattern];
export type GqlUniqueRule = {
  __typename?: 'GqlUniqueRule';
  /** Scope fields for uniqueness check */
  scope: Array<Scalars['String']['output']>;
};

export type GqlUniqueRuleInput = {
  scope: Array<Scalars['String']['input']>;
};

/** Result of unlocking a document (ADR-002) */
export type GqlUnlockResult = {
  __typename?: 'GqlUnlockResult';
  /** Document ID */
  documentId: Scalars['String']['output'];
  /** Key expiration timestamp (ISO 8601) */
  expiresAt: Scalars['String']['output'];
  /** Key expiration in seconds */
  expiresIn: Scalars['Int']['output'];
  /** Decryption key (base64-encoded AES-256-GCM) */
  key: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
};

export type GqlUpdateActorInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expertTier?: InputMaybe<Scalars['String']['input']>;
  lastModifiedReason?: InputMaybe<Scalars['String']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  requiredPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** DRR-103: Multiple Role config IDs for Actor->Role->Scope resolution. */
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<GqlActorStatus | '%future added value'>;
  /** Supervisor actor ID (DRR-061) */
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Team membership (DRR-061) */
  teamId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating analytics */
export type GqlUpdateAnalyticsInput = {
  analyticsName?: InputMaybe<Scalars['String']['input']>;
  criticalThreshold?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  warningThreshold?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for updating an Approval. */
export type GqlUpdateApprovalInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  priority?: InputMaybe<GqlApprovalPriority | '%future added value'>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GqlUpdateConstraintInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDates?: InputMaybe<ConstraintDateRangeInput>;
  limitValue?: InputMaybe<Scalars['Float']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notificationActorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationAtPercent?: InputMaybe<Array<Scalars['Int']['input']>>;
  overrideAllowedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  secondaryLimit?: InputMaybe<Scalars['Float']['input']>;
};

/** Update formula input */
export type GqlUpdateFormulaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  formulaId: Scalars['String']['input'];
  interactions?: InputMaybe<Array<GqlFormulaInteractionInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  primitives?: InputMaybe<Array<GqlPrimitiveType | '%future added value'>>;
  successRate?: InputMaybe<Scalars['Float']['input']>;
  tenantId: Scalars['String']['input'];
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Input for updating an existing Instance.
 *
 * Primarily for administrative updates (priority, deadline, metadata).
 * State transitions use specific mutations (start, pause, resume, etc.).
 */
export type GqlUpdateInstanceInput = {
  /** Business deadline */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** Human-readable instance name */
  instanceName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum retry attempts */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Additional metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Queue priority (0-255) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Scheduled execution start time */
  scheduledStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Categorization tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum execution time in milliseconds */
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating Instance progress. */
export type GqlUpdateProgressInput = {
  /** Mark milestone as completed (optional) */
  completeMilestone?: InputMaybe<Scalars['String']['input']>;
  /** Number of completed tasks */
  completedTasks: Scalars['Int']['input'];
  /** Current milestone name (optional) */
  currentMilestone?: InputMaybe<Scalars['String']['input']>;
  /** Total number of tasks */
  totalTasks: Scalars['Int']['input'];
};

/** Input for updating an existing Team. */
export type GqlUpdateTeamInput = {
  /** Is team active? */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Budget allocation */
  budgetAllocated?: InputMaybe<Scalars['Float']['input']>;
  /** Contact information */
  contacts?: InputMaybe<GqlTeamContactsInput>;
  /** Cost center code */
  costCenter?: InputMaybe<Scalars['String']['input']>;
  /** Custom metadata */
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Deputy leader ID */
  deputyLeadId?: InputMaybe<Scalars['String']['input']>;
  /** Team description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Resource quotas */
  quotaLimits?: InputMaybe<GqlQuotaLimitsInput>;
  /** Status reason (when inactive) */
  statusReason?: InputMaybe<Scalars['String']['input']>;
  /** Searchable tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Team leader ID */
  teamLeadId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating team quotas. */
export type GqlUpdateTeamQuotasInput = {
  /** Team code */
  code: Scalars['String']['input'];
  /** New quota limits */
  quotaLimits: GqlQuotaLimitsInput;
};

/** Input for updating template status */
export type GqlUpdateTemplateStatusInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  status: GqlTemplateStatus | '%future added value';
};

/** Upload Chaos Document Input */
export type GqlUploadChaosDocumentInput = {
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  /** Intake target — what FERP should do with this document (DRR-137) */
  intakeTarget?: InputMaybe<IntakeTarget | '%future added value'>;
  mimeType: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  uploadedBy: Scalars['String']['input'];
};

/** Validation error for a rule */
export type GqlValidationError = {
  __typename?: 'GqlValidationError';
  /** Field path where error occurred */
  field: Scalars['String']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

/** Validation result */
export type GqlValidationResult = {
  __typename?: 'GqlValidationResult';
  completenessScore: Scalars['Float']['output'];
  matchingFormula?: Maybe<Scalars['String']['output']>;
  recommendations: Array<GqlFormulaRecommendation>;
  warnings: Array<GqlValidationWarning>;
};

/** GraphQL union for ValidationRule (8 rule types). */
export type GqlValidationRule =
  | GqlExistsRule
  | GqlExpressionRule
  | GqlLengthRule
  | GqlOneOfRule
  | GqlRangeRule
  | GqlRegexRule
  | GqlStandardRule
  | GqlUniqueRule;

/** Input wrapper for ValidationRule (one-of union). */
export type GqlValidationRuleInput = {
  exists?: InputMaybe<GqlExistsRuleInput>;
  expression?: InputMaybe<GqlExpressionRuleInput>;
  length?: InputMaybe<GqlLengthRuleInput>;
  oneOf?: InputMaybe<GqlOneOfRuleInput>;
  range?: InputMaybe<GqlRangeRuleInput>;
  regex?: InputMaybe<GqlRegexRuleInput>;
  standard?: InputMaybe<GqlStandardRuleInput>;
  unique?: InputMaybe<GqlUniqueRuleInput>;
};

/** GraphQL enum for ValidationSeverity (4 levels). */
export const GqlValidationSeverity = {
  /** Critical error (blocks + escalates) */
  CRITICAL: 'CRITICAL',
  /** Error (blocks submission) */
  ERROR: 'ERROR',
  /** Informational only (doesn't block) */
  INFO: 'INFO',
  /** Warning (doesn't block, but highlights) */
  WARNING: 'WARNING',
} as const;

export type GqlValidationSeverity =
  (typeof GqlValidationSeverity)[keyof typeof GqlValidationSeverity];
/** GraphQL enum for ValidationType (8 types total). */
export const GqlValidationType = {
  /** Complex logic */
  BUSINESS_RULE: 'BUSINESS_RULE',
  /** HIPAA, SOX, FHIR */
  COMPLIANCE: 'COMPLIANCE',
  /** If-then logic */
  CONDITIONAL: 'CONDITIONAL',
  /** Tenant-defined */
  CUSTOM: 'CUSTOM',
  /** Regex, pattern matching */
  FORMAT: 'FORMAT',
  /** Min, max, between */
  RANGE: 'RANGE',
  /** ID exists in database */
  REFERENCE: 'REFERENCE',
  /** No duplicates */
  UNIQUENESS: 'UNIQUENESS',
} as const;

export type GqlValidationType = (typeof GqlValidationType)[keyof typeof GqlValidationType];
/** Validation warning for GraphQL */
export type GqlValidationWarning = {
  __typename?: 'GqlValidationWarning';
  antiPatternId?: Maybe<Scalars['String']['output']>;
  fixWith: Array<GqlPrimitiveType | '%future added value'>;
  message: Scalars['String']['output'];
  severity: GqlWarningSeverity | '%future added value';
  suggestion: Scalars['String']['output'];
  triggeredBy: Array<GqlPrimitiveType | '%future added value'>;
};

/** Per-extraction verification status */
export const GqlVerificationStatus = {
  CONFIRMED: 'CONFIRMED',
  CORRECTED: 'CORRECTED',
  REJECTED: 'REJECTED',
  UNVERIFIED: 'UNVERIFIED',
} as const;

export type GqlVerificationStatus =
  (typeof GqlVerificationStatus)[keyof typeof GqlVerificationStatus];
/** Result of creating a grant */
export type GqlVerifierGrant = {
  __typename?: 'GqlVerifierGrant';
  /** When the grant expires */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique grant ID */
  grantId: Scalars['String']['output'];
  /** When the grant was created */
  grantedAt: Scalars['DateTime']['output'];
  /** Tenant that granted access */
  grantingTenantId: Scalars['String']['output'];
  /** Whether the grant is currently active */
  isActive: Scalars['Boolean']['output'];
  /** Access scope */
  scope: VerificationScope | '%future added value';
  /** Verifier tenant that received access */
  verifierTenantId: Scalars['String']['output'];
  /** Optional workflow type filter */
  workflowTypeFilter?: Maybe<Array<Scalars['String']['output']>>;
};

/** Version History Entry */
export type GqlVersionHistoryEntry = {
  __typename?: 'GqlVersionHistoryEntry';
  changeSummary: Scalars['String']['output'];
  changedAt: Scalars['String']['output'];
  changedBy: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/**
 * GraphQL representation of ViewContext.
 *
 * Single response containing all presentation metadata for a route.
 * Frontend calls this once per navigation and caches the result.
 */
export type GqlViewContext = {
  __typename?: 'GqlViewContext';
  /** Route constraints (informational) */
  constraints: GqlRouteConstraints;
  /** Active form schema overrides */
  formOverrides: Array<GqlFormOverrideRef>;
  /** View lens (clinical, operational, architect, family, user) */
  lens: GqlViewLens | '%future added value';
  /** Navigation groups for this role */
  navGroups: Array<GqlNavGroupRef>;
  /** Scope dimensions for filtering */
  scopeDimensions: Array<GqlScopeDimension>;
  /** Terminology mappings (e.g., {"Subject": "Client", "WorkType": "Service"}) */
  terminology: Scalars['JSON']['output'];
  /** Primitives visible to this role */
  visiblePrimitives: Array<Scalars['String']['output']>;
  /** Work context (if subject-centric route) */
  workContext?: Maybe<GqlWorkContext>;
};

/** GraphQL enum for ViewLens */
export const GqlViewLens = {
  ARCHITECT: 'ARCHITECT',
  CLINICAL: 'CLINICAL',
  FAMILY: 'FAMILY',
  OPERATIONAL: 'OPERATIONAL',
  USER: 'USER',
} as const;

export type GqlViewLens = (typeof GqlViewLens)[keyof typeof GqlViewLens];
export const GqlViolationAction = {
  BLOCK: 'BLOCK',
  ESCALATE: 'ESCALATE',
  LOG: 'LOG',
  REQUIRE_APPROVAL: 'REQUIRE_APPROVAL',
  WARN: 'WARN',
} as const;

export type GqlViolationAction = (typeof GqlViolationAction)[keyof typeof GqlViolationAction];
export type GqlViolationRecord = {
  __typename?: 'GqlViolationRecord';
  actionTaken: GqlViolationAction | '%future added value';
  attemptedValue: Scalars['Float']['output'];
  limitValueAtViolation: Scalars['Float']['output'];
  overagePercent: Scalars['Float']['output'];
  overrideApprovedBy?: Maybe<Scalars['String']['output']>;
  overrideReason?: Maybe<Scalars['String']['output']>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolutionStatus: GqlViolationResolutionStatus | '%future added value';
  violatedAt: Scalars['DateTime']['output'];
  violatedBy: Scalars['String']['output'];
  violationContext: Scalars['JSON']['output'];
  violationId: Scalars['String']['output'];
  wasOverridden: Scalars['Boolean']['output'];
};

export const GqlViolationResolutionStatus = {
  BLOCKED: 'BLOCKED',
  ESCALATED: 'ESCALATED',
  OVERRIDE_APPROVED: 'OVERRIDE_APPROVED',
  OVERRIDE_DENIED: 'OVERRIDE_DENIED',
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
} as const;

export type GqlViolationResolutionStatus =
  (typeof GqlViolationResolutionStatus)[keyof typeof GqlViolationResolutionStatus];
/** Warning severity for GraphQL */
export const GqlWarningSeverity = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
} as const;

export type GqlWarningSeverity = (typeof GqlWarningSeverity)[keyof typeof GqlWarningSeverity];
/** GraphQL type for work context */
export type GqlWorkContext = {
  __typename?: 'GqlWorkContext';
  constellationId?: Maybe<Scalars['String']['output']>;
  enrichmentKeys: Array<Scalars['String']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
};

/** Input for creating a workflow state. */
export type GqlWorkflowStateInput = {
  entryActions: Array<Scalars['String']['input']>;
  exitActions: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Policy primitive IDs evaluated before entry_actions (DRR-129 G1). */
  policyRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  stateType: GqlStateType | '%future added value';
  timeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export const GqlXaResourceState = {
  ACTIVE: 'ACTIVE',
  COMMITTED: 'COMMITTED',
  FAILED: 'FAILED',
  IDLE: 'IDLE',
  PREPARED: 'PREPARED',
  ROLLED_BACK: 'ROLLED_BACK',
} as const;

export type GqlXaResourceState = (typeof GqlXaResourceState)[keyof typeof GqlXaResourceState];
export const GqlXaState = {
  ACTIVE: 'ACTIVE',
  COMMITTED: 'COMMITTED',
  HEURISTIC_COMMIT: 'HEURISTIC_COMMIT',
  HEURISTIC_ROLLBACK: 'HEURISTIC_ROLLBACK',
  IDLE: 'IDLE',
  PREPARED: 'PREPARED',
  ROLLED_BACK: 'ROLLED_BACK',
} as const;

export type GqlXaState = (typeof GqlXaState)[keyof typeof GqlXaState];
export const GqlXaVote = {
  NO: 'NO',
  READ_ONLY: 'READ_ONLY',
  YES: 'YES',
} as const;

export type GqlXaVote = (typeof GqlXaVote)[keyof typeof GqlXaVote];
/** List of grants */
export type GrantList = {
  __typename?: 'GrantList';
  /** Active grants */
  grants: Array<GqlVerifierGrant>;
  /** Total count */
  total: Scalars['Int']['output'];
};

/** Input for creating a verifier grant */
export type GrantVerifierAccessInput = {
  /** Optional: number of days until expiration (default: 90, max: 365) */
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  /** What the verifier can see */
  scope: VerificationScope | '%future added value';
  /** The verifier tenant receiving access */
  verifierTenantId: Scalars['String']['input'];
  /** Optional: limit to specific workflow types */
  workflowTypeFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Result of a graph intersection query across multiple constellations.
 *
 * Uses Valkey SINTER to find entities (tasks, instances) that appear in ALL
 * specified constellation edge sets. Enables surveyor queries like "incomplete
 * tasks for Margaret at Hillside today" = 3-way SINTER.
 */
export type GraphIntersectionResult = {
  __typename?: 'GraphIntersectionResult';
  /** Count of intersecting entities */
  count: Scalars['Int']['output'];
  /** Entity IDs (task IDs, instance IDs) present in ALL constellation edge sets */
  entityIds: Array<Scalars['String']['output']>;
};

/** Aggregation function for grid footer */
export type GridAggregation = {
  __typename?: 'GridAggregation';
  /** Column field_name to aggregate */
  column: Scalars['String']['output'];
  /** Aggregation function: "SUM", "COUNT", "AVG", "MIN", "MAX" */
  function: Scalars['String']['output'];
  /** Display label for aggregation row */
  label?: Maybe<Scalars['String']['output']>;
};

/** Input version of GridAggregation */
export type GridAggregationInput = {
  column: Scalars['String']['input'];
  function: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Column definition for a grid field */
export type GridColumnConfig = {
  __typename?: 'GridColumnConfig';
  /** Whether cells in this column are editable */
  editable?: Maybe<Scalars['Boolean']['output']>;
  /** Column field name (used as key in row objects) */
  fieldName: Scalars['String']['output'];
  /** Field type for this column's cells */
  fieldType: FormFieldType | '%future added value';
  /** Column header label */
  label: Scalars['String']['output'];
  /** Options for select-type columns */
  options?: Maybe<Array<SelectOption>>;
  /** Reference config for reference-type columns */
  referenceConfig?: Maybe<ReferenceConfig>;
  /** Column width (e.g., "100px", "20%") */
  width?: Maybe<Scalars['String']['output']>;
};

/** Input version of GridColumnConfig */
export type GridColumnConfigInput = {
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fieldName: Scalars['String']['input'];
  fieldType: FormFieldType | '%future added value';
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<SelectOptionInput>>;
  referenceConfig?: InputMaybe<ReferenceConfigInput>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/** Configuration for GRID field type (inline table editor) */
export type GridConfig = {
  __typename?: 'GridConfig';
  /** Footer aggregation functions */
  aggregations?: Maybe<Array<GridAggregation>>;
  /** Allow adding new rows */
  allowAddRow?: Maybe<Scalars['Boolean']['output']>;
  /** Allow removing rows */
  allowRemoveRow?: Maybe<Scalars['Boolean']['output']>;
  /** Column definitions */
  columns: Array<GridColumnConfig>;
  /** Maximum number of rows */
  maxRows?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of rows */
  minRows?: Maybe<Scalars['Int']['output']>;
  /** Show row numbers */
  showRowNumbers?: Maybe<Scalars['Boolean']['output']>;
};

/** Input version of GridConfig */
export type GridConfigInput = {
  aggregations?: InputMaybe<Array<GridAggregationInput>>;
  allowAddRow?: InputMaybe<Scalars['Boolean']['input']>;
  allowRemoveRow?: InputMaybe<Scalars['Boolean']['input']>;
  columns: Array<GridColumnConfigInput>;
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  minRows?: InputMaybe<Scalars['Int']['input']>;
  showRowNumbers?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Guard entry (key-value pair for HashMap). */
export type GuardEntry = {
  __typename?: 'GuardEntry';
  /** Guard expression (value) */
  expression: GuardExpression;
  /** Guard name (key) */
  name: Scalars['String']['output'];
};

/** Guard expression for conditional logic. */
export type GuardExpression = {
  __typename?: 'GuardExpression';
  /** The expression code/logic */
  expression: Scalars['String']['output'];
  /** Type of guard expression language */
  guardType: GqlGuardType | '%future added value';
};

/**
 * Outcome of evaluating a guard in simulation mode.
 * DRR-170-A1: UNKNOWN guards are explored but marked Uncertain.
 */
export const GuardOutcome = {
  /** Guard evaluated to false */
  FAILED: 'FAILED',
  /** Guard evaluated to true */
  PASSED: 'PASSED',
  /** Guard depends on runtime data not in mock context */
  UNKNOWN: 'UNKNOWN',
} as const;

export type GuardOutcome = (typeof GuardOutcome)[keyof typeof GuardOutcome];
/** Result of evaluating a single guard. */
export type GuardResult = {
  __typename?: 'GuardResult';
  /** Human-readable explanation (formula text, missing fields, etc.) */
  explanation: Scalars['String']['output'];
  guardName: Scalars['String']['output'];
  guardType: Scalars['String']['output'];
  outcome: GuardOutcome | '%future added value';
};

/** Single guidance step */
export type GuidanceStepOutput = {
  __typename?: 'GuidanceStepOutput';
  /** Estimated duration (e.g., "5 minutes") */
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  /** Human-readable instruction */
  instruction: Scalars['String']['output'];
  /** Required input fields for this step */
  requiredInputs?: Maybe<Array<Scalars['String']['output']>>;
  /** Step number (1-based) */
  stepNumber: Scalars['Int']['output'];
  /** Validation rules to check */
  validationRules?: Maybe<Array<Scalars['String']['output']>>;
};

/** Configuration for HIERARCHICAL_SELECT field type */
export type HierarchicalConfig = {
  __typename?: 'HierarchicalConfig';
  /** GraphQL query to fetch tree data */
  dataSource: Scalars['String']['output'];
  /** JSONPath to label in each node */
  labelPath?: Maybe<Scalars['String']['output']>;
  /** Load children on expand (vs. all upfront) */
  lazyLoad?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum tree depth to display */
  maxDepth?: Maybe<Scalars['Int']['output']>;
  /** Field name that references parent node (for flat data) */
  parentField?: Maybe<Scalars['String']['output']>;
  /** Enable search/filter in tree */
  searchable?: Maybe<Scalars['Boolean']['output']>;
  /** Selection mode: "single", "multi", "leaf-only" */
  selectionMode: Scalars['String']['output'];
  /** JSONPath to value in each node */
  valuePath?: Maybe<Scalars['String']['output']>;
};

/** Input version of HierarchicalConfig */
export type HierarchicalConfigInput = {
  dataSource: Scalars['String']['input'];
  labelPath?: InputMaybe<Scalars['String']['input']>;
  lazyLoad?: InputMaybe<Scalars['Boolean']['input']>;
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  parentField?: InputMaybe<Scalars['String']['input']>;
  searchable?: InputMaybe<Scalars['Boolean']['input']>;
  selectionMode: Scalars['String']['input'];
  valuePath?: InputMaybe<Scalars['String']['input']>;
};

/** HTTP method */
export const HttpMethod = {
  DELETE: 'DELETE',
  GET: 'GET',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
} as const;

export type HttpMethod = (typeof HttpMethod)[keyof typeof HttpMethod];
/** HTTP version */
export const HttpVersion = {
  HTTP_1_1: 'HTTP_1_1',
  HTTP_2: 'HTTP_2',
} as const;

export type HttpVersion = (typeof HttpVersion)[keyof typeof HttpVersion];
/** Input for hydrating a compressed ID */
export type HydrateIdInput = {
  /** Compressed ID (e.g., "pay!1R156") */
  compressedId: Scalars['String']['input'];
};

/** Entity types for domain-agnostic ID generation (16 primitive workflow types) */
export const IdBrokerEntityType = {
  /** Actor performing operations */
  actor: 'actor',
  /** Audit trail entries */
  audit: 'audit',
  /** Cross-system correlation */
  correlation: 'correlation',
  /** Escalation procedures */
  escalation: 'escalation',
  /** Idempotency token generation */
  idempotency: 'idempotency',
  /** Notification and alerting */
  notification: 'notification',
  /** Policy enforcement and governance */
  policy: 'policy',
  /** API request tracking */
  request: 'request',
  /** Resource allocation and management */
  resource: 'resource',
  /** Schedule for automated execution */
  schedule: 'schedule',
  /** User session management */
  session: 'session',
  /** Tenant isolation and management */
  tenant: 'tenant',
  /** Audit trace and logging */
  trace: 'trace',
  /** Transaction coordination */
  transaction: 'transaction',
  /** Workflow edge/transition */
  workflowEdge: 'workflowEdge',
  /** Workflow node in DAG */
  workflowNode: 'workflowNode',
} as const;

export type IdBrokerEntityType = (typeof IdBrokerEntityType)[keyof typeof IdBrokerEntityType];
/**
 * Primitive registration input for ID broker
 * Note: Prefixed to avoid potential collisions (Issue #581)
 */
export type IdBrokerRegisterPrimitiveInput = {
  /** Core primitive type this maps to */
  corePrimitive: GqlCorePrimitive | '%future added value';
  /** Description */
  description: Scalars['String']['input'];
  /** Whether this primitive is life-critical */
  lifeCritical: Scalars['Boolean']['input'];
  /** Primitive name (e.g., "payroll_run") */
  name: Scalars['String']['input'];
  /** Symbol for compression (single character) */
  symbol: Scalars['String']['input'];
};

/**
 * Subgraph registration input for ID broker
 * Note: Renamed to avoid collision with metadata_api::GqlRegisterSubgraphInput (Issue #581)
 */
export type IdBrokerRegisterSubgraphInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Subgraph name (e.g., "payroll") */
  name: Scalars['String']['input'];
  /** ID prefix (3-4 characters, e.g., "pay") */
  prefix: Scalars['String']['input'];
  /** Primitive definitions */
  primitives: Array<IdBrokerRegisterPrimitiveInput>;
  /** Version (semver) */
  version: Scalars['String']['input'];
};

/** Offline → permanent ID mapping */
export type IdMapping = {
  __typename?: 'IdMapping';
  /** Entity type this mapping applies to */
  entityType: Scalars['String']['output'];
  /** Offline ID format: `offline:{device}:{counter}` */
  offlineId: Scalars['String']['output'];
  /** Permanent ID (Snowflake format) */
  permanentId: Scalars['String']['output'];
};

export type ImpactEstimateGql = {
  __typename?: 'ImpactEstimateGql';
  costImpact: CostImpactGql;
  performanceImprovement: PerformanceImprovementGql;
  reliabilityImprovement: ReliabilityImprovementGql;
};

export type ImpactSummary = {
  __typename?: 'ImpactSummary';
  /** Number of employees affected by tax change */
  affectedEmployeeCount: Scalars['Int']['output'];
  /** Average paycheck impact per employee (USD) */
  averageImpactPerPaycheck: Scalars['Float']['output'];
  /** Total monthly payroll impact (USD) */
  totalMonthlyImpact: Scalars['Float']['output'];
};

export const ImplementationEffort = {
  complex: 'complex',
  easy: 'easy',
  moderate: 'moderate',
  trivial: 'trivial',
} as const;

export type ImplementationEffort = (typeof ImplementationEffort)[keyof typeof ImplementationEffort];
export type ImplementationPlanGql = {
  estimatedDurationHours: Scalars['Int']['input'];
  implementationSteps: Array<Scalars['String']['input']>;
  monitoringPlan: Scalars['String']['input'];
  recommendationId: Scalars['String']['input'];
  rollbackPlan: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export const ImportJobStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
} as const;

export type ImportJobStatus = (typeof ImportJobStatus)[keyof typeof ImportJobStatus];
/** Input for importing a local dev chain */
export type ImportLocalDevChainInput = {
  /** Blake3 chain entries from local dev */
  chainEntries: Array<ChainEntryInput>;
  /** Audit: why is this being imported? */
  reason: Scalars['String']['input'];
  /** Session identifier for this import */
  sessionId: Scalars['String']['input'];
  /** Source environment: "local_dev", "staging", etc. */
  sourceEnvironment: Scalars['String']['input'];
};

export const ImportPrimitiveType = {
  ACTOR: 'ACTOR',
} as const;

export type ImportPrimitiveType = (typeof ImportPrimitiveType)[keyof typeof ImportPrimitiveType];
/** Import Result */
export type ImportResult = {
  __typename?: 'ImportResult';
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Success flag */
  success: Scalars['Boolean']['output'];
  /** Imported template ID (new Snowflake ID) */
  templateId: Scalars['String']['output'];
  /** Template version */
  templateVersion: Scalars['String']['output'];
  /** Tenant ID (always current tenant) */
  tenantId: Scalars['String']['output'];
  /** Warnings encountered during import */
  warnings: Array<Scalars['String']['output']>;
};

export type ImportRowResult = {
  __typename?: 'ImportRowResult';
  entityId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Row summary for audit display (name only — DRR-128 minimization) */
  inputSummary: Scalars['String']['output'];
  rowNum: Scalars['Int']['output'];
  /** "created" | "skipped" | "error" */
  status: Scalars['String']['output'];
};

/** Input for importing regulatory rules from YAML */
export type ImportRulesInput = {
  /** Whether to auto-approve rules above confidence threshold */
  allowAutoApprove?: Scalars['Boolean']['input'];
  /** Override confidence threshold for this import (default: 0.9) */
  confidenceThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Config content containing one or more rules */
  configContent: Scalars['String']['input'];
  /** Source identifier (e.g., "mn-dhs-evv-2025", "cms-conditions-of-participation") */
  sourceId: Scalars['String']['input'];
  /** Tenant ID for rule scoping */
  tenantId: Scalars['String']['input'];
};

/** Import Template Input */
export type ImportTemplateInput = {
  /** Overwrite if template with same name exists */
  overwriteExisting: Scalars['Boolean']['input'];
  /** Preserve original IDs (false = generate new Snowflake IDs) */
  preserveIds: Scalars['Boolean']['input'];
  /** Template JSON data */
  templateData: Scalars['JSON']['input'];
  /** Tenant ID (import to this tenant) */
  tenantId: Scalars['String']['input'];
};

/** Input for importing a wearable capture into Document Studio */
export type ImportWearableCaptureInput = {
  /** WearableCapture entity ID from the wearables subgraph */
  captureId: Scalars['String']['input'];
  /** Tenant ID (from auth context) */
  tenantId: Scalars['String']['input'];
};

/** Result of importing a wearable capture */
export type ImportWearableCaptureResult = {
  __typename?: 'ImportWearableCaptureResult';
  /** Created ChaosDocument ID — use this to track the document through the pipeline */
  documentId: Scalars['String']['output'];
  /** Initial document status (UPLOADED) */
  documentStatus: ChaosDocumentStatus | '%future added value';
  /** True if voice note transcription is pending (audio uploaded without pre-existing transcript) */
  transcriptionPending: Scalars['Boolean']['output'];
};

/** Legacy inbox task (deprecated - use GqlTask from task_api instead) */
export type InboxTask = {
  __typename?: 'InboxTask';
  assignees: Array<Scalars['String']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  dualControl?: Maybe<DualControl>;
  dueAt?: Maybe<Scalars['String']['output']>;
  entityRef: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jitr?: Maybe<JitRole>;
  kind: TaskKind | '%future added value';
  requiresMfa: Scalars['Boolean']['output'];
  status: TaskStatus | '%future added value';
  title: Scalars['String']['output'];
  watchers: Array<Scalars['String']['output']>;
};

/**
 * An incident report.
 * Used for safety concerns, injuries, falls, etc.
 */
export type Incident = {
  __typename?: 'Incident';
  /** Description of the incident */
  description: Scalars['String']['output'];
  /** Unique incident ID */
  id: Scalars['String']['output'];
  /** When the incident was reported */
  reportedAt: Scalars['DateTime']['output'];
  /** Who reported the incident */
  reportedBy?: Maybe<Scalars['String']['output']>;
  /** When the incident was resolved (if applicable) */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Severity level (e.g., "low", "medium", "high", "critical") */
  severity: Scalars['String']['output'];
  /** Status (e.g., "reported", "investigating", "resolved") */
  status: Scalars['String']['output'];
  /** Type of incident (e.g., "injury", "fall", "safety") */
  type: Scalars['String']['output'];
};

/** Input for the ingestDocument mutation. */
export type IngestDocumentInput = {
  documentText?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  sessionMessages?: InputMaybe<Scalars['JSON']['input']>;
};

/** Initiate Bulk Operation Input */
export type InitiateBulkOperationInput = {
  /** CSV content (base64 encoded or plain text) */
  csvContent: Scalars['String']['input'];
  /** Filename */
  filename: Scalars['String']['input'];
  /** Processing mode */
  processingMode: ProcessingModeInput;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for initiating a new exchange relationship */
export type InitiateExchangeRelationshipInput = {
  /** Purpose/reason for requesting exchange (audit trail) */
  purpose: Scalars['String']['input'];
  /** Existing tenant-relationships.yaml relationship ID (e.g., "rel-011") */
  relationshipId: Scalars['String']['input'];
};

export type InitiateStructuredImportInput = {
  /**
   * Raw CSV content.
   * Frontend: fetch the presigned URL for the uploaded document, download the content,
   * and pass it here. Max 100 rows (Phase 5); async queue in Phase 6.
   */
  csvContent: Scalars['String']['input'];
  /** Source ChaosDocument ID (for audit linkage) */
  documentId: Scalars['String']['input'];
  /** Actor ID of the user initiating the import */
  initiatedBy: Scalars['String']['input'];
  /** Primitive type to create (currently only ACTOR is supported) */
  primitiveType: ImportPrimitiveType | '%future added value';
  tenant: Scalars['String']['input'];
};

/** Guidance for a specific input field */
export type InputFieldGuidanceOutput = {
  __typename?: 'InputFieldGuidanceOutput';
  /** Example values */
  examples: Array<Scalars['String']['output']>;
  /** Field name */
  fieldName: Scalars['String']['output'];
  /** Helpful hint */
  hint: Scalars['String']['output'];
  /** Help for validation errors */
  validationHelp?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL output type for Instance primitive.
 *
 * 52 fields across 8 categories for complete workflow execution tracking.
 */
export type Instance = {
  __typename?: 'Instance';
  /** Accumulated results from completed tasks/steps */
  accumulatedResults: Scalars['JSON']['output'];
  /** Active event subscriptions (subscription IDs) */
  activeSubscriptions: Array<Scalars['String']['output']>;
  /**
   * Available transitions from the current state with guard evaluation.
   *
   * DRR-189: Reads the workflow YAML, finds transitions from `current_state`,
   * and evaluates guards to determine which transitions are actually available.
   *
   * Guard evaluation:
   * - `all_tasks_completed`: checks pending task count via TaskRepository
   * - `json_logic` guards: deferred (guard_passed=false, guard name shown)
   * - Empty guards `[]`: always pass (guard_passed=true)
   *
   * Returns empty when status is not Running.
   */
  availableTransitions: Array<GqlAvailableTransition>;
  /** Number of cache hits */
  cacheHits: Scalars['Int']['output'];
  /** Number of cache misses */
  cacheMisses: Scalars['Int']['output'];
  /** Timestamp when instance completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of completed tasks */
  completedTasks: Scalars['Int']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this instance.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  /**
   * Constellation config ID this lifecycle instance is coordinated by (DRR-140).
   * e.g., "constellation-care-service-plan"
   */
  constellationRef?: Maybe<Scalars['String']['output']>;
  /** Runtime context variables (mutable during execution) */
  contextVariables: Scalars['JSON']['output'];
  /** Total CPU time in milliseconds */
  cpuTimeMs?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when instance was created */
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this instance */
  createdByActor?: Maybe<ActorSummary>;
  /** Current milestone name */
  currentMilestone?: Maybe<Scalars['String']['output']>;
  /** Current workflow state/node name */
  currentState: Scalars['String']['output'];
  /** Number of database queries executed */
  dbQueries: Scalars['Int']['output'];
  /** Business deadline (SLA enforcement) */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Total execution duration in milliseconds */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Execution engine type */
  engineType: GqlExecutionEngine | '%future added value';
  /** Engine version string */
  engineVersion: Scalars['String']['output'];
  /** Machine-readable error code */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Detailed error information (stack trace, context) */
  errorDetails?: Maybe<Scalars['JSON']['output']>;
  /** Human-readable error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Estimated execution cost in USD */
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  /** Total number of events processed */
  eventCount: Scalars['Int']['output'];
  /** ID of task that caused failure */
  failedTaskId?: Maybe<Scalars['String']['output']>;
  /** Number of failed tasks */
  failedTasks: Scalars['Int']['output'];
  /** Whether formula participation was auto-detected */
  formulaAutoDetected: Scalars['Boolean']['output'];
  /** Formula number (1-6) if this instance participates in a formula */
  formulaNumber?: Maybe<Scalars['Int']['output']>;
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Input payload provided at instance creation */
  inputData: Scalars['JSON']['output'];
  /** Human-readable instance name */
  instanceName?: Maybe<Scalars['String']['output']>;
  /** Whether this instance is active (soft delete) */
  isActive: Scalars['Boolean']['output'];
  /** Timestamp of last event */
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID of last processed event */
  lastEventId?: Maybe<Scalars['String']['output']>;
  /** Type of last processed event */
  lastEventType?: Maybe<Scalars['String']['output']>;
  /** Maximum retry attempts */
  maxRetries: Scalars['Int']['output'];
  /** Peak memory usage in MB */
  memoryPeakMb?: Maybe<Scalars['Int']['output']>;
  /** Additional metadata (extensibility) */
  metadata: Scalars['JSON']['output'];
  /** List of completed milestone names */
  milestonesCompleted: Array<Scalars['String']['output']>;
  /** Final output data (set on completion) */
  outputData?: Maybe<Scalars['JSON']['output']>;
  /**
   * Parent instance ID (for append-only state chains)
   *
   * **Pure Append-Only Architecture**:
   * - None: This is the root instance (initial creation)
   * - Some(id): This instance is a state transition of parent instance
   *
   * Links to previous version for complete FSM audit trail.
   */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Timestamp when instance was paused */
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Previous workflow state (for rollback) */
  previousState?: Maybe<Scalars['String']['output']>;
  /** Queue priority (0-255, higher = more urgent) */
  priority: Scalars['Int']['output'];
  /** Overall progress percentage (0.0 - 100.0) */
  progressPercent: Scalars['Float']['output'];
  /** Number of recovery attempts made */
  recoveryAttempts: Scalars['Int']['output'];
  /** Timestamp when instance was resumed */
  resumedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Root instance ID (top of workflow tree for hierarchical workflows) */
  rootInstanceId: Scalars['String']['output'];
  /** Scheduled execution start time */
  scheduledStartTime?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when instance started executing */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current execution status */
  status: GqlInstanceStatus | '%future added value';
  /**
   * Sequential actor ID of the SUBJECT this instance belongs to (DRR-141, DRR-117).
   * Populated when workflow_definition_id = "wf-0-12-001" and a subject is known.
   * Enables listSubjectsWithLifecycle: subject → lifecycle phase in O(1).
   */
  subjectActorId?: Maybe<Scalars['String']['output']>;
  /** Subject actor resolved name (e.g., "Dorothy Johnson" instead of "2_3"). */
  subjectName?: Maybe<Scalars['String']['output']>;
  /** Categorization tags */
  tags: Array<Scalars['String']['output']>;
  /** Maximum execution time in milliseconds */
  timeoutMs?: Maybe<Scalars['Int']['output']>;
  /** Total number of tasks in workflow */
  totalTasks: Scalars['Int']['output'];
  /**
   * DRR-309: Journey tracks for multi-track workflows.
   *
   * Returns parallel fragment instances ("tracks") for this workflow instance.
   * Track data is stored in Valkey at `idx:instance:{id}:tracks` as a hash
   * where field = track_id and value = JSON with track metadata.
   *
   * Returns empty vec if:
   * - This is not a multi-track workflow
   * - Valkey is unavailable (graceful degradation)
   * - No tracks have been spawned yet
   */
  tracks: Array<GqlJourneyTrack>;
  /** Timestamp when instance was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Version number for optimistic locking */
  version: Scalars['Int']['output'];
  /** WorkflowDefinition this instance executes */
  workflowDefinitionId: Scalars['String']['output'];
  /** Resolved workflow definition description. */
  workflowDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Resolved workflow definition name (human-readable).
   * workflow_definition_id is already on every instance — this resolves the name at query time
   * via Valkey O(1) cache hit or DDB fallback. No data duplication.
   */
  workflowName: Scalars['String']['output'];
};

/**
 * A typed edge between journey/workflow instances.
 * Named GqlInstanceJourneyEdge to avoid collision with GqlJourneyEdge in forms_api (DRR-126).
 */
export type InstanceJourneyEdge = {
  __typename?: 'InstanceJourneyEdge';
  /** Created timestamp (ISO 8601) */
  createdAt: Scalars['String']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Edge type */
  edgeType: Scalars['String']['output'];
  /** Edge ID (composite: source:type:target) */
  id: Scalars['String']['output'];
  /** Source instance ID */
  sourceInstanceId: Scalars['String']['output'];
  /** Target instance ID */
  targetInstanceId: Scalars['String']['output'];
};

/** Input for instantiating a template */
export type InstantiateTemplateInput = {
  /** User ID creating the instance */
  createdBy: Scalars['String']['input'];
  /** Human-readable instance name */
  instanceName: Scalars['String']['input'];
  /** Parameter values (JSON map: parameter_name -> value) */
  parameterValues: Scalars['JSON']['input'];
  /** Template ID to instantiate */
  templateId: Scalars['String']['input'];
  /** Tenant ID for this instance */
  tenantId: Scalars['String']['input'];
};

/** A rule that couldn't evaluate because of missing context. */
export type InsufficientRule = {
  __typename?: 'InsufficientRule';
  missingFields: Array<Scalars['String']['output']>;
  requiredFields: Array<Scalars['String']['output']>;
  ruleId: Scalars['String']['output'];
};

/**
 * Result of classifying device-extracted text against FormSchema catalog.
 *
 * Returned by `classifyIntakeText` mutation to tell the frontend which
 * subgraph entity type the captured media maps to and which mutation to call.
 */
export type IntakeClassification = {
  __typename?: 'IntakeClassification';
  /** Confidence score (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** GraphQL mutation name for creating this entity */
  createMutation: Scalars['String']['output'];
  /** Human-readable display name */
  displayName: Scalars['String']['output'];
  /** Target entity type (e.g., "FhirPatient", "ErpInvoice") */
  entityType: Scalars['String']['output'];
  /** Field values extracted from the text */
  extractedFields: Array<ExtractedField>;
  /** Target subgraph (e.g., "fhir", "accounting") */
  subgraph: Scalars['String']['output'];
};

export type IntakeConversationMessage = {
  __typename?: 'IntakeConversationMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  role: MessageRole | '%future added value';
  tenant: Scalars['String']['output'];
};

/** A single extracted field mapped to a FormSchema field name (DRR-187). */
export type IntakeExtractedField = {
  __typename?: 'IntakeExtractedField';
  /** Confidence score (0.0–1.0). < 0.7 = yellow highlight, < 0.4 = left empty. */
  confidence: Scalars['Float']['output'];
  /** FormSchema field name (e.g., "name", "date_of_birth", "address"). */
  fieldName: Scalars['String']['output'];
  /** Extracted value (de-tokenized — real PII, resolved from Presidio token map). */
  value: Scalars['JSON']['output'];
};

/** Input for the intakeProcess mutation (DRR-187). */
export type IntakeProcessInput = {
  /** Document type hint from on-device classifier (e.g., "government_id", "insurance_card"). */
  documentTypeHint?: InputMaybe<Scalars['String']['input']>;
  /** Industry context for graph-aware suggestions. */
  industry?: Scalars['String']['input'];
  /** Intake session ID for multi-step tracking. Omit to start a new session. */
  intakeSessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pseudonymized text from on-device OCR + Presidio NER pipeline.
   * PII replaced with tokens like `<PERSON_1>`, `<DATE_OF_BIRTH_1>`.
   * Hub sidecar de-tokenizes after Claude responds.
   */
  mediaText?: InputMaybe<Scalars['String']['input']>;
  /** Natural language prompt or instruction (e.g., "Process this ID photo"). */
  prompt: Scalars['String']['input'];
  /** Previous session messages for multi-turn intake conversations. */
  sessionMessages?: InputMaybe<Scalars['JSON']['input']>;
};

/** Response from intake processing (DRR-187). */
export type IntakeProcessResponse = {
  __typename?: 'IntakeProcessResponse';
  /** Classified document type (e.g., "government_id", "insurance_card"). */
  documentType?: Maybe<Scalars['String']['output']>;
  /** Processing time in milliseconds. */
  processingTimeMs: Scalars['Float']['output'];
  /** Proposed actions for HITL confirmation. */
  proposals: Array<IntakeProposal>;
  /** Agent's text response (explanation, questions, next-step guidance). */
  response: Scalars['String']['output'];
  /** Conversation history — pass back as sessionMessages to continue. */
  sessionMessages: Scalars['JSON']['output'];
  /** Suggested next steps (e.g., "Take a photo of the insurance card"). */
  suggestedNextSteps: Array<Scalars['String']['output']>;
  /** Token usage. */
  usage: AgentUsageInfo;
};

/** A proposal from the intake agent for HITL confirmation (DRR-187). */
export type IntakeProposal = {
  __typename?: 'IntakeProposal';
  /** Overall confidence (0.0–1.0). */
  confidence: Scalars['Float']['output'];
  /** Pre-filled form fields mapped to FormSchema field names. */
  extractedFields: Array<IntakeExtractedField>;
  /** Proposal type: "create_actor", "create_fhir_patient", "launch_workflow". */
  proposalType: Scalars['String']['output'];
  /** Why the agent suggests this action. */
  reason: Scalars['String']['output'];
  /** Target entity type or workflow ID. */
  target: Scalars['String']['output'];
};

/** Intake target GraphQL enum (DRR-137, DRR-220) */
export const IntakeTarget = {
  ADVOCACY_AGGREGATE: 'ADVOCACY_AGGREGATE',
  BACKGROUND_CHECK: 'BACKGROUND_CHECK',
  CARE_VOCABULARY: 'CARE_VOCABULARY',
  CONSENT_FORM: 'CONSENT_FORM',
  DOCUMENT: 'DOCUMENT',
  EMPLOYEE_DOCUMENT: 'EMPLOYEE_DOCUMENT',
  EVIDENCE_PACKAGE: 'EVIDENCE_PACKAGE',
  FINANCIAL_DOCUMENT: 'FINANCIAL_DOCUMENT',
  FORM_TEMPLATE: 'FORM_TEMPLATE',
  INSURANCE_DOCUMENT: 'INSURANCE_DOCUMENT',
  LEGISLATION_FEEDBACK: 'LEGISLATION_FEEDBACK',
  LICENSE_CREDENTIAL: 'LICENSE_CREDENTIAL',
  REGULATORY_DOCUMENT: 'REGULATORY_DOCUMENT',
  STRUCTURED_IMPORT: 'STRUCTURED_IMPORT',
  SUBJECT_INTAKE: 'SUBJECT_INTAKE',
  TASK_GROUP_DEFINITION: 'TASK_GROUP_DEFINITION',
  TRAINING_CERTIFICATE: 'TRAINING_CERTIFICATE',
  VENDOR_CONTRACT: 'VENDOR_CONTRACT',
} as const;

export type IntakeTarget = (typeof IntakeTarget)[keyof typeof IntakeTarget];
/**
 * Integration primitive - external system connectivity
 *
 * All fields match the backend Integration struct 1:1.
 * Complex nested types are serialized as JSON.
 */
export type Integration = {
  __typename?: 'Integration';
  alertNotificationIds: Array<Scalars['String']['output']>;
  asyncQueueId?: Maybe<Scalars['String']['output']>;
  /** Auth configuration as JSON (tagged union) */
  authConfig: Scalars['JSON']['output'];
  authScope: Array<Scalars['String']['output']>;
  authType: AuthenticationType | '%future added value';
  avgResponseTimeMs: Scalars['Float']['output'];
  baseUrl: Scalars['String']['output'];
  checkpointOnFailure: Scalars['Boolean']['output'];
  circuitBreakerEnabled: Scalars['Boolean']['output'];
  circuitBreakerHalfOpenMaxCalls: Scalars['Int']['output'];
  circuitBreakerResetSeconds: Scalars['Int']['output'];
  circuitBreakerState: CircuitBreakerState | '%future added value';
  circuitBreakerThreshold: Scalars['Int']['output'];
  clientCertificateRef?: Maybe<Scalars['String']['output']>;
  /** Compressed ID format (lazy-loaded from cache/DynamoDB) */
  compressedId?: Maybe<Scalars['String']['output']>;
  compression: Scalars['Boolean']['output'];
  connectTimeoutMs: Scalars['Int']['output'];
  consecutiveFailures: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  credentialRotationDays: Scalars['Int']['output'];
  credentialVaultRef?: Maybe<Scalars['String']['output']>;
  currentHealthStatus: IntegrationHealthStatus | '%future added value';
  currentRateLimitRemaining?: Maybe<Scalars['Int']['output']>;
  /** Custom HTTP headers as JSON (HashMap<String, String>) */
  customHeaders: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  dnsCacheTtlSeconds: Scalars['Int']['output'];
  /** Endpoint configs as JSON (HashMap<String, EndpointConfig>) */
  endpoints: Scalars['JSON']['output'];
  eventStreamId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  healthCheckEnabled: Scalars['Boolean']['output'];
  healthCheckEndpoint?: Maybe<Scalars['String']['output']>;
  healthCheckExpectedStatus: Scalars['Int']['output'];
  healthCheckIntervalSeconds: Scalars['Int']['output'];
  healthCheckMethod: HttpMethod | '%future added value';
  healthCheckTimeoutMs: Scalars['Int']['output'];
  httpVersion: HttpVersion | '%future added value';
  integrationCode: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  integrationName: Scalars['String']['output'];
  integrationType: IntegrationType | '%future added value';
  isActive: Scalars['Boolean']['output'];
  keepAlive: Scalars['Boolean']['output'];
  lastCircuitBreakerReset?: Maybe<Scalars['DateTime']['output']>;
  lastCircuitBreakerTrip?: Maybe<Scalars['DateTime']['output']>;
  lastCredentialRotation?: Maybe<Scalars['DateTime']['output']>;
  lastHealthCheck?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessfulCall?: Maybe<Scalars['DateTime']['output']>;
  managedResourceIds: Array<Scalars['String']['output']>;
  maxConnections: Scalars['Int']['output'];
  maxRetries: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  metricsAnalyticsId?: Maybe<Scalars['String']['output']>;
  originalId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  protocol: Protocol | '%future added value';
  /** Proxy configuration as JSON */
  proxyConfig?: Maybe<Scalars['JSON']['output']>;
  rateLimitCurrentTokens: Scalars['Float']['output'];
  rateLimitEnabled: Scalars['Boolean']['output'];
  rateLimitLastRefill?: Maybe<Scalars['DateTime']['output']>;
  rateLimitQueueMaxSize?: Maybe<Scalars['Int']['output']>;
  rateLimitRequestsPerWindow: Scalars['Int']['output'];
  rateLimitResetAt?: Maybe<Scalars['DateTime']['output']>;
  rateLimitStrategy: RateLimitStrategy | '%future added value';
  rateLimitWindowSeconds: Scalars['Int']['output'];
  readTimeoutMs: Scalars['Int']['output'];
  retryBackoffType: BackoffType | '%future added value';
  retryEnabled: Scalars['Boolean']['output'];
  retryInitialDelayMs: Scalars['Int']['output'];
  retryMaxDelayMs: Scalars['Int']['output'];
  retryMultiplier: Scalars['Float']['output'];
  retryOnStatusCodes: Array<Scalars['Int']['output']>;
  rotateCredentials: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  syncScheduleId?: Maybe<Scalars['String']['output']>;
  timeoutMs: Scalars['Int']['output'];
  /** TLS/SSL configuration as JSON */
  tlsConfig: Scalars['JSON']['output'];
  tokenRefreshEnabled: Scalars['Boolean']['output'];
  tokenRefreshThresholdSeconds: Scalars['Int']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uptimePercentage: Scalars['Float']['output'];
  version: Scalars['Int']['output'];
  webhookEnabled: Scalars['Boolean']['output'];
  webhookEvents: Array<Scalars['String']['output']>;
  webhookMaxPayloadSizeBytes: Scalars['String']['output'];
  webhookRetryFailed: Scalars['Boolean']['output'];
  webhookSecret?: Maybe<Scalars['String']['output']>;
  webhookSignatureAlgorithm: SignatureAlgorithm | '%future added value';
  webhookSignatureHeader: Scalars['String']['output'];
};

export type IntegrationAnomaly = {
  __typename?: 'IntegrationAnomaly';
  acknowledged: Scalars['Boolean']['output'];
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy?: Maybe<Scalars['String']['output']>;
  actual?: Maybe<Scalars['String']['output']>;
  anomalyId: Scalars['ID']['output'];
  anomalyType: IntegrationAnomalyType | '%future added value';
  description: Scalars['String']['output'];
  detectedAt: Scalars['DateTime']['output'];
  expected?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  recommendedAction: Scalars['String']['output'];
  referenceDate?: Maybe<Scalars['NaiveDate']['output']>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  ruleId: Scalars['String']['output'];
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variance?: Maybe<Scalars['Float']['output']>;
  workerId?: Maybe<Scalars['String']['output']>;
  workerName?: Maybe<Scalars['String']['output']>;
};

export type IntegrationAnomalyAckResult = {
  __typename?: 'IntegrationAnomalyAckResult';
  acknowledged: Scalars['Boolean']['output'];
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy?: Maybe<Scalars['String']['output']>;
  anomalyId: Scalars['ID']['output'];
};

export type IntegrationAnomalyFilter = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  anomalyType?: InputMaybe<IntegrationAnomalyType | '%future added value'>;
  endDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  tenantId: Scalars['String']['input'];
};

export type IntegrationAnomalyList = {
  __typename?: 'IntegrationAnomalyList';
  items: Array<IntegrationAnomaly>;
  totalCount: Scalars['Int']['output'];
};

export type IntegrationAnomalyResolveResult = {
  __typename?: 'IntegrationAnomalyResolveResult';
  anomalyId: Scalars['ID']['output'];
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export const IntegrationAnomalyType = {
  AM_PM_FLIP: 'AM_PM_FLIP',
  APPROACHING_LIMIT: 'APPROACHING_LIMIT',
  BUDGET_OVERRUN: 'BUDGET_OVERRUN',
  CERTIFICATION_EXPIRED: 'CERTIFICATION_EXPIRED',
  CONFLICT: 'CONFLICT',
  CUSTOM: 'CUSTOM',
  DEVIATION_FROM_EXPECTED: 'DEVIATION_FROM_EXPECTED',
  DUPLICATE: 'DUPLICATE',
  DURATION_TOO_LONG: 'DURATION_TOO_LONG',
  DURATION_TOO_SHORT: 'DURATION_TOO_SHORT',
  EXCEEDS_DAILY_LIMIT: 'EXCEEDS_DAILY_LIMIT',
  EXCEEDS_TOTAL_ALLOCATION: 'EXCEEDS_TOTAL_ALLOCATION',
  EXCEEDS_WEEKLY_LIMIT: 'EXCEEDS_WEEKLY_LIMIT',
  INCOMPLETE_DATA: 'INCOMPLETE_DATA',
  MISSING_APPROVAL: 'MISSING_APPROVAL',
  MISSING_RECORD: 'MISSING_RECORD',
  OUTSIDE_NORMAL_HOURS: 'OUTSIDE_NORMAL_HOURS',
  PAYMENT_DISCREPANCY: 'PAYMENT_DISCREPANCY',
  RATE_MISMATCH: 'RATE_MISMATCH',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
} as const;

export type IntegrationAnomalyType =
  (typeof IntegrationAnomalyType)[keyof typeof IntegrationAnomalyType];
export type IntegrationApiAuditEvent = {
  __typename?: 'IntegrationApiAuditEvent';
  accountId: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  endpoint: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  eventType: IntegrationApiAuditEventType | '%future added value';
  method: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  recordCount?: Maybe<Scalars['Int']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export const IntegrationApiAuditEventType = {
  API_ERROR: 'API_ERROR',
  AUTH_ATTEMPT: 'AUTH_ATTEMPT',
  AUTH_FAILURE: 'AUTH_FAILURE',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  DATA_EXTRACT: 'DATA_EXTRACT',
  DATA_EXTRACT_FAILED: 'DATA_EXTRACT_FAILED',
  RATE_LIMITED: 'RATE_LIMITED',
  SYNC_COMPLETED: 'SYNC_COMPLETED',
  SYNC_FAILED: 'SYNC_FAILED',
  SYNC_STARTED: 'SYNC_STARTED',
  TOKEN_REFRESH: 'TOKEN_REFRESH',
} as const;

export type IntegrationApiAuditEventType =
  (typeof IntegrationApiAuditEventType)[keyof typeof IntegrationApiAuditEventType];
/**
 * Integration Archive Result (FERP Append-Only Architecture)
 *
 * Returned by `archiveIntegration` mutation. Contains full audit metadata
 * for compliance (HIPAA, SOX, SOC2).
 *
 * FERP Principle: No DELETE operations - use archive instead.
 */
export type IntegrationArchiveResult = {
  __typename?: 'IntegrationArchiveResult';
  /** Timestamp when the integration was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** User ID who performed the archive */
  archivedBy: Scalars['String']['output'];
  /** Integration ID that was archived */
  integrationId: Scalars['String']['output'];
  /** Integration name that was archived */
  integrationName: Scalars['String']['output'];
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Mandatory reason for archiving (audit compliance) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type IntegrationAuditFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<IntegrationApiAuditEventType | '%future added value'>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId: Scalars['String']['input'];
};

export type IntegrationBurnRateFilter = {
  asOfDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<IntegrationBurnStatus | '%future added value'>>;
  tenantId: Scalars['String']['input'];
};

export type IntegrationBurnRateReport = {
  __typename?: 'IntegrationBurnRateReport';
  agreementType: Scalars['String']['output'];
  asOfDate: Scalars['NaiveDate']['output'];
  burnRateRatio: Scalars['Float']['output'];
  dailyAvgUsage: Scalars['Float']['output'];
  dailyLimit?: Maybe<Scalars['Float']['output']>;
  daysElapsed: Scalars['Int']['output'];
  daysRemaining: Scalars['Int']['output'];
  endDate: Scalars['NaiveDate']['output'];
  externalId: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  narrative: Scalars['String']['output'];
  payer: Scalars['String']['output'];
  periodProgress: Scalars['Float']['output'];
  platform: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  projectedExhaustionDate?: Maybe<Scalars['NaiveDate']['output']>;
  projectedUnusedAtEnd?: Maybe<Scalars['Float']['output']>;
  quotaType: IntegrationQuotaType | '%future added value';
  recommendedAction: Scalars['String']['output'];
  remaining: Scalars['Float']['output'];
  reportId: Scalars['ID']['output'];
  startDate: Scalars['NaiveDate']['output'];
  status: IntegrationBurnStatus | '%future added value';
  subjectExternalId: Scalars['String']['output'];
  subjectName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAuthorized: Scalars['Float']['output'];
  totalDays: Scalars['Int']['output'];
  unitLabel: Scalars['String']['output'];
  used: Scalars['Float']['output'];
  utilizationRate: Scalars['Float']['output'];
  weeklyLimit?: Maybe<Scalars['Float']['output']>;
};

export const IntegrationBurnStatus = {
  BURNING_FAST: 'BURNING_FAST',
  CRITICAL: 'CRITICAL',
  EXCEEDED: 'EXCEEDED',
  EXHAUSTED: 'EXHAUSTED',
  EXPIRING_SOON: 'EXPIRING_SOON',
  ON_TRACK: 'ON_TRACK',
  UNDER_UTILIZING: 'UNDER_UTILIZING',
} as const;

export type IntegrationBurnStatus =
  (typeof IntegrationBurnStatus)[keyof typeof IntegrationBurnStatus];
/** Paginated connection for integrations */
export type IntegrationConnection = {
  __typename?: 'IntegrationConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Integration>;
  totalCount: Scalars['Int']['output'];
};

/** Connection test result */
export type IntegrationConnectionTestResult = {
  __typename?: 'IntegrationConnectionTestResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
  responseTimeMs: Scalars['Float']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  testedAt: Scalars['DateTime']['output'];
};

/** Health check result */
export type IntegrationHealthCheckResult = {
  __typename?: 'IntegrationHealthCheckResult';
  checkedAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
  responseTimeMs: Scalars['Float']['output'];
  status: IntegrationHealthStatus | '%future added value';
};

/** Health status of integration */
export const IntegrationHealthStatus = {
  DEGRADED: 'DEGRADED',
  HEALTHY: 'HEALTHY',
  UNHEALTHY: 'UNHEALTHY',
  UNKNOWN: 'UNKNOWN',
} as const;

export type IntegrationHealthStatus =
  (typeof IntegrationHealthStatus)[keyof typeof IntegrationHealthStatus];
export const IntegrationNotificationChannel = {
  EMAIL: 'EMAIL',
  IN_APP: 'IN_APP',
  PUSH: 'PUSH',
  SMS: 'SMS',
} as const;

export type IntegrationNotificationChannel =
  (typeof IntegrationNotificationChannel)[keyof typeof IntegrationNotificationChannel];
export type IntegrationNotificationInput = {
  channel: IntegrationNotificationChannel | '%future added value';
  notificationType: Scalars['String']['input'];
  relatedAnomalyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workerId: Scalars['String']['input'];
};

export type IntegrationNotificationResult = {
  __typename?: 'IntegrationNotificationResult';
  channel: IntegrationNotificationChannel | '%future added value';
  notificationId: Scalars['ID']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
};

export const IntegrationQuotaType = {
  COUNT: 'COUNT',
  CURRENCY: 'CURRENCY',
  CUSTOM: 'CUSTOM',
  HOURS: 'HOURS',
  UNITS: 'UNITS',
} as const;

export type IntegrationQuotaType = (typeof IntegrationQuotaType)[keyof typeof IntegrationQuotaType];
export type IntegrationRecordCount = {
  __typename?: 'IntegrationRecordCount';
  count: Scalars['Int']['output'];
  recordType: Scalars['String']['output'];
};

export type IntegrationSyncInput = {
  endDate: Scalars['NaiveDate']['input'];
  platform: Scalars['String']['input'];
  startDate: Scalars['NaiveDate']['input'];
  tenantId: Scalars['String']['input'];
};

export type IntegrationSyncMetadata = {
  __typename?: 'IntegrationSyncMetadata';
  accountId: Scalars['String']['output'];
  anomalyCount: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  dateRangeEnd?: Maybe<Scalars['NaiveDate']['output']>;
  dateRangeStart?: Maybe<Scalars['NaiveDate']['output']>;
  errors: Array<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  recordCounts: Array<IntegrationRecordCount>;
  startedAt: Scalars['DateTime']['output'];
  status: IntegrationSyncStatus | '%future added value';
  syncId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
};

export type IntegrationSyncResult = {
  __typename?: 'IntegrationSyncResult';
  message: Scalars['String']['output'];
  status: IntegrationSyncStatus | '%future added value';
  syncId: Scalars['ID']['output'];
};

export const IntegrationSyncStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PARTIAL_SUCCESS: 'PARTIAL_SUCCESS',
  RUNNING: 'RUNNING',
} as const;

export type IntegrationSyncStatus =
  (typeof IntegrationSyncStatus)[keyof typeof IntegrationSyncStatus];
/** Type of external integration connection */
export const IntegrationType = {
  /** DRR-166: Browser portal automation (Playwright headless) */
  BROWSER_PORTAL: 'BROWSER_PORTAL',
  DATABASE: 'DATABASE',
  EVENT_STREAM: 'EVENT_STREAM',
  GRAPHQL: 'GRAPHQL',
  GRPC: 'GRPC',
  MESSAGE_QUEUE: 'MESSAGE_QUEUE',
  REST_API: 'REST_API',
  SFTP: 'SFTP',
  SOAP_API: 'SOAP_API',
  WEBHOOK_INBOUND: 'WEBHOOK_INBOUND',
  WEBHOOK_OUTBOUND: 'WEBHOOK_OUTBOUND',
} as const;

export type IntegrationType = (typeof IntegrationType)[keyof typeof IntegrationType];
export type IntegrationWorkerContact = {
  __typename?: 'IntegrationWorkerContact';
  highestPriority: Scalars['Int']['output'];
  issueCount: Scalars['Int']['output'];
  issues: Array<IntegrationWorkerIssue>;
  workerEmail?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['String']['output'];
  workerName: Scalars['String']['output'];
  workerPhone?: Maybe<Scalars['String']['output']>;
};

export type IntegrationWorkerContactFilter = {
  issueType?: InputMaybe<Scalars['String']['input']>;
  minPriority?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type IntegrationWorkerIssue = {
  __typename?: 'IntegrationWorkerIssue';
  anomalyId: Scalars['ID']['output'];
  anomalyType: IntegrationAnomalyType | '%future added value';
  description: Scalars['String']['output'];
  referenceDate?: Maybe<Scalars['NaiveDate']['output']>;
  subjectName: Scalars['String']['output'];
};

/** A constraint/classification for controlled items. */
export type InventoryConstraint = {
  __typename?: 'InventoryConstraint';
  /** Constraint identifier */
  constraintId: Scalars['String']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name */
  name: Scalars['String']['output'];
  /** Regulatory reference (statute, rule) */
  regulatoryReference?: Maybe<Scalars['String']['output']>;
  /** Required number of witnesses for verification */
  requiredWitnesses: Scalars['Int']['output'];
  /** Whether dual signature is required */
  requiresDualSignature: Scalars['Boolean']['output'];
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Acceptable variance tolerance */
  varianceTolerance: Scalars['Float']['output'];
  /** Required verification frequency (seconds) */
  verificationFrequencySeconds?: Maybe<Scalars['Int']['output']>;
};

/** Issue severity for preflight validation */
export const IssueSeverity = {
  /** Blocks activation - must fix */
  BLOCKING: 'BLOCKING',
  /** Info - nice to have */
  INFO: 'INFO',
  /** Warning - should fix */
  WARNING: 'WARNING',
} as const;

export type IssueSeverity = (typeof IssueSeverity)[keyof typeof IssueSeverity];
/** JIT Access Request (GraphQL output) */
export type JitAccessRequest = {
  __typename?: 'JITAccessRequest';
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedBy: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  emergency: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  justification: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  rejectedAt?: Maybe<Scalars['String']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  requestedRole: Scalars['String']['output'];
  requestedRoleDisplayName?: Maybe<Scalars['String']['output']>;
  requesterEmail: Scalars['String']['output'];
  requesterId: Scalars['String']['output'];
  requesterRole: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** Input for requesting JIT access */
export type JitAccessRequestInput = {
  durationMinutes: Scalars['Int']['input'];
  emergency?: Scalars['Boolean']['input'];
  justification: Scalars['String']['input'];
  requestedRole: Scalars['String']['input'];
  requesterEmail: Scalars['String']['input'];
  requesterId: Scalars['String']['input'];
  requesterRole: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** JIT Active Session (GraphQL output) */
export type JitActiveSession = {
  __typename?: 'JITActiveSession';
  expiresAt: Scalars['String']['output'];
  extensionCount: Scalars['Int']['output'];
  grantedAt: Scalars['String']['output'];
  lastActivity: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  originalDurationMinutes: Scalars['Int']['output'];
  remainingMinutes: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
  revocationReason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['String']['output']>;
  revokedBy?: Maybe<Scalars['String']['output']>;
  roleDisplayName?: Maybe<Scalars['String']['output']>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** JIT Policy (GraphQL output) */
export type JitPolicy = {
  __typename?: 'JITPolicy';
  allowedRoles: Array<Scalars['String']['output']>;
  autoApprovalEnabled: Scalars['Boolean']['output'];
  autoApprovalMaxDurationMinutes: Scalars['Int']['output'];
  autoApprovalRoles: Array<Scalars['String']['output']>;
  defaultMaxDurationMinutes: Scalars['Int']['output'];
  emergencyAccessEnabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  extensionEnabled: Scalars['Boolean']['output'];
  maxExtensionCount: Scalars['Int']['output'];
  policyId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** Filter for listing JIT requests */
export type JitRequestFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  requesterId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** JIT Statistics (GraphQL output) */
export type JitStatistics = {
  __typename?: 'JITStatistics';
  activeSessions: Scalars['Int']['output'];
  approvedRequests: Scalars['Int']['output'];
  autoApprovedRequests: Scalars['Int']['output'];
  averageApprovalTimeMinutes: Scalars['Float']['output'];
  averageSessionDurationMinutes: Scalars['Float']['output'];
  expiredSessions: Scalars['Int']['output'];
  pendingRequests: Scalars['Int']['output'];
  rejectedRequests: Scalars['Int']['output'];
  revokedSessions: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  totalRequests: Scalars['Int']['output'];
};

export type JitGrant = {
  __typename?: 'JitGrant';
  expiresAt: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type JitRole = {
  __typename?: 'JitRole';
  role: Scalars['String']['output'];
  ttlMins: Scalars['Int']['output'];
};

/** Result of creating a journey audit event. */
export type JourneyAuditEvent = {
  __typename?: 'JourneyAuditEvent';
  /** Event type */
  eventType: Scalars['String']['output'];
  /** Audit event ID */
  id: Scalars['String']['output'];
  /** Instance ID */
  instanceId: Scalars['String']['output'];
  /** Reason provided */
  reason: Scalars['String']['output'];
  /** ID of the review task if created */
  reviewTaskId?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the event */
  timestamp: Scalars['String']['output'];
  /** User who triggered the event */
  triggeredBy: Scalars['String']['output'];
};

/** Result of requesting a KBA challenge. */
export type KbaChallengeResult = {
  __typename?: 'KbaChallengeResult';
  /** Verification attempts remaining before lockout. */
  attemptsRemaining: Scalars['Int']['output'];
  /** Masked identifier (e.g., "j****@example.com"). */
  maskedIdentifier: Scalars['String']['output'];
  /** Human-readable message. */
  message: Scalars['String']['output'];
  /** Method used: "email_code" or "sms_code". */
  method: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  /** Seconds until the code expires. */
  timeoutSecs: Scalars['Int']['output'];
};

/** KBA configuration input for ceremony creation. */
export type KbaConfigInput = {
  /** Maximum verification attempts before lockout. Default: 3. */
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  /** Verification method: EMAIL_CODE or SMS_CODE. Default: EMAIL_CODE. */
  method?: InputMaybe<KbaMethodInput | '%future added value'>;
  /** Challenge code timeout in seconds. Default: 600 (10 minutes). */
  timeoutSecs?: InputMaybe<Scalars['Int']['input']>;
};

/** KBA verification method. */
export const KbaMethodInput = {
  EMAIL_CODE: 'EMAIL_CODE',
  SMS_CODE: 'SMS_CODE',
} as const;

export type KbaMethodInput = (typeof KbaMethodInput)[keyof typeof KbaMethodInput];
/** Result of verifying a KBA code. */
export type KbaVerificationResult = {
  __typename?: 'KbaVerificationResult';
  /** Human-readable message. */
  message: Scalars['String']['output'];
  /** Next action: "proceed_to_sign", "try_again", or "contact_support". */
  nextAction: Scalars['String']['output'];
  /** Attempts remaining (0 if locked out). */
  remainingAttempts: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Kind capabilities */
export type KindCapabilities = {
  __typename?: 'KindCapabilities';
  bulkOperations: Scalars['Boolean']['output'];
  collaborativeEditing: Scalars['Boolean']['output'];
  importExport: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  offlineSupport: Scalars['Boolean']['output'];
  realTimeUpdates: Scalars['Boolean']['output'];
  uiSchema: Scalars['Boolean']['output'];
  validation: Scalars['Boolean']['output'];
  versioning: Scalars['Boolean']['output'];
  workflowEnabled: Scalars['Boolean']['output'];
};

/** LLM fix recommendation output */
export type LlmFixRecommendation = {
  __typename?: 'LLMFixRecommendation';
  /** Applied timestamp (if accepted) */
  appliedAt?: Maybe<Scalars['String']['output']>;
  /** Applied by user ID (if accepted) */
  appliedBy?: Maybe<Scalars['String']['output']>;
  /** Overall confidence */
  confidence: Scalars['Float']['output'];
  /** Created timestamp */
  createdAt: Scalars['String']['output'];
  /** Created by user ID */
  createdBy: Scalars['String']['output'];
  /** Unified diff */
  diff: Scalars['String']['output'];
  /** LLM model used */
  llmModel: Scalars['String']['output'];
  /** Original template ID */
  originalTemplateId: Scalars['String']['output'];
  /** AI reasoning */
  reasoning: Scalars['String']['output'];
  /** Recommendation ID */
  recommendationId: Scalars['String']['output'];
  /** Status (pending | accepted | rejected) */
  status: Scalars['String']['output'];
  /** Suggested fixes */
  suggestedFixes: Array<TemplateFix>;
};

/** Ledger account output */
export type LedgerAccount = {
  __typename?: 'LedgerAccount';
  accountId: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  balanceCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  pointsBalance: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  tenantNum: Scalars['Int']['output'];
};

/** Chain status output */
export type LedgerChainStatus = {
  __typename?: 'LedgerChainStatus';
  entryCount: Scalars['Int']['output'];
  genesisHash: Scalars['String']['output'];
  headHash: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

/** Chain verification result output */
export type LedgerChainVerificationResult = {
  __typename?: 'LedgerChainVerificationResult';
  entryCount: Scalars['Int']['output'];
  firstInvalidAt?: Maybe<Scalars['Int']['output']>;
  genesisHash: Scalars['String']['output'];
  headHash: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

/** Ledger settlement output */
export type LedgerSettlement = {
  __typename?: 'LedgerSettlement';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  hash: Scalars['String']['output'];
  period: Scalars['String']['output'];
  reconciled?: Maybe<Scalars['Boolean']['output']>;
  serviceCompanyName?: Maybe<Scalars['String']['output']>;
  serviceCompanyTenantNum: Scalars['Int']['output'];
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  settlementId: Scalars['String']['output'];
  status: LedgerSettlementStatus | '%future added value';
  transactionCount: Scalars['Int']['output'];
};

/** Settlement status for GraphQL schema */
export const LedgerSettlementStatus = {
  ACCEPTED: 'ACCEPTED',
  DISPUTED: 'DISPUTED',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  PROPOSED: 'PROPOSED',
  SETTLED: 'SETTLED',
} as const;

export type LedgerSettlementStatus =
  (typeof LedgerSettlementStatus)[keyof typeof LedgerSettlementStatus];
/** Ledger token output */
export type LedgerToken = {
  __typename?: 'LedgerToken';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rulesRef?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
  tokenType: LedgerTokenType | '%future added value';
};

/** Token type for GraphQL schema */
export const LedgerTokenType = {
  PAYMENT: 'PAYMENT',
  SECURITY: 'SECURITY',
  SOCIAL: 'SOCIAL',
} as const;

export type LedgerTokenType = (typeof LedgerTokenType)[keyof typeof LedgerTokenType];
/** Ledger transfer output */
export type LedgerTransfer = {
  __typename?: 'LedgerTransfer';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  fromActorId?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  moovTransferId?: Maybe<Scalars['String']['output']>;
  serviceCategory?: Maybe<Scalars['String']['output']>;
  socialSubtype?: Maybe<Scalars['String']['output']>;
  status: LedgerTransferStatus | '%future added value';
  toActorId?: Maybe<Scalars['String']['output']>;
  tokenType: LedgerTokenType | '%future added value';
  transferId: Scalars['String']['output'];
};

/** Transfer status for GraphQL schema */
export const LedgerTransferStatus = {
  CONFIRMED: 'CONFIRMED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  REVERSED: 'REVERSED',
} as const;

export type LedgerTransferStatus = (typeof LedgerTransferStatus)[keyof typeof LedgerTransferStatus];
/**
 * A file from a tenant's legacy archive (pre-FERP system data).
 *
 * Access is gated by ClamAV scan status:
 * - CLEAN/MACRO_DETECTED: `view_url` and `download_url` are populated
 * - INFECTED/UNSCANNED: URLs are null, only metadata visible
 *
 * Warning text comes from backend, not frontend (DRR-055).
 */
export type LegacyArchiveFile = {
  __typename?: 'LegacyArchiveFile';
  /** Whether the tenant can download this file */
  canDownload: Scalars['Boolean']['output'];
  /** Whether the tenant can view this file in-browser */
  canView: Scalars['Boolean']['output'];
  /** ClamAV version used for scan */
  clamavVersion?: Maybe<Scalars['String']['output']>;
  /** MIME content type */
  contentType: Scalars['String']['output'];
  /**
   * CloudFront signed URL for download (Content-Disposition: attachment).
   * Null if INFECTED or UNSCANNED.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Unique file identifier (blake3 hash of content) */
  fileId: Scalars['String']['output'];
  /** Original filename from legacy system */
  fileName: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** When the file was scanned (null if UNSCANNED) */
  scanDate?: Maybe<Scalars['DateTime']['output']>;
  /** ClamAV scan result */
  scanStatus: ScanStatus | '%future added value';
  /**
   * CloudFront signed URL for in-browser viewing (Content-Disposition: inline).
   * Null if INFECTED or UNSCANNED.
   */
  viewUrl?: Maybe<Scalars['String']['output']>;
  /** Download warning severity level */
  warningLevel: WarningLevel | '%future added value';
  /**
   * Backend-generated warning message text for the download dialog.
   * Frontend renders this directly — no hardcoded warning strings.
   */
  warningMessage?: Maybe<Scalars['String']['output']>;
};

/** GraphQL type for PolicyAction. */
export type LegacyPolicyAction = {
  __typename?: 'LegacyPolicyAction';
  /** Action type (approve, reject, notify, etc.) */
  actionType: Scalars['String']['output'];
  /** Action parameters (JSON) */
  params: Scalars['String']['output'];
};

/** Input for policy action. */
export type LegacyPolicyActionInput = {
  /** Action type */
  actionType: Scalars['String']['input'];
  /** Action parameters (JSON string) */
  params: Scalars['String']['input'];
};

/** GraphQL type for PolicyCondition. */
export type LegacyPolicyCondition = {
  __typename?: 'LegacyPolicyCondition';
  /** Field path (e.g. "confidence.overall") */
  field: Scalars['String']['output'];
  /** Operator (equals, greater_than, etc.) */
  operator: Scalars['String']['output'];
  /** Value to compare against (JSON) */
  value: Scalars['String']['output'];
};

/** Input for policy condition. */
export type LegacyPolicyConditionInput = {
  /** Field path */
  field: Scalars['String']['input'];
  /** Operator */
  operator: Scalars['String']['input'];
  /** Value (JSON string) */
  value: Scalars['String']['input'];
};

/** GraphQL type for PolicyRule. */
export type LegacyPolicyRule = {
  __typename?: 'LegacyPolicyRule';
  /** Actions to execute when conditions met */
  actions: Array<LegacyPolicyAction>;
  /** Conditions (AND logic) */
  conditions: Array<LegacyPolicyCondition>;
  /** Rule name */
  name: Scalars['String']['output'];
  /** Priority (higher = evaluated first) */
  priority: Scalars['Int']['output'];
  /** Rule ID */
  ruleId: Scalars['String']['output'];
};

/**
 * Input for submitting T1 legislation feedback (DRR-148).
 *
 * ## NEVER ALLOW
 *
 * Do NOT add `tenant_id`, `actor_id`, narrative, or any identifying field here.
 * Values are validated against enum variants before storage.
 */
export type LegislationFeedbackInput = {
  /** Impact severity — must be one of: minor, moderate, significant, critical */
  impactSeverity: Scalars['String']['input'];
  /** Impact area — must be one of: financial, operational, safety, staffing, other */
  impactType: Scalars['String']['input'];
  /** RuleSet / regulation this feedback applies to (e.g., "rs-4-1-005") */
  rulesetId: Scalars['String']['input'];
};

/**
 * A single rollout phase within a multi-phase legislation.
 *
 * Empty vec on `GqlRuleSet.phases` for single-phase rulesets (the default
 * for all existing rulesets — Gate 16 via `#[serde(default)]`).
 */
export type LegislationPhase = {
  __typename?: 'LegislationPhase';
  /** Date this phase takes effect (ISO 8601) */
  effectiveDate: Scalars['String']['output'];
  /** Human-readable phase name (e.g., "Staffing ratio requirements") */
  name: Scalars['String']['output'];
  /** Phase identifier (e.g., "phase_1") */
  phaseId: Scalars['String']['output'];
  /** Statute sections covered by this phase */
  sections: Array<Scalars['String']['output']>;
};

/** A step in a lens onboarding checklist. */
export type LensChecklistStep = {
  __typename?: 'LensChecklistStep';
  /** Which constellation ring this step applies to */
  ring: Scalars['String']['output'];
  /** Status field to track completion */
  statusField: Scalars['String']['output'];
  /** Human-readable step description */
  step: Scalars['String']['output'];
};

/** Result of comparing lens evaluations across multiple roles. */
export type LensComparisonResult = {
  __typename?: 'LensComparisonResult';
  /** Fields with mixed access (hidden for some roles, visible for others) */
  mixedAccessFields: Array<FieldAccessDiff>;
  /** Role entries being compared */
  roles: Array<LensComparisonRole>;
  /** Fields hidden by ALL roles (universal restrictions) */
  universallyHidden: Array<Scalars['String']['output']>;
  /** Fields visible to ALL roles (universal access) */
  universallyVisible: Array<Scalars['String']['output']>;
};

/** A single role's lens evaluation for comparison. */
export type LensComparisonRole = {
  __typename?: 'LensComparisonRole';
  /** Count of hidden fields */
  hiddenFieldCount: Scalars['Int']['output'];
  /** Fields hidden by lens evaluation */
  hiddenFields: Array<Scalars['String']['output']>;
  /** Display label for this role set */
  label: Scalars['String']['output'];
  /** Role IDs evaluated */
  roleIds: Array<Scalars['String']['output']>;
  /** Scopes resolved for these roles */
  scopes: Array<Scalars['String']['output']>;
  /** Triggered rule ID from Phase 1 */
  triggeredRuleId?: Maybe<Scalars['String']['output']>;
};

/** Result of evaluating the 4-phase lens chain. */
export type LensEvaluationResult = {
  __typename?: 'LensEvaluationResult';
  /** Whether break-glass was activated (Phase 4 emergency) */
  breakGlassActivated: Scalars['Boolean']['output'];
  /**
   * DRR-103: Fields hidden by lens Phase 3 rules (HIPAA minimum necessary, etc.)
   * Frontend should hide these fields in addition to FormSchema required_scope filtering.
   */
  hiddenFields: Array<Scalars['String']['output']>;
  /** Per-phase results */
  phases: Array<LensPhaseResult>;
  /** Number of phases evaluated */
  phasesEvaluated: Scalars['Int']['output'];
  /** Total evaluation time in microseconds */
  totalDurationUs: Scalars['String']['output'];
  /** Final set of visible entity IDs after all phases */
  visibleEntityIds: Array<Scalars['String']['output']>;
  /** Final set of visible field names after all phases */
  visibleFields: Array<Scalars['String']['output']>;
  /** Whether evaluation completed within 20ms target (DRR-075) */
  withinLatencyTarget: Scalars['Boolean']['output'];
};

/** Lens phase in the 4-phase evaluation chain. */
export const LensPhase = {
  /** Phase 1: Role-based filtering (RBAC-derived visibility) */
  ROLE: 'ROLE',
  /** Phase 2: Scope-position filtering (DAG location determines view) */
  SCOPE: 'SCOPE',
  /** Phase 3: Setting/industry filtering (vertical-specific rules) */
  SETTING: 'SETTING',
  /** Phase 4: Situational filtering (emergency, audit mode, training) */
  SITUATION: 'SITUATION',
} as const;

export type LensPhase = (typeof LensPhase)[keyof typeof LensPhase];
/** Result of a single lens phase evaluation. */
export type LensPhaseResult = {
  __typename?: 'LensPhaseResult';
  /** Break-glass event ID (for audit reference, Phase 4 only) */
  breakGlassEventId?: Maybe<Scalars['String']['output']>;
  /** Duration of this phase in microseconds */
  durationUs: Scalars['String']['output'];
  /** Whether this phase narrowed the input */
  narrowed: Scalars['Boolean']['output'];
  /** Which phase */
  phase: LensPhase | '%future added value';
  /** Remaining break-glass uses today (Phase 4 only) */
  remainingBreakGlassUses?: Maybe<Scalars['Int']['output']>;
  /** Rule that triggered this result */
  triggeredRuleId?: Maybe<Scalars['String']['output']>;
  /** Whether this phase widened visibility (only Phase 4) */
  widened: Scalars['Boolean']['output'];
};

/** Safety level for a lens. */
export const LensSafetyLevel = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
} as const;

export type LensSafetyLevel = (typeof LensSafetyLevel)[keyof typeof LensSafetyLevel];
/**
 * Lens template definition (DRR-075/085 config type #6).
 *
 * A lens filters what a specific role/perspective sees within a
 * constellation. Two schemas exist:
 * - Rules-based (older): `rules[]` with conditions and actions
 * - Ring-filter-based (onboarding): `ring_filters` per ring + `onboarding_checklist`
 */
export type LensTemplate = {
  __typename?: 'LensTemplate';
  /** Which constellation this lens targets (if specified) */
  appliesToConstellation?: Maybe<Scalars['String']['output']>;
  /** Description of what this lens filters */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique lens identifier (e.g., "ln-5-0-002") */
  lensId: Scalars['String']['output'];
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Onboarding checklist steps (onboarding lenses only) */
  onboardingChecklist: Array<LensChecklistStep>;
  /** Lens phase: role, scope, setting, situation */
  phase: Scalars['String']['output'];
  /** Number of rules (rules-based lens) or ring filters (ring-filter lens) */
  ruleCount: Scalars['Int']['output'];
  /** Safety level: critical, high, medium, low */
  safetyLevel?: Maybe<Scalars['String']['output']>;
  /** Semantic version */
  version: Scalars['String']['output'];
  /** Verticals this lens applies to */
  verticals: Array<Scalars['String']['output']>;
};

/** Action available in list (row actions or bulk actions) */
export type ListAction = {
  __typename?: 'ListAction';
  /** Action type: "navigate", "mutation", "modal" */
  actionType: Scalars['String']['output'];
  /** Whether this is a bulk action */
  bulk: Scalars['Boolean']['output'];
  /** Danger action (red styling) */
  danger: Scalars['Boolean']['output'];
  /** Icon identifier */
  icon?: Maybe<Scalars['String']['output']>;
  /** Action identifier */
  id: Scalars['String']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** GraphQL mutation to execute (for "mutation" type) */
  mutation?: Maybe<Scalars['String']['output']>;
  /** Navigation path (for "navigate" type) */
  navigateTo?: Maybe<Scalars['String']['output']>;
  /** Confirmation required */
  requiresConfirmation: Scalars['Boolean']['output'];
  /** Condition for showing action (CEL expression) */
  visibleWhen?: Maybe<Scalars['String']['output']>;
};

/** Response for list active JIT sessions query */
export type ListActiveJitSessionsResult = {
  __typename?: 'ListActiveJITSessionsResult';
  sessions: Array<JitActiveSession>;
  totalCount: Scalars['Int']['output'];
};

/** List column definition */
export type ListColumn = {
  __typename?: 'ListColumn';
  /** Column type */
  columnType: ListColumnType | '%future added value';
  /** Whether column is filterable */
  filterable: Scalars['Boolean']['output'];
  /** Formatter name (e.g., "date", "currency", "phone") */
  formatter?: Maybe<Scalars['String']['output']>;
  /** Display header */
  label: Scalars['String']['output'];
  /** Whether to mask on display */
  maskOnDisplay: Scalars['Boolean']['output'];
  /** Column identifier */
  name: Scalars['String']['output'];
  /** Display order */
  order?: Maybe<Scalars['Int']['output']>;
  /** JSONPath to data */
  path: Scalars['String']['output'];
  /** PII classification for masking */
  piiClassification: PiiDataClassification | '%future added value';
  /** Whether column is sortable */
  sortable: Scalars['Boolean']['output'];
  /** Status configuration for STATUS type */
  statusConfig?: Maybe<StatusConfig>;
  /** Column width (e.g., "100px", "20%", "auto") */
  width?: Maybe<Scalars['String']['output']>;
};

/** Column type for list display */
export const ListColumnType = {
  ACTIONS: 'ACTIONS',
  AVATAR: 'AVATAR',
  BADGE: 'BADGE',
  BOOLEAN: 'BOOLEAN',
  CURRENCY: 'CURRENCY',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  /** Image thumbnail column */
  IMAGE: 'IMAGE',
  LINK: 'LINK',
  NUMBER: 'NUMBER',
  STATUS: 'STATUS',
  TEXT: 'TEXT',
} as const;

export type ListColumnType = (typeof ListColumnType)[keyof typeof ListColumnType];
/** Input for listing definitions */
export type ListDefinitionsInput = {
  kind: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Input for listing drafts */
export type ListDraftsInput = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** Filter definition for list */
export type ListFilter = {
  __typename?: 'ListFilter';
  /** Default value */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Filter type: "text", "select", "date-range", "number-range", "boolean" */
  filterType: Scalars['String']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** Filter identifier */
  name: Scalars['String']['output'];
  /** Options for select filters */
  options?: Maybe<Array<SelectOption>>;
  /** Field path to filter on */
  path: Scalars['String']['output'];
};

/** Response for list JIT requests query */
export type ListJitRequestsResult = {
  __typename?: 'ListJITRequestsResult';
  requests: Array<JitAccessRequest>;
  totalCount: Scalars['Int']['output'];
};

/** Complete list schema for a subgraph entity */
export type ListSchema = {
  __typename?: 'ListSchema';
  /** Available actions */
  actions?: Maybe<Array<ListAction>>;
  /** Column definitions */
  columns: Array<ListColumn>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Default sort configuration */
  defaultSort?: Maybe<SortConfig>;
  /** Display title for the list */
  displayName: Scalars['String']['output'];
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Available filters */
  filters?: Maybe<Array<ListFilter>>;
  /** GraphQL query for fetching list */
  listQuery?: Maybe<Scalars['String']['output']>;
  /** Default page size */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Safety level */
  safetyLevel: FormSafetyLevel | '%future added value';
  /** Subgraph this schema belongs to */
  subgraph: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Schema version */
  version: Scalars['String']['output'];
};

/** LLM-generated edit suggestion */
export type LlmEditSuggestion = {
  __typename?: 'LlmEditSuggestion';
  /** Affected edge IDs */
  affectedEdges: Array<Scalars['String']['output']>;
  /** Affected node IDs */
  affectedNodes: Array<Scalars['String']['output']>;
  /** Whether this change affects compliance */
  complianceImpact: Scalars['Boolean']['output'];
  /** Confidence score (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** Generated config patch */
  configPatch: Scalars['String']['output'];
  /** Human-readable explanation */
  explanation: Scalars['String']['output'];
  /** Operation type */
  operation: WorkflowEditOperation | '%future added value';
  /** Suggested inheritance level for this change */
  suggestedLevel: Scalars['String']['output'];
  /** Unique ID for this suggestion */
  suggestionId: Scalars['String']['output'];
  /** Validation warnings */
  warnings: Array<Scalars['String']['output']>;
};

export type LlmEditSuggestionInput = {
  affectedEdges: Array<Scalars['String']['input']>;
  affectedNodes: Array<Scalars['String']['input']>;
  complianceImpact: Scalars['Boolean']['input'];
  configPatch: Scalars['String']['input'];
  explanation: Scalars['String']['input'];
  operation: WorkflowEditOperation | '%future added value';
  suggestedLevel: Scalars['String']['input'];
};

/**
 * LLM transit gate classification for form fields (DRR-169).
 *
 * Determines what the edge server does with a field before sending to Claude API.
 * Default is `Strip` (fail-closed) — unknown/new fields are never sent to LLM.
 *
 * **Layer 1 (structural exclusion)**: `Strip` fields are removed from the payload.
 * **Layer 2 (safe passthrough)**: `Safe` fields are sent unchanged (structured, no PII).
 * **Layer 3 (Presidio scan)**: `Scan` fields are scanned by NER before transit.
 *
 * Classification is orthogonal to `PIIDataClassification` (access control).
 * A field can be L2_CARE_OPERATIONAL (staff can see) but `Safe` for LLM transit
 * (e.g., a SELECT with medical terms that don't identify a person).
 */
export const LlmGateClassification = {
  /**
   * Field passed through unchanged — structured data, no PII risk.
   * Use for enums, dates, numbers, status fields, etc.
   */
  SAFE: 'SAFE',
  /**
   * Field scanned by Presidio NER before LLM transit.
   * Use for free-text fields (notes, descriptions, comments) where
   * users might type PII ad-hoc.
   */
  SCAN: 'SCAN',
  /**
   * Field stripped from LLM payload entirely — never sent to Claude.
   * Default for new/unclassified fields (fail-closed).
   */
  STRIP: 'STRIP',
} as const;

export type LlmGateClassification =
  (typeof LlmGateClassification)[keyof typeof LlmGateClassification];
/** Summary of field names grouped by LLM gate classification (DRR-169). */
export type LlmGateFieldSummary = {
  __typename?: 'LlmGateFieldSummary';
  /** Fields that are safe to pass through unchanged */
  safe: Array<Scalars['String']['output']>;
  /** Fields that require Presidio NER scanning before LLM transit */
  scan: Array<Scalars['String']['output']>;
  /** Fields that are stripped (never sent to LLM) */
  strip: Array<Scalars['String']['output']>;
};

/**
 * LLM Comparison Data for Multi-LLM Analysis
 *
 * FERP Principles:
 * - Domain-agnostic: Works for all AI-generated templates
 * - Data-driven: Consensus calculated from actual LLM results
 * - Life-critical: Transparency in AI template generation
 * - Audit trail: Complete tracking of which LLMs agreed/disagreed
 */
export type LlmcomparisonData = {
  __typename?: 'LlmcomparisonData';
  /** Confidence distribution statistics */
  confidenceDistribution: ConfidenceDistribution;
  /** Field consensus analysis */
  consensusFields: Array<FieldConsensus>;
  /** LLM provider comparison results */
  providers: Array<LlmproviderComparison>;
  /** Template ID being analyzed */
  templateId: Scalars['String']['output'];
};

/** LLM Provider Comparison Result */
export type LlmproviderComparison = {
  __typename?: 'LlmproviderComparison';
  /** Field-level extractions from this provider */
  fieldExtractions: Array<FieldExtraction>;
  /** Overall confidence score for this provider */
  overallConfidence: Scalars['Float']['output'];
  /** Processing time in milliseconds */
  processingTimeMs: Scalars['Int']['output'];
  /** Provider name (claude, gpt4, gemini, etc.) */
  provider: Scalars['String']['output'];
};

export type LogLine = {
  __typename?: 'LogLine';
  atMs: Scalars['Int']['output'];
  channel: Scalars['String']['output'];
  event: Scalars['String']['output'];
  meta: Scalars['JSON']['output'];
};

/** Input for looking up by compressed ID */
export type LookupByCompressedInput = {
  /** Compressed ID to lookup */
  compressedId: Scalars['String']['input'];
};

/** Result of looking up by compressed ID */
export type LookupByCompressedResult = {
  __typename?: 'LookupByCompressedResult';
  /** Whether found in cache */
  cacheHit: Scalars['Boolean']['output'];
  /** Compressed ID (query) */
  compressedId: Scalars['String']['output'];
  /** Lookup latency (milliseconds) */
  latencyMs: Scalars['Float']['output'];
  /** Found Snowflake ID (if exists) */
  snowflakeId?: Maybe<Scalars['String']['output']>;
};

/** Input for looking up by Snowflake ID */
export type LookupBySnowflakeInput = {
  /** Snowflake ID to lookup */
  snowflakeId: Scalars['String']['input'];
};

/** Result of looking up by Snowflake ID */
export type LookupBySnowflakeResult = {
  __typename?: 'LookupBySnowflakeResult';
  /** Whether found in cache */
  cacheHit: Scalars['Boolean']['output'];
  /** Found compressed ID (if exists) */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Lookup latency (milliseconds) */
  latencyMs: Scalars['Float']['output'];
  /** Snowflake ID (query) */
  snowflakeId: Scalars['String']['output'];
};

/** Mandate information for a task — which regulation(s) require this work. */
export type MandateInfo = {
  __typename?: 'MandateInfo';
  /** Jurisdiction level: "federal", "state", "payer", "accreditor", "standard", "tenant" */
  jurisdictionLevel?: Maybe<Scalars['String']['output']>;
  /** Specific provisions within the ruleset that mandate this task */
  provisionRefs: Array<ProvisionRef>;
  /** Ruleset config ID (e.g., "rs-4-1-004") */
  rulesetId: Scalars['String']['output'];
  /** Human-readable ruleset name (e.g., "MN 144G") */
  rulesetName: Scalars['String']['output'];
};

/** A missing mandatory resource for a jurisdiction. */
export type MandatoryResourceGap = {
  __typename?: 'MandatoryResourceGap';
  /** FHIR entity type (e.g., "FhirPatient") */
  entityType: Scalars['String']['output'];
  /** Ruleset ID mandating this (e.g., "rs-4-1-001") */
  rulesetRef?: Maybe<Scalars['String']['output']>;
  /** Statutory requirement (e.g., "MN 144G.61 - Resident records") */
  statuteRequirement: Scalars['String']['output'];
};

/**
 * DRR-207: Mandatory resource validation result.
 * Returned by validateMandatoryResources query for product activation gating.
 */
export type MandatoryResourceValidation = {
  __typename?: 'MandatoryResourceValidation';
  /** Number of mandatory resources configured */
  configuredCount: Scalars['Int']['output'];
  /** Missing mandatory resources (entity types without FSO) */
  missingResources: Array<MandatoryResourceGap>;
  /** Total number of mandatory resources required */
  requiredCount: Scalars['Int']['output'];
  /** Whether all mandatory resources are configured */
  valid: Scalars['Boolean']['output'];
};

/** Manifest build status */
export const ManifestStatus = {
  /** Manifest build in progress */
  BUILDING: 'BUILDING',
  /** Manifest is current and valid */
  CURRENT: 'CURRENT',
  /** Manifest build failed */
  FAILED: 'FAILED',
  /** No manifest exists */
  NOT_FOUND: 'NOT_FOUND',
  /** Manifest is stale (older than TTL) */
  STALE: 'STALE',
} as const;

export type ManifestStatus = (typeof ManifestStatus)[keyof typeof ManifestStatus];
/** Metadata for a subgraph */
export type ManifestSubgraphMetadata = {
  __typename?: 'ManifestSubgraphMetadata';
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Entity types in this subgraph */
  entityTypes: Array<EntityTypeMetadata>;
  /** Subgraph name (e.g., "fhir", "payroll", "erp") */
  name: Scalars['String']['output'];
  /** Subgraph number (0-4 for core and 3 active subgraphs) */
  number: Scalars['Int']['output'];
};

/** Version negotiation info for frontend compatibility checks */
export type ManifestVersionInfo = {
  __typename?: 'ManifestVersionInfo';
  /** Current manifest version */
  currentVersion: Scalars['String']['output'];
  /** Minimum version frontend must support */
  minSupportedVersion: Scalars['String']['output'];
};

/** Equivalence level for code mappings between systems */
export const MappingEquivalenceEnum = {
  /** Codes are semantically equivalent */
  EQUIVALENT: 'EQUIVALENT',
  /** Approximate match - use with caution */
  INEXACT: 'INEXACT',
  /** Target code is narrower/more specific */
  NARROWER: 'NARROWER',
  /** No suitable mapping exists */
  UNMATCHED: 'UNMATCHED',
  /** Target code is broader/more general */
  WIDER: 'WIDER',
} as const;

export type MappingEquivalenceEnum =
  (typeof MappingEquivalenceEnum)[keyof typeof MappingEquivalenceEnum];
/** Configuration for MASTER_DETAIL field type (cascading select) */
export type MasterDetailConfig = {
  __typename?: 'MasterDetailConfig';
  /** Clear detail value when master changes */
  cascadeClear?: Maybe<Scalars['Boolean']['output']>;
  /** GraphQL query to fetch detail options (receives master value as variable) */
  detailOptionsQuery: Scalars['String']['output'];
  /** Expression describing how master value filters details */
  filterExpression?: Maybe<Scalars['String']['output']>;
  /** Field name of the master select field */
  masterField: Scalars['String']['output'];
};

/** Input version of MasterDetailConfig */
export type MasterDetailConfigInput = {
  cascadeClear?: InputMaybe<Scalars['Boolean']['input']>;
  detailOptionsQuery: Scalars['String']['input'];
  filterExpression?: InputMaybe<Scalars['String']['input']>;
  masterField: Scalars['String']['input'];
};

/** Response for master workflow config query */
export type MasterWorkflowConfigResponse = {
  __typename?: 'MasterWorkflowConfigResponse';
  complianceDomains: Array<Scalars['String']['output']>;
  dependencies: Array<WorkflowDependency>;
  id: Scalars['String']['output'];
  metadata?: Maybe<WorkflowMetadata>;
  name: Scalars['String']['output'];
  phases: Array<WorkflowPhase>;
  programConfig?: Maybe<ProgramConfig>;
  programVariant: Scalars['String']['output'];
  subWorkflows: Array<SubWorkflowConfig>;
  version: Scalars['String']['output'];
};

/** MedicationAdministration connection */
export type MedicationAdministrationConnection = {
  __typename?: 'MedicationAdministrationConnection';
  edges: Array<MedicationAdministrationEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** MedicationAdministration edge */
export type MedicationAdministrationEdge = {
  __typename?: 'MedicationAdministrationEdge';
  cursor: Scalars['String']['output'];
  node: FhirMedicationAdministration;
};

/** Medication connection */
export type MedicationConnection = {
  __typename?: 'MedicationConnection';
  edges: Array<MedicationEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** MedicationDispense connection */
export type MedicationDispenseConnection = {
  __typename?: 'MedicationDispenseConnection';
  edges: Array<MedicationDispenseEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** MedicationDispense edge */
export type MedicationDispenseEdge = {
  __typename?: 'MedicationDispenseEdge';
  cursor: Scalars['String']['output'];
  node: FhirMedicationDispense;
};

/** Medication edge */
export type MedicationEdge = {
  __typename?: 'MedicationEdge';
  cursor: Scalars['String']['output'];
  node: FhirMedication;
};

/** MedicationRequest connection */
export type MedicationRequestConnection = {
  __typename?: 'MedicationRequestConnection';
  edges: Array<MedicationRequestEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** MedicationRequest edge */
export type MedicationRequestEdge = {
  __typename?: 'MedicationRequestEdge';
  cursor: Scalars['String']['output'];
  node: FhirMedicationRequest;
};

/** Input for merging multiple PDF documents */
export type MergeDocumentsInput = {
  /** IDs of documents to merge (in order) */
  documentIds: Array<Scalars['String']['input']>;
  /** Name for the merged document */
  mergedDocumentName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Result of a document merge operation */
export type MergeDocumentsResult = {
  __typename?: 'MergeDocumentsResult';
  /** Audit event ID for this merge operation */
  auditEventId: Scalars['String']['output'];
  /** The newly created merged document */
  document?: Maybe<Document>;
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Whether the merge operation succeeded */
  success: Scalars['Boolean']['output'];
};

export const MessageRole = {
  ASSISTANT: 'ASSISTANT',
  USER: 'USER',
} as const;

export type MessageRole = (typeof MessageRole)[keyof typeof MessageRole];
export type MetadataFilterInput = {
  accessLevels?: InputMaybe<Array<AccessLevelGql | '%future added value'>>;
  complianceLevels?: InputMaybe<Array<ComplianceLevelGql | '%future added value'>>;
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  domainTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataManifest = {
  __typename?: 'MetadataManifest';
  formPatterns: Array<FormPatternMetadata>;
  generatedAt: Scalars['String']['output'];
  manifestVersion: Scalars['String']['output'];
  primitives: Array<PrimitiveMetadata>;
  subgraphs: Array<ManifestSubgraphMetadata>;
};

export type MetadataPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Metadata result for frontend repository pattern integration
 * LIFE-CRITICAL: Supports useMetadataRepository hook
 */
export type MetadataResult = {
  __typename?: 'MetadataResult';
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  metadataType: Scalars['String']['output'];
};

/** Chaos→DSL Conversion Result (GraphQL output) */
export type MetadataTemplateConversionResult = {
  __typename?: 'MetadataTemplateConversionResult';
  /** Confidence metrics */
  confidence: ConfidenceMetrics;
  /** Evidence attribution map */
  evidence: EvidenceMap;
  /** AI generation metadata */
  generationMetadata: GenerationMetadata;
  /** Requires human review flag */
  requiresHumanReview: Scalars['Boolean']['output'];
  /** Generated template (draft) */
  template: WorkflowTemplateMetadata;
};

/** Metric category (business classification) */
export const MetricCategory = {
  ADOPTION: 'ADOPTION',
  BUSINESS: 'BUSINESS',
  COMPLIANCE: 'COMPLIANCE',
  PERFORMANCE: 'PERFORMANCE',
  SYSTEM: 'SYSTEM',
} as const;

export type MetricCategory = (typeof MetricCategory)[keyof typeof MetricCategory];
/** * Metric status enumeration */
export const MetricStatusOutput = {
  ABOVE_TARGET: 'ABOVE_TARGET',
  AT_RISK: 'AT_RISK',
  BELOW_TARGET: 'BELOW_TARGET',
  ON_TARGET: 'ON_TARGET',
} as const;

export type MetricStatusOutput = (typeof MetricStatusOutput)[keyof typeof MetricStatusOutput];
/** Metric type (how values are recorded) */
export const MetricType = {
  COUNTER: 'COUNTER',
  GAUGE: 'GAUGE',
  HISTOGRAM: 'HISTOGRAM',
  SUMMARY: 'SUMMARY',
} as const;

export type MetricType = (typeof MetricType)[keyof typeof MetricType];
/** Metric unit of measurement */
export const MetricUnit = {
  BYTES: 'BYTES',
  COUNT: 'COUNT',
  DOLLARS: 'DOLLARS',
  MILLISECONDS: 'MILLISECONDS',
  MINUTES: 'MINUTES',
  PERCENTAGE: 'PERCENTAGE',
  RATIO: 'RATIO',
  SECONDS: 'SECONDS',
} as const;

export type MetricUnit = (typeof MetricUnit)[keyof typeof MetricUnit];
/** Describes a missing config that should exist for a rule. */
export type MissingConfig = {
  __typename?: 'MissingConfig';
  /** Config type needed (e.g., "task_group", "workflow", "rule") */
  configType: Scalars['String']['output'];
  /** Description of what's missing */
  description: Scalars['String']['output'];
  /** Expected trigger or context (e.g., "day_boundary", "admission") */
  expectedTrigger: Scalars['String']['output'];
};

/** Primitive that was modified by auto-fix */
export type ModifiedPrimitive = {
  __typename?: 'ModifiedPrimitive';
  /** Fields that were changed */
  changedFields: Array<Scalars['String']['output']>;
  /** ID of the modified primitive */
  primitiveId: Scalars['String']['output'];
  /** Type of primitive modified */
  primitiveType: Scalars['String']['output'];
};

/** Module licensing tier */
export const ModuleTier = {
  /** Basic tier - core functionality */
  BASIC: 'BASIC',
  /** Enterprise tier - all features + custom widgets + priority support */
  ENTERPRISE: 'ENTERPRISE',
  /** Free tier - limited features, usage caps */
  FREE: 'FREE',
  /** Professional tier - advanced features */
  PROFESSIONAL: 'PROFESSIONAL',
} as const;

export type ModuleTier = (typeof ModuleTier)[keyof typeof ModuleTier];
/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Abort transaction (emergency abort - life-critical safety feature).
   * Creates new version with Aborted status.
   */
  abortTransaction: Transaction;
  /**
   * Accept a settlement proposal with counterparty Blake3 reconciliation (DRR-105)
   *
   * The counterparty provides their own Blake3 hash of the aggregated transactions.
   * If hashes match, the proposal is ACCEPTED and ready for banking settlement.
   * If hashes differ, the proposal is REJECTED — data integrity violation.
   *
   * Guards: exchange:admin scope + Tier 3 auth
   */
  acceptSettlementProposal: SettlementProposal;
  /**
   * Acknowledge an elopement alert.
   *
   * DRR-100: Life-critical — must be acknowledged by a responsible staff member.
   * Requires: `beacon:acknowledge` scope (DRR-102)
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * acknowledgeElopementAlert(
   * tenantNum: 2
   * alertId: "elop-17-171-1709312345"
   * acknowledgedBy: "2_5"
   * ) {
   * alertId
   * acknowledged
   * acknowledgedBy
   * acknowledgedAt
   * }
   * }
   * ```
   */
  acknowledgeElopementAlert?: Maybe<ElopementAlert>;
  /** Acknowledge an anomaly (mark as seen) */
  acknowledgeIntegrationAnomaly: IntegrationAnomalyAckResult;
  /** Acquire lock for workflow execution */
  acquireWorkflowLock: WorkflowLockResult;
  /** Activate an approved architect proposal (applies the config) (DRR-227) */
  activateArchitectProposal: ArchitectProposal;
  /** Activate workflow definition */
  activateDefinition: Scalars['Boolean']['output'];
  /**
   * Activate selected features (subgraphs) for a tenant.
   *
   * Enables subgraphs in the tenant's SubgraphRegistry and optionally
   * applies a product bundle overlay via the existing `activateProduct` logic.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * activateFeatures(
   * tenantId: "42"
   * featureIds: ["fhir", "edi", "payroll"]
   * productId: "prod-1-001"
   * ) {
   * success
   * activatedFeatures
   * productApplied
   * errors
   * }
   * }
   * ```
   */
  activateFeatures: ActivateFeaturesResult;
  /**
   * Activate a product for a tenant.
   *
   * DRR-095: Creates a tenant-scoped product activation record. The product
   * must exist in the catalog (seeded from YAML). The tenant cannot activate
   * the same product twice (write-once enforced by L1 DDB condition).
   *
   * Requires admin role for the target tenant.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * activateProduct(
   * tenantNum: 2
   * productId: "prod-1-001"
   * activatedBy: "2_1"
   * ) {
   * success
   * tenantProduct {
   * productId
   * provisioningStatus
   * activatedAt
   * }
   * error
   * }
   * }
   * ```
   */
  activateProduct: ProductActivationResult;
  /** Activate a tenant (complete onboarding, admin only) */
  activateSystemTenant: SystemTenant;
  /** Activate validation (creates new version with active=true). */
  activateValidation: Validation;
  /**
   * Activate a workflow (creates new version with active=true).
   * Append-only: Loads existing workflow and creates new version with updated state.
   */
  activateWorkflow: Workflow;
  /** Generate an Actor import CSV template (download as text/csv). */
  actorImportCsvTemplate: Scalars['String']['output'];
  /** Create actor snapshot */
  actorMgmtCreateActorSnapshot: Scalars['Boolean']['output'];
  /** Restart an actor instance */
  actorMgmtRestartActor: Scalars['Boolean']['output'];
  /** Send message to actor */
  actorMgmtSendActorMessage: Scalars['Boolean']['output'];
  /** Start a new actor instance */
  actorMgmtStartActor: ActorDeploymentResult;
  /** Stop an actor instance */
  actorMgmtStopActor: Scalars['Boolean']['output'];
  /** Update actor configuration */
  actorMgmtUpdateActorConfig: Scalars['Boolean']['output'];
  /**
   * Add actor to a queue.
   *
   * Requires: `actor:write` scope
   *
   * Formula #6: Load-Balanced Queue support
   */
  addActorToQueue: Actor;
  /**
   * Add checkpoint to transaction (for rollback).
   * Creates new version with checkpoint added.
   */
  addCheckpointToTransaction: Transaction;
  /** Add a composed component to a workflow definition */
  addComponent: ComponentRefGql;
  /**
   * Add permission to role (creates new version).
   *
   * Requires scope: role:write or role:admin
   */
  addPermission: Role;
  /**
   * Add rule to policy (creates new version with added rule - APPEND-ONLY).
   *
   * **FERP Integration**: Same as update_policy (modifies policy rules).
   * - APPEND-ONLY: Creates new version with rule added
   */
  addPolicyRule: Policy;
  /**
   * Add role inheritance (creates new version).
   *
   * Requires scope: role:write or role:admin
   */
  addRoleInheritance: Role;
  /**
   * Add an edge to the scope DAG.
   *
   * Returns the blockchain-verified mutation record.
   * Rejects cycles (DAG invariant).
   *
   * Requires `scope:write` or `scope:admin` scope.
   */
  addScopeEdge: ScopeMutationEvent;
  /**
   * Add a feature flag to a subgraph
   *
   * Features are tier-independent toggles for specific functionality.
   */
  addSubgraphFeature: SubgraphRegistry;
  /**
   * Add stakeholder to team.
   *
   * Requires `team:write` or `team:admin` scope
   */
  addTeamStakeholder: Team;
  /**
   * DRR-281 Phase 4: One-click adopt an industry term.
   * Creates a tenant override that uses the industry term's label.
   */
  adoptIndustryTerm: TerminologyOverrideResult;
  /** LLM-assisted domain analysis from user intent */
  analyzeDomainFromIntent: Scalars['JSON']['output'];
  /**
   * Analyze an association publication and generate draft advisory RuleSets.
   *
   * DRR-156 Channel 2: LLM reads the document, maps recommendations to
   * FERP vocabulary (care-vocabulary.yaml tags), and generates draft
   * advisory RuleSet YAMLs with typed edges.
   *
   * Drafts are NEVER auto-activated. Architect must review and approve.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * analyzePublication(input: {
   * associationRef: "tag:association:leading-age"
   * publicationTitle: "2026 Person-Centered Care Guidelines"
   * publicationYear: 2026
   * documentText: "..."
   * industry: "assisted_living"
   * jurisdiction: "federal"
   * }) {
   * success
   * draftCount
   * draftCount
   * proposals { proposalId configType displayName safetyLevel }
   * confidence
   * mappedTags
   * }
   * }
   * ```
   */
  analyzePublication: PublicationAnalysisResult;
  appendTransition: Scalars['Boolean']['output'];
  /** Apply a suggestion to the draft */
  applyFormSchemaSuggestion: ApplySuggestionResult;
  /** Apply accepted LLM fixes and re-validate */
  applyLlmFix: ApplyFixResult;
  /** Apply standards pack to workflow */
  applyStandardsPack: ApplyStandardsPackResult;
  /** Add comment to approval. */
  approvalApiAddApprovalComment: Approval;
  /** Create new approval. */
  approvalApiCreateApproval: Approval;
  /** Delegate approval to another actor. */
  approvalApiDelegateApproval: Approval;
  /** Escalate approval to higher authority. */
  approvalApiEscalateApproval: Approval;
  /** Record decision on approval. */
  approvalApiRecordApprovalDecision: Approval;
  /** Update approval metadata (priority, deadline, tags). */
  approvalApiUpdateApproval: Approval;
  /**
   * Approve a config proposal — moves it from proposals/ to seed/.
   *
   * DRR-171: Architect reviews at fragment level (3-5 states max).
   * Approved configs are added to the product's `activates_*` list
   * so all tenants with that product benefit automatically.
   *
   * Pipeline:
   * 1. Read proposal YAML from proposals/{type}/{id}.yaml
   * 2. Determine config type from proposal_id prefix (tg-, wf-, rl-)
   * 3. Copy to appropriate seed/ subdirectory
   * 4. If add_to_product specified, append config ID to product YAML
   * 5. Log T1 audit event
   */
  approveConfigProposal: ApproveProposalResult;
  /** Approve a JIT access request */
  approveJITRequest: ApproveJitRequestResult;
  /**
   * Approve or reject an optimization recommendation
   * LIFE-CRITICAL: Multi-level approval required for critical recommendations
   */
  approveRecommendation: Scalars['Boolean']['output'];
  /**
   * Approve a regulatory rule from the review queue
   *
   * Requires `regulatory:approve` scope + Cedar policy enforcement.
   * CRITICAL safety rules enforce four-eyes principle (importer != approver).
   */
  approveRegulatoryRule: GqlRegulatoryRule;
  /** Approve a BLOCKED override after ConferenceApproval. Architect-only. 1-year expiry. */
  approveTerminologyOverride: StoredTerminologyOverride;
  /**
   * Archive Actor primitive (Issue #671: Append-Only Architecture)
   *
   * REPLACES: deleteActor (removed from schema for append-only compliance)
   *
   * # Life-Critical Compliance
   *
   * - **HIPAA**: Healthcare actor assignments must be auditable
   * - **SOX**: Financial actor authorization trails required
   * - **EU AI Act**: AI actor oversight must be traceable
   *
   * # Arguments
   *
   * * `actor_id` - Actor ID (backend Snowflake ID)
   * * `reason` - Mandatory archival reason for audit trail
   *
   * # Returns
   *
   * - `ActorArchiveResult` with full audit metadata
   */
  archiveActor: ActorArchiveResult;
  /**
   * Archive analytics (FERP Append-Only Architecture)
   *
   * **REPLACES**: `deleteAnalytics` - physical deletion is NOT allowed
   *
   * Archives an analytics metric with mandatory reason for audit compliance.
   * The analytics remains in the database with `enabled: false` status.
   *
   * FERP Principle: Immutable history for life-critical workflows.
   */
  archiveAnalytics: AnalyticsArchiveResult;
  /**
   * Archive an annotation (append-only: content preserved, is_active set to false).
   *
   * Requires `annotation:admin` scope.
   *
   * Creates a new version with `archived=true` and `is_active=false`.
   * The original content is preserved for compliance audit trail.
   */
  archiveAnnotation: GqlAnnotationArchiveResult;
  /**
   * Archive an audit record (FERP Append-Only Architecture)
   *
   * NOTE: Audit records ARE the audit trail itself and CANNOT be archived.
   * This mutation exists to provide a clear error message explaining why.
   *
   * Audit records are the ultimate compliance artifacts under HIPAA, SOX, and SOC2.
   * They must remain permanently accessible for regulatory inquiries.
   * Archiving an audit record would defeat the purpose of having an audit trail.
   *
   * Alternative: Use `extend_audit_retention` to manage retention periods.
   * Requires: `audit:write` scope (DRR-102)
   */
  archiveAudit: AuditArchiveResultQl;
  /**
   * Archive contract (FERP Append-Only Architecture).
   *
   * FERP Principle: Immutable history for life-critical workflows.
   * No physical deletion - sets status to Archived and preserves full audit trail.
   *
   * Requires `contract:admin` scope.
   *
   * # Arguments
   * - `workflow_instance_id`: Workflow instance the contract belongs to
   * - `contract_id`: ID of the contract to archive
   * - `reason`: Mandatory reason for archival (audit trail requirement)
   *
   * # Returns
   * `ContractArchiveResult` with full audit metadata
   *
   * # Idempotent
   * If contract is already archived, returns existing archive metadata.
   */
  archiveContract: ContractArchiveResult;
  /**
   * Archive integration (FERP Append-Only Architecture)
   *
   * **REPLACES**: `deleteIntegration` - physical deletion is NOT allowed
   *
   * Archives an integration with mandatory reason for audit compliance.
   * The integration remains in the database with `enabled: false` status.
   *
   * FERP Principle: Immutable history for life-critical workflows.
   */
  archiveIntegration: IntegrationArchiveResult;
  /**
   * Archive notification (FERP Append-Only Architecture).
   *
   * FERP Principle: Immutable history for life-critical workflows.
   * No physical deletion - sets archived=true and preserves full audit trail.
   *
   * Requires `notification:admin` scope.
   *
   * # Arguments
   * - `notification_id`: ID of the notification to archive
   * - `reason`: Mandatory reason for archival (audit trail requirement)
   *
   * # Returns
   * `NotificationArchiveResult` with full audit metadata
   *
   * # Idempotent
   * If notification is already archived, returns existing archive metadata.
   */
  archiveNotification: NotificationArchiveResult;
  /**
   * Archive policy rule (FERP Append-Only Architecture)
   *
   * REPLACES: delete_policy_rule (removed for append-only compliance)
   * - Soft archive: Sets deleted = true with full audit trail
   * - Audit trail: Full archival metadata preserved
   * - Mandatory reason: Required for audit compliance
   * - Returns: PolicyRuleArchiveResult with full audit metadata
   */
  archivePolicyRule: PolicyRuleArchiveResult;
  /**
   * Archive queue (FERP Append-Only Architecture).
   *
   * **REPLACES**: `deleteQueue` - physical deletion is NOT allowed
   *
   * Archives a queue with mandatory reason for audit compliance.
   * The queue remains in the database with `is_active: false` status.
   *
   * FERP Principle: Immutable history for life-critical workflows.
   *
   * ## Idempotent Behavior
   * If queue is already archived, returns existing archive metadata.
   *
   * ## FERP Integration
   * - RBAC: Requires queue:admin scope
   * - Audit: Creates audit trail entry
   */
  archiveQueue: QueueArchiveResult;
  /**
   * Archive schedule (FERP Append-Only Architecture).
   *
   * **REPLACES**: `deleteSchedule` - physical deletion is NOT allowed
   *
   * Archives a schedule with mandatory reason for audit compliance.
   * The schedule remains in the database with `Archived` status.
   *
   * FERP Principle: Immutable history for life-critical workflows.
   *
   * ## Idempotent Behavior
   * If schedule is already archived, returns existing archive metadata.
   *
   * ## FERP Integration
   * - RBAC: Requires schedule:admin scope
   * - Audit: Creates audit trail entry
   *
   * Requires `schedule:admin` scope
   */
  archiveSchedule: ScheduleArchiveResult;
  /**
   * Archive subgraph metadata (APPEND-ONLY)
   *
   * **FERP Append-Only Architecture**: Instead of DELETE, we archive.
   * A tombstone record is created marking the metadata as inactive.
   * The original data remains accessible for compliance/audit purposes.
   *
   * **Required Role**: Architect (archiving is a LIFE-CRITICAL operation)
   *
   * **Note**: Archived subgraphs can be queried for audit/compliance but
   * will not appear in active lists. They cannot be unarchived via API.
   */
  archiveSubgraphMetadata: ArchiveResult;
  /**
   * Archive a team (FERP Append-Only Architecture)
   *
   * Replaces: deleteTeam (removed for append-only compliance)
   * - Soft archive: Sets active = false with full audit trail
   * - Audit trail: Full archival metadata preserved
   * - Mandatory reason: Required for compliance (HIPAA, SOX, SOC2)
   * - Returns: TeamArchiveResult with full audit metadata
   *
   * Requires `team:write` or `team:admin` scope
   */
  archiveTeam: TeamArchiveResult;
  /** Archive template version */
  archiveTemplate: Scalars['Boolean']['output'];
  /**
   * Archive workflow graph (Issue #659: Append-only architecture)
   *
   * REPLACES: deleteWorkflowGraph (removed for append-only compliance)
   *
   * # Life-Critical Compliance
   *
   * - **HIPAA**: Healthcare workflow graphs must be auditable
   * - **SOX**: Financial workflow audit trails required
   * - **FDA 21 CFR Part 11**: Medical device workflow traceability
   */
  archiveWorkflowGraph: ArchivedWorkflowGraph;
  /** Assess criticality for a workflow execution */
  assessWorkflowCriticality: WorkflowCriticalityResult;
  /**
   * Assign driver to order ready for pickup
   *
   * NOTE: Requires metadata update + fireEvent("driver_pickup")
   */
  assignDriver: FoodServiceOrder;
  assignTask: Queue;
  /**
   * Assign a task to an actor.
   *
   * Requires: `actor:write` scope
   *
   * Formula #1: Time-Bound Assignment support
   */
  assignTaskToActor: Actor;
  /**
   * Query the tenant AI executive assistant.
   *
   * PHI firewall: question text is Presidio-scrubbed before reaching Bedrock.
   * Context is structural metadata only (zero PHI by construction).
   *
   * Requires: `assistant:query` scope (DRR-131, DRR-102)
   */
  assistantQuery: AssistantQueryResponse;
  /**
   * Attach a chaos document to an existing FERP entity as evidence (DRR-137 Phase 3).
   *
   * Creates a typed EVIDENCED_BY edge (DRR-110):
   * - DDB: edge record co-located with the ChaosDocument (same PK, SK = EVIDENCE_EDGE#...)
   * - Valkey: bidirectional SET indexes
   * - SADD idx:edge:{entity_id}:EVIDENCED_BY {document_id}
   * - SADD idx:edge:{document_id}:EVIDENCES  {entity_id}
   *
   * Idempotent: duplicate edges (same document + entity pair) are silently accepted.
   */
  attachEvidence: EvidenceAttachment;
  /**
   * Submit manual evidence for a statutory provision.
   *
   * DRR-176: For provisions that need non-task proof (photos, certificates,
   * observations). Creates an immutable Audit record with attestation_type: compliance.
   * User-initiated write (not auto-generated — DRR-128 compliant).
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * attestProvision(input: {
   * rulesetId: "rs-4-1-004"
   * provisionRef: "rl-4-0-037"
   * evidenceType: "observation"
   * description: "License posted on wall near entrance"
   * documentIds: ["doc_abc123"]
   * }) {
   * success
   * attestationId
   * }
   * }
   * ```
   */
  attestProvision: AttestProvisionResult;
  /**
   * Backfill training lifecycle instances for existing HUMAN actors.
   *
   * Creates `wf-0-0-006` instances in `active` state for all HUMAN actors
   * that don't already have a training instance. Use this for production
   * deployment to ensure all existing staff have training tracking.
   *
   * Returns the count of instances created.
   *
   * Requires: `actor:admin` scope
   */
  backfillTrainingInstances: BackfillTrainingResult;
  /**
   * Complete a basic enrollment step
   *
   * Called after the frontend completes a WebAuthn registration/verification.
   */
  basicCompleteEnrollmentStep: BasicEnrollmentFlow;
  /**
   * Skip basic enrollment entirely
   *
   * Allows user to skip enrollment. They can enroll later from Settings.
   */
  basicSkipEnrollment: Scalars['Boolean']['output'];
  /** Skip a basic enrollment step */
  basicSkipEnrollmentStep: BasicEnrollmentFlow;
  /**
   * Start basic enrollment flow
   *
   * Initiates the basic enrollment process. The actual WebAuthn registration
   * is handled by the PII Vault subgraph.
   */
  basicStartEnrollment: BasicEnrollmentFlow;
  /**
   * Compress multiple Snowflake IDs in batch
   *
   * Max 100 IDs per request for safety.
   */
  batchCompress: BatchCompressResult;
  /**
   * Create multiple signing ceremonies from a template in a single call (D4).
   *
   * Each batch entry specifies a document_id and ordered participant emails matching
   * the template's slot order. Useful for mass distribution: employee onboarding
   * packages, insurance docs, etc.
   *
   * Returns one SigningCeremony per successful creation. Individual failures are
   * collected in `errors` and do NOT abort the batch. Maximum 50 items per call.
   */
  batchCreateCeremonyFromTemplate: BatchCeremonyResult;
  /** Decompress multiple compressed IDs in batch */
  batchDecompress: BatchDecompressResult;
  /** Batch enable/disable analytics */
  batchSetAnalyticsEnabled: Scalars['Int']['output'];
  /** Bootstrap system templates (admin only) */
  bootstrapSystemTemplates: Scalars['Boolean']['output'];
  /**
   * Break-glass emergency override for wall-blocked scope access.
   *
   * DRR-123 §12: Bypasses wall enforcement for emergency situations.
   * Requires: fresh_witness + enhanced_audit. Review within 24h.
   * Notifications sent to ALD and QA roles.
   */
  breakGlassWallOverride: BreakGlassOverrideResult;
  /** Bulk acknowledge anomalies */
  bulkAcknowledgeAnomalies: Array<IntegrationAnomalyAckResult>;
  /** Bulk send notifications to multiple workers */
  bulkSendWorkerNotifications: Array<IntegrationNotificationResult>;
  /** Bulk-verify all unverified extractions above a confidence threshold */
  bulkVerifyExtractions: GqlSourceCoordinateMap;
  /** Cancel own architect proposal (DRR-227) */
  cancelArchitectProposal: ArchitectProposal;
  /** Cancel bulk operation */
  cancelBulkOperation: BulkOperation;
  /** Cancel a running or paused DAG execution */
  cancelDagExecution: DagstateTransitionResponse;
  /**
   * Cancel an Encounter (sets Encounter.status = "cancelled" or "entered-in-error")
   *
   * This is a soft-delete operation - the encounter is NOT physically deleted.
   * If entered_in_error = true, DUAL CONTROL is required (2+ approvals).
   *
   * ## 5-Step Write Pattern
   *
   * 0. Validate status transition and dual control (if entered-in-error)
   * 1. Update Medplum projection
   * 2. Write DeactivationEvent to S3 (SOURCE OF TRUTH)
   * 3. Update INDEX projection (mark as cancelled)
   * 4. Invalidate caches
   */
  cancelEncounter: FhirEncounter;
  /**
   * Cancel an Observation (sets Observation.status = "cancelled" or "entered-in-error")
   *
   * This is a soft-delete operation - the observation is NOT physically deleted.
   * If entered_in_error = true, DUAL CONTROL is required (2+ approvals).
   */
  cancelObservation: FhirObservation;
  /**
   * Cancel an order (from any non-final state)
   *
   * NOTE: Use fireEvent(instanceId, "order_cancelled") instead.
   */
  cancelOrder: FoodServiceOrder;
  /**
   * Cancel a Procedure (sets Procedure.status = "not-done" or "entered-in-error")
   *
   * This is a soft-delete operation - the procedure is NOT physically deleted.
   * If entered_in_error = true, DUAL CONTROL is required (2+ approvals).
   */
  cancelProcedure: FhirProcedure;
  /**
   * Cancel a sub-workflow and optionally trigger compensation.
   *
   * Cancels the child workflow and updates the parent's tracking.
   * Creates a new version via append-only transition.
   */
  cancelSubWorkflow: Instance;
  /**
   * Cancel a pending witness request (operator action).
   *
   * Requires Tier 3+ authentication.
   * Only the operator who created the request can cancel it.
   */
  cancelWitnessRequest: WitnessRequestGql;
  /** Add a provider to track */
  carecircleAddProvider: CareCircleRecordTracker;
  /** Claim a raffle prize */
  carecircleClaimPrize: CareCircleRaffleEntry;
  /** Create a new family account */
  carecircleCreateFamily: CareCircleFamily;
  /** Mark provider record as received */
  carecircleMarkRecordReceived: CareCircleRecordTracker;
  /** Mark provider record as requested */
  carecircleMarkRecordRequested: CareCircleRecordTracker;
  /**
   * Record a raffle action (earn points)
   * Uses EngagementTracker with ruleset-defined point values (DRR-291)
   */
  carecircleRecordRaffleAction: CareCircleRaffleEntry;
  /** Start a new care assessment */
  carecircleStartAssessment: CareCircleAssessment;
  /** Start tracking medical records */
  carecircleStartRecordTracker: CareCircleRecordTracker;
  /** Submit a lead to a facility (express interest) */
  carecircleSubmitLead: CareCircleLead;
  /** Update a care assessment */
  carecircleUpdateAssessment: CareCircleAssessment;
  /** Check framework compliance */
  checkFrameworkCompliance: FrameworkComplianceResult;
  claimTask?: Maybe<InboxTask>;
  /**
   * Classify extracted text from device OCR/transcription and match it to
   * the best FormSchema entity type for intake routing (DRR-159).
   *
   * The device (phone camera, microphone) performs OCR or speech-to-text
   * locally. The extracted text is sent to this mutation, which classifies
   * it against the FormSchema catalog and returns the target subgraph,
   * entity type, create mutation, and any extracted field values.
   *
   * # Example
   *
   * ```graphql
   * mutation {
   * classifyIntakeText(text: "Patient Name: Jane Doe\nDOB: 1985-03-15\nAllergies: Penicillin") {
   * subgraph
   * entityType
   * createMutation
   * displayName
   * confidence
   * extractedFields {
   * fieldName
   * value
   * confidence
   * }
   * }
   * }
   * ```
   */
  classifyIntakeText?: Maybe<IntakeClassification>;
  /** Clear error for analytics (after successful aggregation) */
  clearAnalyticsError: Scalars['Boolean']['output'];
  /** Clear system caches */
  clearCache: Scalars['Boolean']['output'];
  /**
   * DRR-178: Clear focus context — return to unscoped view.
   *
   * Requires `scope:write` or `scope:admin` scope.
   */
  clearFocusContext: Scalars['Boolean']['output'];
  /** Clone validation with new code. */
  cloneValidation: Validation;
  /** Clone a workflow with a new version. */
  cloneWorkflow: Workflow;
  /**
   * Commit transaction (finalize).
   * Creates new version with Committed status.
   */
  commitTransaction: Transaction;
  /** Compensate SAGA execution (life-critical rollback with full validation) */
  compensateSaga: SagaExecutionResponse;
  /**
   * Compile DSL source to JDM format
   *
   * Parses the WHEN/THEN DSL source and compiles it to JDM (JSON Decision Model)
   * format suitable for zen-engine evaluation.
   *
   * # Arguments
   *
   * * `input` - DSL source and optional field/action validation lists
   *
   * # Returns
   *
   * Compilation result with JDM JSON, AST, or errors
   *
   * # Example
   *
   * ```graphql
   * mutation {
   * compileDsl(input: {
   * source: "WHEN confidence >= 0.95 THEN auto_approve"
   * }) {
   * success
   * jdm
   * ruleCount
   * inputFields
   * }
   * }
   * ```
   */
  compileDsl: DslCompilationResult;
  /**
   * Complete a single field during step-through signing.
   *
   * Called once per field as the signer walks through their placed fields.
   * When all fields for a participant are completed, the participant's
   * overall signature is automatically recorded.
   */
  completeCeremonyField: SigningCeremony;
  /**
   * Mark attestation as complete
   *
   * Called after all PII records have been stored.
   *
   * Requires: pii:import scope and MFA (Tier 2)
   */
  completePiiAttestation: CompleteAttestationResult;
  completeTask?: Maybe<Receipt>;
  /**
   * Complete a task for an actor.
   *
   * Requires: `actor:write` scope
   */
  completeTaskForActor: Actor;
  /**
   * Complete a verified witness request (operator action after witness verification).
   *
   * Requires Tier 4 authentication (hardware key + witness verification).
   * The completion token from verify_witness_request must be provided.
   */
  completeWitnessRequest: WitnessRequestGql;
  /**
   * AI-powered workflow composition via Claude Agent SDK (DRR-168).
   *
   * The agent validates all suggestions against FERP's composition engine,
   * regulatory DAG, and conflict detection before returning them.
   *
   * Multi-turn: pass `sessionMessages` from the previous response to
   * continue a conversation (max 20 turns per session).
   *
   * Requires: `agent:compose` scope — architect/admin only.
   * Non-critical: returns error if agent service is unavailable.
   *
   * Flow: Validate auth → Mint service JWT → Call agent service
   * → Agent uses tools to validate against FERP → Return suggestions
   */
  composeWorkflow: ComposeWorkflowResponse;
  /**
   * Apply an auto-fix for a detected anti-pattern
   *
   * This mutation:
   * 1. Validates the anti-pattern applies to the current context
   * 2. Generates new primitives with default configurations
   * 3. Links them to existing primitives as specified
   * 4. Re-validates to confirm the fix resolved the issue
   *
   * # Authorization
   * Requires: `composition:write` scope
   *
   * # Tenant Isolation
   * Uses `auth_ctx.tenant` for context (ignores input.tenant_id for security)
   *
   * # Arguments
   * * `input` - Auto-fix input containing anti-pattern ID and context
   *
   * # Returns
   * * Details of added/modified primitives and validation status
   *
   * # Example Mutation
   * ```graphql
   * mutation ApplyFix($input: ApplyAutoFixInput!) {
   * applyAntiPatternFix(input: $input) {
   * antiPatternId
   * addedPrimitives {
   * primitiveType
   * primitiveId
   * linkedTo
   * }
   * validationPassed
   * remainingWarnings {
   * severity
   * message
   * }
   * }
   * }
   * ```
   *
   * # Notes
   * - Critical fixes (e.g., Formula #4 Saga Checkpoint) require confirmation
   * - The client should prompt the user before applying requiresConfirmation fixes
   */
  compositionApplyAntiPatternFix: AppliedAutoFixResult;
  /**
   * Create a new anti-pattern (tenant-specific or system)
   *
   * Creates a new anti-pattern definition. Use tenant_id="system" for system-wide patterns.
   *
   * # Authorization
   * Requires: `antipattern:write` scope
   * For system patterns: Also requires `tenant:admin` scope
   *
   * # Tenant Isolation
   * - "system" tenant patterns require tenant:admin scope
   * - Tenant-specific patterns created within authenticated tenant
   *
   * # Arguments
   * * `input` - Anti-pattern creation input
   *
   * # Example Mutation
   * ```graphql
   * mutation CreateAntiPattern($input: CreateAntiPatternInput!) {
   * createAntiPattern(input: $input) {
   * id
   * name
   * severity
   * }
   * }
   * ```
   */
  compositionCreateAntiPattern: AvailableAntiPatternFix;
  /**
   * Delete an anti-pattern (soft delete)
   *
   * Soft-deletes an anti-pattern by setting enabled=false.
   * The pattern remains in DynamoDB for audit purposes.
   *
   * # Authorization
   * Requires: `antipattern:delete` scope (defense-in-depth: separate from write)
   * For system patterns: Also requires `tenant:admin` scope
   *
   * # Tenant Isolation
   * - "system" tenant patterns require tenant:admin scope
   * - Tenant-specific patterns only deletable by that tenant
   *
   * # Arguments
   * * `tenant_id` - Tenant identifier
   * * `id` - Anti-pattern identifier
   */
  compositionDeleteAntiPattern: Scalars['Boolean']['output'];
  /**
   * Link custom rules to a formula (tenant customization)
   *
   * # Authorization
   * Requires: `composition:write` scope
   *
   * # Tenant Isolation
   * Rules are linked within the authenticated user's tenant context.
   *
   * # Arguments
   * * `tenant_id` - IGNORED for security (uses auth_ctx.tenant)
   * * `formula_number` - Formula to link rules to
   * * `activation_rule_ids` - Optional activation rule IDs
   * * `anti_pattern_rule_ids` - Optional anti-pattern rule IDs
   * * `action_rule_ids` - Optional action rule IDs
   */
  compositionLinkRulesToFormula: Scalars['Boolean']['output'];
  /**
   * Seed system anti-patterns from defaults
   *
   * Seeds the system anti-patterns from the default definitions.
   * This is idempotent - calling multiple times only inserts new patterns.
   *
   * # Authorization
   * Requires: `tenant:admin` scope (system-wide operation)
   *
   * # Returns
   * * Number of patterns that were actually inserted
   */
  compositionSeedSystemAntiPatterns: Scalars['Int']['output'];
  /**
   * Update an existing anti-pattern
   *
   * Updates specified fields of an existing anti-pattern.
   * Only provided fields are updated; others remain unchanged.
   *
   * # Authorization
   * Requires: `antipattern:write` scope
   * For system patterns: Also requires `tenant:admin` scope
   *
   * # Tenant Isolation
   * - "system" tenant patterns require tenant:admin scope
   * - Tenant-specific patterns only updatable by that tenant
   *
   * # Arguments
   * * `input` - Anti-pattern update input
   */
  compositionUpdateAntiPattern: AvailableAntiPatternFix;
  /**
   * Compress a hydrated ID to storage format
   *
   * Converts `tenant-1#payroll_run-156` to `pay!1R156`
   */
  compressId: GqlCompressResult;
  /**
   * Compute a form field value on the server.
   *
   * Used for SERVER_CACHED and SERVER_LIVE computed fields.
   * CLIENT-tier fields should be computed in the frontend and this
   * mutation will reject them with an error.
   */
  computeFieldValue: GqlComputedResult;
  /** Connect two composed components with an edge */
  connectComponents: ComponentEdgeGql;
  /**
   * Convert Chaos Document to Metadata DSL Template
   *
   * FERP Principles:
   * - Repository pattern: Get chaos document from ChaosDocumentRepository
   * - Data-driven: All conversion logic from ChaosToMetadataDSLConverter service
   * - Life-critical: Complete audit trail for AI-generated templates
   * - Domain-agnostic: Works for all domains via metadata
   *
   * Phase 12 Foundation: Automatic template generation from chaos ingestion
   */
  convertChaosToDsl: MetadataTemplateConversionResult;
  /**
   * Create a new actor.
   *
   * Requires: `actor:write` scope
   */
  createActor: Actor;
  /** Create a new analytics metric with backend Snowflake ID */
  createAnalytics: Analytics;
  /**
   * Create a new annotation on an entity.
   *
   * Requires `annotation:write` or `annotation:admin` scope.
   *
   * If `parentId` is provided, creates a reply. The thread_root_id and depth
   * are automatically computed from the parent annotation.
   *
   * @mentions in the `mentions` field trigger notifications to the mentioned actors
   * via the existing Notification primitive.
   */
  createAnnotation: GqlAnnotation;
  /** Create a new architect proposal (tenant architect) (DRR-227) */
  createArchitectProposal: ArchitectProposal;
  /**
   * Create a new audit record
   * Requires: `audit:write` scope (DRR-102)
   */
  createAudit: AuditQl;
  /**
   * Create audit from Metadata DSL template (FERP integration point 1)
   * Requires: `audit:write` scope (DRR-102)
   */
  createAuditFromTemplate: AuditQl;
  /**
   * Instantiate a signing ceremony from a saved template.
   *
   * `participant_emails` must be parallel to `template.participants` order.
   * Empty string skips an optional slot; required slots must have a non-empty email.
   */
  createCeremonyFromTemplate: SigningCeremony;
  /** Create a new reusable ceremony template. */
  createCeremonyTemplate: CeremonyTemplateGql;
  /**
   * Create standard checkpoint.
   *
   * **Use Case**: Manual checkpoint creation for workflow resume points
   *
   * # Arguments
   *
   * * `input` - Checkpoint creation parameters
   */
  createCheckpoint: Checkpoint;
  /**
   * Create a new communication log entry.
   * Creates an audit trail of QP/supervisor contacts.
   */
  createCommunicationLog: CommunicationLog;
  /**
   * Create a new FHIR Condition
   *
   * Issue #27: 5-Step Write Pattern (Valkey → Medplum → S3 → INDEX → Valkey)
   * Active conditions requiring care plans are indexed as work items
   */
  createCondition: FhirCondition;
  /**
   * Create a new constraint.
   *
   * Requires: `constraint:write` or `constraint:admin` scope
   */
  createConstraint: Constraint;
  /**
   * Create a new contract
   *
   * Requires `contract:write` or `contract:admin` scope
   */
  createContract: Contract;
  /**
   * Create new domain metadata (system administrators only)
   * Requires: `metadata:write` scope (DRR-102)
   */
  createDomainMetadata: DomainMetadataGql;
  /**
   * Create a new FHIR Encounter
   *
   * Issue #27: 5-Step Write Pattern (Valkey → Medplum → S3 → INDEX → Valkey)
   * 0. Valkey: Rate limit + Idempotency check
   * 1. Medplum: Write FHIR R4 projection (read model for FHIR queries)
   * 2. S3/Wasabi: Write immutable fact (SOURCE OF TRUTH)
   * 3. DynamoDB: Write INDEX projection (for myWork dashboard)
   * 4. Valkey: Mark completed + Invalidate caches
   */
  createEncounter: FhirEncounter;
  /** Create a new entity */
  createEntity: GenericEntity;
  /** Create expert Actor with safety validation (life-critical) */
  createExpertWithSafetyValidation: ActorGql;
  /**
   * Create a FHIR resource via the dual-write pipeline (DRR-080)
   *
   * Write order depends on FHIR_DUAL_WRITE_MODE:
   * - medplum_primary: Medplum first, DynamoDB shadow
   * - dynamodb_primary: DynamoDB first, Medplum shadow
   * - dynamodb_only: DynamoDB only (no Medplum)
   */
  createFhirStorageResource: FhirStoredResourceType;
  /**
   * Create a new FHIR resource in DynamoDB storage (DRR-080)
   *
   * Creates version 1 of the resource. For immutable resources
   * (Observation, MedicationAdministration), this is the only version.
   */
  createFhirStoredResource: FhirStoredResource;
  /**
   * Create a new form schema.
   *
   * Creates a base schema for a subgraph entity.
   * Requires admin privileges.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * createFormSchema(input: {
   * subgraph: "fhir"
   * entityType: "Patient"
   * version: "1.0.0"
   * displayName: "Patient Registration"
   * safetyLevel: CRITICAL
   * fields: [
   * {
   * name: "firstName"
   * path: "name.given[0]"
   * fieldType: TEXT
   * label: "First Name"
   * required: true
   * piiClassification: L1G_USER_OR_GUARDIAN
   * auditRequired: true
   * maskOnDisplay: false
   * }
   * ]
   * layout: {
   * layoutType: "single-page"
   * sections: [
   * { id: "demographics", title: "Demographics", fields: ["firstName"] }
   * ]
   * }
   * }) {
   * subgraph
   * entityType
   * version
   * }
   * }
   * ```
   */
  createFormSchema: FormSchema;
  /** Create a new draft for editing */
  createFormSchemaDraft: FormSchemaDraftOutput;
  /**
   * Create a new incident report.
   * Triggers notification workflow for safety concerns.
   */
  createIncident: Incident;
  /** Create a new integration with backend Snowflake ID */
  createIntegration: Integration;
  /**
   * Record a journey audit event (break-glass, emergency override, etc.).
   *
   * This is a life-safety mutation that:
   * 1. Writes to the Audit primitive for compliance trail
   * 2. Optionally creates a 24-hour review task
   */
  createJourneyAuditEvent: JourneyAuditEvent;
  /**
   * Create a MedicationAdministration (record medication given to patient)
   *
   * This records when a medication was actually administered to a patient,
   * typically during an inpatient stay or clinical visit.
   */
  createMedicationAdministration: FhirMedicationAdministration;
  /**
   * Create a MedicationDispense (fill/refill a prescription)
   *
   * This records a fill or refill of an existing MedicationRequest.
   * Each dispense decrements the refills_remaining count.
   */
  createMedicationDispense: FhirMedicationDispense;
  /**
   * Create a MedicationRequest (prescription)
   *
   * This creates a new prescription in Medplum with refill tracking.
   * The number_of_repeats_allowed field determines how many refills are allowed.
   */
  createMedicationRequest: FhirMedicationRequest;
  /**
   * Create new notification.
   *
   * Requires `notification:write` or `notification:admin` scope
   */
  createNotification: Notification;
  /**
   * Create a new FHIR Observation
   *
   * Issue #27: 5-Step Write Pattern (Valkey → Medplum → S3 → INDEX → Valkey)
   * Only observations flagged for review (abnormal values) are indexed as work items
   */
  createObservation: FhirObservation;
  /** Create a new orchestration pattern */
  createOrchestrationPattern: OrchestrationPattern;
  /** Create new version of pattern (append-only) */
  createOrchestrationPatternVersion: OrchestrationPattern;
  /** Create a new orchestration rule */
  createOrchestrationRule: OrchestrationRule;
  /**
   * Create new version of rule (FERP Append-Only)
   *
   * Creates a NEW version of the rule. Previous version preserved for audit.
   */
  createOrchestrationRuleVersion: OrchestrationRule;
  /** Create a new food order — spawns wf-7-0-1 workflow instance */
  createOrder: FoodServiceOrder;
  /**
   * Create a new FHIR Patient (proxies to Medplum)
   *
   * Issue #30/#31: Generates FERP compressed ID BEFORE Medplum call
   * Issue #22: Emits PatientCreated event for event sourcing
   * Issue #31: Registers patient in lifecycle registry
   */
  createPatient: FhirPatient;
  /**
   * Create a Patient using the Dual-Purpose Outbox Pattern (FPF-004)
   *
   * This mutation demonstrates the FPF-004 architecture:
   * 1. Write FHIR resource to S3 (source of truth with WORM retention)
   * 2. Write metadata to DynamoDB in atomic transaction with outbox item
   * 3. Return immediately - background processor syncs to Medplum
   *
   * The outbox processor polls DynamoDB and:
   * - Executes pending outbox items against Medplum
   * - Retries failures with exponential backoff
   * - Moves permanently failed items to DLQ
   * - Marks completed items for cleanup via TTL
   */
  createPatientViaOutbox: Scalars['String']['output'];
  /**
   * Create PII attestation before bulk import
   *
   * This is the legal record that someone attested to the data source.
   * Must be called BEFORE storing any PII records.
   *
   * Requires: pii:import scope and MFA (Tier 2)
   */
  createPiiAttestation: CreateAttestationResult;
  /**
   * Create new policy.
   *
   * **FERP Integration**:
   * - RBAC: Requires 'policy_admin' or 'workflow_admin' role
   * - Monitoring: Tracks creation event via track_change()
   * - Validation: Full policy validation before creation
   */
  createPolicy: Policy;
  /**
   * Create policy rule
   *
   * Creates new policy rule with backend-generated Snowflake ID
   */
  createPolicyRule: PolicyRule;
  /**
   * Create a new FHIR Procedure
   *
   * Issue #27: 5-Step Write Pattern (Valkey → Medplum → S3 → INDEX → Valkey)
   * Active procedures (in-progress, preparation) are indexed as work items
   */
  createProcedure: FhirProcedure;
  createQueue: Queue;
  createResource: Resource;
  /**
   * Create new role.
   *
   * Requires scope: role:write or role:admin
   */
  createRole: Role;
  /** Create new role template */
  createRoleTemplate: RoleTemplate;
  /**
   * Create new version of template (FERP Append-Only)
   *
   * This mutation creates a NEW version of the template.
   * The previous version is preserved for complete audit trail.
   *
   * FERP Append-Only Semantics:
   * - Previous versions remain accessible via `getRoleTemplateVersion`
   * - Version number is auto-incremented
   * - All version history preserved for compliance
   *
   * Example:
   * ```graphql
   * mutation {
   * createRoleTemplateVersion(
   * templateId: "tmpl_123",
   * input: { ... }
   * ) {
   * templateId
   * version  # Returns new version number
   * updatedAt
   * }
   * }
   * ```
   */
  createRoleTemplateVersion: RoleTemplate;
  /**
   * Create saga compensation checkpoint (Formula #4).
   *
   * **Use Case**: Distributed saga transaction rollback points
   *
   * # Arguments
   *
   * * `input` - Saga compensation parameters
   */
  createSagaCompensationCheckpoint: Checkpoint;
  /** Create saga transaction (Formula #4 constructor). */
  createSagaTransaction: Transaction;
  /**
   * Create a new schedule.
   *
   * Requires `schedule:write` or `schedule:admin` scope
   */
  createSchedule: Schedule;
  /** Create a new signing ceremony for a document. */
  createSigningCeremony: SigningCeremony;
  /**
   * Create new subgraph metadata
   *
   * **Required Role**: Admin (creating subgraphs affects system architecture)
   *
   * Note: Routes, nav items, and entity types are added via separate mutations
   * to keep the API manageable.
   */
  createSubgraphMetadata: SubgraphMetadata;
  /** Create a new system tenant (admin only) */
  createSystemTenant: SystemTenant;
  /** Create a new system user (admin only) */
  createSystemUser: SystemUser;
  /**
   * Create a new team.
   *
   * Requires `team:write` or `team:admin` scope
   */
  createTeam: Team;
  /**
   * Create new template metadata
   * Requires: `metadata:write` scope (DRR-102)
   */
  createTemplateMetadata: TemplateMetadataOutput;
  /**
   * Create tenant branding
   *
   * Creates new tenant branding with audit trail
   */
  createTenantBranding: TenantBranding;
  /**
   * Create new trace (manual creation - typically system-generated via integration helpers).
   *
   * **Use Case**: Manual trace creation for testing or external system integration
   *
   * **Note**: In production, traces are typically created automatically via:
   * - `Trace::workflow_start_trace()` - In Instance::start()
   * - `Trace::task_execution_trace()` - In Task::execute()
   * - `Trace::ai_decision_trace()` - In AIActor::make_decision()
   *
   * # Arguments
   *
   * * `input` - Trace creation input (all required fields)
   *
   * # Returns
   *
   * Created trace with backend-generated Snowflake ID
   */
  createTrace: Trace;
  /** Create new validation. */
  createValidation: Validation;
  /**
   * Create a new version of subgraph metadata (APPEND-ONLY)
   *
   * **FERP Append-Only Architecture**: Instead of UPDATE, we create a new version.
   * The previous version remains in the audit trail for compliance/forensics.
   *
   * **Required Role**: Admin (or Architect for life-critical subgraphs)
   *
   * **Note**: The old version is preserved. Use `listSubgraphMetadataVersions` to
   * view the full history (future query).
   */
  createVersionSubgraphMetadata: SubgraphMetadata;
  /**
   * Create a witness request for a Tier 4 life-critical operation.
   *
   * Requires Tier 3+ authentication (hardware security key).
   * The request will be visible to potential witnesses for verification.
   */
  createWitnessRequest: CreateWitnessRequestPayload;
  /** Create a new workflow. */
  createWorkflow: Workflow;
  /** Create workflow graph */
  createWorkflowGraph: WorkflowGraph;
  /** Deactivate an orchestration rule (append-only soft delete) */
  deactivateOrchestrationRule: OrchestrationRule;
  /**
   * Deactivate a Patient (sets Patient.active = false)
   *
   * This is a soft-delete operation - the patient record is NOT physically deleted.
   * Use this when a patient should no longer appear in active lists but their
   * historical data must be preserved for compliance.
   *
   * ## Audit Trail
   *
   * A DeactivationEvent is stored in S3 as the immutable source of truth.
   */
  deactivatePatient: FhirPatient;
  /**
   * Deactivate a product for a tenant (convenience for setting status to Suspended).
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * deactivateProduct(tenantNum: 2, productId: "prod-1-001") {
   * success
   * tenantProduct { provisioningStatus }
   * }
   * }
   * ```
   */
  deactivateProduct: ProductActivationResult;
  /** Deactivate validation (creates new version with active=false). */
  deactivateValidation: Validation;
  /**
   * Deactivate a workflow (creates new version with active=false).
   * Append-only: Loads existing workflow and creates new version with updated state.
   */
  deactivateWorkflow: Workflow;
  /** Decline a signing ceremony. */
  declineCeremony: SigningCeremony;
  decommissionResource: Resource;
  /** Decompress a compressed ID to Snowflake format */
  decompressId: DecompressIdResult;
  /**
   * Decrypt an AES-256-GCM encrypted document using KMS envelope decryption.
   *
   * Retrieves the KMS-encrypted data key blob from S3 (companion `.kmsblob` object),
   * calls KMS Decrypt to recover the plaintext AES key, then decrypts the PDF blob.
   */
  decryptDocument: DecryptDocumentResult;
  delegateTask?: Maybe<InboxTask>;
  /**
   * Delete a registered biometric credential
   *
   * # Use Case
   * - User lost device
   * - User upgrading device
   * - Security policy requires credential rotation
   */
  deleteBiometricCredential: Scalars['Boolean']['output'];
  /** Delete a ceremony template. Existing ceremonies created from this template are unaffected. */
  deleteCeremonyTemplate: Scalars['Boolean']['output'];
  /** Delete chaos document (soft delete) */
  deleteChaosDocument: Scalars['Boolean']['output'];
  /** Delete draft */
  deleteDraft: Scalars['Boolean']['output'];
  /** Delete many drafts */
  deleteDraftMany: Scalars['Int']['output'];
  /** Delete an entity (soft delete with audit trail) */
  deleteEntity: Scalars['Boolean']['output'];
  /**
   * Delete tenant-specific override.
   *
   * Reverts to base schema for the tenant.
   */
  deleteFormSchemaOverride: Scalars['Boolean']['output'];
  /** Delete a system user (soft delete, admin only) */
  deleteSystemUser: Scalars['Boolean']['output'];
  /**
   * **DEPRECATED (Issue #671)**: Use `archiveTemplate` instead.
   *
   * This mutation performs hard delete which violates append-only architecture.
   * For FERP compliance, use `archive_template` which provides proper
   * soft-delete with audit trail.
   *
   * # Migration Guide
   *
   * ```graphql
   * # OLD (DEPRECATED):
   * mutation { deleteTemplateMetadata(tenant: "...", templateId: "...", version: "...") }
   *
   * # NEW (RECOMMENDED):
   * mutation { archiveTemplate(tenant: "...", templateId: "...", reason: "...") { success } }
   * ```
   */
  deleteTemplateMetadata: Scalars['Boolean']['output'];
  /**
   * Delete tenant branding
   *
   * Deletes tenant branding (soft delete with audit trail)
   */
  deleteTenantBranding: Scalars['Boolean']['output'];
  /** Delete a registered webhook endpoint (D1). */
  deleteWebhookEndpoint: Scalars['Boolean']['output'];
  /** Deny a BLOCKED override. Architect-only. */
  denyTerminologyOverride: StoredTerminologyOverride;
  /**
   * Add dependencies in batch (workflow creation).
   *
   * **FERP Integration**:
   * - RBAC: Requires 'workflow_designer' or 'workflow_admin' role
   * - Monitoring: Tracks batch creation event
   */
  dependencyApiAddDependenciesBatch: Array<Dependency>;
  /**
   * Archive dependency (FERP Append-Only Architecture)
   *
   * **REPLACES**: `deleteDependency` - physical deletion is NOT allowed
   *
   * Archives a dependency with mandatory reason for audit compliance.
   * FERP Principle: Immutable history for life-critical workflows.
   *
   * **FERP Integration**:
   * - RBAC: Requires 'workflow_designer' or 'workflow_admin' role
   * - Monitoring: Tracks archive event with full audit trail
   */
  dependencyApiArchiveDependency: DependencyArchiveResult;
  /**
   * Create new dependency.
   *
   * **FERP Integration**:
   * - RBAC: Requires 'workflow_designer' or 'workflow_admin' role
   * - Monitoring: Tracks creation event via track_change()
   * - Validation: Full dependency validation before creation
   */
  dependencyApiCreateDependency: Dependency;
  /**
   * Rebuild workflow DAG (after dependency changes).
   *
   * This is a metadata operation - returns the rebuilt DAG representation.
   */
  dependencyApiRebuildWorkflowDag: WorkflowDag;
  /**
   * Deposit funds — initiate Moov ACH pull, mint payment tokens
   *
   * Flow: Validate → BankingGateway POST /deposit → XADD mint transfer → journal entry
   * Requires: `ledger:write` scope (DRR-102)
   */
  depositFunds: LedgerTransfer;
  /**
   * Deprecate an actor.
   *
   * Requires: `actor:admin` scope
   */
  deprecateActor: Actor;
  /**
   * Deprecate policy (soft delete via is_active=false - APPEND-ONLY).
   *
   * **FERP Integration**:
   * - RBAC: Requires 'policy_admin' or 'workflow_admin' role
   * - Monitoring: Tracks deprecation event
   * - APPEND-ONLY: Creates new version with is_active=false (no physical delete)
   */
  deprecatePolicy: Policy;
  /**
   * Deprecate template (FERP Append-Only soft delete)
   *
   * Creates a new version with status=Deprecated.
   * Previous versions remain accessible for audit trail.
   *
   * FERP Append-Only Semantics:
   * - Does NOT delete the template
   * - Creates a new version with Deprecated status
   * - All previous versions preserved
   *
   * Returns the deprecated template with new version number.
   */
  deprecateRoleTemplate: RoleTemplate;
  dequeueTask?: Maybe<Scalars['String']['output']>;
  /**
   * Disable a constraint.
   *
   * Requires: `constraint:admin` scope
   *
   * NOTE: This creates a new version with active=false (append-only)
   */
  disableConstraint: Constraint;
  /**
   * Disable policy (creates new version with enabled=false - APPEND-ONLY).
   *
   * **FERP Integration**:
   * - RBAC: Requires 'policy_admin' role
   * - Monitoring: CRITICAL tracking (affects system behavior)
   * - APPEND-ONLY: Creates new version with enabled=false
   */
  disablePolicy: Policy;
  /**
   * Disable a schedule.
   *
   * Requires `schedule:write` or `schedule:admin` scope
   */
  disableSchedule: Schedule;
  /**
   * Disable a subgraph (keeps configuration but prevents use)
   *
   * LIFE-CRITICAL: Disabled subgraphs cannot be referenced in audits.
   */
  disableSubgraph: SubgraphRegistry;
  /** Discard a draft */
  discardFormSchemaDraft: Scalars['Boolean']['output'];
  /**
   * Dismiss a drift alert.
   *
   * Marks an alert as reviewed/dismissed by DON.
   * Requires `assessment:dismiss` scope.
   */
  dismissDriftAlert: Scalars['Boolean']['output'];
  /** Archive document (move to archived status) */
  documentApiArchiveDocument: Document;
  /**
   * Archive document with mandatory reason (FERP Append-Only Architecture)
   *
   * Replaces: deleteDocument (deprecated for append-only compliance)
   * - Soft archive: Sets status to archived with full audit trail
   * - Mandatory reason: Required for compliance (HIPAA, SOX, SOC2)
   * - Returns: DocumentArchiveResult with full audit metadata
   */
  documentApiArchiveDocumentWithReason: DocumentArchiveResult;
  /** Create a new document with backend Snowflake ID */
  documentApiCreateDocument: Document;
  /** Create a new version of the document */
  documentApiCreateDocumentVersion: Document;
  /**
   * Delete document - DEPRECATED (FERP Append-Only Architecture)
   *
   * This mutation is deprecated. Use `archiveDocument` or `archiveDocumentWithReason` instead.
   * FERP Principle: No DELETE operations - use archive instead.
   */
  documentApiDeleteDocument: Document;
  /**
   * Generate a pre-signed S3 upload URL with Content-Type enforcement (DRR-081)
   *
   * Defense-in-depth: Even if the application layer is bypassed, the pre-signed
   * URL forces the client to upload with the declared Content-Type. S3 rejects
   * the upload if the Content-Type header doesn't match.
   *
   * Allowed MIME types: application/pdf, text/plain, text/csv, text/markdown
   */
  documentApiGenerateDocumentUploadUrl: DocumentUploadUrlResult;
  /**
   * Merge multiple PDF documents into one (DRR-079)
   *
   * Pipeline:
   * 1. Load PDFs from S3
   * 2. Merge via lopdf page manipulation
   * 3. Store new merged PDF in S3
   * 4. Create audit record
   */
  documentApiMergeDocuments: MergeDocumentsResult;
  /** Record approval decision on document */
  documentApiRecordDocumentApprovalDecision: Document;
  /**
   * Generate a pre-signed S3 download URL for viewing a document
   *
   * Looks up the document by ID, reads s3_key/s3_bucket, and generates a
   * presigned GET URL. In local dev, rewrites Docker-internal MinIO URLs
   * to browser-reachable `S3_BROWSER_ENDPOINT`.
   */
  documentApiRequestDocumentDownloadUrl: DocumentDownloadUrlResult;
  /**
   * Save PDF annotations to Document.dynamodb_content (DRR-079)
   *
   * Persists annotation JSON array. If payload >300KB, overflows to S3 with
   * pointer in DynamoDB.
   */
  documentApiSavePdfAnnotations: Document;
  /**
   * Sign a PDF document with a visual signature (DRR-079)
   *
   * Pipeline:
   * 1. Load PDF from S3 via presigned URL
   * 2. Embed signature image using lopdf
   * 3. Create PKCS#7 signature using cms crate
   * 4. Sign digest with KMS key via aws-sdk-kms
   * 5. Store new signed PDF version in S3 (immutable, versioned)
   * 6. Create audit record via Document primitive
   */
  documentApiSignDocument: SignDocumentResult;
  /** Submit document for approval */
  documentApiSubmitDocumentForApproval: Document;
  /** Update document status (transitions through workflow) */
  documentApiUpdateDocumentStatus: Document;
  /**
   * Get domain metadata by type and version
   * Requires: `metadata:read` scope (DRR-102)
   */
  domainMetadata?: Maybe<DomainMetadataGql>;
  drainQueue: Queue;
  /**
   * Dry-run policy evaluation
   *
   * Tests policy conditions against sample data without executing actions
   */
  dryRunPolicy: DryRunResult;
  /**
   * AI-powered form schema editing — generates JSON patches with PII classification.
   *
   * Requires: `agent:compose` scope — architect/admin only.
   */
  editFormSchema: ComposeWorkflowResponse;
  elevateForTask?: Maybe<JitGrant>;
  /** Execute emergency control actions */
  emergencyAction: EmergencyActionResult;
  /**
   * Emergency override a regulatory threshold (break-glass)
   * LIFE-CRITICAL: Requires justification and limited duration
   */
  emergencyOverrideRegulatoryThreshold: Scalars['Boolean']['output'];
  /**
   * Enable a constraint.
   *
   * Requires: `constraint:admin` scope
   *
   * NOTE: This creates a new version with active=true (append-only)
   */
  enableConstraint: Constraint;
  /**
   * Enable policy (creates new version with enabled=true - APPEND-ONLY).
   *
   * **FERP Integration**:
   * - RBAC: Requires 'policy_admin' role
   * - Monitoring: CRITICAL tracking (affects system behavior)
   * - APPEND-ONLY: Creates new version with enabled=true
   */
  enablePolicy: Policy;
  /** Enable a previously disabled subgraph */
  enableSubgraph: SubgraphRegistry;
  /** Encrypt a document using AES-256-GCM (Auth-to-Open). */
  encryptDocument: EncryptDocumentResult;
  enqueueTask: Queue;
  /**
   * Enroll a new actor — creates Actor + Instance + Constellation in one action.
   *
   * DRR-174: Single-click enrollment. Product config determines actor type,
   * workflow, and constellation template. Frontend calls this from dashboard button.
   *
   * Requires: scope from product.enrollment.required_scope (default: enrollment:create)
   */
  enrollActor: GqlEnrollmentResult;
  /** Query entities with filtering and pagination */
  entities: GenericEntityConnection;
  /** Get a specific entity by ID */
  entity?: Maybe<GenericEntity>;
  /** Get entity schema for dynamic UI generation */
  entitySchema: Scalars['JSON']['output'];
  /** Get available entity types for a domain */
  entityTypes: Array<Scalars['String']['output']>;
  /** Archive old events (soft delete - preserves audit trail) */
  eventApiArchiveEvents: Scalars['Int']['output'];
  /** Create a new event (immutable audit record) */
  eventApiCreateEvent: Event;
  /** Verify and repair hash chain (admin operation) */
  eventApiVerifyAndRepairChain: GqlEventChainIntegrity;
  /** Execute a DAG workflow with full tracing */
  executeDagWorkflow: DagexecutionResponse;
  /** Execute an action on an entity */
  executeEntityAction: Scalars['JSON']['output'];
  /**
   * AI-powered proposal explanation — generates human-readable summary for architect review.
   *
   * Takes structured proposal fields (NOT raw config) and returns a plain-language
   * explanation of what the proposal does, why it exists, and the impact of approval.
   *
   * DRR-172: Config format never crosses the GraphQL boundary.
   * Requires: `agent:compose` scope — architect only.
   */
  explainConfigProposal: ComposeWorkflowResponse;
  /** Export audit trail to CSV/PDF/JSON (SOX §404) */
  exportAuditTrail: ExportAuditTrailResult;
  /** Export RBAC audit log */
  exportRBACAuditLog: ExportAuditTrailResult;
  /** Export template to JSON */
  exportTemplate: TemplateExportData;
  /**
   * Extend retention period for an audit (regulatory requirement)
   * Requires: `audit:write` scope (DRR-102)
   */
  extendAuditRetention: AuditQl;
  /** Extend an active JIT session */
  extendJITSession: ExtendJitSessionResult;
  /**
   * Extract structured workflow data from an uploaded PDF via Bedrock Claude
   *
   * Downloads the document from Wasabi, sends to Bedrock for analysis,
   * and stores the extraction result on the ChaosDocument for use by
   * convertChaosToDSL.
   */
  extractChaosDocument: ChaosExtractionResult;
  /**
   * Extract PII from a captured image (SSN card, driver's license, etc.)
   *
   * Uses Tesseract OCR + Presidio for local PII detection.
   * If store_in_vault=true, stores encrypted values in PII vault.
   *
   * Requires: pii:capture scope and MFA (Tier 2)
   */
  extractImagePii: ExtractImagePiiResult;
  /**
   * DRR-281 Phase 2: Extract industry terms from association documents via LLM.
   * Architect-only. Outputs tag:advisory:industry-* entries for review.
   */
  extractIndustryTerms: ExtractIndustryTermsResult;
  /**
   * AI-powered statute metadata extraction — parses URL or pasted text to auto-fill form fields.
   *
   * Given a URL or document text, uses Claude to extract:
   * association ref, publication title, year, industry, jurisdiction, and the full document text.
   *
   * DRR-172: Reduces manual data entry for statute ingestion.
   * Requires: `agent:compose` scope — architect only.
   */
  extractStatuteMetadata: StatuteMetadata;
  /**
   * Fill a state agency PDF form with FERP data (DRR-180).
   *
   * Reads the original state PDF, maps FERP data to AcroForm field names
   * using the specified form field map config, and creates a Document
   * primitive with the filled-but-editable PDF.
   *
   * Requires scope: `document:fill_state_form`
   */
  fillStateForm: FillStateFormResult;
  /** Finalize a plan with authority approval. */
  finalizePlan: ServicePlan;
  /**
   * Finish biometric authentication and receive JWT token
   *
   * # Returns
   * - `BiometricAuthenticationSuccess`: JWT token for API access
   *
   * # Frontend Integration
   * ```typescript
   * const assertion = await startAuthentication(JSON.parse(challenge));
   *
   * const { token, userId, tenantId, expiresAt } = await graphql(`
   * mutation {
   * finishBiometricAuthentication(input: {
   * sessionId: "${sessionId}"
   * assertionJson: ${JSON.stringify(assertion)}
   * }) {
   * success
   * token
   * userId
   * tenantId
   * expiresAt
   * }
   * }
   * `);
   *
   * // Store token in localStorage or secure cookie
   * localStorage.setItem('authToken', token);
   * ```
   */
  finishBiometricAuthentication: BiometricAuthenticationSuccess;
  /**
   * Finish biometric registration after credential creation
   *
   * # Returns
   * - `BiometricRegistrationSuccess`: Registration confirmation
   *
   * # Frontend Integration
   * ```typescript
   * const credential = await startRegistration(JSON.parse(challenge));
   *
   * const result = await graphql(`
   * mutation {
   * finishBiometricRegistration(input: {
   * userId: "user123"
   * credentialJson: ${JSON.stringify(credential)}
   * deviceName: "iPhone 14 Pro"
   * }) {
   * success
   * credentialId
   * deviceName
   * registeredAt
   * }
   * }
   * `);
   * ```
   */
  finishBiometricRegistration: BiometricRegistrationSuccess;
  /**
   * Flatten an XFA PDF to a standard PDF for browser preview (DRR-180).
   *
   * Takes a source PDF reference (seed state-form filename without extension)
   * and returns a Document primitive with the flattened PDF. No field filling —
   * just converts XFA layout to standard PDF text/graphics.
   *
   * Use case: previewing state government XFA forms in the browser without
   * Adobe Reader and without needing a form field map config.
   *
   * Requires scope: `document:fill_state_form` or `document:admin`
   */
  flattenXfaPreview: FlattenXfaPreviewResult;
  /**
   * Manually flush staged safety events from Redis to DynamoDB
   * LIFE-CRITICAL: Background job runs every 60s, this allows manual flush for critical events
   */
  flushSafetyEvents: Scalars['Int']['output'];
  /**
   * Create a new formula.
   *
   * Requires scope: formula:write or formula:admin or tenant_admin role
   */
  formulaRegistryCreateFormula: GqlDataDrivenFormula;
  /**
   * Delete formula (soft delete by disabling).
   *
   * Requires scope: formula:admin or tenant_admin role
   */
  formulaRegistryDeleteFormula: Scalars['Boolean']['output'];
  /**
   * Seed built-in formulas for a tenant.
   *
   * Requires scope: formula:admin or tenant_admin role
   */
  formulaRegistrySeedBuiltinFormulas: GqlSeedFormulasResult;
  /**
   * Update formula (creates new version).
   *
   * Requires scope: formula:write or formula:admin or tenant_admin role
   */
  formulaRegistryUpdateFormula: GqlDataDrivenFormula;
  /**
   * Generate ACH file for payment source.
   *
   * This is an idempotent operation. If the same idempotency_key is provided,
   * the previous result will be returned.
   *
   * Requires: `ach_processor` role
   *
   * # Arguments
   *
   * * `input` - ACH file generation parameters
   *
   * # Returns
   *
   * Generated ACH file metadata with S3 location.
   *
   * # Errors
   *
   * - `FORBIDDEN`: Missing `ach_processor` role
   * - `NOT_FOUND`: Source entity not found
   * - `VALIDATION`: No payment entries or invalid data
   * - `EXTERNAL_SERVICE`: edi-service or subgraph failure
   */
  generateAchFile: GqlAchFile;
  /**
   * Generate an ALF admission document PDF and write a Document primitive (DRR-131 / MN 144G)
   *
   * Renders one of the four MN 144G admission templates, uploads to S3 under
   * `tenants/{tenant}/admissions/{instance_id}/`, and writes a Document primitive with:
   * - `document_type: File` (legal document, not an internal report)
   * - `current_status: Pending` (awaits resident / representative signing)
   * - `workflow_instance_id` linked to the admission workflow instance
   * - `regulatory_rule_ids` linking to the MN 144G rules this document satisfies
   *
   * The caller is responsible for building `dataContextJson` from the facility Actor
   * metadata and the admission record fields — matching the `{{variable}}` keys in the template.
   */
  generateAdmissionPdf: GenerateReportPdfResult;
  /**
   * DRR-189 P5: Generate an advisory recommendation via LLM analysis.
   * Architect-only. Delegates to advisory_generator module.
   */
  generateAdvisory: GenerateAdvisoryResult;
  /**
   * Generate advocacy position by aggregating T1 tenant feedback into T2 (DRR-148).
   *
   * This is the ONLY code path that crosses the T1→T2 boundary.
   *
   * ## Authorization (H4)
   *
   * `RequireScope("advocacy:generate")` — architect-only scope.
   * Tenant actors CANNOT call this. Only system actors with the advocacy:generate
   * scope can trigger aggregation. Produces an audit event (mutation → T1 audit).
   *
   * ## Privacy Guarantee (H1 + H2 + H3)
   *
   * - H1: Output written to `PK = ~0` (system partition — no tenant FK)
   * - H2: k-anonymity applied before write (buckets < 5 contributors suppressed)
   * - H3: Output type `AdvocacyDocument` has only enum fields — no tenant data possible
   *
   * ## NEVER ALLOW
   *
   * Do NOT add a `tenantId` argument to this mutation.
   * Do NOT log raw T1 feedback content during aggregation.
   */
  generateAdvocacyPosition: AdvocacyPosition;
  /**
   * Generate compliance report for an audit
   * Requires: `audit:write` scope (DRR-102)
   */
  generateAuditReport: AuditReportQl;
  /**
   * Generate a batch of PDFs from a template and data rows (DRR-079)
   *
   * Pipeline:
   * 1. Load template from DynamoDB
   * 2. Parse template YAML with ferp-pdf
   * 3. Render each row using BatchPdfProcessor
   * 4. Upload results to S3 under `batch-{id}/` prefix
   * 5. Return per-row results with S3 keys
   */
  generateBatchPdfs: GenerateBatchPdfsResult;
  /**
   * Manually regenerate the evidence certificate for a completed ceremony (C3).
   *
   * Useful if the auto-generation at completion time failed.
   */
  generateCeremonyEvidenceCertificate: SigningCeremony;
  /**
   * Generate draft config proposals from DRR-172 coverage gaps.
   *
   * Reads `requires:` blocks from rules in a ruleset, identifies unmet
   * requirements (task groups/workflows that don't exist), and generates
   * draft YAML proposals for architect review.
   *
   * Industry-agnostic: works for any ruleset in any product.
   * The proposals are saved to `proposals/` (filesystem) for review,
   * NOT auto-seeded. Architect must approve via `approveConfigProposal`.
   *
   * ## Pipeline
   *
   * ```text
   * requires: gap detected
   * → LLM generates draft YAML from gap spec
   * → saved to proposals/{type}/{id}.yaml
   * → architect reviews in Fragment Composer (DRR-171)
   * → approved → moves to seed/ → becomes operational
   * ```
   */
  generateConfigProposals: GenerateProposalsResult;
  /**
   * Generate a printable daily shift task sheet PDF (paper-bridge adoption feature).
   *
   * Fetches active tasks for the given team actor + date + shift, renders the
   * `pdf-tpl-hc-daily-task-sheet-001` template, uploads to S3, and returns a
   * pre-signed URL for the staff member to open/print.
   *
   * The PDF footer includes a QR code pointing to `/attest/{shift_token}` so
   * staff can scan the printed sheet to record bulk completion digitally.
   *
   * Per DRR-128 (write-time minimization): resident names are printed as
   * "First L." (first name + last initial only). No staff IDs are printed.
   *
   * Data tier: T2 (operational). The Document primitive expires after 1 year.
   * The printed sheet itself is ephemeral — discard after shift reconciliation.
   */
  generateDailyTaskSheet: GenerateReportPdfResult;
  /**
   * Generate a document asynchronously
   *
   * Dispatches to SQS for processing by Report Engine or Forms Engine.
   * Returns job ID for status tracking.
   */
  generateDocument: GqlDocumentJob;
  /**
   * Generate Emergency Preparedness Manual from survey form checkpoints (DRR-246)
   *
   * This mutation generates a branded EP Manual by pulling requirements from
   * the federal EP ruleset (0-3-001) and survey form checkpoints. The manual
   * is always current — regenerate whenever CMS Appendix Z or MDH supplements change.
   *
   * Pipeline:
   * 1. Load tenant branding (name, logo, address, license, capacity)
   * 2. Load ruleset (0-3-001 for federal EP requirements)
   * 3. Extract EP rules from ruleset member_rules (rl-0-3-001 through rl-0-3-009)
   * 4. Load survey form checkpoints (sf-0-3-001, sf-4-1-001)
   * 5. Load EP task group (tg-4-4-1)
   * 6. Load facility-specific EP data from constellation
   * 7. Render multi-section PDF via ferp-pdf
   * 8. Upload to S3 and create Document primitive
   * 9. Return pre-signed download URL
   */
  generateEpManual: GenerateEpManualResult;
  /**
   * Generate an evidence report for a resident.
   *
   * Creates MDH-ready evidence package for reassessment request.
   * Requires `assessment:report` scope.
   */
  generateEvidenceReport: EvidenceReportGql;
  /**
   * Generate a form schema from a pattern template.
   *
   * Creates and persists a complete `GqlFormSchema` using one of the 12
   * interaction patterns. Optional config overrides allow customization.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * generateFormSchema(
   * subgraph: "ofbiz"
   * entityType: "GlAccount"
   * patternId: HIERARCHICAL
   * ) {
   * subgraph
   * entityType
   * version
   * fields { name fieldType label }
   * }
   * }
   * ```
   */
  generateFormSchema: FormSchema;
  /** Generate edit suggestions from a natural language prompt */
  generateFormSchemaSuggestions: GenerateSuggestionsResult;
  /**
   * Generate centralized Snowflake IDs - Single source of truth for frontend
   * LIFE-CRITICAL: Centralized ID generation for domain-agnostic architecture
   */
  generateId: GenerateIdResult;
  /**
   * Generate AI-powered optimization recommendations for a workflow
   * LIFE-CRITICAL: All recommendations undergo safety validation
   */
  generateOptimizationRecommendations: OptimizationGenerationResponseGql;
  /**
   * Generate a formal ruleset compliance acknowledgment PDF with signature
   * blocks for reviewer, approver, and administrator sign-off.
   *
   * The document is created with `PendingApproval` status (requires signing).
   * When `initiateCeremony` is true, a signing ceremony is created after
   * PDF generation and participants receive signing invitations.
   *
   * Uses the same rich data context as `generateRulesetComplianceReport`
   * (source legislation, member rules, edges, evidence) plus signer names
   * for the signature block sublabels.
   */
  generateRulesetAcknowledgment: GenerateAcknowledgmentResult;
  /**
   * Generate a compliance report PDF for a RuleSet (DRR-131 Phase 1)
   *
   * Fetches the RuleSet metadata, renders a compliance report PDF using the
   * specified template, uploads to S3, and writes a Document primitive with
   * `created_by_source: TenantDecision`.
   */
  generateRulesetComplianceReport: GenerateReportPdfResult;
  /**
   * Generate an individual staff competency record PDF (surveyor-ready)
   *
   * This mutation generates a printable competency verification record for
   * a specific staff member and task group. MDH surveyors request these
   * during 144G compliance surveys to verify staff training.
   *
   * Pipeline:
   * 1. Load staff actor record
   * 2. Load task group config (assessment criteria)
   * 3. Load completed task instance for this staff + task group
   * 4. Load tenant/facility branding
   * 5. Render PDF with criteria checklist and signatures
   * 6. Upload to S3 and create Document primitive
   * 7. Return pre-signed download URL
   *
   * Example: "Show me Maria's Hoyer lift competency record"
   * → generateStaffCompetencyRecord(actorId: "2-cna-001", taskGroupId: "tg-4-13-020")
   */
  generateStaffCompetencyRecord: GenerateStaffCompetencyRecordResult;
  /**
   * Generate a single ID for a subgraph primitive
   *
   * Returns both compressed (storage) and hydrated (API) formats.
   * Uses SubgraphIdRegistry for atomic counter allocation.
   */
  generateSubgraphId: GqlIdGenerationResult;
  /**
   * Generate a batch of IDs for a subgraph primitive
   *
   * Uses SubgraphIdRegistry batch allocation for efficiency.
   */
  generateSubgraphIdBatch: GqlBatchIdGenerationResult;
  /**
   * DRR-189: Generate a per-subject care summary PDF.
   *
   * Aggregates all tasks for a subject actor across all workflow instances,
   * renders a care summary using the specified template, uploads to S3,
   * and writes a Document primitive.
   *
   * Used by the Journey page "Export" button for surveyor evidence.
   */
  generateSubjectCareSummary: GenerateReportPdfResult;
  /** Generate AI-powered guidance for completing a task */
  generateTaskGuidance: GenerateTaskGuidanceResult;
  /**
   * Generate a task instructions PDF for a Task (DRR-131 Phase 1)
   *
   * Fetches the Task primitive, renders an instructions sheet using the specified
   * template, uploads to S3, and writes a Document primitive with
   * `created_by_source: TenantDecision`.
   */
  generateTaskInstructionsPdf: GenerateReportPdfResult;
  /**
   * Generate a training curriculum PDF from regulatory rules (living manual)
   *
   * This mutation generates a branded training curriculum document by pulling
   * requirements from the regulatory ruleset and task groups. The curriculum
   * is always current — regenerate whenever rules change.
   *
   * Pipeline:
   * 1. Load tenant branding (name, logo, address, license)
   * 2. Load ruleset (rs-4-1-004 for MN 144G)
   * 3. Extract training rules from ruleset member_rules
   * 4. Load task groups (tg-4-13-001, tg-4-13-002, tg-4-13-003, tg-4-9-001)
   * 5. Render multi-section PDF via ferp-pdf
   * 6. Upload to S3 and create Document primitive
   * 7. Return pre-signed download URL
   */
  generateTrainingCurriculum: GenerateTrainingCurriculumResult;
  /**
   * Generate a workflow execution summary PDF for a workflow Instance (DRR-131 Phase 1)
   *
   * Fetches the Instance primitive and its task counts, renders an execution summary
   * using the specified template, uploads to S3, and writes a Document primitive with
   * `created_by_source: TenantDecision`.
   */
  generateWorkflowExecutionPdf: GenerateReportPdfResult;
  /**
   * AI-powered task guidance — step-by-step completion with compliance context.
   *
   * Requires: `agent:compose` scope — architect/admin only.
   */
  getAiTaskGuidance: ComposeWorkflowResponse;
  /** Get aggregated analytics summary */
  getAnalyticsSummary: AnalyticsSummary;
  /** Get time-series analytics data */
  getAnalyticsTimeSeries: Array<TimeSeriesPoint>;
  /** Get approval queue for tenant */
  getApprovalQueue: ApprovalQueueResponse;
  /** Get approval workflow instance by ID */
  getApprovalWorkflowInstance?: Maybe<ApprovalWorkflowInstance>;
  /** Get audit statistics for date range */
  getAuditStatistics: AuditStatistics;
  /** Get forensic audit trail with filters (SOX §404) */
  getAuditTrail: AuditTrailResponse;
  /** Get chaos document details */
  getChaosDocumentDetails: ChaosDocumentDetails;
  /**
   * Get a Wasabi presigned PUT URL for uploading a chaos document
   *
   * Returns a presigned URL the frontend can use to upload directly to Wasabi.
   * Follows the same pattern as ceremony document uploads (DRR-091).
   */
  getChaosUploadUrl: ChaosUploadUrlResult;
  /** Get conversion status for document */
  getConversionStatus: ConversionStatus;
  /** Get current active version */
  getCurrentPolicyVersion?: Maybe<PolicyVersion>;
  /** Get the full conversation history for an intake session (DRR-137 Phase 4). */
  getIntakeConversation: Array<IntakeConversationMessage>;
  /** Get latest version of a template */
  getLatestTemplateMetadata?: Maybe<TemplateMetadataOutput>;
  /** Get analytics for specific policy */
  getPolicyAnalytics?: Maybe<PolicyAnalytics>;
  /** Get a specific template by ID */
  getPolicyTemplate?: Maybe<PolicyTemplate>;
  /** Get specific policy version */
  getPolicyVersion?: Maybe<PolicyVersion>;
  /** Get standards pack details */
  getStandardsPackDetails: StandardsPackDetails;
  /** Retrieve a previously-run structured import job by ID. */
  getStructuredImportJob: StructuredImportJob;
  /** Get template by ID and version */
  getTemplateMetadata?: Maybe<TemplateMetadataOutput>;
  /**
   * Get template metadata cache metrics
   *
   * Returns real-time cache performance metrics including hit/miss rates,
   * operation latencies, error rates, and cost savings estimates.
   *
   * **GitHub Issue #325**: Cache metrics instrumentation
   *
   * # Example
   * ```graphql
   * query {
   * getTemplateMetadataCacheMetrics {
   * cacheHitRate
   * avgCacheHitLatencyMs
   * effectivenessScore
   * isMeetingTargets
   * estimatedMonthlySavingsUsd
   * }
   * }
   * ```
   */
  getTemplateMetadataCacheMetrics: TemplateCacheMetrics;
  /** Get template publication status */
  getTemplatePublicationStatus: PublicationStatus | '%future added value';
  /** Get specific template version by version number */
  getTemplateVersion?: Maybe<TemplateVersion>;
  /** Calculate diff between two template versions */
  getTemplateVersionDiff: TemplateVersionDiff;
  /** Get template version history */
  getTemplateVersionHistory: Array<VersionEntryOutput>;
  /** Get version history summary for a template */
  getTemplateVersionHistorySummary: TemplateVersionHistorySummary;
  getTenantId: Scalars['String']['output'];
  /** Get top N policies by metric */
  getTopPolicies: Array<PolicyRanking>;
  /** Calculate diff between two versions */
  getVersionDiff: PolicyVersionDiff;
  /** Get version history summary */
  getVersionHistory: PolicyVersionHistorySummary;
  /** Get workflow compliance status */
  getWorkflowCompliance: WorkflowComplianceStatus;
  /** Grant access to a verifier tenant */
  grantVerifierAccess: GqlVerifierGrant;
  /**
   * Implement an approved optimization recommendation
   * LIFE-CRITICAL: Careful rollout with monitoring and rollback capability
   * Uses staged deployment with automatic rollback on errors
   */
  implementRecommendation: Scalars['Boolean']['output'];
  /**
   * Import a local dev chain using the same pipeline.
   *
   * Uses `device_id = "local_dev:{session_id}"` — identical verification.
   * Requires an import reason for audit trail.
   *
   * Requires: `sync:admin` scope (DRR-102)
   */
  importLocalDevChain: SyncResult;
  /**
   * Import regulatory rules from YAML content
   *
   * Requires `regulatory:import` scope. Also enforced via Cedar policy.
   */
  importRegulatoryRules: GqlBatchImportResult;
  /**
   * Import a new RuleSet into the system.
   *
   * Creates:
   * 1. `CFG#RULESET#{id}` config record in DDB (system tenant)
   * 2. `POLICY#{id}` primitive record for each tenant (DRR-112 dual-write)
   *
   * Requires `regulatory:import` scope (architect / compliance officer).
   */
  importRuleSet: RuleSet;
  /** Import template from JSON */
  importTemplate: ImportResult;
  /**
   * Import a WearableCapture (Vuzix glasses) into the Document Studio chaos pipeline.
   * Registers the existing wearable S3 URI as a ChaosDocument — no re-upload.
   * DRR-128: no data duplication.
   */
  importWearableCaptureToStudio: ImportWearableCaptureResult;
  /** Increment template usage count (atomic operation) */
  incrementTemplateUsage: Scalars['Int']['output'];
  /**
   * Increment constraint usage.
   *
   * Requires: `constraint:write` or `constraint:admin` scope
   *
   * NOTE: This creates a new version with updated usage (append-only)
   */
  incrementUsage: Constraint;
  /**
   * AI-powered document-to-DSL conversion — extracts structured configs from documents.
   *
   * Requires: `agent:compose` scope — architect/admin only.
   */
  ingestDocument: ComposeWorkflowResponse;
  /** Initialize analytics for new policy */
  initializePolicyAnalytics: Scalars['Boolean']['output'];
  /** Initiate bulk operation (process CSV) */
  initiateBulkOperation: BulkOperation;
  /**
   * Initiate a new exchange relationship (Step 1: A initiates)
   *
   * Creates the relationship in PENDING_APPROVAL state and records
   * the first consent step. Requires 5 more approvals to activate.
   */
  initiateExchangeRelationship: ExchangeRelationship;
  /**
   * Initiate a structured CSV import job.
   *
   * Parses the CSV, creates Actor primitives via ActorRepository + UserRegistry,
   * persists the StructuredImportJob record, and returns the completed job.
   *
   * Supports up to 100 rows synchronously (Phase 5 scope).
   * Duplicate rows (same name+type) are idempotent — returns status="skipped".
   */
  initiateStructuredImport: StructuredImportJob;
  /** Cancel instance execution (append-only: creates new version). */
  instanceApiCancelInstance: Instance;
  /**
   * Commit a draft: read from Valkey → write to DDB → start → spawn tasks.
   * Auto-generates instance name: `{workflow} | {subject} | {YYYYMMDD_HHmmss}`.
   */
  instanceApiCommitDraftInstance: Instance;
  /** Complete instance with output data (append-only: creates new version). */
  instanceApiCompleteInstance: Instance;
  /**
   * Create a draft instance in Valkey only (zero DDB cost).
   * Checks reservation key to prevent duplicate active instances for the same
   * subject + workflow. Draft auto-expires via Valkey TTL.
   * Requires: `workflow:create` scope (DRR-197)
   */
  instanceApiCreateDraftInstance: GqlDraftInstanceResult;
  /** Create new instance from workflow definition. */
  instanceApiCreateInstance: Instance;
  /** Fail instance with error information (append-only: creates new version). */
  instanceApiFailInstance: Instance;
  /**
   * Fire a named workflow event to advance the state machine.
   *
   * Validates the event against the workflow YAML transitions, creates an
   * append-only state transition, and executes entry actions for the new state.
   * This is the primary user-facing API for workflow traversal.
   *
   * # Flow
   * 1. Look up instance via Valkey-first
   * 2. Load workflow YAML and find valid transition for (current_state, event_name)
   * 3. Create append-only transition to the target state
   * 4. Execute entry actions for the new state (create tasks, evaluate rules, etc.)
   * 5. Return the new instance version
   */
  instanceApiFireEvent: Instance;
  /** Pause instance execution (append-only: creates new version). */
  instanceApiPauseInstance: Instance;
  /**
   * Record event for instance (for event-driven tracking).
   * Creates a new version via append-only transition.
   */
  instanceApiRecordInstanceEvent: Instance;
  /** Resume paused instance (append-only: creates new version). */
  instanceApiResumeInstance: Instance;
  /**
   * Start instance execution (append-only: creates new version).
   *
   * Accepts optional `workflowDefinitionId` for direct primary-key lookup.
   * Without it, falls back to slow GSI1 scan across all status partitions
   * which can miss newly-created instances due to DynamoDB eventual consistency.
   */
  instanceApiStartInstance: Instance;
  /**
   * Transition instance state (pure append-only).
   *
   * Creates a new instance version with updated state, preserving complete
   * audit trail via parent_id linkage.
   *
   * This is the ONLY way to change instance state in pure append-only architecture.
   *
   * # Arguments
   *
   * * `tenant_id` - Tenant ID
   * * `workflow_definition_id` - Workflow definition ID
   * * `instance_id` - Current instance ID
   * * `input` - Transition details (new_status, new_state, trigger)
   *
   * # Returns
   *
   * New instance version with:
   * - New Snowflake ID
   * - `parent_id` linking to current instance
   * - Incremented `version` number
   * - Updated `status` and `current_state`
   * - New `updated_at` timestamp
   *
   * # Example
   *
   * ```graphql
   * mutation {
   * transitionInstance(
   * tenantId: "healthcare-tenant"
   * workflowDefinitionId: "wf_def_123"
   * instanceId: "inst_abc"
   * input: {
   * newStatus: RUNNING
   * newState: "processing_claim"
   * trigger: "user_started_workflow"
   * }
   * ) {
   * id
   * parentId
   * version
   * status
   * currentState
   * updatedAt
   * }
   * }
   * ```
   */
  instanceApiTransitionInstance: Instance;
  /**
   * Update instance metadata (priority, deadline, tags, etc.).
   * Creates a new version via append-only transition.
   */
  instanceApiUpdateInstance: Instance;
  /** Update instance progress (append-only: creates new version). */
  instanceApiUpdateInstanceProgress: Instance;
  /** Instantiate template into a role */
  instantiateRoleTemplate: RoleDefinition;
  /** Instantiate a template with custom parameter values */
  instantiateTemplate: PolicyTemplateInstance;
  /**
   * AI-assisted intake processing — document classification + entity form pre-fill (DRR-187).
   *
   * Receives pseudonymized text from on-device OCR + Presidio NER pipeline.
   * Claude classifies the document, maps extracted fields to FormSchema definitions,
   * and returns structured proposals for HITL confirmation. The agent NEVER writes
   * directly — all entity creation requires explicit user confirmation.
   *
   * Pipeline: Phone OCR → Presidio NER (hub) → tokenized text → Claude → proposals
   *
   * Requires: `intake:process` scope — front-desk/admissions staff, not architect-only.
   */
  intakeProcess: IntakeProcessResponse;
  /** Invalidate form schema cache */
  invalidateFormSchema: Scalars['Boolean']['output'];
  /**
   * Create a typed edge between two journey/workflow instances.
   *
   * Stores bidirectional Valkey SET indexes for efficient traversal:
   * - Forward: `idx:{tenant}:journey_edge:{source}:{TYPE}` → Set of target IDs
   * - Reverse: `idx:{tenant}:journey_edge:{target}:{INVERSE}` → Set of source IDs
   *
   * # Arguments
   * * `input` - Edge creation details
   *
   * # Example
   * ```graphql
   * mutation {
   * createJourneyEdge(input: {
   * sourceInstanceId: "parent-123"
   * targetInstanceId: "child-456"
   * edgeType: SPAWNED_BY
   * description: "Assessment spawned from intake"
   * }) {
   * id
   * edgeType
   * createdAt
   * }
   * }
   * ```
   */
  journeyEdgeApiCreateJourneyEdge: InstanceJourneyEdge;
  /**
   * Delete a journey edge between two instances.
   *
   * Removes the edge from both forward and reverse Valkey indexes.
   */
  journeyEdgeApiDeleteJourneyEdge: Scalars['Boolean']['output'];
  /** List chaos documents for tenant */
  listChaosDocuments: Array<ChaosDocument>;
  /**
   * List available domain metadata with filtering and pagination
   * Requires: `metadata:read` scope (DRR-102)
   */
  listDomainMetadata: DomainMetadataConnection;
  /**
   * List optimization recommendations for a tenant
   * Supports filtering by status and pagination
   */
  listOptimizationRecommendations: Array<OptimizationRecommendationGql>;
  /** List pending approvals for specific approver */
  listPendingApprovals: Array<ApprovalWorkflowInstance>;
  /** List analytics for all policies in tenant */
  listPolicyAnalytics: Array<PolicyAnalytics>;
  /** List all active policy templates */
  listPolicyTemplates: Array<PolicyTemplate>;
  /** List all versions for a policy */
  listPolicyVersions: Array<PolicyVersion>;
  /** List published templates (excludes drafts and archived) */
  listPublishedTemplates: Array<TemplateListItem>;
  /** List available domains with registered schemas */
  listSchemaDomains: Array<Scalars['String']['output']>;
  /** List available standards packs */
  listStandardsPacks: Array<StandardsPackListItem>;
  /** List template instances for a tenant */
  listTemplateInstances: Array<PolicyTemplateInstance>;
  /** List all instances of a specific template (cross-tenant analytics) */
  listTemplateUsage: Array<PolicyTemplateInstance>;
  /** List all versions for a template */
  listTemplateVersions: Array<TemplateVersion>;
  /** List templates by category */
  listTemplatesByCategory: Array<PolicyTemplate>;
  /** List templates by domain (usage-sorted via GSI1) */
  listTemplatesByDomain: Array<TemplateListItem>;
  /** List templates by domain and type (filtered GSI1 query) */
  listTemplatesByDomainAndType: Array<TemplateListItem>;
  /** List all templates for a tenant (GSI2) */
  listTemplatesByTenant: Array<TemplateListItem>;
  /** Add a pending suggestion to a draft */
  llmWorkflowAddSuggestionToDraft: WorkflowDraft;
  /** Apply a suggestion to the draft */
  llmWorkflowApplySuggestion: DraftOperationResponse;
  /** Create a new editing draft for a workflow */
  llmWorkflowCreateDraft: DraftOperationResponse;
  /** Discard a draft */
  llmWorkflowDiscardDraft: Scalars['Boolean']['output'];
  /**
   * Generate LLM suggestions for workflow modifications
   *
   * Takes a natural language prompt and generates YAML patches
   * that can be previewed and applied to the workflow.
   */
  llmWorkflowGenerateSuggestions: GenerateSuggestionsResponse;
  /** Save draft to persistent storage (Wasabi) */
  llmWorkflowPersistDraft: DraftOperationResponse;
  /** Undo the last edit in the draft */
  llmWorkflowUndoLastEdit: DraftOperationResponse;
  /** Health check for management API */
  managementHealth: Scalars['Boolean']['output'];
  /**
   * Mark delivery as complete
   *
   * NOTE: Use fireEvent(instanceId, "delivery_confirmed") instead.
   */
  markDelivered: FoodServiceOrder;
  /**
   * Modify contract resolution time (append-only versioning)
   *
   * Requires `contract:write` or `contract:admin` scope
   */
  modifyContractResolution: Contract;
  /**
   * Move team to new parent.
   *
   * Requires `team:write` or `team:admin` scope
   */
  moveTeam: Team;
  /** Organize multiple tasks using AI */
  organizeTasks: OrganizeTasksResult;
  /**
   * Pause accumulator for a resident.
   *
   * Called when resident is hospitalized, on leave, etc.
   * Requires `assessment:manage` scope.
   */
  pauseAccumulator: AccumulatorSummaryGql;
  /**
   * Pause a contract (stops SLA clock)
   *
   * Requires `contract:write` or `contract:admin` scope
   */
  pauseContract: Contract;
  /** Pause a running DAG execution */
  pauseDagExecution: DagstateTransitionResponse;
  pauseQueue: Queue;
  /**
   * Pause a schedule.
   *
   * Requires `schedule:write` or `schedule:admin` scope
   */
  pauseSchedule: Schedule;
  /** Persist draft to the UI schema repository */
  persistFormSchemaDraft: FormSchemaDraftOutput;
  /**
   * Force persist safety event to DynamoDB (7-year retention)
   * LIFE-CRITICAL: Bypass Redis TTL for critical events requiring immediate persistence
   */
  persistSafetyEvent: SafetyEvent;
  ping: Scalars['Boolean']['output'];
  /**
   * Generate a new shift plan.
   *
   * Creates optimized task assignments for the specified shift window.
   * Requires `shift:manage` scope.
   */
  planShift: ShiftPlan;
  /**
   * Preview what would be imported from a schema
   *
   * Shows expected fields without actually creating template.
   */
  previewSchemaImport: Scalars['JSON']['output'];
  /**
   * Process an inbound HL7 v2 message (ADT or ORU).
   *
   * DRR-153: Parses the raw HL7 string, stores derived FHIR resources via the
   * enrichment pipeline, then creates a `wf-4-8-001` workflow instance to
   * coordinate routing to the subject's active operational workflow instance.
   *
   * For ORU messages, writes `FhirObservation` resources which automatically
   * trigger Zen Engine rule evaluation (rl-4-2-001) for critical lab alerts.
   *
   * Fire-and-forget on enrichment/routing failures — the FHIR write is the
   * primary operation. Routing failures are logged and retried via outbox.
   */
  processHl7Message: ProcessHl7MessageResult;
  /**
   * DRR-281 Phase 2: Promote an advisory to an industry term.
   * Architect-only. Returns YAML snippet to add to care-vocabulary.yaml.
   */
  promoteToIndustryTerm: PromoteToIndustryTermResult;
  /** Publish approved template */
  publishTemplate: WorkflowTemplateMetadata;
  /**
   * Assign role to user
   *
   * Requires: tenant:admin scope
   * Audit: Immutable record in audit trail
   */
  rbacAssignRole: UserRoleAssignment;
  /**
   * Create new role definition
   *
   * Requires: tenant:admin scope
   */
  rbacCreateRole: RoleDefinition;
  /**
   * Delete role (soft delete)
   *
   * Requires: tenant:admin scope
   */
  rbacDeleteRole: Scalars['Boolean']['output'];
  /**
   * Bulk import permission template
   *
   * Example: Import "admin" template with all inherited permissions
   */
  rbacImportPermissionTemplate: RoleDefinition;
  /**
   * Revoke role from user
   *
   * Requires: tenant:admin scope
   * Audit: Logs revocation with reason
   */
  rbacRevokeRole: Scalars['Boolean']['output'];
  /**
   * Update role definition
   *
   * Requires: tenant:admin scope
   * Life-Critical: Triggers approval workflow if role has critical permissions
   */
  rbacUpdateRole: RoleDefinition;
  /** Reactivate a suspended subgraph */
  reactivateSubgraph: SubgraphRegistry;
  /**
   * Reassign a pending signer to a new name/email (C6).
   *
   * Only valid while the participant is still Pending. Revokes the old
   * signing token (if any) and generates a new one for the new email.
   */
  reassignCeremonyParticipant: SigningCeremony;
  /**
   * Trigger a manifest rebuild
   *
   * # Authorization
   * SuperAdmin role required (affects all tenants)
   *
   * # Returns
   * Build job ID for tracking progress
   */
  rebuildAnalyticsManifest: Scalars['String']['output'];
  /** Recommend standards packs for workflow (AI-powered) */
  recommendStandardsPacks: RecommendationResult;
  /**
   * Record a tenant's adoption or dismissal of a best practice recommendation.
   *
   * DRR-156: Creates an immutable T1 Audit event recording the decision.
   * Dismissals MUST include a reason (perception-safe: "not applicable to
   * our setting" not "we disagree with the recommendation").
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * recordAdoptionDecision(input: {
   * tenantNum: 2
   * practiceRef: "rs-4-16-001"
   * decision: ADOPTED
   * decidedBy: "2_1"
   * }) {
   * success
   * practiceRef
   * decision
   * auditEventId
   * }
   * }
   * ```
   */
  recordAdoptionDecision: AdoptionDecisionResult;
  /** Record error for analytics */
  recordAnalyticsError: Scalars['Boolean']['output'];
  /** Record approval decision */
  recordApprovalDecision: ApprovalWorkflowInstance;
  /**
   * Record a consent step in the chain-of-command approval
   *
   * Steps 3 and 6 (owner confirms) require Tier 4 auth + fresh witness.
   */
  recordExchangeConsent: ExchangeRelationship;
  /**
   * Record a schedule execution.
   *
   * Requires `schedule:write` or `schedule:admin` scope
   */
  recordExecution: Schedule;
  /**
   * Record an instantiation of the workflow (updates formula metrics).
   * Append-only: Creates new version with updated metrics.
   */
  recordInstantiation: Workflow;
  /**
   * Record a participant's signature in the ceremony.
   *
   * Downloads the document PDF, applies PAdES-B-B signature via KMS,
   * uploads the signed version to S3, and advances the ceremony state machine.
   */
  recordParticipantSignature: SigningCeremony;
  /** Record policy evaluation event (for analytics tracking) */
  recordPolicyEvaluation: Scalars['Boolean']['output'];
  /**
   * Record a payer prior authorization approval.
   *
   * Writes `EnrichmentSource::Edi` / `DataClass::Auth` enrichment on the
   * constellation so the task spawner can gate services on auth status.
   * Emits an outbox item for durability (same pattern as FHIR enrichment).
   *
   * Required scope: `edi:write` or `edi:admin`
   */
  recordPriorAuthApproval: PriorAuthApprovalResult;
  /**
   * Record a BLE proximity event from a scanner.
   *
   * DRR-100 Tier 1/4: Primary data ingestion path for BLE events.
   * Automatically checks for elopement conditions and returns an alert if triggered.
   * Requires: `beacon:write` scope (DRR-102). Tier 4 raw sensor data (DRR-114).
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * recordProximityEvent(tenantNum: 2, input: {
   * beaconId: "17-bcn-901"
   * zoneId: "17-zone-parking"
   * rssi: -65
   * estimatedDistanceM: 2.5
   * scannerId: "phone-staff-1"
   * scannerActorId: "2_5"
   * sourceTier: 1
   * }) {
   * success
   * event { beaconId zoneId timestamp }
   * elopementAlert { alertId severity subjectActorId }
   * error
   * }
   * }
   * ```
   */
  recordProximityEvent: ProximityEventResult;
  /**
   * Sign a document via a one-time token link (A1 — external signers, no auth required).
   *
   * Resolves the token to find the ceremony + participant, then delegates to the
   * same PAdES pipeline as `recordParticipantSignature`. Consumes the token on success
   * (single-use enforcement).
   */
  recordSignatureViaToken: SigningCeremony;
  recordUsage: Resource;
  /**
   * Record a constraint violation.
   *
   * Requires: `constraint:write` or `constraint:admin` scope
   *
   * NOTE: This creates a new version with violation recorded (append-only)
   */
  recordViolation: Constraint;
  /** Record successful workflow execution */
  recordWorkflowExecution: Scalars['Boolean']['output'];
  refreshFederation: FederationState;
  /**
   * Refund unused balance to resident
   *
   * Flow: Calculate unused → BankingGateway POST /refund → burn tokens → XADD
   * Requires: `ledger:write` scope (DRR-102)
   */
  refundUnusedBalance: LedgerTransfer;
  /**
   * Register a new BLE beacon for a tenant.
   *
   * DRR-100: Write-once (L1 condition). Use for initial beacon deployment.
   * Requires: `beacon:write` scope (DRR-102)
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * registerBeacon(tenantNum: 2, input: {
   * beaconId: "17-bcn-701"
   * beaconUuid: "f7826da6-4fa2-4e98-8024-bc5b71e0893e"
   * major: 7
   * minor: 701
   * zoneId: "17-zone-new-wing"
   * beaconType: "STAFF"
   * model: "BC021"
   * }) {
   * success
   * beacon { beaconId minor status }
   * error
   * }
   * }
   * ```
   */
  registerBeacon: BeaconRegistrationResult;
  /**
   * Register a completed document (called by Forms/Report Engine)
   *
   * Creates DocumentRegistryEntry after document has been generated and uploaded to Wasabi.
   * This is called by workers after successful document generation.
   */
  registerDocument: GqlDocumentRegistryEntry;
  /**
   * Register participant in emergency
   *
   * # Arguments
   * * `emergency_id` - Unique emergency identifier
   * * `user_id` - User being registered
   *
   * # Returns
   * Current participant count after registration
   */
  registerEmergencyParticipant: Scalars['Int']['output'];
  /**
   * Register platform credentials for a tenant
   * NOTE: This stores encrypted credentials - handle with care
   */
  registerPlatformCredentials: Scalars['Boolean']['output'];
  /**
   * Register a new subgraph with the ID broker
   *
   * Must be called at subgraph startup before generating IDs.
   * Requires admin access.
   */
  registerSubgraph: GqlRegisterSubgraphResult;
  /** Register a webhook endpoint to receive ceremony lifecycle events (D1). */
  registerWebhookEndpoint: WebhookEndpoint;
  /** Reject a single extraction with a reason */
  rejectExtraction: GqlExtraction;
  /** Reject a JIT access request */
  rejectJITRequest: RejectJitRequestResult;
  /** Reject LLM fix recommendations */
  rejectLlmFix: Scalars['Boolean']['output'];
  /**
   * Reject a regulatory rule from the review queue
   *
   * Requires `regulatory:approve` scope + Cedar policy enforcement.
   * CRITICAL safety rules enforce four-eyes principle (importer != rejector).
   */
  rejectRegulatoryRule: GqlRegulatoryRule;
  /**
   * Reject a witness request (witness action).
   *
   * Requires Tier 3+ authentication.
   * The rejector cannot be the same person as the operator.
   */
  rejectWitnessRequest: WitnessRequestGql;
  releaseResource: Resource;
  /** Release workflow lock */
  releaseWorkflowLock: Scalars['Boolean']['output'];
  /**
   * Reload workflow configurations from YAML files
   *
   * Use this after editing YAML config files to see changes without restart.
   */
  reloadWorkflowConfigs: Scalars['Boolean']['output'];
  /** Remove a composed component */
  removeComponent: Scalars['Boolean']['output'];
  /**
   * Remove permission from role (creates new version).
   *
   * Requires scope: role:write or role:admin
   */
  removePermission: Role;
  /**
   * Remove rule from policy (creates new version with rule removed - APPEND-ONLY).
   *
   * **FERP Integration**: Same as update_policy (modifies policy rules).
   * - APPEND-ONLY: Creates new version with rule removed
   */
  removePolicyRule: Policy;
  /**
   * Remove role inheritance (creates new version).
   *
   * Requires scope: role:write or role:admin
   */
  removeRoleInheritance: Role;
  /**
   * Remove an edge from the scope DAG.
   *
   * Creates an EdgeRemoved mutation in the hash chain.
   * The edge is logically removed but the mutation is preserved.
   *
   * Requires `scope:write` or `scope:admin` scope.
   */
  removeScopeEdge: ScopeMutationEvent;
  /** Remove a feature flag from a subgraph */
  removeSubgraphFeature: SubgraphRegistry;
  /**
   * Remove stakeholder from team.
   *
   * Requires `team:write` or `team:admin` scope
   */
  removeTeamStakeholder: Team;
  /**
   * DRR-281 Phase 4: Remove a terminology override.
   * Reverts to industry term (if exists) or statutory definition.
   */
  removeTerminologyOverride: Scalars['Boolean']['output'];
  /**
   * Render PDF from HTML template via agent service (DRR-079 migration)
   *
   * This mutation uses the Python agent service's weasyprint-based HTML→PDF
   * renderer. Templates are HTML with Jinja2 syntax and CSS layout, which
   * handles text wrapping automatically (no manual coordinate positioning).
   *
   * Pipeline:
   * 1. Call agent service /render-pdf endpoint
   * 2. Upload PDF bytes to S3
   * 3. Create Document primitive for audit trail
   * 4. Return pre-signed download URL
   *
   * Templates live in agent-service's pdf_templates/ directory. Available
   * templates can be queried via `htmlPdfTemplates` query.
   */
  renderHtmlPdf: RenderHtmlPdfResult;
  /**
   * Trigger a shift replan due to changed conditions.
   *
   * Called when staff calls out, emergency admission, incident, etc.
   * Requires `shift:manage` scope.
   */
  replanShift: ShiftPlan;
  /** Replay a previous execution for debugging */
  replayDagExecution: DagexecutionResponse;
  /** Move a DLQ outbox item back to OUTBOX for replay by key. */
  replayOutbox: Scalars['Boolean']['output'];
  /**
   * Request a presigned download URL for a ceremony's signed document.
   *
   * Returns a time-limited S3 presigned GET URL (60 minutes) for the
   * latest signed PDF version. Only available after at least one
   * participant has signed.
   */
  requestCeremonyDocumentUrl: CeremonyDocumentUrl;
  /** Request emergency break-glass access (HIPAA §164.312(a)(2)(ii)) */
  requestEmergencyAccess: EmergencyAccessToken;
  /**
   * Request a presigned download URL for reading a document from an exchange
   *
   * FERP generates the presigned URL — the browser downloads directly from Wasabi.
   * KMS decrypt is scoped to the recipient tenant only.
   *
   * Guards: exchange:read scope + Tier 3 auth (manual check)
   * Checks: relationship active, requester is recipient (not sender)
   */
  requestExchangeDownloadUrl: ExchangeDownloadUrlResult;
  /**
   * Request a presigned upload URL for pushing a document through an exchange relationship
   *
   * FERP generates the presigned URL — the browser uploads directly to Wasabi.
   * FERP backend NEVER touches document bytes.
   *
   * Guards: exchange:push scope + Tier 3 auth (manual check)
   * Checks: relationship active, sender is participant, MIME type allowlist
   */
  requestExchangeUploadUrl: ExchangeUploadUrlResult;
  /** Request JIT access to a role */
  requestJITAccess: RequestJitAccessResult;
  /**
   * Request a KBA challenge for a ceremony participant.
   *
   * Issues a 6-digit verification code via the configured method (email/SMS).
   * The participant must enter this code via `verifyKbaChallenge` before they
   * can sign. Respects max attempts — returns an error if the participant is
   * already locked out.
   */
  requestKbaChallenge: KbaChallengeResult;
  /** Request LLM fix recommendations for validation errors */
  requestLlmFix: LlmFixRecommendation;
  /** Request a terminology override. SAFE=auto-approve, CAUTION=rationale needed, BLOCKED=conference. */
  requestTerminologyOverride: TerminologyOverrideResult;
  reserveResource: Resource;
  /**
   * Reset circuit breaker for an actor.
   *
   * Requires: `actor:admin` scope
   */
  resetCircuitBreaker: Actor;
  /**
   * Reset tenant branding to defaults
   *
   * Resets branding to industry-specific defaults
   */
  resetTenantBranding: TenantBranding;
  /**
   * Reset constraint usage.
   *
   * Requires: `constraint:write` or `constraint:admin` scope
   *
   * NOTE: This creates a new version with reset usage (append-only)
   */
  resetUsage: Constraint;
  /**
   * Resolve a Condition (sets Condition.clinicalStatus to inactive/resolved/remission)
   *
   * This is a soft-delete operation - the condition is NOT physically deleted.
   * If entered_in_error = true, DUAL CONTROL is required (2+ approvals).
   */
  resolveCondition: FhirCondition;
  /** Resolve an anomaly */
  resolveIntegrationAnomaly: IntegrationAnomalyResolveResult;
  /**
   * Resolve a sync conflict.
   *
   * Records the human decision on a conflict and grafts the accepted value.
   * Med dosage conflicts require nurse/supervisor review (Tier 3+ auth).
   *
   * Requires: `sync:resolve` scope + Tier 3 auth (DRR-102)
   */
  resolveSyncConflict: ConflictResolution;
  /**
   * Re-submit a rejected rule for review after corrections
   *
   * Requires `regulatory:import` scope (same as initial import).
   */
  resubmitRegulatoryRule: GqlRegulatoryRule;
  /**
   * Resume accumulator for a resident.
   *
   * Called when resident returns from hospitalization, leave, etc.
   * Requires `assessment:manage` scope.
   */
  resumeAccumulator: AccumulatorSummaryGql;
  /**
   * Resume a paused contract
   *
   * Requires `contract:write` or `contract:admin` scope
   */
  resumeContract: Contract;
  /** Resume a paused DAG execution */
  resumeDagExecution: DagstateTransitionResponse;
  resumeQueue: Queue;
  /**
   * Resume a paused schedule.
   *
   * Requires `schedule:write` or `schedule:admin` scope
   */
  resumeSchedule: Schedule;
  /** Retry a failed node execution */
  retryFailedNode: DagnodeTransitionResponse;
  /** Review architect proposal (tenant admin - approve or reject) (DRR-227) */
  reviewArchitectProposal: ArchitectProposal;
  /**
   * Revoke a document (deny future access)
   *
   * Can be called post-download to revoke access for subsequent opens.
   */
  revokeDocument: GqlDocumentRegistryEntry;
  /** Revoke active emergency access */
  revokeEmergencyAccess: RevokeEmergencyAccessResult;
  /**
   * Revoke an exchange relationship — owner-initiated, immediate effect
   *
   * Disables KMS key and removes IAM access. Channel closes instantly.
   * Existing ciphertext becomes permanently undecryptable.
   *
   * Guards: exchange:revoke scope + manual Tier 4 + witness check
   */
  revokeExchangeRelationship: ExchangeRelationship;
  /** Revoke an active JIT session */
  revokeJITSession: RevokeJitSessionResult;
  /**
   * Revoke all documents for a user (employee termination)
   *
   * Bulk operation for compliance when user access must be immediately terminated.
   */
  revokeUserDocuments: Scalars['Int']['output'];
  /** Revoke a verifier grant */
  revokeVerifierAccess: RevokeGrantResult;
  /** Rollback bulk operation (revoke all created assignments) */
  rollbackBulkOperation: BulkOperation;
  /** Rollback policy to previous version */
  rollbackPolicy: PolicyRollbackResult;
  /** Rollback template to previous version */
  rollbackTemplate: TemplateRollbackResult;
  /**
   * Rollback transaction (execute compensation tasks).
   * Creates new version with RolledBack status.
   */
  rollbackTransaction: Transaction;
  /** Rotate integration credentials */
  rotateCredentials: Integration;
  /** Run a what-if scenario analysis */
  runDagScenario: DagscenarioResponse;
  /** Save a workflow definition from the editor */
  saveDagWorkflow: SaveDagWorkflowResponse;
  /** Save draft */
  saveDraft: SaveResult;
  /**
   * Save an EDI claim as a draft Transaction primitive.
   *
   * Creates a Transaction with status=Created (DRAFT). The form data is stored
   * as JSON on the transaction. Can be resumed later by calling this mutation
   * again with updated data, or submitted via submitEdiClaim.
   *
   * Required scope: `edi:write` or `transaction:write`
   */
  saveEdiClaimDraft: EdiClaimResult;
  /**
   * Save tenant-specific override for a form schema.
   *
   * Allows tenants to customize field labels, visibility, etc.
   * without modifying the base schema.
   */
  saveFormSchemaOverride: FormSchemaOverride;
  /** Save a form schema for an entity context */
  saveUiSchema: UiFormSchema;
  sendActorMessage: Scalars['Boolean']['output'];
  /**
   * Send a message in an intake conversation and get an AI response (DRR-137 Phase 4).
   *
   * Flow:
   * 1. Persist user message to DDB (PK=T#{tenant}#CHAOS_DOC#{doc_id}, SK=CONV_MSG#{micros})
   * 2. Fetch full conversation history
   * 3. Build system prompt from document context + format history into prompt
   * 4. Call LlmProvider.generate() — degrades gracefully when LLM not configured
   * 5. Persist assistant response to DDB
   * 6. Return assistant ConversationMessage
   */
  sendIntakeMessage: IntakeConversationMessage;
  /** Send notification to a worker about their issues */
  sendWorkerNotification: IntegrationNotificationResult;
  /**
   * Send workflow signal to existing workflow instance
   * Life-critical: Maintains audit trail and state consistency
   */
  sendWorkflowSignal: WorkflowSignalResponse;
  /** Set individual feature flag */
  setFeatureFlag: Scalars['Boolean']['output'];
  /**
   * DRR-178: Set focus context — "I'm working on this actor."
   *
   * Stores in Valkey with 8-hour TTL (shift-aligned). Per-device focus.
   * Perspective: "subject" = work FOR this actor, "performer" = work BY this actor.
   *
   * Requires `scope:write` or `scope:admin` scope.
   */
  setFocusContext: FocusContext;
  /** Create or remove a freeze window for a given integration period. */
  setFreeze: Scalars['Boolean']['output'];
  /**
   * Settle with a service company for a period
   *
   * Flow: XRANGE aggregate → create settlement proposal → BankingGateway POST /settle → hash-chain
   * Requires: `ledger:write` scope (DRR-102)
   */
  settleServiceCompany: LedgerSettlement;
  /**
   * Fire an event in step-through simulation mode.
   * Same guard evaluation as production, but actions planned not executed.
   */
  simulateEvent: SimulationStepResult;
  /**
   * Simulate the impact of implementing a recommendation
   * LIFE-CRITICAL: Dry-run simulation before actual implementation
   * Uses historical workflow data and isolated sandbox environment
   */
  simulateRecommendationImpact: SimulationResultGql;
  /**
   * Run a full scenario simulation (ALL_PATHS, HAPPY_PATH, etc.).
   * DRR-170-A1: ALL_PATHS uses visit-count=2, explores UNKNOWN guards.
   */
  simulateScenario: SimulationRunResult;
  spawnActor: Scalars['Boolean']['output'];
  /** Spawn a workflow actor that appends workflow events from messages */
  spawnWorkflowActor: Scalars['String']['output'];
  /**
   * Spend payment tokens on a service
   *
   * Flow: Validate fund separation → XADD → journal entry (debit resident, credit service co)
   * Requires: `ledger:write` scope (DRR-102)
   */
  spendPaymentTokens: LedgerTransfer;
  /**
   * Stage safety event in Redis for high-frequency access
   * LIFE-CRITICAL: <100ms latency, 5-min TTL, auto-flushed to DynamoDB every 60s
   */
  stageSafetyEvent: SafetyEvent;
  /**
   * Start biometric authentication for a user
   *
   * # Returns
   * - `BiometricAuthenticationChallenge`: Challenge to send to frontend
   *
   * # Frontend Integration
   * ```typescript
   * import { startAuthentication } from '@simplewebauthn/browser';
   *
   * const { challenge, sessionId } = await graphql(`
   * mutation {
   * startBiometricAuthentication(input: {
   * username: "dr.smith"
   * tenantId: "healthcare-clinic"
   * }) {
   * challenge
   * sessionId
   * expiresAt
   * }
   * }
   * `);
   *
   * const assertion = await startAuthentication(JSON.parse(challenge));
   * ```
   */
  startBiometricAuthentication: BiometricAuthenticationChallenge;
  /**
   * Start biometric registration for a user
   *
   * # Returns
   * - `BiometricRegistrationChallenge`: Challenge to send to frontend
   *
   * # Frontend Integration
   * ```typescript
   * import { startRegistration } from '@simplewebauthn/browser';
   *
   * const { challenge, userId } = await graphql(`
   * mutation {
   * startBiometricRegistration(input: {
   * userId: "user123"
   * username: "dr.smith"
   * displayName: "Dr. Sarah Smith"
   * }) {
   * challenge
   * userId
   * expiresAt
   * }
   * }
   * `);
   *
   * const credential = await startRegistration(JSON.parse(challenge));
   * ```
   */
  startBiometricRegistration: BiometricRegistrationChallenge;
  /**
   * Start new SAGA execution (life-critical operation)
   *
   * **FERP Pattern**: Repository-integrated SAGA execution
   * Uses SagaExecutionRepository for two-tier Redis/DynamoDB storage
   */
  startSaga: SagaExecutionResponse;
  /**
   * Start a new simulation session for a workflow definition.
   * Session stored in Valkey with 30-min TTL (ephemeral, not DDB).
   */
  startSimulation: GqlSimulationSession;
  /**
   * Start a sub-workflow from a parent workflow instance.
   *
   * Creates a new child instance linked to the parent via parent_id.
   * The child inherits the root_instance_id from the parent for hierarchy tracking.
   *
   * # Arguments
   *
   * * `tenant_id` - Tenant ID
   * * `input` - Sub-workflow configuration
   *
   * # Returns
   *
   * Result containing:
   * - `child_instance_id`: The new child instance ID
   * - `inline_result`: For INLINE mode, the completion result (if synchronous)
   *
   * # Example
   *
   * ```graphql
   * mutation {
   * startSubWorkflow(
   * tenantId: "tenant-1"
   * input: {
   * parentInstanceId: "parent-123"
   * workflowName: "hire_employee"
   * workflowVersion: "1.0"
   * executionMode: ASYNC
   * failureMode: FAIL_PARENT
   * inputData: { employeeId: "emp-456" }
   * }
   * ) {
   * success
   * childInstanceId
   * }
   * }
   * ```
   */
  startSubWorkflow: GqlStartSubWorkflowResult;
  stopActor: Scalars['Boolean']['output'];
  /**
   * Store a batch of PII records
   *
   * Records are encrypted and stored in the PII vault.
   * Returns tokens that can be used to reference the PII.
   *
   * Requires: pii:import scope and MFA (Tier 2)
   */
  storePiiBatch: StorePiiBatchResult;
  /**
   * Store tenant-specific regulatory compliance configuration
   * LIFE-CRITICAL: Prevents legal discrimination liability by storing configurable thresholds
   */
  storeRegulatoryComplianceConfig: Scalars['Boolean']['output'];
  /** Submit architect proposal for review (runs simulation first) (DRR-227) */
  submitArchitectProposal: ArchitectProposal;
  /**
   * Submit a draft EDI claim for processing.
   *
   * Transitions the Transaction from Created (DRAFT) → Active (INTAKE) and
   * dispatches the outbound workflow (e.g., outbound-837p-claim-submission.yaml).
   *
   * The workflow engine handles all subsequent phases:
   * INTAKE → VALIDATE → TRANSFORM → COMPLY → TRANSMIT → RECONCILE → ARCHIVE
   *
   * Required scope: `edi:write` or `transaction:write`
   */
  submitEdiClaim: EdiClaimResult;
  /**
   * Submit T1 legislation feedback from an opted-in tenant (DRR-148 T1 write path).
   *
   * Writes a stripped record to `PK = ADVOCACY_FEEDBACK#{ruleset_id}` — the
   * system-level anonymous index consumed by `generateAdvocacyPosition`.
   *
   * ## Identity Stripping (T1→cross-write boundary)
   *
   * Only `(regulation_id, impact_type, impact_severity)` are written.
   * No tenant_id, actor_id, narrative, or identifying fields are stored.
   * The submission UUID is FERP-generated (opaque, no tenant encoding).
   *
   * ## Authorization
   *
   * `RequireScope("advocacy:submit")` — available to opted-in tenant actors.
   * Opt-in is controlled by `advocacy_data_sharing_enabled` in constellation-facility-meta.
   *
   * ## NEVER ADD
   *
   * Do NOT add `tenantId` to the written record. Do NOT log content.
   */
  submitLegislationFeedback: Scalars['Boolean']['output'];
  /** Submit a plan review. */
  submitPlanReview: PlanReviewResult;
  /**
   * Submit a settlement proposal between two tenants (DRR-105 + DRR-109)
   *
   * Validates:
   * 1. Both tenants have an active CONTRACTS_WITH relationship
   * 2. Settlement amount is positive
   * 3. Blake3 reconciliation hash is provided (64-char hex)
   * 4. Proposer is a participant in the relationship
   *
   * Guards: exchange:admin scope + Tier 3 auth
   */
  submitSettlementProposal: SettlementProposal;
  /**
   * Submit template for approval
   *
   * FERP Principles:
   * - Repository pattern: Get template from WorkflowTemplateMetadataRepository
   * - Data-driven: Approval requirements from DynamoDB policies
   * - Life-critical: Complete audit trail for approval submission
   * - Domain-agnostic: Works for all domains via metadata
   */
  submitTemplateForApproval: ApprovalWorkflowInstance;
  /**
   * Submit USRN review decision.
   * This advances the care plan to DoN queue or requests changes.
   */
  submitUsrnReview: UsrnReviewResult;
  /**
   * Use Bedrock Claude to suggest which fields are most relevant for a user's goal.
   *
   * Reads the constellation YAML for the primitive, builds a prompt with the
   * field inventory and optional context profile, then asks the LLM to rank
   * fields by relevance.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * suggestFields(input: {
   * primitiveType: "Task"
   * contextId: "healthcare-discharge"
   * userGoal: "Process a patient discharge with medication reconciliation"
   * vertical: "healthcare"
   * }) {
   * suggestions { fieldName ringId reasoning relevance critical }
   * provider
   * totalFieldsConsidered
   * }
   * }
   * ```
   */
  suggestFields: FieldSuggestionResponse;
  /**
   * Suggest regulatory nodes for a tenant during onboarding (DRR-075)
   *
   * Uses the existing Bedrock LLM provider to suggest applicable regulatory
   * bodies based on NAICS industry, state, and services. Returns structured
   * suggestions with confidence scores and reasons.
   *
   * Ground-truth constrained: LLM can only select from known regulatory node IDs
   * in `regulatory-nodes/*.yaml`. Any hallucinated IDs are filtered out.
   */
  suggestRegulatoryNodes: GqlSuggestRegulatoryNodesResult;
  /**
   * AI-powered floor plan room extraction via Claude vision (DRR-179 Phase 3).
   *
   * Uploads the floor plan image to Claude vision, which identifies room labels
   * and their approximate positions. Returns suggested placements for admin
   * review in the SpatialPinningEditor before saving.
   *
   * Requires: `agent:compose` scope — architect/admin only.
   */
  suggestRoomPlacements: SuggestRoomPlacementsResponse;
  /**
   * Set a sunset date on an existing RuleSet.
   *
   * After `sunset_date`, the RuleSet is no longer returned by
   * `listRuleSets(effectiveOnly: true)`. The record is NOT deleted —
   * historical queries via `as_of_date` can still retrieve it (DRR-096).
   *
   * Requires `regulatory:import` scope.
   */
  sunsetRuleSet: RuleSet;
  /**
   * Publish a new RuleSet version that supersedes an existing one.
   *
   * Steps:
   * 1. Creates new RuleSet with `supersedes = old_id`
   * 2. Sets `superseded_by = new_id` on the old RuleSet
   * 3. Dual-writes Policy primitive for the new version (DRR-112)
   *
   * Requires `regulatory:import` scope.
   */
  supersedeRuleSet: RuleSet;
  /**
   * Suspend a subgraph (e.g., for payment issues)
   *
   * LIFE-CRITICAL: Suspended subgraphs cannot be used until reactivated.
   */
  suspendSubgraph: SubgraphRegistry;
  /** Suspend a tenant (admin only) */
  suspendSystemTenant: SystemTenant;
  /**
   * Switch the current user's traversal mode (DRR-135).
   *
   * Persists to Valkey key `pref:{tenant_num}:{auth_subject}:traversal_mode`.
   * No scope required — personal preference only.
   */
  switchTraversalMode: Scalars['Boolean']['output'];
  /**
   * Switch the active wall for the current session.
   *
   * Requires: The actor must hold roles in the target wall.
   * Policy: session_activation — one wall per session, switching requires re-auth.
   * Enhanced audit trail is generated for all wall switches.
   */
  switchWall: SwitchWallResult;
  /**
   * Sync an offline device chain.
   *
   * Executes the full 8-step sync pipeline:
   * verify → classify → detect conflicts → remap IDs → graft → archive → acknowledge
   *
   * ## Life-Safety
   *
   * Med administration conflicts NEVER auto-resolve (DRR-104 rule #3).
   * Broken chain → entire session rejected and quarantined.
   *
   * Requires: `sync:write` scope (DRR-102)
   */
  syncOfflineChain: SyncResult;
  /**
   * Assign task to an actor.
   *
   * Requires: `task:write` scope
   *
   * Uses append-only pattern - creates new task version with updated assignment.
   */
  taskApiAssignTask: Task;
  /**
   * Cancel task.
   *
   * Requires: `task:write` scope
   *
   * Uses append-only pattern - creates new version with Cancelled status.
   */
  taskApiCancelTask: Task;
  /**
   * Complete task.
   *
   * Requires: `task:write` scope
   *
   * Uses append-only pattern - creates new version with Completed status.
   */
  taskApiCompleteTask: Task;
  /**
   * Complete all active tasks matching a tool_hint (DRR-934).
   *
   * Requires: `task:write` scope
   *
   * When a tool successfully saves (e.g., SpatialPinningEditor saves floor plan
   * coordinates), this mutation auto-completes all onboarding tasks that have
   * the matching `tool_hint` field.
   *
   * # Arguments
   * - `tool_hint`: The tool identifier (e.g., "spatial_pinning_editor", "live_photo_capture")
   *
   * # Returns
   * - Count of tasks that were completed
   *
   * # Tool → Task Group Mapping
   * | Tool                  | tool_hint value          | Task Group  |
   * |-----------------------|--------------------------|-------------|
   * | SpatialPinningEditor  | spatial_pinning_editor   | tg-0-1-005  |
   * | LivePhotoCapture      | live_photo_capture       | tg-0-1-001  |
   * | PhotoComplianceUpload | photo_compliance_upload  | tg-0-1-004  |
   * | IntakeStudioCSV       | intake_studio_csv        | tg-0-1-001  |
   * | RoleAssignmentUI      | role_assignment_ui       | tg-0-1-001  |
   * | FormSchemaAdmin       | form_schema_admin        | tg-0-1-004  |
   * | RoomAssignmentUI      | room_assignment_ui       | tg-0-1-005  |
   * | EquipmentChecklist    | equipment_checklist      | tg-0-1-005  |
   */
  taskApiCompleteTasksByToolHint: Scalars['Int']['output'];
  /**
   * Create a new task.
   *
   * Requires: `task:write` scope
   */
  taskApiCreateTask: Task;
  /**
   * Fail task.
   *
   * Requires: `task:write` scope
   *
   * Uses append-only pattern - creates new version with Failed status.
   */
  taskApiFailTask: Task;
  /**
   * Reschedule a task (calendar drag-and-drop).
   *
   * Updates scheduled_start and scheduled_end times.
   * Life-critical tasks require explicit override confirmation.
   *
   * Requires: `task:write` scope
   */
  taskApiRescheduleTask: Task;
  /**
   * Start task execution.
   *
   * Requires: `task:write` scope
   *
   * Uses append-only pattern - creates new version with InProgress status.
   * DRR-297 Phase 2: Life-critical tasks require checkout lock.
   */
  taskApiStartTask: Task;
  /**
   * Transition task state (pure append-only).
   *
   * Requires: `task:write` scope
   *
   * Creates a new task version with updated state, preserving complete
   * audit trail via parent_id linkage.
   */
  taskApiTransitionTask: Task;
  /**
   * Update task progress (append-only - creates new version).
   *
   * Requires: `task:write` scope
   */
  taskApiUpdateTaskProgress: Task;
  /**
   * Archive template (soft delete)
   *
   * Requires `template:admin` scope
   */
  templateApiArchiveTemplate: Template;
  /**
   * Create child template from parent (template composition)
   *
   * Requires `template:write` or `template:admin` scope
   */
  templateApiCreateChildTemplate: Template;
  /**
   * Create a new template
   *
   * Requires `template:write` or `template:admin` scope
   */
  templateApiCreateTemplate: Template;
  /**
   * Generate primitive instances from template (execute template)
   *
   * Requires `template:write` or `template:admin` scope
   */
  templateApiGenerateInstancesFromTemplate: GqlGeneratedInstances;
  /**
   * Publish template (PendingApproval/Approved -> Published)
   *
   * Requires `template:publish` or `template:admin` scope
   */
  templateApiPublishTemplate: Template;
  /**
   * Submit template for approval (Draft -> PendingApproval)
   *
   * Requires `template:write` or `template:admin` scope
   */
  templateApiSubmitTemplateForApproval: GqlTemplateApprovalConfig;
  /**
   * Update template status (Draft -> PendingApproval -> Published -> Archived)
   *
   * Requires `template:write` or `template:admin` scope
   */
  templateApiUpdateTemplateStatus: Template;
  /**
   * Validate template structure (run 11-phase validation)
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiValidateTemplate: GqlTemplateValidationResult;
  /**
   * Get tenant metadata for specific domain
   * Requires: `metadata:read` scope (DRR-102)
   */
  tenantMetadata?: Maybe<TenantMetadataGql>;
  /** List all terminology overrides for the current tenant. */
  terminologyOverrides: Array<StoredTerminologyOverride>;
  /** Test integration connection (validates connectivity without affecting health metrics) */
  testIntegrationConnection: IntegrationConnectionTestResult;
  /** Test platform credentials (verify they work) */
  testPlatformCredentials: Scalars['Boolean']['output'];
  /** Test validation rule against sample data. */
  testValidation: Scalars['Boolean']['output'];
  /** Track configuration change for external monitoring (FERP integration point 6) */
  trackAuditChange: Scalars['String']['output'];
  /**
   * Transfer a social token between residents
   *
   * Flow: Validate anti-spam → XADD social stream → increment daily counter
   * Requires: `ledger:write` scope (DRR-102)
   */
  transferSocialToken: LedgerTransfer;
  /** Transition a specific node to a new status */
  transitionNodeStatus: DagnodeTransitionResponse;
  /** Transition SAGA state (life-critical distributed state management) */
  transitionSagaState: SagaExecutionResponse;
  /**
   * Trigger DRR-072 meta-orchestration pipeline for a chaos document.
   *
   * **THIS IS THE E2E SINGLE CODE PATH** (DRR-072):
   * 1. Retrieve document from ChaosDocumentRepository
   * 2. Update status to ANALYZING
   * 3. Build document context from document metadata
   * 4. Execute via PipelineOrchestrator::execute() → CapabilityRegistry → PipelineCompiler → DAGRuntime
   * 5. Update status to CONVERTED or FAILED
   * 6. Return pipeline execution result with full audit trail
   *
   * Same execution path for ALL document types (healthcare/finance/legal).
   * Pipeline varies based on capabilities; execution path does not.
   */
  triggerChaosPipeline: PipelineExecutionResult;
  /** Trigger a sync for a platform */
  triggerIntegrationSync: IntegrationSyncResult;
  /**
   * Trigger nightly export pipeline manually
   *
   * # Authorization
   * SuperAdmin role required - exports affect all tenant data
   *
   * # Security
   * - Uses JWT-validated auth context (cannot be spoofed)
   * - Export operations affect all tenants → requires SuperAdmin
   * - Full audit logging of user_id, tenant, and role
   *
   * # Returns
   * Export job ID for tracking progress
   */
  triggerNightlyExport: Scalars['String']['output'];
  /** Signal a reconcile run for an integration by creating a RECON_REQ row. */
  triggerReconcile: Scalars['Boolean']['output'];
  /**
   * Trigger a schedule execution now.
   *
   * Requires `schedule:write` or `schedule:admin` scope
   */
  triggerScheduleNow: Schedule;
  /** Trigger a tax change simulation (creates 4 notifications) */
  triggerTaxChange: TriggerTaxChangeResult;
  /** Undo the last applied edit */
  undoFormSchemaEdit: FormSchemaDraftOutput;
  /**
   * Unlock a document for viewing (ADR-002 Auth-to-Open)
   *
   * Validates session, checks revocation/expiration, returns decryption key.
   * Called by JavaScript embedded in PDF.
   *
   * **Security Features** (implemented in auth_to_open module):
   * - Session validation
   * - Rate limiting (10 req/min per user)
   * - KMS envelope encryption
   * - Audit trail logging
   * - Post-download revocation support
   */
  unlockDocument: GqlUnlockResult;
  /**
   * Unregister participant from emergency
   *
   * # Arguments
   * * `emergency_id` - Unique emergency identifier
   * * `user_id` - User being unregistered
   *
   * # Returns
   * Current participant count after unregistration
   */
  unregisterEmergencyParticipant: Scalars['Int']['output'];
  /**
   * Unregister a subgraph from tenant
   *
   * WARNING: This removes the subgraph entirely. Use disable_subgraph to keep config.
   */
  unregisterSubgraph: SubgraphRegistry;
  /**
   * Update ACH file status (e.g., mark as transmitted).
   *
   * Requires: `ach:write` scope
   */
  updateAchFileStatus: GqlAchFile;
  /**
   * Update an existing actor.
   *
   * Requires: `actor:write` scope
   */
  updateActor: Actor;
  /**
   * Update actor status.
   *
   * Requires: `actor:write` scope
   */
  updateActorStatus: Actor;
  /** Update analytics (full update) */
  updateAnalytics: Analytics;
  /** Update time series values (aggregation result) */
  updateAnalyticsTimeSeries: Analytics;
  /**
   * Update an existing audit record (limited fields, immutability enforced)
   * Requires: `audit:write` scope (DRR-102)
   */
  updateAudit: AuditQl;
  /** Update circuit breaker state */
  updateCircuitBreakerState: Integration;
  /**
   * DRR-134/118: Add or remove an actor from a constellation ring.
   *
   * Creates a new constellation version (append-only, DRR-118) with updated
   * Ring 1 participants. Updates Valkey bidirectional edges.
   *
   * Requires `constellation:admin` or `tenant:admin` scope.
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * updateConstellationParticipant(input: {
   * constellationId: "cst-4-1-001"
   * actorId: "2_3"
   * ring: 1
   * edgeType: "COORDINATED_BY"
   * action: ADD
   * }) {
   * success
   * message
   * constellationId
   * }
   * }
   * ```
   */
  updateConstellationParticipant: ConstellationParticipantResult;
  /**
   * Update constraint is NOT supported (append-only pattern).
   *
   * Use create_constraint to create a new version instead.
   */
  updateConstraint: Constraint;
  /** Update criticality configuration for a workflow type */
  updateCriticalityConfig: Scalars['Boolean']['output'];
  /**
   * Update dish status (fires recipe workflow event)
   *
   * NOTE: Child workflow events require parent instance lookup.
   */
  updateDishStatus: FoodServiceOrderItem;
  /** Update an existing entity */
  updateEntity: GenericEntity;
  /** Update expert capacity and availability status */
  updateExpertCapacity: ActorGql;
  /**
   * Update a FHIR resource via the dual-write pipeline (DRR-080)
   *
   * Creates a new version (append-only) for mutable resource types.
   */
  updateFhirStorageResource: FhirStoredResourceType;
  /**
   * Create a new version of a mutable FHIR resource (DRR-080, append-only)
   *
   * The original version is NEVER modified. A new item with incremented
   * version number is created. Returns error for immutable resource types.
   */
  updateFhirStoredResource: FhirStoredResource;
  /**
   * Update an existing form schema.
   *
   * Creates a new version of the schema.
   */
  updateFormSchema: FormSchema;
  /** Update integration health status (called by health check service) */
  updateHealthStatus: IntegrationHealthCheckResult;
  /** Update integration configuration */
  updateIntegration: Integration;
  /**
   * Advance order to next state (fires workflow event)
   *
   * Valid events per state:
   * - received: "order_acknowledged", "order_cancelled"
   * - in_prep: "prep_complete", "order_cancelled"
   * - quality_check: "qc_passed", "qc_failed"
   * - ready_for_pickup: "driver_pickup"
   * - dispatched: "delivery_confirmed"
   */
  updateOrderStatus: FoodServiceOrder;
  /**
   * Update existing policy (creates new version - APPEND-ONLY).
   *
   * **FERP Integration**:
   * - RBAC: Requires 'policy_admin' or 'workflow_admin' role
   * - Monitoring: Tracks update event with old/new values
   * - APPEND-ONLY: Creates new version, links to previous via parent_id
   */
  updatePolicy: Policy;
  /**
   * Update policy rule
   *
   * Updates existing policy rule (immutable audit trail)
   */
  updatePolicyRule: PolicyRule;
  /**
   * Update presence status for the current user's actor.
   *
   * DRR-061: Sets ephemeral Valkey key with 90s TTL.
   * Requires: authentication
   */
  updatePresence: Scalars['Boolean']['output'];
  /**
   * Update the provisioning status of a tenant product.
   *
   * DRR-095: Lifecycle transitions:
   * - activated → suspended (investigation, compliance hold)
   * - suspended → activated (resume operations)
   * - draft → customized → activated (initial setup flow)
   *
   * ## Example
   *
   * ```graphql
   * mutation {
   * updateProductStatus(
   * tenantNum: 2
   * productId: "prod-1-001"
   * newStatus: SUSPENDED
   * ) {
   * success
   * tenantProduct {
   * provisioningStatus
   * lastStatusChange
   * }
   * error
   * }
   * }
   * ```
   */
  updateProductStatus: ProductActivationResult;
  /**
   * Update tenant-specific regulatory compliance configuration
   * LIFE-CRITICAL: Updates configurable thresholds to prevent discrimination
   */
  updateRegulatoryComplianceConfig: Scalars['Boolean']['output'];
  /**
   * Update a regulatory threshold value (non-emergency)
   * LIFE-CRITICAL: Applies normal change control with audit context
   */
  updateRegulatoryThreshold: Scalars['Boolean']['output'];
  updateResourceCapacity: Resource;
  updateResourceStatus: Resource;
  /**
   * Update metadata fields on an existing RuleSet (non-structural edits).
   *
   * Patches: `display_name`, `description`, `safety_level`, `is_life_critical`,
   * `visibility_scope`. Does NOT touch temporal or version-chain fields.
   *
   * Requires `regulatory:import` scope.
   */
  updateRuleSetMetadata: RuleSet;
  /**
   * Update safety event (remediation status, escalation, evidence)
   * LIFE-CRITICAL: Maintains immutable audit trail for all updates
   */
  updateSafetyEvent: SafetyEvent;
  /** Update the map-level review status */
  updateSourceMapStatus: GqlSourceCoordinateMap;
  /** Update a system tenant (admin only) */
  updateSystemTenant: SystemTenant;
  /** Update a system user (admin only) */
  updateSystemUser: SystemUser;
  /**
   * Update an existing team.
   *
   * Requires `team:write` or `team:admin` scope
   */
  updateTeam: Team;
  /**
   * Update team quotas.
   *
   * Requires `team:write` or `team:admin` scope
   */
  updateTeamQuotas: Team;
  /**
   * Update template metadata (creates new version)
   * Requires: `metadata:write` scope (DRR-102)
   */
  updateTemplateMetadata: TemplateMetadataOutput;
  /**
   * Update tenant branding
   *
   * Updates existing tenant branding (immutable audit trail)
   */
  updateTenantBranding: TenantBranding;
  /**
   * Create or update tenant metadata
   * Requires: `metadata:write` scope (DRR-102)
   */
  updateTenantMetadata: TenantMetadataGql;
  /** Update comprehensive tenant settings */
  updateTenantSettings: Scalars['Boolean']['output'];
  /**
   * Update existing trace (typically to complete a span).
   *
   * **Use Case**: Complete in-progress span with end_at, duration, status, error details
   *
   * # Arguments
   *
   * * `tenant_id` - Multi-tenant isolation
   * * `trace_id` - OpenTelemetry trace ID (128-bit hex)
   * * `span_id` - OpenTelemetry span ID (64-bit hex)
   * * `input` - Update fields (all optional)
   *
   * # Returns
   *
   * Updated trace with incremented version
   */
  updateTrace: Trace;
  /** Update workflow graph */
  updateWorkflowGraph: WorkflowGraph;
  /**
   * Upgrade a subgraph's tier (Basic → Professional → Enterprise)
   *
   * This affects which features are available and usage quotas.
   */
  upgradeSubgraphTier: SubgraphRegistry;
  /**
   * Upload chaos document
   *
   * FERP Principles:
   * - Repository pattern: Uses ChaosDocumentRepository
   * - Life-critical: Complete audit trail
   * - Data-driven: Document metadata in DynamoDB, content in S3
   */
  uploadChaosDocument: ChaosDocument;
  upsertSettings: Scalars['Boolean']['output'];
  /**
   * Validate checkpoint integrity (checksum verification).
   *
   * **Use Case**: Detect corrupted/tampered checkpoints before rollback
   *
   * # Arguments
   *
   * * `checkpoint_id` - Checkpoint ID to validate
   */
  validateCheckpointIntegrity: CheckpointValidationResult;
  /** Validate composition for a workflow by (tenant, name[, version]) */
  validateComposition: FormsValidationResult;
  /**
   * Validate DSL source without compiling to JDM
   *
   * Parses the DSL source and returns validation results without
   * generating the full JDM output. Useful for quick syntax validation.
   *
   * # Arguments
   *
   * * `input` - DSL source to validate
   *
   * # Returns
   *
   * Validation result with errors, warnings, and rule summaries
   */
  validateDsl: DslValidationResult;
  /** Validate metadata composition for workflow */
  validateMetadata: ValidationResultGql;
  /** Validate template import data */
  validateTemplateImport: TemplateValidationResult;
  /**
   * Validate template metadata using domain-agnostic 6-layer validation framework
   *
   * This replaces the simple validation with comprehensive multi-layer validation.
   */
  validateTemplateMetadata: ValidationExecutionResult;
  /**
   * DEPRECATED: Simple validation - Use validateTemplateMetadata from TemplateMetadataQuery instead
   *
   * This method performs basic validation (25 primitives, field mappings).
   * The new 6-layer validation framework in TemplateMetadataQuery provides comprehensive validation.
   * @deprecated Use validateTemplateMetadata query instead
   */
  validateTemplateMetadataSimple: WorkflowTemplateValidationResult;
  /**
   * DRR-235: Pre-flight validation for workflow activation.
   *
   * Validates a workflow BEFORE activation by checking:
   * 1. Dependency existence (task groups, roles, constellations, policies)
   * 2. DRR-170 simulation (unreachable states, dead ends, policy gaps)
   * 3. 5W1H dimension coverage (WHO, WHAT, WHY, WHERE, WHEN, HOW)
   *
   * Returns a comprehensive report enabling LLM-assisted workflow design
   * to catch issues during design, not implementation.
   *
   * DRR-237 Phase 1: Wires DDB existence checks, handler registry, and simulation.
   */
  validateWorkflowPreflight: PreflightReport;
  /** Verify or correct a single extraction */
  verifyExtraction: GqlExtraction;
  /**
   * Verify a KBA challenge code submitted by a participant.
   *
   * On success, the participant's KBA status transitions to PASSED and they
   * can proceed to sign. On failure, the attempt counter increments; after
   * max attempts the participant is locked out.
   */
  verifyKbaChallenge: KbaVerificationResult;
  /**
   * Verify chain integrity for a tenant's ledger
   *
   * Reads all stream entries, reconstructs hash chain, verifies linkage
   * Requires: `ledger:read` scope (DRR-102)
   */
  verifyLedgerChain: LedgerChainVerificationResult;
  /**
   * Verify a witness request (witness action).
   *
   * Requires Tier 3+ authentication (hardware security key).
   * The witness cannot be the same person as the operator.
   */
  verifyWitnessRequest: VerifyWitnessRequestPayload;
  /**
   * Void (cancel) a signing ceremony (C1).
   *
   * Only valid from DRAFT, SENT, or SIGNING states.
   * Sends cancellation notifications to all pending participants via the outbox.
   */
  voidCeremony: SigningCeremony;
  /**
   * Compose a workflow from atomic parts (task groups + guards).
   *
   * Takes a list of task group IDs in order. Each becomes a state with:
   * - SpawnTasksFromGroups entry action
   * - all_tasks_completed guard on the forward transition
   *
   * Architect-only: RequireScope("workflow:compose").
   * Returns the generated workflow definition for review before seeding.
   */
  wfCompositionComposeFromParts: ComposeFromPartsResult;
  /**
   * Create workflows for a tenant based on their metadata
   *
   * This creates a master workflow and associated instances.
   */
  wfCompositionCreateTenantWorkflows: CreateTenantWorkflowsResult;
  /**
   * Get fully composed metadata for a workflow with runtime context
   * Requires: `metadata:read` scope (DRR-102)
   */
  workflowMetadata: ComposedMetadataGql;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAbortTransactionArgs = {
  reason: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAcceptSettlementProposalArgs = {
  input: AcceptSettlementProposalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAcknowledgeElopementAlertArgs = {
  acknowledgedBy: Scalars['String']['input'];
  alertId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAcknowledgeIntegrationAnomalyArgs = {
  acknowledgedBy: Scalars['String']['input'];
  anomalyId: Scalars['ID']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAcquireWorkflowLockArgs = {
  workflowExecution: WorkflowExecutionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActivateArchitectProposalArgs = {
  proposalId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActivateDefinitionArgs = {
  input: ActivateDefinitionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActivateFeaturesArgs = {
  featureIds: Array<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActivateProductArgs = {
  activatedBy: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActivateSystemTenantArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActivateValidationArgs = {
  code: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActivateWorkflowArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActorMgmtCreateActorSnapshotArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActorMgmtRestartActorArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActorMgmtSendActorMessageArgs = {
  message: ActorMessage;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActorMgmtStartActorArgs = {
  config: ActorConfig;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActorMgmtStopActorArgs = {
  actorId: Scalars['String']['input'];
  graceful?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationActorMgmtUpdateActorConfigArgs = {
  actorId: Scalars['String']['input'];
  config: ActorConfig;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddActorToQueueArgs = {
  actorId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddCheckpointToTransactionArgs = {
  checkpointId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddComponentArgs = {
  input: AddComponentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddPermissionArgs = {
  permission: PermissionInput;
  roleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddPolicyRuleArgs = {
  policyId: Scalars['String']['input'];
  rule: PolicyRuleInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddRoleInheritanceArgs = {
  childRoleId: Scalars['String']['input'];
  parentRoleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddScopeEdgeArgs = {
  input: AddScopeEdgeInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddSubgraphFeatureArgs = {
  input: AddSubgraphFeatureInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAddTeamStakeholderArgs = {
  input: GqlAddStakeholderInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAdoptIndustryTermArgs = {
  industryTermId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAnalyzeDomainFromIntentArgs = {
  description: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAnalyzePublicationArgs = {
  input: AnalyzePublicationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAppendTransitionArgs = {
  input: AppendTransitionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApplyFormSchemaSuggestionArgs = {
  input: ApplyFormSchemaSuggestionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApplyLlmFixArgs = {
  input: ApplyLlmFixInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApplyStandardsPackArgs = {
  input: ApplyStandardsPackInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApprovalApiAddApprovalCommentArgs = {
  approvalId: Scalars['String']['input'];
  input: GqlAddCommentInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApprovalApiCreateApprovalArgs = {
  input: GqlCreateApprovalInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApprovalApiDelegateApprovalArgs = {
  approvalId: Scalars['String']['input'];
  input: GqlDelegateApprovalInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApprovalApiEscalateApprovalArgs = {
  approvalId: Scalars['String']['input'];
  input: GqlEscalateApprovalInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApprovalApiRecordApprovalDecisionArgs = {
  approvalId: Scalars['String']['input'];
  input: GqlRecordDecisionInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApprovalApiUpdateApprovalArgs = {
  approvalId: Scalars['String']['input'];
  input: GqlUpdateApprovalInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApproveConfigProposalArgs = {
  input: ApproveProposalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApproveJitRequestArgs = {
  input: ApproveJitRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApproveRecommendationArgs = {
  decision: ApprovalDecisionGql;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApproveRegulatoryRuleArgs = {
  input: ApproveRuleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationApproveTerminologyOverrideArgs = {
  definitionId: Scalars['String']['input'];
  rationale: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveActorArgs = {
  actorId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveAuditArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveContractArgs = {
  contractId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveIntegrationArgs = {
  integrationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveNotificationArgs = {
  notificationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchivePolicyRuleArgs = {
  input: ArchivePolicyRuleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveQueueArgs = {
  queueId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveScheduleArgs = {
  reason: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveSubgraphMetadataArgs = {
  reason: Scalars['String']['input'];
  subgraphId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveTeamArgs = {
  code: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveTemplateArgs = {
  archiverId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationArchiveWorkflowGraphArgs = {
  input: ArchiveWorkflowGraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAssessWorkflowCriticalityArgs = {
  workflowExecution: WorkflowExecutionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAssignDriverArgs = {
  input: AssignDriverInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAssignTaskArgs = {
  input: AssignTaskInput;
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAssignTaskToActorArgs = {
  actorId: Scalars['String']['input'];
  input: GqlAssignTaskToActorInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAssistantQueryArgs = {
  input: AssistantQueryInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAttachEvidenceArgs = {
  input: AttachEvidenceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationAttestProvisionArgs = {
  input: AttestProvisionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBasicCompleteEnrollmentStepArgs = {
  input: BasicCompleteEnrollmentStepInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBasicSkipEnrollmentArgs = {
  input: BasicSkipEnrollmentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBasicSkipEnrollmentStepArgs = {
  input: BasicSkipEnrollmentStepInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBasicStartEnrollmentArgs = {
  input: BasicStartEnrollmentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBatchCompressArgs = {
  input: BatchCompressInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBatchCreateCeremonyFromTemplateArgs = {
  input: BatchCreateCeremonyFromTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBatchDecompressArgs = {
  input: BatchDecompressInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBatchSetAnalyticsEnabledArgs = {
  analyticsIds: Array<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBreakGlassWallOverrideArgs = {
  input: BreakGlassOverrideInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBulkAcknowledgeAnomaliesArgs = {
  acknowledgedBy: Scalars['String']['input'];
  anomalyIds: Array<Scalars['ID']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBulkSendWorkerNotificationsArgs = {
  channel: IntegrationNotificationChannel;
  notificationType: Scalars['String']['input'];
  workerIds: Array<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationBulkVerifyExtractionsArgs = {
  input: BulkVerifyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelArchitectProposalArgs = {
  proposalId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelBulkOperationArgs = {
  batchId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelDagExecutionArgs = {
  executionId: Scalars['ID']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelEncounterArgs = {
  input: CancelEncounterInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelObservationArgs = {
  input: CancelObservationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelOrderArgs = {
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelProcedureArgs = {
  input: CancelProcedureInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelSubWorkflowArgs = {
  childInstanceId: Scalars['String']['input'];
  compensate?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCancelWitnessRequestArgs = {
  requestId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleAddProviderArgs = {
  input: AddProviderInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleClaimPrizeArgs = {
  entryId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleCreateFamilyArgs = {
  input: CreateFamilyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleMarkRecordReceivedArgs = {
  providerName: Scalars['String']['input'];
  trackerId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleMarkRecordRequestedArgs = {
  providerName: Scalars['String']['input'];
  trackerId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleRecordRaffleActionArgs = {
  action: CareCircleRaffleAction;
  familyId: Scalars['String']['input'];
  referralFamilyId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleStartAssessmentArgs = {
  familyId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleStartRecordTrackerArgs = {
  careRecipientName: Scalars['String']['input'];
  familyId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleSubmitLeadArgs = {
  input: SubmitLeadInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCarecircleUpdateAssessmentArgs = {
  input: UpdateAssessmentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCheckFrameworkComplianceArgs = {
  input: CheckFrameworkComplianceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationClaimTaskArgs = {
  id: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationClassifyIntakeTextArgs = {
  text: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationClearAnalyticsErrorArgs = {
  analyticsId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationClearCacheArgs = {
  cacheType?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCloneValidationArgs = {
  newCode: Scalars['String']['input'];
  newName: Scalars['String']['input'];
  sourceCode: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCloneWorkflowArgs = {
  newVersion: Scalars['String']['input'];
  sourceWorkflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCommitTransactionArgs = {
  transactionId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompensateSagaArgs = {
  input: CompensateSagaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompileDslArgs = {
  input: CompileDslInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompleteCeremonyFieldArgs = {
  input: CompleteCeremonyFieldInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompletePiiAttestationArgs = {
  input: CompleteAttestationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompleteTaskArgs = {
  decision: DecisionInput;
  id: Scalars['String']['input'];
  mfaToken?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompleteTaskForActorArgs = {
  actorId: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
  taskId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompleteWitnessRequestArgs = {
  input: CompleteWitnessRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationComposeWorkflowArgs = {
  input: ComposeWorkflowInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompositionApplyAntiPatternFixArgs = {
  input: ApplyAutoFixInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompositionCreateAntiPatternArgs = {
  input: CreateAntiPatternInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompositionDeleteAntiPatternArgs = {
  id: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompositionLinkRulesToFormulaArgs = {
  actionRuleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  activationRuleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  antiPatternRuleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  formulaNumber: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompositionUpdateAntiPatternArgs = {
  input: UpdateAntiPatternInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCompressIdArgs = {
  input: SubgraphCompressIdInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationComputeFieldValueArgs = {
  input: ComputeFieldValueInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationConnectComponentsArgs = {
  input: ConnectComponentsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationConvertChaosToDslArgs = {
  input: ConvertChaosToDslInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateActorArgs = {
  input: GqlCreateActorInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateAnalyticsArgs = {
  input: CreateAnalyticsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateAnnotationArgs = {
  input: GqlCreateAnnotationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateArchitectProposalArgs = {
  input: CreateArchitectProposalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateAuditArgs = {
  input: CreateAuditInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateAuditFromTemplateArgs = {
  input: CreateFromTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateCeremonyFromTemplateArgs = {
  input: CreateCeremonyFromTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateCeremonyTemplateArgs = {
  input: CreateCeremonyTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateCheckpointArgs = {
  input: GqlCreateCheckpointInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateCommunicationLogArgs = {
  input: CreateCommunicationLogInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateConditionArgs = {
  input: CreateConditionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateConstraintArgs = {
  input: GqlCreateConstraintInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateContractArgs = {
  input: GqlCreateContractInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateDomainMetadataArgs = {
  input: CreateDomainMetadataInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateEncounterArgs = {
  input: CreateEncounterInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateExpertWithSafetyValidationArgs = {
  input: CreateActorInputGql;
  safetyScore: Scalars['Float']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateFhirStorageResourceArgs = {
  input: CreateFhirResourceGqlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateFhirStoredResourceArgs = {
  input: CreateFhirStoredResourceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateFormSchemaArgs = {
  input: FormSchemaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateFormSchemaDraftArgs = {
  input: CreateFormSchemaDraftInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateIncidentArgs = {
  input: CreateIncidentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateJourneyAuditEventArgs = {
  input: CreateJourneyAuditEventInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateMedicationAdministrationArgs = {
  input: CreateMedicationAdministrationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateMedicationDispenseArgs = {
  input: CreateMedicationDispenseInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateMedicationRequestArgs = {
  input: CreateMedicationRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateNotificationArgs = {
  input: GqlCreateNotificationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateObservationArgs = {
  input: CreateObservationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateOrchestrationPatternArgs = {
  input: CreateOrchestrationPatternInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateOrchestrationPatternVersionArgs = {
  input: CreateOrchestrationPatternInput;
  patternType: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateOrchestrationRuleArgs = {
  input: CreateOrchestrationRuleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateOrchestrationRuleVersionArgs = {
  input: CreateOrchestrationRuleInput;
  ruleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreatePatientArgs = {
  input: CreatePatientInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreatePatientViaOutboxArgs = {
  input: CreatePatientInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreatePiiAttestationArgs = {
  input: CreateAttestationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreatePolicyArgs = {
  input: CreatePolicyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreatePolicyRuleArgs = {
  input: CreatePolicyRuleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateProcedureArgs = {
  input: CreateProcedureInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateQueueArgs = {
  input: GqlCreateQueueInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateResourceArgs = {
  input: GqlCreateResourceInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateRoleArgs = {
  input: CreateActorRoleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateRoleTemplateArgs = {
  input: CreateRoleTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateRoleTemplateVersionArgs = {
  input: CreateRoleTemplateInput;
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateSagaCompensationCheckpointArgs = {
  input: GqlSagaCompensationCheckpointInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateSagaTransactionArgs = {
  input: CreateSagaTransactionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateScheduleArgs = {
  input: GqlCreateScheduleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateSigningCeremonyArgs = {
  input: CreateSigningCeremonyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateSubgraphMetadataArgs = {
  input: SubgraphMetadataInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateSystemTenantArgs = {
  input: CreateSystemTenantInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateSystemUserArgs = {
  input: CreateSystemUserInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateTeamArgs = {
  input: GqlCreateTeamInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateTemplateMetadataArgs = {
  input: CreateTemplateMetadataInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateTenantBrandingArgs = {
  input: CreateTenantBrandingInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateTraceArgs = {
  input: CreateTraceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateValidationArgs = {
  input: GqlCreateValidationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateVersionSubgraphMetadataArgs = {
  input: SubgraphMetadataInput;
  subgraphId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateWitnessRequestArgs = {
  input: CreateWitnessRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateWorkflowArgs = {
  input: GqlCreateWorkflowInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationCreateWorkflowGraphArgs = {
  input: CreateWorkflowGraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeactivateOrchestrationRuleArgs = {
  ruleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeactivatePatientArgs = {
  input: DeactivatePatientInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeactivateProductArgs = {
  productId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeactivateValidationArgs = {
  code: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeactivateWorkflowArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeclineCeremonyArgs = {
  input: DeclineCeremonyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDecommissionResourceArgs = {
  resourceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDecompressIdArgs = {
  input: DecompressIdInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDecryptDocumentArgs = {
  input: DecryptDocumentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDelegateTaskArgs = {
  id: Scalars['String']['input'];
  toUserId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteBiometricCredentialArgs = {
  credentialId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteCeremonyTemplateArgs = {
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteChaosDocumentArgs = {
  actor: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteDraftArgs = {
  input: DeleteDraftInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteDraftManyArgs = {
  input: DeleteDraftManyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteEntityArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteFormSchemaOverrideArgs = {
  entityType: Scalars['String']['input'];
  subgraph: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteSystemUserArgs = {
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteTemplateMetadataArgs = {
  actor: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteTenantBrandingArgs = {
  input: DeleteTenantBrandingInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeleteWebhookEndpointArgs = {
  endpointId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDenyTerminologyOverrideArgs = {
  definitionId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDependencyApiAddDependenciesBatchArgs = {
  dependencies: Array<CreateDependencyInput>;
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDependencyApiArchiveDependencyArgs = {
  dependencyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDependencyApiCreateDependencyArgs = {
  input: CreateDependencyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDependencyApiRebuildWorkflowDagArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDepositFundsArgs = {
  input: DepositFundsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeprecateActorArgs = {
  actorId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeprecatePolicyArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDeprecateRoleTemplateArgs = {
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDequeueTaskArgs = {
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDisableConstraintArgs = {
  code: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDisablePolicyArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDisableScheduleArgs = {
  scheduleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDisableSubgraphArgs = {
  input: ToggleSubgraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDiscardFormSchemaDraftArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDismissDriftAlertArgs = {
  input: DismissAlertInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiArchiveDocumentArgs = {
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiArchiveDocumentWithReasonArgs = {
  documentId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiCreateDocumentArgs = {
  input: CreateDocumentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiCreateDocumentVersionArgs = {
  input: CreateDocumentVersionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiDeleteDocumentArgs = {
  documentId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiGenerateDocumentUploadUrlArgs = {
  input: GenerateDocumentUploadUrlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiMergeDocumentsArgs = {
  input: MergeDocumentsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiRecordDocumentApprovalDecisionArgs = {
  approverId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  decision: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiRequestDocumentDownloadUrlArgs = {
  input: RequestDocumentDownloadUrlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiSavePdfAnnotationsArgs = {
  input: SavePdfAnnotationsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiSignDocumentArgs = {
  input: SignDocumentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiSubmitDocumentForApprovalArgs = {
  approverActorIds: Array<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDocumentApiUpdateDocumentStatusArgs = {
  input: UpdateDocumentStatusInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDomainMetadataArgs = {
  domainType: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDrainQueueArgs = {
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationDryRunPolicyArgs = {
  input: DryRunPolicyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEditFormSchemaArgs = {
  input: EditFormSchemaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationElevateForTaskArgs = {
  id: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEmergencyActionArgs = {
  emergencyInput: EmergencyControlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEmergencyOverrideRegulatoryThresholdArgs = {
  input: EmergencyOverrideInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEnableConstraintArgs = {
  code: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEnablePolicyArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEnableSubgraphArgs = {
  input: ToggleSubgraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEncryptDocumentArgs = {
  input: EncryptDocumentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEnqueueTaskArgs = {
  input: GqlEnqueueTaskInput;
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEnrollActorArgs = {
  initialData?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EntityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEntityArgs = {
  id: Scalars['ID']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEntitySchemaArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEntityTypesArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEventApiArchiveEventsArgs = {
  olderThan: Scalars['DateTime']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEventApiCreateEventArgs = {
  input: GqlCreateEventInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationEventApiVerifyAndRepairChainArgs = {
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExecuteDagWorkflowArgs = {
  input: ExecuteDagWorkflowInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExecuteEntityActionArgs = {
  action: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExplainConfigProposalArgs = {
  input: ExplainProposalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExportAuditTrailArgs = {
  input: ExportAuditTrailInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExportRbacAuditLogArgs = {
  input: ExportRbacAuditInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExportTemplateArgs = {
  input: ExportTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExtendAuditRetentionArgs = {
  id: Scalars['ID']['input'];
  input: ExtendRetentionInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExtendJitSessionArgs = {
  input: ExtendJitSessionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExtractChaosDocumentArgs = {
  documentId: Scalars['String']['input'];
  extractedBy: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExtractImagePiiArgs = {
  input: ExtractImagePiiInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExtractIndustryTermsArgs = {
  input: ExtractIndustryTermsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationExtractStatuteMetadataArgs = {
  input: ExtractStatuteMetadataInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFillStateFormArgs = {
  input: FillStateFormInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFinalizePlanArgs = {
  authorityActorId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFinishBiometricAuthenticationArgs = {
  input: FinishBiometricAuthenticationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFinishBiometricRegistrationArgs = {
  input: FinishBiometricRegistrationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFlattenXfaPreviewArgs = {
  sourceFormRef: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFlushSafetyEventsArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFormulaRegistryCreateFormulaArgs = {
  input: GqlCreateFormulaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFormulaRegistryDeleteFormulaArgs = {
  formulaId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFormulaRegistrySeedBuiltinFormulasArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationFormulaRegistryUpdateFormulaArgs = {
  input: GqlUpdateFormulaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateAchFileArgs = {
  input: GqlGenerateAchFileInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateAdmissionPdfArgs = {
  input: GenerateAdmissionPdfInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateAdvisoryArgs = {
  input: GenerateAdvisoryInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateAdvocacyPositionArgs = {
  rulesetId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateAuditReportArgs = {
  id: Scalars['ID']['input'];
  input: GenerateReportInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateBatchPdfsArgs = {
  input: GenerateBatchPdfsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateCeremonyEvidenceCertificateArgs = {
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateConfigProposalsArgs = {
  input: GenerateProposalsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateDailyTaskSheetArgs = {
  input: GenerateDailyTaskSheetInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateDocumentArgs = {
  input: GenerateDocumentInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateEpManualArgs = {
  rulesetId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateEvidenceReportArgs = {
  input: GenerateEvidenceReportInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateFormSchemaArgs = {
  config?: InputMaybe<PatternConfigInput>;
  entityType: Scalars['String']['input'];
  patternId: PatternId;
  subgraph: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateFormSchemaSuggestionsArgs = {
  input: GenerateFormSchemaSuggestionsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateIdArgs = {
  input: GenerateIdInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateOptimizationRecommendationsArgs = {
  request: OptimizationGenerationRequestGql;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateRulesetAcknowledgmentArgs = {
  input: GenerateRulesetAcknowledgmentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateRulesetComplianceReportArgs = {
  input: GenerateRulesetReportInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateStaffCompetencyRecordArgs = {
  staffActorId: Scalars['String']['input'];
  taskGroupId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateSubgraphIdArgs = {
  input: GenerateSubgraphIdInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateSubgraphIdBatchArgs = {
  input: GenerateSubgraphIdBatchInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateSubjectCareSummaryArgs = {
  input: GenerateSubjectCareSummaryInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateTaskGuidanceArgs = {
  input: GenerateTaskGuidanceInput;
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateTaskInstructionsPdfArgs = {
  input: GenerateTaskInstructionsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateTrainingCurriculumArgs = {
  rulesetId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGenerateWorkflowExecutionPdfArgs = {
  input: GenerateWorkflowSummaryInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetAiTaskGuidanceArgs = {
  input: GetTaskGuidanceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetAnalyticsSummaryArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetAnalyticsTimeSeriesArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  timeRange: AnalyticsTimeRange;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetApprovalQueueArgs = {
  filter?: InputMaybe<ApprovalQueueFilter>;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetApprovalWorkflowInstanceArgs = {
  instanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetAuditStatisticsArgs = {
  dateRange: AuditDateRangeInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetAuditTrailArgs = {
  filter: AuditTrailFilter;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetChaosDocumentDetailsArgs = {
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetChaosUploadUrlArgs = {
  documentId: Scalars['String']['input'];
  fileSizeBytes: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetConversionStatusArgs = {
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetCurrentPolicyVersionArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetIntakeConversationArgs = {
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetLatestTemplateMetadataArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetPolicyAnalyticsArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetPolicyTemplateArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetPolicyVersionArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetStandardsPackDetailsArgs = {
  standardsPackId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetStructuredImportJobArgs = {
  documentId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetTemplateMetadataArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetTemplatePublicationStatusArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetTemplateVersionArgs = {
  templateId: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetTemplateVersionDiffArgs = {
  fromVersion: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
  toVersion: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetTemplateVersionHistoryArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetTemplateVersionHistorySummaryArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetTopPoliciesArgs = {
  limit: Scalars['Int']['input'];
  metric: PolicyMetricType;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetVersionDiffArgs = {
  fromVersion: Scalars['Int']['input'];
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  toVersion: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetVersionHistoryArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGetWorkflowComplianceArgs = {
  tenant: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationGrantVerifierAccessArgs = {
  input: GrantVerifierAccessInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationImplementRecommendationArgs = {
  plan: ImplementationPlanGql;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationImportLocalDevChainArgs = {
  input: ImportLocalDevChainInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationImportRegulatoryRulesArgs = {
  input: ImportRulesInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationImportRuleSetArgs = {
  input: GqlRuleSetInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationImportTemplateArgs = {
  input: ImportTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationImportWearableCaptureToStudioArgs = {
  actorId: Scalars['String']['input'];
  captureType: Scalars['String']['input'];
  contentUri: Scalars['String']['input'];
  input: ImportWearableCaptureInput;
  transcription?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationIncrementTemplateUsageArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationIncrementUsageArgs = {
  amount: Scalars['Float']['input'];
  code: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationIngestDocumentArgs = {
  input: IngestDocumentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInitializePolicyAnalyticsArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInitiateBulkOperationArgs = {
  input: InitiateBulkOperationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInitiateExchangeRelationshipArgs = {
  input: InitiateExchangeRelationshipInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInitiateStructuredImportArgs = {
  input: InitiateStructuredImportInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiCancelInstanceArgs = {
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiCommitDraftInstanceArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiCompleteInstanceArgs = {
  instanceId: Scalars['String']['input'];
  outputData: Scalars['JSON']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiCreateDraftInstanceArgs = {
  input: GqlCreateInstanceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiCreateInstanceArgs = {
  input: GqlCreateInstanceInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiFailInstanceArgs = {
  input: GqlRecordErrorInput;
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiFireEventArgs = {
  eventName: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiPauseInstanceArgs = {
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiRecordInstanceEventArgs = {
  eventId: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiResumeInstanceArgs = {
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiStartInstanceArgs = {
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  workflowDefinitionId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiTransitionInstanceArgs = {
  input: GqlTransitionInstanceInput;
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiUpdateInstanceArgs = {
  input: GqlUpdateInstanceInput;
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstanceApiUpdateInstanceProgressArgs = {
  input: GqlUpdateProgressInput;
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstantiateRoleTemplateArgs = {
  input: RbacInstantiateTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInstantiateTemplateArgs = {
  input: InstantiateTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationIntakeProcessArgs = {
  input: IntakeProcessInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationInvalidateFormSchemaArgs = {
  kind: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationJourneyEdgeApiCreateJourneyEdgeArgs = {
  input: GqlCreateJourneyEdgeInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationJourneyEdgeApiDeleteJourneyEdgeArgs = {
  edgeType: GqlJourneyEdgeType;
  sourceInstanceId: Scalars['String']['input'];
  targetInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListChaosDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<ChaosDocumentStatus>;
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListDomainMetadataArgs = {
  filter?: InputMaybe<MetadataFilterInput>;
  pagination?: InputMaybe<MetadataPaginationInput>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListOptimizationRecommendationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<RecommendationStatus>>;
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListPendingApprovalsArgs = {
  approverId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListPolicyAnalyticsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListPolicyVersionsArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListPublishedTemplatesArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListStandardsPacksArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListTemplateInstancesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListTemplateUsageArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListTemplateVersionsArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListTemplatesByCategoryArgs = {
  category: PolicyTemplateCategory;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListTemplatesByDomainArgs = {
  domain: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListTemplatesByDomainAndTypeArgs = {
  domain: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  templateType: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationListTemplatesByTenantArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationLlmWorkflowAddSuggestionToDraftArgs = {
  draftId: Scalars['String']['input'];
  suggestion: LlmEditSuggestionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationLlmWorkflowApplySuggestionArgs = {
  input: ApplySuggestionInput;
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationLlmWorkflowCreateDraftArgs = {
  input: CreateDraftInput;
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationLlmWorkflowDiscardDraftArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationLlmWorkflowGenerateSuggestionsArgs = {
  input: GenerateSuggestionsInput;
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationLlmWorkflowPersistDraftArgs = {
  input: PersistDraftInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationLlmWorkflowUndoLastEditArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationMarkDeliveredArgs = {
  orderId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationModifyContractResolutionArgs = {
  changeReason: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  newResolutionMinutes: Scalars['Int']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationMoveTeamArgs = {
  input: GqlMoveTeamInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationOrganizeTasksArgs = {
  input: OrganizeTasksInput;
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPauseAccumulatorArgs = {
  input: PauseAccumulatorInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPauseContractArgs = {
  contractId: Scalars['String']['input'];
  pauseReason: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPauseDagExecutionArgs = {
  executionId: Scalars['ID']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPauseQueueArgs = {
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPauseScheduleArgs = {
  scheduleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPersistFormSchemaDraftArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPersistSafetyEventArgs = {
  eventId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPlanShiftArgs = {
  input: PlanShiftInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPreviewSchemaImportArgs = {
  resourceType: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationProcessHl7MessageArgs = {
  input: ProcessHl7MessageInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPromoteToIndustryTermArgs = {
  input: PromoteToIndustryTermInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationPublishTemplateArgs = {
  input: PublishTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRbacAssignRoleArgs = {
  input: AssignRoleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRbacCreateRoleArgs = {
  input: CreateRoleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRbacDeleteRoleArgs = {
  roleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRbacImportPermissionTemplateArgs = {
  templateName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRbacRevokeRoleArgs = {
  input: RevokeRoleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRbacUpdateRoleArgs = {
  input: UpdateRoleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReactivateSubgraphArgs = {
  input: ReactivateSubgraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReassignCeremonyParticipantArgs = {
  input: ReassignCeremonyParticipantInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRebuildAnalyticsManifestArgs = {
  forceFullRebuild?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecommendStandardsPacksArgs = {
  tenant: Scalars['String']['input'];
  workflow: Scalars['JSON']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordAdoptionDecisionArgs = {
  input: AdoptionDecisionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordAnalyticsErrorArgs = {
  analyticsId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordApprovalDecisionArgs = {
  input: RecordApprovalDecisionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordExchangeConsentArgs = {
  input: RecordExchangeConsentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordExecutionArgs = {
  executionTimeMs: Scalars['Int']['input'];
  scheduleId: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordInstantiationArgs = {
  completed: Scalars['Boolean']['input'];
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  errored: Scalars['Boolean']['input'];
  formulaName?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordParticipantSignatureArgs = {
  input: RecordParticipantSignatureInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordPolicyEvaluationArgs = {
  input: RecordEvaluationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordPriorAuthApprovalArgs = {
  input: RecordPriorAuthApprovalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordProximityEventArgs = {
  input: RecordProximityEventInput;
  tenantNum: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordSignatureViaTokenArgs = {
  input: RecordSignatureViaTokenInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordUsageArgs = {
  durationMinutes: Scalars['Int']['input'];
  resourceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordViolationArgs = {
  code: Scalars['String']['input'];
  input: GqlRecordViolationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRecordWorkflowExecutionArgs = {
  assessmentResult: Scalars['String']['input'];
  workflowExecution: WorkflowExecutionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRefreshFederationArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRefundUnusedBalanceArgs = {
  input: RefundUnusedBalanceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRegisterBeaconArgs = {
  input: RegisterBeaconInput;
  tenantNum: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRegisterDocumentArgs = {
  input: RegisterDocumentInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRegisterEmergencyParticipantArgs = {
  emergencyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRegisterPlatformCredentialsArgs = {
  accountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRegisterSubgraphArgs = {
  input: IdBrokerRegisterSubgraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRegisterWebhookEndpointArgs = {
  input: RegisterWebhookInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRejectExtractionArgs = {
  input: RejectExtractionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRejectJitRequestArgs = {
  input: RejectJitRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRejectLlmFixArgs = {
  input: RejectLlmFixInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRejectRegulatoryRuleArgs = {
  input: RejectRuleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRejectWitnessRequestArgs = {
  input: RejectWitnessRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReleaseResourceArgs = {
  resourceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReleaseWorkflowLockArgs = {
  lockId: Scalars['String']['input'];
  releasingActor: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemoveComponentArgs = {
  input: RemoveComponentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemovePermissionArgs = {
  action: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemovePolicyRuleArgs = {
  policyId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemoveRoleInheritanceArgs = {
  childRoleId: Scalars['String']['input'];
  parentRoleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemoveScopeEdgeArgs = {
  input: RemoveScopeEdgeInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemoveSubgraphFeatureArgs = {
  input: RemoveSubgraphFeatureInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemoveTeamStakeholderArgs = {
  input: GqlRemoveStakeholderInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRemoveTerminologyOverrideArgs = {
  definitionId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRenderHtmlPdfArgs = {
  input: RenderHtmlPdfInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReplanShiftArgs = {
  input: ReplanShiftInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReplayDagExecutionArgs = {
  executionId: Scalars['ID']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReplayOutboxArgs = {
  sk: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestCeremonyDocumentUrlArgs = {
  input: RequestCeremonyDocumentUrlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestEmergencyAccessArgs = {
  input: EmergencyAccessInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestExchangeDownloadUrlArgs = {
  input: RequestExchangeDownloadUrlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestExchangeUploadUrlArgs = {
  input: RequestExchangeUploadUrlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestJitAccessArgs = {
  input: JitAccessRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestKbaChallengeArgs = {
  ceremonyId: Scalars['String']['input'];
  participantIndex: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestLlmFixArgs = {
  input: RequestLlmFixInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRequestTerminologyOverrideArgs = {
  input: RequestTerminologyOverrideInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReserveResourceArgs = {
  actorId: Scalars['String']['input'];
  durationHours: Scalars['Int']['input'];
  resourceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResetCircuitBreakerArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResetTenantBrandingArgs = {
  input: ResetTenantBrandingInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResetUsageArgs = {
  code: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResolveConditionArgs = {
  input: ResolveConditionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResolveIntegrationAnomalyArgs = {
  anomalyId: Scalars['ID']['input'];
  resolutionNotes: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResolveSyncConflictArgs = {
  input: ResolveSyncConflictInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResubmitRegulatoryRuleArgs = {
  ruleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  yamlContent: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResumeAccumulatorArgs = {
  input: ResumeAccumulatorInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResumeContractArgs = {
  contractId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResumeDagExecutionArgs = {
  executionId: Scalars['ID']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResumeQueueArgs = {
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationResumeScheduleArgs = {
  scheduleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRetryFailedNodeArgs = {
  input: RetryFailedNodeInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationReviewArchitectProposalArgs = {
  input: ReviewArchitectProposalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRevokeDocumentArgs = {
  input: RevokeDocumentInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRevokeEmergencyAccessArgs = {
  incidentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRevokeExchangeRelationshipArgs = {
  input: RevokeExchangeRelationshipInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRevokeJitSessionArgs = {
  input: RevokeJitSessionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRevokeUserDocumentsArgs = {
  input: RevokeUserDocumentsInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRevokeVerifierAccessArgs = {
  grantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRollbackBulkOperationArgs = {
  input: RollbackBulkOperationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRollbackPolicyArgs = {
  input: RollbackPolicyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRollbackTemplateArgs = {
  input: RollbackTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRollbackTransactionArgs = {
  transactionId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRotateCredentialsArgs = {
  integrationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationRunDagScenarioArgs = {
  input: RunDagScenarioInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSaveDagWorkflowArgs = {
  input: SaveDagWorkflowInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSaveDraftArgs = {
  input: SaveDraftInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSaveEdiClaimDraftArgs = {
  input: SaveEdiClaimDraftInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSaveFormSchemaOverrideArgs = {
  input: FormSchemaOverrideInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSaveUiSchemaArgs = {
  schema: UiFormSchemaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSendActorMessageArgs = {
  input: SendActorInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSendIntakeMessageArgs = {
  input: SendIntakeMessageInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSendWorkerNotificationArgs = {
  input: IntegrationNotificationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSendWorkflowSignalArgs = {
  instanceId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  signalData: Scalars['JSON']['input'];
  signalName: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSetFeatureFlagArgs = {
  flagInput: FeatureFlagInput;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSetFocusContextArgs = {
  perspective?: Scalars['String']['input'];
  subjectActorId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSetFreezeArgs = {
  kind: Scalars['String']['input'];
  lock: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  period: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSettleServiceCompanyArgs = {
  input: SettleServiceCompanyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSimulateEventArgs = {
  event: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSimulateRecommendationImpactArgs = {
  recommendationId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSimulateScenarioArgs = {
  mockVariables?: InputMaybe<Scalars['JSON']['input']>;
  scenario: SimulationScenario;
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSpawnActorArgs = {
  id: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSpawnWorkflowActorArgs = {
  instanceId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSpendPaymentTokensArgs = {
  input: SpendPaymentTokensInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStageSafetyEventArgs = {
  input: CreateSafetyEventInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStartBiometricAuthenticationArgs = {
  input: StartBiometricAuthenticationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStartBiometricRegistrationArgs = {
  input: StartBiometricRegistrationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStartSagaArgs = {
  input: StartSagaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStartSimulationArgs = {
  input: StartSimulationInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStartSubWorkflowArgs = {
  input: GqlStartSubWorkflowInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStopActorArgs = {
  id: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStorePiiBatchArgs = {
  input: StorePiiBatchInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationStoreRegulatoryComplianceConfigArgs = {
  configData: Scalars['JSON']['input'];
  configType: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSubmitArchitectProposalArgs = {
  proposalId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSubmitEdiClaimArgs = {
  input: SubmitEdiClaimInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSubmitLegislationFeedbackArgs = {
  input: LegislationFeedbackInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSubmitPlanReviewArgs = {
  input: PlanReviewInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSubmitSettlementProposalArgs = {
  input: SubmitSettlementProposalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSubmitTemplateForApprovalArgs = {
  input: SubmitTemplateForApprovalInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSubmitUsrnReviewArgs = {
  input: UsrnReviewDecisionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSuggestFieldsArgs = {
  input: FieldSuggestionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSuggestRegulatoryNodesArgs = {
  input: SuggestRegulatoryNodesInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSuggestRoomPlacementsArgs = {
  input: SuggestRoomPlacementsInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSunsetRuleSetArgs = {
  rulesetId: Scalars['String']['input'];
  sunsetDate: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSupersedeRuleSetArgs = {
  input: GqlRuleSetInput;
  oldId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSuspendSubgraphArgs = {
  input: SuspendSubgraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSuspendSystemTenantArgs = {
  reason: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSwitchTraversalModeArgs = {
  mode: GqlTraversalMode;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSwitchWallArgs = {
  input: SwitchWallInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationSyncOfflineChainArgs = {
  input: SyncOfflineChainInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiAssignTaskArgs = {
  input: AssignTaskInput;
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiCancelTaskArgs = {
  reason: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiCompleteTaskArgs = {
  input: GqlCompleteTaskInput;
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiCompleteTasksByToolHintArgs = {
  toolHint: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiCreateTaskArgs = {
  input: GqlCreateTaskInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiFailTaskArgs = {
  input: GqlFailTaskInput;
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiRescheduleTaskArgs = {
  input: GqlRescheduleTaskInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiStartTaskArgs = {
  taskId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiTransitionTaskArgs = {
  input: GqlTransitionTaskInput;
  taskId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTaskApiUpdateTaskProgressArgs = {
  input: UpdateTaskProgressInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiArchiveTemplateArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiCreateChildTemplateArgs = {
  name: Scalars['String']['input'];
  overrides?: InputMaybe<Scalars['JSON']['input']>;
  parentTemplateId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiCreateTemplateArgs = {
  input: GqlCreateTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiGenerateInstancesFromTemplateArgs = {
  runtimeContext?: InputMaybe<Scalars['JSON']['input']>;
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiPublishTemplateArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiSubmitTemplateForApprovalArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiUpdateTemplateStatusArgs = {
  input: GqlUpdateTemplateStatusInput;
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTemplateApiValidateTemplateArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTenantMetadataArgs = {
  domainType: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTestIntegrationConnectionArgs = {
  integrationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTestPlatformCredentialsArgs = {
  platform: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTestValidationArgs = {
  code: Scalars['String']['input'];
  testData: Scalars['JSON']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTrackAuditChangeArgs = {
  id: Scalars['ID']['input'];
  input: TrackChangeInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTransferSocialTokenArgs = {
  input: TransferSocialTokenInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTransitionNodeStatusArgs = {
  input: TransitionNodeStatusInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTransitionSagaStateArgs = {
  input: TransitionSagaStateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTriggerChaosPipelineArgs = {
  input: TriggerChaosPipelineInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTriggerIntegrationSyncArgs = {
  input: IntegrationSyncInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTriggerNightlyExportArgs = {
  exportDate?: InputMaybe<Scalars['NaiveDate']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTriggerReconcileArgs = {
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTriggerScheduleNowArgs = {
  scheduleId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationTriggerTaxChangeArgs = {
  input: TriggerTaxChangeInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUndoFormSchemaEditArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUnlockDocumentArgs = {
  input: UnlockDocumentInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUnregisterEmergencyParticipantArgs = {
  emergencyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUnregisterSubgraphArgs = {
  input: UnregisterSubgraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateAchFileStatusArgs = {
  id: Scalars['ID']['input'];
  status: GqlAchFileStatus;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateActorArgs = {
  actorId: Scalars['String']['input'];
  input: GqlUpdateActorInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateActorStatusArgs = {
  actorId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: GqlActorStatus;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  input: GqlUpdateAnalyticsInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateAnalyticsTimeSeriesArgs = {
  analyticsId: Scalars['String']['input'];
  averageValue: Scalars['Float']['input'];
  currentValue: Scalars['Float']['input'];
  maxValue: Scalars['Float']['input'];
  minValue: Scalars['Float']['input'];
  standardDeviation: Scalars['Float']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateAuditArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAuditInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateCircuitBreakerStateArgs = {
  input: UpdateCircuitBreakerInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateConstellationParticipantArgs = {
  input: UpdateConstellationParticipantInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateConstraintArgs = {
  code: Scalars['String']['input'];
  input: GqlUpdateConstraintInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateCriticalityConfigArgs = {
  config: CriticalityConfigInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateDishStatusArgs = {
  dishId: Scalars['String']['input'];
  event: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateEntityArgs = {
  input: UpdateEntityInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateExpertCapacityArgs = {
  actorId: Scalars['ID']['input'];
  capacity: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateFhirStorageResourceArgs = {
  input: UpdateFhirResourceGqlInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateFhirStoredResourceArgs = {
  input: UpdateFhirStoredResourceInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateFormSchemaArgs = {
  input: FormSchemaInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateHealthStatusArgs = {
  input: UpdateHealthStatusInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateIntegrationArgs = {
  input: CreateIntegrationInput;
  integrationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdatePolicyArgs = {
  input: UpdatePolicyInput;
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdatePolicyRuleArgs = {
  input: UpdatePolicyRuleInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdatePresenceArgs = {
  status: GqlPresenceStatus;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateProductStatusArgs = {
  newStatus: ProductProvisioningStatus;
  productId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateRegulatoryComplianceConfigArgs = {
  configData: Scalars['JSON']['input'];
  configId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateRegulatoryThresholdArgs = {
  input: UpdateRegulatoryThresholdInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateResourceCapacityArgs = {
  newCapacity: Scalars['Int']['input'];
  resourceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateResourceStatusArgs = {
  resourceId: Scalars['String']['input'];
  status: GqlResourceStatus;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateRuleSetMetadataArgs = {
  input: GqlRuleSetMetadataInput;
  rulesetId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateSafetyEventArgs = {
  eventId: Scalars['String']['input'];
  input: UpdateSafetyEventInput;
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateSourceMapStatusArgs = {
  input: UpdateSourceMapStatusInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateSystemTenantArgs = {
  input: UpdateSystemTenantInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateSystemUserArgs = {
  input: UpdateSystemUserInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateTeamArgs = {
  code: Scalars['String']['input'];
  input: GqlUpdateTeamInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateTeamQuotasArgs = {
  input: GqlUpdateTeamQuotasInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateTemplateMetadataArgs = {
  input: UpdateTemplateMetadataInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateTenantBrandingArgs = {
  input: UpdateTenantBrandingInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateTenantMetadataArgs = {
  input: CreateTenantMetadataInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateTenantSettingsArgs = {
  settings: TenantSettingsInput;
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateTraceArgs = {
  input: UpdateTraceInput;
  spanId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  traceId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpdateWorkflowGraphArgs = {
  input: UpdateWorkflowGraphInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpgradeSubgraphTierArgs = {
  input: UpgradeSubgraphTierInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUploadChaosDocumentArgs = {
  input: GqlUploadChaosDocumentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationUpsertSettingsArgs = {
  input: SettingsInput;
  tenant: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateCheckpointIntegrityArgs = {
  checkpointId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateCompositionArgs = {
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateDslArgs = {
  input: ValidateDslInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateMetadataArgs = {
  tenantId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateTemplateImportArgs = {
  input: ValidateTemplateInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateTemplateMetadataArgs = {
  metadata: TemplateMetadataContentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateTemplateMetadataSimpleArgs = {
  metadata: TemplateMetadataContentInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationValidateWorkflowPreflightArgs = {
  input: WorkflowPreflightInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationVerifyExtractionArgs = {
  input: VerifyExtractionInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationVerifyKbaChallengeArgs = {
  ceremonyId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  participantIndex: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationVerifyLedgerChainArgs = {
  tenantNum: Scalars['Int']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationVerifyWitnessRequestArgs = {
  input: VerifyWitnessRequestInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationVoidCeremonyArgs = {
  input: VoidCeremonyInput;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationWfCompositionComposeFromPartsArgs = {
  name: Scalars['String']['input'];
  productRef?: InputMaybe<Scalars['String']['input']>;
  subgraph?: InputMaybe<Scalars['String']['input']>;
  taskGroupIds: Array<Scalars['String']['input']>;
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationWfCompositionCreateTenantWorkflowsArgs = {
  metadata: TenantMetadataInput;
  tenantId: Scalars['String']['input'];
};

/** Combined mutation root (Medplum proxy + DRR-080 DynamoDB storage) */
export type MutationWorkflowMetadataArgs = {
  context?: InputMaybe<RuntimeContextInput>;
  tenantId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** Filter input for myWork query */
export type MyWorkFilter = {
  /** Filter by assigned actor ID (for "my tasks" queries) */
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by source domain (e.g., "fhir", "payroll") */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Include completed items (default: false) */
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show overdue items */
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by priority */
  priority?: InputMaybe<WorkPriority | '%future added value'>;
  /** Filter by status */
  status?: InputMaybe<WorkStatus | '%future added value'>;
};

/**
 * DRR-188 H3: Aggregated pending item counts per navigation group.
 * Returned by the navigationSummary query for the Context Banner.
 * Labels are pre-rendered with constellation-driven terminology.
 */
export type NavigationGroupSummary = {
  __typename?: 'NavigationGroupSummary';
  /**
   * Pre-rendered action description using constellation terminology.
   * E.g., "3 residents need care plan review"
   */
  actionLabel: Scalars['String']['output'];
  /** Navigation group ID (e.g., nav-grp-user-care) */
  groupId: Scalars['String']['output'];
  /** Tabler icon name */
  icon: Scalars['String']['output'];
  /** Group display label (from setting or NVO override) */
  label: Scalars['String']['output'];
  /** Total pending items in this group */
  pendingCount: Scalars['Int']['output'];
  /** Primary page path for one-click navigation */
  primaryPath: Scalars['String']['output'];
  /** Sort order (groups with urgent items float up) */
  sortOrder: Scalars['Int']['output'];
  /** Items breaching SLA (subset of pending_count) */
  urgentCount: Scalars['Int']['output'];
};

/** Node-specific metadata */
export type NodeMetadata = {
  __typename?: 'NodeMetadata';
  checkType?: Maybe<Scalars['String']['output']>;
  formType?: Maybe<Scalars['String']['output']>;
  interviewType?: Maybe<Scalars['String']['output']>;
  lookbackYears?: Maybe<Scalars['Int']['output']>;
  passingScore?: Maybe<Scalars['Int']['output']>;
  requiredDocuments: Array<Scalars['String']['output']>;
  trainingModule?: Maybe<Scalars['String']['output']>;
  validForDays?: Maybe<Scalars['Int']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

/** GraphQL output type for Notification primitive. */
export type Notification = {
  __typename?: 'Notification';
  archived: Scalars['Boolean']['output'];
  bccActorIds: Array<Scalars['String']['output']>;
  ccActorIds: Array<Scalars['String']['output']>;
  channels: Array<GqlNotificationChannel | '%future added value'>;
  complianceFrameworks: Array<Scalars['String']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this notification.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this notification */
  createdByActor?: Maybe<ActorSummary>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryAttempts: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastDeliveryError?: Maybe<Scalars['String']['output']>;
  messageTemplate: Scalars['String']['output'];
  notificationTitle: Scalars['String']['output'];
  notificationType: GqlNotificationTriggerType | '%future added value';
  originalId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  primitiveType: Scalars['String']['output'];
  priority: GqlNotificationPriority | '%future added value';
  readAt?: Maybe<Scalars['DateTime']['output']>;
  recipientActorIds: Array<Scalars['String']['output']>;
  relatedApprovalIds: Array<Scalars['String']['output']>;
  relatedSlaIds: Array<Scalars['String']['output']>;
  relatedTaskIds: Array<Scalars['String']['output']>;
  relatedTransactionIds: Array<Scalars['String']['output']>;
  retentionUntil?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: GqlNotificationStatus | '%future added value';
  triggerEntityId: Scalars['String']['output'];
  triggerEntityType: Scalars['String']['output'];
  triggerEventId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** WHO last updated this notification */
  updatedByActor?: Maybe<ActorSummary>;
  version: Scalars['Int']['output'];
  workflowInstanceId: Scalars['String']['output'];
};

/**
 * Result of archiving a notification (FERP Append-Only Architecture).
 *
 * FERP Principle: Immutable history for life-critical workflows.
 * No physical deletion - archive creates immutable audit trail.
 */
export type NotificationArchiveResult = {
  __typename?: 'NotificationArchiveResult';
  /** When the notification was archived (ISO 8601) */
  archivedAt: Scalars['DateTime']['output'];
  /** Who archived the notification */
  archivedBy: Scalars['String']['output'];
  /** Human-readable result message */
  message: Scalars['String']['output'];
  /** ID of the archived notification */
  notificationId: Scalars['String']['output'];
  /** Title of the archived notification */
  notificationTitle: Scalars['String']['output'];
  /** Mandatory reason for archival (audit trail) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  channel: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationList = {
  __typename?: 'NotificationList';
  /** Pagination token for next page */
  nextToken?: Maybe<Scalars['String']['output']>;
  /** List of notifications */
  notifications: Array<TaxNotification>;
  /** Total count (for pagination) */
  totalCount: Scalars['Int']['output'];
};

export type NotificationSettingsInput = {
  /** Notification channels configuration */
  channels?: InputMaybe<Scalars['JSON']['input']>;
  /** Email notification settings */
  emailEnabled: Scalars['Boolean']['input'];
  /** Quiet hours configuration */
  quietHours?: InputMaybe<QuietHoursInput>;
  /** SMS notification settings */
  smsEnabled: Scalars['Boolean']['input'];
  /** Webhook notification settings */
  webhookEnabled: Scalars['Boolean']['input'];
};

export type NotificationStats = {
  __typename?: 'NotificationStats';
  /** Count of failed notifications */
  failedCount: Scalars['Int']['output'];
  /** ISO8601 date of last sent notification */
  lastSentDate?: Maybe<Scalars['String']['output']>;
  /** ISO8601 date of next scheduled notification */
  nextNotificationDate?: Maybe<Scalars['String']['output']>;
  /** Count of scheduled notifications */
  scheduledCount: Scalars['Int']['output'];
  /** Count of successfully sent notifications */
  sentCount: Scalars['Int']['output'];
};

/** Observation connection */
export type ObservationConnection = {
  __typename?: 'ObservationConnection';
  edges: Array<ObservationEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Observation edge */
export type ObservationEdge = {
  __typename?: 'ObservationEdge';
  cursor: Scalars['String']['output'];
  node: FhirObservation;
};

/**
 * A single entity from the actor's ReadCache, ready to be stored in the
 * Automerge ReadCacheDoc. `data` is a JSON blob — the schema is defined by
 * the backend FormSchema for `entity_type`; the frontend never hard-codes it.
 */
export type OfflineCachedEntity = {
  __typename?: 'OfflineCachedEntity';
  /** Constellation ring this entity belongs to (0–4) */
  constellationRing: Scalars['Int']['output'];
  /** Full entity payload — the hub writes this into ReadCacheDoc.entities */
  data: Scalars['JSON']['output'];
  /** Stable entity ID (backend-canonical, not offline_id) */
  entityId: Scalars['String']['output'];
  /** Backend-defined type string: "resident", "medication", "matter", "account" */
  entityType: Scalars['String']['output'];
};

export type OfflineConfigInput = {
  canRunOffline: Scalars['Boolean']['input'];
  maxOfflineMinutes?: InputMaybe<Scalars['Int']['input']>;
  requiresSyncValidation: Scalars['Boolean']['input'];
};

/**
 * Full bootstrap payload for one actor's ReadCacheDoc.
 * The hub writes this into the Automerge doc; the device syncs it automatically.
 */
export type OfflineEnvelopePayload = {
  __typename?: 'OfflineEnvelopePayload';
  actorId: Scalars['String']['output'];
  /** Deterministic Automerge doc ID: "read-cache-{tenant_id}" */
  docId: Scalars['String']['output'];
  /** Entities scoped to this actor's constellation (residents, meds, tasks, etc.) */
  entities: Array<OfflineCachedEntity>;
  /**
   * FormSchema configs keyed by entity_type (JSON blobs, same shape as
   * the FormSchema API — lets the offline device render forms without network)
   */
  formSchemas: Array<OfflineFormSchema>;
  /** Server-defined staleness manifest — tenant can tighten FERP defaults only */
  stalenessManifest: Array<OfflineStalenessRule>;
  /** Unix millisecond timestamp of this snapshot — becomes ReadCacheDoc.synced_at */
  syncedAt: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/** A cached FormSchema entry — entity_type → schema JSON. */
export type OfflineFormSchema = {
  __typename?: 'OfflineFormSchema';
  entityType: Scalars['String']['output'];
  schema: Scalars['JSON']['output'];
};

/**
 * One rule in the staleness manifest. Mirrors `StalenessRule` in
 * `offline_core/src/types.ts`. All thresholds are non-negotiable FERP
 * defaults unless overridden by a tighter tenant constellation config.
 */
export type OfflineStalenessRule = {
  __typename?: 'OfflineStalenessRule';
  category: Scalars['String']['output'];
  /** If true, stale data blocks the action regardless of max_age_seconds */
  critical: Scalars['Boolean']['output'];
  /** Max age in seconds before the category is considered stale */
  maxAgeSeconds: Scalars['Int']['output'];
  /** Action on stale: "block" | "confirm" | "warn" */
  onStale: Scalars['String']['output'];
};

/** Operation Enum */
export const Operation = {
  ASSIGN: 'ASSIGN',
  REVOKE: 'REVOKE',
  UPDATE_EXPIRATION: 'UPDATE_EXPIRATION',
} as const;

export type Operation = (typeof Operation)[keyof typeof Operation];
/** Operation Count (GraphQL output) */
export type OperationCount = {
  __typename?: 'OperationCount';
  count: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
};

export type OptimizationGenerationRequestGql = {
  focusAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  maxRecommendations?: InputMaybe<Scalars['Int']['input']>;
  optimizationType: Array<RecommendationType | '%future added value'>;
  safetyThreshold?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
  timeRangeHours?: InputMaybe<Scalars['Int']['input']>;
  workflowName: Scalars['String']['input'];
};

export type OptimizationGenerationResponseGql = {
  __typename?: 'OptimizationGenerationResponseGql';
  generationTimeMs: Scalars['Int']['output'];
  llmModelUsed: Scalars['String']['output'];
  recommendations: Array<OptimizationRecommendationGql>;
  safetyAlerts: Array<Scalars['String']['output']>;
  totalAnalyzed: Scalars['Int']['output'];
};

export type OptimizationRecommendationGql = {
  __typename?: 'OptimizationRecommendationGql';
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  auditTrail: Array<AuditEventGql>;
  complianceTags: Array<Scalars['String']['output']>;
  confidenceLevel: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  estimatedImpact: ImpactEstimateGql;
  evidence: Array<AnalysisEvidenceGql>;
  generationTimestamp: Scalars['String']['output'];
  id: Scalars['String']['output'];
  implementationEffort: ImplementationEffort | '%future added value';
  implementedAt?: Maybe<Scalars['String']['output']>;
  llmModel: Scalars['String']['output'];
  llmPromptHash: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  priorityScore: Scalars['Int']['output'];
  proposedChanges: Array<ProposedChangeGql>;
  recommendationType: RecommendationType | '%future added value';
  regulatoryImpact: RegulatoryImpactGql;
  riskAssessment: RiskAssessmentGql;
  rootCauseAnalysis: Scalars['String']['output'];
  safetyValidation: SafetyValidationGql;
  severity: RecommendationSeverity | '%future added value';
  status: RecommendationStatus | '%future added value';
  tenant: Scalars['String']['output'];
  workflowName: Scalars['String']['output'];
};

export type OrchestrationPattern = {
  __typename?: 'OrchestrationPattern';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  defaultConfig?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orchestrationSteps: Array<OrchestrationStep>;
  patternType: Scalars['String']['output'];
  ruleTags: Array<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type OrchestrationRule = {
  __typename?: 'OrchestrationRule';
  actions: Scalars['JSON']['output'];
  appliesToDomains: Array<Scalars['String']['output']>;
  appliesToEntityTypes: Array<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  conditions: Scalars['JSON']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  inputSchema?: Maybe<Scalars['JSON']['output']>;
  isActive: Scalars['Boolean']['output'];
  isTerminal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originalId?: Maybe<Scalars['String']['output']>;
  outputSchema?: Maybe<Scalars['JSON']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  prerequisites: Array<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  purpose: Scalars['String']['output'];
  regulatoryFramework: Array<Scalars['String']['output']>;
  ruleId: Scalars['String']['output'];
  semanticMeaning: Scalars['String']['output'];
  sourcePrimitive: Scalars['String']['output'];
  sourcePrimitiveId: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type OrchestrationStep = {
  __typename?: 'OrchestrationStep';
  config?: Maybe<Scalars['JSON']['output']>;
  required: Scalars['Boolean']['output'];
  ruleTag?: Maybe<Scalars['String']['output']>;
  stepId: Scalars['String']['output'];
  stepType: Scalars['String']['output'];
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
};

export type OrchestrationStepInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  ruleTag?: InputMaybe<Scalars['String']['input']>;
  stepId: Scalars['String']['input'];
  stepType: Scalars['String']['input'];
  timeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Suggestions for organizing tasks */
export type OrganizationSuggestionOutput = {
  __typename?: 'OrganizationSuggestionOutput';
  /** Suggested grouping strategy */
  groupBy: Scalars['String']['output'];
  /** Priority overrides for specific tasks */
  priorityOverrides: Array<PriorityOverrideOutput>;
  /** Suggested sort order */
  sortOrder: Scalars['String']['output'];
};

/** Organizational structure metadata */
export type OrganizationalStructureGql = {
  __typename?: 'OrganizationalStructureGql';
  hierarchyLevels: Scalars['Int']['output'];
  reportingStructure: Scalars['JSON']['output'];
};

/** Context for task organization */
export type OrganizeContextInput = {
  /** Client IDs for client-based grouping */
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Current shift (e.g., "morning", "evening") */
  shift?: InputMaybe<Scalars['String']['input']>;
};

/** Input for organizing multiple tasks */
export type OrganizeTasksInput = {
  /** Context for organization (client IDs, shift info) */
  context?: InputMaybe<OrganizeContextInput>;
  /** User preferences */
  preferences?: InputMaybe<UserPreferencesInput>;
  /** Task IDs to organize */
  taskIds: Array<Scalars['String']['input']>;
  /** Tenant ID for isolation */
  tenantId: Scalars['String']['input'];
  /** User's role for context-aware organization */
  userRole?: InputMaybe<Scalars['String']['input']>;
};

/** Result of organizing tasks */
export type OrganizeTasksResult = {
  __typename?: 'OrganizeTasksResult';
  /** Task groups */
  groups: Array<TaskGroupOutput>;
  /** Organized task list */
  organizedTasks: Array<OrganizedTaskOutput>;
  /** Summary statistics */
  summary: TaskSummaryOutput;
};

/** Organized task with grouping and sorting info */
export type OrganizedTaskOutput = {
  __typename?: 'OrganizedTaskOutput';
  /** Group key this task belongs to */
  groupKey: Scalars['String']['output'];
  /** Human-readable group label */
  groupLabel: Scalars['String']['output'];
  /** Reason for priority/urgency */
  priorityReason: Scalars['String']['output'];
  /** Sort order within group */
  sortOrder: Scalars['Int']['output'];
  /** Suggested start time (if applicable) */
  suggestedStartTime?: Maybe<Scalars['String']['output']>;
  /** Task ID */
  taskId: Scalars['String']['output'];
  /** Urgency score (0.0 - 1.0) */
  urgencyScore: Scalars['Float']['output'];
};

/** Outlier Value (Provider Disagreement) */
export type OutlierValue = {
  __typename?: 'OutlierValue';
  /** Deviation score (0.0-1.0, higher = more different) */
  deviationScore: Scalars['Float']['output'];
  /** Provider name */
  provider: Scalars['String']['output'];
  /** Outlier value extracted */
  value: Scalars['JSON']['output'];
};

export const OverrideClassification = {
  BLOCKED: 'BLOCKED',
  CAUTION: 'CAUTION',
  SAFE: 'SAFE',
} as const;

export type OverrideClassification =
  (typeof OverrideClassification)[keyof typeof OverrideClassification];
/** Override policy — how conflicts between jurisdictions resolve. */
export type OverridePolicy = {
  __typename?: 'OverridePolicy';
  /** Resolution strategy (e.g., "more_restrictive_wins") */
  conflictResolution: Scalars['String']['output'];
  /** Direction (e.g., "state_overrides_federal") */
  direction: Scalars['String']['output'];
  /** Documentation of the override rationale */
  documentation?: Maybe<Scalars['String']['output']>;
};

export const OverrideStatus = {
  ACTIVE: 'ACTIVE',
  DENIED: 'DENIED',
  EXPIRED: 'EXPIRED',
  PENDING_CONFERENCE: 'PENDING_CONFERENCE',
} as const;

export type OverrideStatus = (typeof OverrideStatus)[keyof typeof OverrideStatus];
/**
 * PII data classification levels.
 *
 * **Security Model:**
 * - L1: User biometric ONLY (SSN, bank account) - guardians NEVER have access
 * - L1G: User OR enrolled guardian (name, DOB, address)
 * - L2: Facility staff with RBAC (allergies, medications)
 * - L3: Standard RBAC (job title, department)
 *
 * **Used By:**
 * - pii-vault: Defines encryption tier for each field
 * - payroll: Determines consent requirements for 1099
 * - fhir: Determines access for patient identity vs clinical data
 */
export const PiiDataClassification = {
  /** User OR enrolled guardian - name, DOB, address */
  L1G_USER_OR_GUARDIAN: 'L1G_USER_OR_GUARDIAN',
  /** User biometric ONLY - SSN, bank accounts (guardians NEVER have access) */
  L1_USER_ONLY: 'L1_USER_ONLY',
  /** Facility staff with RBAC - allergies, medications (care operational) */
  L2_CARE_OPERATIONAL: 'L2_CARE_OPERATIONAL',
  /** Standard RBAC - job title, department (general operational) */
  L3_GENERAL_OPERATIONAL: 'L3_GENERAL_OPERATIONAL',
} as const;

export type PiiDataClassification =
  (typeof PiiDataClassification)[keyof typeof PiiDataClassification];
export const PadesProfile = {
  /** Basic Electronic Signature */
  BB: 'BB',
  /** B-T + OCSP + DSS (long-term validation) */
  BLT: 'BLT',
  /** B-LT + document timestamp (7+ year archival) */
  BLTA: 'BLTA',
  /** B-B + RFC 3161 timestamp */
  BT: 'BT',
} as const;

export type PadesProfile = (typeof PadesProfile)[keyof typeof PadesProfile];
/** Auto-increment configuration for sequential category generation. */
export type PageAssignmentAutoIncrement = {
  __typename?: 'PageAssignmentAutoIncrement';
  /** Whether auto-increment is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Template for generated labels (e.g., "Floor {n}") */
  labelTemplate: Scalars['String']['output'];
  /** Starting number */
  start: Scalars['Int']['output'];
};

/** A category that pages can be assigned to. */
export type PageAssignmentCategory = {
  __typename?: 'PageAssignmentCategory';
  /** Hex color for UI badge/border */
  color?: Maybe<Scalars['String']['output']>;
  /** Optional description shown as tooltip */
  description?: Maybe<Scalars['String']['output']>;
  /** Tabler icon name */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique category identifier within this context */
  id: Scalars['String']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** Sort order for display */
  sortOrder: Scalars['Int']['output'];
};

/** Full page assignment configuration for a context — drives the DocumentPageAssigner component. */
export type PageAssignmentConfig = {
  __typename?: 'PageAssignmentConfig';
  /** Auto-increment config (if categories are generated sequentially) */
  autoIncrement?: Maybe<PageAssignmentAutoIncrement>;
  /** Static categories (empty if auto-increment or dynamic) */
  categories: Array<PageAssignmentCategory>;
  /** Assignment constraints */
  constraints: PageAssignmentConstraints;
  /** Context identifier (e.g., "floor_plans", "contract_sections") */
  contextId: Scalars['String']['output'];
  /** Description of this context */
  description: Scalars['String']['output'];
  /** Output mode: image export or page range */
  mode: PageAssignmentMode | '%future added value';
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** MIME type for image export mode (e.g., "image/png") */
  outputMime?: Maybe<Scalars['String']['output']>;
  /** UI rendering configuration */
  ui: PageAssignmentUiConfig;
};

/** Constraints on page assignment behavior. */
export type PageAssignmentConstraints = {
  __typename?: 'PageAssignmentConstraints';
  /** Maximum total assignments (0 = unlimited) */
  maxAssignments: Scalars['Int']['output'];
  /** Whether a page can be assigned to multiple categories */
  multiCategory: Scalars['Boolean']['output'];
  /** Category IDs that must have at least one page assigned */
  requiredCategories: Array<Scalars['String']['output']>;
};

/** Output mode for page assignment — determines what the frontend produces. */
export const PageAssignmentMode = {
  /** Pages exported as PNG blobs (floor plans, diagrams) */
  IMAGE_EXPORT: 'IMAGE_EXPORT',
  /** Page number ranges only (contracts, regulations, intake docs) */
  PAGE_RANGE: 'PAGE_RANGE',
} as const;

export type PageAssignmentMode = (typeof PageAssignmentMode)[keyof typeof PageAssignmentMode];
/** UI configuration for the page assigner component. */
export type PageAssignmentUiConfig = {
  __typename?: 'PageAssignmentUiConfig';
  /** Label for the assign button */
  assignButtonLabel: Scalars['String']['output'];
  /** Mantine color for assigned badge */
  assignedBadgeColor: Scalars['String']['output'];
  /** Grid columns for thumbnail layout */
  columns: Scalars['Int']['output'];
  /** Tabler icon name for the context header */
  icon: Scalars['String']['output'];
  /** Thumbnail render width in pixels */
  thumbnailWidth: Scalars['Int']['output'];
};

/**
 * Shared page info output for connection types.
 *
 * **Used By:**
 * - All primitive APIs with connection types
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Cursor for the last item in this page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more items after this page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are items before this page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor for the first item in this page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Shared pagination input for list queries.
 *
 * **Used By:**
 * - All primitive APIs with list/connection queries
 */
export type PaginationInput = {
  /** Cursor for pagination (opaque string from previous response) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of items to return (default: 20, max: 100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Parameter metadata from DynamoDB for S3 + DynamoDB hybrid storage */
export type ParameterMetadataGql = {
  __typename?: 'ParameterMetadataGql';
  cacheTtl: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Parameter Type Enum (GraphQL) */
export const ParameterType = {
  /** Array parameter */
  ARRAY: 'ARRAY',
  /** Boolean parameter */
  BOOLEAN: 'BOOLEAN',
  /** Number parameter */
  NUMBER: 'NUMBER',
  /** Object parameter */
  OBJECT: 'OBJECT',
  /** String parameter */
  STRING: 'STRING',
} as const;

export type ParameterType = (typeof ParameterType)[keyof typeof ParameterType];
/** Parameter version for batch cache validation */
export type ParameterVersionGql = {
  __typename?: 'ParameterVersionGql';
  checksum: Scalars['String']['output'];
  paramName: Scalars['String']['output'];
  paramType: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for parameter version batch queries */
export type ParameterVersionInput = {
  paramName: Scalars['String']['input'];
  paramType: Scalars['String']['input'];
};

export type ParticipantInput = {
  /** Signing location embedded in the PDF appearance stream. */
  appearanceLocation?: InputMaybe<Scalars['String']['input']>;
  /** Signing reason embedded in the PDF appearance stream. */
  appearanceReason?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  /** Field type (B1 — field placement). Defaults to Signature. */
  fieldType?: InputMaybe<SignatureFieldType | '%future added value'>;
  /** Field height (relative 0–1). */
  height?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Page number for the signature field (1-indexed). None = invisible field. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** E.164 phone number for SMS notifications, e.g. "+16125550123" (D2). */
  phone?: InputMaybe<Scalars['String']['input']>;
  role: SignerRole | '%future added value';
  /** Field width (relative 0–1). */
  width?: InputMaybe<Scalars['Float']['input']>;
  /** Left edge of field (relative 0–1, origin top-left). */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Top edge of field (relative 0–1, origin top-left). */
  y?: InputMaybe<Scalars['Float']['input']>;
};

export const ParticipantStatus = {
  DECLINED: 'DECLINED',
  PENDING: 'PENDING',
  SIGNED: 'SIGNED',
  VIEWED: 'VIEWED',
} as const;

export type ParticipantStatus = (typeof ParticipantStatus)[keyof typeof ParticipantStatus];
/** Patient connection for paginated queries */
export type PatientConnection = {
  __typename?: 'PatientConnection';
  edges: Array<PatientEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Patient edge in a connection */
export type PatientEdge = {
  __typename?: 'PatientEdge';
  cursor: Scalars['String']['output'];
  node: FhirPatient;
};

/**
 * User-provided overrides when instantiating a pattern template.
 *
 * Allows callers to customize the generated form without modifying
 * the underlying pattern template definition.
 */
export type PatternConfigInput = {
  /** Override the default display name shown in UI headers/breadcrumbs. */
  displayNameOverride?: InputMaybe<Scalars['String']['input']>;
  /** Override the default entity type name for the generated schema. */
  entityTypeOverride?: InputMaybe<Scalars['String']['input']>;
  /** Additional fields to append to the generated form. */
  extraFields?: InputMaybe<Array<FormFieldDefinitionInput>>;
  /** Field names from the pattern to exclude from the generated form. */
  hiddenFieldNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Describes a single field to generate within a pattern template.
 *
 * Carries enough information for the backend to emit a fully-formed
 * `GqlFormFieldDefinition` without the frontend needing to infer
 * any field semantics.
 */
export type PatternFieldSpec = {
  __typename?: 'PatternFieldSpec';
  /** Configuration for computed/derived fields. */
  computedConfig?: Maybe<ComputedFieldConfig>;
  /** Machine-readable field identifier (e.g., `"patient_name"`). */
  fieldName: Scalars['String']['output'];
  /** GraphQL field type controlling the rendered input widget. */
  fieldType: FormFieldType | '%future added value';
  /** Configuration for grid/table-embedded fields. */
  gridConfig?: Maybe<GridConfig>;
  /** Configuration for hierarchical (tree) field behavior. */
  hierarchicalConfig?: Maybe<HierarchicalConfig>;
  /** Human-readable label displayed in the UI. */
  label: Scalars['String']['output'];
  /** Configuration for master-detail linked fields. */
  masterDetailConfig?: Maybe<MasterDetailConfig>;
  /** Display order within its section (lower = first). */
  order: Scalars['Int']['output'];
  /** Whether the field is required for form submission. */
  required: Scalars['Boolean']['output'];
  /** Predefined select/dropdown options for this field. */
  selectOptions?: Maybe<Array<SelectOption>>;
  /** Optional CSS-compatible width hint (e.g., `"50%"`, `"200px"`). */
  width?: Maybe<Scalars['String']['output']>;
};

/**
 * Identifies a reusable form pattern template.
 *
 * Each variant maps to a well-known UI/data pattern used across
 * healthcare RCM, financial services, and legal workflows.
 */
export const PatternId = {
  /** Read-only aggregated view across multiple source entities. */
  AGGREGATE_VIEW: 'AGGREGATE_VIEW',
  /** Multi-step approval workflow with audit trail. */
  APPROVAL_FLOW: 'APPROVAL_FLOW',
  /** System or tenant configuration key/value management. */
  CONFIGURATION: 'CONFIGURATION',
  /** Document upload, versioning, and metadata capture. */
  DOCUMENT: 'DOCUMENT',
  /** Header section with tabular line items (e.g., invoice + rows). */
  HEADER_LINES: 'HEADER_LINES',
  /** Tree-structured entities with parent/child relationships. */
  HIERARCHICAL: 'HIERARCHICAL',
  /** Read-only or typeahead reference lookup against a registry. */
  LOOKUP_REFERENCE: 'LOOKUP_REFERENCE',
  /** A primary record with a related detail list (e.g., order + line items). */
  MASTER_DETAIL: 'MASTER_DETAIL',
  /** Many-to-many or association-table relationship management. */
  RELATIONSHIP: 'RELATIONSHIP',
  /** Basic create/read/update operations on a single entity. */
  SIMPLE_CRUD: 'SIMPLE_CRUD',
  /** Entity whose primary concern is lifecycle status transitions. */
  STATUS_TRACKER: 'STATUS_TRACKER',
  /** Time-indexed data points (e.g., vitals, metrics). */
  TIME_SERIES: 'TIME_SERIES',
} as const;

export type PatternId = (typeof PatternId)[keyof typeof PatternId];
/**
 * Descriptive metadata for a pattern template.
 *
 * Used by the frontend to display pattern selection UI and guide
 * users toward the correct template for their entity type.
 */
export type PatternMetadata = {
  __typename?: 'PatternMetadata';
  /** Complexity rating: "low", "medium", or "high". */
  complexity: Scalars['String']['output'];
  /** Brief description of when this pattern applies. */
  description: Scalars['String']['output'];
  /** Representative entity examples that fit this pattern. */
  exampleEntities: Array<Scalars['String']['output']>;
  /** Primary field types used by this pattern (e.g., "TextInput", "GRID"). */
  keyFieldTypes: Array<Scalars['String']['output']>;
  /** Human-readable pattern name (e.g., "Simple CRUD"). */
  name: Scalars['String']['output'];
  /** Unique pattern identifier. */
  patternId: PatternId | '%future added value';
};

/** Describes a visual section grouping fields within a pattern template. */
export type PatternSectionSpec = {
  __typename?: 'PatternSectionSpec';
  /** Whether the section can be collapsed by the user. */
  collapsible?: Maybe<Scalars['Boolean']['output']>;
  /** Number of grid columns for this section layout (default = 1). */
  columns?: Maybe<Scalars['Int']['output']>;
  /** Optional explanatory text rendered below the title. */
  description?: Maybe<Scalars['String']['output']>;
  /** Ordered list of `PatternFieldSpec.field_name` values in this section. */
  fieldNames: Array<Scalars['String']['output']>;
  /** Unique section identifier within the template. */
  id: Scalars['String']['output'];
  /** Display order among sibling sections (lower = first). */
  order: Scalars['Int']['output'];
  /** Section heading displayed in the UI. */
  title: Scalars['String']['output'];
};

/**
 * A complete, reusable form pattern template.
 *
 * Templates are the authoritative source for field definitions,
 * section layout, validations, and optional mutation/query scaffolding.
 * The frontend renders these without adding any local logic (Dumb Frontend).
 */
export type PatternTemplate = {
  __typename?: 'PatternTemplate';
  /** Optional GraphQL mutation template string for create operations. */
  createMutationTemplate?: Maybe<Scalars['String']['output']>;
  /** Longer description of when/why to use this pattern. */
  description: Scalars['String']['output'];
  /** Optional GraphQL query template string for data fetching. */
  fetchQueryTemplate?: Maybe<Scalars['String']['output']>;
  /** All fields the pattern defines, in their default order. */
  fieldSpecs: Array<PatternFieldSpec>;
  /** Human-readable template name (e.g., "Simple CRUD Form"). */
  name: Scalars['String']['output'];
  /** Which pattern this template implements. */
  patternId: PatternId | '%future added value';
  /** Safety classification governing approval and audit requirements. */
  safetyLevel: FormSafetyLevel | '%future added value';
  /** Section layout for organizing fields in the UI. */
  sectionSpecs: Array<PatternSectionSpec>;
  /** Optional GraphQL mutation template string for update operations. */
  updateMutationTemplate?: Maybe<Scalars['String']['output']>;
  /** Validation rules applied to the generated form. */
  validations?: Maybe<Array<FormValidationRule>>;
};

/** Input for pausing accumulator */
export type PauseAccumulatorInput = {
  reason: Scalars['String']['input'];
  residentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Federation-aware detail reference for Payroll Run */
export type PayrollRunDetailRef = {
  __typename?: 'PayrollRunDetailRef';
  /** Payroll Run ID (federation key) */
  id: Scalars['ID']['output'];
};

/** A PDF template definition (read from DynamoDB, seeded from YAML) */
export type PdfTemplate = {
  __typename?: 'PdfTemplate';
  /** When the template was created */
  createdAt: Scalars['String']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable template name */
  name: Scalars['String']['output'];
  /** Page orientation (portrait, landscape) */
  orientation?: Maybe<Scalars['String']['output']>;
  /** Page size (letter, a4, legal) */
  pageSize: Scalars['String']['output'];
  /** Subgraph this template belongs to (e.g., "hc", "pay", "core") */
  subgraph: Scalars['String']['output'];
  /** Unique template identifier (e.g., "pdf-tpl-hc-eob-001") */
  templateId: Scalars['String']['output'];
  /** When the template was last updated */
  updatedAt: Scalars['String']['output'];
  /** Variable names required by this template */
  variables: Array<Scalars['String']['output']>;
  /** Template version */
  version: Scalars['String']['output'];
};

/**
 * A pending config proposal awaiting architect review.
 *
 * All fields are parsed server-side from the config storage format.
 * The storage format itself is an internal implementation detail and
 * NEVER exposed through the GraphQL boundary.
 */
export type PendingProposal = {
  __typename?: 'PendingProposal';
  /** Config type: "rule", "task_group", or "workflow". */
  configType: Scalars['String']['output'];
  /** Description of what this proposal does. */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Typed relationships (edges) declared by this proposal. */
  edges: Array<ProposalEdge>;
  /** When the proposal was generated (ISO 8601). */
  generatedAt?: Maybe<Scalars['String']['output']>;
  /** Proposal ID (derived from filename, e.g., "rl-4-0-148"). */
  proposalId: Scalars['String']['output'];
  /** Key regulatory provisions (for rule proposals). */
  provisions: Array<ProposalProvision>;
  /** Safety level (critical, high, medium, low, advisory). */
  safetyLevel?: Maybe<Scalars['String']['output']>;
  /** Setting context (e.g., "assisted_living"). */
  setting?: Maybe<Scalars['String']['output']>;
  /** Source rule that identified the gap (e.g., "rl-4-0-140"). */
  sourceRule?: Maybe<Scalars['String']['output']>;
  /** Workflow states (for workflow proposals). */
  states: Array<ProposalWorkflowState>;
  /** Proposal status (draft, approved, rejected). */
  status: Scalars['String']['output'];
  /** Statute references (e.g., "MN 144G.03, 144G.05"). */
  statuteRef?: Maybe<Scalars['String']['output']>;
  /** Subgraph context (e.g., "fhir"). */
  subgraph?: Maybe<Scalars['String']['output']>;
  /** Workflow transitions (for workflow proposals). */
  transitions: Array<ProposalWorkflowTransition>;
  /** Trigger event (for workflows, e.g., "on_staff_hire"). */
  trigger?: Maybe<Scalars['String']['output']>;
};

/** Summary of all pending proposals. */
export type PendingProposalsSummary = {
  __typename?: 'PendingProposalsSummary';
  /** All pending proposals. */
  proposals: Array<PendingProposal>;
  /** Breakdown by config type. */
  ruleCount: Scalars['Int']['output'];
  taskGroupCount: Scalars['Int']['output'];
  /** Total number of pending proposals. */
  totalCount: Scalars['Int']['output'];
  workflowCount: Scalars['Int']['output'];
};

/** Performance configuration */
export type PerformanceConfig = {
  __typename?: 'PerformanceConfig';
  batchUpdates?: Maybe<Scalars['Boolean']['output']>;
  debounceValidation?: Maybe<Scalars['Int']['output']>;
  lazyLoadThreshold?: Maybe<Scalars['Int']['output']>;
  preloadWidgets: Array<Scalars['String']['output']>;
  virtualizeThreshold?: Maybe<Scalars['Int']['output']>;
};

export type PerformanceImprovementGql = {
  __typename?: 'PerformanceImprovementGql';
  errorRateReductionPct: Scalars['Float']['output'];
  executionTimeReductionPct: Scalars['Float']['output'];
  throughputIncreasePct: Scalars['Float']['output'];
};

/** Performance metric for real-time monitoring */
export type PerformanceMetric = {
  __typename?: 'PerformanceMetric';
  additionalMetadata: Scalars['JSON']['output'];
  isThresholdExceeded: Scalars['Boolean']['output'];
  metricId: Scalars['String']['output'];
  metricType: Scalars['String']['output'];
  primitiveType?: Maybe<Scalars['String']['output']>;
  sagaExecutionId?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  threshold: Scalars['Float']['output'];
  timestamp: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** GraphQL output type for performance statistics. */
export type PerformanceStats = {
  __typename?: 'PerformanceStats';
  /** Average duration */
  avgDurationMs: Scalars['Int']['output'];
  /** Cache hit rate (percentage) */
  cacheHitRate: Scalars['Float']['output'];
  /** Failure count */
  failureCount: Scalars['Int']['output'];
  /** Median duration (p50) */
  p50DurationMs: Scalars['Int']['output'];
  /** 95th percentile duration */
  p95DurationMs: Scalars['Int']['output'];
  /** 99th percentile duration */
  p99DurationMs: Scalars['Int']['output'];
  /** Success count */
  successCount: Scalars['Int']['output'];
  /** Total cache hits */
  totalCacheHits: Scalars['Int']['output'];
  /** Total cache misses */
  totalCacheMisses: Scalars['Int']['output'];
  /** Total number of spans */
  totalSpans: Scalars['Int']['output'];
  /** Workflow instance ID */
  workflowInstanceId: Scalars['String']['output'];
};

/** GraphQL output type for Permission. */
export type Permission = {
  __typename?: 'Permission';
  /** Action allowed (e.g., "read", "write", "delete", "approve") */
  action: Scalars['String']['output'];
  /** Optional condition (JSONPath expression) */
  condition?: Maybe<Scalars['String']['output']>;
  /** Resource type (e.g., "Patient", "Claim", "Workflow") */
  resourceType: Scalars['String']['output'];
  /** Scope constraint */
  scope: GqlPermissionScope | '%future added value';
};

/** GraphQL input type for Permission. */
export type PermissionInput = {
  /** Action */
  action: Scalars['String']['input'];
  /** Optional condition */
  condition?: InputMaybe<Scalars['String']['input']>;
  /** Resource type */
  resourceType: Scalars['String']['input'];
  /** Scope */
  scope: GqlPermissionScope | '%future added value';
};

/** GraphQL output type for permission validation result. */
export type PermissionValidationResult = {
  __typename?: 'PermissionValidationResult';
  /** Reason if denied */
  denialReason?: Maybe<Scalars['String']['output']>;
  /** Does role have this permission? */
  hasPermission: Scalars['Boolean']['output'];
  /** Parent role ID if inherited */
  inheritedFrom?: Maybe<Scalars['String']['output']>;
  /** Source of permission (own, inherited, denied) */
  source: Scalars['String']['output'];
};

/** Input for saving draft to persistent storage */
export type PersistDraftInput = {
  /** Draft ID */
  draftId: Scalars['String']['input'];
  /** Optional: Change status before persisting */
  newStatus?: InputMaybe<DraftStatus | '%future added value'>;
};

/** PII attestation status (GraphQL output type) */
export type PiiAttestationStatus = {
  __typename?: 'PiiAttestationStatus';
  attestationId: Scalars['String']['output'];
  batchId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Int']['output'];
  recordCount: Scalars['Int']['output'];
  recordsImported?: Maybe<Scalars['Int']['output']>;
  status: AttestationStatus | '%future added value';
  tenantId: Scalars['String']['output'];
};

/** PII entity types (from Presidio detection) */
export const PiiEntityType = {
  CREDIT_CARD: 'CREDIT_CARD',
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  IBAN_CODE: 'IBAN_CODE',
  IP_ADDRESS: 'IP_ADDRESS',
  MEDICAL_LICENSE: 'MEDICAL_LICENSE',
  NPI_NUMBER: 'NPI_NUMBER',
  OTHER: 'OTHER',
  PHONE_NUMBER: 'PHONE_NUMBER',
  US_ADDRESS: 'US_ADDRESS',
  US_BANK_NUMBER: 'US_BANK_NUMBER',
  US_DRIVER_LICENSE: 'US_DRIVER_LICENSE',
  US_PASSPORT: 'US_PASSPORT',
  US_SSN: 'US_SSN',
} as const;

export type PiiEntityType = (typeof PiiEntityType)[keyof typeof PiiEntityType];
/** Single PII record to store */
export type PiiRecordInput = {
  /** Column name from source file */
  columnName: Scalars['String']['input'];
  /** PII entity type */
  entityType: PiiEntityType | '%future added value';
  /** Subject actor ID */
  subjectId: Scalars['String']['input'];
  /** The PII value to vault */
  value: Scalars['String']['input'];
};

/** Token for a stored PII record */
export type PiiToken = {
  __typename?: 'PiiToken';
  /** Entity type */
  entityType: PiiEntityType | '%future added value';
  /** Last 4 characters for display */
  lastFour: Scalars['String']['output'];
  /** Subject actor ID */
  subjectId: Scalars['String']['output'];
  /** Opaque token reference */
  token: Scalars['String']['output'];
};

/** Result of DRR-072 meta-orchestration pipeline execution */
export type PipelineExecutionResult = {
  __typename?: 'PipelineExecutionResult';
  /** Total capabilities evaluated */
  capabilitiesEvaluated: Scalars['Int']['output'];
  /** Number of capabilities that matched the document context */
  capabilitiesMatched: Scalars['Int']['output'];
  /** Completed nodes */
  completedNodes: Scalars['Int']['output'];
  /** Document that triggered the pipeline */
  documentId: Scalars['String']['output'];
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** DAG execution ID (for querying status/metrics via dagExecutionStatus) */
  executionId: Scalars['String']['output'];
  /** Failed nodes */
  failedNodes: Scalars['Int']['output'];
  /** IDs of matched capabilities (for traceability) */
  matchedCapabilityIds: Array<Scalars['String']['output']>;
  /** Execution status (Completed, Failed, etc.) */
  status: Scalars['String']['output'];
  /** Whether the pipeline executed successfully */
  success: Scalars['Boolean']['output'];
  /** Tenant context */
  tenant: Scalars['String']['output'];
  /** Total execution time in milliseconds */
  totalDurationMs?: Maybe<Scalars['Int']['output']>;
  /** Total nodes in the compiled pipeline */
  totalNodes: Scalars['Int']['output'];
};

/** Change between plan versions */
export type PlanChange = {
  __typename?: 'PlanChange';
  /** Type of change (added, removed, modified) */
  changeType: PlanChangeType | '%future added value';
  /** Field or domain that changed */
  field: Scalars['String']['output'];
  /** New value (if applicable) */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Previous value (if applicable) */
  previousValue?: Maybe<Scalars['String']['output']>;
};

/** Type of change between versions */
export const PlanChangeType = {
  /** New field or domain added */
  ADDED: 'ADDED',
  /** Field or domain value modified */
  MODIFIED: 'MODIFIED',
  /** Field or domain removed */
  REMOVED: 'REMOVED',
} as const;

export type PlanChangeType = (typeof PlanChangeType)[keyof typeof PlanChangeType];
/** Comparison between plan versions */
export type PlanComparison = {
  __typename?: 'PlanComparison';
  /** List of changes between versions */
  changes: Array<PlanChange>;
  /** Days until current plan expires */
  daysUntilExpiry?: Maybe<Scalars['Int']['output']>;
  /** Whether this is an initial plan */
  isInitial: Scalars['Boolean']['output'];
  /** Prior version (None if this is initial plan) */
  priorVersion?: Maybe<PlanVersion>;
  /** Proposed/current version */
  proposedVersion: PlanVersion;
  /** Subject identifier */
  subjectId: Scalars['String']['output'];
  /** Subject display name */
  subjectName: Scalars['String']['output'];
};

/**
 * A plan awaiting approval or review.
 * Domain-agnostic representation of any plan requiring multi-role approval.
 */
export type PlanQueueItem = {
  __typename?: 'PlanQueueItem';
  /** Activity domains covered by this plan */
  activityDomains: Array<ActivityDomain>;
  /** Creation timestamp (Unix ms) */
  createdAt: Scalars['Int']['output'];
  /** Days until plan expires (if applicable) */
  daysUntilExpiry?: Maybe<Scalars['Int']['output']>;
  /** Whether this is an initial plan or update */
  isInitial: Scalars['Boolean']['output'];
  /** Unique plan identifier */
  planId: Scalars['String']['output'];
  /** Plan type identifier (care_plan, case_plan, project_plan) */
  planType: Scalars['String']['output'];
  /** Role required to approve this plan */
  requiredAuthorityRole: Scalars['String']['output'];
  /** Role required to review this plan */
  requiredReviewerRole?: Maybe<Scalars['String']['output']>;
  /** Current plan status */
  status: PlanStatus | '%future added value';
  /** Subject identifier (resident, client, project, account) */
  subjectId: Scalars['String']['output'];
  /** Subject display name for UI */
  subjectName: Scalars['String']['output'];
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Last update timestamp (Unix ms) */
  updatedAt?: Maybe<Scalars['Int']['output']>;
  /** Plan version number */
  version: Scalars['Int']['output'];
};

/** Input for submitting a plan review */
export type PlanReviewInput = {
  /** Approval decision */
  approved: Scalars['Boolean']['input'];
  /** Review notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Plan identifier */
  planId: Scalars['String']['input'];
  /** Reviewer actor ID */
  reviewerActorId: Scalars['String']['input'];
  /** Tenant identifier */
  tenantId: Scalars['String']['input'];
};

/** Result of plan review submission */
export type PlanReviewResult = {
  __typename?: 'PlanReviewResult';
  /** Next required action (if any) */
  nextAction?: Maybe<Scalars['String']['output']>;
  /** Plan identifier */
  planId: Scalars['String']['output'];
  /** Review timestamp */
  reviewedAt: Scalars['Int']['output'];
  /** New status after review */
  status: PlanStatus | '%future added value';
};

/** Input for planning a shift */
export type PlanShiftInput = {
  /** Shift duration in hours (default 8) */
  durationHours?: InputMaybe<Scalars['Int']['input']>;
  /** Floor/unit to plan for */
  floorId: Scalars['String']['input'];
  /** Shift start (defaults to now) */
  shiftStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Plan status values */
export const PlanStatus = {
  /** Approved and active */
  ACTIVE: 'ACTIVE',
  /** Draft, not yet submitted */
  DRAFT: 'DRAFT',
  /** Expired (past effective end date) */
  EXPIRED: 'EXPIRED',
  /** Awaiting authority approval */
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  /** Awaiting review */
  PENDING_REVIEW: 'PENDING_REVIEW',
  /** Rejected by reviewer or authority */
  REJECTED: 'REJECTED',
  /** Superseded by newer version */
  SUPERSEDED: 'SUPERSEDED',
} as const;

export type PlanStatus = (typeof PlanStatus)[keyof typeof PlanStatus];
/** Plan version for comparison */
export type PlanVersion = {
  __typename?: 'PlanVersion';
  /** Activity domains in this version */
  activityDomains: Array<ActivityDomain>;
  /** Creation timestamp */
  createdAt: Scalars['Int']['output'];
  /** Actor who created this version */
  createdBy: Scalars['String']['output'];
  /** Summary of this version */
  summary?: Maybe<Scalars['String']['output']>;
  /** Version number */
  version: Scalars['Int']['output'];
};

/** An action that WOULD be executed, but is suppressed in simulation. */
export type PlannedAction = {
  __typename?: 'PlannedAction';
  actionType: Scalars['String']['output'];
  params: Scalars['JSON']['output'];
  /** Always true in simulation */
  sideEffectsSuppressed: Scalars['Boolean']['output'];
  /** Human-readable descriptions of what would be created */
  wouldCreate: Array<Scalars['String']['output']>;
};

/** Planned resource reservation */
export type PlannedReservation = {
  __typename?: 'PlannedReservation';
  /** Whether confirmed */
  confirmed: Scalars['Boolean']['output'];
  /** End time */
  endTime: Scalars['DateTime']['output'];
  /** Reservation ID */
  reservationId: Scalars['String']['output'];
  /** Resource code */
  resourceCode: Scalars['String']['output'];
  /** Start time */
  startTime: Scalars['DateTime']['output'];
  /** Subject using the resource */
  subjectId: Scalars['String']['output'];
  /** Task this reservation is for */
  taskId: Scalars['String']['output'];
};

/** GraphQL output type for Policy primitive. */
export type Policy = {
  __typename?: 'Policy';
  /** Active flag */
  active: Scalars['Boolean']['output'];
  /** Approvals governed by this policy */
  associatedApprovalIds: Array<Scalars['String']['output']>;
  /** Documents validated by this policy */
  associatedDocumentIds: Array<Scalars['String']['output']>;
  /** Roles required for policy actions */
  associatedRoleIds: Array<Scalars['String']['output']>;
  /** Audit level (None, Basic, Detailed, Complete) */
  auditLevel: GqlAuditLevel | '%future added value';
  /** Performance SLA tracking (target: <1ms for Zen Engine) */
  avgEvaluationTimeMs: Scalars['Float']['output'];
  /** Cache efficiency (0.0-1.0) */
  cacheHitRate: Scalars['Float']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this policy.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Is policy enabled? */
  enabled: Scalars['Boolean']['output'];
  /** Total evaluations (lifetime counter) */
  evaluationCount: Scalars['Int']['output'];
  /** Which formula uses this policy */
  formulaContext?: Maybe<Scalars['String']['output']>;
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Policy implementation engine (Cedar, CEL, JsonLogic, Zen) */
  implementation: GqlPolicyImplementation | '%future added value';
  /** Soft delete flag */
  isActive: Scalars['Boolean']['output'];
  /** Extensible metadata (JSON) */
  metadata: Scalars['String']['output'];
  /** Policy name */
  name: Scalars['String']['output'];
  /** Stable ID across all versions */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Link to previous version */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Policy type (Approval, Validation, Security, Compliance, Notification) */
  policyType: GqlPolicyType | '%future added value';
  /** Numeric version for append-only tracking */
  recordVersion: Scalars['Int']['output'];
  /** Policy rules */
  rules: Array<LegacyPolicyRule>;
  /** Policy scope (Workflow, Task, Approval, Global) */
  scope: GqlPolicyScope | '%future added value';
  /** Audit version */
  version: Scalars['Int']['output'];
  /** Workflow context (if workflow-scoped) */
  workflowInstanceId?: Maybe<Scalars['String']['output']>;
};

/** Policy Action Output */
export type PolicyAction = {
  __typename?: 'PolicyAction';
  /** Action parameters (JSON) */
  params: Scalars['JSON']['output'];
  /** Action type */
  type: PolicyActionType | '%future added value';
};

/** Policy Action Input (from PolicyRuleBuilder UI) */
export type PolicyActionInput = {
  /** Action parameters (JSON object) */
  params: Scalars['JSON']['input'];
  /** Action type */
  type: PolicyActionType | '%future added value';
};

/** Policy Action Template (GraphQL Output) */
export type PolicyActionTemplate = {
  __typename?: 'PolicyActionTemplate';
  /** Action type (APPROVE, ESCALATE, BLOCK, etc.) */
  actionType: Scalars['String']['output'];
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Parameters template (may contain {{parameter}} placeholders) */
  paramsTemplate: Scalars['JSON']['output'];
};

/** Policy Action Type Enum (GraphQL) */
export const PolicyActionType = {
  /** Auto-approve */
  APPROVE: 'APPROVE',
  /** Block action */
  BLOCK: 'BLOCK',
  /** Custom action */
  CUSTOM: 'CUSTOM',
  /** Escalate workflow */
  ESCALATE: 'ESCALATE',
  /** Send notification */
  NOTIFY: 'NOTIFY',
} as const;

export type PolicyActionType = (typeof PolicyActionType)[keyof typeof PolicyActionType];
/** Policy Analytics (GraphQL Output) */
export type PolicyAnalytics = {
  __typename?: 'PolicyAnalytics';
  /** Average execution time (milliseconds) */
  avgExecutionTimeMs: Scalars['Float']['output'];
  /** Cache hit count */
  cacheHitCount: Scalars['Int']['output'];
  /** Cache hit rate (0.0 - 1.0) */
  cacheHitRate: Scalars['Float']['output'];
  /** Cache miss count */
  cacheMissCount: Scalars['Int']['output'];
  /** Created timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Effectiveness score (0.0 - 1.0) */
  effectivenessScore: Scalars['Float']['output'];
  /** Error count */
  errorCount: Scalars['Int']['output'];
  /** Error rate (0.0 - 1.0) */
  errorRate: Scalars['Float']['output'];
  /** Total evaluation count */
  evaluationCount: Scalars['Int']['output'];
  /** Last evaluation timestamp */
  lastEvaluationAt?: Maybe<Scalars['DateTime']['output']>;
  /** Matched count */
  matchedCount: Scalars['Int']['output'];
  /** Non-matched count */
  nonMatchedCount: Scalars['Int']['output'];
  /** P50 execution time (milliseconds) */
  p50ExecutionTimeMs: Scalars['Int']['output'];
  /** P95 execution time (milliseconds) */
  p95ExecutionTimeMs: Scalars['Int']['output'];
  /** P99 execution time (milliseconds) */
  p99ExecutionTimeMs: Scalars['Int']['output'];
  /** Policy ID */
  policyId: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Total execution time (milliseconds) */
  totalExecutionTimeMs: Scalars['Int']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Change Type (GraphQL Enum)
 * Renamed to PolicyChangeType to avoid collision with optimization_api::ChangeType
 */
export const PolicyChangeType = {
  /** Field added */
  ADDED: 'ADDED',
  /** Field deleted */
  DELETED: 'DELETED',
  /** Field modified */
  MODIFIED: 'MODIFIED',
} as const;

export type PolicyChangeType = (typeof PolicyChangeType)[keyof typeof PolicyChangeType];
/** Policy Condition Output */
export type PolicyCondition = {
  __typename?: 'PolicyCondition';
  /** Field path */
  field: Scalars['String']['output'];
  /** Operator type */
  operator: PolicyOperator | '%future added value';
  /** Comparison value (JSON) */
  value: Scalars['JSON']['output'];
};

/** Policy Condition Input (from PolicyRuleBuilder UI) */
export type PolicyConditionInput = {
  /** Field path (e.g., "template.confidence", "validation.violation_count") */
  field: Scalars['String']['input'];
  /** Operator type */
  operator: PolicyOperator | '%future added value';
  /** Comparison value (string, number, boolean as JSON) */
  value: Scalars['JSON']['input'];
};

/** Policy Condition Template (GraphQL Output) */
export type PolicyConditionTemplate = {
  __typename?: 'PolicyConditionTemplate';
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Field path (e.g., "template.confidence") */
  field: Scalars['String']['output'];
  /** Operator (GREATER_THAN, EQUALS, etc.) */
  operator: Scalars['String']['output'];
  /** Value template (may contain {{parameter}} placeholders) */
  valueTemplate: Scalars['JSON']['output'];
};

/** Paginated policy results. */
export type PolicyConnection = {
  __typename?: 'PolicyConnection';
  /** Has more results */
  hasMore: Scalars['Boolean']['output'];
  /** List of policies */
  items: Array<Policy>;
  /** Next page cursor */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Policy evaluation result. */
export type PolicyEvaluationResult = {
  __typename?: 'PolicyEvaluationResult';
  /** Actions executed */
  actionsExecuted: Array<Scalars['String']['output']>;
  /** Did policy conditions match? */
  matched: Scalars['Boolean']['output'];
  /** Policy ID */
  policyId: Scalars['String']['output'];
  /** Evaluation result (JSON) */
  result: Scalars['String']['output'];
};

/**
 * Field Change (GraphQL Output)
 * Renamed to PolicyFieldChange to avoid collision with template_version_graphql::GqlFieldChange
 */
export type PolicyFieldChange = {
  __typename?: 'PolicyFieldChange';
  /** Change type */
  changeType: PolicyChangeType | '%future added value';
  /** Field path */
  fieldPath: Scalars['String']['output'];
  /** New value (JSON) */
  newValue?: Maybe<Scalars['JSON']['output']>;
  /** Old value (JSON) */
  oldValue?: Maybe<Scalars['JSON']['output']>;
};

/** Policy implementation */
export type PolicyImplementation = {
  __typename?: 'PolicyImplementation';
  config?: Maybe<Scalars['JSON']['output']>;
  implType: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

/** Policy list item for policy manager */
export type PolicyListItem = {
  __typename?: 'PolicyListItem';
  auditLevel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  implementation?: Maybe<PolicyImplementation>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  policyType: Scalars['String']['output'];
  rules: Array<PolicyRuleItem>;
  scope: Scalars['String']['output'];
};

/**
 * Policy Metric Type for ranking (GraphQL Enum)
 *
 * Specifies which metric to use when ranking policies by performance.
 * Different from Analytics MetricType (Counter/Gauge/Histogram/Summary).
 */
export const PolicyMetricType = {
  /** Average execution time */
  AVG_EXECUTION_TIME: 'AVG_EXECUTION_TIME',
  /** Cache hit rate */
  CACHE_HIT_RATE: 'CACHE_HIT_RATE',
  /** Effectiveness score */
  EFFECTIVENESS: 'EFFECTIVENESS',
  /** Error rate */
  ERROR_RATE: 'ERROR_RATE',
  /** Evaluation count */
  EVALUATION_COUNT: 'EVALUATION_COUNT',
} as const;

export type PolicyMetricType = (typeof PolicyMetricType)[keyof typeof PolicyMetricType];
/** Policy Operator Enum (GraphQL) */
export const PolicyOperator = {
  /** Contains (substring match) */
  CONTAINS: 'CONTAINS',
  /** Equals (==) */
  EQUALS: 'EQUALS',
  /** Greater than (>) */
  GREATER_THAN: 'GREATER_THAN',
  /** Less than (<) */
  LESS_THAN: 'LESS_THAN',
  /** Not equals (!=) */
  NOT_EQUALS: 'NOT_EQUALS',
  /** Regex match */
  REGEX: 'REGEX',
} as const;

export type PolicyOperator = (typeof PolicyOperator)[keyof typeof PolicyOperator];
/** Policy Ranking (GraphQL Output) */
export type PolicyRanking = {
  __typename?: 'PolicyRanking';
  /** Metric value */
  metricValue: Scalars['Float']['output'];
  /** Policy ID */
  policyId: Scalars['String']['output'];
  /** Policy name */
  policyName: Scalars['String']['output'];
  /** Rank position (1-based) */
  rank: Scalars['Int']['output'];
};

/**
 * Rollback Result (GraphQL Output)
 * Renamed to PolicyRollbackResult to avoid collision with template_version_graphql::GqlRollbackResult
 */
export type PolicyRollbackResult = {
  __typename?: 'PolicyRollbackResult';
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** New version ID */
  newVersionId: Scalars['String']['output'];
  /** New version number created */
  newVersionNumber: Scalars['Int']['output'];
  /** Success flag */
  success: Scalars['Boolean']['output'];
};

/** Policy Rule Output */
export type PolicyRule = {
  __typename?: 'PolicyRule';
  /** Actions */
  actions: Array<PolicyAction>;
  /** Conditions */
  conditions: Array<PolicyCondition>;
  /** Audit trail */
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Enabled flag */
  enabled: Scalars['Boolean']['output'];
  /** Policy ID */
  policyId: Scalars['String']['output'];
  /** Policy name */
  policyName: Scalars['String']['output'];
  /** Policy type */
  policyType: Scalars['String']['output'];
  /** Priority */
  priority: Scalars['Int']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Policy Rule Archive Result (FERP Append-Only Architecture)
 *
 * Returned by `archivePolicyRule` mutation. Contains full audit metadata.
 * FERP Principle: Immutable history for life-critical workflows.
 */
export type PolicyRuleArchiveResult = {
  __typename?: 'PolicyRuleArchiveResult';
  /** Timestamp when the policy was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** User ID who performed the archive */
  archivedBy: Scalars['String']['output'];
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Policy ID that was archived */
  policyId: Scalars['String']['output'];
  /** Policy name that was archived */
  policyName: Scalars['String']['output'];
  /** Mandatory reason for archiving (audit compliance) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Input for creating a policy rule. */
export type PolicyRuleInput = {
  /** Actions to execute */
  actions: Array<LegacyPolicyActionInput>;
  /** Conditions (AND logic) */
  conditions: Array<LegacyPolicyConditionInput>;
  /** Rule name */
  name: Scalars['String']['input'];
  /** Priority (higher = evaluated first) */
  priority: Scalars['Int']['input'];
};

/** Policy rule for manager lists */
export type PolicyRuleItem = {
  __typename?: 'PolicyRuleItem';
  action: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

/**
 * Result of policy evaluation in simulation mode.
 * DRR-170-A1: InsufficientContext prevents false-negative silence.
 */
export type PolicySimResult = {
  __typename?: 'PolicySimResult';
  /** Fields required by rules but missing from context */
  contextFieldsMissing: Array<Scalars['String']['output']>;
  /** Fields present in mock_variables */
  contextFieldsProvided: Array<Scalars['String']['output']>;
  /** Rules that could NOT be evaluated due to missing context fields */
  insufficientContext: Array<InsufficientRule>;
  /** Rules that matched and their actions */
  matchedRules: Array<Scalars['String']['output']>;
};

/** Policy Template (GraphQL Output) */
export type PolicyTemplate = {
  __typename?: 'PolicyTemplate';
  /** Action templates with {{parameter}} placeholders */
  actionTemplate: Array<PolicyActionTemplate>;
  /** Template category (confidence, validation, criticality, etc.) */
  category: PolicyTemplateCategory | '%future added value';
  /** Condition templates with {{parameter}} placeholders */
  conditionTemplate: Array<PolicyConditionTemplate>;
  /** When template was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the template (system/admin) */
  createdBy: Scalars['String']['output'];
  /** Default priority (higher = evaluated first) */
  defaultPriority: Scalars['Int']['output'];
  /** Detailed description of template purpose */
  description: Scalars['String']['output'];
  /** Whether template is active */
  isActive: Scalars['Boolean']['output'];
  /** Customizable parameters */
  parameters: Array<TemplateParameter>;
  /** Policy type (approval/validation/notification) */
  policyType: Scalars['String']['output'];
  /** Searchable tags */
  tags: Array<Scalars['String']['output']>;
  /** Global template ID (e.g., "TPL_HIGH_CONFIDENCE_AUTO_APPROVE") */
  templateId: Scalars['String']['output'];
  /** Human-readable template name */
  templateName: Scalars['String']['output'];
  /** Use cases for this template */
  useCases: Array<Scalars['String']['output']>;
  /** Template version number */
  version: Scalars['Int']['output'];
};

/** Policy Template Category Enum (GraphQL) */
export const PolicyTemplateCategory = {
  /** Confidence threshold-based routing */
  CONFIDENCE_THRESHOLD: 'CONFIDENCE_THRESHOLD',
  /** Custom category */
  CUSTOM: 'CUSTOM',
  /** Life-critical approval routing */
  LIFE_CRITICAL: 'LIFE_CRITICAL',
  /** Regulatory compliance (HIPAA, SOX, etc.) */
  REGULATORY_COMPLIANCE: 'REGULATORY_COMPLIANCE',
  /** Validation violation handling */
  VALIDATION_VIOLATION: 'VALIDATION_VIOLATION',
} as const;

export type PolicyTemplateCategory =
  (typeof PolicyTemplateCategory)[keyof typeof PolicyTemplateCategory];
/** Policy Template Instance (GraphQL Output) */
export type PolicyTemplateInstance = {
  __typename?: 'PolicyTemplateInstance';
  /** When instance was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the instance (user ID) */
  createdBy: Scalars['String']['output'];
  /** Unique instance ID (Snowflake ID) */
  instanceId: Scalars['String']['output'];
  /** Human-readable instance name */
  instanceName: Scalars['String']['output'];
  /** Whether instance is active */
  isActive: Scalars['Boolean']['output'];
  /** Parameter values used for instantiation (JSON map) */
  parameterValues: Scalars['JSON']['output'];
  /** Generated PolicyRule ID (after instantiation) */
  policyRuleId: Scalars['String']['output'];
  /** Template ID this instance was created from */
  templateId: Scalars['String']['output'];
  /** Tenant ID owning this instance */
  tenantId: Scalars['String']['output'];
};

/** Policy Version (GraphQL Output) */
export type PolicyVersion = {
  __typename?: 'PolicyVersion';
  /** Change description */
  changeDescription: Scalars['String']['output'];
  /** Created timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Created by (user ID) */
  createdBy: Scalars['String']['output'];
  /** Policy ID */
  policyId: Scalars['String']['output'];
  /** Policy snapshot (complete PolicyRule at this version) */
  policySnapshot: Scalars['JSON']['output'];
  /** Previous version ID */
  previousVersionId?: Maybe<Scalars['String']['output']>;
  /** Version status */
  status: PolicyVersionStatus | '%future added value';
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Version ID */
  versionId: Scalars['String']['output'];
  /** Version number */
  versionNumber: Scalars['Int']['output'];
};

/** Policy Version Diff (GraphQL Output) */
export type PolicyVersionDiff = {
  __typename?: 'PolicyVersionDiff';
  /** List of field changes */
  changes: Array<PolicyFieldChange>;
  /** From version number */
  fromVersion: Scalars['Int']['output'];
  /** Summary of changes */
  summary: Scalars['String']['output'];
  /** To version number */
  toVersion: Scalars['Int']['output'];
};

/**
 * Version History Summary (GraphQL Output)
 * Renamed to PolicyVersionHistorySummary to avoid collision with template_version_graphql::GqlVersionHistorySummary
 */
export type PolicyVersionHistorySummary = {
  __typename?: 'PolicyVersionHistorySummary';
  /** Current active version number */
  currentVersion: Scalars['Int']['output'];
  /** First version created */
  firstCreatedAt: Scalars['DateTime']['output'];
  /** Last version created */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Policy ID */
  policyId: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Total number of changes */
  totalChanges: Scalars['Int']['output'];
  /** Total number of versions */
  totalVersions: Scalars['Int']['output'];
};

/**
 * Version Status (GraphQL Enum)
 * Renamed to PolicyVersionStatus to avoid collision with template_version_graphql::GqlVersionStatus
 */
export const PolicyVersionStatus = {
  /** Active version */
  ACTIVE: 'ACTIVE',
  /** Deprecated version */
  DEPRECATED: 'DEPRECATED',
  /** Draft version */
  DRAFT: 'DRAFT',
  /** Superseded version */
  SUPERSEDED: 'SUPERSEDED',
} as const;

export type PolicyVersionStatus = (typeof PolicyVersionStatus)[keyof typeof PolicyVersionStatus];
/** Node position */
export type Position = {
  __typename?: 'Position';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** Position input */
export type PositionInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type PotentialDuplicateResult = {
  __typename?: 'PotentialDuplicateResult';
  matchingFields: Array<Scalars['String']['output']>;
  similarityScore: Scalars['Float']['output'];
  timeDifferenceMinutes: Scalars['Int']['output'];
  workflowId: Scalars['String']['output'];
};

/** A preflight issue (blocking or warning) */
export type PreflightIssue = {
  __typename?: 'PreflightIssue';
  /** Suggested fix */
  fix?: Maybe<Scalars['String']['output']>;
  /** Issue type code (e.g., "MISSING_TASK_GROUP") */
  issueType: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Issue severity */
  severity: IssueSeverity | '%future added value';
  /** State name where issue was found (if applicable) */
  stateName?: Maybe<Scalars['String']['output']>;
};

/** Complete preflight validation report */
export type PreflightReport = {
  __typename?: 'PreflightReport';
  /** Blocking issues that must be fixed */
  blockingIssues: Array<PreflightIssue>;
  /** Whether workflow can be activated */
  canActivate: Scalars['Boolean']['output'];
  /** Dependency check results */
  dependencyReport: Array<DependencyCheck>;
  /** 5W1H dimension coverage */
  dimensionCoverage: Array<DimensionCheck>;
  /** Simulation results (DRR-170) */
  simulationReport: SimulationReport;
  /** Warnings that should be fixed */
  warnings: Array<PreflightIssue>;
  /** Workflow ID being validated */
  workflowId: Scalars['String']['output'];
};

/** A failed prerequisite check for a scope. */
export type PrerequisiteFailure = {
  __typename?: 'PrerequisiteFailure';
  /** Detail about what's missing */
  detail: Scalars['String']['output'];
  /** Type of prerequisite that failed (training, delegation, certification, tenure, witness) */
  prerequisiteType: Scalars['String']['output'];
  /** How to remediate (e.g., "Complete task group tg-4-13-001") */
  remediation: Scalars['String']['output'];
  /** Task group to complete for training prerequisites */
  remediationTaskGroup?: Maybe<Scalars['String']['output']>;
};

/** Primitive composition */
export type PrimitiveComposition = {
  __typename?: 'PrimitiveComposition';
  connections: Array<PrimitiveConnection>;
  nodes: Array<PrimitiveNode>;
};

/** Primitive composition input */
export type PrimitiveCompositionInput = {
  connections: Array<PrimitiveConnectionInput>;
  nodes: Array<PrimitiveNodeInput>;
};

/** Primitive composition output */
export type PrimitiveCompositionOutput = {
  __typename?: 'PrimitiveCompositionOutput';
  connections: Array<PrimitiveConnectionOutput>;
  nodes: Array<PrimitiveNodeOutput>;
};

/** Primitive connection */
export type PrimitiveConnection = {
  __typename?: 'PrimitiveConnection';
  connectionType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

/** Primitive connection input */
export type PrimitiveConnectionInput = {
  connectionType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

/** Primitive connection output */
export type PrimitiveConnectionOutput = {
  __typename?: 'PrimitiveConnectionOutput';
  connectionType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

/** * Primitive instance in composition (shows 16 primitive types) */
export type PrimitiveInstanceOutput = {
  __typename?: 'PrimitiveInstanceOutput';
  /** Primitive configuration (JSON) */
  configuration: Scalars['JSONObject']['output'];
  /** Primitive instance ID */
  primitiveId: Scalars['String']['output'];
  /** Primitive type (one of 16) */
  primitiveType: Scalars['String']['output'];
};

/** Primitive mapping */
export type PrimitiveMapping = {
  __typename?: 'PrimitiveMapping';
  auditTracking?: Maybe<AuditTracking>;
  /** Field path within primitive */
  fieldPath: Scalars['String']['output'];
  /** Primitive node ID */
  primitiveId: Scalars['String']['output'];
  /** Primitive type (must be one of 16) */
  primitiveType: Scalars['String']['output'];
  transformation?: Maybe<TransformationSpec>;
};

/** Primitive mapping input */
export type PrimitiveMappingInput = {
  auditTracking?: InputMaybe<AuditTrackingInput>;
  fieldPath: Scalars['String']['input'];
  primitiveId: Scalars['String']['input'];
  primitiveType: Scalars['String']['input'];
  transformation?: InputMaybe<TransformationSpecInput>;
};

/** Primitive mapping output */
export type PrimitiveMappingOutput = {
  __typename?: 'PrimitiveMappingOutput';
  auditTracking?: Maybe<Scalars['JSON']['output']>;
  fieldPath: Scalars['String']['output'];
  primitiveId: Scalars['String']['output'];
  primitiveType: Scalars['String']['output'];
  transformation?: Maybe<Scalars['JSON']['output']>;
};

/** Metadata for a single FERP primitive (Task, Workflow, Template, etc.) */
export type PrimitiveMetadata = {
  __typename?: 'PrimitiveMetadata';
  /** Description of this primitive */
  description?: Maybe<Scalars['String']['output']>;
  /** List of field names exposed by this primitive */
  fields: Array<Scalars['String']['output']>;
  /** GraphQL mutation prefix for this primitive (e.g., "createTask", "updateWorkflow") */
  graphqlMutationPrefix: Scalars['String']['output'];
  /** GraphQL query name to fetch this primitive (e.g., "task", "workflow") */
  graphqlQuery: Scalars['String']['output'];
  /** Whether this primitive is life-critical */
  lifeCritical?: Maybe<Scalars['Boolean']['output']>;
  /** Custom metadata as JSON (for subgraph-specific extensions) */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Primitive name (e.g., "Task", "Workflow") */
  name: Scalars['String']['output'];
  /** Lifecycle phase this primitive belongs to */
  phase: Scalars['String']['output'];
  /** Registry version (for cache invalidation) */
  registryVersion: Scalars['Int']['output'];
  /** Single-character symbol used in keys (e.g., "T", "W") */
  symbol: Scalars['String']['output'];
};

/** Primitive node (must be one of 16 types) */
export type PrimitiveNode = {
  __typename?: 'PrimitiveNode';
  id: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  /**
   * Node type (MUST be one of 16 FERP primitive types)
   * Validated by PrimitiveWorkflowType::validate()
   */
  nodeType: Scalars['String']['output'];
  position?: Maybe<Position>;
};

/** Primitive node input */
export type PrimitiveNodeInput = {
  id: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<PositionInput>;
  type: Scalars['String']['input'];
};

/** Primitive node output */
export type PrimitiveNodeOutput = {
  __typename?: 'PrimitiveNodeOutput';
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
};

/** Lifecycle phase of a primitive (for color coding) */
export const PrimitivePhase = {
  CONFIGURE: 'CONFIGURE',
  DESIGN: 'DESIGN',
  EXECUTE: 'EXECUTE',
  MONITOR: 'MONITOR',
  OPTIMIZE: 'OPTIMIZE',
} as const;

export type PrimitivePhase = (typeof PrimitivePhase)[keyof typeof PrimitivePhase];
/** GraphQL-compatible wrapper for FERP primitive types */
export const PrimitiveType = {
  ACTOR: 'ACTOR',
  ANALYTICS: 'ANALYTICS',
  APPROVAL: 'APPROVAL',
  AUDIT: 'AUDIT',
  CHECKPOINT: 'CHECKPOINT',
  CONSTRAINT: 'CONSTRAINT',
  CONTRACT: 'CONTRACT',
  DEPENDENCY: 'DEPENDENCY',
  DOCUMENT: 'DOCUMENT',
  EVENT: 'EVENT',
  INSTANCE: 'INSTANCE',
  INTEGRATION: 'INTEGRATION',
  NOTIFICATION: 'NOTIFICATION',
  POLICY: 'POLICY',
  QUEUE: 'QUEUE',
  RESOURCE: 'RESOURCE',
  ROLE: 'ROLE',
  SCHEDULE: 'SCHEDULE',
  TASK: 'TASK',
  TEAM: 'TEAM',
  TEMPLATE: 'TEMPLATE',
  TENANT: 'TENANT',
  TRACE: 'TRACE',
  TRANSACTION: 'TRANSACTION',
  USER: 'USER',
  VALIDATION: 'VALIDATION',
  WORKFLOW: 'WORKFLOW',
} as const;

export type PrimitiveType = (typeof PrimitiveType)[keyof typeof PrimitiveType];
/** Usage statistics for a primitive type */
export type PrimitiveTypeUsage = {
  __typename?: 'PrimitiveTypeUsage';
  /** Usage count */
  count: Scalars['Int']['output'];
  /** Percentage of total (0.0-1.0) */
  percentage: Scalars['Float']['output'];
  /** Primitive type */
  primitiveType: PrimitiveType | '%future added value';
};

/** Result of recording a prior auth approval. */
export type PriorAuthApprovalResult = {
  __typename?: 'PriorAuthApprovalResult';
  /** Auth number recorded */
  authNumber: Scalars['String']['output'];
  /** Enrichment outbox item written (true = durably queued) */
  outboxQueued: Scalars['Boolean']['output'];
  /** Timestamp */
  recordedAt: Scalars['String']['output'];
  /** Subject actor ID the auth was written for */
  subjectActorId: Scalars['String']['output'];
};

/** Priority override for a specific task */
export type PriorityOverrideOutput = {
  __typename?: 'PriorityOverrideOutput';
  /** Reason for override */
  reason: Scalars['String']['output'];
  /** Suggested priority */
  suggestedPriority: Scalars['String']['output'];
  /** Task ID */
  taskId: Scalars['String']['output'];
};

/** Procedure connection */
export type ProcedureConnection = {
  __typename?: 'ProcedureConnection';
  edges: Array<ProcedureEdge>;
  pageInfo: FhirPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Procedure edge */
export type ProcedureEdge = {
  __typename?: 'ProcedureEdge';
  cursor: Scalars['String']['output'];
  node: FhirProcedure;
};

/** Input for processing an inbound HL7 v2 message. */
export type ProcessHl7MessageInput = {
  /** Message class: "ADT" or "ORU" */
  messageClass: Scalars['String']['input'];
  /** Raw HL7 v2 message string (MLLP-unwrapped) */
  rawHl7: Scalars['String']['input'];
  /** Tenant number (from MLLP connection config) */
  tenantNum: Scalars['Int']['input'];
};

/** Result of processing an inbound HL7 v2 message. */
export type ProcessHl7MessageResult = {
  __typename?: 'ProcessHl7MessageResult';
  /** MSH.10 — message control ID (idempotency reference) */
  messageControlId: Scalars['String']['output'];
  /** Message type (e.g. "A01", "ORU") */
  messageType: Scalars['String']['output'];
  /** Number of FHIR resources created */
  resourcesCreated: Scalars['Int']['output'];
  /** Whether a workflow routing event was queued (ADT only) */
  routingQueued: Scalars['Boolean']['output'];
  /** Subject actor ID resolved from MRN (empty if not found) */
  subjectActorId?: Maybe<Scalars['String']['output']>;
};

/** Processing Mode Input */
export type ProcessingModeInput = {
  /** Error threshold (for continue_on_error mode, 0.0 - 1.0) */
  errorThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Mode type: "stop_on_error", "continue_on_error", "dry_run" */
  modeType: Scalars['String']['input'];
};

/** Result of a product activation/deactivation mutation. */
export type ProductActivationResult = {
  __typename?: 'ProductActivationResult';
  /**
   * DRR-172: Coverage gaps detected at activation time.
   * Rules in this product's rulesets that have no downstream config
   * (task group or workflow) operationalizing them. Warn-not-block.
   */
  coverageGaps: Array<ActivationCoverageGap>;
  /** Error message if the operation failed */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * DRR-207: Mandatory resource gaps detected at activation time.
   * FHIR resources required by statute but without configured overrides.
   * BLOCKING for jurisdictions with mandatory resources.
   */
  mandatoryResourceGaps: Array<ProductMandatoryResourceGap>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** The tenant product record (created or updated) */
  tenantProduct?: Maybe<TenantProduct>;
};

/** DRR-207: A mandatory resource gap found during product activation. */
export type ProductMandatoryResourceGap = {
  __typename?: 'ProductMandatoryResourceGap';
  /** FHIR entity type (e.g., "FhirPatient") */
  entityType: Scalars['String']['output'];
  /** Ruleset ID mandating this (e.g., "rs-4-1-001") */
  rulesetRef?: Maybe<Scalars['String']['output']>;
  /** Statutory requirement (e.g., "MN 144G.61 - Resident records") */
  statuteRequirement: Scalars['String']['output'];
};

/**
 * Product provisioning lifecycle states (DRR-095).
 *
 * reference → draft → customized → activated → suspended
 */
export const ProductProvisioningStatus = {
  /** Live, governing tenant operations */
  ACTIVATED: 'ACTIVATED',
  /** Tenant modified, not yet activated */
  CUSTOMIZED: 'CUSTOMIZED',
  /** Tenant copy, customization in progress */
  DRAFT: 'DRAFT',
  /** Curated by FERP, read-only baseline */
  REFERENCE: 'REFERENCE',
  /** Temporarily deactivated (investigation, renewal) */
  SUSPENDED: 'SUSPENDED',
} as const;

export type ProductProvisioningStatus =
  (typeof ProductProvisioningStatus)[keyof typeof ProductProvisioningStatus];
/** Program variant configuration (MN DHS programs) */
export type ProgramConfig = {
  __typename?: 'ProgramConfig';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eligibility?: Maybe<EligibilityConfig>;
  evvRequirement?: Maybe<EvvConfig>;
  name: Scalars['String']['output'];
  serviceCodes: Array<Scalars['String']['output']>;
  supervisionRequirements?: Maybe<SupervisionConfig>;
  variant: Scalars['String']['output'];
  workflowOverrides?: Maybe<Scalars['JSON']['output']>;
};

/** Input for promoting an advisory to an industry term. */
export type PromoteToIndustryTermInput = {
  /** Advisory ID to promote (tag:advisory:industry-xxx) */
  advisoryId: Scalars['String']['input'];
  /** Final industry term ID (tag:industry:xxx) — architect may adjust */
  industryTermId: Scalars['String']['input'];
  /** Confirmed statutory mapping (tag:def:xxx) */
  mapsToStatutory: Scalars['String']['input'];
};

/** Result of promoting an advisory to industry term. */
export type PromoteToIndustryTermResult = {
  __typename?: 'PromoteToIndustryTermResult';
  /** YAML snippet to add to care-vocabulary.yaml industry namespace */
  industryTermYaml?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Type of config to propose. */
export const ProposalConfigType = {
  /** Task group config proposal. */
  TASK_GROUP: 'TASK_GROUP',
  /** Workflow config proposal. */
  WORKFLOW: 'WORKFLOW',
} as const;

export type ProposalConfigType = (typeof ProposalConfigType)[keyof typeof ProposalConfigType];
/** A typed relationship declared by a config proposal. */
export type ProposalEdge = {
  __typename?: 'ProposalEdge';
  /** Edge type (MANDATED_BY, IMPROVES, MITIGATES, REIMBURSES_VIA, etc.). */
  edgeType: Scalars['String']['output'];
  /** Relationship strength (primary, supporting). Defaults to "primary". */
  strength?: Maybe<Scalars['String']['output']>;
  /** Target config ID or tag reference. */
  target: Scalars['String']['output'];
};

/** A key regulatory provision referenced by a rule proposal. */
export type ProposalProvision = {
  __typename?: 'ProposalProvision';
  /** Config types required to satisfy this provision. */
  requiredConfigTypes: Array<Scalars['String']['output']>;
  /** Statute section reference (e.g., "144G.03 Subd 1"). */
  section: Scalars['String']['output'];
  /** Why it matters. */
  significance: Scalars['String']['output'];
  /** What the statute says. */
  text: Scalars['String']['output'];
};

/** Proposal status */
export const ProposalStatus = {
  /** Activated - config is now live */
  ACTIVATED: 'ACTIVATED',
  /** Approved - ready to activate */
  APPROVED: 'APPROVED',
  /** Cancelled by proposer */
  CANCELLED: 'CANCELLED',
  /** Draft - not yet submitted */
  DRAFT: 'DRAFT',
  /** Pending admin review */
  PENDING_REVIEW: 'PENDING_REVIEW',
  /** Rejected by admin */
  REJECTED: 'REJECTED',
  /** Simulation running */
  SIMULATING: 'SIMULATING',
  /** Simulation failed - cannot proceed */
  SIMULATION_FAILED: 'SIMULATION_FAILED',
} as const;

export type ProposalStatus = (typeof ProposalStatus)[keyof typeof ProposalStatus];
/** A workflow state in a workflow proposal. */
export type ProposalWorkflowState = {
  __typename?: 'ProposalWorkflowState';
  /** Human-readable name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** State identifier. */
  name: Scalars['String']['output'];
  /** Policy references evaluated on entry. */
  policyRefs: Array<Scalars['String']['output']>;
  /** State type (initial, operational, terminal). */
  stateType: Scalars['String']['output'];
};

/** A workflow transition in a workflow proposal. */
export type ProposalWorkflowTransition = {
  __typename?: 'ProposalWorkflowTransition';
  /** Event that triggers this transition. */
  event: Scalars['String']['output'];
  /** Source state. */
  fromState: Scalars['String']['output'];
  /** Target state. */
  toState: Scalars['String']['output'];
};

export type ProposedChangeGql = {
  __typename?: 'ProposedChangeGql';
  changeRationale: Scalars['String']['output'];
  changeType: ChangeType | '%future added value';
  currentValue: Scalars['JSON']['output'];
  proposedValue: Scalars['JSON']['output'];
  riskLevel: RiskLevel | '%future added value';
  targetComponent: Scalars['String']['output'];
};

/** Communication protocol */
export const Protocol = {
  AMQP: 'AMQP',
  HTTP: 'HTTP',
  HTTPS: 'HTTPS',
  SFTP: 'SFTP',
  WSS: 'WSS',
} as const;

export type Protocol = (typeof Protocol)[keyof typeof Protocol];
/**
 * Context describing the origin of a primitive.
 * Returned by `primitiveProvenance` query.
 */
export type ProvenanceContext = {
  __typename?: 'ProvenanceContext';
  /** Human-readable creation reason (e.g., "rule_engine:rl-4-0-146") */
  creationReason: Scalars['String']['output'];
  /** Config ID that created this primitive (e.g., "tg-4-7-001") */
  sourceConfigId: Scalars['String']['output'];
  /** Config type (e.g., "task_group", "workflow", "policy") */
  sourceConfigType: Scalars['String']['output'];
};

/** Complete provenance graph for visualization */
export type ProvenanceGraph = {
  __typename?: 'ProvenanceGraph';
  /** All edges in the graph */
  edges: Array<ProvenanceGraphEdge>;
  /** All nodes in the graph */
  nodes: Array<ProvenanceGraphNode>;
};

/** Edge in a provenance graph visualization */
export type ProvenanceGraphEdge = {
  __typename?: 'ProvenanceGraphEdge';
  /** Edge label (always "CREATED") */
  label: Scalars['String']['output'];
  /** Source node ID (config) */
  source: Scalars['String']['output'];
  /** Target node ID (primitive) */
  target: Scalars['String']['output'];
};

/** Node in a provenance graph visualization */
export type ProvenanceGraphNode = {
  __typename?: 'ProvenanceGraphNode';
  /** For configs: the config type (task_group, workflow, etc.) */
  configType?: Maybe<Scalars['String']['output']>;
  /** Unique node ID */
  id: Scalars['String']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** Node type: "config" or "primitive" */
  nodeType: Scalars['String']['output'];
  /** For primitives: the primitive type (Task, Instance, etc.) */
  primitiveType?: Maybe<Scalars['String']['output']>;
};

/** Reference to a specific provision within a ruleset (DRR-176). */
export type ProvisionRef = {
  __typename?: 'ProvisionRef';
  /** Optional description of what this provision requires */
  description?: Maybe<Scalars['String']['output']>;
  /** Rule ID within the ruleset (e.g., "rl-4-0-032") */
  ruleId: Scalars['String']['output'];
  /** Section reference in the source statute (e.g., "144G.45 Subd 2") */
  sectionRef: Scalars['String']['output'];
};

/** Compliance status for a single statutory provision. */
export type ProvisionStatus = {
  __typename?: 'ProvisionStatus';
  /** Description of what this provision requires */
  description: Scalars['String']['output'];
  /** Task groups that satisfy this provision (via provision_refs edges) */
  linkedTaskGroups: Array<Scalars['String']['output']>;
  /** Number of manual attestations for this provision */
  manualEvidenceCount: Scalars['Int']['output'];
  /** Rule name */
  name: Scalars['String']['output'];
  /** Evidence types required (from evidence_requirements metadata) */
  requiredEvidence: Array<EvidenceRequirement>;
  /** Member rule ID (e.g., "rl-4-0-032") */
  ruleId: Scalars['String']['output'];
  /** Statute section reference (e.g., "144G.70") */
  sectionRef: Scalars['String']['output'];
  /** Status: EVIDENCED, GAP, PENDING, EXPIRED */
  status: Scalars['String']['output'];
  /** Number of completed tasks linked to this provision */
  taskEvidenceCount: Scalars['Int']['output'];
};

/** Result of a proximity event recording. */
export type ProximityEventResult = {
  __typename?: 'ProximityEventResult';
  elopementAlert?: Maybe<ElopementAlert>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<BeaconEvent>;
  success: Scalars['Boolean']['output'];
};

/** Public website manifest data (DRR-107: consumed by export script) */
export type PublicWebsiteManifest = {
  __typename?: 'PublicWebsiteManifest';
  /** Accreditations */
  accreditations: Array<Scalars['String']['output']>;
  /** Physical address */
  address?: Maybe<Scalars['String']['output']>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Business hours */
  hours?: Maybe<Scalars['String']['output']>;
  /** Industry vertical */
  industry: Scalars['String']['output'];
  /** License type */
  licenseType?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Services offered */
  services: Array<Scalars['String']['output']>;
  /** URL slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Tagline */
  tagline?: Maybe<Scalars['String']['output']>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
};

/**
 * Result of LLM document analysis.
 *
 * Returns structured proposals — the config storage format is an
 * implementation detail that NEVER crosses the GraphQL boundary.
 */
export type PublicationAnalysisResult = {
  __typename?: 'PublicationAnalysisResult';
  /** LLM confidence assessment (0.0 - 1.0). */
  confidence: Scalars['Float']['output'];
  /** Number of draft proposals generated. */
  draftCount: Scalars['Int']['output'];
  /** Vocabulary tags the LLM mapped to (for review). */
  mappedTags: Array<Scalars['String']['output']>;
  /** Structured proposals (parsed server-side from config format). */
  proposals: Array<PendingProposal>;
  /** Whether the analysis completed successfully. */
  success: Scalars['Boolean']['output'];
  /** Warning messages (e.g., "Could not map 2 recommendations to vocabulary"). */
  warnings: Array<Scalars['String']['output']>;
};

/** Publication Status (GraphQL enum) */
export const PublicationStatus = {
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
} as const;

export type PublicationStatus = (typeof PublicationStatus)[keyof typeof PublicationStatus];
/** Publish Template Input */
export type PublishTemplateInput = {
  /** Approval instance ID */
  approvalInstanceId: Scalars['String']['input'];
  /** Publisher ID */
  publisherId: Scalars['String']['input'];
  /** Template ID */
  templateId: Scalars['String']['input'];
  /** Tenant */
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type Query = {
  __typename?: 'Query';
  /**
   * Get ACH file by ID.
   *
   * Requires: `ach:read` scope
   */
  achFile?: Maybe<GqlAchFile>;
  /**
   * List ACH files for tenant with optional filters.
   *
   * Requires: `ach:read` scope
   */
  achFiles: GqlAchFileConnection;
  /** Actors with active (non-expired) credentials */
  activeCredentials: Array<Scalars['String']['output']>;
  /**
   * DRR-103 Phase 3: Get active lenses for the current tenant's setting.
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  activeLenses: Array<ActiveLens>;
  /**
   * Get the active shift plan for a floor.
   *
   * Returns the most recent plan for the specified floor.
   * Requires `shift:read` scope.
   */
  activeShiftPlan?: Maybe<ShiftPlan>;
  /** List all active tenants (admin only) */
  activeSystemTenants: Array<SystemTenant>;
  /** Actor's completion count */
  actorCompletionCount: Scalars['Int']['output'];
  /**
   * Actor's completion history (what have they completed?)
   *
   * Returns completions sorted by time, most recent first.
   */
  actorCompletions: Array<CompletionProgress>;
  /** Which templates does actor still need? (bulk gap check) */
  actorGaps: Array<Scalars['String']['output']>;
  /** Generate an Actor import CSV template. */
  actorImportCsvTemplate: Scalars['String']['output'];
  /** Get actor security information by ID */
  actorMgmtActor?: Maybe<ActorSecurity>;
  /** Get actor performance metrics over time */
  actorMgmtGetActorPerformanceHistory: Array<ActorMetrics>;
  /** Get actor snapshot information */
  actorMgmtGetActorSnapshot?: Maybe<ActorSnapshotInfo>;
  /** Get detailed statistics for a specific actor */
  actorMgmtGetActorStats?: Maybe<ActorStatsResult>;
  /** Get overall actor system health report */
  actorMgmtGetSystemActorHealth: ActorSystemHealth;
  /** List all actors with optional filtering */
  actorMgmtListActors: Array<ActorInfo>;
  actorsRuntimeInfo: ActorsRuntimeInfoGql;
  adminListFhirAdverseEvents: Array<FhirStoredResourceType>;
  adminListFhirAllergyIntolerances: Array<FhirStoredResourceType>;
  adminListFhirCarePlans: Array<FhirStoredResourceType>;
  adminListFhirCareTeams: Array<FhirStoredResourceType>;
  adminListFhirClaimResponses: Array<FhirStoredResourceType>;
  adminListFhirClaims: Array<FhirStoredResourceType>;
  adminListFhirConditions: Array<FhirStoredResourceType>;
  adminListFhirDiagnosticReports: Array<FhirStoredResourceType>;
  adminListFhirEncounters: Array<FhirStoredResourceType>;
  adminListFhirGoals: Array<FhirStoredResourceType>;
  adminListFhirImmunizations: Array<FhirStoredResourceType>;
  adminListFhirMedicationAdministrations: Array<FhirStoredResourceType>;
  adminListFhirMedicationRequests: Array<FhirStoredResourceType>;
  adminListFhirMedicationStatements: Array<FhirStoredResourceType>;
  adminListFhirMedications: Array<FhirStoredResourceType>;
  adminListFhirMedicinalProductInteractions: Array<FhirStoredResourceType>;
  adminListFhirObservations: Array<FhirStoredResourceType>;
  adminListFhirPatients: Array<FhirStoredResourceType>;
  adminListFhirPractitioners: Array<FhirStoredResourceType>;
  adminListFhirProcedures: Array<FhirStoredResourceType>;
  adminListFhirServiceRequests: Array<FhirStoredResourceType>;
  /**
   * Get anonymized adoption insights for a practice across similar tenants.
   *
   * DRR-156 Phase 5 / DRR-148: System-level aggregation with k-anonymity.
   * Returns adoption rate and outcome improvement ONLY if k >= 5 tenants
   * in the same industry+jurisdiction segment have the practice available.
   *
   * Industry-agnostic: the segment is derived from the Product's industry
   * and jurisdiction fields. No hardcoded industry logic.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * adoptionInsights(practiceRef: "rs-4-16-001") {
   * practiceRef
   * segmentSize
   * adoptionRate
   * suppressedByKAnonymity
   * }
   * }
   * ```
   */
  adoptionInsights: AdoptionInsights;
  /**
   * DRR-189 P5: Advisory recommendations from LLM analysis.
   *
   * Returns approved advisories above confidence threshold (0.6).
   * Includes terminology trend forecasts, legislative predictions,
   * and industry best practice recommendations.
   */
  advisoryRecommendations: Array<AdvisoryRecommendation>;
  /**
   * View aggregate advocacy positions for a pending RuleSet (DRR-148).
   *
   * Returns T2 `AdvocacyDocument` records: count distributions only.
   * No tenant-identifying fields. No narratives. No contributing actor IDs.
   *
   * ## H4: ONE-WAY GATE
   *
   * This query returns T2 data only. There is NO reverse resolver —
   * no query exists that starts from `AdvocacyDocument` and reaches T1 contributors.
   * The absent resolver IS the gate.
   *
   * ## NEVER BUILD
   *
   * Never add a `tenantId: String` argument to this resolver.
   * Never add a resolver that returns which tenants contributed to a position.
   */
  advocacyPositions: Array<AdvocacyDocument>;
  /**
   * Check the AI agent service health status.
   *
   * Requires: `agent:compose` or `tenant:admin` scope (DRR-168).
   */
  agentServiceHealth: AgentServiceHealth;
  /**
   * Get navigation filtered by the current user's scopes (DRR-102 Phase 2).
   *
   * Returns only the nav items and routes that the authenticated user has
   * permission to access, based on their resolved scopes from `x-ferp-scopes`.
   *
   * This is the scope-aware replacement for `getTenantSubgraphConfig` nav items.
   * The frontend calls this instead of filtering client-side.
   *
   * **Filtering rules:**
   * - Routes with `requiredPermissions: []` (empty) → always included
   * - Routes with `requiredPermissions: ["a", "b"]` → included if user has ANY of them
   * - Nav items are included if their `path` matches an allowed route
   * - Parent nav items are included if ANY child is included
   *
   * Usage:
   * ```graphql
   * query AllowedNav($tenantId: String!, $layer: ViewLayer!) {
   * allowedNavigation(tenantId: $tenantId, layer: $layer) {
   * navItems { id label path icon layer sortOrder parentId badge }
   * routes { path component layer title requiredPermissions }
   * }
   * }
   * ```
   */
  allowedNavigation: AllowedNavigation;
  /**
   * DRR-183: Returns ambient display configuration from st-0-2.yaml.
   *
   * Backend-driven config for wall-mounted kiosk displays.
   * Requires `scope:read` scope (same as setting_bundle — authenticated staff).
   */
  ambientDisplayConfig: AmbientDisplayConfig;
  /**
   * Get current status of the analytics manifest
   *
   * Returns information about:
   * - Manifest build status and freshness
   * - Files and rows indexed
   * - Coverage (tenants, subgraphs, date range)
   * - Cache status
   *
   * # Security
   * - Requires authentication (any role)
   * - Read-only, minimal exposure but still authenticated
   */
  analyticsManifestStatus: AnalyticsManifestStatusResponse;
  /** LLM-assisted domain analysis from user intent */
  analyzeDomainFromIntent: Scalars['JSON']['output'];
  /**
   * Analyze a natural language description to suggest a FormSchema pattern.
   *
   * Uses LLM to classify the user's intent into a subgraph, entity type,
   * pattern ID, and compliance frameworks. Falls back to deterministic
   * `detect_pattern` if LLM is unavailable or confidence is too low.
   */
  analyzeSchemaIntent: SchemaIntentAnalysis;
  /** Apply standards pack to workflow */
  applyStandardsPack: ApplyStandardsPackResult;
  /**
   * Get an approval by ID (direct query)
   *
   * Fetches from ApprovalRepository.
   * Falls back to stub if repository unavailable or entity not found.
   */
  approval: FerpApproval;
  /** Get approval by ID. */
  approvalApiGetApproval?: Maybe<Approval>;
  /** Get pending approvals count for approver (for dashboard). */
  approvalApiGetPendingApprovalsCount: Scalars['Int']['output'];
  /** List approvals by status. */
  approvalApiListApprovalsByStatus: GqlApprovalConnection;
  /** List approvals by workflow instance ID. */
  approvalApiListApprovalsByWorkflow: GqlApprovalConnection;
  /** List approvals for a specific approver. */
  approvalApiListApprovalsForApprover: GqlApprovalConnection;
  /** List approvals in a chain. */
  approvalApiListApprovalsInChain: Array<Approval>;
  /**
   * Approve or reject an optimization recommendation
   * LIFE-CRITICAL: Multi-level approval required for critical recommendations
   */
  approveRecommendation: Scalars['Boolean']['output'];
  /**
   * Get plans awaiting approval by the specified authority role.
   *
   * Maps to domain-specific queries:
   * - Healthcare: DoN care plan queue
   * - Legal: Partner case plan queue
   * - Construction: PM project plan queue
   */
  approverPlanQueue: Array<PlanQueueItem>;
  /** Get a specific architect proposal by ID (DRR-227) */
  architectProposal?: Maybe<ArchitectProposal>;
  /** List architect proposals for the current tenant (DRR-227) */
  architectProposals: Array<ArchitectProposal>;
  /** Archive published template (soft delete) */
  archiveTemplate: Scalars['Boolean']['output'];
  /**
   * Get accumulator summary for a resident.
   *
   * Returns current drift detection status and summary metrics.
   * Requires `assessment:read` scope.
   */
  assessmentAccumulatorSummary?: Maybe<AccumulatorSummaryGql>;
  /**
   * Get active drift alerts for a facility.
   *
   * Returns residents with high-confidence major drift.
   * Requires `assessment:read` scope.
   */
  assessmentAlerts: Array<DriftAlertGql>;
  /**
   * Get all field drift results for a resident.
   *
   * Returns per-field drift analysis with confidence scores.
   * Requires `assessment:read` scope.
   */
  assessmentDriftResults: Array<FieldDriftResultGql>;
  /**
   * Get field mapping definitions.
   *
   * Returns all MnCHOICES field definitions with evidence sources.
   * Requires `assessment:read` scope.
   */
  assessmentFieldMappings: Array<FieldMappingGql>;
  /** Attach a ChaosDocument as evidence to a FERP entity (EVIDENCED_BY edge, DRR-110). */
  attachEvidence: EvidenceAttachment;
  /**
   * Get checkpoints for a specific audit form.
   *
   * # Arguments
   * * `form_id` - The audit form identifier
   * * `priority` - Optional filter by priority level
   */
  auditCheckpoints: Array<AuditCheckpoint>;
  /**
   * Get a single audit form by ID.
   *
   * # Arguments
   * * `form_id` - The audit form identifier (e.g., "0-3-001")
   */
  auditForm?: Maybe<AuditForm>;
  /**
   * Find the audit form that assesses a specific CFR.
   *
   * # Arguments
   * * `cfr` - The CFR reference (e.g., "42 CFR 483.73")
   */
  auditFormByCfr?: Maybe<AuditForm>;
  /**
   * List all audit forms, optionally filtered by regulatory body or jurisdiction.
   *
   * # Arguments
   * * `regulatory_body` - Filter by regulatory body (e.g., "CMS", "OSHA", "HHS_OCR")
   * * `jurisdiction` - Filter by jurisdiction (e.g., "federal", "MN")
   * * `limit` - Maximum number of results
   */
  auditForms: Array<AuditForm>;
  /** Available drivers for dispatch */
  availableDrivers: Array<FoodServiceDriver>;
  /**
   * List all available features (subgraphs) for setup wizard.
   *
   * Features are derived from subgraph metadata YAMLs in
   * `common/configs/seed/subgraphs/`. Each subgraph with a `feature:`
   * section becomes a selectable feature.
   *
   * Results are sorted: `is_core: true` first, then alphabetical by name.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * availableFeatures {
   * featureId
   * name
   * category
   * isCore
   * dependencies
   * shortDescription
   * }
   * }
   * ```
   */
  availableFeatures: Array<FeatureDefinition>;
  /**
   * DRR-281 Phase 4: Get available industry terms for adoption.
   * Returns industry terms that the tenant hasn't yet adopted.
   */
  availableIndustryTerms: Array<AvailableIndustryTerm>;
  /** Get all available primitives */
  availablePrimitives: Array<PrimitiveMetadata>;
  /**
   * DRR-178: Returns available scope dimensions for a given primitive type.
   *
   * Reads `scope_dimensions` from the active Setting YAML and resolves
   * label templates using `subject_label` and `scope_labels` from the same setting.
   * Filters dimensions by `applies_to` — only returns dimensions whose field
   * is relevant to the requested primitive type.
   *
   * Example: for primitive_type="task", returns dimensions like
   * "By Resident" (subject_actor_id), "By Status" (status), "By Room" (location).
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  availableScopeDimensions: Array<ScopeDimension>;
  /**
   * List all available subgraphs that have form schemas.
   *
   * Useful for discovery in admin interfaces.
   */
  availableSubgraphs: Array<Scalars['String']['output']>;
  /** Get available widgets from the registry (DRR-048: data-driven) */
  availableWidgets: Array<WidgetDefinition>;
  /**
   * Wait until there are no OUTBOX items targeting the given integration (kind:name) for this tenant.
   * Returns true if empty before timeout.
   */
  awaitOutboxEmpty: Scalars['Boolean']['output'];
  /**
   * Wait until a WATERMARK record exists for the given integration (kind:name) and
   * optionally until last_success_ts >= min_success_ts. Returns true if condition met before timeout.
   */
  awaitWatermark: Scalars['Boolean']['output'];
  /**
   * Get current basic enrollment flow for the user
   *
   * Returns an enrollment flow if the user needs basic enrollment.
   */
  basicGetCurrentEnrollmentFlow?: Maybe<BasicEnrollmentFlow>;
  /**
   * Get basic enrollment prompt for the user
   *
   * Returns a prompt if the user needs basic enrollment.
   */
  basicGetEnrollmentPrompt?: Maybe<BasicEnrollmentPrompt>;
  /**
   * Check if the current user has basic auth enrollment (JWT present)
   *
   * Returns true if the user has a valid JWT with tenant claim.
   * For full WebAuthn PRF enrollment, use piiVaultIsEnrolled.
   */
  basicIsEnrolled: Scalars['Boolean']['output'];
  /**
   * Get a single beacon by ID.
   *
   * Requires: `beacon:read` scope (DRR-102)
   *
   * ## Example
   *
   * ```graphql
   * query {
   * beacon(tenantNum: 2, beaconId: "2-bcn-101") {
   * beaconId
   * zoneId
   * status
   * lastSeen
   * batteryMv
   * }
   * }
   * ```
   */
  beacon?: Maybe<Beacon>;
  /**
   * List all beacons for a tenant, with optional filtering.
   *
   * DRR-100: Entity code 8B (wearables subgraph).
   * Requires: `beacon:read` scope (DRR-102)
   *
   * ## Example
   *
   * ```graphql
   * query {
   * beacons(tenantNum: 2, zoneId: "2-zone-lobby") {
   * beaconId
   * major
   * minor
   * zoneId
   * status
   * beaconType
   * batteryMv
   * }
   * }
   * ```
   */
  beacons: Array<Beacon>;
  /** Check if a tenant can access a specific route */
  canTenantAccessRoute: Scalars['Boolean']['output'];
  /** Get a specific assessment */
  carecircleAssessment?: Maybe<CareCircleAssessment>;
  /** Get a single facility by ID */
  carecircleFacility?: Maybe<CareCircleFacility>;
  /**
   * Get facilities with competitive features (FERP-managed or high-scoring)
   * Competitive moat features defined in rs-senior-care-* rulesets
   */
  carecircleFeaturedFacilities: Array<CareCircleFacility>;
  /** Get my assessments */
  carecircleMyAssessments: Array<CareCircleAssessment>;
  /** Get my family profile */
  carecircleMyFamily?: Maybe<CareCircleFamily>;
  /** Get my leads (facilities I've expressed interest in) */
  carecircleMyLeads: Array<CareCircleLead>;
  /** Get my raffle entries */
  carecircleMyRaffleEntries: Array<CareCircleRaffleEntry>;
  /** Get my record tracker */
  carecircleMyRecordTracker?: Maybe<CareCircleRecordTracker>;
  /**
   * Get available raffle actions and their point values
   * Actions defined in rs-carecircle-raffle-actions ruleset (DRR-291)
   */
  carecircleRaffleActions: Array<CareCircleRaffleActionInfo>;
  /**
   * Get current raffle status
   * Uses EngagementTracker with ruleset-defined prizes (DRR-291)
   */
  carecircleRaffleStatus: CareCircleRaffleStatus;
  /**
   * Search for facilities matching criteria
   * Uses recipe-based scoring from rs-senior-care-* rulesets (DRR-291)
   */
  carecircleSearchFacilities: Array<CareCircleFacility>;
  /**
   * Get chain verification result for a sync session.
   *
   * Returns the cryptographic verification proof including genesis metadata.
   * Used by regulators to verify offline activity provenance.
   *
   * Requires: `sync:read` scope
   */
  chainVerification?: Maybe<ChainVerificationResult>;
  /**
   * Check if a value would violate a constraint.
   *
   * Requires: `constraint:read` or `constraint:admin` scope
   */
  checkConstraint: Scalars['Boolean']['output'];
  /** Check framework compliance */
  checkFrameworkCompliance: FrameworkComplianceResult;
  /** Check if I have access to a specific tenant (as verifier) */
  checkVerifierAccess?: Maybe<GqlVerifierGrant>;
  /** Get information about a code system */
  codeSystemInfo: CodeSystemInfo;
  /** List recent code usage rows for the current tenant, optionally filtered by code prefix. */
  codeUsageRecent: Array<CodeUsage>;
  /**
   * Get communication logs visible to the current user.
   * Filtered by caller's scope (QP sees their contacts, admin sees all).
   */
  communicationLogs: Array<CommunicationLog>;
  /**
   * Compare lens evaluations across multiple role sets.
   *
   * Evaluates the 4-phase lens chain for each role set and produces a diff
   * showing: universally hidden fields, universally visible fields, and
   * mixed-access fields (where some roles can see a field but others cannot).
   *
   * Used by the ConstellationPage "Compare Roles" mode to show side-by-side
   * what ALD sees vs CNA sees vs DON sees on the same constellation.
   *
   * Requires `scope:admin` scope (admin-only comparison tool).
   */
  compareLensEvaluation: LensComparisonResult;
  /**
   * Gap analysis: find actors who are required but haven't completed
   *
   * Given a list of required actors and a template, returns those who haven't completed it.
   */
  completionGaps: Array<CompletionGap>;
  /**
   * Return all available filter dimensions and their values for the compliance browser.
   *
   * The frontend builds filter chips purely from this response — no hardcoded
   * dimension lists, no industry name maps, no jurisdiction dropdowns.
   *
   * Dimensions returned: legislation, jurisdiction, facility_type, safety_level,
   * applies_when, status. Each dimension includes a count of matching rulesets.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * complianceFilterDimensions {
   * totalCount
   * dimensions {
   * dimension
   * label
   * renderAs
   * values { value label count }
   * }
   * }
   * }
   * ```
   */
  complianceFilterDimensions: ComplianceFilterDimensions;
  /**
   * Evidence-backed compliance status for a ruleset — per-provision drill-down.
   *
   * DRR-176: Derived compliance via read-time DAG traversal.
   * For each member_rule (provision), checks:
   * 1. Are there task groups with provision_refs pointing to this rule? (config coverage)
   * 2. Are there completed tasks in those task groups? (task evidence)
   * 3. Are there evidence_requirements declared? (what's needed)
   *
   * Status per provision:
   * - EVIDENCED: at least one task completion or manual attestation exists
   * - PENDING: config coverage exists but no execution evidence yet
   * - GAP: no config coverage at all
   */
  complianceStatus: ComplianceStatus;
  /**
   * Evaluate workflow composition and get suggestions/warnings
   *
   * # Authorization
   * Requires: `composition:read` scope
   *
   * # Tenant Isolation
   * Uses `auth_ctx.tenant` for evaluation (ignores input.tenant_id for security)
   *
   * # Arguments
   * * `input` - Composition context with primitives and metadata
   *
   * # Returns
   * * Formula suggestions, anti-pattern warnings, and triggered actions
   */
  compositionEvaluateComposition: CompositionResult;
  /**
   * Get a specific anti-pattern by ID
   *
   * # Authorization
   * Requires: `antipattern:read` scope
   *
   * # Tenant Isolation
   * - For "system" tenant patterns: accessible to all authenticated users
   * - For tenant-specific patterns: only accessible to that tenant
   *
   * # Arguments
   * * `tenant_id` - "system" for system patterns, otherwise uses auth_ctx.tenant
   * * `id` - Anti-pattern identifier
   */
  compositionGetAntiPattern?: Maybe<AvailableAntiPatternFix>;
  /**
   * Get available auto-fixes for anti-patterns in the current composition
   *
   * Returns a list of anti-patterns that:
   * 1. Apply to the current set of primitives (has required primitives)
   * 2. Are actually anti-patterns (missing required primitives)
   * 3. Have an auto-fix available
   *
   * # Authorization
   * Requires: `composition:read` AND `antipattern:read` scopes
   *
   * # Tenant Isolation
   * Uses `auth_ctx.tenant` for evaluation (ignores input.tenant_id for security)
   *
   * # Example Query
   * ```graphql
   * query GetAvailableFixes($input: CompositionInput!) {
   * getAvailableFixes(input: $input) {
   * id
   * name
   * severity
   * message
   * hasAutoFix
   * autoFixDescription
   * requiresConfirmation
   * }
   * }
   * ```
   */
  compositionGetAvailableFixes: Array<AvailableAntiPatternFix>;
  /**
   * Get formula information by number
   *
   * # Authorization
   * Requires: `formula:read` scope
   */
  compositionGetFormula?: Maybe<FormulaInfo>;
  /**
   * List all system anti-patterns (regardless of context)
   *
   * Returns all 6 default system anti-patterns with their auto-fix configurations.
   * Useful for documentation or showing all possible anti-patterns.
   *
   * # Authorization
   * Requires: `antipattern:read` scope
   *
   * NOTE: This now uses the AntiPatternRepository for data-driven patterns.
   * Falls back to hardcoded defaults if repository is not available.
   */
  compositionListAntiPatterns: Array<AvailableAntiPatternFix>;
  /**
   * List anti-patterns for a tenant (merged system + tenant patterns)
   *
   * Returns system patterns merged with tenant-specific overrides and custom patterns.
   * Tenant patterns with the same ID override system patterns.
   *
   * # Authorization
   * Requires: `antipattern:read` scope
   *
   * # Tenant Isolation
   * Uses `auth_ctx.tenant` - ignores input tenant_id for security.
   * Only returns patterns for the authenticated user's tenant.
   *
   * # Arguments
   * * `tenant_id` - IGNORED for security (uses auth_ctx.tenant)
   *
   * # Example Query
   * ```graphql
   * query ListTenantAntiPatterns {
   * listAntiPatternsForTenant(tenantId: "healthcare-tenant") {
   * id
   * name
   * severity
   * message
   * hasAutoFix
   * }
   * }
   * ```
   */
  compositionListAntiPatternsForTenant: Array<AvailableAntiPatternFix>;
  /**
   * List all available formulas
   *
   * # Authorization
   * Requires: `formula:read` scope
   */
  compositionListFormulas: Array<FormulaInfo>;
  /**
   * Get compression statistics for a tenant (Issue #480)
   *
   * Returns real-time statistics from DynamoDB with atomic counters.
   */
  compressionStats: CompressionStats;
  /**
   * Get a FHIR Condition by ID (proxies to Medplum GraphQL API)
   * Accepts either raw FHIR ID or federated ID (tenant:fhir_id)
   *
   * Uses Valkey caching for performance (5-minute TTL).
   */
  condition?: Maybe<FhirCondition>;
  /** List FHIR Conditions with optional patient filter (proxies to Medplum GraphQL API) */
  conditions: ConditionConnection;
  /**
   * Get all primitives created by a specific config.
   * Use for reverse lookups: "What did this task group create?"
   */
  configCreatedPrimitives: Array<Scalars['String']['output']>;
  /**
   * Query forward edges from a config node (DRR-110).
   *
   * Returns edges where `configId` is the source. Optionally filter by `edgeType`.
   * If `edgeType` is null, returns all forward edge types.
   *
   * Example: `configEdges(configId: "tg-4-3-001", edgeType: "MANDATED_BY")`
   * → returns all rulesets mandating this task group.
   */
  configEdges: Array<ConfigEdge>;
  /**
   * Impact analysis: what primitives will be affected if this config changes?
   * Checks all primitive types and returns counts + IDs.
   */
  configImpact: ConfigImpactResult;
  /**
   * DRR-172 Phase 5: List config proposals from the proposals/ directory.
   *
   * Proposals are draft configs generated from coverage gap detection.
   * They live in `common/configs/proposals/` and are NOT seeded to DDB.
   * Architect reviews and approves proposals, which then move to seed/.
   *
   * Returns all proposals with their status (draft/approved/rejected).
   * Requires admin scope.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * configProposals {
   * proposalId
   * configType
   * sourceRule
   * status
   * displayName
   * generatedAt
   * }
   * }
   * ```
   */
  configProposals: Array<ConfigProposal>;
  /**
   * Query reverse edges to a config node (DRR-110).
   *
   * Returns edges where `configId` is the target. Optionally filter by `inverseType`.
   * If `inverseType` is null, returns all reverse edge types.
   *
   * Example: `configReverseEdges(configId: "rs-4-1-004", inverseType: "MANDATES")`
   * → returns all task groups mandated by this ruleset.
   */
  configReverseEdges: Array<ConfigEdge>;
  /**
   * List all config types in the registry (DRR-111).
   *
   * Returns all 15+ config types with their SK templates, symbols,
   * filename patterns, dimensions, and source directories.
   */
  configTypeRegistry: Array<RegistryConfigType>;
  /**
   * Get a hub-and-spoke constellation template by ID.
   *
   * DRR-085: Constellation config type #12. Distinct from field constellations.
   * Loads from `common/configs/seed/constellations/{id}.yaml`.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * constellationTemplate(constellationId: "constellation-care-service-plan") {
   * constellationId
   * name
   * center { primitiveType actorType labelTemplate }
   * rings { ringId ringNumber label edgeTypes color shape }
   * appliesTo { scope industries centerLabel subjectType }
   * }
   * }
   * ```
   */
  constellationTemplate?: Maybe<ConstellationTemplate>;
  /**
   * List all hub-and-spoke constellation templates.
   *
   * DRR-085: Returns all constellation config type #12 templates.
   * Optionally filter by scope (e.g., "care", "legal", "staffing").
   *
   * ## Example
   *
   * ```graphql
   * query {
   * constellationTemplates(scope: "care") {
   * constellationId
   * name
   * appliesTo { scope industries centerLabel }
   * }
   * }
   * ```
   */
  constellationTemplates: Array<ConstellationTemplate>;
  /**
   * Get a constellation with a lens filter applied.
   *
   * DRR-085/090: Combines a constellation template with a lens to produce
   * annotated rings with highlight/de-emphasize markers. This is the core
   * innovation — same constellation, different perspective.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * constellationWithLens(
   * constellationId: "constellation-product-onboarding"
   * lensId: "ln-5-0-002"
   * mode: "definition"
   * ) {
   * constellationName
   * lensName
   * rings {
   * ringId
   * label
   * highlighted
   * deEmphasized
   * showFields
   * expandSections
   * checklist { step ring statusField }
   * }
   * }
   * }
   * ```
   */
  constellationWithLens?: Maybe<FilteredConstellation>;
  /**
   * Get all constellations an actor participates in, derived from Valkey reverse edge indexes.
   *
   * DRR-126 Phase 4: Role-scoped constellation query. Returns all constellation IDs
   * where the actor appears as Ring 1 (COORDINATED_BY), Ring 2 (AUTHORIZED_BY),
   * or Ring 4 (REVIEWED_BY) participant. Uses Valkey reverse edge indexes written
   * at constellation instance creation time (constellation_instances.rs).
   *
   * Backend enforces visibility per DRR-102. No frontend role logic needed.
   *
   * ## Edge types queried
   * - `idx:edge:{actor_id}:COORDINATES` → Ring 1 (coordinator/responder)
   * - `idx:edge:{actor_id}:AUTHORIZES`  → Ring 2 (authority/supervisor)
   * - `idx:edge:{actor_id}:REVIEWS`     → Ring 4 (auditor/reviewer)
   *
   * ## Example
   *
   * ```graphql
   * query {
   * constellationsByActor(actorId: "42_3") {
   * actorId
   * constellationIds
   * memberships { constellationId ring edgeType role }
   * }
   * }
   * ```
   */
  constellationsByActor: ActorConstellationMemberships;
  /** Get a controlled item by ID. */
  controlledItem?: Maybe<ControlledItem>;
  /** Get count verification for a constraint category. */
  controlledItemCount: ControlledItemCount;
  /** List controlled items by constraint. */
  controlledItemsByConstraint: Array<ControlledItem>;
  /** Get items needing verification. */
  controlledItemsNeedingVerification: Array<ControlledItem>;
  /** Convert chaos document to DSL template */
  convertChaosToDsl: MetadataTemplateConversionResult;
  /**
   * Get current coordination weights configuration.
   *
   * Includes regulatory floors (immutable) and learnable weights.
   * Requires `coordination:read` scope.
   */
  coordinationWeights: CoordinationWeights;
  /**
   * Create new domain metadata (system administrators only)
   * Requires: `metadata:write` scope (DRR-102)
   */
  createDomainMetadata: DomainMetadataGql;
  /** Create a new entity */
  createEntity: GenericEntity;
  /**
   * Create new template metadata
   * Requires: `metadata:write` scope (DRR-102)
   */
  createTemplateMetadata: TemplateMetadataOutput;
  /**
   * Get critical checkpoints across all forms for a regulatory body.
   *
   * These are life-safety or immediate jeopardy items.
   */
  criticalCheckpoints: Array<AuditCheckpoint>;
  /**
   * Query cross-tenant audit records from archived Parquet data
   *
   * # Authorization
   * - ADMIN role required for cross-tenant queries
   * - Regular users can only query their own tenant
   *
   * # Performance
   * Uses three-layer optimization:
   * 1. Manifest index prunes 80-95% of files
   * 2. Parquet row group statistics prune 70-90% of row groups
   * 3. HTTP range requests fetch only matching data
   */
  crossTenantAuditReport: CrossTenantAuditReport;
  /** Get execution status and progress */
  dagExecutionStatus?: Maybe<DagexecutionStatus>;
  /** List recent DAG executions */
  dagExecutions: Array<DagexecutionSummary>;
  /** Get workflow performance metrics and bottleneck analysis */
  dagPerformanceMetrics?: Maybe<DagperformanceMetrics>;
  /** Get workflow definition for visualization (loads from definition store) */
  dagWorkflow?: Maybe<DagworkflowGql>;
  /** List all loaded workflow definitions */
  dagWorkflowDefinitions: Array<DagworkflowGql>;
  /**
   * Debug resolver to see what auth context the backend received.
   * Returns role_ids, scopes count, tenant, subject for troubleshooting.
   */
  debugAuth: Scalars['String']['output'];
  /**
   * Detailed debug resolver showing full auth resolution chain.
   * Use this to diagnose CEO scope resolution issues (DRR-312 debugging).
   */
  debugAuthChain: Scalars['String']['output'];
  decisionGetActiveDecision?: Maybe<DecisionModelJson>;
  decisionGetDecisionVersion?: Maybe<DecisionModelJson>;
  decisionListDecisionHistory: Array<DecisionModelJson>;
  decisionListDecisions: Array<DecisionModelJson>;
  /**
   * Decode a scope-encoded config filename (DRR-089, DRR-111).
   *
   * Takes a filename like "wf-2-0-001" and returns its decoded dimensions:
   * prefix="wf", config_type="workflow", segments=[subgraph=erp, category=doc, seq=001].
   */
  decodeConfigFilename: DecodedFilename;
  deleteAudience: Scalars['Boolean']['output'];
  /** Delete chaos document */
  deleteChaosDocument: Scalars['Boolean']['output'];
  /** Delete an entity (soft delete with audit trail) */
  deleteEntity: Scalars['Boolean']['output'];
  /**
   * **DEPRECATED (Issue #671)**: Use `archiveTemplate` instead.
   *
   * This mutation performs hard delete which violates append-only architecture.
   * For FERP compliance, use `archive_template` which provides proper
   * soft-delete with audit trail.
   *
   * # Migration Guide
   *
   * ```graphql
   * # OLD (DEPRECATED):
   * mutation { deleteTemplateMetadata(tenant: "...", templateId: "...", version: "...") }
   *
   * # NEW (RECOMMENDED):
   * mutation { archiveTemplate(tenant: "...", templateId: "...", reason: "...") { success } }
   * ```
   */
  deleteTemplateMetadata: Scalars['Boolean']['output'];
  /** Build complete DAG for workflow. */
  dependencyApiBuildWorkflowDag: WorkflowDag;
  /** Detect circular dependencies in workflow. */
  dependencyApiDetectCircularDependencies: CircularDependencyResult;
  /** Get critical path for workflow (CPM algorithm). */
  dependencyApiGetCriticalPath: CriticalPathResult;
  /** Get dependency by ID. */
  dependencyApiGetDependency?: Maybe<Dependency>;
  /** Get dependencies for specific task (incoming + outgoing). */
  dependencyApiGetTaskDependencies: Array<Dependency>;
  /** List dependencies by workflow (enables DAG construction). */
  dependencyApiListDependenciesByWorkflow: DependencyConnection;
  /** Validate dependency definition (without creating). */
  dependencyApiValidateDependency: Scalars['Boolean']['output'];
  /**
   * List all dimension code tables (DRR-111).
   *
   * Returns dimension_codes tables (jurisdiction, setting, category, etc.)
   * with bidirectional code-to-value mappings.
   */
  dimensionCodeTables: Array<RegistryDimensionTable>;
  /**
   * Get a document by ID (direct query)
   *
   * Fetches from DocumentRepository.
   * Falls back to stub if repository unavailable or entity not found.
   */
  document: FerpDocument;
  /**
   * Get document access audit log
   *
   * Returns all access attempts for a document (compliance audit).
   */
  documentAccessLog: Array<GqlDocumentAccessLog>;
  /** Get Chaos-to-DSL generated documents */
  documentApiGetChaosGeneratedDocuments: Array<Document>;
  /** Get document by tenant + ID. */
  documentApiGetDocument?: Maybe<Document>;
  /** Get document version history */
  documentApiGetDocumentVersionHistory: Array<DocumentVersionInfo>;
  /** Get documents by status (Draft, PendingReview, Approved, etc.) */
  documentApiGetDocumentsByStatus: Array<Document>;
  /** Get documents by type (WorkflowDefinition, PolicyDocument, etc.) */
  documentApiGetDocumentsByType: Array<Document>;
  /** Get documents pending approval */
  documentApiGetDocumentsPendingApproval: Array<Document>;
  /** List documents for tenant with pagination */
  documentApiListDocuments: DocumentConnection;
  /** Get a document generation job status */
  documentJob?: Maybe<GqlDocumentJob>;
  /**
   * Get domain metadata by type and version
   * Requires: `metadata:read` scope (DRR-102)
   */
  domainMetadata?: Maybe<DomainMetadataGql>;
  /** Get driver's daily statistics (DRR-055: backend-driven) */
  driverDailyStats: FoodServiceDriverDailyStats;
  /** Deliveries assigned to a specific driver (dispatched state) */
  driverDeliveries: Array<FoodServiceDelivery>;
  /**
   * List recent elopement alerts for a tenant.
   *
   * DRR-100: Life-critical elopement detection.
   * Requires: `beacon:read` scope (DRR-102)
   *
   * ## Example
   *
   * ```graphql
   * query {
   * elopementAlerts(tenantNum: 2, unacknowledgedOnly: true) {
   * alertId
   * subjectActorId
   * triggerZoneId
   * severity
   * acknowledged
   * createdAt
   * }
   * }
   * ```
   */
  elopementAlerts: Array<ElopementAlert>;
  /**
   * Get current participant count for emergency
   *
   * # Arguments
   * * `emergency_id` - Unique emergency identifier
   *
   * # Returns
   * Current participant count (0 if emergency not found)
   */
  emergencyParticipantCount: Scalars['Int']['output'];
  /**
   * Get an employee by ID (direct query)
   *
   * Fetches from ActorRepository where actor_type = Human.
   * Falls back to stub if repository unavailable or entity not found.
   */
  employee: Employee;
  /**
   * List employees for a tenant (with pagination)
   *
   * Fetches from ActorRepository where actor_type = Human.
   * Returns empty list if repository unavailable.
   */
  employees: Array<Employee>;
  /**
   * Get a FHIR Encounter by ID (proxies to Medplum GraphQL API)
   * Accepts either raw FHIR ID or federated ID (tenant:fhir_id)
   *
   * Uses Valkey caching for performance (5-minute TTL).
   */
  encounter?: Maybe<FhirEncounter>;
  /** List FHIR Encounters with optional patient filter (proxies to Medplum GraphQL API) */
  encounters: EncounterConnection;
  /** Query entities with filtering and pagination */
  entities: GenericEntityConnection;
  /** Get a specific entity by ID */
  entity?: Maybe<GenericEntity>;
  /**
   * Get entity preview for hover cards.
   *
   * Returns summary information about an entity without full navigation.
   * Used by EntityPreviewCard component.
   */
  entityPreview: EntityPreview;
  /** Get entity schema for dynamic UI generation */
  entitySchema: Scalars['JSON']['output'];
  /**
   * Search for entities across subgraphs with constellation or tenant scoping.
   *
   * Scope is inferred from entity type:
   * - Person/role entities (Actor, Team, FhirPatient, etc.) → constellation-scoped
   * - Non-person entities (Document, Resource, FhirMedication, etc.) → tenant-scoped
   *
   * When constellation-scoped, results are limited to entities bound to the
   * current user's constellation via ring edges (DRR-118).
   */
  entitySearch: Array<EntitySearchResult>;
  /** Get available entity types for a domain */
  entityTypes: Array<Scalars['String']['output']>;
  /**
   * Estimate cost of an analytics query before execution
   *
   * Uses manifest index to calculate:
   * - Number of files that would be accessed
   * - Estimated row groups to read
   * - Data transfer costs
   * - Compute costs
   *
   * # Security
   * - Uses JWT-validated auth context (cannot be spoofed)
   * - Cross-tenant estimates require SuperAdmin
   * - Single-tenant estimates require TenantAdmin
   */
  estimateAnalyticsCost: AnalyticsCostEstimate;
  /**
   * 3. Setting: Active lenses from tenant setting apply field/entity rules
   * 4. Situation: Break-glass override for emergencies
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  evaluateLens: LensEvaluationResult;
  /**
   * Evaluate policy against provided context.
   *
   * **FERP Integration**: Requires RBAC permission + optional monitoring based on audit level.
   */
  evaluatePolicy: PolicyEvaluationResult;
  /** Get critical events (severity = Critical) */
  eventApiGetCriticalEvents: Array<Event>;
  /** Get event by ID */
  eventApiGetEvent?: Maybe<Event>;
  /** Get events by entity (e.g., all events for a specific Task) */
  eventApiGetEventsByEntity: Array<Event>;
  /** Get events by transaction (Formula #4 saga tracking) */
  eventApiGetEventsByTransaction: Array<Event>;
  /** Get events by workflow instance */
  eventApiGetEventsByWorkflowInstance: Array<Event>;
  /** List events with pagination and filtering */
  eventApiListEvents: GqlEventConnection;
  /**
   * DRR-138: List violation events for the operational Risk dashboard.
   *
   * Returns `ComplianceEvent`-typed Events written by the ViolationCheck
   * path in `create_task`. Optionally filter by severity:
   * - `CRITICAL` → task was blocked
   * - `WARNING`  → warn / deferred / check unavailable
   *
   * Scoped to `task:read` or `compliance:read`.
   */
  eventApiListViolationEvents: GqlEventConnection;
  /** Verify hash chain integrity for cryptographic audit trail */
  eventApiVerifyEventChainIntegrity: GqlEventChainIntegrity;
  /**
   * List exchanged documents for a relationship (metadata only — NO content)
   *
   * Returns file metadata (sender, timestamp, fileName, fileSize, fileType).
   * Document bytes are NEVER returned through GraphQL.
   */
  exchangeDocuments: Array<ExchangeDocument>;
  /**
   * List active exchange relationships for the current tenant
   *
   * Returns all relationships where the current tenant is a participant
   * (either sender or recipient side).
   */
  exchangeRelationships: Array<ExchangeRelationship>;
  /** Execute an action on an entity */
  executeEntityAction: Scalars['JSON']['output'];
  /** Already expired credentials */
  expiredCredentials: Array<Scalars['String']['output']>;
  /**
   * Credentials expiring soon
   *
   * Returns actors whose credentials for the given template will expire within the specified days.
   */
  expiringCredentials: Array<ExpiringCredentialEntry>;
  /** Export audit trail to CSV/PDF/JSON (SOX §404) */
  exportAuditTrail: ExportAuditTrailResult;
  /** Export a draft as JSON for download */
  exportFormSchemaDraft?: Maybe<Scalars['String']['output']>;
  /** Export template to JSON */
  exportTemplate: TemplateExportData;
  federationInfo: FederationState;
  /** List all FhirAdverseEvent resources for a tenant (DRR-052) */
  fhirAdverseEvents: Array<FhirStoredResourceType>;
  /**
   * Get allergy records for a specific resident.
   * LIFE-CRITICAL: Med Aide MUST see allergy alerts before administering.
   */
  fhirAllergiesBySubject: Array<FhirStoredResourceType>;
  /** List all FhirAllergyIntolerance resources for a tenant (DRR-052) */
  fhirAllergyIntolerances: Array<FhirStoredResourceType>;
  /** List all FhirCarePlan resources for a tenant (DRR-052) */
  fhirCarePlans: Array<FhirStoredResourceType>;
  /** List all FhirCareTeam resources for a tenant (DRR-052) */
  fhirCareTeams: Array<FhirStoredResourceType>;
  /** List all FhirClaimResponse resources for a tenant (DRR-052) */
  fhirClaimResponses: Array<FhirStoredResourceType>;
  /** List all FhirClaim resources for a tenant (DRR-052) */
  fhirClaims: Array<FhirStoredResourceType>;
  /** List all FhirCondition resources for a tenant (DRR-052) */
  fhirConditions: Array<FhirStoredResourceType>;
  /** List all FhirDiagnosticReport resources for a tenant (DRR-052) */
  fhirDiagnosticReports: Array<FhirStoredResourceType>;
  /**
   * Get DRR-080 FHIR dual-write status and discrepancy metrics
   *
   * Returns the current operating mode and read-comparison metrics
   * for the 90-day parallel-run. Target: <0.01% discrepancy rate.
   */
  fhirDualWriteStatus?: Maybe<FhirDualWriteStatusType>;
  /** List all FhirEncounter resources for a tenant (DRR-052) */
  fhirEncounters: Array<FhirStoredResourceType>;
  /**
   * Get expected narcotic count for a controlled substance.
   *
   * Calculates: dispensed_quantity - administered_doses = expected_remaining.
   * Used by shift-change controlled substance count task.
   *
   * ## Scopes Required
   * - `medication:admin_delegated` (Med Aide)
   * - OR `fhir:read` (clinical data access)
   */
  fhirExpectedNarcoticCount: FhirNarcoticCount;
  /** List all FhirGoal resources for a tenant (DRR-052) */
  fhirGoals: Array<FhirStoredResourceType>;
  /** List all FhirImmunization resources for a tenant (DRR-052) */
  fhirImmunizations: Array<FhirStoredResourceType>;
  /** Get medication administration records (MAR) for a specific resident. */
  fhirMedAdminsBySubject: Array<FhirStoredResourceType>;
  /** Get medication dispense (delivery) records for a specific resident. */
  fhirMedDispensesBySubject: Array<FhirStoredResourceType>;
  /** Get medication history (statements) for a specific resident. */
  fhirMedStatementsBySubject: Array<FhirStoredResourceType>;
  /** List all FhirMedicationAdministration resources for a tenant (DRR-052) */
  fhirMedicationAdministrations: Array<FhirStoredResourceType>;
  /** List all FhirMedicationRequest resources for a tenant (DRR-052) */
  fhirMedicationRequests: Array<FhirStoredResourceType>;
  /**
   * Get today's medication shift plan for current user.
   *
   * Returns medication tasks grouped by time window for the current shift.
   * Drug interactions evaluated across the FULL day (not per-task).
   * Controlled substances highlighted with dual-count requirement.
   *
   * ## Scopes Required
   * - `medication:admin_delegated` (Med Aide)
   * - OR `task:read` (general task access)
   */
  fhirMedicationShiftPlan: FhirMedicationShiftPlan;
  /** List all FhirMedicationStatement resources for a tenant (DRR-052) */
  fhirMedicationStatements: Array<FhirStoredResourceType>;
  /** List all FhirMedication resources for a tenant (DRR-052) */
  fhirMedications: Array<FhirStoredResourceType>;
  /**
   * Get active medication orders for a specific resident.
   * DRR-198: Resident-scoped — prevents cross-resident medication display.
   */
  fhirMedicationsBySubject: Array<FhirStoredResourceType>;
  /** List all FhirMedicinalProductInteraction resources for a tenant (DRR-052) */
  fhirMedicinalProductInteractions: Array<FhirStoredResourceType>;
  /** List all FhirObservation resources for a tenant (DRR-052) */
  fhirObservations: Array<FhirStoredResourceType>;
  /** List all FhirPatient resources for a tenant (DRR-052) */
  fhirPatients: Array<FhirStoredResourceType>;
  /** List all FhirPractitioner resources for a tenant (DRR-052) */
  fhirPractitioners: Array<FhirStoredResourceType>;
  /**
   * Get active prescriptions with parsed SIG schedules for a resident.
   * DRR-200: Prescription-as-Ruleset — returns prescriptions with schedule windows.
   */
  fhirPrescriptionSchedulesBySubject: Scalars['JSON']['output'];
  /**
   * Check which prescriptions need refill (days supply < threshold).
   *
   * Auto-triggers refill task when supply runs low.
   *
   * ## Scopes Required
   * - `fhir:read` (clinical data access)
   * - OR `clinical:read`
   */
  fhirPrescriptionsNeedingRefill: FhirRefillNeededList;
  /** List all FhirProcedure resources for a tenant (DRR-052) */
  fhirProcedures: Array<FhirStoredResourceType>;
  /** Get the version history of a FHIR resource (newest first) */
  fhirResourceVersionHistory: FhirResourceVersionHistory;
  /** List all FhirServiceRequest resources for a tenant (DRR-052) */
  fhirServiceRequests: Array<FhirStoredResourceType>;
  /** Get a FHIR resource from the dual-write repository */
  fhirStorageResource?: Maybe<FhirStoredResourceType>;
  /**
   * Get the latest version of a stored FHIR resource by ID
   *
   * Returns the most recent version from DynamoDB (with Valkey cache).
   */
  fhirStoredResource?: Maybe<FhirStoredResource>;
  /** Get a specific version of a stored FHIR resource */
  fhirStoredResourceVersion?: Maybe<FhirStoredResource>;
  /** List latest versions of all stored FHIR resources of a given type */
  fhirStoredResources: FhirStoredResourceConnection;
  /**
   * Get field constellation for a FERP primitive.
   *
   * Loads the field-constellation YAML for the given primitive type,
   * and optionally applies a context profile to highlight relevant fields.
   *
   * ## Arguments
   *
   * - `primitive_type`: Primitive name (e.g., "Task", "Workflow")
   * - `context_id`: Optional context profile to apply (e.g., "healthcare-discharge")
   *
   * ## Example
   *
   * ```graphql
   * query {
   * fieldConstellation(primitiveType: "Task", contextId: "healthcare-discharge") {
   * constellationId
   * totalFieldCount
   * promotedFieldCount
   * rings {
   * ringId
   * label
   * color
   * highlighted
   * fields { fieldName label fieldType promoted }
   * }
   * contextProfiles { contextId name verticals promotedFields }
   * }
   * }
   * ```
   */
  fieldConstellation?: Maybe<FieldConstellation>;
  /**
   * List filename abbreviation tables (DRR-089, DRR-111).
   *
   * Returns abbreviation codes used in scope-encoded filenames.
   * Separate from dimension_codes — these are specifically for filename encoding.
   */
  filenameAbbreviationTables: Array<RegistryDimensionTable>;
  /**
   * Find bottlenecks exceeding duration threshold.
   *
   * **Use Case**: Performance optimization, SLA breach investigation
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to analyze
   * * `threshold_ms` - Duration threshold in milliseconds (operations slower than this are bottlenecks)
   *
   * # Returns
   *
   * List of traces representing bottlenecks (sorted by duration, slowest first)
   */
  findBottlenecks: Array<Trace>;
  /**
   * DRR-178: Returns the current focus context for the authenticated actor.
   *
   * Focus context is stored in Valkey with 8-hour TTL (shift-aligned).
   * Returns null fields if no focus is active.
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  focusContext: FocusContext;
  /** Get available form schema patterns */
  formPatterns: Array<FormPatternMetadata>;
  /**
   * Get form schema for a subgraph entity.
   *
   * Returns the base schema with tenant-specific overrides applied.
   * Uses Valkey cache for <50ms response times.
   *
   * ## Arguments
   *
   * - `subgraph`: Subgraph name (e.g., "fhir", "payroll", "ofbiz")
   * - `entity_type`: Entity type (e.g., "Patient", "Worker", "Invoice")
   *
   * ## Example
   *
   * ```graphql
   * query {
   * formSchema(subgraph: "fhir", entityType: "Patient") {
   * subgraph
   * entityType
   * version
   * safetyLevel
   * fields {
   * name
   * label
   * fieldType
   * required
   * piiClassification
   * }
   * layout {
   * layoutType
   * sections {
   * title
   * fields
   * }
   * }
   * }
   * }
   * ```
   */
  formSchema?: Maybe<FormSchema>;
  /** Get a specific draft by ID */
  formSchemaDraft?: Maybe<FormSchemaDraftOutput>;
  /**
   * Get form schema filtered for LLM transit (DRR-169).
   *
   * Returns the schema with:
   * - `Strip` fields removed (identifiable PII — SSN, name, DOB, etc.)
   * - `Safe` fields kept (structured data — enums, dates, status)
   * - `Scan` fields kept but annotated (free-text — needs Presidio NER)
   *
   * Also returns a `fieldSummary` showing which fields are in each category.
   *
   * Used by the agent service (DRR-168) to understand what data it can
   * safely include in LLM payloads. The edge gateway uses this to build
   * the sanitization policy for each form type.
   *
   * Requires `agent:compose` scope — only architect/admin roles.
   */
  formSchemaForLlm?: Maybe<FormSchemaForLlm>;
  /**
   * Get tenant-specific override for a form schema.
   *
   * Returns only the override, not the merged schema.
   */
  formSchemaOverride?: Maybe<FormSchemaOverride>;
  /**
   * DRR-207: Count FormSchemaOverrides targeting a specific entity type.
   *
   * Used for the "X overrides" badge on FHIR entity cards.
   * Counts across all jurisdictions (fso-* files targeting this entity).
   */
  formSchemaOverrideCount: Scalars['Int']['output'];
  /**
   * DRR-207: List all FormSchemaOverrides for the current tenant.
   *
   * Returns summary info (counts) for the list page, not full override data.
   * Optionally filter by subgraph (e.g., "fhir").
   */
  formSchemaOverrides: Array<FormSchemaOverrideSummary>;
  /**
   * Get form schema with a specific version (no tenant overrides).
   *
   * Useful for version comparison or rollback scenarios.
   */
  formSchemaVersion?: Maybe<FormSchema>;
  /**
   * List all form schemas for a subgraph.
   *
   * Returns base schemas only (no tenant overrides).
   */
  formSchemas: Array<FormSchema>;
  /**
   * Batch get parameter versions for cache validation
   * LIFE-CRITICAL: Efficient login-time parameter version checking
   */
  formsBatchParameterVersions: Array<ParameterVersionGql>;
  /** Compute structural diff between two JSON definitions */
  formsDiffDefinitions: DiffResult;
  /** Dry run guard evaluation */
  formsDryRunGuard: DryRunGuardResult;
  /**
   * Get complete entity details for drill-down modal (Sprint 2 UX Enhancement)
   *
   * DOMAIN-AGNOSTIC: Works with all 16 primitive workflow types
   * LIFE-CRITICAL: Complete audit trails via timeline events
   * DATA-DRIVEN: All entity data from repositories
   */
  formsEntityDetails: EntityDetailsOutput;
  /** Find experts by specializations with compliance requirements */
  formsFindExpertsBySpecializations: Array<ActorGql>;
  /** Find experts by tier (for expert routing) */
  formsFindExpertsByTier: Array<ActorGql>;
  /**
   * Get metadata for frontend repository pattern integration
   * LIFE-CRITICAL: Supports useMetadataRepository hook with proper data structure
   */
  formsFindMetadata?: Maybe<MetadataResult>;
  /**
   * Get S3 signed URL for parameter content
   * LIFE-CRITICAL: Secure tenant-isolated S3 access for parameter storage
   */
  formsGenerateS3SignedUrl: Scalars['String']['output'];
  /** Get Actor by tenant and ID (FERP repository pattern) */
  formsGetActor?: Maybe<ActorGql>;
  /**
   * Get available compliance frameworks for tenant
   * LIFE-CRITICAL: Supports dynamic configuration showcase
   */
  formsGetAvailableComplianceFrameworks: Array<ComplianceFrameworkGql>;
  /** Get available experts matching criteria (for expert selection flow) */
  formsGetAvailableExperts: Array<ActorGql>;
  /**
   * Get business process types for tenant
   * LIFE-CRITICAL: Process complexity and duration tracking
   */
  formsGetBusinessProcessTypes: Array<BusinessProcessTypeGql>;
  /** Get cache health status */
  formsGetCacheHealth: Scalars['JSON']['output'];
  /** Get cache invalidation history */
  formsGetCacheInvalidations: Array<Scalars['JSON']['output']>;
  /** Get cache key patterns */
  formsGetCacheKeyPatterns: Array<Scalars['JSON']['output']>;
  /** Get cache metrics (mock implementation until CacheMetricsRepository is implemented) */
  formsGetCacheMetrics: Scalars['JSON']['output'];
  /** Get cache metrics history (time series data) */
  formsGetCacheMetricsHistory: Scalars['JSON']['output'];
  /** Get cache operation statistics */
  formsGetCacheOperationStats: Array<Scalars['JSON']['output']>;
  /** Get complete workflow data */
  formsGetCompleteWorkflow: CompleteWorkflowData;
  /**
   * Get department configuration for tenant
   * LIFE-CRITICAL: Organizational structure for safety escalation
   */
  formsGetDepartmentConfiguration?: Maybe<DepartmentConfigurationGql>;
  /** Get saved draft */
  formsGetDraft: DraftResult;
  /** Get draft versions (version history for a draft) */
  formsGetDraftVersions: Array<Scalars['JSON']['output']>;
  /** Get enhanced form schema with metadata */
  formsGetEnhancedFormSchema: EnhancedFormSchema;
  /**
   * Get filter configurations for component
   * LIFE-CRITICAL: Zero hardcoded values architecture
   */
  formsGetFilterConfigurations: Array<FilterConfigurationGql>;
  /** Get form schema for a specific kind */
  formsGetFormSchema: SchemaResult;
  /** Get a single governance context by ID */
  formsGetGovernanceContext?: Maybe<Scalars['JSON']['output']>;
  /** Get job queue metrics for monitoring dashboard */
  formsGetJobQueueMetrics: Scalars['JSON']['output'];
  /** Get capabilities for a form kind */
  formsGetKindCapabilities: KindCapabilities;
  /**
   * Get parameter metadata from DynamoDB
   * LIFE-CRITICAL: Version-based caching support for frontend parameter repository
   */
  formsGetParameterMetadata?: Maybe<ParameterMetadataGql>;
  /**
   * Get regulatory authority types for tenant
   * LIFE-CRITICAL: Multi-jurisdictional compliance management
   */
  formsGetRegulatoryAuthorityTypes: Array<RegulatoryAuthorityTypeGql>;
  /**
   * Get tenant-specific regulatory compliance configuration
   * LIFE-CRITICAL: Provides configurable thresholds to prevent discrimination liability
   */
  formsGetRegulatoryComplianceConfig?: Maybe<Scalars['JSON']['output']>;
  /**
   * Get a single regulatory threshold by type and framework for a tenant
   * LIFE-CRITICAL: Centralized access to tenant-configured thresholds
   */
  formsGetRegulatoryThreshold?: Maybe<RegulatoryThresholdGql>;
  /** Batch get regulatory thresholds */
  formsGetRegulatoryThresholdsBatch: Array<RegulatoryThresholdGql>;
  /**
   * Get safety event by ID (checks Redis first, then DynamoDB)
   * LIFE-CRITICAL: Dual-tier lookup for high-frequency access
   */
  formsGetSafetyEvent?: Maybe<SafetyEvent>;
  /**
   * Get safety events by time range for historical analysis
   * LIFE-CRITICAL: Regulatory reporting and compliance audits
   */
  formsGetSafetyEventsByTimerange: Array<SafetyEvent>;
  /**
   * Get staged safety events from Redis (5-min TTL cache)
   * LIFE-CRITICAL: Real-time monitoring of high-frequency events
   */
  formsGetStagedSafetyEvents: Array<SafetyEvent>;
  /** Get team capacity metrics for handoff decisions */
  formsGetTeamCapacityMetrics: TeamCapacityMetricsGql;
  /** List actor descriptors (stored as drafts with kind="ActorDescriptor") */
  formsListActorDescriptors: Array<Scalars['JSON']['output']>;
  /**
   * List Actors with filtering and pagination
   * List Actors with filtering and pagination (legacy forms API).
   * Use `listActors` query from actor_api for Actor primitive CRUD operations.
   */
  formsListActors: Array<ActorGql>;
  /** List component edges for a workflow */
  formsListComponentEdges: Array<ComponentEdgeGql>;
  /** List composed components for a workflow by (tenant, name[, version]) */
  formsListComponents: Array<ComponentRefGql>;
  /** List workflow definitions */
  formsListDefinitions: Array<DefinitionListItem>;
  /** List all saved drafts */
  formsListDrafts: Array<DraftListItem>;
  /** List governance contexts with pagination */
  formsListGovernanceContexts: Scalars['JSON']['output'];
  /** List job statuses with pagination */
  formsListJobStatuses: Scalars['JSON']['output'];
  /** List supported form kinds */
  formsListKinds: Array<Scalars['String']['output']>;
  /**
   * List all regulatory compliance configurations for a tenant
   * LIFE-CRITICAL: Shows all configurable thresholds for audit and management
   */
  formsListRegulatoryComplianceConfigs: Array<RegulatoryComplianceConfigGql>;
  /**
   * List safety events with comprehensive filtering and pagination
   * LIFE-CRITICAL: Advanced querying for regulatory compliance and audit reporting
   */
  formsListSafetyEvents: Array<SafetyEvent>;
  /** Get policies for a tenant - uses proper policy governance repository for life-critical system */
  formsPolicies: Array<PolicyListItem>;
  /**
   * DRR-126 Phase 3: Co-responder visibility for a specific workflow instance.
   *
   * Returns all actors who have tasks for the given constellation + workflow instance.
   * Enables Ring 1 actors to see each other's task status when responding to the same event.
   * Detail is role-scoped: operational status only — no clinical data exposed.
   *
   * Co-responders are grouped by assigned_to actor; each entry shows their aggregate
   * task status for this instance (pending/in_progress/completed/overdue).
   *
   * FERP COMPLIANCE:
   * - Multi-tenant isolation (tenant from AuthCtx)
   * - Repository pattern (TaskRepository)
   * - DRR-102: Backend-computed visibility (no frontend role logic)
   * - DRR-114: T2 operational data only (no T3 QAPI metrics)
   */
  formsTaskCoRespondersForInstance: GqlCoResponderList;
  /**
   * Aggregate task status counts per workflow instance for a constellation.
   *
   * DRR-126 Phase 2: Powers Ring 3 status overlays in constellation instance mode.
   * Queries all tasks with the given constellation_id, groups by instance_id,
   * and returns per-instance status counts.
   *
   * The by_instance list maps to Ring 3 deliverables:
   * `by_instance[n].instance_id = ring_3_deliverables[n].instance_id`
   *
   * No new DynamoDB storage — derived from existing Task records.
   */
  formsTaskConstellationTaskSummary: GqlConstellationTaskSummary;
  /**
   * Derive the current lifecycle phase for a subject's constellation lifecycle workflow.
   *
   * DRR-140: The lifecycle phase IS the workflow instance's `current_state`.
   * Resolution: Instance(current_state) + ConstellationConfig(lifecycle.phases) → phase metadata.
   *
   * - `instance_id`: The wf-0-12-001 lifecycle workflow instance ID for the subject.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * derivedLifecyclePhase(instanceId: "abc123") {
   * phaseId label isTerminal constellationConfigId
   * }
   * }
   * ```
   *
   * Returns `null` when:
   * - Instance not found or has no `constellation_ref`
   * - Constellation config missing (not yet seeded)
   * - Constellation has no lifecycle block
   */
  formsTaskDerivedLifecyclePhase?: Maybe<GqlLifecyclePhase>;
  /**
   * Build a journey graph for N selected actors — residents, staff, or both.
   *
   * DRR-126 Phase 5: Powers the NeuralJourneyGraph component (react-force-graph-3d).
   * For each actor ID, fetches all tasks where they appear as subject OR performer,
   * then builds nodes (tasks) + edges (temporal sequence + intersection events).
   *
   * Intersection nodes = tasks where multiple actors share the same `instance_id`
   * (i.e., they were both present in the same care event constellation instance).
   * These highlight in yellow in the 3D renderer — the moments lives intersected.
   *
   * Data tier: T2 (operational). No clinical content — task metadata only.
   * Backend enforces scope per DRR-102. Duration variance NOT included (T3).
   *
   * ## Example
   *
   * ```graphql
   * query {
   * entityJourneyGraph(actorIds: ["42_3", "42_7"], limit: 200) {
   * actors { ... }
   * nodes { nodeId taskId taskName actorId actorRole timestamp instanceId }
   * edges { sourceNodeId targetNodeId edgeType weight }
   * intersectionInstanceIds
   * totalNodes
   * }
   * }
   * ```
   */
  formsTaskEntityJourneyGraph: GqlEntityJourneyGraph;
  /**
   * Chronological timeline of all constellation instances a subject was involved in.
   *
   * DRR-126 Phase 6: Given a `subject_actor_id` (resident or any subject),
   * returns all past + present constellation instances grouped from their tasks.
   * Each timeline event = one constellation instance (grouped by constellation_id + instance_id).
   *
   * Sorted newest-first. Active (in_progress/overdue) events appear at top.
   * Frontend renders as a vertical timeline with status-colored cards.
   *
   * Data tier: T2 (operational, task metadata only). DRR-114 compliant.
   */
  formsTaskSubjectJourneyTimeline: GqlJourneyTimeline;
  /**
   * Get a single task by ID
   *
   * FERP COMPLIANCE:
   * - Multi-tenant isolation (tenant from AuthCtx)
   * - Repository pattern (TaskRepository.find_by_id)
   * - Backend Snowflake ID (id from client)
   */
  formsTaskTask?: Maybe<Task>;
  /**
   * 4-hop breadcrumb chain for a task. DRR-126 Phase 8.
   *
   * Returns: Task → TaskGroup (tg-*) → [Workflow (wf-*)] → Constellation → Mandate (rs-*)
   *
   * All hops are derived from fields already stored on the task:
   * task_group_ref (hop 1), constellation_id (hop 3), mandate_ref (hop 4).
   * workflow_ref (hop 2) is optional — present when indexed via constellation config.
   *
   * Data tier: T2. No clinical content. DRR-114 compliant.
   */
  formsTaskTaskBreadcrumb?: Maybe<GqlTaskBreadcrumb>;
  /**
   * Get task metrics (aggregated statistics)
   *
   * FERP COMPLIANCE:
   * - Multi-tenant isolation (tenant from AuthCtx)
   * - Repository pattern (TaskRepository)
   * - Data-driven (metrics calculated from backend data)
   */
  formsTaskTaskMetrics: TaskMetrics;
  /**
   * List tasks with optional filtering and pagination
   *
   * FERP COMPLIANCE:
   * - Multi-tenant isolation (tenant from AuthCtx)
   * - Repository pattern (TaskRepository)
   * - Data-driven (filter params from input)
   */
  formsTaskTasks: Array<Task>;
  /**
   * Get tasks assigned to a specific user
   *
   * FERP COMPLIANCE:
   * - Multi-tenant isolation (tenant from AuthCtx)
   * - Repository pattern (TaskRepository.list with filter)
   * - Data-driven (assignee_id from input)
   */
  formsTaskTasksByAssignee: Array<Task>;
  /**
   * Returns feature flags for the current tenant.
   *
   * Flags are seeded from the `features:` section of
   * `common/configs/seed/constellations/constellation-facility-meta.yaml`.
   * To toggle a feature: update the YAML, re-run ferp-seed — no code changes.
   *
   * DRR-055: Dumb frontend — frontend NEVER hardcodes which features to show.
   * It reads this query and conditionally renders nav items + pages.
   */
  formsTaskTenantFeatureFlags: GqlTenantFeatureFlags;
  /** Validate draft data against schema */
  formsValidateDraft: FormsValidationResult;
  /** Validate expert for assignment (life-critical validation) */
  formsValidateExpertAssignment: ExpertValidationResult;
  /** Aggregate related workflow primitives for a selected component */
  formsWorkflowPrimitives: WorkflowPrimitiveResponse;
  /** Get completeness score for current primitives */
  formulaRegistryGetCompletenessScore: GqlCompletenessScore;
  /**
   * Get formula by ID and version.
   *
   * Requires scope: formula:read or formula:admin
   */
  formulaRegistryGetFormula?: Maybe<GqlDataDrivenFormula>;
  /**
   * Get latest version of a formula.
   *
   * Requires scope: formula:read or formula:admin
   */
  formulaRegistryGetLatestFormula?: Maybe<GqlDataDrivenFormula>;
  /**
   * List enabled formulas for a tenant.
   *
   * Requires scope: formula:read or formula:admin
   */
  formulaRegistryListEnabledFormulas: Array<GqlDataDrivenFormula>;
  /**
   * List all formulas for a tenant.
   *
   * Requires scope: formula:read or formula:admin
   */
  formulaRegistryListFormulas: Array<GqlDataDrivenFormula>;
  /**
   * List formulas by success rate (highest first).
   *
   * Requires scope: formula:read or formula:admin
   */
  formulaRegistryListFormulasBySuccessRate: Array<GqlDataDrivenFormula>;
  /** List all available primitive types */
  formulaRegistryListPrimitiveTypes: Array<GqlPrimitiveType | '%future added value'>;
  /** Get formula recommendations for current primitives */
  formulaRegistryRecommendFormulas: Array<GqlFormulaRecommendation>;
  /** Complete validation: warnings + recommendations + score */
  formulaRegistryValidateAndRecommend: GqlValidationResult;
  /** Validate primitives against anti-patterns */
  formulaRegistryValidatePrimitives: Array<GqlValidationWarning>;
  /**
   * Generate AI-powered optimization recommendations for a workflow
   * LIFE-CRITICAL: All recommendations undergo safety validation
   */
  generateOptimizationRecommendations: OptimizationGenerationResponseGql;
  /**
   * Get a generated document by ID
   *
   * Returns document metadata (not content). Content is stored in Wasabi.
   */
  generatedDocument?: Maybe<GqlDocumentRegistryEntry>;
  /**
   * List active constraints.
   *
   * Requires: `constraint:read` or `constraint:admin` scope
   */
  getActiveConstraints: Array<Constraint>;
  /**
   * Get active schedules for tenant.
   *
   * Requires `schedule:read` or `schedule:admin` scope
   */
  getActiveSchedules: Array<Schedule>;
  /** Get all active transactions (currently executing). */
  getActiveTransactions: Array<Transaction>;
  /**
   * Get actor by ID.
   *
   * Requires: `actor:read` scope
   */
  getActor?: Maybe<Actor>;
  /**
   * Get actor statistics.
   *
   * Requires: `actor:read` scope
   */
  getActorStatistics: GqlActorStatistics;
  /**
   * Get actors by capability.
   *
   * Requires: `actor:read` scope
   */
  getActorsByCapability: Array<Actor>;
  /**
   * Get actors by team.
   *
   * Requires: `actor:read` scope
   */
  getActorsByTeam: Array<Actor>;
  /**
   * Get actors by type.
   *
   * Requires: `actor:read` scope
   */
  getActorsByType: Array<Actor>;
  /**
   * Get actors with open circuit breaker.
   *
   * Requires: `actor:read` scope
   */
  getActorsWithOpenCircuitBreaker: Array<Actor>;
  /**
   * Get aggregated progress for a parent workflow and all its children.
   *
   * Provides a summary view of progress across the entire workflow hierarchy.
   * Uses GSI5 (root_instance_id) to find all hierarchy members.
   */
  getAggregatedProgress: GqlAggregatedProgress;
  /**
   * Get AI decision statistics for workflow instance.
   *
   * **Use Case**: AI decision confidence analysis, low-confidence detection
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to analyze
   *
   * # Returns
   *
   * AI decision statistics including confidence distribution, total tokens used
   */
  getAiDecisionStats: AiDecisionStats;
  /** Get analytics by ID */
  getAnalytics?: Maybe<Analytics>;
  /** Get analytics by category (Performance, Adoption, Business, System, Compliance) */
  getAnalyticsByCategory: Array<Analytics>;
  /** Get analytics by code (unique identifier within tenant) */
  getAnalyticsByCode?: Maybe<Analytics>;
  /** Get analytics by queue ID (Formula #6 Load-Balanced Queue support) */
  getAnalyticsByQueue: Array<Analytics>;
  /** Get analytics dashboard with all categories */
  getAnalyticsDashboard: AnalyticsDashboard;
  /** Get aggregated analytics summary */
  getAnalyticsSummary: AnalyticsSummary;
  /** Get time-series analytics data */
  getAnalyticsTimeSeries: Array<TimeSeriesPoint>;
  /** Get analytics with anomalies detected */
  getAnalyticsWithAnomalies: Array<Analytics>;
  /** Get analytics with threshold breaches (critical alerts) */
  getAnalyticsWithThresholdBreaches: Array<Analytics>;
  /**
   * Get annotation by ID.
   *
   * Requires `annotation:read` or `annotation:admin` scope.
   */
  getAnnotation?: Maybe<GqlAnnotation>;
  /**
   * Get annotation count for a specific entity.
   *
   * Requires `annotation:read` or `annotation:admin` scope.
   */
  getAnnotationCount: Scalars['Int']['output'];
  /** Get approval queue for tenant */
  getApprovalQueue: ApprovalQueueResponse;
  /** Get approval workflow instance */
  getApprovalWorkflowInstance?: Maybe<ApprovalWorkflowInstance>;
  getAudience: Array<Scalars['String']['output']>;
  /**
   * Get a single audit by ID
   * Requires: `audit:read` scope (DRR-102)
   */
  getAudit?: Maybe<AuditQl>;
  /**
   * Get the complete approval chain for an audit (dual approval tracking)
   * Requires: `audit:read` scope (DRR-102)
   */
  getAuditApprovalChain: Array<AuditQl>;
  /** Get audit statistics for date range */
  getAuditStatistics: AuditStatistics;
  /** Get forensic audit trail with filters (SOX §404) */
  getAuditTrail: AuditTrailResponse;
  /**
   * Get available actors.
   *
   * Requires: `actor:read` scope
   */
  getAvailableActors: Array<Actor>;
  getAvailableResources: Array<Resource>;
  /** Get bulk operation status by batch ID */
  getBulkOperationStatus?: Maybe<BulkOperation>;
  /** Get the current status of a signing ceremony. */
  getCeremonyStatus?: Maybe<SigningCeremony>;
  getCeremonyTemplate?: Maybe<CeremonyTemplateGql>;
  /** Get chaos document details */
  getChaosDocumentDetails: ChaosDocumentDetails;
  /**
   * Get checkpoint by ID.
   *
   * **Use Case**: Retrieve specific checkpoint details for rollback/resume
   *
   * # Arguments
   *
   * * `checkpoint_id` - Checkpoint Snowflake ID
   */
  getCheckpoint?: Maybe<Checkpoint>;
  /**
   * Get checkpoint chain (complete rollback dependency graph).
   *
   * **Use Case**: View all dependent checkpoints for recursive rollback
   *
   * # Arguments
   *
   * * `checkpoint_id` - Starting checkpoint ID
   */
  getCheckpointChain: Array<Checkpoint>;
  /**
   * Get checkpoint statistics for workflow.
   *
   * **Use Case**: Analytics and monitoring (storage usage, rollback counts)
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to analyze
   */
  getCheckpointStatistics: GqlCheckpointStatistics;
  /**
   * Get checkpoints by transaction (Formula #4 - saga compensation).
   *
   * **Use Case**: Retrieve all checkpoints for a saga transaction (ordered rollback)
   *
   * # Arguments
   *
   * * `transaction_id` - Saga transaction ID
   */
  getCheckpointsByTransaction: Array<Checkpoint>;
  /**
   * Get all child workflows for a parent instance.
   *
   * Returns progress information for all sub-workflows spawned by the parent.
   *
   * Note: Uses root_instance_id GSI (GSI5) to find hierarchy members,
   * then filters by parent_id. A dedicated parent_id GSI would be more efficient
   * for deeply nested hierarchies.
   */
  getChildWorkflows: GqlChildWorkflowConnection;
  /**
   * Get constraint by code.
   *
   * Requires: `constraint:read` or `constraint:admin` scope
   */
  getConstraint?: Maybe<Constraint>;
  /**
   * List constraints by entity.
   *
   * Requires: `constraint:read` or `constraint:admin` scope
   *
   * Uses ConstraintRepository.list_by_scope to find constraints scoped to entity type/ID.
   */
  getConstraintsByEntity: Array<Constraint>;
  /**
   * List constraints by type.
   *
   * Requires: `constraint:read` or `constraint:admin` scope
   */
  getConstraintsByType: Array<Constraint>;
  /**
   * Get a contract by ID
   *
   * Requires `contract:read` or `contract:admin` scope
   */
  getContract?: Maybe<Contract>;
  /**
   * Get a contract by external ID (for webhooks/DMZ)
   *
   * Requires `contract:read` or `contract:admin` scope
   */
  getContractByExternalId?: Maybe<Contract>;
  /**
   * Get a contract by slug
   *
   * Requires `contract:read` or `contract:admin` scope
   */
  getContractBySlug?: Maybe<Contract>;
  /** Get conversion status */
  getConversionStatus: ConversionStatus;
  /** Get current active version */
  getCurrentPolicyVersion?: Maybe<PolicyVersion>;
  /**
   * Get DSL syntax help and examples
   *
   * Returns documentation for the WHEN/THEN DSL syntax including
   * operators, built-in fields/actions, and usage examples.
   */
  getDslSyntaxHelp: DslSyntaxHelp;
  /**
   * Get schedules due for execution.
   *
   * Requires `schedule:read` or `schedule:admin` scope
   */
  getDueSchedules: Array<Schedule>;
  /** Get enabled analytics for a tenant (active collection) */
  getEnabledAnalytics: Array<Analytics>;
  /** Get failed transactions requiring intervention. */
  getFailedTransactions: Array<Transaction>;
  /**
   * Get the complete instance hierarchy from a root instance.
   *
   * Returns a tree structure for visualization of parent-child relationships.
   */
  getInstanceHierarchy: GqlInstanceHierarchyNode;
  /** Get the intake conversation history for a document. */
  getIntakeConversation: Array<IntakeConversationMessage>;
  /** Get integration by ID */
  getIntegration?: Maybe<Integration>;
  /** Get integrations by health status */
  getIntegrationsByHealthStatus: Array<Integration>;
  /** Get integrations by type (REST_API, GRAPHQL, WEBHOOK, etc.) */
  getIntegrationsByType: Array<Integration>;
  /** Get integrations needing credential rotation */
  getIntegrationsNeedingCredentialRotation: Array<Integration>;
  /** Get integrations with open circuit breakers (critical for incident response) */
  getIntegrationsWithOpenCircuitBreaker: Array<Integration>;
  /** Get JIT policy for a tenant */
  getJITPolicy?: Maybe<JitPolicy>;
  /** Get JIT statistics for a tenant */
  getJITStatistics: JitStatistics;
  /**
   * Get latest checkpoint for workflow instance.
   *
   * **Use Case**: Resume workflow from most recent save point
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to query
   */
  getLatestCheckpoint?: Maybe<Checkpoint>;
  /** Get latest version of a template */
  getLatestTemplateMetadata?: Maybe<TemplateMetadataOutput>;
  /**
   * Get least loaded actors for load balancing.
   *
   * Requires: `actor:read` scope
   *
   * Formula #6: Load-Balanced Queue support
   */
  getLeastLoadedActors: Array<Actor>;
  /**
   * Life-critical: Returns all resources flagged as life-critical for this tenant.
   * Used for safety dashboards and emergency resource allocation.
   */
  getLifeCriticalResources: Array<Resource>;
  /**
   * Get life-critical schedules for tenant.
   *
   * Requires `schedule:read` or `schedule:admin` scope
   */
  getLifeCriticalSchedules: Array<Schedule>;
  /**
   * Get LLM Comparison Data for Multi-LLM Template Analysis
   *
   * FERP Principles:
   * - Domain-agnostic: Works for all AI-generated templates
   * - Data-driven: Returns actual LLM provider results from DynamoDB
   * - Life-critical: Transparency enables trust in AI-generated workflows
   * - Audit trail: Complete tracking of which LLMs agreed/disagreed on each field
   *
   * Sprint 3 Task 3.2: Unblocks MultiLLMComparisonDashboard frontend integration
   */
  getLlmComparisonData: LlmcomparisonData;
  /** Get LLM fix recommendation by ID */
  getLlmFixRecommendation?: Maybe<LlmFixRecommendation>;
  /**
   * Get the current user's actor record.
   *
   * O(1) via Valkey auth→sequential ID index.
   * Fallback: O(N) scan for cold cache (populates index on hit).
   * Requires: authentication (no specific scope - every user can see their own actor)
   */
  getMyActor?: Maybe<Actor>;
  /**
   * Get notification by ID.
   *
   * Requires `notification:read` or `notification:admin` scope
   */
  getNotification?: Maybe<Notification>;
  /** Get notification statistics for a company */
  getNotificationStats: NotificationStats;
  /** Get list of notifications for a company */
  getNotifications: NotificationList;
  /** Get a single orchestration pattern by type */
  getOrchestrationPattern?: Maybe<OrchestrationPattern>;
  /** Get a single orchestration rule by ID */
  getOrchestrationRule?: Maybe<OrchestrationRule>;
  getOverloadedQueues: Array<Queue>;
  /**
   * Get performance statistics for workflow instance.
   *
   * **Use Case**: Performance monitoring, bottleneck detection, SLA compliance
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to analyze
   *
   * # Returns
   *
   * Performance statistics including p50/p95/p99 latencies, success rate, bottlenecks
   */
  getPerformanceStats: PerformanceStats;
  /** Get policy by ID. */
  getPolicy?: Maybe<Policy>;
  /** Get analytics for specific policy */
  getPolicyAnalytics?: Maybe<PolicyAnalytics>;
  /** Get policy rule by ID */
  getPolicyRule?: Maybe<PolicyRule>;
  /** Get a specific template by ID */
  getPolicyTemplate?: Maybe<PolicyTemplate>;
  /** Get specific policy version */
  getPolicyVersion?: Maybe<PolicyVersion>;
  getQueue?: Maybe<Queue>;
  getQueueStatistics: GqlQueueStatistics;
  getQueuesByWorkflowInstance: Array<Queue>;
  getQueuesWithSlaBreaches: Array<Queue>;
  /** Get RBAC audit statistics */
  getRBACAuditStatistics: RbacAuditStatistics;
  /**
   * Get recoverable checkpoints (resume-enabled and available).
   *
   * **Use Case**: Find all valid resume points for crashed workflow
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to query
   */
  getRecoverableCheckpoints: Array<Checkpoint>;
  getResource?: Maybe<Resource>;
  getResourceUtilizationReport: GqlResourceUtilizationReport;
  getResourcesByStatus: Array<Resource>;
  getResourcesByType: Array<Resource>;
  /**
   * Get role by ID.
   *
   * Requires scope: role:read or role:admin
   */
  getRole?: Maybe<Role>;
  /**
   * Get role hierarchy tree (including inherited permissions).
   *
   * Requires scope: role:read or role:admin
   */
  getRoleHierarchy: RoleHierarchy;
  /**
   * Get effective permissions (inherited + own).
   *
   * Requires scope: role:read or role:admin
   */
  getRolePermissions: EffectivePermissions;
  /** Get single template by ID */
  getRoleTemplate?: Maybe<RoleTemplate>;
  /** Get saga success rate (Formula #4). */
  getSagaSuccessRate: Scalars['Float']['output'];
  /**
   * Get schedule by ID.
   *
   * Requires `schedule:read` or `schedule:admin` scope
   */
  getSchedule?: Maybe<Schedule>;
  /**
   * Get schedule execution summary.
   *
   * Requires `schedule:read` or `schedule:admin` scope
   */
  getScheduleExecutionSummary: GqlScheduleExecutionSummary;
  /** Get standards pack details */
  getStandardsPackDetails: StandardsPackDetails;
  /** Retrieve a previously-run structured import job by ID. */
  getStructuredImportJob: StructuredImportJob;
  /** Get definition for a specific subgraph */
  getSubgraphDefinition?: Maybe<GqlSubgraphDefinition>;
  /**
   * Get metadata for a specific subgraph
   *
   * **Required Role**: User (all authenticated users)
   */
  getSubgraphMetadata?: Maybe<SubgraphMetadata>;
  /** Get subgraph registry for tenant */
  getSubgraphRegistry?: Maybe<SubgraphRegistry>;
  /** Get the tier for a specific subgraph */
  getSubgraphTier?: Maybe<ModuleTier | '%future added value'>;
  /**
   * Get team by code.
   *
   * Requires `team:read` or `team:admin` scope
   */
  getTeam?: Maybe<Team>;
  /** Get team by code (deprecated - use getTeam instead). */
  getTeamByCode?: Maybe<Team>;
  /**
   * Get team hierarchy (recursive children).
   *
   * Requires `team:read` or `team:admin` scope
   */
  getTeamHierarchy?: Maybe<Team>;
  /**
   * Get presence status for all team members.
   *
   * DRR-061: Reads ephemeral Valkey keys with 90s TTL.
   * Requires: `actor:read` scope
   */
  getTeamPresence: Array<GqlActorPresence>;
  /**
   * Get aggregated team workspace data.
   *
   * DRR-061: Single query returning team info + members + presence.
   * Avoids N+1 frontend queries.
   * Requires: `actor:read` scope
   */
  getTeamWorkspace: GqlTeamWorkspaceData;
  /** Get template by ID and version */
  getTemplateMetadata?: Maybe<TemplateMetadataOutput>;
  /**
   * Get template metadata cache metrics
   *
   * Returns real-time cache performance metrics including hit/miss rates,
   * operation latencies, error rates, and cost savings estimates.
   *
   * **GitHub Issue #325**: Cache metrics instrumentation
   *
   * # Example
   * ```graphql
   * query {
   * getTemplateMetadataCacheMetrics {
   * cacheHitRate
   * avgCacheHitLatencyMs
   * effectivenessScore
   * isMeetingTargets
   * estimatedMonthlySavingsUsd
   * }
   * }
   * ```
   */
  getTemplateMetadataCacheMetrics: TemplateCacheMetrics;
  /** Get template publication status */
  getTemplatePublicationStatus: PublicationStatus | '%future added value';
  /** Get template usage statistics */
  getTemplateUsage: Scalars['Int']['output'];
  /** Get specific template version by version number */
  getTemplateVersion?: Maybe<TemplateVersion>;
  /** Calculate diff between two template versions */
  getTemplateVersionDiff: TemplateVersionDiff;
  /** Get template version history */
  getTemplateVersionHistory: Array<VersionEntryOutput>;
  /** Get version history summary for a template */
  getTemplateVersionHistorySummary: TemplateVersionHistorySummary;
  /**
   * Get tenant branding by tenant ID
   *
   * Returns branding configuration for tenant
   */
  getTenantBranding?: Maybe<TenantBranding>;
  /**
   * Get tenant branding by custom domain
   *
   * Returns branding configuration for custom domain (e.g., "healthcare-manager.com")
   */
  getTenantBrandingByCustomDomain?: Maybe<TenantBranding>;
  /**
   * Get tenant branding by subdomain
   *
   * Returns branding configuration for subdomain (e.g., "healthcare-clinic")
   */
  getTenantBrandingBySubdomain?: Maybe<TenantBranding>;
  /** Get all entity types available to a tenant */
  getTenantEntityTypes: Array<SubgraphEntityType>;
  getTenantId: Scalars['String']['output'];
  /** Get nav items for a specific layer available to a tenant */
  getTenantNavItemsForLayer: Array<SubgraphNavItem>;
  /** Get routes for a specific layer available to a tenant */
  getTenantRoutesForLayer: Array<SubgraphRoute>;
  /**
   * Get complete subgraph configuration for a tenant
   *
   * This is the PRIMARY query for data-driven frontends.
   * Returns all routes, nav items, entity types, and permissions
   * based on the tenant's enabled subgraphs.
   *
   * Usage:
   * ```graphql
   * query GetTenantConfig($tenantId: String!) {
   * getTenantSubgraphConfig(tenantId: $tenantId) {
   * enabledSubgraphIds
   * allRoutes { path component layer title }
   * allNavItems { id label path icon layer sortOrder }
   * allEntityTypes { name pluralName graphqlType }
   * hasLifeCritical
   * }
   * }
   * ```
   */
  getTenantSubgraphConfig: TenantSubgraphConfig;
  /** Get time series data for specific analytics */
  getTimeSeriesData: Array<TimeSeriesDataPoint>;
  /** Get top N policies by metric */
  getTopPolicies: Array<PolicyRanking>;
  /**
   * Get trace by trace_id and span_id.
   *
   * **Use Case**: Retrieve specific span details for debugging
   *
   * # Arguments
   *
   * * `tenant_id` - Multi-tenant isolation
   * * `trace_id` - OpenTelemetry trace ID (128-bit hex)
   * * `span_id` - OpenTelemetry span ID (64-bit hex)
   */
  getTrace?: Maybe<Trace>;
  /** Get transaction by ID. */
  getTransaction?: Maybe<Transaction>;
  /** Get transaction statistics (aggregate metrics). */
  getTransactionStatistics: TransactionStatistics;
  /** Get unhealthy integrations requiring attention */
  getUnhealthyIntegrations: Array<Integration>;
  /**
   * Get unread notification count for recipient.
   *
   * Counts notifications that have not been read (read_at is None).
   * Requires `notification:read` or `notification:admin` scope
   */
  getUnreadCount: Scalars['Int']['output'];
  /** Get validation by code. */
  getValidation?: Maybe<Validation>;
  /** Get validation by ID (deprecated - use getValidation instead). */
  getValidationById?: Maybe<Validation>;
  /** Calculate diff between two versions */
  getVersionDiff: PolicyVersionDiff;
  /** Get version history summary */
  getVersionHistory: PolicyVersionHistorySummary;
  /**
   * List violated constraints.
   *
   * Requires: `constraint:read` or `constraint:admin` scope
   */
  getViolatedConstraints: Array<Constraint>;
  /**
   * Get a specific workflow by ID.
   *
   * Enriches the entity record with states/transitions from the YAML config
   * when the entity has a `config_ref` in metadata and only placeholder states.
   */
  getWorkflow?: Maybe<Workflow>;
  /** Get workflow compliance status */
  getWorkflowCompliance: WorkflowComplianceStatus;
  /** Get workflow graph by ID */
  getWorkflowGraph?: Maybe<WorkflowGraph>;
  /** Get workflow statistics for a tenant. */
  getWorkflowStatistics: WorkflowStatistics;
  /**
   * Multi-constellation graph intersection query using Valkey SINTER.
   *
   * DRR-255: Returns entity IDs (tasks, instances) that appear in ALL specified
   * constellation edge sets. Enables surveyor queries like "incomplete tasks for
   * Margaret at Hillside today" = 3-way intersection of subject, facility, and
   * encounter constellations.
   *
   * ## Performance
   * - SINTER on 10K sets: 2-3ms average (50x safety margin vs 100ms threshold)
   * - O(N*M) where N = smallest set size, M = number of sets
   *
   * ## Edge types used
   * - `idx:edge:{constellation_id}:HAS_SUBJECT` → tasks for this subject
   * - `idx:edge:{constellation_id}:BILLS_FOR` → tasks billable to encounter
   * - `idx:edge:{constellation_id}:LOCATION_OF` → tasks at this facility
   *
   * ## Example
   *
   * ```graphql
   * query {
   * graphIntersection(constellationIds: [
   * "17-resident-042",
   * "17-encounter-2026-04-24",
   * "17-facility-001"
   * ]) {
   * entityIds
   * count
   * }
   * }
   * ```
   */
  graphIntersection: GraphIntersectionResult;
  /**
   * HACCP compliance report for a date range
   *
   * Queries completed sanitation tasks (tg-7-2-*) and temperature logs
   * for HACCP documentation and audit readiness.
   */
  haccpReport: FoodServiceHaccpReport;
  /**
   * Check if an actor has completed a specific template (O(1) via Valkey SET)
   *
   * Returns true if the actor has completed the template.
   */
  hasCompleted: Scalars['Boolean']['output'];
  /** Check if tenant has a registry configured */
  hasSubgraphRegistry: Scalars['Boolean']['output'];
  health: Scalars['Boolean']['output'];
  /**
   * List available HTML PDF templates from agent service (DRR-079 migration)
   *
   * These templates use HTML/CSS layout (via weasyprint) instead of
   * YAML with manual coordinate positioning. Templates live in the
   * agent service's pdf_templates/ directory.
   */
  htmlPdfTemplates: Array<Scalars['String']['output']>;
  /**
   * Hydrate a compressed ID to its full format
   *
   * Converts `pay!1R156` to `tenant-1#payroll_run-156`
   */
  hydrateId: GqlHydrateResult;
  /**
   * Implement an approved optimization recommendation
   * LIFE-CRITICAL: Careful rollout with monitoring and rollback capability
   * Uses staged deployment with automatic rollback on errors
   */
  implementRecommendation: Scalars['Boolean']['output'];
  /** Import template from JSON */
  importTemplate: ImportResult;
  /**
   * Import a WearableCapture (Vuzix glasses) into the Document Studio chaos pipeline.
   * Registers the existing wearable S3 URI as a ChaosDocument — no re-upload.
   * DRR-128: no data duplication.
   */
  importWearableCaptureToStudio: ImportWearableCaptureResult;
  /**
   * Get incidents filtered by status.
   * Visible to users with incident:report or incident:view scope.
   */
  incidents: Array<Incident>;
  /** Increment template usage count (atomic operation) */
  incrementTemplateUsage: Scalars['Int']['output'];
  /** Initialize analytics for new policy */
  initializePolicyAnalytics: Scalars['Boolean']['output'];
  /** Initiate a structured CSV import job (Actor batch creation, max 100 rows). */
  initiateStructuredImport: StructuredImportJob;
  inspectActor?: Maybe<ActorStatsGql>;
  /** Get instance by ID. */
  instanceApiGetInstance?: Maybe<Instance>;
  /** Get instance by correlation ID (distributed tracing). */
  instanceApiGetInstanceByCorrelation?: Maybe<Instance>;
  /**
   * Get complete state transition history for instance (pure append-only).
   *
   * Returns all versions of an instance by following parent_id chain.
   * Versions are sorted by version number (ascending).
   *
   * # Performance
   *
   * - Query time: 5-20ms for typical workflows (5-10 state transitions)
   * - 10-50x FASTER than CloudWatch Logs Insights (100-500ms)
   *
   * # Example
   *
   * ```graphql
   * query {
   * getInstanceHistory(
   * tenantId: "healthcare-tenant"
   * workflowDefinitionId: "wf_def_123"
   * instanceId: "inst_abc"
   * ) {
   * id
   * version
   * status
   * currentState
   * updatedAt
   * parentId
   * }
   * }
   * ```
   */
  instanceApiGetInstanceHistory: Array<Instance>;
  /**
   * Get instances created by (or owned by) a specific actor (DRR-141).
   *
   * Returns all instances where `audit_info.created_by` matches the actor ID.
   * Used by InstanceListPage "My Instances" filter tab.
   *
   * Requires: `instance:read` scope
   *
   * ```graphql
   * query GetInstancesByActor($actorId: String!) {
   * getInstancesByActor(actorId: $actorId) {
   * id
   * instanceName
   * status
   * }
   * }
   * ```
   */
  instanceApiGetInstancesByActor: Array<Instance>;
  /**
   * Get instances assigned to a specific subject actor (DRR-141).
   *
   * Returns all Running/Pending/Paused instances where `subject_actor_id` matches.
   * Used by InstanceListPage "Resident" filter tab — same pattern as `getTasksBySubject`.
   *
   * Requires: `instance:read` scope
   *
   * ```graphql
   * query GetInstancesBySubject($subjectActorId: String!) {
   * getInstancesBySubject(subjectActorId: $subjectActorId) {
   * id
   * instanceName
   * status
   * currentState
   * subjectActorId
   * }
   * }
   * ```
   */
  instanceApiGetInstancesBySubject: Array<Instance>;
  /** Get instances with active subscriptions (for event-driven monitoring). */
  instanceApiListActiveInstances: GqlInstanceConnection;
  /** List instances with filters. */
  instanceApiListInstances: GqlInstanceConnection;
  /** List instances by status. */
  instanceApiListInstancesByStatus: GqlInstanceConnection;
  /** List instances by workflow definition ID. */
  instanceApiListInstancesByWorkflow: GqlInstanceConnection;
  /**
   * List SUBJECT actors with their current lifecycle phase (DRR-141).
   *
   * Returns subjects accessible to the current user, each annotated with the
   * lifecycle phase derived from their `wf-0-12-001` Instance `current_state`.
   *
   * - Uses `my_subject_actor_ids` Valkey traversal (DRR-135) to scope results to
   * subjects the current user is authorized to see via constellation membership.
   * - Falls back to all lifecycle instances if Valkey is cold (no assignments).
   * - Lifecycle phase = `current_state` on the `wf-0-12-001` Instance — derived,
   * never stored separately (DRR-140).
   * - Actor names are NOT resolved here — use frontend `resolveActorName`/`ActorNameContext`.
   *
   * ```graphql
   * query {
   * listSubjectsWithLifecycle {
   * actorId
   * lifecyclePhase   # "onboarding" | "active" | "exiting" | "closed" | null
   * }
   * }
   * ```
   */
  instanceApiListSubjectsWithLifecycle: Array<GqlSubjectWithLifecycle>;
  /** Instantiate a template with custom parameter values */
  instantiateTemplate: PolicyTemplateInstance;
  /** Lookup integration base URL */
  integBase?: Maybe<Scalars['String']['output']>;
  /** Get anomalies/alerts from platform sync */
  integrationAnomalies: IntegrationAnomalyList;
  /** Get API audit log */
  integrationApiAudit: Array<IntegrationApiAuditEvent>;
  /** Get burn rate reports for authorizations/agreements */
  integrationBurnRateReports: Array<IntegrationBurnRateReport>;
  /** List supported platforms */
  integrationSupportedPlatforms: Array<Scalars['String']['output']>;
  /** Get the latest sync status for a tenant/platform */
  integrationSyncStatus?: Maybe<IntegrationSyncMetadata>;
  /** Get workers who need to be contacted about issues */
  integrationWorkerContactQueue: Array<IntegrationWorkerContact>;
  /** Get an inventory constraint definition. */
  inventoryConstraint?: Maybe<InventoryConstraint>;
  /** List all inventory constraints for a tenant. */
  inventoryConstraints: Array<InventoryConstraint>;
  /**
   * Check if DSL compiler feature is available
   *
   * Returns availability status and feature flag information.
   */
  isDslAvailable: DslAvailability;
  /** Get items needing action (overdue, upcoming, flagged). */
  itemsNeedingAction: Array<ActionableItem>;
  /**
   * Get AI suggestions for journey next steps.
   *
   * Generates suggestions based on:
   * - Current workflow state
   * - Pending tasks
   * - Time since last action
   * - Deadline proximity
   */
  journeyAiSuggestions: Array<AiSuggestion>;
  /**
   * Get regulatory audit sections and compliance status.
   *
   * Populates from:
   * - Workflow's policy_refs -> linked rulesets
   * - Task completion status as evidence
   * - Ruleset member_rules as requirements
   */
  journeyAuditSections: Array<AuditSection>;
  /**
   * Get journey edges for a specific instance.
   *
   * Returns the raw edge records without resolving the linked instances.
   */
  journeyEdgeApiJourneyEdges: Array<InstanceJourneyEdge>;
  /**
   * Get instances linked to a given instance via journey edges.
   *
   * Returns all instances connected to the specified instance,
   * with edge type and direction information.
   *
   * # Arguments
   * * `instance_id` - The instance to find links for
   * * `edge_type` - Optional filter by edge type
   *
   * # Example
   * ```graphql
   * query {
   * linkedInstances(instanceId: "inst-123") {
   * instance { id instanceName status }
   * edgeType
   * direction
   * }
   * }
   * ```
   */
  journeyEdgeApiLinkedInstances: Array<GqlLinkedInstance>;
  /** Kitchen metrics for manager dashboard */
  kitchenMetrics: FoodServiceKitchenMetrics;
  /**
   * Get a ledger account by actor ID
   * Requires: `ledger:read` scope (DRR-102)
   */
  ledgerAccount?: Maybe<LedgerAccount>;
  /**
   * List all ledger accounts for a tenant
   * Requires: `ledger:read` scope (DRR-102)
   */
  ledgerAccounts: Array<LedgerAccount>;
  /**
   * Get chain verification status
   * Requires: `ledger:read` scope (DRR-102)
   */
  ledgerChainStatus: LedgerChainStatus;
  /**
   * Get ledger settlements for a period
   * Requires: `ledger:read` scope (DRR-102)
   */
  ledgerSettlements: Array<LedgerSettlement>;
  /**
   * List all token definitions for a tenant
   * Requires: `ledger:read` scope (DRR-102)
   */
  ledgerTokens: Array<LedgerToken>;
  /**
   * Get ledger transfers with optional filtering
   * Requires: `ledger:read` scope (DRR-102)
   */
  ledgerTransfers: Array<LedgerTransfer>;
  /**
   * Get a single legacy archive file by ID.
   *
   * Returns full file metadata with CloudFront signed URLs
   * (if scan status permits access).
   */
  legacyArchiveFile?: Maybe<LegacyArchiveFile>;
  /**
   * List legacy archive files for the authenticated tenant.
   *
   * Returns paginated list of files with scan status, access flags,
   * and CloudFront signed URLs (for CLEAN/MACRO_DETECTED files).
   * INFECTED/UNSCANNED files return metadata only (no URLs).
   */
  legacyArchiveFiles: Array<LegacyArchiveFile>;
  /**
   * Get a lens template by ID.
   *
   * DRR-075/085: Lenses filter constellation views by role/perspective.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * lensTemplate(lensId: "ln-5-0-002") {
   * lensId
   * name
   * phase
   * appliesToConstellation
   * onboardingChecklist { step ring statusField }
   * }
   * }
   * ```
   */
  lensTemplate?: Maybe<LensTemplate>;
  /**
   * List all lens templates, optionally filtered by vertical or constellation.
   *
   * DRR-075/085: Returns all lens config type #6 templates.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * lensTemplates(vertical: "assisted-living") {
   * lensId
   * name
   * phase
   * appliesToConstellation
   * }
   * }
   * ```
   */
  lensTemplates: Array<LensTemplate>;
  /** List active JIT sessions for a tenant */
  listActiveJITSessions: ListActiveJitSessionsResult;
  /**
   * List active roles for tenant.
   *
   * Requires scope: role:read or role:admin
   */
  listActiveRoles: RoleConnection;
  /**
   * List active teams only.
   *
   * Requires `team:read` or `team:admin` scope
   */
  listActiveTeams: Array<Team>;
  /** List active validations. */
  listActiveValidations: Array<Validation>;
  /** List active workflows for a tenant. */
  listActiveWorkflows: Array<Workflow>;
  /**
   * List actors for tenant.
   *
   * Requires: `actor:read` scope (returns empty for unauthenticated users)
   */
  listActors: GqlActorConnection;
  /**
   * List AI-generated audits (Formula #3: AI Human Hybrid)
   * Requires: `audit:read` scope (DRR-102)
   */
  listAiGeneratedAudits: AuditListResultQl;
  /**
   * Get all subgraph metadata for a tenant
   *
   * Now tenant-scoped for IAM isolation. Returns all subgraph metadata
   * available to the specified tenant.
   *
   * For production frontend use, prefer `getTenantSubgraphConfig` which
   * filters by tenant's enabled subgraphs via SubgraphRegistry.
   *
   * **Required Role**: User (all authenticated users)
   */
  listAllSubgraphMetadata: Array<SubgraphMetadata>;
  /** List analytics for tenant with pagination */
  listAnalytics: AnalyticsConnection;
  /**
   * List all annotations in a thread, oldest first (chronological).
   *
   * Requires `annotation:read` or `annotation:admin` scope.
   */
  listAnnotationThread: GqlAnnotationConnection;
  /**
   * List annotations for a specific entity, newest first.
   *
   * Requires `annotation:read` or `annotation:admin` scope.
   */
  listAnnotations: GqlAnnotationConnection;
  /**
   * Find atomic parts that satisfy a given requirement (ruleset, tag, etc.)
   *
   * Examples:
   * listAtomicParts(satisfies: "rs-4-1-004") → task groups mandated by 144G
   * listAtomicParts(satisfies: "tag:outcome:functional-assessment") → parts that fulfill this
   * listAtomicParts(partType: "TASK_GROUP") → all task groups
   */
  listAtomicParts: Array<GqlCatalogPart>;
  listAudiences: Array<Scalars['String']['output']>;
  /**
   * List all audits for a tenant with pagination
   * Requires: `audit:read` scope (DRR-102)
   */
  listAudits: AuditListResultQl;
  /**
   * List audits by compliance framework
   * Requires: `audit:read` scope (DRR-102)
   */
  listAuditsByFramework: AuditListResultQl;
  /**
   * List audits within a compliance period
   * Requires: `audit:read` scope (DRR-102)
   */
  listAuditsByPeriod: AuditListResultQl;
  /**
   * List audits in a specific processing queue (Formula #6)
   * Requires: `audit:read` scope (DRR-102)
   */
  listAuditsByQueue: AuditListResultQl;
  /**
   * List audits by compliance status
   * Requires: `audit:read` scope (DRR-102)
   */
  listAuditsByStatus: AuditListResultQl;
  /**
   * List audits by user who generated them
   * Requires: `audit:read` scope (DRR-102)
   */
  listAuditsByUser: AuditListResultQl;
  /**
   * List all available briefing templates.
   *
   * Loads YAML config files from `common/configs/seed/briefing-templates/`.
   * Templates are config-as-code processed by EmitAssistantBriefing workflow action.
   *
   * Requires: `assistant:briefing:view` scope (DRR-131, DRR-102)
   */
  listBriefingTemplates: Array<BriefingTemplate>;
  listBroadcastLogs: Array<LogLine>;
  /** List bulk operations for tenant */
  listBulkOperations: Array<BulkOperation>;
  /** List all ceremonies for a document. */
  listCeremoniesForDocument: Array<SigningCeremony>;
  listCeremonyTemplates: Array<CeremonyTemplateGql>;
  /** List chaos documents */
  listChaosDocuments: Array<ChaosDocument>;
  /**
   * List checkpoints by workflow instance (sequence-ordered).
   *
   * **Use Case**: View all checkpoints for a workflow instance (ordered by sequence_number)
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to query
   * * `limit` - Max results (default: 100, max: 500)
   */
  listCheckpointsByWorkflow: Array<Checkpoint>;
  /**
   * List child teams by parent ID.
   *
   * Requires `team:read` or `team:admin` scope
   */
  listChildTeams: Array<Team>;
  /**
   * List constraints for tenant.
   *
   * Requires: `constraint:read` or `constraint:admin` scope
   */
  listConstraints: GqlConstraintConnection;
  /**
   * List contracts by status (for monitoring dashboards)
   *
   * Requires `contract:read` or `contract:admin` scope
   */
  listContractsByStatus: GqlContractConnection;
  /**
   * List contracts by workflow instance
   *
   * Requires `contract:read` or `contract:admin` scope
   */
  listContractsByWorkflow: GqlContractConnection;
  /**
   * List available domain metadata with filtering and pagination
   * Requires: `metadata:read` scope (DRR-102)
   */
  listDomainMetadata: DomainMetadataConnection;
  /** Convenience: list only drifted integrations (status == "drift"), newest first */
  listDrift: Array<ReconRecord>;
  /** List enabled policies only. */
  listEnabledPolicies: PolicyConnection;
  /** List all enabled subgraphs for tenant */
  listEnabledSubgraphs: SubgraphList;
  /**
   * List audits with retention expiring before a given date
   * Requires: `audit:read` scope (DRR-102)
   */
  listExpiringAudits: AuditListResultQl;
  /** List subgraphs expiring within N days */
  listExpiringSubgraphs: Array<ExpiringSubgraph>;
  /** List stored FHIR AdverseEvent resources */
  listFhirAdverseEvents: FhirStoredResourceConnection;
  /** List stored FHIR AllergyIntolerance resources */
  listFhirAllergyIntolerances: FhirStoredResourceConnection;
  /** List stored FHIR CarePlan resources */
  listFhirCarePlans: FhirStoredResourceConnection;
  /** List stored FHIR CareTeam resources */
  listFhirCareTeams: FhirStoredResourceConnection;
  /** List stored FHIR ClaimResponse resources */
  listFhirClaimResponses: FhirStoredResourceConnection;
  /** List stored FHIR Claim resources */
  listFhirClaims: FhirStoredResourceConnection;
  /** List stored FHIR Condition resources */
  listFhirConditions: FhirStoredResourceConnection;
  /** List stored FHIR DiagnosticReport resources */
  listFhirDiagnosticReports: FhirStoredResourceConnection;
  /** List stored FHIR Encounter resources */
  listFhirEncounters: FhirStoredResourceConnection;
  /** List stored FHIR Goal resources */
  listFhirGoals: FhirStoredResourceConnection;
  /** List stored FHIR Immunization resources */
  listFhirImmunizations: FhirStoredResourceConnection;
  /** List stored FHIR MedicationAdministration resources */
  listFhirMedicationAdministrations: FhirStoredResourceConnection;
  /** List stored FHIR MedicationRequest resources */
  listFhirMedicationRequests: FhirStoredResourceConnection;
  /** List stored FHIR Medication resources */
  listFhirMedications: FhirStoredResourceConnection;
  /** List stored FHIR Observation resources */
  listFhirObservations: FhirStoredResourceConnection;
  /** List stored FHIR Patient resources */
  listFhirPatients: FhirStoredResourceConnection;
  /** List stored FHIR Practitioner resources */
  listFhirPractitioners: FhirStoredResourceConnection;
  /** List stored FHIR Procedure resources */
  listFhirProcedures: FhirStoredResourceConnection;
  /** List stored FHIR ServiceRequest resources */
  listFhirServiceRequests: FhirStoredResourceConnection;
  /** List all drafts for a user */
  listFormSchemaDrafts: Array<FormSchemaDraftSummaryOutput>;
  listFreeze: Array<Freeze>;
  /** List grants I've given (as granting tenant) */
  listGrantedAccess: GrantList;
  /** List integrations for tenant with pagination */
  listIntegrations: IntegrationConnection;
  /** List JIT access requests (with optional filtering) */
  listJITRequests: ListJitRequestsResult;
  /** List life-critical subgraphs for tenant */
  listLifeCriticalSubgraphs: SubgraphList;
  /** List life-critical workflows for a tenant. */
  listLifeCriticalWorkflows: Array<Workflow>;
  /** List all LLM fix recommendations for a template */
  listLlmFixRecommendations: Array<LlmFixRecommendation>;
  /**
   * List workflows visible to a specific actor based on their role_ids.
   *
   * Role-based filtering (DRR-102): actors with `workflow:admin` see ALL workflows;
   * actors with only `workflow:read` see workflows where their role_ids overlap with
   * `metadata.required_role_ids` (or workflows with no role restriction).
   *
   * Used by the Workflows page to show role-relevant workflows instead of everything.
   */
  listMyWorkflows: Array<Workflow>;
  /**
   * List notifications by status.
   *
   * Requires `notification:read` or `notification:admin` scope
   */
  listNotificationsByStatus: GqlNotificationConnection;
  /**
   * List all notifications for the current tenant (admin view).
   *
   * Requires `notification:read` or `notification:admin` scope
   */
  listNotificationsByTenant: GqlNotificationConnection;
  /**
   * List notifications by trigger entity.
   *
   * Requires `notification:read` or `notification:admin` scope
   */
  listNotificationsByTrigger: GqlNotificationConnection;
  /**
   * List notifications by recipient.
   *
   * Requires `notification:read` or `notification:admin` scope
   */
  listNotificationsForRecipient: GqlNotificationConnection;
  /**
   * List optimization recommendations for a tenant
   * Supports filtering by status and pagination
   */
  listOptimizationRecommendations: Array<OptimizationRecommendationGql>;
  /** List all orchestration patterns */
  listOrchestrationPatterns: Array<OrchestrationPattern>;
  /** List all orchestration rules for a tenant */
  listOrchestrationRules: Array<OrchestrationRule>;
  /** List pending approvals for approver */
  listPendingApprovals: Array<ApprovalWorkflowInstance>;
  /** List policies by tenant with pagination. */
  listPolicies: PolicyConnection;
  /** List policies by scope (Workflow, Task, Approval, Global). */
  listPoliciesByScope: Array<Policy>;
  /** List policies by type (Approval, Validation, Security, Compliance, Notification). */
  listPoliciesByType: PolicyConnection;
  /** List analytics for all policies in tenant */
  listPolicyAnalytics: Array<PolicyAnalytics>;
  /** List policy rules by tenant */
  listPolicyRules: Array<PolicyRule>;
  /** List all active policy templates */
  listPolicyTemplates: Array<PolicyTemplate>;
  /** List all versions for a policy */
  listPolicyVersions: Array<PolicyVersion>;
  /** List published templates (exclude drafts and archived) */
  listPublishedTemplates: Array<TemplateListItem>;
  listQueues: GqlQueueConnection;
  /** List RBAC audit log entries */
  listRBACAuditLog: RbacAuditLogResponse;
  /** List grants I've received (as verifier) */
  listReceivedGrants: GrantList;
  /** List recent reconciliation records for tenant; optionally filter by status (ok|drift|error) */
  listRecon: Array<ReconRecord>;
  listResources: GqlResourceConnection;
  /** List all templates for a tenant */
  listRoleTemplates: Array<RoleTemplate>;
  /**
   * List roles by tenant with pagination.
   *
   * Requires scope: role:read or role:admin
   */
  listRoles: RoleConnection;
  /**
   * List roles by category.
   *
   * Requires scope: role:read or role:admin
   */
  listRolesByCategory: Array<Role>;
  /**
   * List runtime actor mailbox IDs (in-memory actor system, not Actor primitives).
   * Use `listActors` query from actor_api for Actor primitive CRUD operations.
   */
  listRuntimeActors: Array<Scalars['String']['output']>;
  /**
   * List schedules with pagination.
   *
   * Requires `schedule:read` or `schedule:admin` scope
   */
  listSchedules: GqlScheduleConnection;
  /**
   * Get list schema for a subgraph entity.
   *
   * Defines columns, filters, and actions for entity list views.
   */
  listSchema?: Maybe<ListSchema>;
  /** List available domains with registered schemas */
  listSchemaDomains: Array<Scalars['String']['output']>;
  /**
   * List all spans in a distributed trace (complete trace tree).
   *
   * **Use Case**: View complete execution flow across services (distributed tracing)
   *
   * # Arguments
   *
   * * `trace_id` - OpenTelemetry trace ID (128-bit hex)
   */
  listSpansByTraceId: Array<Trace>;
  /** List available standards packs */
  listStandardsPacks: Array<StandardsPackListItem>;
  /**
   * List all registered subgraphs
   *
   * Returns metadata about all subgraphs that have registered with the ID broker.
   * Requires admin access.
   */
  listSubgraphs: Array<GqlSubgraphDefinition>;
  /** List subgraphs by tier */
  listSubgraphsByTier: SubgraphList;
  listSuppressedEmails: Array<Scalars['String']['output']>;
  listSuppressedSms: Array<Scalars['String']['output']>;
  /**
   * List all teams for tenant.
   *
   * Requires `team:read` or `team:admin` scope
   */
  listTeams: Array<Team>;
  /**
   * List teams by team type.
   *
   * Requires `team:read` or `team:admin` scope
   */
  listTeamsByType: Array<Team>;
  /** List template instances for a tenant */
  listTemplateInstances: Array<PolicyTemplateInstance>;
  /** List all instances of a specific template (cross-tenant analytics) */
  listTemplateUsage: Array<PolicyTemplateInstance>;
  /** List all versions for a template */
  listTemplateVersions: Array<TemplateVersion>;
  /** List templates by category */
  listTemplatesByCategory: Array<PolicyTemplate>;
  /** List templates by domain (usage-sorted via GSI1) */
  listTemplatesByDomain: Array<TemplateListItem>;
  /** List templates by domain and type (filtered GSI1 query) */
  listTemplatesByDomainAndType: Array<TemplateListItem>;
  /** List all templates for a tenant (GSI2) */
  listTemplatesByTenant: Array<TemplateListItem>;
  /**
   * List all tenant brandings
   *
   * Returns all tenant brandings (admin only)
   */
  listTenantBrandings: Array<TenantBranding>;
  /** List all tenants with subgraph registries (admin operation) */
  listTenantsWithRegistries: Array<Scalars['String']['output']>;
  /**
   * List traces by task ID with pagination.
   *
   * **Use Case**: View all execution traces for a specific task
   *
   * # Arguments
   *
   * * `task_id` - Task to query
   * * `limit` - Max results (default: 50, max: 500)
   * * `cursor` - Pagination cursor from previous response
   */
  listTracesByTaskId: TraceConnection;
  /**
   * List traces by workflow instance with pagination.
   *
   * **Use Case**: View all execution traces for a workflow instance (time-sorted)
   *
   * # Arguments
   *
   * * `workflow_instance_id` - Workflow instance to query
   * * `limit` - Max results (default: 50, max: 500)
   * * `cursor` - Pagination cursor from previous response
   */
  listTracesByWorkflowInstance: TraceConnection;
  /** List transactions by status. */
  listTransactionsByStatus: Array<Transaction>;
  /** List all transactions for tenant (paginated). */
  listTransactionsByTenant: TransactionPage;
  /** List transactions by workflow instance. */
  listTransactionsByWorkflow: Array<Transaction>;
  /** List all schemas for a module */
  listUiSchemas: Array<UiFormSchema>;
  /** List only usable subgraphs (enabled + active/trial + not expired) */
  listUsableSubgraphs: SubgraphList;
  /** List all validations for tenant. */
  listValidations: Array<Validation>;
  /** List validations by execution phase. */
  listValidationsByPhase: Array<Validation>;
  /** List validations by validation type. */
  listValidationsByType: Array<Validation>;
  /** List registered webhook endpoints for a tenant (D1). */
  listWebhookEndpoints: Array<WebhookEndpoint>;
  /** List workflow graphs for tenant */
  listWorkflowGraphs: WorkflowGraphList;
  /** List all workflows for a tenant. */
  listWorkflows: WorkflowConnection;
  /** List workflows by execution strategy. */
  listWorkflowsByStrategy: Array<Workflow>;
  /** Export draft to YAML */
  llmWorkflowExportDraft: ExportDraftResponse;
  /** Get a draft by ID */
  llmWorkflowGetDraft?: Maybe<WorkflowDraft>;
  /** List drafts for current user */
  llmWorkflowListDrafts: Array<DraftSummary>;
  /** Preview YAML for a draft without persisting */
  llmWorkflowPreviewDraftYaml: Scalars['String']['output'];
  /** Lookup Snowflake ID by compressed ID */
  lookupByCompressed: LookupByCompressedResult;
  /** Lookup compressed ID by Snowflake ID */
  lookupBySnowflake: LookupBySnowflakeResult;
  /**
   * Look up a code's display name and details
   *
   * Requires Medplum connection (FHIR_BASE/FHIR_TOKEN env vars).
   */
  lookupCode: CodeInfo;
  /** Health check for management API */
  managementHealth: Scalars['Boolean']['output'];
  /**
   * Get the master workflow configuration for a program variant
   *
   * Returns the full orchestration config including sub-workflows,
   * dependencies, phases, and program-specific configuration.
   */
  masterWorkflowConfig: MasterWorkflowConfigResponse;
  /** Get a FHIR Medication by ID (drug definition) */
  medication?: Maybe<FhirMedication>;
  /** Get a FHIR MedicationAdministration by ID */
  medicationAdministration?: Maybe<FhirMedicationAdministration>;
  /** Search for MedicationAdministrations */
  medicationAdministrations: MedicationAdministrationConnection;
  /** Get a FHIR MedicationDispense by ID (fill/refill) */
  medicationDispense?: Maybe<FhirMedicationDispense>;
  /** Search for MedicationDispenses (fills/refills) */
  medicationDispenses: MedicationDispenseConnection;
  /** Get a FHIR MedicationRequest by ID (prescription) */
  medicationRequest?: Maybe<FhirMedicationRequest>;
  /** Search for MedicationRequests (prescriptions) */
  medicationRequests: MedicationRequestConnection;
  /** Search for Medications (drug definitions) */
  medications: MedicationConnection;
  /**
   * Get complete metadata manifest for frontend discovery and code generation
   *
   * This endpoint returns all primitive metadata, subgraph entity types,
   * and form patterns needed for the frontend to generate typed hooks
   * and discovery utilities.
   */
  metadataManifest: MetadataManifest;
  /** Get version info for frontend compatibility checks */
  metadataManifestVersion: ManifestVersionInfo;
  /**
   * My accessible subgraphs — intersection of role-allowed and tenant-enabled
   *
   * This resolver returns the subgraphs that the CURRENT USER can actually access,
   * which is the intersection of:
   * 1. What the tenant has enabled (SubgraphRegistry)
   * 2. What the user's roles allow (role-registry.yaml)
   *
   * Use this for frontend nav filtering instead of listEnabledSubgraphs.
   */
  myAccessibleSubgraphs: SubgraphList;
  /**
   * Get capabilities for the current user on a specific entity type.
   *
   * Multi-dimensional resolution (DRR-200/202):
   * - WHO: current actor + credentials + delegation chain
   * - WHERE: jurisdiction from context or auth default
   * - WHEN: current time (delegation expiry check)
   * - WHAT: entity type from input
   *
   * Frontend caches this result and uses it to conditionally render
   * action buttons (Create, Edit, Delete, Approve, etc.).
   */
  myCapabilities: Capabilities;
  /**
   * Batch capability check for multiple entity types.
   *
   * More efficient than calling myCapabilities multiple times.
   */
  myCapabilitiesBatch: Array<Capabilities>;
  /**
   * Query certifications expiring soon for the authenticated actor.
   *
   * DRR-284 (#985): Proactive certification expiration alerts.
   * Returns certifications expiring within 90 days, sorted by urgency.
   *
   * Urgency levels:
   * - EXPIRED: Already expired, scopes currently blocked
   * - CRITICAL: Expiring within 30 days
   * - WARNING: Expiring within 60 days
   * - NOTICE: Expiring within 90 days
   */
  myCertificationGaps: CertificationGapsResult;
  /**
   * List documents for the current user (my documents)
   *
   * Supports filtering by type, year, status.
   */
  myGeneratedDocuments: GqlDocumentConnection;
  myInbox: Array<InboxTask>;
  /**
   * Returns the current user's role config IDs from auth context.
   *
   * In dev mode, these come from `x-ferp-role-ids` header.
   * In production, resolved from JWT claims via role mapping.
   *
   * Used by MyAccessPage to query scopes without relying on localStorage.
   */
  myRoleIds: Array<Scalars['String']['output']>;
  /**
   * DRR-284: Get scope gaps for the current actor.
   *
   * Returns scopes that the actor's roles would grant, but are blocked due
   * to unmet prerequisites (missing training, delegation, certification, etc.)
   *
   * Use this to show the actor what they need to complete to unlock additional
   * capabilities (e.g., medication admin requires med aide training + RN delegation).
   *
   * No scope guard — actors can see their own gaps.
   */
  myScopeGaps: ScopeGapsResult;
  /**
   * Get service authorizations visible to the current user.
   * Returns authorizations from lead agency with units and utilization.
   */
  myServiceAuthorizations: Array<ServiceAuthorization>;
  /** Get current actor's station assignment (DRR-055: backend-driven) */
  myStationAssignment: FoodServiceStationAssignment;
  /**
   * Get the IDs of SUBJECT actors assigned to the current user (Ring 1 filter, DRR-135).
   *
   * Two-hop Valkey traversal:
   * GET idx:{tenant_num}:auth_user:{auth_id}    → sequential actor ID
   * SMEMBERS idx:edge:{actor_id}:COORDINATES   → constellation IDs
   * SMEMBERS idx:edge:{cst_id}:SUBJECT          → center actor IDs
   *
   * Returns empty vec if the user has no constellation memberships (Valkey cold / no assignments).
   * Frontend falls back to showing all subjects in that case.
   */
  mySubjectActorIds: Array<Scalars['String']['output']>;
  /**
   * Get edges for the current user filtered by type.
   * Used by worker management to get EMPLOYS/SERVES relationships.
   *
   * Backend filters based on caller's actor ID and edge type.
   * Edge types are stored in Valkey with keys: idx:edge:{actor_id}:{edge_type}
   */
  mySubjectEdges: Array<SubjectEdge>;
  /**
   * Get SUBJECT actors visible to the current user (DRR-135 + DRR-279 secure backend filtering).
   *
   * Visibility rules enforced SERVER-SIDE via role-based subject_filter (DRR-279):
   * - `SubjectFilter::All` OR admin scopes → see all subjects (admin oversight)
   * - `SubjectFilter::SelfOnly` → participant sees only their own subject record
   * - `SubjectFilter::Edge(type)` → worker sees only subjects via specific edge
   * - No subject_filter + not admin → legacy behavior (all Ring 1 edges)
   *
   * This is the SECURE resolver for "My People" views. Frontend should use this
   * instead of `getActorsByType(SUBJECT)` which returns all subjects.
   */
  mySubjects: Array<Actor>;
  /**
   * Get tasks assigned to a specific actor
   *
   * Queries the TASK# index for efficient "my tasks" queries.
   */
  myTasks: WorkItemConnection;
  /**
   * Get the current user's traversal mode (DRR-135).
   *
   * Reads from Valkey key `pref:{tenant_num}:{auth_subject}:traversal_mode`.
   * Default (no stored preference) is derived from the actor's wall classification:
   * - clinical wall  → PersonCentered (rounds-based: start from people)
   * - operational wall → TaskCentric  (operations-based: start from work queues)
   * - no wall / architect → TaskCentric
   */
  myTraversalMode: GqlActorTraversalMode;
  /**
   * Get unified view context for the current route.
   *
   * Returns all presentation metadata needed to render a route:
   * - Lens (clinical, operational, architect)
   * - Terminology mappings
   * - Visible primitives
   * - Navigation groups
   * - Form overrides
   * - Scope dimensions
   * - Work context (if subject-centric)
   * - Route constraints
   *
   * Frontend should call this once per navigation and cache the result.
   * Invalidation happens via response extensions on state changes.
   */
  myViewContext: GqlViewContext;
  /**
   * DRR-135: Returns the view layer (user/admin/architect) for the current actor.
   *
   * Priority: explicit `view_layer` field in role YAML > wall-based fallback.
   * Wall controls data isolation; view_layer controls UI navigation tier.
   *
   * - `view_layer: admin` (explicit) → Admin (e.g. DON: clinical wall, admin nav)
   * - `wall: operational` (fallback) → Admin
   * - `wall: clinical` or no wall (fallback) → User
   * - SaaS SuperAdmin → Architect
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  myViewLayer: ViewLayer | '%future added value';
  /**
   * Get witness requests created by the current user.
   *
   * Requires Tier 2+ authentication.
   */
  myWitnessRequests: Array<WitnessRequestGql>;
  /**
   * Get all work items for the current user/tenant
   *
   * This is the primary "show all my work" query that aggregates work
   * from all domains (FHIR, Payroll, etc.) using the INSTANCE# index.
   *
   * ## Performance
   *
   * - Single DynamoDB query (no N-subgraph fan-out)
   * - p50 latency: <50ms
   * - Native pagination via cursor
   *
   * ## Filtering
   *
   * The composite SK format `INSTANCE#{domain}#{status}#{priority}#{ts}#{id}`
   * enables efficient filtering via `begins_with`:
   * - All work: `begins_with(sk, "INSTANCE#")`
   * - By domain: `begins_with(sk, "INSTANCE#fhir#")`
   * - By domain+status: `begins_with(sk, "INSTANCE#fhir#pending#")`
   */
  myWork: WorkItemConnection;
  /**
   * DRR-188 H3: Returns aggregated pending item counts per navigation group.
   *
   * The Context Banner uses this to show frontline staff what needs attention.
   * Labels are pre-rendered with constellation-driven terminology (subject_label).
   * Groups with zero pending items are omitted.
   *
   * Performance: Valkey-cached counts with 60s TTL. Target <200ms.
   */
  navigationSummary: Array<NavigationGroupSummary>;
  /**
   * Get a FHIR Observation by ID (proxies to Medplum GraphQL API)
   * Accepts either raw FHIR ID or federated ID (tenant:fhir_id)
   *
   * Uses Valkey caching for performance (5-minute TTL).
   */
  observation?: Maybe<FhirObservation>;
  /** List FHIR Observations with optional patient filter (proxies to Medplum GraphQL API) */
  observations: ObservationConnection;
  /**
   * Bootstrap payload for an actor's Automerge ReadCacheDoc (DRR-150 Phase 3).
   *
   * The facility hub calls this when an actor authenticates. It returns:
   * - All entities in the actor's constellation assignment for `shift_date`
   * - A staleness_manifest (FERP defaults + any tighter tenant overrides)
   * - FormSchema blobs for offline form rendering
   *
   * The hub writes the result into the actor's ReadCacheDoc and syncs it
   * to the device. The device never calls this query directly — it relies
   * on the hub's Automerge sync.
   *
   * **Scope**: `sync:write` (all care-staff roles carry this).
   */
  offlineEnvelope: OfflineEnvelopePayload;
  /** Single order status lookup */
  orderStatus?: Maybe<FoodServiceOrder>;
  /**
   * DRR-138: List task groups with no MANDATED_BY edge (Coverage Gaps panel).
   *
   * An orphan task group has no regulatory anchor — it exists in the seed but
   * no ruleset declares a MANDATES edge pointing to it. This is an architectural
   * gap per DRR-110: every task group MUST have at least one MANDATED_BY edge.
   *
   * Resolution: add `edges: [{type: MANDATED_BY, target: rs-X-Y-Z}]` in the YAML.
   *
   * Requires `compliance:read` or `admin` scope.
   */
  orphanTaskGroups: Array<TaskGroup>;
  /**
   * Get page assignment configuration for a specific context.
   * Returns categories, mode, constraints, and UI config that drive
   * the DocumentPageAssigner frontend component.
   */
  pageAssignmentConfig?: Maybe<PageAssignmentConfig>;
  /** List all available page assignment contexts. */
  pageAssignmentContexts: Array<Scalars['String']['output']>;
  /** Parse a YAML workflow definition string into DAG format (for editor import) */
  parseWorkflowYaml?: Maybe<DagworkflowGql>;
  /**
   * Resolve which atomic parts a specific ruleset requires.
   *
   * Traverses the full edge graph from a ruleset to find all
   * task groups, form fragments, and dependencies.
   */
  partsForRuleset: Array<GqlCatalogPart>;
  /**
   * Get a FHIR Patient by ID (proxies to Medplum GraphQL API)
   * Accepts either raw FHIR ID or federated ID (tenant:fhir_id)
   *
   * Uses Valkey caching for performance (5-minute TTL).
   */
  patient?: Maybe<FhirPatient>;
  /** List FHIR Patients with pagination (proxies to Medplum GraphQL API) */
  patients: PatientConnection;
  /**
   * Get a specific pattern template by ID.
   *
   * Returns the full template with field specs, sections, and validations.
   */
  patternTemplate: PatternTemplate;
  /**
   * List all available pattern templates with metadata.
   *
   * Returns the 12 interaction patterns (Simple CRUD, Hierarchical,
   * Master-Detail, Header-Lines, etc.) with descriptions and examples.
   */
  patternTemplates: Array<PatternMetadata>;
  /** Get a PDF template by ID */
  pdfTemplate?: Maybe<PdfTemplate>;
  /** List PDF templates, optionally filtered by subgraph */
  pdfTemplates: Array<PdfTemplate>;
  /** List architect proposals pending admin review (DRR-227) */
  pendingArchitectProposals: Array<ArchitectProposal>;
  /** List pending jobs (for admin monitoring) */
  pendingDocumentJobs: GqlJobConnection;
  /**
   * List all pending config proposals awaiting architect review.
   *
   * Scans the `proposals/` directories on the filesystem for YAML files
   * that have been generated but not yet approved or rejected.
   *
   * DRR-172: Proposals are generated by `generateConfigProposals` and saved
   * to the filesystem. This query loads them for display in the Proposal
   * Review page without requiring a ruleset search first.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * pendingProposals {
   * totalCount
   * ruleCount
   * proposals {
   * proposalId
   * configType
   * displayName
   * description
   * safetyLevel
   * statuteRef
   * edges { edgeType target }
   * provisions { section text significance }
   * states { name stateType displayName }
   * transitions { fromState toState event }
   * }
   * }
   * }
   * ```
   */
  pendingProposals: PendingProposalsSummary;
  /** Orders pending quality check (quality_check state) */
  pendingQc: Array<FoodServiceOrder>;
  /**
   * List pending rulesets — legislation that has been announced but is not yet effective (DRR-144).
   *
   * Returns rulesets with `status: pending | announced` ordered by `effective_date` ascending.
   * Used by the legislative intelligence dashboard and pre-compliance readiness workflows.
   *
   * Optionally filter by jurisdiction and/or industry.
   */
  pendingRulesets: Array<RuleSet>;
  /**
   * Get all pending witness requests for the current tenant.
   *
   * Requires Tier 2+ authentication.
   * Returns requests ordered by expiration time (soonest first).
   */
  pendingWitnessRequests: Array<WitnessRequestGql>;
  /**
   * Get attestation status
   *
   * Requires: pii:read scope
   */
  piiAttestation?: Maybe<PiiAttestationStatus>;
  /** Compare current and proposed versions of a plan. */
  planVersionComparison: PlanComparison;
  /**
   * Get a policy by ID (direct query)
   *
   * Fetches from PolicyRepository.
   * Falls back to stub if repository unavailable or entity not found.
   */
  policy: FerpPolicy;
  /** Get refill history for a prescription */
  prescriptionRefillHistory: Array<FhirMedicationDispense>;
  /** Preview how a rule would be routed without actually importing */
  previewRuleRouting: GqlRuleImportResult;
  /**
   * Preview what would be imported from a schema
   *
   * Shows expected fields without actually creating template.
   */
  previewSchemaImport: Scalars['JSON']['output'];
  /** Get a specific primitive by name */
  primitive?: Maybe<PrimitiveMetadata>;
  /**
   * Get the provenance (origin) of a primitive.
   * Returns which config created this primitive and why.
   */
  primitiveProvenance?: Maybe<ProvenanceContext>;
  /**
   * Explore relationships for any primitive instance.
   *
   * Returns 1-hop connected nodes grouped by relationship type.
   * Double-click any node in the visualization to re-center on it.
   */
  primitiveRelationships: RelationshipExplorerResult;
  /** Get the prior version of a plan (if exists). */
  priorPlanVersion?: Maybe<PlanVersion>;
  /**
   * Get a FHIR Procedure by ID (proxies to Medplum GraphQL API)
   * Accepts either raw FHIR ID or federated ID (tenant:fhir_id)
   *
   * Uses Valkey caching for performance (5-minute TTL).
   */
  procedure?: Maybe<FhirProcedure>;
  /** List FHIR Procedures with optional patient filter (proxies to Medplum GraphQL API) */
  procedures: ProcedureConnection;
  /**
   * List all product definitions from the DDB-seeded catalog.
   *
   * DRR-095: Products are config type #16 (`CFG#PRODUCT#{id}`), seeded
   * from `common/configs/seed/products/*.yaml` by `ferp-seed`.
   *
   * Supports optional filtering by industry and/or jurisdiction.
   * Results are sorted alphabetically by product_id.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * productCatalog(industry: "assisted_living", jurisdiction: "MN") {
   * productId
   * name
   * requiredRulesets
   * activatesWorkflows
   * }
   * }
   * ```
   */
  productCatalog: Array<GqlProductDefinition>;
  /**
   * Get a single product definition by ID from the DDB-seeded catalog.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * productCatalogEntry(productId: "prod-1-001") {
   * productId
   * name
   * requiredRulesets
   * activatesWorkflows
   * }
   * }
   * ```
   */
  productCatalogEntry?: Maybe<GqlProductDefinition>;
  /**
   * Get a product definition by ID.
   *
   * DRR-095: Products are Layer 2 config sets.
   * DRR-096: Products reference temporally-valid RuleSets.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * productDefinition(productId: "prod-1-001") {
   * productId
   * name
   * industry
   * jurisdiction
   * requiredRulesets
   * activatesWorkflows
   * activatesOverrides
   * }
   * }
   * ```
   */
  productDefinition?: Maybe<GqlProductDefinition>;
  /**
   * List all product definitions, optionally filtered by industry and/or jurisdiction.
   *
   * DRR-095: Returns all Layer 2 product config sets.
   * Supports multi-service tenants (ALF + HC + PT/OT under one company).
   *
   * ## Example
   *
   * ```graphql
   * query {
   * productDefinitions(industry: "assisted_living", jurisdiction: "MN") {
   * productId
   * name
   * requiredRulesets
   * }
   * }
   * ```
   */
  productDefinitions: Array<GqlProductDefinition>;
  /** Get all available program variants (MN DHS programs) */
  programVariants: Array<ProgramConfig>;
  /**
   * Get provenance graph for visualization.
   * Returns nodes and edges suitable for Cytoscape rendering.
   */
  provenanceGraph: ProvenanceGraph;
  /**
   * Get public website manifest for a tenant (DRR-107)
   *
   * Returns only the public-safe fields needed for website generation.
   * Consumed by export-public-tenant-manifest.py --from-graphql.
   */
  publicWebsiteManifest?: Maybe<PublicWebsiteManifest>;
  /** Publish approved template (move from draft to published) */
  publishTemplate: WorkflowTemplateMetadata;
  /** Query audit events for ID operations */
  queryIdAudit: GqlAuditQueryResult;
  /** Query rules by tags (for pattern discovery) */
  queryOrchestrationRules: Array<OrchestrationRule>;
  /**
   * Get current user's role for a tenant
   *
   * Returns: RoleDefinition with computed permissions
   */
  rbacCurrentUserRole: UserRoleResponse;
  /**
   * Get effective role (with inherited scopes/capabilities)
   *
   * Authorization: Requires metadata:read or tenant:admin scope (DRR-102)
   */
  rbacGetEffectiveRole?: Maybe<EffectiveRole>;
  /** Get role by ID with computed permissions */
  rbacGetRole?: Maybe<RoleDefinition>;
  /** Get user role assignments (Admin only) */
  rbacGetUserRoles: Array<UserRoleAssignment>;
  /** List all roles for a tenant */
  rbacListRoles: Array<RoleDefinition>;
  /**
   * Get user's effective permissions (including inherited)
   *
   * Returns: Array of permission strings
   * Authorization: Requires metadata:read or tenant:admin scope (DRR-102)
   */
  rbacUserPermissions: UserPermissionsResponse;
  /**
   * Read masked PII value
   *
   * Returns masked value (e.g., ***-**-1234 for SSN).
   * Requires: pii:read scope and MFA (Tier 2)
   */
  readMaskedPii: ReadMaskedPiiResult;
  /** Orders ready for driver pickup (ready_for_pickup state) */
  readyForPickup: Array<FoodServiceOrder>;
  /**
   * Get workflows that are ready to execute
   *
   * Returns workflows whose dependencies are satisfied based on
   * the list of completed workflows.
   */
  readyWorkflows: Array<SubWorkflowConfig>;
  /** Recommend standards packs for workflow (AI-powered) */
  recommendStandardsPacks: RecommendationResult;
  /**
   * Get best practice recommendations for a tenant (all 3 intelligence layers).
   *
   * DRR-156: Industry-agnostic. Recommendations come from the tenant's
   * activated Product's `recommended_rulesets` field. The Product YAML
   * determines WHAT is recommended — this resolver just computes the gap.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * recommendations(tenantNum: 2) {
   * totalCount
   * pendingCount
   * recommendations {
   * practiceRef
   * title
   * sourceAssociation
   * intelligenceLayer
   * adoptionStatus
   * improves
   * mitigates
   * }
   * }
   * }
   * ```
   */
  recommendations: RecommendationSummary;
  /**
   * Get recommended retry count based on current participant count
   *
   * # Arguments
   * * `emergency_id` - Unique emergency identifier
   *
   * # Returns
   * Recommended retry count based on scale (3, 7, 10, or 15)
   */
  recommendedRetryCount: Scalars['Int']['output'];
  /** Record approval decision (approve/reject/request revision) */
  recordApprovalDecision: ApprovalWorkflowInstance;
  /** Record policy evaluation event (for analytics tracking) */
  recordPolicyEvaluation: Scalars['Boolean']['output'];
  /**
   * Get an overview of the config type registry (DRR-111).
   *
   * Returns stats and patterns for the entire registry.
   */
  registryOverview: RegistryOverview;
  /**
   * DRR-172: Regulatory coverage gap detection — reverse edge scan.
   *
   * For a given ruleset, walks all `member_rules` and checks whether
   * each rule has at least one downstream config (task group or workflow)
   * with a `MANDATED_BY` edge pointing to it. Rules with no reverse edge
   * are coverage gaps — the regulation mandates something but no config
   * operationalizes it.
   *
   * Domain-agnostic: works for any ruleset in any industry. The query
   * returns gap data, NOT industry-specific remediation advice.
   *
   * Requires `compliance:read` or `admin` scope.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * regulatoryCoverageGaps(rulesetId: "rs-4-1-004") {
   * rulesetId
   * totalRules
   * coveredRules
   * uncoveredRules
   * coveragePercent
   * gaps {
   * ruleId
   * ruleName
   * sectionRef
   * description
   * downstreamConfigCount
   * }
   * }
   * }
   * ```
   */
  regulatoryCoverageGaps: CoverageGapReport;
  /**
   * Coverage overview for ALL rulesets — shows gap status at a glance.
   *
   * Returns each ruleset's coverage percentage without the full gap details.
   * Use `regulatoryCoverageGaps(rulesetId)` for detailed gaps on a specific ruleset.
   *
   * DRR-172: Enables a coverage dashboard that doesn't require knowing ruleset IDs.
   */
  regulatoryCoverageOverview: Array<RulesetCoverageSummary>;
  /** Get statistics about review queues */
  regulatoryQueueStats: GqlQueueStats;
  /**
   * Compute regulatory readiness score for a tenant
   *
   * Fetches all approved rules, checks which have linked evidence documents,
   * and returns a readiness percentage with gap analysis.
   */
  regulatoryReadinessScore: GqlReadinessScore;
  /** Get a single regulatory rule by ID */
  regulatoryRule?: Maybe<GqlRegulatoryRule>;
  /** List regulatory rules with optional filters */
  regulatoryRules: Array<GqlRegulatoryRule>;
  /**
   * Request a presigned S3 URL for a ceremony document using a signing token
   * (unauthenticated — no FERP account required).
   *
   * Used by `PublicSigningPage` to load the PDF inline before signing.
   * Falls back to the original document key if no signed version exists yet.
   */
  requestDocumentUrlViaToken: CeremonyDocumentUrl;
  /** Request emergency break-glass access (HIPAA §164.312(a)(2)(ii)) */
  requestEmergencyAccess: EmergencyAccessToken;
  /**
   * Get a presigned download URL for a ceremony's evidence certificate (C3).
   *
   * Returns a time-limited S3 presigned GET URL (60 minutes) for the
   * evidence certificate PDF. Only available after the ceremony has completed
   * and the certificate has been generated.
   */
  requestEvidenceCertificateUrl: CeremonyDocumentUrl;
  /**
   * Resolve the effective version of a RuleSet at a given date (DRR-096).
   *
   * Walks the supersedes/superseded_by version chain and returns the
   * version that is effective at `asOfDate` (defaults to today).
   *
   * During transition periods where multiple versions are simultaneously
   * effective, returns the newest applicable version (latest effective_date).
   *
   * ## Example
   *
   * ```graphql
   * query {
   * resolveEffectiveRuleSet(rulesetId: "rs-4-1-001", asOfDate: "2025-07-01") {
   * rulesetId
   * version
   * effectiveDate
   * sunsetDate
   * isCurrent
   * }
   * }
   * ```
   */
  resolveEffectiveRuleSet?: Maybe<RuleSet>;
  /**
   * DRR-103 Phase 3: Evaluate the 4-phase lens chain for an actor.
   *
   * Phases:
   * 1. Role: Actor's role scopes determine entity access
   * 2. Scope: DAG position narrows to assigned entities
   * DRR-103: Resolve scopes for a list of role IDs from YAML configs.
   *
   * Returns the merged, deduplicated scopes for the given role IDs.
   * Used by DevImpersonationPanel to fetch scopes from the backend
   * instead of maintaining a hardcoded DEV_ROLE_SCOPES map.
   *
   * In production, this same resolution happens in auth middleware
   * from JWT `ferp_roles` claim → RoleScopeMap → YAML lookup.
   *
   * No scope guard required — this returns the YAML-defined scopes,
   * not the caller's own scopes. YAML configs are not secret.
   * DRR-196: Guard removed — DevImpersonationPanel needs this to switch users.
   */
  resolveRoleScopes: Array<Scalars['String']['output']>;
  /**
   * Resolve a signing token to ceremony + participant context.
   *
   * Used by the public `/sign/{token}` page — no authentication required.
   * The token itself serves as proof of invitation.
   */
  resolveSigningToken?: Maybe<SigningTokenPayload>;
  /**
   * Resolved terminology for the current tenant.
   *
   * Returns a flat list of concept → display term mappings derived from
   * statutory definitions activated via the tenant's product/ruleset chain.
   * Tenant overrides (validated via Zen Engine) are applied on top.
   *
   * This is the SINGLE SOURCE OF TRUTH for all UI terminology.
   * Replaces: fhirLabels, scopeLabels, tenant branding terminology.
   *
   * NOTE: No RequireScope guard - returns empty for unauthenticated users.
   * This allows the frontend to load without 401 errors before login.
   */
  resolvedTerminology: Array<ResolvedTerm>;
  /** Get plans awaiting review by the specified reviewer role. */
  reviewerPlanQueue: Array<PlanQueueItem>;
  /** Revoke active emergency access */
  revokeEmergencyAccess: RevokeEmergencyAccessResult;
  /** Rollback policy to previous version */
  rollbackPolicy: PolicyRollbackResult;
  /** Rollback template to previous version */
  rollbackTemplate: TemplateRollbackResult;
  /** Get a single ruleset by ID. */
  ruleSet?: Maybe<RuleSet>;
  /**
   * Get the full version chain for a RuleSet (DRR-096).
   *
   * Returns all versions of the given RuleSet, ordered by effective_date
   * (oldest first). Includes superseded, current, and future versions.
   * Useful for legislation history views and audit trails.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * ruleSetVersionChain(rulesetId: "rs-4-1-001") {
   * rulesetId
   * version
   * effectiveDate
   * sunsetDate
   * supersedes
   * supersededBy
   * isCurrentlyEffective
   * }
   * }
   * ```
   */
  ruleSetVersionChain: Array<RuleSet>;
  /**
   * List all rulesets with optional filtering.
   *
   * By default, returns only currently-effective rulesets (DRR-096 temporal filtering).
   * Set `effectiveOnly` to false to return all rulesets regardless of dates.
   * Use `asOfDate` (YYYY-MM-DD) for point-in-time queries.
   */
  ruleSets: Array<RuleSet>;
  /**
   * Query rulesets by multi-dimensional intersection (DRR-096).
   *
   * Uses Valkey SINTER for efficient compound queries across dimension
   * indexes. Falls back to DynamoDB in-memory filtering if Valkey is
   * unavailable.
   *
   * After dimension resolution, applies temporal filtering:
   * `effective_date <= as_of_date < sunset_date`.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * ruleSetsByDimensions(
   * filter: { jurisdiction: "MN", industry: "assisted_living" }
   * effectiveOnly: true
   * asOfDate: "2025-07-01"
   * ) {
   * rulesetId
   * displayName
   * effectiveDate
   * isCurrentlyEffective
   * }
   * }
   * ```
   */
  ruleSetsByDimensions: Array<RuleSet>;
  /**
   * * Get executive safety metrics for CEO dashboard
   *      *
   *      * Calculates real-time safety scores from audit trail data.
   *      * All metrics are tenant-configured and domain-agnostic.
   *      *
   *      * Requires: `safety:read` scope (DRR-102)
   */
  safetyMetricsExecutiveSafetyMetrics: ExecutiveSafetyMetricsOutput;
  /** Get specific SAGA definition */
  sagaDefinition?: Maybe<SagaDefinitionGql>;
  /** List SAGA definitions for tenant (data-driven from database) */
  sagaDefinitions: Array<SagaDefinitionGql>;
  /** Get SAGA execution status (life-critical repository access) */
  sagaExecutionStatus?: Maybe<SagaExecutionResponse>;
  /** List recent SAGA executions for tenant (repository-backed) */
  sagaExecutions: Array<SagaExecutionSummary>;
  /**
   * Get safety scores for SAGA execution (life-critical monitoring)
   *
   * **FERP Pattern**: Data-driven safety assessment
   * - Tenant configuration determines which domains are assessed
   * - Safety scores calculated from audit trail and execution metadata
   * - Violations detected based on tenant-specific safety rules
   */
  sagaSafetyScores?: Maybe<SagaSafetyScores>;
  /**
   * Get scope assignments for an actor (for correlation/filtering only, never display IDs).
   *
   * Returns AssignedTo and Correlates edges for the given actor as opaque string IDs.
   * DRR-102: Fail closed — no assignments = empty result (not "show all").
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  scopeAssignments: ScopeAssignments;
  /**
   * Verify the integrity of the tenant's scope mutation hash chain.
   *
   * Requires `scope:admin` scope.
   */
  scopeChainVerification: ScopeChainVerification;
  /**
   * List edges filtered by type.
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  scopeEdges: Array<ScopeEdge>;
  /**
   * Get the full scope graph for the current tenant.
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  scopeGraph: ScopeGraph;
  /** DRR-312 Debug: Public scope map initialization status (no auth required) */
  scopeMapStatus: Scalars['String']['output'];
  /**
   * Get scope mutations (audit trail) for the current tenant.
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  scopeMutations: Array<ScopeMutationEvent>;
  /**
   * Get the scope path from root to a specific actor.
   *
   * Requires `scope:read` or `scope:admin` scope.
   */
  scopePath: ScopePath;
  /**
   * Search actors by name within tenant.
   *
   * DRR-061: Case-insensitive substring match on name, instance_name, role.
   * Requires: `actor:read` scope
   */
  searchActors: Array<Actor>;
  /**
   * Get search analytics for admin dashboard.
   *
   * Returns aggregated search metrics for the specified date range.
   */
  searchAnalytics: SearchAnalytics;
  /**
   * Search for codes by text query
   *
   * Requires Medplum connection (FHIR_BASE/FHIR_TOKEN env vars).
   */
  searchCodes: CodeSearchResult;
  /**
   * Search entities across all enabled subgraphs for the tenant.
   *
   * Returns up to 25 results sorted by relevance (exact > prefix > contains).
   * Respects tenant isolation via JWT claims.
   */
  searchEntities: SearchEntitiesResult;
  /** Send a message in an intake conversation and get an AI response. */
  sendIntakeMessage: IntakeConversationMessage;
  /** Get a service plan by ID. */
  servicePlan?: Maybe<ServicePlan>;
  /** List service plans for a subject. */
  servicePlansBySubject: Array<ServicePlan>;
  /**
   * Get conflicts for a specific sync session.
   *
   * Requires: `sync:read` scope
   */
  sessionConflicts: Array<SyncConflict>;
  /**
   * DRR-103 Phase 3: Get the setting bundle for the current tenant.
   *
   * Used by ScopeBreadcrumbNavigator for scope depth labels and user menu items.
   */
  settingBundle: SettingBundle;
  /** Get a shift/schedule by ID. */
  shiftSchedule?: Maybe<ShiftSchedule>;
  /** List shift schedules for a date range. */
  shiftSchedules: Array<ShiftSchedule>;
  /** Get work items for a shift/schedule period. */
  shiftWorkItems: Array<ShiftWorkItem>;
  /** Get work items for a subject within a schedule. */
  shiftWorkItemsBySubject: Array<ShiftWorkItem>;
  /**
   * Simulate the impact of implementing a recommendation
   * LIFE-CRITICAL: Dry-run simulation before actual implementation
   * Uses historical workflow data and isolated sandbox environment
   */
  simulateRecommendationImpact: SimulationResultGql;
  /** Get available transitions from the current simulated state. */
  simulationAvailableTransitions: Array<SimAvailableTransition>;
  /** Get the full simulation session history. */
  simulationHistory: Array<SimulatedTransition>;
  /** Get a single source coordinate map by ID */
  sourceMap?: Maybe<GqlSourceCoordinateMap>;
  /** Get aggregate statistics across all source maps for a tenant */
  sourceMapStats: GqlSourceMapStats;
  /** List source maps with optional filters */
  sourceMaps: Array<GqlSourceCoordinateMap>;
  /** Orders assigned to a specific station (in_prep state) */
  stationOrders: Array<FoodServiceOrder>;
  /**
   * Look up a single statutory definition by its tag ID.
   *
   * Accepts both short form ("144g-ulp") and full form ("tag:def:144g-ulp").
   */
  statutoryDefinition?: Maybe<StatutoryDefinition>;
  /**
   * All statutory definitions in the registry.
   *
   * Returns the full definition detail including constraints, statutory scope,
   * and edges to other definitions. Used by compliance dashboards and admin views.
   */
  statutoryDefinitions: Array<StatutoryDefinition>;
  /**
   * Impact analysis: find all definitions affected by a statute section change.
   *
   * Given a statute section (e.g., "144G.71"), returns all definitions that:
   * 1. Are defined by that section (source.statute matches)
   * 2. Have edges referencing that section (edge.statute_ref matches)
   *
   * This powers the "what changes if the legislature amends this?" query.
   */
  statutoryImpactAnalysis: StatutoryImpactReport;
  /**
   * Query subgraph correlation over archived data
   *
   * Finds relationships and temporal patterns between events
   * in different subgraphs (e.g., payroll processing → ACH transmission).
   */
  subgraphCorrelation: SubgraphCorrelationResult;
  /** Get all subgraphs and their entity types */
  subgraphEntities: Array<SubgraphEntitiesResult>;
  /** Get entity types for a specific subgraph */
  subgraphEntityTypes: Array<EntityTypeMetadata>;
  /** Check if a subgraph has a specific feature */
  subgraphHasFeature: Scalars['Boolean']['output'];
  /** Submit template for approval workflow */
  submitTemplateForApproval: ApprovalWorkflowInstance;
  /**
   * Suggest a workflow composition for a given ruleset.
   *
   * Traverses edges from the ruleset to find all mandated task groups,
   * orders them by category (intake → assessment → financial → agreement),
   * and returns a composition suggestion.
   *
   * Deterministic — no LLM needed. The LLM composeWorkflow mutation
   * (agent_api) is for complex/custom compositions from natural language.
   */
  suggestComposition: GqlCompositionSuggestion;
  /** List all supported code systems */
  supportedCodeSystems: Array<CodeSystemInfo>;
  /**
   * Get unresolved sync conflicts.
   *
   * Returns all conflicts pending human review for the current tenant.
   * Med dosage conflicts are always included (NEVER auto-resolved).
   *
   * Requires: `sync:read` scope
   */
  syncConflicts: Array<SyncConflict>;
  /**
   * List sync sessions for the current tenant.
   *
   * Optionally filter by device ID. Returns most recent sessions first.
   *
   * Requires: `sync:read` scope
   */
  syncHistory: Array<SyncSession>;
  /**
   * Get a sync session by ID.
   *
   * Returns session metadata including status, entry counts, and archive key.
   *
   * Requires: `sync:read` scope (DRR-102)
   */
  syncSession?: Maybe<SyncSession>;
  /** Get system tenant by ID (admin only) */
  systemTenant?: Maybe<SystemTenant>;
  /** Get system tenant by domain (for subdomain routing) */
  systemTenantByDomain?: Maybe<SystemTenant>;
  /** List tenants by industry (admin only) */
  systemTenantsByIndustry: Array<SystemTenant>;
  /**
   * Get system user by ID (admin only)
   * Requires: `system:admin` scope (DRR-102)
   */
  systemUser?: Maybe<SystemUser>;
  /** Get system user by email (admin only) */
  systemUserByEmail?: Maybe<SystemUser>;
  /** List users by tenant (admin only) */
  systemUsersByTenant: Array<SystemUser>;
  /**
   * Get overdue tasks (active tasks past their scheduled_end).
   *
   * Requires: `task:read` scope
   *
   * Queries active tasks and filters by scheduled_end < now.
   */
  taskApiGetOverdueTasks: Array<Task>;
  /**
   * Get task by workflow instance and task ID.
   *
   * Requires: `task:read` scope
   *
   * Note: Task retrieval requires workflow_instance_id due to DynamoDB key design.
   * Use get_tasks_by_workflow_instance to find tasks for a workflow.
   */
  taskApiGetTask?: Maybe<Task>;
  /**
   * Get task by ID only (life-safety: single-ID lookup for detail pages).
   *
   * DRR-SAFETY: Enables direct task navigation without knowing workflowInstanceId.
   * Uses Valkey `state:{tenant}:{task_id}` cache (7-day TTL, written by task spawner).
   *
   * Requires: `task:read` scope
   */
  taskApiGetTaskById?: Maybe<Task>;
  /**
   * Get complete state transition history for task (pure append-only).
   *
   * Requires: `task:read` scope
   *
   * Returns all versions of a task by following parent_id chain.
   * Versions are sorted by version number (ascending).
   *
   * # Performance
   * - Query time: 5-20ms for typical tasks (5-10 state transitions)
   * - Includes complete reassignment history
   * - 10-50x FASTER than CloudWatch Logs Insights (100-500ms)
   */
  taskApiGetTaskHistory: Array<Task>;
  /**
   * Get task statistics for a tenant.
   *
   * Requires: `task:read` scope
   */
  taskApiGetTaskStatistics: GqlTaskStatistics;
  /**
   * Get tasks assigned to a specific actor.
   *
   * Requires: `task:read` scope
   */
  taskApiGetTasksByActor: Array<Task>;
  /**
   * Get tasks by status.
   *
   * Requires: `task:read` scope
   */
  taskApiGetTasksByStatus: Array<Task>;
  /**
   * Get tasks by subject actor (e.g., all tasks for a resident/patient).
   *
   * Uses Valkey subject index for O(1) lookup — no full-scan.
   * Requires: `task:read` scope
   */
  taskApiGetTasksBySubject: Array<Task>;
  /**
   * Get tasks by task type (task_group_ref).
   *
   * Uses Valkey task_type index for O(1) lookup — no full-scan.
   * Requires: `task:read` scope
   */
  taskApiGetTasksByTaskType: Array<Task>;
  /**
   * Get all tasks for a workflow instance.
   *
   * Requires: `task:read` scope
   */
  taskApiGetTasksByWorkflowInstance: Array<Task>;
  /**
   * Get training tasks assigned to a specific employee.
   *
   * Filters by task_group_ref prefixes: tg-0-2-*, tg-4-9-*, tg-4-13-*, tg-5-4-*.
   * Uses the existing list_by_actor index for O(1) lookup, then filters to training groups.
   *
   * Requires: `training:manage` scope (supervisors can view any employee's training)
   */
  taskApiGetTrainingTasksByEmployee: Array<Task>;
  /**
   * List system health check tasks for oversight dashboard.
   *
   * DRR-298: System tasks (task_type: system) are automated health checks that
   * run nightly. This resolver provides visibility for ALD/DON to monitor system
   * health without polluting the main task list.
   *
   * Requires: `system:read` or `system:admin` scope (ALD/DON/CEO only)
   */
  taskApiListSystemTasks: GqlTaskConnection;
  /**
   * List active tasks for a tenant.
   *
   * Requires: `task:read` scope
   *
   * DRR-102: Backend-driven authorization enforcement.
   * - `task:admin` scope → returns ALL active tasks (for ALD/DON/admin roles)
   * - `task:read` scope only → returns tasks assigned to the current actor
   * via Valkey O(1) index: `idx:{tenant}:actor:{actor_id}`
   *
   * This prevents data leakage where a CNA could see tasks assigned to
   * RNs, DONs, and other roles via the "All Tasks" tab.
   */
  taskApiListTasks: GqlTaskConnection;
  /**
   * List training tasks (tasks with training-related task_group_ref).
   *
   * Uses Valkey SUNION across all training task group indexes for O(N) lookup.
   * Training task groups: tg-4-13-1 through tg-4-13-48 (competency modules).
   *
   * Falls back to DDB scan + filter if Valkey cold or empty.
   *
   * Requires: `training:manage` scope
   */
  taskApiListTrainingTasks: GqlTaskConnection;
  /**
   * Get enrichment context for a task's subject (medication, allergy, DEA schedule data).
   *
   * DRR-149: Loads pre-computed enrichment from Valkey for the task's subject
   * actor. Used by the frontend to pre-populate medication administration forms
   * with drug name, dosage, allergy alerts, and drug interaction warnings.
   *
   * LIFE-CRITICAL: A Med Aide administering medications without seeing allergy
   * alerts or drug interactions is a patient safety gap.
   *
   * Returns JSON object with enrichment fields:
   * - interaction_severity, allergy_match_found, allergen_name (DRR-149 Phase 1)
   * - has_schedule_ii_medication, controlled_substance_list (DEA classification)
   * - assist_level_*, aoss_score (CarePlan enrichment)
   *
   * Returns null if no enrichment data exists (safe — forms still render without pre-fill).
   */
  taskApiTaskEnrichmentContext?: Maybe<Scalars['JSON']['output']>;
  /** Get completion hints for a specific task */
  taskCompletionHints: TaskCompletionHintsResult;
  /**
   * Get a single task group by its ID, optionally scoped to a subgraph/setting.
   *
   * Requires `task:read` scope.
   */
  taskGroup?: Maybe<TaskGroup>;
  /**
   * Get category summaries with group counts, optionally filtered by subgraph/setting.
   *
   * Requires `task:read` scope.
   */
  taskGroupCategories: Array<TaskGroupCategoryInfo>;
  /**
   * List all task groups, optionally filtered by subgraph, setting, and/or category.
   *
   * Requires `task:read` scope.
   */
  taskGroups: Array<TaskGroup>;
  /**
   * Get templates pending approval (for approvers)
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiGetPendingApprovalTemplates: Array<Template>;
  /**
   * Get a single template by ID
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiGetTemplate?: Maybe<Template>;
  /**
   * Get template versions by name
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiGetTemplateVersions: Array<Template>;
  /**
   * Get published templates by category
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiGetTemplatesByCategory: Array<Template>;
  /**
   * Get templates by target formula (v1.1 formula-aware query)
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiGetTemplatesByFormula: Array<Template>;
  /**
   * Get templates by status (Draft, PendingApproval, Published, Archived)
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiGetTemplatesByStatus: Array<Template>;
  /**
   * List templates with pagination
   *
   * Requires `template:read` or `template:admin` scope
   */
  templateApiListTemplates: GqlTemplateConnection;
  /** Template completion count (how many actors completed this?) */
  templateCompletionCount: Scalars['Int']['output'];
  /**
   * Get a tenant by ID (direct query)
   *
   * Fetches from TenantConfigRepository via BackendRouter.
   * Falls back to stub if repository unavailable or tenant not found.
   */
  tenant: Tenant;
  /**
   * Get tenant flow map data for visualization.
   *
   * Aggregates task flow data for Sankey, Chord, and Temporal views.
   * Requires `analytics:view` scope.
   *
   * **Phase 2**: Queries actual Actor and Task primitives from DynamoDB.
   */
  tenantFlowMap: TenantFlowMap;
  /**
   * Get tenant metadata for specific domain
   * Requires: `metadata:read` scope (DRR-102)
   */
  tenantMetadata?: Maybe<TenantMetadataGql>;
  /**
   * Get a specific tenant product activation record.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * tenantProduct(tenantNum: 2, productId: "prod-1-001") {
   * productId
   * provisioningStatus
   * activatedAt
   * }
   * }
   * ```
   */
  tenantProduct?: Maybe<TenantProduct>;
  /**
   * List all products activated for a specific tenant.
   *
   * DRR-095: Returns tenant-scoped activation records at
   * `PK=~{tenant_num}, SK=PRODUCT#{product_id}`.
   *
   * ## Example
   *
   * ```graphql
   * query {
   * tenantProducts(tenantNum: 2) {
   * productId
   * productName
   * provisioningStatus
   * activatedAt
   * activatedBy
   * rulesetCount
   * workflowCount
   * }
   * }
   * ```
   */
  tenantProducts: Array<TenantProduct>;
  /**
   * List all tenants (admin only)
   *
   * Note: This is a privileged operation. In production, add proper authorization.
   */
  tenants: Array<Tenant>;
  /**
   * DRR-281 Phase 4: Get terminology settings showing all three layers.
   * Returns all statutory definitions with industry terms and tenant overrides.
   */
  terminologySettings: Array<TerminologySettingsEntry>;
  timeline: Array<TransitionEventGql>;
  /**
   * Get the most commonly cited deficiencies across audit forms.
   *
   * # Arguments
   * * `regulatory_body` - Optional filter by regulatory body
   * * `limit` - Maximum number of results (default: 10)
   */
  topDeficiencies: Array<CitedCheckpoint>;
  /** Combined transcript for an entity: code usage and receipts, newest first */
  transcript: Array<TranscriptEntry>;
  /**
   * Translate a code from one system to another
   *
   * Uses FHIR ConceptMap resources for mapping.
   * Requires Medplum connection (FHIR_BASE/FHIR_TOKEN env vars).
   */
  translateCode: Array<CodeMapping>;
  /**
   * Translate FERP term to industry-specific term
   *
   * Returns translated term using tenant's terminology mapping
   */
  translateTerm: TranslationResult;
  /**
   * Manually trigger a reminder check for a tenant (ops/admin use only).
   *
   * Runs one cycle of the C4 reminder worker for the given tenant.
   * Returns the number of reminders queued (0 until reminded_at tracking is wired to DDB).
   */
  triggerCeremonyReminders: Scalars['Int']['output'];
  /**
   * Get form schema for an entity in a specific context
   *
   * Resolves with fallback priority:
   * 1. Exact match (mode + role + safety)
   * 2. Role wildcard
   * 3. Safety wildcard
   * 4. Default schema
   */
  uiSchema?: Maybe<UiFormSchema>;
  /** Get UI schema version info for frontend compatibility negotiation */
  uiSchemaVersion: UischemaVersionInfo;
  /** Update an existing entity */
  updateEntity: GenericEntity;
  /**
   * Update template metadata (creates new version)
   * Requires: `metadata:write` scope (DRR-102)
   */
  updateTemplateMetadata: TemplateMetadataOutput;
  /**
   * Create or update tenant metadata
   * Requires: `metadata:write` scope (DRR-102)
   */
  updateTenantMetadata: TenantMetadataGql;
  /** Upload chaos document */
  uploadChaosDocument: ChaosDocument;
  upsertAudience: Scalars['Boolean']['output'];
  /**
   * Returns the current user's computed capabilities based on their
   * scopes, role, and tenant entitlements.
   *
   * **DRR-102**: This is the canonical endpoint for frontend authorization.
   * The frontend MUST call this query and gate UI elements on the returned
   * booleans. Local scope/role checks in frontend code are BLOCKED.
   *
   * No scope guard on this resolver — every authenticated user can query
   * their own capabilities. The auth middleware ensures authentication.
   */
  userCapabilities: UserCapabilities;
  /** Get all reviews assigned to the current USRN session. */
  usrnAssignedReviews: Array<TokenizedCarePlanReview>;
  /**
   * Get a tokenized care plan review by magic link session.
   * This is the main entry point for external USRN reviewers.
   *
   * Security: No RequireScope — authenticated via magic link token in header.
   */
  usrnReview: TokenizedCarePlanReview;
  /** Check session validity (for frontend to verify before showing UI). */
  usrnSessionValid: Scalars['Boolean']['output'];
  /**
   * Validate audit against all federated subgraphs (Medplum FHIR, PAYROLL, OFBiz)
   * Requires: `audit:read` scope (DRR-102)
   */
  validateAuditSubgraphs: Array<SubgraphValidationResultQl>;
  /**
   * Validate a medical code (may query Medplum for authoritative validation)
   *
   * First validates format locally, then optionally queries Medplum
   * if configured (FHIR_BASE/FHIR_TOKEN env vars).
   */
  validateCode: CodeValidationResult;
  /**
   * Validate a medical code format (fast, local validation)
   *
   * Checks if the code matches the expected format for the code system.
   * Does NOT check if the code exists in the code system.
   */
  validateCodeFormat: CodeValidationResult;
  /** Validate data against validation rule (dry-run execution). */
  validateData: Scalars['Boolean']['output'];
  /**
   * DRR-207: Validate mandatory resources for product activation.
   *
   * Returns validation result showing which mandatory FHIR resources
   * are configured for a primary ruleset. Used as a gate for activateProduct.
   *
   * # Arguments
   * * `primary_ruleset` - Ruleset ID (e.g., "rs-4-1-004" for MN 144G ALF)
   * * `subgraph` - Subgraph to validate (default: "fhir")
   */
  validateMandatoryResources: MandatoryResourceValidation;
  /** Validate metadata composition for workflow */
  validateMetadata: ValidationResultGql;
  /**
   * Validate permission (test if role has permission).
   *
   * Requires scope: role:read or role:admin
   */
  validatePermission: PermissionValidationResult;
  /** Validate policy rules without creating policy. */
  validatePolicyRules: Scalars['Boolean']['output'];
  /**
   * Validate subgraph reference with full licensing checks
   *
   * LIFE-CRITICAL: This validates licensing, expiration, and feature access.
   */
  validateSubgraphLicensing: SubgraphReferenceValidation;
  /**
   * Validate a subgraph reference against tenant's registry
   *
   * LIFE-CRITICAL: This checks if tenant is allowed to use a subgraph.
   * Bakery trying to use Medplum will fail this validation.
   */
  validateSubgraphReference: SubgraphReferenceValidation;
  /** Validate template import data */
  validateTemplateImport: TemplateValidationResult;
  /**
   * Validate template metadata using domain-agnostic 6-layer validation framework
   *
   * This replaces the simple validation with comprehensive multi-layer validation.
   */
  validateTemplateMetadata: ValidationExecutionResult;
  /**
   * DEPRECATED: Simple validation - Use validateTemplateMetadata from TemplateMetadataQuery instead
   *
   * This method performs basic validation (25 primitives, field mappings).
   * The new 6-layer validation framework in TemplateMetadataQuery provides comprehensive validation.
   * @deprecated Use validateTemplateMetadata query instead
   */
  validateTemplateMetadataSimple: WorkflowTemplateValidationResult;
  /** Validate a workflow's state machine structure. */
  validateWorkflow: WorkflowValidationResult;
  /** Build a deep-link to the vendor UI based on INTEG base_url and a relative path */
  vendorDeeplink?: Maybe<Scalars['String']['output']>;
  /** Get recent verification results. */
  verificationHistory: Array<VerificationResult>;
  /**
   * Verify all cryptographic signatures in the signed PDF for a ceremony (D5).
   *
   * Reads ceremony participant state and returns a verification result per signer.
   * `is_valid` is set optimistically from `signed_at` presence; for full cryptographic
   * verification, use the ferp_pdf PKI pipeline (see TODO below).
   * Requires document:read scope.
   */
  verifyCeremonySignatures: CeremonySignatureVerification;
  /**
   * Preview what workflows would apply for given tenant metadata
   *
   * This is a read-only operation with no side effects.
   * Use this in the tenant setup wizard to show the user
   * what workflows they'll need to complete.
   */
  wfCompositionPreviewComposition: CompositionPreviewResult;
  /** Get a specific widget by name */
  widget?: Maybe<WidgetDefinition>;
  /** Get widgets filtered by category */
  widgetsByCategory: Array<WidgetDefinition>;
  /** Get widgets available for a specific subgraph */
  widgetsForSubgraph: Array<WidgetDefinition>;
  /**
   * Get a witness request by ID.
   *
   * Requires Tier 2+ authentication.
   */
  witnessRequest?: Maybe<WitnessRequestGql>;
  /**
   * Get a specific workflow definition with all nodes and edges
   *
   * The definition is resolved with inheritance based on the context
   * (state, industry, program, certification).
   */
  workflowDefinition: WorkflowDefinition;
  /**
   * Get fully composed metadata for a workflow with runtime context
   * Requires: `metadata:read` scope (DRR-102)
   */
  workflowMetadata: ComposedMetadataGql;
  /**
   * Get the workflow registry for a tenant
   *
   * Returns list of available workflows, their dependencies, and program configuration.
   */
  workflowRegistry: WorkflowRegistryResponse;
  /**
   * Get a single zone by ID.
   *
   * Requires: `beacon:read` scope (DRR-102)
   *
   * ## Example
   *
   * ```graphql
   * query {
   * zone(tenantNum: 2, zoneId: "2-zone-lobby") {
   * zoneId
   * name
   * capacity
   * activeBeaconCount
   * }
   * }
   * ```
   */
  zone?: Maybe<Zone>;
  /**
   * List all zones for a tenant, with optional type filtering.
   *
   * DRR-108: Zone architecture.
   * Requires: `beacon:read` scope (DRR-102)
   *
   * ## Example
   *
   * ```graphql
   * query {
   * zones(tenantNum: 2, zoneType: "MEDICAL") {
   * zoneId
   * name
   * zoneType
   * floor
   * safetyLevel
   * elopementRelevant
   * activeBeaconCount
   * }
   * }
   * ```
   */
  zones: Array<Zone>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAchFileArgs = {
  id: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAchFilesArgs = {
  effectiveDateEnd?: InputMaybe<Scalars['NaiveDate']['input']>;
  effectiveDateStart?: InputMaybe<Scalars['NaiveDate']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sourceType?: InputMaybe<GqlAchSourceType>;
  status?: InputMaybe<GqlAchFileStatus>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActiveCredentialsArgs = {
  templateRef: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActiveShiftPlanArgs = {
  floorId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorCompletionCountArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorCompletionsArgs = {
  actorId: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorGapsArgs = {
  actorId: Scalars['String']['input'];
  requiredTemplateRefs: Array<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorMgmtActorArgs = {
  id: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorMgmtGetActorPerformanceHistoryArgs = {
  actorId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorMgmtGetActorSnapshotArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorMgmtGetActorStatsArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryActorMgmtListActorsArgs = {
  actorType?: InputMaybe<ActorType>;
  status?: InputMaybe<ActorStatus>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirAdverseEventsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirAllergyIntolerancesArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirCarePlansArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirCareTeamsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirClaimResponsesArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirClaimsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirConditionsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirDiagnosticReportsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirEncountersArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirGoalsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirImmunizationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirMedicationAdministrationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirMedicationRequestsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirMedicationStatementsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirMedicationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirMedicinalProductInteractionsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirObservationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirPatientsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirPractitionersArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirProceduresArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdminListFhirServiceRequestsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdoptionInsightsArgs = {
  practiceRef: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAdvocacyPositionsArgs = {
  rulesetId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAllowedNavigationArgs = {
  layer: ViewLayer;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAnalyzeDomainFromIntentArgs = {
  description: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAnalyzeSchemaIntentArgs = {
  description: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApplyStandardsPackArgs = {
  input: ApplyStandardsPackInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApprovalArgs = {
  id: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApprovalApiGetApprovalArgs = {
  approvalId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApprovalApiGetPendingApprovalsCountArgs = {
  approverId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApprovalApiListApprovalsByStatusArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status: GqlApprovalStatus;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApprovalApiListApprovalsByWorkflowArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApprovalApiListApprovalsForApproverArgs = {
  approverId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApprovalApiListApprovalsInChainArgs = {
  approvalChainId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApproveRecommendationArgs = {
  decision: ApprovalDecisionGql;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryApproverPlanQueueArgs = {
  authorityRole: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryArchitectProposalArgs = {
  proposalId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryArchitectProposalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProposalStatus>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryArchiveTemplateArgs = {
  archiverId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAssessmentAccumulatorSummaryArgs = {
  residentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAssessmentAlertsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAssessmentDriftResultsArgs = {
  input: GetDriftResultsInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAttachEvidenceArgs = {
  input: AttachEvidenceInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAuditCheckpointsArgs = {
  formId: Scalars['String']['input'];
  priority?: InputMaybe<CheckpointPriority>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAuditFormArgs = {
  formId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAuditFormByCfrArgs = {
  cfr: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAuditFormsArgs = {
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAvailableIndustryTermsArgs = {
  industry?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAvailableScopeDimensionsArgs = {
  primitiveType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAwaitOutboxEmptyArgs = {
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryAwaitWatermarkArgs = {
  kind: Scalars['String']['input'];
  minSuccessTs?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryBeaconArgs = {
  beaconId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryBeaconsArgs = {
  beaconType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantNum: Scalars['Int']['input'];
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCanTenantAccessRouteArgs = {
  path: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCarecircleAssessmentArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCarecircleFacilityArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCarecircleFeaturedFacilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCarecircleSearchFacilitiesArgs = {
  input: FacilitySearchInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryChainVerificationArgs = {
  sessionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCheckConstraintArgs = {
  code: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCheckFrameworkComplianceArgs = {
  input: CheckFrameworkComplianceInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCheckVerifierAccessArgs = {
  targetTenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCodeSystemInfoArgs = {
  system: CodeSystemEnum;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCodeUsageRecentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCommunicationLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompareLensEvaluationArgs = {
  input: CompareLensInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompletionGapsArgs = {
  requiredActorIds: Array<Scalars['String']['input']>;
  templateRef: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryComplianceStatusArgs = {
  rulesetId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompositionEvaluateCompositionArgs = {
  input: CompositionInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompositionGetAntiPatternArgs = {
  id: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompositionGetAvailableFixesArgs = {
  input: CompositionInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompositionGetFormulaArgs = {
  formulaNumber: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompositionListAntiPatternsForTenantArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCompressionStatsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConditionArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConditionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConfigCreatedPrimitivesArgs = {
  configId: Scalars['String']['input'];
  primitiveType: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConfigEdgesArgs = {
  configId: Scalars['String']['input'];
  edgeType?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConfigImpactArgs = {
  configId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConfigReverseEdgesArgs = {
  configId: Scalars['String']['input'];
  inverseType?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConstellationTemplateArgs = {
  constellationId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConstellationTemplatesArgs = {
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConstellationWithLensArgs = {
  constellationId: Scalars['String']['input'];
  lensId: Scalars['String']['input'];
  mode?: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConstellationsByActorArgs = {
  actorId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryControlledItemArgs = {
  itemId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryControlledItemCountArgs = {
  constraintId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryControlledItemsByConstraintArgs = {
  constraintId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ControlledItemStatus>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryControlledItemsNeedingVerificationArgs = {
  constraintType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryConvertChaosToDslArgs = {
  input: ConvertChaosToDslInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCreateDomainMetadataArgs = {
  input: CreateDomainMetadataInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCreateEntityArgs = {
  input: CreateEntityInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCreateTemplateMetadataArgs = {
  input: CreateTemplateMetadataInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCriticalCheckpointsArgs = {
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryCrossTenantAuditReportArgs = {
  input: CrossTenantAuditReportInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDagExecutionStatusArgs = {
  executionId: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDagExecutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDagPerformanceMetricsArgs = {
  executionId: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDagWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDecisionGetActiveDecisionArgs = {
  name: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDecisionGetDecisionVersionArgs = {
  name: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDecisionListDecisionHistoryArgs = {
  name: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDecisionListDecisionsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDecodeConfigFilenameArgs = {
  filename: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDeleteAudienceArgs = {
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDeleteChaosDocumentArgs = {
  actor: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDeleteEntityArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDeleteTemplateMetadataArgs = {
  actor: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDependencyApiBuildWorkflowDagArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDependencyApiDetectCircularDependenciesArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDependencyApiGetCriticalPathArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDependencyApiGetDependencyArgs = {
  dependencyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDependencyApiGetTaskDependenciesArgs = {
  taskId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDependencyApiListDependenciesByWorkflowArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDependencyApiValidateDependencyArgs = {
  input: CreateDependencyInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentAccessLogArgs = {
  documentId: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentApiGetChaosGeneratedDocumentsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentApiGetDocumentArgs = {
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentApiGetDocumentVersionHistoryArgs = {
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentApiGetDocumentsByStatusArgs = {
  status: DocumentStatus;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentApiGetDocumentsByTypeArgs = {
  documentType: DocumentType;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentApiGetDocumentsPendingApprovalArgs = {
  approverActorId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentApiListDocumentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDocumentJobArgs = {
  jobId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDomainMetadataArgs = {
  domainType: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDriverDailyStatsArgs = {
  driverId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryDriverDeliveriesArgs = {
  driverId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryElopementAlertsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantNum: Scalars['Int']['input'];
  unacknowledgedOnly?: Scalars['Boolean']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEmergencyParticipantCountArgs = {
  emergencyId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEmployeeArgs = {
  id: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEmployeesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEncounterArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEncountersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EntityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEntityArgs = {
  id: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEntityPreviewArgs = {
  entityType: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEntitySchemaArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEntitySearchArgs = {
  input: EntitySearchInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEntityTypesArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEstimateAnalyticsCostArgs = {
  input: EstimateAnalyticsCostInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEvaluateLensArgs = {
  input: EvaluateLensInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEvaluatePolicyArgs = {
  input: EvaluatePolicyInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiGetCriticalEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiGetEventArgs = {
  eventId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiGetEventsByEntityArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiGetEventsByTransactionArgs = {
  tenantId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiGetEventsByWorkflowInstanceArgs = {
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiListEventsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GqlEventFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiListViolationEventsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<GqlEventSeverity>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryEventApiVerifyEventChainIntegrityArgs = {
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryExchangeDocumentsArgs = {
  relationshipId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryExecuteEntityActionArgs = {
  action: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryExpiredCredentialsArgs = {
  templateRef: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryExpiringCredentialsArgs = {
  templateRef: Scalars['String']['input'];
  withinDays?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryExportAuditTrailArgs = {
  input: ExportAuditTrailInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryExportFormSchemaDraftArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryExportTemplateArgs = {
  input: ExportTemplateInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFederationInfoArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirAdverseEventsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirAllergiesBySubjectArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirAllergyIntolerancesArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirCarePlansArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirCareTeamsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirClaimResponsesArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirClaimsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirConditionsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirDiagnosticReportsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirEncountersArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirExpectedNarcoticCountArgs = {
  prescriptionId: Scalars['String']['input'];
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirGoalsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirImmunizationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedAdminsBySubjectArgs = {
  limit?: Scalars['Int']['input'];
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedDispensesBySubjectArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedStatementsBySubjectArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedicationAdministrationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedicationRequestsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedicationShiftPlanArgs = {
  timeWindow?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedicationStatementsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedicationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedicationsBySubjectArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirMedicinalProductInteractionsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirObservationsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirPatientsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirPractitionersArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirPrescriptionSchedulesBySubjectArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirPrescriptionsNeedingRefillArgs = {
  subjectActorId: Scalars['String']['input'];
  thresholdDays?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirProceduresArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirResourceVersionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: FhirStorageResourceType;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirServiceRequestsArgs = {
  limit?: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirStorageResourceArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirStoredResourceArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: FhirStorageResourceType;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirStoredResourceVersionArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: FhirStorageResourceType;
  version: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFhirStoredResourcesArgs = {
  limit?: Scalars['Int']['input'];
  resourceType: FhirStorageResourceType;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFieldConstellationArgs = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  primitiveType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFindBottlenecksArgs = {
  tenantId: Scalars['String']['input'];
  thresholdMs: Scalars['Int']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemaArgs = {
  entityType: Scalars['String']['input'];
  rulesetId?: InputMaybe<Scalars['String']['input']>;
  schemaId?: InputMaybe<Scalars['String']['input']>;
  subgraph: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemaDraftArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemaForLlmArgs = {
  entityType: Scalars['String']['input'];
  subgraph: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemaOverrideArgs = {
  entityType: Scalars['String']['input'];
  subgraph: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemaOverrideCountArgs = {
  entityType: Scalars['String']['input'];
  subgraph: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemaOverridesArgs = {
  subgraph?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemaVersionArgs = {
  entityType: Scalars['String']['input'];
  subgraph: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormSchemasArgs = {
  subgraph: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsBatchParameterVersionsArgs = {
  parameters: Array<ParameterVersionInput>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsDiffDefinitionsArgs = {
  left: Scalars['JSON']['input'];
  right: Scalars['JSON']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsDryRunGuardArgs = {
  input: DryRunGuardInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsEntityDetailsArgs = {
  input: EntityDetailsInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsFindExpertsBySpecializationsArgs = {
  complianceFrameworks: Array<Scalars['String']['input']>;
  specializations: Array<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsFindExpertsByTierArgs = {
  tenant: Scalars['String']['input'];
  tier: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsFindMetadataArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metadataType: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGenerateS3SignedUrlArgs = {
  bucket: Scalars['String']['input'];
  expirySeconds?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetActorArgs = {
  actorId: Scalars['ID']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetAvailableComplianceFrameworksArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetAvailableExpertsArgs = {
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  minSuccessRate?: InputMaybe<Scalars['Float']['input']>;
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant: Scalars['String']['input'];
  tier?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetBusinessProcessTypesArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetCacheHealthArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetCacheInvalidationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetCacheKeyPatternsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetCacheMetricsArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetCacheMetricsHistoryArgs = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetCacheOperationStatsArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetCompleteWorkflowArgs = {
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetDepartmentConfigurationArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetDraftArgs = {
  input: GetDraftInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetDraftVersionsArgs = {
  key: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetEnhancedFormSchemaArgs = {
  input: GetEnhancedFormSchemaInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetFilterConfigurationsArgs = {
  component: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetFormSchemaArgs = {
  input: GetFormSchemaInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetGovernanceContextArgs = {
  id: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetJobQueueMetricsArgs = {
  tenant: Scalars['String']['input'];
  timeRange?: InputMaybe<Scalars['JSON']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetKindCapabilitiesArgs = {
  kind: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetParameterMetadataArgs = {
  paramName: Scalars['String']['input'];
  paramType: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetRegulatoryAuthorityTypesArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetRegulatoryComplianceConfigArgs = {
  configType: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetRegulatoryThresholdArgs = {
  frameworkId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  thresholdType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetRegulatoryThresholdsBatchArgs = {
  inputs: Array<RegulatoryThresholdQueryInput>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetSafetyEventArgs = {
  eventId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetSafetyEventsByTimerangeArgs = {
  categoryFilter?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  severityFilter?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['DateTime']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetStagedSafetyEventsArgs = {
  categoryFilter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  severityThreshold?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsGetTeamCapacityMetricsArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListActorDescriptorsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListActorsArgs = {
  filter?: InputMaybe<ActorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListComponentEdgesArgs = {
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListComponentsArgs = {
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListDefinitionsArgs = {
  input: ListDefinitionsInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListDraftsArgs = {
  input: ListDraftsInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListGovernanceContextsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<Scalars['JSON']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListJobStatusesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<Scalars['JSON']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListRegulatoryComplianceConfigsArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsListSafetyEventsArgs = {
  filter: SafetyEventFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsPoliciesArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskCoRespondersForInstanceArgs = {
  constellationId: Scalars['String']['input'];
  currentActorId?: InputMaybe<Scalars['String']['input']>;
  instanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskConstellationTaskSummaryArgs = {
  constellationId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskDerivedLifecyclePhaseArgs = {
  instanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskEntityJourneyGraphArgs = {
  actorIds: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskSubjectJourneyTimelineArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskTaskArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskTaskBreadcrumbArgs = {
  taskId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskTaskMetricsArgs = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskTasksArgs = {
  filter?: InputMaybe<TaskFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsTaskTasksByAssigneeArgs = {
  assigneeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsValidateDraftArgs = {
  input: ValidateDraftInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsValidateExpertAssignmentArgs = {
  actorId: Scalars['ID']['input'];
  requirements: ExpertRequirementsInput;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormsWorkflowPrimitivesArgs = {
  input: WorkflowPrimitiveContextInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryGetCompletenessScoreArgs = {
  primitives: Array<GqlPrimitiveType>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryGetFormulaArgs = {
  formulaId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryGetLatestFormulaArgs = {
  formulaId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryListEnabledFormulasArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryListFormulasArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryListFormulasBySuccessRateArgs = {
  minRate: Scalars['Float']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryRecommendFormulasArgs = {
  primitives: Array<GqlPrimitiveType>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryValidateAndRecommendArgs = {
  primitives: Array<GqlPrimitiveType>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryFormulaRegistryValidatePrimitivesArgs = {
  primitives: Array<GqlPrimitiveType>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGenerateOptimizationRecommendationsArgs = {
  request: OptimizationGenerationRequestGql;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGeneratedDocumentArgs = {
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetActorArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetActorStatisticsArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetActorsByCapabilityArgs = {
  capability: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetActorsByTeamArgs = {
  teamId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetActorsByTypeArgs = {
  actorType: GqlActorType;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAggregatedProgressArgs = {
  parentInstanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAiDecisionStatsArgs = {
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsByCategoryArgs = {
  category: MetricCategory;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsByCodeArgs = {
  analyticsCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsByQueueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsDashboardArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsSummaryArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsTimeSeriesArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  timeRange: AnalyticsTimeRange;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsWithAnomaliesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnalyticsWithThresholdBreachesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnnotationArgs = {
  annotationId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAnnotationCountArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetApprovalQueueArgs = {
  filter?: InputMaybe<ApprovalQueueFilter>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetApprovalWorkflowInstanceArgs = {
  instanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAudienceArgs = {
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAuditArgs = {
  id: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAuditApprovalChainArgs = {
  auditId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAuditStatisticsArgs = {
  dateRange: AuditDateRangeInput;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAuditTrailArgs = {
  filter: AuditTrailFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetAvailableResourcesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetBulkOperationStatusArgs = {
  batchId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetCeremonyStatusArgs = {
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetCeremonyTemplateArgs = {
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetChaosDocumentDetailsArgs = {
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetCheckpointArgs = {
  checkpointId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetCheckpointChainArgs = {
  checkpointId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetCheckpointStatisticsArgs = {
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetCheckpointsByTransactionArgs = {
  transactionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetChildWorkflowsArgs = {
  filter?: InputMaybe<GqlChildWorkflowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentInstanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetConstraintArgs = {
  code: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetConstraintsByEntityArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetConstraintsByTypeArgs = {
  constraintType: GqlConstraintType;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetContractArgs = {
  contractId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetContractByExternalIdArgs = {
  externalId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetContractBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetConversionStatusArgs = {
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetCurrentPolicyVersionArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetDueSchedulesArgs = {
  withinMinutes: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetEnabledAnalyticsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetInstanceHierarchyArgs = {
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  rootInstanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetIntakeConversationArgs = {
  documentId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetIntegrationArgs = {
  integrationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetIntegrationsByHealthStatusArgs = {
  healthStatus: IntegrationHealthStatus;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetIntegrationsByTypeArgs = {
  integrationType: IntegrationType;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetIntegrationsNeedingCredentialRotationArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetIntegrationsWithOpenCircuitBreakerArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetJitPolicyArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetJitStatisticsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetLatestCheckpointArgs = {
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetLatestTemplateMetadataArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetLeastLoadedActorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetLifeCriticalResourcesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetLlmComparisonDataArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetLlmFixRecommendationArgs = {
  recommendationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetNotificationArgs = {
  notificationId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetNotificationStatsArgs = {
  companyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetNotificationsArgs = {
  input: GetNotificationsInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetOrchestrationPatternArgs = {
  patternType: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetOrchestrationRuleArgs = {
  ruleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetOverloadedQueuesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetPerformanceStatsArgs = {
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetPolicyArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetPolicyAnalyticsArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetPolicyRuleArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetPolicyTemplateArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetPolicyVersionArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetQueueArgs = {
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetQueueStatisticsArgs = {
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetQueuesByWorkflowInstanceArgs = {
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetQueuesWithSlaBreachesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetRbacAuditStatisticsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetRecoverableCheckpointsArgs = {
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetResourceArgs = {
  resourceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetResourceUtilizationReportArgs = {
  resourceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetResourcesByStatusArgs = {
  status: GqlResourceStatus;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetResourcesByTypeArgs = {
  resourceType: GqlResourceType;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetRoleArgs = {
  roleId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetRoleHierarchyArgs = {
  roleId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetRolePermissionsArgs = {
  roleId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetRoleTemplateArgs = {
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetScheduleArgs = {
  scheduleId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetScheduleExecutionSummaryArgs = {
  scheduleId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetStandardsPackDetailsArgs = {
  standardsPackId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetStructuredImportJobArgs = {
  documentId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetSubgraphDefinitionArgs = {
  subgraph: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetSubgraphMetadataArgs = {
  subgraphId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetSubgraphRegistryArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetSubgraphTierArgs = {
  subgraphName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTeamArgs = {
  code: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTeamByCodeArgs = {
  code: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTeamHierarchyArgs = {
  code: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTeamPresenceArgs = {
  teamId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTeamWorkspaceArgs = {
  teamId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTemplateMetadataArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTemplatePublicationStatusArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTemplateUsageArgs = {
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTemplateVersionArgs = {
  templateId: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTemplateVersionDiffArgs = {
  fromVersion: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
  toVersion: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTemplateVersionHistoryArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTemplateVersionHistorySummaryArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTenantBrandingArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTenantBrandingByCustomDomainArgs = {
  customDomain: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTenantBrandingBySubdomainArgs = {
  subdomain: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTenantEntityTypesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTenantNavItemsForLayerArgs = {
  layer: ViewLayer;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTenantRoutesForLayerArgs = {
  layer: ViewLayer;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTenantSubgraphConfigArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTimeSeriesDataArgs = {
  analyticsId: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTopPoliciesArgs = {
  limit: Scalars['Int']['input'];
  metric: PolicyMetricType;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTraceArgs = {
  spanId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  traceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetTransactionArgs = {
  transactionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetUnhealthyIntegrationsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetUnreadCountArgs = {
  recipientActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetValidationArgs = {
  code: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetValidationByIdArgs = {
  code: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetVersionDiffArgs = {
  fromVersion: Scalars['Int']['input'];
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  toVersion: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetVersionHistoryArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetWorkflowArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetWorkflowComplianceArgs = {
  tenant: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGetWorkflowGraphArgs = {
  graphId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryGraphIntersectionArgs = {
  constellationIds: Array<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryHaccpReportArgs = {
  endDate: Scalars['Int']['input'];
  startDate: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryHasCompletedArgs = {
  actorId: Scalars['String']['input'];
  templateRef: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryHasSubgraphRegistryArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryHydrateIdArgs = {
  input: HydrateIdInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryImplementRecommendationArgs = {
  plan: ImplementationPlanGql;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryImportTemplateArgs = {
  input: ImportTemplateInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryImportWearableCaptureToStudioArgs = {
  actorId: Scalars['String']['input'];
  captureType: Scalars['String']['input'];
  contentUri: Scalars['String']['input'];
  input: ImportWearableCaptureInput;
  transcription?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIncidentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIncrementTemplateUsageArgs = {
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInitializePolicyAnalyticsArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInitiateStructuredImportArgs = {
  input: InitiateStructuredImportInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInspectActorArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiGetInstanceArgs = {
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiGetInstanceByCorrelationArgs = {
  correlationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiGetInstanceHistoryArgs = {
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiGetInstancesByActorArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiGetInstancesBySubjectArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiListActiveInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiListInstancesArgs = {
  filter?: InputMaybe<GqlInstanceFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiListInstancesByStatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status: GqlInstanceStatus;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstanceApiListInstancesByWorkflowArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInstantiateTemplateArgs = {
  input: InstantiateTemplateInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIntegBaseArgs = {
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIntegrationAnomaliesArgs = {
  filter: IntegrationAnomalyFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIntegrationApiAuditArgs = {
  filter: IntegrationAuditFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIntegrationBurnRateReportsArgs = {
  filter: IntegrationBurnRateFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIntegrationSyncStatusArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryIntegrationWorkerContactQueueArgs = {
  filter: IntegrationWorkerContactFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInventoryConstraintArgs = {
  constraintId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryInventoryConstraintsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryItemsNeedingActionArgs = {
  actorId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<WorkItemType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryJourneyAiSuggestionsArgs = {
  instanceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryJourneyAuditSectionsArgs = {
  instanceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryJourneyEdgeApiJourneyEdgesArgs = {
  edgeType?: InputMaybe<GqlJourneyEdgeType>;
  instanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryJourneyEdgeApiLinkedInstancesArgs = {
  edgeType?: InputMaybe<GqlJourneyEdgeType>;
  instanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLedgerAccountArgs = {
  actorId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLedgerAccountsArgs = {
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLedgerChainStatusArgs = {
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLedgerSettlementsArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLedgerTokensArgs = {
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLedgerTransfersArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  tenantNum: Scalars['Int']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
  tokenType?: InputMaybe<LedgerTokenType>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLegacyArchiveFileArgs = {
  fileId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLegacyArchiveFilesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLensTemplateArgs = {
  lensId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLensTemplatesArgs = {
  constellation?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListActiveJitSessionsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListActiveRolesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListActiveTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListActiveValidationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListActorsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAiGeneratedAuditsArgs = {
  humanReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAnalyticsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAnnotationThreadArgs = {
  limit?: Scalars['Int']['input'];
  threadRootId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAnnotationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAtomicPartsArgs = {
  partType?: InputMaybe<Scalars['String']['input']>;
  satisfies?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAudiencesArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAuditsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAuditsByFrameworkArgs = {
  frameworkType: GqlAuditFrameworkType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAuditsByPeriodArgs = {
  endDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAuditsByQueueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  queueId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAuditsByStatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status: AuditComplianceStatus;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListAuditsByUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListBroadcastLogsArgs = {
  beforeMs?: InputMaybe<Scalars['Int']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListBulkOperationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListCeremoniesForDocumentArgs = {
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListCeremonyTemplatesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListChaosDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<ChaosDocumentStatus>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListCheckpointsByWorkflowArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListChildTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListConstraintsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListContractsByStatusArgs = {
  limit?: Scalars['Int']['input'];
  status: GqlContractStatus;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListContractsByWorkflowArgs = {
  limit?: Scalars['Int']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListDomainMetadataArgs = {
  filter?: InputMaybe<MetadataFilterInput>;
  pagination?: InputMaybe<MetadataPaginationInput>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListDriftArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListEnabledPoliciesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListEnabledSubgraphsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListExpiringAuditsArgs = {
  expiresBefore: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListExpiringSubgraphsArgs = {
  days: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirAdverseEventsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirAllergyIntolerancesArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirCarePlansArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirCareTeamsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirClaimResponsesArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirClaimsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirConditionsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirDiagnosticReportsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirEncountersArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirGoalsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirImmunizationsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirMedicationAdministrationsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirMedicationRequestsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirMedicationsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirObservationsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirPatientsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirPractitionersArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirProceduresArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFhirServiceRequestsArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListFormSchemaDraftsArgs = {
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListIntegrationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListJitRequestsArgs = {
  filter: JitRequestFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListLifeCriticalSubgraphsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListLlmFixRecommendationsArgs = {
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListMyWorkflowsArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListNotificationsByStatusArgs = {
  limit?: Scalars['Int']['input'];
  status: GqlNotificationStatus;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListNotificationsByTenantArgs = {
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListNotificationsByTriggerArgs = {
  limit?: Scalars['Int']['input'];
  triggerEntityId: Scalars['String']['input'];
  triggerEntityType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListNotificationsForRecipientArgs = {
  limit?: Scalars['Int']['input'];
  recipientActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListOptimizationRecommendationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<RecommendationStatus>>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListOrchestrationPatternsArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListOrchestrationRulesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPendingApprovalsArgs = {
  approverId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPoliciesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPoliciesByScopeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: GqlPolicyScope;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPoliciesByTypeArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  policyType: GqlPolicyType;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPolicyAnalyticsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPolicyRulesArgs = {
  policyType?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPolicyVersionsArgs = {
  policyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListPublishedTemplatesArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListQueuesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListRbacAuditLogArgs = {
  filter: RbacAuditFilter;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListReconArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListResourcesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListRoleTemplatesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListRolesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<GqlRoleCategory>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListRolesByCategoryArgs = {
  category: GqlRoleCategory;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListSchedulesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListSchemaArgs = {
  entityType: Scalars['String']['input'];
  subgraph: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListSpansByTraceIdArgs = {
  traceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListStandardsPacksArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListSubgraphsByTierArgs = {
  tenantId: Scalars['String']['input'];
  tier: ModuleTier;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListSuppressedEmailsArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListSuppressedSmsArgs = {
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTeamsByTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  teamType: GqlTeamType;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTemplateInstancesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTemplateUsageArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTemplateVersionsArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTemplatesByCategoryArgs = {
  category: PolicyTemplateCategory;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTemplatesByDomainArgs = {
  domain: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  templateType?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTemplatesByDomainAndTypeArgs = {
  domain: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  templateType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTemplatesByTenantArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTracesByTaskIdArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  taskId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTracesByWorkflowInstanceArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTransactionsByStatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status: GqlTransactionStatus;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTransactionsByTenantArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListTransactionsByWorkflowArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListUiSchemasArgs = {
  module: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListUsableSubgraphsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListValidationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListValidationsByPhaseArgs = {
  executionPhase: GqlExecutionPhase;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListValidationsByTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  validationType: GqlValidationType;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListWebhookEndpointsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListWorkflowGraphsArgs = {
  filter?: InputMaybe<WorkflowGraphFilter>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListWorkflowsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryListWorkflowsByStrategyArgs = {
  strategy: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLlmWorkflowExportDraftArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLlmWorkflowGetDraftArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLlmWorkflowListDraftsArgs = {
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLlmWorkflowPreviewDraftYamlArgs = {
  draftId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLookupByCompressedArgs = {
  input: LookupByCompressedInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLookupBySnowflakeArgs = {
  input: LookupBySnowflakeInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryLookupCodeArgs = {
  code: Scalars['String']['input'];
  system: CodeSystemEnum;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMasterWorkflowConfigArgs = {
  programVariant: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationAdministrationArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationAdministrationsArgs = {
  limit?: Scalars['Int']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationDispenseArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationDispensesArgs = {
  limit?: Scalars['Int']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  prescriptionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationRequestArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationRequestsArgs = {
  limit?: Scalars['Int']['input'];
  medication?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMedicationsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyAccessibleSubgraphsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyCapabilitiesArgs = {
  context: CapabilityContext;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyCapabilitiesBatchArgs = {
  contexts: Array<CapabilityContext>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyGeneratedDocumentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DocumentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyInboxArgs = {
  status?: InputMaybe<TaskStatus>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyServiceAuthorizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMySubjectEdgesArgs = {
  edgeType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyTasksArgs = {
  actorId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WorkStatus>;
  tenantId: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyViewContextArgs = {
  route: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryMyWorkArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MyWorkFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryNavigationSummaryArgs = {
  layer: ViewLayer;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryObservationArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryObservationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryOfflineEnvelopeArgs = {
  actorId: Scalars['String']['input'];
  shiftDate: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryOrderStatusArgs = {
  orderId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPageAssignmentConfigArgs = {
  context: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryParseWorkflowYamlArgs = {
  yamlContent: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPartsForRulesetArgs = {
  rulesetId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPatientArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPatientsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPatternTemplateArgs = {
  patternId: PatternId;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPdfTemplateArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPdfTemplatesArgs = {
  subgraph?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPendingDocumentJobsArgs = {
  documentType?: InputMaybe<GqlGeneratedDocumentType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPendingRulesetsArgs = {
  industry?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPiiAttestationArgs = {
  attestationId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPlanVersionComparisonArgs = {
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPolicyArgs = {
  id: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPrescriptionRefillHistoryArgs = {
  prescriptionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPreviewRuleRoutingArgs = {
  tenantId: Scalars['String']['input'];
  yamlContent: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPreviewSchemaImportArgs = {
  resourceType: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPrimitiveArgs = {
  name: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPrimitiveProvenanceArgs = {
  primitiveId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPrimitiveRelationshipsArgs = {
  maxPerType?: InputMaybe<Scalars['Int']['input']>;
  primitiveId: Scalars['String']['input'];
  primitiveType: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPriorPlanVersionArgs = {
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryProcedureArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryProceduresArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryProductCatalogArgs = {
  industry?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryProductCatalogEntryArgs = {
  productId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryProductDefinitionArgs = {
  productId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryProductDefinitionsArgs = {
  industry?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryProvenanceGraphArgs = {
  depth?: Scalars['Int']['input'];
  rootConfigId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPublicWebsiteManifestArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryPublishTemplateArgs = {
  input: PublishTemplateInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryQueryIdAuditArgs = {
  input: QueryIdAuditInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryQueryOrchestrationRulesArgs = {
  input: QueryOrchestrationRulesInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRbacCurrentUserRoleArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRbacGetEffectiveRoleArgs = {
  roleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRbacGetRoleArgs = {
  roleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRbacGetUserRolesArgs = {
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRbacListRolesArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRbacUserPermissionsArgs = {
  tenantId: Scalars['String']['input'];
  userRole: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryReadMaskedPiiArgs = {
  input: ReadMaskedPiiInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryReadyWorkflowsArgs = {
  completedWorkflows: Array<Scalars['String']['input']>;
  programVariant?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRecommendStandardsPacksArgs = {
  tenant: Scalars['String']['input'];
  workflow: Scalars['JSON']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRecommendationsArgs = {
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRecommendedRetryCountArgs = {
  emergencyId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRecordApprovalDecisionArgs = {
  input: RecordApprovalDecisionInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRecordPolicyEvaluationArgs = {
  input: RecordEvaluationInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRegulatoryCoverageGapsArgs = {
  rulesetId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRegulatoryQueueStatsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRegulatoryRuleArgs = {
  ruleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRegulatoryRulesArgs = {
  filter: RuleFilterInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRequestDocumentUrlViaTokenArgs = {
  token: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRequestEmergencyAccessArgs = {
  input: EmergencyAccessInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRequestEvidenceCertificateUrlArgs = {
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryResolveEffectiveRuleSetArgs = {
  asOfDate?: InputMaybe<Scalars['String']['input']>;
  rulesetId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryResolveRoleScopesArgs = {
  roleIds: Array<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryResolveSigningTokenArgs = {
  token: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryReviewerPlanQueueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  reviewerRole: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRevokeEmergencyAccessArgs = {
  incidentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRollbackPolicyArgs = {
  input: RollbackPolicyInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRollbackTemplateArgs = {
  input: RollbackTemplateInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRuleSetArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRuleSetVersionChainArgs = {
  rulesetId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRuleSetsArgs = {
  asOfDate?: InputMaybe<Scalars['String']['input']>;
  effectiveOnly?: Scalars['Boolean']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryRuleSetsByDimensionsArgs = {
  asOfDate?: InputMaybe<Scalars['String']['input']>;
  effectiveOnly?: Scalars['Boolean']['input'];
  filter: RuleSetDimensionFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySafetyMetricsExecutiveSafetyMetricsArgs = {
  input: SafetyMetricsInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySagaDefinitionArgs = {
  sagaId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySagaExecutionStatusArgs = {
  executionId: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySagaExecutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<SagaExecutionStatus>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySagaSafetyScoresArgs = {
  executionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryScopeAssignmentsArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryScopeEdgesArgs = {
  edgeType?: InputMaybe<ScopeEdgeType>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryScopeMutationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryScopePathArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySearchActorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySearchAnalyticsArgs = {
  dateRange: DateRangeInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySearchCodesArgs = {
  limit?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  system: CodeSystemEnum;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySearchEntitiesArgs = {
  input: SearchEntitiesInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySendIntakeMessageArgs = {
  input: SendIntakeMessageInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryServicePlanArgs = {
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryServicePlansBySubjectArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PlanStatus>;
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySessionConflictsArgs = {
  sessionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryShiftScheduleArgs = {
  scheduleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryShiftSchedulesArgs = {
  actorId?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['Int']['input'];
  startTime: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryShiftWorkItemsArgs = {
  actorId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<WorkItemType>;
  scheduleId: Scalars['String']['input'];
  status?: InputMaybe<WorkItemStatus>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryShiftWorkItemsBySubjectArgs = {
  scheduleId: Scalars['String']['input'];
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySimulateRecommendationImpactArgs = {
  recommendationId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySimulationAvailableTransitionsArgs = {
  sessionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySimulationHistoryArgs = {
  sessionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySourceMapArgs = {
  mappingId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySourceMapStatsArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySourceMapsArgs = {
  filter: SourceMapFilterInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryStationOrdersArgs = {
  station: FoodServiceStation;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryStatutoryDefinitionArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryStatutoryImpactAnalysisArgs = {
  statuteSection: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySubgraphCorrelationArgs = {
  input: SubgraphCorrelationInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySubgraphEntityTypesArgs = {
  subgraphName: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySubgraphHasFeatureArgs = {
  feature: Scalars['String']['input'];
  subgraphName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySubmitTemplateForApprovalArgs = {
  input: SubmitTemplateForApprovalInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySuggestCompositionArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  rulesetId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySyncConflictsArgs = {
  status?: InputMaybe<GqlConflictStatus>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySyncHistoryArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySyncSessionArgs = {
  sessionId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySystemTenantArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySystemTenantByDomainArgs = {
  domain: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySystemTenantsByIndustryArgs = {
  industry: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySystemUserArgs = {
  userId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySystemUserByEmailArgs = {
  email: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QuerySystemUsersByTenantArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTaskArgs = {
  taskId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTaskByIdArgs = {
  taskId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTaskHistoryArgs = {
  taskId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTasksByActorArgs = {
  actorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTasksByStatusArgs = {
  status: GqlTaskStatus;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTasksBySubjectArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTasksByTaskTypeArgs = {
  taskGroupRef: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTasksByWorkflowInstanceArgs = {
  workflowInstanceId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiGetTrainingTasksByEmployeeArgs = {
  employeeActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiListSystemTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiListTasksArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiListTrainingTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskApiTaskEnrichmentContextArgs = {
  subjectActorId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskCompletionHintsArgs = {
  taskId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskGroupArgs = {
  groupId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
  subgraph?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskGroupCategoriesArgs = {
  setting?: InputMaybe<Scalars['String']['input']>;
  subgraph?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTaskGroupsArgs = {
  category?: InputMaybe<TaskGroupCategory>;
  setting?: InputMaybe<Scalars['String']['input']>;
  subgraph?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTemplateApiGetTemplateArgs = {
  templateId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTemplateApiGetTemplateVersionsArgs = {
  name: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTemplateApiGetTemplatesByCategoryArgs = {
  category: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTemplateApiGetTemplatesByFormulaArgs = {
  formulaId: Scalars['String']['input'];
  minSuccessRate?: InputMaybe<Scalars['Float']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTemplateApiGetTemplatesByStatusArgs = {
  status: GqlTemplateStatus;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTemplateApiListTemplatesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTemplateCompletionCountArgs = {
  templateRef: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTenantFlowMapArgs = {
  dateRange: FlowMapDateRangeInput;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTenantMetadataArgs = {
  domainType: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTenantProductArgs = {
  productId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTenantProductsArgs = {
  tenantNum: Scalars['Int']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTenantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTerminologySettingsArgs = {
  industry?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTimelineArgs = {
  instanceId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTopDeficienciesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTranscriptArgs = {
  entityRef: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTranslateCodeArgs = {
  sourceCode: Scalars['String']['input'];
  sourceSystem: CodeSystemEnum;
  targetSystem: CodeSystemEnum;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTranslateTermArgs = {
  input: TranslateTermInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryTriggerCeremonyRemindersArgs = {
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryUiSchemaArgs = {
  context: Uicontext;
  entity: Scalars['String']['input'];
  module: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryUpdateEntityArgs = {
  input: UpdateEntityInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryUpdateTemplateMetadataArgs = {
  input: UpdateTemplateMetadataInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryUpdateTenantMetadataArgs = {
  input: CreateTenantMetadataInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryUploadChaosDocumentArgs = {
  input: GqlUploadChaosDocumentInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryUpsertAudienceArgs = {
  items: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryUsrnReviewArgs = {
  reviewId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateAuditSubgraphsArgs = {
  auditId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateCodeArgs = {
  code: Scalars['String']['input'];
  system: CodeSystemEnum;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateCodeFormatArgs = {
  code: Scalars['String']['input'];
  system: CodeSystemEnum;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateDataArgs = {
  code: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateMandatoryResourcesArgs = {
  primaryRuleset: Scalars['String']['input'];
  subgraph?: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateMetadataArgs = {
  tenantId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidatePermissionArgs = {
  action: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceType: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidatePolicyRulesArgs = {
  input: CreatePolicyInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateSubgraphLicensingArgs = {
  input: ValidateSubgraphLicensingInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateSubgraphReferenceArgs = {
  input: ValidateSubgraphReferenceInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateTemplateImportArgs = {
  input: ValidateTemplateInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateTemplateMetadataArgs = {
  metadata: TemplateMetadataContentInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateTemplateMetadataSimpleArgs = {
  metadata: TemplateMetadataContentInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryValidateWorkflowArgs = {
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryVendorDeeplinkArgs = {
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryVerificationHistoryArgs = {
  constraintId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<VerificationStatus>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryVerifyCeremonySignaturesArgs = {
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWfCompositionPreviewCompositionArgs = {
  metadata: TenantMetadataInput;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWidgetArgs = {
  name: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWidgetsByCategoryArgs = {
  category: WidgetCategory;
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWidgetsForSubgraphArgs = {
  subgraphId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWitnessRequestArgs = {
  id: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWorkflowDefinitionArgs = {
  certification?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  programVariant?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  workflowName: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWorkflowMetadataArgs = {
  context?: InputMaybe<RuntimeContextInput>;
  tenantId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryWorkflowRegistryArgs = {
  programVariant?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryZoneArgs = {
  tenantNum: Scalars['Int']['input'];
  zoneId: Scalars['String']['input'];
};

/** Combined query root (Medplum proxy + DRR-080 DynamoDB storage + DRR-232 medication) */
export type QueryZonesArgs = {
  tenantNum: Scalars['Int']['input'];
  zoneType?: InputMaybe<Scalars['String']['input']>;
};

/** Input for querying audit events */
export type QueryIdAuditInput = {
  /** End time (ISO 8601) */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Filter by event type */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Maximum results (default 100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum severity (debug, info, warning, error, critical) */
  minSeverity?: InputMaybe<Scalars['String']['input']>;
  /** Pagination token */
  nextToken?: InputMaybe<Scalars['String']['input']>;
  /** Filter by primitive */
  primitive?: InputMaybe<Scalars['String']['input']>;
  /** Start time (ISO 8601) */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Filter by subgraph */
  subgraph?: InputMaybe<Scalars['String']['input']>;
  /** Filter by tenant ID */
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Query execution metadata */
export type QueryMetadata = {
  __typename?: 'QueryMetadata';
  /** Execution end time */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Duration in milliseconds */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Files pruned by manifest */
  filesPrunedByManifest: Scalars['Int']['output'];
  /** Manifest version used */
  manifestVersion?: Maybe<Scalars['String']['output']>;
  /** Query ID for tracking */
  queryId: Scalars['String']['output'];
  /** Row groups pruned by statistics */
  rowGroupsPrunedByStats: Scalars['Int']['output'];
  /** Execution start time */
  startedAt: Scalars['DateTime']['output'];
};

export type QueryOrchestrationRulesInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId: Scalars['String']['input'];
};

export type Queue = {
  __typename?: 'Queue';
  assignedActorMap: Scalars['JSON']['output'];
  assignmentStrategy: GqlAssignmentStrategy | '%future added value';
  assignmentTimeoutSeconds: Scalars['Int']['output'];
  avgWaitTimeSeconds: Scalars['Int']['output'];
  capacity: Scalars['Int']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this queue.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this queue */
  createdByActor?: Maybe<ActorSummary>;
  currentSize: Scalars['Int']['output'];
  deduplicationEnabled: Scalars['Boolean']['output'];
  deduplicationWindowSeconds?: Maybe<Scalars['Int']['output']>;
  defaultPriority: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  eligibilityRules: Array<Scalars['String']['output']>;
  eventTopic?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemsProcessedToday: Scalars['Int']['output'];
  lastAssignmentAt?: Maybe<Scalars['DateTime']['output']>;
  lastPerformanceCheckAt?: Maybe<Scalars['DateTime']['output']>;
  maxConcurrentAssignments: Scalars['Int']['output'];
  metricsCollectedCount: Scalars['Int']['output'];
  oldestItemAgeSeconds: Scalars['Int']['output'];
  overflowStrategy: GqlOverflowStrategy | '%future added value';
  performanceAlertEnabled: Scalars['Boolean']['output'];
  priorityBoostEnabled: Scalars['Boolean']['output'];
  priorityBoostIncrement?: Maybe<Scalars['Int']['output']>;
  priorityBoostThresholdSeconds?: Maybe<Scalars['Int']['output']>;
  priorityRules: Array<Scalars['String']['output']>;
  processingRatePerHour: Scalars['Int']['output'];
  queueName: Scalars['String']['output'];
  queueType: GqlQueueType | '%future added value';
  slaBreachCount: Scalars['Int']['output'];
  targetAvgWaitTimeSeconds: Scalars['Int']['output'];
  targetProcessingRatePerHour: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** WHO last updated this queue */
  updatedByActor?: Maybe<ActorSummary>;
  warningThresholdPercent: Scalars['Int']['output'];
};

/**
 * Result of archiving a queue (FERP Append-Only Architecture).
 *
 * FERP Principle: Immutable history for life-critical workflows.
 * Physical deletion is NOT allowed in life-critical systems.
 */
export type QueueArchiveResult = {
  __typename?: 'QueueArchiveResult';
  /** When the queue was archived (ISO 8601) */
  archivedAt: Scalars['DateTime']['output'];
  /** Who archived the queue */
  archivedBy: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** ID of the archived queue */
  queueId: Scalars['String']['output'];
  /** Name of the archived queue */
  queueName: Scalars['String']['output'];
  /** Mandatory reason for archival (audit trail) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Quick action button */
export type QuickActionOutput = {
  __typename?: 'QuickActionOutput';
  /** Unique action ID */
  actionId: Scalars['String']['output'];
  /** Description of what action does */
  description: Scalars['String']['output'];
  /** Optional icon identifier */
  icon?: Maybe<Scalars['String']['output']>;
  /** Button label */
  label: Scalars['String']['output'];
  /** Data to prefill if action is taken */
  prefillData?: Maybe<Scalars['JSON']['output']>;
};

export type QuietHoursInput = {
  /** Days of week (0=Sunday, 6=Saturday) */
  days: Array<Scalars['Int']['input']>;
  /** End time (HH:MM format) */
  endTime: Scalars['String']['input'];
  /** Start time (HH:MM format) */
  startTime: Scalars['String']['input'];
  /** Timezone */
  timezone: Scalars['String']['input'];
};

/** RBAC Audit Filter (GraphQL input) */
export type RbacAuditFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** RBAC Audit Log Entry (GraphQL output) */
export type RbacAuditLogEntry = {
  __typename?: 'RBACAuditLogEntry';
  actor: Scalars['String']['output'];
  actorRole: Scalars['String']['output'];
  afterValue?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['String']['output'];
  beforeValue?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  ipAddress: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** RBAC Audit Log Response (GraphQL output) */
export type RbacAuditLogResponse = {
  __typename?: 'RBACAuditLogResponse';
  entries: Array<RbacAuditLogEntry>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

/** RBAC Audit Statistics (GraphQL output) */
export type RbacAuditStatistics = {
  __typename?: 'RBACAuditStatistics';
  operationsByType: Array<OperationCount>;
  successRate: Scalars['Float']['output'];
  totalOperations: Scalars['Int']['output'];
  userActivity: Array<RbacUserActivity>;
};

export type RbacInstantiateTemplateInput = {
  roleNameOverride?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** RBAC User Activity (GraphQL output) */
export type RbacUserActivity = {
  __typename?: 'RBACUserActivity';
  lastActivity: Scalars['DateTime']['output'];
  operationCount: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** Rate limit handling strategy */
export const RateLimitStrategy = {
  DROP_OLDEST: 'DROP_OLDEST',
  QUEUE: 'QUEUE',
  REJECT_NEW: 'REJECT_NEW',
} as const;

export type RateLimitStrategy = (typeof RateLimitStrategy)[keyof typeof RateLimitStrategy];
/** Reactivate subgraph input */
export type ReactivateSubgraphInput = {
  /** Subgraph identifier */
  subgraphName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for reading masked PII */
export type ReadMaskedPiiInput = {
  entityType: PiiEntityType | '%future added value';
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Result of reading masked PII */
export type ReadMaskedPiiResult = {
  __typename?: 'ReadMaskedPiiResult';
  error?: Maybe<Scalars['String']['output']>;
  maskedValue?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for reassigning a signer after ceremony creation (C6). */
export type ReassignCeremonyParticipantInput = {
  ceremonyId: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
  newName: Scalars['String']['input'];
  participantIndex: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type ReassignmentRecord = {
  __typename?: 'ReassignmentRecord';
  fromActorId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  reassignedAt: Scalars['DateTime']['output'];
  reassignedBy: Scalars['String']['output'];
  toActorId: Scalars['String']['output'];
};

export type Receipt = {
  __typename?: 'Receipt';
  actorId: Scalars['String']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  decision: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reasonCode?: Maybe<Scalars['String']['output']>;
};

/** Standards Pack Recommendation Result */
export type RecommendationResult = {
  __typename?: 'RecommendationResult';
  analysisTimestamp: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  detectedComplexity: Scalars['String']['output'];
  detectedDomain: Scalars['String']['output'];
  recommendations: Array<StandardsPackRecommendation>;
  workflowId: Scalars['String']['output'];
};

export const RecommendationSeverity = {
  critical: 'critical',
  high: 'high',
  low: 'low',
  medium: 'medium',
} as const;

export type RecommendationSeverity =
  (typeof RecommendationSeverity)[keyof typeof RecommendationSeverity];
export const RecommendationStatus = {
  approved: 'approved',
  implemented: 'implemented',
  monitoring: 'monitoring',
  pending: 'pending',
  rejected: 'rejected',
} as const;

export type RecommendationStatus = (typeof RecommendationStatus)[keyof typeof RecommendationStatus];
/** Summary of all recommendations for a tenant (DRR-156). */
export type RecommendationSummary = {
  __typename?: 'RecommendationSummary';
  /** Recommendations already adopted. */
  adoptedCount: Scalars['Int']['output'];
  /** Recommendations dismissed. */
  dismissedCount: Scalars['Int']['output'];
  /** Recommendations not yet reviewed. */
  pendingCount: Scalars['Int']['output'];
  /** Individual recommendations, sorted by intelligence_layer then practice_ref. */
  recommendations: Array<BestPracticeRecommendation>;
  /** Total recommendations across all layers. */
  totalCount: Scalars['Int']['output'];
};

export const RecommendationType = {
  architecture: 'architecture',
  compliance: 'compliance',
  cost: 'cost',
  performance: 'performance',
  reliability: 'reliability',
  resource: 'resource',
  safety: 'safety',
} as const;

export type RecommendationType = (typeof RecommendationType)[keyof typeof RecommendationType];
export type ReconRecord = {
  __typename?: 'ReconRecord';
  actualHash: Scalars['String']['output'];
  expectedHash: Scalars['String']['output'];
  extraCount: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  lastRun: Scalars['Int']['output'];
  missingCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Record Approval Decision Input */
export type RecordApprovalDecisionInput = {
  /** Approver details */
  approverId: Scalars['String']['input'];
  approverName: Scalars['String']['input'];
  approverRole: Scalars['String']['input'];
  /** Comments */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decision type */
  decisionType: DecisionType | '%future added value';
  /** Approval instance ID */
  instanceId: Scalars['String']['input'];
  /** Revision items */
  revisionItems: Array<RevisionItemInput>;
};

/** Input for recording policy evaluation */
export type RecordEvaluationInput = {
  /** Execution time (milliseconds) */
  executionTimeMs: Scalars['Int']['input'];
  /** Whether from cache */
  fromCache: Scalars['Boolean']['input'];
  /** Whether had error */
  hadError: Scalars['Boolean']['input'];
  /** Whether policy matched */
  matched: Scalars['Boolean']['input'];
  /** Policy ID */
  policyId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for recording a consent step */
export type RecordExchangeConsentInput = {
  /** Relationship being approved */
  relationshipId: Scalars['String']['input'];
  /** Which consent step is being approved */
  step: ExchangeConsentStep | '%future added value';
};

export type RecordParticipantSignatureInput = {
  ceremonyId: Scalars['String']['input'];
  participantIndex: Scalars['Int']['input'];
  /**
   * PNG data URL from signature capture (data:image/png;base64,...).
   * Optional for ceremony-level signing; when provided, embeds the
   * visual signature into the PDF before PAdES cryptographic signing.
   */
  signatureImage?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/**
 * Input for recording a payer prior authorization approval.
 *
 * Written by billing staff after a 278 response is received. Populates
 * `EnrichmentSource::Edi` / `DataClass::Auth` enrichment on the constellation
 * so the task spawner knows which services are authorized and their expiry.
 */
export type RecordPriorAuthApprovalInput = {
  /** Authorization expiry date (ISO-8601) */
  authExpiryDate: Scalars['String']['input'];
  /** Payer-assigned authorization number */
  authNumber: Scalars['String']['input'];
  /** Constellation ID to write enrichment against */
  constellationId: Scalars['String']['input'];
  /** Covered services list (CPT or HCPCS codes) */
  coveredServices: Array<Scalars['String']['input']>;
  /** Payer ID / NPI that issued the authorization */
  payerId: Scalars['String']['input'];
  /** Subject actor ID (resident/patient this auth covers) */
  subjectActorId: Scalars['String']['input'];
};

/** Input for recording a proximity event. */
export type RecordProximityEventInput = {
  /** Beacon that was detected */
  beaconId: Scalars['String']['input'];
  /** Estimated distance in meters */
  estimatedDistanceM?: InputMaybe<Scalars['Float']['input']>;
  /** RSSI value at time of detection */
  rssi: Scalars['Int']['input'];
  /** Actor ID of the scanner operator */
  scannerActorId?: InputMaybe<Scalars['String']['input']>;
  /** Scanner device ID */
  scannerId: Scalars['String']['input'];
  /** Event source tier (1=phone, 2=ESP32, 3=Pi, 4=cloud) */
  sourceTier: Scalars['Int']['input'];
  /** Zone where detection occurred */
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for signing via a one-time token link (A1 — external signers). */
export type RecordSignatureViaTokenInput = {
  /** PNG data URL from signature capture (data:image/png;base64,...). Optional. */
  signatureImage?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Configuration for REFERENCE field type (entity lookup) */
export type ReferenceConfig = {
  __typename?: 'ReferenceConfig';
  /** Allow creating new entities inline */
  allowCreate?: Maybe<Scalars['Boolean']['output']>;
  /** Entity type to reference (e.g., "Patient", "Practitioner") */
  entityType: Scalars['String']['output'];
  /** Path to label in query result */
  labelPath?: Maybe<Scalars['String']['output']>;
  /** GraphQL query to fetch options (optional, for custom queries) */
  query?: Maybe<Scalars['String']['output']>;
  /** Additional search/filter parameters */
  searchFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Subgraph containing the referenced entity (e.g., "fhir", "payroll") */
  subgraph: Scalars['String']['output'];
  /** Path to value in query result */
  valuePath?: Maybe<Scalars['String']['output']>;
};

/** Input version of ReferenceConfig */
export type ReferenceConfigInput = {
  allowCreate?: InputMaybe<Scalars['Boolean']['input']>;
  entityType: Scalars['String']['input'];
  labelPath?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
  subgraph: Scalars['String']['input'];
  valuePath?: InputMaybe<Scalars['String']['input']>;
};

/** Input for refunding unused balance */
export type RefundUnusedBalanceInput = {
  actorId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
};

/** Input for registering a new beacon. */
export type RegisterBeaconInput = {
  /** Assigned resident actor ID (wearable beacons only) */
  assignedActorId?: InputMaybe<Scalars['String']['input']>;
  /** Beacon identifier (e.g., "17-bcn-101") */
  beaconId: Scalars['String']['input'];
  /** Beacon type: STAFF (fixed) or RESIDENT (wearable) */
  beaconType: Scalars['String']['input'];
  /** iBeacon UUID */
  beaconUuid: Scalars['String']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Physical location note */
  locationNote?: InputMaybe<Scalars['String']['input']>;
  /** iBeacon major value */
  major: Scalars['Int']['input'];
  /** iBeacon minor value (unique per beacon in facility) */
  minor: Scalars['Int']['input'];
  /** Hardware model */
  model: Scalars['String']['input'];
  /** Zone this beacon is deployed in (null for wearable beacons) */
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for registering a completed document (from Forms/Report Engine) */
export type RegisterDocumentInput = {
  /** Content hash (SHA-256) */
  contentHash: Scalars['String']['input'];
  /** Created by user ID (admin who requested generation) */
  createdByUserId: Scalars['String']['input'];
  /** Optional description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Document type */
  documentType: GqlGeneratedDocumentType | '%future added value';
  /** Encryption algorithm (e.g., "AES-256-GCM") */
  encryptionAlgorithm: Scalars['String']['input'];
  /** KMS encryption key ID */
  encryptionKeyId: Scalars['String']['input'];
  /** File size in bytes */
  fileSizeBytes: Scalars['Int']['input'];
  /** Job ID from SQS */
  jobId: Scalars['String']['input'];
  /** KMS ciphertext blob (base64) */
  kmsCiphertextBlob: Scalars['String']['input'];
  /** MIME type */
  mimeType: Scalars['String']['input'];
  /** Owner user ID */
  ownerUserId: Scalars['String']['input'];
  /** Source entity ID */
  sourceEntityId: Scalars['String']['input'];
  /** Source entity type ("employee", "patient", "custom") */
  sourceEntityType: Scalars['String']['input'];
  /** Source subgraph ("payroll", "healthcare", "core") */
  sourceSubgraph: Scalars['String']['input'];
  /** Wasabi storage bucket */
  storageBucket: Scalars['String']['input'];
  /** Wasabi storage key */
  storageKey: Scalars['String']['input'];
  /** Tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tax year (optional, for W-2/1099) */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
  /** Display title */
  title: Scalars['String']['input'];
};

/** Register a new webhook endpoint for ceremony lifecycle events (D1). */
export type RegisterWebhookInput = {
  /** Event filter. Use `["*"]` to subscribe to all ceremony events. */
  events: Array<Scalars['String']['input']>;
  /** Optional HMAC-SHA256 signing secret for payload verification. */
  secret?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** A config type definition from the registry. */
export type RegistryConfigType = {
  __typename?: 'RegistryConfigType';
  /** Dimension definitions for this config type */
  dimensions: Array<RegistryDimensionDef>;
  /** Regex pattern for valid filenames */
  filenamePattern: Scalars['String']['output'];
  /** Filename prefix (e.g., "wf", "rl") */
  filenamePrefix: Scalars['String']['output'];
  /** DRR-089 filename template (e.g., "wf-{subgraph}-{category}-{seq}") */
  filenameTemplate?: Maybe<Scalars['String']['output']>;
  /** YAML ID field name (e.g., "workflow_id") */
  idField: Scalars['String']['output'];
  /** Whether this uses a legacy SK pattern */
  legacySk: Scalars['Boolean']['output'];
  /** Config type name (e.g., "workflow", "rule") */
  name: Scalars['String']['output'];
  /** Seed loader Rust type name */
  seedLoader?: Maybe<Scalars['String']['output']>;
  /** Compressed SK template (e.g., "cA{id}") */
  skCompressed: Scalars['String']['output'];
  /** Verbose SK template (e.g., "CFG#WORKFLOW#{id}") */
  skVerbose: Scalars['String']['output'];
  /** Directories scanned for YAML configs */
  sourceDirs: Array<Scalars['String']['output']>;
  /** Compression symbol (e.g., "A", "D") */
  symbol: Scalars['String']['output'];
};

/** A dimension code table — maps human-readable values to sequential numeric codes. */
export type RegistryDimensionCode = {
  __typename?: 'RegistryDimensionCode';
  /** Sequential numeric code (e.g., "0", "1") */
  code: Scalars['String']['output'];
  /** Human-readable value (e.g., "federal", "MN") */
  value: Scalars['String']['output'];
};

/** A single dimension definition within a config type. */
export type RegistryDimensionDef = {
  __typename?: 'RegistryDimensionDef';
  /** Default value if not specified */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Example values */
  examples: Array<Scalars['String']['output']>;
  /** What dimension code table this maps to */
  mapsTo?: Maybe<Scalars['String']['output']>;
  /** Dimension name (e.g., "jurisdiction", "setting") */
  name: Scalars['String']['output'];
  /** Where the dimension value comes from */
  source?: Maybe<Scalars['String']['output']>;
  /** How it's stored (always "edge" per DRR-075) */
  storage?: Maybe<Scalars['String']['output']>;
};

/** A complete dimension code table. */
export type RegistryDimensionTable = {
  __typename?: 'RegistryDimensionTable';
  /** All codes in this dimension */
  codes: Array<RegistryDimensionCode>;
  /** Number of codes in this table */
  count: Scalars['Int']['output'];
  /** Dimension name (e.g., "jurisdiction", "category") */
  name: Scalars['String']['output'];
};

/** Full registry overview with stats. */
export type RegistryOverview = {
  __typename?: 'RegistryOverview';
  /** Total config types */
  configTypeCount: Scalars['Int']['output'];
  /** Total dimension code tables */
  dimensionTableCount: Scalars['Int']['output'];
  /** Registry format version */
  registryVersion: Scalars['String']['output'];
  /** Total individual dimension codes across all tables */
  totalDimensionCodes: Scalars['Int']['output'];
  /** Valkey index pattern */
  valkeyIndexPattern?: Maybe<Scalars['String']['output']>;
  /** Wasabi key pattern */
  wasabiKeyPattern?: Maybe<Scalars['String']['output']>;
};

/** Regulatory requirement for the workflow. */
export type Regulation = {
  __typename?: 'Regulation';
  /** Regulatory framework (HIPAA, SOX, FDA, GDPR, etc.) */
  framework: Scalars['String']['output'];
  /** Regulation ID */
  id: Scalars['String']['output'];
  /** Regulation name */
  name: Scalars['String']['output'];
  /** Specific requirement text */
  requirement: Scalars['String']['output'];
  /** How compliance is verified */
  verificationMethod: Scalars['String']['output'];
};

/**
 * Regulatory authority type for multi-jurisdictional compliance
 * LIFE-CRITICAL: Regulatory intersection resolution
 */
export type RegulatoryAuthorityTypeGql = {
  __typename?: 'RegulatoryAuthorityTypeGql';
  applicableIndustries: Array<Scalars['String']['output']>;
  authorityType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  jurisdictionLevel: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Regulatory compliance configuration for GraphQL
 * LIFE-CRITICAL: Stores tenant-specific compliance thresholds to prevent discrimination
 */
export type RegulatoryComplianceConfigGql = {
  __typename?: 'RegulatoryComplianceConfigGql';
  configData: Scalars['JSON']['output'];
  configType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tenant: Scalars['String']['output'];
};

export type RegulatoryImpactGql = {
  __typename?: 'RegulatoryImpactGql';
  complianceRiskScore: Scalars['Int']['output'];
  fda21CfrPart11Impact: RegulatoryImpactLevel | '%future added value';
  gdprImpact: RegulatoryImpactLevel | '%future added value';
  hipaaImpact: RegulatoryImpactLevel | '%future added value';
  pciDssImpact: RegulatoryImpactLevel | '%future added value';
  regulatoryApprovalRequired: Scalars['Boolean']['output'];
  soxImpact: RegulatoryImpactLevel | '%future added value';
};

export const RegulatoryImpactLevel = {
  minor: 'minor',
  moderate: 'moderate',
  none: 'none',
  significant: 'significant',
} as const;

export type RegulatoryImpactLevel =
  (typeof RegulatoryImpactLevel)[keyof typeof RegulatoryImpactLevel];
/**
 * Regulatory threshold representation for GraphQL
 * LIFE-CRITICAL: Tenant-configurable thresholds with audit-friendly metadata
 */
export type RegulatoryThresholdGql = {
  __typename?: 'RegulatoryThresholdGql';
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  frameworkId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  numericValue: Scalars['Float']['output'];
  sourceAuthority?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  thresholdType: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

/** Batch query input for thresholds */
export type RegulatoryThresholdQueryInput = {
  frameworkId: Scalars['String']['input'];
  thresholdType: Scalars['String']['input'];
};

/** Input for rejecting a single extraction */
export type RejectExtractionInput = {
  extractionId: Scalars['String']['input'];
  mappingId: Scalars['String']['input'];
  /** Reason for rejection (required) */
  reason: Scalars['String']['input'];
  reviewerId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Input for rejecting JIT request */
export type RejectJitRequestInput = {
  reason: Scalars['String']['input'];
  rejectedBy: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Response for reject JIT request mutation */
export type RejectJitRequestResult = {
  __typename?: 'RejectJITRequestResult';
  message: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Input for rejecting LLM fixes */
export type RejectLlmFixInput = {
  /** Recommendation ID to reject */
  recommendationId: Scalars['String']['input'];
  /** Optional rejection reason */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** Template ID */
  templateId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for rejecting a rule from the review queue */
export type RejectRuleInput = {
  /** Reason for rejection (required) */
  reason: Scalars['String']['input'];
  /** Reviewer ID (user rejecting) */
  reviewerId: Scalars['String']['input'];
  /** Rule ID to reject */
  ruleId: Scalars['String']['input'];
  /** Suggested corrections (optional) */
  suggestedCorrections?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for rejecting a witness request */
export type RejectWitnessRequestInput = {
  /** Reason for rejection */
  reason: Scalars['String']['input'];
  /** Request ID to reject */
  requestId: Scalars['String']['input'];
};

/** Summary count of related nodes by primitive type */
export type RelatedCount = {
  __typename?: 'RelatedCount';
  /** Number of related nodes of this type */
  count: Scalars['Int']['output'];
  /** Relationship label */
  edgeLabel: Scalars['String']['output'];
  /** Primitive type name */
  primitiveType: Scalars['String']['output'];
};

/** * Related entity reference (DOMAIN-AGNOSTIC) */
export type RelatedEntityOutput = {
  __typename?: 'RelatedEntityOutput';
  /** Related entity ID */
  entityId: Scalars['String']['output'];
  /** Related entity type */
  entityType: Scalars['String']['output'];
  /** Relationship metadata */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Relationship type (e.g., "PARENT", "CHILD", "DEPENDS_ON") */
  relationshipType: Scalars['String']['output'];
};

/** An edge in the relationship explorer graph */
export type RelationshipEdge = {
  __typename?: 'RelationshipEdge';
  /** Direction relative to center */
  direction: RelationshipEdgeDirection | '%future added value';
  /** Relationship type (e.g., "has_tasks", "assigned_to") */
  edgeType: Scalars['String']['output'];
  /** Human-readable label */
  label: Scalars['String']['output'];
  /** Source node ID */
  sourceId: Scalars['String']['output'];
  /** Target node ID */
  targetId: Scalars['String']['output'];
};

/** Direction of the relationship edge */
export const RelationshipEdgeDirection = {
  /** Center node is the child */
  INCOMING: 'INCOMING',
  /** Center node is the parent */
  OUTGOING: 'OUTGOING',
  /** Field reference (e.g., task.assigned_actor_id) */
  REFERENCE: 'REFERENCE',
} as const;

export type RelationshipEdgeDirection =
  (typeof RelationshipEdgeDirection)[keyof typeof RelationshipEdgeDirection];
/** Full relationship explorer response */
export type RelationshipExplorerResult = {
  __typename?: 'RelationshipExplorerResult';
  /** Center node */
  center: RelationshipNode;
  /** All edges */
  edges: Array<RelationshipEdge>;
  /** All nodes (including center) */
  nodes: Array<RelationshipNode>;
  /** Summary: count of related nodes by primitive type */
  relatedCounts: Array<RelatedCount>;
};

/** A node in the relationship explorer graph */
export type RelationshipNode = {
  __typename?: 'RelationshipNode';
  /** Number of this node's own children (for "load more" affordance) */
  childCount: Scalars['Int']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** Additional metadata */
  metadata: Array<RelationshipNodeMetadata>;
  /** Unique node ID (format: primitiveType:instanceId) */
  nodeId: Scalars['String']['output'];
  /** Lifecycle phase (for color coding) */
  phase: PrimitivePhase | '%future added value';
  /** Primitive type (e.g., "task", "workflow", "actor") */
  primitiveType: Scalars['String']['output'];
  /** Ring number (0 = center, 1 = direct) */
  ring: Scalars['Int']['output'];
  /** Role in the graph */
  role: RelationshipNodeRole | '%future added value';
  /** Status if available */
  status?: Maybe<Scalars['String']['output']>;
};

/** A key-value metadata pair on a node */
export type RelationshipNodeMetadata = {
  __typename?: 'RelationshipNodeMetadata';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Role a node plays in the relationship graph */
export const RelationshipNodeRole = {
  /** The focal node at the center */
  CENTER: 'CENTER',
  /** Directly connected (1-hop) */
  RELATED: 'RELATED',
} as const;

export type RelationshipNodeRole = (typeof RelationshipNodeRole)[keyof typeof RelationshipNodeRole];
export type ReliabilityImprovementGql = {
  __typename?: 'ReliabilityImprovementGql';
  availabilityIncreasePct: Scalars['Float']['output'];
  mttrReductionPct: Scalars['Float']['output'];
  slaComplianceImprovementPct: Scalars['Float']['output'];
};

/** Input for removing a component reference */
export type RemoveComponentInput = {
  id: Scalars['ID']['input'];
};

/** Input for removing a scope edge. */
export type RemoveScopeEdgeInput = {
  /** Relationship type */
  edgeType: ScopeEdgeType | '%future added value';
  /** Source actor ID (parent) */
  sourceActorId: Scalars['String']['input'];
  /** Target actor ID (child) */
  targetActorId: Scalars['String']['input'];
};

/** Remove feature from subgraph input */
export type RemoveSubgraphFeatureInput = {
  /** Feature to disable */
  feature: Scalars['String']['input'];
  /** Subgraph identifier */
  subgraphName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for HTML-based PDF rendering (DRR-079 migration) */
export type RenderHtmlPdfInput = {
  /** Optional: return HTML instead of PDF (for debugging) */
  debugHtml?: Scalars['Boolean']['input'];
  /** Template ID from agent service (e.g., "hc-alf-competency-record") */
  templateId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** Template variables as JSON object string */
  variablesJson: Scalars['String']['input'];
};

/** Result of HTML-based PDF rendering */
export type RenderHtmlPdfResult = {
  __typename?: 'RenderHtmlPdfResult';
  /** Content type (application/pdf or text/html for debug) */
  contentType: Scalars['String']['output'];
  /** Document primitive ID for the generated PDF */
  documentId: Scalars['String']['output'];
  /** Pre-signed download URL (valid for 1 hour) */
  downloadUrl: Scalars['String']['output'];
  /** When the PDF was generated */
  generatedAt: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** S3 key where the PDF is stored */
  s3Key: Scalars['String']['output'];
  /** PDF file size in bytes */
  sizeBytes: Scalars['Int']['output'];
  /** Whether generation succeeded */
  success: Scalars['Boolean']['output'];
  /** Template ID used */
  templateId: Scalars['String']['output'];
};

/** Input for replanning a shift */
export type ReplanShiftInput = {
  /** Existing plan ID to replan */
  planId: Scalars['String']['input'];
  /** Reason (for manual trigger) */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Resource code (for resource unavailable trigger) */
  resourceCode?: InputMaybe<Scalars['String']['input']>;
  /** Staff ID (for callout trigger) */
  staffId?: InputMaybe<Scalars['String']['input']>;
  /** Subject ID (for admission/incident triggers) */
  subjectId?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** Trigger type */
  triggerType: ReplanTriggerType | '%future added value';
};

/** Replan trigger types */
export const ReplanTriggerType = {
  /** Emergency admission */
  EMERGENCY_ADMISSION: 'EMERGENCY_ADMISSION',
  /** Manual request */
  MANUAL_REQUEST: 'MANUAL_REQUEST',
  /** Resident incident */
  RESIDENT_INCIDENT: 'RESIDENT_INCIDENT',
  /** Resource unavailable */
  RESOURCE_UNAVAILABLE: 'RESOURCE_UNAVAILABLE',
  /** Staff called out */
  STAFF_CALLOUT: 'STAFF_CALLOUT',
} as const;

export type ReplanTriggerType = (typeof ReplanTriggerType)[keyof typeof ReplanTriggerType];
/** Recommendation level for GraphQL */
export const ReportRecommendationGql = {
  MONITOR: 'MONITOR',
  NO_ACTION: 'NO_ACTION',
  REVIEW_RECOMMENDED: 'REVIEW_RECOMMENDED',
  URGENT_REVIEW: 'URGENT_REVIEW',
} as const;

export type ReportRecommendationGql =
  (typeof ReportRecommendationGql)[keyof typeof ReportRecommendationGql];
/** Input for requesting a presigned download URL. */
export type RequestCeremonyDocumentUrlInput = {
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Input for requesting a pre-signed document download URL */
export type RequestDocumentDownloadUrlInput = {
  /** Document ID */
  documentId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for requesting an exchange download URL */
export type RequestExchangeDownloadUrlInput = {
  /** Document ID to download */
  documentId: Scalars['String']['input'];
  /** Relationship the document was pushed through */
  relationshipId: Scalars['String']['input'];
};

/** Input for requesting an exchange upload URL */
export type RequestExchangeUploadUrlInput = {
  /** Original filename */
  fileName: Scalars['String']['input'];
  /** File size in bytes */
  fileSizeBytes: Scalars['Int']['input'];
  /** MIME type (must be in DRR-081 allowlist) */
  fileType: Scalars['String']['input'];
  /** Relationship to push the document through */
  relationshipId: Scalars['String']['input'];
};

/** Response for request JIT access mutation */
export type RequestJitAccessResult = {
  __typename?: 'RequestJITAccessResult';
  expiresAt?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  requiresApproval: Scalars['Boolean']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Input for requesting LLM fix recommendations */
export type RequestLlmFixInput = {
  /** User requesting fixes (for audit trail) */
  requestedBy: Scalars['String']['input'];
  /** Template ID with validation errors */
  templateId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

export type RequestTerminologyOverrideInput = {
  definitionId: Scalars['String']['input'];
  proposedTerm: Scalars['String']['input'];
  rationale?: InputMaybe<Scalars['String']['input']>;
};

/** Reset Tenant Branding Input */
export type ResetTenantBrandingInput = {
  /** Company name (required) */
  companyName: Scalars['String']['input'];
  /** Industry for defaults (healthcare, dental, legal, finance) */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Subdomain (required) */
  subdomain: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for resolving a Condition (soft-delete to inactive/resolved/remission) */
export type ResolveConditionInput = {
  /** Dual control approvals (required if entered_in_error = true) */
  approvals?: Array<DualControlApprovalInput>;
  /** If true, marks as "entered-in-error" (requires dual control approval) */
  enteredInError?: Scalars['Boolean']['input'];
  /** Condition ID to resolve */
  id: Scalars['String']['input'];
  /** Reason for resolution (required for audit trail) */
  reason: Scalars['String']['input'];
  /** Resolution type (inactive, resolved, remission) */
  resolution?: ConditionResolutionInput | '%future added value';
};

/** Input for resolving a sync conflict */
export type ResolveSyncConflictInput = {
  /** The accepted value (device A, device B, or manually entered) */
  acceptedValue: Scalars['JSON']['input'];
  /** Conflict ID to resolve */
  conflictId: Scalars['String']['input'];
  /** Reason for the resolution (audit trail) */
  reason: Scalars['String']['input'];
};

/** A resolved terminology term with its source and statutory backing. */
export type ResolvedTerm = {
  __typename?: 'ResolvedTerm';
  /** Acceptable alternative terms (SAFE to use without approval) */
  acceptableAlternatives: Array<Scalars['String']['output']>;
  /** The canonical concept being defined (e.g., "Patient", "ULP") */
  concept: Scalars['String']['output'];
  /** Reference to the statutory definition (tag:def:* ID), if any */
  definitionRef?: Maybe<Scalars['String']['output']>;
  /** What the UI should display (e.g., "Resident", "Direct Care Staff") */
  display: Scalars['String']['output'];
  /** Full statutory definition text (for tooltips and compliance display) */
  legalDefinition?: Maybe<Scalars['String']['output']>;
  /** Where this term came from */
  source: TermSource | '%future added value';
  /** Statute section reference (e.g., "MN 144G.08 Subd 7") */
  statuteRef?: Maybe<Scalars['String']['output']>;
};

/** GraphQL output type for Resource primitive */
export type Resource = {
  __typename?: 'Resource';
  accessAuditEnabled: Scalars['Boolean']['output'];
  acquisitionCost: Scalars['Float']['output'];
  allowOverbooking: Scalars['Boolean']['output'];
  anomalyScore?: Maybe<Scalars['Float']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedReason?: Maybe<Scalars['String']['output']>;
  assetTag?: Maybe<Scalars['String']['output']>;
  autoReleaseMinutes: Scalars['Int']['output'];
  availableCapacity: Scalars['Float']['output'];
  avgUtilizationPercent: Scalars['Float']['output'];
  barcode?: Maybe<Scalars['String']['output']>;
  bookingWindowDays: Scalars['Int']['output'];
  certifications: Array<Scalars['String']['output']>;
  complianceStatus: GqlComplianceStatus | '%future added value';
  /** Compressed ID format (lazy-loaded from cache/DynamoDB) */
  compressedId?: Maybe<Scalars['String']['output']>;
  concurrentUsageAllowed: Scalars['Boolean']['output'];
  conflictResolution: GqlConflictResolution | '%future added value';
  correlationId?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this resource */
  createdByActor?: Maybe<ActorSummary>;
  currentQuantity: Scalars['Float']['output'];
  currentValue: Scalars['Float']['output'];
  decommissionDate?: Maybe<Scalars['DateTime']['output']>;
  depreciationMethod: GqlDepreciationMethod | '%future added value';
  depreciationRate: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  efficiencyRating: Scalars['Float']['output'];
  extendedMetadata: Scalars['JSON']['output'];
  idleTimePercent: Scalars['Float']['output'];
  inUseCapacity: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isConsumable: Scalars['Boolean']['output'];
  isLifeCriticalResource: Scalars['Boolean']['output'];
  isPhysical: Scalars['Boolean']['output'];
  lastAuditDate?: Maybe<Scalars['DateTime']['output']>;
  lastMaintenanceDate?: Maybe<Scalars['DateTime']['output']>;
  lastSterilizationDate?: Maybe<Scalars['DateTime']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  lifecycleStage: GqlResourceLifecycleStage | '%future added value';
  lifecycleStartDate?: Maybe<Scalars['DateTime']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  maintenanceIntervalDays: Scalars['Int']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  maxBookingDurationMinutes: Scalars['Int']['output'];
  maxConcurrentUsers: Scalars['Int']['output'];
  minBookingDurationMinutes: Scalars['Int']['output'];
  minimumReserve: Scalars['Float']['output'];
  modelNumber?: Maybe<Scalars['String']['output']>;
  monthlyCost: Scalars['Float']['output'];
  nextMaintenanceDate?: Maybe<Scalars['DateTime']['output']>;
  originalId: Scalars['String']['output'];
  /** WHO owns this resource */
  ownerActor?: Maybe<ActorSummary>;
  ownerId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parentResourceId?: Maybe<Scalars['String']['output']>;
  peakUsageDay?: Maybe<Scalars['String']['output']>;
  peakUsageHour?: Maybe<Scalars['Int']['output']>;
  peakUtilizationPercent: Scalars['Float']['output'];
  reorderThreshold?: Maybe<Scalars['Float']['output']>;
  requiresApprovalForUse: Scalars['Boolean']['output'];
  requiresCertification: Scalars['Boolean']['output'];
  reservationEnabled: Scalars['Boolean']['output'];
  reservedCapacity: Scalars['Float']['output'];
  resourceCategory: Scalars['String']['output'];
  resourceCode: Scalars['String']['output'];
  resourceId: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
  resourceStatus: GqlResourceStatus | '%future added value';
  resourceSubcategory?: Maybe<Scalars['String']['output']>;
  resourceType: GqlResourceType | '%future added value';
  restrictedToRoles: Array<Scalars['String']['output']>;
  retirementDate?: Maybe<Scalars['DateTime']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sterilizationCycleCount: Scalars['Int']['output'];
  sterilizationRequired: Scalars['Boolean']['output'];
  tags: Array<Scalars['String']['output']>;
  totalCapacity: Scalars['Float']['output'];
  totalCostToDate: Scalars['Float']['output'];
  totalDowntimeHours: Scalars['Float']['output'];
  totalUsageCount: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** WHO last updated this resource */
  updatedByActor?: Maybe<ActorSummary>;
  usageTrend: GqlTrendDirection | '%future added value';
  utilizationRatePercent: Scalars['Float']['output'];
  warrantyExpiryDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ResourceLimitsInput = {
  /** Maximum actor instances */
  maxActorInstances?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum API requests per hour */
  maxApiRequestsPerHour?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum concurrent workflows */
  maxConcurrentWorkflows?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum storage usage in bytes */
  maxStorageBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Rate limiting configuration */
  rateLimits?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Represents a link to a related resource (hypermedia link)
 *
 * ## HATEOAS Principle
 *
 * Enables clients to discover related resources without hardcoding URLs or relationships.
 *
 * ## Example
 *
 * ```json
 * {
 * "resourceType": "company",
 * "id": "acme-corp",
 * "url": "/companies/acme-corp",
 * "relationship": "owner",
 * "title": "ACME Corporation"
 * }
 * ```
 */
export type ResourceLink = {
  __typename?: 'ResourceLink';
  /** Resource ID (backend Snowflake ID) */
  id: Scalars['String']['output'];
  /** Relationship to current resource (owner, trigger, approver, etc.) */
  relationship: Scalars['String']['output'];
  /** Type of resource (company, tax_change, user, document, etc.) */
  resourceType: Scalars['String']['output'];
  /** Human-readable title/name of resource */
  title?: Maybe<Scalars['String']['output']>;
  /** URL or path to resource */
  url: Scalars['String']['output'];
};

/** GraphQL output type for ResourceScope. */
export type ResourceScope = {
  __typename?: 'ResourceScope';
  /** Constraint type */
  constraintType: RoleConstraintMode | '%future added value';
  /** Specific resource IDs */
  resourceIds: Array<Scalars['String']['output']>;
  /** Resource type */
  resourceType: Scalars['String']['output'];
};

/** GraphQL input type for ResourceScope. */
export type ResourceScopeInput = {
  /** Constraint type */
  constraintType: RoleConstraintMode | '%future added value';
  /** Resource IDs */
  resourceIds: Array<Scalars['String']['input']>;
  /** Resource type */
  resourceType: Scalars['String']['input'];
};

/** Input for resuming accumulator */
export type ResumeAccumulatorInput = {
  resetConfidence?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type RetryFailedNodeInput = {
  executionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
};

export type RetryPolicy = {
  __typename?: 'RetryPolicy';
  backoffMs: Scalars['Int']['output'];
  exponential: Scalars['Boolean']['output'];
  maxAttempts: Scalars['Int']['output'];
  maxBackoffMs: Scalars['Int']['output'];
};

/** Input for reviewing an architect proposal (DRR-227) */
export type ReviewArchitectProposalInput = {
  /** Approve or reject? */
  approved: Scalars['Boolean']['input'];
  /** Proposal ID */
  proposalId: Scalars['String']['input'];
  /** Reason (required for rejection) */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Revision Item (GraphQL output) */
export type RevisionItem = {
  __typename?: 'RevisionItem';
  /** Field ID */
  fieldId: Scalars['String']['output'];
  /** Issue description */
  issue: Scalars['String']['output'];
  /** Suggested fix */
  suggestedFix?: Maybe<Scalars['String']['output']>;
};

/** Revision Item Input */
export type RevisionItemInput = {
  /** Field ID */
  fieldId: Scalars['String']['input'];
  /** Issue description */
  issue: Scalars['String']['input'];
  /** Suggested fix */
  suggestedFix?: InputMaybe<Scalars['String']['input']>;
};

/** Input for revoking a document */
export type RevokeDocumentInput = {
  /** Document ID to revoke */
  documentId: Scalars['String']['input'];
  /** Reason for revocation */
  reason: Scalars['String']['input'];
};

/** Revoke Emergency Access Result (GraphQL output) */
export type RevokeEmergencyAccessResult = {
  __typename?: 'RevokeEmergencyAccessResult';
  /** Incident ID */
  incidentId: Scalars['String']['output'];
  /** Revocation timestamp */
  revokedAt: Scalars['DateTime']['output'];
  /** User who revoked access */
  revokedBy: Scalars['String']['output'];
  revokedByName: Scalars['String']['output'];
  /** Success flag */
  success: Scalars['Boolean']['output'];
};

/** Input for revoking an exchange relationship */
export type RevokeExchangeRelationshipInput = {
  /** Reason for revocation (audit trail) */
  reason: Scalars['String']['input'];
  /** Relationship to revoke */
  relationshipId: Scalars['String']['input'];
};

/** Result of revoking a grant */
export type RevokeGrantResult = {
  __typename?: 'RevokeGrantResult';
  /** Error message if failed */
  error?: Maybe<Scalars['String']['output']>;
  /** When the grant was revoked */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether revocation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Input for revoking JIT session */
export type RevokeJitSessionInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  revokedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Response for revoke JIT session mutation */
export type RevokeJitSessionResult = {
  __typename?: 'RevokeJITSessionResult';
  message: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Revoke Role Input */
export type RevokeRoleInput = {
  /** Reason for revocation (required for audit) */
  reason: Scalars['String']['input'];
  /** Role ID */
  roleId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** User ID */
  userId: Scalars['String']['input'];
};

/** Input for revoking all user documents */
export type RevokeUserDocumentsInput = {
  /** Reason for revocation */
  reason: Scalars['String']['input'];
  /** User whose documents to revoke */
  userId: Scalars['String']['input'];
};

export type RiskAssessmentGql = {
  __typename?: 'RiskAssessmentGql';
  approvalRequirements: Array<ApprovalRequirementGql>;
  implementationRisk: RiskLevel | '%future added value';
  monitoringRequirements: Array<Scalars['String']['output']>;
  rollbackComplexity: RollbackComplexity | '%future added value';
  testingRequirements: Array<Scalars['String']['output']>;
};

export const RiskLevel = {
  high: 'high',
  low: 'low',
  medium: 'medium',
} as const;

export type RiskLevel = (typeof RiskLevel)[keyof typeof RiskLevel];
/** * Risk level enumeration */
export const RiskLevelOutput = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
} as const;

export type RiskLevelOutput = (typeof RiskLevelOutput)[keyof typeof RiskLevelOutput];
/** GraphQL output type for Role primitive. */
export type Role = {
  __typename?: 'Role';
  /** Soft delete flag */
  active: Scalars['Boolean']['output'];
  /** Financial and resource limits for approval authority */
  approvalLimits?: Maybe<ApprovalLimits>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this role.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** When this role was created (Unix ms) */
  createdAt: Scalars['Int']['output'];
  /** Who created this role */
  createdBy: Scalars['String']['output'];
  /** Role purpose and responsibilities */
  description?: Maybe<Scalars['String']['output']>;
  /** Optional validity period */
  effectiveDateRange?: Maybe<RoleDateRange>;
  /** Organizational hierarchy depth (0 = top) */
  hierarchyLevel: Scalars['Int']['output'];
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Parent role IDs (multiple inheritance) */
  inheritsFrom: Array<Scalars['String']['output']>;
  /** Record active flag (append-only lifecycle) */
  isActive: Scalars['Boolean']['output'];
  /** Extensible metadata (AWS integration, etc.) */
  metadata: Scalars['JSON']['output'];
  /** Original ID for version chain root */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Parent ID for append-only versioning */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Permission evaluation mode (Allow/Deny) */
  permissionMode: GqlPermissionMode | '%future added value';
  /** Granted permissions */
  permissions: Array<Permission>;
  /** Record version number (append-only) */
  recordVersion: Scalars['Int']['output'];
  /** Approval IDs requiring this role */
  requiredForApprovals: Array<Scalars['String']['output']>;
  /** Resource-level constraints */
  resourceScopes: Array<ResourceScope>;
  /** Organizational category */
  roleCategory: GqlRoleCategory | '%future added value';
  /** Role name (UNIQUE within tenant) */
  roleName: Scalars['String']['output'];
  /** Searchable tags */
  tags: Array<Scalars['String']['output']>;
  /** When this role was last updated (Unix ms) */
  updatedAt: Scalars['Int']['output'];
  /** Who last updated this role */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Audit version (optimistic locking) */
  version: Scalars['Int']['output'];
};

/** GraphQL connection type for paginated role lists. */
export type RoleConnection = {
  __typename?: 'RoleConnection';
  /** Has more results */
  hasMore: Scalars['Boolean']['output'];
  /** Role items */
  items: Array<Role>;
  /** Next page cursor */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL enum for role constraint mode (inclusive/exclusive).
 *
 * Different from ConstraintType in constraint_api which describes constraint categories.
 */
export const RoleConstraintMode = {
  /** All resource IDs except these are allowed (blacklist) */
  EXCLUSIVE: 'EXCLUSIVE',
  /** Only these resource IDs are allowed (whitelist) */
  INCLUSIVE: 'INCLUSIVE',
} as const;

export type RoleConstraintMode = (typeof RoleConstraintMode)[keyof typeof RoleConstraintMode];
/** GraphQL output type for DateRange in role context. */
export type RoleDateRange = {
  __typename?: 'RoleDateRange';
  /** End date (role becomes inactive) */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Start date (role becomes active) */
  startDate: Scalars['DateTime']['output'];
};

/** Role Definition Output */
export type RoleDefinition = {
  __typename?: 'RoleDefinition';
  /** Capabilities */
  capabilities: Array<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created by */
  createdBy: Scalars['String']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Enabled flag */
  enabled: Scalars['Boolean']['output'];
  /** Parent roles */
  inheritsFrom: Array<Scalars['String']['output']>;
  /** Role ID */
  roleId: Scalars['String']['output'];
  /** Role name */
  roleName: Scalars['String']['output'];
  /** Scopes */
  scopes: Array<Scalars['String']['output']>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Updated at */
  updatedAt: Scalars['DateTime']['output'];
  /** Updated by */
  updatedBy: Scalars['String']['output'];
};

/** GraphQL output type for role hierarchy. */
export type RoleHierarchy = {
  __typename?: 'RoleHierarchy';
  /** All ancestor roles (recursive) */
  ancestors: Array<Role>;
  /** Child roles (roles that inherit from this one) */
  children: Array<Role>;
  /** Inheritance depth (0 = root role) */
  depth: Scalars['Int']['output'];
  /** Parent roles */
  parents: Array<Role>;
  /** Current role */
  role: Role;
};

/** A set of role IDs with a display label. */
export type RoleSetInput = {
  /** Display label (e.g., "ALD", "CNA", "DON") */
  label: Scalars['String']['input'];
  /** Role IDs for this comparison entry */
  roleIds: Array<Scalars['String']['input']>;
};

export type RoleTemplate = {
  __typename?: 'RoleTemplate';
  category: Scalars['String']['output'];
  complianceFrameworks: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  roleDefinition: TemplateRoleDefinition;
  status: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

/** Rollback Bulk Operation Input */
export type RollbackBulkOperationInput = {
  /** Batch ID to rollback */
  batchId: Scalars['String']['input'];
  /** Rollback reason (required for audit) */
  reason: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

export const RollbackComplexity = {
  complex: 'complex',
  moderate: 'moderate',
  simple: 'simple',
} as const;

export type RollbackComplexity = (typeof RollbackComplexity)[keyof typeof RollbackComplexity];
/** Input for rollback request */
export type RollbackPolicyInput = {
  /** Policy ID */
  policyId: Scalars['String']['input'];
  /** User ID performing rollback */
  rollbackBy: Scalars['String']['input'];
  /** Reason for rollback */
  rollbackReason: Scalars['String']['input'];
  /** Target version number to rollback to */
  targetVersion: Scalars['Int']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Rollback Template Input */
export type RollbackTemplateInput = {
  /** Reason for rollback */
  rollbackReason: Scalars['String']['input'];
  /** Target version number to rollback to */
  targetVersion: Scalars['Int']['input'];
  /** Template ID */
  templateId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Row Result Output */
export type RowResult = {
  __typename?: 'RowResult';
  /** Assignment ID (if successful) */
  assignmentId?: Maybe<Scalars['String']['output']>;
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Operation */
  operation: Operation | '%future added value';
  /** Role ID */
  roleId: Scalars['String']['output'];
  /** Role name */
  roleName: Scalars['String']['output'];
  /** Row number (1-indexed) */
  rowNumber: Scalars['Int']['output'];
  /** Row status */
  status: RowStatus | '%future added value';
  /** User ID */
  userId: Scalars['String']['output'];
};

/** Row Status Enum */
export const RowStatus = {
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
  SUCCESS: 'SUCCESS',
} as const;

export type RowStatus = (typeof RowStatus)[keyof typeof RowStatus];
/** Rule Conflict */
export type RuleConflict = {
  __typename?: 'RuleConflict';
  existingRule: Scalars['String']['output'];
  fieldPath: Scalars['String']['output'];
  newRule: Scalars['String']['output'];
  resolution: Scalars['String']['output'];
};

/** Input for querying rules by status or queue */
export type RuleFilterInput = {
  /** Filter by compliance domain */
  complianceDomain?: InputMaybe<GqlComplianceDomain | '%future added value'>;
  /** Maximum results (default: 50) */
  limit?: Scalars['Int']['input'];
  /** Offset for pagination */
  offset?: Scalars['Int']['input'];
  /** Filter by review queue */
  queue?: InputMaybe<GqlReviewQueue | '%future added value'>;
  /** Filter by safety level */
  safetyLevel?: InputMaybe<GqlSafetyLevel | '%future added value'>;
  /** Filter by status */
  status?: InputMaybe<GqlRuleStatus | '%future added value'>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/**
 * A RuleSet — legislation bundle or grouped rules with regulatory context.
 *
 * DRR-071: RuleSets group related rules under a compliance umbrella.
 * DRR-090: Rules-first constellation architecture.
 * DRR-096: Temporally-valid legislation packages.
 */
export type RuleSet = {
  __typename?: 'RuleSet';
  /** Form schema IDs affected */
  affectsFormSchemas: Array<Scalars['String']['output']>;
  /** Workflow IDs affected by this ruleset */
  affectsWorkflows: Array<Scalars['String']['output']>;
  /**
   * Date the law was signed / officially announced (not yet effective).
   *
   * ISO 8601 date string, e.g. "2025-06-15". Separate from `effective_date`
   * (compliance deadline). Enables pre-compliance readiness workflows (DRR-147).
   */
  announcedDate?: Maybe<Scalars['String']['output']>;
  /** Industries this ruleset applies to (e.g., ["assisted_living"]) */
  appliesToIndustries: Array<Scalars['String']['output']>;
  /**
   * Facility-level boolean flags that gate applicability of rules in this set.
   * e.g., ["ma_participating", "ferp_network_member", "has_dementia_care"]
   * Seeded from `applies_when_flags` array in YAML. Used for filter indexing
   * via `idx:cfg:rs:applies_when:{flag}` Valkey SET keys.
   */
  appliesWhenFlags: Array<Scalars['String']['output']>;
  /** Category / subgraph owner (e.g., "compliance", "fhir", "erp") */
  category: Scalars['String']['output'];
  /** Compliance frameworks (e.g., ["MN_MDH_ALF", "STATE_ALF"]) */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** RuleSet IDs this depends on (DAG) */
  dependsOn: Array<Scalars['String']['output']>;
  /** Description of this legislation bundle */
  description: Scalars['String']['output'];
  /** Human-readable display name */
  displayName: Scalars['String']['output'];
  /** Temporal validity — effective date (DRR-096) */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /**
   * Evaluation mode for this RuleSet.
   *
   * Values: `production` | `sandbox_warn` | `sandbox_simulation`
   *
   * `serde(default)` → existing DDB records missing this field = "production".
   * Gate 16 compliant. The evaluator uses this to intercept Action::Block.
   */
  evaluationMode: Scalars['String']['output'];
  /** Whether this RuleSet is currently effective (computed: effective_date <= now < sunset_date) */
  isCurrentlyEffective: Scalars['Boolean']['output'];
  /** Whether this contains life-critical rules */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Jurisdiction (e.g., "MN", "federal") */
  jurisdiction: Scalars['String']['output'];
  /** Summary of member rules in this bundle */
  memberRules: Array<RuleSummary>;
  /** Machine-readable name */
  name: Scalars['String']['output'];
  /** Override policy (how state/federal conflicts resolve) */
  overridePolicy?: Maybe<OverridePolicy>;
  /**
   * Phased rollout schedule for multi-phase legislation.
   *
   * Empty vec for single-phase rulesets (all existing rulesets).
   */
  phases: Array<LegislationPhase>;
  /**
   * DRR-219: Populations this ruleset applies to (for cross-cutting discovery).
   * e.g., ["vulnerable_adult", "minor", "dementia"]
   * Used for Valkey SET indexing via `idx:cfg:rs:population:{pop}`.
   */
  populationsServed: Array<Scalars['String']['output']>;
  /** Number of rules in this bundle */
  ruleCount: Scalars['Int']['output'];
  /** Rule IDs contained in this RuleSet */
  ruleIds: Array<Scalars['String']['output']>;
  /** Unique RuleSet identifier (e.g., "rs-4-1-004") */
  rulesetId: Scalars['String']['output'];
  /** Safety level: standard, high, critical */
  safetyLevel: Scalars['String']['output'];
  /** Sandbox visual config. Present only when `evaluation_mode != "production"`. */
  sandboxConfig?: Maybe<SandboxConfig>;
  /** Setting context (e.g., "general", "assisted_living") */
  setting: Scalars['String']['output'];
  /** Source legislation details (statute, authority, sections) */
  sourceLegislation?: Maybe<SourceLegislation>;
  /**
   * Lifecycle status of this RuleSet.
   *
   * Values: `draft` | `announced` | `pending` | `active` | `transitioning` |
   * `superseded` | `sunset`
   *
   * `serde(default)` → existing DDB records missing this field deserialize as "active".
   * Gate 16 compliant.
   */
  status: Scalars['String']['output'];
  /** Temporal validity — sunset date (null = still active) */
  sunsetDate?: Maybe<Scalars['String']['output']>;
  /** ID of the RuleSet version that supersedes this one — DRR-096 */
  supersededBy?: Maybe<Scalars['String']['output']>;
  /** ID of the RuleSet version this supersedes (e.g., "rs-4-1-001:1.0") — DRR-096 */
  supersedes?: Maybe<Scalars['String']['output']>;
  /** Workflow IDs triggered by this RuleSet */
  triggerWorkflows: Array<Scalars['String']['output']>;
  /** Version string (e.g., "1.0", "2.0") — DRR-096 */
  version?: Maybe<Scalars['String']['output']>;
  /**
   * Minimum scope required to view this RuleSet.
   *
   * - `null` → visible to all authenticated users (universal minimum)
   * - `"care:view"` → care delivery staff (clinical protocols, HCBS programs)
   * - `"compliance:view"` → compliance officers / administrators (full library)
   *
   * The `rule_sets` resolver filters rows by the caller's scopes server-side.
   */
  visibilityScope?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for multi-dimensional RuleSet queries (DRR-096).
 *
 * Each dimension is optional — only specified dimensions participate in
 * the Valkey SINTER intersection. Unspecified dimensions are ignored.
 * Dimension values come from `complianceFilterDimensions` — never hardcode.
 */
export type RuleSetDimensionFilter = {
  /**
   * Applies-when flag — rulesets that apply only when a facility has
   * a specific configuration flag set.
   * e.g., "ma_participating", "ferp_network_member", "has_dementia_care"
   */
  appliesWhen?: InputMaybe<Scalars['String']['input']>;
  /** Category (e.g., "compliance", "labor") */
  category?: InputMaybe<Scalars['String']['input']>;
  /**
   * Facility type — mirrors `industry` values but exposed as a distinct
   * filter dimension in the compliance browser UI.
   * e.g., "assisted_living", "aldf", "hcbs", "home_care"
   */
  facilityType?: InputMaybe<Scalars['String']['input']>;
  /** Industry code (e.g., "assisted_living", "home_care") */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Jurisdiction code (e.g., "MN", "federal") */
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  /**
   * Short statute citation filter — match rulesets by legislation name.
   * e.g., "MN 144G", "42 CFR 483"
   */
  legislation?: InputMaybe<Scalars['String']['input']>;
  /** Safety level (e.g., "critical", "standard") */
  safetyLevel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Lifecycle status filter (DRR-144).
   * e.g., "pending", "active", "announced"
   */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Rule severity for validation */
export const RuleSeverity = {
  /** Error, blocks progress */
  ERROR: 'ERROR',
  /** Informational only */
  INFO: 'INFO',
  /** Warning, can proceed */
  WARNING: 'WARNING',
} as const;

export type RuleSeverity = (typeof RuleSeverity)[keyof typeof RuleSeverity];
/** Summary of a member rule within a RuleSet. */
export type RuleSummary = {
  __typename?: 'RuleSummary';
  /** Survey checkpoint IDs this rule maps to (e.g., ["E-0001", "E-0004"]) */
  checkpoints: Array<Scalars['String']['output']>;
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** DRR-176: What evidence proves this provision is met */
  evidenceRequirements?: Maybe<Array<EvidenceRequirementDef>>;
  /** Evidence completeness status */
  evidenceStatus: Scalars['String']['output'];
  /** Machine-readable name */
  name: Scalars['String']['output'];
  /** Rule identifier */
  ruleId: Scalars['String']['output'];
  /** Statute section reference (e.g., "144G.71 Subd 6-7") */
  sectionRef?: Maybe<Scalars['String']['output']>;
};

/** Coverage summary for a single ruleset (lightweight, no gap details). */
export type RulesetCoverageSummary = {
  __typename?: 'RulesetCoverageSummary';
  /** Coverage percentage (0-100) */
  coveragePercent: Scalars['Int']['output'];
  /** Rules with downstream configs */
  coveredRules: Scalars['Int']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Human-readable name */
  displayName: Scalars['String']['output'];
  /** Number of gaps (uncovered rules) */
  gapCount: Scalars['Int']['output'];
  /** Jurisdiction (e.g., "MN") */
  jurisdiction: Scalars['String']['output'];
  /** Ruleset ID (e.g., "rs-4-1-004") */
  rulesetId: Scalars['String']['output'];
  /** Safety level */
  safetyLevel: Scalars['String']['output'];
  /** Setting context (e.g., "assisted_living") */
  setting: Scalars['String']['output'];
  /** Total member rules */
  totalRules: Scalars['Int']['output'];
};

export type RunDagScenarioInput = {
  baseWorkflowId: Scalars['ID']['input'];
  createdBy: Scalars['String']['input'];
  description: Scalars['String']['input'];
  parameterOverrides?: InputMaybe<Array<KeyValueInput>>;
  scenarioName: Scalars['String']['input'];
};

export type RuntimeContextInput = {
  device?: InputMaybe<DeviceTypeGql | '%future added value'>;
  emergencyMode: Scalars['Boolean']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  sessionContext?: InputMaybe<Scalars['JSON']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userPreferences?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Enhanced SafetyEvent Primitive with ~40 comprehensive audit fields
 * for life-critical healthcare, financial, and legal compliance
 */
export type SafetyEvent = {
  __typename?: 'SafetyEvent';
  /** Actor descriptor ID if actor-based execution */
  actorDescriptorId?: Maybe<Scalars['String']['output']>;
  /** List of affected entities (patients, accounts, documents, workflows) */
  affectedEntities: Array<AffectedEntity>;
  /** Immutable audit trail ID (cryptographic integrity) */
  auditTrailId: Scalars['String']['output'];
  /** Event category (PatientSafety, FinancialFraud, LegalPrivilege, DataBreach, SystemFailure) */
  category: Scalars['String']['output'];
  /** Event creation timestamp (audit trail) */
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable event description */
  description: Scalars['String']['output'];
  /** Whether emergency contacts were notified (life-critical events) */
  emergencyContactsNotified: Scalars['Boolean']['output'];
  /** List of user IDs escalated to */
  escalatedTo: Array<Scalars['String']['output']>;
  /** Current escalation level (L1, L2, L3, Emergency) */
  escalationLevel?: Maybe<Scalars['String']['output']>;
  /** Escalation path ID (from tenant Policy metadata) */
  escalationPathId?: Maybe<Scalars['String']['output']>;
  /** Timeline of escalation actions with timestamps */
  escalationTimestamps: Array<EscalationTimestamp>;
  /** Whether escalation was triggered */
  escalationTriggered: Scalars['Boolean']['output'];
  /** Unique event ID (Snowflake ID from backend) */
  eventId: Scalars['String']['output'];
  /** Specific event type (SafetyViolation, ThresholdExceeded, UnauthorizedAccess, etc.) */
  eventType: Scalars['String']['output'];
  /** Evidence data (screenshots, logs, transaction details) */
  evidence?: Maybe<Scalars['JSON']['output']>;
  /** Additional metadata (domain-specific context) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Parent event ID (for event hierarchies) */
  parentEventId?: Maybe<Scalars['String']['output']>;
  /** Specific primitive instance ID */
  primitiveInstanceId?: Maybe<Scalars['String']['output']>;
  /** Primitive type involved (wfl, ins, sig, exe, mon, gov, pol, esc, not, met, aud, rep, ana, opt, rel, lif) */
  primitiveType?: Maybe<Scalars['String']['output']>;
  /** Related event IDs (correlation for cascade failures) */
  relatedEventIds: Array<Scalars['String']['output']>;
  /** Actual completion timestamp */
  remediationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Deadline for remediation completion (regulatory requirement) */
  remediationDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Remediation notes and action log */
  remediationNotes?: Maybe<Scalars['String']['output']>;
  /** User ID assigned to remediate this event */
  remediationOwner?: Maybe<Scalars['String']['output']>;
  /** Whether remediation action is required */
  remediationRequired: Scalars['Boolean']['output'];
  /** Current remediation status (Pending, InProgress, Completed, Escalated) */
  remediationStatus?: Maybe<Scalars['String']['output']>;
  /** Rule ID that triggered this event (from tenant Policy metadata) */
  ruleId: Scalars['String']['output'];
  /** Current safety score (0.0-100.0) */
  safetyScore: Scalars['Float']['output'];
  /** Safety score change caused by this event */
  safetyScoreDelta?: Maybe<Scalars['Float']['output']>;
  /** SAGA execution ID if event occurred during distributed transaction */
  sagaExecutionId?: Maybe<Scalars['String']['output']>;
  /** Session ID for user action correlation */
  sessionId?: Maybe<Scalars['String']['output']>;
  /** Severity level (Critical, High, Medium, Low, Info) */
  severity: Scalars['String']['output'];
  /** Source IP address (security audit requirement) */
  sourceIp?: Maybe<Scalars['String']['output']>;
  /** Source system that generated the event */
  sourceSystem: Scalars['String']['output'];
  /** Tenant ID for multi-tenant isolation */
  tenantId: Scalars['String']['output'];
  /** Event occurrence timestamp (ISO 8601) */
  timestamp: Scalars['DateTime']['output'];
  /** Last update timestamp (for remediation tracking) */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID who triggered the event (or system if automated) */
  userId: Scalars['String']['output'];
  /** Workflow instance ID if event occurred during workflow execution */
  workflowInstanceId?: Maybe<Scalars['String']['output']>;
};

/** Comprehensive filter for querying safety events (life-critical search capabilities) */
export type SafetyEventFilter = {
  /** Filter by actor descriptor ID */
  actorDescriptorId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by affected entity IDs (specific patients, accounts, etc.) */
  affectedEntityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by affected entity types (Patient, Account, Document, etc.) */
  affectedEntityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by event categories (PatientSafety, FinancialFraud, LegalPrivilege, etc.) */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Cursor for cursor-based pagination (DynamoDB LastEvaluatedKey) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Filter by emergency contacts notified flag */
  emergencyContactsNotified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by escalated to user IDs */
  escalatedTo?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by escalation levels (L1, L2, L3, Emergency) */
  escalationLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by escalation triggered flag */
  escalationTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by specific event IDs (exact match) */
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by event types (SafetyViolation, ThresholdExceeded, etc.) */
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum number of results to return (default: 100, max: 1000) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum safety score threshold (0.0-100.0) */
  maxSafetyScore?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum safety score threshold (0.0-100.0) */
  minSafetyScore?: InputMaybe<Scalars['Float']['input']>;
  /** Offset for pagination (default: 0) */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by primitive instance ID */
  primitiveInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by primitive type (one of 16 FERP primitives) */
  primitiveType?: InputMaybe<Scalars['String']['input']>;
  /** Filter by overdue remediations (deadline passed) */
  remediationOverdue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by remediation owner (assigned user ID) */
  remediationOwner?: InputMaybe<Scalars['String']['input']>;
  /** Filter by remediation required flag */
  remediationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by remediation statuses (Pending, InProgress, Completed, Escalated) */
  remediationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by rule IDs (regulatory compliance rules) */
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by SAGA execution ID (distributed transaction tracking) */
  sagaExecutionId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by severity levels (Critical, High, Medium, Low, Info) */
  severities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sort field (timestamp, safety_score, severity, etc.) */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort order (asc, desc) */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  /** Filter by source IP address (security audit) */
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  /** Filter by source system */
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID for multi-tenant isolation (MANDATORY) */
  tenantId: Scalars['String']['input'];
  /** End timestamp for time range query (ISO 8601) */
  timestampEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start timestamp for time range query (ISO 8601) */
  timestampStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by user ID who triggered the event */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by workflow instance ID (workflow execution tracking) */
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Safety event notification for real-time monitoring (Sprint 6 Week 1)
 * Lightweight event for subscription delivery - full details via getSafetyEvent query
 */
export type SafetyEventNotification = {
  __typename?: 'SafetyEventNotification';
  /** Immutable audit trail ID */
  auditTrailId: Scalars['String']['output'];
  /** Event category (PatientSafety, FinancialFraud, LegalPrivilege, DataBreach, SystemFailure) */
  category: Scalars['String']['output'];
  /** Brief description for notification display */
  description: Scalars['String']['output'];
  /** Whether emergency contacts were notified */
  emergencyContactsNotified: Scalars['Boolean']['output'];
  /** Escalation level (L1, L2, L3, Emergency) */
  escalationLevel?: Maybe<Scalars['String']['output']>;
  /** Whether escalation was triggered */
  escalationTriggered: Scalars['Boolean']['output'];
  /** Event ID (Snowflake ID from backend) */
  eventId: Scalars['String']['output'];
  /** Specific event type (SafetyViolation, ThresholdExceeded, UnauthorizedAccess, etc.) */
  eventType: Scalars['String']['output'];
  /** Whether event is still staged in Redis (not yet flushed to DynamoDB) */
  isStaged: Scalars['Boolean']['output'];
  /** Whether remediation action is required */
  remediationRequired: Scalars['Boolean']['output'];
  /** Current safety score (0.0-100.0) */
  safetyScore: Scalars['Float']['output'];
  /** Safety score delta (change from previous) */
  safetyScoreDelta?: Maybe<Scalars['Float']['output']>;
  /** Severity level (Critical, High, Medium, Low, Info) */
  severity: Scalars['String']['output'];
  /** Tenant ID for multi-tenant isolation */
  tenant: Scalars['String']['output'];
  /** Event occurrence timestamp (ISO 8601) */
  timestamp: Scalars['String']['output'];
  /** User ID who triggered the event */
  userId: Scalars['String']['output'];
};

/**
 * Life-critical safety event for monitoring
 * DEPRECATED: Use SafetyEventPrimitive from types::safety_event instead
 * This type is kept for backwards compatibility with existing subscriptions
 */
export type SafetyEventSubscription = {
  __typename?: 'SafetyEventSubscription';
  auditTrailId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emergencyContactsNotified: Scalars['Boolean']['output'];
  escalationTriggered: Scalars['Boolean']['output'];
  eventId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  primitiveType?: Maybe<Scalars['String']['output']>;
  remediationRequired: Scalars['Boolean']['output'];
  ruleId: Scalars['String']['output'];
  safetyScore: Scalars['Float']['output'];
  sagaExecutionId?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** * Input for executiveSafetyMetrics query */
export type SafetyMetricsInput = {
  /** Include deprecated fields (patient_safety_index, financial_fraud_prevention, legal_privilege_protection) */
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tenant identifier */
  tenant: Scalars['String']['input'];
  /** Time window for metrics calculation in seconds (default: 86400 = 24 hours) */
  timeWindowSecs?: InputMaybe<Scalars['Int']['input']>;
};

export type SafetyOverride = {
  __typename?: 'SafetyOverride';
  overriddenBy: Scalars['String']['output'];
  overriddenByRole: Scalars['String']['output'];
  overrideDeviceId: Scalars['String']['output'];
  overrideIpAddress: Scalars['String']['output'];
  overrideReason: Scalars['String']['output'];
  overrideTimestamp: Scalars['DateTime']['output'];
  safetyCheckFailed: Scalars['String']['output'];
  supervisorApprovalId?: Maybe<Scalars['String']['output']>;
};

/** * Safety trend enumeration */
export const SafetyTrendOutput = {
  DECLINING: 'DECLINING',
  IMPROVING: 'IMPROVING',
  STABLE: 'STABLE',
} as const;

export type SafetyTrendOutput = (typeof SafetyTrendOutput)[keyof typeof SafetyTrendOutput];
export type SafetyValidationGql = {
  __typename?: 'SafetyValidationGql';
  emergencyProcedureImpact: Scalars['Boolean']['output'];
  financialIntegrityCheck: Scalars['Boolean']['output'];
  legalPrivilegeCheck: Scalars['Boolean']['output'];
  patientSafetyCheck: Scalars['Boolean']['output'];
  safetyBlockers: Array<Scalars['String']['output']>;
  safetyScore: Scalars['Int']['output'];
};

/** SAGA audit context for GraphQL */
export type SagaAuditContext = {
  __typename?: 'SagaAuditContext';
  /** Correlation ID for tracking */
  correlationId: Scalars['String']['output'];
  /** Operation initiator */
  initiator: Scalars['String']['output'];
  /** Operation type */
  operationType: Scalars['String']['output'];
  /** SAGA execution ID */
  sagaExecutionId: Scalars['String']['output'];
  /** Tenant ID (for isolation) */
  tenantId: Scalars['String']['output'];
  /** Operation timestamp */
  timestamp: Scalars['DateTime']['output'];
};

/** SAGA definition for GraphQL (data-driven structure) */
export type SagaDefinitionGql = {
  __typename?: 'SagaDefinitionGQL';
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** SAGA metadata from tenant configuration */
  metadata: Scalars['JSON']['output'];
  /** SAGA definition ID */
  sagaId: Scalars['String']['output'];
  /** SAGA steps configuration */
  steps: Array<SagaStepGql>;
  /** SAGA version */
  version: Scalars['String']['output'];
};

/** SAGA execution response */
export type SagaExecutionResponse = {
  __typename?: 'SagaExecutionResponse';
  /** Audit context for life-critical tracking */
  auditContext: SagaAuditContext;
  /** Current SAGA state */
  currentState: Scalars['String']['output'];
  /** Unique execution ID */
  executionId: Scalars['String']['output'];
  /** SAGA definition ID */
  sagaId: Scalars['String']['output'];
  /** Execution start timestamp */
  startedAt: Scalars['DateTime']['output'];
  /** Current execution status */
  status: SagaExecutionStatus | '%future added value';
};

/** SAGA execution status enumeration */
export const SagaExecutionStatus = {
  /** SAGA was cancelled */
  cancelled: 'cancelled',
  /** SAGA completed with compensation */
  compensated: 'compensated',
  /** SAGA is performing compensation */
  compensating: 'compensating',
  /** SAGA completed successfully */
  completed: 'completed',
  /** SAGA execution failed */
  failed: 'failed',
  /** SAGA is currently executing */
  inProgress: 'inProgress',
  /** SAGA is pending execution */
  pending: 'pending',
} as const;

export type SagaExecutionStatus = (typeof SagaExecutionStatus)[keyof typeof SagaExecutionStatus];
/** SAGA execution summary for listing */
export type SagaExecutionSummary = {
  __typename?: 'SagaExecutionSummary';
  /** Completion timestamp (if applicable) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current state */
  currentState: Scalars['String']['output'];
  /** Execution ID */
  executionId: Scalars['String']['output'];
  /** Initiator */
  initiator: Scalars['String']['output'];
  /** SAGA definition ID */
  sagaId: Scalars['String']['output'];
  /** Start timestamp */
  startedAt: Scalars['DateTime']['output'];
  /** Execution status */
  status: SagaExecutionStatus | '%future added value';
};

/** Domain-specific safety scores (data-driven from tenant config) */
export type SagaSafetyDomains = {
  __typename?: 'SagaSafetyDomains';
  /** Financial safety score (0-100, null if not applicable) */
  financial?: Maybe<Scalars['Float']['output']>;
  /** Healthcare safety score (0-100, null if not applicable) */
  healthcare?: Maybe<Scalars['Float']['output']>;
  /** Legal safety score (0-100, null if not applicable) */
  legal?: Maybe<Scalars['Float']['output']>;
  /** Operational safety score (0-100, null if not applicable) */
  operational?: Maybe<Scalars['Float']['output']>;
};

/** SAGA safety scores output (life-critical monitoring) */
export type SagaSafetyScores = {
  __typename?: 'SagaSafetyScores';
  /** Safety assessment ID */
  assessmentId: Scalars['String']['output'];
  /** Domain-specific safety scores */
  domains: SagaSafetyDomains;
  /** SAGA execution ID */
  executionId: Scalars['String']['output'];
  /** Additional metadata from tenant configuration */
  metadata: Scalars['JSON']['output'];
  /** Overall safety score (0-100) */
  overall: Scalars['Float']['output'];
  /** Assessment timestamp */
  timestamp: Scalars['DateTime']['output'];
  /** Safety violations detected */
  violations: Array<SagaSafetyViolation>;
};

/** Safety violation detected during SAGA execution */
export type SagaSafetyViolation = {
  __typename?: 'SagaSafetyViolation';
  /** Whether this violation blocks execution */
  blockingAction: Scalars['Boolean']['output'];
  /** When the violation was detected */
  createdAt: Scalars['DateTime']['output'];
  /** Domain where violation occurred */
  domain: Scalars['String']['output'];
  /** Violation ID */
  id: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Recommended remediation action */
  recommendation: Scalars['String']['output'];
  /** Violation severity */
  severity: SagaViolationSeverity | '%future added value';
  /** Type of violation */
  violationType: Scalars['String']['output'];
};

/** SAGA state transition event for real-time updates */
export type SagaStateTransitionEvent = {
  __typename?: 'SagaStateTransitionEvent';
  auditTrailId: Scalars['String']['output'];
  eventId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  executionResult?: Maybe<Scalars['JSON']['output']>;
  fromState: Scalars['String']['output'];
  performanceMetrics?: Maybe<Scalars['JSON']['output']>;
  primitiveType: Scalars['String']['output'];
  safetyScore?: Maybe<Scalars['Float']['output']>;
  sagaExecutionId: Scalars['String']['output'];
  stepId: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** SAGA step for GraphQL */
export type SagaStepGql = {
  __typename?: 'SagaStepGQL';
  /** Action handler identifier */
  actionHandler: Scalars['String']['output'];
  /** Optional compensation handler */
  compensationHandler?: Maybe<Scalars['String']['output']>;
  /** Step kind (sync/async/fire-and-forget) */
  kind: Scalars['String']['output'];
  /** Step metadata (includes primitive type) */
  metadata: Scalars['JSON']['output'];
  /** Step name */
  name: Scalars['String']['output'];
  /** Step identifier */
  stepId: Scalars['String']['output'];
  /** Step timeout in seconds */
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
};

/** Severity level for safety violations */
export const SagaViolationSeverity = {
  /** Blocking - execution cannot proceed */
  blocking: 'blocking',
  /** Critical - immediate action required */
  critical: 'critical',
  /** Error - requires attention */
  error: 'error',
  /** Informational - no action required */
  info: 'info',
  /** Warning - should be reviewed */
  warning: 'warning',
} as const;

export type SagaViolationSeverity =
  (typeof SagaViolationSeverity)[keyof typeof SagaViolationSeverity];
/**
 * Visual configuration for sandbox-mode RuleSets.
 *
 * Backend controls all visual indicators — frontend is dumb (DRR-055).
 * Color is constrained to amber/yellow/orange range only.
 * Never green (false clear) or red (false emergency).
 */
export type SandboxConfig = {
  __typename?: 'SandboxConfig';
  /** Banner message shown in UI (e.g., "Sandbox: Simulating proposed 144G amendments") */
  bannerMessage: Scalars['String']['output'];
  /** ISO 8601 date after which sandbox auto-exits (when law takes effect) */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** Banner background color: "amber" | "yellow" | "orange" */
  visualIndicatorColor: Scalars['String']['output'];
};

export type SaveDagEdgeInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

export type SaveDagNodeInput = {
  criticality: DagcriticalityEnum | '%future added value';
  dependsOn?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  nodeType: DagnodeTypeEnum | '%future added value';
  phaseId?: InputMaybe<Scalars['String']['input']>;
  phaseName?: InputMaybe<Scalars['String']['input']>;
  phaseOrder?: InputMaybe<Scalars['Int']['input']>;
  requiredRole?: InputMaybe<Scalars['String']['input']>;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveDagPhaseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  engine: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  phaseId: Scalars['String']['input'];
};

export type SaveDagWorkflowInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdBy: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  edges: Array<SaveDagEdgeInput>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nodes: Array<SaveDagNodeInput>;
  phases?: InputMaybe<Array<SaveDagPhaseInput>>;
  safetyLevel?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};

export type SaveDagWorkflowResponse = {
  __typename?: 'SaveDAGWorkflowResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

/** Input for saving a draft */
export type SaveDraftInput = {
  draft: Scalars['JSON']['input'];
  key: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  ttlSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for saving an EDI claim draft.
 *
 * The claim_data field contains the raw form JSON as submitted by FormRenderer.
 * Field names match the enrichment YAML field_name values (e.g., "patient_last_name",
 * "diagnosis_codes", "service_lines_grid").
 */
export type SaveEdiClaimDraftInput = {
  /** Form data as JSON (field names from enrichment YAML) */
  claimData: Scalars['JSON']['input'];
  /** Source format hint (e.g., "form", "cms1500", "fhir_claim") */
  sourceFormat?: Scalars['String']['input'];
  /** EDI transaction set type (e.g., "837P", "837I", "270") */
  transactionSetType?: Scalars['String']['input'];
};

/** Input for saving PDF annotations to Document.dynamodb_content */
export type SavePdfAnnotationsInput = {
  /** JSON string of annotation array */
  annotationsJson: Scalars['String']['input'];
  /** Document ID */
  documentId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Save result */
export type SaveResult = {
  __typename?: 'SaveResult';
  key: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

/**
 * ClamAV scan status for a legacy archive file.
 *
 * Determines access level:
 * - CLEAN: Full access (view + download)
 * - MACRO_DETECTED: Gated access (view + download with elevated warning)
 * - INFECTED: Blocked (metadata only, no URLs)
 * - UNSCANNED: Blocked (queued for scan, no URLs)
 */
export const ScanStatus = {
  /** File passed ClamAV scan — no threats detected */
  CLEAN: 'CLEAN',
  /** File flagged as malware by ClamAV — access blocked */
  INFECTED: 'INFECTED',
  /** File contains macros/active content — not malware but potentially risky */
  MACRO_DETECTED: 'MACRO_DETECTED',
  /** File not yet scanned — access blocked until scan completes */
  UNSCANNED: 'UNSCANNED',
} as const;

export type ScanStatus = (typeof ScanStatus)[keyof typeof ScanStatus];
export type Schedule = {
  __typename?: 'Schedule';
  analyticsOptimizationEnabled: Scalars['Boolean']['output'];
  clinicalOverrideAllowed: Scalars['Boolean']['output'];
  clinicalScheduleType?: Maybe<Scalars['String']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this schedule.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  consecutiveFailures: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this schedule */
  createdByActor?: Maybe<ActorSummary>;
  cronExpression?: Maybe<Scalars['String']['output']>;
  currentExecutionCount: Scalars['Int']['output'];
  dailyExecutionQuota?: Maybe<Scalars['Int']['output']>;
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  escalationOnMissMinutes: Scalars['Int']['output'];
  executionWindowMinutes: Scalars['Int']['output'];
  extendedMetadata: Scalars['JSON']['output'];
  failureAction: Scalars['String']['output'];
  isLifeCritical: Scalars['Boolean']['output'];
  lastExecutionAt?: Maybe<Scalars['DateTime']['output']>;
  maxExecutions?: Maybe<Scalars['Int']['output']>;
  maxRetryAttempts: Scalars['Int']['output'];
  monthlyExecutionQuota?: Maybe<Scalars['Int']['output']>;
  nextExecutionAt?: Maybe<Scalars['DateTime']['output']>;
  quotaExceededAction: Scalars['String']['output'];
  rateLimitPerHour?: Maybe<Scalars['Int']['output']>;
  retryOnFailure: Scalars['Boolean']['output'];
  safetyWindowMinutes: Scalars['Int']['output'];
  scheduleCode: Scalars['String']['output'];
  scheduleId: Scalars['String']['output'];
  scheduleName: Scalars['String']['output'];
  schedulePriority: GqlSchedulePriority | '%future added value';
  scheduleStatus: GqlScheduleStatus | '%future added value';
  scheduleType: GqlScheduleType | '%future added value';
  startDatetime: Scalars['DateTime']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** WHO last updated this schedule */
  updatedByActor?: Maybe<ActorSummary>;
};

/**
 * Result of archiving a schedule (FERP Append-Only Architecture).
 *
 * FERP Principle: Immutable history for life-critical workflows.
 * Physical deletion is NOT allowed in life-critical systems.
 */
export type ScheduleArchiveResult = {
  __typename?: 'ScheduleArchiveResult';
  /** When the schedule was archived (ISO 8601) */
  archivedAt: Scalars['DateTime']['output'];
  /** Who archived the schedule */
  archivedBy: Scalars['String']['output'];
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Mandatory reason for archival (audit trail) */
  reason: Scalars['String']['output'];
  /** ID of the archived schedule */
  scheduleId: Scalars['String']['output'];
  /** Name of the archived schedule */
  scheduleName: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
};

/**
 * Result of LLM-powered schema intent analysis.
 * Used by the AI Schema Import wizard to suggest patterns and subgraphs.
 */
export type SchemaIntentAnalysis = {
  __typename?: 'SchemaIntentAnalysis';
  /** Applicable compliance frameworks (e.g., "FHIR R4", "HIPAA", "SOX") */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Confidence score 0.0–1.0 */
  confidence: Scalars['Float']['output'];
  /** Suggested entity type name */
  entityType: Scalars['String']['output'];
  /** Human-readable reasoning */
  reasoning: Scalars['String']['output'];
  /** Detected subgraph (e.g., "ferp-core", "fhir", "payroll", "ofbiz") */
  subgraph: Scalars['String']['output'];
  /** Suggested pattern ID (e.g., "SIMPLE_CRUD", "HIERARCHICAL") */
  suggestedPattern: Scalars['String']['output'];
};

/** Result of getting a form schema */
export type SchemaResult = {
  __typename?: 'SchemaResult';
  kind: Scalars['String']['output'];
  schema: Scalars['JSON']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/** Actor IDs assigned to/from a given actor — for correlation/filtering only, never for display. */
export type ScopeAssignments = {
  __typename?: 'ScopeAssignments';
  /**
   * Outbound ASSIGNED_TO: actors this actor is the source of assignment for.
   * E.g. for a staff member, these are the residents assigned to their care.
   */
  assignedActorIds: Array<Scalars['String']['output']>;
  /** External entity IDs via CORRELATES edges (e.g., FHIR patient UUIDs). */
  correlatedEntityIds: Array<Scalars['String']['output']>;
  /**
   * Inbound ASSIGNED_TO: actors that have ASSIGNED_TO edges pointing AT this actor.
   * E.g. for a resident, these are the staff members assigned to care for them.
   */
  inboundActorIds: Array<Scalars['String']['output']>;
};

/** Result of verifying a tenant's scope mutation hash chain. */
export type ScopeChainVerification = {
  __typename?: 'ScopeChainVerification';
  /** Whether the chain is fully intact */
  chainIntact: Scalars['Boolean']['output'];
  /** Number that failed verification */
  failedCount: Scalars['String']['output'];
  /** Tenant whose chain was verified */
  tenantId: Scalars['String']['output'];
  /** Total number of mutations in the chain */
  totalMutations: Scalars['String']['output'];
  /** When the verification was performed */
  verifiedAt: Scalars['DateTime']['output'];
  /** Number verified successfully */
  verifiedCount: Scalars['String']['output'];
};

/**
 * A scope dimension defines how a primitive list can be grouped and which
 * visual renderer is suggested for that grouping. Dimensions are defined in
 * the Setting YAML (`scope_dimensions` section) and resolved with domain-agnostic
 * labels (e.g., "By Resident" for ALF, "By Client" for home care).
 */
export type ScopeDimension = {
  __typename?: 'ScopeDimension';
  /** All renderers that can display this dimension */
  availableRenderers: Array<Scalars['String']['output']>;
  /** Unique dimension identifier (e.g., "subject_actor", "status", "location") */
  dimensionId: Scalars['String']['output'];
  /** Primitive field to group by (e.g., "subject_actor_id", "status") */
  field: Scalars['String']['output'];
  /** Resolved label (e.g., "By Resident" — template already resolved) */
  label: Scalars['String']['output'];
  /** Sort order in the dimension picker */
  sortOrder: Scalars['Int']['output'];
  /** Suggested visual renderer for this dimension */
  suggestedRenderer: Scalars['String']['output'];
};

/**
 * A single edge in the scope containment DAG.
 * Raw actor IDs are NEVER exposed — display names only.
 * Use scopeAssignments(actorId:) for correlation queries.
 */
export type ScopeEdge = {
  __typename?: 'ScopeEdge';
  /** Relationship type */
  edgeType: ScopeEdgeType | '%future added value';
  /** When this edge became effective */
  effectiveFrom: Scalars['DateTime']['output'];
  /** When this edge expires (None = indefinite) */
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   * DRR-179: Additional metadata (spatial coordinates, floor plan doc ID, etc.)
   * Stored as JSON on the DDB edge record. Null for edges without metadata.
   */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Display name of the source actor (never a raw sequential ID) */
  sourceName: Scalars['String']['output'];
  /** Display name of the target actor (never a raw sequential ID) */
  targetName: Scalars['String']['output'];
};

/** Edge type in the scope DAG. */
export const ScopeEdgeType = {
  /** Resource assignment (Actor assigned_to Team/Unit) */
  ASSIGNED_TO: 'ASSIGNED_TO',
  /** Organizational containment (Organization > Division > Facility > Unit) */
  CONTAINS: 'CONTAINS',
  /** Cross-reference correlation */
  CORRELATES: 'CORRELATES',
  /** Voluntary governance relationship (professional standards) */
  GOVERNED_BY: 'GOVERNED_BY',
  /** Physical/logical location */
  LOCATED_AT: 'LOCATED_AT',
  /** Ownership relationship (physical/legal ownership, compliance routing) */
  OWNED_BY: 'OWNED_BY',
  /** Participation relationship */
  PARTICIPATES: 'PARTICIPATES',
  /** Regulatory authority relationship (mandatory compliance) */
  REGULATED_BY: 'REGULATED_BY',
} as const;

export type ScopeEdgeType = (typeof ScopeEdgeType)[keyof typeof ScopeEdgeType];
/** A scope that was denied due to unmet prerequisites. */
export type ScopeGap = {
  __typename?: 'ScopeGap';
  /** List of prerequisites that were not met */
  failures: Array<PrerequisiteFailure>;
  /** The scope that was denied */
  scope: Scalars['String']['output'];
};

/** Result of myScopeGaps query. */
export type ScopeGapsResult = {
  __typename?: 'ScopeGapsResult';
  /** Actor ID for which gaps were evaluated */
  actorId: Scalars['String']['output'];
  /** DRR-283: Scope bounds violations (floor/ceiling) */
  boundsViolations: Array<BoundsViolation>;
  /** Scopes that are blocked due to unmet prerequisites */
  gaps: Array<ScopeGap>;
  /** Roles that were evaluated */
  roles: Array<Scalars['String']['output']>;
  /** Total number of scopes that could be unlocked by completing prerequisites */
  totalBlockedScopes: Scalars['Int']['output'];
  /** Total number of bounds violations */
  totalBoundsViolations: Scalars['Int']['output'];
};

/** The full scope graph for a tenant. */
export type ScopeGraph = {
  __typename?: 'ScopeGraph';
  /** Number of edges */
  edgeCount: Scalars['Int']['output'];
  /** All edges in the scope graph */
  edges: Array<ScopeEdge>;
  /** Leaf nodes (no outgoing edges) */
  leaves: Array<Scalars['String']['output']>;
  /** Number of nodes */
  nodeCount: Scalars['Int']['output'];
  /** Root nodes (no incoming edges) */
  roots: Array<Scalars['String']['output']>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
};

/** A blockchain-verified scope mutation event. */
export type ScopeMutationEvent = {
  __typename?: 'ScopeMutationEvent';
  /** The edge that was mutated */
  edge: ScopeEdge;
  /** SHA-256 hash of this mutation */
  hash: Scalars['String']['output'];
  /** Unique mutation ID */
  id: Scalars['String']['output'];
  /** Kind of mutation (EdgeAdded, EdgeRemoved, etc.) */
  mutationKind: Scalars['String']['output'];
  /** Who performed this mutation */
  performedBy: Scalars['String']['output'];
  /** Hash of the previous mutation in the chain */
  previousHash?: Maybe<Scalars['String']['output']>;
  /** Monotonically increasing sequence number */
  sequence: Scalars['String']['output'];
  /** When this mutation occurred */
  timestamp: Scalars['DateTime']['output'];
};

/** The scope path from root to a specific actor. */
export type ScopePath = {
  __typename?: 'ScopePath';
  /** Actor ID at the end of the path */
  actorId: Scalars['String']['output'];
  /** Depth (number of edges from root) */
  depth: Scalars['Int']['output'];
  /** Path from root to actor (ordered root → leaf) */
  path: Array<Scalars['String']['output']>;
};

/** Search analytics result (for admin dashboard) */
export type SearchAnalytics = {
  __typename?: 'SearchAnalytics';
  avgDurationMs: Scalars['Float']['output'];
  searchVolume: Array<SearchVolume>;
  topSearches: Array<TopSearch>;
  totalSearches: Scalars['Int']['output'];
  zeroResultQueries: Array<ZeroResultQuery>;
};

/**
 * Input for cross-subgraph entity search.
 *
 * **Used By:**
 * - search_api: Unified entity search across all subgraphs
 */
export type SearchEntitiesInput = {
  /** Optional filter to specific entity types (e.g., ["Patient", "PayrollRun"]) */
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pagination */
  pagination?: InputMaybe<PaginationInput>;
  /** Free-text search query */
  query: Scalars['String']['input'];
  /** Optional filter to specific subgraphs (e.g., ["fhir", "payroll"]) */
  subgraphIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Paginated search results */
export type SearchEntitiesResult = {
  __typename?: 'SearchEntitiesResult';
  /** Matching entities */
  items: Array<SearchResultItem>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Total count across all subgraphs */
  totalCount: Scalars['Int']['output'];
};

/** A single search result with subgraph context */
export type SearchResultItem = {
  __typename?: 'SearchResultItem';
  /** Relative path to the entity detail page */
  detailPath?: Maybe<Scalars['String']['output']>;
  /** Display-friendly name/title (from displayField) */
  displayValue: Scalars['String']['output'];
  /** Entity type name (e.g., "Patient", "PayrollRun") */
  entityType: Scalars['String']['output'];
  /** Icon name from entity metadata */
  icon?: Maybe<Scalars['String']['output']>;
  /** Entity ID (Snowflake) */
  id: Scalars['String']['output'];
  /** Identifier field values as key-value pairs (JSON string) */
  identifiers?: Maybe<Scalars['String']['output']>;
  /** Whether this entity is life-critical */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Subgraph ID (e.g., "fhir", "payroll") */
  subgraphId: Scalars['String']['output'];
};

export type SearchVolume = {
  __typename?: 'SearchVolume';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

/** Option for select/multiselect fields */
export type SelectOption = {
  __typename?: 'SelectOption';
  /** Optional description/help text */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether option is disabled */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Optional group for grouped options */
  group?: Maybe<Scalars['String']['output']>;
  /** Optional icon identifier */
  icon?: Maybe<Scalars['String']['output']>;
  /** Display label */
  label: Scalars['String']['output'];
  /** Value stored when selected */
  value: Scalars['String']['output'];
};

/** Input version of SelectOption */
export type SelectOptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SendActorInput = {
  delayMs?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
};

export type SendIntakeMessageInput = {
  content: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  sentBy: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/**
 * A service authorization from a lead agency.
 * Tracks approved services, units, and utilization.
 */
export type ServiceAuthorization = {
  __typename?: 'ServiceAuthorization';
  /** Number of units authorized */
  authorizedUnits: Scalars['Float']['output'];
  /** Authorization end date */
  endDate: Scalars['String']['output'];
  /** Unique authorization ID */
  id: Scalars['String']['output'];
  /** Lead agency name */
  leadAgency?: Maybe<Scalars['String']['output']>;
  /** Type of service (e.g., "Personal Care", "Homemaking") */
  serviceType: Scalars['String']['output'];
  /** Authorization start date */
  startDate: Scalars['String']['output'];
  /** Status (e.g., "active", "expired", "pending") */
  status: Scalars['String']['output'];
  /** Unit type (e.g., "hours", "visits") */
  unitType: Scalars['String']['output'];
  /** Number of units used */
  usedUnits: Scalars['Float']['output'];
};

/** Full service plan representation */
export type ServicePlan = {
  __typename?: 'ServicePlan';
  /** Activity domains */
  activityDomains: Array<ActivityDomain>;
  /** Approval timestamp */
  approvedAt?: Maybe<Scalars['Int']['output']>;
  /** Actor ID of the approving authority (if approved) */
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['Int']['output'];
  /** Effective end date */
  effectiveEnd?: Maybe<Scalars['Int']['output']>;
  /** Effective start date */
  effectiveStart?: Maybe<Scalars['Int']['output']>;
  /** Unique plan identifier */
  id: Scalars['String']['output'];
  /** Plan type identifier */
  planType: Scalars['String']['output'];
  /** Review notes */
  reviewNotes?: Maybe<Scalars['String']['output']>;
  /** Review timestamp */
  reviewedAt?: Maybe<Scalars['Int']['output']>;
  /** Actor ID of the reviewer (if reviewed) */
  reviewedBy?: Maybe<Scalars['String']['output']>;
  /** Current status */
  status: PlanStatus | '%future added value';
  /** Subject identifier */
  subjectId: Scalars['String']['output'];
  /** Subject display name */
  subjectName: Scalars['String']['output'];
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt?: Maybe<Scalars['Int']['output']>;
  /** Version number */
  version: Scalars['Int']['output'];
};

/** Setting bundle for an industry/vertical. */
export type SettingBundle = {
  __typename?: 'SettingBundle';
  /** Active lenses for this setting */
  activeLenses: Array<Scalars['String']['output']>;
  /**
   * DRR-134/135: Actor type → industry display label mapping.
   * Keys are GqlActorType enum values (HUMAN, SUBJECT, COMPOSITE, EXTERNAL).
   * Values are domain-appropriate labels ("Staff", "Resident", "Organization", "Partner").
   * Used by WorkforcePage to render setting-bundle-driven tabs.
   */
  actorTypeLabels: Scalars['JSON']['output'];
  /** Industry code */
  code: Scalars['String']['output'];
  /** Code system (NAICS, SIC, HCPCS, etc.) */
  codeSystem: Scalars['String']['output'];
  /** DRR-188: Context banner configuration */
  contextBanner: ContextBannerConfig;
  /** Full definition as JSON */
  definition: Scalars['String']['output'];
  /**
   * FHIR resource type → industry terminology mapping (ln-5-2-001).
   * Keys are FHIR R4 resource type names; values are industry display names.
   * E.g. "Patient" → "Resident", "Encounter" → "Service Visit".
   */
  fhirLabels: Scalars['JSON']['output'];
  /** Industry label */
  industryLabel: Scalars['String']['output'];
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Navigation groups defined for this setting (per view layer) */
  navigationGroups: Array<SettingNavigationGroup>;
  /** Regulatory frameworks */
  regulatoryFrameworks: Array<Scalars['String']['output']>;
  /** Setting ID */
  settingId: Scalars['String']['output'];
  /** Subject label (patient, client, employee, etc.) */
  subjectLabel: Scalars['String']['output'];
  /**
   * User menu items for the avatar dropdown (personal self-service).
   * Defined in Setting YAML `navigation.user_menu_items[]`.
   * NVO lever 6 (`user_menu_overrides`) can rename or hide items per tenant.
   * Frontend filters against `allowedNavigation.routes` + `userScopes` for visibility.
   */
  userMenuItems: Array<SettingUserMenuItem>;
  /** Vertical */
  vertical: Scalars['String']['output'];
};

/**
 * A navigation group from the Setting YAML.
 * DRR-055: Backend-driven UI — navigation structure from YAML, not frontend code.
 * DRR-188: Extended with action_label_template + primary_path for Context Banner.
 */
export type SettingNavigationGroup = {
  __typename?: 'SettingNavigationGroup';
  /**
   * DRR-188: Template for context banner action label.
   * Variables: {count}, {subject_plural} (from setting subject_label).
   * E.g., "{count} {subject_plural} need care plan review"
   */
  actionLabelTemplate?: Maybe<Scalars['String']['output']>;
  /**
   * Mantine color name for the group (e.g., "blue", "teal", "violet").
   * Used for sidebar icons and context banner badges.
   */
  color?: Maybe<Scalars['String']['output']>;
  /** Tabler icon name (e.g., IconHeartHandshake) */
  icon: Scalars['String']['output'];
  /** Group ID (e.g., nav-grp-user-care) */
  id: Scalars['String']['output'];
  /**
   * Whether this is a standalone top-level item (Dashboard, Calendar) vs a collapsible group.
   * Standalone items render as single nav links, not expandable sections.
   */
  isStandalone: Scalars['Boolean']['output'];
  /** Display label (e.g., Care Management) */
  label: Scalars['String']['output'];
  /** View layer this group applies to (USER, ADMIN, ARCHITECT) */
  layer: Scalars['String']['output'];
  /**
   * DRR-196: Item-level scope requirements within this group.
   * Maps pattern name → required scopes. E.g., {"approvals": ["approval:read"]}.
   * Items not in this map are visible to all users within the group.
   */
  memberItemScopes: Scalars['JSON']['output'];
  /** Patterns to match nav item IDs against */
  memberPatterns: Array<Scalars['String']['output']>;
  /** DRR-188: Primary page path for one-click navigation from context banner. */
  primaryPath?: Maybe<Scalars['String']['output']>;
  /**
   * DRR-196: Scopes required to see this navigation group.
   * Empty = visible to all users within the layer.
   * Non-empty = user must have at least one of these scopes.
   */
  requiredScopes: Array<Scalars['String']['output']>;
  /** Sort order within the layer */
  sortOrder: Scalars['Int']['output'];
};

/**
 * A user menu item from the Setting YAML.
 * Personal self-service items displayed in the avatar dropdown.
 * Distinct from sidebar navigation — these are "about ME as an employee."
 *
 * Legislation backing (MN ALF example):
 * - My Access: MN 144G.71 Subd 6-7 (delegation), 144G.45 (competency)
 * - My Training: MN 144G.45 Subd 3 (annual training), 144G.72 (dementia)
 * - My Payroll: FLSA 29 USC 207 (overtime), MN 181.032 (earnings statements)
 */
export type SettingUserMenuItem = {
  __typename?: 'SettingUserMenuItem';
  /** Tabler icon name (e.g., "IconUser", "IconCertificate") */
  icon: Scalars['String']['output'];
  /** Unique identifier (e.g., "um-profile", "um-training") */
  id: Scalars['String']['output'];
  /** Display label (e.g., "My Profile", "My Training") */
  label: Scalars['String']['output'];
  /** Route path (e.g., "/ferp-core/profile", "/ferp-core/my-training") */
  path: Scalars['String']['output'];
  /**
   * Scopes required to see this item. Empty = always visible.
   * Frontend checks against `allowedNavigation.userScopes` for visibility.
   */
  requiredScopes: Array<Scalars['String']['output']>;
  /** Sort order within the user menu */
  sortOrder: Scalars['Int']['output'];
};

export type SettingsInput = {
  archiveAfterDays?: InputMaybe<Scalars['Int']['input']>;
  extras?: InputMaybe<Scalars['JSON']['input']>;
  maxBackoffMs?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pollIntervalMs?: InputMaybe<Scalars['Int']['input']>;
  quotaPerMin?: InputMaybe<Scalars['Int']['input']>;
  ttlDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for settling with a service company */
export type SettleServiceCompanyInput = {
  period: Scalars['String']['input'];
  serviceCompanyTenantNum: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

/**
 * A settlement proposal between two tenants (DRR-105 + DRR-109)
 *
 * Validates:
 * 1. Both tenants have an active CONTRACTS_WITH relationship
 * 2. Settlement amount matches aggregated transaction totals
 * 3. Blake3 reconciliation hash matches between both parties
 */
export type SettlementProposal = {
  __typename?: 'SettlementProposal';
  /** Settlement amount in cents (USD) */
  amountCents: Scalars['Int']['output'];
  /** Blake3 hash of aggregated transaction data (counterparty side, set on acceptance) */
  counterpartyReconciliationHash?: Maybe<Scalars['String']['output']>;
  /** Counterparty tenant (facility operator) */
  counterpartyTenantId: Scalars['String']['output'];
  /** Settlement period end (inclusive) */
  periodEnd: Scalars['DateTime']['output'];
  /** Settlement period start (inclusive) */
  periodStart: Scalars['DateTime']['output'];
  /** Settlement proposal ID */
  proposalId: Scalars['String']['output'];
  /** When the proposal was created */
  proposedAt: Scalars['DateTime']['output'];
  /** Blake3 hash of aggregated transaction data (proposer side) */
  proposerReconciliationHash: Scalars['String']['output'];
  /** Proposing tenant (service company) */
  proposerTenantId: Scalars['String']['output'];
  /** Whether reconciliation hashes match */
  reconciled: Scalars['Boolean']['output'];
  /** Exchange relationship ID (must be CONTRACTS_WITH type) */
  relationshipId: Scalars['String']['output'];
  /** When the proposal was accepted/rejected */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When banking settlement completed */
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current proposal status */
  status: SettlementProposalStatus | '%future added value';
  /** Number of transactions aggregated into this settlement */
  transactionCount: Scalars['Int']['output'];
};

/** Settlement proposal status */
export const SettlementProposalStatus = {
  /** Counterparty accepted — ready for banking settlement */
  ACCEPTED: 'ACCEPTED',
  /** Settlement failed — requires manual intervention */
  FAILED: 'FAILED',
  /** Proposal created, awaiting counterparty acceptance */
  PROPOSED: 'PROPOSED',
  /** Settlement rejected by counterparty */
  REJECTED: 'REJECTED',
  /** Settlement completed — funds transferred */
  SETTLED: 'SETTLED',
  /** Banking settlement in progress */
  SETTLING: 'SETTLING',
} as const;

export type SettlementProposalStatus =
  (typeof SettlementProposalStatus)[keyof typeof SettlementProposalStatus];
/**
 * Shift identifier for daily task sheet generation.
 * Determines which tasks and which time range to include on the printed sheet.
 */
export const ShiftPeriod = {
  /** AM shift — 06:00 to 14:00 */
  AM: 'AM',
  /** NOC shift — 22:00 to 06:00 (next day) */
  NOC: 'NOC',
  /** PM shift — 14:00 to 22:00 */
  PM: 'PM',
} as const;

export type ShiftPeriod = (typeof ShiftPeriod)[keyof typeof ShiftPeriod];
/** Shift plan with optimized task assignments */
export type ShiftPlan = {
  __typename?: 'ShiftPlan';
  /** Task assignments */
  assignments: Array<TaskAssignment>;
  /** Floor/unit this plan covers */
  floorId: Scalars['String']['output'];
  /** When plan was generated */
  generatedAt: Scalars['DateTime']['output'];
  /** Unique plan ID */
  planId: Scalars['String']['output'];
  /** What triggered replan (null for initial plan) */
  replanTrigger?: Maybe<Scalars['String']['output']>;
  /** Resource reservations */
  reservations: Array<PlannedReservation>;
  /** Shift end time */
  shiftEnd: Scalars['DateTime']['output'];
  /** Shift start time */
  shiftStart: Scalars['DateTime']['output'];
  /** Staff on this shift */
  staffRoster: Array<ShiftStaffMember>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Plan version (increments on replan) */
  version: Scalars['Int']['output'];
  /** Any warnings */
  warnings: Array<Scalars['String']['output']>;
};

/** A shift or schedule period. */
export type ShiftSchedule = {
  __typename?: 'ShiftSchedule';
  /** Assigned actor IDs */
  assignedActorIds: Array<Scalars['String']['output']>;
  /** Completed items count */
  completedItems: Scalars['Int']['output'];
  /** End time (Unix ms) */
  endTime: Scalars['Int']['output'];
  /** Schedule name (e.g., "Morning Shift", "Week 14") */
  name: Scalars['String']['output'];
  /** Overdue items count */
  overdueItems: Scalars['Int']['output'];
  /** Pending items count */
  pendingItems: Scalars['Int']['output'];
  /** Schedule identifier */
  scheduleId: Scalars['String']['output'];
  /** Start time (Unix ms) */
  startTime: Scalars['Int']['output'];
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Total items in this schedule */
  totalItems: Scalars['Int']['output'];
};

/** Staff member on shift */
export type ShiftStaffMember = {
  __typename?: 'ShiftStaffMember';
  /** Actor ID */
  actorId: Scalars['String']['output'];
  /** Available for assignment */
  available: Scalars['Boolean']['output'];
  /** Competencies */
  competencies: Array<Scalars['String']['output']>;
  /** Current location */
  currentLocation?: Maybe<Scalars['String']['output']>;
  /** Current task count */
  currentWorkload: Scalars['Int']['output'];
  /** Role ID */
  roleId: Scalars['String']['output'];
};

/**
 * A work item within a shift or schedule period.
 * Domain-agnostic representation of scheduled work.
 */
export type ShiftWorkItem = {
  __typename?: 'ShiftWorkItem';
  /** Assigned actor ID (if assigned) */
  assignedActorId?: Maybe<Scalars['String']['output']>;
  /** Category for grouping (e.g., "morning_meds", "pm_deadline") */
  category?: Maybe<Scalars['String']['output']>;
  /** Additional instructions or notes */
  instructions?: Maybe<Scalars['String']['output']>;
  /** Unique item identifier */
  itemId: Scalars['String']['output'];
  /** Work item type (medication_admin, deadline, equipment_check) */
  itemType: WorkItemType | '%future added value';
  /** Display label for the work item */
  label: Scalars['String']['output'];
  /** Priority level (1-5, 1 = highest) */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Scheduled time (Unix ms) */
  scheduledTime: Scalars['Int']['output'];
  /** Current status */
  status: WorkItemStatus | '%future added value';
  /** Subject identifier (resident, client, project) */
  subjectId: Scalars['String']['output'];
  /** Subject display name */
  subjectName: Scalars['String']['output'];
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Time window end (Unix ms) */
  windowEnd?: Maybe<Scalars['Int']['output']>;
  /** Time window start (Unix ms) */
  windowStart?: Maybe<Scalars['Int']['output']>;
};

/** Input for signing a document with a visual signature */
export type SignDocumentInput = {
  /** ID of the document to sign */
  documentId: Scalars['String']['input'];
  /** Base64-encoded PNG signature image data URL */
  signatureImage: Scalars['String']['input'];
  /** Actor ID of the signer */
  signerId: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Result of a document signing operation */
export type SignDocumentResult = {
  __typename?: 'SignDocumentResult';
  /** Audit event ID for this signing operation */
  auditEventId: Scalars['String']['output'];
  /** The new signed document version */
  document?: Maybe<Document>;
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** S3 key of the signed PDF */
  signedS3Key?: Maybe<Scalars['String']['output']>;
  /** Whether the signing operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Webhook signature algorithm */
export const SignatureAlgorithm = {
  HMAC_SHA256: 'HMAC_SHA256',
  HMAC_SHA512: 'HMAC_SHA512',
  RSA_SHA256: 'RSA_SHA256',
} as const;

export type SignatureAlgorithm = (typeof SignatureAlgorithm)[keyof typeof SignatureAlgorithm];
/** Type of signature field placed on the PDF page (B1). */
export const SignatureFieldType = {
  /** Auto-populated signing date stamp. */
  DATE_SIGNED: 'DATE_SIGNED',
  /** Initials only (smaller field). */
  INITIALS: 'INITIALS',
  /** Full handwritten signature. */
  SIGNATURE: 'SIGNATURE',
  /** Free text input field. */
  TEXT_FIELD: 'TEXT_FIELD',
} as const;

export type SignatureFieldType = (typeof SignatureFieldType)[keyof typeof SignatureFieldType];
/** Result of verifying signatures in a single signed PDF (D5). */
export type SignatureVerificationResult = {
  __typename?: 'SignatureVerificationResult';
  certificateSubject: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
  padesProfile: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  revocationChecked: Scalars['Boolean']['output'];
  signedAt: Scalars['String']['output'];
  signerEmail: Scalars['String']['output'];
  signerName: Scalars['String']['output'];
  timestampValid: Scalars['Boolean']['output'];
};

export const SignerRole = {
  APPROVER: 'APPROVER',
  CARBON_COPY: 'CARBON_COPY',
  SIGNER: 'SIGNER',
  WITNESS: 'WITNESS',
} as const;

export type SignerRole = (typeof SignerRole)[keyof typeof SignerRole];
export type SigningCeremony = {
  __typename?: 'SigningCeremony';
  /** Custom branding for the public signing page (D6). */
  branding?: Maybe<CeremonyBranding>;
  ceremonyId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documentId: Scalars['String']['output'];
  /** S3 key of the evidence certificate PDF (C3 — generated on completion). */
  evidenceS3Key?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Placed fields for step-through signing. When non-empty, the signing UI walks
   * through fields one at a time instead of showing a single signature capture.
   */
  fields: Array<CeremonyPlacedField>;
  participants: Array<CeremonyParticipant>;
  /**
   * Post-signing redirect URL (D3). When set, the public signing page redirects here
   * instead of showing the confirmation screen.
   */
  returnUrl?: Maybe<Scalars['String']['output']>;
  /** S3 key of the latest signed PDF version (set after first PAdES signing). */
  signedS3Key?: Maybe<Scalars['String']['output']>;
  signingOrder: SigningOrder | '%future added value';
  status: CeremonyStatus | '%future added value';
  tenantId: Scalars['String']['output'];
  /** Reason for voiding (C1). */
  voidReason?: Maybe<Scalars['String']['output']>;
  /** When the ceremony was voided by the sender (C1). */
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

export const SigningOrder = {
  PARALLEL: 'PARALLEL',
  SEQUENTIAL: 'SEQUENTIAL',
} as const;

export type SigningOrder = (typeof SigningOrder)[keyof typeof SigningOrder];
/** Payload returned when resolving a signing token (A1 — public signing link). */
export type SigningTokenPayload = {
  __typename?: 'SigningTokenPayload';
  /** True if this participant already signed (token was already consumed). */
  alreadySigned: Scalars['Boolean']['output'];
  /** Custom branding for the public signing page (D6). */
  branding?: Maybe<CeremonyBranding>;
  ceremonyId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  documentName: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fieldHeight?: Maybe<Scalars['Float']['output']>;
  /** Field placement coordinates for this participant's signature field. */
  fieldPage?: Maybe<Scalars['Int']['output']>;
  fieldWidth?: Maybe<Scalars['Float']['output']>;
  fieldX?: Maybe<Scalars['Float']['output']>;
  fieldY?: Maybe<Scalars['Float']['output']>;
  /**
   * Placed fields for this participant's step-through signing experience.
   * When non-empty, the signing UI walks through fields one at a time.
   */
  fields: Array<CeremonyPlacedField>;
  participantEmail: Scalars['String']['output'];
  participantIndex: Scalars['Int']['output'];
  participantName: Scalars['String']['output'];
  /** Post-signing redirect URL (D3). Public signing page redirects here on success. */
  returnUrl?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

/** An available transition visible from the current simulated state. */
export type SimAvailableTransition = {
  __typename?: 'SimAvailableTransition';
  event: Scalars['String']['output'];
  guardNames: Array<Scalars['String']['output']>;
  toState: Scalars['String']['output'];
};

/** A single simulated transition in the execution tree. */
export type SimulatedTransition = {
  __typename?: 'SimulatedTransition';
  actionsPlanned: Array<PlannedAction>;
  event: Scalars['String']['output'];
  fromState: Scalars['String']['output'];
  guardsEvaluated: Array<GuardResult>;
  /** Whether this edge's guards included Unknown outcomes */
  hasUncertainGuards: Scalars['Boolean']['output'];
  policyResults: Array<PolicySimResult>;
  toState: Scalars['String']['output'];
};

export type SimulationError = {
  __typename?: 'SimulationError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
};

/** Simulation report from DRR-170 ALL_PATHS */
export type SimulationReport = {
  __typename?: 'SimulationReport';
  /** States with no outgoing transitions (except FINAL) */
  deadEnds: Array<Scalars['String']['output']>;
  /** Reachable states count */
  reachableStates: Scalars['Int']['output'];
  /** Self-loop states (for day_boundary, etc.) */
  selfLoopStates: Array<Scalars['String']['output']>;
  /** Total states in workflow */
  totalStates: Scalars['Int']['output'];
  /** States that cannot be reached from initial state */
  unreachableStates: Array<Scalars['String']['output']>;
  /** States with policy_refs but no EvaluatePolicy action */
  unwiredPolicies: Array<Scalars['String']['output']>;
};

export type SimulationResultGql = {
  __typename?: 'SimulationResultGql';
  projectedOutcomes: Scalars['JSON']['output'];
  riskAnalysis: Scalars['JSON']['output'];
  simulationConfidence: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/** The full result of simulateScenario(ALL_PATHS). */
export type SimulationRunResult = {
  __typename?: 'SimulationRunResult';
  summary: SimulationSummary;
  tree: SimulationTreeNode;
  workflowId: Scalars['String']['output'];
};

/** Scenarios for batch simulation. */
export const SimulationScenario = {
  /** BFS enumerate all reachable paths (DRR-170-A1: visit-count=2) */
  ALL_PATHS: 'ALL_PATHS',
  /** Follow first available transition at each state until Final */
  HAPPY_PATH: 'HAPPY_PATH',
  /** Follow rejection/failure transitions where available */
  REJECTION_PATH: 'REJECTION_PATH',
  /** Trigger timeouts at each state */
  TIMEOUT_PATH: 'TIMEOUT_PATH',
} as const;

export type SimulationScenario = (typeof SimulationScenario)[keyof typeof SimulationScenario];
/** Result of a single step-through simulation event. */
export type SimulationStepResult = {
  __typename?: 'SimulationStepResult';
  /** Available transitions from the new state */
  availableEvents: Array<Scalars['String']['output']>;
  newState: Scalars['String']['output'];
  previousState: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  transition: SimulatedTransition;
};

/** Summary statistics for an ALL_PATHS simulation run. */
export type SimulationSummary = {
  __typename?: 'SimulationSummary';
  deadEndStates: Array<Scalars['String']['output']>;
  /** Errors found during simulation */
  errors: Array<SimulationError>;
  finalStates: Array<Scalars['String']['output']>;
  longestPathLength: Scalars['Int']['output'];
  /** States with policy_refs but no evaluate_policy action (DRR-170-A1 §24) */
  policyGaps: Array<Scalars['String']['output']>;
  reachableStates: Scalars['Int']['output'];
  selfLoopStates: Array<Scalars['String']['output']>;
  totalStates: Scalars['Int']['output'];
  totalTransitionsExplored: Scalars['Int']['output'];
  uncertainTransitions: Scalars['Int']['output'];
  unreachableStates: Array<Scalars['String']['output']>;
  /** Warnings found during simulation */
  warnings: Array<SimulationWarning>;
};

/** An edge in the execution tree (transition + target node). */
export type SimulationTreeEdge = {
  __typename?: 'SimulationTreeEdge';
  target: SimulationTreeNode;
  transition: SimulatedTransition;
};

/** A node in the ALL_PATHS execution tree. */
export type SimulationTreeNode = {
  __typename?: 'SimulationTreeNode';
  /** Transitions explored from this node */
  children: Array<SimulationTreeEdge>;
  /** Whether this node was terminated due to visit-count limit */
  isRepeating: Scalars['Boolean']['output'];
  stateName: Scalars['String']['output'];
  stateType: Scalars['String']['output'];
  visitCount: Scalars['Int']['output'];
};

export type SimulationWarning = {
  __typename?: 'SimulationWarning';
  message: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
  warningType: Scalars['String']['output'];
};

/** Sort configuration */
export type SortConfig = {
  __typename?: 'SortConfig';
  /** Direction: "asc" or "desc" */
  direction: Scalars['String']['output'];
  /** Field to sort by */
  field: Scalars['String']['output'];
};

/** Source legislation — statute citations and regulatory authority. */
export type SourceLegislation = {
  __typename?: 'SourceLegislation';
  /** Regulatory authority (e.g., "Minnesota Department of Health") */
  authority: Scalars['String']['output'];
  /** Date of last statutory amendment */
  lastAmended?: Maybe<Scalars['String']['output']>;
  /** Reference to a RegNode config */
  regnodeRef?: Maybe<Scalars['String']['output']>;
  /** Specific statute sections covered */
  sections: Array<Scalars['String']['output']>;
  /** Short citation (e.g., "MN 144G") */
  shortCite: Scalars['String']['output'];
  /** Full statute reference (e.g., "MN Statutes Chapter 144G") */
  statute: Scalars['String']['output'];
  /** URL to official statute text */
  url?: Maybe<Scalars['String']['output']>;
};

/** Source document metadata (source-map context) */
export type SourceMapDocument = {
  __typename?: 'SourceMapDocument';
  documentId: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  s3Uri?: Maybe<Scalars['String']['output']>;
  sha256: Scalars['String']['output'];
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Filter input for listing source maps */
export type SourceMapFilterInput = {
  limit?: Scalars['Int']['input'];
  reviewStatus?: InputMaybe<GqlReviewStatus | '%future added value'>;
  tenantId: Scalars['String']['input'];
};

/** Input for spending payment tokens */
export type SpendPaymentTokensInput = {
  actorId: Scalars['String']['input'];
  amountCents: Scalars['Int']['input'];
  serviceCategory: Scalars['String']['input'];
  serviceCompanyTenantNum: Scalars['Int']['input'];
  tenantNum: Scalars['Int']['input'];
};

export type StaffingFloors = {
  __typename?: 'StaffingFloors';
  /** Minimum awake staff 24/7 */
  minimumAwakeStaff: Scalars['Int']['output'];
  /** ULP ratio for day shift */
  ulpRatioDay: Scalars['Int']['output'];
  /** ULP ratio for memory care */
  ulpRatioMemoryCare: Scalars['Int']['output'];
  /** ULP ratio for night shift */
  ulpRatioNight: Scalars['Int']['output'];
};

/** Standards Pack Details (full) */
export type StandardsPackDetails = {
  __typename?: 'StandardsPackDetails';
  applicableDomains: Array<Scalars['String']['output']>;
  applicableResourceTypes: Array<Scalars['String']['output']>;
  constraints: Scalars['JSON']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: GqlStandardsPackKind | '%future added value';
  pointers: Array<Scalars['String']['output']>;
  standard: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  version: Scalars['String']['output'];
  versionHistory: Array<GqlVersionHistoryEntry>;
};

/** Standards Pack List Item (lightweight) */
export type StandardsPackListItem = {
  __typename?: 'StandardsPackListItem';
  applicableDomains: Array<Scalars['String']['output']>;
  applicableResourceTypes: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: GqlStandardsPackKind | '%future added value';
  standard: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Standards Pack Recommendation */
export type StandardsPackRecommendation = {
  __typename?: 'StandardsPackRecommendation';
  autoApply: Scalars['Boolean']['output'];
  confidence: Scalars['Float']['output'];
  packId: Scalars['String']['output'];
  packName: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

/** GraphQL input for starting biometric authentication */
export type StartBiometricAuthenticationInput = {
  /** Tenant ID for multi-tenant isolation */
  tenantId: Scalars['String']['input'];
  /** Username to authenticate (lookup in users table) */
  username: Scalars['String']['input'];
};

/** GraphQL input for starting biometric registration */
export type StartBiometricRegistrationInput = {
  /** Display name (for user-friendly presentation) */
  displayName: Scalars['String']['input'];
  /** Tenant ID for backend routing (GitHub Issue #378) */
  tenantId: Scalars['String']['input'];
  /** User ID (from existing user account) */
  userId: Scalars['String']['input'];
  /** Username (for display in authenticator) */
  username: Scalars['String']['input'];
};

/** SAGA execution request input (data-driven configuration) */
export type StartSagaInput = {
  /** Correlation ID for tracking (optional) */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /** Initiator identifier for audit trails */
  initiator: Scalars['String']['input'];
  /** Input payload for SAGA execution (data-driven) */
  input: Scalars['JSON']['input'];
  /** Execution metadata (tenant-configurable) */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** SAGA definition ID from tenant configuration */
  sagaId: Scalars['String']['input'];
  /** SAGA version to execute (from tenant parameters) */
  sagaVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Input for starting a simulation session. */
export type StartSimulationInput = {
  mockActors?: InputMaybe<Array<Scalars['String']['input']>>;
  mockVariables?: InputMaybe<Scalars['JSON']['input']>;
  workflowId: Scalars['String']['input'];
};

/** State definition view */
export type StateDefView = {
  __typename?: 'StateDefView';
  name: Scalars['String']['output'];
  transitions: Array<TransitionView>;
};

/**
 * Represents a possible state transition in the workflow's finite state machine
 *
 * ## FSM Integration
 *
 * This type exposes FERP's existing FSM logic through GraphQL, making state
 * transitions explicit instead of requiring frontend to duplicate FSM logic.
 *
 * ## Example
 *
 * ```json
 * {
 * "to": "in_review",
 * "action": "submitForReview",
 * "conditions": ["has_permission:review", "validation_passed"],
 * "description": "Submit notification for compliance review",
 * "estimatedDuration": "PT24H"
 * }
 * ```
 */
export type StateTransition = {
  __typename?: 'StateTransition';
  /** Action that triggers this transition (corresponds to Action.mutation) */
  action: Scalars['String']['output'];
  /** Conditions that must be met for transition to occur */
  conditions: Array<Scalars['String']['output']>;
  /** Human-readable description of transition */
  description: Scalars['String']['output'];
  /** Estimated duration for this transition (ISO 8601 duration) */
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  /** Target state name */
  to: Scalars['String']['output'];
};

/** Status configuration for STATUS column type */
export type StatusConfig = {
  __typename?: 'StatusConfig';
  /** Map of value -> color (e.g., {"active": "green", "inactive": "gray"}) */
  colorMap?: Maybe<Scalars['String']['output']>;
  /** Map of value -> label (e.g., {"active": "Active", "inactive": "Inactive"}) */
  labelMap?: Maybe<Scalars['String']['output']>;
};

/** Extracted statute metadata from LLM analysis. */
export type StatuteMetadata = {
  __typename?: 'StatuteMetadata';
  /** Suggested association reference (e.g., "MN-DHS-2024"). */
  associationRef: Scalars['String']['output'];
  /** Extracted document text (first ~5000 chars). */
  documentText: Scalars['String']['output'];
  /** Detected industry. */
  industry: Scalars['String']['output'];
  /** Detected jurisdiction (e.g., "US-MN"). */
  jurisdiction: Scalars['String']['output'];
  /** Extracted publication title (e.g., "Minnesota Statute 144G"). */
  publicationTitle: Scalars['String']['output'];
  /** Extracted or inferred publication year. */
  publicationYear: Scalars['Int']['output'];
};

/** A statutory definition entry (full detail for admin/compliance views). */
export type StatutoryDefinition = {
  __typename?: 'StatutoryDefinition';
  /** Acceptable alternative display terms */
  acceptableAlternatives: Array<Scalars['String']['output']>;
  /** Authority that published the definition */
  authority?: Maybe<Scalars['String']['output']>;
  /** Statute chapter */
  chapter?: Maybe<Scalars['String']['output']>;
  /** Constraint rationale (why these constraints exist) */
  constraintRationale?: Maybe<Scalars['String']['output']>;
  /** Default display term for UI */
  defaultDisplay?: Maybe<Scalars['String']['output']>;
  /** Short description */
  description: Scalars['String']['output'];
  /** When the definition took effect */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** FERP primitive this maps to */
  ferpPrimitive?: Maybe<Scalars['String']['output']>;
  /** FERP role category this maps to */
  ferpRoleCategory?: Maybe<Scalars['String']['output']>;
  /** FHIR resource type this maps to */
  fhirResource?: Maybe<Scalars['String']['output']>;
  /** Tag ID (e.g., "tag:def:144g-ulp") */
  id: Scalars['String']['output'];
  /** Human-readable label (e.g., "Unlicensed Personnel") */
  label: Scalars['String']['output'];
  /** When the definition was last amended */
  lastAmended?: Maybe<Scalars['String']['output']>;
  /** Full statutory definition text */
  legalDefinition?: Maybe<Scalars['String']['output']>;
  /** Constraint safety level (CRITICAL, HIGH, ELEVATED, etc.) */
  safetyLevel?: Maybe<Scalars['String']['output']>;
  /** Statute section reference */
  statuteRef?: Maybe<Scalars['String']['output']>;
  /** Statutory edges to other definitions (DRR-189) */
  statutoryEdges: Array<StatutoryEdge>;
};

/**
 * A statutory edge — a relationship DEFINED BY LEGISLATION between two concepts.
 * These are not inferred or manually authored; they exist because the statute says so.
 *
 * Example: MN 144G.71 defines that a CNS DELEGATES_TO ULPs.
 * Example: MN 144G.70 defines that a Service Plan IS_BASED_ON Uniform Assessment.
 *
 * DRR-189: Statutory definitions are nodes; statutory edges are the relationships
 * between them as defined in legislation. Together they form a statutory knowledge graph.
 */
export type StatutoryEdge = {
  __typename?: 'StatutoryEdge';
  /** Whether this edge is conditional (e.g., delegation requires competency verification) */
  conditional: Scalars['Boolean']['output'];
  /** Conditions for this edge to be active (e.g., "competency_verified") */
  conditions: Array<Scalars['String']['output']>;
  /** Whether this edge creates a delegation chain (affects scope of practice) */
  createsDelegation: Scalars['Boolean']['output'];
  /** Human-readable description of the relationship */
  description?: Maybe<Scalars['String']['output']>;
  /** Edge type (e.g., "DELEGATES_TO", "IS_BASED_ON", "REQUIRES", "SUPERVISES") */
  edgeType: Scalars['String']['output'];
  /** Statute section that establishes this relationship */
  statuteRef: Scalars['String']['output'];
  /** Target definition ID (tag:def:* ID) */
  target: Scalars['String']['output'];
  /** Target definition display label (resolved for convenience) */
  targetLabel?: Maybe<Scalars['String']['output']>;
};

/** A single definition affected by a statute section change. */
export type StatutoryImpactEntry = {
  __typename?: 'StatutoryImpactEntry';
  /** Affected edges (edge_type → target format) */
  affectedEdges: Array<Scalars['String']['output']>;
  /** Default display term */
  defaultDisplay?: Maybe<Scalars['String']['output']>;
  /** Definition tag ID (e.g., "tag:def:144g-ulp") */
  definitionId: Scalars['String']['output'];
  /** How this definition is affected: "DIRECT" (its source statute) or "EDGE_REFERENCE" (via edge) */
  impactType: Scalars['String']['output'];
  /** Definition label */
  label: Scalars['String']['output'];
  /** The definition's source statute reference */
  statuteRef?: Maybe<Scalars['String']['output']>;
};

/** Impact analysis report for a statute section change. */
export type StatutoryImpactReport = {
  __typename?: 'StatutoryImpactReport';
  /** List of affected definitions with impact details */
  definitions: Array<StatutoryImpactEntry>;
  /** The statute section analyzed */
  statuteSection: Scalars['String']['output'];
  /** Total number of definitions affected */
  totalAffected: Scalars['Int']['output'];
};

/** Storage backend type */
export const StorageType = {
  DYNAMODB: 'DYNAMODB',
  EXTERNAL: 'EXTERNAL',
  S3: 'S3',
} as const;

export type StorageType = (typeof StorageType)[keyof typeof StorageType];
/** Input for storing a batch of PII records */
export type StorePiiBatchInput = {
  /** Attestation ID from createPiiAttestation */
  attestationId: Scalars['String']['input'];
  /** Batch ID from createPiiAttestation */
  batchId: Scalars['String']['input'];
  /** Records to store */
  records: Array<PiiRecordInput>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Result of storing PII batch */
export type StorePiiBatchResult = {
  __typename?: 'StorePiiBatchResult';
  error?: Maybe<Scalars['String']['output']>;
  recordsStored: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  tokens: Array<PiiToken>;
};

export type StoredTerminologyOverride = {
  __typename?: 'StoredTerminologyOverride';
  classification: OverrideClassification | '%future added value';
  decidedAt?: Maybe<Scalars['String']['output']>;
  decidedBy?: Maybe<Scalars['String']['output']>;
  decisionRationale?: Maybe<Scalars['String']['output']>;
  definitionId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  proposedTerm: Scalars['String']['output'];
  rationale?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['String']['output'];
  requestedBy: Scalars['String']['output'];
  status: OverrideStatus | '%future added value';
  violatedConstraint?: Maybe<Scalars['String']['output']>;
};

export type StructuredImportJob = {
  __typename?: 'StructuredImportJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdCount: Scalars['Int']['output'];
  documentId: Scalars['String']['output'];
  errorCount: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  primitiveType: ImportPrimitiveType | '%future added value';
  processedRows: Scalars['Int']['output'];
  results: Array<ImportRowResult>;
  status: ImportJobStatus | '%future added value';
  tenant: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
};

/** Sub-workflow configuration (reference to another workflow) */
export type SubWorkflowConfig = {
  __typename?: 'SubWorkflowConfig';
  color?: Maybe<Scalars['String']['output']>;
  complianceDomains: Array<Scalars['String']['output']>;
  criticality: WorkflowCriticality | '%future added value';
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  estimatedSteps: Scalars['Int']['output'];
  executionMode: ExecutionMode | '%future added value';
  failureMode: FailureMode | '%future added value';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maxRetries: Scalars['Int']['output'];
  parallelGroup?: Maybe<Scalars['String']['output']>;
  repeatFrequency?: Maybe<Scalars['String']['output']>;
  repeating: Scalars['Boolean']['output'];
  workflowName: Scalars['String']['output'];
  workflowVersion: Scalars['String']['output'];
};

/** Reference to a sub-workflow */
export type SubWorkflowInfo = {
  __typename?: 'SubWorkflowInfo';
  /** Can run in parallel */
  canParallel: Scalars['Boolean']['output'];
  /** Dependencies */
  dependsOn: Array<Scalars['String']['output']>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Execution order */
  order: Scalars['Int']['output'];
  /** State count */
  stateCount: Scalars['Int']['output'];
  /** Workflow ID */
  workflowId: Scalars['String']['output'];
};

/**
 * Input for compressing a hydrated ID (subgraph-specific)
 * Note: Renamed to avoid collision with compression_api::CompressIdInput (Issue #581)
 */
export type SubgraphCompressIdInput = {
  /** Hydrated ID (e.g., "tenant-123#payroll_run-156") */
  hydratedId: Scalars['String']['input'];
  /** Subgraph name (required for compression) */
  subgraph: Scalars['String']['input'];
};

/** Individual subgraph correlation */
export type SubgraphCorrelation = {
  __typename?: 'SubgraphCorrelation';
  /** Correlation strength (0.0-1.0) */
  correlationStrength: Scalars['Float']['output'];
  /** Sample correlated events */
  sampleCorrelatedEvents: Array<CorrelatedEventPair>;
  /** Shared entities count */
  sharedEntitiesCount: Scalars['Int']['output'];
  /** Secondary subgraph ID */
  subgraphId: Scalars['String']['output'];
  /** Temporal overlap percentage */
  temporalOverlapPercent: Scalars['Float']['output'];
};

/** Input for subgraph correlation query */
export type SubgraphCorrelationInput = {
  /** Correlation type (temporal, causal, entity) */
  correlationType?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['NaiveDate']['input'];
  /** Primary subgraph ID */
  primarySubgraphId: Scalars['String']['input'];
  /** Secondary subgraph IDs to correlate */
  secondarySubgraphIds: Array<Scalars['String']['input']>;
  /** Time window for correlation */
  startDate: Scalars['NaiveDate']['input'];
};

/** Subgraph correlation result */
export type SubgraphCorrelationResult = {
  __typename?: 'SubgraphCorrelationResult';
  /** Correlated subgraph results */
  correlations: Array<SubgraphCorrelation>;
  /** Overall correlation strength (0.0-1.0) */
  overallCorrelationStrength: Scalars['Float']['output'];
  /** Primary subgraph summary */
  primarySubgraph: SubgraphSummary;
  /** Query metadata */
  queryMetadata: QueryMetadata;
};

/** Subgraph entities result (for organization) */
export type SubgraphEntitiesResult = {
  __typename?: 'SubgraphEntitiesResult';
  /** Entity types in this subgraph */
  entities: Array<EntityTypeMetadata>;
  /** Subgraph name (e.g., "fhir", "payroll", "erp") */
  subgraphName: Scalars['String']['output'];
};

/** Entity type definition for form generation */
export type SubgraphEntityType = {
  __typename?: 'SubgraphEntityType';
  /** Category ID (references entity_categories[].id for grouping) */
  category?: Maybe<Scalars['String']['output']>;
  /** Compliance frameworks */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Description */
  description: Scalars['String']['output'];
  /** Primary display field */
  displayField: Scalars['String']['output'];
  /** Form schema reference */
  formSchemaId?: Maybe<Scalars['String']['output']>;
  /** GraphQL type name */
  graphqlType: Scalars['String']['output'];
  /** Fields that make up identifier */
  identifierFields: Array<Scalars['String']['output']>;
  /** Whether life-critical */
  isLifeCritical: Scalars['Boolean']['output'];
  /** List schema reference */
  listSchemaId?: Maybe<Scalars['String']['output']>;
  /** Subgraph-specific key-value metadata (dynamic columns in entity manager) */
  metadata: Scalars['JSON']['output'];
  /** Entity type name */
  name: Scalars['String']['output'];
  /** CRUD permissions */
  permissions: EntityPermissions;
  /** Plural form */
  pluralName: Scalars['String']['output'];
  /** Tier: essential | standard | advanced | specialist */
  tier?: Maybe<Scalars['String']['output']>;
};

export type SubgraphInfo = {
  __typename?: 'SubgraphInfo';
  baseUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastRefreshedMs?: Maybe<Scalars['Int']['output']>;
  sdlPath: Scalars['String']['output'];
};

/** List of subgraph names */
export type SubgraphList = {
  __typename?: 'SubgraphList';
  /** Subgraph identifiers */
  subgraphs: Array<Scalars['String']['output']>;
};

/** Full subgraph metadata */
export type SubgraphMetadata = {
  __typename?: 'SubgraphMetadata';
  /** Category rules for auto-categorization */
  categoryRules: Array<CategoryRule>;
  /** Color theme */
  color: Scalars['String']['output'];
  /** Compliance frameworks */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Dependencies */
  dependsOn: Array<Scalars['String']['output']>;
  /** Description */
  description: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Entity categories for grouping in management UI */
  entityCategories: Array<EntityCategory>;
  /** Entity presets for progressive disclosure */
  entityPresets: Array<EntityPreset>;
  /** Entity types */
  entityTypes: Array<SubgraphEntityType>;
  /** Icon identifier */
  icon: Scalars['String']['output'];
  /** Whether life-critical */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Navigation items */
  navItems: Array<SubgraphNavItem>;
  /** Permission scopes */
  permissionScopes: Array<SubgraphPermissionScope>;
  /** Routes this subgraph contributes */
  routes: Array<SubgraphRoute>;
  /** Unique identifier */
  subgraphId: Scalars['String']['output'];
  /** Last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Version */
  version: Scalars['String']['output'];
  /** Widget IDs available for this subgraph (for frontend registry lookup) */
  widgetIds: Array<Scalars['String']['output']>;
};

/** Input for creating/updating subgraph metadata */
export type SubgraphMetadataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  dependsOn?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  isLifeCritical?: InputMaybe<Scalars['Boolean']['input']>;
  subgraphId: Scalars['String']['input'];
};

/** Navigation item contributed by a subgraph */
export type SubgraphNavItem = {
  __typename?: 'SubgraphNavItem';
  /** Badge configuration (JSON) */
  badge?: Maybe<Scalars['JSON']['output']>;
  /** Icon identifier */
  icon: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Display label */
  label: Scalars['String']['output'];
  /** Which layer this nav item appears in */
  layer: ViewLayer | '%future added value';
  /** Parent nav item ID */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Route path */
  path: Scalars['String']['output'];
  /** Sort order within the layer */
  sortOrder: Scalars['Int']['output'];
};

/** Permission scope definition */
export type SubgraphPermissionScope = {
  __typename?: 'SubgraphPermissionScope';
  /** Action */
  action: Scalars['String']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Whether life-critical */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Resource type */
  resourceType: Scalars['String']['output'];
  /** Scope identifier */
  scope: Scalars['String']['output'];
};

/** Validation result for subgraph reference */
export type SubgraphReferenceValidation = {
  __typename?: 'SubgraphReferenceValidation';
  /** Error message if invalid */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the reference is valid */
  isValid: Scalars['Boolean']['output'];
  /** Resource type */
  resourceType: Scalars['String']['output'];
  /** Subgraph name */
  subgraph: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
};

/** Subgraph Registry (output) */
export type SubgraphRegistry = {
  __typename?: 'SubgraphRegistry';
  /** When created */
  createdAt: Scalars['DateTime']['output'];
  /** All registered subgraphs */
  registeredSubgraphs: Scalars['JSON']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Who last updated */
  updatedBy: Scalars['String']['output'];
  /** Version (for optimistic locking) */
  version: Scalars['Int']['output'];
};

/** Route definition contributed by a subgraph */
export type SubgraphRoute = {
  __typename?: 'SubgraphRoute';
  /** Child routes */
  children: Array<SubgraphRoute>;
  /** Component to render */
  component: Scalars['String']['output'];
  /** Which layer this route belongs to */
  layer: ViewLayer | '%future added value';
  /** Route path (e.g., "/admin/healthcare") */
  path: Scalars['String']['output'];
  /** Required permissions to access this route */
  requiredPermissions: Array<Scalars['String']['output']>;
  /** Whether this route requires life-critical authorization */
  requiresLifeCriticalAuth: Scalars['Boolean']['output'];
  /** Human-readable title */
  title: Scalars['String']['output'];
};

/** Subgraph summary for correlation */
export type SubgraphSummary = {
  __typename?: 'SubgraphSummary';
  /** Event count in window */
  eventCount: Scalars['Int']['output'];
  /** Event types observed */
  eventTypes: Array<Scalars['String']['output']>;
  /** Subgraph ID */
  subgraphId: Scalars['String']['output'];
  /** Unique entities */
  uniqueEntities: Scalars['Int']['output'];
};

export type SubgraphValidationResultQl = {
  __typename?: 'SubgraphValidationResultQL';
  errorMessages: Array<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  subgraphName: Scalars['String']['output'];
  validationTimestamp: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/**
 * An edge representing a relationship between actors (e.g., EMPLOYS, SERVES).
 * Used by worker management pages to show employer-employee relationships.
 */
export type SubjectEdge = {
  __typename?: 'SubjectEdge';
  /** When this edge was created */
  createdAt: Scalars['DateTime']['output'];
  /** Edge type (e.g., "EMPLOYS", "SERVES") */
  edgeType: Scalars['String']['output'];
  /** Unique edge ID */
  id: Scalars['String']['output'];
  /** Optional metadata (JSON) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Source actor ID (e.g., participant who employs) */
  sourceActorId: Scalars['String']['output'];
  /** Target actor ID (e.g., worker who is employed) */
  targetActorId: Scalars['String']['output'];
};

/** Submission configuration */
export type SubmissionConfig = {
  __typename?: 'SubmissionConfig';
  confirmation?: Maybe<Scalars['JSON']['output']>;
  endpoint: Scalars['String']['output'];
  headers?: Maybe<Scalars['JSON']['output']>;
  method: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  transform?: Maybe<Scalars['JSON']['output']>;
  webhooks: Array<Scalars['JSON']['output']>;
};

/** Input for submitting a draft claim. */
export type SubmitEdiClaimInput = {
  /** Transaction ID of the draft to submit */
  transactionId: Scalars['String']['input'];
};

/** Input for submitting a lead */
export type SubmitLeadInput = {
  assessmentId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
  familyId: Scalars['String']['input'];
  shareEmail: Scalars['Boolean']['input'];
  sharePhone: Scalars['Boolean']['input'];
};

/** Input for submitting a settlement proposal */
export type SubmitSettlementProposalInput = {
  /** Settlement amount in cents (USD) */
  amountCents: Scalars['Int']['input'];
  /** Counterparty tenant identifier */
  counterpartyTenantId: Scalars['String']['input'];
  /** Settlement period end (inclusive) */
  periodEnd: Scalars['DateTime']['input'];
  /** Settlement period start (inclusive) */
  periodStart: Scalars['DateTime']['input'];
  /** Blake3 hash of aggregated transaction data for reconciliation */
  reconciliationHash: Scalars['String']['input'];
  /** Tenant-relationships.yaml relationship ID (must be CONTRACTS_WITH type) */
  relationshipId: Scalars['String']['input'];
  /** Number of transactions aggregated */
  transactionCount: Scalars['Int']['input'];
};

/** Submit Template for Approval Input */
export type SubmitTemplateForApprovalInput = {
  /** Conversion result from Chaos→DSL */
  conversionResult: ConversionResultInput;
  /** Submitter ID */
  submitterId: Scalars['String']['input'];
  /** Validation result from Phase 11 */
  validationResult: ValidationResultInput;
};

/** Input for LLM-driven regulatory node suggestions during tenant onboarding */
export type SuggestRegulatoryNodesInput = {
  /** NAICS sector code (e.g., "62" for Healthcare) */
  naicsCode: Scalars['String']['input'];
  /** Payers the tenant accepts (for context) */
  payers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Services the tenant offers (for context) */
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  /** US state code (e.g., "MN") */
  state: Scalars['String']['input'];
  /** NAICS subsector code (e.g., "621") */
  subsector?: InputMaybe<Scalars['String']['input']>;
};

/** Input for suggestRoomPlacements mutation (DRR-179 Phase 3). */
export type SuggestRoomPlacementsInput = {
  /** Document ID of the uploaded floor plan image. */
  floorPlanDocumentId: Scalars['String']['input'];
  /** Industry context for room labeling (e.g., "assisted_living", "warehouse"). */
  industry?: InputMaybe<Scalars['String']['input']>;
};

/** Response from floor plan room extraction. */
export type SuggestRoomPlacementsResponse = {
  __typename?: 'SuggestRoomPlacementsResponse';
  /** Processing time in milliseconds. */
  processingTimeMs: Scalars['Float']['output'];
  /** Suggested room placements for admin review. */
  suggestions: Array<SuggestedRoomPlacement>;
  /** Token usage. */
  usage: AgentUsageInfo;
};

/** A single suggested room placement from Claude vision extraction. */
export type SuggestedRoomPlacement = {
  __typename?: 'SuggestedRoomPlacement';
  /** Confidence score (0.0–1.0). */
  confidence: Scalars['Float']['output'];
  /** Detected room label (e.g., "Room 101", "Kitchen"). */
  label: Scalars['String']['output'];
  /** Optional room type classification. */
  roomType?: Maybe<Scalars['String']['output']>;
  /** Normalized X coordinate (0.0–1.0). */
  x: Scalars['Float']['output'];
  /** Normalized Y coordinate (0.0–1.0). */
  y: Scalars['Float']['output'];
};

/** Supervision requirements configuration */
export type SupervisionConfig = {
  __typename?: 'SupervisionConfig';
  documentationRequired: Scalars['Boolean']['output'];
  frequency?: Maybe<Scalars['String']['output']>;
  supervisionType?: Maybe<Scalars['String']['output']>;
  supervisorCredentials: Array<Scalars['String']['output']>;
};

export type SupervisionStrategyInput = {
  /** Backoff base milliseconds */
  backoffBaseMs?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum backoff delay */
  maxBackoffMs?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum restart attempts */
  maxRestarts?: InputMaybe<Scalars['Int']['input']>;
  /** Strategy type */
  strategy: SupervisionType | '%future added value';
};

export type SupervisionStrategyResult = {
  __typename?: 'SupervisionStrategyResult';
  backoffBaseMs?: Maybe<Scalars['Int']['output']>;
  currentRestartCount: Scalars['Int']['output'];
  lastRestartAt?: Maybe<Scalars['DateTime']['output']>;
  maxBackoffMs?: Maybe<Scalars['Int']['output']>;
  maxRestarts?: Maybe<Scalars['Int']['output']>;
  strategy: SupervisionType | '%future added value';
};

export const SupervisionType = {
  /** Escalate to parent */
  escalate: 'escalate',
  /** Restart on failure */
  restart: 'restart',
  /** Resume on failure (ignore error) */
  resume: 'resume',
  /** Stop on failure */
  stop: 'stop',
} as const;

export type SupervisionType = (typeof SupervisionType)[keyof typeof SupervisionType];
/** Suspend subgraph input */
export type SuspendSubgraphInput = {
  /** Optional reason for suspension */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Subgraph identifier */
  subgraphName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for switching the active wall (requires re-authentication). */
export type SwitchWallInput = {
  /** Justification for wall switch (required for audit trail) */
  justification: Scalars['String']['input'];
  /** Target wall to activate (e.g., "clinical", "operational") */
  targetWall: Scalars['String']['input'];
};

/** Result of a wall switch operation. */
export type SwitchWallResult = {
  __typename?: 'SwitchWallResult';
  /** The now-active wall */
  activeWall: Scalars['String']['output'];
  /** Audit event ID for this switch */
  auditEventId: Scalars['String']['output'];
  /** Previous wall (if any) */
  previousWall?: Maybe<Scalars['String']['output']>;
  /** Whether the switch was successful */
  success: Scalars['Boolean']['output'];
  /** When the switch occurred */
  switchedAt: Scalars['DateTime']['output'];
};

/** A sync conflict requiring resolution */
export type SyncConflict = {
  __typename?: 'SyncConflict';
  /** Approval primitive ID for conflict resolution routing */
  approvalId?: Maybe<Scalars['String']['output']>;
  /** Unique conflict identifier */
  conflictId: Scalars['String']['output'];
  /** Value from the syncing device */
  deviceAValue: Scalars['JSON']['output'];
  /** Value from hub or second device (null if conflict is with hub state) */
  deviceBValue?: Maybe<Scalars['JSON']['output']>;
  /** Entity that is in conflict */
  entityId: Scalars['String']['output'];
  /** Type of entity (maps to primitive type) */
  entityType: Scalars['String']['output'];
  /** Why this conflict occurred */
  reason: GqlConflictReason | '%future added value';
  /** Current conflict status */
  status: GqlConflictStatus | '%future added value';
};

/** Input for syncing an offline device chain */
export type SyncOfflineChainInput = {
  /** Base64-encoded Automerge document (optional, for CRDT merge) */
  automergeDoc?: InputMaybe<Scalars['String']['input']>;
  /** Blake3 chain entries from the device */
  chainEntries: Array<ChainEntryInput>;
  /** Device identifier */
  deviceId: Scalars['String']['input'];
  /** Schema version the device was using */
  schemaVersion: Scalars['String']['input'];
};

/** Result of a sync operation */
export type SyncResult = {
  __typename?: 'SyncResult';
  /** Wasabi WORM archive key (if archived) */
  archiveKey?: Maybe<Scalars['String']['output']>;
  /** Whether the Blake3 chain was verified successfully */
  chainVerified: Scalars['Boolean']['output'];
  /** Conflicts requiring human review */
  conflicts: Array<SyncConflict>;
  /** Entries successfully grafted onto hub streams */
  entriesGrafted: Scalars['Int']['output'];
  /** Total entries received from device */
  entriesProcessed: Scalars['Int']['output'];
  /** Offline → permanent ID mappings created */
  idMappings: Array<IdMapping>;
  /** Unique session identifier */
  sessionId: Scalars['String']['output'];
  /** Overall sync status */
  status: GqlSyncStatus | '%future added value';
};

/** Sync session metadata */
export type SyncSession = {
  __typename?: 'SyncSession';
  /** Actor who recorded events offline */
  actorId: Scalars['String']['output'];
  /** Wasabi archive key */
  archiveKey?: Maybe<Scalars['String']['output']>;
  /** Whether chain verification passed */
  chainVerified: Scalars['Boolean']['output'];
  /** When the sync completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device that produced this session */
  deviceId: Scalars['String']['output'];
  /** Entries in conflict */
  entriesConflicted: Scalars['Int']['output'];
  /** Entries grafted to hub */
  entriesGrafted: Scalars['Int']['output'];
  /** Entries received from device */
  entriesReceived: Scalars['Int']['output'];
  /** Session identifier */
  sessionId: Scalars['String']['output'];
  /** Source environment for dev imports */
  sourceEnvironment?: Maybe<Scalars['String']['output']>;
  /** When the sync started */
  startedAt: Scalars['DateTime']['output'];
  /** Overall status */
  status: GqlSyncStatus | '%future added value';
};

/** GraphQL type for SystemTenant */
export type SystemTenant = {
  __typename?: 'SystemTenant';
  /** Compliance frameworks */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Created timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Domain slug */
  domain: Scalars['String']['output'];
  /** Industry vertical */
  industry: Scalars['String']['output'];
  /** Is active? */
  isActive: Scalars['Boolean']['output'];
  /** Max API requests per hour */
  maxApiRequestsPerHour: Scalars['Int']['output'];
  /** Max users allowed */
  maxUsers: Scalars['Int']['output'];
  /** Max workflows allowed */
  maxWorkflows: Scalars['Int']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Onboarding status */
  onboardingStatus: GqlOnboardingStatus | '%future added value';
  /** Primary contact email */
  primaryContactEmail: Scalars['String']['output'];
  /** Primary contact name */
  primaryContactName: Scalars['String']['output'];
  /** Tenant settings (JSON) */
  settings: Scalars['JSON']['output'];
  /** Storage limit in GB */
  storageLimitGb: Scalars['Int']['output'];
  /** Subscription tier */
  subscriptionTier: Scalars['String']['output'];
  /** Support email */
  supportEmail?: Maybe<Scalars['String']['output']>;
  /** Tenant ID (Snowflake ID) */
  tenantId: Scalars['String']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

/** GraphQL type for SystemUser */
export type SystemUser = {
  __typename?: 'SystemUser';
  /** Authentik UUID (for SSO) */
  authentikUuid: Scalars['String']['output'];
  /** Backup auth enabled */
  backupAuthEnabled: Scalars['Boolean']['output'];
  /** Created timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Email address */
  email: Scalars['String']['output'];
  /** Failed login attempts */
  failedLoginAttempts: Scalars['Int']['output'];
  /** Global roles */
  globalRoles: Array<Scalars['String']['output']>;
  /** Is account active? */
  isActive: Scalars['Boolean']['output'];
  /** Last login timestamp */
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  /** Preferred language */
  preferredLanguage: Scalars['String']['output'];
  /** Tenants this user can access */
  tenantIds: Array<Scalars['String']['output']>;
  /** Timezone */
  timezone: Scalars['String']['output'];
  /** Updated timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID (Snowflake ID) */
  userId: Scalars['String']['output'];
  /** Username (display name) */
  username: Scalars['String']['output'];
  /** WebAuthn credential IDs */
  webauthnCredentialIds: Array<Scalars['String']['output']>;
};

/** Tamper Alert (GraphQL output) */
export type TamperAlert = {
  __typename?: 'TamperAlert';
  /** Audit ID of tampered entry */
  auditId: Scalars['String']['output'];
  /** Detection timestamp */
  detectedAt: Scalars['DateTime']['output'];
  /** Reason for detection */
  reason: Scalars['String']['output'];
  /** Severity */
  severity: Scalars['String']['output'];
};

export type Task = {
  __typename?: 'Task';
  actualCost?: Maybe<Scalars['Float']['output']>;
  actualVsEstimatedRatio?: Maybe<Scalars['Float']['output']>;
  /** WHO performs this task — resolved to human-readable name */
  assignedActor?: Maybe<ActorSummary>;
  assignedActorId?: Maybe<Scalars['String']['output']>;
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedBy?: Maybe<Scalars['String']['output']>;
  /** WHO assigned this task */
  assignedByActor?: Maybe<ActorSummary>;
  /**
   * Auditor actor ID — resolved from constellation's REVIEWED_BY edge (DRR-118)
   *
   * Maps to: QA reviewer (healthcare), Ethics reviewer (legal), Internal audit (financial).
   * Returns None if no constellation_id, no edge, or Valkey unavailable.
   */
  auditorActorId?: Maybe<Scalars['String']['output']>;
  /**
   * Authority actor ID — resolved from constellation's AUTHORIZED_BY edge (DRR-118)
   *
   * Maps to: ALD (healthcare), Partner (legal), Compliance officer (financial).
   * Returns None if no constellation_id, no edge, or Valkey unavailable.
   */
  authorityActorId?: Maybe<Scalars['String']['output']>;
  /**
   * Actor ID who has checked out this life-critical task.
   * Prevents concurrent work on medication/controlled substance tasks.
   */
  checkedOutBy?: Maybe<Scalars['String']['output']>;
  /** When the checkout lock expires (auto-release after TTL) */
  checkoutExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this task.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  contextVariables: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this task */
  createdByActor?: Maybe<ActorSummary>;
  /** DRR-130: How this task was created — regulatory rule, workflow operation, or tenant decision. */
  createdBySource: GqlTaskCreatedBySource | '%future added value';
  currentActorWorkload?: Maybe<Scalars['Float']['output']>;
  currentStep?: Maybe<Scalars['String']['output']>;
  dependencies: Array<Scalars['String']['output']>;
  dependents: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /**
   * Human-readable display name for this task (DRR-217).
   *
   * Resolves from Valkey cache (1-2ms) with graceful degradation.
   * After DRR-217 key compression, IDs like "2_1847" need display names
   * like "Morning Medication Pass" for UX.
   *
   * # Resolution Order
   * 1. Valkey cache (1-2ms, 95%+ hit rate)
   * 2. Wasabi S3 fallback (50-100ms, when S3 feature enabled)
   * 3. Graceful degradation: returns `self.title` if resolver unavailable
   *
   * # Returns
   * Human-readable display name for this task.
   */
  displayName: Scalars['String']['output'];
  /** SLA deadline for this task */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  durationMs?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  estimatedDurationMs?: Maybe<Scalars['String']['output']>;
  expectedOutputSchema?: Maybe<Scalars['String']['output']>;
  failureStrategy: GqlFailureStrategy | '%future added value';
  /** Composable form fragments — ordered list of atomic fragment IDs (DRR-173) */
  formComponents: Array<Scalars['String']['output']>;
  /** FormSchemaOverride ID — jurisdiction-specific form customization */
  formSchemaOverride?: Maybe<Scalars['String']['output']>;
  /** FormSchema binding — single form (legacy). Prefer formComponents (DRR-173). */
  formSchemaRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inputData: Scalars['JSON']['output'];
  /** Whether this task is active (false = archived/soft-deleted) */
  isActive: Scalars['Boolean']['output'];
  /** True when the governing ruleset has an active override policy (DRR-117). */
  mandateIsOverride?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Jurisdiction level of the governing regulation (DRR-117).
   * Resolved via: mandate_ref → ruleset → regnode → known-regulatory-nodes.yaml
   * Returns: "federal" | "state" | "payer" | "accreditor" | "standard" | "tenant" | null
   */
  mandateJurisdiction?: Maybe<Scalars['String']['output']>;
  /**
   * WHY — Mandating regulation config ID (DRR-117)
   * Denormalized from parent task group's MANDATED_BY edge target.
   * Example: `rs-4-1-004` (MN 144G)
   */
  mandateRef?: Maybe<Scalars['String']['output']>;
  /** Authoritative source URL for the governing regulation (DRR-117). */
  mandateSourceUrl?: Maybe<Scalars['String']['output']>;
  /**
   * ALL regulatory mandates for this task (DRR-204).
   *
   * Resolution: task_group_ref → Valkey `idx:edge:{tg}:MANDATED_BY` → ruleset IDs
   * → edge metadata `idx:edge:meta:{tg}:MANDATED_BY:{rs}` → provision_refs
   *
   * Returns a list of mandate info objects, each containing:
   * - ruleset_id: The mandating ruleset (e.g., "rs-4-1-004")
   * - ruleset_name: Human-readable name (e.g., "MN 144G")
   * - provision_refs: Specific statute sections that mandate this task
   *
   * Falls back to [mandate_ref] as single-element list if no task_group_ref or no edges.
   */
  mandates: Array<MandateInfo>;
  maxRetries: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  notificationEvents: Array<GqlTaskNotificationEvent | '%future added value'>;
  outputData?: Maybe<Scalars['JSON']['output']>;
  /** Output entity specs — what completing this task auto-creates */
  outputEntities: Array<GqlTaskOutputSpec>;
  /** Parent task ID (for append-only state chains) */
  parentId?: Maybe<Scalars['String']['output']>;
  priority: GqlTaskPriority | '%future added value';
  progressPercent?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  reassignmentAllowed: Scalars['Boolean']['output'];
  reassignmentHistory: Array<ReassignmentRecord>;
  retryCount: Scalars['Int']['output'];
  retryDelayMs: Scalars['String']['output'];
  /** Root task ID (for efficient history queries via GSI) */
  rootTaskId: Scalars['String']['output'];
  scheduledEnd?: Maybe<Scalars['DateTime']['output']>;
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  sequenceOrder?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: GqlTaskStatus | '%future added value';
  /** WHO this task is about (patient/resident/client) */
  subjectActor?: Maybe<ActorSummary>;
  /**
   * Subject actor — WHO this task is about (patient/client/resident)
   * Distinct from assignedActorId (WHO performs the task)
   */
  subjectActorId?: Maybe<Scalars['String']['output']>;
  /**
   * Supervisor actor ID — resolved from constellation's COORDINATED_BY edge (DRR-118)
   *
   * Resolution: Task.constellation_id → Valkey SMEMBERS → first actor ID.
   * Returns None if no constellation_id, no edge, or Valkey unavailable.
   */
  supervisorActorId?: Maybe<Scalars['String']['output']>;
  /**
   * DHS CL service category — reimbursement alignment (DRR-223)
   * Denormalized from parent task group's `category` field.
   * Values: adl, behavioral, clinical, iadl, transportation, socialization
   */
  taskCategory?: Maybe<Scalars['String']['output']>;
  /**
   * Task group config ID that spawned this task.
   * Enables grouping by work type (e.g., "Daily Medication Tasks").
   */
  taskGroupRef?: Maybe<Scalars['String']['output']>;
  taskType: GqlTaskType | '%future added value';
  /** Team actor — care team this task belongs to (DRR-128) */
  teamActor?: Maybe<ActorSummary>;
  /** Care team this task belongs to — team performance tracking (DRR-128) */
  teamActorId?: Maybe<Scalars['String']['output']>;
  /**
   * Tool that auto-completes this task when successfully used (DRR-934).
   * Examples: "spatial_pinning_editor", "live_photo_capture".
   */
  toolHint?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** WHO last updated this task */
  updatedByActor?: Maybe<ActorSummary>;
  version: Scalars['Int']['output'];
  /**
   * Violation check outcome from task creation (DRR-130).
   * Returns "warn", "deferred", or null if no violation was detected.
   * "block" never appears here — blocked tasks fail the mutation entirely.
   */
  violationOutcome?: Maybe<Scalars['String']['output']>;
  /**
   * Review deadline for deferred violation checks (24h post-creation).
   * Only set when violation_outcome = "deferred".
   */
  violationReviewDeadline?: Maybe<Scalars['String']['output']>;
};

/** Task assignment in a shift plan */
export type TaskAssignment = {
  __typename?: 'TaskAssignment';
  /** Assigned staff member */
  assignedStaffId: Scalars['String']['output'];
  /** Secondary staff for two-person assists */
  assistStaffId?: Maybe<Scalars['String']['output']>;
  /** Continuity score for cognitive residents */
  continuityScore?: Maybe<Scalars['Float']['output']>;
  /** Priority score */
  priorityScore: Scalars['Int']['output'];
  /** Why this assignment was made */
  rationale: AssignmentRationale;
  /** Resource reservation ID */
  reservationId?: Maybe<Scalars['String']['output']>;
  /** Scheduled end */
  scheduledEnd: Scalars['DateTime']['output'];
  /** Scheduled start */
  scheduledStart: Scalars['DateTime']['output'];
  /** Resident/subject ID */
  subjectId: Scalars['String']['output'];
  /** Task ID */
  taskId: Scalars['String']['output'];
};

/** Task assignment event (new task assigned to user) */
export type TaskAssignmentEvent = {
  __typename?: 'TaskAssignmentEvent';
  assignedBy: Scalars['String']['output'];
  assignedTo: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  instanceId: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

/**
 * Task collaboration event (real-time multi-user editing)
 *
 * Phase 3B: Real-Time Collaboration ($300K/year)
 * Supports: user presence, field locks, conflict detection
 */
export type TaskCollaborationEvent = {
  __typename?: 'TaskCollaborationEvent';
  eventType: Scalars['String']['output'];
  fieldName?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  taskId: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** Completion hints for a task */
export type TaskCompletionHintsResult = {
  __typename?: 'TaskCompletionHintsResult';
  /** Contextual information */
  contextualInfo: Array<ContextualInfoOutput>;
  /** Guidance for input fields */
  inputFieldGuidance: Array<InputFieldGuidanceOutput>;
  /** Quick actions available */
  quickActions: Array<QuickActionOutput>;
};

/** Task count grouped by performer */
export type TaskCountByPerformer = {
  __typename?: 'TaskCountByPerformer';
  count: Scalars['Int']['output'];
  performerId: Scalars['String']['output'];
};

/** Task count grouped by source */
export type TaskCountBySource = {
  __typename?: 'TaskCountBySource';
  count: Scalars['Int']['output'];
  sourceId: Scalars['String']['output'];
};

/** Task count grouped by subject */
export type TaskCountBySubject = {
  __typename?: 'TaskCountBySubject';
  count: Scalars['Int']['output'];
  subjectId: Scalars['String']['output'];
};

/** Filter for querying tasks */
export type TaskFilterInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by constellation instance. DRR-118. */
  constellationId?: InputMaybe<Scalars['String']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<FormsTaskPriority | '%future added value'>;
  status?: InputMaybe<FormsTaskStatus | '%future added value'>;
  /** Filter by subject actor (patient/resident). DRR-117. */
  subjectActorId?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
};

/** A task group template containing ordered child tasks. */
export type TaskGroup = {
  __typename?: 'TaskGroup';
  /** Category this group belongs to */
  category: TaskGroupCategory | '%future added value';
  /** Ordered list of child task templates */
  children: Array<ChildTask>;
  /** Mantine color for badges */
  color?: Maybe<Scalars['String']['output']>;
  /** How completion is determined */
  completionStrategy: CompletionStrategy | '%future added value';
  /** Parent config file identifier (e.g., "fhir-alf-tg-adl") */
  configId: Scalars['String']['output'];
  /** Description of what this group covers */
  description?: Maybe<Scalars['String']['output']>;
  /** Tabler icon name for UI display */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique group identifier (e.g., "adl-bathing") */
  id: Scalars['String']['output'];
  /** Whether any tasks in this group are life-critical */
  isLifeCritical: Scalars['Boolean']['output'];
  /** Human-readable group name */
  name: Scalars['String']['output'];
  /** Schedule configuration as JSON string */
  schedule?: Maybe<Scalars['String']['output']>;
  /** Setting context (e.g., "assisted_living") */
  setting: Scalars['String']['output'];
  /** Subgraph this group belongs to */
  subgraph: Scalars['String']['output'];
  /** Searchable tags */
  tags: Array<Scalars['String']['output']>;
};

/** Task group category (matches categories in task-group-templates.yaml). */
export const TaskGroupCategory = {
  /** Activities of Daily Living (bathing, dressing, toileting, mobility, eating) */
  ADL: 'ADL',
  /** Clinical Assessments (vitals, skin checks, shift assessments) */
  CLINICAL: 'CLINICAL',
  /** Medication Administration (scheduled and PRN med passes) */
  MEDICATION: 'MEDICATION',
  /** Nutrition & Dining (meal service, hydration, dietary monitoring) */
  NUTRITION: 'NUTRITION',
  /** Safety & Environment (rounds, drills, infection control) */
  SAFETY: 'SAFETY',
  /** Social & Activities (recreation, engagement, therapy) */
  SOCIAL: 'SOCIAL',
  /** Training & Competency (orientation, ULP competencies, continuing education) */
  TRAINING: 'TRAINING',
  /** Training Compliance (annual required training) */
  TRAINING_COMPLIANCE: 'TRAINING_COMPLIANCE',
  /** ULP Competency (144G.61 Subd 2 competency verification) */
  ULP_COMPETENCY: 'ULP_COMPETENCY',
} as const;

export type TaskGroupCategory = (typeof TaskGroupCategory)[keyof typeof TaskGroupCategory];
/** Summary information about a task group category. */
export type TaskGroupCategoryInfo = {
  __typename?: 'TaskGroupCategoryInfo';
  /** Mantine color */
  color: Scalars['String']['output'];
  /** Category description */
  description: Scalars['String']['output'];
  /** Number of task groups in this category */
  groupCount: Scalars['Int']['output'];
  /** Tabler icon name */
  icon: Scalars['String']['output'];
  /** Category identifier (adl, medication, clinical, etc.) */
  id: Scalars['String']['output'];
  /** Human-readable category name */
  name: Scalars['String']['output'];
};

/** Task group definition */
export type TaskGroupOutput = {
  __typename?: 'TaskGroupOutput';
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique group key */
  groupKey: Scalars['String']['output'];
  /** Optional icon identifier */
  icon?: Maybe<Scalars['String']['output']>;
  /** Human-readable label */
  label: Scalars['String']['output'];
  /** Number of tasks in group */
  taskCount: Scalars['Int']['output'];
};

/** Task guidance with steps and tips */
export type TaskGuidanceOutput = {
  __typename?: 'TaskGuidanceOutput';
  /** Compliance notes (regulatory requirements) */
  complianceNotes: Array<Scalars['String']['output']>;
  /** Confidence score (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** Unique guidance ID */
  guidanceId: Scalars['String']['output'];
  /** Links to related documentation */
  relatedDocumentation: Array<Scalars['String']['output']>;
  /** Step-by-step instructions */
  steps: Array<GuidanceStepOutput>;
  /** Task this guidance is for */
  taskId: Scalars['String']['output'];
  /** Helpful tips */
  tips: Array<Scalars['String']['output']>;
  /** Warnings to be aware of */
  warnings: Array<Scalars['String']['output']>;
};

export const TaskKind = {
  UNKNOWN: 'UNKNOWN',
  ack: 'ack',
  approval: 'approval',
  handoff: 'handoff',
  review: 'review',
} as const;

export type TaskKind = (typeof TaskKind)[keyof typeof TaskKind];
/** Task metrics aggregation */
export type TaskMetrics = {
  __typename?: 'TaskMetrics';
  avgCompletionTime: Scalars['Float']['output'];
  completedTasks: Scalars['Int']['output'];
  completionRate: Scalars['Float']['output'];
  inProgressTasks: Scalars['Int']['output'];
  overdueTasks: Scalars['Int']['output'];
  pendingTasks: Scalars['Int']['output'];
  totalTasks: Scalars['Int']['output'];
};

export type TaskPriorityWeights = {
  __typename?: 'TaskPriorityWeights';
  /** Acuity weight */
  acuityWeight: Scalars['Int']['output'];
  /** Continuity weight */
  continuityWeight: Scalars['Int']['output'];
  /** Deadline weight */
  deadlineWeight: Scalars['Int']['output'];
  /** Resource weight */
  resourceWeight: Scalars['Int']['output'];
  /** Sequence weight */
  sequenceWeight: Scalars['Int']['output'];
};

export const TaskStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  UNKNOWN: 'UNKNOWN',
  blocked: 'blocked',
  done: 'done',
  expired: 'expired',
  open: 'open',
} as const;

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];
/** Task status update event (status transition) */
export type TaskStatusUpdate = {
  __typename?: 'TaskStatusUpdate';
  instanceId: Scalars['String']['output'];
  newStatus: Scalars['String']['output'];
  oldStatus: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  taskId: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type TaskSummaryInput = {
  criticalPriority: Scalars['Int']['input'];
  overdue: Scalars['Int']['input'];
  pendingApproval: Scalars['Int']['input'];
  totalOpen: Scalars['Int']['input'];
};

/** Summary of organized tasks */
export type TaskSummaryOutput = {
  __typename?: 'TaskSummaryOutput';
  /** Number of critical priority tasks */
  criticalCount: Scalars['Int']['output'];
  /** Estimated total duration */
  estimatedTotalDuration?: Maybe<Scalars['String']['output']>;
  /** Number of overdue tasks */
  overdueCount: Scalars['Int']['output'];
  /** AI-suggested focus area */
  suggestedFocus: Scalars['String']['output'];
  /** Total number of tasks */
  totalTasks: Scalars['Int']['output'];
};

/** GraphQL Object implementation with hypermedia fields */
export type TaxNotification = {
  __typename?: 'TaxNotification';
  /**
   * Available actions based on current state and user permissions
   *
   * ## Example Response
   *
   * ```json
   * [
   * {
   * "name": "cancelNotification",
   * "description": "Cancel this scheduled notification",
   * "mutation": "cancelNotification",
   * "requiresConfirmation": true,
   * "requiresPermission": ["tax_notifications:cancel"],
   * "icon": "cancel",
   * "variant": "danger"
   * }
   * ]
   * ```
   */
  availableActions: Array<Action>;
  /** Tax category (federal, state, local) */
  category: Scalars['String']['output'];
  /** Delivery channels (email, sms, slack, in_app) */
  channels: Array<Scalars['String']['output']>;
  /** Company identifier */
  companyId: Scalars['String']['output'];
  /** ISO8601 timestamp when notification was created */
  createdAt: Scalars['String']['output'];
  /** ISO8601 date when tax change becomes effective */
  effectiveDate: Scalars['String']['output'];
  /** Impact summary for payroll */
  impactSummary: ImpactSummary;
  /** Tax jurisdiction (US, CA, UK) */
  jurisdiction: Scalars['String']['output'];
  /**
   * Possible next states based on current workflow state
   *
   * ## Example Response
   *
   * ```json
   * [
   * {
   * "to": "cancelled",
   * "action": "cancelNotification",
   * "conditions": ["has_permission:tax_notifications:cancel"],
   * "description": "Cancel notification"
   * },
   * {
   * "to": "sending",
   * "action": "auto_trigger",
   * "conditions": [],
   * "description": "Automatic trigger at scheduled time",
   * "estimatedDuration": "PT5M"
   * }
   * ]
   * ```
   */
  nextStates: Array<StateTransition>;
  /** Notification type (30d, 7d, day-of, post-payroll, emergency) */
  notificationType: Scalars['String']['output'];
  /** Primary key */
  pk: Scalars['String']['output'];
  /**
   * Links to related resources
   *
   * ## Example Response
   *
   * ```json
   * [
   * {
   * "resourceType": "company",
   * "id": "acme-corp",
   * "url": "/companies/acme-corp",
   * "relationship": "owner",
   * "title": "ACME Corporation"
   * },
   * {
   * "resourceType": "tax_change",
   * "id": "tax_change_123",
   * "url": "/tax-changes/tax_change_123",
   * "relationship": "trigger",
   * "title": "2026 Social Security Wage Base Increase"
   * }
   * ]
   * ```
   */
  relatedResources: Array<ResourceLink>;
  /** ISO8601 date when notification should be sent */
  sendDate: Scalars['String']['output'];
  /** ISO8601 timestamp when notification was sent (optional) */
  sentAt?: Maybe<Scalars['String']['output']>;
  /** Sort key */
  sk: Scalars['String']['output'];
  /** Status (scheduled, sent, failed, cancelled) */
  status: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /**
   * Workflow business context for AI agents
   *
   * ## Example Response
   *
   * ```json
   * {
   * "workflowType": "tax_notifications",
   * "domain": "payroll",
   * "criticality": "operational",
   * "estimatedCompletionTime": "PT48H",
   * "metadata": {
   * "affected_employees": "150",
   * "total_impact": "12500.00",
   * "notification_type": "30d"
   * }
   * }
   * ```
   */
  workflowContext: WorkflowContext;
  /** Tax year */
  year: Scalars['Int']['output'];
};

/** GraphQL output type for Team primitive. */
export type Team = {
  __typename?: 'Team';
  /** Is team active? */
  active: Scalars['Boolean']['output'];
  /** Audit version (optimistic locking) */
  auditVersion: Scalars['Int']['output'];
  /** Budget assigned */
  budgetAllocated?: Maybe<Scalars['Float']['output']>;
  /** Reason for this change */
  changeReason: Scalars['String']['output'];
  /** User who made this change */
  changedBy: Scalars['String']['output'];
  /** Short code (alphanumeric + hyphens/underscores) */
  code: Scalars['String']['output'];
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this team.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Team contact information */
  contacts: GqlTeamContacts;
  /** Accounting code */
  costCenter?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Created by user ID */
  createdBy: Scalars['String']['output'];
  /** Unlimited extensibility for tenant-specific fields */
  customFields: Scalars['JSON']['output'];
  /** Backup leader */
  deputyLeadId?: Maybe<Scalars['String']['output']>;
  /** Team purpose */
  description?: Maybe<Scalars['String']['output']>;
  /** Team start date */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Team end date (for project teams) */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Escalation chain */
  escalationPath: Array<Scalars['String']['output']>;
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Whether this version is the active head */
  isActive: Scalars['Boolean']['output'];
  /** Hierarchy level (0 = root, max 5) */
  level: Scalars['Int']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Original entity ID for version chain */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Version chain parent (not org hierarchy) */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Parent team for tree structure */
  parentTeamId?: Maybe<Scalars['String']['output']>;
  /** Full path ("/eng/backend/api") */
  path: Scalars['String']['output'];
  /** Resource quotas */
  quotaLimits: GqlQuotaLimits;
  /** Key stakeholders */
  stakeholderIds: Array<Scalars['String']['output']>;
  /** Why inactive/ended? */
  statusReason?: Maybe<Scalars['String']['output']>;
  /** Searchable tags */
  tags: Array<Scalars['String']['output']>;
  /** Primary team leader */
  teamLeadId?: Maybe<Scalars['String']['output']>;
  /** Team type classification */
  teamType: GqlTeamType | '%future added value';
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Updated by user ID */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Record version number */
  version: Scalars['Int']['output'];
};

/**
 * Team Archive Result (FERP Append-Only Architecture)
 *
 * Returned by `archiveTeam` mutation. Contains full audit metadata
 * for compliance (HIPAA, SOX, SOC2).
 *
 * FERP Principle: No DELETE operations - use archive instead.
 */
export type TeamArchiveResult = {
  __typename?: 'TeamArchiveResult';
  /** Timestamp when the team was archived */
  archivedAt: Scalars['DateTime']['output'];
  /** User ID who performed the archive */
  archivedBy: Scalars['String']['output'];
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Mandatory reason for archiving (audit compliance) */
  reason: Scalars['String']['output'];
  /** Whether the archive operation succeeded */
  success: Scalars['Boolean']['output'];
  /** Team code that was archived */
  teamCode: Scalars['String']['output'];
  /** Team name that was archived */
  teamName: Scalars['String']['output'];
};

/**
 * Expert metadata utilities for GraphQL - maintains data-driven architecture
 * Expert data lives in Actor.metadata JsonValue field, not hardcoded structs
 * Team capacity metrics for expert routing decisions
 */
export type TeamCapacityMetricsGql = {
  __typename?: 'TeamCapacityMetricsGql';
  availableExperts: Scalars['Int']['output'];
  avgCapacity: Scalars['Float']['output'];
  overloadedExperts: Scalars['Int']['output'];
  shouldHandoffToSpecialists: Scalars['Boolean']['output'];
};

/**
 * GraphQL output type for Template primitive
 *
 * Templates store complete Metadata DSL (4-layer structure) and generate primitive instances.
 * Position in 25-Primitive Grid: Phase 1 (DESIGN), Position #2/25
 */
export type Template = {
  __typename?: 'Template';
  active: Scalars['Boolean']['output'];
  auditRequirements: Array<Scalars['String']['output']>;
  auditVersion: Scalars['Int']['output'];
  authorityId?: Maybe<Scalars['String']['output']>;
  businessLayer: Scalars['JSON']['output'];
  category: Scalars['String']['output'];
  complianceFrameworks: Array<Scalars['String']['output']>;
  complianceLevel?: Maybe<Scalars['String']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this template.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  criticality: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  formulaSuccessRates: Scalars['JSON']['output'];
  formulasParticipating: Array<Scalars['String']['output']>;
  generatedInstanceIds: Array<Scalars['String']['output']>;
  generationCount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  jurisdictionalScope: Array<Scalars['String']['output']>;
  lastGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  mappingsLayer: Scalars['JSON']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  originalId?: Maybe<Scalars['String']['output']>;
  parentVersionId?: Maybe<Scalars['String']['output']>;
  primitiveLayer: Scalars['JSON']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  recordVersion: Scalars['Int']['output'];
  riskClassification?: Maybe<Scalars['String']['output']>;
  status: GqlTemplateStatus | '%future added value';
  tags: Array<Scalars['String']['output']>;
  targetFormulas: Array<Scalars['String']['output']>;
  uiLayer: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  usageCount: Scalars['String']['output'];
  validationResult?: Maybe<Scalars['JSON']['output']>;
  version: Scalars['String']['output'];
};

/**
 * GraphQL output type for cache metrics
 *
 * Matches TemplateCacheMetricsSummary but uses async-graphql SimpleObject derive.
 */
export type TemplateCacheMetrics = {
  __typename?: 'TemplateCacheMetrics';
  /** Average cache hit latency (milliseconds) */
  avgCacheHitLatencyMs: Scalars['Float']['output'];
  /** Average cache miss latency (milliseconds) */
  avgCacheMissLatencyMs: Scalars['Float']['output'];
  /** Average DynamoDB fallback latency (milliseconds) */
  avgDynamodbFallbackLatencyMs: Scalars['Float']['output'];
  /** Total cache errors */
  cacheErrors: Scalars['Int']['output'];
  /** Cache hit rate (0.0 to 1.0) */
  cacheHitRate: Scalars['Float']['output'];
  /** Total cache hits */
  cacheHits: Scalars['Int']['output'];
  /** Total cache invalidations */
  cacheInvalidations: Scalars['Int']['output'];
  /** Estimated cache memory usage (bytes) */
  cacheMemoryUsageBytes: Scalars['Int']['output'];
  /** Total cache misses */
  cacheMisses: Scalars['Int']['output'];
  /** Total cache writes */
  cacheWrites: Scalars['Int']['output'];
  /** Number of templates currently cached */
  cachedTemplatesCount: Scalars['Int']['output'];
  /** Timestamp when metrics were collected (RFC3339) */
  collectedAt: Scalars['String']['output'];
  /** Cache effectiveness score (0.0 to 1.0) */
  effectivenessScore: Scalars['Float']['output'];
  /** Estimated monthly cost savings from caching (USD) */
  estimatedMonthlySavingsUsd: Scalars['Float']['output'];
  /** Whether cache is meeting performance targets (>90% hit rate, <1ms latency) */
  isMeetingTargets: Scalars['Boolean']['output'];
};

/**
 * Change Type (GraphQL Enum)
 * Renamed to TemplateChangeType to avoid collision with policy_version_graphql::GqlChangeType
 */
export const TemplateChangeType = {
  /** Field added */
  ADDED: 'ADDED',
  /** Field deleted */
  DELETED: 'DELETED',
  /** Field modified */
  MODIFIED: 'MODIFIED',
} as const;

export type TemplateChangeType = (typeof TemplateChangeType)[keyof typeof TemplateChangeType];
/**
 * Template Export Data
 *
 * Complete template export with metadata and evidence
 */
export type TemplateExportData = {
  __typename?: 'TemplateExportData';
  /** Evidence data (if included) */
  evidence?: Maybe<Scalars['JSON']['output']>;
  /** Export format version */
  exportVersion: Scalars['String']['output'];
  /** Export metadata */
  metadata: ExportMetadata;
  /** Template data (complete WorkflowTemplateMetadata) */
  template: Scalars['JSON']['output'];
};

/**
 * Field Change (GraphQL Output)
 * Renamed to TemplateFieldChange to avoid collision with policy_version_graphql::GqlFieldChange
 */
export type TemplateFieldChange = {
  __typename?: 'TemplateFieldChange';
  /** Change type */
  changeType: TemplateChangeType | '%future added value';
  /** Field path */
  fieldPath: Scalars['String']['output'];
  /** New value (JSON) */
  newValue?: Maybe<Scalars['JSON']['output']>;
  /** Old value (JSON) */
  oldValue?: Maybe<Scalars['JSON']['output']>;
};

/** Single template fix operation */
export type TemplateFix = {
  __typename?: 'TemplateFix';
  /** Value after fix (JSON) */
  after: Scalars['String']['output'];
  /** Value before fix (JSON) */
  before: Scalars['String']['output'];
  /** Confidence in this fix (0.0-1.0) */
  confidence: Scalars['Float']['output'];
  /** Field ID being fixed */
  fieldId: Scalars['String']['output'];
  /** Type of fix operation */
  fixType: Scalars['String']['output'];
  /** AI reasoning for this fix */
  reasoning: Scalars['String']['output'];
  /** Step ID containing the field */
  stepId: Scalars['String']['output'];
};

/**
 * Template list item (lightweight)
 *
 * Used for listing without loading full metadata.
 */
export type TemplateListItem = {
  __typename?: 'TemplateListItem';
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
  templateVersion: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

/** Template metadata content (5 layers) */
export type TemplateMetadataContent = {
  __typename?: 'TemplateMetadataContent';
  /** Business metadata (name, domain, category, etc.) */
  business: BusinessMetadata;
  /** Compliance metadata (frameworks, audit level) */
  compliance: ComplianceMetadata;
  /** Field mappings (ui ↔ primitives) */
  mappings: Scalars['JSON']['output'];
  /** Primitive composition (16 types only) */
  primitives: PrimitiveComposition;
  /** UI metadata (layout, steps, fields) */
  ui: Uimetadata;
};

/** Template metadata content input */
export type TemplateMetadataContentInput = {
  business: BusinessMetadataInput;
  compliance: ComplianceMetadataInput;
  mappings: Scalars['JSON']['input'];
  primitives: PrimitiveCompositionInput;
  ui: UimetadataInput;
};

/** Template metadata content output */
export type TemplateMetadataContentOutput = {
  __typename?: 'TemplateMetadataContentOutput';
  business: BusinessMetadataOutput;
  compliance: ComplianceMetadataOutput;
  mappings: Scalars['JSON']['output'];
  primitives: PrimitiveCompositionOutput;
  ui: UimetadataOutput;
};

/**
 * Complete template metadata output (full detail)
 *
 * Used for get_template_metadata and get_latest_template_metadata queries.
 * Returns all fields for complete template information.
 *
 * SPRINT 3 ENHANCEMENT: Added evidence attribution for AI-generated templates
 */
export type TemplateMetadataOutput = {
  __typename?: 'TemplateMetadataOutput';
  /** Overall confidence metrics for AI-generated template */
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  /**
   * Evidence attribution for each field (field_id → evidence)
   * CRITICAL: Required for audit trail and trust in AI-generated templates
   */
  evidence?: Maybe<Array<WorkflowEvidenceAttributionOutput>>;
  /** Extraction metadata (source document, LLM provider, etc.) */
  extractionMetadata?: Maybe<ExtractionMetadataOutput>;
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  metadata: TemplateMetadataContentOutput;
  schemaVersion: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
  templateVersion: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
  versionHistory: Array<VersionEntryOutput>;
};

/** Template Parameter (GraphQL Output) */
export type TemplateParameter = {
  __typename?: 'TemplateParameter';
  /** Default value (JSON) */
  defaultValue: Scalars['JSON']['output'];
  /** Parameter description */
  description: Scalars['String']['output'];
  /** Parameter name (used in {{name}} placeholders) */
  name: Scalars['String']['output'];
  /** Parameter data type */
  paramType: ParameterType | '%future added value';
  /** Validation rules (min, max, pattern as JSON) */
  validation?: Maybe<Scalars['JSON']['output']>;
};

export type TemplateRoleDefinition = {
  __typename?: 'TemplateRoleDefinition';
  capabilities: Array<Scalars['String']['output']>;
  certificationRequirements?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  inheritsFrom: Array<Scalars['String']['output']>;
  orchestration?: Maybe<Scalars['JSON']['output']>;
  requiredSkills: Array<Scalars['String']['output']>;
  roleName: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
  specializations: Array<Scalars['String']['output']>;
};

export type TemplateRoleDefinitionInput = {
  capabilities: Array<Scalars['String']['input']>;
  certificationRequirements?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  inheritsFrom: Array<Scalars['String']['input']>;
  orchestration?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  roleName: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Rollback Result (GraphQL Output)
 * Renamed to TemplateRollbackResult to avoid collision with policy_version_graphql::GqlRollbackResult
 */
export type TemplateRollbackResult = {
  __typename?: 'TemplateRollbackResult';
  /** Error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** New version ID */
  newVersionId: Scalars['String']['output'];
  /** New version number */
  newVersionNumber: Scalars['Int']['output'];
  /** Success flag */
  success: Scalars['Boolean']['output'];
};

/**
 * Validation Result
 * Renamed to TemplateValidationResult to avoid collision with forms_api::types::ValidationResult
 */
export type TemplateValidationResult = {
  __typename?: 'TemplateValidationResult';
  /** Validation errors */
  errors: Array<Scalars['String']['output']>;
  /** Template name (if parseable) */
  templateName?: Maybe<Scalars['String']['output']>;
  /** Template version (if parseable) */
  templateVersion?: Maybe<Scalars['String']['output']>;
  /** Valid flag */
  valid: Scalars['Boolean']['output'];
  /** Validation warnings */
  warnings: Array<Scalars['String']['output']>;
};

/** Template Version (GraphQL Output) */
export type TemplateVersion = {
  __typename?: 'TemplateVersion';
  /** Change description */
  changeDescription: Scalars['String']['output'];
  /** Created timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Created by (user ID) */
  createdBy: Scalars['String']['output'];
  /** Previous version ID */
  previousVersionId?: Maybe<Scalars['String']['output']>;
  /** Version status */
  status: TemplateVersionStatus | '%future added value';
  /** Template ID */
  templateId: Scalars['String']['output'];
  /** Template snapshot (complete WorkflowTemplateMetadata at this version) */
  templateSnapshot: Scalars['JSON']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Version ID */
  versionId: Scalars['String']['output'];
  /** Version number */
  versionNumber: Scalars['Int']['output'];
};

/** Template Version Diff (GraphQL Output) */
export type TemplateVersionDiff = {
  __typename?: 'TemplateVersionDiff';
  /** List of field changes */
  changes: Array<TemplateFieldChange>;
  /** From version number */
  fromVersion: Scalars['Int']['output'];
  /** Summary of changes */
  summary: Scalars['String']['output'];
  /** To version number */
  toVersion: Scalars['Int']['output'];
};

/**
 * Version History Summary (GraphQL Output)
 * Renamed to TemplateVersionHistorySummary to avoid collision with policy_version_graphql::GqlVersionHistorySummary
 */
export type TemplateVersionHistorySummary = {
  __typename?: 'TemplateVersionHistorySummary';
  /** Current active version number */
  currentVersion: Scalars['Int']['output'];
  /** First version created */
  firstCreatedAt: Scalars['DateTime']['output'];
  /** Last version created */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Template ID */
  templateId: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Total number of changes */
  totalChanges: Scalars['Int']['output'];
  /** Total number of versions */
  totalVersions: Scalars['Int']['output'];
};

/**
 * Version Status (GraphQL Enum)
 * Renamed to TemplateVersionStatus to avoid collision with policy_version_graphql::GqlVersionStatus
 */
export const TemplateVersionStatus = {
  /** Active version */
  ACTIVE: 'ACTIVE',
  /** Deprecated version */
  DEPRECATED: 'DEPRECATED',
  /** Draft version */
  DRAFT: 'DRAFT',
  /** Superseded version */
  SUPERSEDED: 'SUPERSEDED',
} as const;

export type TemplateVersionStatus =
  (typeof TemplateVersionStatus)[keyof typeof TemplateVersionStatus];
/**
 * Tenant federation entity - **projection of TenantConfig**
 *
 * Represents an organization/company in the FERP system.
 * The underlying data comes from TenantConfigRepository via BackendRouter.
 * Subgraphs like Payroll extend this with configuration specific to their domain.
 *
 * # FERP Architecture Note
 *
 * Tenant is NOT one of the 25 primitives. It's the organizational isolation
 * boundary that owns primitives. TenantConfig defines:
 * - Storage tier configuration (cloud, self-hosted, hybrid)
 * - Feature flags enabled for the tenant
 * - Database connection configuration
 *
 * # FERP Architecture Mapping
 *
 * | Tenant Field | TenantConfig Field | Notes |
 * |--------------|-------------------|-------|
 * | id | tenant_id | Tenant identifier |
 * | name | display_name | Display name |
 * | status | status | TenantStatus enum |
 * | timezone | region | Deployment region |
 * | domains | enabled_features | Feature flags as domain proxies |
 *
 * # Federation Key
 * `@key(fields: "id")` - resolved by ID lookup via FederationEntityQuery
 *
 * # Example Extension (in payroll subgraph)
 * ```graphql
 * extend type Tenant @key(fields: "id") {
 * id: ID! @external
 * payrollConfig: TenantPayrollConfig
 * circuitBreakerStatus: CircuitBreakerStatus
 * }
 * ```
 */
export type Tenant = {
  __typename?: 'Tenant';
  /** Domain identifiers/features this tenant has enabled */
  domains: Array<Scalars['String']['output']>;
  /** Unique identifier (federation @key) - maps to TenantConfig.tenant_id */
  id: Scalars['ID']['output'];
  /** Tenant display name - maps to TenantConfig.display_name */
  name: Scalars['String']['output'];
  /** Tenant status (active, suspended, etc.) - maps to TenantConfig.status */
  status: Scalars['String']['output'];
  /** Primary timezone/region (from tenant configuration) */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Tenant Branding Output */
export type TenantBranding = {
  __typename?: 'TenantBranding';
  /** Accent color (hex) */
  accentColor: Scalars['String']['output'];
  /** Accreditations */
  accreditations: Array<Scalars['String']['output']>;
  /** Physical address */
  address?: Maybe<Scalars['String']['output']>;
  /** Company name */
  companyName: Scalars['String']['output'];
  /** Company tagline */
  companyTagline?: Maybe<Scalars['String']['output']>;
  /** Compliance frameworks */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Audit trail */
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Custom domain */
  customDomain?: Maybe<Scalars['String']['output']>;
  /** Favicon URL */
  faviconUrl?: Maybe<Scalars['String']['output']>;
  /** Feature flags */
  features: TenantFeatures;
  /** Font family */
  fontFamily: Scalars['String']['output'];
  /** Hide FERP branding */
  hideFerpBranding: Scalars['Boolean']['output'];
  /** Business hours */
  hours?: Maybe<Scalars['String']['output']>;
  /** Industry vertical */
  industry: Scalars['String']['output'];
  /** License type */
  licenseType?: Maybe<Scalars['String']['output']>;
  /** Logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Primary color (hex) */
  primaryColor: Scalars['String']['output'];
  /** Safety configuration */
  safetyConfig: TenantSafetyConfig;
  /** Secondary color (hex) */
  secondaryColor: Scalars['String']['output'];
  /** Services offered */
  services: Array<Scalars['String']['output']>;
  /** Show help center */
  showHelpCenter: Scalars['Boolean']['output'];
  /** Show support chat */
  showSupportChat: Scalars['Boolean']['output'];
  /** Subdomain */
  subdomain: Scalars['String']['output'];
  /** Support email */
  supportEmail?: Maybe<Scalars['String']['output']>;
  /** Support phone */
  supportPhone?: Maybe<Scalars['String']['output']>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Terminology mapping (FERP term → Industry term) */
  terminology: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  /** Public website slug */
  websiteSlug?: Maybe<Scalars['String']['output']>;
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Tenant Feature Flags Output */
export type TenantFeatures = {
  __typename?: 'TenantFeatures';
  auditTrail: Scalars['Boolean']['output'];
  documentGeneration: Scalars['Boolean']['output'];
  dualApproval: Scalars['Boolean']['output'];
  lifeCritical: Scalars['Boolean']['output'];
  realTimeAlerts: Scalars['Boolean']['output'];
};

/** Complete flow map data for all three views */
export type TenantFlowMap = {
  __typename?: 'TenantFlowMap';
  /** Activity buckets (for Temporal Heatmap) */
  activityBuckets: Array<FlowMapActivityBucket>;
  /** Intersection points (for highlighting shared work) */
  intersections: Array<FlowMapIntersection>;
  /** Performers (for Sankey middle column, Chord top arc) */
  performers: Array<FlowMapPerformer>;
  /** Sources of work (for Sankey left column) */
  sources: Array<FlowMapSource>;
  /** Subjects (for Sankey right column, Chord bottom arc) */
  subjects: Array<FlowMapSubject>;
};

export type TenantMetadataGql = {
  __typename?: 'TenantMetadataGql';
  brandConfig: BrandConfigGql;
  businessRules: Scalars['JSON']['output'];
  createdAt: Scalars['String']['output'];
  extends: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

/** Input for tenant metadata */
export type TenantMetadataInput = {
  /** City (optional for local licensing) */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Custom fields for extensibility (JSON object) */
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Industry type: "healthcare", "food_service", "retail", "laundry" */
  industry: Scalars['String']['input'];
  /** Payers accepted: ["private_pay", "medicaid_ew", "medicare"] */
  payers?: Array<Scalars['String']['input']>;
  /** Service type within industry (optional) */
  serviceType?: InputMaybe<Scalars['String']['input']>;
  /** Services offered */
  services?: Array<Scalars['String']['input']>;
  /** State of primary operation: "MN", "WI", etc. */
  state: Scalars['String']['input'];
};

/**
 * A tenant-specific product activation record.
 *
 * Created when a tenant activates a product from the catalog.
 * Stored at `PK=~{tenant_num}, SK=PRODUCT#{product_id}`.
 */
export type TenantProduct = {
  __typename?: 'TenantProduct';
  /** ISO 8601 timestamp of activation */
  activatedAt?: Maybe<Scalars['String']['output']>;
  /** Actor global ID who activated this product */
  activatedBy?: Maybe<Scalars['String']['output']>;
  /** Industry (denormalized from product definition) */
  industry: Scalars['String']['output'];
  /** Jurisdiction (denormalized from product definition) */
  jurisdiction: Scalars['String']['output'];
  /** ISO 8601 timestamp of last status change */
  lastStatusChange?: Maybe<Scalars['String']['output']>;
  /** Product identifier (e.g., "prod-1-001") */
  productId: Scalars['String']['output'];
  /** Human-readable product name (denormalized for quick display) */
  productName: Scalars['String']['output'];
  /** Product version at time of activation */
  productVersion: Scalars['String']['output'];
  /** Current provisioning status */
  provisioningStatus: ProductProvisioningStatus | '%future added value';
  /** Number of rulesets activated by this product */
  rulesetCount: Scalars['Int']['output'];
  /** Tenant number */
  tenantNum: Scalars['Int']['output'];
  /** Number of workflows activated by this product */
  workflowCount: Scalars['Int']['output'];
};

/** Tenant Safety Config Output */
export type TenantSafetyConfig = {
  __typename?: 'TenantSafetyConfig';
  autoEscalationEnabled: Scalars['Boolean']['output'];
  defaultSafetyLevel: Scalars['String']['output'];
  requireConfirmationAbove: Scalars['String']['output'];
};

/** Input Types for Admin Operations */
export type TenantSettingsInput = {
  /** Audit configuration */
  auditConfig?: InputMaybe<AuditConfigInput>;
  /** Tenant-specific configuration */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Feature flags configuration */
  featureFlags?: InputMaybe<Scalars['JSON']['input']>;
  /** Integration settings */
  integrations?: InputMaybe<Scalars['JSON']['input']>;
  /** Notification preferences */
  notifications?: InputMaybe<NotificationSettingsInput>;
  /** Resource limits and quotas */
  resourceLimits?: InputMaybe<ResourceLimitsInput>;
};

/**
 * Tenant's complete subgraph configuration
 *
 * This is the PRIMARY query for frontends to get all data-driven config:
 * - Routes to register
 * - Navigation items to display
 * - Entity types for form generation
 * - Permission scopes for RBAC
 */
export type TenantSubgraphConfig = {
  __typename?: 'TenantSubgraphConfig';
  /** All entity types available to this tenant */
  allEntityTypes: Array<SubgraphEntityType>;
  /** All nav items available to this tenant (sorted) */
  allNavItems: Array<SubgraphNavItem>;
  /** All permission scopes available to this tenant */
  allPermissionScopes: Array<SubgraphPermissionScope>;
  /** All routes available to this tenant (flattened) */
  allRoutes: Array<SubgraphRoute>;
  /** All widget IDs available to this tenant (flattened, for registry filtering) */
  allWidgetIds: Array<Scalars['String']['output']>;
  /** All enabled subgraph IDs */
  enabledSubgraphIds: Array<Scalars['String']['output']>;
  /** Whether tenant has any life-critical subgraphs */
  hasLifeCritical: Scalars['Boolean']['output'];
  /** Full metadata for each enabled subgraph */
  subgraphs: Array<SubgraphMetadata>;
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
};

/** Source of a resolved terminology term (DRR-281 three-layer architecture). */
export const TermSource = {
  /** LLM-proposed term awaiting architect approval (tag:advisory:*) */
  ADVISORY: 'ADVISORY',
  /**
   * Layer 2: Term from industry registry (care-vocabulary.yaml tag:industry:*)
   * Common across an industry but not defined in statute.
   */
  INDUSTRY: 'INDUSTRY',
  /** Legacy term from pre-DRR-189 label maps (to be migrated) */
  LEGACY: 'LEGACY',
  /** Layer 1: Term from legislation (care-vocabulary.yaml tag:def:*) */
  STATUTORY: 'STATUTORY',
  /**
   * Layer 3: Term from tenant override (DDB TerminologyOverride or NVO role_display_overrides)
   * Facility-specific customization.
   */
  TENANT: 'TENANT',
} as const;

export type TermSource = (typeof TermSource)[keyof typeof TermSource];
export type TerminologyOverrideResult = {
  __typename?: 'TerminologyOverrideResult';
  acceptableAlternatives: Array<Scalars['String']['output']>;
  approved: Scalars['Boolean']['output'];
  classification: OverrideClassification | '%future added value';
  definitionLabel: Scalars['String']['output'];
  message: Scalars['String']['output'];
  proposedTerm: Scalars['String']['output'];
  status: OverrideStatus | '%future added value';
  statuteRef?: Maybe<Scalars['String']['output']>;
  violatedConstraint?: Maybe<Scalars['String']['output']>;
};

/**
 * A single entry in the terminology settings view.
 * Shows a concept with its resolution across all three layers.
 */
export type TerminologySettingsEntry = {
  __typename?: 'TerminologySettingsEntry';
  /** Statutory definition ID (tag:def:*) */
  definitionId: Scalars['String']['output'];
  /** Industries where this term applies */
  industries: Array<Scalars['String']['output']>;
  /** Industry term abbreviation */
  industryAbbreviation?: Maybe<Scalars['String']['output']>;
  /** Industry term label (if available) */
  industryLabel?: Maybe<Scalars['String']['output']>;
  /** Industry term ID (tag:industry:*) */
  industryTermId?: Maybe<Scalars['String']['output']>;
  /** Override status (if tenant has an override) */
  overrideStatus?: Maybe<OverrideStatus | '%future added value'>;
  /** Current resolved display term */
  resolvedDisplay: Scalars['String']['output'];
  /** Source of current resolution */
  resolvedSource: TermSource | '%future added value';
  /** Statute reference */
  statuteRef?: Maybe<Scalars['String']['output']>;
  /** Statutory label (from legislation) */
  statutoryLabel: Scalars['String']['output'];
  /** Tenant override label (if set) */
  tenantLabel?: Maybe<Scalars['String']['output']>;
};

/** Threshold direction (whether high or low values breach) */
export const ThresholdDirection = {
  ABOVE: 'ABOVE',
  BELOW: 'BELOW',
  BOTH: 'BOTH',
} as const;

export type ThresholdDirection = (typeof ThresholdDirection)[keyof typeof ThresholdDirection];
/** Time series data point */
export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  avg: Scalars['Float']['output'];
  count: Scalars['String']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  stdDev: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

/** Time Series Point (GraphQL Output) */
export type TimeSeriesPoint = {
  __typename?: 'TimeSeriesPoint';
  /** Average execution time (milliseconds) */
  avgExecutionTimeMs: Scalars['Float']['output'];
  /** Cache hit rate */
  cacheHitRate: Scalars['Float']['output'];
  /** Evaluation count */
  evaluationCount: Scalars['Int']['output'];
  /** Matched count */
  matchedCount: Scalars['Int']['output'];
  /** Timestamp */
  timestamp: Scalars['DateTime']['output'];
};

/** Timeline event */
export type TimelineEvent = {
  __typename?: 'TimelineEvent';
  actor?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

/** * Timeline event for audit trail (DOMAIN-AGNOSTIC) */
export type TimelineEventOutput = {
  __typename?: 'TimelineEventOutput';
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Event type (e.g., "CREATED", "UPDATED", "TRANSITIONED") */
  eventType: Scalars['String']['output'];
  /** Event unique identifier */
  id: Scalars['String']['output'];
  /** Event metadata */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Event timestamp (Unix milliseconds) */
  timestamp: Scalars['Int']['output'];
  /** User ID who triggered event */
  userId: Scalars['String']['output'];
};

/** Enable/Disable Subgraph Input */
export type ToggleSubgraphInput = {
  /** Subgraph identifier */
  subgraphName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

export type TokenizedAdlAssessment = {
  __typename?: 'TokenizedAdlAssessment';
  bathing: Scalars['String']['output'];
  dressing: Scalars['String']['output'];
  eating: Scalars['String']['output'];
  mobility: Scalars['String']['output'];
  observations: Scalars['String']['output'];
  toileting: Scalars['String']['output'];
};

/**
 * A tokenized care plan review visible to external USRN.
 * All PHI has been replaced with tokens via Presidio (DRR-169A).
 */
export type TokenizedCarePlanReview = {
  __typename?: 'TokenizedCarePlanReview';
  /** ADL assessment data (tokenized) */
  adlAssessment: TokenizedAdlAssessment;
  /** Conditions/diagnoses (tokenized) */
  conditions: Array<Scalars['String']['output']>;
  /** Tokenized facility identifier (e.g., "[FACILITY_001]") */
  facilityToken: Scalars['String']['output'];
  /** AI-generated care plan draft (tokenized throughout) */
  generatedPlan: Scalars['String']['output'];
  /** Medications list (tokenized) */
  medications: Array<TokenizedMedication>;
  /** Prior care plan summary if exists (tokenized) */
  priorPlanSummary?: Maybe<Scalars['String']['output']>;
  /** Review deadline (24h from assignment) */
  reviewDeadline: Scalars['String']['output'];
  /** Review ID (for API calls) */
  reviewId: Scalars['String']['output'];
  /** Current status */
  status: Scalars['String']['output'];
  /** Tokenized subject identifier (e.g., "[PERSON_042]") */
  subjectToken: Scalars['String']['output'];
};

export type TokenizedMedication = {
  __typename?: 'TokenizedMedication';
  /** Dosage (not PHI) */
  dosage: Scalars['String']['output'];
  /** Frequency (not PHI) */
  frequency: Scalars['String']['output'];
  /** Tokenized medication name (e.g., "[MED_A]") */
  nameToken: Scalars['String']['output'];
  /** Route (not PHI) */
  route: Scalars['String']['output'];
};

export type TopSearch = {
  __typename?: 'TopSearch';
  avgResults: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  query: Scalars['String']['output'];
};

/** GraphQL output type for Trace primitive. */
export type Trace = {
  __typename?: 'Trace';
  /** WHO performed this traced operation */
  actor?: Maybe<ActorSummary>;
  /** Alternative options considered */
  alternativeOptions: Array<Scalars['JSON']['output']>;
  /** OpenTelemetry attributes (key-value pairs) */
  attributes: Scalars['JSONObject']['output'];
  /** W3C Baggage (cross-cutting concerns) */
  baggage?: Maybe<Scalars['JSONObject']['output']>;
  /** Cache hits (Redis) */
  cacheHits?: Maybe<Scalars['Int']['output']>;
  /** Cache misses (Redis) */
  cacheMisses?: Maybe<Scalars['Int']['output']>;
  /** Compressed ID format (lazy-loaded from cache/DynamoDB) */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** CPU usage percentage */
  cpuPercent?: Maybe<Scalars['Float']['output']>;
  /** When created */
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this trace */
  createdByActor?: Maybe<ActorSummary>;
  /** Confidence score for AI decisions (0.0-1.0) */
  decisionConfidence?: Maybe<Scalars['Float']['output']>;
  /** Human-readable reasoning (for AI decisions) */
  decisionReasoning?: Maybe<Scalars['String']['output']>;
  /** Duration in milliseconds (derived from started_at - ended_at) */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** When this span ended (None if still running) */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Error code (if failed) */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Error stack trace (if failed) */
  errorStackTrace?: Maybe<Scalars['String']['output']>;
  /** Evidence sources supporting decision */
  evidenceSources: Array<Scalars['String']['output']>;
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Whether this trace is active (false = archived/soft-deleted) */
  isActive: Scalars['Boolean']['output'];
  /** Memory usage in MB */
  memoryMb?: Maybe<Scalars['Float']['output']>;
  /** Additional structured metadata */
  metadata: Scalars['JSON']['output'];
  /** Network bytes transferred */
  networkBytes?: Maybe<Scalars['Int']['output']>;
  /** Human-readable operation name */
  operationName: Scalars['String']['output'];
  /** Original trace ID (stable across all versions for querying) */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Parent trace ID (for amendment/correction chain) */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Parent span ID (for nested operations) */
  parentSpanId?: Maybe<Scalars['String']['output']>;
  /** Zen Engine policy evaluation results */
  policyEvaluationResults?: Maybe<Scalars['JSON']['output']>;
  /** Service/component name (for distributed systems) */
  serviceName: Scalars['String']['output'];
  /** OpenTelemetry-compatible span ID (64-bit, hex-encoded) */
  spanId: Scalars['String']['output'];
  /** Type of span */
  spanType: GqlTraceSpanType | '%future added value';
  /** When this span started (ISO 8601) */
  startedAt: Scalars['DateTime']['output'];
  /** Trace status */
  status: GqlTraceStatus | '%future added value';
  /** Tags for filtering/grouping */
  tags: Array<Scalars['String']['output']>;
  /** Timestamp for time-series queries */
  timestamp: Scalars['DateTime']['output'];
  /** AI tokens used (for cost tracking) */
  tokensUsed?: Maybe<Scalars['Int']['output']>;
  /** W3C Trace Context (traceparent header value) */
  traceContext?: Maybe<Scalars['String']['output']>;
  /** OpenTelemetry-compatible trace ID (128-bit, hex-encoded) */
  traceId: Scalars['String']['output'];
  /** Type of triggering entity */
  triggerEntityType?: Maybe<Scalars['String']['output']>;
  /** Validation rule results */
  validationResults?: Maybe<Scalars['JSON']['output']>;
  /** Audit version (optimistic locking) */
  version: Scalars['Int']['output'];
};

/** GraphQL connection type for paginated trace lists. */
export type TraceConnection = {
  __typename?: 'TraceConnection';
  /** Has more results */
  hasMore: Scalars['Boolean']['output'];
  /** Trace items */
  items: Array<Trace>;
  /** Next page cursor */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type TrackChangeInput = {
  changeDescription: Scalars['String']['input'];
  changeMetadata?: InputMaybe<Scalars['JSON']['input']>;
  changeType: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
};

/** GraphQL representation of Transaction primitive */
export type Transaction = {
  __typename?: 'Transaction';
  auditTrailRequired: Scalars['Boolean']['output'];
  auditTrailRetentionYears: Scalars['Int']['output'];
  autoCommit: Scalars['Boolean']['output'];
  checkpointOverheadMs?: Maybe<Scalars['Int']['output']>;
  committedAt?: Maybe<Scalars['DateTime']['output']>;
  compensationStrategy: GqlCompensationStrategy | '%future added value';
  compensationTimeoutSeconds: Scalars['Int']['output'];
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Compliance officer for this transaction */
  complianceOfficer?: Maybe<ActorSummary>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this transaction.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** WHO created this transaction */
  createdByActor?: Maybe<ActorSummary>;
  crossTenantAuthorization: Array<CrossTenantAuth>;
  cryptographicSignature?: Maybe<Scalars['String']['output']>;
  currentStep: Scalars['Int']['output'];
  deadlockDetectionEnabled: Scalars['Boolean']['output'];
  distributedLockId?: Maybe<Scalars['String']['output']>;
  emergencyAbortEnabled: Scalars['Boolean']['output'];
  executionTimeMs?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  idempotencyKey: Scalars['String']['output'];
  isCrossTenant: Scalars['Boolean']['output'];
  isLifeCritical: Scalars['Boolean']['output'];
  isNested: Scalars['Boolean']['output'];
  isolationLevel: GqlIsolationLevel | '%future added value';
  lockAcquiredAt?: Maybe<Scalars['DateTime']['output']>;
  lockHolderInstanceId?: Maybe<Scalars['String']['output']>;
  lockTimeoutSeconds: Scalars['Int']['output'];
  maxCompensationAttempts: Scalars['Int']['output'];
  preservePartialState: Scalars['Boolean']['output'];
  regulatoryDeadline?: Maybe<Scalars['DateTime']['output']>;
  regulatorySubmissionId?: Maybe<Scalars['String']['output']>;
  requiresTwoPhaseCommit: Scalars['Boolean']['output'];
  retryCount: Scalars['Int']['output'];
  retryPolicy: RetryPolicy;
  rollbackOnAnyFailure: Scalars['Boolean']['output'];
  rollbackTimeMs?: Maybe<Scalars['Int']['output']>;
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  safetyApprovalRequired: Scalars['Boolean']['output'];
  safetyApproverRoles: Array<Scalars['String']['output']>;
  safetyChecklistIds: Array<Scalars['String']['output']>;
  safetyOverrideLog: Array<SafetyOverride>;
  safetyValidationRequired: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: GqlTransactionStatus | '%future added value';
  timeoutSeconds: Scalars['Int']['output'];
  totalSteps: Scalars['Int']['output'];
  transactionCode: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  transactionName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** WHO last updated this transaction */
  updatedByActor?: Maybe<ActorSummary>;
  witnessSignatures: Array<WitnessSignature>;
  xaBranchQualifier?: Maybe<Scalars['String']['output']>;
  xaCoordinatorUrl?: Maybe<Scalars['String']['output']>;
  xaFormatId?: Maybe<Scalars['Int']['output']>;
  xaParticipants: Array<XaParticipant>;
  xaState?: Maybe<GqlXaState | '%future added value'>;
  xaTransactionId?: Maybe<Scalars['String']['output']>;
};

/** Paginated transaction list */
export type TransactionPage = {
  __typename?: 'TransactionPage';
  nextToken?: Maybe<Scalars['String']['output']>;
  transactions: Array<Transaction>;
};

/** Transaction statistics */
export type TransactionStatistics = {
  __typename?: 'TransactionStatistics';
  avgExecutionTimeMs: Scalars['Float']['output'];
  avgSteps: Scalars['Float']['output'];
  committedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  rolledBackCount: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  totalTransactions: Scalars['Int']['output'];
};

/** Transaction status enum */
export const TransactionStatus = {
  /** Compensation completed */
  COMPENSATED: 'COMPENSATED',
  /** Compensation in progress (rollback) */
  COMPENSATING: 'COMPENSATING',
  /** Transaction completed successfully */
  COMPLETED: 'COMPLETED',
  /** Transaction failed */
  FAILED: 'FAILED',
  /** Transaction initiated */
  INITIATED: 'INITIATED',
  /** Transaction in progress */
  IN_PROGRESS: 'IN_PROGRESS',
} as const;

export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus];
/** Transaction status change event (SAGA monitoring) */
export type TransactionStatusChangedEvent = {
  __typename?: 'TransactionStatusChangedEvent';
  /** Compensation step (if rollback in progress) */
  compensationStep?: Maybe<Scalars['String']['output']>;
  /** Error message (if failed) */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Integration ID */
  integrationId: Scalars['String']['output'];
  /** Previous status */
  previousStatus: TransactionStatus | '%future added value';
  /** New status */
  status: TransactionStatus | '%future added value';
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Event timestamp */
  timestamp: Scalars['String']['output'];
  /** Transaction ID */
  transactionId: Scalars['String']['output'];
  /** Transaction type */
  transactionType: Scalars['String']['output'];
};

export type TranscriptEntry = {
  __typename?: 'TranscriptEntry';
  atMs: Scalars['Int']['output'];
  code?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  receiptId?: Maybe<Scalars['String']['output']>;
};

/** Input for transferring a social token */
export type TransferSocialTokenInput = {
  fromActorId: Scalars['String']['input'];
  tenantNum: Scalars['Int']['input'];
  toActorId: Scalars['String']['input'];
  tokenSubtype: Scalars['String']['input'];
};

/** Transformation specification */
export type TransformationSpec = {
  __typename?: 'TransformationSpec';
  falseValue?: Maybe<Scalars['JSON']['output']>;
  functionName?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  transformationType: Scalars['String']['output'];
  trueValue?: Maybe<Scalars['JSON']['output']>;
};

/** Transformation spec input */
export type TransformationSpecInput = {
  falseValue?: InputMaybe<Scalars['JSON']['input']>;
  functionName?: InputMaybe<Scalars['String']['input']>;
  functionParams?: InputMaybe<Scalars['JSON']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  trueValue?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
};

export type TransitionEventGql = {
  __typename?: 'TransitionEventGql';
  at: Scalars['Int']['output'];
  by: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  transition: Scalars['String']['output'];
};

export type TransitionNodeStatusInput = {
  executionId: Scalars['ID']['input'];
  newStatus: DagnodeStatusEnum | '%future added value';
  nodeId: Scalars['String']['input'];
};

/** SAGA state transition input */
export type TransitionSagaStateInput = {
  /** Optional execution context */
  executionContext?: InputMaybe<Scalars['JSON']['input']>;
  /** Execution ID of the SAGA */
  executionId: Scalars['String']['input'];
  /** Primitive type being executed (must be one of 16) */
  primitiveType?: InputMaybe<Scalars['String']['input']>;
  /** Target state to transition to */
  targetState: Scalars['String']['input'];
  /** Transition trigger event */
  triggerEvent: Scalars['String']['input'];
};

/** Transition view */
export type TransitionView = {
  __typename?: 'TransitionView';
  actions: Array<Scalars['String']['output']>;
  guard?: Maybe<Scalars['String']['output']>;
  signal: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

/** Translate Term Input */
export type TranslateTermInput = {
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
  /** FERP term to translate */
  term: Scalars['String']['input'];
};

/** Translation Result */
export type TranslationResult = {
  __typename?: 'TranslationResult';
  /** Original FERP term */
  originalTerm: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** Translated term (industry-specific) */
  translatedTerm: Scalars['String']['output'];
};

/** Trend direction */
export const TrendDirection = {
  DECREASING: 'DECREASING',
  INCREASING: 'INCREASING',
  STABLE: 'STABLE',
  VOLATILE: 'VOLATILE',
} as const;

export type TrendDirection = (typeof TrendDirection)[keyof typeof TrendDirection];
/** Input for triggering the DRR-072 meta-orchestration pipeline */
export type TriggerChaosPipelineInput = {
  /** Chaos document ID (must exist in ChaosDocumentRepository) */
  documentId: Scalars['String']['input'];
  /** Override safety level (optional - defaults to HIGH) */
  safetyLevel?: InputMaybe<Scalars['String']['input']>;
  /** Override target domain (optional - auto-detected from document if not specified) */
  targetDomain?: InputMaybe<Scalars['String']['input']>;
  /** Tenant context */
  tenant: Scalars['String']['input'];
  /** Who triggered the pipeline (for audit trail) */
  triggeredBy: Scalars['String']['input'];
};

export type TriggerTaxChangeInput = {
  /** Company identifier */
  companyId: Scalars['String']['input'];
  /** ISO8601 date when change becomes effective */
  effectiveDate: Scalars['String']['input'];
  /** Tax jurisdiction (US, CA, UK) */
  jurisdiction: Scalars['String']['input'];
  /** New tax rate (e.g., 0.062 for 6.2%) */
  newRate?: InputMaybe<Scalars['Float']['input']>;
  /** New wage base (e.g., 176100 for $176,100) */
  newWageBase?: InputMaybe<Scalars['Float']['input']>;
  /** Tax type (SOCIAL_SECURITY, MEDICARE, INCOME_TAX) */
  taxType: Scalars['String']['input'];
  /** Tenant identifier */
  tenantId: Scalars['String']['input'];
  /** Tax year */
  year: Scalars['Int']['input'];
};

export type TriggerTaxChangeResult = {
  __typename?: 'TriggerTaxChangeResult';
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** IDs of notifications created */
  notificationIds: Array<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Action triggered by formula activation */
export type TriggeredAction = {
  __typename?: 'TriggeredAction';
  /** Action type (auto_link, suggest_add, etc.) */
  actionType: Scalars['String']['output'];
  /** Action parameters (JSON string) */
  params: Scalars['String']['output'];
  /** The action rule that fired */
  ruleId: Scalars['String']['output'];
  /** Target primitive or entity */
  target: Scalars['String']['output'];
};

/** Field validation configuration */
export type UiFieldValidation = {
  __typename?: 'UIFieldValidation';
  /** Maximum value (for numbers) or length (for strings) */
  max?: Maybe<Scalars['Float']['output']>;
  /** Custom validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Minimum value (for numbers) or length (for strings) */
  min?: Maybe<Scalars['Float']['output']>;
  /** Regex pattern for string validation */
  pattern?: Maybe<Scalars['String']['output']>;
  /** Field is required */
  required: Scalars['Boolean']['output'];
};

/** Configuration for a single form field */
export type UiFormFieldConfig = {
  __typename?: 'UIFormFieldConfig';
  /** Widget component name from registry */
  component: Scalars['String']['output'];
  /**
   * Custom renderer props (JSON-encoded).
   * Passed to the custom renderer component as additional configuration.
   */
  customRendererProps?: Maybe<Scalars['String']['output']>;
  /** Default value (JSON-encoded) */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Whether field is disabled */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Help text shown below field */
  helpText?: Maybe<Scalars['String']['output']>;
  /** Display label */
  label: Scalars['String']['output'];
  /** Field name (matches entity property) */
  name: Scalars['String']['output'];
  /** Field order (lower = earlier) */
  order?: Maybe<Scalars['Int']['output']>;
  /** Placeholder text */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Whether field is read-only */
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Custom renderer key (for CUSTOM field types).
   * Subgraphs provide matching React components via EntityFormGenerator's customRenderers prop.
   */
  rendererKey?: Maybe<Scalars['String']['output']>;
  /** Field validation rules */
  validation?: Maybe<UiFieldValidation>;
  /** Conditional visibility expression (CEL or JSONLogic) */
  visibleWhen?: Maybe<Scalars['String']['output']>;
  /** Custom widget props (JSON-encoded) */
  widgetProps?: Maybe<Scalars['String']['output']>;
};

/** Layout type for the form */
export const UiFormLayout = {
  /** Single-page form */
  SINGLE_PAGE: 'SINGLE_PAGE',
  /** Tabbed form */
  TABS: 'TABS',
  /** Two-column layout */
  TWO_COLUMN: 'TWO_COLUMN',
  /** Multi-step wizard */
  WIZARD: 'WIZARD',
} as const;

export type UiFormLayout = (typeof UiFormLayout)[keyof typeof UiFormLayout];
export type UiFormSchema = {
  __typename?: 'UIFormSchema';
  actions: Array<FormAction>;
  description?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  fields: Array<UiFormFieldConfig>;
  layout: UiFormLayout | '%future added value';
  module: Scalars['String']['output'];
  schemaVersion: Scalars['String']['output'];
  steps?: Maybe<Array<WizardStep>>;
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Input type for creating/updating form schemas */
export type UiFormSchemaInput = {
  actions?: InputMaybe<Array<FormActionInput>>;
  context: Uicontext;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
  fields: Array<FormFieldConfigInput>;
  layout: UiFormLayout | '%future added value';
  module: Scalars['String']['input'];
  steps?: InputMaybe<Array<WizardStepInput>>;
  title: Scalars['String']['input'];
};

/** Context for resolving which UI schema to use */
export type Uicontext = {
  /** Domain/module name (e.g., "accounting", "fhir") */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Rendering mode (CREATE, EDIT, VIEW, APPROVE, LIST) */
  mode: Uimode | '%future added value';
  /** User role for role-specific fields */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Safety level for rendering decisions */
  safetyLevel?: InputMaybe<UisafetyLevel | '%future added value'>;
};

/** UI field */
export type Uifield = {
  __typename?: 'Uifield';
  component: Scalars['String']['output'];
  dataSource?: Maybe<DataSource>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  mapsTo: Array<PrimitiveMapping>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  validation?: Maybe<Scalars['JSON']['output']>;
};

/** UI field input */
export type UifieldInput = {
  component: Scalars['String']['input'];
  dataSource?: InputMaybe<DataSourceInput>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  mapsTo: Array<PrimitiveMappingInput>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
  validation?: InputMaybe<ValidationRulesInput>;
};

/** UI field output */
export type UifieldOutput = {
  __typename?: 'UifieldOutput';
  component: Scalars['String']['output'];
  dataSource?: Maybe<Scalars['JSON']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  mapsTo: Array<PrimitiveMappingOutput>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  validation?: Maybe<Scalars['JSON']['output']>;
};

/** UI metadata */
export type Uimetadata = {
  __typename?: 'Uimetadata';
  /** Layout type (stepper, wizard, single-page) */
  layout: Scalars['String']['output'];
  /** UI steps */
  steps: Array<Uistep>;
};

/** UI metadata input */
export type UimetadataInput = {
  layout: Scalars['String']['input'];
  steps: Array<UistepInput>;
};

/** UI metadata output */
export type UimetadataOutput = {
  __typename?: 'UimetadataOutput';
  layout: Scalars['String']['output'];
  steps: Array<UistepOutput>;
};

/** UI rendering mode */
export const Uimode = {
  /** Approval workflow context */
  APPROVE: 'APPROVE',
  /** Creating a new entity */
  CREATE: 'CREATE',
  /** Editing an existing entity */
  EDIT: 'EDIT',
  /** List/table view */
  LIST: 'LIST',
  /** Read-only view */
  VIEW: 'VIEW',
} as const;

export type Uimode = (typeof Uimode)[keyof typeof Uimode];
/** Safety level for UI rendering decisions */
export const UisafetyLevel = {
  /** Life-critical operations (healthcare, safety-critical) */
  CRITICAL: 'CRITICAL',
  /** High-value operations requiring extra confirmation */
  HIGH: 'HIGH',
  /** Standard operations */
  STANDARD: 'STANDARD',
} as const;

export type UisafetyLevel = (typeof UisafetyLevel)[keyof typeof UisafetyLevel];
/**
 * Version negotiation info for frontend compatibility checks.
 * Frontend queries this to verify it supports the current schema format.
 */
export type UischemaVersionInfo = {
  __typename?: 'UischemaVersionInfo';
  /** Current schema format version produced by this backend */
  currentVersion: Scalars['String']['output'];
  /** Minimum schema version this backend can serve */
  minSupportedVersion: Scalars['String']['output'];
};

/** UI step */
export type Uistep = {
  __typename?: 'Uistep';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<Uifield>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** UI step input */
export type UistepInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<UifieldInput>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** UI step output */
export type UistepOutput = {
  __typename?: 'UistepOutput';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<UifieldOutput>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Input for unlocking a document (ADR-002) */
export type UnlockDocumentInput = {
  /** Document ID to unlock */
  documentId: Scalars['String']['input'];
  /** Client IP address (for audit trail) */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  /** Session ID (from cookie in production) */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** PDF reader user agent (for audit trail) */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  /** User ID (from auth context in production) */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Unregister Subgraph Input */
export type UnregisterSubgraphInput = {
  /** Subgraph identifier */
  subgraphName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for updating an existing anti-pattern */
export type UpdateAntiPatternInput = {
  /** Updated auto-fix configuration (JSON string, optional) */
  autoFixJson?: InputMaybe<Scalars['String']['input']>;
  /** New description (optional) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Anti-pattern ID to update */
  id: Scalars['String']['input'];
  /** New message (optional) */
  message?: InputMaybe<Scalars['String']['input']>;
  /** New name (optional) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New severity (optional) */
  severity?: InputMaybe<WarningSeverity | '%future added value'>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for updating assessment */
export type UpdateAssessmentInput = {
  assessmentId: Scalars['String']['input'];
  careLevel?: InputMaybe<CareCircleCareLevel | '%future added value'>;
  maxBudget?: InputMaybe<Scalars['Int']['input']>;
  maxDistanceMiles?: InputMaybe<Scalars['Int']['input']>;
  medicaidEligible?: InputMaybe<Scalars['Boolean']['input']>;
  mobility?: InputMaybe<CareCircleMobility | '%future added value'>;
  moveInTimeline?: InputMaybe<CareCircleMoveInTimeline | '%future added value'>;
  specificLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  vaBenefits?: InputMaybe<Scalars['Boolean']['input']>;
  wantsPharmacist?: InputMaybe<Scalars['Boolean']['input']>;
  wantsPsychologist?: InputMaybe<Scalars['Boolean']['input']>;
  wantsRn247?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuditInput = {
  approvedByUserId?: InputMaybe<Scalars['String']['input']>;
  complianceStatus?: InputMaybe<AuditComplianceStatus | '%future added value'>;
  findingsSummary?: InputMaybe<Scalars['String']['input']>;
  reportS3Url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating circuit breaker state */
export type UpdateCircuitBreakerInput = {
  integrationId: Scalars['String']['input'];
  resetConsecutiveFailures: Scalars['Boolean']['input'];
  state: CircuitBreakerState | '%future added value';
};

/** Input for adding/removing an actor from a constellation ring. */
export type UpdateConstellationParticipantInput = {
  /** Action: "ADD" or "REMOVE" */
  action: Scalars['String']['input'];
  /** Actor ID to add/remove (sequential ID, e.g., "2_3") */
  actorId: Scalars['String']['input'];
  /** Constellation instance ID (e.g., "cst-4-1-001") */
  constellationId: Scalars['String']['input'];
  /** Edge type (COORDINATED_BY, AUTHORIZED_BY, REVIEWED_BY, REPRESENTS) */
  edgeType: Scalars['String']['input'];
  /** Ring number (1 = participants, 2 = authorities, 4 = auditors) */
  ring: Scalars['Int']['input'];
};

/** Input for updating document status */
export type UpdateDocumentStatusInput = {
  documentId: Scalars['String']['input'];
  newStatus: DocumentStatus | '%future added value';
  reason?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Input for updating entities */
export type UpdateEntityInput = {
  /** Updated configuration */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** New description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Entity ID */
  id: Scalars['ID']['input'];
  /** Updated metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** New name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated priority */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** New status */
  status?: InputMaybe<EntityStatus | '%future added value'>;
  /** Updated tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version for optimistic locking */
  version: Scalars['Int']['input'];
};

/** Input for updating a FHIR resource via dual-write pipeline */
export type UpdateFhirResourceGqlInput = {
  /** Updated FHIR JSON payload as string */
  fhirJson: Scalars['String']['input'];
  /** Resource ID (must match existing resource) */
  resourceId: Scalars['String']['input'];
  /** FHIR resource type (e.g., "Patient", "Encounter") */
  resourceType: Scalars['String']['input'];
  /** Tenant number */
  tenantNum: Scalars['Int']['input'];
  /** Who is updating this resource */
  updatedBy: Scalars['String']['input'];
};

/** Input for creating a new version of a mutable FHIR resource */
export type UpdateFhirStoredResourceInput = {
  /** Audit: operation description */
  auditOperation: Scalars['String']['input'];
  /** Updated FHIR R4 JSON payload (as string) */
  fhirJson: Scalars['String']['input'];
  /** Resource ID (must match existing resource) */
  resourceId: Scalars['String']['input'];
  /** FHIR resource type */
  resourceType: FhirStorageResourceType | '%future added value';
};

/** Input for updating integration health */
export type UpdateHealthStatusInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  healthStatus: IntegrationHealthStatus | '%future added value';
  integrationId: Scalars['String']['input'];
  responseTimeMs?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for updating order status */
export type UpdateOrderStatusInput = {
  event: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

/** Input for updating a policy. */
export type UpdatePolicyInput = {
  /** Updated audit level */
  auditLevel?: InputMaybe<GqlAuditLevel | '%future added value'>;
  /** Updated name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated rules */
  rules?: InputMaybe<Array<PolicyRuleInput>>;
  /** Updated by user ID */
  updatedBy: Scalars['String']['input'];
};

/** Update Policy Rule Input */
export type UpdatePolicyRuleInput = {
  /** Actions (optional update) */
  actions?: InputMaybe<Array<PolicyActionInput>>;
  /** Conditions (optional update) */
  conditions?: InputMaybe<Array<PolicyConditionInput>>;
  /** Enabled flag (optional update) */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Policy ID (existing) */
  policyId: Scalars['String']['input'];
  /** Policy name (optional update) */
  policyName?: InputMaybe<Scalars['String']['input']>;
  /** Priority (optional update) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Tenant ID (for validation) */
  tenantId: Scalars['String']['input'];
};

/** Update input for thresholds */
export type UpdateRegulatoryThresholdInput = {
  frameworkId: Scalars['String']['input'];
  numericValue: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  sourceAuthority?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
  thresholdType: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Update Role Input */
export type UpdateRoleInput = {
  /** Capabilities (optional update) */
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description (optional update) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name (optional update) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Enabled flag (optional update) */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent roles (optional update) */
  inheritsFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Role ID (existing) */
  roleId: Scalars['String']['input'];
  /** Scopes (optional update) */
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tenant ID (for validation) */
  tenantId: Scalars['String']['input'];
};

/** Comprehensive input for updating safety events (remediation/escalation tracking) */
export type UpdateSafetyEventInput = {
  /** Additional affected entities discovered during investigation */
  affectedEntities?: InputMaybe<Array<AffectedEntityInput>>;
  /** Whether emergency contacts were notified */
  emergencyContactsNotified?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of user IDs escalated to (append-only for audit trail) */
  escalatedTo?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Current escalation level (L1, L2, L3, Emergency) */
  escalationLevel?: InputMaybe<Scalars['String']['input']>;
  /** Escalation path ID (from tenant Policy metadata) */
  escalationPathId?: InputMaybe<Scalars['String']['input']>;
  /** Timeline of escalation actions (append-only audit trail) */
  escalationTimestamps?: InputMaybe<Array<EscalationTimestampInput>>;
  /** Whether escalation was triggered (can escalate after initial creation) */
  escalationTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Evidence data (can be appended during investigation) */
  evidence?: InputMaybe<Scalars['JSON']['input']>;
  /** Additional metadata (can be enhanced during investigation) */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Parent event ID (can be set during investigation) */
  parentEventId?: InputMaybe<Scalars['String']['input']>;
  /** Related event IDs (can be linked during root cause analysis) */
  relatedEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Actual completion timestamp (auto-set when status = "Completed") */
  remediationCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Deadline for remediation completion (can be extended with audit trail) */
  remediationDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** Remediation notes and action log (append-only for audit trail) */
  remediationNotes?: InputMaybe<Scalars['String']['input']>;
  /** User ID assigned to remediate this event */
  remediationOwner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Current remediation status (Pending, InProgress, Completed, Escalated)
   * From tenant Policy metadata (data-driven)
   */
  remediationStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating map-level review status */
export type UpdateSourceMapStatusInput = {
  mappingId: Scalars['String']['input'];
  reviewerId: Scalars['String']['input'];
  status: GqlReviewStatus | '%future added value';
  tenantId: Scalars['String']['input'];
};

/** Input for updating a system tenant */
export type UpdateSystemTenantInput = {
  /** New compliance frameworks */
  complianceFrameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** New limits (if upgrading/downgrading) */
  maxUsers?: InputMaybe<Scalars['Int']['input']>;
  maxWorkflows?: InputMaybe<Scalars['Int']['input']>;
  /** New name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New subscription tier */
  subscriptionTier?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Input for updating a system user */
export type UpdateSystemUserInput = {
  /** Add tenant access */
  addTenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Update global roles */
  globalRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Preferred language */
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Remove tenant access */
  removeTenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  userId: Scalars['String']['input'];
  /** New username */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskProgressInput = {
  currentStep?: InputMaybe<Scalars['String']['input']>;
  progressPercent: Scalars['Float']['input'];
  taskId: Scalars['String']['input'];
};

/** Update template metadata input */
export type UpdateTemplateMetadataInput = {
  changes: Scalars['String']['input'];
  currentVersion: Scalars['String']['input'];
  metadata: TemplateMetadataContentInput;
  newVersion: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  updatedBy: Scalars['String']['input'];
};

/** Update Tenant Branding Input */
export type UpdateTenantBrandingInput = {
  /** Accent color (optional update) */
  accentColor?: InputMaybe<Scalars['String']['input']>;
  /** Accreditations */
  accreditations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Physical address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Company name (optional update) */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Company tagline (optional update) */
  companyTagline?: InputMaybe<Scalars['String']['input']>;
  /** Custom domain (optional update) */
  customDomain?: InputMaybe<Scalars['String']['input']>;
  /** Favicon URL (optional update) */
  faviconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Font family (optional update) */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Hide FERP branding (optional update) */
  hideFerpBranding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business hours */
  hours?: InputMaybe<Scalars['String']['input']>;
  /** License type */
  licenseType?: InputMaybe<Scalars['String']['input']>;
  /** Logo URL (optional update) */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Primary color (optional update) */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Secondary color (optional update) */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Services offered */
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Show help center (optional update) */
  showHelpCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show support chat (optional update) */
  showSupportChat?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subdomain (optional update) */
  subdomain?: InputMaybe<Scalars['String']['input']>;
  /** Support email (optional update) */
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  /** Support phone (optional update) */
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID (for validation) */
  tenantId: Scalars['String']['input'];
  /** Terminology mapping (optional update) */
  terminology?: InputMaybe<Scalars['JSON']['input']>;
  /** Public website slug */
  websiteSlug?: InputMaybe<Scalars['String']['input']>;
  /** Website URL (optional update) */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL input type for updating a trace. */
export type UpdateTraceInput = {
  /** Cache hits (Redis) */
  cacheHits?: InputMaybe<Scalars['Int']['input']>;
  /** Cache misses (Redis) */
  cacheMisses?: InputMaybe<Scalars['Int']['input']>;
  /** CPU usage percentage */
  cpuPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Duration in milliseconds (derived from started_at - ended_at) */
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  /** When this span ended (None if still running) */
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Error code (if failed) */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Error message (if failed) */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Error stack trace (if failed) */
  errorStackTrace?: InputMaybe<Scalars['String']['input']>;
  /** Memory usage in MB */
  memoryMb?: InputMaybe<Scalars['Float']['input']>;
  /** Additional structured metadata */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Network bytes transferred */
  networkBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Trace status */
  status?: InputMaybe<GqlTraceStatus | '%future added value'>;
  /** Tags for filtering/grouping */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** AI tokens used (for cost tracking) */
  tokensUsed?: InputMaybe<Scalars['Int']['input']>;
};

/** Update workflow graph input */
export type UpdateWorkflowGraphInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  edges?: InputMaybe<Array<WorkflowEdgeInput>>;
  graphId: Scalars['String']['input'];
  graphName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  nodes?: InputMaybe<Array<WorkflowNodeInput>>;
  tenantId: Scalars['String']['input'];
};

/** Upgrade subgraph tier input */
export type UpgradeSubgraphTierInput = {
  /** New tier level */
  newTier: ModuleTier | '%future added value';
  /** Subgraph identifier */
  subgraphName: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** User Activity (GraphQL output) */
export type UserActivity = {
  __typename?: 'UserActivity';
  /** Action count */
  actionCount: Scalars['Int']['output'];
  /** User ID */
  userId: Scalars['String']['output'];
  /** User name */
  userName: Scalars['String']['output'];
};

/**
 * Backend-computed capability flags for the authenticated user.
 *
 * The frontend uses these booleans to show/hide UI elements without
 * ever inspecting scopes or roles locally. Each flag aggregates one
 * or more scope checks so the UI stays dumb.
 *
 * Returned by the `userCapabilities` query (DRR-102).
 */
export type UserCapabilities = {
  __typename?: 'UserCapabilities';
  /**
   * The effective authentication tier as a string label.
   * Values: "Tier1" (passkey), "Tier2" (device-bound), "Tier3" (hardware key),
   * "Tier4" (hardware key + witness). Derived from SaaS role and scopes.
   */
  authTier: Scalars['String']['output'];
  /**
   * The scopes currently granted to this user (filtered to known scopes).
   * Frontend uses this for fine-grained checks beyond the boolean flags.
   */
  availableScopes: Array<Scalars['String']['output']>;
  /**
   * Can acknowledge life-critical elopement alerts (DRR-100/108).
   * True if user holds beacon:acknowledge scope.
   */
  canAcknowledgeElopement: Scalars['Boolean']['output'];
  /**
   * Can perform system administration operations.
   * True if user holds system:admin or tenant:admin scope.
   */
  canAdminSystem: Scalars['Boolean']['output'];
  /**
   * Can approve/reject regulatory rules from the review queue (DRR-058).
   * True if user holds regulatory:approve scope.
   */
  canApproveRegulatory: Scalars['Boolean']['output'];
  /**
   * Can import regulatory rules via the intelligence pipeline (DRR-058).
   * True if user holds regulatory:import scope.
   */
  canImportRegulatory: Scalars['Boolean']['output'];
  /**
   * Can manage cross-tenant exchange relationships (DRR-105).
   * True if user holds exchange:admin or exchange:push.
   */
  canManageExchange: Scalars['Boolean']['output'];
  /** Whether PII-free observer mode is available (requires scope + header). */
  canObserveWorkflows: Scalars['Boolean']['output'];
  /**
   * Can participate in document signing ceremonies (DRR-091).
   * True if user holds document:sign scope.
   */
  canSignDocuments: Scalars['Boolean']['output'];
  /**
   * Can perform chain-attested offline sync (DRR-113).
   * True if user holds sync:write or sync:admin.
   */
  canSyncChains: Scalars['Boolean']['output'];
  /**
   * Can view QAPI-protected data (T3 scope-gated per DRR-114).
   * Guards: duration variance, staffing ratios, completion rates.
   */
  canViewQapi: Scalars['Boolean']['output'];
  /**
   * Can create witness attestations (Tier 4 verification).
   * True if user holds witness:write scope.
   */
  canWitness: Scalars['Boolean']['output'];
  /**
   * Can create/modify audit records (SOX/HIPAA/FDA compliance).
   * True if user holds audit:write scope.
   */
  canWriteAudit: Scalars['Boolean']['output'];
  /**
   * Can perform financial ledger mutations (DRR-109).
   * True if user holds ledger:write scope.
   */
  canWriteLedger: Scalars['Boolean']['output'];
  /**
   * Can modify metadata (affects all tenants).
   * True if user holds metadata:write scope.
   */
  canWriteMetadata: Scalars['Boolean']['output'];
  /**
   * Subgraphs the tenant has access to.
   * Empty list means all subgraphs (backward compatibility).
   */
  enabledSubgraphs: Array<Scalars['String']['output']>;
  /**
   * The user's SaaS role within the tenant.
   * Values: "SuperAdmin", "TenantAdmin", "TenantUser".
   */
  saasRole: Scalars['String']['output'];
};

/** User Permissions Response */
export type UserPermissionsResponse = {
  __typename?: 'UserPermissionsResponse';
  /** Computed at */
  computedAt: Scalars['DateTime']['output'];
  /** Permission strings */
  permissions: Array<Scalars['String']['output']>;
  /** Role name */
  role: Scalars['String']['output'];
  /** Tenant ID */
  tenant: Scalars['String']['output'];
};

/** User preferences for guidance generation */
export type UserPreferencesInput = {
  /** Maximum concurrent tasks */
  maxConcurrentTasks?: InputMaybe<Scalars['Int']['input']>;
  /** Preferred grouping strategy */
  preferredGrouping?: InputMaybe<Scalars['String']['input']>;
  /** Working hours (e.g., "09:00-17:00") */
  workingHours?: InputMaybe<WorkingHoursInput>;
};

/** User Role Assignment Output */
export type UserRoleAssignment = {
  __typename?: 'UserRoleAssignment';
  /** Assigned at */
  assignedAt: Scalars['DateTime']['output'];
  /** Assigned by */
  assignedBy: Scalars['String']['output'];
  /** Assignment ID */
  assignmentId: Scalars['String']['output'];
  /** Expires at */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Revocation reason */
  revocationReason?: Maybe<Scalars['String']['output']>;
  /** Revoked */
  revoked: Scalars['Boolean']['output'];
  /** Revoked at */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Revoked by */
  revokedBy?: Maybe<Scalars['String']['output']>;
  /** Role (populated) */
  role?: Maybe<RoleDefinition>;
  /** Role ID */
  roleId: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['String']['output'];
};

/** Current User Role Response */
export type UserRoleResponse = {
  __typename?: 'UserRoleResponse';
  /** Effective capabilities (including inherited) */
  capabilities: Array<Scalars['String']['output']>;
  /** Role name (e.g., "admin", "viewer") */
  role: Scalars['String']['output'];
  /** Effective scopes (including inherited) */
  scopes: Array<Scalars['String']['output']>;
  /** Tenant ID */
  tenant: Scalars['String']['output'];
};

/** User task update event (any update to user's tasks) */
export type UserTaskUpdate = {
  __typename?: 'UserTaskUpdate';
  assignedTo?: Maybe<Scalars['String']['output']>;
  changes: Scalars['JSON']['output'];
  instanceId: Scalars['String']['output'];
  isTeamTask: Scalars['Boolean']['output'];
  priority: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  updateType: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

/** USRN review decision */
export type UsrnReviewDecisionInput = {
  /** Specific change requests if decision is CHANGES_REQUESTED */
  changeRequests?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Decision: APPROVED or CHANGES_REQUESTED */
  decision: Scalars['String']['input'];
  /** Clinical notes (will be shown to DoN) */
  notes: Scalars['String']['input'];
  /** Review ID */
  reviewId: Scalars['String']['input'];
};

export type UsrnReviewResult = {
  __typename?: 'UsrnReviewResult';
  message: Scalars['String']['output'];
  nextReviewAvailable: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

/** Input for validating a draft */
export type ValidateDraftInput = {
  draft: Scalars['JSON']['input'];
  kind: Scalars['String']['input'];
};

/** Input for DSL validation only (no JDM generation) */
export type ValidateDslInput = {
  /** DSL source code to validate */
  source: Scalars['String']['input'];
};

/** Validate subgraph reference with licensing input */
export type ValidateSubgraphLicensingInput = {
  /** Required feature (optional) */
  requiredFeature?: InputMaybe<Scalars['String']['input']>;
  /** Resource type */
  resourceType: Scalars['String']['input'];
  /** Subgraph identifier */
  subgraph: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Validate Subgraph Reference Input */
export type ValidateSubgraphReferenceInput = {
  /** Resource type (e.g., "AuditEvent") */
  resourceType: Scalars['String']['input'];
  /** Subgraph identifier (e.g., "medplum") */
  subgraph: Scalars['String']['input'];
  /** Tenant ID */
  tenantId: Scalars['String']['input'];
};

/** Validate Template Input */
export type ValidateTemplateInput = {
  /** Template JSON data to validate */
  templateData: Scalars['JSON']['input'];
};

/** GraphQL output type for Validation primitive. */
export type Validation = {
  __typename?: 'Validation';
  /** Is validation active? */
  active: Scalars['Boolean']['output'];
  /** Audit version (optimistic locking) */
  auditVersion: Scalars['Int']['output'];
  /** Unique code within tenant */
  code: Scalars['String']['output'];
  /** Regulatory frameworks (HIPAA/SOX/FHIR/X12/ISO20022) */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Compressed ID format (lazy-loaded from cache/DynamoDB) */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Optional conditional expression (Zen DSL) */
  conditionalLogic?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Created by user ID */
  createdBy: Scalars['String']['output'];
  /** Unlimited extensibility for tenant-specific fields */
  customMetadata: Scalars['JSON']['output'];
  /** Validation codes this depends on */
  dependsOn: Array<Scalars['String']['output']>;
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** Date range when validation is effective */
  effectiveDates?: Maybe<ValidationDateRange>;
  /** User-facing error message */
  errorMessage: Scalars['String']['output'];
  /** When to execute validation */
  executionPhase: Array<GqlExecutionPhase | '%future added value'>;
  /** Dot-notation path to field (e.g., "patient.ssn") */
  fieldPath: Scalars['String']['output'];
  /** Optional suggestion to fix error */
  fixSuggestion?: Maybe<Scalars['String']['output']>;
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Soft delete flag */
  isActive: Scalars['Boolean']['output'];
  /** Does error block submission? */
  isBlocking: Scalars['Boolean']['output'];
  /** Display name for UI */
  name: Scalars['String']['output'];
  /** Stable ID across all versions */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Additional rule parameters */
  parameters: Scalars['JSON']['output'];
  /** Link to previous version for version chain */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Numeric version for append-only tracking */
  recordVersion: Scalars['Int']['output'];
  /** Validation rule specification */
  rule: GqlValidationRule;
  /** Error severity level */
  severity: GqlValidationSeverity | '%future added value';
  /** Searchable tags */
  tags: Array<Scalars['String']['output']>;
  /** Multi-tenant isolation */
  tenantId: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Updated by user ID */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Type of validation */
  validationType: GqlValidationType | '%future added value';
};

/** GraphQL type for DateRange in validation context. */
export type ValidationDateRange = {
  __typename?: 'ValidationDateRange';
  /** End date (optional) */
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Start date */
  start: Scalars['DateTime']['output'];
};

/** GraphQL input type for DateRange. */
export type ValidationDateRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
};

/**
 * Validation Execution Result - Complete validation summary (GraphQL output)
 *
 * Matches GraphQL schema ValidationExecutionResult type exactly.
 */
export type ValidationExecutionResult = {
  __typename?: 'ValidationExecutionResult';
  /** Layers executed (may be less if short-circuited) */
  layersExecuted: Scalars['Int']['output'];
  /** Overall success (true if no error-level violations) */
  success: Scalars['Boolean']['output'];
  /** Summary message */
  summary: Scalars['String']['output'];
  /** Total layers in plan */
  totalLayers: Scalars['Int']['output'];
  /** All violations found */
  violations: Array<ValidationViolationOutput>;
};

export type ValidationResultGql = {
  __typename?: 'ValidationResultGql';
  complianceIssues: Array<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  safetyViolations: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/** Validation Result Input */
export type ValidationResultInput = {
  /** Validation success flag */
  success: Scalars['Boolean']['input'];
  /** Violations (if any) */
  violations: Array<ValidationViolationInput>;
};

/** Validation rule for workflow steps */
export type ValidationRule = {
  __typename?: 'ValidationRule';
  errorMessage: Scalars['String']['output'];
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  severity: RuleSeverity | '%future added value';
};

export type ValidationRuleInput = {
  condition: Scalars['String']['input'];
  description: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
  expected: Scalars['String']['input'];
  severity: Scalars['String']['input'];
};

/**
 * Validation rules input
 *
 * Typed structure for field validation rules.
 * Preserves all validation metadata for life-critical audit trail.
 *
 * Architecture: GraphQL (camelCase) → This struct → serde → Model (snake_case JsonValue)
 */
export type ValidationRulesInput = {
  customValidator?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['JSON']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['JSON']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  requiredIf?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** ValidationSeverity - determines blocking behavior */
export const ValidationSeverity = {
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING',
} as const;

export type ValidationSeverity = (typeof ValidationSeverity)[keyof typeof ValidationSeverity];
/** Validation Severity - Determines blocking behavior (GraphQL enum) */
export const ValidationSeverityOutput = {
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING',
} as const;

export type ValidationSeverityOutput =
  (typeof ValidationSeverityOutput)[keyof typeof ValidationSeverityOutput];
/** Validation Summary (GraphQL output) */
export type ValidationSummary = {
  __typename?: 'ValidationSummary';
  /** Error count */
  errorCount: Scalars['Int']['output'];
  /** Validation success flag */
  success: Scalars['Boolean']['output'];
  /** Total violations */
  totalViolations: Scalars['Int']['output'];
  /** Warning count */
  warningCount: Scalars['Int']['output'];
};

/** Validation Violation Input */
export type ValidationViolationInput = {
  /** Error code */
  code: Scalars['String']['input'];
  /** Message */
  message: Scalars['String']['input'];
  /** Severity */
  severity: ValidationSeverity | '%future added value';
};

/** Validation Violation - Single validation failure (GraphQL output) */
export type ValidationViolationOutput = {
  __typename?: 'ValidationViolationOutput';
  code: Scalars['String']['output'];
  fieldId?: Maybe<Scalars['String']['output']>;
  fixSuggestion?: Maybe<Scalars['JSON']['output']>;
  layer: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  severity: ValidationSeverityOutput | '%future added value';
  standardsReference?: Maybe<Scalars['String']['output']>;
};

/** Result of a verification action. */
export type VerificationResult = {
  __typename?: 'VerificationResult';
  /** Actual counted quantity */
  actualCount: Scalars['Float']['output'];
  /** Constraint being verified */
  constraintId: Scalars['String']['output'];
  /** Discrepancy report ID (if variance exceeded tolerance) */
  discrepancyReportId?: Maybe<Scalars['String']['output']>;
  /** Expected count at time of verification */
  expectedCount: Scalars['Float']['output'];
  /** Notes from verification */
  notes?: Maybe<Scalars['String']['output']>;
  /** Primary verifier actor ID */
  primaryVerifierId: Scalars['String']['output'];
  /** Verification status */
  status: VerificationStatus | '%future added value';
  /** Tenant identifier */
  tenantId: Scalars['String']['output'];
  /** Variance */
  variance: Scalars['Float']['output'];
  /** Verification identifier */
  verificationId: Scalars['String']['output'];
  /** Verification timestamp (Unix ms) */
  verifiedAt: Scalars['Int']['output'];
  /** Witness actor IDs */
  witnessIds: Array<Scalars['String']['output']>;
};

/** Verification scope - what the verifier can see */
export const VerificationScope = {
  /** Full compliance view (for external auditors) */
  COMPLIANCE_AUDIT: 'COMPLIANCE_AUDIT',
  /** Only see transactions between authorized tenants */
  TRANSACTIONS_ONLY: 'TRANSACTIONS_ONLY',
  /** See transactions + audit trail */
  TRANSACTIONS_WITH_AUDIT: 'TRANSACTIONS_WITH_AUDIT',
} as const;

export type VerificationScope = (typeof VerificationScope)[keyof typeof VerificationScope];
/** Status of a verification */
export const VerificationStatus = {
  /** Verification disputed */
  DISPUTED: 'DISPUTED',
  /** Verification failed (variance exceeded tolerance) */
  FAILED: 'FAILED',
  /** Verification passed (within tolerance) */
  PASSED: 'PASSED',
  /** Verification pending witness signature */
  PENDING_WITNESS: 'PENDING_WITNESS',
  /** Verification voided */
  VOIDED: 'VOIDED',
} as const;

export type VerificationStatus = (typeof VerificationStatus)[keyof typeof VerificationStatus];
/** Input for verifying a single extraction */
export type VerifyExtractionInput = {
  /** Required if status is "corrected" */
  correctionNote?: InputMaybe<Scalars['String']['input']>;
  extractionId: Scalars['String']['input'];
  mappingId: Scalars['String']['input'];
  reviewerId: Scalars['String']['input'];
  /** "confirmed" or "corrected" */
  status: GqlVerificationStatus | '%future added value';
  tenantId: Scalars['String']['input'];
};

/** Input for verifying a witness request */
export type VerifyWitnessRequestInput = {
  /** Request ID to verify */
  requestId: Scalars['String']['input'];
  /** Witness role (e.g., "RN", "Pharmacist", "Supervisor") */
  witnessRole: Scalars['String']['input'];
};

/** Payload for verifyWitnessRequest mutation */
export type VerifyWitnessRequestPayload = {
  __typename?: 'VerifyWitnessRequestPayload';
  /** Token for completing the operation (must be used within 2 minutes) */
  completionToken: Scalars['String']['output'];
  /** The updated request */
  request: WitnessRequestGql;
};

/** Version history entry output */
export type VersionEntryOutput = {
  __typename?: 'VersionEntryOutput';
  changes: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** GraphQL enum for safety level (view context specific) */
export const ViewContextSafetyLevel = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
} as const;

export type ViewContextSafetyLevel =
  (typeof ViewContextSafetyLevel)[keyof typeof ViewContextSafetyLevel];
/** View layer enum for GraphQL */
export const ViewLayer = {
  /** Admin layer - "Team Work" */
  ADMIN: 'ADMIN',
  /** Architect layer - "Primitive Composition" */
  ARCHITECT: 'ARCHITECT',
  /** User layer - "My Work" */
  USER: 'USER',
} as const;

export type ViewLayer = (typeof ViewLayer)[keyof typeof ViewLayer];
export type ViolationInput = {
  configId: Scalars['String']['input'];
  severity: Scalars['String']['input'];
};

/** Input for voiding (cancelling) a signing ceremony (C1). */
export type VoidCeremonyInput = {
  ceremonyId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/**
 * Warning level for the download confirmation dialog.
 *
 * Frontend renders the `warning_message` text from backend — it does NOT
 * hardcode warning strings (DRR-055 dumb frontend pattern).
 */
export const WarningLevel = {
  /** Elevated warning — macros/active content detected */
  ELEVATED: 'ELEVATED',
  /** No warning needed (CLEAN files) */
  NONE: 'NONE',
  /** Standard warning — file from external source, scan passed */
  STANDARD: 'STANDARD',
} as const;

export type WarningLevel = (typeof WarningLevel)[keyof typeof WarningLevel];
/** Severity level for anti-pattern warnings */
export const WarningSeverity = {
  /** Critical (life-safety concern) */
  CRITICAL: 'CRITICAL',
  /** Informational (pattern could be improved) */
  INFO: 'INFO',
  /** Warning (potential issue) */
  WARNING: 'WARNING',
} as const;

export type WarningSeverity = (typeof WarningSeverity)[keyof typeof WarningSeverity];
/** Registered webhook endpoint (D1). */
export type WebhookEndpoint = {
  __typename?: 'WebhookEndpoint';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  endpointId: Scalars['String']['output'];
  /**
   * Event filter list. "ceremony.signed", "ceremony.completed", "ceremony.declined",
   * "ceremony.voided", "ceremony.expired". Use `["*"]` for all.
   */
  events: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Widget category */
export const WidgetCategory = {
  /** Accounting-specific widgets */
  ACCOUNTING: 'ACCOUNTING',
  /** Core Mantine components */
  CORE: 'CORE',
  /** FHIR/Healthcare widgets */
  FHIR: 'FHIR',
  /** Inventory/ERP widgets */
  INVENTORY: 'INVENTORY',
  /** Payroll widgets */
  PAYROLL: 'PAYROLL',
} as const;

export type WidgetCategory = (typeof WidgetCategory)[keyof typeof WidgetCategory];
/** Widget definition for the frontend registry */
export type WidgetDefinition = {
  __typename?: 'WidgetDefinition';
  /** Subgraphs that can use this widget (empty = all) */
  allowedSubgraphs: Array<Scalars['String']['output']>;
  /** Widget category */
  category: WidgetCategory | '%future added value';
  /** Description for admin UI */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name for UI builders */
  displayName: Scalars['String']['output'];
  /** Component import path (for frontend reference) */
  importPath?: Maybe<Scalars['String']['output']>;
  /** Whether this widget requires lazy loading */
  lazy: Scalars['Boolean']['output'];
  /** Whether this widget handles life-critical data */
  lifeCriticalCapable: Scalars['Boolean']['output'];
  /** Widget component name */
  name: Scalars['String']['output'];
  /** Widget props schema (JSON Schema) */
  propsSchema?: Maybe<Scalars['String']['output']>;
  /** Supported field types */
  supportedTypes: Array<Scalars['String']['output']>;
};

/** Type of life-critical operation requiring witness */
export const WitnessOperationTypeGql = {
  /** Batch payment release */
  BATCH_PAYMENT_RELEASE: 'BATCH_PAYMENT_RELEASE',
  /** Blood transfusion */
  BLOOD_TRANSFUSION: 'BLOOD_TRANSFUSION',
  /** Custom operation type (requires customOperationType field) */
  CUSTOM: 'CUSTOM',
  /** Patient discharge against medical advice */
  DISCHARGE_AGAINST_ADVICE: 'DISCHARGE_AGAINST_ADVICE',
  /** Emergency override (break-glass) */
  EMERGENCY_OVERRIDE: 'EMERGENCY_OVERRIDE',
  /** High-risk medication dispensing */
  HIGH_RISK_MEDICATION: 'HIGH_RISK_MEDICATION',
  /** Financial transaction above threshold */
  HIGH_VALUE_TRANSACTION: 'HIGH_VALUE_TRANSACTION',
  /** Legal document execution */
  LEGAL_DOCUMENT_EXECUTION: 'LEGAL_DOCUMENT_EXECUTION',
  /** Patient medication administration */
  MEDICATION_ADMINISTRATION: 'MEDICATION_ADMINISTRATION',
  /** Settlement approval */
  SETTLEMENT_APPROVAL: 'SETTLEMENT_APPROVAL',
  /** Wire transfer approval */
  WIRE_TRANSFER_APPROVAL: 'WIRE_TRANSFER_APPROVAL',
} as const;

export type WitnessOperationTypeGql =
  (typeof WitnessOperationTypeGql)[keyof typeof WitnessOperationTypeGql];
export type WitnessRequestGql = {
  __typename?: 'WitnessRequestGql';
  /** Timestamp when request was completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when request was created */
  createdAt: Scalars['DateTime']['output'];
  /** Custom operation type name (if operation_type is CUSTOM) */
  customOperationType?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the action */
  description: Scalars['String']['output'];
  /** Entity being operated on */
  entityId: Scalars['String']['output'];
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Timestamp when request expires */
  expiresAt: Scalars['DateTime']['output'];
  /** Unique request identifier */
  id: Scalars['String']['output'];
  /** Whether the request has expired */
  isExpired: Scalars['Boolean']['output'];
  /** Optional metadata (JSON string) */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Type of operation */
  operationType: WitnessOperationTypeGql | '%future added value';
  /** Operator who initiated the request */
  operatorId: Scalars['String']['output'];
  /** Seconds remaining until expiration (None if expired) */
  secondsRemaining?: Maybe<Scalars['Int']['output']>;
  /** Current status */
  status: WitnessStatusGql | '%future added value';
  /** Tenant context */
  tenantId: Scalars['String']['output'];
  /** Timestamp when request was verified */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Witness user ID (set after verification) */
  witnessId?: Maybe<Scalars['String']['output']>;
  /** Witness role (e.g., "RN", "Pharmacist", "Supervisor") */
  witnessRole?: Maybe<Scalars['String']['output']>;
};

export type WitnessSignature = {
  __typename?: 'WitnessSignature';
  certificateId?: Maybe<Scalars['String']['output']>;
  notarizationJurisdiction?: Maybe<Scalars['String']['output']>;
  signatureData: Scalars['String']['output'];
  signatureType: GqlSignatureType | '%future added value';
  signedAt: Scalars['DateTime']['output'];
  witnessId: Scalars['String']['output'];
  witnessName: Scalars['String']['output'];
  witnessRole: Scalars['String']['output'];
};

/** Witness request status */
export const WitnessStatusGql = {
  /** Request was cancelled by operator */
  CANCELLED: 'CANCELLED',
  /** Operation completed successfully */
  COMPLETED: 'COMPLETED',
  /** Request expired without verification */
  EXPIRED: 'EXPIRED',
  /** Request created, waiting for witness */
  PENDING: 'PENDING',
  /** Request was rejected by witness */
  REJECTED: 'REJECTED',
  /** Witness has verified the request */
  VERIFIED: 'VERIFIED',
} as const;

export type WitnessStatusGql = (typeof WitnessStatusGql)[keyof typeof WitnessStatusGql];
/** Wizard step configuration */
export type WizardStep = {
  __typename?: 'WizardStep';
  /** Step description */
  description?: Maybe<Scalars['String']['output']>;
  /** Field names included in this step */
  fields: Array<Scalars['String']['output']>;
  /** Optional step icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** Step title */
  title: Scalars['String']['output'];
};

export type WizardStepInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type WorkItem = {
  __typename?: 'WorkItem';
  /** Assigned actor ID */
  assignedTo?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp (epoch ms) */
  createdAt: Scalars['Int']['output'];
  /** SK of the domain-specific detail record for federation resolution */
  detailSk: Scalars['String']['output'];
  /** Source domain: "fhir", "payroll", "accounting", "website" */
  domain: Scalars['String']['output'];
  /** Due date if applicable (epoch ms) */
  dueAt?: Maybe<Scalars['Int']['output']>;
  /**
   * Federation resolver: FHIR Encounter detail
   *
   * Returns an EncounterDetailRef if this work item is from the FHIR domain.
   * The returned reference can be extended by the FHIR subgraph to provide
   * full Encounter details.
   *
   * Returns `null` if domain is not "fhir".
   */
  encounterDetail?: Maybe<EncounterDetailRef>;
  /** Unique identifier of the workflow instance */
  id: Scalars['ID']['output'];
  /** Whether this item is overdue */
  isOverdue: Scalars['Boolean']['output'];
  /**
   * Federation resolver: Payroll Run detail
   *
   * Returns a PayrollRunDetailRef if this work item is from the Payroll domain.
   * The returned reference can be extended by the Payroll subgraph to provide
   * full PayrollRun details.
   *
   * Returns `null` if domain is not "payroll".
   */
  payrollRunDetail?: Maybe<PayrollRunDetailRef>;
  /** Priority */
  priority: WorkPriority | '%future added value';
  /** Current status */
  status: WorkStatus | '%future added value';
  /** Display title for dashboards */
  title: Scalars['String']['output'];
  /** Last update timestamp (epoch ms) */
  updatedAt: Scalars['Int']['output'];
  /** Workflow type within domain: "encounter", "payroll_run", "invoice" */
  workflowType: Scalars['String']['output'];
};

/** Paginated result of work items */
export type WorkItemConnection = {
  __typename?: 'WorkItemConnection';
  /** Whether there are more results */
  hasNextPage: Scalars['Boolean']['output'];
  /** Work items for this page */
  items: Array<WorkItem>;
  /** Cursor for next page (if more results exist) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Total count (if available) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Status of a shift work item */
export const WorkItemStatus = {
  /** Cancelled */
  CANCELLED: 'CANCELLED',
  /** Completed successfully */
  COMPLETED: 'COMPLETED',
  /** In progress */
  IN_PROGRESS: 'IN_PROGRESS',
  /** Past due */
  OVERDUE: 'OVERDUE',
  /** Not yet started */
  PENDING: 'PENDING',
  /** Skipped with reason */
  SKIPPED: 'SKIPPED',
} as const;

export type WorkItemStatus = (typeof WorkItemStatus)[keyof typeof WorkItemStatus];
/** Type of shift work item */
export const WorkItemType = {
  /** Deadline or due date */
  DEADLINE: 'DEADLINE',
  /** Documentation requirement */
  DOCUMENTATION: 'DOCUMENTATION',
  /** Follow-up from prior item */
  FOLLOW_UP: 'FOLLOW_UP',
  /** Recurring task */
  RECURRING_TASK: 'RECURRING_TASK',
  /** Ad-hoc request */
  REQUEST: 'REQUEST',
  /** Scheduled action (medication pass, equipment check) */
  SCHEDULED_ACTION: 'SCHEDULED_ACTION',
  /** Verification or check */
  VERIFICATION: 'VERIFICATION',
} as const;

export type WorkItemType = (typeof WorkItemType)[keyof typeof WorkItemType];
/** Priority filter for myWork query */
export const WorkPriority = {
  /** Life-critical - requires immediate attention */
  CRITICAL: 'CRITICAL',
  /** High priority - should be addressed soon */
  HIGH: 'HIGH',
  /** Low priority - can be deferred */
  LOW: 'LOW',
  /** Normal priority - standard workflow */
  NORMAL: 'NORMAL',
} as const;

export type WorkPriority = (typeof WorkPriority)[keyof typeof WorkPriority];
/** Work status filter for myWork query */
export const WorkStatus = {
  /** Cancelled by user */
  CANCELLED: 'CANCELLED',
  /** Successfully completed */
  COMPLETED: 'COMPLETED',
  /** Initial state, not yet started */
  DRAFT: 'DRAFT',
  /** Failed with error */
  FAILED: 'FAILED',
  /** Currently being worked on */
  IN_PROGRESS: 'IN_PROGRESS',
  /** On hold/paused */
  ON_HOLD: 'ON_HOLD',
  /** Waiting to be picked up */
  PENDING: 'PENDING',
  /** Waiting for approval */
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  /** Scheduled for future execution */
  SCHEDULED: 'SCHEDULED',
} as const;

export type WorkStatus = (typeof WorkStatus)[keyof typeof WorkStatus];
/**
 * Workflow - Top-level process definition primitive.
 *
 * Position #1/25 in FERP's primitive architecture (DESIGN phase).
 * Defines the canonical structure of a business process including states,
 * transitions, guards, and actions.
 *
 * Total: 36 fields (28 base + 8 formula tracking) + 1 computed (compressed_id)
 */
export type Workflow = {
  __typename?: 'Workflow';
  /** Action registry (as list of key-value entries) */
  actions: Array<ActionEntry>;
  /** Is this workflow version active? */
  active: Scalars['Boolean']['output'];
  /** Audit trail (WHO/WHEN/VERSION) */
  auditInfo: WorkflowAuditInfo;
  /** Required audit actions (WHO, WHEN, WHAT, WHERE, WHY) */
  auditRequirements: Array<Scalars['String']['output']>;
  /** Regulatory authority ID (optional) */
  authorityId?: Maybe<Scalars['String']['output']>;
  /** Compliance frameworks (HIPAA, SOX, FDA, GDPR, etc.) */
  complianceFrameworks: Array<Scalars['String']['output']>;
  /** Compliance level (high, medium, low) */
  complianceLevel?: Maybe<Scalars['String']['output']>;
  /**
   * Compressed ID format (lazy-loaded from cache/DynamoDB)
   *
   * Returns the compressed version of the Snowflake ID for this workflow.
   * Uses Valkey cache (85%+ hit rate, <1ms) with DynamoDB fallback (~10ms).
   *
   * # Performance
   * - Cache hit: <1ms
   * - Cache miss: ~10ms (DynamoDB lookup)
   *
   * # Returns
   * - `Some(compressed_id)` if mapping exists
   * - `None` if no compressed ID has been generated yet
   */
  compressedId?: Maybe<Scalars['String']['output']>;
  /** Criticality level: "life_critical", "critical", "operational" */
  criticality: Scalars['String']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable display name for this workflow (DRR-217).
   *
   * Resolves from Valkey cache (1-2ms) with graceful degradation.
   * After DRR-217 key compression, IDs like "2_47" need display names
   * like "MN 144G Daily Care Workflow" for UX.
   *
   * # Resolution Order
   * 1. Valkey cache (1-2ms, 95%+ hit rate)
   * 2. Wasabi S3 fallback (50-100ms, when S3 feature enabled)
   * 3. Graceful degradation: returns `self.name` if resolver unavailable
   *
   * # Returns
   * Human-readable display name for this workflow.
   */
  displayName: Scalars['String']['output'];
  /** When this workflow becomes effective (ISO 8601) */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Execution strategy: "dag", "saga", "state_machine", "actor" */
  executionStrategy?: Maybe<Scalars['String']['output']>;
  /** When this workflow expires (ISO 8601) */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Per-formula average duration (seconds) */
  formulaAvgDurations: Array<FormulaDurationEntry>;
  /** Per-formula completion rate (0.0-1.0) */
  formulaCompletionRates: Array<FormulaMetricEntry>;
  /** Per-formula error rate (0.0-1.0) */
  formulaErrorRates: Array<FormulaMetricEntry>;
  /** Per-formula state machine complexity */
  formulaStateCounts: Array<FormulaStateCountEntry>;
  /** Guard registry (as list of key-value entries) */
  guards: Array<GuardEntry>;
  /** Backend Snowflake ID */
  id: Scalars['String']['output'];
  /** Starting state name */
  initialState: Scalars['String']['output'];
  /** Total instances generated from this workflow */
  instantiationCount: Scalars['Int']['output'];
  /** Soft delete flag */
  isActive: Scalars['Boolean']['output'];
  /** Jurisdictional scope (US, EU, healthcare, finance, etc.) */
  jurisdictionalScope: Array<Scalars['String']['output']>;
  /** When workflow last generated instances (ISO 8601) */
  lastInstantiatedAt?: Maybe<Scalars['String']['output']>;
  /** Unlimited JSON metadata */
  metadata: Scalars['JSON']['output'];
  /** Workflow name */
  name: Scalars['String']['output'];
  /** Stable ID across all versions */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Link to previous version for version chain */
  parentVersionId?: Maybe<Scalars['String']['output']>;
  /** Per-formula recommended execution strategy */
  recommendedExecutionStrategies: Array<FormulaStrategyEntry>;
  /** Numeric version for append-only tracking */
  recordVersion: Scalars['Int']['output'];
  /** Regulatory requirements */
  regulations: Array<Regulation>;
  /** Retry configuration for failed executions */
  retryPolicy?: Maybe<WorkflowRetryPolicy>;
  /** Risk classification (high, medium, low) */
  riskClassification?: Maybe<Scalars['String']['output']>;
  /** State definitions */
  states: Array<WorkflowState>;
  /** Which formulas this workflow enables */
  targetFormulas: Array<Scalars['String']['output']>;
  /** Overall workflow timeout in seconds */
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
  /** Transition rules between states */
  transitions: Array<WorkflowStateTransition>;
  /** Semantic version (e.g., "1.0.0") */
  version: Scalars['String']['output'];
};

/** Audit information for tracking changes. */
export type WorkflowAuditInfo = {
  __typename?: 'WorkflowAuditInfo';
  /** When the record was created (ISO 8601) */
  createdAt: Scalars['String']['output'];
  /** User/system that created this record */
  createdBy: Scalars['String']['output'];
  /** When the record was last modified (ISO 8601) */
  updatedAt: Scalars['String']['output'];
  /** User/system that last modified this record */
  updatedBy: Scalars['String']['output'];
  /** Record version number (optimistic locking) */
  version: Scalars['Int']['output'];
};

/** Workflow Compliance Status */
export type WorkflowComplianceStatus = {
  __typename?: 'WorkflowComplianceStatus';
  certifications: Array<ComplianceCertification>;
  frameworkScores: Array<FrameworkScore>;
  lastCheckedAt: Scalars['String']['output'];
  overallScore: Scalars['Float']['output'];
  tenant: Scalars['String']['output'];
  violations: Array<ComplianceViolation>;
  workflowId: Scalars['String']['output'];
};

/** Workflow configuration for forms */
export type WorkflowConfig = {
  __typename?: 'WorkflowConfig';
  actions: Array<Scalars['JSON']['output']>;
  guards: Array<Scalars['JSON']['output']>;
  initialState: Scalars['String']['output'];
  transitions: Array<Scalars['JSON']['output']>;
  workflowId: Scalars['String']['output'];
};

/** Paginated workflow results. */
export type WorkflowConnection = {
  __typename?: 'WorkflowConnection';
  /** Whether there are more results */
  hasNextPage: Scalars['Boolean']['output'];
  /** List of workflows */
  items: Array<Workflow>;
  /** Total count of workflows matching the query */
  totalCount: Scalars['Int']['output'];
};

/**
 * Represents workflow business context for AI agents
 *
 * ## AI-Ready Design
 *
 * This type provides structured context that enables AI agents to:
 * - Understand workflow purpose and priority
 * - Make informed decisions about automation
 * - Escalate appropriately based on risk
 *
 * ## Example
 *
 * ```json
 * {
 * "workflowType": "tax_notifications",
 * "domain": "payroll",
 * "criticality": "operational",
 * "estimatedCompletionTime": "PT48H",
 * "metadata": {
 * "confidence_score": "0.95",
 * "validation_violations": "0",
 * "life_critical": "false"
 * }
 * }
 * ```
 */
export type WorkflowContext = {
  __typename?: 'WorkflowContext';
  /** Criticality level (life_critical, critical, operational) */
  criticality: Scalars['String']['output'];
  /** Business domain (healthcare, finance, legal, payroll, etc.) */
  domain: Scalars['String']['output'];
  /** Estimated time to complete workflow (ISO 8601 duration) */
  estimatedCompletionTime?: Maybe<Scalars['String']['output']>;
  /** Additional metadata as key-value pairs */
  metadata: Scalars['JSONObject']['output'];
  /** Type of workflow (from 25 primitive workflow types) */
  workflowType: Scalars['String']['output'];
};

/** Criticality level for workflow steps */
export const WorkflowCriticality = {
  /** Must complete for compliance */
  COMPLIANCE_CRITICAL: 'COMPLIANCE_CRITICAL',
  /** Financial impact if fails */
  FINANCIALLY_SIGNIFICANT: 'FINANCIALLY_SIGNIFICANT',
  /** Life safety implications */
  LIFE_CRITICAL: 'LIFE_CRITICAL',
  /** Normal operational step */
  OPERATIONAL: 'OPERATIONAL',
  /** Direct patient/client impact */
  PATIENT_IMPACT: 'PATIENT_IMPACT',
} as const;

export type WorkflowCriticality = (typeof WorkflowCriticality)[keyof typeof WorkflowCriticality];
/** GraphQL Output Types */
export type WorkflowCriticalityResult = {
  __typename?: 'WorkflowCriticalityResult';
  canExecute: Scalars['Boolean']['output'];
  canRunOffline: Scalars['Boolean']['output'];
  criticalityLevel: Scalars['String']['output'];
  deduplicationFingerprint: Scalars['String']['output'];
  lockType: Scalars['String']['output'];
  offlineRisks: Array<Scalars['String']['output']>;
  potentialDuplicates: Array<PotentialDuplicateResult>;
  requiresLock: Scalars['Boolean']['output'];
  violations: Array<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

/** Workflow DAG representation. */
export type WorkflowDag = {
  __typename?: 'WorkflowDAG';
  /** Total dependency count */
  dependencyCount: Scalars['Int']['output'];
  /** DAG edges (dependencies) */
  edges: Array<DagEdge>;
  /** Has cycles detected */
  hasCycles: Scalars['Boolean']['output'];
  /** DAG nodes (tasks) */
  nodes: Array<DagNode>;
  /** Workflow ID */
  workflowId: Scalars['String']['output'];
};

/** Complete workflow definition (with nodes and edges) */
export type WorkflowDefinition = {
  __typename?: 'WorkflowDefinition';
  /** Compliance frameworks (union-only: child cannot remove parent's) */
  complianceFrameworks: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  edges: Array<WorkflowEdge>;
  /** Parent workflow this extends (for inheritance) */
  extends?: Maybe<Scalars['String']['output']>;
  fallbackExtends?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Whether this workflow is life-critical (monotonic: can only increase) */
  isLifeCritical: Scalars['Boolean']['output'];
  metadata?: Maybe<WorkflowMetadata>;
  name: Scalars['String']['output'];
  nodes: Array<WorkflowNode>;
  /** Timeout in seconds (child overrides parent if specified) */
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
  version: Scalars['String']['output'];
};

/** Workflow definition view */
export type WorkflowDefinitionView = {
  __typename?: 'WorkflowDefinitionView';
  active: Scalars['Boolean']['output'];
  initialState: Scalars['String']['output'];
  name: Scalars['String']['output'];
  states: Array<StateDefView>;
  version: Scalars['String']['output'];
};

/** Dependency between workflows */
export type WorkflowDependency = {
  __typename?: 'WorkflowDependency';
  /** Optional condition expression */
  condition?: Maybe<Scalars['String']['output']>;
  /** Workflow that depends on another */
  dependent: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Workflow that must complete first */
  required: Scalars['String']['output'];
};

/** Draft workflow state (in-memory + persistent) */
export type WorkflowDraft = {
  __typename?: 'WorkflowDraft';
  /** Context for this draft */
  context: WorkflowEditContext;
  /** Current state of the workflow definition */
  currentState: WorkflowDefinition;
  /** Unique draft ID */
  draftId: Scalars['String']['output'];
  /** Edit history (list of applied suggestions) */
  editHistory: Array<AppliedEdit>;
  /** Draft metadata */
  metadata: DraftMetadata;
  /** Pending suggestions not yet applied */
  pendingSuggestions: Array<LlmEditSuggestion>;
  /** Workflow being edited */
  workflowName: Scalars['String']['output'];
};

/** Edge (transition) between workflow nodes */
export type WorkflowEdge = {
  __typename?: 'WorkflowEdge';
  condition?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<EdgeMetadata>;
  /** Remove this edge (for inheritance override) */
  remove: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

/** Workflow edge input (without ID - will be generated by backend) */
export type WorkflowEdgeInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

/** Context for workflow editing (used as both input and output) */
export type WorkflowEditContext = {
  __typename?: 'WorkflowEditContext';
  certification?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  programVariant?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

/** Edit operation type */
export const WorkflowEditOperation = {
  /** Add compliance check */
  ADD_COMPLIANCE_CHECK: 'ADD_COMPLIANCE_CHECK',
  /** Add a new edge */
  ADD_EDGE: 'ADD_EDGE',
  /** Add a new node */
  ADD_NODE: 'ADD_NODE',
  /** Add validation rule */
  ADD_VALIDATION_RULE: 'ADD_VALIDATION_RULE',
  /** Modify an existing edge */
  MODIFY_EDGE: 'MODIFY_EDGE',
  /** Modify workflow metadata */
  MODIFY_METADATA: 'MODIFY_METADATA',
  /** Modify an existing node */
  MODIFY_NODE: 'MODIFY_NODE',
  /** Remove an edge */
  REMOVE_EDGE: 'REMOVE_EDGE',
  /** Remove a node */
  REMOVE_NODE: 'REMOVE_NODE',
} as const;

export type WorkflowEditOperation =
  (typeof WorkflowEditOperation)[keyof typeof WorkflowEditOperation];
export type WorkflowEvent = {
  __typename?: 'WorkflowEvent';
  eventType: Scalars['String']['output'];
  fromState?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instanceId: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  toState?: Maybe<Scalars['String']['output']>;
  workflowName: Scalars['String']['output'];
};

/**
 * Evidence attribution for a single field
 *
 * Tracks source document → extracted text → field mapping for audit trail.
 * CRITICAL: Required for trust and compliance in AI-generated templates.
 */
export type WorkflowEvidenceAttributionOutput = {
  __typename?: 'WorkflowEvidenceAttributionOutput';
  /** AI confidence score (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** Timestamp of extraction */
  extractedAt: Scalars['String']['output'];
  /** Extracted text that led to this field */
  extractedText: Scalars['String']['output'];
  /** Field ID that this evidence supports */
  fieldId: Scalars['String']['output'];
  /** LLM provider used for extraction (claude, gpt4, gemini) */
  llmProvider: Scalars['String']['output'];
  /** Page number in source document (if applicable) */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** Source document ID (S3 key or Chaos document ID) */
  sourceDocumentId: Scalars['String']['output'];
  /** Section/location reference in source document */
  sourceLocation: Scalars['String']['output'];
  /** Source type (pdf, email, voice, manual) */
  sourceType: Scalars['String']['output'];
  /** Human validation status */
  validatedByHuman: Scalars['Boolean']['output'];
};

/** GraphQL Input Types */
export type WorkflowExecutionInput = {
  /** Additional context/metadata as JSON string */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Actor initiating this workflow */
  initiatingActor: Scalars['String']['input'];
  /** Whether this is an offline execution */
  isOfflineExecution: Scalars['Boolean']['input'];
  /** Tenant context */
  tenantId: Scalars['String']['input'];
  /** The actual workflow data as JSON string */
  workflowData: Scalars['String']['input'];
  /** Unique workflow instance identifier */
  workflowId: Scalars['String']['input'];
  /** One of the 15 workflow engine types */
  workflowType: Scalars['String']['input'];
};

/** Workflow graph */
export type WorkflowGraph = {
  __typename?: 'WorkflowGraph';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  edges: Array<WorkflowGraphEdge>;
  graphId: Scalars['String']['output'];
  graphName: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nodes: Array<WorkflowGraphNode>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

/** Workflow graph change event for real-time subscriptions */
export type WorkflowGraphChangeEvent = {
  __typename?: 'WorkflowGraphChangeEvent';
  /** Type of change: "created", "updated", or "deleted" */
  changeType: Scalars['String']['output'];
  /** Timestamp of change (RFC3339) */
  changedAt: Scalars['String']['output'];
  /** User ID who made the change */
  changedBy: Scalars['String']['output'];
  /** Updated graph data (None if deleted) */
  graph?: Maybe<WorkflowGraph>;
};

/** Workflow edge */
export type WorkflowGraphEdge = {
  __typename?: 'WorkflowGraphEdge';
  condition?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

/** Workflow graph filter */
export type WorkflowGraphFilter = {
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  graphName?: InputMaybe<Scalars['String']['input']>;
};

/** Workflow graph list result */
export type WorkflowGraphList = {
  __typename?: 'WorkflowGraphList';
  graphs: Array<WorkflowGraph>;
  totalCount: Scalars['Int']['output'];
};

/** Workflow node */
export type WorkflowGraphNode = {
  __typename?: 'WorkflowGraphNode';
  approvalPolicyId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nodeType: WorkflowNodeType | '%future added value';
  subgraphId?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  /** Canvas x-coordinate (pixels). Defaults to 0 for records seeded before layout was added. */
  x: Scalars['Float']['output'];
  /** Canvas y-coordinate (pixels). Defaults to 0 for records seeded before layout was added. */
  y: Scalars['Float']['output'];
};

/** Workflow instance view */
export type WorkflowInstanceView = {
  __typename?: 'WorkflowInstanceView';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type WorkflowLockResult = {
  __typename?: 'WorkflowLockResult';
  expiresAt: Scalars['DateTime']['output'];
  lockId: Scalars['String']['output'];
  lockScope: Scalars['String']['output'];
  lockedAt: Scalars['DateTime']['output'];
  lockedBy: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
  workflowType: Scalars['String']['output'];
};

/** Metadata for workflows */
export type WorkflowMetadata = {
  __typename?: 'WorkflowMetadata';
  auditLevel?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  complianceDomains: Array<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  retentionDays?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** Individual node (step) in a workflow */
export type WorkflowNode = {
  __typename?: 'WorkflowNode';
  complianceChecks: Array<ComplianceCheck>;
  criticality: WorkflowCriticality | '%future added value';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Position control for inheritance */
  insertAfter?: Maybe<Scalars['String']['output']>;
  insertBefore?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  metadata?: Maybe<NodeMetadata>;
  nodeType: Scalars['String']['output'];
  /** Remove this node (for inheritance override) */
  remove: Scalars['Boolean']['output'];
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
  validationRules: Array<ValidationRule>;
};

/** Workflow node input (without ID - will be generated by backend) */
export type WorkflowNodeInput = {
  approvalPolicyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  subgraphId?: InputMaybe<Scalars['String']['input']>;
  taskTemplateId?: InputMaybe<Scalars['String']['input']>;
  type: WorkflowNodeType | '%future added value';
  x?: Scalars['Float']['input'];
  y?: Scalars['Float']['input'];
};

/** Workflow node type enum */
export const WorkflowNodeType = {
  APPROVAL: 'APPROVAL',
  DECISION: 'DECISION',
  END: 'END',
  START: 'START',
  SUBGRAPH: 'SUBGRAPH',
  TASK: 'TASK',
} as const;

export type WorkflowNodeType = (typeof WorkflowNodeType)[keyof typeof WorkflowNodeType];
/** Phase grouping for workflows */
export type WorkflowPhase = {
  __typename?: 'WorkflowPhase';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parallel: Scalars['Boolean']['output'];
  workflows: Array<Scalars['String']['output']>;
};

/** Input for preflight validation */
export type WorkflowPreflightInput = {
  /** Whether to check 5W1H dimensions (default: true) */
  checkDimensions?: Scalars['Boolean']['input'];
  /** Whether to run simulation (default: true) */
  runSimulation?: Scalars['Boolean']['input'];
  /** Workflow ID to validate (existing workflow) */
  workflowId?: InputMaybe<Scalars['String']['input']>;
  /** YAML content to validate (draft workflow) */
  yamlContent?: InputMaybe<Scalars['String']['input']>;
};

/** Input describing the workflow component context for primitive aggregation */
export type WorkflowPrimitiveContextInput = {
  selectedKey: Scalars['String']['input'];
  selectedKind: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

/** Aggregated primitive response for a workflow context */
export type WorkflowPrimitiveResponse = {
  __typename?: 'WorkflowPrimitiveResponse';
  identifiers: Array<Scalars['String']['output']>;
  primitives: Array<WorkflowPrimitiveSummary>;
  selectedKey: Scalars['String']['output'];
  selectedKind: Scalars['String']['output'];
};

/** Summary of an individual primitive returned by aggregation */
export type WorkflowPrimitiveSummary = {
  __typename?: 'WorkflowPrimitiveSummary';
  draft: Scalars['JSON']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
};

/** Response for workflow registry query */
export type WorkflowRegistryResponse = {
  __typename?: 'WorkflowRegistryResponse';
  dependencies: Array<WorkflowDependency>;
  programConfig?: Maybe<ProgramConfig>;
  workflows: Array<SubWorkflowConfig>;
};

/** Retry policy for failed workflow executions. */
export type WorkflowRetryPolicy = {
  __typename?: 'WorkflowRetryPolicy';
  /** Backoff multiplier for exponential backoff */
  backoffMultiplier: Scalars['Float']['output'];
  /** Initial backoff duration in seconds */
  backoffSeconds: Scalars['Int']['output'];
  /** Maximum number of retry attempts */
  maxAttempts: Scalars['Int']['output'];
};

/** Select option input for workflow template metadata */
export type WorkflowSelectOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Response from workflow signal operation */
export type WorkflowSignalResponse = {
  __typename?: 'WorkflowSignalResponse';
  error?: Maybe<Scalars['String']['output']>;
  instanceId: Scalars['String']['output'];
  newState?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** State within a workflow. */
export type WorkflowState = {
  __typename?: 'WorkflowState';
  /** Actions to execute when entering this state */
  entryActions: Array<Scalars['String']['output']>;
  /** Actions to execute when exiting this state */
  exitActions: Array<Scalars['String']['output']>;
  /** State name (unique within workflow) */
  name: Scalars['String']['output'];
  /**
   * Policy/RuleSet config IDs that gate this state (DRR-129).
   * Evaluated before entry actions: CRITICAL=block, WARNING=log, DEFERRED=audit.
   */
  policyRefs: Array<Scalars['String']['output']>;
  /** State type (Initial, Normal, Final, Parallel, Choice) */
  stateType: GqlStateType | '%future added value';
  /** Optional timeout in seconds */
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
  /** Configuration for the UI pattern (varies by pattern type). */
  uiConfig?: Maybe<Scalars['JSON']['output']>;
  /** UI pattern for rendering this state (DRR-309). */
  uiPattern?: Maybe<GqlUiPattern | '%future added value'>;
};

export type WorkflowStateInput = {
  stateName: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

/**
 * Transition between two states in a workflow FSM.
 *
 * Different from hypermedia StateTransition which is for HATEOAS navigation.
 */
export type WorkflowStateTransition = {
  __typename?: 'WorkflowStateTransition';
  /** Actions to execute during transition */
  actions: Array<Scalars['String']['output']>;
  /** Event that triggers this transition */
  event: Scalars['String']['output'];
  /** Source state name */
  fromState: Scalars['String']['output'];
  /** Guard names that must pass (AND logic) */
  guards: Array<Scalars['String']['output']>;
  /** Destination state name */
  toState: Scalars['String']['output'];
};

/** Workflow statistics. */
export type WorkflowStatistics = {
  __typename?: 'WorkflowStatistics';
  /** Active workflows */
  activeWorkflows: Scalars['Int']['output'];
  /** Average completion rate */
  avgCompletionRate: Scalars['Float']['output'];
  /** Life-critical workflows */
  lifeCriticalWorkflows: Scalars['Int']['output'];
  /** Total instantiations across all workflows */
  totalInstantiations: Scalars['Int']['output'];
  /** Total workflows for tenant */
  totalWorkflows: Scalars['Int']['output'];
};

/**
 * WorkflowTemplateMetadata (matches GraphQL schema exactly)
 *
 * This is the target structure for DSL conversion
 */
export type WorkflowTemplateMetadata = {
  __typename?: 'WorkflowTemplateMetadata';
  /** Timestamps (set by repository) */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Creator (from conversion context) */
  createdBy: Scalars['String']['output'];
  /** Domain (healthcare, finance, legal, etc.) */
  domain: Scalars['String']['output'];
  /** Complete metadata content */
  metadata: TemplateMetadataContent;
  /** Schema version (always "2.0" for Metadata DSL v2) */
  schemaVersion: Scalars['String']['output'];
  /** Template identifier */
  templateId: Scalars['String']['output'];
  /** Template type (patient-intake, invoice-processing, etc.) */
  templateType: Scalars['String']['output'];
  /** Template version (starts at "1.0.0-draft") */
  templateVersion: Scalars['String']['output'];
  /** Tenant ID */
  tenant: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * DEPRECATED: Old simple validation result (use ValidationExecutionResultOutput instead)
 * Kept for backwards compatibility only
 * Renamed to WorkflowTemplateValidationResult to avoid collision with template_import_export::TemplateValidationResult
 */
export type WorkflowTemplateValidationResult = {
  __typename?: 'WorkflowTemplateValidationResult';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/** Workflow validation result. */
export type WorkflowValidationResult = {
  __typename?: 'WorkflowValidationResult';
  /** Validation errors (if any) */
  errors: Array<Scalars['String']['output']>;
  /** Whether validation passed */
  valid: Scalars['Boolean']['output'];
  /** Validation warnings (if any) */
  warnings: Array<Scalars['String']['output']>;
};

/** Working hours input */
export type WorkingHoursInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type XaParticipant = {
  __typename?: 'XAParticipant';
  committedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  preparedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceManagerId: Scalars['String']['output'];
  resourceManagerUrl: Scalars['String']['output'];
  vote?: Maybe<GqlXaVote | '%future added value'>;
  xaResourceState: GqlXaResourceState | '%future added value';
};

export type ZeroResultQuery = {
  __typename?: 'ZeroResultQuery';
  count: Scalars['Int']['output'];
  lastSearched: Scalars['DateTime']['output'];
  query: Scalars['String']['output'];
};

/**
 * A physical zone within a facility.
 *
 * DRR-108: Zone architecture for BLE proximity tracking.
 * Key: `PK=~{tenant_num}, SK=ZONE#{zone_id}`
 */
export type Zone = {
  __typename?: 'Zone';
  /** Current number of beacons detected in this zone (from Valkey) */
  activeBeaconCount: Scalars['Int']['output'];
  /** iBeacon major value for this zone's beacons */
  beaconMajor: Scalars['Int']['output'];
  beaconMinorEnd: Scalars['Int']['output'];
  /** Range of minor values assigned to this zone */
  beaconMinorStart: Scalars['Int']['output'];
  /** Maximum occupancy */
  capacity: Scalars['Int']['output'];
  /** Zone description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether this zone is relevant for elopement detection */
  elopementRelevant: Scalars['Boolean']['output'];
  /** Floor number (0 = ground/outdoor) */
  floor: Scalars['Int']['output'];
  /** Human-readable zone name */
  name: Scalars['String']['output'];
  /** Safety level for this zone */
  safetyLevel: ZoneSafetyLevel | '%future added value';
  /** Tenant number */
  tenantNum: Scalars['Int']['output'];
  /** Zone identifier (e.g., "17-zone-lobby") */
  zoneId: Scalars['String']['output'];
  /** Zone type classification */
  zoneType: ZoneType | '%future added value';
};

/** Safety level for zones. */
export const ZoneSafetyLevel = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  STANDARD: 'STANDARD',
} as const;

export type ZoneSafetyLevel = (typeof ZoneSafetyLevel)[keyof typeof ZoneSafetyLevel];
/** Zone type classification. */
export const ZoneType = {
  /** Shared common areas (lobby, dining, activity rooms) */
  COMMON: 'COMMON',
  /** Clinical areas (nurse station, medication room) */
  MEDICAL: 'MEDICAL',
  /** Exterior areas (garden, courtyard, parking) */
  OUTDOOR: 'OUTDOOR',
  /** Living quarters organized by wing */
  RESIDENTIAL: 'RESIDENTIAL',
  /** Controlled access (medication storage, records) */
  RESTRICTED: 'RESTRICTED',
  /** Operational areas (kitchen, laundry, maintenance) */
  SERVICE: 'SERVICE',
} as const;

export type ZoneType = (typeof ZoneType)[keyof typeof ZoneType];
export type FhirStoredFieldsFragment = {
  __typename?: 'FhirStoredResourceType';
  resourceId: string;
  resourceType: string;
  tenantNum: number;
  fhirJson: string;
  version: number;
  versionOf?: string | null;
  isLatest: boolean;
  createdBy: string;
  createdAt: string;
  auditOperation: string;
};

export type WorkflowFieldsFragment = {
  __typename?: 'Workflow';
  id: string;
  name: string;
  displayName: string;
  version: string;
  description?: string | null;
  initialState: string;
  active: boolean;
  timeoutSeconds?: number | null;
  executionStrategy?: string | null;
  criticality: string;
  complianceLevel?: string | null;
  riskClassification?: string | null;
  complianceFrameworks: Array<string>;
  authorityId?: string | null;
  auditRequirements: Array<string>;
  jurisdictionalScope: Array<string>;
  effectiveDate?: string | null;
  expirationDate?: string | null;
  targetFormulas: Array<string>;
  lastInstantiatedAt?: string | null;
  instantiationCount: number;
  parentVersionId?: string | null;
  originalId?: string | null;
  metadata: Record<string, unknown>;
  recordVersion: number;
  isActive: boolean;
  compressedId?: string | null;
  auditInfo: {
    __typename?: 'WorkflowAuditInfo';
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
    version: number;
  };
  states: Array<{
    __typename?: 'WorkflowState';
    name: string;
    stateType: GqlStateType;
    entryActions: Array<string>;
    exitActions: Array<string>;
    timeoutSeconds?: number | null;
  }>;
  transitions: Array<{
    __typename?: 'WorkflowStateTransition';
    fromState: string;
    toState: string;
    event: string;
    guards: Array<string>;
    actions: Array<string>;
  }>;
  guards: Array<{
    __typename?: 'GuardEntry';
    name: string;
    expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
  }>;
  actions: Array<{
    __typename?: 'ActionEntry';
    name: string;
    definition: {
      __typename?: 'ActionDefinition';
      actionType: GqlActionType;
      configuration: Record<string, unknown>;
    };
  }>;
  retryPolicy?: {
    __typename?: 'WorkflowRetryPolicy';
    maxAttempts: number;
    backoffSeconds: number;
    backoffMultiplier: number;
  } | null;
  regulations: Array<{
    __typename?: 'Regulation';
    id: string;
    name: string;
    framework: string;
    requirement: string;
  }>;
  formulaCompletionRates: Array<{
    __typename?: 'FormulaMetricEntry';
    formulaName: string;
    value: number;
  }>;
  formulaAvgDurations: Array<{
    __typename?: 'FormulaDurationEntry';
    formulaName: string;
    durationSeconds: number;
  }>;
  recommendedExecutionStrategies: Array<{
    __typename?: 'FormulaStrategyEntry';
    formulaName: string;
    strategy: string;
  }>;
  formulaStateCounts: Array<{
    __typename?: 'FormulaStateCountEntry';
    formulaName: string;
    stateCount: number;
  }>;
  formulaErrorRates: Array<{
    __typename?: 'FormulaMetricEntry';
    formulaName: string;
    value: number;
  }>;
};

export type GuardEntryFieldsFragment = {
  __typename?: 'GuardEntry';
  name: string;
  expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
};

export type ConstraintFieldsFragment = {
  __typename?: 'Constraint';
  id: string;
  name: string;
  code: string;
  description?: string | null;
  constraintType: GqlConstraintType;
  monitoredEntityId?: string | null;
  monitoredEntityType?: string | null;
  limitValue: number;
  active: boolean;
  currentStatus: GqlConstraintStatus;
  currentUsage: number;
  operator: GqlConstraintOperator;
  unit: string;
  createdAt: string;
  updatedAt: string;
  scope: { __typename?: 'GqlConstraintScope'; scopeType: string; scopeId?: string | null };
};

export type DependencyFieldsFragment = {
  __typename?: 'Dependency';
  id: string;
  name: string;
  description?: string | null;
  dependencyType: GqlDependencyType;
  isConditional: boolean;
  status: GqlDependencyStatus;
  active: boolean;
  version: number;
};

export type FormSchemaFieldsFragment = {
  __typename?: 'FormSchema';
  subgraph: string;
  entityType: string;
  version: string;
  displayName: string;
  description?: string | null;
  safetyLevel: FormSafetyLevel;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type WorkItemFieldsFragment = {
  __typename?: 'WorkItem';
  id: string;
  domain: string;
  workflowType: string;
  status: WorkStatus;
  priority: WorkPriority;
  assignedTo?: string | null;
  title: string;
  createdAt: number;
  updatedAt: number;
  dueAt?: number | null;
  isOverdue: boolean;
  detailSk: string;
};

export type ActorFieldsFragment = {
  __typename?: 'Actor';
  id: string;
  name: string;
  authUserId?: string | null;
  actorType: GqlActorType;
  category?: string | null;
  domain?: string | null;
  description?: string | null;
  role?: string | null;
  primaryRoleId?: string | null;
  roleIds: Array<string>;
  resolvedScopes: Array<string>;
  configuration: Record<string, unknown>;
  circuitBreakerOpen: boolean;
  circuitBreakerThreshold: number;
  active: boolean;
  available: boolean;
  workload: number;
  maxCapacity: number;
  teamId?: string | null;
  supervisorId?: string | null;
  certifications: Array<string>;
  specializations: Array<string>;
  expertTier?: string | null;
  licenseNumber?: string | null;
  licenseJurisdiction?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type PolicyFieldsFragment = {
  __typename?: 'Policy';
  id: string;
  name: string;
  description?: string | null;
  policyType: GqlPolicyType;
  scope: GqlPolicyScope;
  implementation: GqlPolicyImplementation;
  enabled: boolean;
  active: boolean;
  auditLevel: GqlAuditLevel;
  version: number;
};

export type PermissionFieldsFragment = {
  __typename?: 'EffectivePermissions';
  roleId: string;
  ownPermissions: Array<{
    __typename?: 'Permission';
    resourceType: string;
    action: string;
    condition?: string | null;
    scope: GqlPermissionScope;
  }>;
  inheritedPermissions: Array<{
    __typename?: 'Permission';
    resourceType: string;
    action: string;
    condition?: string | null;
    scope: GqlPermissionScope;
  }>;
  effectivePermissions: Array<{
    __typename?: 'Permission';
    resourceType: string;
    action: string;
    condition?: string | null;
    scope: GqlPermissionScope;
  }>;
};

export type QueueFieldsFragment = {
  __typename?: 'Queue';
  id: string;
  queueName: string;
  queueType: GqlQueueType;
  capacity: number;
  currentSize: number;
  createdAt: string;
  updatedAt: string;
  assignedActorMap: Record<string, unknown>;
  eventTopic?: string | null;
  assignmentStrategy: GqlAssignmentStrategy;
  maxConcurrentAssignments: number;
  assignmentTimeoutSeconds: number;
  lastAssignmentAt?: string | null;
  avgWaitTimeSeconds: number;
  processingRatePerHour: number;
  itemsProcessedToday: number;
  oldestItemAgeSeconds: number;
  slaBreachCount: number;
  metricsCollectedCount: number;
  description: string;
  eligibilityRules: Array<string>;
  priorityRules: Array<string>;
  deduplicationEnabled: boolean;
  deduplicationWindowSeconds?: number | null;
  defaultPriority: number;
  priorityBoostEnabled: boolean;
  priorityBoostThresholdSeconds?: number | null;
  priorityBoostIncrement?: number | null;
  overflowStrategy: GqlOverflowStrategy;
  warningThresholdPercent: number;
  targetProcessingRatePerHour: number;
  targetAvgWaitTimeSeconds: number;
  performanceAlertEnabled: boolean;
  lastPerformanceCheckAt?: string | null;
  compressedId?: string | null;
  createdByActor?: {
    __typename?: 'ActorSummary';
    id: string;
    displayName: string;
    role?: string | null;
  } | null;
  updatedByActor?: {
    __typename?: 'ActorSummary';
    id: string;
    displayName: string;
    role?: string | null;
  } | null;
};

export type ScheduleFieldsFragment = {
  __typename?: 'Schedule';
  scheduleId: string;
  scheduleName: string;
  scheduleCode: string;
  cronExpression?: string | null;
  timezone: string;
  scheduleStatus: GqlScheduleStatus;
  scheduleType: GqlScheduleType;
  schedulePriority: GqlSchedulePriority;
  createdAt: string;
  updatedAt: string;
};

export type TaskFieldsFragment = {
  __typename?: 'Task';
  id: string;
  parentId?: string | null;
  name: string;
  description: string;
  taskType: GqlTaskType;
  assignedAt?: string | null;
  status: GqlTaskStatus;
  priority: GqlTaskPriority;
  startedAt?: string | null;
  completedAt?: string | null;
  createdAt: string;
  updatedAt?: string | null;
  version: number;
  metadata: Record<string, unknown>;
  sequenceOrder?: number | null;
  taskGroupRef?: string | null;
  dependencies: Array<string>;
  dependents: Array<string>;
  scheduledStart?: string | null;
  scheduledEnd?: string | null;
  dueAt?: string | null;
  estimatedDurationMs?: string | null;
  durationMs?: string | null;
  progressPercent?: number | null;
  errorMessage?: string | null;
  retryCount: number;
  maxRetries: number;
  failureStrategy: GqlFailureStrategy;
  createdBySource: GqlTaskCreatedBySource;
  mandateRef?: string | null;
  mandateJurisdiction?: string | null;
  mandateIsOverride?: boolean | null;
  mandateSourceUrl?: string | null;
  violationOutcome?: string | null;
  violationReviewDeadline?: string | null;
  toolHint?: string | null;
  assignedActorId?: string | null;
  subjectActorId?: string | null;
  teamActorId?: string | null;
  checkedOutBy?: string | null;
  checkoutExpiresAt?: string | null;
  mandates: Array<{
    __typename?: 'MandateInfo';
    rulesetId: string;
    rulesetName: string;
    jurisdictionLevel?: string | null;
    provisionRefs: Array<{
      __typename?: 'ProvisionRef';
      ruleId: string;
      sectionRef: string;
      description?: string | null;
    }>;
  }>;
  assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
};

export type StateFieldsFragment = {
  __typename?: 'WorkflowState';
  name: string;
  stateType: GqlStateType;
  timeoutSeconds?: number | null;
  entryActions: Array<string>;
  exitActions: Array<string>;
  policyRefs: Array<string>;
};

export type EventFieldsFragment = {
  __typename?: 'Event';
  id: string;
  eventName: string;
  eventType: GqlEventType;
  entityType: string;
  severity: GqlEventSeverity;
  category: GqlEventCategory;
  createdAt: string;
  performedAt: string;
};

export type SagaFieldsFragment = {
  __typename?: 'SagaDefinitionGQL';
  sagaId: string;
  description?: string | null;
  version: string;
  metadata: Record<string, unknown>;
};

export type DagNodeFieldsFragment = {
  __typename?: 'DAGNode';
  id: string;
  name: string;
  incomingDependencies: number;
  outgoingDependencies: number;
};

export type MetricFieldsFragment = {
  __typename?: 'GqlQueueStatistics';
  queueId: string;
  currentSize: number;
  avgWaitTimeSeconds: number;
  processingRatePerHour: number;
  slaBreachCount: number;
  utilizationPercent: number;
  isOverThreshold: boolean;
};

export type AlertFieldsFragment = {
  __typename?: 'SafetyEvent';
  eventId: string;
  severity: string;
  category: string;
  eventType: string;
  description: string;
  remediationStatus?: string | null;
  remediationRequired: boolean;
  createdAt: string;
  updatedAt: string;
};

export type AuditFieldsFragment = {
  __typename?: 'AuditQL';
  id: string;
  auditCode: string;
  auditName: string;
  actionTypes: Array<string>;
  complianceStatus: AuditComplianceStatus;
  frameworkType: GqlAuditFrameworkType;
  createdAt: string;
  updatedAt: string;
  version: number;
  parentId?: string | null;
  originalId?: string | null;
  isActive: boolean;
  compliancePeriodStart: string;
  compliancePeriodEnd: string;
  regulatoryQuestion: string;
  eventIds: Array<string>;
  eventCount: number;
  uniqueEventTypes: Array<string>;
  findingsSummary: string;
  violationsDetected: number;
  userIds: Array<string>;
  userActionCount: number;
  primitiveTypesAccessed: Array<string>;
  navigationPaths: Array<Array<string>>;
  timeSpentSeconds: Array<string>;
  accessPatterns: Record<string, unknown>;
  featuresUsed: Array<string>;
  featuresUnused: Array<string>;
  adoptionRatePercent: number;
  retentionYears: number;
  retentionExpiresAt: string;
  immutabilityRequired: boolean;
  signatureRequired: boolean;
  dataLineage: Record<string, unknown>;
  regulatoryFrameworks: Array<string>;
  reportFormat: GqlReportFormat;
  reportTemplateId: string;
  reportS3Url?: string | null;
  generatedByUserId: string;
  approvedByUserId?: string | null;
  approvalRequired: boolean;
  uniqueActors: number;
  uniqueEntities: number;
  uniqueWorkflows: number;
  aiGenerated: boolean;
  aiConfidence?: number | null;
  chaosExtractionId?: string | null;
  approvalWorkflowId?: string | null;
  previousAuditId?: string | null;
  subgraphReferences: Record<string, unknown>;
  lastValidationTimestamp?: string | null;
  createdByUserId: string;
  updatedBy?: string | null;
};

export type NotificationFieldsFragment = {
  __typename?: 'Notification';
  id: string;
  notificationTitle: string;
  messageTemplate: string;
  notificationType: GqlNotificationTriggerType;
  priority: GqlNotificationPriority;
  channels: Array<GqlNotificationChannel>;
  status: GqlNotificationStatus;
  createdAt: string;
  updatedAt: string;
  workflowInstanceId: string;
  primitiveType: string;
  version: number;
  parentId?: string | null;
  originalId?: string | null;
  isActive: boolean;
  recipientActorIds: Array<string>;
  ccActorIds: Array<string>;
  bccActorIds: Array<string>;
  triggerEventId: string;
  triggerEntityId: string;
  triggerEntityType: string;
  relatedTaskIds: Array<string>;
  relatedSlaIds: Array<string>;
  relatedApprovalIds: Array<string>;
  relatedTransactionIds: Array<string>;
  sentAt?: string | null;
  deliveredAt?: string | null;
  readAt?: string | null;
  deliveryAttempts: number;
  lastDeliveryError?: string | null;
  expiresAt?: string | null;
  complianceFrameworks: Array<string>;
  retentionUntil?: string | null;
  archived: boolean;
  compressedId?: string | null;
  createdByActor?: {
    __typename?: 'ActorSummary';
    id: string;
    displayName: string;
    role?: string | null;
  } | null;
  updatedByActor?: {
    __typename?: 'ActorSummary';
    id: string;
    displayName: string;
    role?: string | null;
  } | null;
};

export type ContractFieldsFragment = {
  __typename?: 'Contract';
  id: string;
  tenantId: string;
  slaName: string;
  slug?: string | null;
  externalId?: string | null;
  entityType: string;
  entityId: string;
  workflowInstanceId: string;
  notificationActorIds: Array<string>;
  notificationChannels: Array<string>;
  notificationAtPercent: Array<number>;
  startedAt?: string | null;
  currentStatus: GqlContractStatus;
  elapsedMinutes?: string | null;
  lastCheckedAt?: string | null;
  paused: boolean;
  responseTimeMinutes: string;
  resolutionTimeMinutes: string;
  warningThresholdPercent: number;
  escalateAfterMinutes: string;
  escalationChain: Array<string>;
  breachCount: string;
  complianceRate: number;
  lastBreachAt?: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  metadata: Record<string, unknown>;
  compressedId?: string | null;
};

export type RiskFieldsFragment = {
  __typename?: 'SafetyEvent';
  eventId: string;
  severity: string;
  category: string;
  eventType: string;
  description: string;
  remediationStatus?: string | null;
  createdAt: string;
};

export type EvidenceFieldsFragment = {
  __typename?: 'DocumentVersionInfo';
  documentId: string;
  version: string;
  changeDescription: string;
  createdAt: string;
  createdBy: string;
  isLatest: boolean;
};

export type VersionFieldsFragment = {
  __typename?: 'DocumentVersionInfo';
  documentId: string;
  version: string;
  changeDescription: string;
  createdAt: string;
  createdBy: string;
  isLatest: boolean;
};

export type GenerateIdResultFieldsFragment = {
  __typename?: 'GenerateIdResult';
  ids: Array<string>;
  entityType: IdBrokerEntityType;
  format: string;
};

export type RegulatoryRuleFieldsFragment = {
  __typename?: 'GqlRegulatoryRule';
  id: string;
  version: number;
  status: GqlRuleStatus;
  queue: GqlReviewQueue;
  text: string;
  supersedes?: string | null;
  changelog?: string | null;
  requiresHumanReview: boolean;
  createdBy: string;
  createdAt: string;
  reviewerId?: string | null;
  reviewedAt?: string | null;
  reviewComment?: string | null;
  rejectionReason?: string | null;
  conflictingRuleIds: Array<string>;
  structured: {
    __typename?: 'GqlStructuredRule';
    actor: string;
    action: string;
    trigger?: string | null;
    deadline?: string | null;
    evidence: Array<{
      __typename?: 'GqlEvidence';
      name: string;
      description: string;
      required: boolean;
      fhirResource?: string | null;
    }>;
    exceptions: Array<{
      __typename?: 'GqlException';
      condition: string;
      alternativeAction?: string | null;
    }>;
  };
  source: {
    __typename?: 'GqlRuleSource';
    effectiveDate: string;
    sunsetDate?: string | null;
    document: {
      __typename?: 'GqlSourceDocument';
      id: string;
      title: string;
      url?: string | null;
      version?: string | null;
    };
    location: {
      __typename?: 'GqlSourceLocation';
      section: string;
      subdivision?: string | null;
      paragraph?: string | null;
      page?: number | null;
    };
  };
  extraction: {
    __typename?: 'GqlExtractionMetadata';
    confidence: number;
    confidencePercentage: number;
    extractor?: string | null;
    extractedAt?: string | null;
    reviewedBy?: string | null;
    reviewedAt?: string | null;
  };
  classification: {
    __typename?: 'GqlClassification';
    safetyLevel: GqlSafetyLevel;
    complianceDomain: GqlComplianceDomain;
    piiImpact: boolean;
    tags: Array<string>;
  };
};

export type RuleImportResultFieldsFragment = {
  __typename?: 'GqlRuleImportResult';
  ruleId?: string | null;
  success: boolean;
  warnings: Array<string>;
  routeDecision?: {
    __typename?: 'GqlRouteDecision';
    queue: GqlReviewQueue;
    reason: string;
    confidence: number;
    safetyOverride: boolean;
    conflictsDetected: boolean;
    conflictingRuleIds: Array<string>;
  } | null;
  errors: Array<{ __typename?: 'GqlValidationError'; field: string; message: string }>;
};

export type BatchImportResultFieldsFragment = {
  __typename?: 'GqlBatchImportResult';
  importedCount: number;
  failedCount: number;
  autoApprovedCount: number;
  reviewRequiredCount: number;
  warnings: Array<string>;
  results: Array<{
    __typename?: 'GqlRuleImportResult';
    ruleId?: string | null;
    success: boolean;
    warnings: Array<string>;
    routeDecision?: {
      __typename?: 'GqlRouteDecision';
      queue: GqlReviewQueue;
      reason: string;
      confidence: number;
      safetyOverride: boolean;
      conflictsDetected: boolean;
      conflictingRuleIds: Array<string>;
    } | null;
    errors: Array<{ __typename?: 'GqlValidationError'; field: string; message: string }>;
  }>;
};

export type QueueStatsFieldsFragment = {
  __typename?: 'GqlQueueStats';
  total: number;
  autoApproved: number;
  confidenceReview: number;
  conflictReview: number;
  safetyReview: number;
  humanReviewPercentage: number;
};

export type TemplateFieldsFragment = {
  __typename?: 'Template';
  id: string;
  name: string;
  description?: string | null;
  category: string;
  status: GqlTemplateStatus;
  criticality: string;
  complianceLevel?: string | null;
  riskClassification?: string | null;
  active: boolean;
  version: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy?: string | null;
};

export type RoleFieldsFragment = {
  __typename?: 'Role';
  id: string;
  roleName: string;
  description?: string | null;
  roleCategory: GqlRoleCategory;
  permissionMode: GqlPermissionMode;
  active: boolean;
  version: number;
};

export type TeamFieldsFragment = {
  __typename?: 'Team';
  id: string;
  name: string;
  code: string;
  teamType: GqlTeamType;
  description?: string | null;
  active: boolean;
  level: number;
  path: string;
  parentTeamId?: string | null;
  teamLeadId?: string | null;
  deputyLeadId?: string | null;
  budgetAllocated?: number | null;
  stakeholderIds: Array<string>;
  createdAt: string;
  updatedAt: string;
};

export type ValidationFieldsFragment = {
  __typename?: 'Validation';
  id: string;
  name: string;
  code: string;
  description?: string | null;
  validationType: GqlValidationType;
  severity: GqlValidationSeverity;
  isBlocking: boolean;
  active: boolean;
  executionPhase: Array<GqlExecutionPhase>;
  createdAt: string;
  updatedAt: string;
};

export type InstanceFieldsFragment = {
  __typename?: 'Instance';
  id: string;
  workflowDefinitionId: string;
  instanceName?: string | null;
  workflowName: string;
  workflowDescription?: string | null;
  subjectName?: string | null;
  subjectActorId?: string | null;
  currentState: string;
  previousState?: string | null;
  status: GqlInstanceStatus;
  priority: number;
  engineType: GqlExecutionEngine;
  progressPercent: number;
  totalTasks: number;
  completedTasks: number;
  failedTasks: number;
  startedAt?: string | null;
  completedAt?: string | null;
  createdAt: string;
  updatedAt: string;
  version: number;
  parentId?: string | null;
  errorMessage?: string | null;
  errorCode?: string | null;
  failedTaskId?: string | null;
  tags: Array<string>;
  cpuTimeMs?: number | null;
  memoryPeakMb?: number | null;
  dbQueries: number;
  cacheHits: number;
  cacheMisses: number;
  availableTransitions: Array<{
    __typename?: 'GqlAvailableTransition';
    event: string;
    toState: string;
    displayName: string;
    guard?: string | null;
    guardPassed: boolean;
  }>;
};

export type ApprovalFieldsFragment = {
  __typename?: 'Approval';
  id: string;
  status: GqlApprovalStatus;
  decision?: GqlApprovalDecision | null;
  approvalType: GqlApprovalType;
  approvalStrategy: GqlApprovalStrategy;
  approverRole: string;
  createdAt: string;
  expiresAt?: string | null;
  decidedAt?: string | null;
  entityType?: string | null;
  updatedAt: string;
};

export type DocumentFieldsFragment = {
  __typename?: 'Document';
  documentId: string;
  documentName: string;
  documentType: DocumentType;
  category: string;
  currentStatus: DocumentStatus;
  mimeType: string;
  fileSizeBytes: string;
  storageType: StorageType;
  s3Key?: string | null;
  s3Bucket?: string | null;
  dynamodbContent?: string | null;
  createdAt: string;
  updatedAt: string;
  version: string;
  regulatoryRuleIds: Array<string>;
  regulatoryEvidenceName?: string | null;
};

export type TraceFieldsFragment = {
  __typename?: 'Trace';
  id: string;
  traceId: string;
  spanId: string;
  parentSpanId?: string | null;
  operationName: string;
  spanType: GqlTraceSpanType;
  durationMs?: number | null;
  startedAt: string;
  endedAt?: string | null;
  errorMessage?: string | null;
  createdAt: string;
};

export type CheckpointFieldsFragment = {
  __typename?: 'Checkpoint';
  id: string;
  checkpointName: string;
  checkpointType: GqlCheckpointType;
  currentStatus: GqlCheckpointStatus;
  snapshotFormat: GqlSnapshotFormat;
  entityType: string;
  isActive: boolean;
  canRollback: boolean;
  rollbackCount: number;
  rollbackStrategy: GqlRollbackStrategy;
  snapshotSizeBytes: number;
  snapshotEncrypted: boolean;
  compressionRatio: number;
  resumeEnabled: boolean;
  retentionDays: number;
  sequenceNumber: number;
  lastAccessedAt?: string | null;
  lastRollbackAt?: string | null;
  lastRollbackReason?: string | null;
  createdAt: string;
  updatedAt: string;
  accessCount: number;
  recoveryAttemptedAt?: string | null;
  recoverySuccess?: boolean | null;
  serializationDurationMs: number;
  stateSnapshot: Record<string, unknown>;
  snapshotChecksum: string;
  deltaFromPrevious?: Record<string, unknown> | null;
  autoArchiveAt?: string | null;
  resumeTimeoutSeconds: number;
  maxResumeAttempts: number;
  rollbackOrder: number;
  metadata: Record<string, unknown>;
  parentId?: string | null;
  originalId?: string | null;
  compressedId?: string | null;
  recoveredByActor?: {
    __typename?: 'ActorSummary';
    id: string;
    displayName: string;
    role?: string | null;
  } | null;
  createdByActor?: {
    __typename?: 'ActorSummary';
    id: string;
    displayName: string;
    role?: string | null;
  } | null;
};

export type TransactionFieldsFragment = {
  __typename?: 'Transaction';
  transactionId: string;
  transactionName: string;
  transactionCode: string;
  status: GqlTransactionStatus;
  isolationLevel: GqlIsolationLevel;
  totalSteps: number;
  currentStep: number;
  startedAt?: string | null;
  committedAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type AnalyticsFieldsFragment = {
  __typename?: 'Analytics';
  analyticsId: string;
  analyticsName: string;
  analyticsCode: string;
  metricType: MetricType;
  metricCategory: MetricCategory;
  metricUnit: MetricUnit;
  currentValue: number;
  previousValue: number;
  warningThreshold?: number | null;
  criticalThreshold?: number | null;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
};

export type ResourceFieldsFragment = {
  __typename?: 'Resource';
  resourceId: string;
  resourceName: string;
  resourceCode: string;
  resourceType: GqlResourceType;
  resourceCategory: string;
  resourceStatus: GqlResourceStatus;
  totalCapacity: number;
  availableCapacity: number;
  isLifeCriticalResource: boolean;
  createdAt: string;
  updatedAt: string;
};

export type IntegrationFieldsFragment = {
  __typename?: 'Integration';
  integrationId: string;
  integrationName: string;
  integrationCode: string;
  integrationType: IntegrationType;
  protocol: Protocol;
  baseUrl: string;
  currentHealthStatus: IntegrationHealthStatus;
  authType: AuthenticationType;
  circuitBreakerState: CircuitBreakerState;
  createdAt: string;
  updatedAt: string;
};

export type IsDslAvailableQueryVariables = Exact<{ [key: string]: never }>;

export type IsDslAvailableQuery = {
  __typename?: 'Query';
  isDslAvailable: {
    __typename?: 'DslAvailability';
    available: boolean;
    feature: string;
    message: string;
  };
};

export type GetDslSyntaxHelpQueryVariables = Exact<{ [key: string]: never }>;

export type GetDslSyntaxHelpQuery = {
  __typename?: 'Query';
  getDslSyntaxHelp: {
    __typename?: 'DslSyntaxHelp';
    version: string;
    builtinFields: Array<string>;
    builtinActions: Array<string>;
    syntaxReference: string;
    operators: Array<{
      __typename?: 'GqlOperatorInfo';
      symbol: string;
      name: string;
      example: string;
    }>;
    examples: Array<{
      __typename?: 'GqlDslExample';
      name: string;
      description: string;
      source: string;
    }>;
  };
};

export type CompileDslMutationVariables = Exact<{
  input: CompileDslInput;
}>;

export type CompileDslMutation = {
  __typename?: 'Mutation';
  compileDsl: {
    __typename?: 'DslCompilationResult';
    success: boolean;
    jdm?: string | null;
    ast?: string | null;
    ruleCount: number;
    inputFields: Array<string>;
    errors: Array<{
      __typename?: 'GqlCompileError';
      message: string;
      kind: GqlCompileErrorKind;
      line?: number | null;
      column?: number | null;
      ferpCode: string;
    }>;
  };
};

export type ValidateDslMutationVariables = Exact<{
  input: ValidateDslInput;
}>;

export type ValidateDslMutation = {
  __typename?: 'Mutation';
  validateDsl: {
    __typename?: 'DslValidationResult';
    valid: boolean;
    ruleCount: number;
    warnings: Array<string>;
    errors: Array<{
      __typename?: 'GqlCompileError';
      message: string;
      kind: GqlCompileErrorKind;
      line?: number | null;
      column?: number | null;
      ferpCode: string;
    }>;
    rulesSummary: Array<{
      __typename?: 'GqlRuleSummary';
      name?: string | null;
      actions: Array<string>;
      priority?: number | null;
      deadlineSeconds?: number | null;
      terminal: boolean;
      conditionCount: number;
    }>;
  };
};

export type ListPolicyRulesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  policyType?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPolicyRulesQuery = {
  __typename?: 'Query';
  listPolicyRules: Array<{
    __typename?: 'PolicyRule';
    policyId: string;
    tenantId: string;
    policyType: string;
    policyName: string;
    enabled: boolean;
    priority: number;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
    conditions: Array<{
      __typename?: 'PolicyCondition';
      field: string;
      operator: PolicyOperator;
      value: Record<string, unknown>;
    }>;
    actions: Array<{
      __typename?: 'PolicyAction';
      type: PolicyActionType;
      params: Record<string, unknown>;
    }>;
  }>;
};

export type GetPolicyRuleQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
}>;

export type GetPolicyRuleQuery = {
  __typename?: 'Query';
  getPolicyRule?: {
    __typename?: 'PolicyRule';
    policyId: string;
    tenantId: string;
    policyType: string;
    policyName: string;
    enabled: boolean;
    priority: number;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
    conditions: Array<{
      __typename?: 'PolicyCondition';
      field: string;
      operator: PolicyOperator;
      value: Record<string, unknown>;
    }>;
    actions: Array<{
      __typename?: 'PolicyAction';
      type: PolicyActionType;
      params: Record<string, unknown>;
    }>;
  } | null;
};

export type CreatePolicyRuleMutationVariables = Exact<{
  input: CreatePolicyRuleInput;
}>;

export type CreatePolicyRuleMutation = {
  __typename?: 'Mutation';
  createPolicyRule: {
    __typename?: 'PolicyRule';
    policyId: string;
    tenantId: string;
    policyType: string;
    policyName: string;
    enabled: boolean;
    priority: number;
    createdAt: string;
    createdBy: string;
  };
};

export type UpdatePolicyRuleMutationVariables = Exact<{
  input: UpdatePolicyRuleInput;
}>;

export type UpdatePolicyRuleMutation = {
  __typename?: 'Mutation';
  updatePolicyRule: {
    __typename?: 'PolicyRule';
    policyId: string;
    policyName: string;
    enabled: boolean;
    priority: number;
    updatedAt: string;
    updatedBy: string;
  };
};

export type ArchivePolicyRuleMutationVariables = Exact<{
  input: ArchivePolicyRuleInput;
}>;

export type ArchivePolicyRuleMutation = {
  __typename?: 'Mutation';
  archivePolicyRule: {
    __typename?: 'PolicyRuleArchiveResult';
    success: boolean;
    policyId: string;
    policyName: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
    message: string;
  };
};

export type DryRunPolicyMutationVariables = Exact<{
  input: DryRunPolicyInput;
}>;

export type DryRunPolicyMutation = {
  __typename?: 'Mutation';
  dryRunPolicy: {
    __typename?: 'DryRunResult';
    policyId: string;
    matched: boolean;
    zenDsl: string;
    conditionsEvaluated: Array<{
      __typename?: 'ConditionEvaluation';
      matched: boolean;
      reason?: string | null;
      condition: {
        __typename?: 'PolicyCondition';
        field: string;
        operator: PolicyOperator;
        value: Record<string, unknown>;
      };
    }>;
    actionsToExecute: Array<{
      __typename?: 'PolicyAction';
      type: PolicyActionType;
      params: Record<string, unknown>;
    }>;
  };
};

export type ListPolicyTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type ListPolicyTemplatesQuery = {
  __typename?: 'Query';
  listPolicyTemplates: Array<{
    __typename?: 'PolicyTemplate';
    templateId: string;
    templateName: string;
    description: string;
    category: PolicyTemplateCategory;
    policyType: string;
    defaultPriority: number;
    useCases: Array<string>;
    tags: Array<string>;
    version: number;
    createdAt: string;
    createdBy: string;
    isActive: boolean;
    conditionTemplate: Array<{
      __typename?: 'PolicyConditionTemplate';
      field: string;
      operator: string;
      valueTemplate: Record<string, unknown>;
      description: string;
    }>;
    actionTemplate: Array<{
      __typename?: 'PolicyActionTemplate';
      actionType: string;
      paramsTemplate: Record<string, unknown>;
      description: string;
    }>;
    parameters: Array<{
      __typename?: 'TemplateParameter';
      name: string;
      paramType: ParameterType;
      defaultValue: Record<string, unknown>;
      description: string;
      validation?: Record<string, unknown> | null;
    }>;
  }>;
};

export type ListTemplatesByCategoryQueryVariables = Exact<{
  category: PolicyTemplateCategory;
}>;

export type ListTemplatesByCategoryQuery = {
  __typename?: 'Query';
  listTemplatesByCategory: Array<{
    __typename?: 'PolicyTemplate';
    templateId: string;
    templateName: string;
    description: string;
    category: PolicyTemplateCategory;
    policyType: string;
    defaultPriority: number;
    useCases: Array<string>;
    tags: Array<string>;
    version: number;
    isActive: boolean;
    parameters: Array<{
      __typename?: 'TemplateParameter';
      name: string;
      paramType: ParameterType;
      defaultValue: Record<string, unknown>;
      description: string;
    }>;
  }>;
};

export type GetPolicyTemplateQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;

export type GetPolicyTemplateQuery = {
  __typename?: 'Query';
  getPolicyTemplate?: {
    __typename?: 'PolicyTemplate';
    templateId: string;
    templateName: string;
    description: string;
    category: PolicyTemplateCategory;
    policyType: string;
    defaultPriority: number;
    useCases: Array<string>;
    tags: Array<string>;
    version: number;
    createdAt: string;
    createdBy: string;
    isActive: boolean;
    conditionTemplate: Array<{
      __typename?: 'PolicyConditionTemplate';
      field: string;
      operator: string;
      valueTemplate: Record<string, unknown>;
      description: string;
    }>;
    actionTemplate: Array<{
      __typename?: 'PolicyActionTemplate';
      actionType: string;
      paramsTemplate: Record<string, unknown>;
      description: string;
    }>;
    parameters: Array<{
      __typename?: 'TemplateParameter';
      name: string;
      paramType: ParameterType;
      defaultValue: Record<string, unknown>;
      description: string;
      validation?: Record<string, unknown> | null;
    }>;
  } | null;
};

export type ListTemplateInstancesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type ListTemplateInstancesQuery = {
  __typename?: 'Query';
  listTemplateInstances: Array<{
    __typename?: 'PolicyTemplateInstance';
    instanceId: string;
    templateId: string;
    tenantId: string;
    instanceName: string;
    parameterValues: Record<string, unknown>;
    policyRuleId: string;
    createdAt: string;
    createdBy: string;
    isActive: boolean;
  }>;
};

export type InstantiateTemplateMutationVariables = Exact<{
  input: InstantiateTemplateInput;
}>;

export type InstantiateTemplateMutation = {
  __typename?: 'Mutation';
  instantiateTemplate: {
    __typename?: 'PolicyTemplateInstance';
    instanceId: string;
    templateId: string;
    tenantId: string;
    instanceName: string;
    parameterValues: Record<string, unknown>;
    policyRuleId: string;
    createdAt: string;
    createdBy: string;
    isActive: boolean;
  };
};

export type BootstrapSystemTemplatesMutationVariables = Exact<{ [key: string]: never }>;

export type BootstrapSystemTemplatesMutation = {
  __typename?: 'Mutation';
  bootstrapSystemTemplates: boolean;
};

export type GetLlmFixRecommendationQueryVariables = Exact<{
  recommendationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type GetLlmFixRecommendationQuery = {
  __typename?: 'Query';
  getLlmFixRecommendation?: {
    __typename?: 'LLMFixRecommendation';
    recommendationId: string;
    originalTemplateId: string;
    confidence: number;
    reasoning: string;
    diff: string;
    llmModel: string;
    status: string;
    createdAt: string;
    createdBy: string;
    appliedAt?: string | null;
    appliedBy?: string | null;
    suggestedFixes: Array<{
      __typename?: 'TemplateFix';
      fieldId: string;
      stepId: string;
      fixType: string;
      before: string;
      after: string;
      reasoning: string;
      confidence: number;
    }>;
  } | null;
};

export type ListLlmFixRecommendationsQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type ListLlmFixRecommendationsQuery = {
  __typename?: 'Query';
  listLlmFixRecommendations: Array<{
    __typename?: 'LLMFixRecommendation';
    recommendationId: string;
    confidence: number;
    status: string;
    createdAt: string;
  }>;
};

export type RequestLlmFixMutationVariables = Exact<{
  input: RequestLlmFixInput;
}>;

export type RequestLlmFixMutation = {
  __typename?: 'Mutation';
  requestLlmFix: {
    __typename?: 'LLMFixRecommendation';
    recommendationId: string;
    originalTemplateId: string;
    confidence: number;
    reasoning: string;
    diff: string;
    llmModel: string;
    status: string;
    createdAt: string;
    createdBy: string;
    suggestedFixes: Array<{
      __typename?: 'TemplateFix';
      fieldId: string;
      stepId: string;
      fixType: string;
      before: string;
      after: string;
      reasoning: string;
      confidence: number;
    }>;
  };
};

export type ApplyLlmFixMutationVariables = Exact<{
  input: ApplyLlmFixInput;
}>;

export type ApplyLlmFixMutation = {
  __typename?: 'Mutation';
  applyLlmFix: {
    __typename?: 'ApplyFixResult';
    templateId: string;
    fixesApplied: number;
    validationPassed: boolean;
    remainingViolations: Array<string>;
    updatedTemplate?: string | null;
  };
};

export type RejectLlmFixMutationVariables = Exact<{
  input: RejectLlmFixInput;
}>;

export type RejectLlmFixMutation = { __typename?: 'Mutation'; rejectLlmFix: boolean };

export type GetApprovalWorkflowInstanceQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;

export type GetApprovalWorkflowInstanceQuery = {
  __typename?: 'Query';
  getApprovalWorkflowInstance?: {
    __typename?: 'ApprovalWorkflowInstance';
    instanceId: string;
    templateId: string;
    templateVersion: string;
    tenant: string;
    domain: string;
    criticality: string;
    status: ApprovalStatus;
    dualControlRequired: boolean;
    deadline: string;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
    requiredApprovers: Array<{ __typename?: 'ApproverSpec'; role: string; requiredCount: number }>;
    decisions: Array<{
      __typename?: 'ApprovalDecision';
      decisionId: string;
      approverId: string;
      approverName: string;
      approverRole: string;
      decisionType: DecisionType;
      comments?: string | null;
      decidedAt: string;
      revisionItems: Array<{
        __typename?: 'RevisionItem';
        fieldId: string;
        issue: string;
        suggestedFix?: string | null;
      }>;
    }>;
  } | null;
};

export type ListPendingDslApprovalsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  approverId: Scalars['String']['input'];
}>;

export type ListPendingDslApprovalsQuery = {
  __typename?: 'Query';
  listPendingApprovals: Array<{
    __typename?: 'ApprovalWorkflowInstance';
    instanceId: string;
    templateId: string;
    templateVersion: string;
    tenant: string;
    domain: string;
    criticality: string;
    status: ApprovalStatus;
    createdAt: string;
    createdBy: string;
    requiredApprovers: Array<{ __typename?: 'ApproverSpec'; role: string; requiredCount: number }>;
  }>;
};

export type GetTemplatePublicationStatusQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;

export type GetTemplatePublicationStatusQuery = {
  __typename?: 'Query';
  getTemplatePublicationStatus: PublicationStatus;
};

export type ApproveRecommendationMutationVariables = Exact<{
  decision: ApprovalDecisionGql;
}>;

export type ApproveRecommendationMutation = {
  __typename?: 'Mutation';
  approveRecommendation: boolean;
};

export type SaveDraftMutationVariables = Exact<{
  input: SaveDraftInput;
}>;

export type SaveDraftMutation = {
  __typename?: 'Mutation';
  saveDraft: { __typename?: 'SaveResult'; ok: boolean; key: string };
};

export type DiscardDraftMutationVariables = Exact<{
  draftId: Scalars['String']['input'];
}>;

export type DiscardDraftMutation = { __typename?: 'Mutation'; llmWorkflowDiscardDraft: boolean };

export type DeleteDraftMutationVariables = Exact<{
  input: DeleteDraftInput;
}>;

export type DeleteDraftMutation = { __typename?: 'Mutation'; deleteDraft: boolean };

export type DeleteDraftManyMutationVariables = Exact<{
  input: DeleteDraftManyInput;
}>;

export type DeleteDraftManyMutation = { __typename?: 'Mutation'; deleteDraftMany: number };

export type SaveFormSchemaOverrideMutationVariables = Exact<{
  input: FormSchemaOverrideInput;
}>;

export type SaveFormSchemaOverrideMutation = {
  __typename?: 'Mutation';
  saveFormSchemaOverride: {
    __typename?: 'FormSchemaOverride';
    tenantId: string;
    subgraph: string;
    entityType: string;
    displayName?: string | null;
    description?: string | null;
    hiddenFields?: Array<string> | null;
    readonlyFields?: Array<string> | null;
    labelOverrides?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    customFields?: Array<{
      __typename?: 'FormFieldDefinition';
      name: string;
      path: string;
      fieldType: FormFieldType;
      label: string;
      required: boolean;
      placeholder?: string | null;
      helpText?: string | null;
    }> | null;
    customValidations?: Array<{
      __typename?: 'FormValidationRule';
      id: string;
      expression: string;
      message: string;
    }> | null;
  };
};

export type DeleteFormSchemaOverrideMutationVariables = Exact<{
  subgraph: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
}>;

export type DeleteFormSchemaOverrideMutation = {
  __typename?: 'Mutation';
  deleteFormSchemaOverride: boolean;
};

export type PublishTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;

export type PublishTemplateMutation = {
  __typename?: 'Mutation';
  templateApiPublishTemplate: {
    __typename?: 'Template';
    id: string;
    name: string;
    version: string;
    status: GqlTemplateStatus;
    publishedBy?: string | null;
    publishedAt?: string | null;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type ExportTemplateMutationVariables = Exact<{
  input: ExportTemplateInput;
}>;

export type ExportTemplateMutation = {
  __typename?: 'Mutation';
  exportTemplate: {
    __typename?: 'TemplateExportData';
    exportVersion: string;
    template: Record<string, unknown>;
    metadata: { __typename?: 'ExportMetadata'; exportedAt: string; exportedBy: string };
  };
};

export type ImportTemplateMutationVariables = Exact<{
  input: ImportTemplateInput;
}>;

export type ImportTemplateMutation = {
  __typename?: 'Mutation';
  importTemplate: {
    __typename?: 'ImportResult';
    success: boolean;
    templateId: string;
    templateVersion: string;
    warnings: Array<string>;
  };
};

export type ApproveTerminologyOverrideMutationVariables = Exact<{
  definitionId: Scalars['String']['input'];
  rationale: Scalars['String']['input'];
}>;

export type ApproveTerminologyOverrideMutation = {
  __typename?: 'Mutation';
  approveTerminologyOverride: {
    __typename?: 'StoredTerminologyOverride';
    definitionId: string;
    proposedTerm: string;
    classification: OverrideClassification;
    status: OverrideStatus;
    rationale?: string | null;
    requestedBy: string;
    requestedAt: string;
    decidedBy?: string | null;
    decidedAt?: string | null;
    decisionRationale?: string | null;
    violatedConstraint?: string | null;
    expiresAt?: string | null;
  };
};

export type AppendTransitionMutationVariables = Exact<{
  input: AppendTransitionInput;
}>;

export type AppendTransitionMutation = { __typename?: 'Mutation'; appendTransition: boolean };

export type GenerateIdMutationVariables = Exact<{
  input: GenerateIdInput;
}>;

export type GenerateIdMutation = {
  __typename?: 'Mutation';
  generateId: {
    __typename?: 'GenerateIdResult';
    ids: Array<string>;
    entityType: IdBrokerEntityType;
    format: string;
  };
};

export type CreateWorkflowMutationVariables = Exact<{
  input: GqlCreateWorkflowInput;
}>;

export type CreateWorkflowMutation = {
  __typename?: 'Mutation';
  createWorkflow: {
    __typename?: 'Workflow';
    id: string;
    name: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
  };
};

export type CreateConstraintMutationVariables = Exact<{
  input: GqlCreateConstraintInput;
}>;

export type CreateConstraintMutation = {
  __typename?: 'Mutation';
  createConstraint: {
    __typename?: 'Constraint';
    id: string;
    name: string;
    code: string;
    constraintType: GqlConstraintType;
    active: boolean;
    createdAt: string;
  };
};

export type CreateDependencyMutationVariables = Exact<{
  input: CreateDependencyInput;
}>;

export type CreateDependencyMutation = {
  __typename?: 'Mutation';
  dependencyApiCreateDependency: {
    __typename?: 'Dependency';
    id: string;
    dependencyType: GqlDependencyType;
    status: GqlDependencyStatus;
  };
};

export type ArchiveDependencyMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  dependencyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveDependencyMutation = {
  __typename?: 'Mutation';
  dependencyApiArchiveDependency: {
    __typename?: 'DependencyArchiveResult';
    success: boolean;
    message: string;
    dependencyId: string;
    dependencyName: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
  };
};

export type CreateFormSchemaMutationVariables = Exact<{
  input: FormSchemaInput;
}>;

export type CreateFormSchemaMutation = {
  __typename?: 'Mutation';
  createFormSchema: {
    __typename?: 'FormSchema';
    subgraph: string;
    entityType: string;
    version: string;
    createdAt?: string | null;
  };
};

export type UpdateFormSchemaMutationVariables = Exact<{
  input: FormSchemaInput;
}>;

export type UpdateFormSchemaMutation = {
  __typename?: 'Mutation';
  updateFormSchema: {
    __typename?: 'FormSchema';
    subgraph: string;
    entityType: string;
    version: string;
    updatedAt?: string | null;
  };
};

export type EditFormSchemaMutationVariables = Exact<{
  input: EditFormSchemaInput;
}>;

export type EditFormSchemaMutation = {
  __typename?: 'Mutation';
  editFormSchema: {
    __typename?: 'ComposeWorkflowResponse';
    response: string;
    turnCount: number;
    sessionMessages: Record<string, unknown>;
    stopReason: string;
    usage: { __typename?: 'AgentUsageInfo'; inputTokens: number; outputTokens: number };
  };
};

export type SuggestFieldsMutationVariables = Exact<{
  input: FieldSuggestionInput;
}>;

export type SuggestFieldsMutation = {
  __typename?: 'Mutation';
  suggestFields: {
    __typename?: 'FieldSuggestionResponse';
    primitiveType: string;
    contextId?: string | null;
    provider: string;
    totalFieldsConsidered: number;
    suggestions: Array<{
      __typename?: 'FieldSuggestion';
      fieldName: string;
      ringId: string;
      reasoning: string;
      relevance: number;
      critical: boolean;
    }>;
  };
};

export type CreateActorMutationVariables = Exact<{
  input: GqlCreateActorInput;
}>;

export type CreateActorMutation = {
  __typename?: 'Mutation';
  createActor: {
    __typename?: 'Actor';
    id: string;
    tenantId: string;
    name: string;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    createdAt: string;
  };
};

export type UpdateActorMutationVariables = Exact<{
  actorId: Scalars['String']['input'];
  input: GqlUpdateActorInput;
}>;

export type UpdateActorMutation = {
  __typename?: 'Mutation';
  updateActor: {
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type ArchiveActorMutationVariables = Exact<{
  actorId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveActorMutation = {
  __typename?: 'Mutation';
  archiveActor: {
    __typename?: 'ActorArchiveResult';
    success: boolean;
    message: string;
    actorId: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
  };
};

export type CreatePolicyMutationVariables = Exact<{
  input: CreatePolicyInput;
}>;

export type CreatePolicyMutation = {
  __typename?: 'Mutation';
  createPolicy: {
    __typename?: 'Policy';
    id: string;
    name: string;
    description?: string | null;
    policyType: GqlPolicyType;
    enabled: boolean;
  };
};

export type CreateQueueMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  input: GqlCreateQueueInput;
}>;

export type CreateQueueMutation = {
  __typename?: 'Mutation';
  createQueue: { __typename?: 'Queue'; id: string; queueName: string; createdAt: string };
};

export type ArchiveQueueMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveQueueMutation = {
  __typename?: 'Mutation';
  archiveQueue: {
    __typename?: 'QueueArchiveResult';
    success: boolean;
    message: string;
    queueId: string;
    queueName: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
  };
};

export type CreateScheduleMutationVariables = Exact<{
  input: GqlCreateScheduleInput;
}>;

export type CreateScheduleMutation = {
  __typename?: 'Mutation';
  createSchedule: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    scheduleStatus: GqlScheduleStatus;
    createdAt: string;
  };
};

export type ArchiveScheduleMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveScheduleMutation = {
  __typename?: 'Mutation';
  archiveSchedule: {
    __typename?: 'ScheduleArchiveResult';
    success: boolean;
    message: string;
    scheduleId: string;
    scheduleName: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
  };
};

export type CreateTaskMutationVariables = Exact<{
  input: GqlCreateTaskInput;
}>;

export type CreateTaskMutation = {
  __typename?: 'Mutation';
  taskApiCreateTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    description: string;
    taskType: GqlTaskType;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    createdAt: string;
    createdBySource: GqlTaskCreatedBySource;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
  };
};

export type AssignTaskMutationVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  input: AssignTaskInput;
}>;

export type AssignTaskMutation = {
  __typename?: 'Mutation';
  taskApiAssignTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    assignedActorId?: string | null;
    assignedAt?: string | null;
    status: GqlTaskStatus;
  };
};

export type StartTaskMutationVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;

export type StartTaskMutation = {
  __typename?: 'Mutation';
  taskApiStartTask: {
    __typename?: 'Task';
    id: string;
    status: GqlTaskStatus;
    startedAt?: string | null;
  };
};

export type CompleteTaskMutationVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  input: GqlCompleteTaskInput;
}>;

export type CompleteTaskMutation = {
  __typename?: 'Mutation';
  taskApiCompleteTask: {
    __typename?: 'Task';
    id: string;
    status: GqlTaskStatus;
    completedAt?: string | null;
  };
};

export type FailTaskMutationVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  input: GqlFailTaskInput;
}>;

export type FailTaskMutation = {
  __typename?: 'Mutation';
  taskApiFailTask: {
    __typename?: 'Task';
    id: string;
    status: GqlTaskStatus;
    errorMessage?: string | null;
  };
};

export type ClaimTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ClaimTaskMutation = {
  __typename?: 'Mutation';
  claimTask?: {
    __typename?: 'InboxTask';
    id: string;
    entityRef: string;
    title: string;
    kind: TaskKind;
    status: TaskStatus;
    dueAt?: string | null;
    requiresMfa: boolean;
    assignees: Array<string>;
    watchers: Array<string>;
    deepLink?: string | null;
  } | null;
};

export type AssignTaskToActorMutationVariables = Exact<{
  actorId: Scalars['String']['input'];
  input: GqlAssignTaskToActorInput;
}>;

export type AssignTaskToActorMutation = {
  __typename?: 'Mutation';
  assignTaskToActor: {
    __typename?: 'Actor';
    id: string;
    name: string;
    actorType: GqlActorType;
    status: GqlActorStatus;
    available: boolean;
    assignedTaskIds: Array<string>;
  };
};

export type CompleteTasksByToolHintMutationVariables = Exact<{
  toolHint: Scalars['String']['input'];
}>;

export type CompleteTasksByToolHintMutation = {
  __typename?: 'Mutation';
  taskApiCompleteTasksByToolHint: number;
};

export type RescheduleTaskMutationVariables = Exact<{
  input: GqlRescheduleTaskInput;
}>;

export type RescheduleTaskMutation = {
  __typename?: 'Mutation';
  taskApiRescheduleTask: {
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type AcknowledgeElopementAlertMutationVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  alertId: Scalars['String']['input'];
  acknowledgedBy: Scalars['String']['input'];
}>;

export type AcknowledgeElopementAlertMutation = {
  __typename?: 'Mutation';
  acknowledgeElopementAlert?: {
    __typename?: 'ElopementAlert';
    alertId: string;
    acknowledged: boolean;
    acknowledgedBy?: string | null;
    acknowledgedAt?: string | null;
  } | null;
};

export type ResolveSyncConflictMutationVariables = Exact<{
  input: ResolveSyncConflictInput;
}>;

export type ResolveSyncConflictMutation = {
  __typename?: 'Mutation';
  resolveSyncConflict: {
    __typename?: 'ConflictResolution';
    conflictId: string;
    resolvedAt: string;
    resolvedBy: string;
    status: GqlConflictStatus;
  };
};

export type CreateEventMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  input: GqlCreateEventInput;
}>;

export type CreateEventMutation = {
  __typename?: 'Mutation';
  eventApiCreateEvent: {
    __typename?: 'Event';
    id: string;
    eventName: string;
    eventType: GqlEventType;
    entityType: string;
    createdAt: string;
  };
};

export type ArchiveEventsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  olderThan: Scalars['DateTime']['input'];
}>;

export type ArchiveEventsMutation = { __typename?: 'Mutation'; eventApiArchiveEvents: number };

export type StartSagaMutationVariables = Exact<{
  input: StartSagaInput;
}>;

export type StartSagaMutation = {
  __typename?: 'Mutation';
  startSaga: {
    __typename?: 'SagaExecutionResponse';
    executionId: string;
    sagaId: string;
    status: SagaExecutionStatus;
    startedAt: string;
    currentState: string;
  };
};

export type ExecuteDagWorkflowMutationVariables = Exact<{
  input: ExecuteDagWorkflowInput;
}>;

export type ExecuteDagWorkflowMutation = {
  __typename?: 'Mutation';
  executeDagWorkflow: {
    __typename?: 'DagexecutionResponse';
    success: boolean;
    executionId: string;
    message: string;
    result?: {
      __typename?: 'DagexecutionResultGQL';
      executionId: string;
      workflowId: string;
      status: DagexecutionStatusEnum;
      totalNodes: number;
      completedNodes: number;
      failedNodes: number;
      startedAt: string;
      completedAt?: string | null;
    } | null;
  };
};

export type CancelDagExecutionMutationVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;

export type CancelDagExecutionMutation = {
  __typename?: 'Mutation';
  cancelDagExecution: {
    __typename?: 'DagstateTransitionResponse';
    success: boolean;
    executionId: string;
    newStatus: DagexecutionStatusEnum;
    message: string;
    timestamp: string;
  };
};

export type StageSafetyEventMutationVariables = Exact<{
  input: CreateSafetyEventInput;
}>;

export type StageSafetyEventMutation = {
  __typename?: 'Mutation';
  stageSafetyEvent: {
    __typename?: 'SafetyEvent';
    eventId: string;
    tenantId: string;
    severity: string;
    category: string;
    eventType: string;
    createdAt: string;
  };
};

export type CreateAuditMutationVariables = Exact<{
  input: CreateAuditInput;
}>;

export type CreateAuditMutation = {
  __typename?: 'Mutation';
  createAudit: {
    __typename?: 'AuditQL';
    id: string;
    auditCode: string;
    auditName: string;
    createdAt: string;
    complianceStatus: AuditComplianceStatus;
  };
};

export type ArchiveAuditMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveAuditMutation = {
  __typename?: 'Mutation';
  archiveAudit: {
    __typename?: 'AuditArchiveResultQL';
    success: boolean;
    message: string;
    auditId: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
  };
};

export type CreateNotificationMutationVariables = Exact<{
  input: GqlCreateNotificationInput;
}>;

export type CreateNotificationMutation = {
  __typename?: 'Mutation';
  createNotification: {
    __typename?: 'Notification';
    id: string;
    notificationTitle: string;
    notificationType: GqlNotificationTriggerType;
    priority: GqlNotificationPriority;
    createdAt: string;
  };
};

export type ArchiveNotificationMutationVariables = Exact<{
  notificationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveNotificationMutation = {
  __typename?: 'Mutation';
  archiveNotification: {
    __typename?: 'NotificationArchiveResult';
    success: boolean;
    message: string;
    notificationId: string;
    notificationTitle: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
  };
};

export type GenerateEvidenceReportMutationVariables = Exact<{
  input: GenerateEvidenceReportInput;
}>;

export type GenerateEvidenceReportMutation = {
  __typename?: 'Mutation';
  generateEvidenceReport: {
    __typename?: 'EvidenceReportGql';
    reportId: string;
    tenantId: string;
    residentId: string;
    residentName: string;
    assessmentDate: string;
    reportDate: string;
    evidenceStartDate: string;
    evidenceEndDate: string;
    recommendation: ReportRecommendationGql;
    coverageDisclosure: string;
    generatedBy: string;
    generatedAt: string;
  };
};

export type PauseAccumulatorMutationVariables = Exact<{
  input: PauseAccumulatorInput;
}>;

export type PauseAccumulatorMutation = {
  __typename?: 'Mutation';
  pauseAccumulator: {
    __typename?: 'AccumulatorSummaryGql';
    residentId: string;
    status: AccumulationStatusGql;
    totalFields: number;
    fieldsWithDrift: number;
    majorDriftFields: number;
    avgConfidence: number;
    daysSinceAssessment: number;
    lastUpdated: string;
  };
};

export type ResumeAccumulatorMutationVariables = Exact<{
  input: ResumeAccumulatorInput;
}>;

export type ResumeAccumulatorMutation = {
  __typename?: 'Mutation';
  resumeAccumulator: {
    __typename?: 'AccumulatorSummaryGql';
    residentId: string;
    status: AccumulationStatusGql;
    totalFields: number;
    fieldsWithDrift: number;
    majorDriftFields: number;
    avgConfidence: number;
    daysSinceAssessment: number;
    lastUpdated: string;
  };
};

export type CreateContractMutationVariables = Exact<{
  input: GqlCreateContractInput;
}>;

export type CreateContractMutation = {
  __typename?: 'Mutation';
  createContract: {
    __typename?: 'Contract';
    id: string;
    tenantId: string;
    slaName: string;
    slug?: string | null;
    entityType: string;
    entityId: string;
    currentStatus: GqlContractStatus;
    createdAt: string;
  };
};

export type ArchiveContractMutationVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveContractMutation = {
  __typename?: 'Mutation';
  archiveContract: {
    __typename?: 'ContractArchiveResult';
    success: boolean;
    message: string;
    contractId: string;
    contractName: string;
    archivedAt: string;
    archivedBy: string;
    reason: string;
  };
};

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;

export type CreateDocumentMutation = {
  __typename?: 'Mutation';
  documentApiCreateDocument: {
    __typename?: 'Document';
    documentId: string;
    documentName: string;
    documentType: DocumentType;
    mimeType: string;
    fileSizeBytes: string;
    description?: string | null;
    currentStatus: DocumentStatus;
    s3Key?: string | null;
    createdAt: string;
  };
};

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;

export type DeleteDocumentMutation = {
  __typename?: 'Mutation';
  documentApiDeleteDocument: {
    __typename?: 'Document';
    documentId: string;
    documentName: string;
    currentStatus: DocumentStatus;
  };
};

export type CreateDocumentVersionMutationVariables = Exact<{
  input: CreateDocumentVersionInput;
}>;

export type CreateDocumentVersionMutation = {
  __typename?: 'Mutation';
  documentApiCreateDocumentVersion: {
    __typename?: 'Document';
    documentId: string;
    fileSizeBytes: string;
    currentStatus: DocumentStatus;
    createdAt: string;
  };
};

export type ArchiveDocumentMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;

export type ArchiveDocumentMutation = {
  __typename?: 'Mutation';
  documentApiArchiveDocument: {
    __typename?: 'Document';
    documentId: string;
    fileSizeBytes: string;
  };
};

export type SignDocumentMutationVariables = Exact<{
  input: SignDocumentInput;
}>;

export type SignDocumentMutation = {
  __typename?: 'Mutation';
  documentApiSignDocument: {
    __typename?: 'SignDocumentResult';
    success: boolean;
    signedS3Key?: string | null;
    auditEventId: string;
    message: string;
    document?: {
      __typename?: 'Document';
      documentId: string;
      documentName: string;
      documentType: DocumentType;
      category: string;
      currentStatus: DocumentStatus;
      mimeType: string;
      fileSizeBytes: string;
      storageType: StorageType;
      s3Key?: string | null;
      s3Bucket?: string | null;
      dynamodbContent?: string | null;
      createdAt: string;
      updatedAt: string;
      version: string;
      regulatoryRuleIds: Array<string>;
      regulatoryEvidenceName?: string | null;
    } | null;
  };
};

export type MergeDocumentsMutationVariables = Exact<{
  input: MergeDocumentsInput;
}>;

export type MergeDocumentsMutation = {
  __typename?: 'Mutation';
  documentApiMergeDocuments: {
    __typename?: 'MergeDocumentsResult';
    success: boolean;
    auditEventId: string;
    message: string;
    document?: {
      __typename?: 'Document';
      documentId: string;
      documentName: string;
      documentType: DocumentType;
      category: string;
      currentStatus: DocumentStatus;
      mimeType: string;
      fileSizeBytes: string;
      storageType: StorageType;
      s3Key?: string | null;
      s3Bucket?: string | null;
      dynamodbContent?: string | null;
      createdAt: string;
      updatedAt: string;
      version: string;
      regulatoryRuleIds: Array<string>;
      regulatoryEvidenceName?: string | null;
    } | null;
  };
};

export type SavePdfAnnotationsMutationVariables = Exact<{
  input: SavePdfAnnotationsInput;
}>;

export type SavePdfAnnotationsMutation = {
  __typename?: 'Mutation';
  documentApiSavePdfAnnotations: {
    __typename?: 'Document';
    documentId: string;
    documentName: string;
    documentType: DocumentType;
    category: string;
    currentStatus: DocumentStatus;
    mimeType: string;
    fileSizeBytes: string;
    storageType: StorageType;
    s3Key?: string | null;
    s3Bucket?: string | null;
    dynamodbContent?: string | null;
    createdAt: string;
    updatedAt: string;
    version: string;
    regulatoryRuleIds: Array<string>;
    regulatoryEvidenceName?: string | null;
  };
};

export type EncryptDocumentMutationVariables = Exact<{
  input: EncryptDocumentInput;
}>;

export type EncryptDocumentMutation = {
  __typename?: 'Mutation';
  encryptDocument: {
    __typename?: 'EncryptDocumentResult';
    success: boolean;
    encryptedS3Key?: string | null;
    message: string;
  };
};

export type FillStateFormMutationVariables = Exact<{
  input: FillStateFormInput;
}>;

export type FillStateFormMutation = {
  __typename?: 'Mutation';
  fillStateForm: {
    __typename?: 'FillStateFormResult';
    documentId: string;
    filledFields: Array<string>;
    blankFields: Array<string>;
    warnings: Array<string>;
  };
};

export type RenderHtmlPdfMutationVariables = Exact<{
  input: RenderHtmlPdfInput;
}>;

export type RenderHtmlPdfMutation = {
  __typename?: 'Mutation';
  renderHtmlPdf: {
    __typename?: 'RenderHtmlPdfResult';
    success: boolean;
    documentId: string;
    s3Key: string;
    downloadUrl: string;
    templateId: string;
    contentType: string;
    sizeBytes: number;
    generatedAt: string;
    message: string;
  };
};

export type CreateSigningCeremonyMutationVariables = Exact<{
  input: CreateSigningCeremonyInput;
}>;

export type CreateSigningCeremonyMutation = {
  __typename?: 'Mutation';
  createSigningCeremony: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    documentId: string;
    tenantId: string;
    status: CeremonyStatus;
    signingOrder: SigningOrder;
    expiresAt?: string | null;
    createdAt: string;
    participants: Array<{
      __typename?: 'CeremonyParticipant';
      name: string;
      email: string;
      role: SignerRole;
      status: ParticipantStatus;
      fieldName: string;
    }>;
  };
};

export type RecordParticipantSignatureMutationVariables = Exact<{
  input: RecordParticipantSignatureInput;
}>;

export type RecordParticipantSignatureMutation = {
  __typename?: 'Mutation';
  recordParticipantSignature: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    status: CeremonyStatus;
    signedS3Key?: string | null;
    completedAt?: string | null;
    participants: Array<{
      __typename?: 'CeremonyParticipant';
      name: string;
      role: SignerRole;
      status: ParticipantStatus;
      signedAt?: string | null;
      fieldName: string;
    }>;
  };
};

export type RequestCeremonyDocumentUrlMutationVariables = Exact<{
  input: RequestCeremonyDocumentUrlInput;
}>;

export type RequestCeremonyDocumentUrlMutation = {
  __typename?: 'Mutation';
  requestCeremonyDocumentUrl: {
    __typename?: 'CeremonyDocumentUrl';
    downloadUrl: string;
    fileName: string;
    expiresInSeconds: number;
  };
};

export type DeclineCeremonyMutationVariables = Exact<{
  input: DeclineCeremonyInput;
}>;

export type DeclineCeremonyMutation = {
  __typename?: 'Mutation';
  declineCeremony: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    status: CeremonyStatus;
    participants: Array<{
      __typename?: 'CeremonyParticipant';
      name: string;
      role: SignerRole;
      status: ParticipantStatus;
      declinedAt?: string | null;
      declineReason?: string | null;
    }>;
  };
};

export type CreateWorkflowGraphMutationVariables = Exact<{
  input: CreateWorkflowGraphInput;
}>;

export type CreateWorkflowGraphMutation = {
  __typename?: 'Mutation';
  createWorkflowGraph: {
    __typename?: 'WorkflowGraph';
    graphId: string;
    tenantId: string;
    graphName: string;
    description?: string | null;
    createdAt: string;
    createdBy: string;
  };
};

export type UpdateWorkflowGraphMutationVariables = Exact<{
  input: UpdateWorkflowGraphInput;
}>;

export type UpdateWorkflowGraphMutation = {
  __typename?: 'Mutation';
  updateWorkflowGraph: {
    __typename?: 'WorkflowGraph';
    graphId: string;
    tenantId: string;
    graphName: string;
    description?: string | null;
    updatedAt: string;
    updatedBy: string;
  };
};

export type ArchiveWorkflowGraphMutationVariables = Exact<{
  input: ArchiveWorkflowGraphInput;
}>;

export type ArchiveWorkflowGraphMutation = {
  __typename?: 'Mutation';
  archiveWorkflowGraph: {
    __typename?: 'ArchivedWorkflowGraph';
    graphId: string;
    archivedAt: string;
    archivedBy?: string | null;
    reason?: string | null;
  };
};

export type GenerateTaskGuidanceMutationVariables = Exact<{
  input: GenerateTaskGuidanceInput;
  userId: Scalars['String']['input'];
}>;

export type GenerateTaskGuidanceMutation = {
  __typename?: 'Mutation';
  generateTaskGuidance: {
    __typename?: 'GenerateTaskGuidanceResult';
    guidance: {
      __typename?: 'TaskGuidanceOutput';
      guidanceId: string;
      taskId: string;
      tips: Array<string>;
      warnings: Array<string>;
      complianceNotes: Array<string>;
      relatedDocumentation: Array<string>;
      confidence: number;
      steps: Array<{
        __typename?: 'GuidanceStepOutput';
        stepNumber: number;
        instruction: string;
        estimatedDuration?: string | null;
        requiredInputs?: Array<string> | null;
        validationRules?: Array<string> | null;
      }>;
    };
    organizationSuggestions?: {
      __typename?: 'OrganizationSuggestionOutput';
      groupBy: string;
      sortOrder: string;
      priorityOverrides: Array<{
        __typename?: 'PriorityOverrideOutput';
        taskId: string;
        suggestedPriority: string;
        reason: string;
      }>;
    } | null;
  };
};

export type OrganizeTasksMutationVariables = Exact<{
  input: OrganizeTasksInput;
  userId: Scalars['String']['input'];
}>;

export type OrganizeTasksMutation = {
  __typename?: 'Mutation';
  organizeTasks: {
    __typename?: 'OrganizeTasksResult';
    organizedTasks: Array<{
      __typename?: 'OrganizedTaskOutput';
      taskId: string;
      groupKey: string;
      groupLabel: string;
      sortOrder: number;
      urgencyScore: number;
      priorityReason: string;
      suggestedStartTime?: string | null;
    }>;
    groups: Array<{
      __typename?: 'TaskGroupOutput';
      groupKey: string;
      label: string;
      taskCount: number;
      description?: string | null;
      icon?: string | null;
    }>;
    summary: {
      __typename?: 'TaskSummaryOutput';
      totalTasks: number;
      criticalCount: number;
      overdueCount: number;
      suggestedFocus: string;
      estimatedTotalDuration?: string | null;
    };
  };
};

export type ImportRegulatoryRulesMutationVariables = Exact<{
  input: ImportRulesInput;
}>;

export type ImportRegulatoryRulesMutation = {
  __typename?: 'Mutation';
  importRegulatoryRules: {
    __typename?: 'GqlBatchImportResult';
    importedCount: number;
    failedCount: number;
    autoApprovedCount: number;
    reviewRequiredCount: number;
    warnings: Array<string>;
    results: Array<{
      __typename?: 'GqlRuleImportResult';
      ruleId?: string | null;
      success: boolean;
      warnings: Array<string>;
      routeDecision?: {
        __typename?: 'GqlRouteDecision';
        queue: GqlReviewQueue;
        reason: string;
        confidence: number;
        safetyOverride: boolean;
        conflictsDetected: boolean;
        conflictingRuleIds: Array<string>;
      } | null;
      errors: Array<{ __typename?: 'GqlValidationError'; field: string; message: string }>;
    }>;
  };
};

export type ApproveRegulatoryRuleMutationVariables = Exact<{
  input: ApproveRuleInput;
}>;

export type ApproveRegulatoryRuleMutation = {
  __typename?: 'Mutation';
  approveRegulatoryRule: {
    __typename?: 'GqlRegulatoryRule';
    id: string;
    version: number;
    status: GqlRuleStatus;
    queue: GqlReviewQueue;
    text: string;
    supersedes?: string | null;
    changelog?: string | null;
    requiresHumanReview: boolean;
    createdBy: string;
    createdAt: string;
    reviewerId?: string | null;
    reviewedAt?: string | null;
    reviewComment?: string | null;
    rejectionReason?: string | null;
    conflictingRuleIds: Array<string>;
    structured: {
      __typename?: 'GqlStructuredRule';
      actor: string;
      action: string;
      trigger?: string | null;
      deadline?: string | null;
      evidence: Array<{
        __typename?: 'GqlEvidence';
        name: string;
        description: string;
        required: boolean;
        fhirResource?: string | null;
      }>;
      exceptions: Array<{
        __typename?: 'GqlException';
        condition: string;
        alternativeAction?: string | null;
      }>;
    };
    source: {
      __typename?: 'GqlRuleSource';
      effectiveDate: string;
      sunsetDate?: string | null;
      document: {
        __typename?: 'GqlSourceDocument';
        id: string;
        title: string;
        url?: string | null;
        version?: string | null;
      };
      location: {
        __typename?: 'GqlSourceLocation';
        section: string;
        subdivision?: string | null;
        paragraph?: string | null;
        page?: number | null;
      };
    };
    extraction: {
      __typename?: 'GqlExtractionMetadata';
      confidence: number;
      confidencePercentage: number;
      extractor?: string | null;
      extractedAt?: string | null;
      reviewedBy?: string | null;
      reviewedAt?: string | null;
    };
    classification: {
      __typename?: 'GqlClassification';
      safetyLevel: GqlSafetyLevel;
      complianceDomain: GqlComplianceDomain;
      piiImpact: boolean;
      tags: Array<string>;
    };
  };
};

export type RejectRegulatoryRuleMutationVariables = Exact<{
  input: RejectRuleInput;
}>;

export type RejectRegulatoryRuleMutation = {
  __typename?: 'Mutation';
  rejectRegulatoryRule: {
    __typename?: 'GqlRegulatoryRule';
    id: string;
    version: number;
    status: GqlRuleStatus;
    queue: GqlReviewQueue;
    text: string;
    supersedes?: string | null;
    changelog?: string | null;
    requiresHumanReview: boolean;
    createdBy: string;
    createdAt: string;
    reviewerId?: string | null;
    reviewedAt?: string | null;
    reviewComment?: string | null;
    rejectionReason?: string | null;
    conflictingRuleIds: Array<string>;
    structured: {
      __typename?: 'GqlStructuredRule';
      actor: string;
      action: string;
      trigger?: string | null;
      deadline?: string | null;
      evidence: Array<{
        __typename?: 'GqlEvidence';
        name: string;
        description: string;
        required: boolean;
        fhirResource?: string | null;
      }>;
      exceptions: Array<{
        __typename?: 'GqlException';
        condition: string;
        alternativeAction?: string | null;
      }>;
    };
    source: {
      __typename?: 'GqlRuleSource';
      effectiveDate: string;
      sunsetDate?: string | null;
      document: {
        __typename?: 'GqlSourceDocument';
        id: string;
        title: string;
        url?: string | null;
        version?: string | null;
      };
      location: {
        __typename?: 'GqlSourceLocation';
        section: string;
        subdivision?: string | null;
        paragraph?: string | null;
        page?: number | null;
      };
    };
    extraction: {
      __typename?: 'GqlExtractionMetadata';
      confidence: number;
      confidencePercentage: number;
      extractor?: string | null;
      extractedAt?: string | null;
      reviewedBy?: string | null;
      reviewedAt?: string | null;
    };
    classification: {
      __typename?: 'GqlClassification';
      safetyLevel: GqlSafetyLevel;
      complianceDomain: GqlComplianceDomain;
      piiImpact: boolean;
      tags: Array<string>;
    };
  };
};

export type ResubmitRegulatoryRuleMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
  yamlContent: Scalars['String']['input'];
}>;

export type ResubmitRegulatoryRuleMutation = {
  __typename?: 'Mutation';
  resubmitRegulatoryRule: {
    __typename?: 'GqlRegulatoryRule';
    id: string;
    version: number;
    status: GqlRuleStatus;
    queue: GqlReviewQueue;
    text: string;
    supersedes?: string | null;
    changelog?: string | null;
    requiresHumanReview: boolean;
    createdBy: string;
    createdAt: string;
    reviewerId?: string | null;
    reviewedAt?: string | null;
    reviewComment?: string | null;
    rejectionReason?: string | null;
    conflictingRuleIds: Array<string>;
    structured: {
      __typename?: 'GqlStructuredRule';
      actor: string;
      action: string;
      trigger?: string | null;
      deadline?: string | null;
      evidence: Array<{
        __typename?: 'GqlEvidence';
        name: string;
        description: string;
        required: boolean;
        fhirResource?: string | null;
      }>;
      exceptions: Array<{
        __typename?: 'GqlException';
        condition: string;
        alternativeAction?: string | null;
      }>;
    };
    source: {
      __typename?: 'GqlRuleSource';
      effectiveDate: string;
      sunsetDate?: string | null;
      document: {
        __typename?: 'GqlSourceDocument';
        id: string;
        title: string;
        url?: string | null;
        version?: string | null;
      };
      location: {
        __typename?: 'GqlSourceLocation';
        section: string;
        subdivision?: string | null;
        paragraph?: string | null;
        page?: number | null;
      };
    };
    extraction: {
      __typename?: 'GqlExtractionMetadata';
      confidence: number;
      confidencePercentage: number;
      extractor?: string | null;
      extractedAt?: string | null;
      reviewedBy?: string | null;
      reviewedAt?: string | null;
    };
    classification: {
      __typename?: 'GqlClassification';
      safetyLevel: GqlSafetyLevel;
      complianceDomain: GqlComplianceDomain;
      piiImpact: boolean;
      tags: Array<string>;
    };
  };
};

export type InitiateExchangeRelationshipMutationVariables = Exact<{
  input: InitiateExchangeRelationshipInput;
}>;

export type InitiateExchangeRelationshipMutation = {
  __typename?: 'Mutation';
  initiateExchangeRelationship: {
    __typename?: 'ExchangeRelationship';
    relationshipId: string;
    fromTenantId: string;
    toTenantId: string;
    status: ExchangeRelationshipStatus;
    approvalCount: number;
    requiredApprovals: number;
    establishedAt?: string | null;
  };
};

export type RecordExchangeConsentMutationVariables = Exact<{
  input: RecordExchangeConsentInput;
}>;

export type RecordExchangeConsentMutation = {
  __typename?: 'Mutation';
  recordExchangeConsent: {
    __typename?: 'ExchangeRelationship';
    relationshipId: string;
    status: ExchangeRelationshipStatus;
    approvalCount: number;
    requiredApprovals: number;
    establishedAt?: string | null;
    consentRecords: Array<{
      __typename?: 'ExchangeConsentRecord';
      step: ExchangeConsentStep;
      actorId: string;
      tenantId: string;
      consentedAt: string;
      authTier: number;
      witnessVerified: boolean;
    }>;
  };
};

export type RequestExchangeUploadUrlMutationVariables = Exact<{
  input: RequestExchangeUploadUrlInput;
}>;

export type RequestExchangeUploadUrlMutation = {
  __typename?: 'Mutation';
  requestExchangeUploadUrl: {
    __typename?: 'ExchangeUploadUrlResult';
    uploadUrl: string;
    documentId: string;
    s3Key: string;
    expiresInSeconds: number;
  };
};

export type RequestExchangeDownloadUrlMutationVariables = Exact<{
  input: RequestExchangeDownloadUrlInput;
}>;

export type RequestExchangeDownloadUrlMutation = {
  __typename?: 'Mutation';
  requestExchangeDownloadUrl: {
    __typename?: 'ExchangeDownloadUrlResult';
    downloadUrl: string;
    fileName: string;
    contentType: string;
    expiresInSeconds: number;
  };
};

export type RevokeExchangeRelationshipMutationVariables = Exact<{
  input: RevokeExchangeRelationshipInput;
}>;

export type RevokeExchangeRelationshipMutation = {
  __typename?: 'Mutation';
  revokeExchangeRelationship: {
    __typename?: 'ExchangeRelationship';
    relationshipId: string;
    status: ExchangeRelationshipStatus;
    expiresAt?: string | null;
  };
};

export type ImportRuleSetMutationVariables = Exact<{
  input: GqlRuleSetInput;
}>;

export type ImportRuleSetMutation = {
  __typename?: 'Mutation';
  importRuleSet: {
    __typename?: 'RuleSet';
    rulesetId: string;
    displayName: string;
    description: string;
    safetyLevel: string;
    isLifeCritical: boolean;
    jurisdiction: string;
    category: string;
    setting: string;
    appliesToIndustries: Array<string>;
    version?: string | null;
    effectiveDate?: string | null;
    sunsetDate?: string | null;
    isCurrentlyEffective: boolean;
    supersedes?: string | null;
    supersededBy?: string | null;
    complianceFrameworks: Array<string>;
    ruleCount: number;
    ruleIds: Array<string>;
  };
};

export type SupersedeRuleSetMutationVariables = Exact<{
  oldId: Scalars['String']['input'];
  input: GqlRuleSetInput;
}>;

export type SupersedeRuleSetMutation = {
  __typename?: 'Mutation';
  supersedeRuleSet: {
    __typename?: 'RuleSet';
    rulesetId: string;
    displayName: string;
    version?: string | null;
    effectiveDate?: string | null;
    isCurrentlyEffective: boolean;
    supersedes?: string | null;
    supersededBy?: string | null;
  };
};

export type SunsetRuleSetMutationVariables = Exact<{
  rulesetId: Scalars['String']['input'];
  sunsetDate: Scalars['String']['input'];
}>;

export type SunsetRuleSetMutation = {
  __typename?: 'Mutation';
  sunsetRuleSet: {
    __typename?: 'RuleSet';
    rulesetId: string;
    displayName: string;
    sunsetDate?: string | null;
    isCurrentlyEffective: boolean;
  };
};

export type UpdateRuleSetMetadataMutationVariables = Exact<{
  rulesetId: Scalars['String']['input'];
  input: GqlRuleSetMetadataInput;
}>;

export type UpdateRuleSetMetadataMutation = {
  __typename?: 'Mutation';
  updateRuleSetMetadata: {
    __typename?: 'RuleSet';
    rulesetId: string;
    displayName: string;
    description: string;
    safetyLevel: string;
    isLifeCritical: boolean;
    visibilityScope?: string | null;
  };
};

export type CreateInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  input: GqlCreateInstanceInput;
}>;

export type CreateInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiCreateInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type StartInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  workflowDefinitionId?: InputMaybe<Scalars['String']['input']>;
}>;

export type StartInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiStartInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type PauseInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;

export type PauseInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiPauseInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type ResumeInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;

export type ResumeInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiResumeInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type CancelInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;

export type CancelInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiCancelInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type CompleteInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  outputData: Scalars['JSON']['input'];
}>;

export type CompleteInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiCompleteInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type FailInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  input: GqlRecordErrorInput;
}>;

export type FailInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiFailInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type TransitionInstanceMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  input: GqlTransitionInstanceInput;
}>;

export type TransitionInstanceMutation = {
  __typename?: 'Mutation';
  instanceApiTransitionInstance: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  };
};

export type CreateCeremonyTemplateMutationVariables = Exact<{
  input: CreateCeremonyTemplateInput;
}>;

export type CreateCeremonyTemplateMutation = {
  __typename?: 'Mutation';
  createCeremonyTemplate: {
    __typename?: 'CeremonyTemplateGql';
    templateId: string;
    name: string;
    description?: string | null;
    pdfTemplateId?: string | null;
    ordering: string;
    padesProfile?: string | null;
    expiryHours?: number | null;
    createdAt: string;
    createdBy: string;
    tags: Array<string>;
    participants: Array<{
      __typename?: 'CeremonyTemplateParticipantGql';
      roleName: string;
      signingRole: string;
      required: boolean;
      fieldPage?: number | null;
      fieldX?: number | null;
      fieldY?: number | null;
      fieldWidth?: number | null;
      fieldHeight?: number | null;
      fieldType?: string | null;
      appearanceReason?: string | null;
    }>;
  };
};

export type DeleteCeremonyTemplateMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
}>;

export type DeleteCeremonyTemplateMutation = {
  __typename?: 'Mutation';
  deleteCeremonyTemplate: boolean;
};

export type CreateCeremonyFromTemplateMutationVariables = Exact<{
  input: CreateCeremonyFromTemplateInput;
}>;

export type CreateCeremonyFromTemplateMutation = {
  __typename?: 'Mutation';
  createCeremonyFromTemplate: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    documentId: string;
    tenantId: string;
    status: CeremonyStatus;
    signingOrder: SigningOrder;
    createdAt: string;
  };
};

export type RecordSignatureViaTokenMutationVariables = Exact<{
  input: RecordSignatureViaTokenInput;
}>;

export type RecordSignatureViaTokenMutation = {
  __typename?: 'Mutation';
  recordSignatureViaToken: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    status: CeremonyStatus;
    participants: Array<{
      __typename?: 'CeremonyParticipant';
      name: string;
      email: string;
      role: SignerRole;
      status: ParticipantStatus;
      signedAt?: string | null;
    }>;
  };
};

export type VoidCeremonyMutationVariables = Exact<{
  input: VoidCeremonyInput;
}>;

export type VoidCeremonyMutation = {
  __typename?: 'Mutation';
  voidCeremony: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    status: CeremonyStatus;
    voidedAt?: string | null;
    voidReason?: string | null;
  };
};

export type ReassignCeremonyParticipantMutationVariables = Exact<{
  input: ReassignCeremonyParticipantInput;
}>;

export type ReassignCeremonyParticipantMutation = {
  __typename?: 'Mutation';
  reassignCeremonyParticipant: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    status: CeremonyStatus;
    participants: Array<{
      __typename?: 'CeremonyParticipant';
      name: string;
      email: string;
      role: SignerRole;
      status: ParticipantStatus;
    }>;
  };
};

export type GenerateCeremonyEvidenceCertificateMutationVariables = Exact<{
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type GenerateCeremonyEvidenceCertificateMutation = {
  __typename?: 'Mutation';
  generateCeremonyEvidenceCertificate: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    status: CeremonyStatus;
    evidenceS3Key?: string | null;
  };
};

export type RegisterWebhookEndpointMutationVariables = Exact<{
  input: RegisterWebhookInput;
}>;

export type RegisterWebhookEndpointMutation = {
  __typename?: 'Mutation';
  registerWebhookEndpoint: {
    __typename?: 'WebhookEndpoint';
    endpointId: string;
    tenantId: string;
    url: string;
    events: Array<string>;
    active: boolean;
    createdAt: string;
  };
};

export type DeleteWebhookEndpointMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  endpointId: Scalars['String']['input'];
}>;

export type DeleteWebhookEndpointMutation = {
  __typename?: 'Mutation';
  deleteWebhookEndpoint: boolean;
};

export type BatchCreateCeremonyFromTemplateMutationVariables = Exact<{
  input: BatchCreateCeremonyFromTemplateInput;
}>;

export type BatchCreateCeremonyFromTemplateMutation = {
  __typename?: 'Mutation';
  batchCreateCeremonyFromTemplate: {
    __typename?: 'BatchCeremonyResult';
    totalRequested: number;
    totalCreated: number;
    created: Array<{
      __typename?: 'SigningCeremony';
      ceremonyId: string;
      documentId: string;
      status: CeremonyStatus;
    }>;
    errors: Array<{
      __typename?: 'BatchCeremonyError';
      index: number;
      documentId: string;
      error: string;
    }>;
  };
};

export type SwitchTraversalModeMutationVariables = Exact<{
  mode: GqlTraversalMode;
}>;

export type SwitchTraversalModeMutation = { __typename?: 'Mutation'; switchTraversalMode: boolean };

export type SetFocusContextMutationVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
  perspective?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetFocusContextMutation = {
  __typename?: 'Mutation';
  setFocusContext: {
    __typename?: 'FocusContext';
    subjectActorId?: string | null;
    subjectDisplayName?: string | null;
    perspective: string;
    setAt?: string | null;
    expiresAt?: string | null;
  };
};

export type ClearFocusContextMutationVariables = Exact<{ [key: string]: never }>;

export type ClearFocusContextMutation = { __typename?: 'Mutation'; clearFocusContext: boolean };

export type GenerateWorkflowExecutionPdfMutationVariables = Exact<{
  input: GenerateWorkflowSummaryInput;
}>;

export type GenerateWorkflowExecutionPdfMutation = {
  __typename?: 'Mutation';
  generateWorkflowExecutionPdf: {
    __typename?: 'GenerateReportPdfResult';
    success: boolean;
    documentId: string;
    s3Key?: string | null;
    sizeBytes?: number | null;
    message: string;
  };
};

export type GenerateDailyTaskSheetMutationVariables = Exact<{
  input: GenerateDailyTaskSheetInput;
}>;

export type GenerateDailyTaskSheetMutation = {
  __typename?: 'Mutation';
  generateDailyTaskSheet: {
    __typename?: 'GenerateReportPdfResult';
    success: boolean;
    documentId: string;
    s3Key?: string | null;
    sizeBytes?: number | null;
    message: string;
  };
};

export type GenerateRulesetComplianceReportMutationVariables = Exact<{
  input: GenerateRulesetReportInput;
}>;

export type GenerateRulesetComplianceReportMutation = {
  __typename?: 'Mutation';
  generateRulesetComplianceReport: {
    __typename?: 'GenerateReportPdfResult';
    success: boolean;
    documentId: string;
    s3Key?: string | null;
    sizeBytes?: number | null;
    message: string;
  };
};

export type GenerateRulesetAcknowledgmentMutationVariables = Exact<{
  input: GenerateRulesetAcknowledgmentInput;
}>;

export type GenerateRulesetAcknowledgmentMutation = {
  __typename?: 'Mutation';
  generateRulesetAcknowledgment: {
    __typename?: 'GenerateAcknowledgmentResult';
    success: boolean;
    documentId: string;
    s3Key?: string | null;
    sizeBytes?: number | null;
    message: string;
    ceremonyId?: string | null;
  };
};

export type GenerateSubjectCareSummaryMutationVariables = Exact<{
  input: GenerateSubjectCareSummaryInput;
}>;

export type GenerateSubjectCareSummaryMutation = {
  __typename?: 'Mutation';
  generateSubjectCareSummary: {
    __typename?: 'GenerateReportPdfResult';
    success: boolean;
    documentId: string;
    s3Key?: string | null;
    sizeBytes?: number | null;
    message: string;
  };
};

export type GenerateEpManualMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  rulesetId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GenerateEpManualMutation = {
  __typename?: 'Mutation';
  generateEpManual: {
    __typename?: 'GenerateEpManualResult';
    success: boolean;
    documentId: string;
    s3Key: string;
    downloadUrl: string;
    generatedAt: string;
    rulesetId: string;
    surveyForms: Array<string>;
    checkpointsCovered: number;
    taskGroups: Array<string>;
    pageCount: number;
    sizeBytes: number;
    message: string;
  };
};

export type SubmitSettlementProposalMutationVariables = Exact<{
  input: SubmitSettlementProposalInput;
}>;

export type SubmitSettlementProposalMutation = {
  __typename?: 'Mutation';
  submitSettlementProposal: {
    __typename?: 'SettlementProposal';
    proposalId: string;
    amountCents: number;
    proposerTenantId: string;
    counterpartyTenantId: string;
    periodStart: string;
    periodEnd: string;
    status: SettlementProposalStatus;
    transactionCount: number;
    proposedAt: string;
    proposerReconciliationHash: string;
  };
};

export type AcceptSettlementProposalMutationVariables = Exact<{
  input: AcceptSettlementProposalInput;
}>;

export type AcceptSettlementProposalMutation = {
  __typename?: 'Mutation';
  acceptSettlementProposal: {
    __typename?: 'SettlementProposal';
    proposalId: string;
    amountCents: number;
    status: SettlementProposalStatus;
    counterpartyReconciliationHash?: string | null;
    proposerReconciliationHash: string;
    resolvedAt?: string | null;
    settledAt?: string | null;
  };
};

export type GenerateAuditReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
  input: GenerateReportInput;
}>;

export type GenerateAuditReportMutation = {
  __typename?: 'Mutation';
  generateAuditReport: {
    __typename?: 'AuditReportQL';
    reportId: string;
    auditId: string;
    reportUrl: string;
    reportFormat: GqlReportFormat;
    generatedAt: string;
    sizeBytes: number;
  };
};

export type VerifyWitnessRequestMutationVariables = Exact<{
  input: VerifyWitnessRequestInput;
}>;

export type VerifyWitnessRequestMutation = {
  __typename?: 'Mutation';
  verifyWitnessRequest: {
    __typename?: 'VerifyWitnessRequestPayload';
    completionToken: string;
    request: {
      __typename?: 'WitnessRequestGql';
      id: string;
      status: WitnessStatusGql;
      witnessId?: string | null;
      witnessRole?: string | null;
    };
  };
};

export type CompleteWitnessRequestMutationVariables = Exact<{
  input: CompleteWitnessRequestInput;
}>;

export type CompleteWitnessRequestMutation = {
  __typename?: 'Mutation';
  completeWitnessRequest: {
    __typename?: 'WitnessRequestGql';
    id: string;
    status: WitnessStatusGql;
  };
};

export type CancelWitnessRequestMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;

export type CancelWitnessRequestMutation = {
  __typename?: 'Mutation';
  cancelWitnessRequest: { __typename?: 'WitnessRequestGql'; id: string; status: WitnessStatusGql };
};

export type RejectWitnessRequestMutationVariables = Exact<{
  input: RejectWitnessRequestInput;
}>;

export type RejectWitnessRequestMutation = {
  __typename?: 'Mutation';
  rejectWitnessRequest: { __typename?: 'WitnessRequestGql'; id: string; status: WitnessStatusGql };
};

export type AttestProvisionMutationVariables = Exact<{
  input: AttestProvisionInput;
}>;

export type AttestProvisionMutation = {
  __typename?: 'Mutation';
  attestProvision: {
    __typename?: 'AttestProvisionResult';
    success: boolean;
    attestationId: string;
    message: string;
  };
};

export type RecordAdoptionDecisionMutationVariables = Exact<{
  input: AdoptionDecisionInput;
}>;

export type RecordAdoptionDecisionMutation = {
  __typename?: 'Mutation';
  recordAdoptionDecision: {
    __typename?: 'AdoptionDecisionResult';
    success: boolean;
    practiceRef: string;
    decision: GqlAdoptionStatus;
    auditEventId?: string | null;
  };
};

export type CreateEntityMutationVariables = Exact<{
  input: CreateEntityInput;
}>;

export type CreateEntityMutation = {
  __typename?: 'Mutation';
  createEntity: {
    __typename?: 'GenericEntity';
    id: string;
    name: string;
    entityType: string;
    status: EntityStatus;
    createdAt: string;
  };
};

export type VerifyLedgerChainMutationVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type VerifyLedgerChainMutation = {
  __typename?: 'Mutation';
  verifyLedgerChain: {
    __typename?: 'LedgerChainVerificationResult';
    valid: boolean;
    entryCount: number;
    firstInvalidAt?: number | null;
    headHash: string;
    genesisHash: string;
    verifiedAt: string;
  };
};

export type CreateEntityApprovalMutationVariables = Exact<{
  input: GqlCreateApprovalInput;
  tenantId: Scalars['String']['input'];
}>;

export type CreateEntityApprovalMutation = {
  __typename?: 'Mutation';
  approvalApiCreateApproval: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    createdAt: string;
  };
};

export type AnalyzePublicationMutationVariables = Exact<{
  input: AnalyzePublicationInput;
}>;

export type AnalyzePublicationMutation = {
  __typename?: 'Mutation';
  analyzePublication: {
    __typename?: 'PublicationAnalysisResult';
    success: boolean;
    draftCount: number;
    confidence: number;
    mappedTags: Array<string>;
    warnings: Array<string>;
    proposals: Array<{
      __typename?: 'PendingProposal';
      proposalId: string;
      configType: string;
      displayName?: string | null;
      description?: string | null;
      safetyLevel?: string | null;
    }>;
  };
};

export type ExtractStatuteMetadataMutationVariables = Exact<{
  input: ExtractStatuteMetadataInput;
}>;

export type ExtractStatuteMetadataMutation = {
  __typename?: 'Mutation';
  extractStatuteMetadata: {
    __typename?: 'StatuteMetadata';
    associationRef: string;
    publicationTitle: string;
    publicationYear: number;
    industry: string;
    jurisdiction: string;
    documentText: string;
  };
};

export type GenerateProposalsMutationVariables = Exact<{
  input: GenerateProposalsInput;
}>;

export type GenerateProposalsMutation = {
  __typename?: 'Mutation';
  generateConfigProposals: {
    __typename?: 'GenerateProposalsResult';
    success: boolean;
    draftCount: number;
    gapIds: Array<string>;
    warnings: Array<string>;
    proposals: Array<{
      __typename?: 'PendingProposal';
      proposalId: string;
      configType: string;
      displayName?: string | null;
      description?: string | null;
      safetyLevel?: string | null;
    }>;
  };
};

export type ApproveProposalMutationVariables = Exact<{
  input: ApproveProposalInput;
}>;

export type ApproveProposalMutation = {
  __typename?: 'Mutation';
  approveConfigProposal: {
    __typename?: 'ApproveProposalResult';
    success: boolean;
    proposalId: string;
    movedTo: string;
    auditEventId?: string | null;
  };
};

export type ExplainProposalMutationVariables = Exact<{
  input: ExplainProposalInput;
}>;

export type ExplainProposalMutation = {
  __typename?: 'Mutation';
  explainConfigProposal: { __typename?: 'ComposeWorkflowResponse'; response: string };
};

export type FireEventMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
}>;

export type FireEventMutation = {
  __typename?: 'Mutation';
  instanceApiFireEvent: {
    __typename?: 'Instance';
    id: string;
    status: GqlInstanceStatus;
    currentState: string;
    previousState?: string | null;
    totalTasks: number;
    completedTasks: number;
    version: number;
  };
};

export type RequestDocumentDownloadUrlMutationVariables = Exact<{
  input: RequestDocumentDownloadUrlInput;
}>;

export type RequestDocumentDownloadUrlMutation = {
  __typename?: 'Mutation';
  documentApiRequestDocumentDownloadUrl: {
    __typename?: 'DocumentDownloadUrlResult';
    downloadUrl: string;
    documentName: string;
    mimeType: string;
    expiresInSeconds: number;
  };
};

export type ActivateSystemTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type ActivateSystemTenantMutation = {
  __typename?: 'Mutation';
  activateSystemTenant: {
    __typename?: 'SystemTenant';
    tenantId: string;
    name: string;
    onboardingStatus: GqlOnboardingStatus;
    isActive: boolean;
  };
};

export type UpdateApprovalMetadataMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalId: Scalars['String']['input'];
  input: GqlUpdateApprovalInput;
}>;

export type UpdateApprovalMetadataMutation = {
  __typename?: 'Mutation';
  approvalApiUpdateApproval: {
    __typename?: 'Approval';
    id: string;
    status: GqlApprovalStatus;
    priority: GqlApprovalPriority;
    tags: Array<string>;
    updatedAt: string;
  };
};

export type TriggerChaosPipelineMutationVariables = Exact<{
  input: TriggerChaosPipelineInput;
}>;

export type TriggerChaosPipelineMutation = {
  __typename?: 'Mutation';
  triggerChaosPipeline: {
    __typename?: 'PipelineExecutionResult';
    executionId: string;
    documentId: string;
    tenant: string;
    status: string;
    success: boolean;
    errorMessage?: string | null;
    capabilitiesEvaluated: number;
    capabilitiesMatched: number;
    matchedCapabilityIds: Array<string>;
    totalNodes: number;
    completedNodes: number;
    failedNodes: number;
    totalDurationMs?: number | null;
  };
};

export type AddScopeEdgeMutationVariables = Exact<{
  input: AddScopeEdgeInput;
}>;

export type AddScopeEdgeMutation = {
  __typename?: 'Mutation';
  addScopeEdge: {
    __typename?: 'ScopeMutationEvent';
    id: string;
    mutationKind: string;
    hash: string;
  };
};

export type RemoveScopeEdgeMutationVariables = Exact<{
  input: RemoveScopeEdgeInput;
}>;

export type RemoveScopeEdgeMutation = {
  __typename?: 'Mutation';
  removeScopeEdge: {
    __typename?: 'ScopeMutationEvent';
    id: string;
    mutationKind: string;
    hash: string;
  };
};

export type PlanShiftMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  floorId: Scalars['String']['input'];
  shiftStart?: InputMaybe<Scalars['DateTime']['input']>;
  durationHours?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PlanShiftMutation = {
  __typename?: 'Mutation';
  planShift: {
    __typename?: 'ShiftPlan';
    planId: string;
    tenantId: string;
    floorId: string;
    shiftStart: string;
    shiftEnd: string;
    generatedAt: string;
    version: number;
    warnings: Array<string>;
    assignments: Array<{
      __typename?: 'TaskAssignment';
      taskId: string;
      assignedStaffId: string;
      assistStaffId?: string | null;
      subjectId: string;
      scheduledStart: string;
      scheduledEnd: string;
      priorityScore: number;
      continuityScore?: number | null;
    }>;
    staffRoster: Array<{
      __typename?: 'ShiftStaffMember';
      actorId: string;
      roleId: string;
      available: boolean;
    }>;
  };
};

export type ReplanShiftMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  triggerType: ReplanTriggerType;
  staffId?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReplanShiftMutation = {
  __typename?: 'Mutation';
  replanShift: {
    __typename?: 'ShiftPlan';
    planId: string;
    tenantId: string;
    floorId: string;
    shiftStart: string;
    shiftEnd: string;
    generatedAt: string;
    version: number;
    replanTrigger?: string | null;
    warnings: Array<string>;
    assignments: Array<{
      __typename?: 'TaskAssignment';
      taskId: string;
      assignedStaffId: string;
      assistStaffId?: string | null;
      subjectId: string;
      scheduledStart: string;
      scheduledEnd: string;
      priorityScore: number;
      continuityScore?: number | null;
    }>;
    staffRoster: Array<{
      __typename?: 'ShiftStaffMember';
      actorId: string;
      roleId: string;
      available: boolean;
    }>;
  };
};

export type CreateFhirStorageResourceMutationVariables = Exact<{
  input: CreateFhirResourceGqlInput;
}>;

export type CreateFhirStorageResourceMutation = {
  __typename?: 'Mutation';
  createFhirStorageResource: {
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  };
};

export type UpdateFhirStorageResourceMutationVariables = Exact<{
  input: UpdateFhirResourceGqlInput;
}>;

export type UpdateFhirStorageResourceMutation = {
  __typename?: 'Mutation';
  updateFhirStorageResource: {
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  };
};

export type CreateArchitectProposalMutationVariables = Exact<{
  input: CreateArchitectProposalInput;
}>;

export type CreateArchitectProposalMutation = {
  __typename?: 'Mutation';
  createArchitectProposal: {
    __typename?: 'ArchitectProposal';
    id: string;
    tenantId: string;
    configType: ConfigProposalType;
    configId: string;
    isNew: boolean;
    title: string;
    description: string;
    status: ProposalStatus;
    proposedBy: string;
    proposedAt: string;
    updatedAt: string;
  };
};

export type SubmitArchitectProposalMutationVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;

export type SubmitArchitectProposalMutation = {
  __typename?: 'Mutation';
  submitArchitectProposal: {
    __typename?: 'ArchitectProposal';
    id: string;
    status: ProposalStatus;
    updatedAt: string;
    simulation?: {
      __typename?: 'ArchitectProposalSimulation';
      passed: boolean;
      errorCount: number;
      warningCount: number;
      errors: Array<string>;
      warnings: Array<string>;
      simulatedAt: string;
    } | null;
  };
};

export type ReviewArchitectProposalMutationVariables = Exact<{
  input: ReviewArchitectProposalInput;
}>;

export type ReviewArchitectProposalMutation = {
  __typename?: 'Mutation';
  reviewArchitectProposal: {
    __typename?: 'ArchitectProposal';
    id: string;
    status: ProposalStatus;
    reviewedBy?: string | null;
    reviewedAt?: string | null;
    rejectionReason?: string | null;
    updatedAt: string;
  };
};

export type ActivateArchitectProposalMutationVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;

export type ActivateArchitectProposalMutation = {
  __typename?: 'Mutation';
  activateArchitectProposal: {
    __typename?: 'ArchitectProposal';
    id: string;
    status: ProposalStatus;
    activatedAt?: string | null;
    updatedAt: string;
  };
};

export type CancelArchitectProposalMutationVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;

export type CancelArchitectProposalMutation = {
  __typename?: 'Mutation';
  cancelArchitectProposal: {
    __typename?: 'ArchitectProposal';
    id: string;
    status: ProposalStatus;
    updatedAt: string;
  };
};

export type AcknowledgeIntegrationAnomalyMutationVariables = Exact<{
  anomalyId: Scalars['ID']['input'];
  acknowledgedBy: Scalars['String']['input'];
}>;

export type AcknowledgeIntegrationAnomalyMutation = {
  __typename?: 'Mutation';
  acknowledgeIntegrationAnomaly: {
    __typename?: 'IntegrationAnomalyAckResult';
    anomalyId: string;
    acknowledged: boolean;
    acknowledgedAt?: string | null;
    acknowledgedBy?: string | null;
  };
};

export type ResolveIntegrationAnomalyMutationVariables = Exact<{
  anomalyId: Scalars['ID']['input'];
  resolutionNotes: Scalars['String']['input'];
}>;

export type ResolveIntegrationAnomalyMutation = {
  __typename?: 'Mutation';
  resolveIntegrationAnomaly: {
    __typename?: 'IntegrationAnomalyResolveResult';
    anomalyId: string;
    resolved: boolean;
    resolvedAt?: string | null;
    resolutionNotes?: string | null;
  };
};

export type BulkAcknowledgeAnomaliesMutationVariables = Exact<{
  anomalyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  acknowledgedBy: Scalars['String']['input'];
}>;

export type BulkAcknowledgeAnomaliesMutation = {
  __typename?: 'Mutation';
  bulkAcknowledgeAnomalies: Array<{
    __typename?: 'IntegrationAnomalyAckResult';
    anomalyId: string;
    acknowledged: boolean;
    acknowledgedAt?: string | null;
    acknowledgedBy?: string | null;
  }>;
};

export type BulkSendWorkerNotificationsMutationVariables = Exact<{
  workerIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  notificationType: Scalars['String']['input'];
  channel: IntegrationNotificationChannel;
}>;

export type BulkSendWorkerNotificationsMutation = {
  __typename?: 'Mutation';
  bulkSendWorkerNotifications: Array<{
    __typename?: 'IntegrationNotificationResult';
    notificationId: string;
    workerId: string;
    channel: IntegrationNotificationChannel;
    sentAt: string;
    status: string;
  }>;
};

export type RegisterPlatformCredentialsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type RegisterPlatformCredentialsMutation = {
  __typename?: 'Mutation';
  registerPlatformCredentials: boolean;
};

export type TestPlatformCredentialsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
}>;

export type TestPlatformCredentialsMutation = {
  __typename?: 'Mutation';
  testPlatformCredentials: boolean;
};

export type DismissDriftAlertMutationVariables = Exact<{
  input: DismissAlertInput;
}>;

export type DismissDriftAlertMutation = { __typename?: 'Mutation'; dismissDriftAlert: boolean };

export type GenerateAdmissionPdfMutationVariables = Exact<{
  input: GenerateAdmissionPdfInput;
}>;

export type GenerateAdmissionPdfMutation = {
  __typename?: 'Mutation';
  generateAdmissionPdf: {
    __typename?: 'GenerateReportPdfResult';
    success: boolean;
    documentId: string;
    s3Key?: string | null;
    sizeBytes?: number | null;
  };
};

export type FinalizePlanMutationVariables = Exact<{
  planId: Scalars['String']['input'];
  authorityActorId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type FinalizePlanMutation = {
  __typename?: 'Mutation';
  finalizePlan: {
    __typename?: 'ServicePlan';
    id: string;
    subjectId: string;
    subjectName: string;
    planType: string;
    status: PlanStatus;
    version: number;
    createdAt: number;
    updatedAt?: number | null;
  };
};

export type SubmitPlanReviewMutationVariables = Exact<{
  input: PlanReviewInput;
}>;

export type SubmitPlanReviewMutation = {
  __typename?: 'Mutation';
  submitPlanReview: {
    __typename?: 'PlanReviewResult';
    planId: string;
    status: PlanStatus;
    reviewedAt: number;
    nextAction?: string | null;
  };
};

export type SimulateScenarioMutationVariables = Exact<{
  workflowId: Scalars['String']['input'];
  scenario: SimulationScenario;
  mockVariables?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type SimulateScenarioMutation = {
  __typename?: 'Mutation';
  simulateScenario: {
    __typename?: 'SimulationRunResult';
    workflowId: string;
    summary: {
      __typename?: 'SimulationSummary';
      totalStates: number;
      reachableStates: number;
      totalTransitionsExplored: number;
      uncertainTransitions: number;
      longestPathLength: number;
      deadEndStates: Array<string>;
      finalStates: Array<string>;
      selfLoopStates: Array<string>;
      unreachableStates: Array<string>;
      policyGaps: Array<string>;
      errors: Array<{
        __typename?: 'SimulationError';
        errorType: string;
        message: string;
        stateName: string;
      }>;
      warnings: Array<{
        __typename?: 'SimulationWarning';
        warningType: string;
        message: string;
        stateName: string;
      }>;
    };
    tree: {
      __typename?: 'SimulationTreeNode';
      stateName: string;
      stateType: string;
      visitCount: number;
      isRepeating: boolean;
      children: Array<{
        __typename?: 'SimulationTreeEdge';
        target: {
          __typename?: 'SimulationTreeNode';
          stateName: string;
          stateType: string;
          visitCount: number;
          isRepeating: boolean;
        };
        transition: {
          __typename?: 'SimulatedTransition';
          event: string;
          fromState: string;
          toState: string;
          hasUncertainGuards: boolean;
          actionsPlanned: Array<{
            __typename?: 'PlannedAction';
            actionType: string;
            params: Record<string, unknown>;
            sideEffectsSuppressed: boolean;
            wouldCreate: Array<string>;
          }>;
          guardsEvaluated: Array<{
            __typename?: 'GuardResult';
            guardName: string;
            guardType: string;
            outcome: GuardOutcome;
            explanation: string;
          }>;
        };
      }>;
    };
  };
};

export type StartSimulationMutationVariables = Exact<{
  input: StartSimulationInput;
}>;

export type StartSimulationMutation = {
  __typename?: 'Mutation';
  startSimulation: {
    __typename?: 'GqlSimulationSession';
    sessionId: string;
    workflowId: string;
    currentState: string;
    stepCount: number;
  };
};

export type SimulateEventMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
  event: Scalars['String']['input'];
}>;

export type SimulateEventMutation = {
  __typename?: 'Mutation';
  simulateEvent: {
    __typename?: 'SimulationStepResult';
    sessionId: string;
    newState: string;
    previousState: string;
    availableEvents: Array<string>;
    transition: {
      __typename?: 'SimulatedTransition';
      event: string;
      fromState: string;
      toState: string;
      hasUncertainGuards: boolean;
      actionsPlanned: Array<{
        __typename?: 'PlannedAction';
        actionType: string;
        params: Record<string, unknown>;
        sideEffectsSuppressed: boolean;
        wouldCreate: Array<string>;
      }>;
      guardsEvaluated: Array<{
        __typename?: 'GuardResult';
        guardName: string;
        guardType: string;
        outcome: GuardOutcome;
        explanation: string;
      }>;
    };
  };
};

export type AssessWorkflowCriticalityMutationVariables = Exact<{
  workflowExecution: WorkflowExecutionInput;
}>;

export type AssessWorkflowCriticalityMutation = {
  __typename?: 'Mutation';
  assessWorkflowCriticality: {
    __typename?: 'WorkflowCriticalityResult';
    canExecute: boolean;
    criticalityLevel: string;
    requiresLock: boolean;
    lockType: string;
    violations: Array<string>;
    warnings: Array<string>;
    deduplicationFingerprint: string;
    canRunOffline: boolean;
    offlineRisks: Array<string>;
  };
};

export type ValidateWorkflowPreflightMutationVariables = Exact<{
  input: WorkflowPreflightInput;
}>;

export type ValidateWorkflowPreflightMutation = {
  __typename?: 'Mutation';
  validateWorkflowPreflight: {
    __typename?: 'PreflightReport';
    workflowId: string;
    canActivate: boolean;
    blockingIssues: Array<{
      __typename?: 'PreflightIssue';
      severity: IssueSeverity;
      issueType: string;
      message: string;
      fix?: string | null;
      stateName?: string | null;
    }>;
    warnings: Array<{
      __typename?: 'PreflightIssue';
      severity: IssueSeverity;
      issueType: string;
      message: string;
      fix?: string | null;
      stateName?: string | null;
    }>;
    dependencyReport: Array<{
      __typename?: 'DependencyCheck';
      dependencyType: DependencyType;
      refId: string;
      existsInYaml: boolean;
      seededToDdb: boolean;
      handlerImplemented: boolean;
      error?: string | null;
    }>;
    simulationReport: {
      __typename?: 'SimulationReport';
      unreachableStates: Array<string>;
      deadEnds: Array<string>;
      unwiredPolicies: Array<string>;
      selfLoopStates: Array<string>;
      totalStates: number;
      reachableStates: number;
    };
    dimensionCoverage: Array<{
      __typename?: 'DimensionCheck';
      dimension: string;
      resolvable: boolean;
      resolutionPath?: string | null;
      missingField?: string | null;
    }>;
  };
};

export type ActivateProductMutationVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  activatedBy: Scalars['String']['input'];
}>;

export type ActivateProductMutation = {
  __typename?: 'Mutation';
  activateProduct: {
    __typename?: 'ProductActivationResult';
    success: boolean;
    error?: string | null;
    tenantProduct?: {
      __typename?: 'TenantProduct';
      productId: string;
      tenantNum: number;
      provisioningStatus: ProductProvisioningStatus;
      activatedAt?: string | null;
      activatedBy?: string | null;
      lastStatusChange?: string | null;
      productVersion: string;
      productName: string;
      industry: string;
      jurisdiction: string;
      rulesetCount: number;
      workflowCount: number;
    } | null;
    coverageGaps: Array<{
      __typename?: 'ActivationCoverageGap';
      rulesetId: string;
      ruleId: string;
      ruleName: string;
      sectionRef?: string | null;
      description: string;
    }>;
    mandatoryResourceGaps: Array<{
      __typename?: 'ProductMandatoryResourceGap';
      entityType: string;
      statuteRequirement: string;
      rulesetRef?: string | null;
    }>;
  };
};

export type UpdateProductStatusMutationVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  newStatus: ProductProvisioningStatus;
}>;

export type UpdateProductStatusMutation = {
  __typename?: 'Mutation';
  updateProductStatus: {
    __typename?: 'ProductActivationResult';
    success: boolean;
    error?: string | null;
    tenantProduct?: {
      __typename?: 'TenantProduct';
      productId: string;
      provisioningStatus: ProductProvisioningStatus;
      lastStatusChange?: string | null;
    } | null;
  };
};

export type DeactivateProductMutationVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
}>;

export type DeactivateProductMutation = {
  __typename?: 'Mutation';
  deactivateProduct: {
    __typename?: 'ProductActivationResult';
    success: boolean;
    error?: string | null;
    tenantProduct?: {
      __typename?: 'TenantProduct';
      productId: string;
      provisioningStatus: ProductProvisioningStatus;
      lastStatusChange?: string | null;
    } | null;
  };
};

export type EnrollActorMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  initialData?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type EnrollActorMutation = {
  __typename?: 'Mutation';
  enrollActor: {
    __typename?: 'GqlEnrollmentResult';
    success: boolean;
    actorId?: string | null;
    instanceId?: string | null;
    constellationId?: string | null;
    firstTaskId?: string | null;
    error?: string | null;
  };
};

export type FoodServiceCreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;

export type FoodServiceCreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: {
    __typename?: 'FoodServiceOrder';
    id: string;
    orderNumber: string;
    status: FoodServiceOrderStatus;
    brand: string;
    station?: FoodServiceStation | null;
    createdAt: number;
    slaTargetMinutes: number;
    customerName?: string | null;
    deliveryAddress?: string | null;
    items: Array<{
      __typename?: 'FoodServiceOrderItem';
      id: string;
      name: string;
      quantity: number;
      status: FoodServiceDishStatus;
      station: FoodServiceStation;
    }>;
  };
};

export type MyTasksForActorQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  actorId: Scalars['ID']['input'];
  status?: InputMaybe<WorkStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type MyTasksForActorQuery = {
  __typename?: 'Query';
  myTasks: {
    __typename?: 'WorkItemConnection';
    totalCount?: number | null;
    nextCursor?: string | null;
    hasNextPage: boolean;
    items: Array<{
      __typename?: 'WorkItem';
      id: string;
      domain: string;
      workflowType: string;
      status: WorkStatus;
      priority: WorkPriority;
      assignedTo?: string | null;
      title: string;
      createdAt: number;
      updatedAt: number;
      dueAt?: number | null;
      isOverdue: boolean;
      detailSk: string;
    }>;
  };
};

export type GetTeamByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type GetTeamByCodeQuery = {
  __typename?: 'Query';
  getTeam?: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListTeamsByTypeQueryVariables = Exact<{
  teamType: GqlTeamType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListTeamsByTypeQuery = {
  __typename?: 'Query';
  listTeamsByType: Array<{
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type ListChildTeamsQueryVariables = Exact<{
  parentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListChildTeamsQuery = {
  __typename?: 'Query';
  listChildTeams: Array<{
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetTeamHierarchyQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type GetTeamHierarchyQuery = {
  __typename?: 'Query';
  getTeamHierarchy?: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListActiveTeamsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListActiveTeamsQuery = {
  __typename?: 'Query';
  listActiveTeams: Array<{
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetAvailableActorsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableActorsQuery = {
  __typename?: 'Query';
  getAvailableActors: Array<{
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetLeastLoadedActorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetLeastLoadedActorsQuery = {
  __typename?: 'Query';
  getLeastLoadedActors: Array<{
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetActorsWithOpenCircuitBreakerQueryVariables = Exact<{ [key: string]: never }>;

export type GetActorsWithOpenCircuitBreakerQuery = {
  __typename?: 'Query';
  getActorsWithOpenCircuitBreaker: Array<{
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetTeamPresenceQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;

export type GetTeamPresenceQuery = {
  __typename?: 'Query';
  getTeamPresence: Array<{
    __typename?: 'GqlActorPresence';
    actorId: string;
    status: GqlPresenceStatus;
    lastSeen?: string | null;
  }>;
};

export type CompleteTaskForActorMutationVariables = Exact<{
  actorId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
}>;

export type CompleteTaskForActorMutation = {
  __typename?: 'Mutation';
  completeTaskForActor: {
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateActorStatusMutationVariables = Exact<{
  actorId: Scalars['String']['input'];
  status: GqlActorStatus;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateActorStatusMutation = {
  __typename?: 'Mutation';
  updateActorStatus: {
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type ResetCircuitBreakerMutationVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type ResetCircuitBreakerMutation = {
  __typename?: 'Mutation';
  resetCircuitBreaker: {
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type DeprecateActorMutationVariables = Exact<{
  actorId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type DeprecateActorMutation = {
  __typename?: 'Mutation';
  deprecateActor: {
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type AddActorToQueueMutationVariables = Exact<{
  actorId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
}>;

export type AddActorToQueueMutation = {
  __typename?: 'Mutation';
  addActorToQueue: {
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdatePresenceMutationVariables = Exact<{
  status: GqlPresenceStatus;
}>;

export type UpdatePresenceMutation = { __typename?: 'Mutation'; updatePresence: boolean };

export type BackfillTrainingInstancesMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type BackfillTrainingInstancesMutation = {
  __typename?: 'Mutation';
  backfillTrainingInstances: {
    __typename?: 'BackfillTrainingResult';
    createdCount: number;
    skippedCount: number;
    failedActorIds: Array<string>;
  };
};

export type CreateTeamMutationVariables = Exact<{
  input: GqlCreateTeamInput;
}>;

export type CreateTeamMutation = {
  __typename?: 'Mutation';
  createTeam: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateTeamMutationVariables = Exact<{
  code: Scalars['String']['input'];
  input: GqlUpdateTeamInput;
}>;

export type UpdateTeamMutation = {
  __typename?: 'Mutation';
  updateTeam: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  };
};

export type ArchiveTeamMutationVariables = Exact<{
  code: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveTeamMutation = {
  __typename?: 'Mutation';
  archiveTeam: {
    __typename?: 'TeamArchiveResult';
    success: boolean;
    archivedAt: string;
    archivedBy: string;
    reason: string;
    message: string;
    teamCode: string;
    teamName: string;
  };
};

export type MoveTeamMutationVariables = Exact<{
  input: GqlMoveTeamInput;
}>;

export type MoveTeamMutation = {
  __typename?: 'Mutation';
  moveTeam: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  };
};

export type AddTeamStakeholderMutationVariables = Exact<{
  input: GqlAddStakeholderInput;
}>;

export type AddTeamStakeholderMutation = {
  __typename?: 'Mutation';
  addTeamStakeholder: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  };
};

export type RemoveTeamStakeholderMutationVariables = Exact<{
  input: GqlRemoveStakeholderInput;
}>;

export type RemoveTeamStakeholderMutation = {
  __typename?: 'Mutation';
  removeTeamStakeholder: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateTeamQuotasMutationVariables = Exact<{
  input: GqlUpdateTeamQuotasInput;
}>;

export type UpdateTeamQuotasMutation = {
  __typename?: 'Mutation';
  updateTeamQuotas: {
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  };
};

export type ApprovalDetailFieldsFragment = {
  __typename?: 'Approval';
  id: string;
  approvalName: string;
  status: GqlApprovalStatus;
  decision?: GqlApprovalDecision | null;
  approvalType: GqlApprovalType;
  approvalStrategy: GqlApprovalStrategy;
  approverRole: string;
  priority: GqlApprovalPriority;
  requiredApprovals: number;
  currentApprovalCount: number;
  createdAt: string;
  expiresAt?: string | null;
  decidedAt?: string | null;
  startedAt?: string | null;
  reviewedAt?: string | null;
  entityType?: string | null;
  updatedAt: string;
  decisionReason?: string | null;
  rejectionReason?: string | null;
  escalationCount: number;
  tags: Array<string>;
  evidenceUrls: Array<string>;
  attachments: Array<string>;
  comments: Array<{
    __typename?: 'GqlApprovalComment';
    commentId: string;
    actorId: string;
    comment: string;
    timestamp: string;
    parentCommentId?: string | null;
  }>;
  approvers: Array<{
    __typename?: 'GqlActorApproval';
    actorId: string;
    actorName: string;
    role: string;
    decision: GqlApprovalDecision;
    decidedAt: string;
    comments?: string | null;
  }>;
  decisionHistory: Array<{
    __typename?: 'GqlApprovalDecisionEvent';
    eventId: string;
    actorId: string;
    decision: GqlApprovalDecision;
    timestamp: string;
    reason?: string | null;
  }>;
  approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
};

export type QueueDetailFieldsFragment = {
  __typename?: 'Queue';
  id: string;
  queueName: string;
  queueType: GqlQueueType;
  assignmentStrategy: GqlAssignmentStrategy;
  description: string;
  capacity: number;
  currentSize: number;
  avgWaitTimeSeconds: number;
  processingRatePerHour: number;
  itemsProcessedToday: number;
  oldestItemAgeSeconds: number;
  slaBreachCount: number;
  warningThresholdPercent: number;
  overflowStrategy: GqlOverflowStrategy;
  deduplicationEnabled: boolean;
  priorityBoostEnabled: boolean;
  maxConcurrentAssignments: number;
  assignmentTimeoutSeconds: number;
  performanceAlertEnabled: boolean;
  createdAt: string;
  updatedAt: string;
  createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
};

export type NotificationDetailFieldsFragment = {
  __typename?: 'Notification';
  id: string;
  notificationTitle: string;
  messageTemplate: string;
  notificationType: GqlNotificationTriggerType;
  priority: GqlNotificationPriority;
  channels: Array<GqlNotificationChannel>;
  status: GqlNotificationStatus;
  sentAt?: string | null;
  deliveredAt?: string | null;
  readAt?: string | null;
  deliveryAttempts: number;
  lastDeliveryError?: string | null;
  expiresAt?: string | null;
  recipientActorIds: Array<string>;
  ccActorIds: Array<string>;
  triggerEventId: string;
  triggerEntityId: string;
  triggerEntityType: string;
  relatedTaskIds: Array<string>;
  relatedApprovalIds: Array<string>;
  complianceFrameworks: Array<string>;
  createdAt: string;
  updatedAt: string;
  archived: boolean;
  createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
};

export type GetApprovalQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalId: Scalars['String']['input'];
}>;

export type GetApprovalQuery = {
  __typename?: 'Query';
  approvalApiGetApproval?: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  } | null;
};

export type ListPendingApprovalsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPendingApprovalsQuery = {
  __typename?: 'Query';
  approvalApiListApprovalsByStatus: {
    __typename?: 'GqlApprovalConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Approval';
      id: string;
      approvalName: string;
      status: GqlApprovalStatus;
      decision?: GqlApprovalDecision | null;
      approvalType: GqlApprovalType;
      approvalStrategy: GqlApprovalStrategy;
      approverRole: string;
      priority: GqlApprovalPriority;
      requiredApprovals: number;
      currentApprovalCount: number;
      createdAt: string;
      expiresAt?: string | null;
      decidedAt?: string | null;
      startedAt?: string | null;
      reviewedAt?: string | null;
      entityType?: string | null;
      updatedAt: string;
      decisionReason?: string | null;
      rejectionReason?: string | null;
      escalationCount: number;
      tags: Array<string>;
      evidenceUrls: Array<string>;
      attachments: Array<string>;
      comments: Array<{
        __typename?: 'GqlApprovalComment';
        commentId: string;
        actorId: string;
        comment: string;
        timestamp: string;
        parentCommentId?: string | null;
      }>;
      approvers: Array<{
        __typename?: 'GqlActorApproval';
        actorId: string;
        actorName: string;
        role: string;
        decision: GqlApprovalDecision;
        decidedAt: string;
        comments?: string | null;
      }>;
      decisionHistory: Array<{
        __typename?: 'GqlApprovalDecisionEvent';
        eventId: string;
        actorId: string;
        decision: GqlApprovalDecision;
        timestamp: string;
        reason?: string | null;
      }>;
      approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type ListApprovalsByStatusQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  status: GqlApprovalStatus;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListApprovalsByStatusQuery = {
  __typename?: 'Query';
  approvalApiListApprovalsByStatus: {
    __typename?: 'GqlApprovalConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    total: number;
    items: Array<{
      __typename?: 'Approval';
      id: string;
      status: GqlApprovalStatus;
      decision?: GqlApprovalDecision | null;
      approvalType: GqlApprovalType;
      approvalStrategy: GqlApprovalStrategy;
      approverRole: string;
      createdAt: string;
      expiresAt?: string | null;
      decidedAt?: string | null;
      entityType?: string | null;
      updatedAt: string;
    }>;
  };
};

export type ListApprovalsForApproverQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approverId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListApprovalsForApproverQuery = {
  __typename?: 'Query';
  approvalApiListApprovalsForApprover: {
    __typename?: 'GqlApprovalConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Approval';
      id: string;
      approvalName: string;
      status: GqlApprovalStatus;
      decision?: GqlApprovalDecision | null;
      approvalType: GqlApprovalType;
      approvalStrategy: GqlApprovalStrategy;
      approverRole: string;
      priority: GqlApprovalPriority;
      requiredApprovals: number;
      currentApprovalCount: number;
      createdAt: string;
      expiresAt?: string | null;
      decidedAt?: string | null;
      startedAt?: string | null;
      reviewedAt?: string | null;
      entityType?: string | null;
      updatedAt: string;
      decisionReason?: string | null;
      rejectionReason?: string | null;
      escalationCount: number;
      tags: Array<string>;
      evidenceUrls: Array<string>;
      attachments: Array<string>;
      comments: Array<{
        __typename?: 'GqlApprovalComment';
        commentId: string;
        actorId: string;
        comment: string;
        timestamp: string;
        parentCommentId?: string | null;
      }>;
      approvers: Array<{
        __typename?: 'GqlActorApproval';
        actorId: string;
        actorName: string;
        role: string;
        decision: GqlApprovalDecision;
        decidedAt: string;
        comments?: string | null;
      }>;
      decisionHistory: Array<{
        __typename?: 'GqlApprovalDecisionEvent';
        eventId: string;
        actorId: string;
        decision: GqlApprovalDecision;
        timestamp: string;
        reason?: string | null;
      }>;
      approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type ListApprovalsByWorkflowQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListApprovalsByWorkflowQuery = {
  __typename?: 'Query';
  approvalApiListApprovalsByWorkflow: {
    __typename?: 'GqlApprovalConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Approval';
      id: string;
      approvalName: string;
      status: GqlApprovalStatus;
      decision?: GqlApprovalDecision | null;
      approvalType: GqlApprovalType;
      approvalStrategy: GqlApprovalStrategy;
      approverRole: string;
      priority: GqlApprovalPriority;
      requiredApprovals: number;
      currentApprovalCount: number;
      createdAt: string;
      expiresAt?: string | null;
      decidedAt?: string | null;
      startedAt?: string | null;
      reviewedAt?: string | null;
      entityType?: string | null;
      updatedAt: string;
      decisionReason?: string | null;
      rejectionReason?: string | null;
      escalationCount: number;
      tags: Array<string>;
      evidenceUrls: Array<string>;
      attachments: Array<string>;
      comments: Array<{
        __typename?: 'GqlApprovalComment';
        commentId: string;
        actorId: string;
        comment: string;
        timestamp: string;
        parentCommentId?: string | null;
      }>;
      approvers: Array<{
        __typename?: 'GqlActorApproval';
        actorId: string;
        actorName: string;
        role: string;
        decision: GqlApprovalDecision;
        decidedAt: string;
        comments?: string | null;
      }>;
      decisionHistory: Array<{
        __typename?: 'GqlApprovalDecisionEvent';
        eventId: string;
        actorId: string;
        decision: GqlApprovalDecision;
        timestamp: string;
        reason?: string | null;
      }>;
      approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type ListApprovalsInChainQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalChainId: Scalars['String']['input'];
}>;

export type ListApprovalsInChainQuery = {
  __typename?: 'Query';
  approvalApiListApprovalsInChain: Array<{
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type GetPendingApprovalsCountQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approverId: Scalars['String']['input'];
}>;

export type GetPendingApprovalsCountQuery = {
  __typename?: 'Query';
  approvalApiGetPendingApprovalsCount: number;
};

export type ListEscalatedApprovalsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListEscalatedApprovalsQuery = {
  __typename?: 'Query';
  approvalApiListApprovalsByStatus: {
    __typename?: 'GqlApprovalConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Approval';
      id: string;
      approvalName: string;
      status: GqlApprovalStatus;
      decision?: GqlApprovalDecision | null;
      approvalType: GqlApprovalType;
      approvalStrategy: GqlApprovalStrategy;
      approverRole: string;
      priority: GqlApprovalPriority;
      requiredApprovals: number;
      currentApprovalCount: number;
      createdAt: string;
      expiresAt?: string | null;
      decidedAt?: string | null;
      startedAt?: string | null;
      reviewedAt?: string | null;
      entityType?: string | null;
      updatedAt: string;
      decisionReason?: string | null;
      rejectionReason?: string | null;
      escalationCount: number;
      tags: Array<string>;
      evidenceUrls: Array<string>;
      attachments: Array<string>;
      comments: Array<{
        __typename?: 'GqlApprovalComment';
        commentId: string;
        actorId: string;
        comment: string;
        timestamp: string;
        parentCommentId?: string | null;
      }>;
      approvers: Array<{
        __typename?: 'GqlActorApproval';
        actorId: string;
        actorName: string;
        role: string;
        decision: GqlApprovalDecision;
        decidedAt: string;
        comments?: string | null;
      }>;
      decisionHistory: Array<{
        __typename?: 'GqlApprovalDecisionEvent';
        eventId: string;
        actorId: string;
        decision: GqlApprovalDecision;
        timestamp: string;
        reason?: string | null;
      }>;
      approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type CreateApprovalMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  input: GqlCreateApprovalInput;
}>;

export type CreateApprovalMutation = {
  __typename?: 'Mutation';
  approvalApiCreateApproval: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type RecordApprovalDecisionMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalId: Scalars['String']['input'];
  input: GqlRecordDecisionInput;
}>;

export type RecordApprovalDecisionMutation = {
  __typename?: 'Mutation';
  approvalApiRecordApprovalDecision: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type AddApprovalCommentMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalId: Scalars['String']['input'];
  input: GqlAddCommentInput;
}>;

export type AddApprovalCommentMutation = {
  __typename?: 'Mutation';
  approvalApiAddApprovalComment: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type EscalateApprovalMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalId: Scalars['String']['input'];
  input: GqlEscalateApprovalInput;
}>;

export type EscalateApprovalMutation = {
  __typename?: 'Mutation';
  approvalApiEscalateApproval: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type DelegateApprovalMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalId: Scalars['String']['input'];
  input: GqlDelegateApprovalInput;
}>;

export type DelegateApprovalMutation = {
  __typename?: 'Mutation';
  approvalApiDelegateApproval: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type UpdateApprovalMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  approvalId: Scalars['String']['input'];
  input: GqlUpdateApprovalInput;
}>;

export type UpdateApprovalMutation = {
  __typename?: 'Mutation';
  approvalApiUpdateApproval: {
    __typename?: 'Approval';
    id: string;
    approvalName: string;
    status: GqlApprovalStatus;
    decision?: GqlApprovalDecision | null;
    approvalType: GqlApprovalType;
    approvalStrategy: GqlApprovalStrategy;
    approverRole: string;
    priority: GqlApprovalPriority;
    requiredApprovals: number;
    currentApprovalCount: number;
    createdAt: string;
    expiresAt?: string | null;
    decidedAt?: string | null;
    startedAt?: string | null;
    reviewedAt?: string | null;
    entityType?: string | null;
    updatedAt: string;
    decisionReason?: string | null;
    rejectionReason?: string | null;
    escalationCount: number;
    tags: Array<string>;
    evidenceUrls: Array<string>;
    attachments: Array<string>;
    comments: Array<{
      __typename?: 'GqlApprovalComment';
      commentId: string;
      actorId: string;
      comment: string;
      timestamp: string;
      parentCommentId?: string | null;
    }>;
    approvers: Array<{
      __typename?: 'GqlActorApproval';
      actorId: string;
      actorName: string;
      role: string;
      decision: GqlApprovalDecision;
      decidedAt: string;
      comments?: string | null;
    }>;
    decisionHistory: Array<{
      __typename?: 'GqlApprovalDecisionEvent';
      eventId: string;
      actorId: string;
      decision: GqlApprovalDecision;
      timestamp: string;
      reason?: string | null;
    }>;
    approverActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type GetQueueQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
}>;

export type GetQueueQuery = {
  __typename?: 'Query';
  getQueue?: {
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  } | null;
};

export type ListQueuesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListQueuesQuery = {
  __typename?: 'Query';
  listQueues: {
    __typename?: 'GqlQueueConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Queue';
      id: string;
      queueName: string;
      queueType: GqlQueueType;
      assignmentStrategy: GqlAssignmentStrategy;
      description: string;
      capacity: number;
      currentSize: number;
      avgWaitTimeSeconds: number;
      processingRatePerHour: number;
      itemsProcessedToday: number;
      oldestItemAgeSeconds: number;
      slaBreachCount: number;
      warningThresholdPercent: number;
      overflowStrategy: GqlOverflowStrategy;
      deduplicationEnabled: boolean;
      priorityBoostEnabled: boolean;
      maxConcurrentAssignments: number;
      assignmentTimeoutSeconds: number;
      performanceAlertEnabled: boolean;
      createdAt: string;
      updatedAt: string;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type GetQueuesByWorkflowInstanceQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
}>;

export type GetQueuesByWorkflowInstanceQuery = {
  __typename?: 'Query';
  getQueuesByWorkflowInstance: Array<{
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type GetQueueStatisticsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
}>;

export type GetQueueStatisticsQuery = {
  __typename?: 'Query';
  getQueueStatistics: {
    __typename?: 'GqlQueueStatistics';
    queueId: string;
    currentSize: number;
    utilizationPercent: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    slaBreachCount: number;
    isOverThreshold: boolean;
  };
};

export type GetOverloadedQueuesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetOverloadedQueuesQuery = {
  __typename?: 'Query';
  getOverloadedQueues: Array<{
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type GetQueuesWithSlaBreachesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetQueuesWithSlaBreachesQuery = {
  __typename?: 'Query';
  getQueuesWithSlaBreaches: Array<{
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type ApprovalEnqueueTaskMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
  input: GqlEnqueueTaskInput;
}>;

export type ApprovalEnqueueTaskMutation = {
  __typename?: 'Mutation';
  enqueueTask: {
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type ApprovalDequeueTaskMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
}>;

export type ApprovalDequeueTaskMutation = { __typename?: 'Mutation'; dequeueTask?: string | null };

export type ApprovalPauseQueueMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
}>;

export type ApprovalPauseQueueMutation = {
  __typename?: 'Mutation';
  pauseQueue: {
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type ApprovalResumeQueueMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
}>;

export type ApprovalResumeQueueMutation = {
  __typename?: 'Mutation';
  resumeQueue: {
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type ApprovalDrainQueueMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
}>;

export type ApprovalDrainQueueMutation = {
  __typename?: 'Mutation';
  drainQueue: {
    __typename?: 'Queue';
    id: string;
    queueName: string;
    queueType: GqlQueueType;
    assignmentStrategy: GqlAssignmentStrategy;
    description: string;
    capacity: number;
    currentSize: number;
    avgWaitTimeSeconds: number;
    processingRatePerHour: number;
    itemsProcessedToday: number;
    oldestItemAgeSeconds: number;
    slaBreachCount: number;
    warningThresholdPercent: number;
    overflowStrategy: GqlOverflowStrategy;
    deduplicationEnabled: boolean;
    priorityBoostEnabled: boolean;
    maxConcurrentAssignments: number;
    assignmentTimeoutSeconds: number;
    performanceAlertEnabled: boolean;
    createdAt: string;
    updatedAt: string;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  };
};

export type GetNotificationQueryVariables = Exact<{
  notificationId: Scalars['String']['input'];
}>;

export type GetNotificationQuery = {
  __typename?: 'Query';
  getNotification?: {
    __typename?: 'Notification';
    id: string;
    notificationTitle: string;
    messageTemplate: string;
    notificationType: GqlNotificationTriggerType;
    priority: GqlNotificationPriority;
    channels: Array<GqlNotificationChannel>;
    status: GqlNotificationStatus;
    sentAt?: string | null;
    deliveredAt?: string | null;
    readAt?: string | null;
    deliveryAttempts: number;
    lastDeliveryError?: string | null;
    expiresAt?: string | null;
    recipientActorIds: Array<string>;
    ccActorIds: Array<string>;
    triggerEventId: string;
    triggerEntityId: string;
    triggerEntityType: string;
    relatedTaskIds: Array<string>;
    relatedApprovalIds: Array<string>;
    complianceFrameworks: Array<string>;
    createdAt: string;
    updatedAt: string;
    archived: boolean;
    createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  } | null;
};

export type ListNotificationsForRecipientQueryVariables = Exact<{
  recipientActorId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListNotificationsForRecipientQuery = {
  __typename?: 'Query';
  listNotificationsForRecipient: {
    __typename?: 'GqlNotificationConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Notification';
      id: string;
      notificationTitle: string;
      messageTemplate: string;
      notificationType: GqlNotificationTriggerType;
      priority: GqlNotificationPriority;
      channels: Array<GqlNotificationChannel>;
      status: GqlNotificationStatus;
      sentAt?: string | null;
      deliveredAt?: string | null;
      readAt?: string | null;
      deliveryAttempts: number;
      lastDeliveryError?: string | null;
      expiresAt?: string | null;
      recipientActorIds: Array<string>;
      ccActorIds: Array<string>;
      triggerEventId: string;
      triggerEntityId: string;
      triggerEntityType: string;
      relatedTaskIds: Array<string>;
      relatedApprovalIds: Array<string>;
      complianceFrameworks: Array<string>;
      createdAt: string;
      updatedAt: string;
      archived: boolean;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type ListNotificationsByStatusQueryVariables = Exact<{
  status: GqlNotificationStatus;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListNotificationsByStatusQuery = {
  __typename?: 'Query';
  listNotificationsByStatus: {
    __typename?: 'GqlNotificationConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Notification';
      id: string;
      notificationTitle: string;
      messageTemplate: string;
      notificationType: GqlNotificationTriggerType;
      priority: GqlNotificationPriority;
      channels: Array<GqlNotificationChannel>;
      status: GqlNotificationStatus;
      sentAt?: string | null;
      deliveredAt?: string | null;
      readAt?: string | null;
      deliveryAttempts: number;
      lastDeliveryError?: string | null;
      expiresAt?: string | null;
      recipientActorIds: Array<string>;
      ccActorIds: Array<string>;
      triggerEventId: string;
      triggerEntityId: string;
      triggerEntityType: string;
      relatedTaskIds: Array<string>;
      relatedApprovalIds: Array<string>;
      complianceFrameworks: Array<string>;
      createdAt: string;
      updatedAt: string;
      archived: boolean;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type ListNotificationsByTenantQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListNotificationsByTenantQuery = {
  __typename?: 'Query';
  listNotificationsByTenant: {
    __typename?: 'GqlNotificationConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Notification';
      id: string;
      notificationTitle: string;
      messageTemplate: string;
      notificationType: GqlNotificationTriggerType;
      priority: GqlNotificationPriority;
      channels: Array<GqlNotificationChannel>;
      status: GqlNotificationStatus;
      sentAt?: string | null;
      deliveredAt?: string | null;
      readAt?: string | null;
      deliveryAttempts: number;
      lastDeliveryError?: string | null;
      expiresAt?: string | null;
      recipientActorIds: Array<string>;
      ccActorIds: Array<string>;
      triggerEventId: string;
      triggerEntityId: string;
      triggerEntityType: string;
      relatedTaskIds: Array<string>;
      relatedApprovalIds: Array<string>;
      complianceFrameworks: Array<string>;
      createdAt: string;
      updatedAt: string;
      archived: boolean;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type ApprovalListNotificationsByTriggerQueryVariables = Exact<{
  triggerEntityType: Scalars['String']['input'];
  triggerEntityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ApprovalListNotificationsByTriggerQuery = {
  __typename?: 'Query';
  listNotificationsByTrigger: {
    __typename?: 'GqlNotificationConnection';
    total: number;
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Notification';
      id: string;
      notificationTitle: string;
      messageTemplate: string;
      notificationType: GqlNotificationTriggerType;
      priority: GqlNotificationPriority;
      channels: Array<GqlNotificationChannel>;
      status: GqlNotificationStatus;
      sentAt?: string | null;
      deliveredAt?: string | null;
      readAt?: string | null;
      deliveryAttempts: number;
      lastDeliveryError?: string | null;
      expiresAt?: string | null;
      recipientActorIds: Array<string>;
      ccActorIds: Array<string>;
      triggerEventId: string;
      triggerEntityId: string;
      triggerEntityType: string;
      relatedTaskIds: Array<string>;
      relatedApprovalIds: Array<string>;
      complianceFrameworks: Array<string>;
      createdAt: string;
      updatedAt: string;
      archived: boolean;
      createdByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      updatedByActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type GetUnreadNotificationCountQueryVariables = Exact<{
  recipientActorId: Scalars['String']['input'];
}>;

export type GetUnreadNotificationCountQuery = { __typename?: 'Query'; getUnreadCount: number };

export type GetAiTaskGuidanceMutationVariables = Exact<{
  input: GetTaskGuidanceInput;
}>;

export type GetAiTaskGuidanceMutation = {
  __typename?: 'Mutation';
  getAiTaskGuidance: {
    __typename?: 'ComposeWorkflowResponse';
    response: string;
    processingTimeMs: number;
    stopReason: string;
  };
};

export type GenerateTaskInstructionsPdfMutationVariables = Exact<{
  input: GenerateTaskInstructionsInput;
}>;

export type GenerateTaskInstructionsPdfMutation = {
  __typename?: 'Mutation';
  generateTaskInstructionsPdf: {
    __typename?: 'GenerateReportPdfResult';
    documentId: string;
    message: string;
  };
};

export type DelegateTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
  toUserId: Scalars['String']['input'];
}>;

export type DelegateTaskMutation = {
  __typename?: 'Mutation';
  delegateTask?: {
    __typename?: 'InboxTask';
    dueAt?: string | null;
    entityRef: string;
    assignees: Array<string>;
  } | null;
};

export type RecordDocumentApprovalDecisionMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  approverId: Scalars['String']['input'];
  decision: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;

export type RecordDocumentApprovalDecisionMutation = {
  __typename?: 'Mutation';
  documentApiRecordDocumentApprovalDecision: {
    __typename?: 'Document';
    documentName: string;
    category: string;
    accessLevel: AccessLevel;
    createdAt: string;
    updatedAt: string;
  };
};

export type RecordPriorAuthApprovalMutationVariables = Exact<{
  input: RecordPriorAuthApprovalInput;
}>;

export type RecordPriorAuthApprovalMutation = {
  __typename?: 'Mutation';
  recordPriorAuthApproval: {
    __typename?: 'PriorAuthApprovalResult';
    authNumber: string;
    outboxQueued: boolean;
    recordedAt: string;
    subjectActorId: string;
  };
};

export type SubmitTemplateForApprovalMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;

export type SubmitTemplateForApprovalMutation = {
  __typename?: 'Mutation';
  templateApiSubmitTemplateForApproval: {
    __typename?: 'GqlTemplateApprovalConfig';
    requiresApproval: boolean;
    requiredApprovals: number;
    deadlineHours: number;
    roles: Array<string>;
    confidenceThreshold: number;
    currentConfidence: number;
    additionalReviewRequired: boolean;
    additionalReviewReason?: string | null;
  };
};

export type GetPendingApprovalTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPendingApprovalTemplatesQuery = {
  __typename?: 'Query';
  templateApiGetPendingApprovalTemplates: Array<{
    __typename?: 'Template';
    id: string;
    name: string;
    status: GqlTemplateStatus;
    version: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetAuditApprovalChainQueryVariables = Exact<{
  auditId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type GetAuditApprovalChainQuery = {
  __typename?: 'Query';
  getAuditApprovalChain: Array<{
    __typename?: 'AuditQL';
    id: string;
    auditName: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type ElevateForTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ElevateForTaskMutation = {
  __typename?: 'Mutation';
  elevateForTask?: { __typename?: 'JitGrant'; expiresAt: string; role: string } | null;
};

export type ApproverPlanQueueQueryVariables = Exact<{
  authorityRole: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ApproverPlanQueueQuery = {
  __typename?: 'Query';
  approverPlanQueue: Array<{
    __typename?: 'PlanQueueItem';
    planId: string;
    subjectId: string;
    subjectName: string;
    planType: string;
    status: PlanStatus;
    version: number;
    createdAt: number;
    updatedAt?: number | null;
    requiredAuthorityRole: string;
    isInitial: boolean;
    daysUntilExpiry?: number | null;
    tenantId: string;
  }>;
};

export type ReviewerPlanQueueQueryVariables = Exact<{
  reviewerRole: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ReviewerPlanQueueQuery = {
  __typename?: 'Query';
  reviewerPlanQueue: Array<{
    __typename?: 'PlanQueueItem';
    planId: string;
    subjectId: string;
    subjectName: string;
    planType: string;
    status: PlanStatus;
    version: number;
    createdAt: number;
    updatedAt?: number | null;
    requiredReviewerRole?: string | null;
    isInitial: boolean;
    daysUntilExpiry?: number | null;
    tenantId: string;
  }>;
};

export type PlanVersionComparisonQueryVariables = Exact<{
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type PlanVersionComparisonQuery = {
  __typename?: 'Query';
  planVersionComparison: {
    __typename?: 'PlanComparison';
    subjectId: string;
    subjectName: string;
    isInitial: boolean;
    daysUntilExpiry?: number | null;
    priorVersion?: {
      __typename?: 'PlanVersion';
      version: number;
      createdAt: number;
      createdBy: string;
      summary?: string | null;
    } | null;
    proposedVersion: {
      __typename?: 'PlanVersion';
      version: number;
      createdAt: number;
      createdBy: string;
      summary?: string | null;
    };
    changes: Array<{
      __typename?: 'PlanChange';
      changeType: PlanChangeType;
      field: string;
      previousValue?: string | null;
      newValue?: string | null;
    }>;
  };
};

export type PriorPlanVersionQueryVariables = Exact<{
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type PriorPlanVersionQuery = {
  __typename?: 'Query';
  priorPlanVersion?: {
    __typename?: 'PlanVersion';
    version: number;
    createdAt: number;
    createdBy: string;
    summary?: string | null;
    activityDomains: Array<{
      __typename?: 'ActivityDomain';
      domainId: string;
      domainName: string;
      category?: string | null;
    }>;
  } | null;
};

export type ServicePlanQueryVariables = Exact<{
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type ServicePlanQuery = {
  __typename?: 'Query';
  servicePlan?: {
    __typename?: 'ServicePlan';
    id: string;
    subjectId: string;
    subjectName: string;
    planType: string;
    status: PlanStatus;
    version: number;
    createdAt: number;
    updatedAt?: number | null;
    effectiveStart?: number | null;
    effectiveEnd?: number | null;
    approvedBy?: string | null;
    approvedAt?: number | null;
    reviewedBy?: string | null;
    reviewedAt?: number | null;
    reviewNotes?: string | null;
    tenantId: string;
    activityDomains: Array<{
      __typename?: 'ActivityDomain';
      domainId: string;
      domainName: string;
      category?: string | null;
      observations: Array<string>;
    }>;
  } | null;
};

export type ServicePlansBySubjectQueryVariables = Exact<{
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  status?: InputMaybe<PlanStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ServicePlansBySubjectQuery = {
  __typename?: 'Query';
  servicePlansBySubject: Array<{
    __typename?: 'ServicePlan';
    id: string;
    subjectId: string;
    subjectName: string;
    planType: string;
    status: PlanStatus;
    version: number;
    createdAt: number;
    updatedAt?: number | null;
    effectiveStart?: number | null;
    effectiveEnd?: number | null;
    approvedBy?: string | null;
    approvedAt?: number | null;
    tenantId: string;
    activityDomains: Array<{
      __typename?: 'ActivityDomain';
      domainId: string;
      domainName: string;
      category?: string | null;
    }>;
  }>;
};

export type ShiftWorkItemsQueryVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  actorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WorkItemStatus>;
  itemType?: InputMaybe<WorkItemType>;
}>;

export type ShiftWorkItemsQuery = {
  __typename?: 'Query';
  shiftWorkItems: Array<{
    __typename?: 'ShiftWorkItem';
    itemId: string;
    itemType: WorkItemType;
    subjectId: string;
    subjectName: string;
    scheduledTime: number;
    windowStart?: number | null;
    windowEnd?: number | null;
    status: WorkItemStatus;
    priority?: number | null;
    assignedActorId?: string | null;
    label: string;
    instructions?: string | null;
    category?: string | null;
    tenantId: string;
  }>;
};

export type ItemsNeedingActionQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  itemType?: InputMaybe<WorkItemType>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ItemsNeedingActionQuery = {
  __typename?: 'Query';
  itemsNeedingAction: Array<{
    __typename?: 'ActionableItem';
    actionReason: string;
    suggestedAction?: string | null;
    urgency: number;
    timeUntilEscalation?: number | null;
    item: {
      __typename?: 'ShiftWorkItem';
      itemId: string;
      itemType: WorkItemType;
      subjectId: string;
      subjectName: string;
      scheduledTime: number;
      windowStart?: number | null;
      windowEnd?: number | null;
      status: WorkItemStatus;
      priority?: number | null;
      assignedActorId?: string | null;
      label: string;
      instructions?: string | null;
      category?: string | null;
      tenantId: string;
    };
  }>;
};

export type ShiftScheduleQueryVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type ShiftScheduleQuery = {
  __typename?: 'Query';
  shiftSchedule?: {
    __typename?: 'ShiftSchedule';
    scheduleId: string;
    name: string;
    startTime: number;
    endTime: number;
    totalItems: number;
    completedItems: number;
    pendingItems: number;
    overdueItems: number;
    assignedActorIds: Array<string>;
    tenantId: string;
  } | null;
};

export type ShiftSchedulesQueryVariables = Exact<{
  startTime: Scalars['Int']['input'];
  endTime: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
  actorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ShiftSchedulesQuery = {
  __typename?: 'Query';
  shiftSchedules: Array<{
    __typename?: 'ShiftSchedule';
    scheduleId: string;
    name: string;
    startTime: number;
    endTime: number;
    totalItems: number;
    completedItems: number;
    pendingItems: number;
    overdueItems: number;
    assignedActorIds: Array<string>;
    tenantId: string;
  }>;
};

export type ShiftWorkItemsBySubjectQueryVariables = Exact<{
  subjectId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type ShiftWorkItemsBySubjectQuery = {
  __typename?: 'Query';
  shiftWorkItemsBySubject: Array<{
    __typename?: 'ShiftWorkItem';
    itemId: string;
    itemType: WorkItemType;
    subjectId: string;
    subjectName: string;
    scheduledTime: number;
    windowStart?: number | null;
    windowEnd?: number | null;
    status: WorkItemStatus;
    priority?: number | null;
    assignedActorId?: string | null;
    label: string;
    instructions?: string | null;
    category?: string | null;
    tenantId: string;
  }>;
};

export type ControlledItemCountQueryVariables = Exact<{
  constraintId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ControlledItemCountQuery = {
  __typename?: 'Query';
  controlledItemCount: {
    __typename?: 'ControlledItemCount';
    constraintId: string;
    constraintName: string;
    expectedCount: number;
    actualCount: number;
    variance: number;
    withinTolerance: boolean;
    tolerance: number;
    lastVerifiedAt?: number | null;
    verifiedBy?: string | null;
    locationId?: string | null;
    itemCount: number;
    tenantId: string;
  };
};

export type ControlledItemsNeedingVerificationQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  constraintType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ControlledItemsNeedingVerificationQuery = {
  __typename?: 'Query';
  controlledItemsNeedingVerification: Array<{
    __typename?: 'ControlledItem';
    itemId: string;
    name: string;
    constraintId: string;
    constraintName: string;
    quantity: number;
    unit: string;
    locationId?: string | null;
    locationName?: string | null;
    lastVerifiedAt?: number | null;
    lastVerifiedBy?: string | null;
    nextVerificationDue?: number | null;
    status: ControlledItemStatus;
    tenantId: string;
  }>;
};

export type ControlledItemQueryVariables = Exact<{
  itemId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type ControlledItemQuery = {
  __typename?: 'Query';
  controlledItem?: {
    __typename?: 'ControlledItem';
    itemId: string;
    name: string;
    constraintId: string;
    constraintName: string;
    quantity: number;
    unit: string;
    locationId?: string | null;
    locationName?: string | null;
    lastVerifiedAt?: number | null;
    lastVerifiedBy?: string | null;
    nextVerificationDue?: number | null;
    status: ControlledItemStatus;
    tenantId: string;
  } | null;
};

export type ControlledItemsByConstraintQueryVariables = Exact<{
  constraintId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  status?: InputMaybe<ControlledItemStatus>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ControlledItemsByConstraintQuery = {
  __typename?: 'Query';
  controlledItemsByConstraint: Array<{
    __typename?: 'ControlledItem';
    itemId: string;
    name: string;
    constraintId: string;
    constraintName: string;
    quantity: number;
    unit: string;
    locationId?: string | null;
    locationName?: string | null;
    lastVerifiedAt?: number | null;
    lastVerifiedBy?: string | null;
    nextVerificationDue?: number | null;
    status: ControlledItemStatus;
    tenantId: string;
  }>;
};

export type InventoryConstraintQueryVariables = Exact<{
  constraintId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type InventoryConstraintQuery = {
  __typename?: 'Query';
  inventoryConstraint?: {
    __typename?: 'InventoryConstraint';
    constraintId: string;
    name: string;
    description?: string | null;
    regulatoryReference?: string | null;
    verificationFrequencySeconds?: number | null;
    requiredWitnesses: number;
    requiresDualSignature: boolean;
    varianceTolerance: number;
    tenantId: string;
  } | null;
};

export type InventoryConstraintsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type InventoryConstraintsQuery = {
  __typename?: 'Query';
  inventoryConstraints: Array<{
    __typename?: 'InventoryConstraint';
    constraintId: string;
    name: string;
    description?: string | null;
    regulatoryReference?: string | null;
    verificationFrequencySeconds?: number | null;
    requiredWitnesses: number;
    requiresDualSignature: boolean;
    varianceTolerance: number;
    tenantId: string;
  }>;
};

export type VerificationHistoryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  constraintId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<VerificationStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type VerificationHistoryQuery = {
  __typename?: 'Query';
  verificationHistory: Array<{
    __typename?: 'VerificationResult';
    verificationId: string;
    constraintId: string;
    verifiedAt: number;
    primaryVerifierId: string;
    witnessIds: Array<string>;
    expectedCount: number;
    actualCount: number;
    variance: number;
    status: VerificationStatus;
    notes?: string | null;
    discrepancyReportId?: string | null;
    tenantId: string;
  }>;
};

export type ProductCatalogQueryVariables = Exact<{
  industry?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
}>;

export type ProductCatalogQuery = {
  __typename?: 'Query';
  productCatalog: Array<{
    __typename?: 'GqlProductDefinition';
    productId: string;
    version: string;
    name: string;
    description?: string | null;
    status: string;
    brand?: string | null;
    provisioningStatus: string;
    industry: string;
    jurisdiction: string;
    subgraphs: Array<string>;
    primaryRuleset?: string | null;
    requiredRulesets: Array<string>;
    recommendedRulesets: Array<string>;
    activatesWorkflows: Array<string>;
    activatesTaskGroups: Array<string>;
    activatesOverrides: Array<string>;
    activatesConstellations: Array<string>;
    activatesSettings: Array<string>;
    onboardingLenses: Array<string>;
  }>;
};

export type ProductCatalogEntryQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;

export type ProductCatalogEntryQuery = {
  __typename?: 'Query';
  productCatalogEntry?: {
    __typename?: 'GqlProductDefinition';
    productId: string;
    version: string;
    name: string;
    description?: string | null;
    status: string;
    brand?: string | null;
    provisioningStatus: string;
    industry: string;
    jurisdiction: string;
    subgraphs: Array<string>;
    primaryRuleset?: string | null;
    requiredRulesets: Array<string>;
    recommendedRulesets: Array<string>;
    activatesWorkflows: Array<string>;
    activatesTaskGroups: Array<string>;
    activatesOverrides: Array<string>;
    activatesConstellations: Array<string>;
    activatesSettings: Array<string>;
    onboardingLenses: Array<string>;
  } | null;
};

export type TenantProductsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type TenantProductsQuery = {
  __typename?: 'Query';
  tenantProducts: Array<{
    __typename?: 'TenantProduct';
    productId: string;
    tenantNum: number;
    productName: string;
    productVersion: string;
    provisioningStatus: ProductProvisioningStatus;
    activatedAt?: string | null;
    activatedBy?: string | null;
    lastStatusChange?: string | null;
    industry: string;
    jurisdiction: string;
    rulesetCount: number;
    workflowCount: number;
  }>;
};

export type TenantProductQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
}>;

export type TenantProductQuery = {
  __typename?: 'Query';
  tenantProduct?: {
    __typename?: 'TenantProduct';
    productId: string;
    tenantNum: number;
    productName: string;
    productVersion: string;
    provisioningStatus: ProductProvisioningStatus;
    activatedAt?: string | null;
    activatedBy?: string | null;
    lastStatusChange?: string | null;
    industry: string;
    jurisdiction: string;
    rulesetCount: number;
    workflowCount: number;
  } | null;
};

export type ConfigProposalsQueryVariables = Exact<{ [key: string]: never }>;

export type ConfigProposalsQuery = {
  __typename?: 'Query';
  configProposals: Array<{
    __typename?: 'ConfigProposal';
    proposalId: string;
    configType: string;
    sourceRule: string;
    status: string;
    displayName: string;
    description: string;
    generatedAt: string;
    filePath: string;
  }>;
};

export type ListDraftsQueryVariables = Exact<{
  input: ListDraftsInput;
}>;

export type ListDraftsQuery = {
  __typename?: 'Query';
  formsListDrafts: Array<{
    __typename?: 'DraftListItem';
    tenant: string;
    kind: string;
    key: string;
    owner: string;
    updatedBy: string;
    updatedMs: number;
    deleted: boolean;
    data?: Record<string, unknown> | null;
  }>;
};

export type BasicIsEnrolledQueryVariables = Exact<{ [key: string]: never }>;

export type BasicIsEnrolledQuery = { __typename?: 'Query'; basicIsEnrolled: boolean };

export type BasicGetCurrentEnrollmentFlowQueryVariables = Exact<{ [key: string]: never }>;

export type BasicGetCurrentEnrollmentFlowQuery = {
  __typename?: 'Query';
  basicGetCurrentEnrollmentFlow?: {
    __typename?: 'BasicEnrollmentFlow';
    flowId: string;
    status: BasicEnrollmentFlowStatus;
    currentStep: number;
    trigger: BasicEnrollmentPromptType;
    createdAt: string;
    updatedAt: string;
    steps: Array<{
      __typename?: 'BasicEnrollmentStep';
      stepNumber: number;
      title: string;
      description: string;
      status: BasicEnrollmentStepStatus;
      canSkip: boolean;
      completedAt?: string | null;
    }>;
  } | null;
};

export type BasicGetEnrollmentPromptQueryVariables = Exact<{ [key: string]: never }>;

export type BasicGetEnrollmentPromptQuery = {
  __typename?: 'Query';
  basicGetEnrollmentPrompt?: {
    __typename?: 'BasicEnrollmentPrompt';
    promptType: BasicEnrollmentPromptType;
    title: string;
    message: string;
    priority: number;
    canSkip: boolean;
    skipReason?: string | null;
  } | null;
};

export type BasicStartEnrollmentMutationVariables = Exact<{
  input: BasicStartEnrollmentInput;
}>;

export type BasicStartEnrollmentMutation = {
  __typename?: 'Mutation';
  basicStartEnrollment: {
    __typename?: 'BasicEnrollmentFlow';
    flowId: string;
    status: BasicEnrollmentFlowStatus;
    currentStep: number;
    trigger: BasicEnrollmentPromptType;
    createdAt: string;
    updatedAt: string;
    steps: Array<{
      __typename?: 'BasicEnrollmentStep';
      stepNumber: number;
      title: string;
      description: string;
      status: BasicEnrollmentStepStatus;
      canSkip: boolean;
      completedAt?: string | null;
    }>;
  };
};

export type BasicCompleteEnrollmentStepMutationVariables = Exact<{
  input: BasicCompleteEnrollmentStepInput;
}>;

export type BasicCompleteEnrollmentStepMutation = {
  __typename?: 'Mutation';
  basicCompleteEnrollmentStep: {
    __typename?: 'BasicEnrollmentFlow';
    flowId: string;
    status: BasicEnrollmentFlowStatus;
    currentStep: number;
    updatedAt: string;
    steps: Array<{
      __typename?: 'BasicEnrollmentStep';
      stepNumber: number;
      title: string;
      description: string;
      status: BasicEnrollmentStepStatus;
      canSkip: boolean;
      completedAt?: string | null;
    }>;
  };
};

export type BasicSkipEnrollmentStepMutationVariables = Exact<{
  input: BasicSkipEnrollmentStepInput;
}>;

export type BasicSkipEnrollmentStepMutation = {
  __typename?: 'Mutation';
  basicSkipEnrollmentStep: {
    __typename?: 'BasicEnrollmentFlow';
    flowId: string;
    status: BasicEnrollmentFlowStatus;
    currentStep: number;
    updatedAt: string;
    steps: Array<{
      __typename?: 'BasicEnrollmentStep';
      stepNumber: number;
      status: BasicEnrollmentStepStatus;
    }>;
  };
};

export type ListFormSchemaDraftsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type ListFormSchemaDraftsQuery = {
  __typename?: 'Query';
  listFormSchemaDrafts: Array<{
    __typename?: 'FormSchemaDraftSummaryOutput';
    draftId: string;
    subgraph: string;
    entityType: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    editCount: number;
  }>;
};

export type GetScheduleOpsQueryVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;

export type GetScheduleOpsQuery = {
  __typename?: 'Query';
  getSchedule?: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSchedulesOpsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListSchedulesOpsQuery = {
  __typename?: 'Query';
  listSchedules: {
    __typename?: 'GqlScheduleConnection';
    nextCursor?: string | null;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Schedule';
      scheduleId: string;
      scheduleName: string;
      scheduleCode: string;
      cronExpression?: string | null;
      timezone: string;
      scheduleStatus: GqlScheduleStatus;
      scheduleType: GqlScheduleType;
      schedulePriority: GqlSchedulePriority;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type GetActiveSchedulesOpsQueryVariables = Exact<{ [key: string]: never }>;

export type GetActiveSchedulesOpsQuery = {
  __typename?: 'Query';
  getActiveSchedules: Array<{
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetLifeCriticalSchedulesOpsQueryVariables = Exact<{ [key: string]: never }>;

export type GetLifeCriticalSchedulesOpsQuery = {
  __typename?: 'Query';
  getLifeCriticalSchedules: Array<{
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetDueSchedulesOpsQueryVariables = Exact<{
  withinMinutes: Scalars['Int']['input'];
}>;

export type GetDueSchedulesOpsQuery = {
  __typename?: 'Query';
  getDueSchedules: Array<{
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetScheduleExecutionSummaryOpsQueryVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;

export type GetScheduleExecutionSummaryOpsQuery = {
  __typename?: 'Query';
  getScheduleExecutionSummary: {
    __typename?: 'GqlScheduleExecutionSummary';
    scheduleId: string;
    totalExecutions: number;
    successfulExecutions: number;
    failedExecutions: number;
    missedExecutions: number;
    averageExecutionTimeMs: number;
  };
};

export type GetWorkflowOpsQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;

export type GetWorkflowOpsQuery = {
  __typename?: 'Query';
  getWorkflow?: {
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  } | null;
};

export type ListWorkflowsOpsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListWorkflowsOpsQuery = {
  __typename?: 'Query';
  listWorkflows: {
    __typename?: 'WorkflowConnection';
    totalCount: number;
    hasNextPage: boolean;
    items: Array<{
      __typename?: 'Workflow';
      id: string;
      name: string;
      displayName: string;
      version: string;
      description?: string | null;
      initialState: string;
      active: boolean;
      timeoutSeconds?: number | null;
      executionStrategy?: string | null;
      criticality: string;
      complianceLevel?: string | null;
      riskClassification?: string | null;
      complianceFrameworks: Array<string>;
      authorityId?: string | null;
      auditRequirements: Array<string>;
      jurisdictionalScope: Array<string>;
      effectiveDate?: string | null;
      expirationDate?: string | null;
      targetFormulas: Array<string>;
      lastInstantiatedAt?: string | null;
      instantiationCount: number;
      parentVersionId?: string | null;
      originalId?: string | null;
      metadata: Record<string, unknown>;
      recordVersion: number;
      isActive: boolean;
      compressedId?: string | null;
      auditInfo: {
        __typename?: 'WorkflowAuditInfo';
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
        version: number;
      };
      states: Array<{
        __typename?: 'WorkflowState';
        name: string;
        stateType: GqlStateType;
        entryActions: Array<string>;
        exitActions: Array<string>;
        timeoutSeconds?: number | null;
      }>;
      transitions: Array<{
        __typename?: 'WorkflowStateTransition';
        fromState: string;
        toState: string;
        event: string;
        guards: Array<string>;
        actions: Array<string>;
      }>;
      guards: Array<{
        __typename?: 'GuardEntry';
        name: string;
        expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
      }>;
      actions: Array<{
        __typename?: 'ActionEntry';
        name: string;
        definition: {
          __typename?: 'ActionDefinition';
          actionType: GqlActionType;
          configuration: Record<string, unknown>;
        };
      }>;
      retryPolicy?: {
        __typename?: 'WorkflowRetryPolicy';
        maxAttempts: number;
        backoffSeconds: number;
        backoffMultiplier: number;
      } | null;
      regulations: Array<{
        __typename?: 'Regulation';
        id: string;
        name: string;
        framework: string;
        requirement: string;
      }>;
      formulaCompletionRates: Array<{
        __typename?: 'FormulaMetricEntry';
        formulaName: string;
        value: number;
      }>;
      formulaAvgDurations: Array<{
        __typename?: 'FormulaDurationEntry';
        formulaName: string;
        durationSeconds: number;
      }>;
      recommendedExecutionStrategies: Array<{
        __typename?: 'FormulaStrategyEntry';
        formulaName: string;
        strategy: string;
      }>;
      formulaStateCounts: Array<{
        __typename?: 'FormulaStateCountEntry';
        formulaName: string;
        stateCount: number;
      }>;
      formulaErrorRates: Array<{
        __typename?: 'FormulaMetricEntry';
        formulaName: string;
        value: number;
      }>;
    }>;
  };
};

export type ListMyWorkflowsOpsQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type ListMyWorkflowsOpsQuery = {
  __typename?: 'Query';
  listMyWorkflows: Array<{
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  }>;
};

export type ListWorkflowsByStrategyOpsQueryVariables = Exact<{
  strategy: Scalars['String']['input'];
}>;

export type ListWorkflowsByStrategyOpsQuery = {
  __typename?: 'Query';
  listWorkflowsByStrategy: Array<{
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  }>;
};

export type ListActiveWorkflowsOpsQueryVariables = Exact<{ [key: string]: never }>;

export type ListActiveWorkflowsOpsQuery = {
  __typename?: 'Query';
  listActiveWorkflows: Array<{
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  }>;
};

export type ListLifeCriticalWorkflowsOpsQueryVariables = Exact<{ [key: string]: never }>;

export type ListLifeCriticalWorkflowsOpsQuery = {
  __typename?: 'Query';
  listLifeCriticalWorkflows: Array<{
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  }>;
};

export type ValidateWorkflowOpsQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;

export type ValidateWorkflowOpsQuery = {
  __typename?: 'Query';
  validateWorkflow: {
    __typename?: 'WorkflowValidationResult';
    valid: boolean;
    errors: Array<string>;
    warnings: Array<string>;
  };
};

export type GetWorkflowStatisticsOpsQueryVariables = Exact<{ [key: string]: never }>;

export type GetWorkflowStatisticsOpsQuery = {
  __typename?: 'Query';
  getWorkflowStatistics: {
    __typename?: 'WorkflowStatistics';
    totalWorkflows: number;
    activeWorkflows: number;
    lifeCriticalWorkflows: number;
    totalInstantiations: number;
    avgCompletionRate: number;
  };
};

export type ParseWorkflowYamlOpsQueryVariables = Exact<{
  yamlContent: Scalars['String']['input'];
}>;

export type ParseWorkflowYamlOpsQuery = {
  __typename?: 'Query';
  parseWorkflowYaml?: {
    __typename?: 'DagworkflowGQL';
    id: string;
    name: string;
    version: string;
    description?: string | null;
    safetyLevel?: string | null;
    category?: string | null;
    nodes: Array<{
      __typename?: 'DagnodeGQL';
      id: string;
      nodeType: DagnodeTypeEnum;
      label: string;
      criticality: DagcriticalityEnum;
      phaseId?: string | null;
      phaseName?: string | null;
    }>;
    edges: Array<{
      __typename?: 'DagedgeGQL';
      id: string;
      source: string;
      target: string;
      condition?: string | null;
      label?: string | null;
    }>;
  } | null;
};

export type GetCompleteWorkflowOpsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  name: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCompleteWorkflowOpsQuery = {
  __typename?: 'Query';
  formsGetCompleteWorkflow: {
    __typename?: 'CompleteWorkflowData';
    definition?: {
      __typename?: 'WorkflowDefinitionView';
      name: string;
      version: string;
      initialState: string;
      active: boolean;
      states: Array<{
        __typename?: 'StateDefView';
        name: string;
        transitions: Array<{
          __typename?: 'TransitionView';
          signal: string;
          to: string;
          guard?: string | null;
          actions: Array<string>;
        }>;
      }>;
    } | null;
    instances: Array<{
      __typename?: 'WorkflowInstanceView';
      id: string;
      state: string;
      createdAt: string;
    }>;
    actors: Array<{
      __typename?: 'ActorView';
      name: string;
      actorType: string;
      status: string;
      capabilities: Array<string>;
    }>;
    components: Array<{
      __typename?: 'ComponentRefGql';
      id: string;
      componentType: string;
      name: string;
      executionMode: string;
    }>;
  };
};

export type GetWorkflowGraphOpsQueryVariables = Exact<{
  graphId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type GetWorkflowGraphOpsQuery = {
  __typename?: 'Query';
  getWorkflowGraph?: {
    __typename?: 'WorkflowGraph';
    graphId: string;
    tenantId: string;
    graphName: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    nodes: Array<{
      __typename?: 'WorkflowGraphNode';
      id: string;
      label: string;
      nodeType: WorkflowNodeType;
      description?: string | null;
      x: number;
      y: number;
    }>;
    edges: Array<{
      __typename?: 'WorkflowGraphEdge';
      id: string;
      source: string;
      target: string;
      label?: string | null;
      condition?: string | null;
    }>;
  } | null;
};

export type SimulationAvailableTransitionsOpsQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type SimulationAvailableTransitionsOpsQuery = {
  __typename?: 'Query';
  simulationAvailableTransitions: Array<{
    __typename?: 'SimAvailableTransition';
    event: string;
    toState: string;
    guardNames: Array<string>;
  }>;
};

export type SimulationHistoryOpsQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type SimulationHistoryOpsQuery = {
  __typename?: 'Query';
  simulationHistory: Array<{
    __typename?: 'SimulatedTransition';
    fromState: string;
    toState: string;
    event: string;
    hasUncertainGuards: boolean;
    guardsEvaluated: Array<{
      __typename?: 'GuardResult';
      guardName: string;
      guardType: string;
      outcome: GuardOutcome;
      explanation: string;
    }>;
    actionsPlanned: Array<{
      __typename?: 'PlannedAction';
      actionType: string;
      params: Record<string, unknown>;
      sideEffectsSuppressed: boolean;
      wouldCreate: Array<string>;
    }>;
  }>;
};

export type ListIntegrationsOpsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListIntegrationsOpsQuery = {
  __typename?: 'Query';
  listIntegrations: {
    __typename?: 'IntegrationConnection';
    totalCount: number;
    hasNextPage: boolean;
    endCursor?: string | null;
    nodes: Array<{
      __typename?: 'Integration';
      description: string;
      currentHealthStatus: IntegrationHealthStatus;
      integrationId: string;
      integrationName: string;
      integrationCode: string;
      integrationType: IntegrationType;
      protocol: Protocol;
      baseUrl: string;
      authType: AuthenticationType;
      circuitBreakerState: CircuitBreakerState;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type GetIntegrationOpsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
}>;

export type GetIntegrationOpsQuery = {
  __typename?: 'Query';
  getIntegration?: {
    __typename?: 'Integration';
    description: string;
    avgResponseTimeMs: number;
    consecutiveFailures: number;
    lastHealthCheck?: string | null;
    uptimePercentage: number;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetIntegrationsByTypeOpsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  integrationType: IntegrationType;
}>;

export type GetIntegrationsByTypeOpsQuery = {
  __typename?: 'Query';
  getIntegrationsByType: Array<{
    __typename?: 'Integration';
    description: string;
    currentHealthStatus: IntegrationHealthStatus;
    consecutiveFailures: number;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetIntegrationsByHealthStatusOpsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  healthStatus: IntegrationHealthStatus;
}>;

export type GetIntegrationsByHealthStatusOpsQuery = {
  __typename?: 'Query';
  getIntegrationsByHealthStatus: Array<{
    __typename?: 'Integration';
    description: string;
    avgResponseTimeMs: number;
    consecutiveFailures: number;
    lastHealthCheck?: string | null;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetIntegrationsWithOpenCircuitBreakerOpsQuery = {
  __typename?: 'Query';
  getIntegrationsWithOpenCircuitBreaker: Array<{
    __typename?: 'Integration';
    description: string;
    circuitBreakerState: CircuitBreakerState;
    consecutiveFailures: number;
    lastHealthCheck?: string | null;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetUnhealthyIntegrationsOpsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetUnhealthyIntegrationsOpsQuery = {
  __typename?: 'Query';
  getUnhealthyIntegrations: Array<{
    __typename?: 'Integration';
    description: string;
    currentHealthStatus: IntegrationHealthStatus;
    consecutiveFailures: number;
    avgResponseTimeMs: number;
    lastHealthCheck?: string | null;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetIntegrationsNeedingCredentialRotationOpsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetIntegrationsNeedingCredentialRotationOpsQuery = {
  __typename?: 'Query';
  getIntegrationsNeedingCredentialRotation: Array<{
    __typename?: 'Integration';
    description: string;
    lastCredentialRotation?: string | null;
    credentialRotationDays: number;
    rotateCredentials: boolean;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type TestIntegrationConnectionOpsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
}>;

export type TestIntegrationConnectionOpsMutation = {
  __typename?: 'Mutation';
  testIntegrationConnection: {
    __typename?: 'IntegrationConnectionTestResult';
    integrationId: string;
    success: boolean;
    responseTimeMs: number;
    statusCode?: number | null;
    errorMessage?: string | null;
    testedAt: string;
  };
};

export type UpdateCircuitBreakerStateOpsMutationVariables = Exact<{
  input: UpdateCircuitBreakerInput;
}>;

export type UpdateCircuitBreakerStateOpsMutation = {
  __typename?: 'Mutation';
  updateCircuitBreakerState: {
    __typename?: 'Integration';
    circuitBreakerState: CircuitBreakerState;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    createdAt: string;
    updatedAt: string;
  };
};

export type RotateCredentialsOpsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
}>;

export type RotateCredentialsOpsMutation = {
  __typename?: 'Mutation';
  rotateCredentials: {
    __typename?: 'Integration';
    lastCredentialRotation?: string | null;
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateIntegrationOpsMutationVariables = Exact<{
  input: CreateIntegrationInput;
}>;

export type CreateIntegrationOpsMutation = {
  __typename?: 'Mutation';
  createIntegration: {
    __typename?: 'Integration';
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateIntegrationOpsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  input: CreateIntegrationInput;
}>;

export type UpdateIntegrationOpsMutation = {
  __typename?: 'Mutation';
  updateIntegration: {
    __typename?: 'Integration';
    integrationId: string;
    integrationName: string;
    integrationCode: string;
    integrationType: IntegrationType;
    protocol: Protocol;
    baseUrl: string;
    currentHealthStatus: IntegrationHealthStatus;
    authType: AuthenticationType;
    circuitBreakerState: CircuitBreakerState;
    createdAt: string;
    updatedAt: string;
  };
};

export type ArchiveIntegrationOpsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveIntegrationOpsMutation = {
  __typename?: 'Mutation';
  archiveIntegration: {
    __typename?: 'IntegrationArchiveResult';
    success: boolean;
    integrationId: string;
    integrationName: string;
    reason: string;
    message: string;
    archivedAt: string;
    archivedBy: string;
  };
};

export type UpdateHealthStatusOpsMutationVariables = Exact<{
  input: UpdateHealthStatusInput;
}>;

export type UpdateHealthStatusOpsMutation = {
  __typename?: 'Mutation';
  updateHealthStatus: {
    __typename?: 'IntegrationHealthCheckResult';
    integrationId: string;
    status: IntegrationHealthStatus;
    responseTimeMs: number;
    errorMessage?: string | null;
    checkedAt: string;
  };
};

export type PauseScheduleOpsMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;

export type PauseScheduleOpsMutation = {
  __typename?: 'Mutation';
  pauseSchedule: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  };
};

export type ResumeScheduleOpsMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;

export type ResumeScheduleOpsMutation = {
  __typename?: 'Mutation';
  resumeSchedule: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  };
};

export type DisableScheduleOpsMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;

export type DisableScheduleOpsMutation = {
  __typename?: 'Mutation';
  disableSchedule: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  };
};

export type TriggerScheduleNowOpsMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;

export type TriggerScheduleNowOpsMutation = {
  __typename?: 'Mutation';
  triggerScheduleNow: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateScheduleOpsMutationVariables = Exact<{
  input: GqlCreateScheduleInput;
}>;

export type CreateScheduleOpsMutation = {
  __typename?: 'Mutation';
  createSchedule: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  };
};

export type RecordScheduleExecutionOpsMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
  executionTimeMs: Scalars['Int']['input'];
}>;

export type RecordScheduleExecutionOpsMutation = {
  __typename?: 'Mutation';
  recordExecution: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  };
};

export type ArchiveScheduleOpsMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveScheduleOpsMutation = {
  __typename?: 'Mutation';
  archiveSchedule: {
    __typename?: 'ScheduleArchiveResult';
    success: boolean;
    scheduleId: string;
    scheduleName: string;
    reason: string;
    message: string;
    archivedAt: string;
    archivedBy: string;
  };
};

export type ActivateWorkflowOpsMutationVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;

export type ActivateWorkflowOpsMutation = {
  __typename?: 'Mutation';
  activateWorkflow: {
    __typename?: 'Workflow';
    active: boolean;
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  };
};

export type DeactivateWorkflowOpsMutationVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;

export type DeactivateWorkflowOpsMutation = {
  __typename?: 'Mutation';
  deactivateWorkflow: {
    __typename?: 'Workflow';
    active: boolean;
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  };
};

export type CreateWorkflowOpsMutationVariables = Exact<{
  input: GqlCreateWorkflowInput;
}>;

export type CreateWorkflowOpsMutation = {
  __typename?: 'Mutation';
  createWorkflow: {
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  };
};

export type RecordWorkflowInstantiationOpsMutationVariables = Exact<{
  workflowId: Scalars['String']['input'];
  formulaName?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  completed: Scalars['Boolean']['input'];
  errored: Scalars['Boolean']['input'];
}>;

export type RecordWorkflowInstantiationOpsMutation = {
  __typename?: 'Mutation';
  recordInstantiation: {
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  };
};

export type CloneWorkflowOpsMutationVariables = Exact<{
  sourceWorkflowId: Scalars['String']['input'];
  newVersion: Scalars['String']['input'];
}>;

export type CloneWorkflowOpsMutation = {
  __typename?: 'Mutation';
  cloneWorkflow: {
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  };
};

export type ExecutiveSafetyMetricsQueryVariables = Exact<{
  input: SafetyMetricsInput;
}>;

export type ExecutiveSafetyMetricsQuery = {
  __typename?: 'Query';
  safetyMetricsExecutiveSafetyMetrics: {
    __typename?: 'ExecutiveSafetyMetricsOutput';
    overallSafetyScore: number;
    auditTrailIntegrity: number;
    emergencyResponseTime: number;
    riskLevel: RiskLevelOutput;
    regulatoryCompliance: number;
    lastUpdated: string;
    trend: SafetyTrendOutput;
    domainMetrics: Array<{
      __typename?: 'DomainMetricOutput';
      domain: string;
      name: string;
      value: number;
      target: number;
      trend: number;
    }>;
  };
};

export type GetCriticalEventsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetCriticalEventsQuery = {
  __typename?: 'Query';
  eventApiGetCriticalEvents: Array<{
    __typename?: 'Event';
    id: string;
    eventName: string;
    eventType: GqlEventType;
    entityType: string;
    severity: GqlEventSeverity;
    category: GqlEventCategory;
    changeSummary: string;
    metadata: Record<string, unknown>;
    performedAt: string;
    isActive: boolean;
    tags: Array<string>;
  }>;
};

export type GetCriticalPathQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;

export type GetCriticalPathQuery = {
  __typename?: 'Query';
  dependencyApiGetCriticalPath: {
    __typename?: 'CriticalPathResult';
    criticalPath: Array<string>;
    totalDuration: number;
    criticalTasks: Array<{
      __typename?: 'CriticalTask';
      id: string;
      name: string;
      earliestStart: number;
      latestStart: number;
      slack: number;
    }>;
  };
};

export type GetSafetyEventsByTimerangeQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  severityFilter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetSafetyEventsByTimerangeQuery = {
  __typename?: 'Query';
  formsGetSafetyEventsByTimerange: Array<{
    __typename?: 'SafetyEvent';
    eventId: string;
    tenantId: string;
    timestamp: string;
    createdAt: string;
    category: string;
    severity: string;
    eventType: string;
    ruleId: string;
    description: string;
    safetyScore: number;
    sagaExecutionId?: string | null;
    workflowInstanceId?: string | null;
  }>;
};

export type GetStagedSafetyEventsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  severityThreshold?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetStagedSafetyEventsQuery = {
  __typename?: 'Query';
  formsGetStagedSafetyEvents: Array<{
    __typename?: 'SafetyEvent';
    eventId: string;
    tenantId: string;
    timestamp: string;
    createdAt: string;
    category: string;
    severity: string;
    eventType: string;
    ruleId: string;
    description: string;
    safetyScore: number;
    sagaExecutionId?: string | null;
    workflowInstanceId?: string | null;
  }>;
};

export type SafetyListLifeCriticalSubgraphsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type SafetyListLifeCriticalSubgraphsQuery = {
  __typename?: 'Query';
  listLifeCriticalSubgraphs: { __typename?: 'SubgraphList'; subgraphs: Array<string> };
};

export type FlushSafetyEventsMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;

export type FlushSafetyEventsMutation = { __typename?: 'Mutation'; flushSafetyEvents: number };

export type PersistSafetyEventMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
}>;

export type PersistSafetyEventMutation = {
  __typename?: 'Mutation';
  persistSafetyEvent: {
    __typename?: 'SafetyEvent';
    eventId: string;
    eventType: string;
    severity: string;
    timestamp: string;
    description: string;
    safetyScore: number;
  };
};

export type UpdateSafetyEventMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  input: UpdateSafetyEventInput;
}>;

export type UpdateSafetyEventMutation = {
  __typename?: 'Mutation';
  updateSafetyEvent: {
    __typename?: 'SafetyEvent';
    eventId: string;
    eventType: string;
    severity: string;
    description: string;
    safetyScore: number;
  };
};

export type UpdateCriticalityConfigMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  config: CriticalityConfigInput;
}>;

export type UpdateCriticalityConfigMutation = {
  __typename?: 'Mutation';
  updateCriticalityConfig: boolean;
};

export type EmergencyActionMutationVariables = Exact<{
  emergencyInput: EmergencyControlInput;
}>;

export type EmergencyActionMutation = {
  __typename?: 'Mutation';
  emergencyAction: {
    __typename?: 'EmergencyActionResult';
    actionId: string;
    actionType: EmergencyActionType;
    status: EmergencyActionStatus;
    reason: string;
    initiatedBy: string;
    initiatedAt: string;
    completedAt?: string | null;
    affectedComponents: Array<string>;
    resultMessage?: string | null;
  };
};

export type RequestEmergencyAccessMutationVariables = Exact<{
  input: EmergencyAccessInput;
}>;

export type RequestEmergencyAccessMutation = {
  __typename?: 'Mutation';
  requestEmergencyAccess: {
    __typename?: 'EmergencyAccessToken';
    accessToken: string;
    incidentId: string;
    expiresAt: string;
    durationHours: number;
    scenario: string;
  };
};

export type RevokeEmergencyAccessMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  incidentId: Scalars['String']['input'];
}>;

export type RevokeEmergencyAccessMutation = {
  __typename?: 'Mutation';
  revokeEmergencyAccess: {
    __typename?: 'RevokeEmergencyAccessResult';
    success: boolean;
    incidentId: string;
    revokedAt: string;
    revokedBy: string;
    revokedByName: string;
  };
};

export type EmergencyOverrideRegulatoryThresholdMutationVariables = Exact<{
  input: EmergencyOverrideInput;
}>;

export type EmergencyOverrideRegulatoryThresholdMutation = {
  __typename?: 'Mutation';
  emergencyOverrideRegulatoryThreshold: boolean;
};

export type BreakGlassWallOverrideMutationVariables = Exact<{
  input: BreakGlassOverrideInput;
}>;

export type BreakGlassWallOverrideMutation = {
  __typename?: 'Mutation';
  breakGlassWallOverride: {
    __typename?: 'BreakGlassOverrideResult';
    granted: boolean;
    overrideToken?: string | null;
    expiresAt?: string | null;
    auditEventId: string;
    notificationSent: boolean;
    denialReason?: string | null;
  };
};

export type ListPublishedTemplatesQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;

export type ListPublishedTemplatesQuery = {
  __typename?: 'Query';
  listPublishedTemplates: Array<{
    __typename?: 'TemplateListItem';
    templateId: string;
    templateVersion: string;
    domain: string;
    templateType: string;
    name: string;
    category: string;
    description: string;
    icon?: string | null;
    tags: Array<string>;
    usageCount: number;
  }>;
};

export type TerminologyOverridesQueryVariables = Exact<{ [key: string]: never }>;

export type TerminologyOverridesQuery = { __typename?: 'Query' };

export type CoRespondersForInstanceQueryVariables = Exact<{
  constellationId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  currentActorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CoRespondersForInstanceQuery = {
  __typename?: 'Query';
  formsTaskCoRespondersForInstance: {
    __typename?: 'GqlCoResponderList';
    constellationId: string;
    instanceId: string;
    coResponders: Array<{
      __typename?: 'GqlCoResponder';
      actorId: string;
      taskId: string;
      taskName: string;
      taskType: string;
      status: string;
      isSelf: boolean;
    }>;
  };
};

export type DagWorkflowByIdQueryVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;

export type DagWorkflowByIdQuery = {
  __typename?: 'Query';
  dagWorkflow?: {
    __typename?: 'DagworkflowGQL';
    id: string;
    name: string;
    version: string;
    description?: string | null;
    safetyLevel?: string | null;
    category?: string | null;
    createdAt: string;
    createdBy: string;
    nodes: Array<{
      __typename?: 'DagnodeGQL';
      id: string;
      label: string;
      nodeType: DagnodeTypeEnum;
      criticality: DagcriticalityEnum;
      status?: DagnodeStatusEnum | null;
      phaseId?: string | null;
      phaseName?: string | null;
      phaseOrder?: number | null;
      timeoutMs?: number | null;
      requiredRole?: string | null;
      dependsOn: Array<string>;
    }>;
    edges: Array<{
      __typename?: 'DagedgeGQL';
      id: string;
      source: string;
      target: string;
      condition?: string | null;
      label?: string | null;
    }>;
    phases: Array<{
      __typename?: 'DagworkflowPhaseGQL';
      phaseId: string;
      name: string;
      order: number;
      engine: string;
      description?: string | null;
    }>;
  } | null;
};

export type DagWorkflowDefinitionsQueryVariables = Exact<{ [key: string]: never }>;

export type DagWorkflowDefinitionsQuery = {
  __typename?: 'Query';
  dagWorkflowDefinitions: Array<{
    __typename?: 'DagworkflowGQL';
    id: string;
    name: string;
    version: string;
    description?: string | null;
    safetyLevel?: string | null;
    category?: string | null;
    createdAt: string;
    createdBy: string;
    nodes: Array<{
      __typename?: 'DagnodeGQL';
      id: string;
      label: string;
      nodeType: DagnodeTypeEnum;
      criticality: DagcriticalityEnum;
      status?: DagnodeStatusEnum | null;
      phaseId?: string | null;
      phaseName?: string | null;
      phaseOrder?: number | null;
      timeoutMs?: number | null;
      requiredRole?: string | null;
      dependsOn: Array<string>;
    }>;
    edges: Array<{
      __typename?: 'DagedgeGQL';
      id: string;
      source: string;
      target: string;
      condition?: string | null;
      label?: string | null;
    }>;
    phases: Array<{
      __typename?: 'DagworkflowPhaseGQL';
      phaseId: string;
      name: string;
      order: number;
      engine: string;
      description?: string | null;
    }>;
  }>;
};

export type GetEventsByWorkflowInstanceQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
}>;

export type GetEventsByWorkflowInstanceQuery = {
  __typename?: 'Query';
  eventApiGetEventsByWorkflowInstance: Array<{
    __typename?: 'Event';
    id: string;
    eventName: string;
    eventType: GqlEventType;
    entityType: string;
    severity: GqlEventSeverity;
    category: GqlEventCategory;
    createdAt: string;
    performedAt: string;
  }>;
};

export type GetFhirMedStatementsBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetFhirMedStatementsBySubjectQuery = {
  __typename?: 'Query';
  fhirMedStatementsBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    versionOf?: string | null;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type GetInstanceQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;

export type GetInstanceQuery = {
  __typename?: 'Query';
  instanceApiGetInstance?: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  } | null;
};

export type GetInstanceByCorrelationQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  correlationId: Scalars['String']['input'];
}>;

export type GetInstanceByCorrelationQuery = {
  __typename?: 'Query';
  instanceApiGetInstanceByCorrelation?: {
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  } | null;
};

export type GetInstanceHistoryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;

export type GetInstanceHistoryQuery = {
  __typename?: 'Query';
  instanceApiGetInstanceHistory: Array<{
    __typename?: 'Instance';
    id: string;
    workflowDefinitionId: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    subjectActorId?: string | null;
    currentState: string;
    previousState?: string | null;
    status: GqlInstanceStatus;
    priority: number;
    engineType: GqlExecutionEngine;
    progressPercent: number;
    totalTasks: number;
    completedTasks: number;
    failedTasks: number;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    errorMessage?: string | null;
    errorCode?: string | null;
    failedTaskId?: string | null;
    tags: Array<string>;
    cpuTimeMs?: number | null;
    memoryPeakMb?: number | null;
    dbQueries: number;
    cacheHits: number;
    cacheMisses: number;
    availableTransitions: Array<{
      __typename?: 'GqlAvailableTransition';
      event: string;
      toState: string;
      displayName: string;
      guard?: string | null;
      guardPassed: boolean;
    }>;
  }>;
};

export type GetInstancesByActorQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type GetInstancesByActorQuery = {
  __typename?: 'Query';
  instanceApiGetInstancesByActor: Array<{
    __typename?: 'Instance';
    id: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    status: GqlInstanceStatus;
    currentState: string;
    subjectActorId?: string | null;
    workflowDefinitionId: string;
  }>;
};

export type GetInstancesBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetInstancesBySubjectQuery = {
  __typename?: 'Query';
  instanceApiGetInstancesBySubject: Array<{
    __typename?: 'Instance';
    id: string;
    instanceName?: string | null;
    workflowName: string;
    workflowDescription?: string | null;
    subjectName?: string | null;
    status: GqlInstanceStatus;
    currentState: string;
    subjectActorId?: string | null;
    workflowDefinitionId: string;
  }>;
};

export type GetPendingProposalsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPendingProposalsQuery = {
  __typename?: 'Query';
  pendingProposals: {
    __typename?: 'PendingProposalsSummary';
    totalCount: number;
    ruleCount: number;
    taskGroupCount: number;
    workflowCount: number;
    proposals: Array<{
      __typename?: 'PendingProposal';
      proposalId: string;
      configType: string;
      displayName?: string | null;
      description?: string | null;
      safetyLevel?: string | null;
      status: string;
      sourceRule?: string | null;
      generatedAt?: string | null;
      statuteRef?: string | null;
      trigger?: string | null;
      setting?: string | null;
      subgraph?: string | null;
      edges: Array<{
        __typename?: 'ProposalEdge';
        edgeType: string;
        target: string;
        strength?: string | null;
      }>;
      provisions: Array<{
        __typename?: 'ProposalProvision';
        section: string;
        text: string;
        significance: string;
        requiredConfigTypes: Array<string>;
      }>;
      states: Array<{
        __typename?: 'ProposalWorkflowState';
        name: string;
        stateType: string;
        displayName?: string | null;
        policyRefs: Array<string>;
      }>;
      transitions: Array<{
        __typename?: 'ProposalWorkflowTransition';
        fromState: string;
        toState: string;
        event: string;
      }>;
    }>;
  };
};

export type GetTasksByWorkflowInstanceQueryVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
}>;

export type GetTasksByWorkflowInstanceQuery = {
  __typename?: 'Query';
  taskApiGetTasksByWorkflowInstance: Array<{
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type GetWorkflowQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;

export type GetWorkflowQuery = {
  __typename?: 'Query';
  getWorkflow?: {
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
      policyRefs: Array<string>;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  } | null;
};

export type ListActiveInstancesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListActiveInstancesQuery = {
  __typename?: 'Query';
  instanceApiListActiveInstances: {
    __typename?: 'GqlInstanceConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    total: number;
    items: Array<{
      __typename?: 'Instance';
      id: string;
      workflowDefinitionId: string;
      instanceName?: string | null;
      workflowName: string;
      workflowDescription?: string | null;
      subjectName?: string | null;
      subjectActorId?: string | null;
      currentState: string;
      previousState?: string | null;
      status: GqlInstanceStatus;
      priority: number;
      engineType: GqlExecutionEngine;
      progressPercent: number;
      totalTasks: number;
      completedTasks: number;
      failedTasks: number;
      startedAt?: string | null;
      completedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      version: number;
      parentId?: string | null;
      errorMessage?: string | null;
      errorCode?: string | null;
      failedTaskId?: string | null;
      tags: Array<string>;
      cpuTimeMs?: number | null;
      memoryPeakMb?: number | null;
      dbQueries: number;
      cacheHits: number;
      cacheMisses: number;
      availableTransitions: Array<{
        __typename?: 'GqlAvailableTransition';
        event: string;
        toState: string;
        displayName: string;
        guard?: string | null;
        guardPassed: boolean;
      }>;
    }>;
  };
};

export type ListCheckpointsByWorkflowQueryVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListCheckpointsByWorkflowQuery = {
  __typename?: 'Query';
  listCheckpointsByWorkflow: Array<{
    __typename?: 'Checkpoint';
    id: string;
    checkpointName: string;
    checkpointType: GqlCheckpointType;
    currentStatus: GqlCheckpointStatus;
    snapshotFormat: GqlSnapshotFormat;
    entityType: string;
    isActive: boolean;
    canRollback: boolean;
    rollbackCount: number;
    rollbackStrategy: GqlRollbackStrategy;
    snapshotSizeBytes: number;
    snapshotEncrypted: boolean;
    compressionRatio: number;
    resumeEnabled: boolean;
    retentionDays: number;
    sequenceNumber: number;
    lastAccessedAt?: string | null;
    lastRollbackAt?: string | null;
    lastRollbackReason?: string | null;
    createdAt: string;
    updatedAt: string;
    accessCount: number;
    recoveryAttemptedAt?: string | null;
    recoverySuccess?: boolean | null;
    serializationDurationMs: number;
    stateSnapshot: Record<string, unknown>;
    snapshotChecksum: string;
    deltaFromPrevious?: Record<string, unknown> | null;
    autoArchiveAt?: string | null;
    resumeTimeoutSeconds: number;
    maxResumeAttempts: number;
    rollbackOrder: number;
    metadata: Record<string, unknown>;
    parentId?: string | null;
    originalId?: string | null;
    compressedId?: string | null;
    recoveredByActor?: {
      __typename?: 'ActorSummary';
      id: string;
      displayName: string;
      role?: string | null;
    } | null;
    createdByActor?: {
      __typename?: 'ActorSummary';
      id: string;
      displayName: string;
      role?: string | null;
    } | null;
  }>;
};

export type ListContractsByWorkflowQueryVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListContractsByWorkflowQuery = {
  __typename?: 'Query';
  listContractsByWorkflow: {
    __typename?: 'GqlContractConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Contract';
      id: string;
      tenantId: string;
      slaName: string;
      slug?: string | null;
      externalId?: string | null;
      entityType: string;
      entityId: string;
      workflowInstanceId: string;
      notificationActorIds: Array<string>;
      notificationChannels: Array<string>;
      notificationAtPercent: Array<number>;
      startedAt?: string | null;
      currentStatus: GqlContractStatus;
      elapsedMinutes?: string | null;
      lastCheckedAt?: string | null;
      paused: boolean;
      responseTimeMinutes: string;
      resolutionTimeMinutes: string;
      warningThresholdPercent: number;
      escalateAfterMinutes: string;
      escalationChain: Array<string>;
      breachCount: string;
      complianceRate: number;
      lastBreachAt?: string | null;
      createdAt: string;
      updatedAt: string;
      createdBy: string;
      metadata: Record<string, unknown>;
      compressedId?: string | null;
    }>;
  };
};

export type ListDependenciesByWorkflowQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListDependenciesByWorkflowQuery = {
  __typename?: 'Query';
  dependencyApiListDependenciesByWorkflow: {
    __typename?: 'DependencyConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Dependency';
      id: string;
      name: string;
      description?: string | null;
      dependencyType: GqlDependencyType;
      isConditional: boolean;
      status: GqlDependencyStatus;
      active: boolean;
      version: number;
    }>;
  };
};

export type ListInstancesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListInstancesQuery = {
  __typename?: 'Query';
  instanceApiListInstances: {
    __typename?: 'GqlInstanceConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    total: number;
    items: Array<{
      __typename?: 'Instance';
      id: string;
      workflowDefinitionId: string;
      instanceName?: string | null;
      workflowName: string;
      workflowDescription?: string | null;
      subjectName?: string | null;
      subjectActorId?: string | null;
      currentState: string;
      previousState?: string | null;
      status: GqlInstanceStatus;
      priority: number;
      engineType: GqlExecutionEngine;
      progressPercent: number;
      totalTasks: number;
      completedTasks: number;
      failedTasks: number;
      startedAt?: string | null;
      completedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      version: number;
      parentId?: string | null;
      errorMessage?: string | null;
      errorCode?: string | null;
      failedTaskId?: string | null;
      tags: Array<string>;
      cpuTimeMs?: number | null;
      memoryPeakMb?: number | null;
      dbQueries: number;
      cacheHits: number;
      cacheMisses: number;
      availableTransitions: Array<{
        __typename?: 'GqlAvailableTransition';
        event: string;
        toState: string;
        displayName: string;
        guard?: string | null;
        guardPassed: boolean;
      }>;
    }>;
  };
};

export type ListInstancesByStatusQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  status: GqlInstanceStatus;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListInstancesByStatusQuery = {
  __typename?: 'Query';
  instanceApiListInstancesByStatus: {
    __typename?: 'GqlInstanceConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    total: number;
    items: Array<{
      __typename?: 'Instance';
      id: string;
      workflowDefinitionId: string;
      instanceName?: string | null;
      workflowName: string;
      workflowDescription?: string | null;
      subjectName?: string | null;
      subjectActorId?: string | null;
      currentState: string;
      previousState?: string | null;
      status: GqlInstanceStatus;
      priority: number;
      engineType: GqlExecutionEngine;
      progressPercent: number;
      totalTasks: number;
      completedTasks: number;
      failedTasks: number;
      startedAt?: string | null;
      completedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      version: number;
      parentId?: string | null;
      errorMessage?: string | null;
      errorCode?: string | null;
      failedTaskId?: string | null;
      tags: Array<string>;
      cpuTimeMs?: number | null;
      memoryPeakMb?: number | null;
      dbQueries: number;
      cacheHits: number;
      cacheMisses: number;
      availableTransitions: Array<{
        __typename?: 'GqlAvailableTransition';
        event: string;
        toState: string;
        displayName: string;
        guard?: string | null;
        guardPassed: boolean;
      }>;
    }>;
  };
};

export type ListInstancesByWorkflowQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListInstancesByWorkflowQuery = {
  __typename?: 'Query';
  instanceApiListInstancesByWorkflow: {
    __typename?: 'GqlInstanceConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    total: number;
    items: Array<{
      __typename?: 'Instance';
      id: string;
      workflowDefinitionId: string;
      instanceName?: string | null;
      workflowName: string;
      workflowDescription?: string | null;
      subjectName?: string | null;
      subjectActorId?: string | null;
      currentState: string;
      previousState?: string | null;
      status: GqlInstanceStatus;
      priority: number;
      engineType: GqlExecutionEngine;
      progressPercent: number;
      totalTasks: number;
      completedTasks: number;
      failedTasks: number;
      startedAt?: string | null;
      completedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      version: number;
      parentId?: string | null;
      errorMessage?: string | null;
      errorCode?: string | null;
      failedTaskId?: string | null;
      tags: Array<string>;
      cpuTimeMs?: number | null;
      memoryPeakMb?: number | null;
      dbQueries: number;
      cacheHits: number;
      cacheMisses: number;
      availableTransitions: Array<{
        __typename?: 'GqlAvailableTransition';
        event: string;
        toState: string;
        displayName: string;
        guard?: string | null;
        guardPassed: boolean;
      }>;
    }>;
  };
};

export type ListMyWorkflowsQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type ListMyWorkflowsQuery = {
  __typename?: 'Query';
  listMyWorkflows: Array<{
    __typename?: 'Workflow';
    id: string;
    name: string;
    displayName: string;
    version: string;
    description?: string | null;
    initialState: string;
    active: boolean;
    timeoutSeconds?: number | null;
    executionStrategy?: string | null;
    criticality: string;
    complianceLevel?: string | null;
    riskClassification?: string | null;
    complianceFrameworks: Array<string>;
    authorityId?: string | null;
    auditRequirements: Array<string>;
    jurisdictionalScope: Array<string>;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    targetFormulas: Array<string>;
    lastInstantiatedAt?: string | null;
    instantiationCount: number;
    parentVersionId?: string | null;
    originalId?: string | null;
    metadata: Record<string, unknown>;
    recordVersion: number;
    isActive: boolean;
    compressedId?: string | null;
    auditInfo: {
      __typename?: 'WorkflowAuditInfo';
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy: string;
      version: number;
    };
    states: Array<{
      __typename?: 'WorkflowState';
      name: string;
      stateType: GqlStateType;
      entryActions: Array<string>;
      exitActions: Array<string>;
      timeoutSeconds?: number | null;
    }>;
    transitions: Array<{
      __typename?: 'WorkflowStateTransition';
      fromState: string;
      toState: string;
      event: string;
      guards: Array<string>;
      actions: Array<string>;
    }>;
    guards: Array<{
      __typename?: 'GuardEntry';
      name: string;
      expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
    }>;
    actions: Array<{
      __typename?: 'ActionEntry';
      name: string;
      definition: {
        __typename?: 'ActionDefinition';
        actionType: GqlActionType;
        configuration: Record<string, unknown>;
      };
    }>;
    retryPolicy?: {
      __typename?: 'WorkflowRetryPolicy';
      maxAttempts: number;
      backoffSeconds: number;
      backoffMultiplier: number;
    } | null;
    regulations: Array<{
      __typename?: 'Regulation';
      id: string;
      name: string;
      framework: string;
      requirement: string;
    }>;
    formulaCompletionRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
    formulaAvgDurations: Array<{
      __typename?: 'FormulaDurationEntry';
      formulaName: string;
      durationSeconds: number;
    }>;
    recommendedExecutionStrategies: Array<{
      __typename?: 'FormulaStrategyEntry';
      formulaName: string;
      strategy: string;
    }>;
    formulaStateCounts: Array<{
      __typename?: 'FormulaStateCountEntry';
      formulaName: string;
      stateCount: number;
    }>;
    formulaErrorRates: Array<{
      __typename?: 'FormulaMetricEntry';
      formulaName: string;
      value: number;
    }>;
  }>;
};

export type ListTracesByWorkflowInstanceQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  workflowInstanceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTracesByWorkflowInstanceQuery = {
  __typename?: 'Query';
  listTracesByWorkflowInstance: {
    __typename?: 'TraceConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Trace';
      id: string;
      traceId: string;
      spanId: string;
      parentSpanId?: string | null;
      operationName: string;
      spanType: GqlTraceSpanType;
      durationMs?: number | null;
      startedAt: string;
      endedAt?: string | null;
      errorMessage?: string | null;
      createdAt: string;
    }>;
  };
};

export type ListWorkflowsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListWorkflowsQuery = {
  __typename?: 'Query';
  listWorkflows: {
    __typename?: 'WorkflowConnection';
    hasNextPage: boolean;
    totalCount: number;
    items: Array<{
      __typename?: 'Workflow';
      id: string;
      name: string;
      displayName: string;
      version: string;
      description?: string | null;
      initialState: string;
      active: boolean;
      timeoutSeconds?: number | null;
      executionStrategy?: string | null;
      criticality: string;
      complianceLevel?: string | null;
      riskClassification?: string | null;
      complianceFrameworks: Array<string>;
      authorityId?: string | null;
      auditRequirements: Array<string>;
      jurisdictionalScope: Array<string>;
      effectiveDate?: string | null;
      expirationDate?: string | null;
      targetFormulas: Array<string>;
      lastInstantiatedAt?: string | null;
      instantiationCount: number;
      parentVersionId?: string | null;
      originalId?: string | null;
      metadata: Record<string, unknown>;
      recordVersion: number;
      isActive: boolean;
      compressedId?: string | null;
      auditInfo: {
        __typename?: 'WorkflowAuditInfo';
        createdAt: string;
        createdBy: string;
        updatedAt: string;
        updatedBy: string;
        version: number;
      };
      states: Array<{
        __typename?: 'WorkflowState';
        name: string;
        stateType: GqlStateType;
        entryActions: Array<string>;
        exitActions: Array<string>;
        timeoutSeconds?: number | null;
      }>;
      transitions: Array<{
        __typename?: 'WorkflowStateTransition';
        fromState: string;
        toState: string;
        event: string;
        guards: Array<string>;
        actions: Array<string>;
      }>;
      guards: Array<{
        __typename?: 'GuardEntry';
        name: string;
        expression: { __typename?: 'GuardExpression'; expression: string; guardType: GqlGuardType };
      }>;
      actions: Array<{
        __typename?: 'ActionEntry';
        name: string;
        definition: {
          __typename?: 'ActionDefinition';
          actionType: GqlActionType;
          configuration: Record<string, unknown>;
        };
      }>;
      retryPolicy?: {
        __typename?: 'WorkflowRetryPolicy';
        maxAttempts: number;
        backoffSeconds: number;
        backoffMultiplier: number;
      } | null;
      regulations: Array<{
        __typename?: 'Regulation';
        id: string;
        name: string;
        framework: string;
        requirement: string;
      }>;
      formulaCompletionRates: Array<{
        __typename?: 'FormulaMetricEntry';
        formulaName: string;
        value: number;
      }>;
      formulaAvgDurations: Array<{
        __typename?: 'FormulaDurationEntry';
        formulaName: string;
        durationSeconds: number;
      }>;
      recommendedExecutionStrategies: Array<{
        __typename?: 'FormulaStrategyEntry';
        formulaName: string;
        strategy: string;
      }>;
      formulaStateCounts: Array<{
        __typename?: 'FormulaStateCountEntry';
        formulaName: string;
        stateCount: number;
      }>;
      formulaErrorRates: Array<{
        __typename?: 'FormulaMetricEntry';
        formulaName: string;
        value: number;
      }>;
    }>;
  };
};

export type ConstellationTaskSummaryQueryVariables = Exact<{
  constellationId: Scalars['String']['input'];
}>;

export type ConstellationTaskSummaryQuery = {
  __typename?: 'Query';
  formsTaskConstellationTaskSummary: {
    __typename?: 'GqlConstellationTaskSummary';
    constellationId: string;
    total: number;
    pending: number;
    inProgress: number;
    completed: number;
    overdue: number;
    byInstance: Array<{
      __typename?: 'GqlInstanceTaskSummary';
      instanceId: string;
      pending: number;
      inProgress: number;
      completed: number;
      overdue: number;
      failed: number;
      aggregateStatus: string;
    }>;
  };
};

export type GetActiveShiftPlanQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  floorId: Scalars['String']['input'];
}>;

export type GetActiveShiftPlanQuery = {
  __typename?: 'Query';
  activeShiftPlan?: {
    __typename?: 'ShiftPlan';
    planId: string;
    tenantId: string;
    floorId: string;
    shiftStart: string;
    shiftEnd: string;
    generatedAt: string;
    version: number;
    replanTrigger?: string | null;
    warnings: Array<string>;
    assignments: Array<{
      __typename?: 'TaskAssignment';
      taskId: string;
      assignedStaffId: string;
      assistStaffId?: string | null;
      subjectId: string;
      scheduledStart: string;
      scheduledEnd: string;
      priorityScore: number;
      continuityScore?: number | null;
      reservationId?: string | null;
      rationale: {
        __typename?: 'AssignmentRationale';
        acuityContribution: number;
        deadlineContribution: number;
        continuityContribution: number;
        resourceContribution: number;
        sequenceContribution: number;
        overrides: Array<string>;
      };
    }>;
    reservations: Array<{
      __typename?: 'PlannedReservation';
      reservationId: string;
      resourceCode: string;
      taskId: string;
      subjectId: string;
      startTime: string;
      endTime: string;
      confirmed: boolean;
    }>;
    staffRoster: Array<{
      __typename?: 'ShiftStaffMember';
      actorId: string;
      roleId: string;
      currentWorkload: number;
      competencies: Array<string>;
      currentLocation?: string | null;
      available: boolean;
    }>;
  } | null;
};

export type GetCoordinationWeightsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoordinationWeightsQuery = {
  __typename?: 'Query';
  coordinationWeights: {
    __typename?: 'CoordinationWeights';
    twoPersonAssistEnabled: boolean;
    cognitiveContinuityEnabled: boolean;
    targetContinuityPercent: number;
    staffingFloors: {
      __typename?: 'StaffingFloors';
      ulpRatioDay: number;
      ulpRatioNight: number;
      ulpRatioMemoryCare: number;
      minimumAwakeStaff: number;
    };
    taskPriorityWeights: {
      __typename?: 'TaskPriorityWeights';
      acuityWeight: number;
      deadlineWeight: number;
      continuityWeight: number;
      resourceWeight: number;
      sequenceWeight: number;
    };
  };
};

export type GetOnboardingTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetOnboardingTasksQuery = {
  __typename?: 'Query';
  taskApiListTasks: {
    __typename?: 'GqlTaskConnection';
    total: number;
    hasMore: boolean;
    items: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
      status: GqlTaskStatus;
      taskGroupRef?: string | null;
      priority: GqlTaskPriority;
    }>;
  };
};

export type GetTaskQueryVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;

export type GetTaskQuery = {
  __typename?: 'Query';
  taskApiGetTask?: {
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  } | null;
};

export type GetTaskEnrichmentContextQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetTaskEnrichmentContextQuery = {
  __typename?: 'Query';
  taskApiTaskEnrichmentContext?: Record<string, unknown> | null;
};

export type GetTaskForDetailPageQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;

export type GetTaskForDetailPageQuery = {
  __typename?: 'Query';
  taskApiGetTaskById?: {
    __typename?: 'Task';
    id: string;
    name: string;
    description: string;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    taskType: GqlTaskType;
    taskGroupRef?: string | null;
    mandateRef?: string | null;
    toolHint?: string | null;
    formSchemaRef?: string | null;
    formComponents: Array<string>;
    formSchemaOverride?: string | null;
    createdBySource: GqlTaskCreatedBySource;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    metadata: Record<string, unknown>;
    version: number;
    outputEntities: Array<{
      __typename?: 'GqlTaskOutputSpec';
      subgraph: string;
      entityType: string;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  } | null;
};

export type GetTaskStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTaskStatisticsQuery = {
  __typename?: 'Query';
  taskApiGetTaskStatistics: {
    __typename?: 'GqlTaskStatistics';
    tenantId: string;
    totalTasks: number;
    pendingCount: number;
    inProgressCount: number;
    completedCount: number;
    failedCount: number;
    avgDurationMs?: string | null;
    avgProgressPercent: number;
    slaBreachedCount: number;
    slaApproachingCount: number;
  };
};

export type GetTasksByActorQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type GetTasksByActorQuery = {
  __typename?: 'Query';
  taskApiGetTasksByActor: Array<{
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type GetTasksByStatusQueryVariables = Exact<{
  status: GqlTaskStatus;
}>;

export type GetTasksByStatusQuery = {
  __typename?: 'Query';
  taskApiGetTasksByStatus: Array<{
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type GetTasksBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetTasksBySubjectQuery = {
  __typename?: 'Query';
  taskApiGetTasksBySubject: Array<{
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type GetTasksByTaskTypeQueryVariables = Exact<{
  taskGroupRef: Scalars['String']['input'];
}>;

export type GetTasksByTaskTypeQuery = {
  __typename?: 'Query';
  taskApiGetTasksByTaskType: Array<{
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type ListTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTasksQuery = {
  __typename?: 'Query';
  taskApiListTasks: {
    __typename?: 'GqlTaskConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Task';
      id: string;
      parentId?: string | null;
      name: string;
      description: string;
      taskType: GqlTaskType;
      assignedAt?: string | null;
      status: GqlTaskStatus;
      priority: GqlTaskPriority;
      startedAt?: string | null;
      completedAt?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      version: number;
      metadata: Record<string, unknown>;
      sequenceOrder?: number | null;
      taskGroupRef?: string | null;
      dependencies: Array<string>;
      dependents: Array<string>;
      scheduledStart?: string | null;
      scheduledEnd?: string | null;
      dueAt?: string | null;
      estimatedDurationMs?: string | null;
      durationMs?: string | null;
      progressPercent?: number | null;
      errorMessage?: string | null;
      retryCount: number;
      maxRetries: number;
      failureStrategy: GqlFailureStrategy;
      createdBySource: GqlTaskCreatedBySource;
      mandateRef?: string | null;
      mandateJurisdiction?: string | null;
      mandateIsOverride?: boolean | null;
      mandateSourceUrl?: string | null;
      violationOutcome?: string | null;
      violationReviewDeadline?: string | null;
      toolHint?: string | null;
      assignedActorId?: string | null;
      subjectActorId?: string | null;
      teamActorId?: string | null;
      checkedOutBy?: string | null;
      checkoutExpiresAt?: string | null;
      mandates: Array<{
        __typename?: 'MandateInfo';
        rulesetId: string;
        rulesetName: string;
        jurisdictionLevel?: string | null;
        provisionRefs: Array<{
          __typename?: 'ProvisionRef';
          ruleId: string;
          sectionRef: string;
          description?: string | null;
        }>;
      }>;
      assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type ListTrainingTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListTrainingTasksQuery = {
  __typename?: 'Query';
  taskApiListTrainingTasks: {
    __typename?: 'GqlTaskConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Task';
      id: string;
      parentId?: string | null;
      name: string;
      description: string;
      taskType: GqlTaskType;
      assignedAt?: string | null;
      status: GqlTaskStatus;
      priority: GqlTaskPriority;
      startedAt?: string | null;
      completedAt?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      version: number;
      metadata: Record<string, unknown>;
      sequenceOrder?: number | null;
      taskGroupRef?: string | null;
      dependencies: Array<string>;
      dependents: Array<string>;
      scheduledStart?: string | null;
      scheduledEnd?: string | null;
      dueAt?: string | null;
      estimatedDurationMs?: string | null;
      durationMs?: string | null;
      progressPercent?: number | null;
      errorMessage?: string | null;
      retryCount: number;
      maxRetries: number;
      failureStrategy: GqlFailureStrategy;
      createdBySource: GqlTaskCreatedBySource;
      mandateRef?: string | null;
      mandateJurisdiction?: string | null;
      mandateIsOverride?: boolean | null;
      mandateSourceUrl?: string | null;
      violationOutcome?: string | null;
      violationReviewDeadline?: string | null;
      toolHint?: string | null;
      assignedActorId?: string | null;
      subjectActorId?: string | null;
      teamActorId?: string | null;
      checkedOutBy?: string | null;
      checkoutExpiresAt?: string | null;
      mandates: Array<{
        __typename?: 'MandateInfo';
        rulesetId: string;
        rulesetName: string;
        jurisdictionLevel?: string | null;
        provisionRefs: Array<{
          __typename?: 'ProvisionRef';
          ruleId: string;
          sectionRef: string;
          description?: string | null;
        }>;
      }>;
      assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
      subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    }>;
  };
};

export type GetTrainingTasksByEmployeeQueryVariables = Exact<{
  employeeActorId: Scalars['String']['input'];
}>;

export type GetTrainingTasksByEmployeeQuery = {
  __typename?: 'Query';
  taskApiGetTrainingTasksByEmployee: Array<{
    __typename?: 'Task';
    id: string;
    parentId?: string | null;
    name: string;
    description: string;
    taskType: GqlTaskType;
    assignedAt?: string | null;
    status: GqlTaskStatus;
    priority: GqlTaskPriority;
    startedAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    version: number;
    metadata: Record<string, unknown>;
    sequenceOrder?: number | null;
    taskGroupRef?: string | null;
    dependencies: Array<string>;
    dependents: Array<string>;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    dueAt?: string | null;
    estimatedDurationMs?: string | null;
    durationMs?: string | null;
    progressPercent?: number | null;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    failureStrategy: GqlFailureStrategy;
    createdBySource: GqlTaskCreatedBySource;
    mandateRef?: string | null;
    mandateJurisdiction?: string | null;
    mandateIsOverride?: boolean | null;
    mandateSourceUrl?: string | null;
    violationOutcome?: string | null;
    violationReviewDeadline?: string | null;
    toolHint?: string | null;
    assignedActorId?: string | null;
    subjectActorId?: string | null;
    teamActorId?: string | null;
    checkedOutBy?: string | null;
    checkoutExpiresAt?: string | null;
    mandates: Array<{
      __typename?: 'MandateInfo';
      rulesetId: string;
      rulesetName: string;
      jurisdictionLevel?: string | null;
      provisionRefs: Array<{
        __typename?: 'ProvisionRef';
        ruleId: string;
        sectionRef: string;
        description?: string | null;
      }>;
    }>;
    assignedActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
    subjectActor?: { __typename?: 'ActorSummary'; id: string; displayName: string } | null;
  }>;
};

export type TaskBreadcrumbQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;

export type TaskBreadcrumbQuery = {
  __typename?: 'Query';
  formsTaskTaskBreadcrumb?: {
    __typename?: 'GqlTaskBreadcrumb';
    taskId: string;
    taskName: string;
    taskStatus: string;
    taskType: string;
    taskGroupRef?: string | null;
    workflowRef?: string | null;
    constellationId?: string | null;
    mandateRef?: string | null;
  } | null;
};

export type TaskCompletionHintsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type TaskCompletionHintsQuery = {
  __typename?: 'Query';
  taskCompletionHints: {
    __typename?: 'TaskCompletionHintsResult';
    inputFieldGuidance: Array<{
      __typename?: 'InputFieldGuidanceOutput';
      fieldName: string;
      hint: string;
      examples: Array<string>;
      validationHelp?: string | null;
    }>;
    quickActions: Array<{
      __typename?: 'QuickActionOutput';
      actionId: string;
      label: string;
      description: string;
      icon?: string | null;
      prefillData?: Record<string, unknown> | null;
    }>;
    contextualInfo: Array<{
      __typename?: 'ContextualInfoOutput';
      key: string;
      value: string;
      source: string;
    }>;
  };
};

export type TaskMetricsQueryVariables = Exact<{
  instanceId?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;

export type TaskMetricsQuery = {
  __typename?: 'Query';
  formsTaskTaskMetrics: {
    __typename?: 'TaskMetrics';
    totalTasks: number;
    completedTasks: number;
    pendingTasks: number;
    inProgressTasks: number;
    overdueTasks: number;
    completionRate: number;
    avgCompletionTime: number;
  };
};

export type GetTaskGroupsForCareGraphQueryVariables = Exact<{
  category?: InputMaybe<TaskGroupCategory>;
}>;

export type GetTaskGroupsForCareGraphQuery = {
  __typename?: 'Query';
  taskGroups: Array<{
    __typename?: 'TaskGroup';
    id: string;
    configId: string;
    name: string;
    category: TaskGroupCategory;
    color?: string | null;
    isLifeCritical: boolean;
  }>;
};

export type ListTaskGroupsQueryVariables = Exact<{
  subgraph?: InputMaybe<Scalars['String']['input']>;
  setting?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<TaskGroupCategory>;
}>;

export type ListTaskGroupsQuery = {
  __typename?: 'Query';
  taskGroups: Array<{
    __typename?: 'TaskGroup';
    id: string;
    configId: string;
    name: string;
    description?: string | null;
    category: TaskGroupCategory;
    setting: string;
    subgraph: string;
    isLifeCritical: boolean;
    completionStrategy: CompletionStrategy;
    color?: string | null;
    icon?: string | null;
    tags: Array<string>;
    children: Array<{ __typename?: 'ChildTask'; id: string; name: string }>;
  }>;
};

export type OrphanTaskGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type OrphanTaskGroupsQuery = {
  __typename?: 'Query';
  orphanTaskGroups: Array<{
    __typename?: 'TaskGroup';
    id: string;
    configId: string;
    name: string;
    category: TaskGroupCategory;
    subgraph: string;
    setting: string;
    isLifeCritical: boolean;
    description?: string | null;
    icon?: string | null;
    color?: string | null;
    tags: Array<string>;
    completionStrategy: CompletionStrategy;
  }>;
};

export type TaskGroupQueryVariables = Exact<{
  subgraph: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;

export type TaskGroupQuery = {
  __typename?: 'Query';
  taskGroup?: {
    __typename?: 'TaskGroup';
    id: string;
    configId: string;
    name: string;
    description?: string | null;
    category: TaskGroupCategory;
    subgraph: string;
    setting: string;
    color?: string | null;
    icon?: string | null;
    isLifeCritical: boolean;
    completionStrategy: CompletionStrategy;
    schedule?: string | null;
    tags: Array<string>;
    children: Array<{
      __typename?: 'ChildTask';
      id: string;
      name: string;
      taskType: ChildTaskType;
      priority: ChildTaskPriority;
      required: boolean;
      isLifeCritical: boolean;
    }>;
  } | null;
};

export type TaskGroupCategoriesQueryVariables = Exact<{
  subgraph: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;

export type TaskGroupCategoriesQuery = {
  __typename?: 'Query';
  taskGroupCategories: Array<{
    __typename?: 'TaskGroupCategoryInfo';
    id: string;
    name: string;
    description: string;
    color: string;
    icon: string;
    groupCount: number;
  }>;
};

export type GeneratedDocumentQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;

export type GeneratedDocumentQuery = {
  __typename?: 'Query';
  generatedDocument?: {
    __typename?: 'GqlDocumentRegistryEntry';
    id: string;
    documentType: GqlGeneratedDocumentType;
    description?: string | null;
    mimeType: string;
    fileSizeBytes: number;
    createdAt: string;
    createdByUserId: string;
    ownerUserId: string;
    expiresAt?: string | null;
    accessCount: number;
    lastAccessedAt?: string | null;
    authRequired: boolean;
    allowedOpenCount?: number | null;
    revoked: boolean;
    revokedAt?: string | null;
    revokedBy?: string | null;
    revokedReason?: string | null;
    sourceEntityId: string;
    sourceEntityType: string;
    jobId?: string | null;
  } | null;
};

export type GetCeremonyStatusQueryVariables = Exact<{
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type GetCeremonyStatusQuery = {
  __typename?: 'Query';
  getCeremonyStatus?: {
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    documentId: string;
    tenantId: string;
    status: CeremonyStatus;
    signingOrder: SigningOrder;
    signedS3Key?: string | null;
    expiresAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    participants: Array<{
      __typename?: 'CeremonyParticipant';
      name: string;
      email: string;
      role: SignerRole;
      status: ParticipantStatus;
      signedAt?: string | null;
      declinedAt?: string | null;
      declineReason?: string | null;
      fieldName: string;
    }>;
    fields: Array<{
      __typename?: 'CeremonyPlacedField';
      fieldIndex: number;
      participantIndex: number;
      fieldType: SignatureFieldType;
      page: number;
      x: number;
      y: number;
      width: number;
      height: number;
      completed: boolean;
    }>;
  } | null;
};

export type GetDocumentQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;

export type GetDocumentQuery = {
  __typename?: 'Query';
  documentApiGetDocument?: {
    __typename?: 'Document';
    documentId: string;
    documentName: string;
    documentType: DocumentType;
    category: string;
    currentStatus: DocumentStatus;
    mimeType: string;
    fileSizeBytes: string;
    storageType: StorageType;
    s3Key?: string | null;
    s3Bucket?: string | null;
    dynamodbContent?: string | null;
    createdAt: string;
    updatedAt: string;
    version: string;
    regulatoryRuleIds: Array<string>;
    regulatoryEvidenceName?: string | null;
  } | null;
};

export type GetDocumentForCeremonyQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;

export type GetDocumentForCeremonyQuery = {
  __typename?: 'Query';
  documentApiGetDocument?: {
    __typename?: 'Document';
    documentId: string;
    documentName: string;
    documentType: DocumentType;
    category: string;
    mimeType: string;
    s3Key?: string | null;
    s3Bucket?: string | null;
  } | null;
};

export type GetDocumentVersionHistoryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;

export type GetDocumentVersionHistoryQuery = {
  __typename?: 'Query';
  documentApiGetDocumentVersionHistory: Array<{
    __typename?: 'DocumentVersionInfo';
    documentId: string;
    version: string;
    changeDescription: string;
    createdAt: string;
    createdBy: string;
    isLatest: boolean;
  }>;
};

export type GetExchangeDocumentsQueryVariables = Exact<{
  relationshipId: Scalars['String']['input'];
}>;

export type GetExchangeDocumentsQuery = {
  __typename?: 'Query';
  exchangeDocuments: Array<{
    __typename?: 'ExchangeDocument';
    documentId: string;
    relationshipId: string;
    senderTenantId: string;
    senderName?: string | null;
    senderActorId: string;
    fileName: string;
    fileType: string;
    fileSizeBytes: number;
    pushedAt: string;
    expiresAt: string;
    downloaded: boolean;
    downloadedAt?: string | null;
  }>;
};

export type ListCeremoniesForDocumentQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type ListCeremoniesForDocumentQuery = {
  __typename?: 'Query';
  listCeremoniesForDocument: Array<{
    __typename?: 'SigningCeremony';
    ceremonyId: string;
    documentId: string;
    tenantId: string;
    status: CeremonyStatus;
    signingOrder: SigningOrder;
    expiresAt?: string | null;
    completedAt?: string | null;
    createdAt: string;
    participants: Array<{
      __typename?: 'CeremonyParticipant';
      name: string;
      email: string;
      role: SignerRole;
      status: ParticipantStatus;
      signedAt?: string | null;
      declinedAt?: string | null;
      fieldName: string;
    }>;
  }>;
};

export type ListCeremonyTemplatesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type ListCeremonyTemplatesQuery = {
  __typename?: 'Query';
  listCeremonyTemplates: Array<{
    __typename?: 'CeremonyTemplateGql';
    templateId: string;
    name: string;
    description?: string | null;
    documentName: string;
    pdfTemplateId?: string | null;
    ordering: string;
    padesProfile?: string | null;
    expiryHours?: number | null;
    createdAt: string;
    createdBy: string;
    tags: Array<string>;
    participants: Array<{
      __typename?: 'CeremonyTemplateParticipantGql';
      roleName: string;
      signingRole: string;
      required: boolean;
      fieldPage?: number | null;
      fieldX?: number | null;
      fieldY?: number | null;
      fieldWidth?: number | null;
      fieldHeight?: number | null;
      fieldType?: string | null;
      appearanceReason?: string | null;
    }>;
  }>;
};

export type ListDocumentsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListDocumentsQuery = {
  __typename?: 'Query';
  documentApiListDocuments: {
    __typename?: 'DocumentConnection';
    hasNextPage: boolean;
    totalCount: number;
    nodes: Array<{
      __typename?: 'Document';
      documentId: string;
      documentName: string;
      documentType: DocumentType;
      category: string;
      currentStatus: DocumentStatus;
      mimeType: string;
      fileSizeBytes: string;
      storageType: StorageType;
      s3Key?: string | null;
      s3Bucket?: string | null;
      dynamodbContent?: string | null;
      createdAt: string;
      updatedAt: string;
      version: string;
      regulatoryRuleIds: Array<string>;
      regulatoryEvidenceName?: string | null;
    }>;
  };
};

export type MyGeneratedDocumentsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  filter?: InputMaybe<DocumentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type MyGeneratedDocumentsQuery = {
  __typename?: 'Query';
  myGeneratedDocuments: {
    __typename?: 'GqlDocumentConnection';
    totalCount: number;
    hasNextPage: boolean;
    endCursor?: string | null;
    nodes: Array<{
      __typename?: 'GqlDocumentRegistryEntry';
      id: string;
      documentType: GqlGeneratedDocumentType;
      description?: string | null;
      mimeType: string;
      fileSizeBytes: number;
      createdAt: string;
      expiresAt?: string | null;
      accessCount: number;
      lastAccessedAt?: string | null;
      revoked: boolean;
    }>;
  };
};

export type PdfTemplateQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;

export type PdfTemplateQuery = {
  __typename?: 'Query';
  pdfTemplate?: {
    __typename?: 'PdfTemplate';
    templateId: string;
    name: string;
    description?: string | null;
    subgraph: string;
    version: string;
    pageSize: string;
    orientation?: string | null;
    variables: Array<string>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PdfTemplatesQueryVariables = Exact<{
  subgraph?: InputMaybe<Scalars['String']['input']>;
}>;

export type PdfTemplatesQuery = {
  __typename?: 'Query';
  pdfTemplates: Array<{
    __typename?: 'PdfTemplate';
    templateId: string;
    name: string;
    description?: string | null;
    subgraph: string;
    version: string;
    pageSize: string;
    orientation?: string | null;
    variables: Array<string>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type RequestDocumentUrlViaTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type RequestDocumentUrlViaTokenQuery = {
  __typename?: 'Query';
  requestDocumentUrlViaToken: {
    __typename?: 'CeremonyDocumentUrl';
    downloadUrl: string;
    fileName: string;
    expiresInSeconds: number;
  };
};

export type TriggerCeremonyRemindersQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type TriggerCeremonyRemindersQuery = {
  __typename?: 'Query';
  triggerCeremonyReminders: number;
};

export type VerifyCeremonySignaturesQueryVariables = Exact<{
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type VerifyCeremonySignaturesQuery = {
  __typename?: 'Query';
  verifyCeremonySignatures: {
    __typename?: 'CeremonySignatureVerification';
    ceremonyId: string;
    documentId: string;
    allValid: boolean;
    verifiedAt: string;
    signatures: Array<{
      __typename?: 'SignatureVerificationResult';
      signerEmail: string;
      signerName: string;
      isValid: boolean;
      signedAt: string;
      certificateSubject: string;
      padesProfile: string;
      reason?: string | null;
      timestampValid: boolean;
      revocationChecked: boolean;
    }>;
  };
};

export type ConstellationsByActorQueryVariables = Exact<{
  actorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConstellationsByActorQuery = {
  __typename?: 'Query';
  constellationsByActor: {
    __typename?: 'ActorConstellationMemberships';
    actorId: string;
    constellationIds: Array<string>;
    memberships: Array<{
      __typename?: 'ActorConstellationMembership';
      constellationId: string;
      ring: number;
      edgeType: string;
      role: string;
    }>;
  };
};

export type GetActorQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type GetActorQuery = {
  __typename?: 'Query';
  getActor?: {
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetActorByIdQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type GetActorByIdQuery = {
  __typename?: 'Query';
  getActor?: {
    __typename?: 'Actor';
    actorGlobalId?: string | null;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    active: boolean;
    available: boolean;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    maxCapacity: number;
    circuitBreakerOpen: boolean;
  } | null;
};

export type GetActorSecurityQueryVariables = Exact<{
  id: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type GetActorSecurityQuery = {
  __typename?: 'Query';
  actorMgmtActor?: {
    __typename?: 'ActorSecurity';
    actorId: string;
    securityLevel: string;
    emergencyAccess: boolean;
    lastSecurityReview: string;
    certificationLevel: string;
    mfaEnabled: boolean;
    mfaVerifiedAt?: string | null;
    biometricEnabled: boolean;
    biometricVerifiedAt?: string | null;
    emergencyAccessLog: Array<{
      __typename?: 'EmergencyAccessEvent';
      eventId: string;
      accessedAt: string;
      reason: string;
      duration: number;
      systemsAccessed: Array<string>;
    }>;
  } | null;
};

export type GetActorStatisticsQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type GetActorStatisticsQuery = {
  __typename?: 'Query';
  getActorStatistics: {
    __typename?: 'GqlActorStatistics';
    actorId: string;
    workload: number;
    maxCapacity: number;
    circuitBreakerOpen: boolean;
    utilizationPercent: number;
    successRate?: number | null;
    avgTaskResponseMinutes?: number | null;
  };
};

export type GetActorsByCapabilityQueryVariables = Exact<{
  capability: Scalars['String']['input'];
}>;

export type GetActorsByCapabilityQuery = {
  __typename?: 'Query';
  getActorsByCapability: Array<{
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetActorsByTeamQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;

export type GetActorsByTeamQuery = {
  __typename?: 'Query';
  getActorsByTeam: Array<{
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetActorsByTypeQueryVariables = Exact<{
  actorType: GqlActorType;
}>;

export type GetActorsByTypeQuery = {
  __typename?: 'Query';
  getActorsByType: Array<{
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MySubjectsQueryVariables = Exact<{ [key: string]: never }>;

export type MySubjectsQuery = {
  __typename?: 'Query';
  mySubjects: Array<{
    __typename?: 'Actor';
    id: string;
    name: string;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    domain?: string | null;
    description?: string | null;
    role?: string | null;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    resolvedScopes: Array<string>;
    configuration: Record<string, unknown>;
    circuitBreakerOpen: boolean;
    circuitBreakerThreshold: number;
    active: boolean;
    available: boolean;
    workload: number;
    maxCapacity: number;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    licenseNumber?: string | null;
    licenseJurisdiction?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetExchangeRelationshipsQueryVariables = Exact<{ [key: string]: never }>;

export type GetExchangeRelationshipsQuery = {
  __typename?: 'Query';
  exchangeRelationships: Array<{
    __typename?: 'ExchangeRelationship';
    relationshipId: string;
    fromTenantId: string;
    toTenantId: string;
    fromTenantName?: string | null;
    toTenantName?: string | null;
    status: ExchangeRelationshipStatus;
    approvalCount: number;
    requiredApprovals: number;
    establishedAt?: string | null;
    expiresAt?: string | null;
    consentRecords: Array<{
      __typename?: 'ExchangeConsentRecord';
      step: ExchangeConsentStep;
      actorId: string;
      tenantId: string;
      consentedAt: string;
      authTier: number;
      witnessVerified: boolean;
    }>;
  }>;
};

export type GetFocusContextQueryVariables = Exact<{ [key: string]: never }>;

export type GetFocusContextQuery = {
  __typename?: 'Query';
  focusContext: {
    __typename?: 'FocusContext';
    subjectActorId?: string | null;
    subjectDisplayName?: string | null;
    perspective: string;
    setAt?: string | null;
    expiresAt?: string | null;
  };
};

export type GetMyActorQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyActorQuery = {
  __typename?: 'Query';
  getMyActor?: {
    __typename?: 'Actor';
    actorGlobalId?: string | null;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    active: boolean;
    available: boolean;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    teamId?: string | null;
    supervisorId?: string | null;
    certifications: Array<string>;
    specializations: Array<string>;
    expertTier?: string | null;
    maxCapacity: number;
    circuitBreakerOpen: boolean;
  } | null;
};

export type GetTeamWorkspaceQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;

export type GetTeamWorkspaceQuery = {
  __typename?: 'Query';
  getTeamWorkspace: {
    __typename?: 'GqlTeamWorkspaceData';
    teamName: string;
    teamDescription?: string | null;
    teamType?: string | null;
    memberCount: number;
    onlineCount: number;
    members: Array<{
      __typename?: 'Actor';
      id: string;
      name: string;
      actorType: GqlActorType;
      active: boolean;
      currentTaskId?: string | null;
      workload: number;
      maxCapacity: number;
      successRate?: number | null;
    }>;
    presence: Array<{
      __typename?: 'GqlActorPresence';
      actorId: string;
      status: GqlPresenceStatus;
      lastSeen?: string | null;
    }>;
  };
};

export type GetTeamWorkspaceSummaryQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;

export type GetTeamWorkspaceSummaryQuery = {
  __typename?: 'Query';
  getTeamWorkspace: {
    __typename?: 'GqlTeamWorkspaceData';
    teamName: string;
    memberCount: number;
    onlineCount: number;
    members: Array<{
      __typename?: 'Actor';
      id: string;
      name: string;
      actorType: GqlActorType;
      workload: number;
      maxCapacity: number;
    }>;
    presence: Array<{
      __typename?: 'GqlActorPresence';
      actorId: string;
      status: GqlPresenceStatus;
    }>;
  };
};

export type ListActorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListActorsQuery = {
  __typename?: 'Query';
  listActors: {
    __typename?: 'GqlActorConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Actor';
      id: string;
      name: string;
      authUserId?: string | null;
      actorType: GqlActorType;
      category?: string | null;
      domain?: string | null;
      description?: string | null;
      role?: string | null;
      primaryRoleId?: string | null;
      roleIds: Array<string>;
      resolvedScopes: Array<string>;
      configuration: Record<string, unknown>;
      circuitBreakerOpen: boolean;
      circuitBreakerThreshold: number;
      active: boolean;
      available: boolean;
      workload: number;
      maxCapacity: number;
      teamId?: string | null;
      supervisorId?: string | null;
      certifications: Array<string>;
      specializations: Array<string>;
      expertTier?: string | null;
      licenseNumber?: string | null;
      licenseJurisdiction?: string | null;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type ListActorsForPanelQueryVariables = Exact<{ [key: string]: never }>;

export type ListActorsForPanelQuery = {
  __typename?: 'Query';
  listActors: {
    __typename?: 'GqlActorConnection';
    items: Array<{
      __typename?: 'Actor';
      id: string;
      name: string;
      actorType: GqlActorType;
      active: boolean;
    }>;
  };
};

export type ListActorsForSelectQueryVariables = Exact<{ [key: string]: never }>;

export type ListActorsForSelectQuery = {
  __typename?: 'Query';
  listActors: {
    __typename?: 'GqlActorConnection';
    items: Array<{
      __typename?: 'Actor';
      id: string;
      name: string;
      actorType: GqlActorType;
      active: boolean;
    }>;
  };
};

export type ListTeamsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListTeamsQuery = {
  __typename?: 'Query';
  listTeams: Array<{
    __typename?: 'Team';
    id: string;
    name: string;
    code: string;
    teamType: GqlTeamType;
    description?: string | null;
    active: boolean;
    level: number;
    path: string;
    parentTeamId?: string | null;
    teamLeadId?: string | null;
    deputyLeadId?: string | null;
    budgetAllocated?: number | null;
    stakeholderIds: Array<string>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MySubjectActorIdsQueryVariables = Exact<{ [key: string]: never }>;

export type MySubjectActorIdsQuery = { __typename?: 'Query'; mySubjectActorIds: Array<string> };

export type SearchActorsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchActorsQuery = {
  __typename?: 'Query';
  searchActors: Array<{
    __typename?: 'Actor';
    actorGlobalId?: string | null;
    authUserId?: string | null;
    actorType: GqlActorType;
    category?: string | null;
    active: boolean;
    available: boolean;
    certifications: Array<string>;
    specializations: Array<string>;
    primaryRoleId?: string | null;
    roleIds: Array<string>;
    teamId?: string | null;
    supervisorId?: string | null;
  }>;
};

export type GetRolePermissionsQueryVariables = Exact<{
  roleId: Scalars['String']['input'];
}>;

export type GetRolePermissionsQuery = {
  __typename?: 'Query';
  getRolePermissions: {
    __typename?: 'EffectivePermissions';
    roleId: string;
    ownPermissions: Array<{
      __typename?: 'Permission';
      resourceType: string;
      action: string;
      condition?: string | null;
      scope: GqlPermissionScope;
    }>;
    inheritedPermissions: Array<{
      __typename?: 'Permission';
      resourceType: string;
      action: string;
      condition?: string | null;
      scope: GqlPermissionScope;
    }>;
    effectivePermissions: Array<{
      __typename?: 'Permission';
      resourceType: string;
      action: string;
      condition?: string | null;
      scope: GqlPermissionScope;
    }>;
  };
};

export type ListRolesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListRolesQuery = {
  __typename?: 'Query';
  listRoles: {
    __typename?: 'RoleConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Role';
      id: string;
      roleName: string;
      description?: string | null;
      roleCategory: GqlRoleCategory;
      permissionMode: GqlPermissionMode;
      active: boolean;
      version: number;
    }>;
  };
};

export type GetNavigationSummaryQueryVariables = Exact<{
  layer: ViewLayer;
}>;

export type GetNavigationSummaryQuery = {
  __typename?: 'Query';
  navigationSummary: Array<{
    __typename?: 'NavigationGroupSummary';
    groupId: string;
    label: string;
    icon: string;
    pendingCount: number;
    urgentCount: number;
    actionLabel: string;
    primaryPath: string;
    sortOrder: number;
  }>;
};

export type GetSettingBundleAdminQueryVariables = Exact<{ [key: string]: never }>;

export type GetSettingBundleAdminQuery = {
  __typename?: 'Query';
  settingBundle: {
    __typename?: 'SettingBundle';
    settingId: string;
    name: string;
    code: string;
    codeSystem: string;
    vertical: string;
    industryLabel: string;
    subjectLabel: string;
    activeLenses: Array<string>;
    regulatoryFrameworks: Array<string>;
    definition: string;
    navigationGroups: Array<{
      __typename?: 'SettingNavigationGroup';
      id: string;
      label: string;
      icon: string;
      layer: string;
      sortOrder: number;
      memberPatterns: Array<string>;
      memberItemScopes: Record<string, unknown>;
      primaryPath?: string | null;
      isStandalone: boolean;
      requiredScopes: Array<string>;
    }>;
  };
};

export type GetSettingNavigationQueryVariables = Exact<{ [key: string]: never }>;

export type GetSettingNavigationQuery = {
  __typename?: 'Query';
  settingBundle: {
    __typename?: 'SettingBundle';
    settingId: string;
    subjectLabel: string;
    fhirLabels: Record<string, unknown>;
    actorTypeLabels: Record<string, unknown>;
    navigationGroups: Array<{
      __typename?: 'SettingNavigationGroup';
      id: string;
      label: string;
      icon: string;
      layer: string;
      sortOrder: number;
      memberPatterns: Array<string>;
      memberItemScopes: Record<string, unknown>;
      actionLabelTemplate?: string | null;
      primaryPath?: string | null;
      isStandalone: boolean;
      requiredScopes: Array<string>;
    }>;
    contextBanner: {
      __typename?: 'ContextBannerConfig';
      enabled: boolean;
      alwaysVisible: boolean;
      maxGroups: number;
      pollIntervalSeconds: number;
    };
    userMenuItems: Array<{
      __typename?: 'SettingUserMenuItem';
      id: string;
      label: string;
      path: string;
      icon: string;
      sortOrder: number;
      requiredScopes: Array<string>;
    }>;
  };
};

export type GetNotificationStatsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type GetNotificationStatsQuery = {
  __typename?: 'Query';
  getNotificationStats: {
    __typename?: 'NotificationStats';
    sentCount: number;
    failedCount: number;
    scheduledCount: number;
    lastSentDate?: string | null;
    nextNotificationDate?: string | null;
  };
};

export type GetNotificationsQueryVariables = Exact<{
  input: GetNotificationsInput;
}>;

export type GetNotificationsQuery = {
  __typename?: 'Query';
  getNotifications: {
    __typename?: 'NotificationList';
    nextToken?: string | null;
    totalCount: number;
    notifications: Array<{
      __typename?: 'TaxNotification';
      pk: string;
      notificationType: string;
      jurisdiction: string;
      category: string;
      effectiveDate: string;
      createdAt: string;
      companyId: string;
    }>;
  };
};

export type GetPolicyQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
}>;

export type GetPolicyQuery = {
  __typename?: 'Query';
  getPolicy?: {
    __typename?: 'Policy';
    id: string;
    name: string;
    description?: string | null;
    policyType: GqlPolicyType;
    scope: GqlPolicyScope;
    implementation: GqlPolicyImplementation;
    enabled: boolean;
    active: boolean;
    auditLevel: GqlAuditLevel;
    version: number;
  } | null;
};

export type GetRegulatoryRuleQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
}>;

export type GetRegulatoryRuleQuery = {
  __typename?: 'Query';
  regulatoryRule?: {
    __typename?: 'GqlRegulatoryRule';
    id: string;
    version: number;
    status: GqlRuleStatus;
    queue: GqlReviewQueue;
    text: string;
    supersedes?: string | null;
    changelog?: string | null;
    requiresHumanReview: boolean;
    createdBy: string;
    createdAt: string;
    reviewerId?: string | null;
    reviewedAt?: string | null;
    reviewComment?: string | null;
    rejectionReason?: string | null;
    conflictingRuleIds: Array<string>;
    structured: {
      __typename?: 'GqlStructuredRule';
      actor: string;
      action: string;
      trigger?: string | null;
      deadline?: string | null;
      evidence: Array<{
        __typename?: 'GqlEvidence';
        name: string;
        description: string;
        required: boolean;
        fhirResource?: string | null;
      }>;
      exceptions: Array<{
        __typename?: 'GqlException';
        condition: string;
        alternativeAction?: string | null;
      }>;
    };
    source: {
      __typename?: 'GqlRuleSource';
      effectiveDate: string;
      sunsetDate?: string | null;
      document: {
        __typename?: 'GqlSourceDocument';
        id: string;
        title: string;
        url?: string | null;
        version?: string | null;
      };
      location: {
        __typename?: 'GqlSourceLocation';
        section: string;
        subdivision?: string | null;
        paragraph?: string | null;
        page?: number | null;
      };
    };
    extraction: {
      __typename?: 'GqlExtractionMetadata';
      confidence: number;
      confidencePercentage: number;
      extractor?: string | null;
      extractedAt?: string | null;
      reviewedBy?: string | null;
      reviewedAt?: string | null;
    };
    classification: {
      __typename?: 'GqlClassification';
      safetyLevel: GqlSafetyLevel;
      complianceDomain: GqlComplianceDomain;
      piiImpact: boolean;
      tags: Array<string>;
    };
  } | null;
};

export type GetRuleSetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetRuleSetQuery = {
  __typename?: 'Query';
  ruleSet?: {
    __typename?: 'RuleSet';
    rulesetId: string;
    name: string;
    displayName: string;
    description: string;
    safetyLevel: string;
    isLifeCritical: boolean;
    jurisdiction: string;
    category: string;
    setting: string;
    appliesToIndustries: Array<string>;
    effectiveDate?: string | null;
    sunsetDate?: string | null;
    complianceFrameworks: Array<string>;
    ruleCount: number;
    ruleIds: Array<string>;
    dependsOn: Array<string>;
    triggerWorkflows: Array<string>;
    affectsWorkflows: Array<string>;
    affectsFormSchemas: Array<string>;
    sourceLegislation?: {
      __typename?: 'SourceLegislation';
      statute: string;
      shortCite: string;
      sections: Array<string>;
      authority: string;
      regnodeRef?: string | null;
      lastAmended?: string | null;
      url?: string | null;
    } | null;
    memberRules: Array<{
      __typename?: 'RuleSummary';
      ruleId: string;
      name: string;
      description: string;
      sectionRef?: string | null;
      evidenceStatus: string;
    }>;
    overridePolicy?: {
      __typename?: 'OverridePolicy';
      direction: string;
      conflictResolution: string;
      documentation?: string | null;
    } | null;
  } | null;
};

export type ListRegulatoryRulesQueryVariables = Exact<{
  filter: RuleFilterInput;
}>;

export type ListRegulatoryRulesQuery = {
  __typename?: 'Query';
  regulatoryRules: Array<{
    __typename?: 'GqlRegulatoryRule';
    id: string;
    version: number;
    status: GqlRuleStatus;
    queue: GqlReviewQueue;
    text: string;
    supersedes?: string | null;
    changelog?: string | null;
    requiresHumanReview: boolean;
    createdBy: string;
    createdAt: string;
    reviewerId?: string | null;
    reviewedAt?: string | null;
    reviewComment?: string | null;
    rejectionReason?: string | null;
    conflictingRuleIds: Array<string>;
    structured: {
      __typename?: 'GqlStructuredRule';
      actor: string;
      action: string;
      trigger?: string | null;
      deadline?: string | null;
      evidence: Array<{
        __typename?: 'GqlEvidence';
        name: string;
        description: string;
        required: boolean;
        fhirResource?: string | null;
      }>;
      exceptions: Array<{
        __typename?: 'GqlException';
        condition: string;
        alternativeAction?: string | null;
      }>;
    };
    source: {
      __typename?: 'GqlRuleSource';
      effectiveDate: string;
      sunsetDate?: string | null;
      document: {
        __typename?: 'GqlSourceDocument';
        id: string;
        title: string;
        url?: string | null;
        version?: string | null;
      };
      location: {
        __typename?: 'GqlSourceLocation';
        section: string;
        subdivision?: string | null;
        paragraph?: string | null;
        page?: number | null;
      };
    };
    extraction: {
      __typename?: 'GqlExtractionMetadata';
      confidence: number;
      confidencePercentage: number;
      extractor?: string | null;
      extractedAt?: string | null;
      reviewedBy?: string | null;
      reviewedAt?: string | null;
    };
    classification: {
      __typename?: 'GqlClassification';
      safetyLevel: GqlSafetyLevel;
      complianceDomain: GqlComplianceDomain;
      piiImpact: boolean;
      tags: Array<string>;
    };
  }>;
};

export type ListRuleSetsQueryVariables = Exact<{
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  effectiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListRuleSetsQuery = {
  __typename?: 'Query';
  ruleSets: Array<{
    __typename?: 'RuleSet';
    rulesetId: string;
    displayName: string;
    description: string;
    safetyLevel: string;
    isLifeCritical: boolean;
    jurisdiction: string;
    category: string;
    setting: string;
    appliesToIndustries: Array<string>;
    effectiveDate?: string | null;
    sunsetDate?: string | null;
    isCurrentlyEffective: boolean;
    supersedes?: string | null;
    supersededBy?: string | null;
    complianceFrameworks: Array<string>;
    ruleCount: number;
    ruleIds: Array<string>;
    dependsOn: Array<string>;
    triggerWorkflows: Array<string>;
    affectsWorkflows: Array<string>;
    affectsFormSchemas: Array<string>;
    sourceLegislation?: {
      __typename?: 'SourceLegislation';
      statute: string;
      shortCite: string;
      sections: Array<string>;
      authority: string;
      regnodeRef?: string | null;
      lastAmended?: string | null;
      url?: string | null;
    } | null;
    memberRules: Array<{
      __typename?: 'RuleSummary';
      ruleId: string;
      name: string;
      description: string;
      sectionRef?: string | null;
      evidenceStatus: string;
    }>;
    overridePolicy?: {
      __typename?: 'OverridePolicy';
      direction: string;
      conflictResolution: string;
      documentation?: string | null;
    } | null;
  }>;
};

export type ListRulesetsQueryVariables = Exact<{ [key: string]: never }>;

export type ListRulesetsQuery = {
  __typename?: 'Query';
  ruleSets: Array<{ __typename?: 'RuleSet'; rulesetId: string; name: string }>;
};

export type PreviewRuleRoutingQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  yamlContent: Scalars['String']['input'];
}>;

export type PreviewRuleRoutingQuery = {
  __typename?: 'Query';
  previewRuleRouting: {
    __typename?: 'GqlRuleImportResult';
    ruleId?: string | null;
    success: boolean;
    warnings: Array<string>;
    routeDecision?: {
      __typename?: 'GqlRouteDecision';
      queue: GqlReviewQueue;
      reason: string;
      confidence: number;
      safetyOverride: boolean;
      conflictsDetected: boolean;
      conflictingRuleIds: Array<string>;
    } | null;
    errors: Array<{ __typename?: 'GqlValidationError'; field: string; message: string }>;
  };
};

export type GetConstellationDetailQueryVariables = Exact<{
  constellationId: Scalars['String']['input'];
}>;

export type GetConstellationDetailQuery = {
  __typename?: 'Query';
  constellationTemplate?: {
    __typename?: 'ConstellationTemplate';
    constellationId: string;
    version: string;
    name: string;
    description?: string | null;
    center: {
      __typename?: 'ConstellationCenter';
      primitiveType: string;
      actorType?: string | null;
      labelTemplate: string;
      description?: string | null;
    };
    rings: Array<{
      __typename?: 'ConstellationTemplateRing';
      ringId: string;
      ringNumber: number;
      label: string;
      description?: string | null;
      edgeTypes: Array<string>;
      color?: string | null;
      shape?: string | null;
    }>;
    appliesTo: Array<{
      __typename?: 'ConstellationScopeBinding';
      scope: string;
      industries: Array<string>;
      centerLabel: string;
    }>;
  } | null;
};

export type GetConstellationTemplateQueryVariables = Exact<{
  constellationId: Scalars['String']['input'];
}>;

export type GetConstellationTemplateQuery = {
  __typename?: 'Query';
  constellationTemplate?: {
    __typename?: 'ConstellationTemplate';
    constellationId: string;
    name: string;
    description?: string | null;
    version: string;
    center: { __typename?: 'ConstellationCenter'; labelTemplate: string; primitiveType: string };
    rings: Array<{
      __typename?: 'ConstellationTemplateRing';
      ringId: string;
      ringNumber: number;
      label: string;
      description?: string | null;
      color?: string | null;
      definitionShows?: string | null;
      edgeTypes: Array<string>;
      definitionNodes: Array<{
        __typename?: 'ConstellationDefinitionNode';
        taskGroupRef: string;
        workflowRef: string;
        department?: string | null;
        ownerRole?: string | null;
        label?: string | null;
        description?: string | null;
      }>;
    }>;
    appliesTo: Array<{
      __typename?: 'ConstellationScopeBinding';
      scope: string;
      industries: Array<string>;
      centerLabel: string;
    }>;
    modes?: {
      __typename?: 'ConstellationModes';
      definition: {
        __typename?: 'ConstellationMode';
        description: string;
        centerSource: string;
        ringSource: string;
        symbolCase: string;
      };
      instance: {
        __typename?: 'ConstellationMode';
        description: string;
        centerSource: string;
        ringSource: string;
        symbolCase: string;
      };
    } | null;
  } | null;
};

export type GetFieldConstellationQueryVariables = Exact<{
  primitiveType: Scalars['String']['input'];
  contextId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetFieldConstellationQuery = {
  __typename?: 'Query';
  fieldConstellation?: {
    __typename?: 'FieldConstellation';
    constellationId: string;
    primitiveType: string;
    version: string;
    description?: string | null;
    totalFieldCount: number;
    promotedFieldCount: number;
    activeContextId?: string | null;
    rings: Array<{
      __typename?: 'ConstellationRing';
      ringId: string;
      ringNumber: number;
      label: string;
      color?: string | null;
      shape?: string | null;
      description?: string | null;
      fieldCount: number;
      highlighted: boolean;
      fields: Array<{
        __typename?: 'ConstellationFieldNode';
        fieldName: string;
        label: string;
        fieldType: string;
        required: boolean;
        description?: string | null;
        enumValues?: Array<string> | null;
        formulaRefs?: Array<string> | null;
        piiClassification?: string | null;
        promoted: boolean;
      }>;
    }>;
    contextProfiles: Array<{
      __typename?: 'ConstellationContextProfile';
      contextId: string;
      name: string;
      description?: string | null;
      verticals: Array<string>;
      lensRef?: string | null;
      promotedFields: Array<string>;
      highlightRings: Array<string>;
    }>;
  } | null;
};

export type ListConstellationTemplatesQueryVariables = Exact<{
  scope?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListConstellationTemplatesQuery = {
  __typename?: 'Query';
  constellationTemplates: Array<{
    __typename?: 'ConstellationTemplate';
    constellationId: string;
    name: string;
    description?: string | null;
    version: string;
    center: { __typename?: 'ConstellationCenter'; labelTemplate: string; primitiveType: string };
    rings: Array<{
      __typename?: 'ConstellationTemplateRing';
      ringId: string;
      ringNumber: number;
      label: string;
      description?: string | null;
      color?: string | null;
      definitionShows?: string | null;
      edgeTypes: Array<string>;
      definitionNodes: Array<{
        __typename?: 'ConstellationDefinitionNode';
        taskGroupRef: string;
        workflowRef: string;
        department?: string | null;
        ownerRole?: string | null;
        label?: string | null;
        description?: string | null;
      }>;
    }>;
    appliesTo: Array<{
      __typename?: 'ConstellationScopeBinding';
      scope: string;
      industries: Array<string>;
      centerLabel: string;
    }>;
    modes?: {
      __typename?: 'ConstellationModes';
      definition: {
        __typename?: 'ConstellationMode';
        description: string;
        centerSource: string;
        ringSource: string;
        symbolCase: string;
      };
      instance: {
        __typename?: 'ConstellationMode';
        description: string;
        centerSource: string;
        ringSource: string;
        symbolCase: string;
      };
    } | null;
  }>;
};

export type GetTemplateVersionDiffQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
  fromVersion: Scalars['Int']['input'];
  toVersion: Scalars['Int']['input'];
}>;

export type GetTemplateVersionDiffQuery = {
  __typename?: 'Query';
  getTemplateVersionDiff: {
    __typename?: 'TemplateVersionDiff';
    fromVersion: number;
    toVersion: number;
    summary: string;
    changes: Array<{
      __typename?: 'TemplateFieldChange';
      fieldPath: string;
      changeType: TemplateChangeType;
      oldValue?: Record<string, unknown> | null;
      newValue?: Record<string, unknown> | null;
    }>;
  };
};

export type ListTemplateVersionsQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;

export type ListTemplateVersionsQuery = {
  __typename?: 'Query';
  listTemplateVersions: Array<{
    __typename?: 'TemplateVersion';
    versionId: string;
    versionNumber: number;
    templateId: string;
    tenantId: string;
    changeDescription: string;
    createdAt: string;
    createdBy: string;
    status: TemplateVersionStatus;
    previousVersionId?: string | null;
  }>;
};

export type ListTemplatesQueryVariables = Exact<{
  limit?: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTemplatesQuery = {
  __typename?: 'Query';
  templateApiListTemplates: {
    __typename?: 'GqlTemplateConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    total: number;
    items: Array<{
      __typename?: 'Template';
      id: string;
      name: string;
      description?: string | null;
      category: string;
      status: GqlTemplateStatus;
      criticality: string;
      complianceLevel?: string | null;
      riskClassification?: string | null;
      active: boolean;
      version: string;
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      updatedBy?: string | null;
    }>;
  };
};

export type RollbackTemplateQueryVariables = Exact<{
  input: RollbackTemplateInput;
}>;

export type RollbackTemplateQuery = {
  __typename?: 'Query';
  rollbackTemplate: {
    __typename?: 'TemplateRollbackResult';
    success: boolean;
    newVersionId: string;
    newVersionNumber: number;
    errorMessage?: string | null;
  };
};

export type GetConstraintQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type GetConstraintQuery = {
  __typename?: 'Query';
  getConstraint?: {
    __typename?: 'Constraint';
    id: string;
    name: string;
    code: string;
    description?: string | null;
    constraintType: GqlConstraintType;
    monitoredEntityId?: string | null;
    monitoredEntityType?: string | null;
    limitValue: number;
    active: boolean;
    currentStatus: GqlConstraintStatus;
    currentUsage: number;
    operator: GqlConstraintOperator;
    unit: string;
    createdAt: string;
    updatedAt: string;
    scope: { __typename?: 'GqlConstraintScope'; scopeType: string; scopeId?: string | null };
  } | null;
};

export type ListConstraintsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListConstraintsQuery = {
  __typename?: 'Query';
  listConstraints: {
    __typename?: 'GqlConstraintConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Constraint';
      id: string;
      name: string;
      code: string;
      description?: string | null;
      constraintType: GqlConstraintType;
      monitoredEntityId?: string | null;
      monitoredEntityType?: string | null;
      limitValue: number;
      active: boolean;
      currentStatus: GqlConstraintStatus;
      currentUsage: number;
      operator: GqlConstraintOperator;
      unit: string;
      createdAt: string;
      updatedAt: string;
      scope: { __typename?: 'GqlConstraintScope'; scopeType: string; scopeId?: string | null };
    }>;
  };
};

export type ListValidationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListValidationsQuery = {
  __typename?: 'Query';
  listValidations: Array<{
    __typename?: 'Validation';
    id: string;
    name: string;
    code: string;
    description?: string | null;
    validationType: GqlValidationType;
    severity: GqlValidationSeverity;
    isBlocking: boolean;
    active: boolean;
    executionPhase: Array<GqlExecutionPhase>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetCoverageGapsForProductQueryVariables = Exact<{
  rulesetId: Scalars['String']['input'];
}>;

export type GetCoverageGapsForProductQuery = {
  __typename?: 'Query';
  regulatoryCoverageGaps: {
    __typename?: 'CoverageGapReport';
    rulesetId: string;
    totalRules: number;
    coveredRules: number;
    coveragePercent: number;
    gaps: Array<{
      __typename?: 'CoverageGap';
      ruleId: string;
      ruleName: string;
      missingConfigs: Array<{
        __typename?: 'MissingConfig';
        configType: string;
        description: string;
        expectedTrigger: string;
      }>;
    }>;
  };
};

export type GetProductDefinitionQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;

export type GetProductDefinitionQuery = {
  __typename?: 'Query';
  productDefinition?: {
    __typename?: 'GqlProductDefinition';
    productId: string;
    name: string;
    description?: string | null;
    industry: string;
    jurisdiction: string;
    version: string;
    status: string;
    brand?: string | null;
    subgraphs: Array<string>;
    requiredRulesets: Array<string>;
    activatesWorkflows: Array<string>;
    activatesSettings: Array<string>;
    activatesOverrides: Array<string>;
    activatesConstellations: Array<string>;
    onboardingLenses: Array<string>;
    provisioningStatus: string;
  } | null;
};

export type ListProductDefinitionsQueryVariables = Exact<{
  industry?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListProductDefinitionsQuery = {
  __typename?: 'Query';
  productDefinitions: Array<{
    __typename?: 'GqlProductDefinition';
    productId: string;
    name: string;
    description?: string | null;
    industry: string;
    jurisdiction: string;
    version: string;
    status: string;
    brand?: string | null;
    subgraphs: Array<string>;
    requiredRulesets: Array<string>;
    activatesWorkflows: Array<string>;
    activatesTaskGroups: Array<string>;
    activatesSettings: Array<string>;
    activatesOverrides: Array<string>;
    activatesConstellations: Array<string>;
    onboardingLenses: Array<string>;
    provisioningStatus: string;
  }>;
};

export type ResolvedTerminologyQueryVariables = Exact<{ [key: string]: never }>;

export type ResolvedTerminologyQuery = {
  __typename?: 'Query';
  resolvedTerminology: Array<{
    __typename?: 'ResolvedTerm';
    concept: string;
    display: string;
    source: TermSource;
    definitionRef?: string | null;
    statuteRef?: string | null;
    legalDefinition?: string | null;
    acceptableAlternatives: Array<string>;
  }>;
};

export type ComplianceFilterDimensionsQueryVariables = Exact<{ [key: string]: never }>;

export type ComplianceFilterDimensionsQuery = {
  __typename?: 'Query';
  complianceFilterDimensions: {
    __typename?: 'ComplianceFilterDimensions';
    totalCount: number;
    dimensions: Array<{
      __typename?: 'ComplianceFilterDimension';
      dimension: string;
      label: string;
      renderAs: string;
      isMultiSelect: boolean;
      values: Array<{
        __typename?: 'ComplianceFilterValue';
        value: string;
        label: string;
        count: number;
      }>;
    }>;
  };
};

export type DimensionCodeTablesQueryVariables = Exact<{ [key: string]: never }>;

export type DimensionCodeTablesQuery = {
  __typename?: 'Query';
  dimensionCodeTables: Array<{
    __typename?: 'RegistryDimensionTable';
    name: string;
    count: number;
    codes: Array<{ __typename?: 'RegistryDimensionCode'; value: string; code: string }>;
  }>;
};

export type GetAvailableScopeDimensionsQueryVariables = Exact<{
  primitiveType: Scalars['String']['input'];
}>;

export type GetAvailableScopeDimensionsQuery = {
  __typename?: 'Query';
  availableScopeDimensions: Array<{
    __typename?: 'ScopeDimension';
    dimensionId: string;
    field: string;
    label: string;
    suggestedRenderer: string;
    availableRenderers: Array<string>;
    sortOrder: number;
  }>;
};

export type MyViewContextQueryVariables = Exact<{
  route: Scalars['String']['input'];
}>;

export type MyViewContextQuery = {
  __typename?: 'Query';
  myViewContext: {
    __typename?: 'GqlViewContext';
    lens: GqlViewLens;
    terminology: Record<string, unknown>;
    visiblePrimitives: Array<string>;
    navGroups: Array<{
      __typename?: 'GqlNavGroupRef';
      id: string;
      label: string;
      icon?: string | null;
      routes: Array<string>;
      order: number;
    }>;
    formOverrides: Array<{
      __typename?: 'GqlFormOverrideRef';
      id: string;
      baseSchemaId: string;
      overrideType: string;
    }>;
    scopeDimensions: Array<{
      __typename?: 'GqlScopeDimension';
      id: string;
      label: string;
      renderer: string;
      active: boolean;
    }>;
    workContext?: {
      __typename?: 'GqlWorkContext';
      constellationId?: string | null;
      phase?: string | null;
      subjectType?: string | null;
      subjectName?: string | null;
      enrichmentKeys: Array<string>;
    } | null;
    constraints: {
      __typename?: 'GqlRouteConstraints';
      dataTier?: GqlDataTier | null;
      safetyLevel?: ViewContextSafetyLevel | null;
      requiredScopes: Array<string>;
      authTier?: number | null;
    };
  };
};

export type GetConstellationWithLensQueryVariables = Exact<{
  constellationId: Scalars['String']['input'];
  lensId: Scalars['String']['input'];
  mode: Scalars['String']['input'];
}>;

export type GetConstellationWithLensQuery = {
  __typename?: 'Query';
  constellationWithLens?: {
    __typename?: 'FilteredConstellation';
    constellationId: string;
    constellationName: string;
    lensId: string;
    lensName: string;
    mode: string;
    rings: Array<{
      __typename?: 'FilteredRing';
      ringId: string;
      ringNumber: number;
      label: string;
      color?: string | null;
      shape?: string | null;
      provisioning?: string | null;
      onboardingAction?: string | null;
      highlighted: Array<string>;
      deEmphasized: Array<string>;
      showFields: Array<string>;
      hideFields: Array<string>;
      expandSections: Array<string>;
      modeDescription?: string | null;
      instanceStatusFields: Array<string>;
    }>;
    checklist: Array<{
      __typename?: 'LensChecklistStep';
      step: string;
      ring: string;
      statusField: string;
    }>;
  } | null;
};

export type GetDimensionCodeTablesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDimensionCodeTablesQuery = {
  __typename?: 'Query';
  dimensionCodeTables: Array<{
    __typename?: 'RegistryDimensionTable';
    name: string;
    count: number;
    codes: Array<{ __typename?: 'RegistryDimensionCode'; value: string; code: string }>;
  }>;
};

export type ListLensTemplatesQueryVariables = Exact<{
  vertical?: InputMaybe<Scalars['String']['input']>;
  constellation?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListLensTemplatesQuery = {
  __typename?: 'Query';
  lensTemplates: Array<{
    __typename?: 'LensTemplate';
    lensId: string;
    name: string;
    description?: string | null;
    phase: string;
    version: string;
    verticals: Array<string>;
    safetyLevel?: string | null;
    ruleCount: number;
    appliesToConstellation?: string | null;
    onboardingChecklist: Array<{
      __typename?: 'LensChecklistStep';
      step: string;
      ring: string;
      statusField: string;
    }>;
  }>;
};

export type ResolveRoleScopesQueryVariables = Exact<{
  roleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ResolveRoleScopesQuery = { __typename?: 'Query'; resolveRoleScopes: Array<string> };

export type ResolveRoleScopesForAccessQueryVariables = Exact<{
  roleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ResolveRoleScopesForAccessQuery = {
  __typename?: 'Query';
  resolveRoleScopes: Array<string>;
};

export type MyScopeGapsQueryVariables = Exact<{ [key: string]: never }>;

export type MyScopeGapsQuery = {
  __typename?: 'Query';
  myScopeGaps: {
    __typename?: 'ScopeGapsResult';
    actorId: string;
    roles: Array<string>;
    totalBlockedScopes: number;
    gaps: Array<{
      __typename?: 'ScopeGap';
      scope: string;
      failures: Array<{
        __typename?: 'PrerequisiteFailure';
        prerequisiteType: string;
        detail: string;
        remediation: string;
        remediationTaskGroup?: string | null;
      }>;
    }>;
  };
};

export type MyCertificationGapsQueryVariables = Exact<{ [key: string]: never }>;

export type MyCertificationGapsQuery = {
  __typename?: 'Query';
  myCertificationGaps: {
    __typename?: 'CertificationGapsResult';
    actorId: string;
    totalExpiring: number;
    expiringCertifications: Array<{
      __typename?: 'ExpiringCertification';
      certType: string;
      daysUntilExpiration: number;
      expiresAt: string;
      urgency: CertificationUrgency;
      affectedScopes: Array<string>;
    }>;
  };
};

export type AdminListFhirConditionsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AdminListFhirConditionsQuery = {
  __typename?: 'Query';
  adminListFhirConditions: Array<{
    __typename?: 'FhirStoredResourceType';
    resourceId: string;
    resourceType: string;
    tenantNum: number;
    fhirJson: string;
    version: number;
    versionOf?: string | null;
    isLatest: boolean;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type AdminListFhirMedicationRequestsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AdminListFhirMedicationRequestsQuery = {
  __typename?: 'Query';
  adminListFhirMedicationRequests: Array<{
    __typename?: 'FhirStoredResourceType';
    resourceId: string;
    resourceType: string;
    tenantNum: number;
    fhirJson: string;
    version: number;
    versionOf?: string | null;
    isLatest: boolean;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type AdminListFhirObservationsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AdminListFhirObservationsQuery = {
  __typename?: 'Query';
  adminListFhirObservations: Array<{
    __typename?: 'FhirStoredResourceType';
    resourceId: string;
    resourceType: string;
    tenantNum: number;
    fhirJson: string;
    version: number;
    versionOf?: string | null;
    isLatest: boolean;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type AdminListFhirPatientsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AdminListFhirPatientsQuery = {
  __typename?: 'Query';
  adminListFhirPatients: Array<{
    __typename?: 'FhirStoredResourceType';
    resourceId: string;
    resourceType: string;
    tenantNum: number;
    fhirJson: string;
    version: number;
    versionOf?: string | null;
    isLatest: boolean;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type GetFhirAllergiesBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetFhirAllergiesBySubjectQuery = {
  __typename?: 'Query';
  fhirAllergiesBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    versionOf?: string | null;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type GetFhirMedAdminsBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFhirMedAdminsBySubjectQuery = {
  __typename?: 'Query';
  fhirMedAdminsBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    versionOf?: string | null;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type GetFhirMedDispensesBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetFhirMedDispensesBySubjectQuery = {
  __typename?: 'Query';
  fhirMedDispensesBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    versionOf?: string | null;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type GetFhirMedicationsBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetFhirMedicationsBySubjectQuery = {
  __typename?: 'Query';
  fhirMedicationsBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    versionOf?: string | null;
    createdBy: string;
    createdAt: string;
    auditOperation: string;
  }>;
};

export type GetFhirPrescriptionSchedulesBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type GetFhirPrescriptionSchedulesBySubjectQuery = {
  __typename?: 'Query';
  fhirPrescriptionSchedulesBySubject: Record<string, unknown>;
};

export type GetAllLedgerAccountsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type GetAllLedgerAccountsQuery = {
  __typename?: 'Query';
  ledgerAccounts: Array<{
    __typename?: 'LedgerAccount';
    accountId: string;
    actorId: string;
    balanceCents: number;
    pointsBalance: number;
    status: string;
    createdAt: string;
  }>;
};

export type GetAuditLedgerTransfersQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type GetAuditLedgerTransfersQuery = {
  __typename?: 'Query';
  ledgerTransfers: Array<{
    __typename?: 'LedgerTransfer';
    transferId: string;
    fromActorId?: string | null;
    toActorId?: string | null;
    amountCents: number;
    tokenType: LedgerTokenType;
    socialSubtype?: string | null;
    serviceCategory?: string | null;
    hash: string;
    status: LedgerTransferStatus;
    moovTransferId?: string | null;
    createdAt: string;
  }>;
};

export type GetFamilyLedgerAccountQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  actorId: Scalars['String']['input'];
}>;

export type GetFamilyLedgerAccountQuery = {
  __typename?: 'Query';
  ledgerAccount?: {
    __typename?: 'LedgerAccount';
    accountId: string;
    tenantNum: number;
    actorId: string;
    balanceCents: number;
    pointsBalance: number;
    status: string;
    createdAt: string;
  } | null;
};

export type GetFamilyLedgerTransfersQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type GetFamilyLedgerTransfersQuery = {
  __typename?: 'Query';
  ledgerTransfers: Array<{
    __typename?: 'LedgerTransfer';
    transferId: string;
    amountCents: number;
    tokenType: LedgerTokenType;
    serviceCategory?: string | null;
    status: LedgerTransferStatus;
    createdAt: string;
  }>;
};

export type GetLedgerAccountQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  actorId: Scalars['String']['input'];
}>;

export type GetLedgerAccountQuery = {
  __typename?: 'Query';
  ledgerAccount?: {
    __typename?: 'LedgerAccount';
    accountId: string;
    tenantNum: number;
    actorId: string;
    balanceCents: number;
    pointsBalance: number;
    status: string;
    createdAt: string;
  } | null;
};

export type GetLedgerSettlementsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerSettlementsQuery = {
  __typename?: 'Query';
  ledgerSettlements: Array<{
    __typename?: 'LedgerSettlement';
    settlementId: string;
    period: string;
    serviceCompanyTenantNum: number;
    serviceCompanyName?: string | null;
    amountCents: number;
    transactionCount: number;
    status: LedgerSettlementStatus;
    hash: string;
    reconciled?: boolean | null;
    createdAt: string;
    settledAt?: string | null;
  }>;
};

export type GetLedgerTransfersQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type GetLedgerTransfersQuery = {
  __typename?: 'Query';
  ledgerTransfers: Array<{
    __typename?: 'LedgerTransfer';
    transferId: string;
    fromActorId?: string | null;
    toActorId?: string | null;
    amountCents: number;
    tokenType: LedgerTokenType;
    socialSubtype?: string | null;
    serviceCategory?: string | null;
    status: LedgerTransferStatus;
    createdAt: string;
  }>;
};

export type GetScheduleQueryVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;

export type GetScheduleQuery = {
  __typename?: 'Query';
  getSchedule?: {
    __typename?: 'Schedule';
    scheduleId: string;
    scheduleName: string;
    scheduleCode: string;
    cronExpression?: string | null;
    timezone: string;
    scheduleStatus: GqlScheduleStatus;
    scheduleType: GqlScheduleType;
    schedulePriority: GqlSchedulePriority;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListResourcesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListResourcesQuery = {
  __typename?: 'Query';
  listResources: {
    __typename?: 'GqlResourceConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    total: number;
    items: Array<{
      __typename?: 'Resource';
      resourceId: string;
      resourceName: string;
      resourceCode: string;
      resourceType: GqlResourceType;
      resourceCategory: string;
      resourceStatus: GqlResourceStatus;
      totalCapacity: number;
      availableCapacity: number;
      isLifeCriticalResource: boolean;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type ListSchedulesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListSchedulesQuery = {
  __typename?: 'Query';
  listSchedules: {
    __typename?: 'GqlScheduleConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Schedule';
      scheduleId: string;
      scheduleName: string;
      scheduleCode: string;
      cronExpression?: string | null;
      timezone: string;
      scheduleStatus: GqlScheduleStatus;
      scheduleType: GqlScheduleType;
      schedulePriority: GqlSchedulePriority;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type ValidateMandatoryResourcesQueryVariables = Exact<{
  subgraph: Scalars['String']['input'];
  primaryRuleset: Scalars['String']['input'];
}>;

export type ValidateMandatoryResourcesQuery = {
  __typename?: 'Query';
  validateMandatoryResources: {
    __typename?: 'MandatoryResourceValidation';
    valid: boolean;
    configuredCount: number;
    requiredCount: number;
    missingResources: Array<{
      __typename?: 'MandatoryResourceGap';
      entityType: string;
      statuteRequirement: string;
      rulesetRef?: string | null;
    }>;
  };
};

export type ExportAuditTrailQueryVariables = Exact<{
  input: ExportAuditTrailInput;
}>;

export type ExportAuditTrailQuery = {
  __typename?: 'Query';
  exportAuditTrail: {
    __typename?: 'ExportAuditTrailResult';
    exportId: string;
    downloadUrl: string;
    format: string;
    recordCount: number;
    expiresAt: string;
  };
};

export type GetAuditQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;

export type GetAuditQuery = {
  __typename?: 'Query';
  getAudit?: {
    __typename?: 'AuditQL';
    id: string;
    auditCode: string;
    auditName: string;
    actionTypes: Array<string>;
    complianceStatus: AuditComplianceStatus;
    frameworkType: GqlAuditFrameworkType;
    createdAt: string;
    updatedAt: string;
    version: number;
    parentId?: string | null;
    originalId?: string | null;
    isActive: boolean;
    compliancePeriodStart: string;
    compliancePeriodEnd: string;
    regulatoryQuestion: string;
    eventIds: Array<string>;
    eventCount: number;
    uniqueEventTypes: Array<string>;
    findingsSummary: string;
    violationsDetected: number;
    userIds: Array<string>;
    userActionCount: number;
    primitiveTypesAccessed: Array<string>;
    navigationPaths: Array<Array<string>>;
    timeSpentSeconds: Array<string>;
    accessPatterns: Record<string, unknown>;
    featuresUsed: Array<string>;
    featuresUnused: Array<string>;
    adoptionRatePercent: number;
    retentionYears: number;
    retentionExpiresAt: string;
    immutabilityRequired: boolean;
    signatureRequired: boolean;
    dataLineage: Record<string, unknown>;
    regulatoryFrameworks: Array<string>;
    reportFormat: GqlReportFormat;
    reportTemplateId: string;
    reportS3Url?: string | null;
    generatedByUserId: string;
    approvedByUserId?: string | null;
    approvalRequired: boolean;
    uniqueActors: number;
    uniqueEntities: number;
    uniqueWorkflows: number;
    aiGenerated: boolean;
    aiConfidence?: number | null;
    chaosExtractionId?: string | null;
    approvalWorkflowId?: string | null;
    previousAuditId?: string | null;
    subgraphReferences: Record<string, unknown>;
    lastValidationTimestamp?: string | null;
    createdByUserId: string;
    updatedBy?: string | null;
  } | null;
};

export type GetAuditStatisticsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  dateRange: AuditDateRangeInput;
}>;

export type GetAuditStatisticsQuery = {
  __typename?: 'Query';
  getAuditStatistics: {
    __typename?: 'AuditStatistics';
    totalActions: number;
    criticalActionsCount: number;
    complianceViolationsCount: number;
    tamperDetectionCount: number;
    actionsByType: Array<{ __typename?: 'ActionCount'; action: string; count: number }>;
  };
};

export type GetAuditTrailQueryVariables = Exact<{
  filter: AuditTrailFilter;
}>;

export type GetAuditTrailQuery = {
  __typename?: 'Query';
  getAuditTrail: {
    __typename?: 'AuditTrailResponse';
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    entries: Array<{
      __typename?: 'AuditTrailEntry';
      auditId: string;
      action: string;
      entityType: string;
      entityId: string;
      entityName?: string | null;
      userId: string;
      userName: string;
      userRole: string;
      timestamp: string;
      severity: string;
      domain: string;
      metadata: Record<string, unknown>;
      tamperDetected: boolean;
      cryptographicHash: string;
    }>;
    tamperAlerts: Array<{
      __typename?: 'TamperAlert';
      auditId: string;
      reason: string;
      severity: string;
      detectedAt: string;
    }>;
  };
};

export type GetEventQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
}>;

export type GetEventQuery = {
  __typename?: 'Query';
  eventApiGetEvent?: {
    __typename?: 'Event';
    id: string;
    eventName: string;
    eventType: GqlEventType;
    entityType: string;
    severity: GqlEventSeverity;
    category: GqlEventCategory;
    createdAt: string;
    performedAt: string;
  } | null;
};

export type GetEventsByEntityQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
}>;

export type GetEventsByEntityQuery = {
  __typename?: 'Query';
  eventApiGetEventsByEntity: Array<{
    __typename?: 'Event';
    id: string;
    eventName: string;
    eventType: GqlEventType;
    entityType: string;
    severity: GqlEventSeverity;
    category: GqlEventCategory;
    createdAt: string;
    performedAt: string;
  }>;
};

export type GetSafetyEventQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
}>;

export type GetSafetyEventQuery = {
  __typename?: 'Query';
  formsGetSafetyEvent?: {
    __typename?: 'SafetyEvent';
    eventId: string;
    severity: string;
    category: string;
    eventType: string;
    description: string;
    remediationStatus?: string | null;
    remediationRequired: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAuditsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListAuditsQuery = {
  __typename?: 'Query';
  listAudits: {
    __typename?: 'AuditListResultQL';
    nextToken?: string | null;
    audits: Array<{
      __typename?: 'AuditQL';
      id: string;
      auditCode: string;
      auditName: string;
      actionTypes: Array<string>;
      complianceStatus: AuditComplianceStatus;
      frameworkType: GqlAuditFrameworkType;
      createdAt: string;
      updatedAt: string;
      version: number;
      parentId?: string | null;
      originalId?: string | null;
      isActive: boolean;
      compliancePeriodStart: string;
      compliancePeriodEnd: string;
      regulatoryQuestion: string;
      eventIds: Array<string>;
      eventCount: number;
      uniqueEventTypes: Array<string>;
      findingsSummary: string;
      violationsDetected: number;
      userIds: Array<string>;
      userActionCount: number;
      primitiveTypesAccessed: Array<string>;
      navigationPaths: Array<Array<string>>;
      timeSpentSeconds: Array<string>;
      accessPatterns: Record<string, unknown>;
      featuresUsed: Array<string>;
      featuresUnused: Array<string>;
      adoptionRatePercent: number;
      retentionYears: number;
      retentionExpiresAt: string;
      immutabilityRequired: boolean;
      signatureRequired: boolean;
      dataLineage: Record<string, unknown>;
      regulatoryFrameworks: Array<string>;
      reportFormat: GqlReportFormat;
      reportTemplateId: string;
      reportS3Url?: string | null;
      generatedByUserId: string;
      approvedByUserId?: string | null;
      approvalRequired: boolean;
      uniqueActors: number;
      uniqueEntities: number;
      uniqueWorkflows: number;
      aiGenerated: boolean;
      aiConfidence?: number | null;
      chaosExtractionId?: string | null;
      approvalWorkflowId?: string | null;
      previousAuditId?: string | null;
      subgraphReferences: Record<string, unknown>;
      lastValidationTimestamp?: string | null;
      createdByUserId: string;
      updatedBy?: string | null;
    }>;
  };
};

export type ListEventsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  filter?: InputMaybe<GqlEventFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListEventsQuery = {
  __typename?: 'Query';
  eventApiListEvents: {
    __typename?: 'GqlEventConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Event';
      id: string;
      eventName: string;
      eventType: GqlEventType;
      entityType: string;
      severity: GqlEventSeverity;
      category: GqlEventCategory;
      createdAt: string;
      performedAt: string;
    }>;
  };
};

export type ListSafetyEventsQueryVariables = Exact<{
  filter: SafetyEventFilter;
}>;

export type ListSafetyEventsQuery = {
  __typename?: 'Query';
  formsListSafetyEvents: Array<{
    __typename?: 'SafetyEvent';
    eventId: string;
    severity: string;
    category: string;
    eventType: string;
    description: string;
    remediationStatus?: string | null;
    remediationRequired: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetAnalyticsByCategoryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  category: MetricCategory;
}>;

export type GetAnalyticsByCategoryQuery = {
  __typename?: 'Query';
  getAnalyticsByCategory: Array<{
    __typename?: 'Analytics';
    analyticsId: string;
    analyticsName: string;
    analyticsCode: string;
    metricType: MetricType;
    metricCategory: MetricCategory;
    metricUnit: MetricUnit;
    currentValue: number;
    previousValue: number;
    warningThreshold?: number | null;
    criticalThreshold?: number | null;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetAnalyticsByCodeQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  analyticsCode: Scalars['String']['input'];
}>;

export type GetAnalyticsByCodeQuery = {
  __typename?: 'Query';
  getAnalyticsByCode?: {
    __typename?: 'Analytics';
    analyticsId: string;
    analyticsName: string;
    analyticsCode: string;
    metricType: MetricType;
    metricCategory: MetricCategory;
    metricUnit: MetricUnit;
    currentValue: number;
    previousValue: number;
    warningThreshold?: number | null;
    criticalThreshold?: number | null;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetAnalyticsByQueueQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  queueId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAnalyticsByQueueQuery = {
  __typename?: 'Query';
  getAnalyticsByQueue: Array<{
    __typename?: 'Analytics';
    analyticsId: string;
    analyticsName: string;
    analyticsCode: string;
    metricType: MetricType;
    metricCategory: MetricCategory;
    metricUnit: MetricUnit;
    currentValue: number;
    previousValue: number;
    warningThreshold?: number | null;
    criticalThreshold?: number | null;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetAnalyticsDashboardQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetAnalyticsDashboardQuery = {
  __typename?: 'Query';
  getAnalyticsDashboard: {
    __typename?: 'AnalyticsDashboard';
    tenantId: string;
    lastUpdated: string;
    trendsPositive: number;
    trendsNegative: number;
    alertsTriggered: number;
    performanceMetrics: Array<{
      __typename?: 'Analytics';
      analyticsId: string;
      analyticsCode: string;
      analyticsName: string;
      metricName: string;
      metricType: MetricType;
      currentValue: number;
      averageValue: number;
    }>;
    complianceMetrics: Array<{
      __typename?: 'Analytics';
      analyticsId: string;
      analyticsCode: string;
      analyticsName: string;
      metricName: string;
      currentValue: number;
    }>;
    businessMetrics: Array<{
      __typename?: 'Analytics';
      analyticsId: string;
      analyticsCode: string;
      analyticsName: string;
      metricName: string;
      currentValue: number;
    }>;
    systemMetrics: Array<{
      __typename?: 'Analytics';
      analyticsId: string;
      analyticsCode: string;
      analyticsName: string;
      metricName: string;
      currentValue: number;
    }>;
    adoptionMetrics: Array<{
      __typename?: 'Analytics';
      analyticsId: string;
      analyticsCode: string;
      analyticsName: string;
      metricName: string;
      currentValue: number;
    }>;
  };
};

export type GetAnalyticsManifestStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetAnalyticsManifestStatusQuery = {
  __typename?: 'Query';
  analyticsManifestStatus: {
    __typename?: 'AnalyticsManifestStatusResponse';
    status: ManifestStatus;
    version?: string | null;
    builtAt?: string | null;
    expiresAt?: string | null;
    filesIndexed: number;
    totalRowsIndexed: string;
    totalSizeBytes: string;
    tenantsCovered: Array<string>;
    subgraphsCovered: Array<string>;
  };
};

export type GetAnalyticsSummaryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetAnalyticsSummaryQuery = {
  __typename?: 'Query';
  getAnalyticsSummary: {
    __typename?: 'AnalyticsSummary';
    tenantId: string;
    totalPolicies: number;
    totalEvaluations: number;
    totalMatched: number;
    totalErrors: number;
    avgExecutionTimeMs: number;
    overallEffectiveness: number;
    overallCacheHitRate: number;
    generatedAt: string;
  };
};

export type GetAnalyticsTimeSeriesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
  timeRange: AnalyticsTimeRange;
}>;

export type GetAnalyticsTimeSeriesQuery = {
  __typename?: 'Query';
  getAnalyticsTimeSeries: Array<{
    __typename?: 'TimeSeriesPoint';
    timestamp: string;
    evaluationCount: number;
    matchedCount: number;
    avgExecutionTimeMs: number;
    cacheHitRate: number;
  }>;
};

export type GetAnalyticsWithAnomaliesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetAnalyticsWithAnomaliesQuery = {
  __typename?: 'Query';
  getAnalyticsWithAnomalies: Array<{
    __typename?: 'Analytics';
    analyticsId: string;
    analyticsName: string;
    analyticsCode: string;
    metricType: MetricType;
    metricCategory: MetricCategory;
    metricUnit: MetricUnit;
    currentValue: number;
    previousValue: number;
    warningThreshold?: number | null;
    criticalThreshold?: number | null;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetAnalyticsWithThresholdBreachesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetAnalyticsWithThresholdBreachesQuery = {
  __typename?: 'Query';
  getAnalyticsWithThresholdBreaches: Array<{
    __typename?: 'Analytics';
    analyticsId: string;
    analyticsName: string;
    analyticsCode: string;
    metricType: MetricType;
    metricCategory: MetricCategory;
    metricUnit: MetricUnit;
    currentValue: number;
    previousValue: number;
    warningThreshold?: number | null;
    criticalThreshold?: number | null;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetComplianceStatusQueryVariables = Exact<{
  rulesetId: Scalars['String']['input'];
}>;

export type GetComplianceStatusQuery = {
  __typename?: 'Query';
  complianceStatus: {
    __typename?: 'ComplianceStatus';
    rulesetId: string;
    rulesetDisplayName: string;
    totalProvisions: number;
    evidencedCount: number;
    gapCount: number;
    pendingCount: number;
    compliancePercent: number;
    provisions: Array<{
      __typename?: 'ProvisionStatus';
      ruleId: string;
      name: string;
      sectionRef: string;
      description: string;
      status: string;
      linkedTaskGroups: Array<string>;
      taskEvidenceCount: number;
      manualEvidenceCount: number;
      requiredEvidence: Array<{
        __typename?: 'EvidenceRequirement';
        evidenceType: string;
        description: string;
        renewal: string;
      }>;
    }>;
  };
};

export type GetRegulatoryQueueStatsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetRegulatoryQueueStatsQuery = {
  __typename?: 'Query';
  regulatoryQueueStats: {
    __typename?: 'GqlQueueStats';
    total: number;
    autoApproved: number;
    confidenceReview: number;
    conflictReview: number;
    safetyReview: number;
    humanReviewPercentage: number;
  };
};

export type GetSearchAnalyticsQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;

export type GetSearchAnalyticsQuery = {
  __typename?: 'Query';
  searchAnalytics: {
    __typename?: 'SearchAnalytics';
    avgDurationMs: number;
    totalSearches: number;
    topSearches: Array<{
      __typename?: 'TopSearch';
      query: string;
      count: number;
      avgResults: number;
    }>;
    zeroResultQueries: Array<{
      __typename?: 'ZeroResultQuery';
      query: string;
      count: number;
      lastSearched: string;
    }>;
    searchVolume: Array<{ __typename?: 'SearchVolume'; date: string; count: number }>;
  };
};

export type GetSystemTenantStatusQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetSystemTenantStatusQuery = {
  __typename?: 'Query';
  systemTenant?: {
    __typename?: 'SystemTenant';
    tenantId: string;
    onboardingStatus: GqlOnboardingStatus;
    subscriptionTier: string;
  } | null;
};

export type ListAnalyticsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListAnalyticsQuery = {
  __typename?: 'Query';
  listAnalytics: {
    __typename?: 'AnalyticsConnection';
    hasNextPage: boolean;
    totalCount: number;
    nodes: Array<{
      __typename?: 'Analytics';
      analyticsId: string;
      analyticsName: string;
      analyticsCode: string;
      metricType: MetricType;
      metricCategory: MetricCategory;
      metricUnit: MetricUnit;
      currentValue: number;
      previousValue: number;
      warningThreshold?: number | null;
      criticalThreshold?: number | null;
      enabled: boolean;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type ListContractsByStatusQueryVariables = Exact<{
  status: GqlContractStatus;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListContractsByStatusQuery = {
  __typename?: 'Query';
  listContractsByStatus: {
    __typename?: 'GqlContractConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Contract';
      id: string;
      tenantId: string;
      slaName: string;
      slug?: string | null;
      externalId?: string | null;
      entityType: string;
      entityId: string;
      workflowInstanceId: string;
      notificationActorIds: Array<string>;
      notificationChannels: Array<string>;
      notificationAtPercent: Array<number>;
      startedAt?: string | null;
      currentStatus: GqlContractStatus;
      elapsedMinutes?: string | null;
      lastCheckedAt?: string | null;
      paused: boolean;
      responseTimeMinutes: string;
      resolutionTimeMinutes: string;
      warningThresholdPercent: number;
      escalateAfterMinutes: string;
      escalationChain: Array<string>;
      breachCount: string;
      complianceRate: number;
      lastBreachAt?: string | null;
      createdAt: string;
      updatedAt: string;
      createdBy: string;
      metadata: Record<string, unknown>;
      compressedId?: string | null;
    }>;
  };
};

export type StatutoryDefinitionsQueryVariables = Exact<{ [key: string]: never }>;

export type StatutoryDefinitionsQuery = {
  __typename?: 'Query';
  statutoryDefinitions: Array<{
    __typename?: 'StatutoryDefinition';
    id: string;
    label: string;
    defaultDisplay?: string | null;
    statuteRef?: string | null;
    chapter?: string | null;
    safetyLevel?: string | null;
    fhirResource?: string | null;
    ferpPrimitive?: string | null;
    ferpRoleCategory?: string | null;
    legalDefinition?: string | null;
    acceptableAlternatives: Array<string>;
    statutoryEdges: Array<{
      __typename?: 'StatutoryEdge';
      edgeType: string;
      target: string;
      targetLabel?: string | null;
      statuteRef: string;
      description?: string | null;
      createsDelegation: boolean;
      conditional: boolean;
      conditions: Array<string>;
    }>;
  }>;
};

export type StatutoryImpactAnalysisQueryVariables = Exact<{
  statuteSection: Scalars['String']['input'];
}>;

export type StatutoryImpactAnalysisQuery = {
  __typename?: 'Query';
  statutoryImpactAnalysis: {
    __typename?: 'StatutoryImpactReport';
    statuteSection: string;
    totalAffected: number;
    definitions: Array<{
      __typename?: 'StatutoryImpactEntry';
      definitionId: string;
      label: string;
      defaultDisplay?: string | null;
      impactType: string;
      statuteRef?: string | null;
      affectedEdges: Array<string>;
    }>;
  };
};

export type GetSubgraphRegistryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetSubgraphRegistryQuery = {
  __typename?: 'Query';
  getSubgraphRegistry?: {
    __typename?: 'SubgraphRegistry';
    tenantId: string;
    registeredSubgraphs: Record<string, unknown>;
    createdAt: string;
    updatedAt: string;
    updatedBy: string;
    version: number;
  } | null;
};

export type HasSubgraphRegistryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type HasSubgraphRegistryQuery = { __typename?: 'Query'; hasSubgraphRegistry: boolean };

export type ListEnabledSubgraphsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type ListEnabledSubgraphsQuery = {
  __typename?: 'Query';
  listEnabledSubgraphs: { __typename?: 'SubgraphList'; subgraphs: Array<string> };
};

export type ListIntegrationsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListIntegrationsQuery = {
  __typename?: 'Query';
  listIntegrations: {
    __typename?: 'IntegrationConnection';
    hasNextPage: boolean;
    totalCount: number;
    nodes: Array<{
      __typename?: 'Integration';
      integrationId: string;
      integrationName: string;
      integrationCode: string;
      integrationType: IntegrationType;
      protocol: Protocol;
      baseUrl: string;
      currentHealthStatus: IntegrationHealthStatus;
      authType: AuthenticationType;
      circuitBreakerState: CircuitBreakerState;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type ValidateSubgraphReferenceQueryVariables = Exact<{
  input: ValidateSubgraphReferenceInput;
}>;

export type ValidateSubgraphReferenceQuery = {
  __typename?: 'Query';
  validateSubgraphReference: {
    __typename?: 'SubgraphReferenceValidation';
    isValid: boolean;
    subgraph: string;
    resourceType: string;
    tenantId: string;
    errorMessage?: string | null;
  };
};

export type ListTransactionsByTenantQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTransactionsByTenantQuery = {
  __typename?: 'Query';
  listTransactionsByTenant: {
    __typename?: 'TransactionPage';
    nextToken?: string | null;
    transactions: Array<{
      __typename?: 'Transaction';
      transactionId: string;
      transactionName: string;
      transactionCode: string;
      status: GqlTransactionStatus;
      isolationLevel: GqlIsolationLevel;
      totalSteps: number;
      currentStep: number;
      startedAt?: string | null;
      committedAt?: string | null;
      createdAt: string;
      updatedAt: string;
    }>;
  };
};

export type SagaDefinitionQueryVariables = Exact<{
  sagaId: Scalars['String']['input'];
}>;

export type SagaDefinitionQuery = {
  __typename?: 'Query';
  sagaDefinition?: {
    __typename?: 'SagaDefinitionGQL';
    sagaId: string;
    description?: string | null;
    version: string;
    metadata: Record<string, unknown>;
  } | null;
};

export type SagaDefinitionsQueryVariables = Exact<{ [key: string]: never }>;

export type SagaDefinitionsQuery = {
  __typename?: 'Query';
  sagaDefinitions: Array<{
    __typename?: 'SagaDefinitionGQL';
    sagaId: string;
    description?: string | null;
    version: string;
    metadata: Record<string, unknown>;
  }>;
};

export type GetContractQueryVariables = Exact<{
  workflowInstanceId: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
}>;

export type GetContractQuery = {
  __typename?: 'Query';
  getContract?: {
    __typename?: 'Contract';
    id: string;
    tenantId: string;
    slaName: string;
    slug?: string | null;
    externalId?: string | null;
    entityType: string;
    entityId: string;
    workflowInstanceId: string;
    notificationActorIds: Array<string>;
    notificationChannels: Array<string>;
    notificationAtPercent: Array<number>;
    startedAt?: string | null;
    currentStatus: GqlContractStatus;
    elapsedMinutes?: string | null;
    lastCheckedAt?: string | null;
    paused: boolean;
    responseTimeMinutes: string;
    resolutionTimeMinutes: string;
    warningThresholdPercent: number;
    escalateAfterMinutes: string;
    escalationChain: Array<string>;
    breachCount: string;
    complianceRate: number;
    lastBreachAt?: string | null;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    metadata: Record<string, unknown>;
    compressedId?: string | null;
  } | null;
};

export type GetContractByExternalIdQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;

export type GetContractByExternalIdQuery = {
  __typename?: 'Query';
  getContractByExternalId?: {
    __typename?: 'Contract';
    id: string;
    tenantId: string;
    slaName: string;
    slug?: string | null;
    externalId?: string | null;
    entityType: string;
    entityId: string;
    workflowInstanceId: string;
    notificationActorIds: Array<string>;
    notificationChannels: Array<string>;
    notificationAtPercent: Array<number>;
    startedAt?: string | null;
    currentStatus: GqlContractStatus;
    elapsedMinutes?: string | null;
    lastCheckedAt?: string | null;
    paused: boolean;
    responseTimeMinutes: string;
    resolutionTimeMinutes: string;
    warningThresholdPercent: number;
    escalateAfterMinutes: string;
    escalationChain: Array<string>;
    breachCount: string;
    complianceRate: number;
    lastBreachAt?: string | null;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    metadata: Record<string, unknown>;
    compressedId?: string | null;
  } | null;
};

export type GetContractBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetContractBySlugQuery = {
  __typename?: 'Query';
  getContractBySlug?: {
    __typename?: 'Contract';
    id: string;
    tenantId: string;
    slaName: string;
    slug?: string | null;
    externalId?: string | null;
    entityType: string;
    entityId: string;
    workflowInstanceId: string;
    notificationActorIds: Array<string>;
    notificationChannels: Array<string>;
    notificationAtPercent: Array<number>;
    startedAt?: string | null;
    currentStatus: GqlContractStatus;
    elapsedMinutes?: string | null;
    lastCheckedAt?: string | null;
    paused: boolean;
    responseTimeMinutes: string;
    resolutionTimeMinutes: string;
    warningThresholdPercent: number;
    escalateAfterMinutes: string;
    escalationChain: Array<string>;
    breachCount: string;
    complianceRate: number;
    lastBreachAt?: string | null;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    metadata: Record<string, unknown>;
    compressedId?: string | null;
  } | null;
};

export type GetDependencyQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  dependencyId: Scalars['String']['input'];
}>;

export type GetDependencyQuery = {
  __typename?: 'Query';
  dependencyApiGetDependency?: {
    __typename?: 'Dependency';
    id: string;
    name: string;
    description?: string | null;
    dependencyType: GqlDependencyType;
    isConditional: boolean;
    status: GqlDependencyStatus;
    active: boolean;
    version: number;
  } | null;
};

export type ActiveSystemTenantsQueryVariables = Exact<{ [key: string]: never }>;

export type ActiveSystemTenantsQuery = {
  __typename?: 'Query';
  activeSystemTenants: Array<{
    __typename?: 'SystemTenant';
    tenantId: string;
    name: string;
    domain: string;
    industry: string;
    complianceFrameworks: Array<string>;
    subscriptionTier: string;
    maxUsers: number;
    maxWorkflows: number;
    isActive: boolean;
    onboardingStatus: GqlOnboardingStatus;
    primaryContactName: string;
    primaryContactEmail: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type ApplyStandardsPackQueryQueryVariables = Exact<{
  input: ApplyStandardsPackInput;
}>;

export type ApplyStandardsPackQueryQuery = {
  __typename?: 'Query';
  applyStandardsPack: {
    __typename?: 'ApplyStandardsPackResult';
    packId: string;
    workflowId: string;
    success: boolean;
    appliedBy: string;
    appliedAt: string;
    appliedRules: Array<{ __typename?: 'AppliedRule'; ruleId: string; ruleType: string }>;
    conflictsDetected: Array<{ __typename?: 'RuleConflict'; resolution: string }>;
  };
};

export type BeaconsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type BeaconsQuery = {
  __typename?: 'Query';
  beacons: Array<{
    __typename?: 'Beacon';
    beaconId: string;
    beaconUuid: string;
    major: number;
    minor: number;
    zoneId?: string | null;
    beaconType: BeaconType;
    model: string;
    status: BeaconStatus;
    description?: string | null;
    locationNote?: string | null;
    assignedActorId?: string | null;
    batteryMv?: number | null;
    lastRssi?: number | null;
    lastSeen?: string | null;
    tenantNum: number;
  }>;
};

export type ChainVerificationQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type ChainVerificationQuery = {
  __typename?: 'Query';
  chainVerification?: {
    __typename?: 'ChainVerificationResult';
    valid: boolean;
    entriesVerified: number;
    firstBrokenLink?: number | null;
    genesisDeviceId: string;
    genesisActorId: string;
    genesisTimestamp: string;
    chainLength: number;
  } | null;
};

export type ConfigEdgesQueryVariables = Exact<{
  configId: Scalars['String']['input'];
  edgeType?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConfigEdgesQuery = {
  __typename?: 'Query';
  configEdges: Array<{
    __typename?: 'ConfigEdge';
    sourceId: string;
    targetId: string;
    edgeType: string;
    inverseType: string;
    ring: number;
  }>;
};

export type ConfigReverseEdgesQueryVariables = Exact<{
  configId: Scalars['String']['input'];
  inverseType?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConfigReverseEdgesQuery = {
  __typename?: 'Query';
  configReverseEdges: Array<{
    __typename?: 'ConfigEdge';
    sourceId: string;
    targetId: string;
    edgeType: string;
    inverseType: string;
    ring: number;
  }>;
};

export type ConfigTypeRegistryQueryVariables = Exact<{ [key: string]: never }>;

export type ConfigTypeRegistryQuery = {
  __typename?: 'Query';
  configTypeRegistry: Array<{
    __typename?: 'RegistryConfigType';
    name: string;
    symbol: string;
    filenamePrefix: string;
    filenameTemplate?: string | null;
    filenamePattern: string;
    idField: string;
    legacySk: boolean;
    skVerbose: string;
    skCompressed: string;
    sourceDirs: Array<string>;
    seedLoader?: string | null;
    dimensions: Array<{
      __typename?: 'RegistryDimensionDef';
      name: string;
      mapsTo?: string | null;
      defaultValue?: string | null;
      source?: string | null;
      examples: Array<string>;
    }>;
  }>;
};

export type ElopementAlertsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
  unacknowledgedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ElopementAlertsQuery = {
  __typename?: 'Query';
  elopementAlerts: Array<{
    __typename?: 'ElopementAlert';
    alertId: string;
    subjectActorId: string;
    beaconId: string;
    triggerZoneId: string;
    lastSafeZoneId?: string | null;
    severity: ElopementSeverity;
    acknowledged: boolean;
    acknowledgedBy?: string | null;
    acknowledgedAt?: string | null;
    createdAt: string;
    tenantNum: number;
  }>;
};

export type EntityJourneyGraphQueryVariables = Exact<{
  actorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type EntityJourneyGraphQuery = {
  __typename?: 'Query';
  formsTaskEntityJourneyGraph: {
    __typename?: 'GqlEntityJourneyGraph';
    actorNames: Array<string>;
    totalNodes: number;
    intersectionInstanceIds: Array<string>;
    nodes: Array<{
      __typename?: 'GqlJourneyNode';
      nodeId: string;
      taskId: string;
      taskName: string;
      taskType: string;
      status: string;
      actorName: string;
      actorRole: string;
      timestamp: string;
      constellationId: string;
      instanceId: string;
    }>;
    edges: Array<{
      __typename?: 'GqlJourneyEdge';
      sourceNodeId: string;
      targetNodeId: string;
      edgeType: string;
      weight: number;
    }>;
  };
};

export type FormSchemaQueryQueryVariables = Exact<{
  subgraph: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
}>;

export type FormSchemaQueryQuery = {
  __typename?: 'Query';
  formSchema?: {
    __typename?: 'FormSchema';
    subgraph: string;
    entityType: string;
    version: string;
    displayName: string;
    description?: string | null;
    safetyLevel: FormSafetyLevel;
    createdAt?: string | null;
    updatedAt?: string | null;
    createdBy?: string | null;
    views?: Record<string, unknown> | null;
    fetchQuery?: string | null;
    createMutation?: string | null;
    updateMutation?: string | null;
    fields: Array<{
      __typename?: 'FormFieldDefinition';
      name: string;
      label: string;
      fieldType: FormFieldType;
      required: boolean;
      helpText?: string | null;
      placeholder?: string | null;
      defaultValue?: string | null;
      order?: number | null;
      minimumTier?: ModuleTier | null;
      piiClassification: PiiDataClassification;
      auditRequired: boolean;
      options?: Array<{
        __typename?: 'SelectOption';
        value: string;
        label: string;
        description?: string | null;
        disabled?: boolean | null;
        group?: string | null;
        icon?: string | null;
      }> | null;
    }>;
    validations?: Array<{
      __typename?: 'FormValidationRule';
      id: string;
      expression: string;
      message: string;
      severity?: string | null;
      fields: Array<string>;
    }> | null;
    layout: {
      __typename?: 'FormLayout';
      layoutType: string;
      submitLabel?: string | null;
      cancelLabel?: string | null;
      showProgress?: boolean | null;
    };
  } | null;
};

export type FormSchemasQueryVariables = Exact<{
  subgraph: Scalars['String']['input'];
}>;

export type FormSchemasQuery = {
  __typename?: 'Query';
  formSchemas: Array<{
    __typename?: 'FormSchema';
    subgraph: string;
    entityType: string;
    version: string;
    displayName: string;
    description?: string | null;
    safetyLevel: FormSafetyLevel;
    createdAt?: string | null;
    updatedAt?: string | null;
  }>;
};

export type GetAssessmentAccumulatorSummaryQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  residentId: Scalars['String']['input'];
}>;

export type GetAssessmentAccumulatorSummaryQuery = {
  __typename?: 'Query';
  assessmentAccumulatorSummary?: {
    __typename?: 'AccumulatorSummaryGql';
    residentId: string;
    status: AccumulationStatusGql;
    totalFields: number;
    fieldsWithDrift: number;
    majorDriftFields: number;
    avgConfidence: number;
    daysSinceAssessment: number;
    lastUpdated: string;
  } | null;
};

export type GetAssessmentAlertsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetAssessmentAlertsQuery = {
  __typename?: 'Query';
  assessmentAlerts: Array<{
    __typename?: 'DriftAlertGql';
    fieldId: string;
    fieldLabel: string;
    driftSeverity: DriftSeverityGql;
    confidence: number;
    assessedLabel: string;
    observedLabel: string;
    consistentDays: number;
  }>;
};

export type GetAssessmentDriftResultsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  residentId: Scalars['String']['input'];
}>;

export type GetAssessmentDriftResultsQuery = {
  __typename?: 'Query';
  assessmentDriftResults: Array<{
    __typename?: 'FieldDriftResultGql';
    fieldId: string;
    fieldLabel: string;
    section: AssessmentSectionGql;
    assessedValue: number;
    assessedLabel: string;
    observedValue: number;
    observedLabel: string;
    driftAmount: number;
    driftDirection: DriftDirectionGql;
    driftSeverity: DriftSeverityGql;
    confidence: number;
    consistentDays: number;
    lastUpdated: string;
  }>;
};

export type GetAssessmentFieldMappingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAssessmentFieldMappingsQuery = {
  __typename?: 'Query';
  assessmentFieldMappings: Array<{
    __typename?: 'FieldMappingGql';
    fieldId: string;
    section: AssessmentSectionGql;
    fieldNumber: number;
    label: string;
    assessedPath: string;
    minorThreshold: number;
    majorThreshold: number;
  }>;
};

export type GetConfigEdgesForCareGraphQueryVariables = Exact<{
  configId: Scalars['String']['input'];
  edgeType?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetConfigEdgesForCareGraphQuery = {
  __typename?: 'Query';
  configEdges: Array<{
    __typename?: 'ConfigEdge';
    sourceId: string;
    targetId: string;
    edgeType: string;
    inverseType: string;
    ring: number;
  }>;
};

export type GetConfigTypeRegistryQueryVariables = Exact<{ [key: string]: never }>;

export type GetConfigTypeRegistryQuery = {
  __typename?: 'Query';
  configTypeRegistry: Array<{
    __typename?: 'RegistryConfigType';
    name: string;
    symbol: string;
    filenamePrefix: string;
    skVerbose: string;
    skCompressed: string;
    filenameTemplate?: string | null;
    filenamePattern: string;
    idField: string;
    sourceDirs: Array<string>;
    legacySk: boolean;
    seedLoader?: string | null;
    dimensions: Array<{
      __typename?: 'RegistryDimensionDef';
      name: string;
      mapsTo?: string | null;
      source?: string | null;
      storage?: string | null;
      defaultValue?: string | null;
      examples: Array<string>;
    }>;
  }>;
};

export type GetCoverageGapsQueryVariables = Exact<{
  rulesetId: Scalars['String']['input'];
}>;

export type GetCoverageGapsQuery = {
  __typename?: 'Query';
  regulatoryCoverageGaps: {
    __typename?: 'CoverageGapReport';
    rulesetId: string;
    totalRules: number;
    coveredRules: number;
    coveragePercent: number;
    gaps: Array<{
      __typename?: 'CoverageGap';
      ruleId: string;
      ruleName: string;
      missingConfigs: Array<{
        __typename?: 'MissingConfig';
        configType: string;
        description: string;
        expectedTrigger: string;
      }>;
    }>;
  };
};

export type GetCoverageOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoverageOverviewQuery = {
  __typename?: 'Query';
  regulatoryCoverageOverview: Array<{
    __typename?: 'RulesetCoverageSummary';
    rulesetId: string;
    displayName: string;
    description: string;
    jurisdiction: string;
    setting: string;
    safetyLevel: string;
    totalRules: number;
    coveredRules: number;
    gapCount: number;
    coveragePercent: number;
  }>;
};

export type GetFilenameAbbreviationTablesQueryVariables = Exact<{ [key: string]: never }>;

export type GetFilenameAbbreviationTablesQuery = {
  __typename?: 'Query';
  filenameAbbreviationTables: Array<{
    __typename?: 'RegistryDimensionTable';
    name: string;
    count: number;
    codes: Array<{ __typename?: 'RegistryDimensionCode'; value: string; code: string }>;
  }>;
};

export type GetFormSchemaQueryVariables = Exact<{
  input: GetFormSchemaInput;
}>;

export type GetFormSchemaQuery = {
  __typename?: 'Query';
  formsGetFormSchema: {
    __typename?: 'SchemaResult';
    kind: string;
    schema: Record<string, unknown>;
    ui?: Record<string, unknown> | null;
  };
};

export type GetFormSchemaOverrideQueryVariables = Exact<{
  subgraph: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
}>;

export type GetFormSchemaOverrideQuery = {
  __typename?: 'Query';
  formSchemaOverride?: {
    __typename?: 'FormSchemaOverride';
    tenantId: string;
    subgraph: string;
    entityType: string;
    displayName?: string | null;
    description?: string | null;
    hiddenFields?: Array<string> | null;
    readonlyFields?: Array<string> | null;
    labelOverrides?: string | null;
    customFields?: Array<{
      __typename?: 'FormFieldDefinition';
      name: string;
      label: string;
      fieldType: FormFieldType;
      required: boolean;
      defaultValue?: string | null;
    }> | null;
  } | null;
};

export type GetFormSchemaOverrideCountQueryVariables = Exact<{
  subgraph: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
}>;

export type GetFormSchemaOverrideCountQuery = {
  __typename?: 'Query';
  formSchemaOverrideCount: number;
};

export type GetFormSchemaOverridesQueryVariables = Exact<{
  subgraph?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetFormSchemaOverridesQuery = {
  __typename?: 'Query';
  formSchemaOverrides: Array<{
    __typename?: 'FormSchemaOverrideSummary';
    subgraph: string;
    entityType: string;
    hiddenFieldCount: number;
    readonlyFieldCount: number;
    customFieldCount: number;
    labelOverrideCount: number;
    mandatory: boolean;
    statuteRef?: string | null;
  }>;
};

export type GetRegistryOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetRegistryOverviewQuery = {
  __typename?: 'Query';
  registryOverview: {
    __typename?: 'RegistryOverview';
    registryVersion: string;
    configTypeCount: number;
    dimensionTableCount: number;
    totalDimensionCodes: number;
    valkeyIndexPattern?: string | null;
    wasabiKeyPattern?: string | null;
  };
};

export type GetRegulatoryReadinessScoreQueryVariables = Exact<{ [key: string]: never }>;

export type GetRegulatoryReadinessScoreQuery = {
  __typename?: 'Query';
  regulatoryReadinessScore: {
    __typename?: 'GqlReadinessScore';
    totalRules: number;
    fullyEvidencedRules: number;
    partiallyEvidencedRules: number;
    totalEvidenceRequired: number;
    totalEvidenceFound: number;
    scorePct: number;
    criticalRulesTotal: number;
    criticalRulesEvidenced: number;
    highRulesTotal: number;
    highRulesEvidenced: number;
    gaps: Array<{
      __typename?: 'GqlEvidenceGap';
      ruleId: string;
      ruleText: string;
      safetyLevel: GqlSafetyLevel;
      evidenceName: string;
      evidenceDescription: string;
      required: boolean;
      foundDocumentIds: Array<string>;
    }>;
  };
};

export type GetTenantBrandingQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetTenantBrandingQuery = {
  __typename?: 'Query';
  getTenantBranding?: {
    __typename?: 'TenantBranding';
    tenantId: string;
    logoUrl?: string | null;
    faviconUrl?: string | null;
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
    fontFamily: string;
    companyName: string;
    companyTagline?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    websiteUrl?: string | null;
    terminology: Record<string, unknown>;
    customDomain?: string | null;
    subdomain: string;
    hideFerpBranding: boolean;
    showHelpCenter: boolean;
    showSupportChat: boolean;
    createdAt: string;
    updatedAt: string;
    version: number;
  } | null;
};

export type GetTenantBrandingAdminQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetTenantBrandingAdminQuery = {
  __typename?: 'Query';
  getTenantBranding?: {
    __typename?: 'TenantBranding';
    companyName: string;
    companyTagline?: string | null;
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
    fontFamily: string;
    logoUrl?: string | null;
    faviconUrl?: string | null;
    subdomain: string;
    customDomain?: string | null;
    address?: string | null;
    hours?: string | null;
    licenseType?: string | null;
    services: Array<string>;
    accreditations: Array<string>;
    complianceFrameworks: Array<string>;
    industry: string;
    hideFerpBranding: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetTenantBrandingBySubdomainQueryVariables = Exact<{
  subdomain: Scalars['String']['input'];
}>;

export type GetTenantBrandingBySubdomainQuery = {
  __typename?: 'Query';
  getTenantBrandingBySubdomain?: {
    __typename?: 'TenantBranding';
    tenantId: string;
    logoUrl?: string | null;
    faviconUrl?: string | null;
    primaryColor: string;
    secondaryColor: string;
    companyName: string;
    companyTagline?: string | null;
    terminology: Record<string, unknown>;
    subdomain: string;
  } | null;
};

export type GetUiSchemaQueryVariables = Exact<{
  module: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  context: Uicontext;
}>;

export type GetUiSchemaQuery = {
  __typename?: 'Query';
  uiSchema?: {
    __typename?: 'UIFormSchema';
    module: string;
    entityType: string;
    layout: UiFormLayout;
    title: string;
    description?: string | null;
    version: number;
    schemaVersion: string;
    fields: Array<{
      __typename?: 'UIFormFieldConfig';
      name: string;
      label: string;
      component: string;
      placeholder?: string | null;
      helpText?: string | null;
      disabled?: boolean | null;
      readOnly?: boolean | null;
    }>;
    actions: Array<{
      __typename?: 'FormAction';
      id: string;
      label: string;
      variant?: string | null;
      mutation?: string | null;
      confirmMessage?: string | null;
      isPrimary?: boolean | null;
    }>;
  } | null;
};

export type GetUiSchemaVersionQueryVariables = Exact<{ [key: string]: never }>;

export type GetUiSchemaVersionQuery = {
  __typename?: 'Query';
  uiSchemaVersion: {
    __typename?: 'UischemaVersionInfo';
    currentVersion: string;
    minSupportedVersion: string;
  };
};

export type LegacyArchiveFileQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;

export type LegacyArchiveFileQuery = {
  __typename?: 'Query';
  legacyArchiveFile?: {
    __typename?: 'LegacyArchiveFile';
    fileId: string;
    fileName: string;
    fileSize: number;
    contentType: string;
    scanStatus: ScanStatus;
    scanDate?: string | null;
    clamavVersion?: string | null;
    viewUrl?: string | null;
    downloadUrl?: string | null;
    canView: boolean;
    canDownload: boolean;
    warningLevel: WarningLevel;
    warningMessage?: string | null;
  } | null;
};

export type LegacyArchiveFilesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type LegacyArchiveFilesQuery = {
  __typename?: 'Query';
  legacyArchiveFiles: Array<{
    __typename?: 'LegacyArchiveFile';
    fileId: string;
    fileName: string;
    fileSize: number;
    contentType: string;
    scanStatus: ScanStatus;
    scanDate?: string | null;
    clamavVersion?: string | null;
    viewUrl?: string | null;
    downloadUrl?: string | null;
    canView: boolean;
    canDownload: boolean;
    warningLevel: WarningLevel;
    warningMessage?: string | null;
  }>;
};

export type ListPoliciesQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPoliciesQuery = {
  __typename?: 'Query';
  listPolicies: {
    __typename?: 'PolicyConnection';
    hasMore: boolean;
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'Policy';
      id: string;
      name: string;
      description?: string | null;
      policyType: GqlPolicyType;
      scope: GqlPolicyScope;
      implementation: GqlPolicyImplementation;
      enabled: boolean;
      active: boolean;
      auditLevel: GqlAuditLevel;
      version: number;
    }>;
  };
};

export type ListStandardsPacksForCuratorQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;

export type ListStandardsPacksForCuratorQuery = {
  __typename?: 'Query';
  listStandardsPacks: Array<{
    __typename?: 'StandardsPackListItem';
    id: string;
    standard: string;
    version: string;
    kind: GqlStandardsPackKind;
    description?: string | null;
    applicableDomains: Array<string>;
    applicableResourceTypes: Array<string>;
    createdAt: string;
  }>;
};

export type ListWebhookEndpointsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type ListWebhookEndpointsQuery = {
  __typename?: 'Query';
  listWebhookEndpoints: Array<{
    __typename?: 'WebhookEndpoint';
    endpointId: string;
    tenantId: string;
    url: string;
    events: Array<string>;
    active: boolean;
    createdAt: string;
  }>;
};

export type MyCapabilitiesQueryVariables = Exact<{
  context: CapabilityContext;
}>;

export type MyCapabilitiesQuery = {
  __typename?: 'Query';
  myCapabilities: {
    __typename?: 'Capabilities';
    canCreate: boolean;
    canRead: boolean;
    canUpdate: boolean;
    canDelete: boolean;
    canApprove: boolean;
    canDelegate: boolean;
    entityType: string;
    customActions: Array<{
      __typename?: 'CustomActionCapability';
      action: string;
      granted: boolean;
      reason?: string | null;
    }>;
  };
};

export type MyCapabilitiesBatchQueryVariables = Exact<{
  contexts: Array<CapabilityContext> | CapabilityContext;
}>;

export type MyCapabilitiesBatchQuery = {
  __typename?: 'Query';
  myCapabilitiesBatch: Array<{
    __typename?: 'Capabilities';
    canCreate: boolean;
    canRead: boolean;
    canUpdate: boolean;
    canDelete: boolean;
    canApprove: boolean;
    canDelegate: boolean;
    entityType: string;
    customActions: Array<{
      __typename?: 'CustomActionCapability';
      action: string;
      granted: boolean;
      reason?: string | null;
    }>;
  }>;
};

export type MyInboxQueryVariables = Exact<{
  status?: InputMaybe<TaskStatus>;
}>;

export type MyInboxQuery = {
  __typename?: 'Query';
  myInbox: Array<{
    __typename?: 'InboxTask';
    id: string;
    kind: TaskKind;
    title: string;
    status: TaskStatus;
    dueAt?: string | null;
    entityRef: string;
    deepLink?: string | null;
    requiresMfa: boolean;
    assignees: Array<string>;
    watchers: Array<string>;
    dualControl?: { __typename?: 'DualControl'; required: boolean; roles: Array<string> } | null;
    jitr?: { __typename?: 'JitRole'; role: string; ttlMins: number } | null;
  }>;
};

export type MyTraversalModeQueryVariables = Exact<{ [key: string]: never }>;

export type MyTraversalModeQuery = {
  __typename?: 'Query';
  myTraversalMode: {
    __typename?: 'GqlActorTraversalMode';
    mode: GqlTraversalMode;
    isActorOverride: boolean;
  };
};

export type MyViewLayerQueryVariables = Exact<{ [key: string]: never }>;

export type MyViewLayerQuery = { __typename?: 'Query'; myViewLayer: ViewLayer };

export type MyWitnessRequestsQueryVariables = Exact<{ [key: string]: never }>;

export type MyWitnessRequestsQuery = {
  __typename?: 'Query';
  myWitnessRequests: Array<{
    __typename?: 'WitnessRequestGql';
    id: string;
    tenantId: string;
    operatorId: string;
    operationType: WitnessOperationTypeGql;
    entityId: string;
    entityType: string;
    description: string;
    status: WitnessStatusGql;
    witnessId?: string | null;
    witnessRole?: string | null;
    createdAt: string;
    expiresAt: string;
    isExpired: boolean;
    secondsRemaining?: number | null;
  }>;
};

export type PendingWitnessRequestsQueryVariables = Exact<{ [key: string]: never }>;

export type PendingWitnessRequestsQuery = {
  __typename?: 'Query';
  pendingWitnessRequests: Array<{
    __typename?: 'WitnessRequestGql';
    id: string;
    tenantId: string;
    operatorId: string;
    operationType: WitnessOperationTypeGql;
    entityId: string;
    entityType: string;
    description: string;
    status: WitnessStatusGql;
    witnessId?: string | null;
    witnessRole?: string | null;
    createdAt: string;
    expiresAt: string;
    isExpired: boolean;
    secondsRemaining?: number | null;
  }>;
};

export type RecommendStandardsPacksForCuratorQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  workflow: Scalars['JSON']['input'];
}>;

export type RecommendStandardsPacksForCuratorQuery = {
  __typename?: 'Query';
  recommendStandardsPacks: {
    __typename?: 'RecommendationResult';
    workflowId: string;
    detectedDomain: string;
    detectedComplexity: string;
    confidence: number;
    analysisTimestamp: string;
    recommendations: Array<{
      __typename?: 'StandardsPackRecommendation';
      packId: string;
      packName: string;
      reason: string;
      confidence: number;
      priority: number;
      autoApply: boolean;
    }>;
  };
};

export type RecommendationsQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type RecommendationsQuery = {
  __typename?: 'Query';
  recommendations: {
    __typename?: 'RecommendationSummary';
    totalCount: number;
    pendingCount: number;
    adoptedCount: number;
    dismissedCount: number;
    recommendations: Array<{
      __typename?: 'BestPracticeRecommendation';
      practiceRef: string;
      title: string;
      description: string;
      sourceAssociation: string;
      sourceAssociationLabel: string;
      intelligenceLayer: GqlIntelligenceLayer;
      source: GqlRecommendationSource;
      adoptionStatus: GqlAdoptionStatus;
      recommendsConfigs: Array<string>;
      improves: Array<string>;
      mitigates: Array<string>;
      safetyLevel: string;
    }>;
  };
};

export type RegistryOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type RegistryOverviewQuery = {
  __typename?: 'Query';
  registryOverview: {
    __typename?: 'RegistryOverview';
    registryVersion: string;
    configTypeCount: number;
    dimensionTableCount: number;
    totalDimensionCodes: number;
    valkeyIndexPattern?: string | null;
    wasabiKeyPattern?: string | null;
  };
};

export type RequestEvidenceCertificateUrlQueryVariables = Exact<{
  ceremonyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;

export type RequestEvidenceCertificateUrlQuery = {
  __typename?: 'Query';
  requestEvidenceCertificateUrl: {
    __typename?: 'CeremonyDocumentUrl';
    downloadUrl: string;
    fileName: string;
    expiresInSeconds: number;
  };
};

export type ResolveSigningTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type ResolveSigningTokenQuery = {
  __typename?: 'Query';
  resolveSigningToken?: {
    __typename?: 'SigningTokenPayload';
    ceremonyId: string;
    participantIndex: number;
    participantName: string;
    participantEmail: string;
    documentName: string;
    documentId: string;
    tenantId: string;
    expiresAt?: string | null;
    alreadySigned: boolean;
    returnUrl?: string | null;
    fieldPage?: number | null;
    fieldX?: number | null;
    fieldY?: number | null;
    fieldWidth?: number | null;
    fieldHeight?: number | null;
    branding?: {
      __typename?: 'CeremonyBranding';
      logoUrl?: string | null;
      companyName?: string | null;
      primaryColor?: string | null;
    } | null;
    fields: Array<{
      __typename?: 'CeremonyPlacedField';
      fieldIndex: number;
      participantIndex: number;
      fieldType: SignatureFieldType;
      page: number;
      x: number;
      y: number;
      width: number;
      height: number;
      completed: boolean;
    }>;
  } | null;
};

export type SessionConflictsQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type SessionConflictsQuery = {
  __typename?: 'Query';
  sessionConflicts: Array<{
    __typename?: 'SyncConflict';
    conflictId: string;
    entityId: string;
    entityType: string;
    reason: GqlConflictReason;
    status: GqlConflictStatus;
    approvalId?: string | null;
    deviceAValue: Record<string, unknown>;
    deviceBValue?: Record<string, unknown> | null;
  }>;
};

export type SubjectJourneyTimelineQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SubjectJourneyTimelineQuery = {
  __typename?: 'Query';
  formsTaskSubjectJourneyTimeline: {
    __typename?: 'GqlJourneyTimeline';
    totalEvents: number;
    activeEventCount: number;
    events: Array<{
      __typename?: 'GqlJourneyTimelineEvent';
      eventId: string;
      constellationId: string;
      instanceId: string;
      startedAt: string;
      lastActivityAt: string;
      status: string;
      taskCount: number;
      taskTypes: Array<string>;
      performerCount: number;
      isRegulated: boolean;
      constellationName: string;
    }>;
  };
};

export type SyncConflictsQueryVariables = Exact<{
  status?: InputMaybe<GqlConflictStatus>;
}>;

export type SyncConflictsQuery = {
  __typename?: 'Query';
  syncConflicts: Array<{
    __typename?: 'SyncConflict';
    conflictId: string;
    entityId: string;
    entityType: string;
    reason: GqlConflictReason;
    status: GqlConflictStatus;
    approvalId?: string | null;
    deviceAValue: Record<string, unknown>;
    deviceBValue?: Record<string, unknown> | null;
  }>;
};

export type SyncHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type SyncHistoryQuery = {
  __typename?: 'Query';
  syncHistory: Array<{
    __typename?: 'SyncSession';
    sessionId: string;
    deviceId: string;
    actorId: string;
    status: GqlSyncStatus;
    entriesReceived: number;
    entriesGrafted: number;
    entriesConflicted: number;
    chainVerified: boolean;
    archiveKey?: string | null;
    sourceEnvironment?: string | null;
    startedAt: string;
    completedAt?: string | null;
  }>;
};

export type TranslateTermQueryVariables = Exact<{
  input: TranslateTermInput;
}>;

export type TranslateTermQuery = {
  __typename?: 'Query';
  translateTerm: {
    __typename?: 'TranslationResult';
    originalTerm: string;
    translatedTerm: string;
    tenantId: string;
  };
};

export type UpdateEntityQueryQueryVariables = Exact<{
  input: UpdateEntityInput;
}>;

export type UpdateEntityQueryQuery = {
  __typename?: 'Query';
  updateEntity: {
    __typename?: 'GenericEntity';
    id: string;
    name: string;
    entityType: string;
    status: EntityStatus;
    updatedAt: string;
  };
};

export type ZonesQueryVariables = Exact<{
  tenantNum: Scalars['Int']['input'];
}>;

export type ZonesQuery = {
  __typename?: 'Query';
  zones: Array<{
    __typename?: 'Zone';
    zoneId: string;
    name: string;
    zoneType: ZoneType;
    floor: number;
    description?: string | null;
    capacity: number;
    beaconMajor: number;
    beaconMinorStart: number;
    beaconMinorEnd: number;
    safetyLevel: ZoneSafetyLevel;
    elopementRelevant: boolean;
    activeBeaconCount: number;
    tenantNum: number;
  }>;
};

export type HasCompletedQueryVariables = Exact<{
  templateRef: Scalars['String']['input'];
  actorId: Scalars['String']['input'];
}>;

export type HasCompletedQuery = { __typename?: 'Query'; hasCompleted: boolean };

export type CompletionGapsQueryVariables = Exact<{
  templateRef: Scalars['String']['input'];
  requiredActorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type CompletionGapsQuery = {
  __typename?: 'Query';
  completionGaps: Array<{ __typename?: 'CompletionGap'; actorId: string; templateRef: string }>;
};

export type ActorCompletionsQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ActorCompletionsQuery = {
  __typename?: 'Query';
  actorCompletions: Array<{
    __typename?: 'CompletionProgress';
    templateRef: string;
    completedAt: string;
    outcome?: string | null;
  }>;
};

export type ActorCompletionCountQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
}>;

export type ActorCompletionCountQuery = { __typename?: 'Query'; actorCompletionCount: number };

export type TemplateCompletionCountQueryVariables = Exact<{
  templateRef: Scalars['String']['input'];
}>;

export type TemplateCompletionCountQuery = {
  __typename?: 'Query';
  templateCompletionCount: number;
};

export type ExpiringCredentialsQueryVariables = Exact<{
  templateRef: Scalars['String']['input'];
  withinDays?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ExpiringCredentialsQuery = {
  __typename?: 'Query';
  expiringCredentials: Array<{
    __typename?: 'ExpiringCredentialEntry';
    actorId: string;
    expiresAt: string;
    templateRef?: string | null;
  }>;
};

export type ExpiredCredentialsQueryVariables = Exact<{
  templateRef: Scalars['String']['input'];
}>;

export type ExpiredCredentialsQuery = { __typename?: 'Query'; expiredCredentials: Array<string> };

export type ActiveCredentialsQueryVariables = Exact<{
  templateRef: Scalars['String']['input'];
}>;

export type ActiveCredentialsQuery = { __typename?: 'Query'; activeCredentials: Array<string> };

export type ActorGapsQueryVariables = Exact<{
  actorId: Scalars['String']['input'];
  requiredTemplateRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ActorGapsQuery = { __typename?: 'Query'; actorGaps: Array<string> };

export type GetArchitectProposalQueryVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;

export type GetArchitectProposalQuery = {
  __typename?: 'Query';
  architectProposal?: {
    __typename?: 'ArchitectProposal';
    id: string;
    tenantId: string;
    configType: ConfigProposalType;
    configId: string;
    isNew: boolean;
    title: string;
    description: string;
    status: ProposalStatus;
    rejectionReason?: string | null;
    proposedBy: string;
    proposedAt: string;
    reviewedBy?: string | null;
    reviewedAt?: string | null;
    activatedAt?: string | null;
    updatedAt: string;
    simulation?: {
      __typename?: 'ArchitectProposalSimulation';
      passed: boolean;
      errorCount: number;
      warningCount: number;
      errors: Array<string>;
      warnings: Array<string>;
      simulatedAt: string;
    } | null;
  } | null;
};

export type ListArchitectProposalsQueryVariables = Exact<{
  status?: InputMaybe<ProposalStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListArchitectProposalsQuery = {
  __typename?: 'Query';
  architectProposals: Array<{
    __typename?: 'ArchitectProposal';
    id: string;
    tenantId: string;
    configType: ConfigProposalType;
    configId: string;
    isNew: boolean;
    title: string;
    description: string;
    status: ProposalStatus;
    rejectionReason?: string | null;
    proposedBy: string;
    proposedAt: string;
    reviewedBy?: string | null;
    reviewedAt?: string | null;
    activatedAt?: string | null;
    updatedAt: string;
    simulation?: {
      __typename?: 'ArchitectProposalSimulation';
      passed: boolean;
      errorCount: number;
      warningCount: number;
      errors: Array<string>;
      warnings: Array<string>;
      simulatedAt: string;
    } | null;
  }>;
};

export type GetPendingArchitectProposalsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPendingArchitectProposalsQuery = {
  __typename?: 'Query';
  pendingArchitectProposals: Array<{
    __typename?: 'ArchitectProposal';
    id: string;
    tenantId: string;
    configType: ConfigProposalType;
    configId: string;
    isNew: boolean;
    title: string;
    description: string;
    status: ProposalStatus;
    proposedBy: string;
    proposedAt: string;
    updatedAt: string;
    simulation?: {
      __typename?: 'ArchitectProposalSimulation';
      passed: boolean;
      errorCount: number;
      warningCount: number;
      errors: Array<string>;
      warnings: Array<string>;
      simulatedAt: string;
    } | null;
  }>;
};

export type HtmlPdfTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type HtmlPdfTemplatesQuery = { __typename?: 'Query'; htmlPdfTemplates: Array<string> };

export type MyAccessibleSubgraphsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type MyAccessibleSubgraphsQuery = {
  __typename?: 'Query';
  myAccessibleSubgraphs: { __typename?: 'SubgraphList'; subgraphs: Array<string> };
};

export type MyRoleIdsQueryVariables = Exact<{ [key: string]: never }>;

export type MyRoleIdsQuery = { __typename?: 'Query'; myRoleIds: Array<string> };

export type FhirMedicationsBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type FhirMedicationsBySubjectQuery = {
  __typename?: 'Query';
  fhirMedicationsBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    createdBy: string;
    createdAt: string;
  }>;
};

export type FhirAllergiesBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type FhirAllergiesBySubjectQuery = {
  __typename?: 'Query';
  fhirAllergiesBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    createdBy: string;
    createdAt: string;
  }>;
};

export type FhirMedAdminsBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FhirMedAdminsBySubjectQuery = {
  __typename?: 'Query';
  fhirMedAdminsBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    createdBy: string;
    createdAt: string;
  }>;
};

export type FhirMedDispensesBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type FhirMedDispensesBySubjectQuery = {
  __typename?: 'Query';
  fhirMedDispensesBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    createdBy: string;
    createdAt: string;
  }>;
};

export type FhirMedStatementsBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type FhirMedStatementsBySubjectQuery = {
  __typename?: 'Query';
  fhirMedStatementsBySubject: Array<{
    __typename?: 'FhirStoredResourceType';
    tenantNum: number;
    resourceType: string;
    resourceId: string;
    version: number;
    isLatest: boolean;
    fhirJson: string;
    createdBy: string;
    createdAt: string;
  }>;
};

export type FhirPrescriptionSchedulesBySubjectQueryVariables = Exact<{
  subjectActorId: Scalars['String']['input'];
}>;

export type FhirPrescriptionSchedulesBySubjectQuery = {
  __typename?: 'Query';
  fhirPrescriptionSchedulesBySubject: Record<string, unknown>;
};

export type FoodServiceStationOrdersQueryVariables = Exact<{
  station: FoodServiceStation;
}>;

export type FoodServiceStationOrdersQuery = {
  __typename?: 'Query';
  stationOrders: Array<{
    __typename?: 'FoodServiceOrder';
    id: string;
    orderNumber: string;
    status: FoodServiceOrderStatus;
    brand: string;
    station?: FoodServiceStation | null;
    createdAt: number;
    slaTargetMinutes: number;
    elapsedSeconds: number;
    customerName?: string | null;
    specialInstructions?: string | null;
    items: Array<{
      __typename?: 'FoodServiceOrderItem';
      id: string;
      name: string;
      quantity: number;
      status: FoodServiceDishStatus;
      station: FoodServiceStation;
      elapsedSeconds: number;
      targetSeconds: number;
      modifications: Array<string>;
    }>;
  }>;
};

export type FoodServiceReadyForPickupQueryVariables = Exact<{ [key: string]: never }>;

export type FoodServiceReadyForPickupQuery = {
  __typename?: 'Query';
  readyForPickup: Array<{
    __typename?: 'FoodServiceOrder';
    id: string;
    orderNumber: string;
    status: FoodServiceOrderStatus;
    brand: string;
    createdAt: number;
    slaTargetMinutes: number;
    elapsedSeconds: number;
    customerName?: string | null;
    deliveryAddress?: string | null;
    items: Array<{
      __typename?: 'FoodServiceOrderItem';
      id: string;
      name: string;
      quantity: number;
      status: FoodServiceDishStatus;
      station: FoodServiceStation;
    }>;
  }>;
};

export type FoodServicePendingQcQueryVariables = Exact<{ [key: string]: never }>;

export type FoodServicePendingQcQuery = {
  __typename?: 'Query';
  pendingQc: Array<{
    __typename?: 'FoodServiceOrder';
    id: string;
    orderNumber: string;
    status: FoodServiceOrderStatus;
    brand: string;
    createdAt: number;
    elapsedSeconds: number;
    customerName?: string | null;
    items: Array<{
      __typename?: 'FoodServiceOrderItem';
      id: string;
      name: string;
      quantity: number;
      status: FoodServiceDishStatus;
      station: FoodServiceStation;
    }>;
  }>;
};

export type FoodServiceAvailableDriversQueryVariables = Exact<{ [key: string]: never }>;

export type FoodServiceAvailableDriversQuery = {
  __typename?: 'Query';
  availableDrivers: Array<{
    __typename?: 'FoodServiceDriver';
    id: string;
    name: string;
    status: FoodServiceDriverStatus;
    currentDeliveryId?: string | null;
    locationLat?: number | null;
    locationLng?: number | null;
    distanceMiles?: number | null;
  }>;
};

export type FoodServiceDriverDeliveriesQueryVariables = Exact<{
  driverId: Scalars['String']['input'];
}>;

export type FoodServiceDriverDeliveriesQuery = {
  __typename?: 'Query';
  driverDeliveries: Array<{
    __typename?: 'FoodServiceDelivery';
    id: string;
    orderId: string;
    orderNumber: string;
    brand: string;
    customerName: string;
    deliveryAddress: string;
    customerPhone?: string | null;
    items: Array<string>;
    specialInstructions?: string | null;
    pickedUpAt?: number | null;
    estimatedArrivalMinutes?: number | null;
  }>;
};

export type FoodServiceKitchenMetricsQueryVariables = Exact<{ [key: string]: never }>;

export type FoodServiceKitchenMetricsQuery = {
  __typename?: 'Query';
  kitchenMetrics: {
    __typename?: 'FoodServiceKitchenMetrics';
    ordersToday: number;
    ordersInProgress: number;
    avgPrepTimeMinutes: number;
    ordersByBrand: Array<{ __typename?: 'FoodServiceBrandCount'; brand: string; count: number }>;
    stationUtilization: Array<{
      __typename?: 'FoodServiceStationMetric';
      station: FoodServiceStation;
      ordersInQueue: number;
      avgTimeSeconds: number;
    }>;
  };
};

export type FoodServiceOrderStatusQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;

export type FoodServiceOrderStatusQuery = {
  __typename?: 'Query';
  orderStatus?: {
    __typename?: 'FoodServiceOrder';
    id: string;
    orderNumber: string;
    status: FoodServiceOrderStatus;
    brand: string;
    station?: FoodServiceStation | null;
    createdAt: number;
    slaTargetMinutes: number;
    elapsedSeconds: number;
    customerName?: string | null;
    deliveryAddress?: string | null;
    specialInstructions?: string | null;
    items: Array<{
      __typename?: 'FoodServiceOrderItem';
      id: string;
      name: string;
      quantity: number;
      status: FoodServiceDishStatus;
      station: FoodServiceStation;
      elapsedSeconds: number;
      targetSeconds: number;
      modifications: Array<string>;
    }>;
  } | null;
};

export type FoodServiceHaccpReportQueryVariables = Exact<{
  startDate: Scalars['Int']['input'];
  endDate: Scalars['Int']['input'];
}>;

export type FoodServiceHaccpReportQuery = {
  __typename?: 'Query';
  haccpReport: {
    __typename?: 'FoodServiceHaccpReport';
    startDate: number;
    endDate: number;
    tempLogComplianceRate: number;
    sanitationComplianceRate: number;
    criticalViolations: number;
    correctiveActionsTaken: number;
    tempLogs: Array<{
      __typename?: 'FoodServiceTempLog';
      id: string;
      taskId: string;
      equipmentId: string;
      equipmentName: string;
      temperatureF: number;
      recordedAt: number;
      recordedByActorId: string;
      inRange: boolean;
      correctiveAction?: string | null;
    }>;
    sanitationRecords: Array<{
      __typename?: 'FoodServiceSanitationRecord';
      id: string;
      taskGroupRef: string;
      taskGroupName: string;
      completedTasks: number;
      totalTasks: number;
      completionPercentage: number;
      completedAt?: number | null;
      completedByActorId?: string | null;
    }>;
  };
};

export type FoodServiceMyStationAssignmentQueryVariables = Exact<{ [key: string]: never }>;

export type FoodServiceMyStationAssignmentQuery = {
  __typename?: 'Query';
  myStationAssignment: {
    __typename?: 'FoodServiceStationAssignment';
    actorId: string;
    station?: FoodServiceStation | null;
    stationName: string;
    assignedAt?: number | null;
  };
};

export type FoodServiceDriverDailyStatsQueryVariables = Exact<{
  driverId?: InputMaybe<Scalars['String']['input']>;
}>;

export type FoodServiceDriverDailyStatsQuery = {
  __typename?: 'Query';
  driverDailyStats: {
    __typename?: 'FoodServiceDriverDailyStats';
    actorId: string;
    deliveriesCompleted: number;
    tipsCents: number;
    avgDeliveryMinutes: number;
    milesDriven: number;
    date: string;
  };
};

export type GetTenantSubgraphConfigQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type GetTenantSubgraphConfigQuery = {
  __typename?: 'Query';
  getTenantSubgraphConfig: {
    __typename?: 'TenantSubgraphConfig';
    tenantId: string;
    enabledSubgraphIds: Array<string>;
    hasLifeCritical: boolean;
    allRoutes: Array<{
      __typename?: 'SubgraphRoute';
      path: string;
      component: string;
      layer: ViewLayer;
      title: string;
      requiredPermissions: Array<string>;
      requiresLifeCriticalAuth: boolean;
    }>;
    allNavItems: Array<{
      __typename?: 'SubgraphNavItem';
      id: string;
      label: string;
      path: string;
      icon: string;
      layer: ViewLayer;
      sortOrder: number;
      parentId?: string | null;
      badge?: Record<string, unknown> | null;
    }>;
    allEntityTypes: Array<{
      __typename?: 'SubgraphEntityType';
      name: string;
      pluralName: string;
      description: string;
      graphqlType: string;
      displayField: string;
      identifierFields: Array<string>;
      formSchemaId?: string | null;
      listSchemaId?: string | null;
      isLifeCritical: boolean;
      complianceFrameworks: Array<string>;
      permissions: {
        __typename?: 'EntityPermissions';
        create: string;
        read: string;
        update: string;
        delete: string;
        list: string;
      };
    }>;
    allPermissionScopes: Array<{
      __typename?: 'SubgraphPermissionScope';
      scope: string;
      description: string;
      resourceType: string;
      action: string;
      isLifeCritical: boolean;
    }>;
    subgraphs: Array<{
      __typename?: 'SubgraphMetadata';
      subgraphId: string;
      displayName: string;
      description: string;
      icon: string;
      color: string;
      isLifeCritical: boolean;
      complianceFrameworks: Array<string>;
    }>;
  };
};

export type ListAllSubgraphMetadataQueryVariables = Exact<{ [key: string]: never }>;

export type ListAllSubgraphMetadataQuery = {
  __typename?: 'Query';
  listAllSubgraphMetadata: Array<{
    __typename?: 'SubgraphMetadata';
    subgraphId: string;
    displayName: string;
    description: string;
    version: string;
    isLifeCritical: boolean;
    complianceFrameworks: Array<string>;
    navItems: Array<{
      __typename?: 'SubgraphNavItem';
      id: string;
      label: string;
      path: string;
      icon: string;
      layer: ViewLayer;
      sortOrder: number;
      parentId?: string | null;
    }>;
    entityTypes: Array<{
      __typename?: 'SubgraphEntityType';
      name: string;
      pluralName: string;
      graphqlType: string;
      isLifeCritical: boolean;
    }>;
  }>;
};

export type GetSubgraphMetadataQueryVariables = Exact<{
  subgraphId: Scalars['String']['input'];
}>;

export type GetSubgraphMetadataQuery = {
  __typename?: 'Query';
  getSubgraphMetadata?: {
    __typename?: 'SubgraphMetadata';
    subgraphId: string;
    displayName: string;
    description: string;
    version: string;
    isLifeCritical: boolean;
    complianceFrameworks: Array<string>;
    navItems: Array<{
      __typename?: 'SubgraphNavItem';
      id: string;
      label: string;
      path: string;
      icon: string;
      layer: ViewLayer;
      sortOrder: number;
      parentId?: string | null;
    }>;
    entityTypes: Array<{
      __typename?: 'SubgraphEntityType';
      name: string;
      pluralName: string;
      description: string;
      graphqlType: string;
      displayField: string;
      identifierFields: Array<string>;
      formSchemaId?: string | null;
      listSchemaId?: string | null;
      isLifeCritical: boolean;
      complianceFrameworks: Array<string>;
      permissions: {
        __typename?: 'EntityPermissions';
        create: string;
        read: string;
        update: string;
        delete: string;
        list: string;
      };
    }>;
    routes: Array<{
      __typename?: 'SubgraphRoute';
      path: string;
      component: string;
      layer: ViewLayer;
      title: string;
      requiredPermissions: Array<string>;
      requiresLifeCriticalAuth: boolean;
    }>;
    permissionScopes: Array<{
      __typename?: 'SubgraphPermissionScope';
      scope: string;
      description: string;
      resourceType: string;
      action: string;
      isLifeCritical: boolean;
    }>;
  } | null;
};

export type ListLifeCriticalSubgraphsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type ListLifeCriticalSubgraphsQuery = {
  __typename?: 'Query';
  listLifeCriticalSubgraphs: { __typename?: 'SubgraphList'; subgraphs: Array<string> };
};

export type GetAllowedNavigationQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  layer: ViewLayer;
}>;

export type GetAllowedNavigationQuery = {
  __typename?: 'Query';
  allowedNavigation: {
    __typename?: 'AllowedNavigation';
    userScopes: Array<string>;
    navItems: Array<{
      __typename?: 'SubgraphNavItem';
      id: string;
      label: string;
      path: string;
      icon: string;
      layer: ViewLayer;
      sortOrder: number;
      parentId?: string | null;
      badge?: Record<string, unknown> | null;
    }>;
    routes: Array<{
      __typename?: 'SubgraphRoute';
      path: string;
      component: string;
      layer: ViewLayer;
      title: string;
      requiredPermissions: Array<string>;
      requiresLifeCriticalAuth: boolean;
    }>;
    allowedEntityTypes: Array<{
      __typename?: 'SubgraphEntityType';
      name: string;
      pluralName: string;
      description: string;
      graphqlType: string;
      displayField: string;
      identifierFields: Array<string>;
      formSchemaId?: string | null;
      listSchemaId?: string | null;
      isLifeCritical: boolean;
      complianceFrameworks: Array<string>;
      permissions: {
        __typename?: 'EntityPermissions';
        create: string;
        read: string;
        update: string;
        delete: string;
        list: string;
      };
    }>;
  };
};

export type CreateSubgraphMetadataMutationVariables = Exact<{
  input: SubgraphMetadataInput;
}>;

export type CreateSubgraphMetadataMutation = {
  __typename?: 'Mutation';
  createSubgraphMetadata: {
    __typename?: 'SubgraphMetadata';
    subgraphId: string;
    displayName: string;
    version: string;
    isLifeCritical: boolean;
  };
};

export type CreateVersionSubgraphMetadataMutationVariables = Exact<{
  subgraphId: Scalars['String']['input'];
  input: SubgraphMetadataInput;
}>;

export type CreateVersionSubgraphMetadataMutation = {
  __typename?: 'Mutation';
  createVersionSubgraphMetadata: {
    __typename?: 'SubgraphMetadata';
    subgraphId: string;
    displayName: string;
    version: string;
    isLifeCritical: boolean;
  };
};

export type ArchiveSubgraphMetadataMutationVariables = Exact<{
  subgraphId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;

export type ArchiveSubgraphMetadataMutation = {
  __typename?: 'Mutation';
  archiveSubgraphMetadata: {
    __typename?: 'ArchiveResult';
    success: boolean;
    archivedAt?: string | null;
    archivedBy?: string | null;
    reason?: string | null;
    message: string;
  };
};

export const FhirStoredFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FhirStoredFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FhirStoredResourceType' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WorkflowFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GuardEntryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuardEntryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuardEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expression' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ConstraintFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConstraintFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Constraint' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'constraintType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monitoredEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monitoredEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentUsage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scopeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scopeId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DependencyFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DependencyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Dependency' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConditional' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FormSchemaFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FormSchemaFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FormSchema' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WorkItemFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkItemFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'detailSk' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ActorFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PolicyFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PolicyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Policy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'implementation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PermissionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EffectivePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ownPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inheritedPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'effectivePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const QueueFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorMap' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventTopic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastAssignmentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricsCollectedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eligibilityRules' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityRules' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationWindowSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultPriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostThresholdSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostIncrement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetProcessingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetAvgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPerformanceCheckAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ScheduleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TaskFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StateFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkflowState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyRefs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const EventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SagaFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SagaFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SagaDefinitionGQL' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sagaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DagNodeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DAGNodeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DAGNode' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'incomingDependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outgoingDependencies' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MetricFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MetricFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlQueueStatistics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'queueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'utilizationPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverThreshold' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AlertFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlertFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remediationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remediationRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AuditFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuditFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditQL' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'frameworkType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compliancePeriodStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compliancePeriodEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryQuestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueEventTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'findingsSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationsDetected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userActionCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primitiveTypesAccessed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'navigationPaths' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSpentSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessPatterns' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featuresUsed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featuresUnused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'adoptionRatePercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionYears' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'immutabilityRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signatureRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataLineage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportTemplateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportS3Url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generatedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueActors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueWorkflows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiConfidence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chaosExtractionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalWorkflowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousAuditId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subgraphReferences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastValidationTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const NotificationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primitiveType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTaskIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedSlaIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedApprovalIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTransactionIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ContractFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContractFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contract' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationAtPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'elapsedMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolutionTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalateAfterMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationChain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'breachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceRate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastBreachAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RiskFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RiskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remediationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const EvidenceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EvidenceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentVersionInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changeDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const VersionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VersionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentVersionInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changeDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GenerateIdResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GenerateIdResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateIdResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RegulatoryRuleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegulatoryRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRegulatoryRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structured' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fhirResource' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exceptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alternativeAction' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'source' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivision' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paragraph' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidencePercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piiImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changelog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresHumanReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewComment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RuleImportResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RuleImportResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRuleImportResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routeDecision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyOverride' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictsDetected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const BatchImportResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BatchImportResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlBatchImportResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'importedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoApprovedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRequiredCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RuleImportResultFields' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RuleImportResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRuleImportResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routeDecision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyOverride' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictsDetected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const QueueStatsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueStatsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlQueueStats' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoApproved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confidenceReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safetyReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'humanReviewPercentage' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TemplateFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TemplateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Template' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Role' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'permissionMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TeamFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ValidationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ValidationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Validation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBlocking' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionPhase' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InstanceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ApprovalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DocumentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Document' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storageType' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Bucket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamodbContent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRuleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryEvidenceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TraceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TraceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trace' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'traceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spanId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentSpanId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spanType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CheckpointFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CheckpointFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Checkpoint' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkpointName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkpointType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canRollback' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rollbackCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rollbackStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotEncrypted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressionRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionDays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastAccessedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRollbackAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRollbackReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recoveryAttemptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recoverySuccess' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recoveredByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'serializationDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateSnapshot' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotChecksum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deltaFromPrevious' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoArchiveAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxResumeAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rollbackOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TransactionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Transaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'transactionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isolationLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'committedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AnalyticsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyticsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Analytics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticalThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ResourceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLifeCriticalResource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const IntegrationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ApprovalDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const QueueDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const NotificationDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTaskIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedApprovalIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const IsDslAvailableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IsDslAvailable' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDslAvailable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useIsDslAvailableQuery__
 *
 * To run a query within a React component, call `useIsDslAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDslAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDslAvailableQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsDslAvailableQuery(
  baseOptions?: Apollo.QueryHookOptions<IsDslAvailableQuery, IsDslAvailableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsDslAvailableQuery, IsDslAvailableQueryVariables>(
    IsDslAvailableDocument,
    options,
  );
}
export function useIsDslAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IsDslAvailableQuery, IsDslAvailableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IsDslAvailableQuery, IsDslAvailableQueryVariables>(
    IsDslAvailableDocument,
    options,
  );
}
// @ts-ignore
export function useIsDslAvailableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IsDslAvailableQuery, IsDslAvailableQueryVariables>,
): Apollo.UseSuspenseQueryResult<IsDslAvailableQuery, IsDslAvailableQueryVariables>;
export function useIsDslAvailableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IsDslAvailableQuery, IsDslAvailableQueryVariables>,
): Apollo.UseSuspenseQueryResult<IsDslAvailableQuery | undefined, IsDslAvailableQueryVariables>;
export function useIsDslAvailableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IsDslAvailableQuery, IsDslAvailableQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IsDslAvailableQuery, IsDslAvailableQueryVariables>(
    IsDslAvailableDocument,
    options,
  );
}
export type IsDslAvailableQueryHookResult = ReturnType<typeof useIsDslAvailableQuery>;
export type IsDslAvailableLazyQueryHookResult = ReturnType<typeof useIsDslAvailableLazyQuery>;
export type IsDslAvailableSuspenseQueryHookResult = ReturnType<
  typeof useIsDslAvailableSuspenseQuery
>;
export type IsDslAvailableQueryResult = Apollo.QueryResult<
  IsDslAvailableQuery,
  IsDslAvailableQueryVariables
>;
export const GetDslSyntaxHelpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDslSyntaxHelp' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDslSyntaxHelp' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operators' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'example' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'builtinFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'builtinActions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'examples' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'syntaxReference' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDslSyntaxHelpQuery__
 *
 * To run a query within a React component, call `useGetDslSyntaxHelpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDslSyntaxHelpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDslSyntaxHelpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDslSyntaxHelpQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>(
    GetDslSyntaxHelpDocument,
    options,
  );
}
export function useGetDslSyntaxHelpLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>(
    GetDslSyntaxHelpDocument,
    options,
  );
}
// @ts-ignore
export function useGetDslSyntaxHelpSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDslSyntaxHelpQuery,
    GetDslSyntaxHelpQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>;
export function useGetDslSyntaxHelpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDslSyntaxHelpQuery | undefined, GetDslSyntaxHelpQueryVariables>;
export function useGetDslSyntaxHelpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDslSyntaxHelpQuery, GetDslSyntaxHelpQueryVariables>(
    GetDslSyntaxHelpDocument,
    options,
  );
}
export type GetDslSyntaxHelpQueryHookResult = ReturnType<typeof useGetDslSyntaxHelpQuery>;
export type GetDslSyntaxHelpLazyQueryHookResult = ReturnType<typeof useGetDslSyntaxHelpLazyQuery>;
export type GetDslSyntaxHelpSuspenseQueryHookResult = ReturnType<
  typeof useGetDslSyntaxHelpSuspenseQuery
>;
export type GetDslSyntaxHelpQueryResult = Apollo.QueryResult<
  GetDslSyntaxHelpQuery,
  GetDslSyntaxHelpQueryVariables
>;
export const CompileDslDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompileDsl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompileDslInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compileDsl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jdm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inputFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'line' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'column' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ferpCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompileDslMutationFn = ApolloMutationFunction<
  CompileDslMutation,
  CompileDslMutationVariables
>;

/**
 * __useCompileDslMutation__
 *
 * To run a mutation, you first call `useCompileDslMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompileDslMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [compileDslMutation, { data, loading, error }] = useCompileDslMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompileDslMutation(
  baseOptions?: Apollo.MutationHookOptions<CompileDslMutation, CompileDslMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompileDslMutation, CompileDslMutationVariables>(
    CompileDslDocument,
    options,
  );
}
export type CompileDslMutationHookResult = ReturnType<typeof useCompileDslMutation>;
export type CompileDslMutationResult = Apollo.MutationResult<CompileDslMutation>;
export type CompileDslMutationOptions = ApolloBaseMutationOptions<
  CompileDslMutation,
  CompileDslMutationVariables
>;
export const ValidateDslDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ValidateDsl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidateDslInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateDsl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'line' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'column' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ferpCode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rulesSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deadlineSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'terminal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conditionCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ValidateDslMutationFn = ApolloMutationFunction<
  ValidateDslMutation,
  ValidateDslMutationVariables
>;

/**
 * __useValidateDslMutation__
 *
 * To run a mutation, you first call `useValidateDslMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDslMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDslMutation, { data, loading, error }] = useValidateDslMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateDslMutation(
  baseOptions?: Apollo.MutationHookOptions<ValidateDslMutation, ValidateDslMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ValidateDslMutation, ValidateDslMutationVariables>(
    ValidateDslDocument,
    options,
  );
}
export type ValidateDslMutationHookResult = ReturnType<typeof useValidateDslMutation>;
export type ValidateDslMutationResult = Apollo.MutationResult<ValidateDslMutation>;
export type ValidateDslMutationOptions = ApolloBaseMutationOptions<
  ValidateDslMutation,
  ValidateDslMutationVariables
>;
export const ListPolicyRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListPolicyRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'policyType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listPolicyRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'policyType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'policyType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conditions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListPolicyRulesQuery__
 *
 * To run a query within a React component, call `useListPolicyRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPolicyRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPolicyRulesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      policyType: // value for 'policyType'
 *   },
 * });
 */
export function useListPolicyRulesQuery(
  baseOptions: Apollo.QueryHookOptions<ListPolicyRulesQuery, ListPolicyRulesQueryVariables> &
    ({ variables: ListPolicyRulesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPolicyRulesQuery, ListPolicyRulesQueryVariables>(
    ListPolicyRulesDocument,
    options,
  );
}
export function useListPolicyRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPolicyRulesQuery, ListPolicyRulesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPolicyRulesQuery, ListPolicyRulesQueryVariables>(
    ListPolicyRulesDocument,
    options,
  );
}
// @ts-ignore
export function useListPolicyRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPolicyRulesQuery,
    ListPolicyRulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListPolicyRulesQuery, ListPolicyRulesQueryVariables>;
export function useListPolicyRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPolicyRulesQuery, ListPolicyRulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListPolicyRulesQuery | undefined, ListPolicyRulesQueryVariables>;
export function useListPolicyRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPolicyRulesQuery, ListPolicyRulesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPolicyRulesQuery, ListPolicyRulesQueryVariables>(
    ListPolicyRulesDocument,
    options,
  );
}
export type ListPolicyRulesQueryHookResult = ReturnType<typeof useListPolicyRulesQuery>;
export type ListPolicyRulesLazyQueryHookResult = ReturnType<typeof useListPolicyRulesLazyQuery>;
export type ListPolicyRulesSuspenseQueryHookResult = ReturnType<
  typeof useListPolicyRulesSuspenseQuery
>;
export type ListPolicyRulesQueryResult = Apollo.QueryResult<
  ListPolicyRulesQuery,
  ListPolicyRulesQueryVariables
>;
export const GetPolicyRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPolicyRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'policyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPolicyRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'policyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'policyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conditions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPolicyRuleQuery__
 *
 * To run a query within a React component, call `useGetPolicyRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyRuleQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetPolicyRuleQuery(
  baseOptions: Apollo.QueryHookOptions<GetPolicyRuleQuery, GetPolicyRuleQueryVariables> &
    ({ variables: GetPolicyRuleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>(
    GetPolicyRuleDocument,
    options,
  );
}
export function useGetPolicyRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>(
    GetPolicyRuleDocument,
    options,
  );
}
// @ts-ignore
export function useGetPolicyRuleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>;
export function useGetPolicyRuleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPolicyRuleQuery | undefined, GetPolicyRuleQueryVariables>;
export function useGetPolicyRuleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPolicyRuleQuery, GetPolicyRuleQueryVariables>(
    GetPolicyRuleDocument,
    options,
  );
}
export type GetPolicyRuleQueryHookResult = ReturnType<typeof useGetPolicyRuleQuery>;
export type GetPolicyRuleLazyQueryHookResult = ReturnType<typeof useGetPolicyRuleLazyQuery>;
export type GetPolicyRuleSuspenseQueryHookResult = ReturnType<typeof useGetPolicyRuleSuspenseQuery>;
export type GetPolicyRuleQueryResult = Apollo.QueryResult<
  GetPolicyRuleQuery,
  GetPolicyRuleQueryVariables
>;
export const CreatePolicyRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePolicyRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePolicyRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPolicyRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreatePolicyRuleMutationFn = ApolloMutationFunction<
  CreatePolicyRuleMutation,
  CreatePolicyRuleMutationVariables
>;

/**
 * __useCreatePolicyRuleMutation__
 *
 * To run a mutation, you first call `useCreatePolicyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyRuleMutation, { data, loading, error }] = useCreatePolicyRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePolicyRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePolicyRuleMutation,
    CreatePolicyRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePolicyRuleMutation, CreatePolicyRuleMutationVariables>(
    CreatePolicyRuleDocument,
    options,
  );
}
export type CreatePolicyRuleMutationHookResult = ReturnType<typeof useCreatePolicyRuleMutation>;
export type CreatePolicyRuleMutationResult = Apollo.MutationResult<CreatePolicyRuleMutation>;
export type CreatePolicyRuleMutationOptions = ApolloBaseMutationOptions<
  CreatePolicyRuleMutation,
  CreatePolicyRuleMutationVariables
>;
export const UpdatePolicyRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePolicyRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePolicyRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePolicyRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdatePolicyRuleMutationFn = ApolloMutationFunction<
  UpdatePolicyRuleMutation,
  UpdatePolicyRuleMutationVariables
>;

/**
 * __useUpdatePolicyRuleMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyRuleMutation, { data, loading, error }] = useUpdatePolicyRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePolicyRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePolicyRuleMutation,
    UpdatePolicyRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePolicyRuleMutation, UpdatePolicyRuleMutationVariables>(
    UpdatePolicyRuleDocument,
    options,
  );
}
export type UpdatePolicyRuleMutationHookResult = ReturnType<typeof useUpdatePolicyRuleMutation>;
export type UpdatePolicyRuleMutationResult = Apollo.MutationResult<UpdatePolicyRuleMutation>;
export type UpdatePolicyRuleMutationOptions = ApolloBaseMutationOptions<
  UpdatePolicyRuleMutation,
  UpdatePolicyRuleMutationVariables
>;
export const ArchivePolicyRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchivePolicyRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivePolicyRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivePolicyRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchivePolicyRuleMutationFn = ApolloMutationFunction<
  ArchivePolicyRuleMutation,
  ArchivePolicyRuleMutationVariables
>;

/**
 * __useArchivePolicyRuleMutation__
 *
 * To run a mutation, you first call `useArchivePolicyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePolicyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePolicyRuleMutation, { data, loading, error }] = useArchivePolicyRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchivePolicyRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchivePolicyRuleMutation,
    ArchivePolicyRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchivePolicyRuleMutation, ArchivePolicyRuleMutationVariables>(
    ArchivePolicyRuleDocument,
    options,
  );
}
export type ArchivePolicyRuleMutationHookResult = ReturnType<typeof useArchivePolicyRuleMutation>;
export type ArchivePolicyRuleMutationResult = Apollo.MutationResult<ArchivePolicyRuleMutation>;
export type ArchivePolicyRuleMutationOptions = ApolloBaseMutationOptions<
  ArchivePolicyRuleMutation,
  ArchivePolicyRuleMutationVariables
>;
export const DryRunPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DryRunPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DryRunPolicyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dryRunPolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'policyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matched' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conditionsEvaluated' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'condition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'matched' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actionsToExecute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'zenDsl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DryRunPolicyMutationFn = ApolloMutationFunction<
  DryRunPolicyMutation,
  DryRunPolicyMutationVariables
>;

/**
 * __useDryRunPolicyMutation__
 *
 * To run a mutation, you first call `useDryRunPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDryRunPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dryRunPolicyMutation, { data, loading, error }] = useDryRunPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDryRunPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<DryRunPolicyMutation, DryRunPolicyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DryRunPolicyMutation, DryRunPolicyMutationVariables>(
    DryRunPolicyDocument,
    options,
  );
}
export type DryRunPolicyMutationHookResult = ReturnType<typeof useDryRunPolicyMutation>;
export type DryRunPolicyMutationResult = Apollo.MutationResult<DryRunPolicyMutation>;
export type DryRunPolicyMutationOptions = ApolloBaseMutationOptions<
  DryRunPolicyMutation,
  DryRunPolicyMutationVariables
>;
export const ListPolicyTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListPolicyTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listPolicyTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conditionTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actionTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paramsTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPriority' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parameters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paramType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validation' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'useCases' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListPolicyTemplatesQuery__
 *
 * To run a query within a React component, call `useListPolicyTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPolicyTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPolicyTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPolicyTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListPolicyTemplatesQuery,
    ListPolicyTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPolicyTemplatesQuery, ListPolicyTemplatesQueryVariables>(
    ListPolicyTemplatesDocument,
    options,
  );
}
export function useListPolicyTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPolicyTemplatesQuery,
    ListPolicyTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPolicyTemplatesQuery, ListPolicyTemplatesQueryVariables>(
    ListPolicyTemplatesDocument,
    options,
  );
}
// @ts-ignore
export function useListPolicyTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPolicyTemplatesQuery,
    ListPolicyTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListPolicyTemplatesQuery, ListPolicyTemplatesQueryVariables>;
export function useListPolicyTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPolicyTemplatesQuery, ListPolicyTemplatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListPolicyTemplatesQuery | undefined,
  ListPolicyTemplatesQueryVariables
>;
export function useListPolicyTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPolicyTemplatesQuery, ListPolicyTemplatesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPolicyTemplatesQuery, ListPolicyTemplatesQueryVariables>(
    ListPolicyTemplatesDocument,
    options,
  );
}
export type ListPolicyTemplatesQueryHookResult = ReturnType<typeof useListPolicyTemplatesQuery>;
export type ListPolicyTemplatesLazyQueryHookResult = ReturnType<
  typeof useListPolicyTemplatesLazyQuery
>;
export type ListPolicyTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useListPolicyTemplatesSuspenseQuery
>;
export type ListPolicyTemplatesQueryResult = Apollo.QueryResult<
  ListPolicyTemplatesQuery,
  ListPolicyTemplatesQueryVariables
>;
export const ListTemplatesByCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTemplatesByCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PolicyTemplateCategory' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listTemplatesByCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPriority' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parameters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paramType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'useCases' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTemplatesByCategoryQuery__
 *
 * To run a query within a React component, call `useListTemplatesByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplatesByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplatesByCategoryQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useListTemplatesByCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTemplatesByCategoryQuery,
    ListTemplatesByCategoryQueryVariables
  > &
    ({ variables: ListTemplatesByCategoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTemplatesByCategoryQuery, ListTemplatesByCategoryQueryVariables>(
    ListTemplatesByCategoryDocument,
    options,
  );
}
export function useListTemplatesByCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTemplatesByCategoryQuery,
    ListTemplatesByCategoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTemplatesByCategoryQuery, ListTemplatesByCategoryQueryVariables>(
    ListTemplatesByCategoryDocument,
    options,
  );
}
// @ts-ignore
export function useListTemplatesByCategorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTemplatesByCategoryQuery,
    ListTemplatesByCategoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListTemplatesByCategoryQuery,
  ListTemplatesByCategoryQueryVariables
>;
export function useListTemplatesByCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTemplatesByCategoryQuery,
        ListTemplatesByCategoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListTemplatesByCategoryQuery | undefined,
  ListTemplatesByCategoryQueryVariables
>;
export function useListTemplatesByCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTemplatesByCategoryQuery,
        ListTemplatesByCategoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTemplatesByCategoryQuery,
    ListTemplatesByCategoryQueryVariables
  >(ListTemplatesByCategoryDocument, options);
}
export type ListTemplatesByCategoryQueryHookResult = ReturnType<
  typeof useListTemplatesByCategoryQuery
>;
export type ListTemplatesByCategoryLazyQueryHookResult = ReturnType<
  typeof useListTemplatesByCategoryLazyQuery
>;
export type ListTemplatesByCategorySuspenseQueryHookResult = ReturnType<
  typeof useListTemplatesByCategorySuspenseQuery
>;
export type ListTemplatesByCategoryQueryResult = Apollo.QueryResult<
  ListTemplatesByCategoryQuery,
  ListTemplatesByCategoryQueryVariables
>;
export const GetPolicyTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPolicyTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPolicyTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conditionTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actionTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paramsTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPriority' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parameters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paramType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validation' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'useCases' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPolicyTemplateQuery__
 *
 * To run a query within a React component, call `useGetPolicyTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetPolicyTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<GetPolicyTemplateQuery, GetPolicyTemplateQueryVariables> &
    ({ variables: GetPolicyTemplateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPolicyTemplateQuery, GetPolicyTemplateQueryVariables>(
    GetPolicyTemplateDocument,
    options,
  );
}
export function useGetPolicyTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPolicyTemplateQuery,
    GetPolicyTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPolicyTemplateQuery, GetPolicyTemplateQueryVariables>(
    GetPolicyTemplateDocument,
    options,
  );
}
// @ts-ignore
export function useGetPolicyTemplateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPolicyTemplateQuery,
    GetPolicyTemplateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPolicyTemplateQuery, GetPolicyTemplateQueryVariables>;
export function useGetPolicyTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyTemplateQuery, GetPolicyTemplateQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetPolicyTemplateQuery | undefined,
  GetPolicyTemplateQueryVariables
>;
export function useGetPolicyTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyTemplateQuery, GetPolicyTemplateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPolicyTemplateQuery, GetPolicyTemplateQueryVariables>(
    GetPolicyTemplateDocument,
    options,
  );
}
export type GetPolicyTemplateQueryHookResult = ReturnType<typeof useGetPolicyTemplateQuery>;
export type GetPolicyTemplateLazyQueryHookResult = ReturnType<typeof useGetPolicyTemplateLazyQuery>;
export type GetPolicyTemplateSuspenseQueryHookResult = ReturnType<
  typeof useGetPolicyTemplateSuspenseQuery
>;
export type GetPolicyTemplateQueryResult = Apollo.QueryResult<
  GetPolicyTemplateQuery,
  GetPolicyTemplateQueryVariables
>;
export const ListTemplateInstancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTemplateInstances' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listTemplateInstances' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parameterValues' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyRuleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTemplateInstancesQuery__
 *
 * To run a query within a React component, call `useListTemplateInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplateInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplateInstancesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useListTemplateInstancesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTemplateInstancesQuery,
    ListTemplateInstancesQueryVariables
  > &
    ({ variables: ListTemplateInstancesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTemplateInstancesQuery, ListTemplateInstancesQueryVariables>(
    ListTemplateInstancesDocument,
    options,
  );
}
export function useListTemplateInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTemplateInstancesQuery,
    ListTemplateInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTemplateInstancesQuery, ListTemplateInstancesQueryVariables>(
    ListTemplateInstancesDocument,
    options,
  );
}
// @ts-ignore
export function useListTemplateInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTemplateInstancesQuery,
    ListTemplateInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListTemplateInstancesQuery, ListTemplateInstancesQueryVariables>;
export function useListTemplateInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTemplateInstancesQuery,
        ListTemplateInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListTemplateInstancesQuery | undefined,
  ListTemplateInstancesQueryVariables
>;
export function useListTemplateInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTemplateInstancesQuery,
        ListTemplateInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTemplateInstancesQuery, ListTemplateInstancesQueryVariables>(
    ListTemplateInstancesDocument,
    options,
  );
}
export type ListTemplateInstancesQueryHookResult = ReturnType<typeof useListTemplateInstancesQuery>;
export type ListTemplateInstancesLazyQueryHookResult = ReturnType<
  typeof useListTemplateInstancesLazyQuery
>;
export type ListTemplateInstancesSuspenseQueryHookResult = ReturnType<
  typeof useListTemplateInstancesSuspenseQuery
>;
export type ListTemplateInstancesQueryResult = Apollo.QueryResult<
  ListTemplateInstancesQuery,
  ListTemplateInstancesQueryVariables
>;
export const InstantiateTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InstantiateTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantiateTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantiateTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parameterValues' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyRuleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InstantiateTemplateMutationFn = ApolloMutationFunction<
  InstantiateTemplateMutation,
  InstantiateTemplateMutationVariables
>;

/**
 * __useInstantiateTemplateMutation__
 *
 * To run a mutation, you first call `useInstantiateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstantiateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantiateTemplateMutation, { data, loading, error }] = useInstantiateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInstantiateTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InstantiateTemplateMutation,
    InstantiateTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InstantiateTemplateMutation, InstantiateTemplateMutationVariables>(
    InstantiateTemplateDocument,
    options,
  );
}
export type InstantiateTemplateMutationHookResult = ReturnType<
  typeof useInstantiateTemplateMutation
>;
export type InstantiateTemplateMutationResult = Apollo.MutationResult<InstantiateTemplateMutation>;
export type InstantiateTemplateMutationOptions = ApolloBaseMutationOptions<
  InstantiateTemplateMutation,
  InstantiateTemplateMutationVariables
>;
export const BootstrapSystemTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BootstrapSystemTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'bootstrapSystemTemplates' } }],
      },
    },
  ],
} as unknown as DocumentNode;
export type BootstrapSystemTemplatesMutationFn = ApolloMutationFunction<
  BootstrapSystemTemplatesMutation,
  BootstrapSystemTemplatesMutationVariables
>;

/**
 * __useBootstrapSystemTemplatesMutation__
 *
 * To run a mutation, you first call `useBootstrapSystemTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBootstrapSystemTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bootstrapSystemTemplatesMutation, { data, loading, error }] = useBootstrapSystemTemplatesMutation({
 *   variables: {
 *   },
 * });
 */
export function useBootstrapSystemTemplatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BootstrapSystemTemplatesMutation,
    BootstrapSystemTemplatesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BootstrapSystemTemplatesMutation,
    BootstrapSystemTemplatesMutationVariables
  >(BootstrapSystemTemplatesDocument, options);
}
export type BootstrapSystemTemplatesMutationHookResult = ReturnType<
  typeof useBootstrapSystemTemplatesMutation
>;
export type BootstrapSystemTemplatesMutationResult =
  Apollo.MutationResult<BootstrapSystemTemplatesMutation>;
export type BootstrapSystemTemplatesMutationOptions = ApolloBaseMutationOptions<
  BootstrapSystemTemplatesMutation,
  BootstrapSystemTemplatesMutationVariables
>;
export const GetLlmFixRecommendationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLlmFixRecommendation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'recommendationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLlmFixRecommendation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recommendationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'recommendationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'recommendationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalTemplateId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestedFixes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stepId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fixType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasoning' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reasoning' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diff' } },
                { kind: 'Field', name: { kind: 'Name', value: 'llmModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLlmFixRecommendationQuery__
 *
 * To run a query within a React component, call `useGetLlmFixRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLlmFixRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLlmFixRecommendationQuery({
 *   variables: {
 *      recommendationId: // value for 'recommendationId'
 *      templateId: // value for 'templateId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetLlmFixRecommendationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLlmFixRecommendationQuery,
    GetLlmFixRecommendationQueryVariables
  > &
    ({ variables: GetLlmFixRecommendationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLlmFixRecommendationQuery, GetLlmFixRecommendationQueryVariables>(
    GetLlmFixRecommendationDocument,
    options,
  );
}
export function useGetLlmFixRecommendationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLlmFixRecommendationQuery,
    GetLlmFixRecommendationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLlmFixRecommendationQuery, GetLlmFixRecommendationQueryVariables>(
    GetLlmFixRecommendationDocument,
    options,
  );
}
// @ts-ignore
export function useGetLlmFixRecommendationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLlmFixRecommendationQuery,
    GetLlmFixRecommendationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetLlmFixRecommendationQuery,
  GetLlmFixRecommendationQueryVariables
>;
export function useGetLlmFixRecommendationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLlmFixRecommendationQuery,
        GetLlmFixRecommendationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetLlmFixRecommendationQuery | undefined,
  GetLlmFixRecommendationQueryVariables
>;
export function useGetLlmFixRecommendationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLlmFixRecommendationQuery,
        GetLlmFixRecommendationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLlmFixRecommendationQuery,
    GetLlmFixRecommendationQueryVariables
  >(GetLlmFixRecommendationDocument, options);
}
export type GetLlmFixRecommendationQueryHookResult = ReturnType<
  typeof useGetLlmFixRecommendationQuery
>;
export type GetLlmFixRecommendationLazyQueryHookResult = ReturnType<
  typeof useGetLlmFixRecommendationLazyQuery
>;
export type GetLlmFixRecommendationSuspenseQueryHookResult = ReturnType<
  typeof useGetLlmFixRecommendationSuspenseQuery
>;
export type GetLlmFixRecommendationQueryResult = Apollo.QueryResult<
  GetLlmFixRecommendationQuery,
  GetLlmFixRecommendationQueryVariables
>;
export const ListLlmFixRecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListLlmFixRecommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listLlmFixRecommendations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'recommendationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListLlmFixRecommendationsQuery__
 *
 * To run a query within a React component, call `useListLlmFixRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLlmFixRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLlmFixRecommendationsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useListLlmFixRecommendationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListLlmFixRecommendationsQuery,
    ListLlmFixRecommendationsQueryVariables
  > &
    ({ variables: ListLlmFixRecommendationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListLlmFixRecommendationsQuery, ListLlmFixRecommendationsQueryVariables>(
    ListLlmFixRecommendationsDocument,
    options,
  );
}
export function useListLlmFixRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListLlmFixRecommendationsQuery,
    ListLlmFixRecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListLlmFixRecommendationsQuery,
    ListLlmFixRecommendationsQueryVariables
  >(ListLlmFixRecommendationsDocument, options);
}
// @ts-ignore
export function useListLlmFixRecommendationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListLlmFixRecommendationsQuery,
    ListLlmFixRecommendationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListLlmFixRecommendationsQuery,
  ListLlmFixRecommendationsQueryVariables
>;
export function useListLlmFixRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListLlmFixRecommendationsQuery,
        ListLlmFixRecommendationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListLlmFixRecommendationsQuery | undefined,
  ListLlmFixRecommendationsQueryVariables
>;
export function useListLlmFixRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListLlmFixRecommendationsQuery,
        ListLlmFixRecommendationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListLlmFixRecommendationsQuery,
    ListLlmFixRecommendationsQueryVariables
  >(ListLlmFixRecommendationsDocument, options);
}
export type ListLlmFixRecommendationsQueryHookResult = ReturnType<
  typeof useListLlmFixRecommendationsQuery
>;
export type ListLlmFixRecommendationsLazyQueryHookResult = ReturnType<
  typeof useListLlmFixRecommendationsLazyQuery
>;
export type ListLlmFixRecommendationsSuspenseQueryHookResult = ReturnType<
  typeof useListLlmFixRecommendationsSuspenseQuery
>;
export type ListLlmFixRecommendationsQueryResult = Apollo.QueryResult<
  ListLlmFixRecommendationsQuery,
  ListLlmFixRecommendationsQueryVariables
>;
export const RequestLlmFixDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestLlmFix' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RequestLLMFixInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestLlmFix' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'recommendationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalTemplateId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestedFixes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stepId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fixType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasoning' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reasoning' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diff' } },
                { kind: 'Field', name: { kind: 'Name', value: 'llmModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestLlmFixMutationFn = ApolloMutationFunction<
  RequestLlmFixMutation,
  RequestLlmFixMutationVariables
>;

/**
 * __useRequestLlmFixMutation__
 *
 * To run a mutation, you first call `useRequestLlmFixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLlmFixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLlmFixMutation, { data, loading, error }] = useRequestLlmFixMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestLlmFixMutation(
  baseOptions?: Apollo.MutationHookOptions<RequestLlmFixMutation, RequestLlmFixMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RequestLlmFixMutation, RequestLlmFixMutationVariables>(
    RequestLlmFixDocument,
    options,
  );
}
export type RequestLlmFixMutationHookResult = ReturnType<typeof useRequestLlmFixMutation>;
export type RequestLlmFixMutationResult = Apollo.MutationResult<RequestLlmFixMutation>;
export type RequestLlmFixMutationOptions = ApolloBaseMutationOptions<
  RequestLlmFixMutation,
  RequestLlmFixMutationVariables
>;
export const ApplyLlmFixDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyLlmFix' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplyLLMFixInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyLlmFix' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fixesApplied' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validationPassed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remainingViolations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedTemplate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApplyLlmFixMutationFn = ApolloMutationFunction<
  ApplyLlmFixMutation,
  ApplyLlmFixMutationVariables
>;

/**
 * __useApplyLlmFixMutation__
 *
 * To run a mutation, you first call `useApplyLlmFixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyLlmFixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyLlmFixMutation, { data, loading, error }] = useApplyLlmFixMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyLlmFixMutation(
  baseOptions?: Apollo.MutationHookOptions<ApplyLlmFixMutation, ApplyLlmFixMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApplyLlmFixMutation, ApplyLlmFixMutationVariables>(
    ApplyLlmFixDocument,
    options,
  );
}
export type ApplyLlmFixMutationHookResult = ReturnType<typeof useApplyLlmFixMutation>;
export type ApplyLlmFixMutationResult = Apollo.MutationResult<ApplyLlmFixMutation>;
export type ApplyLlmFixMutationOptions = ApolloBaseMutationOptions<
  ApplyLlmFixMutation,
  ApplyLlmFixMutationVariables
>;
export const RejectLlmFixDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RejectLlmFix' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RejectLLMFixInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectLlmFix' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RejectLlmFixMutationFn = ApolloMutationFunction<
  RejectLlmFixMutation,
  RejectLlmFixMutationVariables
>;

/**
 * __useRejectLlmFixMutation__
 *
 * To run a mutation, you first call `useRejectLlmFixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectLlmFixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectLlmFixMutation, { data, loading, error }] = useRejectLlmFixMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectLlmFixMutation(
  baseOptions?: Apollo.MutationHookOptions<RejectLlmFixMutation, RejectLlmFixMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RejectLlmFixMutation, RejectLlmFixMutationVariables>(
    RejectLlmFixDocument,
    options,
  );
}
export type RejectLlmFixMutationHookResult = ReturnType<typeof useRejectLlmFixMutation>;
export type RejectLlmFixMutationResult = Apollo.MutationResult<RejectLlmFixMutation>;
export type RejectLlmFixMutationOptions = ApolloBaseMutationOptions<
  RejectLlmFixMutation,
  RejectLlmFixMutationVariables
>;
export const GetApprovalWorkflowInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetApprovalWorkflowInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getApprovalWorkflowInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiredApprovers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decisions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'decisionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approverId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approverName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'decisionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revisionItems' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'suggestedFix' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dualControlRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetApprovalWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useGetApprovalWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalWorkflowInstanceQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetApprovalWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetApprovalWorkflowInstanceQuery,
    GetApprovalWorkflowInstanceQueryVariables
  > &
    ({ variables: GetApprovalWorkflowInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetApprovalWorkflowInstanceQuery,
    GetApprovalWorkflowInstanceQueryVariables
  >(GetApprovalWorkflowInstanceDocument, options);
}
export function useGetApprovalWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApprovalWorkflowInstanceQuery,
    GetApprovalWorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetApprovalWorkflowInstanceQuery,
    GetApprovalWorkflowInstanceQueryVariables
  >(GetApprovalWorkflowInstanceDocument, options);
}
// @ts-ignore
export function useGetApprovalWorkflowInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetApprovalWorkflowInstanceQuery,
    GetApprovalWorkflowInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetApprovalWorkflowInstanceQuery,
  GetApprovalWorkflowInstanceQueryVariables
>;
export function useGetApprovalWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApprovalWorkflowInstanceQuery,
        GetApprovalWorkflowInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetApprovalWorkflowInstanceQuery | undefined,
  GetApprovalWorkflowInstanceQueryVariables
>;
export function useGetApprovalWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetApprovalWorkflowInstanceQuery,
        GetApprovalWorkflowInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetApprovalWorkflowInstanceQuery,
    GetApprovalWorkflowInstanceQueryVariables
  >(GetApprovalWorkflowInstanceDocument, options);
}
export type GetApprovalWorkflowInstanceQueryHookResult = ReturnType<
  typeof useGetApprovalWorkflowInstanceQuery
>;
export type GetApprovalWorkflowInstanceLazyQueryHookResult = ReturnType<
  typeof useGetApprovalWorkflowInstanceLazyQuery
>;
export type GetApprovalWorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useGetApprovalWorkflowInstanceSuspenseQuery
>;
export type GetApprovalWorkflowInstanceQueryResult = Apollo.QueryResult<
  GetApprovalWorkflowInstanceQuery,
  GetApprovalWorkflowInstanceQueryVariables
>;
export const ListPendingDslApprovalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListPendingDslApprovals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listPendingApprovals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approverId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiredApprovers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredCount' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListPendingDslApprovalsQuery__
 *
 * To run a query within a React component, call `useListPendingDslApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPendingDslApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPendingDslApprovalsQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      approverId: // value for 'approverId'
 *   },
 * });
 */
export function useListPendingDslApprovalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPendingDslApprovalsQuery,
    ListPendingDslApprovalsQueryVariables
  > &
    ({ variables: ListPendingDslApprovalsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPendingDslApprovalsQuery, ListPendingDslApprovalsQueryVariables>(
    ListPendingDslApprovalsDocument,
    options,
  );
}
export function useListPendingDslApprovalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPendingDslApprovalsQuery,
    ListPendingDslApprovalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPendingDslApprovalsQuery, ListPendingDslApprovalsQueryVariables>(
    ListPendingDslApprovalsDocument,
    options,
  );
}
// @ts-ignore
export function useListPendingDslApprovalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPendingDslApprovalsQuery,
    ListPendingDslApprovalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListPendingDslApprovalsQuery,
  ListPendingDslApprovalsQueryVariables
>;
export function useListPendingDslApprovalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingDslApprovalsQuery,
        ListPendingDslApprovalsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListPendingDslApprovalsQuery | undefined,
  ListPendingDslApprovalsQueryVariables
>;
export function useListPendingDslApprovalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingDslApprovalsQuery,
        ListPendingDslApprovalsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListPendingDslApprovalsQuery,
    ListPendingDslApprovalsQueryVariables
  >(ListPendingDslApprovalsDocument, options);
}
export type ListPendingDslApprovalsQueryHookResult = ReturnType<
  typeof useListPendingDslApprovalsQuery
>;
export type ListPendingDslApprovalsLazyQueryHookResult = ReturnType<
  typeof useListPendingDslApprovalsLazyQuery
>;
export type ListPendingDslApprovalsSuspenseQueryHookResult = ReturnType<
  typeof useListPendingDslApprovalsSuspenseQuery
>;
export type ListPendingDslApprovalsQueryResult = Apollo.QueryResult<
  ListPendingDslApprovalsQuery,
  ListPendingDslApprovalsQueryVariables
>;
export const GetTemplatePublicationStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTemplatePublicationStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTemplatePublicationStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'version' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTemplatePublicationStatusQuery__
 *
 * To run a query within a React component, call `useGetTemplatePublicationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatePublicationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatePublicationStatusQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      templateId: // value for 'templateId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetTemplatePublicationStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTemplatePublicationStatusQuery,
    GetTemplatePublicationStatusQueryVariables
  > &
    ({ variables: GetTemplatePublicationStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTemplatePublicationStatusQuery,
    GetTemplatePublicationStatusQueryVariables
  >(GetTemplatePublicationStatusDocument, options);
}
export function useGetTemplatePublicationStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTemplatePublicationStatusQuery,
    GetTemplatePublicationStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTemplatePublicationStatusQuery,
    GetTemplatePublicationStatusQueryVariables
  >(GetTemplatePublicationStatusDocument, options);
}
// @ts-ignore
export function useGetTemplatePublicationStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTemplatePublicationStatusQuery,
    GetTemplatePublicationStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTemplatePublicationStatusQuery,
  GetTemplatePublicationStatusQueryVariables
>;
export function useGetTemplatePublicationStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTemplatePublicationStatusQuery,
        GetTemplatePublicationStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTemplatePublicationStatusQuery | undefined,
  GetTemplatePublicationStatusQueryVariables
>;
export function useGetTemplatePublicationStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTemplatePublicationStatusQuery,
        GetTemplatePublicationStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTemplatePublicationStatusQuery,
    GetTemplatePublicationStatusQueryVariables
  >(GetTemplatePublicationStatusDocument, options);
}
export type GetTemplatePublicationStatusQueryHookResult = ReturnType<
  typeof useGetTemplatePublicationStatusQuery
>;
export type GetTemplatePublicationStatusLazyQueryHookResult = ReturnType<
  typeof useGetTemplatePublicationStatusLazyQuery
>;
export type GetTemplatePublicationStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetTemplatePublicationStatusSuspenseQuery
>;
export type GetTemplatePublicationStatusQueryResult = Apollo.QueryResult<
  GetTemplatePublicationStatusQuery,
  GetTemplatePublicationStatusQueryVariables
>;
export const ApproveRecommendationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApproveRecommendation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'decision' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApprovalDecisionGql' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveRecommendation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'decision' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'decision' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApproveRecommendationMutationFn = ApolloMutationFunction<
  ApproveRecommendationMutation,
  ApproveRecommendationMutationVariables
>;

/**
 * __useApproveRecommendationMutation__
 *
 * To run a mutation, you first call `useApproveRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRecommendationMutation, { data, loading, error }] = useApproveRecommendationMutation({
 *   variables: {
 *      decision: // value for 'decision'
 *   },
 * });
 */
export function useApproveRecommendationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveRecommendationMutation,
    ApproveRecommendationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApproveRecommendationMutation, ApproveRecommendationMutationVariables>(
    ApproveRecommendationDocument,
    options,
  );
}
export type ApproveRecommendationMutationHookResult = ReturnType<
  typeof useApproveRecommendationMutation
>;
export type ApproveRecommendationMutationResult =
  Apollo.MutationResult<ApproveRecommendationMutation>;
export type ApproveRecommendationMutationOptions = ApolloBaseMutationOptions<
  ApproveRecommendationMutation,
  ApproveRecommendationMutationVariables
>;
export const SaveDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveDraftInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ok' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SaveDraftMutationFn = ApolloMutationFunction<
  SaveDraftMutation,
  SaveDraftMutationVariables
>;

/**
 * __useSaveDraftMutation__
 *
 * To run a mutation, you first call `useSaveDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDraftMutation, { data, loading, error }] = useSaveDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveDraftMutation, SaveDraftMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveDraftMutation, SaveDraftMutationVariables>(
    SaveDraftDocument,
    options,
  );
}
export type SaveDraftMutationHookResult = ReturnType<typeof useSaveDraftMutation>;
export type SaveDraftMutationResult = Apollo.MutationResult<SaveDraftMutation>;
export type SaveDraftMutationOptions = ApolloBaseMutationOptions<
  SaveDraftMutation,
  SaveDraftMutationVariables
>;
export const DiscardDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DiscardDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'llmWorkflowDiscardDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DiscardDraftMutationFn = ApolloMutationFunction<
  DiscardDraftMutation,
  DiscardDraftMutationVariables
>;

/**
 * __useDiscardDraftMutation__
 *
 * To run a mutation, you first call `useDiscardDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardDraftMutation, { data, loading, error }] = useDiscardDraftMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useDiscardDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<DiscardDraftMutation, DiscardDraftMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DiscardDraftMutation, DiscardDraftMutationVariables>(
    DiscardDraftDocument,
    options,
  );
}
export type DiscardDraftMutationHookResult = ReturnType<typeof useDiscardDraftMutation>;
export type DiscardDraftMutationResult = Apollo.MutationResult<DiscardDraftMutation>;
export type DiscardDraftMutationOptions = ApolloBaseMutationOptions<
  DiscardDraftMutation,
  DiscardDraftMutationVariables
>;
export const DeleteDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteDraftInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteDraftMutationFn = ApolloMutationFunction<
  DeleteDraftMutation,
  DeleteDraftMutationVariables
>;

/**
 * __useDeleteDraftMutation__
 *
 * To run a mutation, you first call `useDeleteDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftMutation, { data, loading, error }] = useDeleteDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDraftMutation, DeleteDraftMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDraftMutation, DeleteDraftMutationVariables>(
    DeleteDraftDocument,
    options,
  );
}
export type DeleteDraftMutationHookResult = ReturnType<typeof useDeleteDraftMutation>;
export type DeleteDraftMutationResult = Apollo.MutationResult<DeleteDraftMutation>;
export type DeleteDraftMutationOptions = ApolloBaseMutationOptions<
  DeleteDraftMutation,
  DeleteDraftMutationVariables
>;
export const DeleteDraftManyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDraftMany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteDraftManyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDraftMany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteDraftManyMutationFn = ApolloMutationFunction<
  DeleteDraftManyMutation,
  DeleteDraftManyMutationVariables
>;

/**
 * __useDeleteDraftManyMutation__
 *
 * To run a mutation, you first call `useDeleteDraftManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftManyMutation, { data, loading, error }] = useDeleteDraftManyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDraftManyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDraftManyMutation,
    DeleteDraftManyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDraftManyMutation, DeleteDraftManyMutationVariables>(
    DeleteDraftManyDocument,
    options,
  );
}
export type DeleteDraftManyMutationHookResult = ReturnType<typeof useDeleteDraftManyMutation>;
export type DeleteDraftManyMutationResult = Apollo.MutationResult<DeleteDraftManyMutation>;
export type DeleteDraftManyMutationOptions = ApolloBaseMutationOptions<
  DeleteDraftManyMutation,
  DeleteDraftManyMutationVariables
>;
export const SaveFormSchemaOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveFormSchemaOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FormSchemaOverrideInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveFormSchemaOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hiddenFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'readonlyFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelOverrides' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'helpText' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customValidations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SaveFormSchemaOverrideMutationFn = ApolloMutationFunction<
  SaveFormSchemaOverrideMutation,
  SaveFormSchemaOverrideMutationVariables
>;

/**
 * __useSaveFormSchemaOverrideMutation__
 *
 * To run a mutation, you first call `useSaveFormSchemaOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFormSchemaOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFormSchemaOverrideMutation, { data, loading, error }] = useSaveFormSchemaOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFormSchemaOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveFormSchemaOverrideMutation,
    SaveFormSchemaOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveFormSchemaOverrideMutation,
    SaveFormSchemaOverrideMutationVariables
  >(SaveFormSchemaOverrideDocument, options);
}
export type SaveFormSchemaOverrideMutationHookResult = ReturnType<
  typeof useSaveFormSchemaOverrideMutation
>;
export type SaveFormSchemaOverrideMutationResult =
  Apollo.MutationResult<SaveFormSchemaOverrideMutation>;
export type SaveFormSchemaOverrideMutationOptions = ApolloBaseMutationOptions<
  SaveFormSchemaOverrideMutation,
  SaveFormSchemaOverrideMutationVariables
>;
export const DeleteFormSchemaOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFormSchemaOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFormSchemaOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteFormSchemaOverrideMutationFn = ApolloMutationFunction<
  DeleteFormSchemaOverrideMutation,
  DeleteFormSchemaOverrideMutationVariables
>;

/**
 * __useDeleteFormSchemaOverrideMutation__
 *
 * To run a mutation, you first call `useDeleteFormSchemaOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormSchemaOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormSchemaOverrideMutation, { data, loading, error }] = useDeleteFormSchemaOverrideMutation({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useDeleteFormSchemaOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFormSchemaOverrideMutation,
    DeleteFormSchemaOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFormSchemaOverrideMutation,
    DeleteFormSchemaOverrideMutationVariables
  >(DeleteFormSchemaOverrideDocument, options);
}
export type DeleteFormSchemaOverrideMutationHookResult = ReturnType<
  typeof useDeleteFormSchemaOverrideMutation
>;
export type DeleteFormSchemaOverrideMutationResult =
  Apollo.MutationResult<DeleteFormSchemaOverrideMutation>;
export type DeleteFormSchemaOverrideMutationOptions = ApolloBaseMutationOptions<
  DeleteFormSchemaOverrideMutation,
  DeleteFormSchemaOverrideMutationVariables
>;
export const PublishTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PublishTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'templateApiPublishTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PublishTemplateMutationFn = ApolloMutationFunction<
  PublishTemplateMutation,
  PublishTemplateMutationVariables
>;

/**
 * __usePublishTemplateMutation__
 *
 * To run a mutation, you first call `usePublishTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTemplateMutation, { data, loading, error }] = usePublishTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePublishTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishTemplateMutation,
    PublishTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PublishTemplateMutation, PublishTemplateMutationVariables>(
    PublishTemplateDocument,
    options,
  );
}
export type PublishTemplateMutationHookResult = ReturnType<typeof usePublishTemplateMutation>;
export type PublishTemplateMutationResult = Apollo.MutationResult<PublishTemplateMutation>;
export type PublishTemplateMutationOptions = ApolloBaseMutationOptions<
  PublishTemplateMutation,
  PublishTemplateMutationVariables
>;
export const ExportTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExportTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'exportVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'exportedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exportedBy' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ExportTemplateMutationFn = ApolloMutationFunction<
  ExportTemplateMutation,
  ExportTemplateMutationVariables
>;

/**
 * __useExportTemplateMutation__
 *
 * To run a mutation, you first call `useExportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTemplateMutation, { data, loading, error }] = useExportTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<ExportTemplateMutation, ExportTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportTemplateMutation, ExportTemplateMutationVariables>(
    ExportTemplateDocument,
    options,
  );
}
export type ExportTemplateMutationHookResult = ReturnType<typeof useExportTemplateMutation>;
export type ExportTemplateMutationResult = Apollo.MutationResult<ExportTemplateMutation>;
export type ExportTemplateMutationOptions = ApolloBaseMutationOptions<
  ExportTemplateMutation,
  ExportTemplateMutationVariables
>;
export const ImportTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImportTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImportTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ImportTemplateMutationFn = ApolloMutationFunction<
  ImportTemplateMutation,
  ImportTemplateMutationVariables
>;

/**
 * __useImportTemplateMutation__
 *
 * To run a mutation, you first call `useImportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTemplateMutation, { data, loading, error }] = useImportTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<ImportTemplateMutation, ImportTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportTemplateMutation, ImportTemplateMutationVariables>(
    ImportTemplateDocument,
    options,
  );
}
export type ImportTemplateMutationHookResult = ReturnType<typeof useImportTemplateMutation>;
export type ImportTemplateMutationResult = Apollo.MutationResult<ImportTemplateMutation>;
export type ImportTemplateMutationOptions = ApolloBaseMutationOptions<
  ImportTemplateMutation,
  ImportTemplateMutationVariables
>;
export const ApproveTerminologyOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApproveTerminologyOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'definitionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rationale' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveTerminologyOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'definitionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'definitionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rationale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rationale' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedTerm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decisionRationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'violatedConstraint' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApproveTerminologyOverrideMutationFn = ApolloMutationFunction<
  ApproveTerminologyOverrideMutation,
  ApproveTerminologyOverrideMutationVariables
>;

/**
 * __useApproveTerminologyOverrideMutation__
 *
 * To run a mutation, you first call `useApproveTerminologyOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTerminologyOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTerminologyOverrideMutation, { data, loading, error }] = useApproveTerminologyOverrideMutation({
 *   variables: {
 *      definitionId: // value for 'definitionId'
 *      rationale: // value for 'rationale'
 *   },
 * });
 */
export function useApproveTerminologyOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveTerminologyOverrideMutation,
    ApproveTerminologyOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveTerminologyOverrideMutation,
    ApproveTerminologyOverrideMutationVariables
  >(ApproveTerminologyOverrideDocument, options);
}
export type ApproveTerminologyOverrideMutationHookResult = ReturnType<
  typeof useApproveTerminologyOverrideMutation
>;
export type ApproveTerminologyOverrideMutationResult =
  Apollo.MutationResult<ApproveTerminologyOverrideMutation>;
export type ApproveTerminologyOverrideMutationOptions = ApolloBaseMutationOptions<
  ApproveTerminologyOverrideMutation,
  ApproveTerminologyOverrideMutationVariables
>;
export const AppendTransitionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AppendTransition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppendTransitionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appendTransition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AppendTransitionMutationFn = ApolloMutationFunction<
  AppendTransitionMutation,
  AppendTransitionMutationVariables
>;

/**
 * __useAppendTransitionMutation__
 *
 * To run a mutation, you first call `useAppendTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendTransitionMutation, { data, loading, error }] = useAppendTransitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendTransitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AppendTransitionMutation,
    AppendTransitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AppendTransitionMutation, AppendTransitionMutationVariables>(
    AppendTransitionDocument,
    options,
  );
}
export type AppendTransitionMutationHookResult = ReturnType<typeof useAppendTransitionMutation>;
export type AppendTransitionMutationResult = Apollo.MutationResult<AppendTransitionMutation>;
export type AppendTransitionMutationOptions = ApolloBaseMutationOptions<
  AppendTransitionMutation,
  AppendTransitionMutationVariables
>;
export const GenerateIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateIdInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateIdMutationFn = ApolloMutationFunction<
  GenerateIdMutation,
  GenerateIdMutationVariables
>;

/**
 * __useGenerateIdMutation__
 *
 * To run a mutation, you first call `useGenerateIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIdMutation, { data, loading, error }] = useGenerateIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateIdMutation(
  baseOptions?: Apollo.MutationHookOptions<GenerateIdMutation, GenerateIdMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateIdMutation, GenerateIdMutationVariables>(
    GenerateIdDocument,
    options,
  );
}
export type GenerateIdMutationHookResult = ReturnType<typeof useGenerateIdMutation>;
export type GenerateIdMutationResult = Apollo.MutationResult<GenerateIdMutation>;
export type GenerateIdMutationOptions = ApolloBaseMutationOptions<
  GenerateIdMutation,
  GenerateIdMutationVariables
>;
export const CreateWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateWorkflowInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateWorkflowMutationFn = ApolloMutationFunction<
  CreateWorkflowMutation,
  CreateWorkflowMutationVariables
>;

/**
 * __useCreateWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutation, { data, loading, error }] = useCreateWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(
    CreateWorkflowDocument,
    options,
  );
}
export type CreateWorkflowMutationHookResult = ReturnType<typeof useCreateWorkflowMutation>;
export type CreateWorkflowMutationResult = Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = ApolloBaseMutationOptions<
  CreateWorkflowMutation,
  CreateWorkflowMutationVariables
>;
export const CreateConstraintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateConstraint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateConstraintInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConstraint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateConstraintMutationFn = ApolloMutationFunction<
  CreateConstraintMutation,
  CreateConstraintMutationVariables
>;

/**
 * __useCreateConstraintMutation__
 *
 * To run a mutation, you first call `useCreateConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConstraintMutation, { data, loading, error }] = useCreateConstraintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConstraintMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConstraintMutation,
    CreateConstraintMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateConstraintMutation, CreateConstraintMutationVariables>(
    CreateConstraintDocument,
    options,
  );
}
export type CreateConstraintMutationHookResult = ReturnType<typeof useCreateConstraintMutation>;
export type CreateConstraintMutationResult = Apollo.MutationResult<CreateConstraintMutation>;
export type CreateConstraintMutationOptions = ApolloBaseMutationOptions<
  CreateConstraintMutation,
  CreateConstraintMutationVariables
>;
export const CreateDependencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDependency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDependencyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dependencyApiCreateDependency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dependencyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateDependencyMutationFn = ApolloMutationFunction<
  CreateDependencyMutation,
  CreateDependencyMutationVariables
>;

/**
 * __useCreateDependencyMutation__
 *
 * To run a mutation, you first call `useCreateDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDependencyMutation, { data, loading, error }] = useCreateDependencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDependencyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDependencyMutation,
    CreateDependencyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDependencyMutation, CreateDependencyMutationVariables>(
    CreateDependencyDocument,
    options,
  );
}
export type CreateDependencyMutationHookResult = ReturnType<typeof useCreateDependencyMutation>;
export type CreateDependencyMutationResult = Apollo.MutationResult<CreateDependencyMutation>;
export type CreateDependencyMutationOptions = ApolloBaseMutationOptions<
  CreateDependencyMutation,
  CreateDependencyMutationVariables
>;
export const ArchiveDependencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveDependency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dependencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dependencyApiArchiveDependency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dependencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dependencyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dependencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dependencyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveDependencyMutationFn = ApolloMutationFunction<
  ArchiveDependencyMutation,
  ArchiveDependencyMutationVariables
>;

/**
 * __useArchiveDependencyMutation__
 *
 * To run a mutation, you first call `useArchiveDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDependencyMutation, { data, loading, error }] = useArchiveDependencyMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      dependencyId: // value for 'dependencyId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveDependencyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveDependencyMutation,
    ArchiveDependencyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveDependencyMutation, ArchiveDependencyMutationVariables>(
    ArchiveDependencyDocument,
    options,
  );
}
export type ArchiveDependencyMutationHookResult = ReturnType<typeof useArchiveDependencyMutation>;
export type ArchiveDependencyMutationResult = Apollo.MutationResult<ArchiveDependencyMutation>;
export type ArchiveDependencyMutationOptions = ApolloBaseMutationOptions<
  ArchiveDependencyMutation,
  ArchiveDependencyMutationVariables
>;
export const CreateFormSchemaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFormSchema' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FormSchemaInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFormSchema' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateFormSchemaMutationFn = ApolloMutationFunction<
  CreateFormSchemaMutation,
  CreateFormSchemaMutationVariables
>;

/**
 * __useCreateFormSchemaMutation__
 *
 * To run a mutation, you first call `useCreateFormSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormSchemaMutation, { data, loading, error }] = useCreateFormSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormSchemaMutation,
    CreateFormSchemaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFormSchemaMutation, CreateFormSchemaMutationVariables>(
    CreateFormSchemaDocument,
    options,
  );
}
export type CreateFormSchemaMutationHookResult = ReturnType<typeof useCreateFormSchemaMutation>;
export type CreateFormSchemaMutationResult = Apollo.MutationResult<CreateFormSchemaMutation>;
export type CreateFormSchemaMutationOptions = ApolloBaseMutationOptions<
  CreateFormSchemaMutation,
  CreateFormSchemaMutationVariables
>;
export const UpdateFormSchemaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFormSchema' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FormSchemaInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFormSchema' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateFormSchemaMutationFn = ApolloMutationFunction<
  UpdateFormSchemaMutation,
  UpdateFormSchemaMutationVariables
>;

/**
 * __useUpdateFormSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateFormSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormSchemaMutation, { data, loading, error }] = useUpdateFormSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFormSchemaMutation,
    UpdateFormSchemaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateFormSchemaMutation, UpdateFormSchemaMutationVariables>(
    UpdateFormSchemaDocument,
    options,
  );
}
export type UpdateFormSchemaMutationHookResult = ReturnType<typeof useUpdateFormSchemaMutation>;
export type UpdateFormSchemaMutationResult = Apollo.MutationResult<UpdateFormSchemaMutation>;
export type UpdateFormSchemaMutationOptions = ApolloBaseMutationOptions<
  UpdateFormSchemaMutation,
  UpdateFormSchemaMutationVariables
>;
export const EditFormSchemaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditFormSchema' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EditFormSchemaInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editFormSchema' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'response' } },
                { kind: 'Field', name: { kind: 'Name', value: 'turnCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopReason' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'inputTokens' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outputTokens' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EditFormSchemaMutationFn = ApolloMutationFunction<
  EditFormSchemaMutation,
  EditFormSchemaMutationVariables
>;

/**
 * __useEditFormSchemaMutation__
 *
 * To run a mutation, you first call `useEditFormSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFormSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFormSchemaMutation, { data, loading, error }] = useEditFormSchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFormSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<EditFormSchemaMutation, EditFormSchemaMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditFormSchemaMutation, EditFormSchemaMutationVariables>(
    EditFormSchemaDocument,
    options,
  );
}
export type EditFormSchemaMutationHookResult = ReturnType<typeof useEditFormSchemaMutation>;
export type EditFormSchemaMutationResult = Apollo.MutationResult<EditFormSchemaMutation>;
export type EditFormSchemaMutationOptions = ApolloBaseMutationOptions<
  EditFormSchemaMutation,
  EditFormSchemaMutationVariables
>;
export const SuggestFieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SuggestFields' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FieldSuggestionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestFields' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'primitiveType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contextId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ringId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasoning' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relevance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'critical' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalFieldsConsidered' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SuggestFieldsMutationFn = ApolloMutationFunction<
  SuggestFieldsMutation,
  SuggestFieldsMutationVariables
>;

/**
 * __useSuggestFieldsMutation__
 *
 * To run a mutation, you first call `useSuggestFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestFieldsMutation, { data, loading, error }] = useSuggestFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestFieldsMutation(
  baseOptions?: Apollo.MutationHookOptions<SuggestFieldsMutation, SuggestFieldsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SuggestFieldsMutation, SuggestFieldsMutationVariables>(
    SuggestFieldsDocument,
    options,
  );
}
export type SuggestFieldsMutationHookResult = ReturnType<typeof useSuggestFieldsMutation>;
export type SuggestFieldsMutationResult = Apollo.MutationResult<SuggestFieldsMutation>;
export type SuggestFieldsMutationOptions = ApolloBaseMutationOptions<
  SuggestFieldsMutation,
  SuggestFieldsMutationVariables
>;
export const CreateActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateActorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateActorMutationFn = ApolloMutationFunction<
  CreateActorMutation,
  CreateActorMutationVariables
>;

/**
 * __useCreateActorMutation__
 *
 * To run a mutation, you first call `useCreateActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActorMutation, { data, loading, error }] = useCreateActorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActorMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateActorMutation, CreateActorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateActorMutation, CreateActorMutationVariables>(
    CreateActorDocument,
    options,
  );
}
export type CreateActorMutationHookResult = ReturnType<typeof useCreateActorMutation>;
export type CreateActorMutationResult = Apollo.MutationResult<CreateActorMutation>;
export type CreateActorMutationOptions = ApolloBaseMutationOptions<
  CreateActorMutation,
  CreateActorMutationVariables
>;
export const UpdateActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlUpdateActorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateActorMutationFn = ApolloMutationFunction<
  UpdateActorMutation,
  UpdateActorMutationVariables
>;

/**
 * __useUpdateActorMutation__
 *
 * To run a mutation, you first call `useUpdateActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActorMutation, { data, loading, error }] = useUpdateActorMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActorMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateActorMutation, UpdateActorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateActorMutation, UpdateActorMutationVariables>(
    UpdateActorDocument,
    options,
  );
}
export type UpdateActorMutationHookResult = ReturnType<typeof useUpdateActorMutation>;
export type UpdateActorMutationResult = Apollo.MutationResult<UpdateActorMutation>;
export type UpdateActorMutationOptions = ApolloBaseMutationOptions<
  UpdateActorMutation,
  UpdateActorMutationVariables
>;
export const ArchiveActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveActorMutationFn = ApolloMutationFunction<
  ArchiveActorMutation,
  ArchiveActorMutationVariables
>;

/**
 * __useArchiveActorMutation__
 *
 * To run a mutation, you first call `useArchiveActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveActorMutation, { data, loading, error }] = useArchiveActorMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveActorMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveActorMutation, ArchiveActorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveActorMutation, ArchiveActorMutationVariables>(
    ArchiveActorDocument,
    options,
  );
}
export type ArchiveActorMutationHookResult = ReturnType<typeof useArchiveActorMutation>;
export type ArchiveActorMutationResult = Apollo.MutationResult<ArchiveActorMutation>;
export type ArchiveActorMutationOptions = ApolloBaseMutationOptions<
  ArchiveActorMutation,
  ArchiveActorMutationVariables
>;
export const CreatePolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePolicyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreatePolicyMutationFn = ApolloMutationFunction<
  CreatePolicyMutation,
  CreatePolicyMutationVariables
>;

/**
 * __useCreatePolicyMutation__
 *
 * To run a mutation, you first call `useCreatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyMutation, { data, loading, error }] = useCreatePolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePolicyMutation, CreatePolicyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePolicyMutation, CreatePolicyMutationVariables>(
    CreatePolicyDocument,
    options,
  );
}
export type CreatePolicyMutationHookResult = ReturnType<typeof useCreatePolicyMutation>;
export type CreatePolicyMutationResult = Apollo.MutationResult<CreatePolicyMutation>;
export type CreatePolicyMutationOptions = ApolloBaseMutationOptions<
  CreatePolicyMutation,
  CreatePolicyMutationVariables
>;
export const CreateQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateQueueInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateQueueMutationFn = ApolloMutationFunction<
  CreateQueueMutation,
  CreateQueueMutationVariables
>;

/**
 * __useCreateQueueMutation__
 *
 * To run a mutation, you first call `useCreateQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueueMutation, { data, loading, error }] = useCreateQueueMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQueueMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateQueueMutation, CreateQueueMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateQueueMutation, CreateQueueMutationVariables>(
    CreateQueueDocument,
    options,
  );
}
export type CreateQueueMutationHookResult = ReturnType<typeof useCreateQueueMutation>;
export type CreateQueueMutationResult = Apollo.MutationResult<CreateQueueMutation>;
export type CreateQueueMutationOptions = ApolloBaseMutationOptions<
  CreateQueueMutation,
  CreateQueueMutationVariables
>;
export const ArchiveQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queueId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveQueueMutationFn = ApolloMutationFunction<
  ArchiveQueueMutation,
  ArchiveQueueMutationVariables
>;

/**
 * __useArchiveQueueMutation__
 *
 * To run a mutation, you first call `useArchiveQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveQueueMutation, { data, loading, error }] = useArchiveQueueMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveQueueMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveQueueMutation, ArchiveQueueMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveQueueMutation, ArchiveQueueMutationVariables>(
    ArchiveQueueDocument,
    options,
  );
}
export type ArchiveQueueMutationHookResult = ReturnType<typeof useArchiveQueueMutation>;
export type ArchiveQueueMutationResult = Apollo.MutationResult<ArchiveQueueMutation>;
export type ArchiveQueueMutationOptions = ApolloBaseMutationOptions<
  ArchiveQueueMutation,
  ArchiveQueueMutationVariables
>;
export const CreateScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateScheduleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateScheduleMutationFn = ApolloMutationFunction<
  CreateScheduleMutation,
  CreateScheduleMutationVariables
>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(
    CreateScheduleDocument,
    options,
  );
}
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = ApolloBaseMutationOptions<
  CreateScheduleMutation,
  CreateScheduleMutationVariables
>;
export const ArchiveScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveScheduleMutationFn = ApolloMutationFunction<
  ArchiveScheduleMutation,
  ArchiveScheduleMutationVariables
>;

/**
 * __useArchiveScheduleMutation__
 *
 * To run a mutation, you first call `useArchiveScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScheduleMutation, { data, loading, error }] = useArchiveScheduleMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveScheduleMutation,
    ArchiveScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveScheduleMutation, ArchiveScheduleMutationVariables>(
    ArchiveScheduleDocument,
    options,
  );
}
export type ArchiveScheduleMutationHookResult = ReturnType<typeof useArchiveScheduleMutation>;
export type ArchiveScheduleMutationResult = Apollo.MutationResult<ArchiveScheduleMutation>;
export type ArchiveScheduleMutationOptions = ApolloBaseMutationOptions<
  ArchiveScheduleMutation,
  ArchiveScheduleMutationVariables
>;
export const CreateTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateTaskInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiCreateTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateTaskMutationFn = ApolloMutationFunction<
  CreateTaskMutation,
  CreateTaskMutationVariables
>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(
    CreateTaskDocument,
    options,
  );
}
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = ApolloBaseMutationOptions<
  CreateTaskMutation,
  CreateTaskMutationVariables
>;
export const AssignTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignTaskInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiAssignTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AssignTaskMutationFn = ApolloMutationFunction<
  AssignTaskMutation,
  AssignTaskMutationVariables
>;

/**
 * __useAssignTaskMutation__
 *
 * To run a mutation, you first call `useAssignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskMutation, { data, loading, error }] = useAssignTaskMutation({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<AssignTaskMutation, AssignTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignTaskMutation, AssignTaskMutationVariables>(
    AssignTaskDocument,
    options,
  );
}
export type AssignTaskMutationHookResult = ReturnType<typeof useAssignTaskMutation>;
export type AssignTaskMutationResult = Apollo.MutationResult<AssignTaskMutation>;
export type AssignTaskMutationOptions = ApolloBaseMutationOptions<
  AssignTaskMutation,
  AssignTaskMutationVariables
>;
export const StartTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiStartTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartTaskMutationFn = ApolloMutationFunction<
  StartTaskMutation,
  StartTaskMutationVariables
>;

/**
 * __useStartTaskMutation__
 *
 * To run a mutation, you first call `useStartTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTaskMutation, { data, loading, error }] = useStartTaskMutation({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<StartTaskMutation, StartTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartTaskMutation, StartTaskMutationVariables>(
    StartTaskDocument,
    options,
  );
}
export type StartTaskMutationHookResult = ReturnType<typeof useStartTaskMutation>;
export type StartTaskMutationResult = Apollo.MutationResult<StartTaskMutation>;
export type StartTaskMutationOptions = ApolloBaseMutationOptions<
  StartTaskMutation,
  StartTaskMutationVariables
>;
export const CompleteTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCompleteTaskInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiCompleteTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteTaskMutationFn = ApolloMutationFunction<
  CompleteTaskMutation,
  CompleteTaskMutationVariables
>;

/**
 * __useCompleteTaskMutation__
 *
 * To run a mutation, you first call `useCompleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskMutation, { data, loading, error }] = useCompleteTaskMutation({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteTaskMutation, CompleteTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteTaskMutation, CompleteTaskMutationVariables>(
    CompleteTaskDocument,
    options,
  );
}
export type CompleteTaskMutationHookResult = ReturnType<typeof useCompleteTaskMutation>;
export type CompleteTaskMutationResult = Apollo.MutationResult<CompleteTaskMutation>;
export type CompleteTaskMutationOptions = ApolloBaseMutationOptions<
  CompleteTaskMutation,
  CompleteTaskMutationVariables
>;
export const FailTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FailTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlFailTaskInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiFailTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FailTaskMutationFn = ApolloMutationFunction<
  FailTaskMutation,
  FailTaskMutationVariables
>;

/**
 * __useFailTaskMutation__
 *
 * To run a mutation, you first call `useFailTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFailTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [failTaskMutation, { data, loading, error }] = useFailTaskMutation({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFailTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<FailTaskMutation, FailTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FailTaskMutation, FailTaskMutationVariables>(FailTaskDocument, options);
}
export type FailTaskMutationHookResult = ReturnType<typeof useFailTaskMutation>;
export type FailTaskMutationResult = Apollo.MutationResult<FailTaskMutation>;
export type FailTaskMutationOptions = ApolloBaseMutationOptions<
  FailTaskMutation,
  FailTaskMutationVariables
>;
export const ClaimTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ClaimTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'claimTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresMfa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignees' } },
                { kind: 'Field', name: { kind: 'Name', value: 'watchers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deepLink' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ClaimTaskMutationFn = ApolloMutationFunction<
  ClaimTaskMutation,
  ClaimTaskMutationVariables
>;

/**
 * __useClaimTaskMutation__
 *
 * To run a mutation, you first call `useClaimTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimTaskMutation, { data, loading, error }] = useClaimTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClaimTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<ClaimTaskMutation, ClaimTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ClaimTaskMutation, ClaimTaskMutationVariables>(
    ClaimTaskDocument,
    options,
  );
}
export type ClaimTaskMutationHookResult = ReturnType<typeof useClaimTaskMutation>;
export type ClaimTaskMutationResult = Apollo.MutationResult<ClaimTaskMutation>;
export type ClaimTaskMutationOptions = ApolloBaseMutationOptions<
  ClaimTaskMutation,
  ClaimTaskMutationVariables
>;
export const AssignTaskToActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignTaskToActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlAssignTaskToActorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignTaskToActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedTaskIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AssignTaskToActorMutationFn = ApolloMutationFunction<
  AssignTaskToActorMutation,
  AssignTaskToActorMutationVariables
>;

/**
 * __useAssignTaskToActorMutation__
 *
 * To run a mutation, you first call `useAssignTaskToActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskToActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskToActorMutation, { data, loading, error }] = useAssignTaskToActorMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTaskToActorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTaskToActorMutation,
    AssignTaskToActorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignTaskToActorMutation, AssignTaskToActorMutationVariables>(
    AssignTaskToActorDocument,
    options,
  );
}
export type AssignTaskToActorMutationHookResult = ReturnType<typeof useAssignTaskToActorMutation>;
export type AssignTaskToActorMutationResult = Apollo.MutationResult<AssignTaskToActorMutation>;
export type AssignTaskToActorMutationOptions = ApolloBaseMutationOptions<
  AssignTaskToActorMutation,
  AssignTaskToActorMutationVariables
>;
export const CompleteTasksByToolHintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteTasksByToolHint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toolHint' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiCompleteTasksByToolHint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toolHint' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toolHint' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteTasksByToolHintMutationFn = ApolloMutationFunction<
  CompleteTasksByToolHintMutation,
  CompleteTasksByToolHintMutationVariables
>;

/**
 * __useCompleteTasksByToolHintMutation__
 *
 * To run a mutation, you first call `useCompleteTasksByToolHintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTasksByToolHintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTasksByToolHintMutation, { data, loading, error }] = useCompleteTasksByToolHintMutation({
 *   variables: {
 *      toolHint: // value for 'toolHint'
 *   },
 * });
 */
export function useCompleteTasksByToolHintMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteTasksByToolHintMutation,
    CompleteTasksByToolHintMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteTasksByToolHintMutation,
    CompleteTasksByToolHintMutationVariables
  >(CompleteTasksByToolHintDocument, options);
}
export type CompleteTasksByToolHintMutationHookResult = ReturnType<
  typeof useCompleteTasksByToolHintMutation
>;
export type CompleteTasksByToolHintMutationResult =
  Apollo.MutationResult<CompleteTasksByToolHintMutation>;
export type CompleteTasksByToolHintMutationOptions = ApolloBaseMutationOptions<
  CompleteTasksByToolHintMutation,
  CompleteTasksByToolHintMutationVariables
>;
export const RescheduleTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RescheduleTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRescheduleTaskInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiRescheduleTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RescheduleTaskMutationFn = ApolloMutationFunction<
  RescheduleTaskMutation,
  RescheduleTaskMutationVariables
>;

/**
 * __useRescheduleTaskMutation__
 *
 * To run a mutation, you first call `useRescheduleTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleTaskMutation, { data, loading, error }] = useRescheduleTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<RescheduleTaskMutation, RescheduleTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RescheduleTaskMutation, RescheduleTaskMutationVariables>(
    RescheduleTaskDocument,
    options,
  );
}
export type RescheduleTaskMutationHookResult = ReturnType<typeof useRescheduleTaskMutation>;
export type RescheduleTaskMutationResult = Apollo.MutationResult<RescheduleTaskMutation>;
export type RescheduleTaskMutationOptions = ApolloBaseMutationOptions<
  RescheduleTaskMutation,
  RescheduleTaskMutationVariables
>;
export const AcknowledgeElopementAlertDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcknowledgeElopementAlert' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'alertId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'acknowledgedBy' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgeElopementAlert' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'alertId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'alertId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'acknowledgedBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'acknowledgedBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledged' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AcknowledgeElopementAlertMutationFn = ApolloMutationFunction<
  AcknowledgeElopementAlertMutation,
  AcknowledgeElopementAlertMutationVariables
>;

/**
 * __useAcknowledgeElopementAlertMutation__
 *
 * To run a mutation, you first call `useAcknowledgeElopementAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeElopementAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeElopementAlertMutation, { data, loading, error }] = useAcknowledgeElopementAlertMutation({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      alertId: // value for 'alertId'
 *      acknowledgedBy: // value for 'acknowledgedBy'
 *   },
 * });
 */
export function useAcknowledgeElopementAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcknowledgeElopementAlertMutation,
    AcknowledgeElopementAlertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcknowledgeElopementAlertMutation,
    AcknowledgeElopementAlertMutationVariables
  >(AcknowledgeElopementAlertDocument, options);
}
export type AcknowledgeElopementAlertMutationHookResult = ReturnType<
  typeof useAcknowledgeElopementAlertMutation
>;
export type AcknowledgeElopementAlertMutationResult =
  Apollo.MutationResult<AcknowledgeElopementAlertMutation>;
export type AcknowledgeElopementAlertMutationOptions = ApolloBaseMutationOptions<
  AcknowledgeElopementAlertMutation,
  AcknowledgeElopementAlertMutationVariables
>;
export const ResolveSyncConflictDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResolveSyncConflict' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResolveSyncConflictInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveSyncConflict' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'conflictId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResolveSyncConflictMutationFn = ApolloMutationFunction<
  ResolveSyncConflictMutation,
  ResolveSyncConflictMutationVariables
>;

/**
 * __useResolveSyncConflictMutation__
 *
 * To run a mutation, you first call `useResolveSyncConflictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveSyncConflictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveSyncConflictMutation, { data, loading, error }] = useResolveSyncConflictMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveSyncConflictMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResolveSyncConflictMutation,
    ResolveSyncConflictMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResolveSyncConflictMutation, ResolveSyncConflictMutationVariables>(
    ResolveSyncConflictDocument,
    options,
  );
}
export type ResolveSyncConflictMutationHookResult = ReturnType<
  typeof useResolveSyncConflictMutation
>;
export type ResolveSyncConflictMutationResult = Apollo.MutationResult<ResolveSyncConflictMutation>;
export type ResolveSyncConflictMutationOptions = ApolloBaseMutationOptions<
  ResolveSyncConflictMutation,
  ResolveSyncConflictMutationVariables
>;
export const CreateEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateEventInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventApiCreateEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateEventMutationFn = ApolloMutationFunction<
  CreateEventMutation,
  CreateEventMutationVariables
>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(
    CreateEventDocument,
    options,
  );
}
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = ApolloBaseMutationOptions<
  CreateEventMutation,
  CreateEventMutationVariables
>;
export const ArchiveEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'olderThan' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventApiArchiveEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'olderThan' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'olderThan' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveEventsMutationFn = ApolloMutationFunction<
  ArchiveEventsMutation,
  ArchiveEventsMutationVariables
>;

/**
 * __useArchiveEventsMutation__
 *
 * To run a mutation, you first call `useArchiveEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEventsMutation, { data, loading, error }] = useArchiveEventsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      olderThan: // value for 'olderThan'
 *   },
 * });
 */
export function useArchiveEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveEventsMutation, ArchiveEventsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveEventsMutation, ArchiveEventsMutationVariables>(
    ArchiveEventsDocument,
    options,
  );
}
export type ArchiveEventsMutationHookResult = ReturnType<typeof useArchiveEventsMutation>;
export type ArchiveEventsMutationResult = Apollo.MutationResult<ArchiveEventsMutation>;
export type ArchiveEventsMutationOptions = ApolloBaseMutationOptions<
  ArchiveEventsMutation,
  ArchiveEventsMutationVariables
>;
export const StartSagaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartSaga' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'StartSagaInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startSaga' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'executionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sagaId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartSagaMutationFn = ApolloMutationFunction<
  StartSagaMutation,
  StartSagaMutationVariables
>;

/**
 * __useStartSagaMutation__
 *
 * To run a mutation, you first call `useStartSagaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSagaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSagaMutation, { data, loading, error }] = useStartSagaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSagaMutation(
  baseOptions?: Apollo.MutationHookOptions<StartSagaMutation, StartSagaMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartSagaMutation, StartSagaMutationVariables>(
    StartSagaDocument,
    options,
  );
}
export type StartSagaMutationHookResult = ReturnType<typeof useStartSagaMutation>;
export type StartSagaMutationResult = Apollo.MutationResult<StartSagaMutation>;
export type StartSagaMutationOptions = ApolloBaseMutationOptions<
  StartSagaMutation,
  StartSagaMutationVariables
>;
export const ExecuteDagWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExecuteDagWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExecuteDAGWorkflowInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'executeDagWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'executionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'executionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalNodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedNodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failedNodes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ExecuteDagWorkflowMutationFn = ApolloMutationFunction<
  ExecuteDagWorkflowMutation,
  ExecuteDagWorkflowMutationVariables
>;

/**
 * __useExecuteDagWorkflowMutation__
 *
 * To run a mutation, you first call `useExecuteDagWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteDagWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeDagWorkflowMutation, { data, loading, error }] = useExecuteDagWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteDagWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteDagWorkflowMutation,
    ExecuteDagWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExecuteDagWorkflowMutation, ExecuteDagWorkflowMutationVariables>(
    ExecuteDagWorkflowDocument,
    options,
  );
}
export type ExecuteDagWorkflowMutationHookResult = ReturnType<typeof useExecuteDagWorkflowMutation>;
export type ExecuteDagWorkflowMutationResult = Apollo.MutationResult<ExecuteDagWorkflowMutation>;
export type ExecuteDagWorkflowMutationOptions = ApolloBaseMutationOptions<
  ExecuteDagWorkflowMutation,
  ExecuteDagWorkflowMutationVariables
>;
export const CancelDagExecutionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelDagExecution' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'executionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelDagExecution' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'executionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'executionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'executionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelDagExecutionMutationFn = ApolloMutationFunction<
  CancelDagExecutionMutation,
  CancelDagExecutionMutationVariables
>;

/**
 * __useCancelDagExecutionMutation__
 *
 * To run a mutation, you first call `useCancelDagExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDagExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDagExecutionMutation, { data, loading, error }] = useCancelDagExecutionMutation({
 *   variables: {
 *      executionId: // value for 'executionId'
 *   },
 * });
 */
export function useCancelDagExecutionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelDagExecutionMutation,
    CancelDagExecutionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelDagExecutionMutation, CancelDagExecutionMutationVariables>(
    CancelDagExecutionDocument,
    options,
  );
}
export type CancelDagExecutionMutationHookResult = ReturnType<typeof useCancelDagExecutionMutation>;
export type CancelDagExecutionMutationResult = Apollo.MutationResult<CancelDagExecutionMutation>;
export type CancelDagExecutionMutationOptions = ApolloBaseMutationOptions<
  CancelDagExecutionMutation,
  CancelDagExecutionMutationVariables
>;
export const StageSafetyEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StageSafetyEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSafetyEventInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stageSafetyEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StageSafetyEventMutationFn = ApolloMutationFunction<
  StageSafetyEventMutation,
  StageSafetyEventMutationVariables
>;

/**
 * __useStageSafetyEventMutation__
 *
 * To run a mutation, you first call `useStageSafetyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageSafetyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageSafetyEventMutation, { data, loading, error }] = useStageSafetyEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStageSafetyEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StageSafetyEventMutation,
    StageSafetyEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StageSafetyEventMutation, StageSafetyEventMutationVariables>(
    StageSafetyEventDocument,
    options,
  );
}
export type StageSafetyEventMutationHookResult = ReturnType<typeof useStageSafetyEventMutation>;
export type StageSafetyEventMutationResult = Apollo.MutationResult<StageSafetyEventMutation>;
export type StageSafetyEventMutationOptions = ApolloBaseMutationOptions<
  StageSafetyEventMutation,
  StageSafetyEventMutationVariables
>;
export const CreateAuditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAudit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAuditInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAudit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateAuditMutationFn = ApolloMutationFunction<
  CreateAuditMutation,
  CreateAuditMutationVariables
>;

/**
 * __useCreateAuditMutation__
 *
 * To run a mutation, you first call `useCreateAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuditMutation, { data, loading, error }] = useCreateAuditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuditMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAuditMutation, CreateAuditMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAuditMutation, CreateAuditMutationVariables>(
    CreateAuditDocument,
    options,
  );
}
export type CreateAuditMutationHookResult = ReturnType<typeof useCreateAuditMutation>;
export type CreateAuditMutationResult = Apollo.MutationResult<CreateAuditMutation>;
export type CreateAuditMutationOptions = ApolloBaseMutationOptions<
  CreateAuditMutation,
  CreateAuditMutationVariables
>;
export const ArchiveAuditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveAudit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveAudit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveAuditMutationFn = ApolloMutationFunction<
  ArchiveAuditMutation,
  ArchiveAuditMutationVariables
>;

/**
 * __useArchiveAuditMutation__
 *
 * To run a mutation, you first call `useArchiveAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAuditMutation, { data, loading, error }] = useArchiveAuditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveAuditMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveAuditMutation, ArchiveAuditMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveAuditMutation, ArchiveAuditMutationVariables>(
    ArchiveAuditDocument,
    options,
  );
}
export type ArchiveAuditMutationHookResult = ReturnType<typeof useArchiveAuditMutation>;
export type ArchiveAuditMutationResult = Apollo.MutationResult<ArchiveAuditMutation>;
export type ArchiveAuditMutationOptions = ApolloBaseMutationOptions<
  ArchiveAuditMutation,
  ArchiveAuditMutationVariables
>;
export const CreateNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GqlCreateNotificationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNotification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateNotificationMutationFn = ApolloMutationFunction<
  CreateNotificationMutation,
  CreateNotificationMutationVariables
>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNotificationMutation,
    CreateNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(
    CreateNotificationDocument,
    options,
  );
}
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = ApolloBaseMutationOptions<
  CreateNotificationMutation,
  CreateNotificationMutationVariables
>;
export const ArchiveNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveNotification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notificationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveNotificationMutationFn = ApolloMutationFunction<
  ArchiveNotificationMutation,
  ArchiveNotificationMutationVariables
>;

/**
 * __useArchiveNotificationMutation__
 *
 * To run a mutation, you first call `useArchiveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNotificationMutation, { data, loading, error }] = useArchiveNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveNotificationMutation,
    ArchiveNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>(
    ArchiveNotificationDocument,
    options,
  );
}
export type ArchiveNotificationMutationHookResult = ReturnType<
  typeof useArchiveNotificationMutation
>;
export type ArchiveNotificationMutationResult = Apollo.MutationResult<ArchiveNotificationMutation>;
export type ArchiveNotificationMutationOptions = ApolloBaseMutationOptions<
  ArchiveNotificationMutation,
  ArchiveNotificationMutationVariables
>;
export const GenerateEvidenceReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateEvidenceReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateEvidenceReportInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateEvidenceReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'residentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'residentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assessmentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidenceStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidenceEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recommendation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coverageDisclosure' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateEvidenceReportMutationFn = ApolloMutationFunction<
  GenerateEvidenceReportMutation,
  GenerateEvidenceReportMutationVariables
>;

/**
 * __useGenerateEvidenceReportMutation__
 *
 * To run a mutation, you first call `useGenerateEvidenceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEvidenceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEvidenceReportMutation, { data, loading, error }] = useGenerateEvidenceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEvidenceReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateEvidenceReportMutation,
    GenerateEvidenceReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateEvidenceReportMutation,
    GenerateEvidenceReportMutationVariables
  >(GenerateEvidenceReportDocument, options);
}
export type GenerateEvidenceReportMutationHookResult = ReturnType<
  typeof useGenerateEvidenceReportMutation
>;
export type GenerateEvidenceReportMutationResult =
  Apollo.MutationResult<GenerateEvidenceReportMutation>;
export type GenerateEvidenceReportMutationOptions = ApolloBaseMutationOptions<
  GenerateEvidenceReportMutation,
  GenerateEvidenceReportMutationVariables
>;
export const PauseAccumulatorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PauseAccumulator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PauseAccumulatorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pauseAccumulator' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'residentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldsWithDrift' } },
                { kind: 'Field', name: { kind: 'Name', value: 'majorDriftFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgConfidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'daysSinceAssessment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PauseAccumulatorMutationFn = ApolloMutationFunction<
  PauseAccumulatorMutation,
  PauseAccumulatorMutationVariables
>;

/**
 * __usePauseAccumulatorMutation__
 *
 * To run a mutation, you first call `usePauseAccumulatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseAccumulatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseAccumulatorMutation, { data, loading, error }] = usePauseAccumulatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseAccumulatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PauseAccumulatorMutation,
    PauseAccumulatorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PauseAccumulatorMutation, PauseAccumulatorMutationVariables>(
    PauseAccumulatorDocument,
    options,
  );
}
export type PauseAccumulatorMutationHookResult = ReturnType<typeof usePauseAccumulatorMutation>;
export type PauseAccumulatorMutationResult = Apollo.MutationResult<PauseAccumulatorMutation>;
export type PauseAccumulatorMutationOptions = ApolloBaseMutationOptions<
  PauseAccumulatorMutation,
  PauseAccumulatorMutationVariables
>;
export const ResumeAccumulatorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeAccumulator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumeAccumulatorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeAccumulator' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'residentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldsWithDrift' } },
                { kind: 'Field', name: { kind: 'Name', value: 'majorDriftFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgConfidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'daysSinceAssessment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResumeAccumulatorMutationFn = ApolloMutationFunction<
  ResumeAccumulatorMutation,
  ResumeAccumulatorMutationVariables
>;

/**
 * __useResumeAccumulatorMutation__
 *
 * To run a mutation, you first call `useResumeAccumulatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeAccumulatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeAccumulatorMutation, { data, loading, error }] = useResumeAccumulatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeAccumulatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResumeAccumulatorMutation,
    ResumeAccumulatorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResumeAccumulatorMutation, ResumeAccumulatorMutationVariables>(
    ResumeAccumulatorDocument,
    options,
  );
}
export type ResumeAccumulatorMutationHookResult = ReturnType<typeof useResumeAccumulatorMutation>;
export type ResumeAccumulatorMutationResult = Apollo.MutationResult<ResumeAccumulatorMutation>;
export type ResumeAccumulatorMutationOptions = ApolloBaseMutationOptions<
  ResumeAccumulatorMutation,
  ResumeAccumulatorMutationVariables
>;
export const CreateContractDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContract' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateContractInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContract' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateContractMutationFn = ApolloMutationFunction<
  CreateContractMutation,
  CreateContractMutationVariables
>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(
    CreateContractDocument,
    options,
  );
}
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = ApolloBaseMutationOptions<
  CreateContractMutation,
  CreateContractMutationVariables
>;
export const ArchiveContractDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveContract' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contractId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveContract' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contractId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveContractMutationFn = ApolloMutationFunction<
  ArchiveContractMutation,
  ArchiveContractMutationVariables
>;

/**
 * __useArchiveContractMutation__
 *
 * To run a mutation, you first call `useArchiveContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveContractMutation, { data, loading, error }] = useArchiveContractMutation({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      contractId: // value for 'contractId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveContractMutation,
    ArchiveContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveContractMutation, ArchiveContractMutationVariables>(
    ArchiveContractDocument,
    options,
  );
}
export type ArchiveContractMutationHookResult = ReturnType<typeof useArchiveContractMutation>;
export type ArchiveContractMutationResult = Apollo.MutationResult<ArchiveContractMutation>;
export type ArchiveContractMutationOptions = ApolloBaseMutationOptions<
  ArchiveContractMutation,
  ArchiveContractMutationVariables
>;
export const CreateDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDocumentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiCreateDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateDocumentMutationFn = ApolloMutationFunction<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(
    CreateDocumentDocument,
    options,
  );
}
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = ApolloBaseMutationOptions<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;
export const DeleteDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiDeleteDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteDocumentMutationFn = ApolloMutationFunction<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
    DeleteDocumentDocument,
    options,
  );
}
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = ApolloBaseMutationOptions<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;
export const CreateDocumentVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDocumentVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDocumentVersionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiCreateDocumentVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateDocumentVersionMutationFn = ApolloMutationFunction<
  CreateDocumentVersionMutation,
  CreateDocumentVersionMutationVariables
>;

/**
 * __useCreateDocumentVersionMutation__
 *
 * To run a mutation, you first call `useCreateDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentVersionMutation, { data, loading, error }] = useCreateDocumentVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDocumentVersionMutation,
    CreateDocumentVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDocumentVersionMutation, CreateDocumentVersionMutationVariables>(
    CreateDocumentVersionDocument,
    options,
  );
}
export type CreateDocumentVersionMutationHookResult = ReturnType<
  typeof useCreateDocumentVersionMutation
>;
export type CreateDocumentVersionMutationResult =
  Apollo.MutationResult<CreateDocumentVersionMutation>;
export type CreateDocumentVersionMutationOptions = ApolloBaseMutationOptions<
  CreateDocumentVersionMutation,
  CreateDocumentVersionMutationVariables
>;
export const ArchiveDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiArchiveDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveDocumentMutationFn = ApolloMutationFunction<
  ArchiveDocumentMutation,
  ArchiveDocumentMutationVariables
>;

/**
 * __useArchiveDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDocumentMutation, { data, loading, error }] = useArchiveDocumentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useArchiveDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveDocumentMutation,
    ArchiveDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>(
    ArchiveDocumentDocument,
    options,
  );
}
export type ArchiveDocumentMutationHookResult = ReturnType<typeof useArchiveDocumentMutation>;
export type ArchiveDocumentMutationResult = Apollo.MutationResult<ArchiveDocumentMutation>;
export type ArchiveDocumentMutationOptions = ApolloBaseMutationOptions<
  ArchiveDocumentMutation,
  ArchiveDocumentMutationVariables
>;
export const SignDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SignDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SignDocumentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiSignDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DocumentFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'signedS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditEventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Document' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storageType' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Bucket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamodbContent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRuleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryEvidenceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SignDocumentMutationFn = ApolloMutationFunction<
  SignDocumentMutation,
  SignDocumentMutationVariables
>;

/**
 * __useSignDocumentMutation__
 *
 * To run a mutation, you first call `useSignDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDocumentMutation, { data, loading, error }] = useSignDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<SignDocumentMutation, SignDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignDocumentMutation, SignDocumentMutationVariables>(
    SignDocumentDocument,
    options,
  );
}
export type SignDocumentMutationHookResult = ReturnType<typeof useSignDocumentMutation>;
export type SignDocumentMutationResult = Apollo.MutationResult<SignDocumentMutation>;
export type SignDocumentMutationOptions = ApolloBaseMutationOptions<
  SignDocumentMutation,
  SignDocumentMutationVariables
>;
export const MergeDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MergeDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MergeDocumentsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiMergeDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DocumentFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'auditEventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Document' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storageType' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Bucket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamodbContent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRuleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryEvidenceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type MergeDocumentsMutationFn = ApolloMutationFunction<
  MergeDocumentsMutation,
  MergeDocumentsMutationVariables
>;

/**
 * __useMergeDocumentsMutation__
 *
 * To run a mutation, you first call `useMergeDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeDocumentsMutation, { data, loading, error }] = useMergeDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeDocumentsMutation(
  baseOptions?: Apollo.MutationHookOptions<MergeDocumentsMutation, MergeDocumentsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MergeDocumentsMutation, MergeDocumentsMutationVariables>(
    MergeDocumentsDocument,
    options,
  );
}
export type MergeDocumentsMutationHookResult = ReturnType<typeof useMergeDocumentsMutation>;
export type MergeDocumentsMutationResult = Apollo.MutationResult<MergeDocumentsMutation>;
export type MergeDocumentsMutationOptions = ApolloBaseMutationOptions<
  MergeDocumentsMutation,
  MergeDocumentsMutationVariables
>;
export const SavePdfAnnotationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SavePdfAnnotations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SavePdfAnnotationsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiSavePdfAnnotations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DocumentFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Document' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storageType' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Bucket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamodbContent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRuleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryEvidenceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SavePdfAnnotationsMutationFn = ApolloMutationFunction<
  SavePdfAnnotationsMutation,
  SavePdfAnnotationsMutationVariables
>;

/**
 * __useSavePdfAnnotationsMutation__
 *
 * To run a mutation, you first call `useSavePdfAnnotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePdfAnnotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePdfAnnotationsMutation, { data, loading, error }] = useSavePdfAnnotationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePdfAnnotationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SavePdfAnnotationsMutation,
    SavePdfAnnotationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SavePdfAnnotationsMutation, SavePdfAnnotationsMutationVariables>(
    SavePdfAnnotationsDocument,
    options,
  );
}
export type SavePdfAnnotationsMutationHookResult = ReturnType<typeof useSavePdfAnnotationsMutation>;
export type SavePdfAnnotationsMutationResult = Apollo.MutationResult<SavePdfAnnotationsMutation>;
export type SavePdfAnnotationsMutationOptions = ApolloBaseMutationOptions<
  SavePdfAnnotationsMutation,
  SavePdfAnnotationsMutationVariables
>;
export const EncryptDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EncryptDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EncryptDocumentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'encryptDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'encryptedS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EncryptDocumentMutationFn = ApolloMutationFunction<
  EncryptDocumentMutation,
  EncryptDocumentMutationVariables
>;

/**
 * __useEncryptDocumentMutation__
 *
 * To run a mutation, you first call `useEncryptDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEncryptDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [encryptDocumentMutation, { data, loading, error }] = useEncryptDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEncryptDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EncryptDocumentMutation,
    EncryptDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EncryptDocumentMutation, EncryptDocumentMutationVariables>(
    EncryptDocumentDocument,
    options,
  );
}
export type EncryptDocumentMutationHookResult = ReturnType<typeof useEncryptDocumentMutation>;
export type EncryptDocumentMutationResult = Apollo.MutationResult<EncryptDocumentMutation>;
export type EncryptDocumentMutationOptions = ApolloBaseMutationOptions<
  EncryptDocumentMutation,
  EncryptDocumentMutationVariables
>;
export const FillStateFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FillStateForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FillStateFormInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fillStateForm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filledFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blankFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FillStateFormMutationFn = ApolloMutationFunction<
  FillStateFormMutation,
  FillStateFormMutationVariables
>;

/**
 * __useFillStateFormMutation__
 *
 * To run a mutation, you first call `useFillStateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillStateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillStateFormMutation, { data, loading, error }] = useFillStateFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillStateFormMutation(
  baseOptions?: Apollo.MutationHookOptions<FillStateFormMutation, FillStateFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FillStateFormMutation, FillStateFormMutationVariables>(
    FillStateFormDocument,
    options,
  );
}
export type FillStateFormMutationHookResult = ReturnType<typeof useFillStateFormMutation>;
export type FillStateFormMutationResult = Apollo.MutationResult<FillStateFormMutation>;
export type FillStateFormMutationOptions = ApolloBaseMutationOptions<
  FillStateFormMutation,
  FillStateFormMutationVariables
>;
export const RenderHtmlPdfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RenderHtmlPdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RenderHtmlPdfInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderHtmlPdf' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RenderHtmlPdfMutationFn = ApolloMutationFunction<
  RenderHtmlPdfMutation,
  RenderHtmlPdfMutationVariables
>;

/**
 * __useRenderHtmlPdfMutation__
 *
 * To run a mutation, you first call `useRenderHtmlPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderHtmlPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderHtmlPdfMutation, { data, loading, error }] = useRenderHtmlPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderHtmlPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<RenderHtmlPdfMutation, RenderHtmlPdfMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenderHtmlPdfMutation, RenderHtmlPdfMutationVariables>(
    RenderHtmlPdfDocument,
    options,
  );
}
export type RenderHtmlPdfMutationHookResult = ReturnType<typeof useRenderHtmlPdfMutation>;
export type RenderHtmlPdfMutationResult = Apollo.MutationResult<RenderHtmlPdfMutation>;
export type RenderHtmlPdfMutationOptions = ApolloBaseMutationOptions<
  RenderHtmlPdfMutation,
  RenderHtmlPdfMutationVariables
>;
export const CreateSigningCeremonyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSigningCeremony' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateSigningCeremonyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSigningCeremony' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signingOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateSigningCeremonyMutationFn = ApolloMutationFunction<
  CreateSigningCeremonyMutation,
  CreateSigningCeremonyMutationVariables
>;

/**
 * __useCreateSigningCeremonyMutation__
 *
 * To run a mutation, you first call `useCreateSigningCeremonyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSigningCeremonyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSigningCeremonyMutation, { data, loading, error }] = useCreateSigningCeremonyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSigningCeremonyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSigningCeremonyMutation,
    CreateSigningCeremonyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSigningCeremonyMutation, CreateSigningCeremonyMutationVariables>(
    CreateSigningCeremonyDocument,
    options,
  );
}
export type CreateSigningCeremonyMutationHookResult = ReturnType<
  typeof useCreateSigningCeremonyMutation
>;
export type CreateSigningCeremonyMutationResult =
  Apollo.MutationResult<CreateSigningCeremonyMutation>;
export type CreateSigningCeremonyMutationOptions = ApolloBaseMutationOptions<
  CreateSigningCeremonyMutation,
  CreateSigningCeremonyMutationVariables
>;
export const RecordParticipantSignatureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordParticipantSignature' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecordParticipantSignatureInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordParticipantSignature' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signedS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordParticipantSignatureMutationFn = ApolloMutationFunction<
  RecordParticipantSignatureMutation,
  RecordParticipantSignatureMutationVariables
>;

/**
 * __useRecordParticipantSignatureMutation__
 *
 * To run a mutation, you first call `useRecordParticipantSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordParticipantSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordParticipantSignatureMutation, { data, loading, error }] = useRecordParticipantSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordParticipantSignatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordParticipantSignatureMutation,
    RecordParticipantSignatureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordParticipantSignatureMutation,
    RecordParticipantSignatureMutationVariables
  >(RecordParticipantSignatureDocument, options);
}
export type RecordParticipantSignatureMutationHookResult = ReturnType<
  typeof useRecordParticipantSignatureMutation
>;
export type RecordParticipantSignatureMutationResult =
  Apollo.MutationResult<RecordParticipantSignatureMutation>;
export type RecordParticipantSignatureMutationOptions = ApolloBaseMutationOptions<
  RecordParticipantSignatureMutation,
  RecordParticipantSignatureMutationVariables
>;
export const RequestCeremonyDocumentUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestCeremonyDocumentUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RequestCeremonyDocumentUrlInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestCeremonyDocumentUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresInSeconds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestCeremonyDocumentUrlMutationFn = ApolloMutationFunction<
  RequestCeremonyDocumentUrlMutation,
  RequestCeremonyDocumentUrlMutationVariables
>;

/**
 * __useRequestCeremonyDocumentUrlMutation__
 *
 * To run a mutation, you first call `useRequestCeremonyDocumentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCeremonyDocumentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCeremonyDocumentUrlMutation, { data, loading, error }] = useRequestCeremonyDocumentUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCeremonyDocumentUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestCeremonyDocumentUrlMutation,
    RequestCeremonyDocumentUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestCeremonyDocumentUrlMutation,
    RequestCeremonyDocumentUrlMutationVariables
  >(RequestCeremonyDocumentUrlDocument, options);
}
export type RequestCeremonyDocumentUrlMutationHookResult = ReturnType<
  typeof useRequestCeremonyDocumentUrlMutation
>;
export type RequestCeremonyDocumentUrlMutationResult =
  Apollo.MutationResult<RequestCeremonyDocumentUrlMutation>;
export type RequestCeremonyDocumentUrlMutationOptions = ApolloBaseMutationOptions<
  RequestCeremonyDocumentUrlMutation,
  RequestCeremonyDocumentUrlMutationVariables
>;
export const DeclineCeremonyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeclineCeremony' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeclineCeremonyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'declineCeremony' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'declinedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'declineReason' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeclineCeremonyMutationFn = ApolloMutationFunction<
  DeclineCeremonyMutation,
  DeclineCeremonyMutationVariables
>;

/**
 * __useDeclineCeremonyMutation__
 *
 * To run a mutation, you first call `useDeclineCeremonyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineCeremonyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineCeremonyMutation, { data, loading, error }] = useDeclineCeremonyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineCeremonyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeclineCeremonyMutation,
    DeclineCeremonyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeclineCeremonyMutation, DeclineCeremonyMutationVariables>(
    DeclineCeremonyDocument,
    options,
  );
}
export type DeclineCeremonyMutationHookResult = ReturnType<typeof useDeclineCeremonyMutation>;
export type DeclineCeremonyMutationResult = Apollo.MutationResult<DeclineCeremonyMutation>;
export type DeclineCeremonyMutationOptions = ApolloBaseMutationOptions<
  DeclineCeremonyMutation,
  DeclineCeremonyMutationVariables
>;
export const CreateWorkflowGraphDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWorkflowGraph' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateWorkflowGraphInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkflowGraph' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'graphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graphName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateWorkflowGraphMutationFn = ApolloMutationFunction<
  CreateWorkflowGraphMutation,
  CreateWorkflowGraphMutationVariables
>;

/**
 * __useCreateWorkflowGraphMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowGraphMutation, { data, loading, error }] = useCreateWorkflowGraphMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowGraphMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowGraphMutation,
    CreateWorkflowGraphMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateWorkflowGraphMutation, CreateWorkflowGraphMutationVariables>(
    CreateWorkflowGraphDocument,
    options,
  );
}
export type CreateWorkflowGraphMutationHookResult = ReturnType<
  typeof useCreateWorkflowGraphMutation
>;
export type CreateWorkflowGraphMutationResult = Apollo.MutationResult<CreateWorkflowGraphMutation>;
export type CreateWorkflowGraphMutationOptions = ApolloBaseMutationOptions<
  CreateWorkflowGraphMutation,
  CreateWorkflowGraphMutationVariables
>;
export const UpdateWorkflowGraphDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWorkflowGraph' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateWorkflowGraphInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWorkflowGraph' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'graphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graphName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWorkflowGraphMutationFn = ApolloMutationFunction<
  UpdateWorkflowGraphMutation,
  UpdateWorkflowGraphMutationVariables
>;

/**
 * __useUpdateWorkflowGraphMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowGraphMutation, { data, loading, error }] = useUpdateWorkflowGraphMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowGraphMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkflowGraphMutation,
    UpdateWorkflowGraphMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWorkflowGraphMutation, UpdateWorkflowGraphMutationVariables>(
    UpdateWorkflowGraphDocument,
    options,
  );
}
export type UpdateWorkflowGraphMutationHookResult = ReturnType<
  typeof useUpdateWorkflowGraphMutation
>;
export type UpdateWorkflowGraphMutationResult = Apollo.MutationResult<UpdateWorkflowGraphMutation>;
export type UpdateWorkflowGraphMutationOptions = ApolloBaseMutationOptions<
  UpdateWorkflowGraphMutation,
  UpdateWorkflowGraphMutationVariables
>;
export const ArchiveWorkflowGraphDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveWorkflowGraph' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchiveWorkflowGraphInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveWorkflowGraph' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'graphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveWorkflowGraphMutationFn = ApolloMutationFunction<
  ArchiveWorkflowGraphMutation,
  ArchiveWorkflowGraphMutationVariables
>;

/**
 * __useArchiveWorkflowGraphMutation__
 *
 * To run a mutation, you first call `useArchiveWorkflowGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkflowGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkflowGraphMutation, { data, loading, error }] = useArchiveWorkflowGraphMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveWorkflowGraphMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveWorkflowGraphMutation,
    ArchiveWorkflowGraphMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveWorkflowGraphMutation, ArchiveWorkflowGraphMutationVariables>(
    ArchiveWorkflowGraphDocument,
    options,
  );
}
export type ArchiveWorkflowGraphMutationHookResult = ReturnType<
  typeof useArchiveWorkflowGraphMutation
>;
export type ArchiveWorkflowGraphMutationResult =
  Apollo.MutationResult<ArchiveWorkflowGraphMutation>;
export type ArchiveWorkflowGraphMutationOptions = ApolloBaseMutationOptions<
  ArchiveWorkflowGraphMutation,
  ArchiveWorkflowGraphMutationVariables
>;
export const GenerateTaskGuidanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateTaskGuidance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateTaskGuidanceInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateTaskGuidance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guidance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'guidanceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'steps' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'stepNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'instruction' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'estimatedDuration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requiredInputs' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'validationRules' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tips' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'complianceNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relatedDocumentation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationSuggestions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'groupBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priorityOverrides' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'suggestedPriority' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateTaskGuidanceMutationFn = ApolloMutationFunction<
  GenerateTaskGuidanceMutation,
  GenerateTaskGuidanceMutationVariables
>;

/**
 * __useGenerateTaskGuidanceMutation__
 *
 * To run a mutation, you first call `useGenerateTaskGuidanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaskGuidanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaskGuidanceMutation, { data, loading, error }] = useGenerateTaskGuidanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateTaskGuidanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateTaskGuidanceMutation,
    GenerateTaskGuidanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateTaskGuidanceMutation, GenerateTaskGuidanceMutationVariables>(
    GenerateTaskGuidanceDocument,
    options,
  );
}
export type GenerateTaskGuidanceMutationHookResult = ReturnType<
  typeof useGenerateTaskGuidanceMutation
>;
export type GenerateTaskGuidanceMutationResult =
  Apollo.MutationResult<GenerateTaskGuidanceMutation>;
export type GenerateTaskGuidanceMutationOptions = ApolloBaseMutationOptions<
  GenerateTaskGuidanceMutation,
  GenerateTaskGuidanceMutationVariables
>;
export const OrganizeTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OrganizeTasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrganizeTasksInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizeTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizedTasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'groupKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'groupLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'urgencyScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'suggestedStartTime' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'groupKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'criticalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'overdueCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'suggestedFocus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'estimatedTotalDuration' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type OrganizeTasksMutationFn = ApolloMutationFunction<
  OrganizeTasksMutation,
  OrganizeTasksMutationVariables
>;

/**
 * __useOrganizeTasksMutation__
 *
 * To run a mutation, you first call `useOrganizeTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizeTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizeTasksMutation, { data, loading, error }] = useOrganizeTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizeTasksMutation(
  baseOptions?: Apollo.MutationHookOptions<OrganizeTasksMutation, OrganizeTasksMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OrganizeTasksMutation, OrganizeTasksMutationVariables>(
    OrganizeTasksDocument,
    options,
  );
}
export type OrganizeTasksMutationHookResult = ReturnType<typeof useOrganizeTasksMutation>;
export type OrganizeTasksMutationResult = Apollo.MutationResult<OrganizeTasksMutation>;
export type OrganizeTasksMutationOptions = ApolloBaseMutationOptions<
  OrganizeTasksMutation,
  OrganizeTasksMutationVariables
>;
export const ImportRegulatoryRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImportRegulatoryRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImportRulesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importRegulatoryRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BatchImportResultFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RuleImportResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRuleImportResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routeDecision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyOverride' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictsDetected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BatchImportResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlBatchImportResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'importedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoApprovedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRequiredCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RuleImportResultFields' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ImportRegulatoryRulesMutationFn = ApolloMutationFunction<
  ImportRegulatoryRulesMutation,
  ImportRegulatoryRulesMutationVariables
>;

/**
 * __useImportRegulatoryRulesMutation__
 *
 * To run a mutation, you first call `useImportRegulatoryRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRegulatoryRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRegulatoryRulesMutation, { data, loading, error }] = useImportRegulatoryRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportRegulatoryRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportRegulatoryRulesMutation,
    ImportRegulatoryRulesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportRegulatoryRulesMutation, ImportRegulatoryRulesMutationVariables>(
    ImportRegulatoryRulesDocument,
    options,
  );
}
export type ImportRegulatoryRulesMutationHookResult = ReturnType<
  typeof useImportRegulatoryRulesMutation
>;
export type ImportRegulatoryRulesMutationResult =
  Apollo.MutationResult<ImportRegulatoryRulesMutation>;
export type ImportRegulatoryRulesMutationOptions = ApolloBaseMutationOptions<
  ImportRegulatoryRulesMutation,
  ImportRegulatoryRulesMutationVariables
>;
export const ApproveRegulatoryRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApproveRegulatoryRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApproveRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveRegulatoryRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegulatoryRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegulatoryRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRegulatoryRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structured' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fhirResource' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exceptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alternativeAction' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'source' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivision' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paragraph' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidencePercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piiImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changelog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresHumanReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewComment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApproveRegulatoryRuleMutationFn = ApolloMutationFunction<
  ApproveRegulatoryRuleMutation,
  ApproveRegulatoryRuleMutationVariables
>;

/**
 * __useApproveRegulatoryRuleMutation__
 *
 * To run a mutation, you first call `useApproveRegulatoryRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRegulatoryRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRegulatoryRuleMutation, { data, loading, error }] = useApproveRegulatoryRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveRegulatoryRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveRegulatoryRuleMutation,
    ApproveRegulatoryRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApproveRegulatoryRuleMutation, ApproveRegulatoryRuleMutationVariables>(
    ApproveRegulatoryRuleDocument,
    options,
  );
}
export type ApproveRegulatoryRuleMutationHookResult = ReturnType<
  typeof useApproveRegulatoryRuleMutation
>;
export type ApproveRegulatoryRuleMutationResult =
  Apollo.MutationResult<ApproveRegulatoryRuleMutation>;
export type ApproveRegulatoryRuleMutationOptions = ApolloBaseMutationOptions<
  ApproveRegulatoryRuleMutation,
  ApproveRegulatoryRuleMutationVariables
>;
export const RejectRegulatoryRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RejectRegulatoryRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RejectRuleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectRegulatoryRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegulatoryRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegulatoryRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRegulatoryRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structured' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fhirResource' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exceptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alternativeAction' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'source' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivision' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paragraph' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidencePercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piiImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changelog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresHumanReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewComment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RejectRegulatoryRuleMutationFn = ApolloMutationFunction<
  RejectRegulatoryRuleMutation,
  RejectRegulatoryRuleMutationVariables
>;

/**
 * __useRejectRegulatoryRuleMutation__
 *
 * To run a mutation, you first call `useRejectRegulatoryRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRegulatoryRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRegulatoryRuleMutation, { data, loading, error }] = useRejectRegulatoryRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectRegulatoryRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectRegulatoryRuleMutation,
    RejectRegulatoryRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RejectRegulatoryRuleMutation, RejectRegulatoryRuleMutationVariables>(
    RejectRegulatoryRuleDocument,
    options,
  );
}
export type RejectRegulatoryRuleMutationHookResult = ReturnType<
  typeof useRejectRegulatoryRuleMutation
>;
export type RejectRegulatoryRuleMutationResult =
  Apollo.MutationResult<RejectRegulatoryRuleMutation>;
export type RejectRegulatoryRuleMutationOptions = ApolloBaseMutationOptions<
  RejectRegulatoryRuleMutation,
  RejectRegulatoryRuleMutationVariables
>;
export const ResubmitRegulatoryRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResubmitRegulatoryRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'yamlContent' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resubmitRegulatoryRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ruleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'yamlContent' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'yamlContent' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegulatoryRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegulatoryRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRegulatoryRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structured' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fhirResource' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exceptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alternativeAction' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'source' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivision' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paragraph' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidencePercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piiImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changelog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresHumanReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewComment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResubmitRegulatoryRuleMutationFn = ApolloMutationFunction<
  ResubmitRegulatoryRuleMutation,
  ResubmitRegulatoryRuleMutationVariables
>;

/**
 * __useResubmitRegulatoryRuleMutation__
 *
 * To run a mutation, you first call `useResubmitRegulatoryRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubmitRegulatoryRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubmitRegulatoryRuleMutation, { data, loading, error }] = useResubmitRegulatoryRuleMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      ruleId: // value for 'ruleId'
 *      yamlContent: // value for 'yamlContent'
 *   },
 * });
 */
export function useResubmitRegulatoryRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResubmitRegulatoryRuleMutation,
    ResubmitRegulatoryRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResubmitRegulatoryRuleMutation,
    ResubmitRegulatoryRuleMutationVariables
  >(ResubmitRegulatoryRuleDocument, options);
}
export type ResubmitRegulatoryRuleMutationHookResult = ReturnType<
  typeof useResubmitRegulatoryRuleMutation
>;
export type ResubmitRegulatoryRuleMutationResult =
  Apollo.MutationResult<ResubmitRegulatoryRuleMutation>;
export type ResubmitRegulatoryRuleMutationOptions = ApolloBaseMutationOptions<
  ResubmitRegulatoryRuleMutation,
  ResubmitRegulatoryRuleMutationVariables
>;
export const InitiateExchangeRelationshipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InitiateExchangeRelationship' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'InitiateExchangeRelationshipInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initiateExchangeRelationship' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromTenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toTenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
                { kind: 'Field', name: { kind: 'Name', value: 'establishedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InitiateExchangeRelationshipMutationFn = ApolloMutationFunction<
  InitiateExchangeRelationshipMutation,
  InitiateExchangeRelationshipMutationVariables
>;

/**
 * __useInitiateExchangeRelationshipMutation__
 *
 * To run a mutation, you first call `useInitiateExchangeRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateExchangeRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateExchangeRelationshipMutation, { data, loading, error }] = useInitiateExchangeRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateExchangeRelationshipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitiateExchangeRelationshipMutation,
    InitiateExchangeRelationshipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitiateExchangeRelationshipMutation,
    InitiateExchangeRelationshipMutationVariables
  >(InitiateExchangeRelationshipDocument, options);
}
export type InitiateExchangeRelationshipMutationHookResult = ReturnType<
  typeof useInitiateExchangeRelationshipMutation
>;
export type InitiateExchangeRelationshipMutationResult =
  Apollo.MutationResult<InitiateExchangeRelationshipMutation>;
export type InitiateExchangeRelationshipMutationOptions = ApolloBaseMutationOptions<
  InitiateExchangeRelationshipMutation,
  InitiateExchangeRelationshipMutationVariables
>;
export const RecordExchangeConsentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordExchangeConsent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecordExchangeConsentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordExchangeConsent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consentRecords' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consentedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authTier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'witnessVerified' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'establishedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordExchangeConsentMutationFn = ApolloMutationFunction<
  RecordExchangeConsentMutation,
  RecordExchangeConsentMutationVariables
>;

/**
 * __useRecordExchangeConsentMutation__
 *
 * To run a mutation, you first call `useRecordExchangeConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordExchangeConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordExchangeConsentMutation, { data, loading, error }] = useRecordExchangeConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordExchangeConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordExchangeConsentMutation,
    RecordExchangeConsentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RecordExchangeConsentMutation, RecordExchangeConsentMutationVariables>(
    RecordExchangeConsentDocument,
    options,
  );
}
export type RecordExchangeConsentMutationHookResult = ReturnType<
  typeof useRecordExchangeConsentMutation
>;
export type RecordExchangeConsentMutationResult =
  Apollo.MutationResult<RecordExchangeConsentMutation>;
export type RecordExchangeConsentMutationOptions = ApolloBaseMutationOptions<
  RecordExchangeConsentMutation,
  RecordExchangeConsentMutationVariables
>;
export const RequestExchangeUploadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestExchangeUploadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RequestExchangeUploadUrlInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestExchangeUploadUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresInSeconds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestExchangeUploadUrlMutationFn = ApolloMutationFunction<
  RequestExchangeUploadUrlMutation,
  RequestExchangeUploadUrlMutationVariables
>;

/**
 * __useRequestExchangeUploadUrlMutation__
 *
 * To run a mutation, you first call `useRequestExchangeUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestExchangeUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestExchangeUploadUrlMutation, { data, loading, error }] = useRequestExchangeUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestExchangeUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestExchangeUploadUrlMutation,
    RequestExchangeUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestExchangeUploadUrlMutation,
    RequestExchangeUploadUrlMutationVariables
  >(RequestExchangeUploadUrlDocument, options);
}
export type RequestExchangeUploadUrlMutationHookResult = ReturnType<
  typeof useRequestExchangeUploadUrlMutation
>;
export type RequestExchangeUploadUrlMutationResult =
  Apollo.MutationResult<RequestExchangeUploadUrlMutation>;
export type RequestExchangeUploadUrlMutationOptions = ApolloBaseMutationOptions<
  RequestExchangeUploadUrlMutation,
  RequestExchangeUploadUrlMutationVariables
>;
export const RequestExchangeDownloadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestExchangeDownloadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RequestExchangeDownloadUrlInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestExchangeDownloadUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresInSeconds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestExchangeDownloadUrlMutationFn = ApolloMutationFunction<
  RequestExchangeDownloadUrlMutation,
  RequestExchangeDownloadUrlMutationVariables
>;

/**
 * __useRequestExchangeDownloadUrlMutation__
 *
 * To run a mutation, you first call `useRequestExchangeDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestExchangeDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestExchangeDownloadUrlMutation, { data, loading, error }] = useRequestExchangeDownloadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestExchangeDownloadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestExchangeDownloadUrlMutation,
    RequestExchangeDownloadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestExchangeDownloadUrlMutation,
    RequestExchangeDownloadUrlMutationVariables
  >(RequestExchangeDownloadUrlDocument, options);
}
export type RequestExchangeDownloadUrlMutationHookResult = ReturnType<
  typeof useRequestExchangeDownloadUrlMutation
>;
export type RequestExchangeDownloadUrlMutationResult =
  Apollo.MutationResult<RequestExchangeDownloadUrlMutation>;
export type RequestExchangeDownloadUrlMutationOptions = ApolloBaseMutationOptions<
  RequestExchangeDownloadUrlMutation,
  RequestExchangeDownloadUrlMutationVariables
>;
export const RevokeExchangeRelationshipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokeExchangeRelationship' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RevokeExchangeRelationshipInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeExchangeRelationship' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RevokeExchangeRelationshipMutationFn = ApolloMutationFunction<
  RevokeExchangeRelationshipMutation,
  RevokeExchangeRelationshipMutationVariables
>;

/**
 * __useRevokeExchangeRelationshipMutation__
 *
 * To run a mutation, you first call `useRevokeExchangeRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeExchangeRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeExchangeRelationshipMutation, { data, loading, error }] = useRevokeExchangeRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeExchangeRelationshipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeExchangeRelationshipMutation,
    RevokeExchangeRelationshipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeExchangeRelationshipMutation,
    RevokeExchangeRelationshipMutationVariables
  >(RevokeExchangeRelationshipDocument, options);
}
export type RevokeExchangeRelationshipMutationHookResult = ReturnType<
  typeof useRevokeExchangeRelationshipMutation
>;
export type RevokeExchangeRelationshipMutationResult =
  Apollo.MutationResult<RevokeExchangeRelationshipMutation>;
export type RevokeExchangeRelationshipMutationOptions = ApolloBaseMutationOptions<
  RevokeExchangeRelationshipMutation,
  RevokeExchangeRelationshipMutationVariables
>;
export const ImportRuleSetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImportRuleSet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRuleSetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importRuleSet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliesToIndustries' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentlyEffective' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supersededBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ImportRuleSetMutationFn = ApolloMutationFunction<
  ImportRuleSetMutation,
  ImportRuleSetMutationVariables
>;

/**
 * __useImportRuleSetMutation__
 *
 * To run a mutation, you first call `useImportRuleSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRuleSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRuleSetMutation, { data, loading, error }] = useImportRuleSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportRuleSetMutation(
  baseOptions?: Apollo.MutationHookOptions<ImportRuleSetMutation, ImportRuleSetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportRuleSetMutation, ImportRuleSetMutationVariables>(
    ImportRuleSetDocument,
    options,
  );
}
export type ImportRuleSetMutationHookResult = ReturnType<typeof useImportRuleSetMutation>;
export type ImportRuleSetMutationResult = Apollo.MutationResult<ImportRuleSetMutation>;
export type ImportRuleSetMutationOptions = ApolloBaseMutationOptions<
  ImportRuleSetMutation,
  ImportRuleSetMutationVariables
>;
export const SupersedeRuleSetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SupersedeRuleSet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oldId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRuleSetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supersedeRuleSet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'oldId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'oldId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentlyEffective' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supersededBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SupersedeRuleSetMutationFn = ApolloMutationFunction<
  SupersedeRuleSetMutation,
  SupersedeRuleSetMutationVariables
>;

/**
 * __useSupersedeRuleSetMutation__
 *
 * To run a mutation, you first call `useSupersedeRuleSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupersedeRuleSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supersedeRuleSetMutation, { data, loading, error }] = useSupersedeRuleSetMutation({
 *   variables: {
 *      oldId: // value for 'oldId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupersedeRuleSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SupersedeRuleSetMutation,
    SupersedeRuleSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SupersedeRuleSetMutation, SupersedeRuleSetMutationVariables>(
    SupersedeRuleSetDocument,
    options,
  );
}
export type SupersedeRuleSetMutationHookResult = ReturnType<typeof useSupersedeRuleSetMutation>;
export type SupersedeRuleSetMutationResult = Apollo.MutationResult<SupersedeRuleSetMutation>;
export type SupersedeRuleSetMutationOptions = ApolloBaseMutationOptions<
  SupersedeRuleSetMutation,
  SupersedeRuleSetMutationVariables
>;
export const SunsetRuleSetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SunsetRuleSet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sunsetDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sunsetRuleSet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rulesetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sunsetDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sunsetDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentlyEffective' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SunsetRuleSetMutationFn = ApolloMutationFunction<
  SunsetRuleSetMutation,
  SunsetRuleSetMutationVariables
>;

/**
 * __useSunsetRuleSetMutation__
 *
 * To run a mutation, you first call `useSunsetRuleSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSunsetRuleSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sunsetRuleSetMutation, { data, loading, error }] = useSunsetRuleSetMutation({
 *   variables: {
 *      rulesetId: // value for 'rulesetId'
 *      sunsetDate: // value for 'sunsetDate'
 *   },
 * });
 */
export function useSunsetRuleSetMutation(
  baseOptions?: Apollo.MutationHookOptions<SunsetRuleSetMutation, SunsetRuleSetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SunsetRuleSetMutation, SunsetRuleSetMutationVariables>(
    SunsetRuleSetDocument,
    options,
  );
}
export type SunsetRuleSetMutationHookResult = ReturnType<typeof useSunsetRuleSetMutation>;
export type SunsetRuleSetMutationResult = Apollo.MutationResult<SunsetRuleSetMutation>;
export type SunsetRuleSetMutationOptions = ApolloBaseMutationOptions<
  SunsetRuleSetMutation,
  SunsetRuleSetMutationVariables
>;
export const UpdateRuleSetMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRuleSetMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRuleSetMetadataInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRuleSetMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rulesetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibilityScope' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateRuleSetMetadataMutationFn = ApolloMutationFunction<
  UpdateRuleSetMetadataMutation,
  UpdateRuleSetMetadataMutationVariables
>;

/**
 * __useUpdateRuleSetMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateRuleSetMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleSetMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleSetMetadataMutation, { data, loading, error }] = useUpdateRuleSetMetadataMutation({
 *   variables: {
 *      rulesetId: // value for 'rulesetId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRuleSetMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRuleSetMetadataMutation,
    UpdateRuleSetMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRuleSetMetadataMutation, UpdateRuleSetMetadataMutationVariables>(
    UpdateRuleSetMetadataDocument,
    options,
  );
}
export type UpdateRuleSetMetadataMutationHookResult = ReturnType<
  typeof useUpdateRuleSetMetadataMutation
>;
export type UpdateRuleSetMetadataMutationResult =
  Apollo.MutationResult<UpdateRuleSetMetadataMutation>;
export type UpdateRuleSetMetadataMutationOptions = ApolloBaseMutationOptions<
  UpdateRuleSetMetadataMutation,
  UpdateRuleSetMetadataMutationVariables
>;
export const CreateInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateInstanceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiCreateInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateInstanceMutationFn = ApolloMutationFunction<
  CreateInstanceMutation,
  CreateInstanceMutationVariables
>;

/**
 * __useCreateInstanceMutation__
 *
 * To run a mutation, you first call `useCreateInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstanceMutation, { data, loading, error }] = useCreateInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInstanceMutation, CreateInstanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateInstanceMutation, CreateInstanceMutationVariables>(
    CreateInstanceDocument,
    options,
  );
}
export type CreateInstanceMutationHookResult = ReturnType<typeof useCreateInstanceMutation>;
export type CreateInstanceMutationResult = Apollo.MutationResult<CreateInstanceMutation>;
export type CreateInstanceMutationOptions = ApolloBaseMutationOptions<
  CreateInstanceMutation,
  CreateInstanceMutationVariables
>;
export const StartInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiStartInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowDefinitionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartInstanceMutationFn = ApolloMutationFunction<
  StartInstanceMutation,
  StartInstanceMutationVariables
>;

/**
 * __useStartInstanceMutation__
 *
 * To run a mutation, you first call `useStartInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startInstanceMutation, { data, loading, error }] = useStartInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      instanceId: // value for 'instanceId'
 *      workflowDefinitionId: // value for 'workflowDefinitionId'
 *   },
 * });
 */
export function useStartInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<StartInstanceMutation, StartInstanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartInstanceMutation, StartInstanceMutationVariables>(
    StartInstanceDocument,
    options,
  );
}
export type StartInstanceMutationHookResult = ReturnType<typeof useStartInstanceMutation>;
export type StartInstanceMutationResult = Apollo.MutationResult<StartInstanceMutation>;
export type StartInstanceMutationOptions = ApolloBaseMutationOptions<
  StartInstanceMutation,
  StartInstanceMutationVariables
>;
export const PauseInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PauseInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiPauseInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PauseInstanceMutationFn = ApolloMutationFunction<
  PauseInstanceMutation,
  PauseInstanceMutationVariables
>;

/**
 * __usePauseInstanceMutation__
 *
 * To run a mutation, you first call `usePauseInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseInstanceMutation, { data, loading, error }] = usePauseInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function usePauseInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<PauseInstanceMutation, PauseInstanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PauseInstanceMutation, PauseInstanceMutationVariables>(
    PauseInstanceDocument,
    options,
  );
}
export type PauseInstanceMutationHookResult = ReturnType<typeof usePauseInstanceMutation>;
export type PauseInstanceMutationResult = Apollo.MutationResult<PauseInstanceMutation>;
export type PauseInstanceMutationOptions = ApolloBaseMutationOptions<
  PauseInstanceMutation,
  PauseInstanceMutationVariables
>;
export const ResumeInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiResumeInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResumeInstanceMutationFn = ApolloMutationFunction<
  ResumeInstanceMutation,
  ResumeInstanceMutationVariables
>;

/**
 * __useResumeInstanceMutation__
 *
 * To run a mutation, you first call `useResumeInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeInstanceMutation, { data, loading, error }] = useResumeInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useResumeInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<ResumeInstanceMutation, ResumeInstanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResumeInstanceMutation, ResumeInstanceMutationVariables>(
    ResumeInstanceDocument,
    options,
  );
}
export type ResumeInstanceMutationHookResult = ReturnType<typeof useResumeInstanceMutation>;
export type ResumeInstanceMutationResult = Apollo.MutationResult<ResumeInstanceMutation>;
export type ResumeInstanceMutationOptions = ApolloBaseMutationOptions<
  ResumeInstanceMutation,
  ResumeInstanceMutationVariables
>;
export const CancelInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiCancelInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelInstanceMutationFn = ApolloMutationFunction<
  CancelInstanceMutation,
  CancelInstanceMutationVariables
>;

/**
 * __useCancelInstanceMutation__
 *
 * To run a mutation, you first call `useCancelInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInstanceMutation, { data, loading, error }] = useCancelInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCancelInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelInstanceMutation, CancelInstanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelInstanceMutation, CancelInstanceMutationVariables>(
    CancelInstanceDocument,
    options,
  );
}
export type CancelInstanceMutationHookResult = ReturnType<typeof useCancelInstanceMutation>;
export type CancelInstanceMutationResult = Apollo.MutationResult<CancelInstanceMutation>;
export type CancelInstanceMutationOptions = ApolloBaseMutationOptions<
  CancelInstanceMutation,
  CancelInstanceMutationVariables
>;
export const CompleteInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'outputData' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiCompleteInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'outputData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'outputData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteInstanceMutationFn = ApolloMutationFunction<
  CompleteInstanceMutation,
  CompleteInstanceMutationVariables
>;

/**
 * __useCompleteInstanceMutation__
 *
 * To run a mutation, you first call `useCompleteInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeInstanceMutation, { data, loading, error }] = useCompleteInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      instanceId: // value for 'instanceId'
 *      outputData: // value for 'outputData'
 *   },
 * });
 */
export function useCompleteInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteInstanceMutation,
    CompleteInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteInstanceMutation, CompleteInstanceMutationVariables>(
    CompleteInstanceDocument,
    options,
  );
}
export type CompleteInstanceMutationHookResult = ReturnType<typeof useCompleteInstanceMutation>;
export type CompleteInstanceMutationResult = Apollo.MutationResult<CompleteInstanceMutation>;
export type CompleteInstanceMutationOptions = ApolloBaseMutationOptions<
  CompleteInstanceMutation,
  CompleteInstanceMutationVariables
>;
export const FailInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FailInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRecordErrorInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiFailInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FailInstanceMutationFn = ApolloMutationFunction<
  FailInstanceMutation,
  FailInstanceMutationVariables
>;

/**
 * __useFailInstanceMutation__
 *
 * To run a mutation, you first call `useFailInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFailInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [failInstanceMutation, { data, loading, error }] = useFailInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      instanceId: // value for 'instanceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFailInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<FailInstanceMutation, FailInstanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FailInstanceMutation, FailInstanceMutationVariables>(
    FailInstanceDocument,
    options,
  );
}
export type FailInstanceMutationHookResult = ReturnType<typeof useFailInstanceMutation>;
export type FailInstanceMutationResult = Apollo.MutationResult<FailInstanceMutation>;
export type FailInstanceMutationOptions = ApolloBaseMutationOptions<
  FailInstanceMutation,
  FailInstanceMutationVariables
>;
export const TransitionInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TransitionInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GqlTransitionInstanceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiTransitionInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowDefinitionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TransitionInstanceMutationFn = ApolloMutationFunction<
  TransitionInstanceMutation,
  TransitionInstanceMutationVariables
>;

/**
 * __useTransitionInstanceMutation__
 *
 * To run a mutation, you first call `useTransitionInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionInstanceMutation, { data, loading, error }] = useTransitionInstanceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      workflowDefinitionId: // value for 'workflowDefinitionId'
 *      instanceId: // value for 'instanceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransitionInstanceMutation,
    TransitionInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TransitionInstanceMutation, TransitionInstanceMutationVariables>(
    TransitionInstanceDocument,
    options,
  );
}
export type TransitionInstanceMutationHookResult = ReturnType<typeof useTransitionInstanceMutation>;
export type TransitionInstanceMutationResult = Apollo.MutationResult<TransitionInstanceMutation>;
export type TransitionInstanceMutationOptions = ApolloBaseMutationOptions<
  TransitionInstanceMutation,
  TransitionInstanceMutationVariables
>;
export const CreateCeremonyTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCeremonyTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCeremonyTemplateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCeremonyTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfTemplateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ordering' } },
                { kind: 'Field', name: { kind: 'Name', value: 'padesProfile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiryHours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signingRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldY' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldWidth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldHeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appearanceReason' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateCeremonyTemplateMutationFn = ApolloMutationFunction<
  CreateCeremonyTemplateMutation,
  CreateCeremonyTemplateMutationVariables
>;

/**
 * __useCreateCeremonyTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCeremonyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCeremonyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCeremonyTemplateMutation, { data, loading, error }] = useCreateCeremonyTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCeremonyTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCeremonyTemplateMutation,
    CreateCeremonyTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCeremonyTemplateMutation,
    CreateCeremonyTemplateMutationVariables
  >(CreateCeremonyTemplateDocument, options);
}
export type CreateCeremonyTemplateMutationHookResult = ReturnType<
  typeof useCreateCeremonyTemplateMutation
>;
export type CreateCeremonyTemplateMutationResult =
  Apollo.MutationResult<CreateCeremonyTemplateMutation>;
export type CreateCeremonyTemplateMutationOptions = ApolloBaseMutationOptions<
  CreateCeremonyTemplateMutation,
  CreateCeremonyTemplateMutationVariables
>;
export const DeleteCeremonyTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCeremonyTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCeremonyTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteCeremonyTemplateMutationFn = ApolloMutationFunction<
  DeleteCeremonyTemplateMutation,
  DeleteCeremonyTemplateMutationVariables
>;

/**
 * __useDeleteCeremonyTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteCeremonyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCeremonyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCeremonyTemplateMutation, { data, loading, error }] = useDeleteCeremonyTemplateMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteCeremonyTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCeremonyTemplateMutation,
    DeleteCeremonyTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCeremonyTemplateMutation,
    DeleteCeremonyTemplateMutationVariables
  >(DeleteCeremonyTemplateDocument, options);
}
export type DeleteCeremonyTemplateMutationHookResult = ReturnType<
  typeof useDeleteCeremonyTemplateMutation
>;
export type DeleteCeremonyTemplateMutationResult =
  Apollo.MutationResult<DeleteCeremonyTemplateMutation>;
export type DeleteCeremonyTemplateMutationOptions = ApolloBaseMutationOptions<
  DeleteCeremonyTemplateMutation,
  DeleteCeremonyTemplateMutationVariables
>;
export const CreateCeremonyFromTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCeremonyFromTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCeremonyFromTemplateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCeremonyFromTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signingOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateCeremonyFromTemplateMutationFn = ApolloMutationFunction<
  CreateCeremonyFromTemplateMutation,
  CreateCeremonyFromTemplateMutationVariables
>;

/**
 * __useCreateCeremonyFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCeremonyFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCeremonyFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCeremonyFromTemplateMutation, { data, loading, error }] = useCreateCeremonyFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCeremonyFromTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCeremonyFromTemplateMutation,
    CreateCeremonyFromTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCeremonyFromTemplateMutation,
    CreateCeremonyFromTemplateMutationVariables
  >(CreateCeremonyFromTemplateDocument, options);
}
export type CreateCeremonyFromTemplateMutationHookResult = ReturnType<
  typeof useCreateCeremonyFromTemplateMutation
>;
export type CreateCeremonyFromTemplateMutationResult =
  Apollo.MutationResult<CreateCeremonyFromTemplateMutation>;
export type CreateCeremonyFromTemplateMutationOptions = ApolloBaseMutationOptions<
  CreateCeremonyFromTemplateMutation,
  CreateCeremonyFromTemplateMutationVariables
>;
export const RecordSignatureViaTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordSignatureViaToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecordSignatureViaTokenInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordSignatureViaToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordSignatureViaTokenMutationFn = ApolloMutationFunction<
  RecordSignatureViaTokenMutation,
  RecordSignatureViaTokenMutationVariables
>;

/**
 * __useRecordSignatureViaTokenMutation__
 *
 * To run a mutation, you first call `useRecordSignatureViaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSignatureViaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSignatureViaTokenMutation, { data, loading, error }] = useRecordSignatureViaTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordSignatureViaTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordSignatureViaTokenMutation,
    RecordSignatureViaTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordSignatureViaTokenMutation,
    RecordSignatureViaTokenMutationVariables
  >(RecordSignatureViaTokenDocument, options);
}
export type RecordSignatureViaTokenMutationHookResult = ReturnType<
  typeof useRecordSignatureViaTokenMutation
>;
export type RecordSignatureViaTokenMutationResult =
  Apollo.MutationResult<RecordSignatureViaTokenMutation>;
export type RecordSignatureViaTokenMutationOptions = ApolloBaseMutationOptions<
  RecordSignatureViaTokenMutation,
  RecordSignatureViaTokenMutationVariables
>;
export const VoidCeremonyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VoidCeremony' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'VoidCeremonyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voidCeremony' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voidReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type VoidCeremonyMutationFn = ApolloMutationFunction<
  VoidCeremonyMutation,
  VoidCeremonyMutationVariables
>;

/**
 * __useVoidCeremonyMutation__
 *
 * To run a mutation, you first call `useVoidCeremonyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidCeremonyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidCeremonyMutation, { data, loading, error }] = useVoidCeremonyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoidCeremonyMutation(
  baseOptions?: Apollo.MutationHookOptions<VoidCeremonyMutation, VoidCeremonyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VoidCeremonyMutation, VoidCeremonyMutationVariables>(
    VoidCeremonyDocument,
    options,
  );
}
export type VoidCeremonyMutationHookResult = ReturnType<typeof useVoidCeremonyMutation>;
export type VoidCeremonyMutationResult = Apollo.MutationResult<VoidCeremonyMutation>;
export type VoidCeremonyMutationOptions = ApolloBaseMutationOptions<
  VoidCeremonyMutation,
  VoidCeremonyMutationVariables
>;
export const ReassignCeremonyParticipantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReassignCeremonyParticipant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReassignCeremonyParticipantInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reassignCeremonyParticipant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReassignCeremonyParticipantMutationFn = ApolloMutationFunction<
  ReassignCeremonyParticipantMutation,
  ReassignCeremonyParticipantMutationVariables
>;

/**
 * __useReassignCeremonyParticipantMutation__
 *
 * To run a mutation, you first call `useReassignCeremonyParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignCeremonyParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignCeremonyParticipantMutation, { data, loading, error }] = useReassignCeremonyParticipantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignCeremonyParticipantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReassignCeremonyParticipantMutation,
    ReassignCeremonyParticipantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReassignCeremonyParticipantMutation,
    ReassignCeremonyParticipantMutationVariables
  >(ReassignCeremonyParticipantDocument, options);
}
export type ReassignCeremonyParticipantMutationHookResult = ReturnType<
  typeof useReassignCeremonyParticipantMutation
>;
export type ReassignCeremonyParticipantMutationResult =
  Apollo.MutationResult<ReassignCeremonyParticipantMutation>;
export type ReassignCeremonyParticipantMutationOptions = ApolloBaseMutationOptions<
  ReassignCeremonyParticipantMutation,
  ReassignCeremonyParticipantMutationVariables
>;
export const GenerateCeremonyEvidenceCertificateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateCeremonyEvidenceCertificate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateCeremonyEvidenceCertificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceremonyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidenceS3Key' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateCeremonyEvidenceCertificateMutationFn = ApolloMutationFunction<
  GenerateCeremonyEvidenceCertificateMutation,
  GenerateCeremonyEvidenceCertificateMutationVariables
>;

/**
 * __useGenerateCeremonyEvidenceCertificateMutation__
 *
 * To run a mutation, you first call `useGenerateCeremonyEvidenceCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCeremonyEvidenceCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCeremonyEvidenceCertificateMutation, { data, loading, error }] = useGenerateCeremonyEvidenceCertificateMutation({
 *   variables: {
 *      ceremonyId: // value for 'ceremonyId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGenerateCeremonyEvidenceCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateCeremonyEvidenceCertificateMutation,
    GenerateCeremonyEvidenceCertificateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateCeremonyEvidenceCertificateMutation,
    GenerateCeremonyEvidenceCertificateMutationVariables
  >(GenerateCeremonyEvidenceCertificateDocument, options);
}
export type GenerateCeremonyEvidenceCertificateMutationHookResult = ReturnType<
  typeof useGenerateCeremonyEvidenceCertificateMutation
>;
export type GenerateCeremonyEvidenceCertificateMutationResult =
  Apollo.MutationResult<GenerateCeremonyEvidenceCertificateMutation>;
export type GenerateCeremonyEvidenceCertificateMutationOptions = ApolloBaseMutationOptions<
  GenerateCeremonyEvidenceCertificateMutation,
  GenerateCeremonyEvidenceCertificateMutationVariables
>;
export const RegisterWebhookEndpointDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterWebhookEndpoint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterWebhookInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerWebhookEndpoint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'endpointId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'events' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RegisterWebhookEndpointMutationFn = ApolloMutationFunction<
  RegisterWebhookEndpointMutation,
  RegisterWebhookEndpointMutationVariables
>;

/**
 * __useRegisterWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useRegisterWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWebhookEndpointMutation, { data, loading, error }] = useRegisterWebhookEndpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterWebhookEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterWebhookEndpointMutation,
    RegisterWebhookEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterWebhookEndpointMutation,
    RegisterWebhookEndpointMutationVariables
  >(RegisterWebhookEndpointDocument, options);
}
export type RegisterWebhookEndpointMutationHookResult = ReturnType<
  typeof useRegisterWebhookEndpointMutation
>;
export type RegisterWebhookEndpointMutationResult =
  Apollo.MutationResult<RegisterWebhookEndpointMutation>;
export type RegisterWebhookEndpointMutationOptions = ApolloBaseMutationOptions<
  RegisterWebhookEndpointMutation,
  RegisterWebhookEndpointMutationVariables
>;
export const DeleteWebhookEndpointDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteWebhookEndpoint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endpointId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWebhookEndpoint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endpointId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endpointId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteWebhookEndpointMutationFn = ApolloMutationFunction<
  DeleteWebhookEndpointMutation,
  DeleteWebhookEndpointMutationVariables
>;

/**
 * __useDeleteWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookEndpointMutation, { data, loading, error }] = useDeleteWebhookEndpointMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      endpointId: // value for 'endpointId'
 *   },
 * });
 */
export function useDeleteWebhookEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWebhookEndpointMutation,
    DeleteWebhookEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>(
    DeleteWebhookEndpointDocument,
    options,
  );
}
export type DeleteWebhookEndpointMutationHookResult = ReturnType<
  typeof useDeleteWebhookEndpointMutation
>;
export type DeleteWebhookEndpointMutationResult =
  Apollo.MutationResult<DeleteWebhookEndpointMutation>;
export type DeleteWebhookEndpointMutationOptions = ApolloBaseMutationOptions<
  DeleteWebhookEndpointMutation,
  DeleteWebhookEndpointMutationVariables
>;
export const BatchCreateCeremonyFromTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BatchCreateCeremonyFromTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BatchCreateCeremonyFromTemplateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batchCreateCeremonyFromTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'created' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCreated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BatchCreateCeremonyFromTemplateMutationFn = ApolloMutationFunction<
  BatchCreateCeremonyFromTemplateMutation,
  BatchCreateCeremonyFromTemplateMutationVariables
>;

/**
 * __useBatchCreateCeremonyFromTemplateMutation__
 *
 * To run a mutation, you first call `useBatchCreateCeremonyFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateCeremonyFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateCeremonyFromTemplateMutation, { data, loading, error }] = useBatchCreateCeremonyFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateCeremonyFromTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchCreateCeremonyFromTemplateMutation,
    BatchCreateCeremonyFromTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BatchCreateCeremonyFromTemplateMutation,
    BatchCreateCeremonyFromTemplateMutationVariables
  >(BatchCreateCeremonyFromTemplateDocument, options);
}
export type BatchCreateCeremonyFromTemplateMutationHookResult = ReturnType<
  typeof useBatchCreateCeremonyFromTemplateMutation
>;
export type BatchCreateCeremonyFromTemplateMutationResult =
  Apollo.MutationResult<BatchCreateCeremonyFromTemplateMutation>;
export type BatchCreateCeremonyFromTemplateMutationOptions = ApolloBaseMutationOptions<
  BatchCreateCeremonyFromTemplateMutation,
  BatchCreateCeremonyFromTemplateMutationVariables
>;
export const SwitchTraversalModeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SwitchTraversalMode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlTraversalMode' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'switchTraversalMode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SwitchTraversalModeMutationFn = ApolloMutationFunction<
  SwitchTraversalModeMutation,
  SwitchTraversalModeMutationVariables
>;

/**
 * __useSwitchTraversalModeMutation__
 *
 * To run a mutation, you first call `useSwitchTraversalModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchTraversalModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchTraversalModeMutation, { data, loading, error }] = useSwitchTraversalModeMutation({
 *   variables: {
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useSwitchTraversalModeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwitchTraversalModeMutation,
    SwitchTraversalModeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwitchTraversalModeMutation, SwitchTraversalModeMutationVariables>(
    SwitchTraversalModeDocument,
    options,
  );
}
export type SwitchTraversalModeMutationHookResult = ReturnType<
  typeof useSwitchTraversalModeMutation
>;
export type SwitchTraversalModeMutationResult = Apollo.MutationResult<SwitchTraversalModeMutation>;
export type SwitchTraversalModeMutationOptions = ApolloBaseMutationOptions<
  SwitchTraversalModeMutation,
  SwitchTraversalModeMutationVariables
>;
export const SetFocusContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetFocusContext' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perspective' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFocusContext' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perspective' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perspective' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'perspective' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetFocusContextMutationFn = ApolloMutationFunction<
  SetFocusContextMutation,
  SetFocusContextMutationVariables
>;

/**
 * __useSetFocusContextMutation__
 *
 * To run a mutation, you first call `useSetFocusContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFocusContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFocusContextMutation, { data, loading, error }] = useSetFocusContextMutation({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *      perspective: // value for 'perspective'
 *   },
 * });
 */
export function useSetFocusContextMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetFocusContextMutation,
    SetFocusContextMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetFocusContextMutation, SetFocusContextMutationVariables>(
    SetFocusContextDocument,
    options,
  );
}
export type SetFocusContextMutationHookResult = ReturnType<typeof useSetFocusContextMutation>;
export type SetFocusContextMutationResult = Apollo.MutationResult<SetFocusContextMutation>;
export type SetFocusContextMutationOptions = ApolloBaseMutationOptions<
  SetFocusContextMutation,
  SetFocusContextMutationVariables
>;
export const ClearFocusContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ClearFocusContext' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'clearFocusContext' } }],
      },
    },
  ],
} as unknown as DocumentNode;
export type ClearFocusContextMutationFn = ApolloMutationFunction<
  ClearFocusContextMutation,
  ClearFocusContextMutationVariables
>;

/**
 * __useClearFocusContextMutation__
 *
 * To run a mutation, you first call `useClearFocusContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearFocusContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearFocusContextMutation, { data, loading, error }] = useClearFocusContextMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearFocusContextMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearFocusContextMutation,
    ClearFocusContextMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ClearFocusContextMutation, ClearFocusContextMutationVariables>(
    ClearFocusContextDocument,
    options,
  );
}
export type ClearFocusContextMutationHookResult = ReturnType<typeof useClearFocusContextMutation>;
export type ClearFocusContextMutationResult = Apollo.MutationResult<ClearFocusContextMutation>;
export type ClearFocusContextMutationOptions = ApolloBaseMutationOptions<
  ClearFocusContextMutation,
  ClearFocusContextMutationVariables
>;
export const GenerateWorkflowExecutionPdfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateWorkflowExecutionPdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateWorkflowSummaryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateWorkflowExecutionPdf' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateWorkflowExecutionPdfMutationFn = ApolloMutationFunction<
  GenerateWorkflowExecutionPdfMutation,
  GenerateWorkflowExecutionPdfMutationVariables
>;

/**
 * __useGenerateWorkflowExecutionPdfMutation__
 *
 * To run a mutation, you first call `useGenerateWorkflowExecutionPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorkflowExecutionPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorkflowExecutionPdfMutation, { data, loading, error }] = useGenerateWorkflowExecutionPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateWorkflowExecutionPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateWorkflowExecutionPdfMutation,
    GenerateWorkflowExecutionPdfMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateWorkflowExecutionPdfMutation,
    GenerateWorkflowExecutionPdfMutationVariables
  >(GenerateWorkflowExecutionPdfDocument, options);
}
export type GenerateWorkflowExecutionPdfMutationHookResult = ReturnType<
  typeof useGenerateWorkflowExecutionPdfMutation
>;
export type GenerateWorkflowExecutionPdfMutationResult =
  Apollo.MutationResult<GenerateWorkflowExecutionPdfMutation>;
export type GenerateWorkflowExecutionPdfMutationOptions = ApolloBaseMutationOptions<
  GenerateWorkflowExecutionPdfMutation,
  GenerateWorkflowExecutionPdfMutationVariables
>;
export const GenerateDailyTaskSheetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateDailyTaskSheet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateDailyTaskSheetInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateDailyTaskSheet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateDailyTaskSheetMutationFn = ApolloMutationFunction<
  GenerateDailyTaskSheetMutation,
  GenerateDailyTaskSheetMutationVariables
>;

/**
 * __useGenerateDailyTaskSheetMutation__
 *
 * To run a mutation, you first call `useGenerateDailyTaskSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDailyTaskSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDailyTaskSheetMutation, { data, loading, error }] = useGenerateDailyTaskSheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDailyTaskSheetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateDailyTaskSheetMutation,
    GenerateDailyTaskSheetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateDailyTaskSheetMutation,
    GenerateDailyTaskSheetMutationVariables
  >(GenerateDailyTaskSheetDocument, options);
}
export type GenerateDailyTaskSheetMutationHookResult = ReturnType<
  typeof useGenerateDailyTaskSheetMutation
>;
export type GenerateDailyTaskSheetMutationResult =
  Apollo.MutationResult<GenerateDailyTaskSheetMutation>;
export type GenerateDailyTaskSheetMutationOptions = ApolloBaseMutationOptions<
  GenerateDailyTaskSheetMutation,
  GenerateDailyTaskSheetMutationVariables
>;
export const GenerateRulesetComplianceReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateRulesetComplianceReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateRulesetReportInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateRulesetComplianceReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateRulesetComplianceReportMutationFn = ApolloMutationFunction<
  GenerateRulesetComplianceReportMutation,
  GenerateRulesetComplianceReportMutationVariables
>;

/**
 * __useGenerateRulesetComplianceReportMutation__
 *
 * To run a mutation, you first call `useGenerateRulesetComplianceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRulesetComplianceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRulesetComplianceReportMutation, { data, loading, error }] = useGenerateRulesetComplianceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateRulesetComplianceReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateRulesetComplianceReportMutation,
    GenerateRulesetComplianceReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateRulesetComplianceReportMutation,
    GenerateRulesetComplianceReportMutationVariables
  >(GenerateRulesetComplianceReportDocument, options);
}
export type GenerateRulesetComplianceReportMutationHookResult = ReturnType<
  typeof useGenerateRulesetComplianceReportMutation
>;
export type GenerateRulesetComplianceReportMutationResult =
  Apollo.MutationResult<GenerateRulesetComplianceReportMutation>;
export type GenerateRulesetComplianceReportMutationOptions = ApolloBaseMutationOptions<
  GenerateRulesetComplianceReportMutation,
  GenerateRulesetComplianceReportMutationVariables
>;
export const GenerateRulesetAcknowledgmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateRulesetAcknowledgment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateRulesetAcknowledgmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateRulesetAcknowledgment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateRulesetAcknowledgmentMutationFn = ApolloMutationFunction<
  GenerateRulesetAcknowledgmentMutation,
  GenerateRulesetAcknowledgmentMutationVariables
>;

/**
 * __useGenerateRulesetAcknowledgmentMutation__
 *
 * To run a mutation, you first call `useGenerateRulesetAcknowledgmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRulesetAcknowledgmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRulesetAcknowledgmentMutation, { data, loading, error }] = useGenerateRulesetAcknowledgmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateRulesetAcknowledgmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateRulesetAcknowledgmentMutation,
    GenerateRulesetAcknowledgmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateRulesetAcknowledgmentMutation,
    GenerateRulesetAcknowledgmentMutationVariables
  >(GenerateRulesetAcknowledgmentDocument, options);
}
export type GenerateRulesetAcknowledgmentMutationHookResult = ReturnType<
  typeof useGenerateRulesetAcknowledgmentMutation
>;
export type GenerateRulesetAcknowledgmentMutationResult =
  Apollo.MutationResult<GenerateRulesetAcknowledgmentMutation>;
export type GenerateRulesetAcknowledgmentMutationOptions = ApolloBaseMutationOptions<
  GenerateRulesetAcknowledgmentMutation,
  GenerateRulesetAcknowledgmentMutationVariables
>;
export const GenerateSubjectCareSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateSubjectCareSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateSubjectCareSummaryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateSubjectCareSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateSubjectCareSummaryMutationFn = ApolloMutationFunction<
  GenerateSubjectCareSummaryMutation,
  GenerateSubjectCareSummaryMutationVariables
>;

/**
 * __useGenerateSubjectCareSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateSubjectCareSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSubjectCareSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSubjectCareSummaryMutation, { data, loading, error }] = useGenerateSubjectCareSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSubjectCareSummaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateSubjectCareSummaryMutation,
    GenerateSubjectCareSummaryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateSubjectCareSummaryMutation,
    GenerateSubjectCareSummaryMutationVariables
  >(GenerateSubjectCareSummaryDocument, options);
}
export type GenerateSubjectCareSummaryMutationHookResult = ReturnType<
  typeof useGenerateSubjectCareSummaryMutation
>;
export type GenerateSubjectCareSummaryMutationResult =
  Apollo.MutationResult<GenerateSubjectCareSummaryMutation>;
export type GenerateSubjectCareSummaryMutationOptions = ApolloBaseMutationOptions<
  GenerateSubjectCareSummaryMutation,
  GenerateSubjectCareSummaryMutationVariables
>;
export const GenerateEpManualDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateEpManual' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateEpManual' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rulesetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'surveyForms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkpointsCovered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskGroups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateEpManualMutationFn = ApolloMutationFunction<
  GenerateEpManualMutation,
  GenerateEpManualMutationVariables
>;

/**
 * __useGenerateEpManualMutation__
 *
 * To run a mutation, you first call `useGenerateEpManualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEpManualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEpManualMutation, { data, loading, error }] = useGenerateEpManualMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      rulesetId: // value for 'rulesetId'
 *   },
 * });
 */
export function useGenerateEpManualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateEpManualMutation,
    GenerateEpManualMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateEpManualMutation, GenerateEpManualMutationVariables>(
    GenerateEpManualDocument,
    options,
  );
}
export type GenerateEpManualMutationHookResult = ReturnType<typeof useGenerateEpManualMutation>;
export type GenerateEpManualMutationResult = Apollo.MutationResult<GenerateEpManualMutation>;
export type GenerateEpManualMutationOptions = ApolloBaseMutationOptions<
  GenerateEpManualMutation,
  GenerateEpManualMutationVariables
>;
export const SubmitSettlementProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitSettlementProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SubmitSettlementProposalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitSettlementProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposerTenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'counterpartyTenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'periodStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'periodEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transactionCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposerReconciliationHash' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitSettlementProposalMutationFn = ApolloMutationFunction<
  SubmitSettlementProposalMutation,
  SubmitSettlementProposalMutationVariables
>;

/**
 * __useSubmitSettlementProposalMutation__
 *
 * To run a mutation, you first call `useSubmitSettlementProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSettlementProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSettlementProposalMutation, { data, loading, error }] = useSubmitSettlementProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSettlementProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitSettlementProposalMutation,
    SubmitSettlementProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitSettlementProposalMutation,
    SubmitSettlementProposalMutationVariables
  >(SubmitSettlementProposalDocument, options);
}
export type SubmitSettlementProposalMutationHookResult = ReturnType<
  typeof useSubmitSettlementProposalMutation
>;
export type SubmitSettlementProposalMutationResult =
  Apollo.MutationResult<SubmitSettlementProposalMutation>;
export type SubmitSettlementProposalMutationOptions = ApolloBaseMutationOptions<
  SubmitSettlementProposalMutation,
  SubmitSettlementProposalMutationVariables
>;
export const AcceptSettlementProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcceptSettlementProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AcceptSettlementProposalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptSettlementProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'counterpartyReconciliationHash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposerReconciliationHash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settledAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AcceptSettlementProposalMutationFn = ApolloMutationFunction<
  AcceptSettlementProposalMutation,
  AcceptSettlementProposalMutationVariables
>;

/**
 * __useAcceptSettlementProposalMutation__
 *
 * To run a mutation, you first call `useAcceptSettlementProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptSettlementProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptSettlementProposalMutation, { data, loading, error }] = useAcceptSettlementProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptSettlementProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptSettlementProposalMutation,
    AcceptSettlementProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptSettlementProposalMutation,
    AcceptSettlementProposalMutationVariables
  >(AcceptSettlementProposalDocument, options);
}
export type AcceptSettlementProposalMutationHookResult = ReturnType<
  typeof useAcceptSettlementProposalMutation
>;
export type AcceptSettlementProposalMutationResult =
  Apollo.MutationResult<AcceptSettlementProposalMutation>;
export type AcceptSettlementProposalMutationOptions = ApolloBaseMutationOptions<
  AcceptSettlementProposalMutation,
  AcceptSettlementProposalMutationVariables
>;
export const GenerateAuditReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateAuditReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateReportInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateAuditReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportFormat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateAuditReportMutationFn = ApolloMutationFunction<
  GenerateAuditReportMutation,
  GenerateAuditReportMutationVariables
>;

/**
 * __useGenerateAuditReportMutation__
 *
 * To run a mutation, you first call `useGenerateAuditReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuditReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAuditReportMutation, { data, loading, error }] = useGenerateAuditReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenantId: // value for 'tenantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAuditReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateAuditReportMutation,
    GenerateAuditReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateAuditReportMutation, GenerateAuditReportMutationVariables>(
    GenerateAuditReportDocument,
    options,
  );
}
export type GenerateAuditReportMutationHookResult = ReturnType<
  typeof useGenerateAuditReportMutation
>;
export type GenerateAuditReportMutationResult = Apollo.MutationResult<GenerateAuditReportMutation>;
export type GenerateAuditReportMutationOptions = ApolloBaseMutationOptions<
  GenerateAuditReportMutation,
  GenerateAuditReportMutationVariables
>;
export const VerifyWitnessRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyWitnessRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifyWitnessRequestInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyWitnessRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'request' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'witnessId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'witnessRole' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'completionToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type VerifyWitnessRequestMutationFn = ApolloMutationFunction<
  VerifyWitnessRequestMutation,
  VerifyWitnessRequestMutationVariables
>;

/**
 * __useVerifyWitnessRequestMutation__
 *
 * To run a mutation, you first call `useVerifyWitnessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyWitnessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyWitnessRequestMutation, { data, loading, error }] = useVerifyWitnessRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyWitnessRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyWitnessRequestMutation,
    VerifyWitnessRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyWitnessRequestMutation, VerifyWitnessRequestMutationVariables>(
    VerifyWitnessRequestDocument,
    options,
  );
}
export type VerifyWitnessRequestMutationHookResult = ReturnType<
  typeof useVerifyWitnessRequestMutation
>;
export type VerifyWitnessRequestMutationResult =
  Apollo.MutationResult<VerifyWitnessRequestMutation>;
export type VerifyWitnessRequestMutationOptions = ApolloBaseMutationOptions<
  VerifyWitnessRequestMutation,
  VerifyWitnessRequestMutationVariables
>;
export const CompleteWitnessRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteWitnessRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompleteWitnessRequestInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeWitnessRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteWitnessRequestMutationFn = ApolloMutationFunction<
  CompleteWitnessRequestMutation,
  CompleteWitnessRequestMutationVariables
>;

/**
 * __useCompleteWitnessRequestMutation__
 *
 * To run a mutation, you first call `useCompleteWitnessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteWitnessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeWitnessRequestMutation, { data, loading, error }] = useCompleteWitnessRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteWitnessRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteWitnessRequestMutation,
    CompleteWitnessRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteWitnessRequestMutation,
    CompleteWitnessRequestMutationVariables
  >(CompleteWitnessRequestDocument, options);
}
export type CompleteWitnessRequestMutationHookResult = ReturnType<
  typeof useCompleteWitnessRequestMutation
>;
export type CompleteWitnessRequestMutationResult =
  Apollo.MutationResult<CompleteWitnessRequestMutation>;
export type CompleteWitnessRequestMutationOptions = ApolloBaseMutationOptions<
  CompleteWitnessRequestMutation,
  CompleteWitnessRequestMutationVariables
>;
export const CancelWitnessRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelWitnessRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'requestId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelWitnessRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requestId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'requestId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelWitnessRequestMutationFn = ApolloMutationFunction<
  CancelWitnessRequestMutation,
  CancelWitnessRequestMutationVariables
>;

/**
 * __useCancelWitnessRequestMutation__
 *
 * To run a mutation, you first call `useCancelWitnessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWitnessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWitnessRequestMutation, { data, loading, error }] = useCancelWitnessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useCancelWitnessRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelWitnessRequestMutation,
    CancelWitnessRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelWitnessRequestMutation, CancelWitnessRequestMutationVariables>(
    CancelWitnessRequestDocument,
    options,
  );
}
export type CancelWitnessRequestMutationHookResult = ReturnType<
  typeof useCancelWitnessRequestMutation
>;
export type CancelWitnessRequestMutationResult =
  Apollo.MutationResult<CancelWitnessRequestMutation>;
export type CancelWitnessRequestMutationOptions = ApolloBaseMutationOptions<
  CancelWitnessRequestMutation,
  CancelWitnessRequestMutationVariables
>;
export const RejectWitnessRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RejectWitnessRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RejectWitnessRequestInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectWitnessRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RejectWitnessRequestMutationFn = ApolloMutationFunction<
  RejectWitnessRequestMutation,
  RejectWitnessRequestMutationVariables
>;

/**
 * __useRejectWitnessRequestMutation__
 *
 * To run a mutation, you first call `useRejectWitnessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectWitnessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectWitnessRequestMutation, { data, loading, error }] = useRejectWitnessRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectWitnessRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectWitnessRequestMutation,
    RejectWitnessRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RejectWitnessRequestMutation, RejectWitnessRequestMutationVariables>(
    RejectWitnessRequestDocument,
    options,
  );
}
export type RejectWitnessRequestMutationHookResult = ReturnType<
  typeof useRejectWitnessRequestMutation
>;
export type RejectWitnessRequestMutationResult =
  Apollo.MutationResult<RejectWitnessRequestMutation>;
export type RejectWitnessRequestMutationOptions = ApolloBaseMutationOptions<
  RejectWitnessRequestMutation,
  RejectWitnessRequestMutationVariables
>;
export const AttestProvisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AttestProvision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AttestProvisionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attestProvision' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AttestProvisionMutationFn = ApolloMutationFunction<
  AttestProvisionMutation,
  AttestProvisionMutationVariables
>;

/**
 * __useAttestProvisionMutation__
 *
 * To run a mutation, you first call `useAttestProvisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttestProvisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attestProvisionMutation, { data, loading, error }] = useAttestProvisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttestProvisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AttestProvisionMutation,
    AttestProvisionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AttestProvisionMutation, AttestProvisionMutationVariables>(
    AttestProvisionDocument,
    options,
  );
}
export type AttestProvisionMutationHookResult = ReturnType<typeof useAttestProvisionMutation>;
export type AttestProvisionMutationResult = Apollo.MutationResult<AttestProvisionMutation>;
export type AttestProvisionMutationOptions = ApolloBaseMutationOptions<
  AttestProvisionMutation,
  AttestProvisionMutationVariables
>;
export const RecordAdoptionDecisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordAdoptionDecision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AdoptionDecisionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordAdoptionDecision' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'practiceRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditEventId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordAdoptionDecisionMutationFn = ApolloMutationFunction<
  RecordAdoptionDecisionMutation,
  RecordAdoptionDecisionMutationVariables
>;

/**
 * __useRecordAdoptionDecisionMutation__
 *
 * To run a mutation, you first call `useRecordAdoptionDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordAdoptionDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordAdoptionDecisionMutation, { data, loading, error }] = useRecordAdoptionDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordAdoptionDecisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordAdoptionDecisionMutation,
    RecordAdoptionDecisionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordAdoptionDecisionMutation,
    RecordAdoptionDecisionMutationVariables
  >(RecordAdoptionDecisionDocument, options);
}
export type RecordAdoptionDecisionMutationHookResult = ReturnType<
  typeof useRecordAdoptionDecisionMutation
>;
export type RecordAdoptionDecisionMutationResult =
  Apollo.MutationResult<RecordAdoptionDecisionMutation>;
export type RecordAdoptionDecisionMutationOptions = ApolloBaseMutationOptions<
  RecordAdoptionDecisionMutation,
  RecordAdoptionDecisionMutationVariables
>;
export const CreateEntityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEntity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateEntityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEntity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateEntityMutationFn = ApolloMutationFunction<
  CreateEntityMutation,
  CreateEntityMutationVariables
>;

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEntityMutation, CreateEntityMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEntityMutation, CreateEntityMutationVariables>(
    CreateEntityDocument,
    options,
  );
}
export type CreateEntityMutationHookResult = ReturnType<typeof useCreateEntityMutation>;
export type CreateEntityMutationResult = Apollo.MutationResult<CreateEntityMutation>;
export type CreateEntityMutationOptions = ApolloBaseMutationOptions<
  CreateEntityMutation,
  CreateEntityMutationVariables
>;
export const VerifyLedgerChainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyLedgerChain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyLedgerChain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstInvalidAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headHash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'genesisHash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type VerifyLedgerChainMutationFn = ApolloMutationFunction<
  VerifyLedgerChainMutation,
  VerifyLedgerChainMutationVariables
>;

/**
 * __useVerifyLedgerChainMutation__
 *
 * To run a mutation, you first call `useVerifyLedgerChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyLedgerChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyLedgerChainMutation, { data, loading, error }] = useVerifyLedgerChainMutation({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useVerifyLedgerChainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyLedgerChainMutation,
    VerifyLedgerChainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyLedgerChainMutation, VerifyLedgerChainMutationVariables>(
    VerifyLedgerChainDocument,
    options,
  );
}
export type VerifyLedgerChainMutationHookResult = ReturnType<typeof useVerifyLedgerChainMutation>;
export type VerifyLedgerChainMutationResult = Apollo.MutationResult<VerifyLedgerChainMutation>;
export type VerifyLedgerChainMutationOptions = ApolloBaseMutationOptions<
  VerifyLedgerChainMutation,
  VerifyLedgerChainMutationVariables
>;
export const CreateEntityApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEntityApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateApprovalInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiCreateApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateEntityApprovalMutationFn = ApolloMutationFunction<
  CreateEntityApprovalMutation,
  CreateEntityApprovalMutationVariables
>;

/**
 * __useCreateEntityApprovalMutation__
 *
 * To run a mutation, you first call `useCreateEntityApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityApprovalMutation, { data, loading, error }] = useCreateEntityApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCreateEntityApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEntityApprovalMutation,
    CreateEntityApprovalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEntityApprovalMutation, CreateEntityApprovalMutationVariables>(
    CreateEntityApprovalDocument,
    options,
  );
}
export type CreateEntityApprovalMutationHookResult = ReturnType<
  typeof useCreateEntityApprovalMutation
>;
export type CreateEntityApprovalMutationResult =
  Apollo.MutationResult<CreateEntityApprovalMutation>;
export type CreateEntityApprovalMutationOptions = ApolloBaseMutationOptions<
  CreateEntityApprovalMutation,
  CreateEntityApprovalMutationVariables
>;
export const AnalyzePublicationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AnalyzePublication' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzePublicationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'analyzePublication' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draftCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'proposals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mappedTags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AnalyzePublicationMutationFn = ApolloMutationFunction<
  AnalyzePublicationMutation,
  AnalyzePublicationMutationVariables
>;

/**
 * __useAnalyzePublicationMutation__
 *
 * To run a mutation, you first call `useAnalyzePublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzePublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzePublicationMutation, { data, loading, error }] = useAnalyzePublicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyzePublicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnalyzePublicationMutation,
    AnalyzePublicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AnalyzePublicationMutation, AnalyzePublicationMutationVariables>(
    AnalyzePublicationDocument,
    options,
  );
}
export type AnalyzePublicationMutationHookResult = ReturnType<typeof useAnalyzePublicationMutation>;
export type AnalyzePublicationMutationResult = Apollo.MutationResult<AnalyzePublicationMutation>;
export type AnalyzePublicationMutationOptions = ApolloBaseMutationOptions<
  AnalyzePublicationMutation,
  AnalyzePublicationMutationVariables
>;
export const ExtractStatuteMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExtractStatuteMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ExtractStatuteMetadataInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extractStatuteMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'associationRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicationTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicationYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentText' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ExtractStatuteMetadataMutationFn = ApolloMutationFunction<
  ExtractStatuteMetadataMutation,
  ExtractStatuteMetadataMutationVariables
>;

/**
 * __useExtractStatuteMetadataMutation__
 *
 * To run a mutation, you first call `useExtractStatuteMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractStatuteMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractStatuteMetadataMutation, { data, loading, error }] = useExtractStatuteMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtractStatuteMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExtractStatuteMetadataMutation,
    ExtractStatuteMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExtractStatuteMetadataMutation,
    ExtractStatuteMetadataMutationVariables
  >(ExtractStatuteMetadataDocument, options);
}
export type ExtractStatuteMetadataMutationHookResult = ReturnType<
  typeof useExtractStatuteMetadataMutation
>;
export type ExtractStatuteMetadataMutationResult =
  Apollo.MutationResult<ExtractStatuteMetadataMutation>;
export type ExtractStatuteMetadataMutationOptions = ApolloBaseMutationOptions<
  ExtractStatuteMetadataMutation,
  ExtractStatuteMetadataMutationVariables
>;
export const GenerateProposalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateProposals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateProposalsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateConfigProposals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draftCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'proposals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'gapIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateProposalsMutationFn = ApolloMutationFunction<
  GenerateProposalsMutation,
  GenerateProposalsMutationVariables
>;

/**
 * __useGenerateProposalsMutation__
 *
 * To run a mutation, you first call `useGenerateProposalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProposalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProposalsMutation, { data, loading, error }] = useGenerateProposalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProposalsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateProposalsMutation,
    GenerateProposalsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateProposalsMutation, GenerateProposalsMutationVariables>(
    GenerateProposalsDocument,
    options,
  );
}
export type GenerateProposalsMutationHookResult = ReturnType<typeof useGenerateProposalsMutation>;
export type GenerateProposalsMutationResult = Apollo.MutationResult<GenerateProposalsMutation>;
export type GenerateProposalsMutationOptions = ApolloBaseMutationOptions<
  GenerateProposalsMutation,
  GenerateProposalsMutationVariables
>;
export const ApproveProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApproveProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApproveProposalInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveConfigProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'movedTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditEventId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApproveProposalMutationFn = ApolloMutationFunction<
  ApproveProposalMutation,
  ApproveProposalMutationVariables
>;

/**
 * __useApproveProposalMutation__
 *
 * To run a mutation, you first call `useApproveProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveProposalMutation, { data, loading, error }] = useApproveProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveProposalMutation,
    ApproveProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApproveProposalMutation, ApproveProposalMutationVariables>(
    ApproveProposalDocument,
    options,
  );
}
export type ApproveProposalMutationHookResult = ReturnType<typeof useApproveProposalMutation>;
export type ApproveProposalMutationResult = Apollo.MutationResult<ApproveProposalMutation>;
export type ApproveProposalMutationOptions = ApolloBaseMutationOptions<
  ApproveProposalMutation,
  ApproveProposalMutationVariables
>;
export const ExplainProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExplainProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExplainProposalInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'explainConfigProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'response' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ExplainProposalMutationFn = ApolloMutationFunction<
  ExplainProposalMutation,
  ExplainProposalMutationVariables
>;

/**
 * __useExplainProposalMutation__
 *
 * To run a mutation, you first call `useExplainProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExplainProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [explainProposalMutation, { data, loading, error }] = useExplainProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExplainProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExplainProposalMutation,
    ExplainProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExplainProposalMutation, ExplainProposalMutationVariables>(
    ExplainProposalDocument,
    options,
  );
}
export type ExplainProposalMutationHookResult = ReturnType<typeof useExplainProposalMutation>;
export type ExplainProposalMutationResult = Apollo.MutationResult<ExplainProposalMutation>;
export type ExplainProposalMutationOptions = ApolloBaseMutationOptions<
  ExplainProposalMutation,
  ExplainProposalMutationVariables
>;
export const FireEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FireEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiFireEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FireEventMutationFn = ApolloMutationFunction<
  FireEventMutation,
  FireEventMutationVariables
>;

/**
 * __useFireEventMutation__
 *
 * To run a mutation, you first call `useFireEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFireEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fireEventMutation, { data, loading, error }] = useFireEventMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      eventName: // value for 'eventName'
 *   },
 * });
 */
export function useFireEventMutation(
  baseOptions?: Apollo.MutationHookOptions<FireEventMutation, FireEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FireEventMutation, FireEventMutationVariables>(
    FireEventDocument,
    options,
  );
}
export type FireEventMutationHookResult = ReturnType<typeof useFireEventMutation>;
export type FireEventMutationResult = Apollo.MutationResult<FireEventMutation>;
export type FireEventMutationOptions = ApolloBaseMutationOptions<
  FireEventMutation,
  FireEventMutationVariables
>;
export const RequestDocumentDownloadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestDocumentDownloadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RequestDocumentDownloadUrlInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiRequestDocumentDownloadUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresInSeconds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestDocumentDownloadUrlMutationFn = ApolloMutationFunction<
  RequestDocumentDownloadUrlMutation,
  RequestDocumentDownloadUrlMutationVariables
>;

/**
 * __useRequestDocumentDownloadUrlMutation__
 *
 * To run a mutation, you first call `useRequestDocumentDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDocumentDownloadUrlMutation, { data, loading, error }] = useRequestDocumentDownloadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestDocumentDownloadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestDocumentDownloadUrlMutation,
    RequestDocumentDownloadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestDocumentDownloadUrlMutation,
    RequestDocumentDownloadUrlMutationVariables
  >(RequestDocumentDownloadUrlDocument, options);
}
export type RequestDocumentDownloadUrlMutationHookResult = ReturnType<
  typeof useRequestDocumentDownloadUrlMutation
>;
export type RequestDocumentDownloadUrlMutationResult =
  Apollo.MutationResult<RequestDocumentDownloadUrlMutation>;
export type RequestDocumentDownloadUrlMutationOptions = ApolloBaseMutationOptions<
  RequestDocumentDownloadUrlMutation,
  RequestDocumentDownloadUrlMutationVariables
>;
export const ActivateSystemTenantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateSystemTenant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateSystemTenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ActivateSystemTenantMutationFn = ApolloMutationFunction<
  ActivateSystemTenantMutation,
  ActivateSystemTenantMutationVariables
>;

/**
 * __useActivateSystemTenantMutation__
 *
 * To run a mutation, you first call `useActivateSystemTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSystemTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSystemTenantMutation, { data, loading, error }] = useActivateSystemTenantMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useActivateSystemTenantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateSystemTenantMutation,
    ActivateSystemTenantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateSystemTenantMutation, ActivateSystemTenantMutationVariables>(
    ActivateSystemTenantDocument,
    options,
  );
}
export type ActivateSystemTenantMutationHookResult = ReturnType<
  typeof useActivateSystemTenantMutation
>;
export type ActivateSystemTenantMutationResult =
  Apollo.MutationResult<ActivateSystemTenantMutation>;
export type ActivateSystemTenantMutationOptions = ApolloBaseMutationOptions<
  ActivateSystemTenantMutation,
  ActivateSystemTenantMutationVariables
>;
export const UpdateApprovalMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateApprovalMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlUpdateApprovalInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiUpdateApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateApprovalMetadataMutationFn = ApolloMutationFunction<
  UpdateApprovalMetadataMutation,
  UpdateApprovalMetadataMutationVariables
>;

/**
 * __useUpdateApprovalMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovalMetadataMutation, { data, loading, error }] = useUpdateApprovalMetadataMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalId: // value for 'approvalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApprovalMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateApprovalMetadataMutation,
    UpdateApprovalMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateApprovalMetadataMutation,
    UpdateApprovalMetadataMutationVariables
  >(UpdateApprovalMetadataDocument, options);
}
export type UpdateApprovalMetadataMutationHookResult = ReturnType<
  typeof useUpdateApprovalMetadataMutation
>;
export type UpdateApprovalMetadataMutationResult =
  Apollo.MutationResult<UpdateApprovalMetadataMutation>;
export type UpdateApprovalMetadataMutationOptions = ApolloBaseMutationOptions<
  UpdateApprovalMetadataMutation,
  UpdateApprovalMetadataMutationVariables
>;
export const TriggerChaosPipelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerChaosPipeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TriggerChaosPipelineInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerChaosPipeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'executionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'capabilitiesEvaluated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'capabilitiesMatched' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchedCapabilityIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalNodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedNodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failedNodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalDurationMs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TriggerChaosPipelineMutationFn = ApolloMutationFunction<
  TriggerChaosPipelineMutation,
  TriggerChaosPipelineMutationVariables
>;

/**
 * __useTriggerChaosPipelineMutation__
 *
 * To run a mutation, you first call `useTriggerChaosPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerChaosPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerChaosPipelineMutation, { data, loading, error }] = useTriggerChaosPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerChaosPipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerChaosPipelineMutation,
    TriggerChaosPipelineMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TriggerChaosPipelineMutation, TriggerChaosPipelineMutationVariables>(
    TriggerChaosPipelineDocument,
    options,
  );
}
export type TriggerChaosPipelineMutationHookResult = ReturnType<
  typeof useTriggerChaosPipelineMutation
>;
export type TriggerChaosPipelineMutationResult =
  Apollo.MutationResult<TriggerChaosPipelineMutation>;
export type TriggerChaosPipelineMutationOptions = ApolloBaseMutationOptions<
  TriggerChaosPipelineMutation,
  TriggerChaosPipelineMutationVariables
>;
export const AddScopeEdgeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddScopeEdge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddScopeEdgeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addScopeEdge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mutationKind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddScopeEdgeMutationFn = ApolloMutationFunction<
  AddScopeEdgeMutation,
  AddScopeEdgeMutationVariables
>;

/**
 * __useAddScopeEdgeMutation__
 *
 * To run a mutation, you first call `useAddScopeEdgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScopeEdgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScopeEdgeMutation, { data, loading, error }] = useAddScopeEdgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddScopeEdgeMutation(
  baseOptions?: Apollo.MutationHookOptions<AddScopeEdgeMutation, AddScopeEdgeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddScopeEdgeMutation, AddScopeEdgeMutationVariables>(
    AddScopeEdgeDocument,
    options,
  );
}
export type AddScopeEdgeMutationHookResult = ReturnType<typeof useAddScopeEdgeMutation>;
export type AddScopeEdgeMutationResult = Apollo.MutationResult<AddScopeEdgeMutation>;
export type AddScopeEdgeMutationOptions = ApolloBaseMutationOptions<
  AddScopeEdgeMutation,
  AddScopeEdgeMutationVariables
>;
export const RemoveScopeEdgeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveScopeEdge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RemoveScopeEdgeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeScopeEdge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mutationKind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveScopeEdgeMutationFn = ApolloMutationFunction<
  RemoveScopeEdgeMutation,
  RemoveScopeEdgeMutationVariables
>;

/**
 * __useRemoveScopeEdgeMutation__
 *
 * To run a mutation, you first call `useRemoveScopeEdgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScopeEdgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScopeEdgeMutation, { data, loading, error }] = useRemoveScopeEdgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveScopeEdgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveScopeEdgeMutation,
    RemoveScopeEdgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveScopeEdgeMutation, RemoveScopeEdgeMutationVariables>(
    RemoveScopeEdgeDocument,
    options,
  );
}
export type RemoveScopeEdgeMutationHookResult = ReturnType<typeof useRemoveScopeEdgeMutation>;
export type RemoveScopeEdgeMutationResult = Apollo.MutationResult<RemoveScopeEdgeMutation>;
export type RemoveScopeEdgeMutationOptions = ApolloBaseMutationOptions<
  RemoveScopeEdgeMutation,
  RemoveScopeEdgeMutationVariables
>;
export const PlanShiftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PlanShift' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'floorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shiftStart' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'durationHours' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'planShift' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'floorId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'floorId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shiftStart' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shiftStart' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'durationHours' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'durationHours' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shiftStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shiftEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignedStaffId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assistStaffId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'continuityScore' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffRoster' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PlanShiftMutationFn = ApolloMutationFunction<
  PlanShiftMutation,
  PlanShiftMutationVariables
>;

/**
 * __usePlanShiftMutation__
 *
 * To run a mutation, you first call `usePlanShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planShiftMutation, { data, loading, error }] = usePlanShiftMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      floorId: // value for 'floorId'
 *      shiftStart: // value for 'shiftStart'
 *      durationHours: // value for 'durationHours'
 *   },
 * });
 */
export function usePlanShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<PlanShiftMutation, PlanShiftMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PlanShiftMutation, PlanShiftMutationVariables>(
    PlanShiftDocument,
    options,
  );
}
export type PlanShiftMutationHookResult = ReturnType<typeof usePlanShiftMutation>;
export type PlanShiftMutationResult = Apollo.MutationResult<PlanShiftMutation>;
export type PlanShiftMutationOptions = ApolloBaseMutationOptions<
  PlanShiftMutation,
  PlanShiftMutationVariables
>;
export const ReplanShiftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReplanShift' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'triggerType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReplanTriggerType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replanShift' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'planId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'triggerType' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'triggerType' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'staffId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'staffId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subjectId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'reason' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shiftStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shiftEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'replanTrigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignedStaffId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assistStaffId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'continuityScore' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffRoster' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReplanShiftMutationFn = ApolloMutationFunction<
  ReplanShiftMutation,
  ReplanShiftMutationVariables
>;

/**
 * __useReplanShiftMutation__
 *
 * To run a mutation, you first call `useReplanShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplanShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replanShiftMutation, { data, loading, error }] = useReplanShiftMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      planId: // value for 'planId'
 *      triggerType: // value for 'triggerType'
 *      staffId: // value for 'staffId'
 *      subjectId: // value for 'subjectId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useReplanShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<ReplanShiftMutation, ReplanShiftMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReplanShiftMutation, ReplanShiftMutationVariables>(
    ReplanShiftDocument,
    options,
  );
}
export type ReplanShiftMutationHookResult = ReturnType<typeof useReplanShiftMutation>;
export type ReplanShiftMutationResult = Apollo.MutationResult<ReplanShiftMutation>;
export type ReplanShiftMutationOptions = ApolloBaseMutationOptions<
  ReplanShiftMutation,
  ReplanShiftMutationVariables
>;
export const CreateFhirStorageResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFhirStorageResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateFhirResourceGqlInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFhirStorageResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateFhirStorageResourceMutationFn = ApolloMutationFunction<
  CreateFhirStorageResourceMutation,
  CreateFhirStorageResourceMutationVariables
>;

/**
 * __useCreateFhirStorageResourceMutation__
 *
 * To run a mutation, you first call `useCreateFhirStorageResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFhirStorageResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFhirStorageResourceMutation, { data, loading, error }] = useCreateFhirStorageResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFhirStorageResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFhirStorageResourceMutation,
    CreateFhirStorageResourceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFhirStorageResourceMutation,
    CreateFhirStorageResourceMutationVariables
  >(CreateFhirStorageResourceDocument, options);
}
export type CreateFhirStorageResourceMutationHookResult = ReturnType<
  typeof useCreateFhirStorageResourceMutation
>;
export type CreateFhirStorageResourceMutationResult =
  Apollo.MutationResult<CreateFhirStorageResourceMutation>;
export type CreateFhirStorageResourceMutationOptions = ApolloBaseMutationOptions<
  CreateFhirStorageResourceMutation,
  CreateFhirStorageResourceMutationVariables
>;
export const UpdateFhirStorageResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFhirStorageResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateFhirResourceGqlInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFhirStorageResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateFhirStorageResourceMutationFn = ApolloMutationFunction<
  UpdateFhirStorageResourceMutation,
  UpdateFhirStorageResourceMutationVariables
>;

/**
 * __useUpdateFhirStorageResourceMutation__
 *
 * To run a mutation, you first call `useUpdateFhirStorageResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFhirStorageResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFhirStorageResourceMutation, { data, loading, error }] = useUpdateFhirStorageResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFhirStorageResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFhirStorageResourceMutation,
    UpdateFhirStorageResourceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFhirStorageResourceMutation,
    UpdateFhirStorageResourceMutationVariables
  >(UpdateFhirStorageResourceDocument, options);
}
export type UpdateFhirStorageResourceMutationHookResult = ReturnType<
  typeof useUpdateFhirStorageResourceMutation
>;
export type UpdateFhirStorageResourceMutationResult =
  Apollo.MutationResult<UpdateFhirStorageResourceMutation>;
export type UpdateFhirStorageResourceMutationOptions = ApolloBaseMutationOptions<
  UpdateFhirStorageResourceMutation,
  UpdateFhirStorageResourceMutationVariables
>;
export const CreateArchitectProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateArchitectProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateArchitectProposalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createArchitectProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateArchitectProposalMutationFn = ApolloMutationFunction<
  CreateArchitectProposalMutation,
  CreateArchitectProposalMutationVariables
>;

/**
 * __useCreateArchitectProposalMutation__
 *
 * To run a mutation, you first call `useCreateArchitectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArchitectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArchitectProposalMutation, { data, loading, error }] = useCreateArchitectProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArchitectProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateArchitectProposalMutation,
    CreateArchitectProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateArchitectProposalMutation,
    CreateArchitectProposalMutationVariables
  >(CreateArchitectProposalDocument, options);
}
export type CreateArchitectProposalMutationHookResult = ReturnType<
  typeof useCreateArchitectProposalMutation
>;
export type CreateArchitectProposalMutationResult =
  Apollo.MutationResult<CreateArchitectProposalMutation>;
export type CreateArchitectProposalMutationOptions = ApolloBaseMutationOptions<
  CreateArchitectProposalMutation,
  CreateArchitectProposalMutationVariables
>;
export const SubmitArchitectProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitArchitectProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitArchitectProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'proposalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simulation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warningCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitArchitectProposalMutationFn = ApolloMutationFunction<
  SubmitArchitectProposalMutation,
  SubmitArchitectProposalMutationVariables
>;

/**
 * __useSubmitArchitectProposalMutation__
 *
 * To run a mutation, you first call `useSubmitArchitectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitArchitectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitArchitectProposalMutation, { data, loading, error }] = useSubmitArchitectProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useSubmitArchitectProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitArchitectProposalMutation,
    SubmitArchitectProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitArchitectProposalMutation,
    SubmitArchitectProposalMutationVariables
  >(SubmitArchitectProposalDocument, options);
}
export type SubmitArchitectProposalMutationHookResult = ReturnType<
  typeof useSubmitArchitectProposalMutation
>;
export type SubmitArchitectProposalMutationResult =
  Apollo.MutationResult<SubmitArchitectProposalMutation>;
export type SubmitArchitectProposalMutationOptions = ApolloBaseMutationOptions<
  SubmitArchitectProposalMutation,
  SubmitArchitectProposalMutationVariables
>;
export const ReviewArchitectProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReviewArchitectProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewArchitectProposalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewArchitectProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReviewArchitectProposalMutationFn = ApolloMutationFunction<
  ReviewArchitectProposalMutation,
  ReviewArchitectProposalMutationVariables
>;

/**
 * __useReviewArchitectProposalMutation__
 *
 * To run a mutation, you first call `useReviewArchitectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewArchitectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewArchitectProposalMutation, { data, loading, error }] = useReviewArchitectProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewArchitectProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReviewArchitectProposalMutation,
    ReviewArchitectProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReviewArchitectProposalMutation,
    ReviewArchitectProposalMutationVariables
  >(ReviewArchitectProposalDocument, options);
}
export type ReviewArchitectProposalMutationHookResult = ReturnType<
  typeof useReviewArchitectProposalMutation
>;
export type ReviewArchitectProposalMutationResult =
  Apollo.MutationResult<ReviewArchitectProposalMutation>;
export type ReviewArchitectProposalMutationOptions = ApolloBaseMutationOptions<
  ReviewArchitectProposalMutation,
  ReviewArchitectProposalMutationVariables
>;
export const ActivateArchitectProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateArchitectProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateArchitectProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'proposalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ActivateArchitectProposalMutationFn = ApolloMutationFunction<
  ActivateArchitectProposalMutation,
  ActivateArchitectProposalMutationVariables
>;

/**
 * __useActivateArchitectProposalMutation__
 *
 * To run a mutation, you first call `useActivateArchitectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateArchitectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateArchitectProposalMutation, { data, loading, error }] = useActivateArchitectProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useActivateArchitectProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateArchitectProposalMutation,
    ActivateArchitectProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ActivateArchitectProposalMutation,
    ActivateArchitectProposalMutationVariables
  >(ActivateArchitectProposalDocument, options);
}
export type ActivateArchitectProposalMutationHookResult = ReturnType<
  typeof useActivateArchitectProposalMutation
>;
export type ActivateArchitectProposalMutationResult =
  Apollo.MutationResult<ActivateArchitectProposalMutation>;
export type ActivateArchitectProposalMutationOptions = ApolloBaseMutationOptions<
  ActivateArchitectProposalMutation,
  ActivateArchitectProposalMutationVariables
>;
export const CancelArchitectProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelArchitectProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelArchitectProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'proposalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelArchitectProposalMutationFn = ApolloMutationFunction<
  CancelArchitectProposalMutation,
  CancelArchitectProposalMutationVariables
>;

/**
 * __useCancelArchitectProposalMutation__
 *
 * To run a mutation, you first call `useCancelArchitectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelArchitectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelArchitectProposalMutation, { data, loading, error }] = useCancelArchitectProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCancelArchitectProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelArchitectProposalMutation,
    CancelArchitectProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelArchitectProposalMutation,
    CancelArchitectProposalMutationVariables
  >(CancelArchitectProposalDocument, options);
}
export type CancelArchitectProposalMutationHookResult = ReturnType<
  typeof useCancelArchitectProposalMutation
>;
export type CancelArchitectProposalMutationResult =
  Apollo.MutationResult<CancelArchitectProposalMutation>;
export type CancelArchitectProposalMutationOptions = ApolloBaseMutationOptions<
  CancelArchitectProposalMutation,
  CancelArchitectProposalMutationVariables
>;
export const AcknowledgeIntegrationAnomalyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcknowledgeIntegrationAnomaly' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'anomalyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'acknowledgedBy' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgeIntegrationAnomaly' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'anomalyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'anomalyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'acknowledgedBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'acknowledgedBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'anomalyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledged' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AcknowledgeIntegrationAnomalyMutationFn = ApolloMutationFunction<
  AcknowledgeIntegrationAnomalyMutation,
  AcknowledgeIntegrationAnomalyMutationVariables
>;

/**
 * __useAcknowledgeIntegrationAnomalyMutation__
 *
 * To run a mutation, you first call `useAcknowledgeIntegrationAnomalyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeIntegrationAnomalyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeIntegrationAnomalyMutation, { data, loading, error }] = useAcknowledgeIntegrationAnomalyMutation({
 *   variables: {
 *      anomalyId: // value for 'anomalyId'
 *      acknowledgedBy: // value for 'acknowledgedBy'
 *   },
 * });
 */
export function useAcknowledgeIntegrationAnomalyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcknowledgeIntegrationAnomalyMutation,
    AcknowledgeIntegrationAnomalyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcknowledgeIntegrationAnomalyMutation,
    AcknowledgeIntegrationAnomalyMutationVariables
  >(AcknowledgeIntegrationAnomalyDocument, options);
}
export type AcknowledgeIntegrationAnomalyMutationHookResult = ReturnType<
  typeof useAcknowledgeIntegrationAnomalyMutation
>;
export type AcknowledgeIntegrationAnomalyMutationResult =
  Apollo.MutationResult<AcknowledgeIntegrationAnomalyMutation>;
export type AcknowledgeIntegrationAnomalyMutationOptions = ApolloBaseMutationOptions<
  AcknowledgeIntegrationAnomalyMutation,
  AcknowledgeIntegrationAnomalyMutationVariables
>;
export const ResolveIntegrationAnomalyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResolveIntegrationAnomaly' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'anomalyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resolutionNotes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveIntegrationAnomaly' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'anomalyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'anomalyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resolutionNotes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resolutionNotes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'anomalyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolutionNotes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResolveIntegrationAnomalyMutationFn = ApolloMutationFunction<
  ResolveIntegrationAnomalyMutation,
  ResolveIntegrationAnomalyMutationVariables
>;

/**
 * __useResolveIntegrationAnomalyMutation__
 *
 * To run a mutation, you first call `useResolveIntegrationAnomalyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveIntegrationAnomalyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveIntegrationAnomalyMutation, { data, loading, error }] = useResolveIntegrationAnomalyMutation({
 *   variables: {
 *      anomalyId: // value for 'anomalyId'
 *      resolutionNotes: // value for 'resolutionNotes'
 *   },
 * });
 */
export function useResolveIntegrationAnomalyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResolveIntegrationAnomalyMutation,
    ResolveIntegrationAnomalyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResolveIntegrationAnomalyMutation,
    ResolveIntegrationAnomalyMutationVariables
  >(ResolveIntegrationAnomalyDocument, options);
}
export type ResolveIntegrationAnomalyMutationHookResult = ReturnType<
  typeof useResolveIntegrationAnomalyMutation
>;
export type ResolveIntegrationAnomalyMutationResult =
  Apollo.MutationResult<ResolveIntegrationAnomalyMutation>;
export type ResolveIntegrationAnomalyMutationOptions = ApolloBaseMutationOptions<
  ResolveIntegrationAnomalyMutation,
  ResolveIntegrationAnomalyMutationVariables
>;
export const BulkAcknowledgeAnomaliesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkAcknowledgeAnomalies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'anomalyIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'acknowledgedBy' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkAcknowledgeAnomalies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'anomalyIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'anomalyIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'acknowledgedBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'acknowledgedBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'anomalyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledged' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BulkAcknowledgeAnomaliesMutationFn = ApolloMutationFunction<
  BulkAcknowledgeAnomaliesMutation,
  BulkAcknowledgeAnomaliesMutationVariables
>;

/**
 * __useBulkAcknowledgeAnomaliesMutation__
 *
 * To run a mutation, you first call `useBulkAcknowledgeAnomaliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAcknowledgeAnomaliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAcknowledgeAnomaliesMutation, { data, loading, error }] = useBulkAcknowledgeAnomaliesMutation({
 *   variables: {
 *      anomalyIds: // value for 'anomalyIds'
 *      acknowledgedBy: // value for 'acknowledgedBy'
 *   },
 * });
 */
export function useBulkAcknowledgeAnomaliesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkAcknowledgeAnomaliesMutation,
    BulkAcknowledgeAnomaliesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkAcknowledgeAnomaliesMutation,
    BulkAcknowledgeAnomaliesMutationVariables
  >(BulkAcknowledgeAnomaliesDocument, options);
}
export type BulkAcknowledgeAnomaliesMutationHookResult = ReturnType<
  typeof useBulkAcknowledgeAnomaliesMutation
>;
export type BulkAcknowledgeAnomaliesMutationResult =
  Apollo.MutationResult<BulkAcknowledgeAnomaliesMutation>;
export type BulkAcknowledgeAnomaliesMutationOptions = ApolloBaseMutationOptions<
  BulkAcknowledgeAnomaliesMutation,
  BulkAcknowledgeAnomaliesMutationVariables
>;
export const BulkSendWorkerNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkSendWorkerNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workerIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notificationType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntegrationNotificationChannel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkSendWorkerNotifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workerIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workerIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notificationType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'notificationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BulkSendWorkerNotificationsMutationFn = ApolloMutationFunction<
  BulkSendWorkerNotificationsMutation,
  BulkSendWorkerNotificationsMutationVariables
>;

/**
 * __useBulkSendWorkerNotificationsMutation__
 *
 * To run a mutation, you first call `useBulkSendWorkerNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSendWorkerNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSendWorkerNotificationsMutation, { data, loading, error }] = useBulkSendWorkerNotificationsMutation({
 *   variables: {
 *      workerIds: // value for 'workerIds'
 *      notificationType: // value for 'notificationType'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useBulkSendWorkerNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkSendWorkerNotificationsMutation,
    BulkSendWorkerNotificationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkSendWorkerNotificationsMutation,
    BulkSendWorkerNotificationsMutationVariables
  >(BulkSendWorkerNotificationsDocument, options);
}
export type BulkSendWorkerNotificationsMutationHookResult = ReturnType<
  typeof useBulkSendWorkerNotificationsMutation
>;
export type BulkSendWorkerNotificationsMutationResult =
  Apollo.MutationResult<BulkSendWorkerNotificationsMutation>;
export type BulkSendWorkerNotificationsMutationOptions = ApolloBaseMutationOptions<
  BulkSendWorkerNotificationsMutation,
  BulkSendWorkerNotificationsMutationVariables
>;
export const RegisterPlatformCredentialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterPlatformCredentials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accountId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accountName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'username' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerPlatformCredentials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'accountId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'accountName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'username' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'username' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RegisterPlatformCredentialsMutationFn = ApolloMutationFunction<
  RegisterPlatformCredentialsMutation,
  RegisterPlatformCredentialsMutationVariables
>;

/**
 * __useRegisterPlatformCredentialsMutation__
 *
 * To run a mutation, you first call `useRegisterPlatformCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPlatformCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPlatformCredentialsMutation, { data, loading, error }] = useRegisterPlatformCredentialsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      platform: // value for 'platform'
 *      accountId: // value for 'accountId'
 *      accountName: // value for 'accountName'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRegisterPlatformCredentialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterPlatformCredentialsMutation,
    RegisterPlatformCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterPlatformCredentialsMutation,
    RegisterPlatformCredentialsMutationVariables
  >(RegisterPlatformCredentialsDocument, options);
}
export type RegisterPlatformCredentialsMutationHookResult = ReturnType<
  typeof useRegisterPlatformCredentialsMutation
>;
export type RegisterPlatformCredentialsMutationResult =
  Apollo.MutationResult<RegisterPlatformCredentialsMutation>;
export type RegisterPlatformCredentialsMutationOptions = ApolloBaseMutationOptions<
  RegisterPlatformCredentialsMutation,
  RegisterPlatformCredentialsMutationVariables
>;
export const TestPlatformCredentialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TestPlatformCredentials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'testPlatformCredentials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TestPlatformCredentialsMutationFn = ApolloMutationFunction<
  TestPlatformCredentialsMutation,
  TestPlatformCredentialsMutationVariables
>;

/**
 * __useTestPlatformCredentialsMutation__
 *
 * To run a mutation, you first call `useTestPlatformCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestPlatformCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testPlatformCredentialsMutation, { data, loading, error }] = useTestPlatformCredentialsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useTestPlatformCredentialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestPlatformCredentialsMutation,
    TestPlatformCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TestPlatformCredentialsMutation,
    TestPlatformCredentialsMutationVariables
  >(TestPlatformCredentialsDocument, options);
}
export type TestPlatformCredentialsMutationHookResult = ReturnType<
  typeof useTestPlatformCredentialsMutation
>;
export type TestPlatformCredentialsMutationResult =
  Apollo.MutationResult<TestPlatformCredentialsMutation>;
export type TestPlatformCredentialsMutationOptions = ApolloBaseMutationOptions<
  TestPlatformCredentialsMutation,
  TestPlatformCredentialsMutationVariables
>;
export const DismissDriftAlertDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DismissDriftAlert' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DismissAlertInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissDriftAlert' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DismissDriftAlertMutationFn = ApolloMutationFunction<
  DismissDriftAlertMutation,
  DismissDriftAlertMutationVariables
>;

/**
 * __useDismissDriftAlertMutation__
 *
 * To run a mutation, you first call `useDismissDriftAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissDriftAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissDriftAlertMutation, { data, loading, error }] = useDismissDriftAlertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissDriftAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissDriftAlertMutation,
    DismissDriftAlertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DismissDriftAlertMutation, DismissDriftAlertMutationVariables>(
    DismissDriftAlertDocument,
    options,
  );
}
export type DismissDriftAlertMutationHookResult = ReturnType<typeof useDismissDriftAlertMutation>;
export type DismissDriftAlertMutationResult = Apollo.MutationResult<DismissDriftAlertMutation>;
export type DismissDriftAlertMutationOptions = ApolloBaseMutationOptions<
  DismissDriftAlertMutation,
  DismissDriftAlertMutationVariables
>;
export const GenerateAdmissionPdfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateAdmissionPdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GenerateAdmissionPdfInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateAdmissionPdf' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateAdmissionPdfMutationFn = ApolloMutationFunction<
  GenerateAdmissionPdfMutation,
  GenerateAdmissionPdfMutationVariables
>;

/**
 * __useGenerateAdmissionPdfMutation__
 *
 * To run a mutation, you first call `useGenerateAdmissionPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAdmissionPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAdmissionPdfMutation, { data, loading, error }] = useGenerateAdmissionPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAdmissionPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateAdmissionPdfMutation,
    GenerateAdmissionPdfMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateAdmissionPdfMutation, GenerateAdmissionPdfMutationVariables>(
    GenerateAdmissionPdfDocument,
    options,
  );
}
export type GenerateAdmissionPdfMutationHookResult = ReturnType<
  typeof useGenerateAdmissionPdfMutation
>;
export type GenerateAdmissionPdfMutationResult =
  Apollo.MutationResult<GenerateAdmissionPdfMutation>;
export type GenerateAdmissionPdfMutationOptions = ApolloBaseMutationOptions<
  GenerateAdmissionPdfMutation,
  GenerateAdmissionPdfMutationVariables
>;
export const FinalizePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FinalizePlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'authorityActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizePlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'planId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'authorityActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'authorityActorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FinalizePlanMutationFn = ApolloMutationFunction<
  FinalizePlanMutation,
  FinalizePlanMutationVariables
>;

/**
 * __useFinalizePlanMutation__
 *
 * To run a mutation, you first call `useFinalizePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizePlanMutation, { data, loading, error }] = useFinalizePlanMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      authorityActorId: // value for 'authorityActorId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useFinalizePlanMutation(
  baseOptions?: Apollo.MutationHookOptions<FinalizePlanMutation, FinalizePlanMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FinalizePlanMutation, FinalizePlanMutationVariables>(
    FinalizePlanDocument,
    options,
  );
}
export type FinalizePlanMutationHookResult = ReturnType<typeof useFinalizePlanMutation>;
export type FinalizePlanMutationResult = Apollo.MutationResult<FinalizePlanMutation>;
export type FinalizePlanMutationOptions = ApolloBaseMutationOptions<
  FinalizePlanMutation,
  FinalizePlanMutationVariables
>;
export const SubmitPlanReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitPlanReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlanReviewInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitPlanReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextAction' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitPlanReviewMutationFn = ApolloMutationFunction<
  SubmitPlanReviewMutation,
  SubmitPlanReviewMutationVariables
>;

/**
 * __useSubmitPlanReviewMutation__
 *
 * To run a mutation, you first call `useSubmitPlanReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPlanReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPlanReviewMutation, { data, loading, error }] = useSubmitPlanReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPlanReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitPlanReviewMutation,
    SubmitPlanReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitPlanReviewMutation, SubmitPlanReviewMutationVariables>(
    SubmitPlanReviewDocument,
    options,
  );
}
export type SubmitPlanReviewMutationHookResult = ReturnType<typeof useSubmitPlanReviewMutation>;
export type SubmitPlanReviewMutationResult = Apollo.MutationResult<SubmitPlanReviewMutation>;
export type SubmitPlanReviewMutationOptions = ApolloBaseMutationOptions<
  SubmitPlanReviewMutation,
  SubmitPlanReviewMutationVariables
>;
export const SimulateScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SimulateScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulationScenario' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mockVariables' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simulateScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mockVariables' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mockVariables' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reachableStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTransitionsExplored' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uncertainTransitions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longestPathLength' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deadEndStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finalStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selfLoopStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unreachableStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'policyGaps' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'errorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'warnings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'warningType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tree' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stateName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visitCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRepeating' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'children' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'target' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'visitCount' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRepeating' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasUncertainGuards' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'actionsPlanned' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'actionType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sideEffectsSuppressed' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'wouldCreate' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'guardsEvaluated' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'guardName' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'guardType' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'explanation' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SimulateScenarioMutationFn = ApolloMutationFunction<
  SimulateScenarioMutation,
  SimulateScenarioMutationVariables
>;

/**
 * __useSimulateScenarioMutation__
 *
 * To run a mutation, you first call `useSimulateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateScenarioMutation, { data, loading, error }] = useSimulateScenarioMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      scenario: // value for 'scenario'
 *      mockVariables: // value for 'mockVariables'
 *   },
 * });
 */
export function useSimulateScenarioMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SimulateScenarioMutation,
    SimulateScenarioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SimulateScenarioMutation, SimulateScenarioMutationVariables>(
    SimulateScenarioDocument,
    options,
  );
}
export type SimulateScenarioMutationHookResult = ReturnType<typeof useSimulateScenarioMutation>;
export type SimulateScenarioMutationResult = Apollo.MutationResult<SimulateScenarioMutation>;
export type SimulateScenarioMutationOptions = ApolloBaseMutationOptions<
  SimulateScenarioMutation,
  SimulateScenarioMutationVariables
>;
export const StartSimulationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartSimulation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'StartSimulationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startSimulation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stepCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartSimulationMutationFn = ApolloMutationFunction<
  StartSimulationMutation,
  StartSimulationMutationVariables
>;

/**
 * __useStartSimulationMutation__
 *
 * To run a mutation, you first call `useStartSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSimulationMutation, { data, loading, error }] = useStartSimulationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSimulationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartSimulationMutation,
    StartSimulationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartSimulationMutation, StartSimulationMutationVariables>(
    StartSimulationDocument,
    options,
  );
}
export type StartSimulationMutationHookResult = ReturnType<typeof useStartSimulationMutation>;
export type StartSimulationMutationResult = Apollo.MutationResult<StartSimulationMutation>;
export type StartSimulationMutationOptions = ApolloBaseMutationOptions<
  StartSimulationMutation,
  StartSimulationMutationVariables
>;
export const SimulateEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SimulateEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'event' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simulateEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'event' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'event' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availableEvents' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasUncertainGuards' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actionsPlanned' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sideEffectsSuppressed' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'wouldCreate' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guardsEvaluated' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'guardName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'explanation' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SimulateEventMutationFn = ApolloMutationFunction<
  SimulateEventMutation,
  SimulateEventMutationVariables
>;

/**
 * __useSimulateEventMutation__
 *
 * To run a mutation, you first call `useSimulateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateEventMutation, { data, loading, error }] = useSimulateEventMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useSimulateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<SimulateEventMutation, SimulateEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SimulateEventMutation, SimulateEventMutationVariables>(
    SimulateEventDocument,
    options,
  );
}
export type SimulateEventMutationHookResult = ReturnType<typeof useSimulateEventMutation>;
export type SimulateEventMutationResult = Apollo.MutationResult<SimulateEventMutation>;
export type SimulateEventMutationOptions = ApolloBaseMutationOptions<
  SimulateEventMutation,
  SimulateEventMutationVariables
>;
export const AssessWorkflowCriticalityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssessWorkflowCriticality' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowExecution' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkflowExecutionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessWorkflowCriticality' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowExecution' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowExecution' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'canExecute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticalityLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresLock' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lockType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'violations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deduplicationFingerprint' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canRunOffline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offlineRisks' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AssessWorkflowCriticalityMutationFn = ApolloMutationFunction<
  AssessWorkflowCriticalityMutation,
  AssessWorkflowCriticalityMutationVariables
>;

/**
 * __useAssessWorkflowCriticalityMutation__
 *
 * To run a mutation, you first call `useAssessWorkflowCriticalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssessWorkflowCriticalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assessWorkflowCriticalityMutation, { data, loading, error }] = useAssessWorkflowCriticalityMutation({
 *   variables: {
 *      workflowExecution: // value for 'workflowExecution'
 *   },
 * });
 */
export function useAssessWorkflowCriticalityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssessWorkflowCriticalityMutation,
    AssessWorkflowCriticalityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssessWorkflowCriticalityMutation,
    AssessWorkflowCriticalityMutationVariables
  >(AssessWorkflowCriticalityDocument, options);
}
export type AssessWorkflowCriticalityMutationHookResult = ReturnType<
  typeof useAssessWorkflowCriticalityMutation
>;
export type AssessWorkflowCriticalityMutationResult =
  Apollo.MutationResult<AssessWorkflowCriticalityMutation>;
export type AssessWorkflowCriticalityMutationOptions = ApolloBaseMutationOptions<
  AssessWorkflowCriticalityMutation,
  AssessWorkflowCriticalityMutationVariables
>;
export const ValidateWorkflowPreflightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ValidateWorkflowPreflight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkflowPreflightInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateWorkflowPreflight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canActivate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'blockingIssues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fix' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warnings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fix' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dependencyReport' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dependencyType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'refId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'existsInYaml' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seededToDdb' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'handlerImplemented' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simulationReport' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'unreachableStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deadEnds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unwiredPolicies' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selfLoopStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalStates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reachableStates' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dimensionCoverage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dimension' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resolvable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resolutionPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'missingField' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ValidateWorkflowPreflightMutationFn = ApolloMutationFunction<
  ValidateWorkflowPreflightMutation,
  ValidateWorkflowPreflightMutationVariables
>;

/**
 * __useValidateWorkflowPreflightMutation__
 *
 * To run a mutation, you first call `useValidateWorkflowPreflightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateWorkflowPreflightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateWorkflowPreflightMutation, { data, loading, error }] = useValidateWorkflowPreflightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateWorkflowPreflightMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateWorkflowPreflightMutation,
    ValidateWorkflowPreflightMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateWorkflowPreflightMutation,
    ValidateWorkflowPreflightMutationVariables
  >(ValidateWorkflowPreflightDocument, options);
}
export type ValidateWorkflowPreflightMutationHookResult = ReturnType<
  typeof useValidateWorkflowPreflightMutation
>;
export type ValidateWorkflowPreflightMutationResult =
  Apollo.MutationResult<ValidateWorkflowPreflightMutation>;
export type ValidateWorkflowPreflightMutationOptions = ApolloBaseMutationOptions<
  ValidateWorkflowPreflightMutation,
  ValidateWorkflowPreflightMutationVariables
>;
export const ActivateProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'activatedBy' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'activatedBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'activatedBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastStatusChange' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesetCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowCount' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coverageGaps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mandatoryResourceGaps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statuteRequirement' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesetRef' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ActivateProductMutationFn = ApolloMutationFunction<
  ActivateProductMutation,
  ActivateProductMutationVariables
>;

/**
 * __useActivateProductMutation__
 *
 * To run a mutation, you first call `useActivateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProductMutation, { data, loading, error }] = useActivateProductMutation({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      productId: // value for 'productId'
 *      activatedBy: // value for 'activatedBy'
 *   },
 * });
 */
export function useActivateProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateProductMutation,
    ActivateProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateProductMutation, ActivateProductMutationVariables>(
    ActivateProductDocument,
    options,
  );
}
export type ActivateProductMutationHookResult = ReturnType<typeof useActivateProductMutation>;
export type ActivateProductMutationResult = Apollo.MutationResult<ActivateProductMutation>;
export type ActivateProductMutationOptions = ApolloBaseMutationOptions<
  ActivateProductMutation,
  ActivateProductMutationVariables
>;
export const UpdateProductStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProductStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'newStatus' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductProvisioningStatus' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProductStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'newStatus' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastStatusChange' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateProductStatusMutationFn = ApolloMutationFunction<
  UpdateProductStatusMutation,
  UpdateProductStatusMutationVariables
>;

/**
 * __useUpdateProductStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStatusMutation, { data, loading, error }] = useUpdateProductStatusMutation({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      productId: // value for 'productId'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateProductStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProductStatusMutation,
    UpdateProductStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>(
    UpdateProductStatusDocument,
    options,
  );
}
export type UpdateProductStatusMutationHookResult = ReturnType<
  typeof useUpdateProductStatusMutation
>;
export type UpdateProductStatusMutationResult = Apollo.MutationResult<UpdateProductStatusMutation>;
export type UpdateProductStatusMutationOptions = ApolloBaseMutationOptions<
  UpdateProductStatusMutation,
  UpdateProductStatusMutationVariables
>;
export const DeactivateProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastStatusChange' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeactivateProductMutationFn = ApolloMutationFunction<
  DeactivateProductMutation,
  DeactivateProductMutationVariables
>;

/**
 * __useDeactivateProductMutation__
 *
 * To run a mutation, you first call `useDeactivateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateProductMutation, { data, loading, error }] = useDeactivateProductMutation({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDeactivateProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateProductMutation,
    DeactivateProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeactivateProductMutation, DeactivateProductMutationVariables>(
    DeactivateProductDocument,
    options,
  );
}
export type DeactivateProductMutationHookResult = ReturnType<typeof useDeactivateProductMutation>;
export type DeactivateProductMutationResult = Apollo.MutationResult<DeactivateProductMutation>;
export type DeactivateProductMutationOptions = ApolloBaseMutationOptions<
  DeactivateProductMutation,
  DeactivateProductMutationVariables
>;
export const EnrollActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnrollActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'initialData' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'initialData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'initialData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTaskId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EnrollActorMutationFn = ApolloMutationFunction<
  EnrollActorMutation,
  EnrollActorMutationVariables
>;

/**
 * __useEnrollActorMutation__
 *
 * To run a mutation, you first call `useEnrollActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollActorMutation, { data, loading, error }] = useEnrollActorMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      initialData: // value for 'initialData'
 *   },
 * });
 */
export function useEnrollActorMutation(
  baseOptions?: Apollo.MutationHookOptions<EnrollActorMutation, EnrollActorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EnrollActorMutation, EnrollActorMutationVariables>(
    EnrollActorDocument,
    options,
  );
}
export type EnrollActorMutationHookResult = ReturnType<typeof useEnrollActorMutation>;
export type EnrollActorMutationResult = Apollo.MutationResult<EnrollActorMutation>;
export type EnrollActorMutationOptions = ApolloBaseMutationOptions<
  EnrollActorMutation,
  EnrollActorMutationVariables
>;
export const FoodServiceCreateOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FoodServiceCreateOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaTargetMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deliveryAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FoodServiceCreateOrderMutationFn = ApolloMutationFunction<
  FoodServiceCreateOrderMutation,
  FoodServiceCreateOrderMutationVariables
>;

/**
 * __useFoodServiceCreateOrderMutation__
 *
 * To run a mutation, you first call `useFoodServiceCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [foodServiceCreateOrderMutation, { data, loading, error }] = useFoodServiceCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFoodServiceCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FoodServiceCreateOrderMutation,
    FoodServiceCreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FoodServiceCreateOrderMutation,
    FoodServiceCreateOrderMutationVariables
  >(FoodServiceCreateOrderDocument, options);
}
export type FoodServiceCreateOrderMutationHookResult = ReturnType<
  typeof useFoodServiceCreateOrderMutation
>;
export type FoodServiceCreateOrderMutationResult =
  Apollo.MutationResult<FoodServiceCreateOrderMutation>;
export type FoodServiceCreateOrderMutationOptions = ApolloBaseMutationOptions<
  FoodServiceCreateOrderMutation,
  FoodServiceCreateOrderMutationVariables
>;
export const MyTasksForActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyTasksForActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkStatus' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkItemFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkItemFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'detailSk' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyTasksForActorQuery__
 *
 * To run a query within a React component, call `useMyTasksForActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksForActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksForActorQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      actorId: // value for 'actorId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useMyTasksForActorQuery(
  baseOptions: Apollo.QueryHookOptions<MyTasksForActorQuery, MyTasksForActorQueryVariables> &
    ({ variables: MyTasksForActorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyTasksForActorQuery, MyTasksForActorQueryVariables>(
    MyTasksForActorDocument,
    options,
  );
}
export function useMyTasksForActorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyTasksForActorQuery, MyTasksForActorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyTasksForActorQuery, MyTasksForActorQueryVariables>(
    MyTasksForActorDocument,
    options,
  );
}
// @ts-ignore
export function useMyTasksForActorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyTasksForActorQuery,
    MyTasksForActorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyTasksForActorQuery, MyTasksForActorQueryVariables>;
export function useMyTasksForActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyTasksForActorQuery, MyTasksForActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyTasksForActorQuery | undefined, MyTasksForActorQueryVariables>;
export function useMyTasksForActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyTasksForActorQuery, MyTasksForActorQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyTasksForActorQuery, MyTasksForActorQueryVariables>(
    MyTasksForActorDocument,
    options,
  );
}
export type MyTasksForActorQueryHookResult = ReturnType<typeof useMyTasksForActorQuery>;
export type MyTasksForActorLazyQueryHookResult = ReturnType<typeof useMyTasksForActorLazyQuery>;
export type MyTasksForActorSuspenseQueryHookResult = ReturnType<
  typeof useMyTasksForActorSuspenseQuery
>;
export type MyTasksForActorQueryResult = Apollo.QueryResult<
  MyTasksForActorQuery,
  MyTasksForActorQueryVariables
>;
export const GetTeamByCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeamByCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTeamByCodeQuery__
 *
 * To run a query within a React component, call `useGetTeamByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetTeamByCodeQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamByCodeQuery, GetTeamByCodeQueryVariables> &
    ({ variables: GetTeamByCodeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>(
    GetTeamByCodeDocument,
    options,
  );
}
export function useGetTeamByCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>(
    GetTeamByCodeDocument,
    options,
  );
}
// @ts-ignore
export function useGetTeamByCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>;
export function useGetTeamByCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTeamByCodeQuery | undefined, GetTeamByCodeQueryVariables>;
export function useGetTeamByCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTeamByCodeQuery, GetTeamByCodeQueryVariables>(
    GetTeamByCodeDocument,
    options,
  );
}
export type GetTeamByCodeQueryHookResult = ReturnType<typeof useGetTeamByCodeQuery>;
export type GetTeamByCodeLazyQueryHookResult = ReturnType<typeof useGetTeamByCodeLazyQuery>;
export type GetTeamByCodeSuspenseQueryHookResult = ReturnType<typeof useGetTeamByCodeSuspenseQuery>;
export type GetTeamByCodeQueryResult = Apollo.QueryResult<
  GetTeamByCodeQuery,
  GetTeamByCodeQueryVariables
>;
export const ListTeamsByTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTeamsByType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlTeamType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listTeamsByType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'teamType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTeamsByTypeQuery__
 *
 * To run a query within a React component, call `useListTeamsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsByTypeQuery({
 *   variables: {
 *      teamType: // value for 'teamType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListTeamsByTypeQuery(
  baseOptions: Apollo.QueryHookOptions<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables> &
    ({ variables: ListTeamsByTypeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables>(
    ListTeamsByTypeDocument,
    options,
  );
}
export function useListTeamsByTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables>(
    ListTeamsByTypeDocument,
    options,
  );
}
// @ts-ignore
export function useListTeamsByTypeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTeamsByTypeQuery,
    ListTeamsByTypeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables>;
export function useListTeamsByTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTeamsByTypeQuery | undefined, ListTeamsByTypeQueryVariables>;
export function useListTeamsByTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTeamsByTypeQuery, ListTeamsByTypeQueryVariables>(
    ListTeamsByTypeDocument,
    options,
  );
}
export type ListTeamsByTypeQueryHookResult = ReturnType<typeof useListTeamsByTypeQuery>;
export type ListTeamsByTypeLazyQueryHookResult = ReturnType<typeof useListTeamsByTypeLazyQuery>;
export type ListTeamsByTypeSuspenseQueryHookResult = ReturnType<
  typeof useListTeamsByTypeSuspenseQuery
>;
export type ListTeamsByTypeQueryResult = Apollo.QueryResult<
  ListTeamsByTypeQuery,
  ListTeamsByTypeQueryVariables
>;
export const ListChildTeamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListChildTeams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listChildTeams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'parentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListChildTeamsQuery__
 *
 * To run a query within a React component, call `useListChildTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChildTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChildTeamsQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListChildTeamsQuery(
  baseOptions: Apollo.QueryHookOptions<ListChildTeamsQuery, ListChildTeamsQueryVariables> &
    ({ variables: ListChildTeamsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListChildTeamsQuery, ListChildTeamsQueryVariables>(
    ListChildTeamsDocument,
    options,
  );
}
export function useListChildTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListChildTeamsQuery, ListChildTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListChildTeamsQuery, ListChildTeamsQueryVariables>(
    ListChildTeamsDocument,
    options,
  );
}
// @ts-ignore
export function useListChildTeamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListChildTeamsQuery, ListChildTeamsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListChildTeamsQuery, ListChildTeamsQueryVariables>;
export function useListChildTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListChildTeamsQuery, ListChildTeamsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListChildTeamsQuery | undefined, ListChildTeamsQueryVariables>;
export function useListChildTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListChildTeamsQuery, ListChildTeamsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListChildTeamsQuery, ListChildTeamsQueryVariables>(
    ListChildTeamsDocument,
    options,
  );
}
export type ListChildTeamsQueryHookResult = ReturnType<typeof useListChildTeamsQuery>;
export type ListChildTeamsLazyQueryHookResult = ReturnType<typeof useListChildTeamsLazyQuery>;
export type ListChildTeamsSuspenseQueryHookResult = ReturnType<
  typeof useListChildTeamsSuspenseQuery
>;
export type ListChildTeamsQueryResult = Apollo.QueryResult<
  ListChildTeamsQuery,
  ListChildTeamsQueryVariables
>;
export const GetTeamHierarchyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeamHierarchy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTeamHierarchy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTeamHierarchyQuery__
 *
 * To run a query within a React component, call `useGetTeamHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamHierarchyQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetTeamHierarchyQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables> &
    ({ variables: GetTeamHierarchyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>(
    GetTeamHierarchyDocument,
    options,
  );
}
export function useGetTeamHierarchyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>(
    GetTeamHierarchyDocument,
    options,
  );
}
// @ts-ignore
export function useGetTeamHierarchySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamHierarchyQuery,
    GetTeamHierarchyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>;
export function useGetTeamHierarchySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTeamHierarchyQuery | undefined, GetTeamHierarchyQueryVariables>;
export function useGetTeamHierarchySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>(
    GetTeamHierarchyDocument,
    options,
  );
}
export type GetTeamHierarchyQueryHookResult = ReturnType<typeof useGetTeamHierarchyQuery>;
export type GetTeamHierarchyLazyQueryHookResult = ReturnType<typeof useGetTeamHierarchyLazyQuery>;
export type GetTeamHierarchySuspenseQueryHookResult = ReturnType<
  typeof useGetTeamHierarchySuspenseQuery
>;
export type GetTeamHierarchyQueryResult = Apollo.QueryResult<
  GetTeamHierarchyQuery,
  GetTeamHierarchyQueryVariables
>;
export const ListActiveTeamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListActiveTeams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listActiveTeams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListActiveTeamsQuery__
 *
 * To run a query within a React component, call `useListActiveTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveTeamsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListActiveTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>(
    ListActiveTeamsDocument,
    options,
  );
}
export function useListActiveTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>(
    ListActiveTeamsDocument,
    options,
  );
}
// @ts-ignore
export function useListActiveTeamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActiveTeamsQuery,
    ListActiveTeamsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>;
export function useListActiveTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListActiveTeamsQuery | undefined, ListActiveTeamsQueryVariables>;
export function useListActiveTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListActiveTeamsQuery, ListActiveTeamsQueryVariables>(
    ListActiveTeamsDocument,
    options,
  );
}
export type ListActiveTeamsQueryHookResult = ReturnType<typeof useListActiveTeamsQuery>;
export type ListActiveTeamsLazyQueryHookResult = ReturnType<typeof useListActiveTeamsLazyQuery>;
export type ListActiveTeamsSuspenseQueryHookResult = ReturnType<
  typeof useListActiveTeamsSuspenseQuery
>;
export type ListActiveTeamsQueryResult = Apollo.QueryResult<
  ListActiveTeamsQuery,
  ListActiveTeamsQueryVariables
>;
export const GetAvailableActorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAvailableActors' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAvailableActors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAvailableActorsQuery__
 *
 * To run a query within a React component, call `useGetAvailableActorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableActorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableActorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableActorsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAvailableActorsQuery, GetAvailableActorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAvailableActorsQuery, GetAvailableActorsQueryVariables>(
    GetAvailableActorsDocument,
    options,
  );
}
export function useGetAvailableActorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableActorsQuery,
    GetAvailableActorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAvailableActorsQuery, GetAvailableActorsQueryVariables>(
    GetAvailableActorsDocument,
    options,
  );
}
// @ts-ignore
export function useGetAvailableActorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableActorsQuery,
    GetAvailableActorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAvailableActorsQuery, GetAvailableActorsQueryVariables>;
export function useGetAvailableActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAvailableActorsQuery, GetAvailableActorsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetAvailableActorsQuery | undefined,
  GetAvailableActorsQueryVariables
>;
export function useGetAvailableActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAvailableActorsQuery, GetAvailableActorsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAvailableActorsQuery, GetAvailableActorsQueryVariables>(
    GetAvailableActorsDocument,
    options,
  );
}
export type GetAvailableActorsQueryHookResult = ReturnType<typeof useGetAvailableActorsQuery>;
export type GetAvailableActorsLazyQueryHookResult = ReturnType<
  typeof useGetAvailableActorsLazyQuery
>;
export type GetAvailableActorsSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableActorsSuspenseQuery
>;
export type GetAvailableActorsQueryResult = Apollo.QueryResult<
  GetAvailableActorsQuery,
  GetAvailableActorsQueryVariables
>;
export const GetLeastLoadedActorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLeastLoadedActors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLeastLoadedActors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLeastLoadedActorsQuery__
 *
 * To run a query within a React component, call `useGetLeastLoadedActorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeastLoadedActorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeastLoadedActorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLeastLoadedActorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLeastLoadedActorsQuery,
    GetLeastLoadedActorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLeastLoadedActorsQuery, GetLeastLoadedActorsQueryVariables>(
    GetLeastLoadedActorsDocument,
    options,
  );
}
export function useGetLeastLoadedActorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLeastLoadedActorsQuery,
    GetLeastLoadedActorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLeastLoadedActorsQuery, GetLeastLoadedActorsQueryVariables>(
    GetLeastLoadedActorsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLeastLoadedActorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLeastLoadedActorsQuery,
    GetLeastLoadedActorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetLeastLoadedActorsQuery, GetLeastLoadedActorsQueryVariables>;
export function useGetLeastLoadedActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLeastLoadedActorsQuery,
        GetLeastLoadedActorsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetLeastLoadedActorsQuery | undefined,
  GetLeastLoadedActorsQueryVariables
>;
export function useGetLeastLoadedActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLeastLoadedActorsQuery,
        GetLeastLoadedActorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLeastLoadedActorsQuery, GetLeastLoadedActorsQueryVariables>(
    GetLeastLoadedActorsDocument,
    options,
  );
}
export type GetLeastLoadedActorsQueryHookResult = ReturnType<typeof useGetLeastLoadedActorsQuery>;
export type GetLeastLoadedActorsLazyQueryHookResult = ReturnType<
  typeof useGetLeastLoadedActorsLazyQuery
>;
export type GetLeastLoadedActorsSuspenseQueryHookResult = ReturnType<
  typeof useGetLeastLoadedActorsSuspenseQuery
>;
export type GetLeastLoadedActorsQueryResult = Apollo.QueryResult<
  GetLeastLoadedActorsQuery,
  GetLeastLoadedActorsQueryVariables
>;
export const GetActorsWithOpenCircuitBreakerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActorsWithOpenCircuitBreaker' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActorsWithOpenCircuitBreaker' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorsWithOpenCircuitBreakerQuery__
 *
 * To run a query within a React component, call `useGetActorsWithOpenCircuitBreakerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorsWithOpenCircuitBreakerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorsWithOpenCircuitBreakerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActorsWithOpenCircuitBreakerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetActorsWithOpenCircuitBreakerQuery,
    GetActorsWithOpenCircuitBreakerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActorsWithOpenCircuitBreakerQuery,
    GetActorsWithOpenCircuitBreakerQueryVariables
  >(GetActorsWithOpenCircuitBreakerDocument, options);
}
export function useGetActorsWithOpenCircuitBreakerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActorsWithOpenCircuitBreakerQuery,
    GetActorsWithOpenCircuitBreakerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActorsWithOpenCircuitBreakerQuery,
    GetActorsWithOpenCircuitBreakerQueryVariables
  >(GetActorsWithOpenCircuitBreakerDocument, options);
}
// @ts-ignore
export function useGetActorsWithOpenCircuitBreakerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActorsWithOpenCircuitBreakerQuery,
    GetActorsWithOpenCircuitBreakerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetActorsWithOpenCircuitBreakerQuery,
  GetActorsWithOpenCircuitBreakerQueryVariables
>;
export function useGetActorsWithOpenCircuitBreakerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActorsWithOpenCircuitBreakerQuery,
        GetActorsWithOpenCircuitBreakerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetActorsWithOpenCircuitBreakerQuery | undefined,
  GetActorsWithOpenCircuitBreakerQueryVariables
>;
export function useGetActorsWithOpenCircuitBreakerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActorsWithOpenCircuitBreakerQuery,
        GetActorsWithOpenCircuitBreakerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetActorsWithOpenCircuitBreakerQuery,
    GetActorsWithOpenCircuitBreakerQueryVariables
  >(GetActorsWithOpenCircuitBreakerDocument, options);
}
export type GetActorsWithOpenCircuitBreakerQueryHookResult = ReturnType<
  typeof useGetActorsWithOpenCircuitBreakerQuery
>;
export type GetActorsWithOpenCircuitBreakerLazyQueryHookResult = ReturnType<
  typeof useGetActorsWithOpenCircuitBreakerLazyQuery
>;
export type GetActorsWithOpenCircuitBreakerSuspenseQueryHookResult = ReturnType<
  typeof useGetActorsWithOpenCircuitBreakerSuspenseQuery
>;
export type GetActorsWithOpenCircuitBreakerQueryResult = Apollo.QueryResult<
  GetActorsWithOpenCircuitBreakerQuery,
  GetActorsWithOpenCircuitBreakerQueryVariables
>;
export const GetTeamPresenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeamPresence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTeamPresence' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'teamId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSeen' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTeamPresenceQuery__
 *
 * To run a query within a React component, call `useGetTeamPresenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamPresenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamPresenceQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamPresenceQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamPresenceQuery, GetTeamPresenceQueryVariables> &
    ({ variables: GetTeamPresenceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamPresenceQuery, GetTeamPresenceQueryVariables>(
    GetTeamPresenceDocument,
    options,
  );
}
export function useGetTeamPresenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamPresenceQuery, GetTeamPresenceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamPresenceQuery, GetTeamPresenceQueryVariables>(
    GetTeamPresenceDocument,
    options,
  );
}
// @ts-ignore
export function useGetTeamPresenceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamPresenceQuery,
    GetTeamPresenceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTeamPresenceQuery, GetTeamPresenceQueryVariables>;
export function useGetTeamPresenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamPresenceQuery, GetTeamPresenceQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTeamPresenceQuery | undefined, GetTeamPresenceQueryVariables>;
export function useGetTeamPresenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamPresenceQuery, GetTeamPresenceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTeamPresenceQuery, GetTeamPresenceQueryVariables>(
    GetTeamPresenceDocument,
    options,
  );
}
export type GetTeamPresenceQueryHookResult = ReturnType<typeof useGetTeamPresenceQuery>;
export type GetTeamPresenceLazyQueryHookResult = ReturnType<typeof useGetTeamPresenceLazyQuery>;
export type GetTeamPresenceSuspenseQueryHookResult = ReturnType<
  typeof useGetTeamPresenceSuspenseQuery
>;
export type GetTeamPresenceQueryResult = Apollo.QueryResult<
  GetTeamPresenceQuery,
  GetTeamPresenceQueryVariables
>;
export const CompleteTaskForActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteTaskForActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'success' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeTaskForActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'success' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'success' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteTaskForActorMutationFn = ApolloMutationFunction<
  CompleteTaskForActorMutation,
  CompleteTaskForActorMutationVariables
>;

/**
 * __useCompleteTaskForActorMutation__
 *
 * To run a mutation, you first call `useCompleteTaskForActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskForActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskForActorMutation, { data, loading, error }] = useCompleteTaskForActorMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      taskId: // value for 'taskId'
 *      success: // value for 'success'
 *   },
 * });
 */
export function useCompleteTaskForActorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteTaskForActorMutation,
    CompleteTaskForActorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteTaskForActorMutation, CompleteTaskForActorMutationVariables>(
    CompleteTaskForActorDocument,
    options,
  );
}
export type CompleteTaskForActorMutationHookResult = ReturnType<
  typeof useCompleteTaskForActorMutation
>;
export type CompleteTaskForActorMutationResult =
  Apollo.MutationResult<CompleteTaskForActorMutation>;
export type CompleteTaskForActorMutationOptions = ApolloBaseMutationOptions<
  CompleteTaskForActorMutation,
  CompleteTaskForActorMutationVariables
>;
export const UpdateActorStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateActorStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlActorStatus' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateActorStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateActorStatusMutationFn = ApolloMutationFunction<
  UpdateActorStatusMutation,
  UpdateActorStatusMutationVariables
>;

/**
 * __useUpdateActorStatusMutation__
 *
 * To run a mutation, you first call `useUpdateActorStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActorStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActorStatusMutation, { data, loading, error }] = useUpdateActorStatusMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateActorStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActorStatusMutation,
    UpdateActorStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateActorStatusMutation, UpdateActorStatusMutationVariables>(
    UpdateActorStatusDocument,
    options,
  );
}
export type UpdateActorStatusMutationHookResult = ReturnType<typeof useUpdateActorStatusMutation>;
export type UpdateActorStatusMutationResult = Apollo.MutationResult<UpdateActorStatusMutation>;
export type UpdateActorStatusMutationOptions = ApolloBaseMutationOptions<
  UpdateActorStatusMutation,
  UpdateActorStatusMutationVariables
>;
export const ResetCircuitBreakerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetCircuitBreaker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetCircuitBreaker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResetCircuitBreakerMutationFn = ApolloMutationFunction<
  ResetCircuitBreakerMutation,
  ResetCircuitBreakerMutationVariables
>;

/**
 * __useResetCircuitBreakerMutation__
 *
 * To run a mutation, you first call `useResetCircuitBreakerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCircuitBreakerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCircuitBreakerMutation, { data, loading, error }] = useResetCircuitBreakerMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useResetCircuitBreakerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetCircuitBreakerMutation,
    ResetCircuitBreakerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetCircuitBreakerMutation, ResetCircuitBreakerMutationVariables>(
    ResetCircuitBreakerDocument,
    options,
  );
}
export type ResetCircuitBreakerMutationHookResult = ReturnType<
  typeof useResetCircuitBreakerMutation
>;
export type ResetCircuitBreakerMutationResult = Apollo.MutationResult<ResetCircuitBreakerMutation>;
export type ResetCircuitBreakerMutationOptions = ApolloBaseMutationOptions<
  ResetCircuitBreakerMutation,
  ResetCircuitBreakerMutationVariables
>;
export const DeprecateActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeprecateActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deprecateActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeprecateActorMutationFn = ApolloMutationFunction<
  DeprecateActorMutation,
  DeprecateActorMutationVariables
>;

/**
 * __useDeprecateActorMutation__
 *
 * To run a mutation, you first call `useDeprecateActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeprecateActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deprecateActorMutation, { data, loading, error }] = useDeprecateActorMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeprecateActorMutation(
  baseOptions?: Apollo.MutationHookOptions<DeprecateActorMutation, DeprecateActorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeprecateActorMutation, DeprecateActorMutationVariables>(
    DeprecateActorDocument,
    options,
  );
}
export type DeprecateActorMutationHookResult = ReturnType<typeof useDeprecateActorMutation>;
export type DeprecateActorMutationResult = Apollo.MutationResult<DeprecateActorMutation>;
export type DeprecateActorMutationOptions = ApolloBaseMutationOptions<
  DeprecateActorMutation,
  DeprecateActorMutationVariables
>;
export const AddActorToQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddActorToQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addActorToQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddActorToQueueMutationFn = ApolloMutationFunction<
  AddActorToQueueMutation,
  AddActorToQueueMutationVariables
>;

/**
 * __useAddActorToQueueMutation__
 *
 * To run a mutation, you first call `useAddActorToQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActorToQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActorToQueueMutation, { data, loading, error }] = useAddActorToQueueMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useAddActorToQueueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddActorToQueueMutation,
    AddActorToQueueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddActorToQueueMutation, AddActorToQueueMutationVariables>(
    AddActorToQueueDocument,
    options,
  );
}
export type AddActorToQueueMutationHookResult = ReturnType<typeof useAddActorToQueueMutation>;
export type AddActorToQueueMutationResult = Apollo.MutationResult<AddActorToQueueMutation>;
export type AddActorToQueueMutationOptions = ApolloBaseMutationOptions<
  AddActorToQueueMutation,
  AddActorToQueueMutationVariables
>;
export const UpdatePresenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePresence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlPresenceStatus' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePresence' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdatePresenceMutationFn = ApolloMutationFunction<
  UpdatePresenceMutation,
  UpdatePresenceMutationVariables
>;

/**
 * __useUpdatePresenceMutation__
 *
 * To run a mutation, you first call `useUpdatePresenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresenceMutation, { data, loading, error }] = useUpdatePresenceMutation({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePresenceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePresenceMutation, UpdatePresenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePresenceMutation, UpdatePresenceMutationVariables>(
    UpdatePresenceDocument,
    options,
  );
}
export type UpdatePresenceMutationHookResult = ReturnType<typeof useUpdatePresenceMutation>;
export type UpdatePresenceMutationResult = Apollo.MutationResult<UpdatePresenceMutation>;
export type UpdatePresenceMutationOptions = ApolloBaseMutationOptions<
  UpdatePresenceMutation,
  UpdatePresenceMutationVariables
>;
export const BackfillTrainingInstancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BackfillTrainingInstances' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backfillTrainingInstances' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skippedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failedActorIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BackfillTrainingInstancesMutationFn = ApolloMutationFunction<
  BackfillTrainingInstancesMutation,
  BackfillTrainingInstancesMutationVariables
>;

/**
 * __useBackfillTrainingInstancesMutation__
 *
 * To run a mutation, you first call `useBackfillTrainingInstancesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackfillTrainingInstancesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backfillTrainingInstancesMutation, { data, loading, error }] = useBackfillTrainingInstancesMutation({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBackfillTrainingInstancesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackfillTrainingInstancesMutation,
    BackfillTrainingInstancesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BackfillTrainingInstancesMutation,
    BackfillTrainingInstancesMutationVariables
  >(BackfillTrainingInstancesDocument, options);
}
export type BackfillTrainingInstancesMutationHookResult = ReturnType<
  typeof useBackfillTrainingInstancesMutation
>;
export type BackfillTrainingInstancesMutationResult =
  Apollo.MutationResult<BackfillTrainingInstancesMutation>;
export type BackfillTrainingInstancesMutationOptions = ApolloBaseMutationOptions<
  BackfillTrainingInstancesMutation,
  BackfillTrainingInstancesMutationVariables
>;
export const CreateTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateTeamInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateTeamMutationFn = ApolloMutationFunction<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(
    CreateTeamDocument,
    options,
  );
}
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = ApolloBaseMutationOptions<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;
export const UpdateTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlUpdateTeamInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateTeamMutationFn = ApolloMutationFunction<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      code: // value for 'code'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(
    UpdateTeamDocument,
    options,
  );
}
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = ApolloBaseMutationOptions<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;
export const ArchiveTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teamCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teamName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveTeamMutationFn = ApolloMutationFunction<
  ArchiveTeamMutation,
  ArchiveTeamMutationVariables
>;

/**
 * __useArchiveTeamMutation__
 *
 * To run a mutation, you first call `useArchiveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTeamMutation, { data, loading, error }] = useArchiveTeamMutation({
 *   variables: {
 *      code: // value for 'code'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveTeamMutation, ArchiveTeamMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveTeamMutation, ArchiveTeamMutationVariables>(
    ArchiveTeamDocument,
    options,
  );
}
export type ArchiveTeamMutationHookResult = ReturnType<typeof useArchiveTeamMutation>;
export type ArchiveTeamMutationResult = Apollo.MutationResult<ArchiveTeamMutation>;
export type ArchiveTeamMutationOptions = ApolloBaseMutationOptions<
  ArchiveTeamMutation,
  ArchiveTeamMutationVariables
>;
export const MoveTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MoveTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlMoveTeamInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moveTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type MoveTeamMutationFn = ApolloMutationFunction<
  MoveTeamMutation,
  MoveTeamMutationVariables
>;

/**
 * __useMoveTeamMutation__
 *
 * To run a mutation, you first call `useMoveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTeamMutation, { data, loading, error }] = useMoveTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<MoveTeamMutation, MoveTeamMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MoveTeamMutation, MoveTeamMutationVariables>(MoveTeamDocument, options);
}
export type MoveTeamMutationHookResult = ReturnType<typeof useMoveTeamMutation>;
export type MoveTeamMutationResult = Apollo.MutationResult<MoveTeamMutation>;
export type MoveTeamMutationOptions = ApolloBaseMutationOptions<
  MoveTeamMutation,
  MoveTeamMutationVariables
>;
export const AddTeamStakeholderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTeamStakeholder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlAddStakeholderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTeamStakeholder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddTeamStakeholderMutationFn = ApolloMutationFunction<
  AddTeamStakeholderMutation,
  AddTeamStakeholderMutationVariables
>;

/**
 * __useAddTeamStakeholderMutation__
 *
 * To run a mutation, you first call `useAddTeamStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamStakeholderMutation, { data, loading, error }] = useAddTeamStakeholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamStakeholderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddTeamStakeholderMutation,
    AddTeamStakeholderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddTeamStakeholderMutation, AddTeamStakeholderMutationVariables>(
    AddTeamStakeholderDocument,
    options,
  );
}
export type AddTeamStakeholderMutationHookResult = ReturnType<typeof useAddTeamStakeholderMutation>;
export type AddTeamStakeholderMutationResult = Apollo.MutationResult<AddTeamStakeholderMutation>;
export type AddTeamStakeholderMutationOptions = ApolloBaseMutationOptions<
  AddTeamStakeholderMutation,
  AddTeamStakeholderMutationVariables
>;
export const RemoveTeamStakeholderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveTeamStakeholder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRemoveStakeholderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeTeamStakeholder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveTeamStakeholderMutationFn = ApolloMutationFunction<
  RemoveTeamStakeholderMutation,
  RemoveTeamStakeholderMutationVariables
>;

/**
 * __useRemoveTeamStakeholderMutation__
 *
 * To run a mutation, you first call `useRemoveTeamStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamStakeholderMutation, { data, loading, error }] = useRemoveTeamStakeholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamStakeholderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTeamStakeholderMutation,
    RemoveTeamStakeholderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTeamStakeholderMutation, RemoveTeamStakeholderMutationVariables>(
    RemoveTeamStakeholderDocument,
    options,
  );
}
export type RemoveTeamStakeholderMutationHookResult = ReturnType<
  typeof useRemoveTeamStakeholderMutation
>;
export type RemoveTeamStakeholderMutationResult =
  Apollo.MutationResult<RemoveTeamStakeholderMutation>;
export type RemoveTeamStakeholderMutationOptions = ApolloBaseMutationOptions<
  RemoveTeamStakeholderMutation,
  RemoveTeamStakeholderMutationVariables
>;
export const UpdateTeamQuotasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTeamQuotas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlUpdateTeamQuotasInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeamQuotas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateTeamQuotasMutationFn = ApolloMutationFunction<
  UpdateTeamQuotasMutation,
  UpdateTeamQuotasMutationVariables
>;

/**
 * __useUpdateTeamQuotasMutation__
 *
 * To run a mutation, you first call `useUpdateTeamQuotasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamQuotasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamQuotasMutation, { data, loading, error }] = useUpdateTeamQuotasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamQuotasMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamQuotasMutation,
    UpdateTeamQuotasMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamQuotasMutation, UpdateTeamQuotasMutationVariables>(
    UpdateTeamQuotasDocument,
    options,
  );
}
export type UpdateTeamQuotasMutationHookResult = ReturnType<typeof useUpdateTeamQuotasMutation>;
export type UpdateTeamQuotasMutationResult = Apollo.MutationResult<UpdateTeamQuotasMutation>;
export type UpdateTeamQuotasMutationOptions = ApolloBaseMutationOptions<
  UpdateTeamQuotasMutation,
  UpdateTeamQuotasMutationVariables
>;
export const GetApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiGetApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetApprovalQuery__
 *
 * To run a query within a React component, call `useGetApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalId: // value for 'approvalId'
 *   },
 * });
 */
export function useGetApprovalQuery(
  baseOptions: Apollo.QueryHookOptions<GetApprovalQuery, GetApprovalQueryVariables> &
    ({ variables: GetApprovalQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetApprovalQuery, GetApprovalQueryVariables>(GetApprovalDocument, options);
}
export function useGetApprovalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalQuery, GetApprovalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetApprovalQuery, GetApprovalQueryVariables>(
    GetApprovalDocument,
    options,
  );
}
// @ts-ignore
export function useGetApprovalSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetApprovalQuery, GetApprovalQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetApprovalQuery, GetApprovalQueryVariables>;
export function useGetApprovalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApprovalQuery, GetApprovalQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetApprovalQuery | undefined, GetApprovalQueryVariables>;
export function useGetApprovalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApprovalQuery, GetApprovalQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetApprovalQuery, GetApprovalQueryVariables>(
    GetApprovalDocument,
    options,
  );
}
export type GetApprovalQueryHookResult = ReturnType<typeof useGetApprovalQuery>;
export type GetApprovalLazyQueryHookResult = ReturnType<typeof useGetApprovalLazyQuery>;
export type GetApprovalSuspenseQueryHookResult = ReturnType<typeof useGetApprovalSuspenseQuery>;
export type GetApprovalQueryResult = Apollo.QueryResult<
  GetApprovalQuery,
  GetApprovalQueryVariables
>;
export const ListPendingApprovalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListPendingApprovals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiListApprovalsByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'PENDING' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ApprovalDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListPendingApprovalsQuery__
 *
 * To run a query within a React component, call `useListPendingApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPendingApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPendingApprovalsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListPendingApprovalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPendingApprovalsQuery,
    ListPendingApprovalsQueryVariables
  > &
    ({ variables: ListPendingApprovalsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPendingApprovalsQuery, ListPendingApprovalsQueryVariables>(
    ListPendingApprovalsDocument,
    options,
  );
}
export function useListPendingApprovalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPendingApprovalsQuery,
    ListPendingApprovalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPendingApprovalsQuery, ListPendingApprovalsQueryVariables>(
    ListPendingApprovalsDocument,
    options,
  );
}
// @ts-ignore
export function useListPendingApprovalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPendingApprovalsQuery,
    ListPendingApprovalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListPendingApprovalsQuery, ListPendingApprovalsQueryVariables>;
export function useListPendingApprovalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingApprovalsQuery,
        ListPendingApprovalsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListPendingApprovalsQuery | undefined,
  ListPendingApprovalsQueryVariables
>;
export function useListPendingApprovalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingApprovalsQuery,
        ListPendingApprovalsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPendingApprovalsQuery, ListPendingApprovalsQueryVariables>(
    ListPendingApprovalsDocument,
    options,
  );
}
export type ListPendingApprovalsQueryHookResult = ReturnType<typeof useListPendingApprovalsQuery>;
export type ListPendingApprovalsLazyQueryHookResult = ReturnType<
  typeof useListPendingApprovalsLazyQuery
>;
export type ListPendingApprovalsSuspenseQueryHookResult = ReturnType<
  typeof useListPendingApprovalsSuspenseQuery
>;
export type ListPendingApprovalsQueryResult = Apollo.QueryResult<
  ListPendingApprovalsQuery,
  ListPendingApprovalsQueryVariables
>;
export const ListApprovalsByStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListApprovalsByStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlApprovalStatus' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiListApprovalsByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListApprovalsByStatusQuery__
 *
 * To run a query within a React component, call `useListApprovalsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApprovalsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApprovalsByStatusQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListApprovalsByStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListApprovalsByStatusQuery,
    ListApprovalsByStatusQueryVariables
  > &
    ({ variables: ListApprovalsByStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListApprovalsByStatusQuery, ListApprovalsByStatusQueryVariables>(
    ListApprovalsByStatusDocument,
    options,
  );
}
export function useListApprovalsByStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListApprovalsByStatusQuery,
    ListApprovalsByStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListApprovalsByStatusQuery, ListApprovalsByStatusQueryVariables>(
    ListApprovalsByStatusDocument,
    options,
  );
}
// @ts-ignore
export function useListApprovalsByStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListApprovalsByStatusQuery,
    ListApprovalsByStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListApprovalsByStatusQuery, ListApprovalsByStatusQueryVariables>;
export function useListApprovalsByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsByStatusQuery,
        ListApprovalsByStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListApprovalsByStatusQuery | undefined,
  ListApprovalsByStatusQueryVariables
>;
export function useListApprovalsByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsByStatusQuery,
        ListApprovalsByStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListApprovalsByStatusQuery, ListApprovalsByStatusQueryVariables>(
    ListApprovalsByStatusDocument,
    options,
  );
}
export type ListApprovalsByStatusQueryHookResult = ReturnType<typeof useListApprovalsByStatusQuery>;
export type ListApprovalsByStatusLazyQueryHookResult = ReturnType<
  typeof useListApprovalsByStatusLazyQuery
>;
export type ListApprovalsByStatusSuspenseQueryHookResult = ReturnType<
  typeof useListApprovalsByStatusSuspenseQuery
>;
export type ListApprovalsByStatusQueryResult = Apollo.QueryResult<
  ListApprovalsByStatusQuery,
  ListApprovalsByStatusQueryVariables
>;
export const ListApprovalsForApproverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListApprovalsForApprover' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiListApprovalsForApprover' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approverId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ApprovalDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListApprovalsForApproverQuery__
 *
 * To run a query within a React component, call `useListApprovalsForApproverQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApprovalsForApproverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApprovalsForApproverQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approverId: // value for 'approverId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListApprovalsForApproverQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListApprovalsForApproverQuery,
    ListApprovalsForApproverQueryVariables
  > &
    ({ variables: ListApprovalsForApproverQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListApprovalsForApproverQuery, ListApprovalsForApproverQueryVariables>(
    ListApprovalsForApproverDocument,
    options,
  );
}
export function useListApprovalsForApproverLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListApprovalsForApproverQuery,
    ListApprovalsForApproverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListApprovalsForApproverQuery, ListApprovalsForApproverQueryVariables>(
    ListApprovalsForApproverDocument,
    options,
  );
}
// @ts-ignore
export function useListApprovalsForApproverSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListApprovalsForApproverQuery,
    ListApprovalsForApproverQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListApprovalsForApproverQuery,
  ListApprovalsForApproverQueryVariables
>;
export function useListApprovalsForApproverSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsForApproverQuery,
        ListApprovalsForApproverQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListApprovalsForApproverQuery | undefined,
  ListApprovalsForApproverQueryVariables
>;
export function useListApprovalsForApproverSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsForApproverQuery,
        ListApprovalsForApproverQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListApprovalsForApproverQuery,
    ListApprovalsForApproverQueryVariables
  >(ListApprovalsForApproverDocument, options);
}
export type ListApprovalsForApproverQueryHookResult = ReturnType<
  typeof useListApprovalsForApproverQuery
>;
export type ListApprovalsForApproverLazyQueryHookResult = ReturnType<
  typeof useListApprovalsForApproverLazyQuery
>;
export type ListApprovalsForApproverSuspenseQueryHookResult = ReturnType<
  typeof useListApprovalsForApproverSuspenseQuery
>;
export type ListApprovalsForApproverQueryResult = Apollo.QueryResult<
  ListApprovalsForApproverQuery,
  ListApprovalsForApproverQueryVariables
>;
export const ListApprovalsByWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListApprovalsByWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiListApprovalsByWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ApprovalDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListApprovalsByWorkflowQuery__
 *
 * To run a query within a React component, call `useListApprovalsByWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApprovalsByWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApprovalsByWorkflowQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListApprovalsByWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListApprovalsByWorkflowQuery,
    ListApprovalsByWorkflowQueryVariables
  > &
    ({ variables: ListApprovalsByWorkflowQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListApprovalsByWorkflowQuery, ListApprovalsByWorkflowQueryVariables>(
    ListApprovalsByWorkflowDocument,
    options,
  );
}
export function useListApprovalsByWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListApprovalsByWorkflowQuery,
    ListApprovalsByWorkflowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListApprovalsByWorkflowQuery, ListApprovalsByWorkflowQueryVariables>(
    ListApprovalsByWorkflowDocument,
    options,
  );
}
// @ts-ignore
export function useListApprovalsByWorkflowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListApprovalsByWorkflowQuery,
    ListApprovalsByWorkflowQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListApprovalsByWorkflowQuery,
  ListApprovalsByWorkflowQueryVariables
>;
export function useListApprovalsByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsByWorkflowQuery,
        ListApprovalsByWorkflowQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListApprovalsByWorkflowQuery | undefined,
  ListApprovalsByWorkflowQueryVariables
>;
export function useListApprovalsByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsByWorkflowQuery,
        ListApprovalsByWorkflowQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListApprovalsByWorkflowQuery,
    ListApprovalsByWorkflowQueryVariables
  >(ListApprovalsByWorkflowDocument, options);
}
export type ListApprovalsByWorkflowQueryHookResult = ReturnType<
  typeof useListApprovalsByWorkflowQuery
>;
export type ListApprovalsByWorkflowLazyQueryHookResult = ReturnType<
  typeof useListApprovalsByWorkflowLazyQuery
>;
export type ListApprovalsByWorkflowSuspenseQueryHookResult = ReturnType<
  typeof useListApprovalsByWorkflowSuspenseQuery
>;
export type ListApprovalsByWorkflowQueryResult = Apollo.QueryResult<
  ListApprovalsByWorkflowQuery,
  ListApprovalsByWorkflowQueryVariables
>;
export const ListApprovalsInChainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListApprovalsInChain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalChainId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiListApprovalsInChain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalChainId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalChainId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListApprovalsInChainQuery__
 *
 * To run a query within a React component, call `useListApprovalsInChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApprovalsInChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApprovalsInChainQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalChainId: // value for 'approvalChainId'
 *   },
 * });
 */
export function useListApprovalsInChainQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListApprovalsInChainQuery,
    ListApprovalsInChainQueryVariables
  > &
    ({ variables: ListApprovalsInChainQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListApprovalsInChainQuery, ListApprovalsInChainQueryVariables>(
    ListApprovalsInChainDocument,
    options,
  );
}
export function useListApprovalsInChainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListApprovalsInChainQuery,
    ListApprovalsInChainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListApprovalsInChainQuery, ListApprovalsInChainQueryVariables>(
    ListApprovalsInChainDocument,
    options,
  );
}
// @ts-ignore
export function useListApprovalsInChainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListApprovalsInChainQuery,
    ListApprovalsInChainQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListApprovalsInChainQuery, ListApprovalsInChainQueryVariables>;
export function useListApprovalsInChainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsInChainQuery,
        ListApprovalsInChainQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListApprovalsInChainQuery | undefined,
  ListApprovalsInChainQueryVariables
>;
export function useListApprovalsInChainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApprovalsInChainQuery,
        ListApprovalsInChainQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListApprovalsInChainQuery, ListApprovalsInChainQueryVariables>(
    ListApprovalsInChainDocument,
    options,
  );
}
export type ListApprovalsInChainQueryHookResult = ReturnType<typeof useListApprovalsInChainQuery>;
export type ListApprovalsInChainLazyQueryHookResult = ReturnType<
  typeof useListApprovalsInChainLazyQuery
>;
export type ListApprovalsInChainSuspenseQueryHookResult = ReturnType<
  typeof useListApprovalsInChainSuspenseQuery
>;
export type ListApprovalsInChainQueryResult = Apollo.QueryResult<
  ListApprovalsInChainQuery,
  ListApprovalsInChainQueryVariables
>;
export const GetPendingApprovalsCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPendingApprovalsCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiGetPendingApprovalsCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approverId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPendingApprovalsCountQuery__
 *
 * To run a query within a React component, call `useGetPendingApprovalsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingApprovalsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingApprovalsCountQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approverId: // value for 'approverId'
 *   },
 * });
 */
export function useGetPendingApprovalsCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPendingApprovalsCountQuery,
    GetPendingApprovalsCountQueryVariables
  > &
    ({ variables: GetPendingApprovalsCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPendingApprovalsCountQuery, GetPendingApprovalsCountQueryVariables>(
    GetPendingApprovalsCountDocument,
    options,
  );
}
export function useGetPendingApprovalsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingApprovalsCountQuery,
    GetPendingApprovalsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPendingApprovalsCountQuery, GetPendingApprovalsCountQueryVariables>(
    GetPendingApprovalsCountDocument,
    options,
  );
}
// @ts-ignore
export function useGetPendingApprovalsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingApprovalsCountQuery,
    GetPendingApprovalsCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPendingApprovalsCountQuery,
  GetPendingApprovalsCountQueryVariables
>;
export function useGetPendingApprovalsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingApprovalsCountQuery,
        GetPendingApprovalsCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPendingApprovalsCountQuery | undefined,
  GetPendingApprovalsCountQueryVariables
>;
export function useGetPendingApprovalsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingApprovalsCountQuery,
        GetPendingApprovalsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPendingApprovalsCountQuery,
    GetPendingApprovalsCountQueryVariables
  >(GetPendingApprovalsCountDocument, options);
}
export type GetPendingApprovalsCountQueryHookResult = ReturnType<
  typeof useGetPendingApprovalsCountQuery
>;
export type GetPendingApprovalsCountLazyQueryHookResult = ReturnType<
  typeof useGetPendingApprovalsCountLazyQuery
>;
export type GetPendingApprovalsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingApprovalsCountSuspenseQuery
>;
export type GetPendingApprovalsCountQueryResult = Apollo.QueryResult<
  GetPendingApprovalsCountQuery,
  GetPendingApprovalsCountQueryVariables
>;
export const ListEscalatedApprovalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListEscalatedApprovals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiListApprovalsByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'ESCALATED' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ApprovalDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListEscalatedApprovalsQuery__
 *
 * To run a query within a React component, call `useListEscalatedApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEscalatedApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEscalatedApprovalsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListEscalatedApprovalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListEscalatedApprovalsQuery,
    ListEscalatedApprovalsQueryVariables
  > &
    ({ variables: ListEscalatedApprovalsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEscalatedApprovalsQuery, ListEscalatedApprovalsQueryVariables>(
    ListEscalatedApprovalsDocument,
    options,
  );
}
export function useListEscalatedApprovalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEscalatedApprovalsQuery,
    ListEscalatedApprovalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEscalatedApprovalsQuery, ListEscalatedApprovalsQueryVariables>(
    ListEscalatedApprovalsDocument,
    options,
  );
}
// @ts-ignore
export function useListEscalatedApprovalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEscalatedApprovalsQuery,
    ListEscalatedApprovalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEscalatedApprovalsQuery, ListEscalatedApprovalsQueryVariables>;
export function useListEscalatedApprovalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEscalatedApprovalsQuery,
        ListEscalatedApprovalsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListEscalatedApprovalsQuery | undefined,
  ListEscalatedApprovalsQueryVariables
>;
export function useListEscalatedApprovalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEscalatedApprovalsQuery,
        ListEscalatedApprovalsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEscalatedApprovalsQuery, ListEscalatedApprovalsQueryVariables>(
    ListEscalatedApprovalsDocument,
    options,
  );
}
export type ListEscalatedApprovalsQueryHookResult = ReturnType<
  typeof useListEscalatedApprovalsQuery
>;
export type ListEscalatedApprovalsLazyQueryHookResult = ReturnType<
  typeof useListEscalatedApprovalsLazyQuery
>;
export type ListEscalatedApprovalsSuspenseQueryHookResult = ReturnType<
  typeof useListEscalatedApprovalsSuspenseQuery
>;
export type ListEscalatedApprovalsQueryResult = Apollo.QueryResult<
  ListEscalatedApprovalsQuery,
  ListEscalatedApprovalsQueryVariables
>;
export const CreateApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateApprovalInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiCreateApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateApprovalMutationFn = ApolloMutationFunction<
  CreateApprovalMutation,
  CreateApprovalMutationVariables
>;

/**
 * __useCreateApprovalMutation__
 *
 * To run a mutation, you first call `useCreateApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApprovalMutation, { data, loading, error }] = useCreateApprovalMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateApprovalMutation, CreateApprovalMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateApprovalMutation, CreateApprovalMutationVariables>(
    CreateApprovalDocument,
    options,
  );
}
export type CreateApprovalMutationHookResult = ReturnType<typeof useCreateApprovalMutation>;
export type CreateApprovalMutationResult = Apollo.MutationResult<CreateApprovalMutation>;
export type CreateApprovalMutationOptions = ApolloBaseMutationOptions<
  CreateApprovalMutation,
  CreateApprovalMutationVariables
>;
export const RecordApprovalDecisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordApprovalDecision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRecordDecisionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiRecordApprovalDecision' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordApprovalDecisionMutationFn = ApolloMutationFunction<
  RecordApprovalDecisionMutation,
  RecordApprovalDecisionMutationVariables
>;

/**
 * __useRecordApprovalDecisionMutation__
 *
 * To run a mutation, you first call `useRecordApprovalDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordApprovalDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordApprovalDecisionMutation, { data, loading, error }] = useRecordApprovalDecisionMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalId: // value for 'approvalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordApprovalDecisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordApprovalDecisionMutation,
    RecordApprovalDecisionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordApprovalDecisionMutation,
    RecordApprovalDecisionMutationVariables
  >(RecordApprovalDecisionDocument, options);
}
export type RecordApprovalDecisionMutationHookResult = ReturnType<
  typeof useRecordApprovalDecisionMutation
>;
export type RecordApprovalDecisionMutationResult =
  Apollo.MutationResult<RecordApprovalDecisionMutation>;
export type RecordApprovalDecisionMutationOptions = ApolloBaseMutationOptions<
  RecordApprovalDecisionMutation,
  RecordApprovalDecisionMutationVariables
>;
export const AddApprovalCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddApprovalComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlAddCommentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiAddApprovalComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddApprovalCommentMutationFn = ApolloMutationFunction<
  AddApprovalCommentMutation,
  AddApprovalCommentMutationVariables
>;

/**
 * __useAddApprovalCommentMutation__
 *
 * To run a mutation, you first call `useAddApprovalCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApprovalCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApprovalCommentMutation, { data, loading, error }] = useAddApprovalCommentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalId: // value for 'approvalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddApprovalCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddApprovalCommentMutation,
    AddApprovalCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddApprovalCommentMutation, AddApprovalCommentMutationVariables>(
    AddApprovalCommentDocument,
    options,
  );
}
export type AddApprovalCommentMutationHookResult = ReturnType<typeof useAddApprovalCommentMutation>;
export type AddApprovalCommentMutationResult = Apollo.MutationResult<AddApprovalCommentMutation>;
export type AddApprovalCommentMutationOptions = ApolloBaseMutationOptions<
  AddApprovalCommentMutation,
  AddApprovalCommentMutationVariables
>;
export const EscalateApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EscalateApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlEscalateApprovalInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiEscalateApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EscalateApprovalMutationFn = ApolloMutationFunction<
  EscalateApprovalMutation,
  EscalateApprovalMutationVariables
>;

/**
 * __useEscalateApprovalMutation__
 *
 * To run a mutation, you first call `useEscalateApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEscalateApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [escalateApprovalMutation, { data, loading, error }] = useEscalateApprovalMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalId: // value for 'approvalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEscalateApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EscalateApprovalMutation,
    EscalateApprovalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EscalateApprovalMutation, EscalateApprovalMutationVariables>(
    EscalateApprovalDocument,
    options,
  );
}
export type EscalateApprovalMutationHookResult = ReturnType<typeof useEscalateApprovalMutation>;
export type EscalateApprovalMutationResult = Apollo.MutationResult<EscalateApprovalMutation>;
export type EscalateApprovalMutationOptions = ApolloBaseMutationOptions<
  EscalateApprovalMutation,
  EscalateApprovalMutationVariables
>;
export const DelegateApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DelegateApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlDelegateApprovalInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiDelegateApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DelegateApprovalMutationFn = ApolloMutationFunction<
  DelegateApprovalMutation,
  DelegateApprovalMutationVariables
>;

/**
 * __useDelegateApprovalMutation__
 *
 * To run a mutation, you first call `useDelegateApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelegateApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delegateApprovalMutation, { data, loading, error }] = useDelegateApprovalMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalId: // value for 'approvalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDelegateApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DelegateApprovalMutation,
    DelegateApprovalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DelegateApprovalMutation, DelegateApprovalMutationVariables>(
    DelegateApprovalDocument,
    options,
  );
}
export type DelegateApprovalMutationHookResult = ReturnType<typeof useDelegateApprovalMutation>;
export type DelegateApprovalMutationResult = Apollo.MutationResult<DelegateApprovalMutation>;
export type DelegateApprovalMutationOptions = ApolloBaseMutationOptions<
  DelegateApprovalMutation,
  DelegateApprovalMutationVariables
>;
export const UpdateApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlUpdateApprovalInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvalApiUpdateApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approvalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approvalId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApprovalDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApprovalDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Approval' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approverRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentApprovalCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'decisionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'evidenceUrls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCommentId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateApprovalMutationFn = ApolloMutationFunction<
  UpdateApprovalMutation,
  UpdateApprovalMutationVariables
>;

/**
 * __useUpdateApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovalMutation, { data, loading, error }] = useUpdateApprovalMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      approvalId: // value for 'approvalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateApprovalMutation, UpdateApprovalMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateApprovalMutation, UpdateApprovalMutationVariables>(
    UpdateApprovalDocument,
    options,
  );
}
export type UpdateApprovalMutationHookResult = ReturnType<typeof useUpdateApprovalMutation>;
export type UpdateApprovalMutationResult = Apollo.MutationResult<UpdateApprovalMutation>;
export type UpdateApprovalMutationOptions = ApolloBaseMutationOptions<
  UpdateApprovalMutation,
  UpdateApprovalMutationVariables
>;
export const GetQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetQueueQuery__
 *
 * To run a query within a React component, call `useGetQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useGetQueueQuery(
  baseOptions: Apollo.QueryHookOptions<GetQueueQuery, GetQueueQueryVariables> &
    ({ variables: GetQueueQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQueueQuery, GetQueueQueryVariables>(GetQueueDocument, options);
}
export function useGetQueueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQueueQuery, GetQueueQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQueueQuery, GetQueueQueryVariables>(GetQueueDocument, options);
}
// @ts-ignore
export function useGetQueueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetQueueQuery, GetQueueQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetQueueQuery, GetQueueQueryVariables>;
export function useGetQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetQueueQuery, GetQueueQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetQueueQuery | undefined, GetQueueQueryVariables>;
export function useGetQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetQueueQuery, GetQueueQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetQueueQuery, GetQueueQueryVariables>(GetQueueDocument, options);
}
export type GetQueueQueryHookResult = ReturnType<typeof useGetQueueQuery>;
export type GetQueueLazyQueryHookResult = ReturnType<typeof useGetQueueLazyQuery>;
export type GetQueueSuspenseQueryHookResult = ReturnType<typeof useGetQueueSuspenseQuery>;
export type GetQueueQueryResult = Apollo.QueryResult<GetQueueQuery, GetQueueQueryVariables>;
export const ListQueuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListQueues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listQueues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'QueueDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListQueuesQuery__
 *
 * To run a query within a React component, call `useListQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQueuesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListQueuesQuery(
  baseOptions: Apollo.QueryHookOptions<ListQueuesQuery, ListQueuesQueryVariables> &
    ({ variables: ListQueuesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListQueuesQuery, ListQueuesQueryVariables>(ListQueuesDocument, options);
}
export function useListQueuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListQueuesQuery, ListQueuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListQueuesQuery, ListQueuesQueryVariables>(
    ListQueuesDocument,
    options,
  );
}
// @ts-ignore
export function useListQueuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListQueuesQuery, ListQueuesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListQueuesQuery, ListQueuesQueryVariables>;
export function useListQueuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListQueuesQuery, ListQueuesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListQueuesQuery | undefined, ListQueuesQueryVariables>;
export function useListQueuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListQueuesQuery, ListQueuesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListQueuesQuery, ListQueuesQueryVariables>(
    ListQueuesDocument,
    options,
  );
}
export type ListQueuesQueryHookResult = ReturnType<typeof useListQueuesQuery>;
export type ListQueuesLazyQueryHookResult = ReturnType<typeof useListQueuesLazyQuery>;
export type ListQueuesSuspenseQueryHookResult = ReturnType<typeof useListQueuesSuspenseQuery>;
export type ListQueuesQueryResult = Apollo.QueryResult<ListQueuesQuery, ListQueuesQueryVariables>;
export const GetQueuesByWorkflowInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetQueuesByWorkflowInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getQueuesByWorkflowInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetQueuesByWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useGetQueuesByWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueuesByWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueuesByWorkflowInstanceQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useGetQueuesByWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueuesByWorkflowInstanceQuery,
    GetQueuesByWorkflowInstanceQueryVariables
  > &
    ({ variables: GetQueuesByWorkflowInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQueuesByWorkflowInstanceQuery,
    GetQueuesByWorkflowInstanceQueryVariables
  >(GetQueuesByWorkflowInstanceDocument, options);
}
export function useGetQueuesByWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueuesByWorkflowInstanceQuery,
    GetQueuesByWorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQueuesByWorkflowInstanceQuery,
    GetQueuesByWorkflowInstanceQueryVariables
  >(GetQueuesByWorkflowInstanceDocument, options);
}
// @ts-ignore
export function useGetQueuesByWorkflowInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueuesByWorkflowInstanceQuery,
    GetQueuesByWorkflowInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetQueuesByWorkflowInstanceQuery,
  GetQueuesByWorkflowInstanceQueryVariables
>;
export function useGetQueuesByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueuesByWorkflowInstanceQuery,
        GetQueuesByWorkflowInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueuesByWorkflowInstanceQuery | undefined,
  GetQueuesByWorkflowInstanceQueryVariables
>;
export function useGetQueuesByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueuesByWorkflowInstanceQuery,
        GetQueuesByWorkflowInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetQueuesByWorkflowInstanceQuery,
    GetQueuesByWorkflowInstanceQueryVariables
  >(GetQueuesByWorkflowInstanceDocument, options);
}
export type GetQueuesByWorkflowInstanceQueryHookResult = ReturnType<
  typeof useGetQueuesByWorkflowInstanceQuery
>;
export type GetQueuesByWorkflowInstanceLazyQueryHookResult = ReturnType<
  typeof useGetQueuesByWorkflowInstanceLazyQuery
>;
export type GetQueuesByWorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useGetQueuesByWorkflowInstanceSuspenseQuery
>;
export type GetQueuesByWorkflowInstanceQueryResult = Apollo.QueryResult<
  GetQueuesByWorkflowInstanceQuery,
  GetQueuesByWorkflowInstanceQueryVariables
>;
export const GetQueueStatisticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetQueueStatistics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getQueueStatistics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'queueId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utilizationPercent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOverThreshold' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetQueueStatisticsQuery__
 *
 * To run a query within a React component, call `useGetQueueStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueStatisticsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useGetQueueStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<GetQueueStatisticsQuery, GetQueueStatisticsQueryVariables> &
    ({ variables: GetQueueStatisticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQueueStatisticsQuery, GetQueueStatisticsQueryVariables>(
    GetQueueStatisticsDocument,
    options,
  );
}
export function useGetQueueStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueueStatisticsQuery,
    GetQueueStatisticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQueueStatisticsQuery, GetQueueStatisticsQueryVariables>(
    GetQueueStatisticsDocument,
    options,
  );
}
// @ts-ignore
export function useGetQueueStatisticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueueStatisticsQuery,
    GetQueueStatisticsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetQueueStatisticsQuery, GetQueueStatisticsQueryVariables>;
export function useGetQueueStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetQueueStatisticsQuery, GetQueueStatisticsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetQueueStatisticsQuery | undefined,
  GetQueueStatisticsQueryVariables
>;
export function useGetQueueStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetQueueStatisticsQuery, GetQueueStatisticsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetQueueStatisticsQuery, GetQueueStatisticsQueryVariables>(
    GetQueueStatisticsDocument,
    options,
  );
}
export type GetQueueStatisticsQueryHookResult = ReturnType<typeof useGetQueueStatisticsQuery>;
export type GetQueueStatisticsLazyQueryHookResult = ReturnType<
  typeof useGetQueueStatisticsLazyQuery
>;
export type GetQueueStatisticsSuspenseQueryHookResult = ReturnType<
  typeof useGetQueueStatisticsSuspenseQuery
>;
export type GetQueueStatisticsQueryResult = Apollo.QueryResult<
  GetQueueStatisticsQuery,
  GetQueueStatisticsQueryVariables
>;
export const GetOverloadedQueuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOverloadedQueues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOverloadedQueues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOverloadedQueuesQuery__
 *
 * To run a query within a React component, call `useGetOverloadedQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverloadedQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverloadedQueuesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetOverloadedQueuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOverloadedQueuesQuery,
    GetOverloadedQueuesQueryVariables
  > &
    ({ variables: GetOverloadedQueuesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOverloadedQueuesQuery, GetOverloadedQueuesQueryVariables>(
    GetOverloadedQueuesDocument,
    options,
  );
}
export function useGetOverloadedQueuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOverloadedQueuesQuery,
    GetOverloadedQueuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOverloadedQueuesQuery, GetOverloadedQueuesQueryVariables>(
    GetOverloadedQueuesDocument,
    options,
  );
}
// @ts-ignore
export function useGetOverloadedQueuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOverloadedQueuesQuery,
    GetOverloadedQueuesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetOverloadedQueuesQuery, GetOverloadedQueuesQueryVariables>;
export function useGetOverloadedQueuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOverloadedQueuesQuery, GetOverloadedQueuesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetOverloadedQueuesQuery | undefined,
  GetOverloadedQueuesQueryVariables
>;
export function useGetOverloadedQueuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOverloadedQueuesQuery, GetOverloadedQueuesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOverloadedQueuesQuery, GetOverloadedQueuesQueryVariables>(
    GetOverloadedQueuesDocument,
    options,
  );
}
export type GetOverloadedQueuesQueryHookResult = ReturnType<typeof useGetOverloadedQueuesQuery>;
export type GetOverloadedQueuesLazyQueryHookResult = ReturnType<
  typeof useGetOverloadedQueuesLazyQuery
>;
export type GetOverloadedQueuesSuspenseQueryHookResult = ReturnType<
  typeof useGetOverloadedQueuesSuspenseQuery
>;
export type GetOverloadedQueuesQueryResult = Apollo.QueryResult<
  GetOverloadedQueuesQuery,
  GetOverloadedQueuesQueryVariables
>;
export const GetQueuesWithSlaBreachesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetQueuesWithSlaBreaches' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getQueuesWithSlaBreaches' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetQueuesWithSlaBreachesQuery__
 *
 * To run a query within a React component, call `useGetQueuesWithSlaBreachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueuesWithSlaBreachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueuesWithSlaBreachesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetQueuesWithSlaBreachesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueuesWithSlaBreachesQuery,
    GetQueuesWithSlaBreachesQueryVariables
  > &
    ({ variables: GetQueuesWithSlaBreachesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQueuesWithSlaBreachesQuery, GetQueuesWithSlaBreachesQueryVariables>(
    GetQueuesWithSlaBreachesDocument,
    options,
  );
}
export function useGetQueuesWithSlaBreachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueuesWithSlaBreachesQuery,
    GetQueuesWithSlaBreachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQueuesWithSlaBreachesQuery, GetQueuesWithSlaBreachesQueryVariables>(
    GetQueuesWithSlaBreachesDocument,
    options,
  );
}
// @ts-ignore
export function useGetQueuesWithSlaBreachesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueuesWithSlaBreachesQuery,
    GetQueuesWithSlaBreachesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetQueuesWithSlaBreachesQuery,
  GetQueuesWithSlaBreachesQueryVariables
>;
export function useGetQueuesWithSlaBreachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueuesWithSlaBreachesQuery,
        GetQueuesWithSlaBreachesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueuesWithSlaBreachesQuery | undefined,
  GetQueuesWithSlaBreachesQueryVariables
>;
export function useGetQueuesWithSlaBreachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueuesWithSlaBreachesQuery,
        GetQueuesWithSlaBreachesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetQueuesWithSlaBreachesQuery,
    GetQueuesWithSlaBreachesQueryVariables
  >(GetQueuesWithSlaBreachesDocument, options);
}
export type GetQueuesWithSlaBreachesQueryHookResult = ReturnType<
  typeof useGetQueuesWithSlaBreachesQuery
>;
export type GetQueuesWithSlaBreachesLazyQueryHookResult = ReturnType<
  typeof useGetQueuesWithSlaBreachesLazyQuery
>;
export type GetQueuesWithSlaBreachesSuspenseQueryHookResult = ReturnType<
  typeof useGetQueuesWithSlaBreachesSuspenseQuery
>;
export type GetQueuesWithSlaBreachesQueryResult = Apollo.QueryResult<
  GetQueuesWithSlaBreachesQuery,
  GetQueuesWithSlaBreachesQueryVariables
>;
export const ApprovalEnqueueTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApprovalEnqueueTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlEnqueueTaskInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enqueueTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApprovalEnqueueTaskMutationFn = ApolloMutationFunction<
  ApprovalEnqueueTaskMutation,
  ApprovalEnqueueTaskMutationVariables
>;

/**
 * __useApprovalEnqueueTaskMutation__
 *
 * To run a mutation, you first call `useApprovalEnqueueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalEnqueueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalEnqueueTaskMutation, { data, loading, error }] = useApprovalEnqueueTaskMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovalEnqueueTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovalEnqueueTaskMutation,
    ApprovalEnqueueTaskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApprovalEnqueueTaskMutation, ApprovalEnqueueTaskMutationVariables>(
    ApprovalEnqueueTaskDocument,
    options,
  );
}
export type ApprovalEnqueueTaskMutationHookResult = ReturnType<
  typeof useApprovalEnqueueTaskMutation
>;
export type ApprovalEnqueueTaskMutationResult = Apollo.MutationResult<ApprovalEnqueueTaskMutation>;
export type ApprovalEnqueueTaskMutationOptions = ApolloBaseMutationOptions<
  ApprovalEnqueueTaskMutation,
  ApprovalEnqueueTaskMutationVariables
>;
export const ApprovalDequeueTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApprovalDequeueTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dequeueTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApprovalDequeueTaskMutationFn = ApolloMutationFunction<
  ApprovalDequeueTaskMutation,
  ApprovalDequeueTaskMutationVariables
>;

/**
 * __useApprovalDequeueTaskMutation__
 *
 * To run a mutation, you first call `useApprovalDequeueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalDequeueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalDequeueTaskMutation, { data, loading, error }] = useApprovalDequeueTaskMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useApprovalDequeueTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovalDequeueTaskMutation,
    ApprovalDequeueTaskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApprovalDequeueTaskMutation, ApprovalDequeueTaskMutationVariables>(
    ApprovalDequeueTaskDocument,
    options,
  );
}
export type ApprovalDequeueTaskMutationHookResult = ReturnType<
  typeof useApprovalDequeueTaskMutation
>;
export type ApprovalDequeueTaskMutationResult = Apollo.MutationResult<ApprovalDequeueTaskMutation>;
export type ApprovalDequeueTaskMutationOptions = ApolloBaseMutationOptions<
  ApprovalDequeueTaskMutation,
  ApprovalDequeueTaskMutationVariables
>;
export const ApprovalPauseQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApprovalPauseQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pauseQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApprovalPauseQueueMutationFn = ApolloMutationFunction<
  ApprovalPauseQueueMutation,
  ApprovalPauseQueueMutationVariables
>;

/**
 * __useApprovalPauseQueueMutation__
 *
 * To run a mutation, you first call `useApprovalPauseQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalPauseQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalPauseQueueMutation, { data, loading, error }] = useApprovalPauseQueueMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useApprovalPauseQueueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovalPauseQueueMutation,
    ApprovalPauseQueueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApprovalPauseQueueMutation, ApprovalPauseQueueMutationVariables>(
    ApprovalPauseQueueDocument,
    options,
  );
}
export type ApprovalPauseQueueMutationHookResult = ReturnType<typeof useApprovalPauseQueueMutation>;
export type ApprovalPauseQueueMutationResult = Apollo.MutationResult<ApprovalPauseQueueMutation>;
export type ApprovalPauseQueueMutationOptions = ApolloBaseMutationOptions<
  ApprovalPauseQueueMutation,
  ApprovalPauseQueueMutationVariables
>;
export const ApprovalResumeQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApprovalResumeQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApprovalResumeQueueMutationFn = ApolloMutationFunction<
  ApprovalResumeQueueMutation,
  ApprovalResumeQueueMutationVariables
>;

/**
 * __useApprovalResumeQueueMutation__
 *
 * To run a mutation, you first call `useApprovalResumeQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalResumeQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalResumeQueueMutation, { data, loading, error }] = useApprovalResumeQueueMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useApprovalResumeQueueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovalResumeQueueMutation,
    ApprovalResumeQueueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApprovalResumeQueueMutation, ApprovalResumeQueueMutationVariables>(
    ApprovalResumeQueueDocument,
    options,
  );
}
export type ApprovalResumeQueueMutationHookResult = ReturnType<
  typeof useApprovalResumeQueueMutation
>;
export type ApprovalResumeQueueMutationResult = Apollo.MutationResult<ApprovalResumeQueueMutation>;
export type ApprovalResumeQueueMutationOptions = ApolloBaseMutationOptions<
  ApprovalResumeQueueMutation,
  ApprovalResumeQueueMutationVariables
>;
export const ApprovalDrainQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApprovalDrainQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'drainQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueDetailFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Queue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avgWaitTimeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processingRatePerHour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsProcessedToday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oldestItemAgeSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaBreachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overflowStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deduplicationEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priorityBoostEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxConcurrentAssignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performanceAlertEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApprovalDrainQueueMutationFn = ApolloMutationFunction<
  ApprovalDrainQueueMutation,
  ApprovalDrainQueueMutationVariables
>;

/**
 * __useApprovalDrainQueueMutation__
 *
 * To run a mutation, you first call `useApprovalDrainQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalDrainQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalDrainQueueMutation, { data, loading, error }] = useApprovalDrainQueueMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useApprovalDrainQueueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovalDrainQueueMutation,
    ApprovalDrainQueueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApprovalDrainQueueMutation, ApprovalDrainQueueMutationVariables>(
    ApprovalDrainQueueDocument,
    options,
  );
}
export type ApprovalDrainQueueMutationHookResult = ReturnType<typeof useApprovalDrainQueueMutation>;
export type ApprovalDrainQueueMutationResult = Apollo.MutationResult<ApprovalDrainQueueMutation>;
export type ApprovalDrainQueueMutationOptions = ApolloBaseMutationOptions<
  ApprovalDrainQueueMutation,
  ApprovalDrainQueueMutationVariables
>;
export const GetNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNotification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notificationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NotificationDetailFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTaskIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedApprovalIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetNotificationQuery__
 *
 * To run a query within a React component, call `useGetNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationQuery({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useGetNotificationQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables> &
    ({ variables: GetNotificationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationQuery, GetNotificationQueryVariables>(
    GetNotificationDocument,
    options,
  );
}
export function useGetNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNotificationQuery, GetNotificationQueryVariables>(
    GetNotificationDocument,
    options,
  );
}
// @ts-ignore
export function useGetNotificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNotificationQuery,
    GetNotificationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetNotificationQuery, GetNotificationQueryVariables>;
export function useGetNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetNotificationQuery | undefined, GetNotificationQueryVariables>;
export function useGetNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNotificationQuery, GetNotificationQueryVariables>(
    GetNotificationDocument,
    options,
  );
}
export type GetNotificationQueryHookResult = ReturnType<typeof useGetNotificationQuery>;
export type GetNotificationLazyQueryHookResult = ReturnType<typeof useGetNotificationLazyQuery>;
export type GetNotificationSuspenseQueryHookResult = ReturnType<
  typeof useGetNotificationSuspenseQuery
>;
export type GetNotificationQueryResult = Apollo.QueryResult<
  GetNotificationQuery,
  GetNotificationQueryVariables
>;
export const ListNotificationsForRecipientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListNotificationsForRecipient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'recipientActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listNotificationsForRecipient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipientActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'recipientActorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'NotificationDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTaskIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedApprovalIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListNotificationsForRecipientQuery__
 *
 * To run a query within a React component, call `useListNotificationsForRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotificationsForRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotificationsForRecipientQuery({
 *   variables: {
 *      recipientActorId: // value for 'recipientActorId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListNotificationsForRecipientQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListNotificationsForRecipientQuery,
    ListNotificationsForRecipientQueryVariables
  > &
    (
      | { variables: ListNotificationsForRecipientQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListNotificationsForRecipientQuery,
    ListNotificationsForRecipientQueryVariables
  >(ListNotificationsForRecipientDocument, options);
}
export function useListNotificationsForRecipientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListNotificationsForRecipientQuery,
    ListNotificationsForRecipientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListNotificationsForRecipientQuery,
    ListNotificationsForRecipientQueryVariables
  >(ListNotificationsForRecipientDocument, options);
}
// @ts-ignore
export function useListNotificationsForRecipientSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListNotificationsForRecipientQuery,
    ListNotificationsForRecipientQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsForRecipientQuery,
  ListNotificationsForRecipientQueryVariables
>;
export function useListNotificationsForRecipientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsForRecipientQuery,
        ListNotificationsForRecipientQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsForRecipientQuery | undefined,
  ListNotificationsForRecipientQueryVariables
>;
export function useListNotificationsForRecipientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsForRecipientQuery,
        ListNotificationsForRecipientQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListNotificationsForRecipientQuery,
    ListNotificationsForRecipientQueryVariables
  >(ListNotificationsForRecipientDocument, options);
}
export type ListNotificationsForRecipientQueryHookResult = ReturnType<
  typeof useListNotificationsForRecipientQuery
>;
export type ListNotificationsForRecipientLazyQueryHookResult = ReturnType<
  typeof useListNotificationsForRecipientLazyQuery
>;
export type ListNotificationsForRecipientSuspenseQueryHookResult = ReturnType<
  typeof useListNotificationsForRecipientSuspenseQuery
>;
export type ListNotificationsForRecipientQueryResult = Apollo.QueryResult<
  ListNotificationsForRecipientQuery,
  ListNotificationsForRecipientQueryVariables
>;
export const ListNotificationsByStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListNotificationsByStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlNotificationStatus' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listNotificationsByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'NotificationDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTaskIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedApprovalIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListNotificationsByStatusQuery__
 *
 * To run a query within a React component, call `useListNotificationsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotificationsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotificationsByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListNotificationsByStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListNotificationsByStatusQuery,
    ListNotificationsByStatusQueryVariables
  > &
    ({ variables: ListNotificationsByStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListNotificationsByStatusQuery, ListNotificationsByStatusQueryVariables>(
    ListNotificationsByStatusDocument,
    options,
  );
}
export function useListNotificationsByStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListNotificationsByStatusQuery,
    ListNotificationsByStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListNotificationsByStatusQuery,
    ListNotificationsByStatusQueryVariables
  >(ListNotificationsByStatusDocument, options);
}
// @ts-ignore
export function useListNotificationsByStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListNotificationsByStatusQuery,
    ListNotificationsByStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsByStatusQuery,
  ListNotificationsByStatusQueryVariables
>;
export function useListNotificationsByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsByStatusQuery,
        ListNotificationsByStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsByStatusQuery | undefined,
  ListNotificationsByStatusQueryVariables
>;
export function useListNotificationsByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsByStatusQuery,
        ListNotificationsByStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListNotificationsByStatusQuery,
    ListNotificationsByStatusQueryVariables
  >(ListNotificationsByStatusDocument, options);
}
export type ListNotificationsByStatusQueryHookResult = ReturnType<
  typeof useListNotificationsByStatusQuery
>;
export type ListNotificationsByStatusLazyQueryHookResult = ReturnType<
  typeof useListNotificationsByStatusLazyQuery
>;
export type ListNotificationsByStatusSuspenseQueryHookResult = ReturnType<
  typeof useListNotificationsByStatusSuspenseQuery
>;
export type ListNotificationsByStatusQueryResult = Apollo.QueryResult<
  ListNotificationsByStatusQuery,
  ListNotificationsByStatusQueryVariables
>;
export const ListNotificationsByTenantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListNotificationsByTenant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listNotificationsByTenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'NotificationDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTaskIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedApprovalIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListNotificationsByTenantQuery__
 *
 * To run a query within a React component, call `useListNotificationsByTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotificationsByTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotificationsByTenantQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListNotificationsByTenantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListNotificationsByTenantQuery,
    ListNotificationsByTenantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListNotificationsByTenantQuery, ListNotificationsByTenantQueryVariables>(
    ListNotificationsByTenantDocument,
    options,
  );
}
export function useListNotificationsByTenantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListNotificationsByTenantQuery,
    ListNotificationsByTenantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListNotificationsByTenantQuery,
    ListNotificationsByTenantQueryVariables
  >(ListNotificationsByTenantDocument, options);
}
// @ts-ignore
export function useListNotificationsByTenantSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListNotificationsByTenantQuery,
    ListNotificationsByTenantQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsByTenantQuery,
  ListNotificationsByTenantQueryVariables
>;
export function useListNotificationsByTenantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsByTenantQuery,
        ListNotificationsByTenantQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsByTenantQuery | undefined,
  ListNotificationsByTenantQueryVariables
>;
export function useListNotificationsByTenantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsByTenantQuery,
        ListNotificationsByTenantQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListNotificationsByTenantQuery,
    ListNotificationsByTenantQueryVariables
  >(ListNotificationsByTenantDocument, options);
}
export type ListNotificationsByTenantQueryHookResult = ReturnType<
  typeof useListNotificationsByTenantQuery
>;
export type ListNotificationsByTenantLazyQueryHookResult = ReturnType<
  typeof useListNotificationsByTenantLazyQuery
>;
export type ListNotificationsByTenantSuspenseQueryHookResult = ReturnType<
  typeof useListNotificationsByTenantSuspenseQuery
>;
export type ListNotificationsByTenantQueryResult = Apollo.QueryResult<
  ListNotificationsByTenantQuery,
  ListNotificationsByTenantQueryVariables
>;
export const ApprovalListNotificationsByTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApprovalListNotificationsByTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'triggerEntityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'triggerEntityId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listNotificationsByTrigger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'triggerEntityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'triggerEntityType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'triggerEntityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'triggerEntityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'NotificationDetailFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Notification' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveredAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ccActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedTaskIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relatedApprovalIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useApprovalListNotificationsByTriggerQuery__
 *
 * To run a query within a React component, call `useApprovalListNotificationsByTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalListNotificationsByTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalListNotificationsByTriggerQuery({
 *   variables: {
 *      triggerEntityType: // value for 'triggerEntityType'
 *      triggerEntityId: // value for 'triggerEntityId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useApprovalListNotificationsByTriggerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApprovalListNotificationsByTriggerQuery,
    ApprovalListNotificationsByTriggerQueryVariables
  > &
    (
      | { variables: ApprovalListNotificationsByTriggerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ApprovalListNotificationsByTriggerQuery,
    ApprovalListNotificationsByTriggerQueryVariables
  >(ApprovalListNotificationsByTriggerDocument, options);
}
export function useApprovalListNotificationsByTriggerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApprovalListNotificationsByTriggerQuery,
    ApprovalListNotificationsByTriggerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ApprovalListNotificationsByTriggerQuery,
    ApprovalListNotificationsByTriggerQueryVariables
  >(ApprovalListNotificationsByTriggerDocument, options);
}
// @ts-ignore
export function useApprovalListNotificationsByTriggerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApprovalListNotificationsByTriggerQuery,
    ApprovalListNotificationsByTriggerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ApprovalListNotificationsByTriggerQuery,
  ApprovalListNotificationsByTriggerQueryVariables
>;
export function useApprovalListNotificationsByTriggerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApprovalListNotificationsByTriggerQuery,
        ApprovalListNotificationsByTriggerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ApprovalListNotificationsByTriggerQuery | undefined,
  ApprovalListNotificationsByTriggerQueryVariables
>;
export function useApprovalListNotificationsByTriggerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApprovalListNotificationsByTriggerQuery,
        ApprovalListNotificationsByTriggerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ApprovalListNotificationsByTriggerQuery,
    ApprovalListNotificationsByTriggerQueryVariables
  >(ApprovalListNotificationsByTriggerDocument, options);
}
export type ApprovalListNotificationsByTriggerQueryHookResult = ReturnType<
  typeof useApprovalListNotificationsByTriggerQuery
>;
export type ApprovalListNotificationsByTriggerLazyQueryHookResult = ReturnType<
  typeof useApprovalListNotificationsByTriggerLazyQuery
>;
export type ApprovalListNotificationsByTriggerSuspenseQueryHookResult = ReturnType<
  typeof useApprovalListNotificationsByTriggerSuspenseQuery
>;
export type ApprovalListNotificationsByTriggerQueryResult = Apollo.QueryResult<
  ApprovalListNotificationsByTriggerQuery,
  ApprovalListNotificationsByTriggerQueryVariables
>;
export const GetUnreadNotificationCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUnreadNotificationCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'recipientActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUnreadCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipientActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'recipientActorId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetUnreadNotificationCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationCountQuery({
 *   variables: {
 *      recipientActorId: // value for 'recipientActorId'
 *   },
 * });
 */
export function useGetUnreadNotificationCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  > &
    ({ variables: GetUnreadNotificationCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>(
    GetUnreadNotificationCountDocument,
    options,
  );
}
export function useGetUnreadNotificationCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >(GetUnreadNotificationCountDocument, options);
}
// @ts-ignore
export function useGetUnreadNotificationCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetUnreadNotificationCountQuery,
  GetUnreadNotificationCountQueryVariables
>;
export function useGetUnreadNotificationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUnreadNotificationCountQuery,
        GetUnreadNotificationCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetUnreadNotificationCountQuery | undefined,
  GetUnreadNotificationCountQueryVariables
>;
export function useGetUnreadNotificationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUnreadNotificationCountQuery,
        GetUnreadNotificationCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >(GetUnreadNotificationCountDocument, options);
}
export type GetUnreadNotificationCountQueryHookResult = ReturnType<
  typeof useGetUnreadNotificationCountQuery
>;
export type GetUnreadNotificationCountLazyQueryHookResult = ReturnType<
  typeof useGetUnreadNotificationCountLazyQuery
>;
export type GetUnreadNotificationCountSuspenseQueryHookResult = ReturnType<
  typeof useGetUnreadNotificationCountSuspenseQuery
>;
export type GetUnreadNotificationCountQueryResult = Apollo.QueryResult<
  GetUnreadNotificationCountQuery,
  GetUnreadNotificationCountQueryVariables
>;
export const GetAiTaskGuidanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GetAiTaskGuidance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetTaskGuidanceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAiTaskGuidance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'response' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processingTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GetAiTaskGuidanceMutationFn = ApolloMutationFunction<
  GetAiTaskGuidanceMutation,
  GetAiTaskGuidanceMutationVariables
>;

/**
 * __useGetAiTaskGuidanceMutation__
 *
 * To run a mutation, you first call `useGetAiTaskGuidanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAiTaskGuidanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAiTaskGuidanceMutation, { data, loading, error }] = useGetAiTaskGuidanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAiTaskGuidanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetAiTaskGuidanceMutation,
    GetAiTaskGuidanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GetAiTaskGuidanceMutation, GetAiTaskGuidanceMutationVariables>(
    GetAiTaskGuidanceDocument,
    options,
  );
}
export type GetAiTaskGuidanceMutationHookResult = ReturnType<typeof useGetAiTaskGuidanceMutation>;
export type GetAiTaskGuidanceMutationResult = Apollo.MutationResult<GetAiTaskGuidanceMutation>;
export type GetAiTaskGuidanceMutationOptions = ApolloBaseMutationOptions<
  GetAiTaskGuidanceMutation,
  GetAiTaskGuidanceMutationVariables
>;
export const GenerateTaskInstructionsPdfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateTaskInstructionsPdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateTaskInstructionsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateTaskInstructionsPdf' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateTaskInstructionsPdfMutationFn = ApolloMutationFunction<
  GenerateTaskInstructionsPdfMutation,
  GenerateTaskInstructionsPdfMutationVariables
>;

/**
 * __useGenerateTaskInstructionsPdfMutation__
 *
 * To run a mutation, you first call `useGenerateTaskInstructionsPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaskInstructionsPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaskInstructionsPdfMutation, { data, loading, error }] = useGenerateTaskInstructionsPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTaskInstructionsPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateTaskInstructionsPdfMutation,
    GenerateTaskInstructionsPdfMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateTaskInstructionsPdfMutation,
    GenerateTaskInstructionsPdfMutationVariables
  >(GenerateTaskInstructionsPdfDocument, options);
}
export type GenerateTaskInstructionsPdfMutationHookResult = ReturnType<
  typeof useGenerateTaskInstructionsPdfMutation
>;
export type GenerateTaskInstructionsPdfMutationResult =
  Apollo.MutationResult<GenerateTaskInstructionsPdfMutation>;
export type GenerateTaskInstructionsPdfMutationOptions = ApolloBaseMutationOptions<
  GenerateTaskInstructionsPdfMutation,
  GenerateTaskInstructionsPdfMutationVariables
>;
export const DelegateTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DelegateTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delegateTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toUserId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toUserId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignees' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DelegateTaskMutationFn = ApolloMutationFunction<
  DelegateTaskMutation,
  DelegateTaskMutationVariables
>;

/**
 * __useDelegateTaskMutation__
 *
 * To run a mutation, you first call `useDelegateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelegateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delegateTaskMutation, { data, loading, error }] = useDelegateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      toUserId: // value for 'toUserId'
 *   },
 * });
 */
export function useDelegateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<DelegateTaskMutation, DelegateTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DelegateTaskMutation, DelegateTaskMutationVariables>(
    DelegateTaskDocument,
    options,
  );
}
export type DelegateTaskMutationHookResult = ReturnType<typeof useDelegateTaskMutation>;
export type DelegateTaskMutationResult = Apollo.MutationResult<DelegateTaskMutation>;
export type DelegateTaskMutationOptions = ApolloBaseMutationOptions<
  DelegateTaskMutation,
  DelegateTaskMutationVariables
>;
export const RecordDocumentApprovalDecisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordDocumentApprovalDecision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'decision' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiRecordDocumentApprovalDecision' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approverId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approverId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'decision' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'decision' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordDocumentApprovalDecisionMutationFn = ApolloMutationFunction<
  RecordDocumentApprovalDecisionMutation,
  RecordDocumentApprovalDecisionMutationVariables
>;

/**
 * __useRecordDocumentApprovalDecisionMutation__
 *
 * To run a mutation, you first call `useRecordDocumentApprovalDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordDocumentApprovalDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordDocumentApprovalDecisionMutation, { data, loading, error }] = useRecordDocumentApprovalDecisionMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *      approverId: // value for 'approverId'
 *      decision: // value for 'decision'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRecordDocumentApprovalDecisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordDocumentApprovalDecisionMutation,
    RecordDocumentApprovalDecisionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordDocumentApprovalDecisionMutation,
    RecordDocumentApprovalDecisionMutationVariables
  >(RecordDocumentApprovalDecisionDocument, options);
}
export type RecordDocumentApprovalDecisionMutationHookResult = ReturnType<
  typeof useRecordDocumentApprovalDecisionMutation
>;
export type RecordDocumentApprovalDecisionMutationResult =
  Apollo.MutationResult<RecordDocumentApprovalDecisionMutation>;
export type RecordDocumentApprovalDecisionMutationOptions = ApolloBaseMutationOptions<
  RecordDocumentApprovalDecisionMutation,
  RecordDocumentApprovalDecisionMutationVariables
>;
export const RecordPriorAuthApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordPriorAuthApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecordPriorAuthApprovalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordPriorAuthApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'authNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outboxQueued' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordPriorAuthApprovalMutationFn = ApolloMutationFunction<
  RecordPriorAuthApprovalMutation,
  RecordPriorAuthApprovalMutationVariables
>;

/**
 * __useRecordPriorAuthApprovalMutation__
 *
 * To run a mutation, you first call `useRecordPriorAuthApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPriorAuthApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPriorAuthApprovalMutation, { data, loading, error }] = useRecordPriorAuthApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordPriorAuthApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordPriorAuthApprovalMutation,
    RecordPriorAuthApprovalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordPriorAuthApprovalMutation,
    RecordPriorAuthApprovalMutationVariables
  >(RecordPriorAuthApprovalDocument, options);
}
export type RecordPriorAuthApprovalMutationHookResult = ReturnType<
  typeof useRecordPriorAuthApprovalMutation
>;
export type RecordPriorAuthApprovalMutationResult =
  Apollo.MutationResult<RecordPriorAuthApprovalMutation>;
export type RecordPriorAuthApprovalMutationOptions = ApolloBaseMutationOptions<
  RecordPriorAuthApprovalMutation,
  RecordPriorAuthApprovalMutationVariables
>;
export const SubmitTemplateForApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitTemplateForApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'templateApiSubmitTemplateForApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'requiresApproval' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineHours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidenceThreshold' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentConfidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalReviewRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalReviewReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitTemplateForApprovalMutationFn = ApolloMutationFunction<
  SubmitTemplateForApprovalMutation,
  SubmitTemplateForApprovalMutationVariables
>;

/**
 * __useSubmitTemplateForApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitTemplateForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTemplateForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTemplateForApprovalMutation, { data, loading, error }] = useSubmitTemplateForApprovalMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useSubmitTemplateForApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitTemplateForApprovalMutation,
    SubmitTemplateForApprovalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitTemplateForApprovalMutation,
    SubmitTemplateForApprovalMutationVariables
  >(SubmitTemplateForApprovalDocument, options);
}
export type SubmitTemplateForApprovalMutationHookResult = ReturnType<
  typeof useSubmitTemplateForApprovalMutation
>;
export type SubmitTemplateForApprovalMutationResult =
  Apollo.MutationResult<SubmitTemplateForApprovalMutation>;
export type SubmitTemplateForApprovalMutationOptions = ApolloBaseMutationOptions<
  SubmitTemplateForApprovalMutation,
  SubmitTemplateForApprovalMutationVariables
>;
export const GetPendingApprovalTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPendingApprovalTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'templateApiGetPendingApprovalTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPendingApprovalTemplatesQuery__
 *
 * To run a query within a React component, call `useGetPendingApprovalTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingApprovalTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingApprovalTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingApprovalTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPendingApprovalTemplatesQuery,
    GetPendingApprovalTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPendingApprovalTemplatesQuery,
    GetPendingApprovalTemplatesQueryVariables
  >(GetPendingApprovalTemplatesDocument, options);
}
export function useGetPendingApprovalTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingApprovalTemplatesQuery,
    GetPendingApprovalTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPendingApprovalTemplatesQuery,
    GetPendingApprovalTemplatesQueryVariables
  >(GetPendingApprovalTemplatesDocument, options);
}
// @ts-ignore
export function useGetPendingApprovalTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingApprovalTemplatesQuery,
    GetPendingApprovalTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPendingApprovalTemplatesQuery,
  GetPendingApprovalTemplatesQueryVariables
>;
export function useGetPendingApprovalTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingApprovalTemplatesQuery,
        GetPendingApprovalTemplatesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPendingApprovalTemplatesQuery | undefined,
  GetPendingApprovalTemplatesQueryVariables
>;
export function useGetPendingApprovalTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingApprovalTemplatesQuery,
        GetPendingApprovalTemplatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPendingApprovalTemplatesQuery,
    GetPendingApprovalTemplatesQueryVariables
  >(GetPendingApprovalTemplatesDocument, options);
}
export type GetPendingApprovalTemplatesQueryHookResult = ReturnType<
  typeof useGetPendingApprovalTemplatesQuery
>;
export type GetPendingApprovalTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetPendingApprovalTemplatesLazyQuery
>;
export type GetPendingApprovalTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingApprovalTemplatesSuspenseQuery
>;
export type GetPendingApprovalTemplatesQueryResult = Apollo.QueryResult<
  GetPendingApprovalTemplatesQuery,
  GetPendingApprovalTemplatesQueryVariables
>;
export const GetAuditApprovalChainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAuditApprovalChain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'auditId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAuditApprovalChain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'auditId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'auditId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAuditApprovalChainQuery__
 *
 * To run a query within a React component, call `useGetAuditApprovalChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditApprovalChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditApprovalChainQuery({
 *   variables: {
 *      auditId: // value for 'auditId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetAuditApprovalChainQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAuditApprovalChainQuery,
    GetAuditApprovalChainQueryVariables
  > &
    ({ variables: GetAuditApprovalChainQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditApprovalChainQuery, GetAuditApprovalChainQueryVariables>(
    GetAuditApprovalChainDocument,
    options,
  );
}
export function useGetAuditApprovalChainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAuditApprovalChainQuery,
    GetAuditApprovalChainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditApprovalChainQuery, GetAuditApprovalChainQueryVariables>(
    GetAuditApprovalChainDocument,
    options,
  );
}
// @ts-ignore
export function useGetAuditApprovalChainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAuditApprovalChainQuery,
    GetAuditApprovalChainQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAuditApprovalChainQuery, GetAuditApprovalChainQueryVariables>;
export function useGetAuditApprovalChainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditApprovalChainQuery,
        GetAuditApprovalChainQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAuditApprovalChainQuery | undefined,
  GetAuditApprovalChainQueryVariables
>;
export function useGetAuditApprovalChainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditApprovalChainQuery,
        GetAuditApprovalChainQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAuditApprovalChainQuery, GetAuditApprovalChainQueryVariables>(
    GetAuditApprovalChainDocument,
    options,
  );
}
export type GetAuditApprovalChainQueryHookResult = ReturnType<typeof useGetAuditApprovalChainQuery>;
export type GetAuditApprovalChainLazyQueryHookResult = ReturnType<
  typeof useGetAuditApprovalChainLazyQuery
>;
export type GetAuditApprovalChainSuspenseQueryHookResult = ReturnType<
  typeof useGetAuditApprovalChainSuspenseQuery
>;
export type GetAuditApprovalChainQueryResult = Apollo.QueryResult<
  GetAuditApprovalChainQuery,
  GetAuditApprovalChainQueryVariables
>;
export const ElevateForTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ElevateForTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'elevateForTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ElevateForTaskMutationFn = ApolloMutationFunction<
  ElevateForTaskMutation,
  ElevateForTaskMutationVariables
>;

/**
 * __useElevateForTaskMutation__
 *
 * To run a mutation, you first call `useElevateForTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useElevateForTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [elevateForTaskMutation, { data, loading, error }] = useElevateForTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useElevateForTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<ElevateForTaskMutation, ElevateForTaskMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ElevateForTaskMutation, ElevateForTaskMutationVariables>(
    ElevateForTaskDocument,
    options,
  );
}
export type ElevateForTaskMutationHookResult = ReturnType<typeof useElevateForTaskMutation>;
export type ElevateForTaskMutationResult = Apollo.MutationResult<ElevateForTaskMutation>;
export type ElevateForTaskMutationOptions = ApolloBaseMutationOptions<
  ElevateForTaskMutation,
  ElevateForTaskMutationVariables
>;
export const ApproverPlanQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApproverPlanQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'authorityRole' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approverPlanQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'authorityRole' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'authorityRole' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredAuthorityRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInitial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'daysUntilExpiry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useApproverPlanQueueQuery__
 *
 * To run a query within a React component, call `useApproverPlanQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproverPlanQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproverPlanQueueQuery({
 *   variables: {
 *      authorityRole: // value for 'authorityRole'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useApproverPlanQueueQuery(
  baseOptions: Apollo.QueryHookOptions<ApproverPlanQueueQuery, ApproverPlanQueueQueryVariables> &
    ({ variables: ApproverPlanQueueQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApproverPlanQueueQuery, ApproverPlanQueueQueryVariables>(
    ApproverPlanQueueDocument,
    options,
  );
}
export function useApproverPlanQueueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApproverPlanQueueQuery,
    ApproverPlanQueueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ApproverPlanQueueQuery, ApproverPlanQueueQueryVariables>(
    ApproverPlanQueueDocument,
    options,
  );
}
// @ts-ignore
export function useApproverPlanQueueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApproverPlanQueueQuery,
    ApproverPlanQueueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ApproverPlanQueueQuery, ApproverPlanQueueQueryVariables>;
export function useApproverPlanQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ApproverPlanQueueQuery, ApproverPlanQueueQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ApproverPlanQueueQuery | undefined,
  ApproverPlanQueueQueryVariables
>;
export function useApproverPlanQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ApproverPlanQueueQuery, ApproverPlanQueueQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ApproverPlanQueueQuery, ApproverPlanQueueQueryVariables>(
    ApproverPlanQueueDocument,
    options,
  );
}
export type ApproverPlanQueueQueryHookResult = ReturnType<typeof useApproverPlanQueueQuery>;
export type ApproverPlanQueueLazyQueryHookResult = ReturnType<typeof useApproverPlanQueueLazyQuery>;
export type ApproverPlanQueueSuspenseQueryHookResult = ReturnType<
  typeof useApproverPlanQueueSuspenseQuery
>;
export type ApproverPlanQueueQueryResult = Apollo.QueryResult<
  ApproverPlanQueueQuery,
  ApproverPlanQueueQueryVariables
>;
export const ReviewerPlanQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReviewerPlanQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reviewerRole' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewerPlanQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reviewerRole' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reviewerRole' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredReviewerRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isInitial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'daysUntilExpiry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReviewerPlanQueueQuery__
 *
 * To run a query within a React component, call `useReviewerPlanQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewerPlanQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewerPlanQueueQuery({
 *   variables: {
 *      reviewerRole: // value for 'reviewerRole'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useReviewerPlanQueueQuery(
  baseOptions: Apollo.QueryHookOptions<ReviewerPlanQueueQuery, ReviewerPlanQueueQueryVariables> &
    ({ variables: ReviewerPlanQueueQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReviewerPlanQueueQuery, ReviewerPlanQueueQueryVariables>(
    ReviewerPlanQueueDocument,
    options,
  );
}
export function useReviewerPlanQueueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReviewerPlanQueueQuery,
    ReviewerPlanQueueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReviewerPlanQueueQuery, ReviewerPlanQueueQueryVariables>(
    ReviewerPlanQueueDocument,
    options,
  );
}
// @ts-ignore
export function useReviewerPlanQueueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReviewerPlanQueueQuery,
    ReviewerPlanQueueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReviewerPlanQueueQuery, ReviewerPlanQueueQueryVariables>;
export function useReviewerPlanQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewerPlanQueueQuery, ReviewerPlanQueueQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ReviewerPlanQueueQuery | undefined,
  ReviewerPlanQueueQueryVariables
>;
export function useReviewerPlanQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewerPlanQueueQuery, ReviewerPlanQueueQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReviewerPlanQueueQuery, ReviewerPlanQueueQueryVariables>(
    ReviewerPlanQueueDocument,
    options,
  );
}
export type ReviewerPlanQueueQueryHookResult = ReturnType<typeof useReviewerPlanQueueQuery>;
export type ReviewerPlanQueueLazyQueryHookResult = ReturnType<typeof useReviewerPlanQueueLazyQuery>;
export type ReviewerPlanQueueSuspenseQueryHookResult = ReturnType<
  typeof useReviewerPlanQueueSuspenseQuery
>;
export type ReviewerPlanQueueQueryResult = Apollo.QueryResult<
  ReviewerPlanQueueQuery,
  ReviewerPlanQueueQueryVariables
>;
export const PlanVersionComparisonDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlanVersionComparison' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'planVersionComparison' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'planId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'priorVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'proposedVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'changes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'changeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newValue' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isInitial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'daysUntilExpiry' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePlanVersionComparisonQuery__
 *
 * To run a query within a React component, call `usePlanVersionComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanVersionComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanVersionComparisonQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function usePlanVersionComparisonQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlanVersionComparisonQuery,
    PlanVersionComparisonQueryVariables
  > &
    ({ variables: PlanVersionComparisonQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlanVersionComparisonQuery, PlanVersionComparisonQueryVariables>(
    PlanVersionComparisonDocument,
    options,
  );
}
export function usePlanVersionComparisonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlanVersionComparisonQuery,
    PlanVersionComparisonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlanVersionComparisonQuery, PlanVersionComparisonQueryVariables>(
    PlanVersionComparisonDocument,
    options,
  );
}
// @ts-ignore
export function usePlanVersionComparisonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PlanVersionComparisonQuery,
    PlanVersionComparisonQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PlanVersionComparisonQuery, PlanVersionComparisonQueryVariables>;
export function usePlanVersionComparisonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PlanVersionComparisonQuery,
        PlanVersionComparisonQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PlanVersionComparisonQuery | undefined,
  PlanVersionComparisonQueryVariables
>;
export function usePlanVersionComparisonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PlanVersionComparisonQuery,
        PlanVersionComparisonQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PlanVersionComparisonQuery, PlanVersionComparisonQueryVariables>(
    PlanVersionComparisonDocument,
    options,
  );
}
export type PlanVersionComparisonQueryHookResult = ReturnType<typeof usePlanVersionComparisonQuery>;
export type PlanVersionComparisonLazyQueryHookResult = ReturnType<
  typeof usePlanVersionComparisonLazyQuery
>;
export type PlanVersionComparisonSuspenseQueryHookResult = ReturnType<
  typeof usePlanVersionComparisonSuspenseQuery
>;
export type PlanVersionComparisonQueryResult = Apollo.QueryResult<
  PlanVersionComparisonQuery,
  PlanVersionComparisonQueryVariables
>;
export const PriorPlanVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PriorPlanVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'priorPlanVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'planId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityDomains' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'domainId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domainName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePriorPlanVersionQuery__
 *
 * To run a query within a React component, call `usePriorPlanVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriorPlanVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriorPlanVersionQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function usePriorPlanVersionQuery(
  baseOptions: Apollo.QueryHookOptions<PriorPlanVersionQuery, PriorPlanVersionQueryVariables> &
    ({ variables: PriorPlanVersionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PriorPlanVersionQuery, PriorPlanVersionQueryVariables>(
    PriorPlanVersionDocument,
    options,
  );
}
export function usePriorPlanVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PriorPlanVersionQuery, PriorPlanVersionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PriorPlanVersionQuery, PriorPlanVersionQueryVariables>(
    PriorPlanVersionDocument,
    options,
  );
}
// @ts-ignore
export function usePriorPlanVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PriorPlanVersionQuery,
    PriorPlanVersionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PriorPlanVersionQuery, PriorPlanVersionQueryVariables>;
export function usePriorPlanVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PriorPlanVersionQuery, PriorPlanVersionQueryVariables>,
): Apollo.UseSuspenseQueryResult<PriorPlanVersionQuery | undefined, PriorPlanVersionQueryVariables>;
export function usePriorPlanVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PriorPlanVersionQuery, PriorPlanVersionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PriorPlanVersionQuery, PriorPlanVersionQueryVariables>(
    PriorPlanVersionDocument,
    options,
  );
}
export type PriorPlanVersionQueryHookResult = ReturnType<typeof usePriorPlanVersionQuery>;
export type PriorPlanVersionLazyQueryHookResult = ReturnType<typeof usePriorPlanVersionLazyQuery>;
export type PriorPlanVersionSuspenseQueryHookResult = ReturnType<
  typeof usePriorPlanVersionSuspenseQuery
>;
export type PriorPlanVersionQueryResult = Apollo.QueryResult<
  PriorPlanVersionQuery,
  PriorPlanVersionQueryVariables
>;
export const ServicePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ServicePlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servicePlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'planId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'planId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityDomains' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'domainId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domainName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'observations' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'approvedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewNotes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useServicePlanQuery__
 *
 * To run a query within a React component, call `useServicePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePlanQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useServicePlanQuery(
  baseOptions: Apollo.QueryHookOptions<ServicePlanQuery, ServicePlanQueryVariables> &
    ({ variables: ServicePlanQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ServicePlanQuery, ServicePlanQueryVariables>(ServicePlanDocument, options);
}
export function useServicePlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ServicePlanQuery, ServicePlanQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ServicePlanQuery, ServicePlanQueryVariables>(
    ServicePlanDocument,
    options,
  );
}
// @ts-ignore
export function useServicePlanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ServicePlanQuery, ServicePlanQueryVariables>,
): Apollo.UseSuspenseQueryResult<ServicePlanQuery, ServicePlanQueryVariables>;
export function useServicePlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ServicePlanQuery, ServicePlanQueryVariables>,
): Apollo.UseSuspenseQueryResult<ServicePlanQuery | undefined, ServicePlanQueryVariables>;
export function useServicePlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ServicePlanQuery, ServicePlanQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ServicePlanQuery, ServicePlanQueryVariables>(
    ServicePlanDocument,
    options,
  );
}
export type ServicePlanQueryHookResult = ReturnType<typeof useServicePlanQuery>;
export type ServicePlanLazyQueryHookResult = ReturnType<typeof useServicePlanLazyQuery>;
export type ServicePlanSuspenseQueryHookResult = ReturnType<typeof useServicePlanSuspenseQuery>;
export type ServicePlanQueryResult = Apollo.QueryResult<
  ServicePlanQuery,
  ServicePlanQueryVariables
>;
export const ServicePlansBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ServicePlansBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlanStatus' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servicePlansBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityDomains' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'domainId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domainName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'approvedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useServicePlansBySubjectQuery__
 *
 * To run a query within a React component, call `useServicePlansBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePlansBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePlansBySubjectQuery({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      tenantId: // value for 'tenantId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useServicePlansBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServicePlansBySubjectQuery,
    ServicePlansBySubjectQueryVariables
  > &
    ({ variables: ServicePlansBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ServicePlansBySubjectQuery, ServicePlansBySubjectQueryVariables>(
    ServicePlansBySubjectDocument,
    options,
  );
}
export function useServicePlansBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServicePlansBySubjectQuery,
    ServicePlansBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ServicePlansBySubjectQuery, ServicePlansBySubjectQueryVariables>(
    ServicePlansBySubjectDocument,
    options,
  );
}
// @ts-ignore
export function useServicePlansBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServicePlansBySubjectQuery,
    ServicePlansBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ServicePlansBySubjectQuery, ServicePlansBySubjectQueryVariables>;
export function useServicePlansBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServicePlansBySubjectQuery,
        ServicePlansBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServicePlansBySubjectQuery | undefined,
  ServicePlansBySubjectQueryVariables
>;
export function useServicePlansBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServicePlansBySubjectQuery,
        ServicePlansBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ServicePlansBySubjectQuery, ServicePlansBySubjectQueryVariables>(
    ServicePlansBySubjectDocument,
    options,
  );
}
export type ServicePlansBySubjectQueryHookResult = ReturnType<typeof useServicePlansBySubjectQuery>;
export type ServicePlansBySubjectLazyQueryHookResult = ReturnType<
  typeof useServicePlansBySubjectLazyQuery
>;
export type ServicePlansBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useServicePlansBySubjectSuspenseQuery
>;
export type ServicePlansBySubjectQueryResult = Apollo.QueryResult<
  ServicePlansBySubjectQuery,
  ServicePlansBySubjectQueryVariables
>;
export const ShiftWorkItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShiftWorkItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkItemStatus' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkItemType' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shiftWorkItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'itemType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'itemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'windowStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'windowEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instructions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShiftWorkItemsQuery__
 *
 * To run a query within a React component, call `useShiftWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftWorkItemsQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      tenantId: // value for 'tenantId'
 *      actorId: // value for 'actorId'
 *      status: // value for 'status'
 *      itemType: // value for 'itemType'
 *   },
 * });
 */
export function useShiftWorkItemsQuery(
  baseOptions: Apollo.QueryHookOptions<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables> &
    ({ variables: ShiftWorkItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>(
    ShiftWorkItemsDocument,
    options,
  );
}
export function useShiftWorkItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>(
    ShiftWorkItemsDocument,
    options,
  );
}
// @ts-ignore
export function useShiftWorkItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>;
export function useShiftWorkItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShiftWorkItemsQuery | undefined, ShiftWorkItemsQueryVariables>;
export function useShiftWorkItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ShiftWorkItemsQuery, ShiftWorkItemsQueryVariables>(
    ShiftWorkItemsDocument,
    options,
  );
}
export type ShiftWorkItemsQueryHookResult = ReturnType<typeof useShiftWorkItemsQuery>;
export type ShiftWorkItemsLazyQueryHookResult = ReturnType<typeof useShiftWorkItemsLazyQuery>;
export type ShiftWorkItemsSuspenseQueryHookResult = ReturnType<
  typeof useShiftWorkItemsSuspenseQuery
>;
export type ShiftWorkItemsQueryResult = Apollo.QueryResult<
  ShiftWorkItemsQuery,
  ShiftWorkItemsQueryVariables
>;
export const ItemsNeedingActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ItemsNeedingAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkItemType' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'itemsNeedingAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'itemType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'itemId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'windowStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'windowEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instructions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'actionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'urgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeUntilEscalation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useItemsNeedingActionQuery__
 *
 * To run a query within a React component, call `useItemsNeedingActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsNeedingActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsNeedingActionQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      itemType: // value for 'itemType'
 *      actorId: // value for 'actorId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useItemsNeedingActionQuery(
  baseOptions: Apollo.QueryHookOptions<ItemsNeedingActionQuery, ItemsNeedingActionQueryVariables> &
    ({ variables: ItemsNeedingActionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ItemsNeedingActionQuery, ItemsNeedingActionQueryVariables>(
    ItemsNeedingActionDocument,
    options,
  );
}
export function useItemsNeedingActionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ItemsNeedingActionQuery,
    ItemsNeedingActionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ItemsNeedingActionQuery, ItemsNeedingActionQueryVariables>(
    ItemsNeedingActionDocument,
    options,
  );
}
// @ts-ignore
export function useItemsNeedingActionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ItemsNeedingActionQuery,
    ItemsNeedingActionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ItemsNeedingActionQuery, ItemsNeedingActionQueryVariables>;
export function useItemsNeedingActionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ItemsNeedingActionQuery, ItemsNeedingActionQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ItemsNeedingActionQuery | undefined,
  ItemsNeedingActionQueryVariables
>;
export function useItemsNeedingActionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ItemsNeedingActionQuery, ItemsNeedingActionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ItemsNeedingActionQuery, ItemsNeedingActionQueryVariables>(
    ItemsNeedingActionDocument,
    options,
  );
}
export type ItemsNeedingActionQueryHookResult = ReturnType<typeof useItemsNeedingActionQuery>;
export type ItemsNeedingActionLazyQueryHookResult = ReturnType<
  typeof useItemsNeedingActionLazyQuery
>;
export type ItemsNeedingActionSuspenseQueryHookResult = ReturnType<
  typeof useItemsNeedingActionSuspenseQuery
>;
export type ItemsNeedingActionQueryResult = Apollo.QueryResult<
  ItemsNeedingActionQuery,
  ItemsNeedingActionQueryVariables
>;
export const ShiftScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShiftSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shiftSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overdueItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedActorIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShiftScheduleQuery__
 *
 * To run a query within a React component, call `useShiftScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftScheduleQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useShiftScheduleQuery(
  baseOptions: Apollo.QueryHookOptions<ShiftScheduleQuery, ShiftScheduleQueryVariables> &
    ({ variables: ShiftScheduleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShiftScheduleQuery, ShiftScheduleQueryVariables>(
    ShiftScheduleDocument,
    options,
  );
}
export function useShiftScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShiftScheduleQuery, ShiftScheduleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShiftScheduleQuery, ShiftScheduleQueryVariables>(
    ShiftScheduleDocument,
    options,
  );
}
// @ts-ignore
export function useShiftScheduleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ShiftScheduleQuery, ShiftScheduleQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShiftScheduleQuery, ShiftScheduleQueryVariables>;
export function useShiftScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShiftScheduleQuery, ShiftScheduleQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShiftScheduleQuery | undefined, ShiftScheduleQueryVariables>;
export function useShiftScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShiftScheduleQuery, ShiftScheduleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ShiftScheduleQuery, ShiftScheduleQueryVariables>(
    ShiftScheduleDocument,
    options,
  );
}
export type ShiftScheduleQueryHookResult = ReturnType<typeof useShiftScheduleQuery>;
export type ShiftScheduleLazyQueryHookResult = ReturnType<typeof useShiftScheduleLazyQuery>;
export type ShiftScheduleSuspenseQueryHookResult = ReturnType<typeof useShiftScheduleSuspenseQuery>;
export type ShiftScheduleQueryResult = Apollo.QueryResult<
  ShiftScheduleQuery,
  ShiftScheduleQueryVariables
>;
export const ShiftSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShiftSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shiftSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overdueItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedActorIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShiftSchedulesQuery__
 *
 * To run a query within a React component, call `useShiftSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftSchedulesQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      tenantId: // value for 'tenantId'
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useShiftSchedulesQuery(
  baseOptions: Apollo.QueryHookOptions<ShiftSchedulesQuery, ShiftSchedulesQueryVariables> &
    ({ variables: ShiftSchedulesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>(
    ShiftSchedulesDocument,
    options,
  );
}
export function useShiftSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>(
    ShiftSchedulesDocument,
    options,
  );
}
// @ts-ignore
export function useShiftSchedulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>;
export function useShiftSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShiftSchedulesQuery | undefined, ShiftSchedulesQueryVariables>;
export function useShiftSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ShiftSchedulesQuery, ShiftSchedulesQueryVariables>(
    ShiftSchedulesDocument,
    options,
  );
}
export type ShiftSchedulesQueryHookResult = ReturnType<typeof useShiftSchedulesQuery>;
export type ShiftSchedulesLazyQueryHookResult = ReturnType<typeof useShiftSchedulesLazyQuery>;
export type ShiftSchedulesSuspenseQueryHookResult = ReturnType<
  typeof useShiftSchedulesSuspenseQuery
>;
export type ShiftSchedulesQueryResult = Apollo.QueryResult<
  ShiftSchedulesQuery,
  ShiftSchedulesQueryVariables
>;
export const ShiftWorkItemsBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShiftWorkItemsBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shiftWorkItemsBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'itemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'windowStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'windowEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instructions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShiftWorkItemsBySubjectQuery__
 *
 * To run a query within a React component, call `useShiftWorkItemsBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftWorkItemsBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftWorkItemsBySubjectQuery({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      scheduleId: // value for 'scheduleId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useShiftWorkItemsBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShiftWorkItemsBySubjectQuery,
    ShiftWorkItemsBySubjectQueryVariables
  > &
    ({ variables: ShiftWorkItemsBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShiftWorkItemsBySubjectQuery, ShiftWorkItemsBySubjectQueryVariables>(
    ShiftWorkItemsBySubjectDocument,
    options,
  );
}
export function useShiftWorkItemsBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShiftWorkItemsBySubjectQuery,
    ShiftWorkItemsBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShiftWorkItemsBySubjectQuery, ShiftWorkItemsBySubjectQueryVariables>(
    ShiftWorkItemsBySubjectDocument,
    options,
  );
}
// @ts-ignore
export function useShiftWorkItemsBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShiftWorkItemsBySubjectQuery,
    ShiftWorkItemsBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ShiftWorkItemsBySubjectQuery,
  ShiftWorkItemsBySubjectQueryVariables
>;
export function useShiftWorkItemsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShiftWorkItemsBySubjectQuery,
        ShiftWorkItemsBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ShiftWorkItemsBySubjectQuery | undefined,
  ShiftWorkItemsBySubjectQueryVariables
>;
export function useShiftWorkItemsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShiftWorkItemsBySubjectQuery,
        ShiftWorkItemsBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShiftWorkItemsBySubjectQuery,
    ShiftWorkItemsBySubjectQueryVariables
  >(ShiftWorkItemsBySubjectDocument, options);
}
export type ShiftWorkItemsBySubjectQueryHookResult = ReturnType<
  typeof useShiftWorkItemsBySubjectQuery
>;
export type ShiftWorkItemsBySubjectLazyQueryHookResult = ReturnType<
  typeof useShiftWorkItemsBySubjectLazyQuery
>;
export type ShiftWorkItemsBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useShiftWorkItemsBySubjectSuspenseQuery
>;
export type ShiftWorkItemsBySubjectQueryResult = Apollo.QueryResult<
  ShiftWorkItemsBySubjectQuery,
  ShiftWorkItemsBySubjectQueryVariables
>;
export const ControlledItemCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControlledItemCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'controlledItemCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constraintId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constraintId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expectedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actualCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'withinTolerance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tolerance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVerifiedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verifiedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useControlledItemCountQuery__
 *
 * To run a query within a React component, call `useControlledItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlledItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlledItemCountQuery({
 *   variables: {
 *      constraintId: // value for 'constraintId'
 *      tenantId: // value for 'tenantId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useControlledItemCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    ControlledItemCountQuery,
    ControlledItemCountQueryVariables
  > &
    ({ variables: ControlledItemCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ControlledItemCountQuery, ControlledItemCountQueryVariables>(
    ControlledItemCountDocument,
    options,
  );
}
export function useControlledItemCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ControlledItemCountQuery,
    ControlledItemCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ControlledItemCountQuery, ControlledItemCountQueryVariables>(
    ControlledItemCountDocument,
    options,
  );
}
// @ts-ignore
export function useControlledItemCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ControlledItemCountQuery,
    ControlledItemCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ControlledItemCountQuery, ControlledItemCountQueryVariables>;
export function useControlledItemCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ControlledItemCountQuery, ControlledItemCountQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ControlledItemCountQuery | undefined,
  ControlledItemCountQueryVariables
>;
export function useControlledItemCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ControlledItemCountQuery, ControlledItemCountQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ControlledItemCountQuery, ControlledItemCountQueryVariables>(
    ControlledItemCountDocument,
    options,
  );
}
export type ControlledItemCountQueryHookResult = ReturnType<typeof useControlledItemCountQuery>;
export type ControlledItemCountLazyQueryHookResult = ReturnType<
  typeof useControlledItemCountLazyQuery
>;
export type ControlledItemCountSuspenseQueryHookResult = ReturnType<
  typeof useControlledItemCountSuspenseQuery
>;
export type ControlledItemCountQueryResult = Apollo.QueryResult<
  ControlledItemCountQuery,
  ControlledItemCountQueryVariables
>;
export const ControlledItemsNeedingVerificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControlledItemsNeedingVerification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constraintType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'controlledItemsNeedingVerification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constraintType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constraintType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'itemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVerifiedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVerifiedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextVerificationDue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useControlledItemsNeedingVerificationQuery__
 *
 * To run a query within a React component, call `useControlledItemsNeedingVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlledItemsNeedingVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlledItemsNeedingVerificationQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      constraintType: // value for 'constraintType'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useControlledItemsNeedingVerificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ControlledItemsNeedingVerificationQuery,
    ControlledItemsNeedingVerificationQueryVariables
  > &
    (
      | { variables: ControlledItemsNeedingVerificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ControlledItemsNeedingVerificationQuery,
    ControlledItemsNeedingVerificationQueryVariables
  >(ControlledItemsNeedingVerificationDocument, options);
}
export function useControlledItemsNeedingVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ControlledItemsNeedingVerificationQuery,
    ControlledItemsNeedingVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ControlledItemsNeedingVerificationQuery,
    ControlledItemsNeedingVerificationQueryVariables
  >(ControlledItemsNeedingVerificationDocument, options);
}
// @ts-ignore
export function useControlledItemsNeedingVerificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ControlledItemsNeedingVerificationQuery,
    ControlledItemsNeedingVerificationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ControlledItemsNeedingVerificationQuery,
  ControlledItemsNeedingVerificationQueryVariables
>;
export function useControlledItemsNeedingVerificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ControlledItemsNeedingVerificationQuery,
        ControlledItemsNeedingVerificationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ControlledItemsNeedingVerificationQuery | undefined,
  ControlledItemsNeedingVerificationQueryVariables
>;
export function useControlledItemsNeedingVerificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ControlledItemsNeedingVerificationQuery,
        ControlledItemsNeedingVerificationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ControlledItemsNeedingVerificationQuery,
    ControlledItemsNeedingVerificationQueryVariables
  >(ControlledItemsNeedingVerificationDocument, options);
}
export type ControlledItemsNeedingVerificationQueryHookResult = ReturnType<
  typeof useControlledItemsNeedingVerificationQuery
>;
export type ControlledItemsNeedingVerificationLazyQueryHookResult = ReturnType<
  typeof useControlledItemsNeedingVerificationLazyQuery
>;
export type ControlledItemsNeedingVerificationSuspenseQueryHookResult = ReturnType<
  typeof useControlledItemsNeedingVerificationSuspenseQuery
>;
export type ControlledItemsNeedingVerificationQueryResult = Apollo.QueryResult<
  ControlledItemsNeedingVerificationQuery,
  ControlledItemsNeedingVerificationQueryVariables
>;
export const ControlledItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControlledItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'controlledItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'itemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVerifiedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVerifiedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextVerificationDue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useControlledItemQuery__
 *
 * To run a query within a React component, call `useControlledItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlledItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlledItemQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useControlledItemQuery(
  baseOptions: Apollo.QueryHookOptions<ControlledItemQuery, ControlledItemQueryVariables> &
    ({ variables: ControlledItemQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ControlledItemQuery, ControlledItemQueryVariables>(
    ControlledItemDocument,
    options,
  );
}
export function useControlledItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ControlledItemQuery, ControlledItemQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ControlledItemQuery, ControlledItemQueryVariables>(
    ControlledItemDocument,
    options,
  );
}
// @ts-ignore
export function useControlledItemSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ControlledItemQuery, ControlledItemQueryVariables>,
): Apollo.UseSuspenseQueryResult<ControlledItemQuery, ControlledItemQueryVariables>;
export function useControlledItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ControlledItemQuery, ControlledItemQueryVariables>,
): Apollo.UseSuspenseQueryResult<ControlledItemQuery | undefined, ControlledItemQueryVariables>;
export function useControlledItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ControlledItemQuery, ControlledItemQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ControlledItemQuery, ControlledItemQueryVariables>(
    ControlledItemDocument,
    options,
  );
}
export type ControlledItemQueryHookResult = ReturnType<typeof useControlledItemQuery>;
export type ControlledItemLazyQueryHookResult = ReturnType<typeof useControlledItemLazyQuery>;
export type ControlledItemSuspenseQueryHookResult = ReturnType<
  typeof useControlledItemSuspenseQuery
>;
export type ControlledItemQueryResult = Apollo.QueryResult<
  ControlledItemQuery,
  ControlledItemQueryVariables
>;
export const ControlledItemsByConstraintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ControlledItemsByConstraint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ControlledItemStatus' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'controlledItemsByConstraint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constraintId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'itemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVerifiedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastVerifiedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextVerificationDue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useControlledItemsByConstraintQuery__
 *
 * To run a query within a React component, call `useControlledItemsByConstraintQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlledItemsByConstraintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlledItemsByConstraintQuery({
 *   variables: {
 *      constraintId: // value for 'constraintId'
 *      tenantId: // value for 'tenantId'
 *      status: // value for 'status'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useControlledItemsByConstraintQuery(
  baseOptions: Apollo.QueryHookOptions<
    ControlledItemsByConstraintQuery,
    ControlledItemsByConstraintQueryVariables
  > &
    ({ variables: ControlledItemsByConstraintQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ControlledItemsByConstraintQuery,
    ControlledItemsByConstraintQueryVariables
  >(ControlledItemsByConstraintDocument, options);
}
export function useControlledItemsByConstraintLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ControlledItemsByConstraintQuery,
    ControlledItemsByConstraintQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ControlledItemsByConstraintQuery,
    ControlledItemsByConstraintQueryVariables
  >(ControlledItemsByConstraintDocument, options);
}
// @ts-ignore
export function useControlledItemsByConstraintSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ControlledItemsByConstraintQuery,
    ControlledItemsByConstraintQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ControlledItemsByConstraintQuery,
  ControlledItemsByConstraintQueryVariables
>;
export function useControlledItemsByConstraintSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ControlledItemsByConstraintQuery,
        ControlledItemsByConstraintQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ControlledItemsByConstraintQuery | undefined,
  ControlledItemsByConstraintQueryVariables
>;
export function useControlledItemsByConstraintSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ControlledItemsByConstraintQuery,
        ControlledItemsByConstraintQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ControlledItemsByConstraintQuery,
    ControlledItemsByConstraintQueryVariables
  >(ControlledItemsByConstraintDocument, options);
}
export type ControlledItemsByConstraintQueryHookResult = ReturnType<
  typeof useControlledItemsByConstraintQuery
>;
export type ControlledItemsByConstraintLazyQueryHookResult = ReturnType<
  typeof useControlledItemsByConstraintLazyQuery
>;
export type ControlledItemsByConstraintSuspenseQueryHookResult = ReturnType<
  typeof useControlledItemsByConstraintSuspenseQuery
>;
export type ControlledItemsByConstraintQueryResult = Apollo.QueryResult<
  ControlledItemsByConstraintQuery,
  ControlledItemsByConstraintQueryVariables
>;
export const InventoryConstraintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InventoryConstraint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inventoryConstraint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constraintId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constraintId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'regulatoryReference' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verificationFrequencySeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredWitnesses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresDualSignature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'varianceTolerance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInventoryConstraintQuery__
 *
 * To run a query within a React component, call `useInventoryConstraintQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryConstraintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryConstraintQuery({
 *   variables: {
 *      constraintId: // value for 'constraintId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useInventoryConstraintQuery(
  baseOptions: Apollo.QueryHookOptions<
    InventoryConstraintQuery,
    InventoryConstraintQueryVariables
  > &
    ({ variables: InventoryConstraintQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InventoryConstraintQuery, InventoryConstraintQueryVariables>(
    InventoryConstraintDocument,
    options,
  );
}
export function useInventoryConstraintLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InventoryConstraintQuery,
    InventoryConstraintQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InventoryConstraintQuery, InventoryConstraintQueryVariables>(
    InventoryConstraintDocument,
    options,
  );
}
// @ts-ignore
export function useInventoryConstraintSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InventoryConstraintQuery,
    InventoryConstraintQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InventoryConstraintQuery, InventoryConstraintQueryVariables>;
export function useInventoryConstraintSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InventoryConstraintQuery, InventoryConstraintQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  InventoryConstraintQuery | undefined,
  InventoryConstraintQueryVariables
>;
export function useInventoryConstraintSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InventoryConstraintQuery, InventoryConstraintQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InventoryConstraintQuery, InventoryConstraintQueryVariables>(
    InventoryConstraintDocument,
    options,
  );
}
export type InventoryConstraintQueryHookResult = ReturnType<typeof useInventoryConstraintQuery>;
export type InventoryConstraintLazyQueryHookResult = ReturnType<
  typeof useInventoryConstraintLazyQuery
>;
export type InventoryConstraintSuspenseQueryHookResult = ReturnType<
  typeof useInventoryConstraintSuspenseQuery
>;
export type InventoryConstraintQueryResult = Apollo.QueryResult<
  InventoryConstraintQuery,
  InventoryConstraintQueryVariables
>;
export const InventoryConstraintsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InventoryConstraints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inventoryConstraints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constraintId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'regulatoryReference' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verificationFrequencySeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredWitnesses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresDualSignature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'varianceTolerance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInventoryConstraintsQuery__
 *
 * To run a query within a React component, call `useInventoryConstraintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryConstraintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryConstraintsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useInventoryConstraintsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InventoryConstraintsQuery,
    InventoryConstraintsQueryVariables
  > &
    ({ variables: InventoryConstraintsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InventoryConstraintsQuery, InventoryConstraintsQueryVariables>(
    InventoryConstraintsDocument,
    options,
  );
}
export function useInventoryConstraintsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InventoryConstraintsQuery,
    InventoryConstraintsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InventoryConstraintsQuery, InventoryConstraintsQueryVariables>(
    InventoryConstraintsDocument,
    options,
  );
}
// @ts-ignore
export function useInventoryConstraintsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InventoryConstraintsQuery,
    InventoryConstraintsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InventoryConstraintsQuery, InventoryConstraintsQueryVariables>;
export function useInventoryConstraintsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InventoryConstraintsQuery,
        InventoryConstraintsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InventoryConstraintsQuery | undefined,
  InventoryConstraintsQueryVariables
>;
export function useInventoryConstraintsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InventoryConstraintsQuery,
        InventoryConstraintsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InventoryConstraintsQuery, InventoryConstraintsQueryVariables>(
    InventoryConstraintsDocument,
    options,
  );
}
export type InventoryConstraintsQueryHookResult = ReturnType<typeof useInventoryConstraintsQuery>;
export type InventoryConstraintsLazyQueryHookResult = ReturnType<
  typeof useInventoryConstraintsLazyQuery
>;
export type InventoryConstraintsSuspenseQueryHookResult = ReturnType<
  typeof useInventoryConstraintsSuspenseQuery
>;
export type InventoryConstraintsQueryResult = Apollo.QueryResult<
  InventoryConstraintsQuery,
  InventoryConstraintsQueryVariables
>;
export const VerificationHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerificationHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'VerificationStatus' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constraintId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constraintId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'verificationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constraintId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryVerifierId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'witnessIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expectedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actualCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discrepancyReportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useVerificationHistoryQuery__
 *
 * To run a query within a React component, call `useVerificationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationHistoryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      constraintId: // value for 'constraintId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVerificationHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerificationHistoryQuery,
    VerificationHistoryQueryVariables
  > &
    ({ variables: VerificationHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerificationHistoryQuery, VerificationHistoryQueryVariables>(
    VerificationHistoryDocument,
    options,
  );
}
export function useVerificationHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerificationHistoryQuery,
    VerificationHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerificationHistoryQuery, VerificationHistoryQueryVariables>(
    VerificationHistoryDocument,
    options,
  );
}
// @ts-ignore
export function useVerificationHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerificationHistoryQuery,
    VerificationHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<VerificationHistoryQuery, VerificationHistoryQueryVariables>;
export function useVerificationHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerificationHistoryQuery, VerificationHistoryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  VerificationHistoryQuery | undefined,
  VerificationHistoryQueryVariables
>;
export function useVerificationHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerificationHistoryQuery, VerificationHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerificationHistoryQuery, VerificationHistoryQueryVariables>(
    VerificationHistoryDocument,
    options,
  );
}
export type VerificationHistoryQueryHookResult = ReturnType<typeof useVerificationHistoryQuery>;
export type VerificationHistoryLazyQueryHookResult = ReturnType<
  typeof useVerificationHistoryLazyQuery
>;
export type VerificationHistorySuspenseQueryHookResult = ReturnType<
  typeof useVerificationHistorySuspenseQuery
>;
export type VerificationHistoryQueryResult = Apollo.QueryResult<
  VerificationHistoryQuery,
  VerificationHistoryQueryVariables
>;
export const ProductCatalogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductCatalog' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'industry' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jurisdiction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalog' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'industry' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'industry' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jurisdiction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jurisdiction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryRuleset' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredRulesets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recommendedRulesets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesTaskGroups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesOverrides' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesConstellations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesSettings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingLenses' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductCatalogQuery__
 *
 * To run a query within a React component, call `useProductCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogQuery({
 *   variables: {
 *      industry: // value for 'industry'
 *      jurisdiction: // value for 'jurisdiction'
 *   },
 * });
 */
export function useProductCatalogQuery(
  baseOptions?: Apollo.QueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProductCatalogQuery, ProductCatalogQueryVariables>(
    ProductCatalogDocument,
    options,
  );
}
export function useProductCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProductCatalogQuery, ProductCatalogQueryVariables>(
    ProductCatalogDocument,
    options,
  );
}
// @ts-ignore
export function useProductCatalogSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProductCatalogQuery, ProductCatalogQueryVariables>;
export function useProductCatalogSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProductCatalogQuery | undefined, ProductCatalogQueryVariables>;
export function useProductCatalogSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProductCatalogQuery, ProductCatalogQueryVariables>(
    ProductCatalogDocument,
    options,
  );
}
export type ProductCatalogQueryHookResult = ReturnType<typeof useProductCatalogQuery>;
export type ProductCatalogLazyQueryHookResult = ReturnType<typeof useProductCatalogLazyQuery>;
export type ProductCatalogSuspenseQueryHookResult = ReturnType<
  typeof useProductCatalogSuspenseQuery
>;
export type ProductCatalogQueryResult = Apollo.QueryResult<
  ProductCatalogQuery,
  ProductCatalogQueryVariables
>;
export const ProductCatalogEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductCatalogEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryRuleset' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredRulesets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recommendedRulesets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesTaskGroups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesOverrides' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesConstellations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesSettings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingLenses' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductCatalogEntryQuery__
 *
 * To run a query within a React component, call `useProductCatalogEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogEntryQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductCatalogEntryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductCatalogEntryQuery,
    ProductCatalogEntryQueryVariables
  > &
    ({ variables: ProductCatalogEntryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProductCatalogEntryQuery, ProductCatalogEntryQueryVariables>(
    ProductCatalogEntryDocument,
    options,
  );
}
export function useProductCatalogEntryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductCatalogEntryQuery,
    ProductCatalogEntryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProductCatalogEntryQuery, ProductCatalogEntryQueryVariables>(
    ProductCatalogEntryDocument,
    options,
  );
}
// @ts-ignore
export function useProductCatalogEntrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductCatalogEntryQuery,
    ProductCatalogEntryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ProductCatalogEntryQuery, ProductCatalogEntryQueryVariables>;
export function useProductCatalogEntrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProductCatalogEntryQuery, ProductCatalogEntryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ProductCatalogEntryQuery | undefined,
  ProductCatalogEntryQueryVariables
>;
export function useProductCatalogEntrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProductCatalogEntryQuery, ProductCatalogEntryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProductCatalogEntryQuery, ProductCatalogEntryQueryVariables>(
    ProductCatalogEntryDocument,
    options,
  );
}
export type ProductCatalogEntryQueryHookResult = ReturnType<typeof useProductCatalogEntryQuery>;
export type ProductCatalogEntryLazyQueryHookResult = ReturnType<
  typeof useProductCatalogEntryLazyQuery
>;
export type ProductCatalogEntrySuspenseQueryHookResult = ReturnType<
  typeof useProductCatalogEntrySuspenseQuery
>;
export type ProductCatalogEntryQueryResult = Apollo.QueryResult<
  ProductCatalogEntryQuery,
  ProductCatalogEntryQueryVariables
>;
export const TenantProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TenantProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenantProducts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastStatusChange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTenantProductsQuery__
 *
 * To run a query within a React component, call `useTenantProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantProductsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useTenantProductsQuery(
  baseOptions: Apollo.QueryHookOptions<TenantProductsQuery, TenantProductsQueryVariables> &
    ({ variables: TenantProductsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TenantProductsQuery, TenantProductsQueryVariables>(
    TenantProductsDocument,
    options,
  );
}
export function useTenantProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TenantProductsQuery, TenantProductsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TenantProductsQuery, TenantProductsQueryVariables>(
    TenantProductsDocument,
    options,
  );
}
// @ts-ignore
export function useTenantProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TenantProductsQuery, TenantProductsQueryVariables>,
): Apollo.UseSuspenseQueryResult<TenantProductsQuery, TenantProductsQueryVariables>;
export function useTenantProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TenantProductsQuery, TenantProductsQueryVariables>,
): Apollo.UseSuspenseQueryResult<TenantProductsQuery | undefined, TenantProductsQueryVariables>;
export function useTenantProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TenantProductsQuery, TenantProductsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TenantProductsQuery, TenantProductsQueryVariables>(
    TenantProductsDocument,
    options,
  );
}
export type TenantProductsQueryHookResult = ReturnType<typeof useTenantProductsQuery>;
export type TenantProductsLazyQueryHookResult = ReturnType<typeof useTenantProductsLazyQuery>;
export type TenantProductsSuspenseQueryHookResult = ReturnType<
  typeof useTenantProductsSuspenseQuery
>;
export type TenantProductsQueryResult = Apollo.QueryResult<
  TenantProductsQuery,
  TenantProductsQueryVariables
>;
export const TenantProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TenantProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenantProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastStatusChange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTenantProductQuery__
 *
 * To run a query within a React component, call `useTenantProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantProductQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useTenantProductQuery(
  baseOptions: Apollo.QueryHookOptions<TenantProductQuery, TenantProductQueryVariables> &
    ({ variables: TenantProductQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TenantProductQuery, TenantProductQueryVariables>(
    TenantProductDocument,
    options,
  );
}
export function useTenantProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TenantProductQuery, TenantProductQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TenantProductQuery, TenantProductQueryVariables>(
    TenantProductDocument,
    options,
  );
}
// @ts-ignore
export function useTenantProductSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TenantProductQuery, TenantProductQueryVariables>,
): Apollo.UseSuspenseQueryResult<TenantProductQuery, TenantProductQueryVariables>;
export function useTenantProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TenantProductQuery, TenantProductQueryVariables>,
): Apollo.UseSuspenseQueryResult<TenantProductQuery | undefined, TenantProductQueryVariables>;
export function useTenantProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TenantProductQuery, TenantProductQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TenantProductQuery, TenantProductQueryVariables>(
    TenantProductDocument,
    options,
  );
}
export type TenantProductQueryHookResult = ReturnType<typeof useTenantProductQuery>;
export type TenantProductLazyQueryHookResult = ReturnType<typeof useTenantProductLazyQuery>;
export type TenantProductSuspenseQueryHookResult = ReturnType<typeof useTenantProductSuspenseQuery>;
export type TenantProductQueryResult = Apollo.QueryResult<
  TenantProductQuery,
  TenantProductQueryVariables
>;
export const ConfigProposalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConfigProposals' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'configProposals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceRule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filePath' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConfigProposalsQuery__
 *
 * To run a query within a React component, call `useConfigProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigProposalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigProposalsQuery(
  baseOptions?: Apollo.QueryHookOptions<ConfigProposalsQuery, ConfigProposalsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConfigProposalsQuery, ConfigProposalsQueryVariables>(
    ConfigProposalsDocument,
    options,
  );
}
export function useConfigProposalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConfigProposalsQuery, ConfigProposalsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConfigProposalsQuery, ConfigProposalsQueryVariables>(
    ConfigProposalsDocument,
    options,
  );
}
// @ts-ignore
export function useConfigProposalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConfigProposalsQuery,
    ConfigProposalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ConfigProposalsQuery, ConfigProposalsQueryVariables>;
export function useConfigProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigProposalsQuery, ConfigProposalsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConfigProposalsQuery | undefined, ConfigProposalsQueryVariables>;
export function useConfigProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigProposalsQuery, ConfigProposalsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConfigProposalsQuery, ConfigProposalsQueryVariables>(
    ConfigProposalsDocument,
    options,
  );
}
export type ConfigProposalsQueryHookResult = ReturnType<typeof useConfigProposalsQuery>;
export type ConfigProposalsLazyQueryHookResult = ReturnType<typeof useConfigProposalsLazyQuery>;
export type ConfigProposalsSuspenseQueryHookResult = ReturnType<
  typeof useConfigProposalsSuspenseQuery
>;
export type ConfigProposalsQueryResult = Apollo.QueryResult<
  ConfigProposalsQuery,
  ConfigProposalsQueryVariables
>;
export const ListDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ListDraftsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsListDrafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListDraftsQuery__
 *
 * To run a query within a React component, call `useListDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDraftsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListDraftsQuery(
  baseOptions: Apollo.QueryHookOptions<ListDraftsQuery, ListDraftsQueryVariables> &
    ({ variables: ListDraftsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDraftsQuery, ListDraftsQueryVariables>(ListDraftsDocument, options);
}
export function useListDraftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDraftsQuery, ListDraftsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDraftsQuery, ListDraftsQueryVariables>(
    ListDraftsDocument,
    options,
  );
}
// @ts-ignore
export function useListDraftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDraftsQuery, ListDraftsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDraftsQuery, ListDraftsQueryVariables>;
export function useListDraftsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListDraftsQuery, ListDraftsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDraftsQuery | undefined, ListDraftsQueryVariables>;
export function useListDraftsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListDraftsQuery, ListDraftsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDraftsQuery, ListDraftsQueryVariables>(
    ListDraftsDocument,
    options,
  );
}
export type ListDraftsQueryHookResult = ReturnType<typeof useListDraftsQuery>;
export type ListDraftsLazyQueryHookResult = ReturnType<typeof useListDraftsLazyQuery>;
export type ListDraftsSuspenseQueryHookResult = ReturnType<typeof useListDraftsSuspenseQuery>;
export type ListDraftsQueryResult = Apollo.QueryResult<ListDraftsQuery, ListDraftsQueryVariables>;
export const BasicIsEnrolledDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BasicIsEnrolled' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'basicIsEnrolled' } }],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBasicIsEnrolledQuery__
 *
 * To run a query within a React component, call `useBasicIsEnrolledQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicIsEnrolledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicIsEnrolledQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasicIsEnrolledQuery(
  baseOptions?: Apollo.QueryHookOptions<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>(
    BasicIsEnrolledDocument,
    options,
  );
}
export function useBasicIsEnrolledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>(
    BasicIsEnrolledDocument,
    options,
  );
}
// @ts-ignore
export function useBasicIsEnrolledSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BasicIsEnrolledQuery,
    BasicIsEnrolledQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>;
export function useBasicIsEnrolledSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>,
): Apollo.UseSuspenseQueryResult<BasicIsEnrolledQuery | undefined, BasicIsEnrolledQueryVariables>;
export function useBasicIsEnrolledSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<BasicIsEnrolledQuery, BasicIsEnrolledQueryVariables>(
    BasicIsEnrolledDocument,
    options,
  );
}
export type BasicIsEnrolledQueryHookResult = ReturnType<typeof useBasicIsEnrolledQuery>;
export type BasicIsEnrolledLazyQueryHookResult = ReturnType<typeof useBasicIsEnrolledLazyQuery>;
export type BasicIsEnrolledSuspenseQueryHookResult = ReturnType<
  typeof useBasicIsEnrolledSuspenseQuery
>;
export type BasicIsEnrolledQueryResult = Apollo.QueryResult<
  BasicIsEnrolledQuery,
  BasicIsEnrolledQueryVariables
>;
export const BasicGetCurrentEnrollmentFlowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BasicGetCurrentEnrollmentFlow' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'basicGetCurrentEnrollmentFlow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'flowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'steps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stepNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSkip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBasicGetCurrentEnrollmentFlowQuery__
 *
 * To run a query within a React component, call `useBasicGetCurrentEnrollmentFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicGetCurrentEnrollmentFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicGetCurrentEnrollmentFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasicGetCurrentEnrollmentFlowQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BasicGetCurrentEnrollmentFlowQuery,
    BasicGetCurrentEnrollmentFlowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BasicGetCurrentEnrollmentFlowQuery,
    BasicGetCurrentEnrollmentFlowQueryVariables
  >(BasicGetCurrentEnrollmentFlowDocument, options);
}
export function useBasicGetCurrentEnrollmentFlowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BasicGetCurrentEnrollmentFlowQuery,
    BasicGetCurrentEnrollmentFlowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BasicGetCurrentEnrollmentFlowQuery,
    BasicGetCurrentEnrollmentFlowQueryVariables
  >(BasicGetCurrentEnrollmentFlowDocument, options);
}
// @ts-ignore
export function useBasicGetCurrentEnrollmentFlowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BasicGetCurrentEnrollmentFlowQuery,
    BasicGetCurrentEnrollmentFlowQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BasicGetCurrentEnrollmentFlowQuery,
  BasicGetCurrentEnrollmentFlowQueryVariables
>;
export function useBasicGetCurrentEnrollmentFlowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BasicGetCurrentEnrollmentFlowQuery,
        BasicGetCurrentEnrollmentFlowQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BasicGetCurrentEnrollmentFlowQuery | undefined,
  BasicGetCurrentEnrollmentFlowQueryVariables
>;
export function useBasicGetCurrentEnrollmentFlowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BasicGetCurrentEnrollmentFlowQuery,
        BasicGetCurrentEnrollmentFlowQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BasicGetCurrentEnrollmentFlowQuery,
    BasicGetCurrentEnrollmentFlowQueryVariables
  >(BasicGetCurrentEnrollmentFlowDocument, options);
}
export type BasicGetCurrentEnrollmentFlowQueryHookResult = ReturnType<
  typeof useBasicGetCurrentEnrollmentFlowQuery
>;
export type BasicGetCurrentEnrollmentFlowLazyQueryHookResult = ReturnType<
  typeof useBasicGetCurrentEnrollmentFlowLazyQuery
>;
export type BasicGetCurrentEnrollmentFlowSuspenseQueryHookResult = ReturnType<
  typeof useBasicGetCurrentEnrollmentFlowSuspenseQuery
>;
export type BasicGetCurrentEnrollmentFlowQueryResult = Apollo.QueryResult<
  BasicGetCurrentEnrollmentFlowQuery,
  BasicGetCurrentEnrollmentFlowQueryVariables
>;
export const BasicGetEnrollmentPromptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BasicGetEnrollmentPrompt' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'basicGetEnrollmentPrompt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'promptType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canSkip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skipReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBasicGetEnrollmentPromptQuery__
 *
 * To run a query within a React component, call `useBasicGetEnrollmentPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicGetEnrollmentPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicGetEnrollmentPromptQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasicGetEnrollmentPromptQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BasicGetEnrollmentPromptQuery,
    BasicGetEnrollmentPromptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BasicGetEnrollmentPromptQuery, BasicGetEnrollmentPromptQueryVariables>(
    BasicGetEnrollmentPromptDocument,
    options,
  );
}
export function useBasicGetEnrollmentPromptLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BasicGetEnrollmentPromptQuery,
    BasicGetEnrollmentPromptQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BasicGetEnrollmentPromptQuery, BasicGetEnrollmentPromptQueryVariables>(
    BasicGetEnrollmentPromptDocument,
    options,
  );
}
// @ts-ignore
export function useBasicGetEnrollmentPromptSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BasicGetEnrollmentPromptQuery,
    BasicGetEnrollmentPromptQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BasicGetEnrollmentPromptQuery,
  BasicGetEnrollmentPromptQueryVariables
>;
export function useBasicGetEnrollmentPromptSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BasicGetEnrollmentPromptQuery,
        BasicGetEnrollmentPromptQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BasicGetEnrollmentPromptQuery | undefined,
  BasicGetEnrollmentPromptQueryVariables
>;
export function useBasicGetEnrollmentPromptSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BasicGetEnrollmentPromptQuery,
        BasicGetEnrollmentPromptQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BasicGetEnrollmentPromptQuery,
    BasicGetEnrollmentPromptQueryVariables
  >(BasicGetEnrollmentPromptDocument, options);
}
export type BasicGetEnrollmentPromptQueryHookResult = ReturnType<
  typeof useBasicGetEnrollmentPromptQuery
>;
export type BasicGetEnrollmentPromptLazyQueryHookResult = ReturnType<
  typeof useBasicGetEnrollmentPromptLazyQuery
>;
export type BasicGetEnrollmentPromptSuspenseQueryHookResult = ReturnType<
  typeof useBasicGetEnrollmentPromptSuspenseQuery
>;
export type BasicGetEnrollmentPromptQueryResult = Apollo.QueryResult<
  BasicGetEnrollmentPromptQuery,
  BasicGetEnrollmentPromptQueryVariables
>;
export const BasicStartEnrollmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BasicStartEnrollment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicStartEnrollmentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'basicStartEnrollment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'flowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'steps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stepNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSkip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BasicStartEnrollmentMutationFn = ApolloMutationFunction<
  BasicStartEnrollmentMutation,
  BasicStartEnrollmentMutationVariables
>;

/**
 * __useBasicStartEnrollmentMutation__
 *
 * To run a mutation, you first call `useBasicStartEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicStartEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicStartEnrollmentMutation, { data, loading, error }] = useBasicStartEnrollmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBasicStartEnrollmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BasicStartEnrollmentMutation,
    BasicStartEnrollmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BasicStartEnrollmentMutation, BasicStartEnrollmentMutationVariables>(
    BasicStartEnrollmentDocument,
    options,
  );
}
export type BasicStartEnrollmentMutationHookResult = ReturnType<
  typeof useBasicStartEnrollmentMutation
>;
export type BasicStartEnrollmentMutationResult =
  Apollo.MutationResult<BasicStartEnrollmentMutation>;
export type BasicStartEnrollmentMutationOptions = ApolloBaseMutationOptions<
  BasicStartEnrollmentMutation,
  BasicStartEnrollmentMutationVariables
>;
export const BasicCompleteEnrollmentStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BasicCompleteEnrollmentStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BasicCompleteEnrollmentStepInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'basicCompleteEnrollmentStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'flowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'steps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stepNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSkip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BasicCompleteEnrollmentStepMutationFn = ApolloMutationFunction<
  BasicCompleteEnrollmentStepMutation,
  BasicCompleteEnrollmentStepMutationVariables
>;

/**
 * __useBasicCompleteEnrollmentStepMutation__
 *
 * To run a mutation, you first call `useBasicCompleteEnrollmentStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicCompleteEnrollmentStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicCompleteEnrollmentStepMutation, { data, loading, error }] = useBasicCompleteEnrollmentStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBasicCompleteEnrollmentStepMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BasicCompleteEnrollmentStepMutation,
    BasicCompleteEnrollmentStepMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BasicCompleteEnrollmentStepMutation,
    BasicCompleteEnrollmentStepMutationVariables
  >(BasicCompleteEnrollmentStepDocument, options);
}
export type BasicCompleteEnrollmentStepMutationHookResult = ReturnType<
  typeof useBasicCompleteEnrollmentStepMutation
>;
export type BasicCompleteEnrollmentStepMutationResult =
  Apollo.MutationResult<BasicCompleteEnrollmentStepMutation>;
export type BasicCompleteEnrollmentStepMutationOptions = ApolloBaseMutationOptions<
  BasicCompleteEnrollmentStepMutation,
  BasicCompleteEnrollmentStepMutationVariables
>;
export const BasicSkipEnrollmentStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BasicSkipEnrollmentStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BasicSkipEnrollmentStepInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'basicSkipEnrollmentStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'flowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'steps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stepNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BasicSkipEnrollmentStepMutationFn = ApolloMutationFunction<
  BasicSkipEnrollmentStepMutation,
  BasicSkipEnrollmentStepMutationVariables
>;

/**
 * __useBasicSkipEnrollmentStepMutation__
 *
 * To run a mutation, you first call `useBasicSkipEnrollmentStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicSkipEnrollmentStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicSkipEnrollmentStepMutation, { data, loading, error }] = useBasicSkipEnrollmentStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBasicSkipEnrollmentStepMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BasicSkipEnrollmentStepMutation,
    BasicSkipEnrollmentStepMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BasicSkipEnrollmentStepMutation,
    BasicSkipEnrollmentStepMutationVariables
  >(BasicSkipEnrollmentStepDocument, options);
}
export type BasicSkipEnrollmentStepMutationHookResult = ReturnType<
  typeof useBasicSkipEnrollmentStepMutation
>;
export type BasicSkipEnrollmentStepMutationResult =
  Apollo.MutationResult<BasicSkipEnrollmentStepMutation>;
export type BasicSkipEnrollmentStepMutationOptions = ApolloBaseMutationOptions<
  BasicSkipEnrollmentStepMutation,
  BasicSkipEnrollmentStepMutationVariables
>;
export const ListFormSchemaDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListFormSchemaDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listFormSchemaDrafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'draftId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListFormSchemaDraftsQuery__
 *
 * To run a query within a React component, call `useListFormSchemaDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormSchemaDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormSchemaDraftsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useListFormSchemaDraftsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListFormSchemaDraftsQuery,
    ListFormSchemaDraftsQueryVariables
  > &
    ({ variables: ListFormSchemaDraftsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListFormSchemaDraftsQuery, ListFormSchemaDraftsQueryVariables>(
    ListFormSchemaDraftsDocument,
    options,
  );
}
export function useListFormSchemaDraftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListFormSchemaDraftsQuery,
    ListFormSchemaDraftsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListFormSchemaDraftsQuery, ListFormSchemaDraftsQueryVariables>(
    ListFormSchemaDraftsDocument,
    options,
  );
}
// @ts-ignore
export function useListFormSchemaDraftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListFormSchemaDraftsQuery,
    ListFormSchemaDraftsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListFormSchemaDraftsQuery, ListFormSchemaDraftsQueryVariables>;
export function useListFormSchemaDraftsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListFormSchemaDraftsQuery,
        ListFormSchemaDraftsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListFormSchemaDraftsQuery | undefined,
  ListFormSchemaDraftsQueryVariables
>;
export function useListFormSchemaDraftsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListFormSchemaDraftsQuery,
        ListFormSchemaDraftsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListFormSchemaDraftsQuery, ListFormSchemaDraftsQueryVariables>(
    ListFormSchemaDraftsDocument,
    options,
  );
}
export type ListFormSchemaDraftsQueryHookResult = ReturnType<typeof useListFormSchemaDraftsQuery>;
export type ListFormSchemaDraftsLazyQueryHookResult = ReturnType<
  typeof useListFormSchemaDraftsLazyQuery
>;
export type ListFormSchemaDraftsSuspenseQueryHookResult = ReturnType<
  typeof useListFormSchemaDraftsSuspenseQuery
>;
export type ListFormSchemaDraftsQueryResult = Apollo.QueryResult<
  ListFormSchemaDraftsQuery,
  ListFormSchemaDraftsQueryVariables
>;
export const GetScheduleOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScheduleOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetScheduleOpsQuery__
 *
 * To run a query within a React component, call `useGetScheduleOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleOpsQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useGetScheduleOpsQuery(
  baseOptions: Apollo.QueryHookOptions<GetScheduleOpsQuery, GetScheduleOpsQueryVariables> &
    ({ variables: GetScheduleOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>(
    GetScheduleOpsDocument,
    options,
  );
}
export function useGetScheduleOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>(
    GetScheduleOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetScheduleOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>;
export function useGetScheduleOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetScheduleOpsQuery | undefined, GetScheduleOpsQueryVariables>;
export function useGetScheduleOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetScheduleOpsQuery, GetScheduleOpsQueryVariables>(
    GetScheduleOpsDocument,
    options,
  );
}
export type GetScheduleOpsQueryHookResult = ReturnType<typeof useGetScheduleOpsQuery>;
export type GetScheduleOpsLazyQueryHookResult = ReturnType<typeof useGetScheduleOpsLazyQuery>;
export type GetScheduleOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetScheduleOpsSuspenseQuery
>;
export type GetScheduleOpsQueryResult = Apollo.QueryResult<
  GetScheduleOpsQuery,
  GetScheduleOpsQueryVariables
>;
export const ListSchedulesOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListSchedulesOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListSchedulesOpsQuery__
 *
 * To run a query within a React component, call `useListSchedulesOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchedulesOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSchedulesOpsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListSchedulesOpsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>(
    ListSchedulesOpsDocument,
    options,
  );
}
export function useListSchedulesOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>(
    ListSchedulesOpsDocument,
    options,
  );
}
// @ts-ignore
export function useListSchedulesOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListSchedulesOpsQuery,
    ListSchedulesOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>;
export function useListSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListSchedulesOpsQuery | undefined, ListSchedulesOpsQueryVariables>;
export function useListSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListSchedulesOpsQuery, ListSchedulesOpsQueryVariables>(
    ListSchedulesOpsDocument,
    options,
  );
}
export type ListSchedulesOpsQueryHookResult = ReturnType<typeof useListSchedulesOpsQuery>;
export type ListSchedulesOpsLazyQueryHookResult = ReturnType<typeof useListSchedulesOpsLazyQuery>;
export type ListSchedulesOpsSuspenseQueryHookResult = ReturnType<
  typeof useListSchedulesOpsSuspenseQuery
>;
export type ListSchedulesOpsQueryResult = Apollo.QueryResult<
  ListSchedulesOpsQuery,
  ListSchedulesOpsQueryVariables
>;
export const GetActiveSchedulesOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActiveSchedulesOps' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActiveSchedules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActiveSchedulesOpsQuery__
 *
 * To run a query within a React component, call `useGetActiveSchedulesOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSchedulesOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSchedulesOpsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSchedulesOpsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetActiveSchedulesOpsQuery,
    GetActiveSchedulesOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActiveSchedulesOpsQuery, GetActiveSchedulesOpsQueryVariables>(
    GetActiveSchedulesOpsDocument,
    options,
  );
}
export function useGetActiveSchedulesOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActiveSchedulesOpsQuery,
    GetActiveSchedulesOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActiveSchedulesOpsQuery, GetActiveSchedulesOpsQueryVariables>(
    GetActiveSchedulesOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetActiveSchedulesOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActiveSchedulesOpsQuery,
    GetActiveSchedulesOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActiveSchedulesOpsQuery, GetActiveSchedulesOpsQueryVariables>;
export function useGetActiveSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActiveSchedulesOpsQuery,
        GetActiveSchedulesOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetActiveSchedulesOpsQuery | undefined,
  GetActiveSchedulesOpsQueryVariables
>;
export function useGetActiveSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActiveSchedulesOpsQuery,
        GetActiveSchedulesOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActiveSchedulesOpsQuery, GetActiveSchedulesOpsQueryVariables>(
    GetActiveSchedulesOpsDocument,
    options,
  );
}
export type GetActiveSchedulesOpsQueryHookResult = ReturnType<typeof useGetActiveSchedulesOpsQuery>;
export type GetActiveSchedulesOpsLazyQueryHookResult = ReturnType<
  typeof useGetActiveSchedulesOpsLazyQuery
>;
export type GetActiveSchedulesOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetActiveSchedulesOpsSuspenseQuery
>;
export type GetActiveSchedulesOpsQueryResult = Apollo.QueryResult<
  GetActiveSchedulesOpsQuery,
  GetActiveSchedulesOpsQueryVariables
>;
export const GetLifeCriticalSchedulesOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLifeCriticalSchedulesOps' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLifeCriticalSchedules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLifeCriticalSchedulesOpsQuery__
 *
 * To run a query within a React component, call `useGetLifeCriticalSchedulesOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifeCriticalSchedulesOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifeCriticalSchedulesOpsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLifeCriticalSchedulesOpsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLifeCriticalSchedulesOpsQuery,
    GetLifeCriticalSchedulesOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLifeCriticalSchedulesOpsQuery,
    GetLifeCriticalSchedulesOpsQueryVariables
  >(GetLifeCriticalSchedulesOpsDocument, options);
}
export function useGetLifeCriticalSchedulesOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLifeCriticalSchedulesOpsQuery,
    GetLifeCriticalSchedulesOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLifeCriticalSchedulesOpsQuery,
    GetLifeCriticalSchedulesOpsQueryVariables
  >(GetLifeCriticalSchedulesOpsDocument, options);
}
// @ts-ignore
export function useGetLifeCriticalSchedulesOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLifeCriticalSchedulesOpsQuery,
    GetLifeCriticalSchedulesOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetLifeCriticalSchedulesOpsQuery,
  GetLifeCriticalSchedulesOpsQueryVariables
>;
export function useGetLifeCriticalSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLifeCriticalSchedulesOpsQuery,
        GetLifeCriticalSchedulesOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetLifeCriticalSchedulesOpsQuery | undefined,
  GetLifeCriticalSchedulesOpsQueryVariables
>;
export function useGetLifeCriticalSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLifeCriticalSchedulesOpsQuery,
        GetLifeCriticalSchedulesOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLifeCriticalSchedulesOpsQuery,
    GetLifeCriticalSchedulesOpsQueryVariables
  >(GetLifeCriticalSchedulesOpsDocument, options);
}
export type GetLifeCriticalSchedulesOpsQueryHookResult = ReturnType<
  typeof useGetLifeCriticalSchedulesOpsQuery
>;
export type GetLifeCriticalSchedulesOpsLazyQueryHookResult = ReturnType<
  typeof useGetLifeCriticalSchedulesOpsLazyQuery
>;
export type GetLifeCriticalSchedulesOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetLifeCriticalSchedulesOpsSuspenseQuery
>;
export type GetLifeCriticalSchedulesOpsQueryResult = Apollo.QueryResult<
  GetLifeCriticalSchedulesOpsQuery,
  GetLifeCriticalSchedulesOpsQueryVariables
>;
export const GetDueSchedulesOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDueSchedulesOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withinMinutes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDueSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'withinMinutes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'withinMinutes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDueSchedulesOpsQuery__
 *
 * To run a query within a React component, call `useGetDueSchedulesOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDueSchedulesOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDueSchedulesOpsQuery({
 *   variables: {
 *      withinMinutes: // value for 'withinMinutes'
 *   },
 * });
 */
export function useGetDueSchedulesOpsQuery(
  baseOptions: Apollo.QueryHookOptions<GetDueSchedulesOpsQuery, GetDueSchedulesOpsQueryVariables> &
    ({ variables: GetDueSchedulesOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDueSchedulesOpsQuery, GetDueSchedulesOpsQueryVariables>(
    GetDueSchedulesOpsDocument,
    options,
  );
}
export function useGetDueSchedulesOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDueSchedulesOpsQuery,
    GetDueSchedulesOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDueSchedulesOpsQuery, GetDueSchedulesOpsQueryVariables>(
    GetDueSchedulesOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetDueSchedulesOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDueSchedulesOpsQuery,
    GetDueSchedulesOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetDueSchedulesOpsQuery, GetDueSchedulesOpsQueryVariables>;
export function useGetDueSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDueSchedulesOpsQuery, GetDueSchedulesOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetDueSchedulesOpsQuery | undefined,
  GetDueSchedulesOpsQueryVariables
>;
export function useGetDueSchedulesOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDueSchedulesOpsQuery, GetDueSchedulesOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDueSchedulesOpsQuery, GetDueSchedulesOpsQueryVariables>(
    GetDueSchedulesOpsDocument,
    options,
  );
}
export type GetDueSchedulesOpsQueryHookResult = ReturnType<typeof useGetDueSchedulesOpsQuery>;
export type GetDueSchedulesOpsLazyQueryHookResult = ReturnType<
  typeof useGetDueSchedulesOpsLazyQuery
>;
export type GetDueSchedulesOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetDueSchedulesOpsSuspenseQuery
>;
export type GetDueSchedulesOpsQueryResult = Apollo.QueryResult<
  GetDueSchedulesOpsQuery,
  GetDueSchedulesOpsQueryVariables
>;
export const GetScheduleExecutionSummaryOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScheduleExecutionSummaryOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScheduleExecutionSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalExecutions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'successfulExecutions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failedExecutions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'missedExecutions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageExecutionTimeMs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetScheduleExecutionSummaryOpsQuery__
 *
 * To run a query within a React component, call `useGetScheduleExecutionSummaryOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleExecutionSummaryOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleExecutionSummaryOpsQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useGetScheduleExecutionSummaryOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScheduleExecutionSummaryOpsQuery,
    GetScheduleExecutionSummaryOpsQueryVariables
  > &
    (
      | { variables: GetScheduleExecutionSummaryOpsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduleExecutionSummaryOpsQuery,
    GetScheduleExecutionSummaryOpsQueryVariables
  >(GetScheduleExecutionSummaryOpsDocument, options);
}
export function useGetScheduleExecutionSummaryOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduleExecutionSummaryOpsQuery,
    GetScheduleExecutionSummaryOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduleExecutionSummaryOpsQuery,
    GetScheduleExecutionSummaryOpsQueryVariables
  >(GetScheduleExecutionSummaryOpsDocument, options);
}
// @ts-ignore
export function useGetScheduleExecutionSummaryOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetScheduleExecutionSummaryOpsQuery,
    GetScheduleExecutionSummaryOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetScheduleExecutionSummaryOpsQuery,
  GetScheduleExecutionSummaryOpsQueryVariables
>;
export function useGetScheduleExecutionSummaryOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScheduleExecutionSummaryOpsQuery,
        GetScheduleExecutionSummaryOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetScheduleExecutionSummaryOpsQuery | undefined,
  GetScheduleExecutionSummaryOpsQueryVariables
>;
export function useGetScheduleExecutionSummaryOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScheduleExecutionSummaryOpsQuery,
        GetScheduleExecutionSummaryOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScheduleExecutionSummaryOpsQuery,
    GetScheduleExecutionSummaryOpsQueryVariables
  >(GetScheduleExecutionSummaryOpsDocument, options);
}
export type GetScheduleExecutionSummaryOpsQueryHookResult = ReturnType<
  typeof useGetScheduleExecutionSummaryOpsQuery
>;
export type GetScheduleExecutionSummaryOpsLazyQueryHookResult = ReturnType<
  typeof useGetScheduleExecutionSummaryOpsLazyQuery
>;
export type GetScheduleExecutionSummaryOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetScheduleExecutionSummaryOpsSuspenseQuery
>;
export type GetScheduleExecutionSummaryOpsQueryResult = Apollo.QueryResult<
  GetScheduleExecutionSummaryOpsQuery,
  GetScheduleExecutionSummaryOpsQueryVariables
>;
export const GetWorkflowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWorkflowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWorkflowOpsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowOpsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowOpsQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables> &
    ({ variables: GetWorkflowOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>(
    GetWorkflowOpsDocument,
    options,
  );
}
export function useGetWorkflowOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>(
    GetWorkflowOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetWorkflowOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>;
export function useGetWorkflowOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetWorkflowOpsQuery | undefined, GetWorkflowOpsQueryVariables>;
export function useGetWorkflowOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkflowOpsQuery, GetWorkflowOpsQueryVariables>(
    GetWorkflowOpsDocument,
    options,
  );
}
export type GetWorkflowOpsQueryHookResult = ReturnType<typeof useGetWorkflowOpsQuery>;
export type GetWorkflowOpsLazyQueryHookResult = ReturnType<typeof useGetWorkflowOpsLazyQuery>;
export type GetWorkflowOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowOpsSuspenseQuery
>;
export type GetWorkflowOpsQueryResult = Apollo.QueryResult<
  GetWorkflowOpsQuery,
  GetWorkflowOpsQueryVariables
>;
export const ListWorkflowsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListWorkflowsOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listWorkflows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListWorkflowsOpsQuery__
 *
 * To run a query within a React component, call `useListWorkflowsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowsOpsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListWorkflowsOpsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>(
    ListWorkflowsOpsDocument,
    options,
  );
}
export function useListWorkflowsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>(
    ListWorkflowsOpsDocument,
    options,
  );
}
// @ts-ignore
export function useListWorkflowsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListWorkflowsOpsQuery,
    ListWorkflowsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>;
export function useListWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListWorkflowsOpsQuery | undefined, ListWorkflowsOpsQueryVariables>;
export function useListWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListWorkflowsOpsQuery, ListWorkflowsOpsQueryVariables>(
    ListWorkflowsOpsDocument,
    options,
  );
}
export type ListWorkflowsOpsQueryHookResult = ReturnType<typeof useListWorkflowsOpsQuery>;
export type ListWorkflowsOpsLazyQueryHookResult = ReturnType<typeof useListWorkflowsOpsLazyQuery>;
export type ListWorkflowsOpsSuspenseQueryHookResult = ReturnType<
  typeof useListWorkflowsOpsSuspenseQuery
>;
export type ListWorkflowsOpsQueryResult = Apollo.QueryResult<
  ListWorkflowsOpsQuery,
  ListWorkflowsOpsQueryVariables
>;
export const ListMyWorkflowsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListMyWorkflowsOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listMyWorkflows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListMyWorkflowsOpsQuery__
 *
 * To run a query within a React component, call `useListMyWorkflowsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyWorkflowsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyWorkflowsOpsQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useListMyWorkflowsOpsQuery(
  baseOptions: Apollo.QueryHookOptions<ListMyWorkflowsOpsQuery, ListMyWorkflowsOpsQueryVariables> &
    ({ variables: ListMyWorkflowsOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMyWorkflowsOpsQuery, ListMyWorkflowsOpsQueryVariables>(
    ListMyWorkflowsOpsDocument,
    options,
  );
}
export function useListMyWorkflowsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListMyWorkflowsOpsQuery,
    ListMyWorkflowsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMyWorkflowsOpsQuery, ListMyWorkflowsOpsQueryVariables>(
    ListMyWorkflowsOpsDocument,
    options,
  );
}
// @ts-ignore
export function useListMyWorkflowsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListMyWorkflowsOpsQuery,
    ListMyWorkflowsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListMyWorkflowsOpsQuery, ListMyWorkflowsOpsQueryVariables>;
export function useListMyWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMyWorkflowsOpsQuery, ListMyWorkflowsOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListMyWorkflowsOpsQuery | undefined,
  ListMyWorkflowsOpsQueryVariables
>;
export function useListMyWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMyWorkflowsOpsQuery, ListMyWorkflowsOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListMyWorkflowsOpsQuery, ListMyWorkflowsOpsQueryVariables>(
    ListMyWorkflowsOpsDocument,
    options,
  );
}
export type ListMyWorkflowsOpsQueryHookResult = ReturnType<typeof useListMyWorkflowsOpsQuery>;
export type ListMyWorkflowsOpsLazyQueryHookResult = ReturnType<
  typeof useListMyWorkflowsOpsLazyQuery
>;
export type ListMyWorkflowsOpsSuspenseQueryHookResult = ReturnType<
  typeof useListMyWorkflowsOpsSuspenseQuery
>;
export type ListMyWorkflowsOpsQueryResult = Apollo.QueryResult<
  ListMyWorkflowsOpsQuery,
  ListMyWorkflowsOpsQueryVariables
>;
export const ListWorkflowsByStrategyOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListWorkflowsByStrategyOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'strategy' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listWorkflowsByStrategy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'strategy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'strategy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListWorkflowsByStrategyOpsQuery__
 *
 * To run a query within a React component, call `useListWorkflowsByStrategyOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowsByStrategyOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowsByStrategyOpsQuery({
 *   variables: {
 *      strategy: // value for 'strategy'
 *   },
 * });
 */
export function useListWorkflowsByStrategyOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListWorkflowsByStrategyOpsQuery,
    ListWorkflowsByStrategyOpsQueryVariables
  > &
    ({ variables: ListWorkflowsByStrategyOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListWorkflowsByStrategyOpsQuery, ListWorkflowsByStrategyOpsQueryVariables>(
    ListWorkflowsByStrategyOpsDocument,
    options,
  );
}
export function useListWorkflowsByStrategyOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListWorkflowsByStrategyOpsQuery,
    ListWorkflowsByStrategyOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListWorkflowsByStrategyOpsQuery,
    ListWorkflowsByStrategyOpsQueryVariables
  >(ListWorkflowsByStrategyOpsDocument, options);
}
// @ts-ignore
export function useListWorkflowsByStrategyOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListWorkflowsByStrategyOpsQuery,
    ListWorkflowsByStrategyOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListWorkflowsByStrategyOpsQuery,
  ListWorkflowsByStrategyOpsQueryVariables
>;
export function useListWorkflowsByStrategyOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWorkflowsByStrategyOpsQuery,
        ListWorkflowsByStrategyOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListWorkflowsByStrategyOpsQuery | undefined,
  ListWorkflowsByStrategyOpsQueryVariables
>;
export function useListWorkflowsByStrategyOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWorkflowsByStrategyOpsQuery,
        ListWorkflowsByStrategyOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListWorkflowsByStrategyOpsQuery,
    ListWorkflowsByStrategyOpsQueryVariables
  >(ListWorkflowsByStrategyOpsDocument, options);
}
export type ListWorkflowsByStrategyOpsQueryHookResult = ReturnType<
  typeof useListWorkflowsByStrategyOpsQuery
>;
export type ListWorkflowsByStrategyOpsLazyQueryHookResult = ReturnType<
  typeof useListWorkflowsByStrategyOpsLazyQuery
>;
export type ListWorkflowsByStrategyOpsSuspenseQueryHookResult = ReturnType<
  typeof useListWorkflowsByStrategyOpsSuspenseQuery
>;
export type ListWorkflowsByStrategyOpsQueryResult = Apollo.QueryResult<
  ListWorkflowsByStrategyOpsQuery,
  ListWorkflowsByStrategyOpsQueryVariables
>;
export const ListActiveWorkflowsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListActiveWorkflowsOps' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listActiveWorkflows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListActiveWorkflowsOpsQuery__
 *
 * To run a query within a React component, call `useListActiveWorkflowsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveWorkflowsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveWorkflowsOpsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListActiveWorkflowsOpsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListActiveWorkflowsOpsQuery,
    ListActiveWorkflowsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListActiveWorkflowsOpsQuery, ListActiveWorkflowsOpsQueryVariables>(
    ListActiveWorkflowsOpsDocument,
    options,
  );
}
export function useListActiveWorkflowsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActiveWorkflowsOpsQuery,
    ListActiveWorkflowsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListActiveWorkflowsOpsQuery, ListActiveWorkflowsOpsQueryVariables>(
    ListActiveWorkflowsOpsDocument,
    options,
  );
}
// @ts-ignore
export function useListActiveWorkflowsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActiveWorkflowsOpsQuery,
    ListActiveWorkflowsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListActiveWorkflowsOpsQuery, ListActiveWorkflowsOpsQueryVariables>;
export function useListActiveWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActiveWorkflowsOpsQuery,
        ListActiveWorkflowsOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListActiveWorkflowsOpsQuery | undefined,
  ListActiveWorkflowsOpsQueryVariables
>;
export function useListActiveWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActiveWorkflowsOpsQuery,
        ListActiveWorkflowsOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListActiveWorkflowsOpsQuery, ListActiveWorkflowsOpsQueryVariables>(
    ListActiveWorkflowsOpsDocument,
    options,
  );
}
export type ListActiveWorkflowsOpsQueryHookResult = ReturnType<
  typeof useListActiveWorkflowsOpsQuery
>;
export type ListActiveWorkflowsOpsLazyQueryHookResult = ReturnType<
  typeof useListActiveWorkflowsOpsLazyQuery
>;
export type ListActiveWorkflowsOpsSuspenseQueryHookResult = ReturnType<
  typeof useListActiveWorkflowsOpsSuspenseQuery
>;
export type ListActiveWorkflowsOpsQueryResult = Apollo.QueryResult<
  ListActiveWorkflowsOpsQuery,
  ListActiveWorkflowsOpsQueryVariables
>;
export const ListLifeCriticalWorkflowsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListLifeCriticalWorkflowsOps' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listLifeCriticalWorkflows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListLifeCriticalWorkflowsOpsQuery__
 *
 * To run a query within a React component, call `useListLifeCriticalWorkflowsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLifeCriticalWorkflowsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLifeCriticalWorkflowsOpsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListLifeCriticalWorkflowsOpsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListLifeCriticalWorkflowsOpsQuery,
    ListLifeCriticalWorkflowsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListLifeCriticalWorkflowsOpsQuery,
    ListLifeCriticalWorkflowsOpsQueryVariables
  >(ListLifeCriticalWorkflowsOpsDocument, options);
}
export function useListLifeCriticalWorkflowsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListLifeCriticalWorkflowsOpsQuery,
    ListLifeCriticalWorkflowsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListLifeCriticalWorkflowsOpsQuery,
    ListLifeCriticalWorkflowsOpsQueryVariables
  >(ListLifeCriticalWorkflowsOpsDocument, options);
}
// @ts-ignore
export function useListLifeCriticalWorkflowsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListLifeCriticalWorkflowsOpsQuery,
    ListLifeCriticalWorkflowsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListLifeCriticalWorkflowsOpsQuery,
  ListLifeCriticalWorkflowsOpsQueryVariables
>;
export function useListLifeCriticalWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListLifeCriticalWorkflowsOpsQuery,
        ListLifeCriticalWorkflowsOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListLifeCriticalWorkflowsOpsQuery | undefined,
  ListLifeCriticalWorkflowsOpsQueryVariables
>;
export function useListLifeCriticalWorkflowsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListLifeCriticalWorkflowsOpsQuery,
        ListLifeCriticalWorkflowsOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListLifeCriticalWorkflowsOpsQuery,
    ListLifeCriticalWorkflowsOpsQueryVariables
  >(ListLifeCriticalWorkflowsOpsDocument, options);
}
export type ListLifeCriticalWorkflowsOpsQueryHookResult = ReturnType<
  typeof useListLifeCriticalWorkflowsOpsQuery
>;
export type ListLifeCriticalWorkflowsOpsLazyQueryHookResult = ReturnType<
  typeof useListLifeCriticalWorkflowsOpsLazyQuery
>;
export type ListLifeCriticalWorkflowsOpsSuspenseQueryHookResult = ReturnType<
  typeof useListLifeCriticalWorkflowsOpsSuspenseQuery
>;
export type ListLifeCriticalWorkflowsOpsQueryResult = Apollo.QueryResult<
  ListLifeCriticalWorkflowsOpsQuery,
  ListLifeCriticalWorkflowsOpsQueryVariables
>;
export const ValidateWorkflowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateWorkflowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useValidateWorkflowOpsQuery__
 *
 * To run a query within a React component, call `useValidateWorkflowOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateWorkflowOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateWorkflowOpsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useValidateWorkflowOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateWorkflowOpsQuery,
    ValidateWorkflowOpsQueryVariables
  > &
    ({ variables: ValidateWorkflowOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidateWorkflowOpsQuery, ValidateWorkflowOpsQueryVariables>(
    ValidateWorkflowOpsDocument,
    options,
  );
}
export function useValidateWorkflowOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateWorkflowOpsQuery,
    ValidateWorkflowOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValidateWorkflowOpsQuery, ValidateWorkflowOpsQueryVariables>(
    ValidateWorkflowOpsDocument,
    options,
  );
}
// @ts-ignore
export function useValidateWorkflowOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidateWorkflowOpsQuery,
    ValidateWorkflowOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ValidateWorkflowOpsQuery, ValidateWorkflowOpsQueryVariables>;
export function useValidateWorkflowOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ValidateWorkflowOpsQuery, ValidateWorkflowOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ValidateWorkflowOpsQuery | undefined,
  ValidateWorkflowOpsQueryVariables
>;
export function useValidateWorkflowOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ValidateWorkflowOpsQuery, ValidateWorkflowOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ValidateWorkflowOpsQuery, ValidateWorkflowOpsQueryVariables>(
    ValidateWorkflowOpsDocument,
    options,
  );
}
export type ValidateWorkflowOpsQueryHookResult = ReturnType<typeof useValidateWorkflowOpsQuery>;
export type ValidateWorkflowOpsLazyQueryHookResult = ReturnType<
  typeof useValidateWorkflowOpsLazyQuery
>;
export type ValidateWorkflowOpsSuspenseQueryHookResult = ReturnType<
  typeof useValidateWorkflowOpsSuspenseQuery
>;
export type ValidateWorkflowOpsQueryResult = Apollo.QueryResult<
  ValidateWorkflowOpsQuery,
  ValidateWorkflowOpsQueryVariables
>;
export const GetWorkflowStatisticsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWorkflowStatisticsOps' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkflowStatistics' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lifeCriticalWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalInstantiations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgCompletionRate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWorkflowStatisticsOpsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowStatisticsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowStatisticsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowStatisticsOpsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowStatisticsOpsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkflowStatisticsOpsQuery,
    GetWorkflowStatisticsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkflowStatisticsOpsQuery, GetWorkflowStatisticsOpsQueryVariables>(
    GetWorkflowStatisticsOpsDocument,
    options,
  );
}
export function useGetWorkflowStatisticsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowStatisticsOpsQuery,
    GetWorkflowStatisticsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkflowStatisticsOpsQuery, GetWorkflowStatisticsOpsQueryVariables>(
    GetWorkflowStatisticsOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetWorkflowStatisticsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowStatisticsOpsQuery,
    GetWorkflowStatisticsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowStatisticsOpsQuery,
  GetWorkflowStatisticsOpsQueryVariables
>;
export function useGetWorkflowStatisticsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowStatisticsOpsQuery,
        GetWorkflowStatisticsOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowStatisticsOpsQuery | undefined,
  GetWorkflowStatisticsOpsQueryVariables
>;
export function useGetWorkflowStatisticsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWorkflowStatisticsOpsQuery,
        GetWorkflowStatisticsOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkflowStatisticsOpsQuery,
    GetWorkflowStatisticsOpsQueryVariables
  >(GetWorkflowStatisticsOpsDocument, options);
}
export type GetWorkflowStatisticsOpsQueryHookResult = ReturnType<
  typeof useGetWorkflowStatisticsOpsQuery
>;
export type GetWorkflowStatisticsOpsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowStatisticsOpsLazyQuery
>;
export type GetWorkflowStatisticsOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowStatisticsOpsSuspenseQuery
>;
export type GetWorkflowStatisticsOpsQueryResult = Apollo.QueryResult<
  GetWorkflowStatisticsOpsQuery,
  GetWorkflowStatisticsOpsQueryVariables
>;
export const ParseWorkflowYamlOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ParseWorkflowYamlOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'yamlContent' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parseWorkflowYaml' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'yamlContent' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'yamlContent' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useParseWorkflowYamlOpsQuery__
 *
 * To run a query within a React component, call `useParseWorkflowYamlOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParseWorkflowYamlOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParseWorkflowYamlOpsQuery({
 *   variables: {
 *      yamlContent: // value for 'yamlContent'
 *   },
 * });
 */
export function useParseWorkflowYamlOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ParseWorkflowYamlOpsQuery,
    ParseWorkflowYamlOpsQueryVariables
  > &
    ({ variables: ParseWorkflowYamlOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ParseWorkflowYamlOpsQuery, ParseWorkflowYamlOpsQueryVariables>(
    ParseWorkflowYamlOpsDocument,
    options,
  );
}
export function useParseWorkflowYamlOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ParseWorkflowYamlOpsQuery,
    ParseWorkflowYamlOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ParseWorkflowYamlOpsQuery, ParseWorkflowYamlOpsQueryVariables>(
    ParseWorkflowYamlOpsDocument,
    options,
  );
}
// @ts-ignore
export function useParseWorkflowYamlOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ParseWorkflowYamlOpsQuery,
    ParseWorkflowYamlOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ParseWorkflowYamlOpsQuery, ParseWorkflowYamlOpsQueryVariables>;
export function useParseWorkflowYamlOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ParseWorkflowYamlOpsQuery,
        ParseWorkflowYamlOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ParseWorkflowYamlOpsQuery | undefined,
  ParseWorkflowYamlOpsQueryVariables
>;
export function useParseWorkflowYamlOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ParseWorkflowYamlOpsQuery,
        ParseWorkflowYamlOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ParseWorkflowYamlOpsQuery, ParseWorkflowYamlOpsQueryVariables>(
    ParseWorkflowYamlOpsDocument,
    options,
  );
}
export type ParseWorkflowYamlOpsQueryHookResult = ReturnType<typeof useParseWorkflowYamlOpsQuery>;
export type ParseWorkflowYamlOpsLazyQueryHookResult = ReturnType<
  typeof useParseWorkflowYamlOpsLazyQuery
>;
export type ParseWorkflowYamlOpsSuspenseQueryHookResult = ReturnType<
  typeof useParseWorkflowYamlOpsSuspenseQuery
>;
export type ParseWorkflowYamlOpsQueryResult = Apollo.QueryResult<
  ParseWorkflowYamlOpsQuery,
  ParseWorkflowYamlOpsQueryVariables
>;
export const GetCompleteWorkflowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompleteWorkflowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsGetCompleteWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'version' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'states' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transitions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'signal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instances' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capabilities' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'components' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'componentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'executionMode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCompleteWorkflowOpsQuery__
 *
 * To run a query within a React component, call `useGetCompleteWorkflowOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompleteWorkflowOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompleteWorkflowOpsQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      name: // value for 'name'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetCompleteWorkflowOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCompleteWorkflowOpsQuery,
    GetCompleteWorkflowOpsQueryVariables
  > &
    ({ variables: GetCompleteWorkflowOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCompleteWorkflowOpsQuery, GetCompleteWorkflowOpsQueryVariables>(
    GetCompleteWorkflowOpsDocument,
    options,
  );
}
export function useGetCompleteWorkflowOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompleteWorkflowOpsQuery,
    GetCompleteWorkflowOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCompleteWorkflowOpsQuery, GetCompleteWorkflowOpsQueryVariables>(
    GetCompleteWorkflowOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetCompleteWorkflowOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCompleteWorkflowOpsQuery,
    GetCompleteWorkflowOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCompleteWorkflowOpsQuery, GetCompleteWorkflowOpsQueryVariables>;
export function useGetCompleteWorkflowOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCompleteWorkflowOpsQuery,
        GetCompleteWorkflowOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCompleteWorkflowOpsQuery | undefined,
  GetCompleteWorkflowOpsQueryVariables
>;
export function useGetCompleteWorkflowOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCompleteWorkflowOpsQuery,
        GetCompleteWorkflowOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCompleteWorkflowOpsQuery, GetCompleteWorkflowOpsQueryVariables>(
    GetCompleteWorkflowOpsDocument,
    options,
  );
}
export type GetCompleteWorkflowOpsQueryHookResult = ReturnType<
  typeof useGetCompleteWorkflowOpsQuery
>;
export type GetCompleteWorkflowOpsLazyQueryHookResult = ReturnType<
  typeof useGetCompleteWorkflowOpsLazyQuery
>;
export type GetCompleteWorkflowOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetCompleteWorkflowOpsSuspenseQuery
>;
export type GetCompleteWorkflowOpsQueryResult = Apollo.QueryResult<
  GetCompleteWorkflowOpsQuery,
  GetCompleteWorkflowOpsQueryVariables
>;
export const GetWorkflowGraphOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWorkflowGraphOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'graphId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkflowGraph' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'graphId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'graphId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'graphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graphName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWorkflowGraphOpsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowGraphOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowGraphOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowGraphOpsQuery({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetWorkflowGraphOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowGraphOpsQuery,
    GetWorkflowGraphOpsQueryVariables
  > &
    ({ variables: GetWorkflowGraphOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkflowGraphOpsQuery, GetWorkflowGraphOpsQueryVariables>(
    GetWorkflowGraphOpsDocument,
    options,
  );
}
export function useGetWorkflowGraphOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowGraphOpsQuery,
    GetWorkflowGraphOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkflowGraphOpsQuery, GetWorkflowGraphOpsQueryVariables>(
    GetWorkflowGraphOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetWorkflowGraphOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkflowGraphOpsQuery,
    GetWorkflowGraphOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetWorkflowGraphOpsQuery, GetWorkflowGraphOpsQueryVariables>;
export function useGetWorkflowGraphOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkflowGraphOpsQuery, GetWorkflowGraphOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetWorkflowGraphOpsQuery | undefined,
  GetWorkflowGraphOpsQueryVariables
>;
export function useGetWorkflowGraphOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkflowGraphOpsQuery, GetWorkflowGraphOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkflowGraphOpsQuery, GetWorkflowGraphOpsQueryVariables>(
    GetWorkflowGraphOpsDocument,
    options,
  );
}
export type GetWorkflowGraphOpsQueryHookResult = ReturnType<typeof useGetWorkflowGraphOpsQuery>;
export type GetWorkflowGraphOpsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowGraphOpsLazyQuery
>;
export type GetWorkflowGraphOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkflowGraphOpsSuspenseQuery
>;
export type GetWorkflowGraphOpsQueryResult = Apollo.QueryResult<
  GetWorkflowGraphOpsQuery,
  GetWorkflowGraphOpsQueryVariables
>;
export const SimulationAvailableTransitionsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SimulationAvailableTransitionsOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simulationAvailableTransitions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardNames' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSimulationAvailableTransitionsOpsQuery__
 *
 * To run a query within a React component, call `useSimulationAvailableTransitionsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulationAvailableTransitionsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulationAvailableTransitionsOpsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSimulationAvailableTransitionsOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SimulationAvailableTransitionsOpsQuery,
    SimulationAvailableTransitionsOpsQueryVariables
  > &
    (
      | { variables: SimulationAvailableTransitionsOpsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SimulationAvailableTransitionsOpsQuery,
    SimulationAvailableTransitionsOpsQueryVariables
  >(SimulationAvailableTransitionsOpsDocument, options);
}
export function useSimulationAvailableTransitionsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SimulationAvailableTransitionsOpsQuery,
    SimulationAvailableTransitionsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SimulationAvailableTransitionsOpsQuery,
    SimulationAvailableTransitionsOpsQueryVariables
  >(SimulationAvailableTransitionsOpsDocument, options);
}
// @ts-ignore
export function useSimulationAvailableTransitionsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SimulationAvailableTransitionsOpsQuery,
    SimulationAvailableTransitionsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SimulationAvailableTransitionsOpsQuery,
  SimulationAvailableTransitionsOpsQueryVariables
>;
export function useSimulationAvailableTransitionsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimulationAvailableTransitionsOpsQuery,
        SimulationAvailableTransitionsOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SimulationAvailableTransitionsOpsQuery | undefined,
  SimulationAvailableTransitionsOpsQueryVariables
>;
export function useSimulationAvailableTransitionsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimulationAvailableTransitionsOpsQuery,
        SimulationAvailableTransitionsOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SimulationAvailableTransitionsOpsQuery,
    SimulationAvailableTransitionsOpsQueryVariables
  >(SimulationAvailableTransitionsOpsDocument, options);
}
export type SimulationAvailableTransitionsOpsQueryHookResult = ReturnType<
  typeof useSimulationAvailableTransitionsOpsQuery
>;
export type SimulationAvailableTransitionsOpsLazyQueryHookResult = ReturnType<
  typeof useSimulationAvailableTransitionsOpsLazyQuery
>;
export type SimulationAvailableTransitionsOpsSuspenseQueryHookResult = ReturnType<
  typeof useSimulationAvailableTransitionsOpsSuspenseQuery
>;
export type SimulationAvailableTransitionsOpsQueryResult = Apollo.QueryResult<
  SimulationAvailableTransitionsOpsQuery,
  SimulationAvailableTransitionsOpsQueryVariables
>;
export const SimulationHistoryOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SimulationHistoryOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simulationHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUncertainGuards' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guardsEvaluated' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'guardName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'explanation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actionsPlanned' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'params' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sideEffectsSuppressed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'wouldCreate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSimulationHistoryOpsQuery__
 *
 * To run a query within a React component, call `useSimulationHistoryOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulationHistoryOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulationHistoryOpsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSimulationHistoryOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SimulationHistoryOpsQuery,
    SimulationHistoryOpsQueryVariables
  > &
    ({ variables: SimulationHistoryOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SimulationHistoryOpsQuery, SimulationHistoryOpsQueryVariables>(
    SimulationHistoryOpsDocument,
    options,
  );
}
export function useSimulationHistoryOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SimulationHistoryOpsQuery,
    SimulationHistoryOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SimulationHistoryOpsQuery, SimulationHistoryOpsQueryVariables>(
    SimulationHistoryOpsDocument,
    options,
  );
}
// @ts-ignore
export function useSimulationHistoryOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SimulationHistoryOpsQuery,
    SimulationHistoryOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SimulationHistoryOpsQuery, SimulationHistoryOpsQueryVariables>;
export function useSimulationHistoryOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimulationHistoryOpsQuery,
        SimulationHistoryOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SimulationHistoryOpsQuery | undefined,
  SimulationHistoryOpsQueryVariables
>;
export function useSimulationHistoryOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimulationHistoryOpsQuery,
        SimulationHistoryOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SimulationHistoryOpsQuery, SimulationHistoryOpsQueryVariables>(
    SimulationHistoryOpsDocument,
    options,
  );
}
export type SimulationHistoryOpsQueryHookResult = ReturnType<typeof useSimulationHistoryOpsQuery>;
export type SimulationHistoryOpsLazyQueryHookResult = ReturnType<
  typeof useSimulationHistoryOpsLazyQuery
>;
export type SimulationHistoryOpsSuspenseQueryHookResult = ReturnType<
  typeof useSimulationHistoryOpsSuspenseQuery
>;
export type SimulationHistoryOpsQueryResult = Apollo.QueryResult<
  SimulationHistoryOpsQuery,
  SimulationHistoryOpsQueryVariables
>;
export const ListIntegrationsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListIntegrationsOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listIntegrations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'IntegrationFields' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListIntegrationsOpsQuery__
 *
 * To run a query within a React component, call `useListIntegrationsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIntegrationsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIntegrationsOpsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListIntegrationsOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListIntegrationsOpsQuery,
    ListIntegrationsOpsQueryVariables
  > &
    ({ variables: ListIntegrationsOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListIntegrationsOpsQuery, ListIntegrationsOpsQueryVariables>(
    ListIntegrationsOpsDocument,
    options,
  );
}
export function useListIntegrationsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListIntegrationsOpsQuery,
    ListIntegrationsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListIntegrationsOpsQuery, ListIntegrationsOpsQueryVariables>(
    ListIntegrationsOpsDocument,
    options,
  );
}
// @ts-ignore
export function useListIntegrationsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListIntegrationsOpsQuery,
    ListIntegrationsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListIntegrationsOpsQuery, ListIntegrationsOpsQueryVariables>;
export function useListIntegrationsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListIntegrationsOpsQuery, ListIntegrationsOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListIntegrationsOpsQuery | undefined,
  ListIntegrationsOpsQueryVariables
>;
export function useListIntegrationsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListIntegrationsOpsQuery, ListIntegrationsOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListIntegrationsOpsQuery, ListIntegrationsOpsQueryVariables>(
    ListIntegrationsOpsDocument,
    options,
  );
}
export type ListIntegrationsOpsQueryHookResult = ReturnType<typeof useListIntegrationsOpsQuery>;
export type ListIntegrationsOpsLazyQueryHookResult = ReturnType<
  typeof useListIntegrationsOpsLazyQuery
>;
export type ListIntegrationsOpsSuspenseQueryHookResult = ReturnType<
  typeof useListIntegrationsOpsSuspenseQuery
>;
export type ListIntegrationsOpsQueryResult = Apollo.QueryResult<
  ListIntegrationsOpsQuery,
  ListIntegrationsOpsQueryVariables
>;
export const GetIntegrationOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetIntegrationOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgResponseTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consecutiveFailures' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHealthCheck' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uptimePercentage' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetIntegrationOpsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationOpsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetIntegrationOpsQuery(
  baseOptions: Apollo.QueryHookOptions<GetIntegrationOpsQuery, GetIntegrationOpsQueryVariables> &
    ({ variables: GetIntegrationOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIntegrationOpsQuery, GetIntegrationOpsQueryVariables>(
    GetIntegrationOpsDocument,
    options,
  );
}
export function useGetIntegrationOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationOpsQuery,
    GetIntegrationOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIntegrationOpsQuery, GetIntegrationOpsQueryVariables>(
    GetIntegrationOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetIntegrationOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntegrationOpsQuery,
    GetIntegrationOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetIntegrationOpsQuery, GetIntegrationOpsQueryVariables>;
export function useGetIntegrationOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIntegrationOpsQuery, GetIntegrationOpsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationOpsQuery | undefined,
  GetIntegrationOpsQueryVariables
>;
export function useGetIntegrationOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIntegrationOpsQuery, GetIntegrationOpsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIntegrationOpsQuery, GetIntegrationOpsQueryVariables>(
    GetIntegrationOpsDocument,
    options,
  );
}
export type GetIntegrationOpsQueryHookResult = ReturnType<typeof useGetIntegrationOpsQuery>;
export type GetIntegrationOpsLazyQueryHookResult = ReturnType<typeof useGetIntegrationOpsLazyQuery>;
export type GetIntegrationOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationOpsSuspenseQuery
>;
export type GetIntegrationOpsQueryResult = Apollo.QueryResult<
  GetIntegrationOpsQuery,
  GetIntegrationOpsQueryVariables
>;
export const GetIntegrationsByTypeOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetIntegrationsByTypeOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntegrationType' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getIntegrationsByType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consecutiveFailures' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetIntegrationsByTypeOpsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsByTypeOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsByTypeOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsByTypeOpsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useGetIntegrationsByTypeOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntegrationsByTypeOpsQuery,
    GetIntegrationsByTypeOpsQueryVariables
  > &
    ({ variables: GetIntegrationsByTypeOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIntegrationsByTypeOpsQuery, GetIntegrationsByTypeOpsQueryVariables>(
    GetIntegrationsByTypeOpsDocument,
    options,
  );
}
export function useGetIntegrationsByTypeOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationsByTypeOpsQuery,
    GetIntegrationsByTypeOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIntegrationsByTypeOpsQuery, GetIntegrationsByTypeOpsQueryVariables>(
    GetIntegrationsByTypeOpsDocument,
    options,
  );
}
// @ts-ignore
export function useGetIntegrationsByTypeOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntegrationsByTypeOpsQuery,
    GetIntegrationsByTypeOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsByTypeOpsQuery,
  GetIntegrationsByTypeOpsQueryVariables
>;
export function useGetIntegrationsByTypeOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsByTypeOpsQuery,
        GetIntegrationsByTypeOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsByTypeOpsQuery | undefined,
  GetIntegrationsByTypeOpsQueryVariables
>;
export function useGetIntegrationsByTypeOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsByTypeOpsQuery,
        GetIntegrationsByTypeOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIntegrationsByTypeOpsQuery,
    GetIntegrationsByTypeOpsQueryVariables
  >(GetIntegrationsByTypeOpsDocument, options);
}
export type GetIntegrationsByTypeOpsQueryHookResult = ReturnType<
  typeof useGetIntegrationsByTypeOpsQuery
>;
export type GetIntegrationsByTypeOpsLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationsByTypeOpsLazyQuery
>;
export type GetIntegrationsByTypeOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationsByTypeOpsSuspenseQuery
>;
export type GetIntegrationsByTypeOpsQueryResult = Apollo.QueryResult<
  GetIntegrationsByTypeOpsQuery,
  GetIntegrationsByTypeOpsQueryVariables
>;
export const GetIntegrationsByHealthStatusOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetIntegrationsByHealthStatusOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'healthStatus' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntegrationHealthStatus' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getIntegrationsByHealthStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'healthStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'healthStatus' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgResponseTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consecutiveFailures' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHealthCheck' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetIntegrationsByHealthStatusOpsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsByHealthStatusOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsByHealthStatusOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsByHealthStatusOpsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      healthStatus: // value for 'healthStatus'
 *   },
 * });
 */
export function useGetIntegrationsByHealthStatusOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntegrationsByHealthStatusOpsQuery,
    GetIntegrationsByHealthStatusOpsQueryVariables
  > &
    (
      | { variables: GetIntegrationsByHealthStatusOpsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIntegrationsByHealthStatusOpsQuery,
    GetIntegrationsByHealthStatusOpsQueryVariables
  >(GetIntegrationsByHealthStatusOpsDocument, options);
}
export function useGetIntegrationsByHealthStatusOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationsByHealthStatusOpsQuery,
    GetIntegrationsByHealthStatusOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIntegrationsByHealthStatusOpsQuery,
    GetIntegrationsByHealthStatusOpsQueryVariables
  >(GetIntegrationsByHealthStatusOpsDocument, options);
}
// @ts-ignore
export function useGetIntegrationsByHealthStatusOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntegrationsByHealthStatusOpsQuery,
    GetIntegrationsByHealthStatusOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsByHealthStatusOpsQuery,
  GetIntegrationsByHealthStatusOpsQueryVariables
>;
export function useGetIntegrationsByHealthStatusOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsByHealthStatusOpsQuery,
        GetIntegrationsByHealthStatusOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsByHealthStatusOpsQuery | undefined,
  GetIntegrationsByHealthStatusOpsQueryVariables
>;
export function useGetIntegrationsByHealthStatusOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsByHealthStatusOpsQuery,
        GetIntegrationsByHealthStatusOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIntegrationsByHealthStatusOpsQuery,
    GetIntegrationsByHealthStatusOpsQueryVariables
  >(GetIntegrationsByHealthStatusOpsDocument, options);
}
export type GetIntegrationsByHealthStatusOpsQueryHookResult = ReturnType<
  typeof useGetIntegrationsByHealthStatusOpsQuery
>;
export type GetIntegrationsByHealthStatusOpsLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationsByHealthStatusOpsLazyQuery
>;
export type GetIntegrationsByHealthStatusOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationsByHealthStatusOpsSuspenseQuery
>;
export type GetIntegrationsByHealthStatusOpsQueryResult = Apollo.QueryResult<
  GetIntegrationsByHealthStatusOpsQuery,
  GetIntegrationsByHealthStatusOpsQueryVariables
>;
export const GetIntegrationsWithOpenCircuitBreakerOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetIntegrationsWithOpenCircuitBreakerOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getIntegrationsWithOpenCircuitBreaker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consecutiveFailures' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHealthCheck' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetIntegrationsWithOpenCircuitBreakerOpsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsWithOpenCircuitBreakerOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsWithOpenCircuitBreakerOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsWithOpenCircuitBreakerOpsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetIntegrationsWithOpenCircuitBreakerOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntegrationsWithOpenCircuitBreakerOpsQuery,
    GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
  > &
    (
      | { variables: GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIntegrationsWithOpenCircuitBreakerOpsQuery,
    GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
  >(GetIntegrationsWithOpenCircuitBreakerOpsDocument, options);
}
export function useGetIntegrationsWithOpenCircuitBreakerOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationsWithOpenCircuitBreakerOpsQuery,
    GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIntegrationsWithOpenCircuitBreakerOpsQuery,
    GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
  >(GetIntegrationsWithOpenCircuitBreakerOpsDocument, options);
}
// @ts-ignore
export function useGetIntegrationsWithOpenCircuitBreakerOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntegrationsWithOpenCircuitBreakerOpsQuery,
    GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsWithOpenCircuitBreakerOpsQuery,
  GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
>;
export function useGetIntegrationsWithOpenCircuitBreakerOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsWithOpenCircuitBreakerOpsQuery,
        GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsWithOpenCircuitBreakerOpsQuery | undefined,
  GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
>;
export function useGetIntegrationsWithOpenCircuitBreakerOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsWithOpenCircuitBreakerOpsQuery,
        GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIntegrationsWithOpenCircuitBreakerOpsQuery,
    GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
  >(GetIntegrationsWithOpenCircuitBreakerOpsDocument, options);
}
export type GetIntegrationsWithOpenCircuitBreakerOpsQueryHookResult = ReturnType<
  typeof useGetIntegrationsWithOpenCircuitBreakerOpsQuery
>;
export type GetIntegrationsWithOpenCircuitBreakerOpsLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationsWithOpenCircuitBreakerOpsLazyQuery
>;
export type GetIntegrationsWithOpenCircuitBreakerOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationsWithOpenCircuitBreakerOpsSuspenseQuery
>;
export type GetIntegrationsWithOpenCircuitBreakerOpsQueryResult = Apollo.QueryResult<
  GetIntegrationsWithOpenCircuitBreakerOpsQuery,
  GetIntegrationsWithOpenCircuitBreakerOpsQueryVariables
>;
export const GetUnhealthyIntegrationsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUnhealthyIntegrationsOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUnhealthyIntegrations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consecutiveFailures' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgResponseTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastHealthCheck' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetUnhealthyIntegrationsOpsQuery__
 *
 * To run a query within a React component, call `useGetUnhealthyIntegrationsOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnhealthyIntegrationsOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnhealthyIntegrationsOpsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetUnhealthyIntegrationsOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUnhealthyIntegrationsOpsQuery,
    GetUnhealthyIntegrationsOpsQueryVariables
  > &
    ({ variables: GetUnhealthyIntegrationsOpsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUnhealthyIntegrationsOpsQuery,
    GetUnhealthyIntegrationsOpsQueryVariables
  >(GetUnhealthyIntegrationsOpsDocument, options);
}
export function useGetUnhealthyIntegrationsOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnhealthyIntegrationsOpsQuery,
    GetUnhealthyIntegrationsOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUnhealthyIntegrationsOpsQuery,
    GetUnhealthyIntegrationsOpsQueryVariables
  >(GetUnhealthyIntegrationsOpsDocument, options);
}
// @ts-ignore
export function useGetUnhealthyIntegrationsOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUnhealthyIntegrationsOpsQuery,
    GetUnhealthyIntegrationsOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetUnhealthyIntegrationsOpsQuery,
  GetUnhealthyIntegrationsOpsQueryVariables
>;
export function useGetUnhealthyIntegrationsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUnhealthyIntegrationsOpsQuery,
        GetUnhealthyIntegrationsOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetUnhealthyIntegrationsOpsQuery | undefined,
  GetUnhealthyIntegrationsOpsQueryVariables
>;
export function useGetUnhealthyIntegrationsOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUnhealthyIntegrationsOpsQuery,
        GetUnhealthyIntegrationsOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUnhealthyIntegrationsOpsQuery,
    GetUnhealthyIntegrationsOpsQueryVariables
  >(GetUnhealthyIntegrationsOpsDocument, options);
}
export type GetUnhealthyIntegrationsOpsQueryHookResult = ReturnType<
  typeof useGetUnhealthyIntegrationsOpsQuery
>;
export type GetUnhealthyIntegrationsOpsLazyQueryHookResult = ReturnType<
  typeof useGetUnhealthyIntegrationsOpsLazyQuery
>;
export type GetUnhealthyIntegrationsOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetUnhealthyIntegrationsOpsSuspenseQuery
>;
export type GetUnhealthyIntegrationsOpsQueryResult = Apollo.QueryResult<
  GetUnhealthyIntegrationsOpsQuery,
  GetUnhealthyIntegrationsOpsQueryVariables
>;
export const GetIntegrationsNeedingCredentialRotationOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetIntegrationsNeedingCredentialRotationOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getIntegrationsNeedingCredentialRotation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCredentialRotation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'credentialRotationDays' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rotateCredentials' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetIntegrationsNeedingCredentialRotationOpsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsNeedingCredentialRotationOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsNeedingCredentialRotationOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsNeedingCredentialRotationOpsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetIntegrationsNeedingCredentialRotationOpsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntegrationsNeedingCredentialRotationOpsQuery,
    GetIntegrationsNeedingCredentialRotationOpsQueryVariables
  > &
    (
      | { variables: GetIntegrationsNeedingCredentialRotationOpsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIntegrationsNeedingCredentialRotationOpsQuery,
    GetIntegrationsNeedingCredentialRotationOpsQueryVariables
  >(GetIntegrationsNeedingCredentialRotationOpsDocument, options);
}
export function useGetIntegrationsNeedingCredentialRotationOpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationsNeedingCredentialRotationOpsQuery,
    GetIntegrationsNeedingCredentialRotationOpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIntegrationsNeedingCredentialRotationOpsQuery,
    GetIntegrationsNeedingCredentialRotationOpsQueryVariables
  >(GetIntegrationsNeedingCredentialRotationOpsDocument, options);
}
// @ts-ignore
export function useGetIntegrationsNeedingCredentialRotationOpsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntegrationsNeedingCredentialRotationOpsQuery,
    GetIntegrationsNeedingCredentialRotationOpsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsNeedingCredentialRotationOpsQuery,
  GetIntegrationsNeedingCredentialRotationOpsQueryVariables
>;
export function useGetIntegrationsNeedingCredentialRotationOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsNeedingCredentialRotationOpsQuery,
        GetIntegrationsNeedingCredentialRotationOpsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIntegrationsNeedingCredentialRotationOpsQuery | undefined,
  GetIntegrationsNeedingCredentialRotationOpsQueryVariables
>;
export function useGetIntegrationsNeedingCredentialRotationOpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationsNeedingCredentialRotationOpsQuery,
        GetIntegrationsNeedingCredentialRotationOpsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIntegrationsNeedingCredentialRotationOpsQuery,
    GetIntegrationsNeedingCredentialRotationOpsQueryVariables
  >(GetIntegrationsNeedingCredentialRotationOpsDocument, options);
}
export type GetIntegrationsNeedingCredentialRotationOpsQueryHookResult = ReturnType<
  typeof useGetIntegrationsNeedingCredentialRotationOpsQuery
>;
export type GetIntegrationsNeedingCredentialRotationOpsLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationsNeedingCredentialRotationOpsLazyQuery
>;
export type GetIntegrationsNeedingCredentialRotationOpsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationsNeedingCredentialRotationOpsSuspenseQuery
>;
export type GetIntegrationsNeedingCredentialRotationOpsQueryResult = Apollo.QueryResult<
  GetIntegrationsNeedingCredentialRotationOpsQuery,
  GetIntegrationsNeedingCredentialRotationOpsQueryVariables
>;
export const TestIntegrationConnectionOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TestIntegrationConnectionOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'testIntegrationConnection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'testedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TestIntegrationConnectionOpsMutationFn = ApolloMutationFunction<
  TestIntegrationConnectionOpsMutation,
  TestIntegrationConnectionOpsMutationVariables
>;

/**
 * __useTestIntegrationConnectionOpsMutation__
 *
 * To run a mutation, you first call `useTestIntegrationConnectionOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestIntegrationConnectionOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testIntegrationConnectionOpsMutation, { data, loading, error }] = useTestIntegrationConnectionOpsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useTestIntegrationConnectionOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestIntegrationConnectionOpsMutation,
    TestIntegrationConnectionOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TestIntegrationConnectionOpsMutation,
    TestIntegrationConnectionOpsMutationVariables
  >(TestIntegrationConnectionOpsDocument, options);
}
export type TestIntegrationConnectionOpsMutationHookResult = ReturnType<
  typeof useTestIntegrationConnectionOpsMutation
>;
export type TestIntegrationConnectionOpsMutationResult =
  Apollo.MutationResult<TestIntegrationConnectionOpsMutation>;
export type TestIntegrationConnectionOpsMutationOptions = ApolloBaseMutationOptions<
  TestIntegrationConnectionOpsMutation,
  TestIntegrationConnectionOpsMutationVariables
>;
export const UpdateCircuitBreakerStateOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCircuitBreakerStateOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateCircuitBreakerInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCircuitBreakerState' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateCircuitBreakerStateOpsMutationFn = ApolloMutationFunction<
  UpdateCircuitBreakerStateOpsMutation,
  UpdateCircuitBreakerStateOpsMutationVariables
>;

/**
 * __useUpdateCircuitBreakerStateOpsMutation__
 *
 * To run a mutation, you first call `useUpdateCircuitBreakerStateOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCircuitBreakerStateOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCircuitBreakerStateOpsMutation, { data, loading, error }] = useUpdateCircuitBreakerStateOpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCircuitBreakerStateOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCircuitBreakerStateOpsMutation,
    UpdateCircuitBreakerStateOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCircuitBreakerStateOpsMutation,
    UpdateCircuitBreakerStateOpsMutationVariables
  >(UpdateCircuitBreakerStateOpsDocument, options);
}
export type UpdateCircuitBreakerStateOpsMutationHookResult = ReturnType<
  typeof useUpdateCircuitBreakerStateOpsMutation
>;
export type UpdateCircuitBreakerStateOpsMutationResult =
  Apollo.MutationResult<UpdateCircuitBreakerStateOpsMutation>;
export type UpdateCircuitBreakerStateOpsMutationOptions = ApolloBaseMutationOptions<
  UpdateCircuitBreakerStateOpsMutation,
  UpdateCircuitBreakerStateOpsMutationVariables
>;
export const RotateCredentialsOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RotateCredentialsOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rotateCredentials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastCredentialRotation' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RotateCredentialsOpsMutationFn = ApolloMutationFunction<
  RotateCredentialsOpsMutation,
  RotateCredentialsOpsMutationVariables
>;

/**
 * __useRotateCredentialsOpsMutation__
 *
 * To run a mutation, you first call `useRotateCredentialsOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateCredentialsOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateCredentialsOpsMutation, { data, loading, error }] = useRotateCredentialsOpsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRotateCredentialsOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RotateCredentialsOpsMutation,
    RotateCredentialsOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RotateCredentialsOpsMutation, RotateCredentialsOpsMutationVariables>(
    RotateCredentialsOpsDocument,
    options,
  );
}
export type RotateCredentialsOpsMutationHookResult = ReturnType<
  typeof useRotateCredentialsOpsMutation
>;
export type RotateCredentialsOpsMutationResult =
  Apollo.MutationResult<RotateCredentialsOpsMutation>;
export type RotateCredentialsOpsMutationOptions = ApolloBaseMutationOptions<
  RotateCredentialsOpsMutation,
  RotateCredentialsOpsMutationVariables
>;
export const CreateIntegrationOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateIntegrationOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateIntegrationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateIntegrationOpsMutationFn = ApolloMutationFunction<
  CreateIntegrationOpsMutation,
  CreateIntegrationOpsMutationVariables
>;

/**
 * __useCreateIntegrationOpsMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationOpsMutation, { data, loading, error }] = useCreateIntegrationOpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIntegrationOpsMutation,
    CreateIntegrationOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateIntegrationOpsMutation, CreateIntegrationOpsMutationVariables>(
    CreateIntegrationOpsDocument,
    options,
  );
}
export type CreateIntegrationOpsMutationHookResult = ReturnType<
  typeof useCreateIntegrationOpsMutation
>;
export type CreateIntegrationOpsMutationResult =
  Apollo.MutationResult<CreateIntegrationOpsMutation>;
export type CreateIntegrationOpsMutationOptions = ApolloBaseMutationOptions<
  CreateIntegrationOpsMutation,
  CreateIntegrationOpsMutationVariables
>;
export const UpdateIntegrationOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateIntegrationOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateIntegrationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'IntegrationFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateIntegrationOpsMutationFn = ApolloMutationFunction<
  UpdateIntegrationOpsMutation,
  UpdateIntegrationOpsMutationVariables
>;

/**
 * __useUpdateIntegrationOpsMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationOpsMutation, { data, loading, error }] = useUpdateIntegrationOpsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      integrationId: // value for 'integrationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIntegrationOpsMutation,
    UpdateIntegrationOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateIntegrationOpsMutation, UpdateIntegrationOpsMutationVariables>(
    UpdateIntegrationOpsDocument,
    options,
  );
}
export type UpdateIntegrationOpsMutationHookResult = ReturnType<
  typeof useUpdateIntegrationOpsMutation
>;
export type UpdateIntegrationOpsMutationResult =
  Apollo.MutationResult<UpdateIntegrationOpsMutation>;
export type UpdateIntegrationOpsMutationOptions = ApolloBaseMutationOptions<
  UpdateIntegrationOpsMutation,
  UpdateIntegrationOpsMutationVariables
>;
export const ArchiveIntegrationOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveIntegrationOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveIntegrationOpsMutationFn = ApolloMutationFunction<
  ArchiveIntegrationOpsMutation,
  ArchiveIntegrationOpsMutationVariables
>;

/**
 * __useArchiveIntegrationOpsMutation__
 *
 * To run a mutation, you first call `useArchiveIntegrationOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveIntegrationOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveIntegrationOpsMutation, { data, loading, error }] = useArchiveIntegrationOpsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      integrationId: // value for 'integrationId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveIntegrationOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveIntegrationOpsMutation,
    ArchiveIntegrationOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveIntegrationOpsMutation, ArchiveIntegrationOpsMutationVariables>(
    ArchiveIntegrationOpsDocument,
    options,
  );
}
export type ArchiveIntegrationOpsMutationHookResult = ReturnType<
  typeof useArchiveIntegrationOpsMutation
>;
export type ArchiveIntegrationOpsMutationResult =
  Apollo.MutationResult<ArchiveIntegrationOpsMutation>;
export type ArchiveIntegrationOpsMutationOptions = ApolloBaseMutationOptions<
  ArchiveIntegrationOpsMutation,
  ArchiveIntegrationOpsMutationVariables
>;
export const UpdateHealthStatusOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateHealthStatusOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateHealthStatusInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHealthStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateHealthStatusOpsMutationFn = ApolloMutationFunction<
  UpdateHealthStatusOpsMutation,
  UpdateHealthStatusOpsMutationVariables
>;

/**
 * __useUpdateHealthStatusOpsMutation__
 *
 * To run a mutation, you first call `useUpdateHealthStatusOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthStatusOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHealthStatusOpsMutation, { data, loading, error }] = useUpdateHealthStatusOpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHealthStatusOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHealthStatusOpsMutation,
    UpdateHealthStatusOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateHealthStatusOpsMutation, UpdateHealthStatusOpsMutationVariables>(
    UpdateHealthStatusOpsDocument,
    options,
  );
}
export type UpdateHealthStatusOpsMutationHookResult = ReturnType<
  typeof useUpdateHealthStatusOpsMutation
>;
export type UpdateHealthStatusOpsMutationResult =
  Apollo.MutationResult<UpdateHealthStatusOpsMutation>;
export type UpdateHealthStatusOpsMutationOptions = ApolloBaseMutationOptions<
  UpdateHealthStatusOpsMutation,
  UpdateHealthStatusOpsMutationVariables
>;
export const PauseScheduleOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PauseScheduleOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pauseSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PauseScheduleOpsMutationFn = ApolloMutationFunction<
  PauseScheduleOpsMutation,
  PauseScheduleOpsMutationVariables
>;

/**
 * __usePauseScheduleOpsMutation__
 *
 * To run a mutation, you first call `usePauseScheduleOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseScheduleOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseScheduleOpsMutation, { data, loading, error }] = usePauseScheduleOpsMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function usePauseScheduleOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PauseScheduleOpsMutation,
    PauseScheduleOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PauseScheduleOpsMutation, PauseScheduleOpsMutationVariables>(
    PauseScheduleOpsDocument,
    options,
  );
}
export type PauseScheduleOpsMutationHookResult = ReturnType<typeof usePauseScheduleOpsMutation>;
export type PauseScheduleOpsMutationResult = Apollo.MutationResult<PauseScheduleOpsMutation>;
export type PauseScheduleOpsMutationOptions = ApolloBaseMutationOptions<
  PauseScheduleOpsMutation,
  PauseScheduleOpsMutationVariables
>;
export const ResumeScheduleOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeScheduleOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResumeScheduleOpsMutationFn = ApolloMutationFunction<
  ResumeScheduleOpsMutation,
  ResumeScheduleOpsMutationVariables
>;

/**
 * __useResumeScheduleOpsMutation__
 *
 * To run a mutation, you first call `useResumeScheduleOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeScheduleOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeScheduleOpsMutation, { data, loading, error }] = useResumeScheduleOpsMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useResumeScheduleOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResumeScheduleOpsMutation,
    ResumeScheduleOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResumeScheduleOpsMutation, ResumeScheduleOpsMutationVariables>(
    ResumeScheduleOpsDocument,
    options,
  );
}
export type ResumeScheduleOpsMutationHookResult = ReturnType<typeof useResumeScheduleOpsMutation>;
export type ResumeScheduleOpsMutationResult = Apollo.MutationResult<ResumeScheduleOpsMutation>;
export type ResumeScheduleOpsMutationOptions = ApolloBaseMutationOptions<
  ResumeScheduleOpsMutation,
  ResumeScheduleOpsMutationVariables
>;
export const DisableScheduleOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisableScheduleOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disableSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DisableScheduleOpsMutationFn = ApolloMutationFunction<
  DisableScheduleOpsMutation,
  DisableScheduleOpsMutationVariables
>;

/**
 * __useDisableScheduleOpsMutation__
 *
 * To run a mutation, you first call `useDisableScheduleOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableScheduleOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableScheduleOpsMutation, { data, loading, error }] = useDisableScheduleOpsMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useDisableScheduleOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableScheduleOpsMutation,
    DisableScheduleOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisableScheduleOpsMutation, DisableScheduleOpsMutationVariables>(
    DisableScheduleOpsDocument,
    options,
  );
}
export type DisableScheduleOpsMutationHookResult = ReturnType<typeof useDisableScheduleOpsMutation>;
export type DisableScheduleOpsMutationResult = Apollo.MutationResult<DisableScheduleOpsMutation>;
export type DisableScheduleOpsMutationOptions = ApolloBaseMutationOptions<
  DisableScheduleOpsMutation,
  DisableScheduleOpsMutationVariables
>;
export const TriggerScheduleNowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerScheduleNowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerScheduleNow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TriggerScheduleNowOpsMutationFn = ApolloMutationFunction<
  TriggerScheduleNowOpsMutation,
  TriggerScheduleNowOpsMutationVariables
>;

/**
 * __useTriggerScheduleNowOpsMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleNowOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleNowOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerScheduleNowOpsMutation, { data, loading, error }] = useTriggerScheduleNowOpsMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useTriggerScheduleNowOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerScheduleNowOpsMutation,
    TriggerScheduleNowOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TriggerScheduleNowOpsMutation, TriggerScheduleNowOpsMutationVariables>(
    TriggerScheduleNowOpsDocument,
    options,
  );
}
export type TriggerScheduleNowOpsMutationHookResult = ReturnType<
  typeof useTriggerScheduleNowOpsMutation
>;
export type TriggerScheduleNowOpsMutationResult =
  Apollo.MutationResult<TriggerScheduleNowOpsMutation>;
export type TriggerScheduleNowOpsMutationOptions = ApolloBaseMutationOptions<
  TriggerScheduleNowOpsMutation,
  TriggerScheduleNowOpsMutationVariables
>;
export const CreateScheduleOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateScheduleOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateScheduleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateScheduleOpsMutationFn = ApolloMutationFunction<
  CreateScheduleOpsMutation,
  CreateScheduleOpsMutationVariables
>;

/**
 * __useCreateScheduleOpsMutation__
 *
 * To run a mutation, you first call `useCreateScheduleOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleOpsMutation, { data, loading, error }] = useCreateScheduleOpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScheduleOpsMutation,
    CreateScheduleOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateScheduleOpsMutation, CreateScheduleOpsMutationVariables>(
    CreateScheduleOpsDocument,
    options,
  );
}
export type CreateScheduleOpsMutationHookResult = ReturnType<typeof useCreateScheduleOpsMutation>;
export type CreateScheduleOpsMutationResult = Apollo.MutationResult<CreateScheduleOpsMutation>;
export type CreateScheduleOpsMutationOptions = ApolloBaseMutationOptions<
  CreateScheduleOpsMutation,
  CreateScheduleOpsMutationVariables
>;
export const RecordScheduleExecutionOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordScheduleExecutionOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'success' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'executionTimeMs' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordExecution' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'success' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'success' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'executionTimeMs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'executionTimeMs' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordScheduleExecutionOpsMutationFn = ApolloMutationFunction<
  RecordScheduleExecutionOpsMutation,
  RecordScheduleExecutionOpsMutationVariables
>;

/**
 * __useRecordScheduleExecutionOpsMutation__
 *
 * To run a mutation, you first call `useRecordScheduleExecutionOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordScheduleExecutionOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordScheduleExecutionOpsMutation, { data, loading, error }] = useRecordScheduleExecutionOpsMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      success: // value for 'success'
 *      executionTimeMs: // value for 'executionTimeMs'
 *   },
 * });
 */
export function useRecordScheduleExecutionOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordScheduleExecutionOpsMutation,
    RecordScheduleExecutionOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordScheduleExecutionOpsMutation,
    RecordScheduleExecutionOpsMutationVariables
  >(RecordScheduleExecutionOpsDocument, options);
}
export type RecordScheduleExecutionOpsMutationHookResult = ReturnType<
  typeof useRecordScheduleExecutionOpsMutation
>;
export type RecordScheduleExecutionOpsMutationResult =
  Apollo.MutationResult<RecordScheduleExecutionOpsMutation>;
export type RecordScheduleExecutionOpsMutationOptions = ApolloBaseMutationOptions<
  RecordScheduleExecutionOpsMutation,
  RecordScheduleExecutionOpsMutationVariables
>;
export const ArchiveScheduleOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveScheduleOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveScheduleOpsMutationFn = ApolloMutationFunction<
  ArchiveScheduleOpsMutation,
  ArchiveScheduleOpsMutationVariables
>;

/**
 * __useArchiveScheduleOpsMutation__
 *
 * To run a mutation, you first call `useArchiveScheduleOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScheduleOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScheduleOpsMutation, { data, loading, error }] = useArchiveScheduleOpsMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveScheduleOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveScheduleOpsMutation,
    ArchiveScheduleOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveScheduleOpsMutation, ArchiveScheduleOpsMutationVariables>(
    ArchiveScheduleOpsDocument,
    options,
  );
}
export type ArchiveScheduleOpsMutationHookResult = ReturnType<typeof useArchiveScheduleOpsMutation>;
export type ArchiveScheduleOpsMutationResult = Apollo.MutationResult<ArchiveScheduleOpsMutation>;
export type ArchiveScheduleOpsMutationOptions = ApolloBaseMutationOptions<
  ArchiveScheduleOpsMutation,
  ArchiveScheduleOpsMutationVariables
>;
export const ActivateWorkflowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateWorkflowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ActivateWorkflowOpsMutationFn = ApolloMutationFunction<
  ActivateWorkflowOpsMutation,
  ActivateWorkflowOpsMutationVariables
>;

/**
 * __useActivateWorkflowOpsMutation__
 *
 * To run a mutation, you first call `useActivateWorkflowOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateWorkflowOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateWorkflowOpsMutation, { data, loading, error }] = useActivateWorkflowOpsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useActivateWorkflowOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateWorkflowOpsMutation,
    ActivateWorkflowOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateWorkflowOpsMutation, ActivateWorkflowOpsMutationVariables>(
    ActivateWorkflowOpsDocument,
    options,
  );
}
export type ActivateWorkflowOpsMutationHookResult = ReturnType<
  typeof useActivateWorkflowOpsMutation
>;
export type ActivateWorkflowOpsMutationResult = Apollo.MutationResult<ActivateWorkflowOpsMutation>;
export type ActivateWorkflowOpsMutationOptions = ApolloBaseMutationOptions<
  ActivateWorkflowOpsMutation,
  ActivateWorkflowOpsMutationVariables
>;
export const DeactivateWorkflowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateWorkflowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeactivateWorkflowOpsMutationFn = ApolloMutationFunction<
  DeactivateWorkflowOpsMutation,
  DeactivateWorkflowOpsMutationVariables
>;

/**
 * __useDeactivateWorkflowOpsMutation__
 *
 * To run a mutation, you first call `useDeactivateWorkflowOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateWorkflowOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateWorkflowOpsMutation, { data, loading, error }] = useDeactivateWorkflowOpsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDeactivateWorkflowOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateWorkflowOpsMutation,
    DeactivateWorkflowOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeactivateWorkflowOpsMutation, DeactivateWorkflowOpsMutationVariables>(
    DeactivateWorkflowOpsDocument,
    options,
  );
}
export type DeactivateWorkflowOpsMutationHookResult = ReturnType<
  typeof useDeactivateWorkflowOpsMutation
>;
export type DeactivateWorkflowOpsMutationResult =
  Apollo.MutationResult<DeactivateWorkflowOpsMutation>;
export type DeactivateWorkflowOpsMutationOptions = ApolloBaseMutationOptions<
  DeactivateWorkflowOpsMutation,
  DeactivateWorkflowOpsMutationVariables
>;
export const CreateWorkflowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateWorkflowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlCreateWorkflowInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateWorkflowOpsMutationFn = ApolloMutationFunction<
  CreateWorkflowOpsMutation,
  CreateWorkflowOpsMutationVariables
>;

/**
 * __useCreateWorkflowOpsMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowOpsMutation, { data, loading, error }] = useCreateWorkflowOpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowOpsMutation,
    CreateWorkflowOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateWorkflowOpsMutation, CreateWorkflowOpsMutationVariables>(
    CreateWorkflowOpsDocument,
    options,
  );
}
export type CreateWorkflowOpsMutationHookResult = ReturnType<typeof useCreateWorkflowOpsMutation>;
export type CreateWorkflowOpsMutationResult = Apollo.MutationResult<CreateWorkflowOpsMutation>;
export type CreateWorkflowOpsMutationOptions = ApolloBaseMutationOptions<
  CreateWorkflowOpsMutation,
  CreateWorkflowOpsMutationVariables
>;
export const RecordWorkflowInstantiationOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordWorkflowInstantiationOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formulaName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'completed' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'errored' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordInstantiation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'formulaName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'formulaName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'durationSeconds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'durationSeconds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'completed' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'completed' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'errored' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'errored' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordWorkflowInstantiationOpsMutationFn = ApolloMutationFunction<
  RecordWorkflowInstantiationOpsMutation,
  RecordWorkflowInstantiationOpsMutationVariables
>;

/**
 * __useRecordWorkflowInstantiationOpsMutation__
 *
 * To run a mutation, you first call `useRecordWorkflowInstantiationOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordWorkflowInstantiationOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordWorkflowInstantiationOpsMutation, { data, loading, error }] = useRecordWorkflowInstantiationOpsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      formulaName: // value for 'formulaName'
 *      durationSeconds: // value for 'durationSeconds'
 *      completed: // value for 'completed'
 *      errored: // value for 'errored'
 *   },
 * });
 */
export function useRecordWorkflowInstantiationOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordWorkflowInstantiationOpsMutation,
    RecordWorkflowInstantiationOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordWorkflowInstantiationOpsMutation,
    RecordWorkflowInstantiationOpsMutationVariables
  >(RecordWorkflowInstantiationOpsDocument, options);
}
export type RecordWorkflowInstantiationOpsMutationHookResult = ReturnType<
  typeof useRecordWorkflowInstantiationOpsMutation
>;
export type RecordWorkflowInstantiationOpsMutationResult =
  Apollo.MutationResult<RecordWorkflowInstantiationOpsMutation>;
export type RecordWorkflowInstantiationOpsMutationOptions = ApolloBaseMutationOptions<
  RecordWorkflowInstantiationOpsMutation,
  RecordWorkflowInstantiationOpsMutationVariables
>;
export const CloneWorkflowOpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CloneWorkflowOps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceWorkflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'newVersion' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cloneWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceWorkflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceWorkflowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newVersion' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'newVersion' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CloneWorkflowOpsMutationFn = ApolloMutationFunction<
  CloneWorkflowOpsMutation,
  CloneWorkflowOpsMutationVariables
>;

/**
 * __useCloneWorkflowOpsMutation__
 *
 * To run a mutation, you first call `useCloneWorkflowOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneWorkflowOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneWorkflowOpsMutation, { data, loading, error }] = useCloneWorkflowOpsMutation({
 *   variables: {
 *      sourceWorkflowId: // value for 'sourceWorkflowId'
 *      newVersion: // value for 'newVersion'
 *   },
 * });
 */
export function useCloneWorkflowOpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneWorkflowOpsMutation,
    CloneWorkflowOpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloneWorkflowOpsMutation, CloneWorkflowOpsMutationVariables>(
    CloneWorkflowOpsDocument,
    options,
  );
}
export type CloneWorkflowOpsMutationHookResult = ReturnType<typeof useCloneWorkflowOpsMutation>;
export type CloneWorkflowOpsMutationResult = Apollo.MutationResult<CloneWorkflowOpsMutation>;
export type CloneWorkflowOpsMutationOptions = ApolloBaseMutationOptions<
  CloneWorkflowOpsMutation,
  CloneWorkflowOpsMutationVariables
>;
export const ExecutiveSafetyMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExecutiveSafetyMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyMetricsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'safetyMetricsExecutiveSafetyMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'overallSafetyScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditTrailIntegrity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emergencyResponseTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'riskLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'regulatoryCompliance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trend' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'domainMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trend' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useExecutiveSafetyMetricsQuery__
 *
 * To run a query within a React component, call `useExecutiveSafetyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecutiveSafetyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutiveSafetyMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecutiveSafetyMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExecutiveSafetyMetricsQuery,
    ExecutiveSafetyMetricsQueryVariables
  > &
    ({ variables: ExecutiveSafetyMetricsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExecutiveSafetyMetricsQuery, ExecutiveSafetyMetricsQueryVariables>(
    ExecutiveSafetyMetricsDocument,
    options,
  );
}
export function useExecutiveSafetyMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExecutiveSafetyMetricsQuery,
    ExecutiveSafetyMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExecutiveSafetyMetricsQuery, ExecutiveSafetyMetricsQueryVariables>(
    ExecutiveSafetyMetricsDocument,
    options,
  );
}
// @ts-ignore
export function useExecutiveSafetyMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExecutiveSafetyMetricsQuery,
    ExecutiveSafetyMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExecutiveSafetyMetricsQuery, ExecutiveSafetyMetricsQueryVariables>;
export function useExecutiveSafetyMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExecutiveSafetyMetricsQuery,
        ExecutiveSafetyMetricsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExecutiveSafetyMetricsQuery | undefined,
  ExecutiveSafetyMetricsQueryVariables
>;
export function useExecutiveSafetyMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExecutiveSafetyMetricsQuery,
        ExecutiveSafetyMetricsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExecutiveSafetyMetricsQuery, ExecutiveSafetyMetricsQueryVariables>(
    ExecutiveSafetyMetricsDocument,
    options,
  );
}
export type ExecutiveSafetyMetricsQueryHookResult = ReturnType<
  typeof useExecutiveSafetyMetricsQuery
>;
export type ExecutiveSafetyMetricsLazyQueryHookResult = ReturnType<
  typeof useExecutiveSafetyMetricsLazyQuery
>;
export type ExecutiveSafetyMetricsSuspenseQueryHookResult = ReturnType<
  typeof useExecutiveSafetyMetricsSuspenseQuery
>;
export type ExecutiveSafetyMetricsQueryResult = Apollo.QueryResult<
  ExecutiveSafetyMetricsQuery,
  ExecutiveSafetyMetricsQueryVariables
>;
export const GetCriticalEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCriticalEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventApiGetCriticalEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changeSummary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'performedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCriticalEventsQuery__
 *
 * To run a query within a React component, call `useGetCriticalEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCriticalEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCriticalEventsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCriticalEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCriticalEventsQuery, GetCriticalEventsQueryVariables> &
    ({ variables: GetCriticalEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCriticalEventsQuery, GetCriticalEventsQueryVariables>(
    GetCriticalEventsDocument,
    options,
  );
}
export function useGetCriticalEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCriticalEventsQuery,
    GetCriticalEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCriticalEventsQuery, GetCriticalEventsQueryVariables>(
    GetCriticalEventsDocument,
    options,
  );
}
// @ts-ignore
export function useGetCriticalEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCriticalEventsQuery,
    GetCriticalEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCriticalEventsQuery, GetCriticalEventsQueryVariables>;
export function useGetCriticalEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCriticalEventsQuery, GetCriticalEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetCriticalEventsQuery | undefined,
  GetCriticalEventsQueryVariables
>;
export function useGetCriticalEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCriticalEventsQuery, GetCriticalEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCriticalEventsQuery, GetCriticalEventsQueryVariables>(
    GetCriticalEventsDocument,
    options,
  );
}
export type GetCriticalEventsQueryHookResult = ReturnType<typeof useGetCriticalEventsQuery>;
export type GetCriticalEventsLazyQueryHookResult = ReturnType<typeof useGetCriticalEventsLazyQuery>;
export type GetCriticalEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetCriticalEventsSuspenseQuery
>;
export type GetCriticalEventsQueryResult = Apollo.QueryResult<
  GetCriticalEventsQuery,
  GetCriticalEventsQueryVariables
>;
export const GetCriticalPathDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCriticalPath' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dependencyApiGetCriticalPath' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'criticalPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalDuration' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'criticalTasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'earliestStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latestStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slack' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCriticalPathQuery__
 *
 * To run a query within a React component, call `useGetCriticalPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCriticalPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCriticalPathQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetCriticalPathQuery(
  baseOptions: Apollo.QueryHookOptions<GetCriticalPathQuery, GetCriticalPathQueryVariables> &
    ({ variables: GetCriticalPathQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCriticalPathQuery, GetCriticalPathQueryVariables>(
    GetCriticalPathDocument,
    options,
  );
}
export function useGetCriticalPathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCriticalPathQuery, GetCriticalPathQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCriticalPathQuery, GetCriticalPathQueryVariables>(
    GetCriticalPathDocument,
    options,
  );
}
// @ts-ignore
export function useGetCriticalPathSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCriticalPathQuery,
    GetCriticalPathQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCriticalPathQuery, GetCriticalPathQueryVariables>;
export function useGetCriticalPathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCriticalPathQuery, GetCriticalPathQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCriticalPathQuery | undefined, GetCriticalPathQueryVariables>;
export function useGetCriticalPathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCriticalPathQuery, GetCriticalPathQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCriticalPathQuery, GetCriticalPathQueryVariables>(
    GetCriticalPathDocument,
    options,
  );
}
export type GetCriticalPathQueryHookResult = ReturnType<typeof useGetCriticalPathQuery>;
export type GetCriticalPathLazyQueryHookResult = ReturnType<typeof useGetCriticalPathLazyQuery>;
export type GetCriticalPathSuspenseQueryHookResult = ReturnType<
  typeof useGetCriticalPathSuspenseQuery
>;
export type GetCriticalPathQueryResult = Apollo.QueryResult<
  GetCriticalPathQuery,
  GetCriticalPathQueryVariables
>;
export const GetSafetyEventsByTimerangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSafetyEventsByTimerange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'start' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'end' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'severityFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsGetSafetyEventsByTimerange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'start' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'start' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'end' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'end' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'severityFilter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'severityFilter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sagaExecutionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSafetyEventsByTimerangeQuery__
 *
 * To run a query within a React component, call `useGetSafetyEventsByTimerangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSafetyEventsByTimerangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSafetyEventsByTimerangeQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      severityFilter: // value for 'severityFilter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSafetyEventsByTimerangeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSafetyEventsByTimerangeQuery,
    GetSafetyEventsByTimerangeQueryVariables
  > &
    ({ variables: GetSafetyEventsByTimerangeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSafetyEventsByTimerangeQuery, GetSafetyEventsByTimerangeQueryVariables>(
    GetSafetyEventsByTimerangeDocument,
    options,
  );
}
export function useGetSafetyEventsByTimerangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSafetyEventsByTimerangeQuery,
    GetSafetyEventsByTimerangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSafetyEventsByTimerangeQuery,
    GetSafetyEventsByTimerangeQueryVariables
  >(GetSafetyEventsByTimerangeDocument, options);
}
// @ts-ignore
export function useGetSafetyEventsByTimerangeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSafetyEventsByTimerangeQuery,
    GetSafetyEventsByTimerangeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSafetyEventsByTimerangeQuery,
  GetSafetyEventsByTimerangeQueryVariables
>;
export function useGetSafetyEventsByTimerangeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSafetyEventsByTimerangeQuery,
        GetSafetyEventsByTimerangeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSafetyEventsByTimerangeQuery | undefined,
  GetSafetyEventsByTimerangeQueryVariables
>;
export function useGetSafetyEventsByTimerangeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSafetyEventsByTimerangeQuery,
        GetSafetyEventsByTimerangeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSafetyEventsByTimerangeQuery,
    GetSafetyEventsByTimerangeQueryVariables
  >(GetSafetyEventsByTimerangeDocument, options);
}
export type GetSafetyEventsByTimerangeQueryHookResult = ReturnType<
  typeof useGetSafetyEventsByTimerangeQuery
>;
export type GetSafetyEventsByTimerangeLazyQueryHookResult = ReturnType<
  typeof useGetSafetyEventsByTimerangeLazyQuery
>;
export type GetSafetyEventsByTimerangeSuspenseQueryHookResult = ReturnType<
  typeof useGetSafetyEventsByTimerangeSuspenseQuery
>;
export type GetSafetyEventsByTimerangeQueryResult = Apollo.QueryResult<
  GetSafetyEventsByTimerangeQuery,
  GetSafetyEventsByTimerangeQueryVariables
>;
export const GetStagedSafetyEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStagedSafetyEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'severityThreshold' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsGetStagedSafetyEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'severityThreshold' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'severityThreshold' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sagaExecutionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStagedSafetyEventsQuery__
 *
 * To run a query within a React component, call `useGetStagedSafetyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStagedSafetyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStagedSafetyEventsQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      severityThreshold: // value for 'severityThreshold'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStagedSafetyEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStagedSafetyEventsQuery,
    GetStagedSafetyEventsQueryVariables
  > &
    ({ variables: GetStagedSafetyEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStagedSafetyEventsQuery, GetStagedSafetyEventsQueryVariables>(
    GetStagedSafetyEventsDocument,
    options,
  );
}
export function useGetStagedSafetyEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStagedSafetyEventsQuery,
    GetStagedSafetyEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStagedSafetyEventsQuery, GetStagedSafetyEventsQueryVariables>(
    GetStagedSafetyEventsDocument,
    options,
  );
}
// @ts-ignore
export function useGetStagedSafetyEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetStagedSafetyEventsQuery,
    GetStagedSafetyEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetStagedSafetyEventsQuery, GetStagedSafetyEventsQueryVariables>;
export function useGetStagedSafetyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetStagedSafetyEventsQuery,
        GetStagedSafetyEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetStagedSafetyEventsQuery | undefined,
  GetStagedSafetyEventsQueryVariables
>;
export function useGetStagedSafetyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetStagedSafetyEventsQuery,
        GetStagedSafetyEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetStagedSafetyEventsQuery, GetStagedSafetyEventsQueryVariables>(
    GetStagedSafetyEventsDocument,
    options,
  );
}
export type GetStagedSafetyEventsQueryHookResult = ReturnType<typeof useGetStagedSafetyEventsQuery>;
export type GetStagedSafetyEventsLazyQueryHookResult = ReturnType<
  typeof useGetStagedSafetyEventsLazyQuery
>;
export type GetStagedSafetyEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetStagedSafetyEventsSuspenseQuery
>;
export type GetStagedSafetyEventsQueryResult = Apollo.QueryResult<
  GetStagedSafetyEventsQuery,
  GetStagedSafetyEventsQueryVariables
>;
export const SafetyListLifeCriticalSubgraphsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SafetyListLifeCriticalSubgraphs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listLifeCriticalSubgraphs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSafetyListLifeCriticalSubgraphsQuery__
 *
 * To run a query within a React component, call `useSafetyListLifeCriticalSubgraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyListLifeCriticalSubgraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyListLifeCriticalSubgraphsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSafetyListLifeCriticalSubgraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SafetyListLifeCriticalSubgraphsQuery,
    SafetyListLifeCriticalSubgraphsQueryVariables
  > &
    (
      | { variables: SafetyListLifeCriticalSubgraphsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SafetyListLifeCriticalSubgraphsQuery,
    SafetyListLifeCriticalSubgraphsQueryVariables
  >(SafetyListLifeCriticalSubgraphsDocument, options);
}
export function useSafetyListLifeCriticalSubgraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SafetyListLifeCriticalSubgraphsQuery,
    SafetyListLifeCriticalSubgraphsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SafetyListLifeCriticalSubgraphsQuery,
    SafetyListLifeCriticalSubgraphsQueryVariables
  >(SafetyListLifeCriticalSubgraphsDocument, options);
}
// @ts-ignore
export function useSafetyListLifeCriticalSubgraphsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SafetyListLifeCriticalSubgraphsQuery,
    SafetyListLifeCriticalSubgraphsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SafetyListLifeCriticalSubgraphsQuery,
  SafetyListLifeCriticalSubgraphsQueryVariables
>;
export function useSafetyListLifeCriticalSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SafetyListLifeCriticalSubgraphsQuery,
        SafetyListLifeCriticalSubgraphsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SafetyListLifeCriticalSubgraphsQuery | undefined,
  SafetyListLifeCriticalSubgraphsQueryVariables
>;
export function useSafetyListLifeCriticalSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SafetyListLifeCriticalSubgraphsQuery,
        SafetyListLifeCriticalSubgraphsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SafetyListLifeCriticalSubgraphsQuery,
    SafetyListLifeCriticalSubgraphsQueryVariables
  >(SafetyListLifeCriticalSubgraphsDocument, options);
}
export type SafetyListLifeCriticalSubgraphsQueryHookResult = ReturnType<
  typeof useSafetyListLifeCriticalSubgraphsQuery
>;
export type SafetyListLifeCriticalSubgraphsLazyQueryHookResult = ReturnType<
  typeof useSafetyListLifeCriticalSubgraphsLazyQuery
>;
export type SafetyListLifeCriticalSubgraphsSuspenseQueryHookResult = ReturnType<
  typeof useSafetyListLifeCriticalSubgraphsSuspenseQuery
>;
export type SafetyListLifeCriticalSubgraphsQueryResult = Apollo.QueryResult<
  SafetyListLifeCriticalSubgraphsQuery,
  SafetyListLifeCriticalSubgraphsQueryVariables
>;
export const FlushSafetyEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FlushSafetyEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flushSafetyEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FlushSafetyEventsMutationFn = ApolloMutationFunction<
  FlushSafetyEventsMutation,
  FlushSafetyEventsMutationVariables
>;

/**
 * __useFlushSafetyEventsMutation__
 *
 * To run a mutation, you first call `useFlushSafetyEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlushSafetyEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flushSafetyEventsMutation, { data, loading, error }] = useFlushSafetyEventsMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useFlushSafetyEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FlushSafetyEventsMutation,
    FlushSafetyEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FlushSafetyEventsMutation, FlushSafetyEventsMutationVariables>(
    FlushSafetyEventsDocument,
    options,
  );
}
export type FlushSafetyEventsMutationHookResult = ReturnType<typeof useFlushSafetyEventsMutation>;
export type FlushSafetyEventsMutationResult = Apollo.MutationResult<FlushSafetyEventsMutation>;
export type FlushSafetyEventsMutationOptions = ApolloBaseMutationOptions<
  FlushSafetyEventsMutation,
  FlushSafetyEventsMutationVariables
>;
export const PersistSafetyEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PersistSafetyEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'persistSafetyEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyScore' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PersistSafetyEventMutationFn = ApolloMutationFunction<
  PersistSafetyEventMutation,
  PersistSafetyEventMutationVariables
>;

/**
 * __usePersistSafetyEventMutation__
 *
 * To run a mutation, you first call `usePersistSafetyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistSafetyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistSafetyEventMutation, { data, loading, error }] = usePersistSafetyEventMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function usePersistSafetyEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PersistSafetyEventMutation,
    PersistSafetyEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PersistSafetyEventMutation, PersistSafetyEventMutationVariables>(
    PersistSafetyEventDocument,
    options,
  );
}
export type PersistSafetyEventMutationHookResult = ReturnType<typeof usePersistSafetyEventMutation>;
export type PersistSafetyEventMutationResult = Apollo.MutationResult<PersistSafetyEventMutation>;
export type PersistSafetyEventMutationOptions = ApolloBaseMutationOptions<
  PersistSafetyEventMutation,
  PersistSafetyEventMutationVariables
>;
export const UpdateSafetyEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSafetyEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSafetyEventInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSafetyEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyScore' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateSafetyEventMutationFn = ApolloMutationFunction<
  UpdateSafetyEventMutation,
  UpdateSafetyEventMutationVariables
>;

/**
 * __useUpdateSafetyEventMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyEventMutation, { data, loading, error }] = useUpdateSafetyEventMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafetyEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSafetyEventMutation,
    UpdateSafetyEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSafetyEventMutation, UpdateSafetyEventMutationVariables>(
    UpdateSafetyEventDocument,
    options,
  );
}
export type UpdateSafetyEventMutationHookResult = ReturnType<typeof useUpdateSafetyEventMutation>;
export type UpdateSafetyEventMutationResult = Apollo.MutationResult<UpdateSafetyEventMutation>;
export type UpdateSafetyEventMutationOptions = ApolloBaseMutationOptions<
  UpdateSafetyEventMutation,
  UpdateSafetyEventMutationVariables
>;
export const UpdateCriticalityConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCriticalityConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'config' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CriticalityConfigInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCriticalityConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'config' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'config' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateCriticalityConfigMutationFn = ApolloMutationFunction<
  UpdateCriticalityConfigMutation,
  UpdateCriticalityConfigMutationVariables
>;

/**
 * __useUpdateCriticalityConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCriticalityConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCriticalityConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCriticalityConfigMutation, { data, loading, error }] = useUpdateCriticalityConfigMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateCriticalityConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCriticalityConfigMutation,
    UpdateCriticalityConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCriticalityConfigMutation,
    UpdateCriticalityConfigMutationVariables
  >(UpdateCriticalityConfigDocument, options);
}
export type UpdateCriticalityConfigMutationHookResult = ReturnType<
  typeof useUpdateCriticalityConfigMutation
>;
export type UpdateCriticalityConfigMutationResult =
  Apollo.MutationResult<UpdateCriticalityConfigMutation>;
export type UpdateCriticalityConfigMutationOptions = ApolloBaseMutationOptions<
  UpdateCriticalityConfigMutation,
  UpdateCriticalityConfigMutationVariables
>;
export const EmergencyActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EmergencyAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emergencyInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmergencyControlInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emergencyAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emergencyInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emergencyInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initiatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initiatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affectedComponents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resultMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EmergencyActionMutationFn = ApolloMutationFunction<
  EmergencyActionMutation,
  EmergencyActionMutationVariables
>;

/**
 * __useEmergencyActionMutation__
 *
 * To run a mutation, you first call `useEmergencyActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmergencyActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emergencyActionMutation, { data, loading, error }] = useEmergencyActionMutation({
 *   variables: {
 *      emergencyInput: // value for 'emergencyInput'
 *   },
 * });
 */
export function useEmergencyActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmergencyActionMutation,
    EmergencyActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EmergencyActionMutation, EmergencyActionMutationVariables>(
    EmergencyActionDocument,
    options,
  );
}
export type EmergencyActionMutationHookResult = ReturnType<typeof useEmergencyActionMutation>;
export type EmergencyActionMutationResult = Apollo.MutationResult<EmergencyActionMutation>;
export type EmergencyActionMutationOptions = ApolloBaseMutationOptions<
  EmergencyActionMutation,
  EmergencyActionMutationVariables
>;
export const RequestEmergencyAccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestEmergencyAccess' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmergencyAccessInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestEmergencyAccess' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'incidentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationHours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestEmergencyAccessMutationFn = ApolloMutationFunction<
  RequestEmergencyAccessMutation,
  RequestEmergencyAccessMutationVariables
>;

/**
 * __useRequestEmergencyAccessMutation__
 *
 * To run a mutation, you first call `useRequestEmergencyAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmergencyAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmergencyAccessMutation, { data, loading, error }] = useRequestEmergencyAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEmergencyAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestEmergencyAccessMutation,
    RequestEmergencyAccessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestEmergencyAccessMutation,
    RequestEmergencyAccessMutationVariables
  >(RequestEmergencyAccessDocument, options);
}
export type RequestEmergencyAccessMutationHookResult = ReturnType<
  typeof useRequestEmergencyAccessMutation
>;
export type RequestEmergencyAccessMutationResult =
  Apollo.MutationResult<RequestEmergencyAccessMutation>;
export type RequestEmergencyAccessMutationOptions = ApolloBaseMutationOptions<
  RequestEmergencyAccessMutation,
  RequestEmergencyAccessMutationVariables
>;
export const RevokeEmergencyAccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokeEmergencyAccess' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'incidentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeEmergencyAccess' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'incidentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'incidentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'incidentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedByName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RevokeEmergencyAccessMutationFn = ApolloMutationFunction<
  RevokeEmergencyAccessMutation,
  RevokeEmergencyAccessMutationVariables
>;

/**
 * __useRevokeEmergencyAccessMutation__
 *
 * To run a mutation, you first call `useRevokeEmergencyAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeEmergencyAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeEmergencyAccessMutation, { data, loading, error }] = useRevokeEmergencyAccessMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useRevokeEmergencyAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeEmergencyAccessMutation,
    RevokeEmergencyAccessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeEmergencyAccessMutation, RevokeEmergencyAccessMutationVariables>(
    RevokeEmergencyAccessDocument,
    options,
  );
}
export type RevokeEmergencyAccessMutationHookResult = ReturnType<
  typeof useRevokeEmergencyAccessMutation
>;
export type RevokeEmergencyAccessMutationResult =
  Apollo.MutationResult<RevokeEmergencyAccessMutation>;
export type RevokeEmergencyAccessMutationOptions = ApolloBaseMutationOptions<
  RevokeEmergencyAccessMutation,
  RevokeEmergencyAccessMutationVariables
>;
export const EmergencyOverrideRegulatoryThresholdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EmergencyOverrideRegulatoryThreshold' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmergencyOverrideInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emergencyOverrideRegulatoryThreshold' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EmergencyOverrideRegulatoryThresholdMutationFn = ApolloMutationFunction<
  EmergencyOverrideRegulatoryThresholdMutation,
  EmergencyOverrideRegulatoryThresholdMutationVariables
>;

/**
 * __useEmergencyOverrideRegulatoryThresholdMutation__
 *
 * To run a mutation, you first call `useEmergencyOverrideRegulatoryThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmergencyOverrideRegulatoryThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emergencyOverrideRegulatoryThresholdMutation, { data, loading, error }] = useEmergencyOverrideRegulatoryThresholdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmergencyOverrideRegulatoryThresholdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmergencyOverrideRegulatoryThresholdMutation,
    EmergencyOverrideRegulatoryThresholdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EmergencyOverrideRegulatoryThresholdMutation,
    EmergencyOverrideRegulatoryThresholdMutationVariables
  >(EmergencyOverrideRegulatoryThresholdDocument, options);
}
export type EmergencyOverrideRegulatoryThresholdMutationHookResult = ReturnType<
  typeof useEmergencyOverrideRegulatoryThresholdMutation
>;
export type EmergencyOverrideRegulatoryThresholdMutationResult =
  Apollo.MutationResult<EmergencyOverrideRegulatoryThresholdMutation>;
export type EmergencyOverrideRegulatoryThresholdMutationOptions = ApolloBaseMutationOptions<
  EmergencyOverrideRegulatoryThresholdMutation,
  EmergencyOverrideRegulatoryThresholdMutationVariables
>;
export const BreakGlassWallOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BreakGlassWallOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BreakGlassOverrideInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'breakGlassWallOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'granted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overrideToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditEventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationSent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'denialReason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BreakGlassWallOverrideMutationFn = ApolloMutationFunction<
  BreakGlassWallOverrideMutation,
  BreakGlassWallOverrideMutationVariables
>;

/**
 * __useBreakGlassWallOverrideMutation__
 *
 * To run a mutation, you first call `useBreakGlassWallOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBreakGlassWallOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [breakGlassWallOverrideMutation, { data, loading, error }] = useBreakGlassWallOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBreakGlassWallOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BreakGlassWallOverrideMutation,
    BreakGlassWallOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BreakGlassWallOverrideMutation,
    BreakGlassWallOverrideMutationVariables
  >(BreakGlassWallOverrideDocument, options);
}
export type BreakGlassWallOverrideMutationHookResult = ReturnType<
  typeof useBreakGlassWallOverrideMutation
>;
export type BreakGlassWallOverrideMutationResult =
  Apollo.MutationResult<BreakGlassWallOverrideMutation>;
export type BreakGlassWallOverrideMutationOptions = ApolloBaseMutationOptions<
  BreakGlassWallOverrideMutation,
  BreakGlassWallOverrideMutationVariables
>;
export const ListPublishedTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListPublishedTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listPublishedTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usageCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListPublishedTemplatesQuery__
 *
 * To run a query within a React component, call `useListPublishedTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPublishedTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPublishedTemplatesQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useListPublishedTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPublishedTemplatesQuery,
    ListPublishedTemplatesQueryVariables
  > &
    ({ variables: ListPublishedTemplatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPublishedTemplatesQuery, ListPublishedTemplatesQueryVariables>(
    ListPublishedTemplatesDocument,
    options,
  );
}
export function useListPublishedTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPublishedTemplatesQuery,
    ListPublishedTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPublishedTemplatesQuery, ListPublishedTemplatesQueryVariables>(
    ListPublishedTemplatesDocument,
    options,
  );
}
// @ts-ignore
export function useListPublishedTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPublishedTemplatesQuery,
    ListPublishedTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListPublishedTemplatesQuery, ListPublishedTemplatesQueryVariables>;
export function useListPublishedTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPublishedTemplatesQuery,
        ListPublishedTemplatesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListPublishedTemplatesQuery | undefined,
  ListPublishedTemplatesQueryVariables
>;
export function useListPublishedTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPublishedTemplatesQuery,
        ListPublishedTemplatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPublishedTemplatesQuery, ListPublishedTemplatesQueryVariables>(
    ListPublishedTemplatesDocument,
    options,
  );
}
export type ListPublishedTemplatesQueryHookResult = ReturnType<
  typeof useListPublishedTemplatesQuery
>;
export type ListPublishedTemplatesLazyQueryHookResult = ReturnType<
  typeof useListPublishedTemplatesLazyQuery
>;
export type ListPublishedTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useListPublishedTemplatesSuspenseQuery
>;
export type ListPublishedTemplatesQueryResult = Apollo.QueryResult<
  ListPublishedTemplatesQuery,
  ListPublishedTemplatesQueryVariables
>;
export const TerminologyOverridesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TerminologyOverrides' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terminologyOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedTerm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decidedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decisionRationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'violatedConstraint' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTerminologyOverridesQuery__
 *
 * To run a query within a React component, call `useTerminologyOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminologyOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerminologyOverridesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTerminologyOverridesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TerminologyOverridesQuery,
    TerminologyOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TerminologyOverridesQuery, TerminologyOverridesQueryVariables>(
    TerminologyOverridesDocument,
    options,
  );
}
export function useTerminologyOverridesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TerminologyOverridesQuery,
    TerminologyOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TerminologyOverridesQuery, TerminologyOverridesQueryVariables>(
    TerminologyOverridesDocument,
    options,
  );
}
// @ts-ignore
export function useTerminologyOverridesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TerminologyOverridesQuery,
    TerminologyOverridesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TerminologyOverridesQuery, TerminologyOverridesQueryVariables>;
export function useTerminologyOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TerminologyOverridesQuery,
        TerminologyOverridesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TerminologyOverridesQuery | undefined,
  TerminologyOverridesQueryVariables
>;
export function useTerminologyOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TerminologyOverridesQuery,
        TerminologyOverridesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TerminologyOverridesQuery, TerminologyOverridesQueryVariables>(
    TerminologyOverridesDocument,
    options,
  );
}
export type TerminologyOverridesQueryHookResult = ReturnType<typeof useTerminologyOverridesQuery>;
export type TerminologyOverridesLazyQueryHookResult = ReturnType<
  typeof useTerminologyOverridesLazyQuery
>;
export type TerminologyOverridesSuspenseQueryHookResult = ReturnType<
  typeof useTerminologyOverridesSuspenseQuery
>;
export type TerminologyOverridesQueryResult = Apollo.QueryResult<
  TerminologyOverridesQuery,
  TerminologyOverridesQueryVariables
>;
export const CoRespondersForInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoRespondersForInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentActorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsTaskCoRespondersForInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constellationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coResponders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSelf' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCoRespondersForInstanceQuery__
 *
 * To run a query within a React component, call `useCoRespondersForInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoRespondersForInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoRespondersForInstanceQuery({
 *   variables: {
 *      constellationId: // value for 'constellationId'
 *      instanceId: // value for 'instanceId'
 *      currentActorId: // value for 'currentActorId'
 *   },
 * });
 */
export function useCoRespondersForInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoRespondersForInstanceQuery,
    CoRespondersForInstanceQueryVariables
  > &
    ({ variables: CoRespondersForInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CoRespondersForInstanceQuery, CoRespondersForInstanceQueryVariables>(
    CoRespondersForInstanceDocument,
    options,
  );
}
export function useCoRespondersForInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoRespondersForInstanceQuery,
    CoRespondersForInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CoRespondersForInstanceQuery, CoRespondersForInstanceQueryVariables>(
    CoRespondersForInstanceDocument,
    options,
  );
}
// @ts-ignore
export function useCoRespondersForInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CoRespondersForInstanceQuery,
    CoRespondersForInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CoRespondersForInstanceQuery,
  CoRespondersForInstanceQueryVariables
>;
export function useCoRespondersForInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoRespondersForInstanceQuery,
        CoRespondersForInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CoRespondersForInstanceQuery | undefined,
  CoRespondersForInstanceQueryVariables
>;
export function useCoRespondersForInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoRespondersForInstanceQuery,
        CoRespondersForInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoRespondersForInstanceQuery,
    CoRespondersForInstanceQueryVariables
  >(CoRespondersForInstanceDocument, options);
}
export type CoRespondersForInstanceQueryHookResult = ReturnType<
  typeof useCoRespondersForInstanceQuery
>;
export type CoRespondersForInstanceLazyQueryHookResult = ReturnType<
  typeof useCoRespondersForInstanceLazyQuery
>;
export type CoRespondersForInstanceSuspenseQueryHookResult = ReturnType<
  typeof useCoRespondersForInstanceSuspenseQuery
>;
export type CoRespondersForInstanceQueryResult = Apollo.QueryResult<
  CoRespondersForInstanceQuery,
  CoRespondersForInstanceQueryVariables
>;
export const DagWorkflowByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DagWorkflowById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dagWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeoutMs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dependsOn' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phases' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'engine' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDagWorkflowByIdQuery__
 *
 * To run a query within a React component, call `useDagWorkflowByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDagWorkflowByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDagWorkflowByIdQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDagWorkflowByIdQuery(
  baseOptions: Apollo.QueryHookOptions<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables> &
    ({ variables: DagWorkflowByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables>(
    DagWorkflowByIdDocument,
    options,
  );
}
export function useDagWorkflowByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables>(
    DagWorkflowByIdDocument,
    options,
  );
}
// @ts-ignore
export function useDagWorkflowByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DagWorkflowByIdQuery,
    DagWorkflowByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables>;
export function useDagWorkflowByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<DagWorkflowByIdQuery | undefined, DagWorkflowByIdQueryVariables>;
export function useDagWorkflowByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DagWorkflowByIdQuery, DagWorkflowByIdQueryVariables>(
    DagWorkflowByIdDocument,
    options,
  );
}
export type DagWorkflowByIdQueryHookResult = ReturnType<typeof useDagWorkflowByIdQuery>;
export type DagWorkflowByIdLazyQueryHookResult = ReturnType<typeof useDagWorkflowByIdLazyQuery>;
export type DagWorkflowByIdSuspenseQueryHookResult = ReturnType<
  typeof useDagWorkflowByIdSuspenseQuery
>;
export type DagWorkflowByIdQueryResult = Apollo.QueryResult<
  DagWorkflowByIdQuery,
  DagWorkflowByIdQueryVariables
>;
export const DagWorkflowDefinitionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DagWorkflowDefinitions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dagWorkflowDefinitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeoutMs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dependsOn' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phases' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phaseId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'engine' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDagWorkflowDefinitionsQuery__
 *
 * To run a query within a React component, call `useDagWorkflowDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDagWorkflowDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDagWorkflowDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDagWorkflowDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DagWorkflowDefinitionsQuery,
    DagWorkflowDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DagWorkflowDefinitionsQuery, DagWorkflowDefinitionsQueryVariables>(
    DagWorkflowDefinitionsDocument,
    options,
  );
}
export function useDagWorkflowDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DagWorkflowDefinitionsQuery,
    DagWorkflowDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DagWorkflowDefinitionsQuery, DagWorkflowDefinitionsQueryVariables>(
    DagWorkflowDefinitionsDocument,
    options,
  );
}
// @ts-ignore
export function useDagWorkflowDefinitionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DagWorkflowDefinitionsQuery,
    DagWorkflowDefinitionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DagWorkflowDefinitionsQuery, DagWorkflowDefinitionsQueryVariables>;
export function useDagWorkflowDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DagWorkflowDefinitionsQuery,
        DagWorkflowDefinitionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DagWorkflowDefinitionsQuery | undefined,
  DagWorkflowDefinitionsQueryVariables
>;
export function useDagWorkflowDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DagWorkflowDefinitionsQuery,
        DagWorkflowDefinitionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DagWorkflowDefinitionsQuery, DagWorkflowDefinitionsQueryVariables>(
    DagWorkflowDefinitionsDocument,
    options,
  );
}
export type DagWorkflowDefinitionsQueryHookResult = ReturnType<
  typeof useDagWorkflowDefinitionsQuery
>;
export type DagWorkflowDefinitionsLazyQueryHookResult = ReturnType<
  typeof useDagWorkflowDefinitionsLazyQuery
>;
export type DagWorkflowDefinitionsSuspenseQueryHookResult = ReturnType<
  typeof useDagWorkflowDefinitionsSuspenseQuery
>;
export type DagWorkflowDefinitionsQueryResult = Apollo.QueryResult<
  DagWorkflowDefinitionsQuery,
  DagWorkflowDefinitionsQueryVariables
>;
export const GetEventsByWorkflowInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventsByWorkflowInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventApiGetEventsByWorkflowInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventsByWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useGetEventsByWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByWorkflowInstanceQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useGetEventsByWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventsByWorkflowInstanceQuery,
    GetEventsByWorkflowInstanceQueryVariables
  > &
    ({ variables: GetEventsByWorkflowInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventsByWorkflowInstanceQuery,
    GetEventsByWorkflowInstanceQueryVariables
  >(GetEventsByWorkflowInstanceDocument, options);
}
export function useGetEventsByWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventsByWorkflowInstanceQuery,
    GetEventsByWorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventsByWorkflowInstanceQuery,
    GetEventsByWorkflowInstanceQueryVariables
  >(GetEventsByWorkflowInstanceDocument, options);
}
// @ts-ignore
export function useGetEventsByWorkflowInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventsByWorkflowInstanceQuery,
    GetEventsByWorkflowInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEventsByWorkflowInstanceQuery,
  GetEventsByWorkflowInstanceQueryVariables
>;
export function useGetEventsByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventsByWorkflowInstanceQuery,
        GetEventsByWorkflowInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEventsByWorkflowInstanceQuery | undefined,
  GetEventsByWorkflowInstanceQueryVariables
>;
export function useGetEventsByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventsByWorkflowInstanceQuery,
        GetEventsByWorkflowInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventsByWorkflowInstanceQuery,
    GetEventsByWorkflowInstanceQueryVariables
  >(GetEventsByWorkflowInstanceDocument, options);
}
export type GetEventsByWorkflowInstanceQueryHookResult = ReturnType<
  typeof useGetEventsByWorkflowInstanceQuery
>;
export type GetEventsByWorkflowInstanceLazyQueryHookResult = ReturnType<
  typeof useGetEventsByWorkflowInstanceLazyQuery
>;
export type GetEventsByWorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useGetEventsByWorkflowInstanceSuspenseQuery
>;
export type GetEventsByWorkflowInstanceQueryResult = Apollo.QueryResult<
  GetEventsByWorkflowInstanceQuery,
  GetEventsByWorkflowInstanceQueryVariables
>;
export const GetFhirMedStatementsBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFhirMedStatementsBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedStatementsBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFhirMedStatementsBySubjectQuery__
 *
 * To run a query within a React component, call `useGetFhirMedStatementsBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirMedStatementsBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirMedStatementsBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetFhirMedStatementsBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFhirMedStatementsBySubjectQuery,
    GetFhirMedStatementsBySubjectQueryVariables
  > &
    (
      | { variables: GetFhirMedStatementsBySubjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFhirMedStatementsBySubjectQuery,
    GetFhirMedStatementsBySubjectQueryVariables
  >(GetFhirMedStatementsBySubjectDocument, options);
}
export function useGetFhirMedStatementsBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFhirMedStatementsBySubjectQuery,
    GetFhirMedStatementsBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFhirMedStatementsBySubjectQuery,
    GetFhirMedStatementsBySubjectQueryVariables
  >(GetFhirMedStatementsBySubjectDocument, options);
}
// @ts-ignore
export function useGetFhirMedStatementsBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFhirMedStatementsBySubjectQuery,
    GetFhirMedStatementsBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedStatementsBySubjectQuery,
  GetFhirMedStatementsBySubjectQueryVariables
>;
export function useGetFhirMedStatementsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedStatementsBySubjectQuery,
        GetFhirMedStatementsBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedStatementsBySubjectQuery | undefined,
  GetFhirMedStatementsBySubjectQueryVariables
>;
export function useGetFhirMedStatementsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedStatementsBySubjectQuery,
        GetFhirMedStatementsBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFhirMedStatementsBySubjectQuery,
    GetFhirMedStatementsBySubjectQueryVariables
  >(GetFhirMedStatementsBySubjectDocument, options);
}
export type GetFhirMedStatementsBySubjectQueryHookResult = ReturnType<
  typeof useGetFhirMedStatementsBySubjectQuery
>;
export type GetFhirMedStatementsBySubjectLazyQueryHookResult = ReturnType<
  typeof useGetFhirMedStatementsBySubjectLazyQuery
>;
export type GetFhirMedStatementsBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetFhirMedStatementsBySubjectSuspenseQuery
>;
export type GetFhirMedStatementsBySubjectQueryResult = Apollo.QueryResult<
  GetFhirMedStatementsBySubjectQuery,
  GetFhirMedStatementsBySubjectQueryVariables
>;
export const GetInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiGetInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInstanceQuery__
 *
 * To run a query within a React component, call `useGetInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstanceQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<GetInstanceQuery, GetInstanceQueryVariables> &
    ({ variables: GetInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInstanceQuery, GetInstanceQueryVariables>(GetInstanceDocument, options);
}
export function useGetInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInstanceQuery, GetInstanceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInstanceQuery, GetInstanceQueryVariables>(
    GetInstanceDocument,
    options,
  );
}
// @ts-ignore
export function useGetInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetInstanceQuery, GetInstanceQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetInstanceQuery, GetInstanceQueryVariables>;
export function useGetInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInstanceQuery, GetInstanceQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetInstanceQuery | undefined, GetInstanceQueryVariables>;
export function useGetInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInstanceQuery, GetInstanceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInstanceQuery, GetInstanceQueryVariables>(
    GetInstanceDocument,
    options,
  );
}
export type GetInstanceQueryHookResult = ReturnType<typeof useGetInstanceQuery>;
export type GetInstanceLazyQueryHookResult = ReturnType<typeof useGetInstanceLazyQuery>;
export type GetInstanceSuspenseQueryHookResult = ReturnType<typeof useGetInstanceSuspenseQuery>;
export type GetInstanceQueryResult = Apollo.QueryResult<
  GetInstanceQuery,
  GetInstanceQueryVariables
>;
export const GetInstanceByCorrelationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInstanceByCorrelation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'correlationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiGetInstanceByCorrelation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'correlationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'correlationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInstanceByCorrelationQuery__
 *
 * To run a query within a React component, call `useGetInstanceByCorrelationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstanceByCorrelationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstanceByCorrelationQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      correlationId: // value for 'correlationId'
 *   },
 * });
 */
export function useGetInstanceByCorrelationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstanceByCorrelationQuery,
    GetInstanceByCorrelationQueryVariables
  > &
    ({ variables: GetInstanceByCorrelationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInstanceByCorrelationQuery, GetInstanceByCorrelationQueryVariables>(
    GetInstanceByCorrelationDocument,
    options,
  );
}
export function useGetInstanceByCorrelationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstanceByCorrelationQuery,
    GetInstanceByCorrelationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInstanceByCorrelationQuery, GetInstanceByCorrelationQueryVariables>(
    GetInstanceByCorrelationDocument,
    options,
  );
}
// @ts-ignore
export function useGetInstanceByCorrelationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInstanceByCorrelationQuery,
    GetInstanceByCorrelationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetInstanceByCorrelationQuery,
  GetInstanceByCorrelationQueryVariables
>;
export function useGetInstanceByCorrelationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInstanceByCorrelationQuery,
        GetInstanceByCorrelationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetInstanceByCorrelationQuery | undefined,
  GetInstanceByCorrelationQueryVariables
>;
export function useGetInstanceByCorrelationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInstanceByCorrelationQuery,
        GetInstanceByCorrelationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetInstanceByCorrelationQuery,
    GetInstanceByCorrelationQueryVariables
  >(GetInstanceByCorrelationDocument, options);
}
export type GetInstanceByCorrelationQueryHookResult = ReturnType<
  typeof useGetInstanceByCorrelationQuery
>;
export type GetInstanceByCorrelationLazyQueryHookResult = ReturnType<
  typeof useGetInstanceByCorrelationLazyQuery
>;
export type GetInstanceByCorrelationSuspenseQueryHookResult = ReturnType<
  typeof useGetInstanceByCorrelationSuspenseQuery
>;
export type GetInstanceByCorrelationQueryResult = Apollo.QueryResult<
  GetInstanceByCorrelationQuery,
  GetInstanceByCorrelationQueryVariables
>;
export const GetInstanceHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInstanceHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiGetInstanceHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowDefinitionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInstanceHistoryQuery__
 *
 * To run a query within a React component, call `useGetInstanceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstanceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstanceHistoryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      workflowDefinitionId: // value for 'workflowDefinitionId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetInstanceHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<GetInstanceHistoryQuery, GetInstanceHistoryQueryVariables> &
    ({ variables: GetInstanceHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInstanceHistoryQuery, GetInstanceHistoryQueryVariables>(
    GetInstanceHistoryDocument,
    options,
  );
}
export function useGetInstanceHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstanceHistoryQuery,
    GetInstanceHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInstanceHistoryQuery, GetInstanceHistoryQueryVariables>(
    GetInstanceHistoryDocument,
    options,
  );
}
// @ts-ignore
export function useGetInstanceHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInstanceHistoryQuery,
    GetInstanceHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInstanceHistoryQuery, GetInstanceHistoryQueryVariables>;
export function useGetInstanceHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInstanceHistoryQuery, GetInstanceHistoryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetInstanceHistoryQuery | undefined,
  GetInstanceHistoryQueryVariables
>;
export function useGetInstanceHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInstanceHistoryQuery, GetInstanceHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInstanceHistoryQuery, GetInstanceHistoryQueryVariables>(
    GetInstanceHistoryDocument,
    options,
  );
}
export type GetInstanceHistoryQueryHookResult = ReturnType<typeof useGetInstanceHistoryQuery>;
export type GetInstanceHistoryLazyQueryHookResult = ReturnType<
  typeof useGetInstanceHistoryLazyQuery
>;
export type GetInstanceHistorySuspenseQueryHookResult = ReturnType<
  typeof useGetInstanceHistorySuspenseQuery
>;
export type GetInstanceHistoryQueryResult = Apollo.QueryResult<
  GetInstanceHistoryQuery,
  GetInstanceHistoryQueryVariables
>;
export const GetInstancesByActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInstancesByActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiGetInstancesByActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInstancesByActorQuery__
 *
 * To run a query within a React component, call `useGetInstancesByActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstancesByActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstancesByActorQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetInstancesByActorQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstancesByActorQuery,
    GetInstancesByActorQueryVariables
  > &
    ({ variables: GetInstancesByActorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInstancesByActorQuery, GetInstancesByActorQueryVariables>(
    GetInstancesByActorDocument,
    options,
  );
}
export function useGetInstancesByActorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstancesByActorQuery,
    GetInstancesByActorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInstancesByActorQuery, GetInstancesByActorQueryVariables>(
    GetInstancesByActorDocument,
    options,
  );
}
// @ts-ignore
export function useGetInstancesByActorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInstancesByActorQuery,
    GetInstancesByActorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInstancesByActorQuery, GetInstancesByActorQueryVariables>;
export function useGetInstancesByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInstancesByActorQuery, GetInstancesByActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetInstancesByActorQuery | undefined,
  GetInstancesByActorQueryVariables
>;
export function useGetInstancesByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInstancesByActorQuery, GetInstancesByActorQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInstancesByActorQuery, GetInstancesByActorQueryVariables>(
    GetInstancesByActorDocument,
    options,
  );
}
export type GetInstancesByActorQueryHookResult = ReturnType<typeof useGetInstancesByActorQuery>;
export type GetInstancesByActorLazyQueryHookResult = ReturnType<
  typeof useGetInstancesByActorLazyQuery
>;
export type GetInstancesByActorSuspenseQueryHookResult = ReturnType<
  typeof useGetInstancesByActorSuspenseQuery
>;
export type GetInstancesByActorQueryResult = Apollo.QueryResult<
  GetInstancesByActorQuery,
  GetInstancesByActorQueryVariables
>;
export const GetInstancesBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInstancesBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiGetInstancesBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInstancesBySubjectQuery__
 *
 * To run a query within a React component, call `useGetInstancesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstancesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstancesBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetInstancesBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstancesBySubjectQuery,
    GetInstancesBySubjectQueryVariables
  > &
    ({ variables: GetInstancesBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInstancesBySubjectQuery, GetInstancesBySubjectQueryVariables>(
    GetInstancesBySubjectDocument,
    options,
  );
}
export function useGetInstancesBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstancesBySubjectQuery,
    GetInstancesBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInstancesBySubjectQuery, GetInstancesBySubjectQueryVariables>(
    GetInstancesBySubjectDocument,
    options,
  );
}
// @ts-ignore
export function useGetInstancesBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInstancesBySubjectQuery,
    GetInstancesBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInstancesBySubjectQuery, GetInstancesBySubjectQueryVariables>;
export function useGetInstancesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInstancesBySubjectQuery,
        GetInstancesBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetInstancesBySubjectQuery | undefined,
  GetInstancesBySubjectQueryVariables
>;
export function useGetInstancesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInstancesBySubjectQuery,
        GetInstancesBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInstancesBySubjectQuery, GetInstancesBySubjectQueryVariables>(
    GetInstancesBySubjectDocument,
    options,
  );
}
export type GetInstancesBySubjectQueryHookResult = ReturnType<typeof useGetInstancesBySubjectQuery>;
export type GetInstancesBySubjectLazyQueryHookResult = ReturnType<
  typeof useGetInstancesBySubjectLazyQuery
>;
export type GetInstancesBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetInstancesBySubjectSuspenseQuery
>;
export type GetInstancesBySubjectQueryResult = Apollo.QueryResult<
  GetInstancesBySubjectQuery,
  GetInstancesBySubjectQueryVariables
>;
export const GetPendingProposalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPendingProposals' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingProposals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskGroupCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'proposals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'proposalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceRule' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statuteRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'edgeType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'strength' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'provisions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'significance' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requiredConfigTypes' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'states' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'policyRefs' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transitions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPendingProposalsQuery__
 *
 * To run a query within a React component, call `useGetPendingProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingProposalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingProposalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPendingProposalsQuery,
    GetPendingProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPendingProposalsQuery, GetPendingProposalsQueryVariables>(
    GetPendingProposalsDocument,
    options,
  );
}
export function useGetPendingProposalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingProposalsQuery,
    GetPendingProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPendingProposalsQuery, GetPendingProposalsQueryVariables>(
    GetPendingProposalsDocument,
    options,
  );
}
// @ts-ignore
export function useGetPendingProposalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingProposalsQuery,
    GetPendingProposalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPendingProposalsQuery, GetPendingProposalsQueryVariables>;
export function useGetPendingProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPendingProposalsQuery, GetPendingProposalsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetPendingProposalsQuery | undefined,
  GetPendingProposalsQueryVariables
>;
export function useGetPendingProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPendingProposalsQuery, GetPendingProposalsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPendingProposalsQuery, GetPendingProposalsQueryVariables>(
    GetPendingProposalsDocument,
    options,
  );
}
export type GetPendingProposalsQueryHookResult = ReturnType<typeof useGetPendingProposalsQuery>;
export type GetPendingProposalsLazyQueryHookResult = ReturnType<
  typeof useGetPendingProposalsLazyQuery
>;
export type GetPendingProposalsSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingProposalsSuspenseQuery
>;
export type GetPendingProposalsQueryResult = Apollo.QueryResult<
  GetPendingProposalsQuery,
  GetPendingProposalsQueryVariables
>;
export const GetTasksByWorkflowInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTasksByWorkflowInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTasksByWorkflowInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTasksByWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useGetTasksByWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByWorkflowInstanceQuery({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useGetTasksByWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTasksByWorkflowInstanceQuery,
    GetTasksByWorkflowInstanceQueryVariables
  > &
    ({ variables: GetTasksByWorkflowInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTasksByWorkflowInstanceQuery, GetTasksByWorkflowInstanceQueryVariables>(
    GetTasksByWorkflowInstanceDocument,
    options,
  );
}
export function useGetTasksByWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTasksByWorkflowInstanceQuery,
    GetTasksByWorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTasksByWorkflowInstanceQuery,
    GetTasksByWorkflowInstanceQueryVariables
  >(GetTasksByWorkflowInstanceDocument, options);
}
// @ts-ignore
export function useGetTasksByWorkflowInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTasksByWorkflowInstanceQuery,
    GetTasksByWorkflowInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTasksByWorkflowInstanceQuery,
  GetTasksByWorkflowInstanceQueryVariables
>;
export function useGetTasksByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTasksByWorkflowInstanceQuery,
        GetTasksByWorkflowInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTasksByWorkflowInstanceQuery | undefined,
  GetTasksByWorkflowInstanceQueryVariables
>;
export function useGetTasksByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTasksByWorkflowInstanceQuery,
        GetTasksByWorkflowInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTasksByWorkflowInstanceQuery,
    GetTasksByWorkflowInstanceQueryVariables
  >(GetTasksByWorkflowInstanceDocument, options);
}
export type GetTasksByWorkflowInstanceQueryHookResult = ReturnType<
  typeof useGetTasksByWorkflowInstanceQuery
>;
export type GetTasksByWorkflowInstanceLazyQueryHookResult = ReturnType<
  typeof useGetTasksByWorkflowInstanceLazyQuery
>;
export type GetTasksByWorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useGetTasksByWorkflowInstanceSuspenseQuery
>;
export type GetTasksByWorkflowInstanceQueryResult = Apollo.QueryResult<
  GetTasksByWorkflowInstanceQuery,
  GetTasksByWorkflowInstanceQueryVariables
>;
export const GetWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'states' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StateFields' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guards' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GuardEntryFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GuardEntryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GuardEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expression' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkflowState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyRefs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables> &
    ({ variables: GetWorkflowQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
}
export function useGetWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(
    GetWorkflowDocument,
    options,
  );
}
// @ts-ignore
export function useGetWorkflowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetWorkflowQuery, GetWorkflowQueryVariables>;
export function useGetWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetWorkflowQuery | undefined, GetWorkflowQueryVariables>;
export function useGetWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(
    GetWorkflowDocument,
    options,
  );
}
export type GetWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowQuery>;
export type GetWorkflowLazyQueryHookResult = ReturnType<typeof useGetWorkflowLazyQuery>;
export type GetWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSuspenseQuery>;
export type GetWorkflowQueryResult = Apollo.QueryResult<
  GetWorkflowQuery,
  GetWorkflowQueryVariables
>;
export const ListActiveInstancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListActiveInstances' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiListActiveInstances' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListActiveInstancesQuery__
 *
 * To run a query within a React component, call `useListActiveInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveInstancesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListActiveInstancesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListActiveInstancesQuery,
    ListActiveInstancesQueryVariables
  > &
    ({ variables: ListActiveInstancesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListActiveInstancesQuery, ListActiveInstancesQueryVariables>(
    ListActiveInstancesDocument,
    options,
  );
}
export function useListActiveInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActiveInstancesQuery,
    ListActiveInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListActiveInstancesQuery, ListActiveInstancesQueryVariables>(
    ListActiveInstancesDocument,
    options,
  );
}
// @ts-ignore
export function useListActiveInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActiveInstancesQuery,
    ListActiveInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListActiveInstancesQuery, ListActiveInstancesQueryVariables>;
export function useListActiveInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActiveInstancesQuery, ListActiveInstancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListActiveInstancesQuery | undefined,
  ListActiveInstancesQueryVariables
>;
export function useListActiveInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActiveInstancesQuery, ListActiveInstancesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListActiveInstancesQuery, ListActiveInstancesQueryVariables>(
    ListActiveInstancesDocument,
    options,
  );
}
export type ListActiveInstancesQueryHookResult = ReturnType<typeof useListActiveInstancesQuery>;
export type ListActiveInstancesLazyQueryHookResult = ReturnType<
  typeof useListActiveInstancesLazyQuery
>;
export type ListActiveInstancesSuspenseQueryHookResult = ReturnType<
  typeof useListActiveInstancesSuspenseQuery
>;
export type ListActiveInstancesQueryResult = Apollo.QueryResult<
  ListActiveInstancesQuery,
  ListActiveInstancesQueryVariables
>;
export const ListCheckpointsByWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListCheckpointsByWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listCheckpointsByWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CheckpointFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CheckpointFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Checkpoint' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkpointName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkpointType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canRollback' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rollbackCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rollbackStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotEncrypted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressionRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionDays' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastAccessedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRollbackAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRollbackReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recoveryAttemptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recoverySuccess' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recoveredByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'serializationDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateSnapshot' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snapshotChecksum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deltaFromPrevious' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoArchiveAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeTimeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxResumeAttempts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rollbackOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdByActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListCheckpointsByWorkflowQuery__
 *
 * To run a query within a React component, call `useListCheckpointsByWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCheckpointsByWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCheckpointsByWorkflowQuery({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListCheckpointsByWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCheckpointsByWorkflowQuery,
    ListCheckpointsByWorkflowQueryVariables
  > &
    ({ variables: ListCheckpointsByWorkflowQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCheckpointsByWorkflowQuery, ListCheckpointsByWorkflowQueryVariables>(
    ListCheckpointsByWorkflowDocument,
    options,
  );
}
export function useListCheckpointsByWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCheckpointsByWorkflowQuery,
    ListCheckpointsByWorkflowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListCheckpointsByWorkflowQuery,
    ListCheckpointsByWorkflowQueryVariables
  >(ListCheckpointsByWorkflowDocument, options);
}
// @ts-ignore
export function useListCheckpointsByWorkflowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListCheckpointsByWorkflowQuery,
    ListCheckpointsByWorkflowQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListCheckpointsByWorkflowQuery,
  ListCheckpointsByWorkflowQueryVariables
>;
export function useListCheckpointsByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCheckpointsByWorkflowQuery,
        ListCheckpointsByWorkflowQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListCheckpointsByWorkflowQuery | undefined,
  ListCheckpointsByWorkflowQueryVariables
>;
export function useListCheckpointsByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCheckpointsByWorkflowQuery,
        ListCheckpointsByWorkflowQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListCheckpointsByWorkflowQuery,
    ListCheckpointsByWorkflowQueryVariables
  >(ListCheckpointsByWorkflowDocument, options);
}
export type ListCheckpointsByWorkflowQueryHookResult = ReturnType<
  typeof useListCheckpointsByWorkflowQuery
>;
export type ListCheckpointsByWorkflowLazyQueryHookResult = ReturnType<
  typeof useListCheckpointsByWorkflowLazyQuery
>;
export type ListCheckpointsByWorkflowSuspenseQueryHookResult = ReturnType<
  typeof useListCheckpointsByWorkflowSuspenseQuery
>;
export type ListCheckpointsByWorkflowQueryResult = Apollo.QueryResult<
  ListCheckpointsByWorkflowQuery,
  ListCheckpointsByWorkflowQueryVariables
>;
export const ListContractsByWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListContractsByWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listContractsByWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContractFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContractFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contract' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationAtPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'elapsedMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolutionTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalateAfterMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationChain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'breachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceRate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastBreachAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListContractsByWorkflowQuery__
 *
 * To run a query within a React component, call `useListContractsByWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContractsByWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContractsByWorkflowQuery({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListContractsByWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListContractsByWorkflowQuery,
    ListContractsByWorkflowQueryVariables
  > &
    ({ variables: ListContractsByWorkflowQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListContractsByWorkflowQuery, ListContractsByWorkflowQueryVariables>(
    ListContractsByWorkflowDocument,
    options,
  );
}
export function useListContractsByWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListContractsByWorkflowQuery,
    ListContractsByWorkflowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListContractsByWorkflowQuery, ListContractsByWorkflowQueryVariables>(
    ListContractsByWorkflowDocument,
    options,
  );
}
// @ts-ignore
export function useListContractsByWorkflowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListContractsByWorkflowQuery,
    ListContractsByWorkflowQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListContractsByWorkflowQuery,
  ListContractsByWorkflowQueryVariables
>;
export function useListContractsByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListContractsByWorkflowQuery,
        ListContractsByWorkflowQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListContractsByWorkflowQuery | undefined,
  ListContractsByWorkflowQueryVariables
>;
export function useListContractsByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListContractsByWorkflowQuery,
        ListContractsByWorkflowQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListContractsByWorkflowQuery,
    ListContractsByWorkflowQueryVariables
  >(ListContractsByWorkflowDocument, options);
}
export type ListContractsByWorkflowQueryHookResult = ReturnType<
  typeof useListContractsByWorkflowQuery
>;
export type ListContractsByWorkflowLazyQueryHookResult = ReturnType<
  typeof useListContractsByWorkflowLazyQuery
>;
export type ListContractsByWorkflowSuspenseQueryHookResult = ReturnType<
  typeof useListContractsByWorkflowSuspenseQuery
>;
export type ListContractsByWorkflowQueryResult = Apollo.QueryResult<
  ListContractsByWorkflowQuery,
  ListContractsByWorkflowQueryVariables
>;
export const ListDependenciesByWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListDependenciesByWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dependencyApiListDependenciesByWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DependencyFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DependencyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Dependency' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConditional' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListDependenciesByWorkflowQuery__
 *
 * To run a query within a React component, call `useListDependenciesByWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDependenciesByWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDependenciesByWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListDependenciesByWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListDependenciesByWorkflowQuery,
    ListDependenciesByWorkflowQueryVariables
  > &
    ({ variables: ListDependenciesByWorkflowQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDependenciesByWorkflowQuery, ListDependenciesByWorkflowQueryVariables>(
    ListDependenciesByWorkflowDocument,
    options,
  );
}
export function useListDependenciesByWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDependenciesByWorkflowQuery,
    ListDependenciesByWorkflowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDependenciesByWorkflowQuery,
    ListDependenciesByWorkflowQueryVariables
  >(ListDependenciesByWorkflowDocument, options);
}
// @ts-ignore
export function useListDependenciesByWorkflowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDependenciesByWorkflowQuery,
    ListDependenciesByWorkflowQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListDependenciesByWorkflowQuery,
  ListDependenciesByWorkflowQueryVariables
>;
export function useListDependenciesByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDependenciesByWorkflowQuery,
        ListDependenciesByWorkflowQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListDependenciesByWorkflowQuery | undefined,
  ListDependenciesByWorkflowQueryVariables
>;
export function useListDependenciesByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDependenciesByWorkflowQuery,
        ListDependenciesByWorkflowQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDependenciesByWorkflowQuery,
    ListDependenciesByWorkflowQueryVariables
  >(ListDependenciesByWorkflowDocument, options);
}
export type ListDependenciesByWorkflowQueryHookResult = ReturnType<
  typeof useListDependenciesByWorkflowQuery
>;
export type ListDependenciesByWorkflowLazyQueryHookResult = ReturnType<
  typeof useListDependenciesByWorkflowLazyQuery
>;
export type ListDependenciesByWorkflowSuspenseQueryHookResult = ReturnType<
  typeof useListDependenciesByWorkflowSuspenseQuery
>;
export type ListDependenciesByWorkflowQueryResult = Apollo.QueryResult<
  ListDependenciesByWorkflowQuery,
  ListDependenciesByWorkflowQueryVariables
>;
export const ListInstancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListInstances' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiListInstances' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListInstancesQuery__
 *
 * To run a query within a React component, call `useListInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInstancesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListInstancesQuery(
  baseOptions: Apollo.QueryHookOptions<ListInstancesQuery, ListInstancesQueryVariables> &
    ({ variables: ListInstancesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListInstancesQuery, ListInstancesQueryVariables>(
    ListInstancesDocument,
    options,
  );
}
export function useListInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListInstancesQuery, ListInstancesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListInstancesQuery, ListInstancesQueryVariables>(
    ListInstancesDocument,
    options,
  );
}
// @ts-ignore
export function useListInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListInstancesQuery, ListInstancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListInstancesQuery, ListInstancesQueryVariables>;
export function useListInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListInstancesQuery, ListInstancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListInstancesQuery | undefined, ListInstancesQueryVariables>;
export function useListInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListInstancesQuery, ListInstancesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListInstancesQuery, ListInstancesQueryVariables>(
    ListInstancesDocument,
    options,
  );
}
export type ListInstancesQueryHookResult = ReturnType<typeof useListInstancesQuery>;
export type ListInstancesLazyQueryHookResult = ReturnType<typeof useListInstancesLazyQuery>;
export type ListInstancesSuspenseQueryHookResult = ReturnType<typeof useListInstancesSuspenseQuery>;
export type ListInstancesQueryResult = Apollo.QueryResult<
  ListInstancesQuery,
  ListInstancesQueryVariables
>;
export const ListInstancesByStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListInstancesByStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlInstanceStatus' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiListInstancesByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListInstancesByStatusQuery__
 *
 * To run a query within a React component, call `useListInstancesByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInstancesByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInstancesByStatusQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListInstancesByStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListInstancesByStatusQuery,
    ListInstancesByStatusQueryVariables
  > &
    ({ variables: ListInstancesByStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListInstancesByStatusQuery, ListInstancesByStatusQueryVariables>(
    ListInstancesByStatusDocument,
    options,
  );
}
export function useListInstancesByStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListInstancesByStatusQuery,
    ListInstancesByStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListInstancesByStatusQuery, ListInstancesByStatusQueryVariables>(
    ListInstancesByStatusDocument,
    options,
  );
}
// @ts-ignore
export function useListInstancesByStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListInstancesByStatusQuery,
    ListInstancesByStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListInstancesByStatusQuery, ListInstancesByStatusQueryVariables>;
export function useListInstancesByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListInstancesByStatusQuery,
        ListInstancesByStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListInstancesByStatusQuery | undefined,
  ListInstancesByStatusQueryVariables
>;
export function useListInstancesByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListInstancesByStatusQuery,
        ListInstancesByStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListInstancesByStatusQuery, ListInstancesByStatusQueryVariables>(
    ListInstancesByStatusDocument,
    options,
  );
}
export type ListInstancesByStatusQueryHookResult = ReturnType<typeof useListInstancesByStatusQuery>;
export type ListInstancesByStatusLazyQueryHookResult = ReturnType<
  typeof useListInstancesByStatusLazyQuery
>;
export type ListInstancesByStatusSuspenseQueryHookResult = ReturnType<
  typeof useListInstancesByStatusSuspenseQuery
>;
export type ListInstancesByStatusQueryResult = Apollo.QueryResult<
  ListInstancesByStatusQuery,
  ListInstancesByStatusQueryVariables
>;
export const ListInstancesByWorkflowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListInstancesByWorkflow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instanceApiListInstancesByWorkflow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowDefinitionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowDefinitionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstanceFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstanceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Instance' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDefinitionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instanceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engineType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTasks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedTaskId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cpuTimeMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memoryPeakMb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dbQueries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheHits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cacheMisses' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableTransitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guardPassed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListInstancesByWorkflowQuery__
 *
 * To run a query within a React component, call `useListInstancesByWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInstancesByWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInstancesByWorkflowQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      workflowDefinitionId: // value for 'workflowDefinitionId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListInstancesByWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListInstancesByWorkflowQuery,
    ListInstancesByWorkflowQueryVariables
  > &
    ({ variables: ListInstancesByWorkflowQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListInstancesByWorkflowQuery, ListInstancesByWorkflowQueryVariables>(
    ListInstancesByWorkflowDocument,
    options,
  );
}
export function useListInstancesByWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListInstancesByWorkflowQuery,
    ListInstancesByWorkflowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListInstancesByWorkflowQuery, ListInstancesByWorkflowQueryVariables>(
    ListInstancesByWorkflowDocument,
    options,
  );
}
// @ts-ignore
export function useListInstancesByWorkflowSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListInstancesByWorkflowQuery,
    ListInstancesByWorkflowQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListInstancesByWorkflowQuery,
  ListInstancesByWorkflowQueryVariables
>;
export function useListInstancesByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListInstancesByWorkflowQuery,
        ListInstancesByWorkflowQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListInstancesByWorkflowQuery | undefined,
  ListInstancesByWorkflowQueryVariables
>;
export function useListInstancesByWorkflowSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListInstancesByWorkflowQuery,
        ListInstancesByWorkflowQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListInstancesByWorkflowQuery,
    ListInstancesByWorkflowQueryVariables
  >(ListInstancesByWorkflowDocument, options);
}
export type ListInstancesByWorkflowQueryHookResult = ReturnType<
  typeof useListInstancesByWorkflowQuery
>;
export type ListInstancesByWorkflowLazyQueryHookResult = ReturnType<
  typeof useListInstancesByWorkflowLazyQuery
>;
export type ListInstancesByWorkflowSuspenseQueryHookResult = ReturnType<
  typeof useListInstancesByWorkflowSuspenseQuery
>;
export type ListInstancesByWorkflowQueryResult = Apollo.QueryResult<
  ListInstancesByWorkflowQuery,
  ListInstancesByWorkflowQueryVariables
>;
export const ListMyWorkflowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListMyWorkflows' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listMyWorkflows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListMyWorkflowsQuery__
 *
 * To run a query within a React component, call `useListMyWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyWorkflowsQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useListMyWorkflowsQuery(
  baseOptions: Apollo.QueryHookOptions<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables> &
    ({ variables: ListMyWorkflowsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables>(
    ListMyWorkflowsDocument,
    options,
  );
}
export function useListMyWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables>(
    ListMyWorkflowsDocument,
    options,
  );
}
// @ts-ignore
export function useListMyWorkflowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListMyWorkflowsQuery,
    ListMyWorkflowsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables>;
export function useListMyWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListMyWorkflowsQuery | undefined, ListMyWorkflowsQueryVariables>;
export function useListMyWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListMyWorkflowsQuery, ListMyWorkflowsQueryVariables>(
    ListMyWorkflowsDocument,
    options,
  );
}
export type ListMyWorkflowsQueryHookResult = ReturnType<typeof useListMyWorkflowsQuery>;
export type ListMyWorkflowsLazyQueryHookResult = ReturnType<typeof useListMyWorkflowsLazyQuery>;
export type ListMyWorkflowsSuspenseQueryHookResult = ReturnType<
  typeof useListMyWorkflowsSuspenseQuery
>;
export type ListMyWorkflowsQueryResult = Apollo.QueryResult<
  ListMyWorkflowsQuery,
  ListMyWorkflowsQueryVariables
>;
export const ListTracesByWorkflowInstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTracesByWorkflowInstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listTracesByWorkflowInstance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TraceFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TraceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trace' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'traceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spanId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentSpanId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spanType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTracesByWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useListTracesByWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTracesByWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTracesByWorkflowInstanceQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListTracesByWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTracesByWorkflowInstanceQuery,
    ListTracesByWorkflowInstanceQueryVariables
  > &
    ({ variables: ListTracesByWorkflowInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTracesByWorkflowInstanceQuery,
    ListTracesByWorkflowInstanceQueryVariables
  >(ListTracesByWorkflowInstanceDocument, options);
}
export function useListTracesByWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTracesByWorkflowInstanceQuery,
    ListTracesByWorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTracesByWorkflowInstanceQuery,
    ListTracesByWorkflowInstanceQueryVariables
  >(ListTracesByWorkflowInstanceDocument, options);
}
// @ts-ignore
export function useListTracesByWorkflowInstanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTracesByWorkflowInstanceQuery,
    ListTracesByWorkflowInstanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListTracesByWorkflowInstanceQuery,
  ListTracesByWorkflowInstanceQueryVariables
>;
export function useListTracesByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTracesByWorkflowInstanceQuery,
        ListTracesByWorkflowInstanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListTracesByWorkflowInstanceQuery | undefined,
  ListTracesByWorkflowInstanceQueryVariables
>;
export function useListTracesByWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTracesByWorkflowInstanceQuery,
        ListTracesByWorkflowInstanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTracesByWorkflowInstanceQuery,
    ListTracesByWorkflowInstanceQueryVariables
  >(ListTracesByWorkflowInstanceDocument, options);
}
export type ListTracesByWorkflowInstanceQueryHookResult = ReturnType<
  typeof useListTracesByWorkflowInstanceQuery
>;
export type ListTracesByWorkflowInstanceLazyQueryHookResult = ReturnType<
  typeof useListTracesByWorkflowInstanceLazyQuery
>;
export type ListTracesByWorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useListTracesByWorkflowInstanceSuspenseQuery
>;
export type ListTracesByWorkflowInstanceQueryResult = Apollo.QueryResult<
  ListTracesByWorkflowInstanceQuery,
  ListTracesByWorkflowInstanceQueryVariables
>;
export const ListWorkflowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListWorkflows' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listWorkflows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkflowFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkflowFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Workflow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entryActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeoutSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toState' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guards' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expression' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guardType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retryPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttempts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backoffMultiplier' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'framework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirement' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'authorityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionalScope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetFormulas' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaCompletionRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaAvgDurations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'durationSeconds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedExecutionStrategies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strategy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaStateCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formulaErrorRates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'formulaName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastInstantiatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instantiationCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentVersionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListWorkflowsQuery__
 *
 * To run a query within a React component, call `useListWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListWorkflowsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(
    ListWorkflowsDocument,
    options,
  );
}
export function useListWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(
    ListWorkflowsDocument,
    options,
  );
}
// @ts-ignore
export function useListWorkflowsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListWorkflowsQuery, ListWorkflowsQueryVariables>;
export function useListWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListWorkflowsQuery | undefined, ListWorkflowsQueryVariables>;
export function useListWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(
    ListWorkflowsDocument,
    options,
  );
}
export type ListWorkflowsQueryHookResult = ReturnType<typeof useListWorkflowsQuery>;
export type ListWorkflowsLazyQueryHookResult = ReturnType<typeof useListWorkflowsLazyQuery>;
export type ListWorkflowsSuspenseQueryHookResult = ReturnType<typeof useListWorkflowsSuspenseQuery>;
export type ListWorkflowsQueryResult = Apollo.QueryResult<
  ListWorkflowsQuery,
  ListWorkflowsQueryVariables
>;
export const ConstellationTaskSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConstellationTaskSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsTaskConstellationTaskSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constellationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pending' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inProgress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overdue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'byInstance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pending' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inProgress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'overdue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aggregateStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConstellationTaskSummaryQuery__
 *
 * To run a query within a React component, call `useConstellationTaskSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstellationTaskSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstellationTaskSummaryQuery({
 *   variables: {
 *      constellationId: // value for 'constellationId'
 *   },
 * });
 */
export function useConstellationTaskSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConstellationTaskSummaryQuery,
    ConstellationTaskSummaryQueryVariables
  > &
    ({ variables: ConstellationTaskSummaryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConstellationTaskSummaryQuery, ConstellationTaskSummaryQueryVariables>(
    ConstellationTaskSummaryDocument,
    options,
  );
}
export function useConstellationTaskSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConstellationTaskSummaryQuery,
    ConstellationTaskSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConstellationTaskSummaryQuery, ConstellationTaskSummaryQueryVariables>(
    ConstellationTaskSummaryDocument,
    options,
  );
}
// @ts-ignore
export function useConstellationTaskSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConstellationTaskSummaryQuery,
    ConstellationTaskSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ConstellationTaskSummaryQuery,
  ConstellationTaskSummaryQueryVariables
>;
export function useConstellationTaskSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConstellationTaskSummaryQuery,
        ConstellationTaskSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConstellationTaskSummaryQuery | undefined,
  ConstellationTaskSummaryQueryVariables
>;
export function useConstellationTaskSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConstellationTaskSummaryQuery,
        ConstellationTaskSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConstellationTaskSummaryQuery,
    ConstellationTaskSummaryQueryVariables
  >(ConstellationTaskSummaryDocument, options);
}
export type ConstellationTaskSummaryQueryHookResult = ReturnType<
  typeof useConstellationTaskSummaryQuery
>;
export type ConstellationTaskSummaryLazyQueryHookResult = ReturnType<
  typeof useConstellationTaskSummaryLazyQuery
>;
export type ConstellationTaskSummarySuspenseQueryHookResult = ReturnType<
  typeof useConstellationTaskSummarySuspenseQuery
>;
export type ConstellationTaskSummaryQueryResult = Apollo.QueryResult<
  ConstellationTaskSummaryQuery,
  ConstellationTaskSummaryQueryVariables
>;
export const GetActiveShiftPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActiveShiftPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'floorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeShiftPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'floorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'floorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'planId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shiftStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shiftEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'replanTrigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assignedStaffId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assistStaffId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'continuityScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rationale' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'acuityContribution' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deadlineContribution' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'continuityContribution' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceContribution' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sequenceContribution' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'overrides' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reservations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffRoster' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentWorkload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'competencies' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActiveShiftPlanQuery__
 *
 * To run a query within a React component, call `useGetActiveShiftPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveShiftPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveShiftPlanQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useGetActiveShiftPlanQuery(
  baseOptions: Apollo.QueryHookOptions<GetActiveShiftPlanQuery, GetActiveShiftPlanQueryVariables> &
    ({ variables: GetActiveShiftPlanQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActiveShiftPlanQuery, GetActiveShiftPlanQueryVariables>(
    GetActiveShiftPlanDocument,
    options,
  );
}
export function useGetActiveShiftPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActiveShiftPlanQuery,
    GetActiveShiftPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActiveShiftPlanQuery, GetActiveShiftPlanQueryVariables>(
    GetActiveShiftPlanDocument,
    options,
  );
}
// @ts-ignore
export function useGetActiveShiftPlanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActiveShiftPlanQuery,
    GetActiveShiftPlanQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActiveShiftPlanQuery, GetActiveShiftPlanQueryVariables>;
export function useGetActiveShiftPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActiveShiftPlanQuery, GetActiveShiftPlanQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetActiveShiftPlanQuery | undefined,
  GetActiveShiftPlanQueryVariables
>;
export function useGetActiveShiftPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActiveShiftPlanQuery, GetActiveShiftPlanQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActiveShiftPlanQuery, GetActiveShiftPlanQueryVariables>(
    GetActiveShiftPlanDocument,
    options,
  );
}
export type GetActiveShiftPlanQueryHookResult = ReturnType<typeof useGetActiveShiftPlanQuery>;
export type GetActiveShiftPlanLazyQueryHookResult = ReturnType<
  typeof useGetActiveShiftPlanLazyQuery
>;
export type GetActiveShiftPlanSuspenseQueryHookResult = ReturnType<
  typeof useGetActiveShiftPlanSuspenseQuery
>;
export type GetActiveShiftPlanQueryResult = Apollo.QueryResult<
  GetActiveShiftPlanQuery,
  GetActiveShiftPlanQueryVariables
>;
export const GetCoordinationWeightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoordinationWeights' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coordinationWeights' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffingFloors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ulpRatioDay' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ulpRatioNight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ulpRatioMemoryCare' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAwakeStaff' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taskPriorityWeights' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'acuityWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deadlineWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'continuityWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sequenceWeight' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'twoPersonAssistEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cognitiveContinuityEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetContinuityPercent' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCoordinationWeightsQuery__
 *
 * To run a query within a React component, call `useGetCoordinationWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoordinationWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoordinationWeightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoordinationWeightsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCoordinationWeightsQuery,
    GetCoordinationWeightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoordinationWeightsQuery, GetCoordinationWeightsQueryVariables>(
    GetCoordinationWeightsDocument,
    options,
  );
}
export function useGetCoordinationWeightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoordinationWeightsQuery,
    GetCoordinationWeightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoordinationWeightsQuery, GetCoordinationWeightsQueryVariables>(
    GetCoordinationWeightsDocument,
    options,
  );
}
// @ts-ignore
export function useGetCoordinationWeightsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCoordinationWeightsQuery,
    GetCoordinationWeightsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCoordinationWeightsQuery, GetCoordinationWeightsQueryVariables>;
export function useGetCoordinationWeightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCoordinationWeightsQuery,
        GetCoordinationWeightsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCoordinationWeightsQuery | undefined,
  GetCoordinationWeightsQueryVariables
>;
export function useGetCoordinationWeightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCoordinationWeightsQuery,
        GetCoordinationWeightsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCoordinationWeightsQuery, GetCoordinationWeightsQueryVariables>(
    GetCoordinationWeightsDocument,
    options,
  );
}
export type GetCoordinationWeightsQueryHookResult = ReturnType<
  typeof useGetCoordinationWeightsQuery
>;
export type GetCoordinationWeightsLazyQueryHookResult = ReturnType<
  typeof useGetCoordinationWeightsLazyQuery
>;
export type GetCoordinationWeightsSuspenseQueryHookResult = ReturnType<
  typeof useGetCoordinationWeightsSuspenseQuery
>;
export type GetCoordinationWeightsQueryResult = Apollo.QueryResult<
  GetCoordinationWeightsQuery,
  GetCoordinationWeightsQueryVariables
>;
export const GetOnboardingTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOnboardingTasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '200' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiListTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOnboardingTasksQuery__
 *
 * To run a query within a React component, call `useGetOnboardingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingTasksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOnboardingTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOnboardingTasksQuery, GetOnboardingTasksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOnboardingTasksQuery, GetOnboardingTasksQueryVariables>(
    GetOnboardingTasksDocument,
    options,
  );
}
export function useGetOnboardingTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOnboardingTasksQuery,
    GetOnboardingTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOnboardingTasksQuery, GetOnboardingTasksQueryVariables>(
    GetOnboardingTasksDocument,
    options,
  );
}
// @ts-ignore
export function useGetOnboardingTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOnboardingTasksQuery,
    GetOnboardingTasksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetOnboardingTasksQuery, GetOnboardingTasksQueryVariables>;
export function useGetOnboardingTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOnboardingTasksQuery, GetOnboardingTasksQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetOnboardingTasksQuery | undefined,
  GetOnboardingTasksQueryVariables
>;
export function useGetOnboardingTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOnboardingTasksQuery, GetOnboardingTasksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOnboardingTasksQuery, GetOnboardingTasksQueryVariables>(
    GetOnboardingTasksDocument,
    options,
  );
}
export type GetOnboardingTasksQueryHookResult = ReturnType<typeof useGetOnboardingTasksQuery>;
export type GetOnboardingTasksLazyQueryHookResult = ReturnType<
  typeof useGetOnboardingTasksLazyQuery
>;
export type GetOnboardingTasksSuspenseQueryHookResult = ReturnType<
  typeof useGetOnboardingTasksSuspenseQuery
>;
export type GetOnboardingTasksQueryResult = Apollo.QueryResult<
  GetOnboardingTasksQuery,
  GetOnboardingTasksQueryVariables
>;
export const GetTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskQuery(
  baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables> &
    ({ variables: GetTaskQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
}
export function useGetTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
}
// @ts-ignore
export function useGetTaskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTaskQuery, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTaskQuery | undefined, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
}
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const GetTaskEnrichmentContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTaskEnrichmentContext' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiTaskEnrichmentContext' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTaskEnrichmentContextQuery__
 *
 * To run a query within a React component, call `useGetTaskEnrichmentContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskEnrichmentContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskEnrichmentContextQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetTaskEnrichmentContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskEnrichmentContextQuery,
    GetTaskEnrichmentContextQueryVariables
  > &
    ({ variables: GetTaskEnrichmentContextQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskEnrichmentContextQuery, GetTaskEnrichmentContextQueryVariables>(
    GetTaskEnrichmentContextDocument,
    options,
  );
}
export function useGetTaskEnrichmentContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskEnrichmentContextQuery,
    GetTaskEnrichmentContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTaskEnrichmentContextQuery, GetTaskEnrichmentContextQueryVariables>(
    GetTaskEnrichmentContextDocument,
    options,
  );
}
// @ts-ignore
export function useGetTaskEnrichmentContextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskEnrichmentContextQuery,
    GetTaskEnrichmentContextQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTaskEnrichmentContextQuery,
  GetTaskEnrichmentContextQueryVariables
>;
export function useGetTaskEnrichmentContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskEnrichmentContextQuery,
        GetTaskEnrichmentContextQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTaskEnrichmentContextQuery | undefined,
  GetTaskEnrichmentContextQueryVariables
>;
export function useGetTaskEnrichmentContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskEnrichmentContextQuery,
        GetTaskEnrichmentContextQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTaskEnrichmentContextQuery,
    GetTaskEnrichmentContextQueryVariables
  >(GetTaskEnrichmentContextDocument, options);
}
export type GetTaskEnrichmentContextQueryHookResult = ReturnType<
  typeof useGetTaskEnrichmentContextQuery
>;
export type GetTaskEnrichmentContextLazyQueryHookResult = ReturnType<
  typeof useGetTaskEnrichmentContextLazyQuery
>;
export type GetTaskEnrichmentContextSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskEnrichmentContextSuspenseQuery
>;
export type GetTaskEnrichmentContextQueryResult = Apollo.QueryResult<
  GetTaskEnrichmentContextQuery,
  GetTaskEnrichmentContextQueryVariables
>;
export const GetTaskForDetailPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTaskForDetailPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTaskById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formSchemaRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formComponents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formSchemaOverride' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outputEntities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignedActor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subjectActor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTaskForDetailPageQuery__
 *
 * To run a query within a React component, call `useGetTaskForDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskForDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskForDetailPageQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskForDetailPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskForDetailPageQuery,
    GetTaskForDetailPageQueryVariables
  > &
    ({ variables: GetTaskForDetailPageQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskForDetailPageQuery, GetTaskForDetailPageQueryVariables>(
    GetTaskForDetailPageDocument,
    options,
  );
}
export function useGetTaskForDetailPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskForDetailPageQuery,
    GetTaskForDetailPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTaskForDetailPageQuery, GetTaskForDetailPageQueryVariables>(
    GetTaskForDetailPageDocument,
    options,
  );
}
// @ts-ignore
export function useGetTaskForDetailPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskForDetailPageQuery,
    GetTaskForDetailPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTaskForDetailPageQuery, GetTaskForDetailPageQueryVariables>;
export function useGetTaskForDetailPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskForDetailPageQuery,
        GetTaskForDetailPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTaskForDetailPageQuery | undefined,
  GetTaskForDetailPageQueryVariables
>;
export function useGetTaskForDetailPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskForDetailPageQuery,
        GetTaskForDetailPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTaskForDetailPageQuery, GetTaskForDetailPageQueryVariables>(
    GetTaskForDetailPageDocument,
    options,
  );
}
export type GetTaskForDetailPageQueryHookResult = ReturnType<typeof useGetTaskForDetailPageQuery>;
export type GetTaskForDetailPageLazyQueryHookResult = ReturnType<
  typeof useGetTaskForDetailPageLazyQuery
>;
export type GetTaskForDetailPageSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskForDetailPageSuspenseQuery
>;
export type GetTaskForDetailPageQueryResult = Apollo.QueryResult<
  GetTaskForDetailPageQuery,
  GetTaskForDetailPageQueryVariables
>;
export const GetTaskStatisticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTaskStatistics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTaskStatistics' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inProgressCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgDurationMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgProgressPercent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaBreachedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaApproachingCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTaskStatisticsQuery__
 *
 * To run a query within a React component, call `useGetTaskStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaskStatisticsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>(
    GetTaskStatisticsDocument,
    options,
  );
}
export function useGetTaskStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskStatisticsQuery,
    GetTaskStatisticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>(
    GetTaskStatisticsDocument,
    options,
  );
}
// @ts-ignore
export function useGetTaskStatisticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskStatisticsQuery,
    GetTaskStatisticsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>;
export function useGetTaskStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetTaskStatisticsQuery | undefined,
  GetTaskStatisticsQueryVariables
>;
export function useGetTaskStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTaskStatisticsQuery, GetTaskStatisticsQueryVariables>(
    GetTaskStatisticsDocument,
    options,
  );
}
export type GetTaskStatisticsQueryHookResult = ReturnType<typeof useGetTaskStatisticsQuery>;
export type GetTaskStatisticsLazyQueryHookResult = ReturnType<typeof useGetTaskStatisticsLazyQuery>;
export type GetTaskStatisticsSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskStatisticsSuspenseQuery
>;
export type GetTaskStatisticsQueryResult = Apollo.QueryResult<
  GetTaskStatisticsQuery,
  GetTaskStatisticsQueryVariables
>;
export const GetTasksByActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTasksByActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTasksByActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTasksByActorQuery__
 *
 * To run a query within a React component, call `useGetTasksByActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByActorQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetTasksByActorQuery(
  baseOptions: Apollo.QueryHookOptions<GetTasksByActorQuery, GetTasksByActorQueryVariables> &
    ({ variables: GetTasksByActorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTasksByActorQuery, GetTasksByActorQueryVariables>(
    GetTasksByActorDocument,
    options,
  );
}
export function useGetTasksByActorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTasksByActorQuery, GetTasksByActorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTasksByActorQuery, GetTasksByActorQueryVariables>(
    GetTasksByActorDocument,
    options,
  );
}
// @ts-ignore
export function useGetTasksByActorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTasksByActorQuery,
    GetTasksByActorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTasksByActorQuery, GetTasksByActorQueryVariables>;
export function useGetTasksByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksByActorQuery, GetTasksByActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTasksByActorQuery | undefined, GetTasksByActorQueryVariables>;
export function useGetTasksByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksByActorQuery, GetTasksByActorQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTasksByActorQuery, GetTasksByActorQueryVariables>(
    GetTasksByActorDocument,
    options,
  );
}
export type GetTasksByActorQueryHookResult = ReturnType<typeof useGetTasksByActorQuery>;
export type GetTasksByActorLazyQueryHookResult = ReturnType<typeof useGetTasksByActorLazyQuery>;
export type GetTasksByActorSuspenseQueryHookResult = ReturnType<
  typeof useGetTasksByActorSuspenseQuery
>;
export type GetTasksByActorQueryResult = Apollo.QueryResult<
  GetTasksByActorQuery,
  GetTasksByActorQueryVariables
>;
export const GetTasksByStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTasksByStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlTaskStatus' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTasksByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTasksByStatusQuery__
 *
 * To run a query within a React component, call `useGetTasksByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetTasksByStatusQuery(
  baseOptions: Apollo.QueryHookOptions<GetTasksByStatusQuery, GetTasksByStatusQueryVariables> &
    ({ variables: GetTasksByStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTasksByStatusQuery, GetTasksByStatusQueryVariables>(
    GetTasksByStatusDocument,
    options,
  );
}
export function useGetTasksByStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTasksByStatusQuery, GetTasksByStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTasksByStatusQuery, GetTasksByStatusQueryVariables>(
    GetTasksByStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetTasksByStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTasksByStatusQuery,
    GetTasksByStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTasksByStatusQuery, GetTasksByStatusQueryVariables>;
export function useGetTasksByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksByStatusQuery, GetTasksByStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTasksByStatusQuery | undefined, GetTasksByStatusQueryVariables>;
export function useGetTasksByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksByStatusQuery, GetTasksByStatusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTasksByStatusQuery, GetTasksByStatusQueryVariables>(
    GetTasksByStatusDocument,
    options,
  );
}
export type GetTasksByStatusQueryHookResult = ReturnType<typeof useGetTasksByStatusQuery>;
export type GetTasksByStatusLazyQueryHookResult = ReturnType<typeof useGetTasksByStatusLazyQuery>;
export type GetTasksByStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetTasksByStatusSuspenseQuery
>;
export type GetTasksByStatusQueryResult = Apollo.QueryResult<
  GetTasksByStatusQuery,
  GetTasksByStatusQueryVariables
>;
export const GetTasksBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTasksBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTasksBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTasksBySubjectQuery__
 *
 * To run a query within a React component, call `useGetTasksBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetTasksBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<GetTasksBySubjectQuery, GetTasksBySubjectQueryVariables> &
    ({ variables: GetTasksBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTasksBySubjectQuery, GetTasksBySubjectQueryVariables>(
    GetTasksBySubjectDocument,
    options,
  );
}
export function useGetTasksBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTasksBySubjectQuery,
    GetTasksBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTasksBySubjectQuery, GetTasksBySubjectQueryVariables>(
    GetTasksBySubjectDocument,
    options,
  );
}
// @ts-ignore
export function useGetTasksBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTasksBySubjectQuery,
    GetTasksBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTasksBySubjectQuery, GetTasksBySubjectQueryVariables>;
export function useGetTasksBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksBySubjectQuery, GetTasksBySubjectQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetTasksBySubjectQuery | undefined,
  GetTasksBySubjectQueryVariables
>;
export function useGetTasksBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksBySubjectQuery, GetTasksBySubjectQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTasksBySubjectQuery, GetTasksBySubjectQueryVariables>(
    GetTasksBySubjectDocument,
    options,
  );
}
export type GetTasksBySubjectQueryHookResult = ReturnType<typeof useGetTasksBySubjectQuery>;
export type GetTasksBySubjectLazyQueryHookResult = ReturnType<typeof useGetTasksBySubjectLazyQuery>;
export type GetTasksBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetTasksBySubjectSuspenseQuery
>;
export type GetTasksBySubjectQueryResult = Apollo.QueryResult<
  GetTasksBySubjectQuery,
  GetTasksBySubjectQueryVariables
>;
export const GetTasksByTaskTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTasksByTaskType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskGroupRef' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTasksByTaskType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskGroupRef' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskGroupRef' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTasksByTaskTypeQuery__
 *
 * To run a query within a React component, call `useGetTasksByTaskTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByTaskTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByTaskTypeQuery({
 *   variables: {
 *      taskGroupRef: // value for 'taskGroupRef'
 *   },
 * });
 */
export function useGetTasksByTaskTypeQuery(
  baseOptions: Apollo.QueryHookOptions<GetTasksByTaskTypeQuery, GetTasksByTaskTypeQueryVariables> &
    ({ variables: GetTasksByTaskTypeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTasksByTaskTypeQuery, GetTasksByTaskTypeQueryVariables>(
    GetTasksByTaskTypeDocument,
    options,
  );
}
export function useGetTasksByTaskTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTasksByTaskTypeQuery,
    GetTasksByTaskTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTasksByTaskTypeQuery, GetTasksByTaskTypeQueryVariables>(
    GetTasksByTaskTypeDocument,
    options,
  );
}
// @ts-ignore
export function useGetTasksByTaskTypeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTasksByTaskTypeQuery,
    GetTasksByTaskTypeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTasksByTaskTypeQuery, GetTasksByTaskTypeQueryVariables>;
export function useGetTasksByTaskTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksByTaskTypeQuery, GetTasksByTaskTypeQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetTasksByTaskTypeQuery | undefined,
  GetTasksByTaskTypeQueryVariables
>;
export function useGetTasksByTaskTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTasksByTaskTypeQuery, GetTasksByTaskTypeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTasksByTaskTypeQuery, GetTasksByTaskTypeQueryVariables>(
    GetTasksByTaskTypeDocument,
    options,
  );
}
export type GetTasksByTaskTypeQueryHookResult = ReturnType<typeof useGetTasksByTaskTypeQuery>;
export type GetTasksByTaskTypeLazyQueryHookResult = ReturnType<
  typeof useGetTasksByTaskTypeLazyQuery
>;
export type GetTasksByTaskTypeSuspenseQueryHookResult = ReturnType<
  typeof useGetTasksByTaskTypeSuspenseQuery
>;
export type GetTasksByTaskTypeQueryResult = Apollo.QueryResult<
  GetTasksByTaskTypeQuery,
  GetTasksByTaskTypeQueryVariables
>;
export const ListTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiListTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTasksQuery__
 *
 * To run a query within a React component, call `useListTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTasksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTasksQuery, ListTasksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTasksQuery, ListTasksQueryVariables>(ListTasksDocument, options);
}
export function useListTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTasksQuery, ListTasksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTasksQuery, ListTasksQueryVariables>(ListTasksDocument, options);
}
// @ts-ignore
export function useListTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListTasksQuery, ListTasksQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTasksQuery, ListTasksQueryVariables>;
export function useListTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTasksQuery, ListTasksQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTasksQuery | undefined, ListTasksQueryVariables>;
export function useListTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTasksQuery, ListTasksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTasksQuery, ListTasksQueryVariables>(
    ListTasksDocument,
    options,
  );
}
export type ListTasksQueryHookResult = ReturnType<typeof useListTasksQuery>;
export type ListTasksLazyQueryHookResult = ReturnType<typeof useListTasksLazyQuery>;
export type ListTasksSuspenseQueryHookResult = ReturnType<typeof useListTasksSuspenseQuery>;
export type ListTasksQueryResult = Apollo.QueryResult<ListTasksQuery, ListTasksQueryVariables>;
export const ListTrainingTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTrainingTasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiListTrainingTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTrainingTasksQuery__
 *
 * To run a query within a React component, call `useListTrainingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrainingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrainingTasksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListTrainingTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTrainingTasksQuery, ListTrainingTasksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTrainingTasksQuery, ListTrainingTasksQueryVariables>(
    ListTrainingTasksDocument,
    options,
  );
}
export function useListTrainingTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTrainingTasksQuery,
    ListTrainingTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTrainingTasksQuery, ListTrainingTasksQueryVariables>(
    ListTrainingTasksDocument,
    options,
  );
}
// @ts-ignore
export function useListTrainingTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTrainingTasksQuery,
    ListTrainingTasksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListTrainingTasksQuery, ListTrainingTasksQueryVariables>;
export function useListTrainingTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTrainingTasksQuery, ListTrainingTasksQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListTrainingTasksQuery | undefined,
  ListTrainingTasksQueryVariables
>;
export function useListTrainingTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTrainingTasksQuery, ListTrainingTasksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTrainingTasksQuery, ListTrainingTasksQueryVariables>(
    ListTrainingTasksDocument,
    options,
  );
}
export type ListTrainingTasksQueryHookResult = ReturnType<typeof useListTrainingTasksQuery>;
export type ListTrainingTasksLazyQueryHookResult = ReturnType<typeof useListTrainingTasksLazyQuery>;
export type ListTrainingTasksSuspenseQueryHookResult = ReturnType<
  typeof useListTrainingTasksSuspenseQuery
>;
export type ListTrainingTasksQueryResult = Apollo.QueryResult<
  ListTrainingTasksQuery,
  ListTrainingTasksQueryVariables
>;
export const GetTrainingTasksByEmployeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTrainingTasksByEmployee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employeeActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskApiGetTrainingTasksByEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'employeeActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'employeeActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TaskFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Task' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sequenceOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencies' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedDurationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationMs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retryCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxRetries' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureStrategy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBySource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateIsOverride' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mandateSourceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mandates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdictionLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisionRefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'violationOutcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationReviewDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toolHint' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamActorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignedActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjectActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkedOutBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutExpiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTrainingTasksByEmployeeQuery__
 *
 * To run a query within a React component, call `useGetTrainingTasksByEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingTasksByEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrainingTasksByEmployeeQuery({
 *   variables: {
 *      employeeActorId: // value for 'employeeActorId'
 *   },
 * });
 */
export function useGetTrainingTasksByEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTrainingTasksByEmployeeQuery,
    GetTrainingTasksByEmployeeQueryVariables
  > &
    ({ variables: GetTrainingTasksByEmployeeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTrainingTasksByEmployeeQuery, GetTrainingTasksByEmployeeQueryVariables>(
    GetTrainingTasksByEmployeeDocument,
    options,
  );
}
export function useGetTrainingTasksByEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTrainingTasksByEmployeeQuery,
    GetTrainingTasksByEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTrainingTasksByEmployeeQuery,
    GetTrainingTasksByEmployeeQueryVariables
  >(GetTrainingTasksByEmployeeDocument, options);
}
// @ts-ignore
export function useGetTrainingTasksByEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTrainingTasksByEmployeeQuery,
    GetTrainingTasksByEmployeeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTrainingTasksByEmployeeQuery,
  GetTrainingTasksByEmployeeQueryVariables
>;
export function useGetTrainingTasksByEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTrainingTasksByEmployeeQuery,
        GetTrainingTasksByEmployeeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTrainingTasksByEmployeeQuery | undefined,
  GetTrainingTasksByEmployeeQueryVariables
>;
export function useGetTrainingTasksByEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTrainingTasksByEmployeeQuery,
        GetTrainingTasksByEmployeeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTrainingTasksByEmployeeQuery,
    GetTrainingTasksByEmployeeQueryVariables
  >(GetTrainingTasksByEmployeeDocument, options);
}
export type GetTrainingTasksByEmployeeQueryHookResult = ReturnType<
  typeof useGetTrainingTasksByEmployeeQuery
>;
export type GetTrainingTasksByEmployeeLazyQueryHookResult = ReturnType<
  typeof useGetTrainingTasksByEmployeeLazyQuery
>;
export type GetTrainingTasksByEmployeeSuspenseQueryHookResult = ReturnType<
  typeof useGetTrainingTasksByEmployeeSuspenseQuery
>;
export type GetTrainingTasksByEmployeeQueryResult = Apollo.QueryResult<
  GetTrainingTasksByEmployeeQuery,
  GetTrainingTasksByEmployeeQueryVariables
>;
export const TaskBreadcrumbDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskBreadcrumb' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsTaskTaskBreadcrumb' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mandateRef' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTaskBreadcrumbQuery__
 *
 * To run a query within a React component, call `useTaskBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBreadcrumbQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskBreadcrumbQuery(
  baseOptions: Apollo.QueryHookOptions<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables> &
    ({ variables: TaskBreadcrumbQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>(
    TaskBreadcrumbDocument,
    options,
  );
}
export function useTaskBreadcrumbLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>(
    TaskBreadcrumbDocument,
    options,
  );
}
// @ts-ignore
export function useTaskBreadcrumbSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>;
export function useTaskBreadcrumbSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskBreadcrumbQuery | undefined, TaskBreadcrumbQueryVariables>;
export function useTaskBreadcrumbSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TaskBreadcrumbQuery, TaskBreadcrumbQueryVariables>(
    TaskBreadcrumbDocument,
    options,
  );
}
export type TaskBreadcrumbQueryHookResult = ReturnType<typeof useTaskBreadcrumbQuery>;
export type TaskBreadcrumbLazyQueryHookResult = ReturnType<typeof useTaskBreadcrumbLazyQuery>;
export type TaskBreadcrumbSuspenseQueryHookResult = ReturnType<
  typeof useTaskBreadcrumbSuspenseQuery
>;
export type TaskBreadcrumbQueryResult = Apollo.QueryResult<
  TaskBreadcrumbQuery,
  TaskBreadcrumbQueryVariables
>;
export const TaskCompletionHintsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskCompletionHints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskCompletionHints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inputFieldGuidance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hint' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'examples' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validationHelp' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'quickActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefillData' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contextualInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTaskCompletionHintsQuery__
 *
 * To run a query within a React component, call `useTaskCompletionHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCompletionHintsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      taskId: // value for 'taskId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTaskCompletionHintsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TaskCompletionHintsQuery,
    TaskCompletionHintsQueryVariables
  > &
    ({ variables: TaskCompletionHintsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskCompletionHintsQuery, TaskCompletionHintsQueryVariables>(
    TaskCompletionHintsDocument,
    options,
  );
}
export function useTaskCompletionHintsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TaskCompletionHintsQuery,
    TaskCompletionHintsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TaskCompletionHintsQuery, TaskCompletionHintsQueryVariables>(
    TaskCompletionHintsDocument,
    options,
  );
}
// @ts-ignore
export function useTaskCompletionHintsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TaskCompletionHintsQuery,
    TaskCompletionHintsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TaskCompletionHintsQuery, TaskCompletionHintsQueryVariables>;
export function useTaskCompletionHintsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskCompletionHintsQuery, TaskCompletionHintsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  TaskCompletionHintsQuery | undefined,
  TaskCompletionHintsQueryVariables
>;
export function useTaskCompletionHintsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskCompletionHintsQuery, TaskCompletionHintsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TaskCompletionHintsQuery, TaskCompletionHintsQueryVariables>(
    TaskCompletionHintsDocument,
    options,
  );
}
export type TaskCompletionHintsQueryHookResult = ReturnType<typeof useTaskCompletionHintsQuery>;
export type TaskCompletionHintsLazyQueryHookResult = ReturnType<
  typeof useTaskCompletionHintsLazyQuery
>;
export type TaskCompletionHintsSuspenseQueryHookResult = ReturnType<
  typeof useTaskCompletionHintsSuspenseQuery
>;
export type TaskCompletionHintsQueryResult = Apollo.QueryResult<
  TaskCompletionHintsQuery,
  TaskCompletionHintsQueryVariables
>;
export const TaskMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignedTo' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsTaskTaskMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignedTo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assignedTo' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inProgressTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overdueTasks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgCompletionTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTaskMetricsQuery__
 *
 * To run a query within a React component, call `useTaskMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskMetricsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      assignedTo: // value for 'assignedTo'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useTaskMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<TaskMetricsQuery, TaskMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskMetricsQuery, TaskMetricsQueryVariables>(TaskMetricsDocument, options);
}
export function useTaskMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TaskMetricsQuery, TaskMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TaskMetricsQuery, TaskMetricsQueryVariables>(
    TaskMetricsDocument,
    options,
  );
}
// @ts-ignore
export function useTaskMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TaskMetricsQuery, TaskMetricsQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskMetricsQuery, TaskMetricsQueryVariables>;
export function useTaskMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskMetricsQuery, TaskMetricsQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskMetricsQuery | undefined, TaskMetricsQueryVariables>;
export function useTaskMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskMetricsQuery, TaskMetricsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TaskMetricsQuery, TaskMetricsQueryVariables>(
    TaskMetricsDocument,
    options,
  );
}
export type TaskMetricsQueryHookResult = ReturnType<typeof useTaskMetricsQuery>;
export type TaskMetricsLazyQueryHookResult = ReturnType<typeof useTaskMetricsLazyQuery>;
export type TaskMetricsSuspenseQueryHookResult = ReturnType<typeof useTaskMetricsSuspenseQuery>;
export type TaskMetricsQueryResult = Apollo.QueryResult<
  TaskMetricsQuery,
  TaskMetricsQueryVariables
>;
export const GetTaskGroupsForCareGraphDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTaskGroupsForCareGraph' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskGroupCategory' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTaskGroupsForCareGraphQuery__
 *
 * To run a query within a React component, call `useGetTaskGroupsForCareGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskGroupsForCareGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskGroupsForCareGraphQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetTaskGroupsForCareGraphQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTaskGroupsForCareGraphQuery,
    GetTaskGroupsForCareGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskGroupsForCareGraphQuery, GetTaskGroupsForCareGraphQueryVariables>(
    GetTaskGroupsForCareGraphDocument,
    options,
  );
}
export function useGetTaskGroupsForCareGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskGroupsForCareGraphQuery,
    GetTaskGroupsForCareGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTaskGroupsForCareGraphQuery,
    GetTaskGroupsForCareGraphQueryVariables
  >(GetTaskGroupsForCareGraphDocument, options);
}
// @ts-ignore
export function useGetTaskGroupsForCareGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskGroupsForCareGraphQuery,
    GetTaskGroupsForCareGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTaskGroupsForCareGraphQuery,
  GetTaskGroupsForCareGraphQueryVariables
>;
export function useGetTaskGroupsForCareGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskGroupsForCareGraphQuery,
        GetTaskGroupsForCareGraphQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTaskGroupsForCareGraphQuery | undefined,
  GetTaskGroupsForCareGraphQueryVariables
>;
export function useGetTaskGroupsForCareGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskGroupsForCareGraphQuery,
        GetTaskGroupsForCareGraphQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTaskGroupsForCareGraphQuery,
    GetTaskGroupsForCareGraphQueryVariables
  >(GetTaskGroupsForCareGraphDocument, options);
}
export type GetTaskGroupsForCareGraphQueryHookResult = ReturnType<
  typeof useGetTaskGroupsForCareGraphQuery
>;
export type GetTaskGroupsForCareGraphLazyQueryHookResult = ReturnType<
  typeof useGetTaskGroupsForCareGraphLazyQuery
>;
export type GetTaskGroupsForCareGraphSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskGroupsForCareGraphSuspenseQuery
>;
export type GetTaskGroupsForCareGraphQueryResult = Apollo.QueryResult<
  GetTaskGroupsForCareGraphQuery,
  GetTaskGroupsForCareGraphQueryVariables
>;
export const ListTaskGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTaskGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setting' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskGroupCategory' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'setting' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'setting' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionStrategy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTaskGroupsQuery__
 *
 * To run a query within a React component, call `useListTaskGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTaskGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTaskGroupsQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      setting: // value for 'setting'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useListTaskGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>(
    ListTaskGroupsDocument,
    options,
  );
}
export function useListTaskGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>(
    ListTaskGroupsDocument,
    options,
  );
}
// @ts-ignore
export function useListTaskGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>;
export function useListTaskGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTaskGroupsQuery | undefined, ListTaskGroupsQueryVariables>;
export function useListTaskGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTaskGroupsQuery, ListTaskGroupsQueryVariables>(
    ListTaskGroupsDocument,
    options,
  );
}
export type ListTaskGroupsQueryHookResult = ReturnType<typeof useListTaskGroupsQuery>;
export type ListTaskGroupsLazyQueryHookResult = ReturnType<typeof useListTaskGroupsLazyQuery>;
export type ListTaskGroupsSuspenseQueryHookResult = ReturnType<
  typeof useListTaskGroupsSuspenseQuery
>;
export type ListTaskGroupsQueryResult = Apollo.QueryResult<
  ListTaskGroupsQuery,
  ListTaskGroupsQueryVariables
>;
export const OrphanTaskGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrphanTaskGroups' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orphanTaskGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionStrategy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOrphanTaskGroupsQuery__
 *
 * To run a query within a React component, call `useOrphanTaskGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrphanTaskGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrphanTaskGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrphanTaskGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>(
    OrphanTaskGroupsDocument,
    options,
  );
}
export function useOrphanTaskGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>(
    OrphanTaskGroupsDocument,
    options,
  );
}
// @ts-ignore
export function useOrphanTaskGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrphanTaskGroupsQuery,
    OrphanTaskGroupsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>;
export function useOrphanTaskGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrphanTaskGroupsQuery | undefined, OrphanTaskGroupsQueryVariables>;
export function useOrphanTaskGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OrphanTaskGroupsQuery, OrphanTaskGroupsQueryVariables>(
    OrphanTaskGroupsDocument,
    options,
  );
}
export type OrphanTaskGroupsQueryHookResult = ReturnType<typeof useOrphanTaskGroupsQuery>;
export type OrphanTaskGroupsLazyQueryHookResult = ReturnType<typeof useOrphanTaskGroupsLazyQuery>;
export type OrphanTaskGroupsSuspenseQueryHookResult = ReturnType<
  typeof useOrphanTaskGroupsSuspenseQuery
>;
export type OrphanTaskGroupsQueryResult = Apollo.QueryResult<
  OrphanTaskGroupsQuery,
  OrphanTaskGroupsQueryVariables
>;
export const TaskGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setting' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'setting' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'setting' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionStrategy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schedule' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTaskGroupQuery__
 *
 * To run a query within a React component, call `useTaskGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      groupId: // value for 'groupId'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useTaskGroupQuery(
  baseOptions: Apollo.QueryHookOptions<TaskGroupQuery, TaskGroupQueryVariables> &
    ({ variables: TaskGroupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskGroupQuery, TaskGroupQueryVariables>(TaskGroupDocument, options);
}
export function useTaskGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TaskGroupQuery, TaskGroupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TaskGroupQuery, TaskGroupQueryVariables>(TaskGroupDocument, options);
}
// @ts-ignore
export function useTaskGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TaskGroupQuery, TaskGroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskGroupQuery, TaskGroupQueryVariables>;
export function useTaskGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskGroupQuery, TaskGroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<TaskGroupQuery | undefined, TaskGroupQueryVariables>;
export function useTaskGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskGroupQuery, TaskGroupQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TaskGroupQuery, TaskGroupQueryVariables>(
    TaskGroupDocument,
    options,
  );
}
export type TaskGroupQueryHookResult = ReturnType<typeof useTaskGroupQuery>;
export type TaskGroupLazyQueryHookResult = ReturnType<typeof useTaskGroupLazyQuery>;
export type TaskGroupSuspenseQueryHookResult = ReturnType<typeof useTaskGroupSuspenseQuery>;
export type TaskGroupQueryResult = Apollo.QueryResult<TaskGroupQuery, TaskGroupQueryVariables>;
export const TaskGroupCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaskGroupCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setting' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskGroupCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'setting' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'setting' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'groupCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTaskGroupCategoriesQuery__
 *
 * To run a query within a React component, call `useTaskGroupCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupCategoriesQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useTaskGroupCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    TaskGroupCategoriesQuery,
    TaskGroupCategoriesQueryVariables
  > &
    ({ variables: TaskGroupCategoriesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskGroupCategoriesQuery, TaskGroupCategoriesQueryVariables>(
    TaskGroupCategoriesDocument,
    options,
  );
}
export function useTaskGroupCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TaskGroupCategoriesQuery,
    TaskGroupCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TaskGroupCategoriesQuery, TaskGroupCategoriesQueryVariables>(
    TaskGroupCategoriesDocument,
    options,
  );
}
// @ts-ignore
export function useTaskGroupCategoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TaskGroupCategoriesQuery,
    TaskGroupCategoriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TaskGroupCategoriesQuery, TaskGroupCategoriesQueryVariables>;
export function useTaskGroupCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskGroupCategoriesQuery, TaskGroupCategoriesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  TaskGroupCategoriesQuery | undefined,
  TaskGroupCategoriesQueryVariables
>;
export function useTaskGroupCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TaskGroupCategoriesQuery, TaskGroupCategoriesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TaskGroupCategoriesQuery, TaskGroupCategoriesQueryVariables>(
    TaskGroupCategoriesDocument,
    options,
  );
}
export type TaskGroupCategoriesQueryHookResult = ReturnType<typeof useTaskGroupCategoriesQuery>;
export type TaskGroupCategoriesLazyQueryHookResult = ReturnType<
  typeof useTaskGroupCategoriesLazyQuery
>;
export type TaskGroupCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useTaskGroupCategoriesSuspenseQuery
>;
export type TaskGroupCategoriesQueryResult = Apollo.QueryResult<
  TaskGroupCategoriesQuery,
  TaskGroupCategoriesQueryVariables
>;
export const GeneratedDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneratedDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generatedDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAccessedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowedOpenCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revoked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'revokedReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceEntityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceEntityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGeneratedDocumentQuery__
 *
 * To run a query within a React component, call `useGeneratedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratedDocumentQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGeneratedDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<GeneratedDocumentQuery, GeneratedDocumentQueryVariables> &
    ({ variables: GeneratedDocumentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GeneratedDocumentQuery, GeneratedDocumentQueryVariables>(
    GeneratedDocumentDocument,
    options,
  );
}
export function useGeneratedDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GeneratedDocumentQuery,
    GeneratedDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GeneratedDocumentQuery, GeneratedDocumentQueryVariables>(
    GeneratedDocumentDocument,
    options,
  );
}
// @ts-ignore
export function useGeneratedDocumentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GeneratedDocumentQuery,
    GeneratedDocumentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GeneratedDocumentQuery, GeneratedDocumentQueryVariables>;
export function useGeneratedDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GeneratedDocumentQuery, GeneratedDocumentQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GeneratedDocumentQuery | undefined,
  GeneratedDocumentQueryVariables
>;
export function useGeneratedDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GeneratedDocumentQuery, GeneratedDocumentQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GeneratedDocumentQuery, GeneratedDocumentQueryVariables>(
    GeneratedDocumentDocument,
    options,
  );
}
export type GeneratedDocumentQueryHookResult = ReturnType<typeof useGeneratedDocumentQuery>;
export type GeneratedDocumentLazyQueryHookResult = ReturnType<typeof useGeneratedDocumentLazyQuery>;
export type GeneratedDocumentSuspenseQueryHookResult = ReturnType<
  typeof useGeneratedDocumentSuspenseQuery
>;
export type GeneratedDocumentQueryResult = Apollo.QueryResult<
  GeneratedDocumentQuery,
  GeneratedDocumentQueryVariables
>;
export const GetCeremonyStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCeremonyStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCeremonyStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceremonyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signingOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signedS3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'declinedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'declineReason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'participantIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCeremonyStatusQuery__
 *
 * To run a query within a React component, call `useGetCeremonyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCeremonyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCeremonyStatusQuery({
 *   variables: {
 *      ceremonyId: // value for 'ceremonyId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetCeremonyStatusQuery(
  baseOptions: Apollo.QueryHookOptions<GetCeremonyStatusQuery, GetCeremonyStatusQueryVariables> &
    ({ variables: GetCeremonyStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCeremonyStatusQuery, GetCeremonyStatusQueryVariables>(
    GetCeremonyStatusDocument,
    options,
  );
}
export function useGetCeremonyStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCeremonyStatusQuery,
    GetCeremonyStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCeremonyStatusQuery, GetCeremonyStatusQueryVariables>(
    GetCeremonyStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetCeremonyStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCeremonyStatusQuery,
    GetCeremonyStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCeremonyStatusQuery, GetCeremonyStatusQueryVariables>;
export function useGetCeremonyStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCeremonyStatusQuery, GetCeremonyStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetCeremonyStatusQuery | undefined,
  GetCeremonyStatusQueryVariables
>;
export function useGetCeremonyStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCeremonyStatusQuery, GetCeremonyStatusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCeremonyStatusQuery, GetCeremonyStatusQueryVariables>(
    GetCeremonyStatusDocument,
    options,
  );
}
export type GetCeremonyStatusQueryHookResult = ReturnType<typeof useGetCeremonyStatusQuery>;
export type GetCeremonyStatusLazyQueryHookResult = ReturnType<typeof useGetCeremonyStatusLazyQuery>;
export type GetCeremonyStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetCeremonyStatusSuspenseQuery
>;
export type GetCeremonyStatusQueryResult = Apollo.QueryResult<
  GetCeremonyStatusQuery,
  GetCeremonyStatusQueryVariables
>;
export const GetDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiGetDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DocumentFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Document' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storageType' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Bucket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamodbContent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRuleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryEvidenceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables> &
    ({ variables: GetDocumentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
}
export function useGetDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(
    GetDocumentDocument,
    options,
  );
}
// @ts-ignore
export function useGetDocumentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDocumentQuery | undefined, GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDocumentQuery, GetDocumentQueryVariables>(
    GetDocumentDocument,
    options,
  );
}
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSuspenseQuery>;
export type GetDocumentQueryResult = Apollo.QueryResult<
  GetDocumentQuery,
  GetDocumentQueryVariables
>;
export const GetDocumentForCeremonyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDocumentForCeremony' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiGetDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Bucket' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDocumentForCeremonyQuery__
 *
 * To run a query within a React component, call `useGetDocumentForCeremonyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentForCeremonyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentForCeremonyQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentForCeremonyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDocumentForCeremonyQuery,
    GetDocumentForCeremonyQueryVariables
  > &
    ({ variables: GetDocumentForCeremonyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDocumentForCeremonyQuery, GetDocumentForCeremonyQueryVariables>(
    GetDocumentForCeremonyDocument,
    options,
  );
}
export function useGetDocumentForCeremonyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDocumentForCeremonyQuery,
    GetDocumentForCeremonyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDocumentForCeremonyQuery, GetDocumentForCeremonyQueryVariables>(
    GetDocumentForCeremonyDocument,
    options,
  );
}
// @ts-ignore
export function useGetDocumentForCeremonySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDocumentForCeremonyQuery,
    GetDocumentForCeremonyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetDocumentForCeremonyQuery, GetDocumentForCeremonyQueryVariables>;
export function useGetDocumentForCeremonySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDocumentForCeremonyQuery,
        GetDocumentForCeremonyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDocumentForCeremonyQuery | undefined,
  GetDocumentForCeremonyQueryVariables
>;
export function useGetDocumentForCeremonySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDocumentForCeremonyQuery,
        GetDocumentForCeremonyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDocumentForCeremonyQuery, GetDocumentForCeremonyQueryVariables>(
    GetDocumentForCeremonyDocument,
    options,
  );
}
export type GetDocumentForCeremonyQueryHookResult = ReturnType<
  typeof useGetDocumentForCeremonyQuery
>;
export type GetDocumentForCeremonyLazyQueryHookResult = ReturnType<
  typeof useGetDocumentForCeremonyLazyQuery
>;
export type GetDocumentForCeremonySuspenseQueryHookResult = ReturnType<
  typeof useGetDocumentForCeremonySuspenseQuery
>;
export type GetDocumentForCeremonyQueryResult = Apollo.QueryResult<
  GetDocumentForCeremonyQuery,
  GetDocumentForCeremonyQueryVariables
>;
export const GetDocumentVersionHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDocumentVersionHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiGetDocumentVersionHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'VersionFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VersionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentVersionInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changeDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDocumentVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetDocumentVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVersionHistoryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentVersionHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDocumentVersionHistoryQuery,
    GetDocumentVersionHistoryQueryVariables
  > &
    ({ variables: GetDocumentVersionHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDocumentVersionHistoryQuery, GetDocumentVersionHistoryQueryVariables>(
    GetDocumentVersionHistoryDocument,
    options,
  );
}
export function useGetDocumentVersionHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDocumentVersionHistoryQuery,
    GetDocumentVersionHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDocumentVersionHistoryQuery,
    GetDocumentVersionHistoryQueryVariables
  >(GetDocumentVersionHistoryDocument, options);
}
// @ts-ignore
export function useGetDocumentVersionHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDocumentVersionHistoryQuery,
    GetDocumentVersionHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDocumentVersionHistoryQuery,
  GetDocumentVersionHistoryQueryVariables
>;
export function useGetDocumentVersionHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDocumentVersionHistoryQuery,
        GetDocumentVersionHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDocumentVersionHistoryQuery | undefined,
  GetDocumentVersionHistoryQueryVariables
>;
export function useGetDocumentVersionHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDocumentVersionHistoryQuery,
        GetDocumentVersionHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDocumentVersionHistoryQuery,
    GetDocumentVersionHistoryQueryVariables
  >(GetDocumentVersionHistoryDocument, options);
}
export type GetDocumentVersionHistoryQueryHookResult = ReturnType<
  typeof useGetDocumentVersionHistoryQuery
>;
export type GetDocumentVersionHistoryLazyQueryHookResult = ReturnType<
  typeof useGetDocumentVersionHistoryLazyQuery
>;
export type GetDocumentVersionHistorySuspenseQueryHookResult = ReturnType<
  typeof useGetDocumentVersionHistorySuspenseQuery
>;
export type GetDocumentVersionHistoryQueryResult = Apollo.QueryResult<
  GetDocumentVersionHistoryQuery,
  GetDocumentVersionHistoryQueryVariables
>;
export const GetExchangeDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetExchangeDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'relationshipId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exchangeDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relationshipId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'relationshipId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderTenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'senderActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pushedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloaded' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetExchangeDocumentsQuery__
 *
 * To run a query within a React component, call `useGetExchangeDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeDocumentsQuery({
 *   variables: {
 *      relationshipId: // value for 'relationshipId'
 *   },
 * });
 */
export function useGetExchangeDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExchangeDocumentsQuery,
    GetExchangeDocumentsQueryVariables
  > &
    ({ variables: GetExchangeDocumentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExchangeDocumentsQuery, GetExchangeDocumentsQueryVariables>(
    GetExchangeDocumentsDocument,
    options,
  );
}
export function useGetExchangeDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExchangeDocumentsQuery,
    GetExchangeDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExchangeDocumentsQuery, GetExchangeDocumentsQueryVariables>(
    GetExchangeDocumentsDocument,
    options,
  );
}
// @ts-ignore
export function useGetExchangeDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetExchangeDocumentsQuery,
    GetExchangeDocumentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetExchangeDocumentsQuery, GetExchangeDocumentsQueryVariables>;
export function useGetExchangeDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExchangeDocumentsQuery,
        GetExchangeDocumentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetExchangeDocumentsQuery | undefined,
  GetExchangeDocumentsQueryVariables
>;
export function useGetExchangeDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExchangeDocumentsQuery,
        GetExchangeDocumentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetExchangeDocumentsQuery, GetExchangeDocumentsQueryVariables>(
    GetExchangeDocumentsDocument,
    options,
  );
}
export type GetExchangeDocumentsQueryHookResult = ReturnType<typeof useGetExchangeDocumentsQuery>;
export type GetExchangeDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetExchangeDocumentsLazyQuery
>;
export type GetExchangeDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useGetExchangeDocumentsSuspenseQuery
>;
export type GetExchangeDocumentsQueryResult = Apollo.QueryResult<
  GetExchangeDocumentsQuery,
  GetExchangeDocumentsQueryVariables
>;
export const ListCeremoniesForDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListCeremoniesForDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listCeremoniesForDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signingOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'declinedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListCeremoniesForDocumentQuery__
 *
 * To run a query within a React component, call `useListCeremoniesForDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCeremoniesForDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCeremoniesForDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useListCeremoniesForDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCeremoniesForDocumentQuery,
    ListCeremoniesForDocumentQueryVariables
  > &
    ({ variables: ListCeremoniesForDocumentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCeremoniesForDocumentQuery, ListCeremoniesForDocumentQueryVariables>(
    ListCeremoniesForDocumentDocument,
    options,
  );
}
export function useListCeremoniesForDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCeremoniesForDocumentQuery,
    ListCeremoniesForDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListCeremoniesForDocumentQuery,
    ListCeremoniesForDocumentQueryVariables
  >(ListCeremoniesForDocumentDocument, options);
}
// @ts-ignore
export function useListCeremoniesForDocumentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListCeremoniesForDocumentQuery,
    ListCeremoniesForDocumentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListCeremoniesForDocumentQuery,
  ListCeremoniesForDocumentQueryVariables
>;
export function useListCeremoniesForDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCeremoniesForDocumentQuery,
        ListCeremoniesForDocumentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListCeremoniesForDocumentQuery | undefined,
  ListCeremoniesForDocumentQueryVariables
>;
export function useListCeremoniesForDocumentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCeremoniesForDocumentQuery,
        ListCeremoniesForDocumentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListCeremoniesForDocumentQuery,
    ListCeremoniesForDocumentQueryVariables
  >(ListCeremoniesForDocumentDocument, options);
}
export type ListCeremoniesForDocumentQueryHookResult = ReturnType<
  typeof useListCeremoniesForDocumentQuery
>;
export type ListCeremoniesForDocumentLazyQueryHookResult = ReturnType<
  typeof useListCeremoniesForDocumentLazyQuery
>;
export type ListCeremoniesForDocumentSuspenseQueryHookResult = ReturnType<
  typeof useListCeremoniesForDocumentSuspenseQuery
>;
export type ListCeremoniesForDocumentQueryResult = Apollo.QueryResult<
  ListCeremoniesForDocumentQuery,
  ListCeremoniesForDocumentQueryVariables
>;
export const ListCeremonyTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListCeremonyTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listCeremonyTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfTemplateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ordering' } },
                { kind: 'Field', name: { kind: 'Name', value: 'padesProfile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiryHours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signingRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldY' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldWidth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldHeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'appearanceReason' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListCeremonyTemplatesQuery__
 *
 * To run a query within a React component, call `useListCeremonyTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCeremonyTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCeremonyTemplatesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useListCeremonyTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCeremonyTemplatesQuery,
    ListCeremonyTemplatesQueryVariables
  > &
    ({ variables: ListCeremonyTemplatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCeremonyTemplatesQuery, ListCeremonyTemplatesQueryVariables>(
    ListCeremonyTemplatesDocument,
    options,
  );
}
export function useListCeremonyTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCeremonyTemplatesQuery,
    ListCeremonyTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCeremonyTemplatesQuery, ListCeremonyTemplatesQueryVariables>(
    ListCeremonyTemplatesDocument,
    options,
  );
}
// @ts-ignore
export function useListCeremonyTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListCeremonyTemplatesQuery,
    ListCeremonyTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListCeremonyTemplatesQuery, ListCeremonyTemplatesQueryVariables>;
export function useListCeremonyTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCeremonyTemplatesQuery,
        ListCeremonyTemplatesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListCeremonyTemplatesQuery | undefined,
  ListCeremonyTemplatesQueryVariables
>;
export function useListCeremonyTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCeremonyTemplatesQuery,
        ListCeremonyTemplatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCeremonyTemplatesQuery, ListCeremonyTemplatesQueryVariables>(
    ListCeremonyTemplatesDocument,
    options,
  );
}
export type ListCeremonyTemplatesQueryHookResult = ReturnType<typeof useListCeremonyTemplatesQuery>;
export type ListCeremonyTemplatesLazyQueryHookResult = ReturnType<
  typeof useListCeremonyTemplatesLazyQuery
>;
export type ListCeremonyTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useListCeremonyTemplatesSuspenseQuery
>;
export type ListCeremonyTemplatesQueryResult = Apollo.QueryResult<
  ListCeremonyTemplatesQuery,
  ListCeremonyTemplatesQueryVariables
>;
export const ListDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentApiListDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DocumentFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DocumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Document' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storageType' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Key' } },
          { kind: 'Field', name: { kind: 'Name', value: 's3Bucket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dynamodbContent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRuleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryEvidenceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListDocumentsQuery__
 *
 * To run a query within a React component, call `useListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables> &
    ({ variables: ListDocumentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(
    ListDocumentsDocument,
    options,
  );
}
export function useListDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(
    ListDocumentsDocument,
    options,
  );
}
// @ts-ignore
export function useListDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export function useListDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDocumentsQuery | undefined, ListDocumentsQueryVariables>;
export function useListDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(
    ListDocumentsDocument,
    options,
  );
}
export type ListDocumentsQueryHookResult = ReturnType<typeof useListDocumentsQuery>;
export type ListDocumentsLazyQueryHookResult = ReturnType<typeof useListDocumentsLazyQuery>;
export type ListDocumentsSuspenseQueryHookResult = ReturnType<typeof useListDocumentsSuspenseQuery>;
export type ListDocumentsQueryResult = Apollo.QueryResult<
  ListDocumentsQuery,
  ListDocumentsQueryVariables
>;
export const MyGeneratedDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyGeneratedDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myGeneratedDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileSizeBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accessCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAccessedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revoked' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyGeneratedDocumentsQuery__
 *
 * To run a query within a React component, call `useMyGeneratedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGeneratedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGeneratedDocumentsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useMyGeneratedDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyGeneratedDocumentsQuery,
    MyGeneratedDocumentsQueryVariables
  > &
    ({ variables: MyGeneratedDocumentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyGeneratedDocumentsQuery, MyGeneratedDocumentsQueryVariables>(
    MyGeneratedDocumentsDocument,
    options,
  );
}
export function useMyGeneratedDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyGeneratedDocumentsQuery,
    MyGeneratedDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyGeneratedDocumentsQuery, MyGeneratedDocumentsQueryVariables>(
    MyGeneratedDocumentsDocument,
    options,
  );
}
// @ts-ignore
export function useMyGeneratedDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyGeneratedDocumentsQuery,
    MyGeneratedDocumentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyGeneratedDocumentsQuery, MyGeneratedDocumentsQueryVariables>;
export function useMyGeneratedDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyGeneratedDocumentsQuery,
        MyGeneratedDocumentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MyGeneratedDocumentsQuery | undefined,
  MyGeneratedDocumentsQueryVariables
>;
export function useMyGeneratedDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyGeneratedDocumentsQuery,
        MyGeneratedDocumentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyGeneratedDocumentsQuery, MyGeneratedDocumentsQueryVariables>(
    MyGeneratedDocumentsDocument,
    options,
  );
}
export type MyGeneratedDocumentsQueryHookResult = ReturnType<typeof useMyGeneratedDocumentsQuery>;
export type MyGeneratedDocumentsLazyQueryHookResult = ReturnType<
  typeof useMyGeneratedDocumentsLazyQuery
>;
export type MyGeneratedDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useMyGeneratedDocumentsSuspenseQuery
>;
export type MyGeneratedDocumentsQueryResult = Apollo.QueryResult<
  MyGeneratedDocumentsQuery,
  MyGeneratedDocumentsQueryVariables
>;
export const PdfTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PdfTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variables' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePdfTemplateQuery__
 *
 * To run a query within a React component, call `usePdfTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePdfTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<PdfTemplateQuery, PdfTemplateQueryVariables> &
    ({ variables: PdfTemplateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PdfTemplateQuery, PdfTemplateQueryVariables>(PdfTemplateDocument, options);
}
export function usePdfTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PdfTemplateQuery, PdfTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PdfTemplateQuery, PdfTemplateQueryVariables>(
    PdfTemplateDocument,
    options,
  );
}
// @ts-ignore
export function usePdfTemplateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PdfTemplateQuery, PdfTemplateQueryVariables>,
): Apollo.UseSuspenseQueryResult<PdfTemplateQuery, PdfTemplateQueryVariables>;
export function usePdfTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PdfTemplateQuery, PdfTemplateQueryVariables>,
): Apollo.UseSuspenseQueryResult<PdfTemplateQuery | undefined, PdfTemplateQueryVariables>;
export function usePdfTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PdfTemplateQuery, PdfTemplateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PdfTemplateQuery, PdfTemplateQueryVariables>(
    PdfTemplateDocument,
    options,
  );
}
export type PdfTemplateQueryHookResult = ReturnType<typeof usePdfTemplateQuery>;
export type PdfTemplateLazyQueryHookResult = ReturnType<typeof usePdfTemplateLazyQuery>;
export type PdfTemplateSuspenseQueryHookResult = ReturnType<typeof usePdfTemplateSuspenseQuery>;
export type PdfTemplateQueryResult = Apollo.QueryResult<
  PdfTemplateQuery,
  PdfTemplateQueryVariables
>;
export const PdfTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PdfTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variables' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePdfTemplatesQuery__
 *
 * To run a query within a React component, call `usePdfTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfTemplatesQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *   },
 * });
 */
export function usePdfTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<PdfTemplatesQuery, PdfTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PdfTemplatesQuery, PdfTemplatesQueryVariables>(
    PdfTemplatesDocument,
    options,
  );
}
export function usePdfTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PdfTemplatesQuery, PdfTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PdfTemplatesQuery, PdfTemplatesQueryVariables>(
    PdfTemplatesDocument,
    options,
  );
}
// @ts-ignore
export function usePdfTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PdfTemplatesQuery, PdfTemplatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<PdfTemplatesQuery, PdfTemplatesQueryVariables>;
export function usePdfTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PdfTemplatesQuery, PdfTemplatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<PdfTemplatesQuery | undefined, PdfTemplatesQueryVariables>;
export function usePdfTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PdfTemplatesQuery, PdfTemplatesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PdfTemplatesQuery, PdfTemplatesQueryVariables>(
    PdfTemplatesDocument,
    options,
  );
}
export type PdfTemplatesQueryHookResult = ReturnType<typeof usePdfTemplatesQuery>;
export type PdfTemplatesLazyQueryHookResult = ReturnType<typeof usePdfTemplatesLazyQuery>;
export type PdfTemplatesSuspenseQueryHookResult = ReturnType<typeof usePdfTemplatesSuspenseQuery>;
export type PdfTemplatesQueryResult = Apollo.QueryResult<
  PdfTemplatesQuery,
  PdfTemplatesQueryVariables
>;
export const RequestDocumentUrlViaTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RequestDocumentUrlViaToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestDocumentUrlViaToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresInSeconds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRequestDocumentUrlViaTokenQuery__
 *
 * To run a query within a React component, call `useRequestDocumentUrlViaTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentUrlViaTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestDocumentUrlViaTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRequestDocumentUrlViaTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    RequestDocumentUrlViaTokenQuery,
    RequestDocumentUrlViaTokenQueryVariables
  > &
    ({ variables: RequestDocumentUrlViaTokenQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RequestDocumentUrlViaTokenQuery, RequestDocumentUrlViaTokenQueryVariables>(
    RequestDocumentUrlViaTokenDocument,
    options,
  );
}
export function useRequestDocumentUrlViaTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RequestDocumentUrlViaTokenQuery,
    RequestDocumentUrlViaTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RequestDocumentUrlViaTokenQuery,
    RequestDocumentUrlViaTokenQueryVariables
  >(RequestDocumentUrlViaTokenDocument, options);
}
// @ts-ignore
export function useRequestDocumentUrlViaTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RequestDocumentUrlViaTokenQuery,
    RequestDocumentUrlViaTokenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RequestDocumentUrlViaTokenQuery,
  RequestDocumentUrlViaTokenQueryVariables
>;
export function useRequestDocumentUrlViaTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RequestDocumentUrlViaTokenQuery,
        RequestDocumentUrlViaTokenQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RequestDocumentUrlViaTokenQuery | undefined,
  RequestDocumentUrlViaTokenQueryVariables
>;
export function useRequestDocumentUrlViaTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RequestDocumentUrlViaTokenQuery,
        RequestDocumentUrlViaTokenQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RequestDocumentUrlViaTokenQuery,
    RequestDocumentUrlViaTokenQueryVariables
  >(RequestDocumentUrlViaTokenDocument, options);
}
export type RequestDocumentUrlViaTokenQueryHookResult = ReturnType<
  typeof useRequestDocumentUrlViaTokenQuery
>;
export type RequestDocumentUrlViaTokenLazyQueryHookResult = ReturnType<
  typeof useRequestDocumentUrlViaTokenLazyQuery
>;
export type RequestDocumentUrlViaTokenSuspenseQueryHookResult = ReturnType<
  typeof useRequestDocumentUrlViaTokenSuspenseQuery
>;
export type RequestDocumentUrlViaTokenQueryResult = Apollo.QueryResult<
  RequestDocumentUrlViaTokenQuery,
  RequestDocumentUrlViaTokenQueryVariables
>;
export const TriggerCeremonyRemindersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TriggerCeremonyReminders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerCeremonyReminders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTriggerCeremonyRemindersQuery__
 *
 * To run a query within a React component, call `useTriggerCeremonyRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggerCeremonyRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggerCeremonyRemindersQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useTriggerCeremonyRemindersQuery(
  baseOptions: Apollo.QueryHookOptions<
    TriggerCeremonyRemindersQuery,
    TriggerCeremonyRemindersQueryVariables
  > &
    ({ variables: TriggerCeremonyRemindersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TriggerCeremonyRemindersQuery, TriggerCeremonyRemindersQueryVariables>(
    TriggerCeremonyRemindersDocument,
    options,
  );
}
export function useTriggerCeremonyRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TriggerCeremonyRemindersQuery,
    TriggerCeremonyRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TriggerCeremonyRemindersQuery, TriggerCeremonyRemindersQueryVariables>(
    TriggerCeremonyRemindersDocument,
    options,
  );
}
// @ts-ignore
export function useTriggerCeremonyRemindersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TriggerCeremonyRemindersQuery,
    TriggerCeremonyRemindersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TriggerCeremonyRemindersQuery,
  TriggerCeremonyRemindersQueryVariables
>;
export function useTriggerCeremonyRemindersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TriggerCeremonyRemindersQuery,
        TriggerCeremonyRemindersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TriggerCeremonyRemindersQuery | undefined,
  TriggerCeremonyRemindersQueryVariables
>;
export function useTriggerCeremonyRemindersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TriggerCeremonyRemindersQuery,
        TriggerCeremonyRemindersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TriggerCeremonyRemindersQuery,
    TriggerCeremonyRemindersQueryVariables
  >(TriggerCeremonyRemindersDocument, options);
}
export type TriggerCeremonyRemindersQueryHookResult = ReturnType<
  typeof useTriggerCeremonyRemindersQuery
>;
export type TriggerCeremonyRemindersLazyQueryHookResult = ReturnType<
  typeof useTriggerCeremonyRemindersLazyQuery
>;
export type TriggerCeremonyRemindersSuspenseQueryHookResult = ReturnType<
  typeof useTriggerCeremonyRemindersSuspenseQuery
>;
export type TriggerCeremonyRemindersQueryResult = Apollo.QueryResult<
  TriggerCeremonyRemindersQuery,
  TriggerCeremonyRemindersQueryVariables
>;
export const VerifyCeremonySignaturesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerifyCeremonySignatures' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyCeremonySignatures' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceremonyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allValid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verifiedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'signatures' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'signerEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signerName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateSubject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'padesProfile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestampValid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revocationChecked' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useVerifyCeremonySignaturesQuery__
 *
 * To run a query within a React component, call `useVerifyCeremonySignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyCeremonySignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyCeremonySignaturesQuery({
 *   variables: {
 *      ceremonyId: // value for 'ceremonyId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useVerifyCeremonySignaturesQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifyCeremonySignaturesQuery,
    VerifyCeremonySignaturesQueryVariables
  > &
    ({ variables: VerifyCeremonySignaturesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifyCeremonySignaturesQuery, VerifyCeremonySignaturesQueryVariables>(
    VerifyCeremonySignaturesDocument,
    options,
  );
}
export function useVerifyCeremonySignaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifyCeremonySignaturesQuery,
    VerifyCeremonySignaturesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifyCeremonySignaturesQuery, VerifyCeremonySignaturesQueryVariables>(
    VerifyCeremonySignaturesDocument,
    options,
  );
}
// @ts-ignore
export function useVerifyCeremonySignaturesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VerifyCeremonySignaturesQuery,
    VerifyCeremonySignaturesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VerifyCeremonySignaturesQuery,
  VerifyCeremonySignaturesQueryVariables
>;
export function useVerifyCeremonySignaturesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifyCeremonySignaturesQuery,
        VerifyCeremonySignaturesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VerifyCeremonySignaturesQuery | undefined,
  VerifyCeremonySignaturesQueryVariables
>;
export function useVerifyCeremonySignaturesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifyCeremonySignaturesQuery,
        VerifyCeremonySignaturesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerifyCeremonySignaturesQuery,
    VerifyCeremonySignaturesQueryVariables
  >(VerifyCeremonySignaturesDocument, options);
}
export type VerifyCeremonySignaturesQueryHookResult = ReturnType<
  typeof useVerifyCeremonySignaturesQuery
>;
export type VerifyCeremonySignaturesLazyQueryHookResult = ReturnType<
  typeof useVerifyCeremonySignaturesLazyQuery
>;
export type VerifyCeremonySignaturesSuspenseQueryHookResult = ReturnType<
  typeof useVerifyCeremonySignaturesSuspenseQuery
>;
export type VerifyCeremonySignaturesQueryResult = Apollo.QueryResult<
  VerifyCeremonySignaturesQuery,
  VerifyCeremonySignaturesQueryVariables
>;
export const ConstellationsByActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConstellationsByActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constellationsByActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constellationIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'memberships' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ring' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'edgeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConstellationsByActorQuery__
 *
 * To run a query within a React component, call `useConstellationsByActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstellationsByActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstellationsByActorQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useConstellationsByActorQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConstellationsByActorQuery,
    ConstellationsByActorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConstellationsByActorQuery, ConstellationsByActorQueryVariables>(
    ConstellationsByActorDocument,
    options,
  );
}
export function useConstellationsByActorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConstellationsByActorQuery,
    ConstellationsByActorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConstellationsByActorQuery, ConstellationsByActorQueryVariables>(
    ConstellationsByActorDocument,
    options,
  );
}
// @ts-ignore
export function useConstellationsByActorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConstellationsByActorQuery,
    ConstellationsByActorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ConstellationsByActorQuery, ConstellationsByActorQueryVariables>;
export function useConstellationsByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConstellationsByActorQuery,
        ConstellationsByActorQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConstellationsByActorQuery | undefined,
  ConstellationsByActorQueryVariables
>;
export function useConstellationsByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConstellationsByActorQuery,
        ConstellationsByActorQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConstellationsByActorQuery, ConstellationsByActorQueryVariables>(
    ConstellationsByActorDocument,
    options,
  );
}
export type ConstellationsByActorQueryHookResult = ReturnType<typeof useConstellationsByActorQuery>;
export type ConstellationsByActorLazyQueryHookResult = ReturnType<
  typeof useConstellationsByActorLazyQuery
>;
export type ConstellationsByActorSuspenseQueryHookResult = ReturnType<
  typeof useConstellationsByActorSuspenseQuery
>;
export type ConstellationsByActorQueryResult = Apollo.QueryResult<
  ConstellationsByActorQuery,
  ConstellationsByActorQueryVariables
>;
export const GetActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorQuery__
 *
 * To run a query within a React component, call `useGetActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetActorQuery(
  baseOptions: Apollo.QueryHookOptions<GetActorQuery, GetActorQueryVariables> &
    ({ variables: GetActorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorQuery, GetActorQueryVariables>(GetActorDocument, options);
}
export function useGetActorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActorQuery, GetActorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorQuery, GetActorQueryVariables>(GetActorDocument, options);
}
// @ts-ignore
export function useGetActorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetActorQuery, GetActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetActorQuery, GetActorQueryVariables>;
export function useGetActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorQuery, GetActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetActorQuery | undefined, GetActorQueryVariables>;
export function useGetActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorQuery, GetActorQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActorQuery, GetActorQueryVariables>(GetActorDocument, options);
}
export type GetActorQueryHookResult = ReturnType<typeof useGetActorQuery>;
export type GetActorLazyQueryHookResult = ReturnType<typeof useGetActorLazyQuery>;
export type GetActorSuspenseQueryHookResult = ReturnType<typeof useGetActorSuspenseQuery>;
export type GetActorQueryResult = Apollo.QueryResult<GetActorQuery, GetActorQueryVariables>;
export const GetActorByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActorById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorGlobalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorByIdQuery__
 *
 * To run a query within a React component, call `useGetActorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorByIdQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetActorByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetActorByIdQuery, GetActorByIdQueryVariables> &
    ({ variables: GetActorByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorByIdQuery, GetActorByIdQueryVariables>(
    GetActorByIdDocument,
    options,
  );
}
export function useGetActorByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActorByIdQuery, GetActorByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorByIdQuery, GetActorByIdQueryVariables>(
    GetActorByIdDocument,
    options,
  );
}
// @ts-ignore
export function useGetActorByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetActorByIdQuery, GetActorByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetActorByIdQuery, GetActorByIdQueryVariables>;
export function useGetActorByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorByIdQuery, GetActorByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetActorByIdQuery | undefined, GetActorByIdQueryVariables>;
export function useGetActorByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorByIdQuery, GetActorByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActorByIdQuery, GetActorByIdQueryVariables>(
    GetActorByIdDocument,
    options,
  );
}
export type GetActorByIdQueryHookResult = ReturnType<typeof useGetActorByIdQuery>;
export type GetActorByIdLazyQueryHookResult = ReturnType<typeof useGetActorByIdLazyQuery>;
export type GetActorByIdSuspenseQueryHookResult = ReturnType<typeof useGetActorByIdSuspenseQuery>;
export type GetActorByIdQueryResult = Apollo.QueryResult<
  GetActorByIdQuery,
  GetActorByIdQueryVariables
>;
export const GetActorSecurityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActorSecurity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actorMgmtActor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'securityLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emergencyAccess' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSecurityReview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mfaEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mfaVerifiedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'biometricEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'biometricVerifiedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emergencyAccessLog' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accessedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'systemsAccessed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorSecurityQuery__
 *
 * To run a query within a React component, call `useGetActorSecurityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorSecurityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorSecurityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetActorSecurityQuery(
  baseOptions: Apollo.QueryHookOptions<GetActorSecurityQuery, GetActorSecurityQueryVariables> &
    ({ variables: GetActorSecurityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorSecurityQuery, GetActorSecurityQueryVariables>(
    GetActorSecurityDocument,
    options,
  );
}
export function useGetActorSecurityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActorSecurityQuery, GetActorSecurityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorSecurityQuery, GetActorSecurityQueryVariables>(
    GetActorSecurityDocument,
    options,
  );
}
// @ts-ignore
export function useGetActorSecuritySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActorSecurityQuery,
    GetActorSecurityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActorSecurityQuery, GetActorSecurityQueryVariables>;
export function useGetActorSecuritySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorSecurityQuery, GetActorSecurityQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetActorSecurityQuery | undefined, GetActorSecurityQueryVariables>;
export function useGetActorSecuritySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorSecurityQuery, GetActorSecurityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActorSecurityQuery, GetActorSecurityQueryVariables>(
    GetActorSecurityDocument,
    options,
  );
}
export type GetActorSecurityQueryHookResult = ReturnType<typeof useGetActorSecurityQuery>;
export type GetActorSecurityLazyQueryHookResult = ReturnType<typeof useGetActorSecurityLazyQuery>;
export type GetActorSecuritySuspenseQueryHookResult = ReturnType<
  typeof useGetActorSecuritySuspenseQuery
>;
export type GetActorSecurityQueryResult = Apollo.QueryResult<
  GetActorSecurityQuery,
  GetActorSecurityQueryVariables
>;
export const GetActorStatisticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActorStatistics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActorStatistics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utilizationPercent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'successRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgTaskResponseMinutes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorStatisticsQuery__
 *
 * To run a query within a React component, call `useGetActorStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorStatisticsQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetActorStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<GetActorStatisticsQuery, GetActorStatisticsQueryVariables> &
    ({ variables: GetActorStatisticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorStatisticsQuery, GetActorStatisticsQueryVariables>(
    GetActorStatisticsDocument,
    options,
  );
}
export function useGetActorStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActorStatisticsQuery,
    GetActorStatisticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorStatisticsQuery, GetActorStatisticsQueryVariables>(
    GetActorStatisticsDocument,
    options,
  );
}
// @ts-ignore
export function useGetActorStatisticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActorStatisticsQuery,
    GetActorStatisticsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActorStatisticsQuery, GetActorStatisticsQueryVariables>;
export function useGetActorStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorStatisticsQuery, GetActorStatisticsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetActorStatisticsQuery | undefined,
  GetActorStatisticsQueryVariables
>;
export function useGetActorStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorStatisticsQuery, GetActorStatisticsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActorStatisticsQuery, GetActorStatisticsQueryVariables>(
    GetActorStatisticsDocument,
    options,
  );
}
export type GetActorStatisticsQueryHookResult = ReturnType<typeof useGetActorStatisticsQuery>;
export type GetActorStatisticsLazyQueryHookResult = ReturnType<
  typeof useGetActorStatisticsLazyQuery
>;
export type GetActorStatisticsSuspenseQueryHookResult = ReturnType<
  typeof useGetActorStatisticsSuspenseQuery
>;
export type GetActorStatisticsQueryResult = Apollo.QueryResult<
  GetActorStatisticsQuery,
  GetActorStatisticsQueryVariables
>;
export const GetActorsByCapabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActorsByCapability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'capability' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActorsByCapability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'capability' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'capability' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorsByCapabilityQuery__
 *
 * To run a query within a React component, call `useGetActorsByCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorsByCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorsByCapabilityQuery({
 *   variables: {
 *      capability: // value for 'capability'
 *   },
 * });
 */
export function useGetActorsByCapabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActorsByCapabilityQuery,
    GetActorsByCapabilityQueryVariables
  > &
    ({ variables: GetActorsByCapabilityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorsByCapabilityQuery, GetActorsByCapabilityQueryVariables>(
    GetActorsByCapabilityDocument,
    options,
  );
}
export function useGetActorsByCapabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActorsByCapabilityQuery,
    GetActorsByCapabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorsByCapabilityQuery, GetActorsByCapabilityQueryVariables>(
    GetActorsByCapabilityDocument,
    options,
  );
}
// @ts-ignore
export function useGetActorsByCapabilitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActorsByCapabilityQuery,
    GetActorsByCapabilityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActorsByCapabilityQuery, GetActorsByCapabilityQueryVariables>;
export function useGetActorsByCapabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActorsByCapabilityQuery,
        GetActorsByCapabilityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetActorsByCapabilityQuery | undefined,
  GetActorsByCapabilityQueryVariables
>;
export function useGetActorsByCapabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActorsByCapabilityQuery,
        GetActorsByCapabilityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActorsByCapabilityQuery, GetActorsByCapabilityQueryVariables>(
    GetActorsByCapabilityDocument,
    options,
  );
}
export type GetActorsByCapabilityQueryHookResult = ReturnType<typeof useGetActorsByCapabilityQuery>;
export type GetActorsByCapabilityLazyQueryHookResult = ReturnType<
  typeof useGetActorsByCapabilityLazyQuery
>;
export type GetActorsByCapabilitySuspenseQueryHookResult = ReturnType<
  typeof useGetActorsByCapabilitySuspenseQuery
>;
export type GetActorsByCapabilityQueryResult = Apollo.QueryResult<
  GetActorsByCapabilityQuery,
  GetActorsByCapabilityQueryVariables
>;
export const GetActorsByTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActorsByTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActorsByTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'teamId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorsByTeamQuery__
 *
 * To run a query within a React component, call `useGetActorsByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorsByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorsByTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetActorsByTeamQuery(
  baseOptions: Apollo.QueryHookOptions<GetActorsByTeamQuery, GetActorsByTeamQueryVariables> &
    ({ variables: GetActorsByTeamQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorsByTeamQuery, GetActorsByTeamQueryVariables>(
    GetActorsByTeamDocument,
    options,
  );
}
export function useGetActorsByTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActorsByTeamQuery, GetActorsByTeamQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorsByTeamQuery, GetActorsByTeamQueryVariables>(
    GetActorsByTeamDocument,
    options,
  );
}
// @ts-ignore
export function useGetActorsByTeamSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActorsByTeamQuery,
    GetActorsByTeamQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActorsByTeamQuery, GetActorsByTeamQueryVariables>;
export function useGetActorsByTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorsByTeamQuery, GetActorsByTeamQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetActorsByTeamQuery | undefined, GetActorsByTeamQueryVariables>;
export function useGetActorsByTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorsByTeamQuery, GetActorsByTeamQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActorsByTeamQuery, GetActorsByTeamQueryVariables>(
    GetActorsByTeamDocument,
    options,
  );
}
export type GetActorsByTeamQueryHookResult = ReturnType<typeof useGetActorsByTeamQuery>;
export type GetActorsByTeamLazyQueryHookResult = ReturnType<typeof useGetActorsByTeamLazyQuery>;
export type GetActorsByTeamSuspenseQueryHookResult = ReturnType<
  typeof useGetActorsByTeamSuspenseQuery
>;
export type GetActorsByTeamQueryResult = Apollo.QueryResult<
  GetActorsByTeamQuery,
  GetActorsByTeamQueryVariables
>;
export const GetActorsByTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActorsByType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlActorType' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActorsByType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetActorsByTypeQuery__
 *
 * To run a query within a React component, call `useGetActorsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorsByTypeQuery({
 *   variables: {
 *      actorType: // value for 'actorType'
 *   },
 * });
 */
export function useGetActorsByTypeQuery(
  baseOptions: Apollo.QueryHookOptions<GetActorsByTypeQuery, GetActorsByTypeQueryVariables> &
    ({ variables: GetActorsByTypeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorsByTypeQuery, GetActorsByTypeQueryVariables>(
    GetActorsByTypeDocument,
    options,
  );
}
export function useGetActorsByTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActorsByTypeQuery, GetActorsByTypeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorsByTypeQuery, GetActorsByTypeQueryVariables>(
    GetActorsByTypeDocument,
    options,
  );
}
// @ts-ignore
export function useGetActorsByTypeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActorsByTypeQuery,
    GetActorsByTypeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetActorsByTypeQuery, GetActorsByTypeQueryVariables>;
export function useGetActorsByTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorsByTypeQuery, GetActorsByTypeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetActorsByTypeQuery | undefined, GetActorsByTypeQueryVariables>;
export function useGetActorsByTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActorsByTypeQuery, GetActorsByTypeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActorsByTypeQuery, GetActorsByTypeQueryVariables>(
    GetActorsByTypeDocument,
    options,
  );
}
export type GetActorsByTypeQueryHookResult = ReturnType<typeof useGetActorsByTypeQuery>;
export type GetActorsByTypeLazyQueryHookResult = ReturnType<typeof useGetActorsByTypeLazyQuery>;
export type GetActorsByTypeSuspenseQueryHookResult = ReturnType<
  typeof useGetActorsByTypeSuspenseQuery
>;
export type GetActorsByTypeQueryResult = Apollo.QueryResult<
  GetActorsByTypeQuery,
  GetActorsByTypeQueryVariables
>;
export const MySubjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MySubjects' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySubjects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMySubjectsQuery__
 *
 * To run a query within a React component, call `useMySubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySubjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<MySubjectsQuery, MySubjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MySubjectsQuery, MySubjectsQueryVariables>(MySubjectsDocument, options);
}
export function useMySubjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MySubjectsQuery, MySubjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MySubjectsQuery, MySubjectsQueryVariables>(
    MySubjectsDocument,
    options,
  );
}
// @ts-ignore
export function useMySubjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MySubjectsQuery, MySubjectsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MySubjectsQuery, MySubjectsQueryVariables>;
export function useMySubjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MySubjectsQuery, MySubjectsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MySubjectsQuery | undefined, MySubjectsQueryVariables>;
export function useMySubjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MySubjectsQuery, MySubjectsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MySubjectsQuery, MySubjectsQueryVariables>(
    MySubjectsDocument,
    options,
  );
}
export type MySubjectsQueryHookResult = ReturnType<typeof useMySubjectsQuery>;
export type MySubjectsLazyQueryHookResult = ReturnType<typeof useMySubjectsLazyQuery>;
export type MySubjectsSuspenseQueryHookResult = ReturnType<typeof useMySubjectsSuspenseQuery>;
export type MySubjectsQueryResult = Apollo.QueryResult<MySubjectsQuery, MySubjectsQueryVariables>;
export const GetExchangeRelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetExchangeRelationships' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exchangeRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromTenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toTenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromTenantName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toTenantName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredApprovals' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consentRecords' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consentedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authTier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'witnessVerified' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'establishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetExchangeRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetExchangeRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeRelationshipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExchangeRelationshipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetExchangeRelationshipsQuery,
    GetExchangeRelationshipsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExchangeRelationshipsQuery, GetExchangeRelationshipsQueryVariables>(
    GetExchangeRelationshipsDocument,
    options,
  );
}
export function useGetExchangeRelationshipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExchangeRelationshipsQuery,
    GetExchangeRelationshipsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExchangeRelationshipsQuery, GetExchangeRelationshipsQueryVariables>(
    GetExchangeRelationshipsDocument,
    options,
  );
}
// @ts-ignore
export function useGetExchangeRelationshipsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetExchangeRelationshipsQuery,
    GetExchangeRelationshipsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetExchangeRelationshipsQuery,
  GetExchangeRelationshipsQueryVariables
>;
export function useGetExchangeRelationshipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExchangeRelationshipsQuery,
        GetExchangeRelationshipsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetExchangeRelationshipsQuery | undefined,
  GetExchangeRelationshipsQueryVariables
>;
export function useGetExchangeRelationshipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExchangeRelationshipsQuery,
        GetExchangeRelationshipsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetExchangeRelationshipsQuery,
    GetExchangeRelationshipsQueryVariables
  >(GetExchangeRelationshipsDocument, options);
}
export type GetExchangeRelationshipsQueryHookResult = ReturnType<
  typeof useGetExchangeRelationshipsQuery
>;
export type GetExchangeRelationshipsLazyQueryHookResult = ReturnType<
  typeof useGetExchangeRelationshipsLazyQuery
>;
export type GetExchangeRelationshipsSuspenseQueryHookResult = ReturnType<
  typeof useGetExchangeRelationshipsSuspenseQuery
>;
export type GetExchangeRelationshipsQueryResult = Apollo.QueryResult<
  GetExchangeRelationshipsQuery,
  GetExchangeRelationshipsQueryVariables
>;
export const GetFocusContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFocusContext' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focusContext' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'perspective' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFocusContextQuery__
 *
 * To run a query within a React component, call `useGetFocusContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFocusContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFocusContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFocusContextQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFocusContextQuery, GetFocusContextQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFocusContextQuery, GetFocusContextQueryVariables>(
    GetFocusContextDocument,
    options,
  );
}
export function useGetFocusContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFocusContextQuery, GetFocusContextQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFocusContextQuery, GetFocusContextQueryVariables>(
    GetFocusContextDocument,
    options,
  );
}
// @ts-ignore
export function useGetFocusContextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFocusContextQuery,
    GetFocusContextQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetFocusContextQuery, GetFocusContextQueryVariables>;
export function useGetFocusContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetFocusContextQuery, GetFocusContextQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetFocusContextQuery | undefined, GetFocusContextQueryVariables>;
export function useGetFocusContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetFocusContextQuery, GetFocusContextQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFocusContextQuery, GetFocusContextQueryVariables>(
    GetFocusContextDocument,
    options,
  );
}
export type GetFocusContextQueryHookResult = ReturnType<typeof useGetFocusContextQuery>;
export type GetFocusContextLazyQueryHookResult = ReturnType<typeof useGetFocusContextLazyQuery>;
export type GetFocusContextSuspenseQueryHookResult = ReturnType<
  typeof useGetFocusContextSuspenseQuery
>;
export type GetFocusContextQueryResult = Apollo.QueryResult<
  GetFocusContextQuery,
  GetFocusContextQueryVariables
>;
export const GetMyActorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMyActor' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyActor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorGlobalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMyActorQuery__
 *
 * To run a query within a React component, call `useGetMyActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyActorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyActorQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyActorQuery, GetMyActorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyActorQuery, GetMyActorQueryVariables>(GetMyActorDocument, options);
}
export function useGetMyActorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMyActorQuery, GetMyActorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyActorQuery, GetMyActorQueryVariables>(
    GetMyActorDocument,
    options,
  );
}
// @ts-ignore
export function useGetMyActorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyActorQuery, GetMyActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetMyActorQuery, GetMyActorQueryVariables>;
export function useGetMyActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMyActorQuery, GetMyActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetMyActorQuery | undefined, GetMyActorQueryVariables>;
export function useGetMyActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMyActorQuery, GetMyActorQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMyActorQuery, GetMyActorQueryVariables>(
    GetMyActorDocument,
    options,
  );
}
export type GetMyActorQueryHookResult = ReturnType<typeof useGetMyActorQuery>;
export type GetMyActorLazyQueryHookResult = ReturnType<typeof useGetMyActorLazyQuery>;
export type GetMyActorSuspenseQueryHookResult = ReturnType<typeof useGetMyActorSuspenseQuery>;
export type GetMyActorQueryResult = Apollo.QueryResult<GetMyActorQuery, GetMyActorQueryVariables>;
export const GetTeamWorkspaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeamWorkspace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTeamWorkspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'teamId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'teamName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teamDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memberCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onlineCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'members' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentTaskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'successRate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'presence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastSeen' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTeamWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetTeamWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamWorkspaceQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables> &
    ({ variables: GetTeamWorkspaceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables>(
    GetTeamWorkspaceDocument,
    options,
  );
}
export function useGetTeamWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables>(
    GetTeamWorkspaceDocument,
    options,
  );
}
// @ts-ignore
export function useGetTeamWorkspaceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamWorkspaceQuery,
    GetTeamWorkspaceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables>;
export function useGetTeamWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTeamWorkspaceQuery | undefined, GetTeamWorkspaceQueryVariables>;
export function useGetTeamWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTeamWorkspaceQuery, GetTeamWorkspaceQueryVariables>(
    GetTeamWorkspaceDocument,
    options,
  );
}
export type GetTeamWorkspaceQueryHookResult = ReturnType<typeof useGetTeamWorkspaceQuery>;
export type GetTeamWorkspaceLazyQueryHookResult = ReturnType<typeof useGetTeamWorkspaceLazyQuery>;
export type GetTeamWorkspaceSuspenseQueryHookResult = ReturnType<
  typeof useGetTeamWorkspaceSuspenseQuery
>;
export type GetTeamWorkspaceQueryResult = Apollo.QueryResult<
  GetTeamWorkspaceQuery,
  GetTeamWorkspaceQueryVariables
>;
export const GetTeamWorkspaceSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTeamWorkspaceSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTeamWorkspace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'teamId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'teamName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memberCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onlineCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'members' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'presence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTeamWorkspaceSummaryQuery__
 *
 * To run a query within a React component, call `useGetTeamWorkspaceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamWorkspaceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamWorkspaceSummaryQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamWorkspaceSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTeamWorkspaceSummaryQuery,
    GetTeamWorkspaceSummaryQueryVariables
  > &
    ({ variables: GetTeamWorkspaceSummaryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamWorkspaceSummaryQuery, GetTeamWorkspaceSummaryQueryVariables>(
    GetTeamWorkspaceSummaryDocument,
    options,
  );
}
export function useGetTeamWorkspaceSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTeamWorkspaceSummaryQuery,
    GetTeamWorkspaceSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamWorkspaceSummaryQuery, GetTeamWorkspaceSummaryQueryVariables>(
    GetTeamWorkspaceSummaryDocument,
    options,
  );
}
// @ts-ignore
export function useGetTeamWorkspaceSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamWorkspaceSummaryQuery,
    GetTeamWorkspaceSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTeamWorkspaceSummaryQuery,
  GetTeamWorkspaceSummaryQueryVariables
>;
export function useGetTeamWorkspaceSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamWorkspaceSummaryQuery,
        GetTeamWorkspaceSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTeamWorkspaceSummaryQuery | undefined,
  GetTeamWorkspaceSummaryQueryVariables
>;
export function useGetTeamWorkspaceSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamWorkspaceSummaryQuery,
        GetTeamWorkspaceSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTeamWorkspaceSummaryQuery,
    GetTeamWorkspaceSummaryQueryVariables
  >(GetTeamWorkspaceSummaryDocument, options);
}
export type GetTeamWorkspaceSummaryQueryHookResult = ReturnType<
  typeof useGetTeamWorkspaceSummaryQuery
>;
export type GetTeamWorkspaceSummaryLazyQueryHookResult = ReturnType<
  typeof useGetTeamWorkspaceSummaryLazyQuery
>;
export type GetTeamWorkspaceSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetTeamWorkspaceSummarySuspenseQuery
>;
export type GetTeamWorkspaceSummaryQueryResult = Apollo.QueryResult<
  GetTeamWorkspaceSummaryQuery,
  GetTeamWorkspaceSummaryQueryVariables
>;
export const ListActorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListActors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listActors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActorFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActorFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Actor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolvedScopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'configuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertTier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseJurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListActorsQuery__
 *
 * To run a query within a React component, call `useListActorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListActorsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListActorsQuery, ListActorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListActorsQuery, ListActorsQueryVariables>(ListActorsDocument, options);
}
export function useListActorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListActorsQuery, ListActorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListActorsQuery, ListActorsQueryVariables>(
    ListActorsDocument,
    options,
  );
}
// @ts-ignore
export function useListActorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListActorsQuery, ListActorsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListActorsQuery, ListActorsQueryVariables>;
export function useListActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActorsQuery, ListActorsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListActorsQuery | undefined, ListActorsQueryVariables>;
export function useListActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActorsQuery, ListActorsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListActorsQuery, ListActorsQueryVariables>(
    ListActorsDocument,
    options,
  );
}
export type ListActorsQueryHookResult = ReturnType<typeof useListActorsQuery>;
export type ListActorsLazyQueryHookResult = ReturnType<typeof useListActorsLazyQuery>;
export type ListActorsSuspenseQueryHookResult = ReturnType<typeof useListActorsSuspenseQuery>;
export type ListActorsQueryResult = Apollo.QueryResult<ListActorsQuery, ListActorsQueryVariables>;
export const ListActorsForPanelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListActorsForPanel' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listActors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListActorsForPanelQuery__
 *
 * To run a query within a React component, call `useListActorsForPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActorsForPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActorsForPanelQuery({
 *   variables: {
 *   },
 * });
 */
export function useListActorsForPanelQuery(
  baseOptions?: Apollo.QueryHookOptions<ListActorsForPanelQuery, ListActorsForPanelQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListActorsForPanelQuery, ListActorsForPanelQueryVariables>(
    ListActorsForPanelDocument,
    options,
  );
}
export function useListActorsForPanelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActorsForPanelQuery,
    ListActorsForPanelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListActorsForPanelQuery, ListActorsForPanelQueryVariables>(
    ListActorsForPanelDocument,
    options,
  );
}
// @ts-ignore
export function useListActorsForPanelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActorsForPanelQuery,
    ListActorsForPanelQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListActorsForPanelQuery, ListActorsForPanelQueryVariables>;
export function useListActorsForPanelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActorsForPanelQuery, ListActorsForPanelQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListActorsForPanelQuery | undefined,
  ListActorsForPanelQueryVariables
>;
export function useListActorsForPanelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActorsForPanelQuery, ListActorsForPanelQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListActorsForPanelQuery, ListActorsForPanelQueryVariables>(
    ListActorsForPanelDocument,
    options,
  );
}
export type ListActorsForPanelQueryHookResult = ReturnType<typeof useListActorsForPanelQuery>;
export type ListActorsForPanelLazyQueryHookResult = ReturnType<
  typeof useListActorsForPanelLazyQuery
>;
export type ListActorsForPanelSuspenseQueryHookResult = ReturnType<
  typeof useListActorsForPanelSuspenseQuery
>;
export type ListActorsForPanelQueryResult = Apollo.QueryResult<
  ListActorsForPanelQuery,
  ListActorsForPanelQueryVariables
>;
export const ListActorsForSelectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListActorsForSelect' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listActors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListActorsForSelectQuery__
 *
 * To run a query within a React component, call `useListActorsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActorsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActorsForSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useListActorsForSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListActorsForSelectQuery,
    ListActorsForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListActorsForSelectQuery, ListActorsForSelectQueryVariables>(
    ListActorsForSelectDocument,
    options,
  );
}
export function useListActorsForSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActorsForSelectQuery,
    ListActorsForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListActorsForSelectQuery, ListActorsForSelectQueryVariables>(
    ListActorsForSelectDocument,
    options,
  );
}
// @ts-ignore
export function useListActorsForSelectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActorsForSelectQuery,
    ListActorsForSelectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListActorsForSelectQuery, ListActorsForSelectQueryVariables>;
export function useListActorsForSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActorsForSelectQuery, ListActorsForSelectQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListActorsForSelectQuery | undefined,
  ListActorsForSelectQueryVariables
>;
export function useListActorsForSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListActorsForSelectQuery, ListActorsForSelectQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListActorsForSelectQuery, ListActorsForSelectQueryVariables>(
    ListActorsForSelectDocument,
    options,
  );
}
export type ListActorsForSelectQueryHookResult = ReturnType<typeof useListActorsForSelectQuery>;
export type ListActorsForSelectLazyQueryHookResult = ReturnType<
  typeof useListActorsForSelectLazyQuery
>;
export type ListActorsForSelectSuspenseQueryHookResult = ReturnType<
  typeof useListActorsForSelectSuspenseQuery
>;
export type ListActorsForSelectQueryResult = Apollo.QueryResult<
  ListActorsForSelectQuery,
  ListActorsForSelectQueryVariables
>;
export const ListTeamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTeams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listTeams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeamFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Team' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentTeamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'teamLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deputyLeadId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'budgetAllocated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stakeholderIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTeamsQuery__
 *
 * To run a query within a React component, call `useListTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
}
export function useListTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
}
// @ts-ignore
export function useListTeamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTeamsQuery, ListTeamsQueryVariables>;
export function useListTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTeamsQuery | undefined, ListTeamsQueryVariables>;
export function useListTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTeamsQuery, ListTeamsQueryVariables>(
    ListTeamsDocument,
    options,
  );
}
export type ListTeamsQueryHookResult = ReturnType<typeof useListTeamsQuery>;
export type ListTeamsLazyQueryHookResult = ReturnType<typeof useListTeamsLazyQuery>;
export type ListTeamsSuspenseQueryHookResult = ReturnType<typeof useListTeamsSuspenseQuery>;
export type ListTeamsQueryResult = Apollo.QueryResult<ListTeamsQuery, ListTeamsQueryVariables>;
export const MySubjectActorIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MySubjectActorIds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'mySubjectActorIds' } }],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMySubjectActorIdsQuery__
 *
 * To run a query within a React component, call `useMySubjectActorIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubjectActorIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubjectActorIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySubjectActorIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<MySubjectActorIdsQuery, MySubjectActorIdsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MySubjectActorIdsQuery, MySubjectActorIdsQueryVariables>(
    MySubjectActorIdsDocument,
    options,
  );
}
export function useMySubjectActorIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MySubjectActorIdsQuery,
    MySubjectActorIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MySubjectActorIdsQuery, MySubjectActorIdsQueryVariables>(
    MySubjectActorIdsDocument,
    options,
  );
}
// @ts-ignore
export function useMySubjectActorIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MySubjectActorIdsQuery,
    MySubjectActorIdsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MySubjectActorIdsQuery, MySubjectActorIdsQueryVariables>;
export function useMySubjectActorIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MySubjectActorIdsQuery, MySubjectActorIdsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MySubjectActorIdsQuery | undefined,
  MySubjectActorIdsQueryVariables
>;
export function useMySubjectActorIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MySubjectActorIdsQuery, MySubjectActorIdsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MySubjectActorIdsQuery, MySubjectActorIdsQueryVariables>(
    MySubjectActorIdsDocument,
    options,
  );
}
export type MySubjectActorIdsQueryHookResult = ReturnType<typeof useMySubjectActorIdsQuery>;
export type MySubjectActorIdsLazyQueryHookResult = ReturnType<typeof useMySubjectActorIdsLazyQuery>;
export type MySubjectActorIdsSuspenseQueryHookResult = ReturnType<
  typeof useMySubjectActorIdsSuspenseQuery
>;
export type MySubjectActorIdsQueryResult = Apollo.QueryResult<
  MySubjectActorIdsQuery,
  MySubjectActorIdsQueryVariables
>;
export const SearchActorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchActors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchActors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorGlobalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'available' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryRoleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'teamId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supervisorId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchActorsQuery__
 *
 * To run a query within a React component, call `useSearchActorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchActorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchActorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchActorsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchActorsQuery, SearchActorsQueryVariables> &
    ({ variables: SearchActorsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchActorsQuery, SearchActorsQueryVariables>(
    SearchActorsDocument,
    options,
  );
}
export function useSearchActorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchActorsQuery, SearchActorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchActorsQuery, SearchActorsQueryVariables>(
    SearchActorsDocument,
    options,
  );
}
// @ts-ignore
export function useSearchActorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchActorsQuery, SearchActorsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchActorsQuery, SearchActorsQueryVariables>;
export function useSearchActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchActorsQuery, SearchActorsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchActorsQuery | undefined, SearchActorsQueryVariables>;
export function useSearchActorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchActorsQuery, SearchActorsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchActorsQuery, SearchActorsQueryVariables>(
    SearchActorsDocument,
    options,
  );
}
export type SearchActorsQueryHookResult = ReturnType<typeof useSearchActorsQuery>;
export type SearchActorsLazyQueryHookResult = ReturnType<typeof useSearchActorsLazyQuery>;
export type SearchActorsSuspenseQueryHookResult = ReturnType<typeof useSearchActorsSuspenseQuery>;
export type SearchActorsQueryResult = Apollo.QueryResult<
  SearchActorsQuery,
  SearchActorsQueryVariables
>;
export const GetRolePermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRolePermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRolePermissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EffectivePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ownPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inheritedPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'effectivePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRolePermissionsQuery__
 *
 * To run a query within a React component, call `useGetRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolePermissionsQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetRolePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetRolePermissionsQuery, GetRolePermissionsQueryVariables> &
    ({ variables: GetRolePermissionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolePermissionsQuery, GetRolePermissionsQueryVariables>(
    GetRolePermissionsDocument,
    options,
  );
}
export function useGetRolePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRolePermissionsQuery,
    GetRolePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolePermissionsQuery, GetRolePermissionsQueryVariables>(
    GetRolePermissionsDocument,
    options,
  );
}
// @ts-ignore
export function useGetRolePermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRolePermissionsQuery,
    GetRolePermissionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetRolePermissionsQuery, GetRolePermissionsQueryVariables>;
export function useGetRolePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRolePermissionsQuery, GetRolePermissionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetRolePermissionsQuery | undefined,
  GetRolePermissionsQueryVariables
>;
export function useGetRolePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRolePermissionsQuery, GetRolePermissionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRolePermissionsQuery, GetRolePermissionsQueryVariables>(
    GetRolePermissionsDocument,
    options,
  );
}
export type GetRolePermissionsQueryHookResult = ReturnType<typeof useGetRolePermissionsQuery>;
export type GetRolePermissionsLazyQueryHookResult = ReturnType<
  typeof useGetRolePermissionsLazyQuery
>;
export type GetRolePermissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetRolePermissionsSuspenseQuery
>;
export type GetRolePermissionsQueryResult = Apollo.QueryResult<
  GetRolePermissionsQuery,
  GetRolePermissionsQueryVariables
>;
export const ListRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listRoles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Role' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'permissionMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListRolesQuery__
 *
 * To run a query within a React component, call `useListRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRolesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListRolesQuery, ListRolesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListRolesQuery, ListRolesQueryVariables>(ListRolesDocument, options);
}
export function useListRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListRolesQuery, ListRolesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListRolesQuery, ListRolesQueryVariables>(ListRolesDocument, options);
}
// @ts-ignore
export function useListRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListRolesQuery, ListRolesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListRolesQuery, ListRolesQueryVariables>;
export function useListRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRolesQuery, ListRolesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListRolesQuery | undefined, ListRolesQueryVariables>;
export function useListRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRolesQuery, ListRolesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListRolesQuery, ListRolesQueryVariables>(
    ListRolesDocument,
    options,
  );
}
export type ListRolesQueryHookResult = ReturnType<typeof useListRolesQuery>;
export type ListRolesLazyQueryHookResult = ReturnType<typeof useListRolesLazyQuery>;
export type ListRolesSuspenseQueryHookResult = ReturnType<typeof useListRolesSuspenseQuery>;
export type ListRolesQueryResult = Apollo.QueryResult<ListRolesQuery, ListRolesQueryVariables>;
export const GetNavigationSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNavigationSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'layer' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ViewLayer' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'layer' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'layer' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'urgentCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetNavigationSummaryQuery__
 *
 * To run a query within a React component, call `useGetNavigationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationSummaryQuery({
 *   variables: {
 *      layer: // value for 'layer'
 *   },
 * });
 */
export function useGetNavigationSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNavigationSummaryQuery,
    GetNavigationSummaryQueryVariables
  > &
    ({ variables: GetNavigationSummaryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNavigationSummaryQuery, GetNavigationSummaryQueryVariables>(
    GetNavigationSummaryDocument,
    options,
  );
}
export function useGetNavigationSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNavigationSummaryQuery,
    GetNavigationSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNavigationSummaryQuery, GetNavigationSummaryQueryVariables>(
    GetNavigationSummaryDocument,
    options,
  );
}
// @ts-ignore
export function useGetNavigationSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNavigationSummaryQuery,
    GetNavigationSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetNavigationSummaryQuery, GetNavigationSummaryQueryVariables>;
export function useGetNavigationSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNavigationSummaryQuery,
        GetNavigationSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetNavigationSummaryQuery | undefined,
  GetNavigationSummaryQueryVariables
>;
export function useGetNavigationSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNavigationSummaryQuery,
        GetNavigationSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNavigationSummaryQuery, GetNavigationSummaryQueryVariables>(
    GetNavigationSummaryDocument,
    options,
  );
}
export type GetNavigationSummaryQueryHookResult = ReturnType<typeof useGetNavigationSummaryQuery>;
export type GetNavigationSummaryLazyQueryHookResult = ReturnType<
  typeof useGetNavigationSummaryLazyQuery
>;
export type GetNavigationSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetNavigationSummarySuspenseQuery
>;
export type GetNavigationSummaryQueryResult = Apollo.QueryResult<
  GetNavigationSummaryQuery,
  GetNavigationSummaryQueryVariables
>;
export const GetSettingBundleAdminDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSettingBundleAdmin' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settingBundle' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'codeSystem' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vertical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industryLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeLenses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'regulatoryFrameworks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'definition' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'navigationGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'memberPatterns' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'memberItemScopes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isStandalone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredScopes' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSettingBundleAdminQuery__
 *
 * To run a query within a React component, call `useGetSettingBundleAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingBundleAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingBundleAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingBundleAdminQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSettingBundleAdminQuery,
    GetSettingBundleAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSettingBundleAdminQuery, GetSettingBundleAdminQueryVariables>(
    GetSettingBundleAdminDocument,
    options,
  );
}
export function useGetSettingBundleAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSettingBundleAdminQuery,
    GetSettingBundleAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSettingBundleAdminQuery, GetSettingBundleAdminQueryVariables>(
    GetSettingBundleAdminDocument,
    options,
  );
}
// @ts-ignore
export function useGetSettingBundleAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSettingBundleAdminQuery,
    GetSettingBundleAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSettingBundleAdminQuery, GetSettingBundleAdminQueryVariables>;
export function useGetSettingBundleAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSettingBundleAdminQuery,
        GetSettingBundleAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSettingBundleAdminQuery | undefined,
  GetSettingBundleAdminQueryVariables
>;
export function useGetSettingBundleAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSettingBundleAdminQuery,
        GetSettingBundleAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSettingBundleAdminQuery, GetSettingBundleAdminQueryVariables>(
    GetSettingBundleAdminDocument,
    options,
  );
}
export type GetSettingBundleAdminQueryHookResult = ReturnType<typeof useGetSettingBundleAdminQuery>;
export type GetSettingBundleAdminLazyQueryHookResult = ReturnType<
  typeof useGetSettingBundleAdminLazyQuery
>;
export type GetSettingBundleAdminSuspenseQueryHookResult = ReturnType<
  typeof useGetSettingBundleAdminSuspenseQuery
>;
export type GetSettingBundleAdminQueryResult = Apollo.QueryResult<
  GetSettingBundleAdminQuery,
  GetSettingBundleAdminQueryVariables
>;
export const GetSettingNavigationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSettingNavigation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settingBundle' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirLabels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorTypeLabels' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'navigationGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'memberPatterns' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'memberItemScopes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionLabelTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isStandalone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredScopes' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contextBanner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alwaysVisible' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxGroups' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pollIntervalSeconds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userMenuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredScopes' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSettingNavigationQuery__
 *
 * To run a query within a React component, call `useGetSettingNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingNavigationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingNavigationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSettingNavigationQuery,
    GetSettingNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSettingNavigationQuery, GetSettingNavigationQueryVariables>(
    GetSettingNavigationDocument,
    options,
  );
}
export function useGetSettingNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSettingNavigationQuery,
    GetSettingNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSettingNavigationQuery, GetSettingNavigationQueryVariables>(
    GetSettingNavigationDocument,
    options,
  );
}
// @ts-ignore
export function useGetSettingNavigationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSettingNavigationQuery,
    GetSettingNavigationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSettingNavigationQuery, GetSettingNavigationQueryVariables>;
export function useGetSettingNavigationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSettingNavigationQuery,
        GetSettingNavigationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSettingNavigationQuery | undefined,
  GetSettingNavigationQueryVariables
>;
export function useGetSettingNavigationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSettingNavigationQuery,
        GetSettingNavigationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSettingNavigationQuery, GetSettingNavigationQueryVariables>(
    GetSettingNavigationDocument,
    options,
  );
}
export type GetSettingNavigationQueryHookResult = ReturnType<typeof useGetSettingNavigationQuery>;
export type GetSettingNavigationLazyQueryHookResult = ReturnType<
  typeof useGetSettingNavigationLazyQuery
>;
export type GetSettingNavigationSuspenseQueryHookResult = ReturnType<
  typeof useGetSettingNavigationSuspenseQuery
>;
export type GetSettingNavigationQueryResult = Apollo.QueryResult<
  GetSettingNavigationQuery,
  GetSettingNavigationQueryVariables
>;
export const GetNotificationStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNotificationStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNotificationStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sentCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextNotificationDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetNotificationStatsQuery__
 *
 * To run a query within a React component, call `useGetNotificationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationStatsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetNotificationStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNotificationStatsQuery,
    GetNotificationStatsQueryVariables
  > &
    ({ variables: GetNotificationStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationStatsQuery, GetNotificationStatsQueryVariables>(
    GetNotificationStatsDocument,
    options,
  );
}
export function useGetNotificationStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationStatsQuery,
    GetNotificationStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNotificationStatsQuery, GetNotificationStatsQueryVariables>(
    GetNotificationStatsDocument,
    options,
  );
}
// @ts-ignore
export function useGetNotificationStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNotificationStatsQuery,
    GetNotificationStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetNotificationStatsQuery, GetNotificationStatsQueryVariables>;
export function useGetNotificationStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationStatsQuery,
        GetNotificationStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetNotificationStatsQuery | undefined,
  GetNotificationStatsQueryVariables
>;
export function useGetNotificationStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNotificationStatsQuery,
        GetNotificationStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNotificationStatsQuery, GetNotificationStatsQueryVariables>(
    GetNotificationStatsDocument,
    options,
  );
}
export type GetNotificationStatsQueryHookResult = ReturnType<typeof useGetNotificationStatsQuery>;
export type GetNotificationStatsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationStatsLazyQuery
>;
export type GetNotificationStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetNotificationStatsSuspenseQuery
>;
export type GetNotificationStatsQueryResult = Apollo.QueryResult<
  GetNotificationStatsQuery,
  GetNotificationStatsQueryVariables
>;
export const GetNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetNotificationsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNotifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pk' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables> &
    ({ variables: GetNotificationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    options,
  );
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    options,
  );
}
// @ts-ignore
export function useGetNotificationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    options,
  );
}
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<
  typeof useGetNotificationsSuspenseQuery
>;
export type GetNotificationsQueryResult = Apollo.QueryResult<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>;
export const GetPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'policyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'policyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'policyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PolicyFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PolicyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Policy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'implementation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPolicyQuery__
 *
 * To run a query within a React component, call `useGetPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables> &
    ({ variables: GetPolicyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument, options);
}
export function useGetPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument, options);
}
// @ts-ignore
export function useGetPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPolicyQuery, GetPolicyQueryVariables>;
export function useGetPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPolicyQuery | undefined, GetPolicyQueryVariables>;
export function useGetPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPolicyQuery, GetPolicyQueryVariables>(
    GetPolicyDocument,
    options,
  );
}
export type GetPolicyQueryHookResult = ReturnType<typeof useGetPolicyQuery>;
export type GetPolicyLazyQueryHookResult = ReturnType<typeof useGetPolicyLazyQuery>;
export type GetPolicySuspenseQueryHookResult = ReturnType<typeof useGetPolicySuspenseQuery>;
export type GetPolicyQueryResult = Apollo.QueryResult<GetPolicyQuery, GetPolicyQueryVariables>;
export const GetRegulatoryRuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegulatoryRule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ruleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulatoryRule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ruleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ruleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegulatoryRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegulatoryRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRegulatoryRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structured' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fhirResource' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exceptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alternativeAction' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'source' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivision' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paragraph' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidencePercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piiImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changelog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresHumanReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewComment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegulatoryRuleQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryRuleQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useGetRegulatoryRuleQuery(
  baseOptions: Apollo.QueryHookOptions<GetRegulatoryRuleQuery, GetRegulatoryRuleQueryVariables> &
    ({ variables: GetRegulatoryRuleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegulatoryRuleQuery, GetRegulatoryRuleQueryVariables>(
    GetRegulatoryRuleDocument,
    options,
  );
}
export function useGetRegulatoryRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRegulatoryRuleQuery,
    GetRegulatoryRuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegulatoryRuleQuery, GetRegulatoryRuleQueryVariables>(
    GetRegulatoryRuleDocument,
    options,
  );
}
// @ts-ignore
export function useGetRegulatoryRuleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRegulatoryRuleQuery,
    GetRegulatoryRuleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetRegulatoryRuleQuery, GetRegulatoryRuleQueryVariables>;
export function useGetRegulatoryRuleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRegulatoryRuleQuery, GetRegulatoryRuleQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetRegulatoryRuleQuery | undefined,
  GetRegulatoryRuleQueryVariables
>;
export function useGetRegulatoryRuleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRegulatoryRuleQuery, GetRegulatoryRuleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRegulatoryRuleQuery, GetRegulatoryRuleQueryVariables>(
    GetRegulatoryRuleDocument,
    options,
  );
}
export type GetRegulatoryRuleQueryHookResult = ReturnType<typeof useGetRegulatoryRuleQuery>;
export type GetRegulatoryRuleLazyQueryHookResult = ReturnType<typeof useGetRegulatoryRuleLazyQuery>;
export type GetRegulatoryRuleSuspenseQueryHookResult = ReturnType<
  typeof useGetRegulatoryRuleSuspenseQuery
>;
export type GetRegulatoryRuleQueryResult = Apollo.QueryResult<
  GetRegulatoryRuleQuery,
  GetRegulatoryRuleQueryVariables
>;
export const GetRuleSetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRuleSet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ruleSet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliesToIndustries' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dependsOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affectsWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affectsFormSchemas' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceLegislation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sections' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regnodeRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAmended' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'memberRules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'evidenceStatus' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'overridePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conflictResolution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentation' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRuleSetQuery__
 *
 * To run a query within a React component, call `useGetRuleSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuleSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuleSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRuleSetQuery(
  baseOptions: Apollo.QueryHookOptions<GetRuleSetQuery, GetRuleSetQueryVariables> &
    ({ variables: GetRuleSetQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRuleSetQuery, GetRuleSetQueryVariables>(GetRuleSetDocument, options);
}
export function useGetRuleSetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRuleSetQuery, GetRuleSetQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRuleSetQuery, GetRuleSetQueryVariables>(
    GetRuleSetDocument,
    options,
  );
}
// @ts-ignore
export function useGetRuleSetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetRuleSetQuery, GetRuleSetQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetRuleSetQuery, GetRuleSetQueryVariables>;
export function useGetRuleSetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRuleSetQuery, GetRuleSetQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetRuleSetQuery | undefined, GetRuleSetQueryVariables>;
export function useGetRuleSetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRuleSetQuery, GetRuleSetQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRuleSetQuery, GetRuleSetQueryVariables>(
    GetRuleSetDocument,
    options,
  );
}
export type GetRuleSetQueryHookResult = ReturnType<typeof useGetRuleSetQuery>;
export type GetRuleSetLazyQueryHookResult = ReturnType<typeof useGetRuleSetLazyQuery>;
export type GetRuleSetSuspenseQueryHookResult = ReturnType<typeof useGetRuleSetSuspenseQuery>;
export type GetRuleSetQueryResult = Apollo.QueryResult<GetRuleSetQuery, GetRuleSetQueryVariables>;
export const ListRegulatoryRulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListRegulatoryRules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RuleFilterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulatoryRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegulatoryRuleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegulatoryRuleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRegulatoryRule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structured' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trigger' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fhirResource' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exceptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alternativeAction' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'source' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'document' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subdivision' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paragraph' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'extraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidencePercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extractedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piiImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changelog' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresHumanReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewComment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListRegulatoryRulesQuery__
 *
 * To run a query within a React component, call `useListRegulatoryRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegulatoryRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegulatoryRulesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListRegulatoryRulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListRegulatoryRulesQuery,
    ListRegulatoryRulesQueryVariables
  > &
    ({ variables: ListRegulatoryRulesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListRegulatoryRulesQuery, ListRegulatoryRulesQueryVariables>(
    ListRegulatoryRulesDocument,
    options,
  );
}
export function useListRegulatoryRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListRegulatoryRulesQuery,
    ListRegulatoryRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListRegulatoryRulesQuery, ListRegulatoryRulesQueryVariables>(
    ListRegulatoryRulesDocument,
    options,
  );
}
// @ts-ignore
export function useListRegulatoryRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListRegulatoryRulesQuery,
    ListRegulatoryRulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListRegulatoryRulesQuery, ListRegulatoryRulesQueryVariables>;
export function useListRegulatoryRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRegulatoryRulesQuery, ListRegulatoryRulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListRegulatoryRulesQuery | undefined,
  ListRegulatoryRulesQueryVariables
>;
export function useListRegulatoryRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRegulatoryRulesQuery, ListRegulatoryRulesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListRegulatoryRulesQuery, ListRegulatoryRulesQueryVariables>(
    ListRegulatoryRulesDocument,
    options,
  );
}
export type ListRegulatoryRulesQueryHookResult = ReturnType<typeof useListRegulatoryRulesQuery>;
export type ListRegulatoryRulesLazyQueryHookResult = ReturnType<
  typeof useListRegulatoryRulesLazyQuery
>;
export type ListRegulatoryRulesSuspenseQueryHookResult = ReturnType<
  typeof useListRegulatoryRulesSuspenseQuery
>;
export type ListRegulatoryRulesQueryResult = Apollo.QueryResult<
  ListRegulatoryRulesQuery,
  ListRegulatoryRulesQueryVariables
>;
export const ListRuleSetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListRuleSets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jurisdiction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'industry' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'effectiveOnly' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: true },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ruleSets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jurisdiction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jurisdiction' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'industry' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'industry' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'effectiveOnly' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'effectiveOnly' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliesToIndustries' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sunsetDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentlyEffective' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supersedes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supersededBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dependsOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affectsWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'affectsFormSchemas' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceLegislation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'statute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sections' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regnodeRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastAmended' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'memberRules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'evidenceStatus' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'overridePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'direction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conflictResolution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentation' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListRuleSetsQuery__
 *
 * To run a query within a React component, call `useListRuleSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRuleSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRuleSetsQuery({
 *   variables: {
 *      jurisdiction: // value for 'jurisdiction'
 *      industry: // value for 'industry'
 *      effectiveOnly: // value for 'effectiveOnly'
 *   },
 * });
 */
export function useListRuleSetsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListRuleSetsQuery, ListRuleSetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListRuleSetsQuery, ListRuleSetsQueryVariables>(
    ListRuleSetsDocument,
    options,
  );
}
export function useListRuleSetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListRuleSetsQuery, ListRuleSetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListRuleSetsQuery, ListRuleSetsQueryVariables>(
    ListRuleSetsDocument,
    options,
  );
}
// @ts-ignore
export function useListRuleSetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListRuleSetsQuery, ListRuleSetsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListRuleSetsQuery, ListRuleSetsQueryVariables>;
export function useListRuleSetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRuleSetsQuery, ListRuleSetsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListRuleSetsQuery | undefined, ListRuleSetsQueryVariables>;
export function useListRuleSetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRuleSetsQuery, ListRuleSetsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListRuleSetsQuery, ListRuleSetsQueryVariables>(
    ListRuleSetsDocument,
    options,
  );
}
export type ListRuleSetsQueryHookResult = ReturnType<typeof useListRuleSetsQuery>;
export type ListRuleSetsLazyQueryHookResult = ReturnType<typeof useListRuleSetsLazyQuery>;
export type ListRuleSetsSuspenseQueryHookResult = ReturnType<typeof useListRuleSetsSuspenseQuery>;
export type ListRuleSetsQueryResult = Apollo.QueryResult<
  ListRuleSetsQuery,
  ListRuleSetsQueryVariables
>;
export const ListRulesetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListRulesets' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ruleSets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListRulesetsQuery__
 *
 * To run a query within a React component, call `useListRulesetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRulesetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRulesetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRulesetsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListRulesetsQuery, ListRulesetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListRulesetsQuery, ListRulesetsQueryVariables>(
    ListRulesetsDocument,
    options,
  );
}
export function useListRulesetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListRulesetsQuery, ListRulesetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListRulesetsQuery, ListRulesetsQueryVariables>(
    ListRulesetsDocument,
    options,
  );
}
// @ts-ignore
export function useListRulesetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListRulesetsQuery, ListRulesetsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListRulesetsQuery, ListRulesetsQueryVariables>;
export function useListRulesetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRulesetsQuery, ListRulesetsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListRulesetsQuery | undefined, ListRulesetsQueryVariables>;
export function useListRulesetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListRulesetsQuery, ListRulesetsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListRulesetsQuery, ListRulesetsQueryVariables>(
    ListRulesetsDocument,
    options,
  );
}
export type ListRulesetsQueryHookResult = ReturnType<typeof useListRulesetsQuery>;
export type ListRulesetsLazyQueryHookResult = ReturnType<typeof useListRulesetsLazyQuery>;
export type ListRulesetsSuspenseQueryHookResult = ReturnType<typeof useListRulesetsSuspenseQuery>;
export type ListRulesetsQueryResult = Apollo.QueryResult<
  ListRulesetsQuery,
  ListRulesetsQueryVariables
>;
export const PreviewRuleRoutingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PreviewRuleRouting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'yamlContent' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewRuleRouting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'yamlContent' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'yamlContent' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RuleImportResultFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RuleImportResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlRuleImportResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routeDecision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'queue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyOverride' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictsDetected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'conflictingRuleIds' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePreviewRuleRoutingQuery__
 *
 * To run a query within a React component, call `usePreviewRuleRoutingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewRuleRoutingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewRuleRoutingQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      yamlContent: // value for 'yamlContent'
 *   },
 * });
 */
export function usePreviewRuleRoutingQuery(
  baseOptions: Apollo.QueryHookOptions<PreviewRuleRoutingQuery, PreviewRuleRoutingQueryVariables> &
    ({ variables: PreviewRuleRoutingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PreviewRuleRoutingQuery, PreviewRuleRoutingQueryVariables>(
    PreviewRuleRoutingDocument,
    options,
  );
}
export function usePreviewRuleRoutingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PreviewRuleRoutingQuery,
    PreviewRuleRoutingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PreviewRuleRoutingQuery, PreviewRuleRoutingQueryVariables>(
    PreviewRuleRoutingDocument,
    options,
  );
}
// @ts-ignore
export function usePreviewRuleRoutingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PreviewRuleRoutingQuery,
    PreviewRuleRoutingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PreviewRuleRoutingQuery, PreviewRuleRoutingQueryVariables>;
export function usePreviewRuleRoutingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PreviewRuleRoutingQuery, PreviewRuleRoutingQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PreviewRuleRoutingQuery | undefined,
  PreviewRuleRoutingQueryVariables
>;
export function usePreviewRuleRoutingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PreviewRuleRoutingQuery, PreviewRuleRoutingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PreviewRuleRoutingQuery, PreviewRuleRoutingQueryVariables>(
    PreviewRuleRoutingDocument,
    options,
  );
}
export type PreviewRuleRoutingQueryHookResult = ReturnType<typeof usePreviewRuleRoutingQuery>;
export type PreviewRuleRoutingLazyQueryHookResult = ReturnType<
  typeof usePreviewRuleRoutingLazyQuery
>;
export type PreviewRuleRoutingSuspenseQueryHookResult = ReturnType<
  typeof usePreviewRuleRoutingSuspenseQuery
>;
export type PreviewRuleRoutingQueryResult = Apollo.QueryResult<
  PreviewRuleRoutingQuery,
  PreviewRuleRoutingQueryVariables
>;
export const GetConstellationDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConstellationDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constellationTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constellationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'center' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'primitiveType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ringId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ringNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'edgeTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shape' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appliesTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industries' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'centerLabel' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConstellationDetailQuery__
 *
 * To run a query within a React component, call `useGetConstellationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstellationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstellationDetailQuery({
 *   variables: {
 *      constellationId: // value for 'constellationId'
 *   },
 * });
 */
export function useGetConstellationDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConstellationDetailQuery,
    GetConstellationDetailQueryVariables
  > &
    ({ variables: GetConstellationDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConstellationDetailQuery, GetConstellationDetailQueryVariables>(
    GetConstellationDetailDocument,
    options,
  );
}
export function useGetConstellationDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConstellationDetailQuery,
    GetConstellationDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConstellationDetailQuery, GetConstellationDetailQueryVariables>(
    GetConstellationDetailDocument,
    options,
  );
}
// @ts-ignore
export function useGetConstellationDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConstellationDetailQuery,
    GetConstellationDetailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetConstellationDetailQuery, GetConstellationDetailQueryVariables>;
export function useGetConstellationDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConstellationDetailQuery,
        GetConstellationDetailQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetConstellationDetailQuery | undefined,
  GetConstellationDetailQueryVariables
>;
export function useGetConstellationDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConstellationDetailQuery,
        GetConstellationDetailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetConstellationDetailQuery, GetConstellationDetailQueryVariables>(
    GetConstellationDetailDocument,
    options,
  );
}
export type GetConstellationDetailQueryHookResult = ReturnType<
  typeof useGetConstellationDetailQuery
>;
export type GetConstellationDetailLazyQueryHookResult = ReturnType<
  typeof useGetConstellationDetailLazyQuery
>;
export type GetConstellationDetailSuspenseQueryHookResult = ReturnType<
  typeof useGetConstellationDetailSuspenseQuery
>;
export type GetConstellationDetailQueryResult = Apollo.QueryResult<
  GetConstellationDetailQuery,
  GetConstellationDetailQueryVariables
>;
export const GetConstellationTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConstellationTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constellationTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constellationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'center' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primitiveType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ringId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ringNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'definitionShows' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'edgeTypes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'definitionNodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'workflowRef' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'department' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ownerRole' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appliesTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industries' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'centerLabel' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'definition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'centerSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ringSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'symbolCase' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'instance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'centerSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ringSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'symbolCase' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConstellationTemplateQuery__
 *
 * To run a query within a React component, call `useGetConstellationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstellationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstellationTemplateQuery({
 *   variables: {
 *      constellationId: // value for 'constellationId'
 *   },
 * });
 */
export function useGetConstellationTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConstellationTemplateQuery,
    GetConstellationTemplateQueryVariables
  > &
    ({ variables: GetConstellationTemplateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConstellationTemplateQuery, GetConstellationTemplateQueryVariables>(
    GetConstellationTemplateDocument,
    options,
  );
}
export function useGetConstellationTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConstellationTemplateQuery,
    GetConstellationTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConstellationTemplateQuery, GetConstellationTemplateQueryVariables>(
    GetConstellationTemplateDocument,
    options,
  );
}
// @ts-ignore
export function useGetConstellationTemplateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConstellationTemplateQuery,
    GetConstellationTemplateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetConstellationTemplateQuery,
  GetConstellationTemplateQueryVariables
>;
export function useGetConstellationTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConstellationTemplateQuery,
        GetConstellationTemplateQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetConstellationTemplateQuery | undefined,
  GetConstellationTemplateQueryVariables
>;
export function useGetConstellationTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConstellationTemplateQuery,
        GetConstellationTemplateQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetConstellationTemplateQuery,
    GetConstellationTemplateQueryVariables
  >(GetConstellationTemplateDocument, options);
}
export type GetConstellationTemplateQueryHookResult = ReturnType<
  typeof useGetConstellationTemplateQuery
>;
export type GetConstellationTemplateLazyQueryHookResult = ReturnType<
  typeof useGetConstellationTemplateLazyQuery
>;
export type GetConstellationTemplateSuspenseQueryHookResult = ReturnType<
  typeof useGetConstellationTemplateSuspenseQuery
>;
export type GetConstellationTemplateQueryResult = Apollo.QueryResult<
  GetConstellationTemplateQuery,
  GetConstellationTemplateQueryVariables
>;
export const GetFieldConstellationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFieldConstellation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primitiveType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contextId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fieldConstellation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primitiveType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'primitiveType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contextId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contextId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primitiveType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ringId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ringNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shape' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enumValues' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'formulaRefs' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'piiClassification' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highlighted' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contextProfiles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contextId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verticals' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lensRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'promotedFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highlightRings' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalFieldCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promotedFieldCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeContextId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFieldConstellationQuery__
 *
 * To run a query within a React component, call `useGetFieldConstellationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldConstellationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldConstellationQuery({
 *   variables: {
 *      primitiveType: // value for 'primitiveType'
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useGetFieldConstellationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFieldConstellationQuery,
    GetFieldConstellationQueryVariables
  > &
    ({ variables: GetFieldConstellationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFieldConstellationQuery, GetFieldConstellationQueryVariables>(
    GetFieldConstellationDocument,
    options,
  );
}
export function useGetFieldConstellationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFieldConstellationQuery,
    GetFieldConstellationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFieldConstellationQuery, GetFieldConstellationQueryVariables>(
    GetFieldConstellationDocument,
    options,
  );
}
// @ts-ignore
export function useGetFieldConstellationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFieldConstellationQuery,
    GetFieldConstellationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetFieldConstellationQuery, GetFieldConstellationQueryVariables>;
export function useGetFieldConstellationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFieldConstellationQuery,
        GetFieldConstellationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFieldConstellationQuery | undefined,
  GetFieldConstellationQueryVariables
>;
export function useGetFieldConstellationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFieldConstellationQuery,
        GetFieldConstellationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFieldConstellationQuery, GetFieldConstellationQueryVariables>(
    GetFieldConstellationDocument,
    options,
  );
}
export type GetFieldConstellationQueryHookResult = ReturnType<typeof useGetFieldConstellationQuery>;
export type GetFieldConstellationLazyQueryHookResult = ReturnType<
  typeof useGetFieldConstellationLazyQuery
>;
export type GetFieldConstellationSuspenseQueryHookResult = ReturnType<
  typeof useGetFieldConstellationSuspenseQuery
>;
export type GetFieldConstellationQueryResult = Apollo.QueryResult<
  GetFieldConstellationQuery,
  GetFieldConstellationQueryVariables
>;
export const ListConstellationTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListConstellationTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scope' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constellationTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scope' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scope' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'center' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelTemplate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primitiveType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ringId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ringNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'definitionShows' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'edgeTypes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'definitionNodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'workflowRef' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'department' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ownerRole' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appliesTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industries' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'centerLabel' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'definition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'centerSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ringSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'symbolCase' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'instance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'centerSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ringSource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'symbolCase' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListConstellationTemplatesQuery__
 *
 * To run a query within a React component, call `useListConstellationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConstellationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConstellationTemplatesQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useListConstellationTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListConstellationTemplatesQuery,
    ListConstellationTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListConstellationTemplatesQuery, ListConstellationTemplatesQueryVariables>(
    ListConstellationTemplatesDocument,
    options,
  );
}
export function useListConstellationTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListConstellationTemplatesQuery,
    ListConstellationTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListConstellationTemplatesQuery,
    ListConstellationTemplatesQueryVariables
  >(ListConstellationTemplatesDocument, options);
}
// @ts-ignore
export function useListConstellationTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListConstellationTemplatesQuery,
    ListConstellationTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListConstellationTemplatesQuery,
  ListConstellationTemplatesQueryVariables
>;
export function useListConstellationTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListConstellationTemplatesQuery,
        ListConstellationTemplatesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListConstellationTemplatesQuery | undefined,
  ListConstellationTemplatesQueryVariables
>;
export function useListConstellationTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListConstellationTemplatesQuery,
        ListConstellationTemplatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListConstellationTemplatesQuery,
    ListConstellationTemplatesQueryVariables
  >(ListConstellationTemplatesDocument, options);
}
export type ListConstellationTemplatesQueryHookResult = ReturnType<
  typeof useListConstellationTemplatesQuery
>;
export type ListConstellationTemplatesLazyQueryHookResult = ReturnType<
  typeof useListConstellationTemplatesLazyQuery
>;
export type ListConstellationTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useListConstellationTemplatesSuspenseQuery
>;
export type ListConstellationTemplatesQueryResult = Apollo.QueryResult<
  ListConstellationTemplatesQuery,
  ListConstellationTemplatesQueryVariables
>;
export const GetTemplateVersionDiffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTemplateVersionDiff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromVersion' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toVersion' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTemplateVersionDiff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromVersion' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromVersion' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toVersion' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toVersion' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'changes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'changeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'oldValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newValue' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTemplateVersionDiffQuery__
 *
 * To run a query within a React component, call `useGetTemplateVersionDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateVersionDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateVersionDiffQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      fromVersion: // value for 'fromVersion'
 *      toVersion: // value for 'toVersion'
 *   },
 * });
 */
export function useGetTemplateVersionDiffQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTemplateVersionDiffQuery,
    GetTemplateVersionDiffQueryVariables
  > &
    ({ variables: GetTemplateVersionDiffQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTemplateVersionDiffQuery, GetTemplateVersionDiffQueryVariables>(
    GetTemplateVersionDiffDocument,
    options,
  );
}
export function useGetTemplateVersionDiffLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTemplateVersionDiffQuery,
    GetTemplateVersionDiffQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTemplateVersionDiffQuery, GetTemplateVersionDiffQueryVariables>(
    GetTemplateVersionDiffDocument,
    options,
  );
}
// @ts-ignore
export function useGetTemplateVersionDiffSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTemplateVersionDiffQuery,
    GetTemplateVersionDiffQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTemplateVersionDiffQuery, GetTemplateVersionDiffQueryVariables>;
export function useGetTemplateVersionDiffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTemplateVersionDiffQuery,
        GetTemplateVersionDiffQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTemplateVersionDiffQuery | undefined,
  GetTemplateVersionDiffQueryVariables
>;
export function useGetTemplateVersionDiffSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTemplateVersionDiffQuery,
        GetTemplateVersionDiffQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTemplateVersionDiffQuery, GetTemplateVersionDiffQueryVariables>(
    GetTemplateVersionDiffDocument,
    options,
  );
}
export type GetTemplateVersionDiffQueryHookResult = ReturnType<
  typeof useGetTemplateVersionDiffQuery
>;
export type GetTemplateVersionDiffLazyQueryHookResult = ReturnType<
  typeof useGetTemplateVersionDiffLazyQuery
>;
export type GetTemplateVersionDiffSuspenseQueryHookResult = ReturnType<
  typeof useGetTemplateVersionDiffSuspenseQuery
>;
export type GetTemplateVersionDiffQueryResult = Apollo.QueryResult<
  GetTemplateVersionDiffQuery,
  GetTemplateVersionDiffQueryVariables
>;
export const ListTemplateVersionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTemplateVersions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listTemplateVersions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'versionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changeDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'previousVersionId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTemplateVersionsQuery__
 *
 * To run a query within a React component, call `useListTemplateVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplateVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplateVersionsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useListTemplateVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTemplateVersionsQuery,
    ListTemplateVersionsQueryVariables
  > &
    ({ variables: ListTemplateVersionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTemplateVersionsQuery, ListTemplateVersionsQueryVariables>(
    ListTemplateVersionsDocument,
    options,
  );
}
export function useListTemplateVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTemplateVersionsQuery,
    ListTemplateVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTemplateVersionsQuery, ListTemplateVersionsQueryVariables>(
    ListTemplateVersionsDocument,
    options,
  );
}
// @ts-ignore
export function useListTemplateVersionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTemplateVersionsQuery,
    ListTemplateVersionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListTemplateVersionsQuery, ListTemplateVersionsQueryVariables>;
export function useListTemplateVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTemplateVersionsQuery,
        ListTemplateVersionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListTemplateVersionsQuery | undefined,
  ListTemplateVersionsQueryVariables
>;
export function useListTemplateVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTemplateVersionsQuery,
        ListTemplateVersionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTemplateVersionsQuery, ListTemplateVersionsQueryVariables>(
    ListTemplateVersionsDocument,
    options,
  );
}
export type ListTemplateVersionsQueryHookResult = ReturnType<typeof useListTemplateVersionsQuery>;
export type ListTemplateVersionsLazyQueryHookResult = ReturnType<
  typeof useListTemplateVersionsLazyQuery
>;
export type ListTemplateVersionsSuspenseQueryHookResult = ReturnType<
  typeof useListTemplateVersionsSuspenseQuery
>;
export type ListTemplateVersionsQueryResult = Apollo.QueryResult<
  ListTemplateVersionsQuery,
  ListTemplateVersionsQueryVariables
>;
export const ListTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '50' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'templateApiListTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TemplateFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TemplateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Template' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'riskClassification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTemplatesQuery__
 *
 * To run a query within a React component, call `useListTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTemplatesQuery, ListTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTemplatesQuery, ListTemplatesQueryVariables>(
    ListTemplatesDocument,
    options,
  );
}
export function useListTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTemplatesQuery, ListTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTemplatesQuery, ListTemplatesQueryVariables>(
    ListTemplatesDocument,
    options,
  );
}
// @ts-ignore
export function useListTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListTemplatesQuery, ListTemplatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTemplatesQuery, ListTemplatesQueryVariables>;
export function useListTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTemplatesQuery, ListTemplatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListTemplatesQuery | undefined, ListTemplatesQueryVariables>;
export function useListTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTemplatesQuery, ListTemplatesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTemplatesQuery, ListTemplatesQueryVariables>(
    ListTemplatesDocument,
    options,
  );
}
export type ListTemplatesQueryHookResult = ReturnType<typeof useListTemplatesQuery>;
export type ListTemplatesLazyQueryHookResult = ReturnType<typeof useListTemplatesLazyQuery>;
export type ListTemplatesSuspenseQueryHookResult = ReturnType<typeof useListTemplatesSuspenseQuery>;
export type ListTemplatesQueryResult = Apollo.QueryResult<
  ListTemplatesQuery,
  ListTemplatesQueryVariables
>;
export const RollbackTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RollbackTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RollbackTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rollbackTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newVersionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newVersionNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRollbackTemplateQuery__
 *
 * To run a query within a React component, call `useRollbackTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRollbackTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRollbackTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRollbackTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<RollbackTemplateQuery, RollbackTemplateQueryVariables> &
    ({ variables: RollbackTemplateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RollbackTemplateQuery, RollbackTemplateQueryVariables>(
    RollbackTemplateDocument,
    options,
  );
}
export function useRollbackTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RollbackTemplateQuery, RollbackTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RollbackTemplateQuery, RollbackTemplateQueryVariables>(
    RollbackTemplateDocument,
    options,
  );
}
// @ts-ignore
export function useRollbackTemplateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RollbackTemplateQuery,
    RollbackTemplateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RollbackTemplateQuery, RollbackTemplateQueryVariables>;
export function useRollbackTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RollbackTemplateQuery, RollbackTemplateQueryVariables>,
): Apollo.UseSuspenseQueryResult<RollbackTemplateQuery | undefined, RollbackTemplateQueryVariables>;
export function useRollbackTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RollbackTemplateQuery, RollbackTemplateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RollbackTemplateQuery, RollbackTemplateQueryVariables>(
    RollbackTemplateDocument,
    options,
  );
}
export type RollbackTemplateQueryHookResult = ReturnType<typeof useRollbackTemplateQuery>;
export type RollbackTemplateLazyQueryHookResult = ReturnType<typeof useRollbackTemplateLazyQuery>;
export type RollbackTemplateSuspenseQueryHookResult = ReturnType<
  typeof useRollbackTemplateSuspenseQuery
>;
export type RollbackTemplateQueryResult = Apollo.QueryResult<
  RollbackTemplateQuery,
  RollbackTemplateQueryVariables
>;
export const GetConstraintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConstraint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConstraint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConstraintFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConstraintFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Constraint' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'constraintType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monitoredEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monitoredEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentUsage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scopeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scopeId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConstraintQuery__
 *
 * To run a query within a React component, call `useGetConstraintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstraintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstraintQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetConstraintQuery(
  baseOptions: Apollo.QueryHookOptions<GetConstraintQuery, GetConstraintQueryVariables> &
    ({ variables: GetConstraintQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConstraintQuery, GetConstraintQueryVariables>(
    GetConstraintDocument,
    options,
  );
}
export function useGetConstraintLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetConstraintQuery, GetConstraintQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConstraintQuery, GetConstraintQueryVariables>(
    GetConstraintDocument,
    options,
  );
}
// @ts-ignore
export function useGetConstraintSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetConstraintQuery, GetConstraintQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetConstraintQuery, GetConstraintQueryVariables>;
export function useGetConstraintSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetConstraintQuery, GetConstraintQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetConstraintQuery | undefined, GetConstraintQueryVariables>;
export function useGetConstraintSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetConstraintQuery, GetConstraintQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetConstraintQuery, GetConstraintQueryVariables>(
    GetConstraintDocument,
    options,
  );
}
export type GetConstraintQueryHookResult = ReturnType<typeof useGetConstraintQuery>;
export type GetConstraintLazyQueryHookResult = ReturnType<typeof useGetConstraintLazyQuery>;
export type GetConstraintSuspenseQueryHookResult = ReturnType<typeof useGetConstraintSuspenseQuery>;
export type GetConstraintQueryResult = Apollo.QueryResult<
  GetConstraintQuery,
  GetConstraintQueryVariables
>;
export const ListConstraintsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListConstraints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listConstraints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConstraintFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConstraintFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Constraint' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'constraintType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monitoredEntityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monitoredEntityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentUsage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operator' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scopeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scopeId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListConstraintsQuery__
 *
 * To run a query within a React component, call `useListConstraintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConstraintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConstraintsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListConstraintsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListConstraintsQuery, ListConstraintsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListConstraintsQuery, ListConstraintsQueryVariables>(
    ListConstraintsDocument,
    options,
  );
}
export function useListConstraintsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListConstraintsQuery, ListConstraintsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListConstraintsQuery, ListConstraintsQueryVariables>(
    ListConstraintsDocument,
    options,
  );
}
// @ts-ignore
export function useListConstraintsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListConstraintsQuery,
    ListConstraintsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListConstraintsQuery, ListConstraintsQueryVariables>;
export function useListConstraintsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListConstraintsQuery, ListConstraintsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListConstraintsQuery | undefined, ListConstraintsQueryVariables>;
export function useListConstraintsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListConstraintsQuery, ListConstraintsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListConstraintsQuery, ListConstraintsQueryVariables>(
    ListConstraintsDocument,
    options,
  );
}
export type ListConstraintsQueryHookResult = ReturnType<typeof useListConstraintsQuery>;
export type ListConstraintsLazyQueryHookResult = ReturnType<typeof useListConstraintsLazyQuery>;
export type ListConstraintsSuspenseQueryHookResult = ReturnType<
  typeof useListConstraintsSuspenseQuery
>;
export type ListConstraintsQueryResult = Apollo.QueryResult<
  ListConstraintsQuery,
  ListConstraintsQueryVariables
>;
export const ListValidationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListValidations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listValidations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ValidationFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ValidationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Validation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'validationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBlocking' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'executionPhase' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListValidationsQuery__
 *
 * To run a query within a React component, call `useListValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListValidationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListValidationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListValidationsQuery, ListValidationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListValidationsQuery, ListValidationsQueryVariables>(
    ListValidationsDocument,
    options,
  );
}
export function useListValidationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListValidationsQuery, ListValidationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListValidationsQuery, ListValidationsQueryVariables>(
    ListValidationsDocument,
    options,
  );
}
// @ts-ignore
export function useListValidationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListValidationsQuery,
    ListValidationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListValidationsQuery, ListValidationsQueryVariables>;
export function useListValidationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListValidationsQuery, ListValidationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListValidationsQuery | undefined, ListValidationsQueryVariables>;
export function useListValidationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListValidationsQuery, ListValidationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListValidationsQuery, ListValidationsQueryVariables>(
    ListValidationsDocument,
    options,
  );
}
export type ListValidationsQueryHookResult = ReturnType<typeof useListValidationsQuery>;
export type ListValidationsLazyQueryHookResult = ReturnType<typeof useListValidationsLazyQuery>;
export type ListValidationsSuspenseQueryHookResult = ReturnType<
  typeof useListValidationsSuspenseQuery
>;
export type ListValidationsQueryResult = Apollo.QueryResult<
  ListValidationsQuery,
  ListValidationsQueryVariables
>;
export const GetCoverageGapsForProductDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoverageGapsForProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulatoryCoverageGaps' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rulesetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coveredRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coveragePercent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gaps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'missingConfigs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expectedTrigger' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCoverageGapsForProductQuery__
 *
 * To run a query within a React component, call `useGetCoverageGapsForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoverageGapsForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoverageGapsForProductQuery({
 *   variables: {
 *      rulesetId: // value for 'rulesetId'
 *   },
 * });
 */
export function useGetCoverageGapsForProductQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCoverageGapsForProductQuery,
    GetCoverageGapsForProductQueryVariables
  > &
    ({ variables: GetCoverageGapsForProductQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoverageGapsForProductQuery, GetCoverageGapsForProductQueryVariables>(
    GetCoverageGapsForProductDocument,
    options,
  );
}
export function useGetCoverageGapsForProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoverageGapsForProductQuery,
    GetCoverageGapsForProductQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCoverageGapsForProductQuery,
    GetCoverageGapsForProductQueryVariables
  >(GetCoverageGapsForProductDocument, options);
}
// @ts-ignore
export function useGetCoverageGapsForProductSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCoverageGapsForProductQuery,
    GetCoverageGapsForProductQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCoverageGapsForProductQuery,
  GetCoverageGapsForProductQueryVariables
>;
export function useGetCoverageGapsForProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCoverageGapsForProductQuery,
        GetCoverageGapsForProductQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCoverageGapsForProductQuery | undefined,
  GetCoverageGapsForProductQueryVariables
>;
export function useGetCoverageGapsForProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCoverageGapsForProductQuery,
        GetCoverageGapsForProductQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCoverageGapsForProductQuery,
    GetCoverageGapsForProductQueryVariables
  >(GetCoverageGapsForProductDocument, options);
}
export type GetCoverageGapsForProductQueryHookResult = ReturnType<
  typeof useGetCoverageGapsForProductQuery
>;
export type GetCoverageGapsForProductLazyQueryHookResult = ReturnType<
  typeof useGetCoverageGapsForProductLazyQuery
>;
export type GetCoverageGapsForProductSuspenseQueryHookResult = ReturnType<
  typeof useGetCoverageGapsForProductSuspenseQuery
>;
export type GetCoverageGapsForProductQueryResult = Apollo.QueryResult<
  GetCoverageGapsForProductQuery,
  GetCoverageGapsForProductQueryVariables
>;
export const GetProductDefinitionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProductDefinition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productDefinition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredRulesets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesSettings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesOverrides' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesConstellations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingLenses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetProductDefinitionQuery__
 *
 * To run a query within a React component, call `useGetProductDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductDefinitionQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductDefinitionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProductDefinitionQuery,
    GetProductDefinitionQueryVariables
  > &
    ({ variables: GetProductDefinitionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductDefinitionQuery, GetProductDefinitionQueryVariables>(
    GetProductDefinitionDocument,
    options,
  );
}
export function useGetProductDefinitionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductDefinitionQuery,
    GetProductDefinitionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductDefinitionQuery, GetProductDefinitionQueryVariables>(
    GetProductDefinitionDocument,
    options,
  );
}
// @ts-ignore
export function useGetProductDefinitionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductDefinitionQuery,
    GetProductDefinitionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetProductDefinitionQuery, GetProductDefinitionQueryVariables>;
export function useGetProductDefinitionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProductDefinitionQuery,
        GetProductDefinitionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetProductDefinitionQuery | undefined,
  GetProductDefinitionQueryVariables
>;
export function useGetProductDefinitionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProductDefinitionQuery,
        GetProductDefinitionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProductDefinitionQuery, GetProductDefinitionQueryVariables>(
    GetProductDefinitionDocument,
    options,
  );
}
export type GetProductDefinitionQueryHookResult = ReturnType<typeof useGetProductDefinitionQuery>;
export type GetProductDefinitionLazyQueryHookResult = ReturnType<
  typeof useGetProductDefinitionLazyQuery
>;
export type GetProductDefinitionSuspenseQueryHookResult = ReturnType<
  typeof useGetProductDefinitionSuspenseQuery
>;
export type GetProductDefinitionQueryResult = Apollo.QueryResult<
  GetProductDefinitionQuery,
  GetProductDefinitionQueryVariables
>;
export const ListProductDefinitionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListProductDefinitions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'industry' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jurisdiction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productDefinitions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'industry' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'industry' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jurisdiction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jurisdiction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredRulesets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesTaskGroups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesSettings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesOverrides' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatesConstellations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingLenses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provisioningStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListProductDefinitionsQuery__
 *
 * To run a query within a React component, call `useListProductDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductDefinitionsQuery({
 *   variables: {
 *      industry: // value for 'industry'
 *      jurisdiction: // value for 'jurisdiction'
 *   },
 * });
 */
export function useListProductDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProductDefinitionsQuery,
    ListProductDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListProductDefinitionsQuery, ListProductDefinitionsQueryVariables>(
    ListProductDefinitionsDocument,
    options,
  );
}
export function useListProductDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProductDefinitionsQuery,
    ListProductDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListProductDefinitionsQuery, ListProductDefinitionsQueryVariables>(
    ListProductDefinitionsDocument,
    options,
  );
}
// @ts-ignore
export function useListProductDefinitionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProductDefinitionsQuery,
    ListProductDefinitionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListProductDefinitionsQuery, ListProductDefinitionsQueryVariables>;
export function useListProductDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProductDefinitionsQuery,
        ListProductDefinitionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListProductDefinitionsQuery | undefined,
  ListProductDefinitionsQueryVariables
>;
export function useListProductDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProductDefinitionsQuery,
        ListProductDefinitionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListProductDefinitionsQuery, ListProductDefinitionsQueryVariables>(
    ListProductDefinitionsDocument,
    options,
  );
}
export type ListProductDefinitionsQueryHookResult = ReturnType<
  typeof useListProductDefinitionsQuery
>;
export type ListProductDefinitionsLazyQueryHookResult = ReturnType<
  typeof useListProductDefinitionsLazyQuery
>;
export type ListProductDefinitionsSuspenseQueryHookResult = ReturnType<
  typeof useListProductDefinitionsSuspenseQuery
>;
export type ListProductDefinitionsQueryResult = Apollo.QueryResult<
  ListProductDefinitionsQuery,
  ListProductDefinitionsQueryVariables
>;
export const ResolvedTerminologyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResolvedTerminology' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolvedTerminology' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'concept' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'definitionRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statuteRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalDefinition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acceptableAlternatives' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useResolvedTerminologyQuery__
 *
 * To run a query within a React component, call `useResolvedTerminologyQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolvedTerminologyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolvedTerminologyQuery({
 *   variables: {
 *   },
 * });
 */
export function useResolvedTerminologyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ResolvedTerminologyQuery,
    ResolvedTerminologyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResolvedTerminologyQuery, ResolvedTerminologyQueryVariables>(
    ResolvedTerminologyDocument,
    options,
  );
}
export function useResolvedTerminologyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResolvedTerminologyQuery,
    ResolvedTerminologyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ResolvedTerminologyQuery, ResolvedTerminologyQueryVariables>(
    ResolvedTerminologyDocument,
    options,
  );
}
// @ts-ignore
export function useResolvedTerminologySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResolvedTerminologyQuery,
    ResolvedTerminologyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ResolvedTerminologyQuery, ResolvedTerminologyQueryVariables>;
export function useResolvedTerminologySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolvedTerminologyQuery, ResolvedTerminologyQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ResolvedTerminologyQuery | undefined,
  ResolvedTerminologyQueryVariables
>;
export function useResolvedTerminologySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolvedTerminologyQuery, ResolvedTerminologyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ResolvedTerminologyQuery, ResolvedTerminologyQueryVariables>(
    ResolvedTerminologyDocument,
    options,
  );
}
export type ResolvedTerminologyQueryHookResult = ReturnType<typeof useResolvedTerminologyQuery>;
export type ResolvedTerminologyLazyQueryHookResult = ReturnType<
  typeof useResolvedTerminologyLazyQuery
>;
export type ResolvedTerminologySuspenseQueryHookResult = ReturnType<
  typeof useResolvedTerminologySuspenseQuery
>;
export type ResolvedTerminologyQueryResult = Apollo.QueryResult<
  ResolvedTerminologyQuery,
  ResolvedTerminologyQueryVariables
>;
export const ComplianceFilterDimensionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ComplianceFilterDimensions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'complianceFilterDimensions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dimensions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dimension' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renderAs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMultiSelect' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'values' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useComplianceFilterDimensionsQuery__
 *
 * To run a query within a React component, call `useComplianceFilterDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceFilterDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceFilterDimensionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useComplianceFilterDimensionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ComplianceFilterDimensionsQuery,
    ComplianceFilterDimensionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ComplianceFilterDimensionsQuery, ComplianceFilterDimensionsQueryVariables>(
    ComplianceFilterDimensionsDocument,
    options,
  );
}
export function useComplianceFilterDimensionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ComplianceFilterDimensionsQuery,
    ComplianceFilterDimensionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ComplianceFilterDimensionsQuery,
    ComplianceFilterDimensionsQueryVariables
  >(ComplianceFilterDimensionsDocument, options);
}
// @ts-ignore
export function useComplianceFilterDimensionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ComplianceFilterDimensionsQuery,
    ComplianceFilterDimensionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ComplianceFilterDimensionsQuery,
  ComplianceFilterDimensionsQueryVariables
>;
export function useComplianceFilterDimensionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ComplianceFilterDimensionsQuery,
        ComplianceFilterDimensionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ComplianceFilterDimensionsQuery | undefined,
  ComplianceFilterDimensionsQueryVariables
>;
export function useComplianceFilterDimensionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ComplianceFilterDimensionsQuery,
        ComplianceFilterDimensionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ComplianceFilterDimensionsQuery,
    ComplianceFilterDimensionsQueryVariables
  >(ComplianceFilterDimensionsDocument, options);
}
export type ComplianceFilterDimensionsQueryHookResult = ReturnType<
  typeof useComplianceFilterDimensionsQuery
>;
export type ComplianceFilterDimensionsLazyQueryHookResult = ReturnType<
  typeof useComplianceFilterDimensionsLazyQuery
>;
export type ComplianceFilterDimensionsSuspenseQueryHookResult = ReturnType<
  typeof useComplianceFilterDimensionsSuspenseQuery
>;
export type ComplianceFilterDimensionsQueryResult = Apollo.QueryResult<
  ComplianceFilterDimensionsQuery,
  ComplianceFilterDimensionsQueryVariables
>;
export const DimensionCodeTablesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DimensionCodeTables' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dimensionCodeTables' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'codes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDimensionCodeTablesQuery__
 *
 * To run a query within a React component, call `useDimensionCodeTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionCodeTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionCodeTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDimensionCodeTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DimensionCodeTablesQuery,
    DimensionCodeTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DimensionCodeTablesQuery, DimensionCodeTablesQueryVariables>(
    DimensionCodeTablesDocument,
    options,
  );
}
export function useDimensionCodeTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DimensionCodeTablesQuery,
    DimensionCodeTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DimensionCodeTablesQuery, DimensionCodeTablesQueryVariables>(
    DimensionCodeTablesDocument,
    options,
  );
}
// @ts-ignore
export function useDimensionCodeTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DimensionCodeTablesQuery,
    DimensionCodeTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DimensionCodeTablesQuery, DimensionCodeTablesQueryVariables>;
export function useDimensionCodeTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DimensionCodeTablesQuery, DimensionCodeTablesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  DimensionCodeTablesQuery | undefined,
  DimensionCodeTablesQueryVariables
>;
export function useDimensionCodeTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DimensionCodeTablesQuery, DimensionCodeTablesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DimensionCodeTablesQuery, DimensionCodeTablesQueryVariables>(
    DimensionCodeTablesDocument,
    options,
  );
}
export type DimensionCodeTablesQueryHookResult = ReturnType<typeof useDimensionCodeTablesQuery>;
export type DimensionCodeTablesLazyQueryHookResult = ReturnType<
  typeof useDimensionCodeTablesLazyQuery
>;
export type DimensionCodeTablesSuspenseQueryHookResult = ReturnType<
  typeof useDimensionCodeTablesSuspenseQuery
>;
export type DimensionCodeTablesQueryResult = Apollo.QueryResult<
  DimensionCodeTablesQuery,
  DimensionCodeTablesQueryVariables
>;
export const GetAvailableScopeDimensionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAvailableScopeDimensions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primitiveType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableScopeDimensions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primitiveType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'primitiveType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dimensionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedRenderer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availableRenderers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAvailableScopeDimensionsQuery__
 *
 * To run a query within a React component, call `useGetAvailableScopeDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableScopeDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableScopeDimensionsQuery({
 *   variables: {
 *      primitiveType: // value for 'primitiveType'
 *   },
 * });
 */
export function useGetAvailableScopeDimensionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableScopeDimensionsQuery,
    GetAvailableScopeDimensionsQueryVariables
  > &
    ({ variables: GetAvailableScopeDimensionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableScopeDimensionsQuery,
    GetAvailableScopeDimensionsQueryVariables
  >(GetAvailableScopeDimensionsDocument, options);
}
export function useGetAvailableScopeDimensionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableScopeDimensionsQuery,
    GetAvailableScopeDimensionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableScopeDimensionsQuery,
    GetAvailableScopeDimensionsQueryVariables
  >(GetAvailableScopeDimensionsDocument, options);
}
// @ts-ignore
export function useGetAvailableScopeDimensionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableScopeDimensionsQuery,
    GetAvailableScopeDimensionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAvailableScopeDimensionsQuery,
  GetAvailableScopeDimensionsQueryVariables
>;
export function useGetAvailableScopeDimensionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableScopeDimensionsQuery,
        GetAvailableScopeDimensionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAvailableScopeDimensionsQuery | undefined,
  GetAvailableScopeDimensionsQueryVariables
>;
export function useGetAvailableScopeDimensionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableScopeDimensionsQuery,
        GetAvailableScopeDimensionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailableScopeDimensionsQuery,
    GetAvailableScopeDimensionsQueryVariables
  >(GetAvailableScopeDimensionsDocument, options);
}
export type GetAvailableScopeDimensionsQueryHookResult = ReturnType<
  typeof useGetAvailableScopeDimensionsQuery
>;
export type GetAvailableScopeDimensionsLazyQueryHookResult = ReturnType<
  typeof useGetAvailableScopeDimensionsLazyQuery
>;
export type GetAvailableScopeDimensionsSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableScopeDimensionsSuspenseQuery
>;
export type GetAvailableScopeDimensionsQueryResult = Apollo.QueryResult<
  GetAvailableScopeDimensionsQuery,
  GetAvailableScopeDimensionsQueryVariables
>;
export const MyViewContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyViewContext' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'route' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myViewContext' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'route' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'route' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lens' } },
                { kind: 'Field', name: { kind: 'Name', value: 'terminology' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visiblePrimitives' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'navGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'routes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formOverrides' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'baseSchemaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'overrideType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scopeDimensions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renderer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workContext' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phase' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subjectName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrichmentKeys' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'constraints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dataTier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredScopes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authTier' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyViewContextQuery__
 *
 * To run a query within a React component, call `useMyViewContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyViewContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyViewContextQuery({
 *   variables: {
 *      route: // value for 'route'
 *   },
 * });
 */
export function useMyViewContextQuery(
  baseOptions: Apollo.QueryHookOptions<MyViewContextQuery, MyViewContextQueryVariables> &
    ({ variables: MyViewContextQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyViewContextQuery, MyViewContextQueryVariables>(
    MyViewContextDocument,
    options,
  );
}
export function useMyViewContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyViewContextQuery, MyViewContextQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyViewContextQuery, MyViewContextQueryVariables>(
    MyViewContextDocument,
    options,
  );
}
// @ts-ignore
export function useMyViewContextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyViewContextQuery, MyViewContextQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyViewContextQuery, MyViewContextQueryVariables>;
export function useMyViewContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyViewContextQuery, MyViewContextQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyViewContextQuery | undefined, MyViewContextQueryVariables>;
export function useMyViewContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyViewContextQuery, MyViewContextQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyViewContextQuery, MyViewContextQueryVariables>(
    MyViewContextDocument,
    options,
  );
}
export type MyViewContextQueryHookResult = ReturnType<typeof useMyViewContextQuery>;
export type MyViewContextLazyQueryHookResult = ReturnType<typeof useMyViewContextLazyQuery>;
export type MyViewContextSuspenseQueryHookResult = ReturnType<typeof useMyViewContextSuspenseQuery>;
export type MyViewContextQueryResult = Apollo.QueryResult<
  MyViewContextQuery,
  MyViewContextQueryVariables
>;
export const GetConstellationWithLensDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConstellationWithLens' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lensId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constellationWithLens' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constellationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constellationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lensId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lensId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'constellationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lensId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lensName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ringId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ringNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shape' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provisioning' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onboardingAction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'highlighted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deEmphasized' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expandSections' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modeDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instanceStatusFields' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checklist' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ring' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusField' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConstellationWithLensQuery__
 *
 * To run a query within a React component, call `useGetConstellationWithLensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstellationWithLensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstellationWithLensQuery({
 *   variables: {
 *      constellationId: // value for 'constellationId'
 *      lensId: // value for 'lensId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGetConstellationWithLensQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConstellationWithLensQuery,
    GetConstellationWithLensQueryVariables
  > &
    ({ variables: GetConstellationWithLensQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConstellationWithLensQuery, GetConstellationWithLensQueryVariables>(
    GetConstellationWithLensDocument,
    options,
  );
}
export function useGetConstellationWithLensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConstellationWithLensQuery,
    GetConstellationWithLensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConstellationWithLensQuery, GetConstellationWithLensQueryVariables>(
    GetConstellationWithLensDocument,
    options,
  );
}
// @ts-ignore
export function useGetConstellationWithLensSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConstellationWithLensQuery,
    GetConstellationWithLensQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetConstellationWithLensQuery,
  GetConstellationWithLensQueryVariables
>;
export function useGetConstellationWithLensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConstellationWithLensQuery,
        GetConstellationWithLensQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetConstellationWithLensQuery | undefined,
  GetConstellationWithLensQueryVariables
>;
export function useGetConstellationWithLensSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConstellationWithLensQuery,
        GetConstellationWithLensQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetConstellationWithLensQuery,
    GetConstellationWithLensQueryVariables
  >(GetConstellationWithLensDocument, options);
}
export type GetConstellationWithLensQueryHookResult = ReturnType<
  typeof useGetConstellationWithLensQuery
>;
export type GetConstellationWithLensLazyQueryHookResult = ReturnType<
  typeof useGetConstellationWithLensLazyQuery
>;
export type GetConstellationWithLensSuspenseQueryHookResult = ReturnType<
  typeof useGetConstellationWithLensSuspenseQuery
>;
export type GetConstellationWithLensQueryResult = Apollo.QueryResult<
  GetConstellationWithLensQuery,
  GetConstellationWithLensQueryVariables
>;
export const GetDimensionCodeTablesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDimensionCodeTables' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dimensionCodeTables' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'codes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDimensionCodeTablesQuery__
 *
 * To run a query within a React component, call `useGetDimensionCodeTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDimensionCodeTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDimensionCodeTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDimensionCodeTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDimensionCodeTablesQuery,
    GetDimensionCodeTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDimensionCodeTablesQuery, GetDimensionCodeTablesQueryVariables>(
    GetDimensionCodeTablesDocument,
    options,
  );
}
export function useGetDimensionCodeTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDimensionCodeTablesQuery,
    GetDimensionCodeTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDimensionCodeTablesQuery, GetDimensionCodeTablesQueryVariables>(
    GetDimensionCodeTablesDocument,
    options,
  );
}
// @ts-ignore
export function useGetDimensionCodeTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDimensionCodeTablesQuery,
    GetDimensionCodeTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetDimensionCodeTablesQuery, GetDimensionCodeTablesQueryVariables>;
export function useGetDimensionCodeTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDimensionCodeTablesQuery,
        GetDimensionCodeTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDimensionCodeTablesQuery | undefined,
  GetDimensionCodeTablesQueryVariables
>;
export function useGetDimensionCodeTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDimensionCodeTablesQuery,
        GetDimensionCodeTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDimensionCodeTablesQuery, GetDimensionCodeTablesQueryVariables>(
    GetDimensionCodeTablesDocument,
    options,
  );
}
export type GetDimensionCodeTablesQueryHookResult = ReturnType<
  typeof useGetDimensionCodeTablesQuery
>;
export type GetDimensionCodeTablesLazyQueryHookResult = ReturnType<
  typeof useGetDimensionCodeTablesLazyQuery
>;
export type GetDimensionCodeTablesSuspenseQueryHookResult = ReturnType<
  typeof useGetDimensionCodeTablesSuspenseQuery
>;
export type GetDimensionCodeTablesQueryResult = Apollo.QueryResult<
  GetDimensionCodeTablesQuery,
  GetDimensionCodeTablesQueryVariables
>;
export const ListLensTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListLensTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vertical' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'constellation' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lensTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vertical' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vertical' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'constellation' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'constellation' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lensId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phase' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verticals' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ruleCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliesToConstellation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingChecklist' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ring' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusField' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListLensTemplatesQuery__
 *
 * To run a query within a React component, call `useListLensTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLensTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLensTemplatesQuery({
 *   variables: {
 *      vertical: // value for 'vertical'
 *      constellation: // value for 'constellation'
 *   },
 * });
 */
export function useListLensTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListLensTemplatesQuery, ListLensTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListLensTemplatesQuery, ListLensTemplatesQueryVariables>(
    ListLensTemplatesDocument,
    options,
  );
}
export function useListLensTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListLensTemplatesQuery,
    ListLensTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListLensTemplatesQuery, ListLensTemplatesQueryVariables>(
    ListLensTemplatesDocument,
    options,
  );
}
// @ts-ignore
export function useListLensTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListLensTemplatesQuery,
    ListLensTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListLensTemplatesQuery, ListLensTemplatesQueryVariables>;
export function useListLensTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListLensTemplatesQuery, ListLensTemplatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListLensTemplatesQuery | undefined,
  ListLensTemplatesQueryVariables
>;
export function useListLensTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListLensTemplatesQuery, ListLensTemplatesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListLensTemplatesQuery, ListLensTemplatesQueryVariables>(
    ListLensTemplatesDocument,
    options,
  );
}
export type ListLensTemplatesQueryHookResult = ReturnType<typeof useListLensTemplatesQuery>;
export type ListLensTemplatesLazyQueryHookResult = ReturnType<typeof useListLensTemplatesLazyQuery>;
export type ListLensTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useListLensTemplatesSuspenseQuery
>;
export type ListLensTemplatesQueryResult = Apollo.QueryResult<
  ListLensTemplatesQuery,
  ListLensTemplatesQueryVariables
>;
export const ResolveRoleScopesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResolveRoleScopes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveRoleScopes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useResolveRoleScopesQuery__
 *
 * To run a query within a React component, call `useResolveRoleScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveRoleScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveRoleScopesQuery({
 *   variables: {
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useResolveRoleScopesQuery(
  baseOptions: Apollo.QueryHookOptions<ResolveRoleScopesQuery, ResolveRoleScopesQueryVariables> &
    ({ variables: ResolveRoleScopesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResolveRoleScopesQuery, ResolveRoleScopesQueryVariables>(
    ResolveRoleScopesDocument,
    options,
  );
}
export function useResolveRoleScopesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResolveRoleScopesQuery,
    ResolveRoleScopesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ResolveRoleScopesQuery, ResolveRoleScopesQueryVariables>(
    ResolveRoleScopesDocument,
    options,
  );
}
// @ts-ignore
export function useResolveRoleScopesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResolveRoleScopesQuery,
    ResolveRoleScopesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ResolveRoleScopesQuery, ResolveRoleScopesQueryVariables>;
export function useResolveRoleScopesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolveRoleScopesQuery, ResolveRoleScopesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ResolveRoleScopesQuery | undefined,
  ResolveRoleScopesQueryVariables
>;
export function useResolveRoleScopesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolveRoleScopesQuery, ResolveRoleScopesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ResolveRoleScopesQuery, ResolveRoleScopesQueryVariables>(
    ResolveRoleScopesDocument,
    options,
  );
}
export type ResolveRoleScopesQueryHookResult = ReturnType<typeof useResolveRoleScopesQuery>;
export type ResolveRoleScopesLazyQueryHookResult = ReturnType<typeof useResolveRoleScopesLazyQuery>;
export type ResolveRoleScopesSuspenseQueryHookResult = ReturnType<
  typeof useResolveRoleScopesSuspenseQuery
>;
export type ResolveRoleScopesQueryResult = Apollo.QueryResult<
  ResolveRoleScopesQuery,
  ResolveRoleScopesQueryVariables
>;
export const ResolveRoleScopesForAccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResolveRoleScopesForAccess' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveRoleScopes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useResolveRoleScopesForAccessQuery__
 *
 * To run a query within a React component, call `useResolveRoleScopesForAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveRoleScopesForAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveRoleScopesForAccessQuery({
 *   variables: {
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useResolveRoleScopesForAccessQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResolveRoleScopesForAccessQuery,
    ResolveRoleScopesForAccessQueryVariables
  > &
    ({ variables: ResolveRoleScopesForAccessQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResolveRoleScopesForAccessQuery, ResolveRoleScopesForAccessQueryVariables>(
    ResolveRoleScopesForAccessDocument,
    options,
  );
}
export function useResolveRoleScopesForAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResolveRoleScopesForAccessQuery,
    ResolveRoleScopesForAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ResolveRoleScopesForAccessQuery,
    ResolveRoleScopesForAccessQueryVariables
  >(ResolveRoleScopesForAccessDocument, options);
}
// @ts-ignore
export function useResolveRoleScopesForAccessSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResolveRoleScopesForAccessQuery,
    ResolveRoleScopesForAccessQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ResolveRoleScopesForAccessQuery,
  ResolveRoleScopesForAccessQueryVariables
>;
export function useResolveRoleScopesForAccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResolveRoleScopesForAccessQuery,
        ResolveRoleScopesForAccessQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ResolveRoleScopesForAccessQuery | undefined,
  ResolveRoleScopesForAccessQueryVariables
>;
export function useResolveRoleScopesForAccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResolveRoleScopesForAccessQuery,
        ResolveRoleScopesForAccessQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ResolveRoleScopesForAccessQuery,
    ResolveRoleScopesForAccessQueryVariables
  >(ResolveRoleScopesForAccessDocument, options);
}
export type ResolveRoleScopesForAccessQueryHookResult = ReturnType<
  typeof useResolveRoleScopesForAccessQuery
>;
export type ResolveRoleScopesForAccessLazyQueryHookResult = ReturnType<
  typeof useResolveRoleScopesForAccessLazyQuery
>;
export type ResolveRoleScopesForAccessSuspenseQueryHookResult = ReturnType<
  typeof useResolveRoleScopesForAccessSuspenseQuery
>;
export type ResolveRoleScopesForAccessQueryResult = Apollo.QueryResult<
  ResolveRoleScopesForAccessQuery,
  ResolveRoleScopesForAccessQueryVariables
>;
export const MyScopeGapsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyScopeGaps' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myScopeGaps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalBlockedScopes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gaps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'failures' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'prerequisiteType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'remediation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'remediationTaskGroup' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyScopeGapsQuery__
 *
 * To run a query within a React component, call `useMyScopeGapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyScopeGapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyScopeGapsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyScopeGapsQuery(
  baseOptions?: Apollo.QueryHookOptions<MyScopeGapsQuery, MyScopeGapsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyScopeGapsQuery, MyScopeGapsQueryVariables>(MyScopeGapsDocument, options);
}
export function useMyScopeGapsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyScopeGapsQuery, MyScopeGapsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyScopeGapsQuery, MyScopeGapsQueryVariables>(
    MyScopeGapsDocument,
    options,
  );
}
// @ts-ignore
export function useMyScopeGapsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyScopeGapsQuery, MyScopeGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyScopeGapsQuery, MyScopeGapsQueryVariables>;
export function useMyScopeGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyScopeGapsQuery, MyScopeGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyScopeGapsQuery | undefined, MyScopeGapsQueryVariables>;
export function useMyScopeGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyScopeGapsQuery, MyScopeGapsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyScopeGapsQuery, MyScopeGapsQueryVariables>(
    MyScopeGapsDocument,
    options,
  );
}
export type MyScopeGapsQueryHookResult = ReturnType<typeof useMyScopeGapsQuery>;
export type MyScopeGapsLazyQueryHookResult = ReturnType<typeof useMyScopeGapsLazyQuery>;
export type MyScopeGapsSuspenseQueryHookResult = ReturnType<typeof useMyScopeGapsSuspenseQuery>;
export type MyScopeGapsQueryResult = Apollo.QueryResult<
  MyScopeGapsQuery,
  MyScopeGapsQueryVariables
>;
export const MyCertificationGapsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyCertificationGaps' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myCertificationGaps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalExpiring' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expiringCertifications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'certType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'daysUntilExpiration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'urgency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'affectedScopes' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyCertificationGapsQuery__
 *
 * To run a query within a React component, call `useMyCertificationGapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCertificationGapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCertificationGapsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCertificationGapsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyCertificationGapsQuery,
    MyCertificationGapsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyCertificationGapsQuery, MyCertificationGapsQueryVariables>(
    MyCertificationGapsDocument,
    options,
  );
}
export function useMyCertificationGapsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyCertificationGapsQuery,
    MyCertificationGapsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyCertificationGapsQuery, MyCertificationGapsQueryVariables>(
    MyCertificationGapsDocument,
    options,
  );
}
// @ts-ignore
export function useMyCertificationGapsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyCertificationGapsQuery,
    MyCertificationGapsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyCertificationGapsQuery, MyCertificationGapsQueryVariables>;
export function useMyCertificationGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyCertificationGapsQuery, MyCertificationGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MyCertificationGapsQuery | undefined,
  MyCertificationGapsQueryVariables
>;
export function useMyCertificationGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyCertificationGapsQuery, MyCertificationGapsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyCertificationGapsQuery, MyCertificationGapsQueryVariables>(
    MyCertificationGapsDocument,
    options,
  );
}
export type MyCertificationGapsQueryHookResult = ReturnType<typeof useMyCertificationGapsQuery>;
export type MyCertificationGapsLazyQueryHookResult = ReturnType<
  typeof useMyCertificationGapsLazyQuery
>;
export type MyCertificationGapsSuspenseQueryHookResult = ReturnType<
  typeof useMyCertificationGapsSuspenseQuery
>;
export type MyCertificationGapsQueryResult = Apollo.QueryResult<
  MyCertificationGapsQuery,
  MyCertificationGapsQueryVariables
>;
export const AdminListFhirConditionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminListFhirConditions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '100' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminListFhirConditions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FhirStoredFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FhirStoredFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FhirStoredResourceType' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAdminListFhirConditionsQuery__
 *
 * To run a query within a React component, call `useAdminListFhirConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListFhirConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListFhirConditionsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminListFhirConditionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListFhirConditionsQuery,
    AdminListFhirConditionsQueryVariables
  > &
    ({ variables: AdminListFhirConditionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListFhirConditionsQuery, AdminListFhirConditionsQueryVariables>(
    AdminListFhirConditionsDocument,
    options,
  );
}
export function useAdminListFhirConditionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListFhirConditionsQuery,
    AdminListFhirConditionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListFhirConditionsQuery, AdminListFhirConditionsQueryVariables>(
    AdminListFhirConditionsDocument,
    options,
  );
}
// @ts-ignore
export function useAdminListFhirConditionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListFhirConditionsQuery,
    AdminListFhirConditionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListFhirConditionsQuery,
  AdminListFhirConditionsQueryVariables
>;
export function useAdminListFhirConditionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirConditionsQuery,
        AdminListFhirConditionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListFhirConditionsQuery | undefined,
  AdminListFhirConditionsQueryVariables
>;
export function useAdminListFhirConditionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirConditionsQuery,
        AdminListFhirConditionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListFhirConditionsQuery,
    AdminListFhirConditionsQueryVariables
  >(AdminListFhirConditionsDocument, options);
}
export type AdminListFhirConditionsQueryHookResult = ReturnType<
  typeof useAdminListFhirConditionsQuery
>;
export type AdminListFhirConditionsLazyQueryHookResult = ReturnType<
  typeof useAdminListFhirConditionsLazyQuery
>;
export type AdminListFhirConditionsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListFhirConditionsSuspenseQuery
>;
export type AdminListFhirConditionsQueryResult = Apollo.QueryResult<
  AdminListFhirConditionsQuery,
  AdminListFhirConditionsQueryVariables
>;
export const AdminListFhirMedicationRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminListFhirMedicationRequests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '100' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminListFhirMedicationRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FhirStoredFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FhirStoredFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FhirStoredResourceType' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAdminListFhirMedicationRequestsQuery__
 *
 * To run a query within a React component, call `useAdminListFhirMedicationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListFhirMedicationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListFhirMedicationRequestsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminListFhirMedicationRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListFhirMedicationRequestsQuery,
    AdminListFhirMedicationRequestsQueryVariables
  > &
    (
      | { variables: AdminListFhirMedicationRequestsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminListFhirMedicationRequestsQuery,
    AdminListFhirMedicationRequestsQueryVariables
  >(AdminListFhirMedicationRequestsDocument, options);
}
export function useAdminListFhirMedicationRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListFhirMedicationRequestsQuery,
    AdminListFhirMedicationRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListFhirMedicationRequestsQuery,
    AdminListFhirMedicationRequestsQueryVariables
  >(AdminListFhirMedicationRequestsDocument, options);
}
// @ts-ignore
export function useAdminListFhirMedicationRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListFhirMedicationRequestsQuery,
    AdminListFhirMedicationRequestsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListFhirMedicationRequestsQuery,
  AdminListFhirMedicationRequestsQueryVariables
>;
export function useAdminListFhirMedicationRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirMedicationRequestsQuery,
        AdminListFhirMedicationRequestsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListFhirMedicationRequestsQuery | undefined,
  AdminListFhirMedicationRequestsQueryVariables
>;
export function useAdminListFhirMedicationRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirMedicationRequestsQuery,
        AdminListFhirMedicationRequestsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListFhirMedicationRequestsQuery,
    AdminListFhirMedicationRequestsQueryVariables
  >(AdminListFhirMedicationRequestsDocument, options);
}
export type AdminListFhirMedicationRequestsQueryHookResult = ReturnType<
  typeof useAdminListFhirMedicationRequestsQuery
>;
export type AdminListFhirMedicationRequestsLazyQueryHookResult = ReturnType<
  typeof useAdminListFhirMedicationRequestsLazyQuery
>;
export type AdminListFhirMedicationRequestsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListFhirMedicationRequestsSuspenseQuery
>;
export type AdminListFhirMedicationRequestsQueryResult = Apollo.QueryResult<
  AdminListFhirMedicationRequestsQuery,
  AdminListFhirMedicationRequestsQueryVariables
>;
export const AdminListFhirObservationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminListFhirObservations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '100' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminListFhirObservations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FhirStoredFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FhirStoredFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FhirStoredResourceType' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAdminListFhirObservationsQuery__
 *
 * To run a query within a React component, call `useAdminListFhirObservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListFhirObservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListFhirObservationsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminListFhirObservationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListFhirObservationsQuery,
    AdminListFhirObservationsQueryVariables
  > &
    ({ variables: AdminListFhirObservationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListFhirObservationsQuery, AdminListFhirObservationsQueryVariables>(
    AdminListFhirObservationsDocument,
    options,
  );
}
export function useAdminListFhirObservationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListFhirObservationsQuery,
    AdminListFhirObservationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminListFhirObservationsQuery,
    AdminListFhirObservationsQueryVariables
  >(AdminListFhirObservationsDocument, options);
}
// @ts-ignore
export function useAdminListFhirObservationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListFhirObservationsQuery,
    AdminListFhirObservationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminListFhirObservationsQuery,
  AdminListFhirObservationsQueryVariables
>;
export function useAdminListFhirObservationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirObservationsQuery,
        AdminListFhirObservationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListFhirObservationsQuery | undefined,
  AdminListFhirObservationsQueryVariables
>;
export function useAdminListFhirObservationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirObservationsQuery,
        AdminListFhirObservationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AdminListFhirObservationsQuery,
    AdminListFhirObservationsQueryVariables
  >(AdminListFhirObservationsDocument, options);
}
export type AdminListFhirObservationsQueryHookResult = ReturnType<
  typeof useAdminListFhirObservationsQuery
>;
export type AdminListFhirObservationsLazyQueryHookResult = ReturnType<
  typeof useAdminListFhirObservationsLazyQuery
>;
export type AdminListFhirObservationsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListFhirObservationsSuspenseQuery
>;
export type AdminListFhirObservationsQueryResult = Apollo.QueryResult<
  AdminListFhirObservationsQuery,
  AdminListFhirObservationsQueryVariables
>;
export const AdminListFhirPatientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminListFhirPatients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '50' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminListFhirPatients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FhirStoredFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FhirStoredFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FhirStoredResourceType' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAdminListFhirPatientsQuery__
 *
 * To run a query within a React component, call `useAdminListFhirPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListFhirPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListFhirPatientsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminListFhirPatientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminListFhirPatientsQuery,
    AdminListFhirPatientsQueryVariables
  > &
    ({ variables: AdminListFhirPatientsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListFhirPatientsQuery, AdminListFhirPatientsQueryVariables>(
    AdminListFhirPatientsDocument,
    options,
  );
}
export function useAdminListFhirPatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListFhirPatientsQuery,
    AdminListFhirPatientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListFhirPatientsQuery, AdminListFhirPatientsQueryVariables>(
    AdminListFhirPatientsDocument,
    options,
  );
}
// @ts-ignore
export function useAdminListFhirPatientsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminListFhirPatientsQuery,
    AdminListFhirPatientsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AdminListFhirPatientsQuery, AdminListFhirPatientsQueryVariables>;
export function useAdminListFhirPatientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirPatientsQuery,
        AdminListFhirPatientsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminListFhirPatientsQuery | undefined,
  AdminListFhirPatientsQueryVariables
>;
export function useAdminListFhirPatientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminListFhirPatientsQuery,
        AdminListFhirPatientsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdminListFhirPatientsQuery, AdminListFhirPatientsQueryVariables>(
    AdminListFhirPatientsDocument,
    options,
  );
}
export type AdminListFhirPatientsQueryHookResult = ReturnType<typeof useAdminListFhirPatientsQuery>;
export type AdminListFhirPatientsLazyQueryHookResult = ReturnType<
  typeof useAdminListFhirPatientsLazyQuery
>;
export type AdminListFhirPatientsSuspenseQueryHookResult = ReturnType<
  typeof useAdminListFhirPatientsSuspenseQuery
>;
export type AdminListFhirPatientsQueryResult = Apollo.QueryResult<
  AdminListFhirPatientsQuery,
  AdminListFhirPatientsQueryVariables
>;
export const GetFhirAllergiesBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFhirAllergiesBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirAllergiesBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFhirAllergiesBySubjectQuery__
 *
 * To run a query within a React component, call `useGetFhirAllergiesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirAllergiesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirAllergiesBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetFhirAllergiesBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFhirAllergiesBySubjectQuery,
    GetFhirAllergiesBySubjectQueryVariables
  > &
    ({ variables: GetFhirAllergiesBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFhirAllergiesBySubjectQuery, GetFhirAllergiesBySubjectQueryVariables>(
    GetFhirAllergiesBySubjectDocument,
    options,
  );
}
export function useGetFhirAllergiesBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFhirAllergiesBySubjectQuery,
    GetFhirAllergiesBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFhirAllergiesBySubjectQuery,
    GetFhirAllergiesBySubjectQueryVariables
  >(GetFhirAllergiesBySubjectDocument, options);
}
// @ts-ignore
export function useGetFhirAllergiesBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFhirAllergiesBySubjectQuery,
    GetFhirAllergiesBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFhirAllergiesBySubjectQuery,
  GetFhirAllergiesBySubjectQueryVariables
>;
export function useGetFhirAllergiesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirAllergiesBySubjectQuery,
        GetFhirAllergiesBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFhirAllergiesBySubjectQuery | undefined,
  GetFhirAllergiesBySubjectQueryVariables
>;
export function useGetFhirAllergiesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirAllergiesBySubjectQuery,
        GetFhirAllergiesBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFhirAllergiesBySubjectQuery,
    GetFhirAllergiesBySubjectQueryVariables
  >(GetFhirAllergiesBySubjectDocument, options);
}
export type GetFhirAllergiesBySubjectQueryHookResult = ReturnType<
  typeof useGetFhirAllergiesBySubjectQuery
>;
export type GetFhirAllergiesBySubjectLazyQueryHookResult = ReturnType<
  typeof useGetFhirAllergiesBySubjectLazyQuery
>;
export type GetFhirAllergiesBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetFhirAllergiesBySubjectSuspenseQuery
>;
export type GetFhirAllergiesBySubjectQueryResult = Apollo.QueryResult<
  GetFhirAllergiesBySubjectQuery,
  GetFhirAllergiesBySubjectQueryVariables
>;
export const GetFhirMedAdminsBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFhirMedAdminsBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '50' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedAdminsBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFhirMedAdminsBySubjectQuery__
 *
 * To run a query within a React component, call `useGetFhirMedAdminsBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirMedAdminsBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirMedAdminsBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFhirMedAdminsBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFhirMedAdminsBySubjectQuery,
    GetFhirMedAdminsBySubjectQueryVariables
  > &
    ({ variables: GetFhirMedAdminsBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFhirMedAdminsBySubjectQuery, GetFhirMedAdminsBySubjectQueryVariables>(
    GetFhirMedAdminsBySubjectDocument,
    options,
  );
}
export function useGetFhirMedAdminsBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFhirMedAdminsBySubjectQuery,
    GetFhirMedAdminsBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFhirMedAdminsBySubjectQuery,
    GetFhirMedAdminsBySubjectQueryVariables
  >(GetFhirMedAdminsBySubjectDocument, options);
}
// @ts-ignore
export function useGetFhirMedAdminsBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFhirMedAdminsBySubjectQuery,
    GetFhirMedAdminsBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedAdminsBySubjectQuery,
  GetFhirMedAdminsBySubjectQueryVariables
>;
export function useGetFhirMedAdminsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedAdminsBySubjectQuery,
        GetFhirMedAdminsBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedAdminsBySubjectQuery | undefined,
  GetFhirMedAdminsBySubjectQueryVariables
>;
export function useGetFhirMedAdminsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedAdminsBySubjectQuery,
        GetFhirMedAdminsBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFhirMedAdminsBySubjectQuery,
    GetFhirMedAdminsBySubjectQueryVariables
  >(GetFhirMedAdminsBySubjectDocument, options);
}
export type GetFhirMedAdminsBySubjectQueryHookResult = ReturnType<
  typeof useGetFhirMedAdminsBySubjectQuery
>;
export type GetFhirMedAdminsBySubjectLazyQueryHookResult = ReturnType<
  typeof useGetFhirMedAdminsBySubjectLazyQuery
>;
export type GetFhirMedAdminsBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetFhirMedAdminsBySubjectSuspenseQuery
>;
export type GetFhirMedAdminsBySubjectQueryResult = Apollo.QueryResult<
  GetFhirMedAdminsBySubjectQuery,
  GetFhirMedAdminsBySubjectQueryVariables
>;
export const GetFhirMedDispensesBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFhirMedDispensesBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedDispensesBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFhirMedDispensesBySubjectQuery__
 *
 * To run a query within a React component, call `useGetFhirMedDispensesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirMedDispensesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirMedDispensesBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetFhirMedDispensesBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFhirMedDispensesBySubjectQuery,
    GetFhirMedDispensesBySubjectQueryVariables
  > &
    ({ variables: GetFhirMedDispensesBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFhirMedDispensesBySubjectQuery,
    GetFhirMedDispensesBySubjectQueryVariables
  >(GetFhirMedDispensesBySubjectDocument, options);
}
export function useGetFhirMedDispensesBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFhirMedDispensesBySubjectQuery,
    GetFhirMedDispensesBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFhirMedDispensesBySubjectQuery,
    GetFhirMedDispensesBySubjectQueryVariables
  >(GetFhirMedDispensesBySubjectDocument, options);
}
// @ts-ignore
export function useGetFhirMedDispensesBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFhirMedDispensesBySubjectQuery,
    GetFhirMedDispensesBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedDispensesBySubjectQuery,
  GetFhirMedDispensesBySubjectQueryVariables
>;
export function useGetFhirMedDispensesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedDispensesBySubjectQuery,
        GetFhirMedDispensesBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedDispensesBySubjectQuery | undefined,
  GetFhirMedDispensesBySubjectQueryVariables
>;
export function useGetFhirMedDispensesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedDispensesBySubjectQuery,
        GetFhirMedDispensesBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFhirMedDispensesBySubjectQuery,
    GetFhirMedDispensesBySubjectQueryVariables
  >(GetFhirMedDispensesBySubjectDocument, options);
}
export type GetFhirMedDispensesBySubjectQueryHookResult = ReturnType<
  typeof useGetFhirMedDispensesBySubjectQuery
>;
export type GetFhirMedDispensesBySubjectLazyQueryHookResult = ReturnType<
  typeof useGetFhirMedDispensesBySubjectLazyQuery
>;
export type GetFhirMedDispensesBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetFhirMedDispensesBySubjectSuspenseQuery
>;
export type GetFhirMedDispensesBySubjectQueryResult = Apollo.QueryResult<
  GetFhirMedDispensesBySubjectQuery,
  GetFhirMedDispensesBySubjectQueryVariables
>;
export const GetFhirMedicationsBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFhirMedicationsBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedicationsBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditOperation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFhirMedicationsBySubjectQuery__
 *
 * To run a query within a React component, call `useGetFhirMedicationsBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirMedicationsBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirMedicationsBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetFhirMedicationsBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFhirMedicationsBySubjectQuery,
    GetFhirMedicationsBySubjectQueryVariables
  > &
    ({ variables: GetFhirMedicationsBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFhirMedicationsBySubjectQuery,
    GetFhirMedicationsBySubjectQueryVariables
  >(GetFhirMedicationsBySubjectDocument, options);
}
export function useGetFhirMedicationsBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFhirMedicationsBySubjectQuery,
    GetFhirMedicationsBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFhirMedicationsBySubjectQuery,
    GetFhirMedicationsBySubjectQueryVariables
  >(GetFhirMedicationsBySubjectDocument, options);
}
// @ts-ignore
export function useGetFhirMedicationsBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFhirMedicationsBySubjectQuery,
    GetFhirMedicationsBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedicationsBySubjectQuery,
  GetFhirMedicationsBySubjectQueryVariables
>;
export function useGetFhirMedicationsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedicationsBySubjectQuery,
        GetFhirMedicationsBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFhirMedicationsBySubjectQuery | undefined,
  GetFhirMedicationsBySubjectQueryVariables
>;
export function useGetFhirMedicationsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirMedicationsBySubjectQuery,
        GetFhirMedicationsBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFhirMedicationsBySubjectQuery,
    GetFhirMedicationsBySubjectQueryVariables
  >(GetFhirMedicationsBySubjectDocument, options);
}
export type GetFhirMedicationsBySubjectQueryHookResult = ReturnType<
  typeof useGetFhirMedicationsBySubjectQuery
>;
export type GetFhirMedicationsBySubjectLazyQueryHookResult = ReturnType<
  typeof useGetFhirMedicationsBySubjectLazyQuery
>;
export type GetFhirMedicationsBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetFhirMedicationsBySubjectSuspenseQuery
>;
export type GetFhirMedicationsBySubjectQueryResult = Apollo.QueryResult<
  GetFhirMedicationsBySubjectQuery,
  GetFhirMedicationsBySubjectQueryVariables
>;
export const GetFhirPrescriptionSchedulesBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFhirPrescriptionSchedulesBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirPrescriptionSchedulesBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFhirPrescriptionSchedulesBySubjectQuery__
 *
 * To run a query within a React component, call `useGetFhirPrescriptionSchedulesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPrescriptionSchedulesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPrescriptionSchedulesBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useGetFhirPrescriptionSchedulesBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFhirPrescriptionSchedulesBySubjectQuery,
    GetFhirPrescriptionSchedulesBySubjectQueryVariables
  > &
    (
      | { variables: GetFhirPrescriptionSchedulesBySubjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFhirPrescriptionSchedulesBySubjectQuery,
    GetFhirPrescriptionSchedulesBySubjectQueryVariables
  >(GetFhirPrescriptionSchedulesBySubjectDocument, options);
}
export function useGetFhirPrescriptionSchedulesBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFhirPrescriptionSchedulesBySubjectQuery,
    GetFhirPrescriptionSchedulesBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFhirPrescriptionSchedulesBySubjectQuery,
    GetFhirPrescriptionSchedulesBySubjectQueryVariables
  >(GetFhirPrescriptionSchedulesBySubjectDocument, options);
}
// @ts-ignore
export function useGetFhirPrescriptionSchedulesBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFhirPrescriptionSchedulesBySubjectQuery,
    GetFhirPrescriptionSchedulesBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFhirPrescriptionSchedulesBySubjectQuery,
  GetFhirPrescriptionSchedulesBySubjectQueryVariables
>;
export function useGetFhirPrescriptionSchedulesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirPrescriptionSchedulesBySubjectQuery,
        GetFhirPrescriptionSchedulesBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFhirPrescriptionSchedulesBySubjectQuery | undefined,
  GetFhirPrescriptionSchedulesBySubjectQueryVariables
>;
export function useGetFhirPrescriptionSchedulesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFhirPrescriptionSchedulesBySubjectQuery,
        GetFhirPrescriptionSchedulesBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFhirPrescriptionSchedulesBySubjectQuery,
    GetFhirPrescriptionSchedulesBySubjectQueryVariables
  >(GetFhirPrescriptionSchedulesBySubjectDocument, options);
}
export type GetFhirPrescriptionSchedulesBySubjectQueryHookResult = ReturnType<
  typeof useGetFhirPrescriptionSchedulesBySubjectQuery
>;
export type GetFhirPrescriptionSchedulesBySubjectLazyQueryHookResult = ReturnType<
  typeof useGetFhirPrescriptionSchedulesBySubjectLazyQuery
>;
export type GetFhirPrescriptionSchedulesBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useGetFhirPrescriptionSchedulesBySubjectSuspenseQuery
>;
export type GetFhirPrescriptionSchedulesBySubjectQueryResult = Apollo.QueryResult<
  GetFhirPrescriptionSchedulesBySubjectQuery,
  GetFhirPrescriptionSchedulesBySubjectQueryVariables
>;
export const GetAllLedgerAccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllLedgerAccounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerAccounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balanceCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pointsBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAllLedgerAccountsQuery__
 *
 * To run a query within a React component, call `useGetAllLedgerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLedgerAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLedgerAccountsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useGetAllLedgerAccountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllLedgerAccountsQuery,
    GetAllLedgerAccountsQueryVariables
  > &
    ({ variables: GetAllLedgerAccountsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllLedgerAccountsQuery, GetAllLedgerAccountsQueryVariables>(
    GetAllLedgerAccountsDocument,
    options,
  );
}
export function useGetAllLedgerAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllLedgerAccountsQuery,
    GetAllLedgerAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllLedgerAccountsQuery, GetAllLedgerAccountsQueryVariables>(
    GetAllLedgerAccountsDocument,
    options,
  );
}
// @ts-ignore
export function useGetAllLedgerAccountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAllLedgerAccountsQuery,
    GetAllLedgerAccountsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAllLedgerAccountsQuery, GetAllLedgerAccountsQueryVariables>;
export function useGetAllLedgerAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllLedgerAccountsQuery,
        GetAllLedgerAccountsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAllLedgerAccountsQuery | undefined,
  GetAllLedgerAccountsQueryVariables
>;
export function useGetAllLedgerAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllLedgerAccountsQuery,
        GetAllLedgerAccountsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAllLedgerAccountsQuery, GetAllLedgerAccountsQueryVariables>(
    GetAllLedgerAccountsDocument,
    options,
  );
}
export type GetAllLedgerAccountsQueryHookResult = ReturnType<typeof useGetAllLedgerAccountsQuery>;
export type GetAllLedgerAccountsLazyQueryHookResult = ReturnType<
  typeof useGetAllLedgerAccountsLazyQuery
>;
export type GetAllLedgerAccountsSuspenseQueryHookResult = ReturnType<
  typeof useGetAllLedgerAccountsSuspenseQuery
>;
export type GetAllLedgerAccountsQueryResult = Apollo.QueryResult<
  GetAllLedgerAccountsQuery,
  GetAllLedgerAccountsQueryVariables
>;
export const GetAuditLedgerTransfersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAuditLedgerTransfers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerTransfers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'transferId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'socialSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceCategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'moovTransferId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAuditLedgerTransfersQuery__
 *
 * To run a query within a React component, call `useGetAuditLedgerTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLedgerTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLedgerTransfersQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useGetAuditLedgerTransfersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAuditLedgerTransfersQuery,
    GetAuditLedgerTransfersQueryVariables
  > &
    ({ variables: GetAuditLedgerTransfersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditLedgerTransfersQuery, GetAuditLedgerTransfersQueryVariables>(
    GetAuditLedgerTransfersDocument,
    options,
  );
}
export function useGetAuditLedgerTransfersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAuditLedgerTransfersQuery,
    GetAuditLedgerTransfersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditLedgerTransfersQuery, GetAuditLedgerTransfersQueryVariables>(
    GetAuditLedgerTransfersDocument,
    options,
  );
}
// @ts-ignore
export function useGetAuditLedgerTransfersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAuditLedgerTransfersQuery,
    GetAuditLedgerTransfersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAuditLedgerTransfersQuery,
  GetAuditLedgerTransfersQueryVariables
>;
export function useGetAuditLedgerTransfersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditLedgerTransfersQuery,
        GetAuditLedgerTransfersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAuditLedgerTransfersQuery | undefined,
  GetAuditLedgerTransfersQueryVariables
>;
export function useGetAuditLedgerTransfersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditLedgerTransfersQuery,
        GetAuditLedgerTransfersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAuditLedgerTransfersQuery,
    GetAuditLedgerTransfersQueryVariables
  >(GetAuditLedgerTransfersDocument, options);
}
export type GetAuditLedgerTransfersQueryHookResult = ReturnType<
  typeof useGetAuditLedgerTransfersQuery
>;
export type GetAuditLedgerTransfersLazyQueryHookResult = ReturnType<
  typeof useGetAuditLedgerTransfersLazyQuery
>;
export type GetAuditLedgerTransfersSuspenseQueryHookResult = ReturnType<
  typeof useGetAuditLedgerTransfersSuspenseQuery
>;
export type GetAuditLedgerTransfersQueryResult = Apollo.QueryResult<
  GetAuditLedgerTransfersQuery,
  GetAuditLedgerTransfersQueryVariables
>;
export const GetFamilyLedgerAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFamilyLedgerAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balanceCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pointsBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFamilyLedgerAccountQuery__
 *
 * To run a query within a React component, call `useGetFamilyLedgerAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyLedgerAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyLedgerAccountQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetFamilyLedgerAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFamilyLedgerAccountQuery,
    GetFamilyLedgerAccountQueryVariables
  > &
    ({ variables: GetFamilyLedgerAccountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFamilyLedgerAccountQuery, GetFamilyLedgerAccountQueryVariables>(
    GetFamilyLedgerAccountDocument,
    options,
  );
}
export function useGetFamilyLedgerAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFamilyLedgerAccountQuery,
    GetFamilyLedgerAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFamilyLedgerAccountQuery, GetFamilyLedgerAccountQueryVariables>(
    GetFamilyLedgerAccountDocument,
    options,
  );
}
// @ts-ignore
export function useGetFamilyLedgerAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFamilyLedgerAccountQuery,
    GetFamilyLedgerAccountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetFamilyLedgerAccountQuery, GetFamilyLedgerAccountQueryVariables>;
export function useGetFamilyLedgerAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFamilyLedgerAccountQuery,
        GetFamilyLedgerAccountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFamilyLedgerAccountQuery | undefined,
  GetFamilyLedgerAccountQueryVariables
>;
export function useGetFamilyLedgerAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFamilyLedgerAccountQuery,
        GetFamilyLedgerAccountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFamilyLedgerAccountQuery, GetFamilyLedgerAccountQueryVariables>(
    GetFamilyLedgerAccountDocument,
    options,
  );
}
export type GetFamilyLedgerAccountQueryHookResult = ReturnType<
  typeof useGetFamilyLedgerAccountQuery
>;
export type GetFamilyLedgerAccountLazyQueryHookResult = ReturnType<
  typeof useGetFamilyLedgerAccountLazyQuery
>;
export type GetFamilyLedgerAccountSuspenseQueryHookResult = ReturnType<
  typeof useGetFamilyLedgerAccountSuspenseQuery
>;
export type GetFamilyLedgerAccountQueryResult = Apollo.QueryResult<
  GetFamilyLedgerAccountQuery,
  GetFamilyLedgerAccountQueryVariables
>;
export const GetFamilyLedgerTransfersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFamilyLedgerTransfers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerTransfers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'transferId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceCategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFamilyLedgerTransfersQuery__
 *
 * To run a query within a React component, call `useGetFamilyLedgerTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyLedgerTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyLedgerTransfersQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useGetFamilyLedgerTransfersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFamilyLedgerTransfersQuery,
    GetFamilyLedgerTransfersQueryVariables
  > &
    ({ variables: GetFamilyLedgerTransfersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFamilyLedgerTransfersQuery, GetFamilyLedgerTransfersQueryVariables>(
    GetFamilyLedgerTransfersDocument,
    options,
  );
}
export function useGetFamilyLedgerTransfersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFamilyLedgerTransfersQuery,
    GetFamilyLedgerTransfersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFamilyLedgerTransfersQuery, GetFamilyLedgerTransfersQueryVariables>(
    GetFamilyLedgerTransfersDocument,
    options,
  );
}
// @ts-ignore
export function useGetFamilyLedgerTransfersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFamilyLedgerTransfersQuery,
    GetFamilyLedgerTransfersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFamilyLedgerTransfersQuery,
  GetFamilyLedgerTransfersQueryVariables
>;
export function useGetFamilyLedgerTransfersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFamilyLedgerTransfersQuery,
        GetFamilyLedgerTransfersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFamilyLedgerTransfersQuery | undefined,
  GetFamilyLedgerTransfersQueryVariables
>;
export function useGetFamilyLedgerTransfersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFamilyLedgerTransfersQuery,
        GetFamilyLedgerTransfersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFamilyLedgerTransfersQuery,
    GetFamilyLedgerTransfersQueryVariables
  >(GetFamilyLedgerTransfersDocument, options);
}
export type GetFamilyLedgerTransfersQueryHookResult = ReturnType<
  typeof useGetFamilyLedgerTransfersQuery
>;
export type GetFamilyLedgerTransfersLazyQueryHookResult = ReturnType<
  typeof useGetFamilyLedgerTransfersLazyQuery
>;
export type GetFamilyLedgerTransfersSuspenseQueryHookResult = ReturnType<
  typeof useGetFamilyLedgerTransfersSuspenseQuery
>;
export type GetFamilyLedgerTransfersQueryResult = Apollo.QueryResult<
  GetFamilyLedgerTransfersQuery,
  GetFamilyLedgerTransfersQueryVariables
>;
export const GetLedgerAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLedgerAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balanceCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pointsBalance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLedgerAccountQuery__
 *
 * To run a query within a React component, call `useGetLedgerAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerAccountQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetLedgerAccountQuery(
  baseOptions: Apollo.QueryHookOptions<GetLedgerAccountQuery, GetLedgerAccountQueryVariables> &
    ({ variables: GetLedgerAccountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>(
    GetLedgerAccountDocument,
    options,
  );
}
export function useGetLedgerAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>(
    GetLedgerAccountDocument,
    options,
  );
}
// @ts-ignore
export function useGetLedgerAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLedgerAccountQuery,
    GetLedgerAccountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>;
export function useGetLedgerAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLedgerAccountQuery | undefined, GetLedgerAccountQueryVariables>;
export function useGetLedgerAccountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>(
    GetLedgerAccountDocument,
    options,
  );
}
export type GetLedgerAccountQueryHookResult = ReturnType<typeof useGetLedgerAccountQuery>;
export type GetLedgerAccountLazyQueryHookResult = ReturnType<typeof useGetLedgerAccountLazyQuery>;
export type GetLedgerAccountSuspenseQueryHookResult = ReturnType<
  typeof useGetLedgerAccountSuspenseQuery
>;
export type GetLedgerAccountQueryResult = Apollo.QueryResult<
  GetLedgerAccountQuery,
  GetLedgerAccountQueryVariables
>;
export const GetLedgerSettlementsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLedgerSettlements' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerSettlements' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'settlementId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceCompanyTenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceCompanyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transactionCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reconciled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settledAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLedgerSettlementsQuery__
 *
 * To run a query within a React component, call `useGetLedgerSettlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerSettlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerSettlementsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetLedgerSettlementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLedgerSettlementsQuery,
    GetLedgerSettlementsQueryVariables
  > &
    ({ variables: GetLedgerSettlementsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLedgerSettlementsQuery, GetLedgerSettlementsQueryVariables>(
    GetLedgerSettlementsDocument,
    options,
  );
}
export function useGetLedgerSettlementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLedgerSettlementsQuery,
    GetLedgerSettlementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLedgerSettlementsQuery, GetLedgerSettlementsQueryVariables>(
    GetLedgerSettlementsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLedgerSettlementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLedgerSettlementsQuery,
    GetLedgerSettlementsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetLedgerSettlementsQuery, GetLedgerSettlementsQueryVariables>;
export function useGetLedgerSettlementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLedgerSettlementsQuery,
        GetLedgerSettlementsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetLedgerSettlementsQuery | undefined,
  GetLedgerSettlementsQueryVariables
>;
export function useGetLedgerSettlementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLedgerSettlementsQuery,
        GetLedgerSettlementsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLedgerSettlementsQuery, GetLedgerSettlementsQueryVariables>(
    GetLedgerSettlementsDocument,
    options,
  );
}
export type GetLedgerSettlementsQueryHookResult = ReturnType<typeof useGetLedgerSettlementsQuery>;
export type GetLedgerSettlementsLazyQueryHookResult = ReturnType<
  typeof useGetLedgerSettlementsLazyQuery
>;
export type GetLedgerSettlementsSuspenseQueryHookResult = ReturnType<
  typeof useGetLedgerSettlementsSuspenseQuery
>;
export type GetLedgerSettlementsQueryResult = Apollo.QueryResult<
  GetLedgerSettlementsQuery,
  GetLedgerSettlementsQueryVariables
>;
export const GetLedgerTransfersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLedgerTransfers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerTransfers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'transferId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'socialSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceCategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetLedgerTransfersQuery__
 *
 * To run a query within a React component, call `useGetLedgerTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerTransfersQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useGetLedgerTransfersQuery(
  baseOptions: Apollo.QueryHookOptions<GetLedgerTransfersQuery, GetLedgerTransfersQueryVariables> &
    ({ variables: GetLedgerTransfersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLedgerTransfersQuery, GetLedgerTransfersQueryVariables>(
    GetLedgerTransfersDocument,
    options,
  );
}
export function useGetLedgerTransfersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLedgerTransfersQuery,
    GetLedgerTransfersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLedgerTransfersQuery, GetLedgerTransfersQueryVariables>(
    GetLedgerTransfersDocument,
    options,
  );
}
// @ts-ignore
export function useGetLedgerTransfersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLedgerTransfersQuery,
    GetLedgerTransfersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetLedgerTransfersQuery, GetLedgerTransfersQueryVariables>;
export function useGetLedgerTransfersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLedgerTransfersQuery, GetLedgerTransfersQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetLedgerTransfersQuery | undefined,
  GetLedgerTransfersQueryVariables
>;
export function useGetLedgerTransfersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLedgerTransfersQuery, GetLedgerTransfersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLedgerTransfersQuery, GetLedgerTransfersQueryVariables>(
    GetLedgerTransfersDocument,
    options,
  );
}
export type GetLedgerTransfersQueryHookResult = ReturnType<typeof useGetLedgerTransfersQuery>;
export type GetLedgerTransfersLazyQueryHookResult = ReturnType<
  typeof useGetLedgerTransfersLazyQuery
>;
export type GetLedgerTransfersSuspenseQueryHookResult = ReturnType<
  typeof useGetLedgerTransfersSuspenseQuery
>;
export type GetLedgerTransfersQueryResult = Apollo.QueryResult<
  GetLedgerTransfersQuery,
  GetLedgerTransfersQueryVariables
>;
export const GetScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetScheduleQuery__
 *
 * To run a query within a React component, call `useGetScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useGetScheduleQuery(
  baseOptions: Apollo.QueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables> &
    ({ variables: GetScheduleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetScheduleQuery, GetScheduleQueryVariables>(GetScheduleDocument, options);
}
export function useGetScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetScheduleQuery, GetScheduleQueryVariables>(
    GetScheduleDocument,
    options,
  );
}
// @ts-ignore
export function useGetScheduleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetScheduleQuery, GetScheduleQueryVariables>;
export function useGetScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetScheduleQuery | undefined, GetScheduleQueryVariables>;
export function useGetScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetScheduleQuery, GetScheduleQueryVariables>(
    GetScheduleDocument,
    options,
  );
}
export type GetScheduleQueryHookResult = ReturnType<typeof useGetScheduleQuery>;
export type GetScheduleLazyQueryHookResult = ReturnType<typeof useGetScheduleLazyQuery>;
export type GetScheduleSuspenseQueryHookResult = ReturnType<typeof useGetScheduleSuspenseQuery>;
export type GetScheduleQueryResult = Apollo.QueryResult<
  GetScheduleQuery,
  GetScheduleQueryVariables
>;
export const ListResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLifeCriticalResource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListResourcesQuery__
 *
 * To run a query within a React component, call `useListResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResourcesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables> &
    ({ variables: ListResourcesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListResourcesQuery, ListResourcesQueryVariables>(
    ListResourcesDocument,
    options,
  );
}
export function useListResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListResourcesQuery, ListResourcesQueryVariables>(
    ListResourcesDocument,
    options,
  );
}
// @ts-ignore
export function useListResourcesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListResourcesQuery, ListResourcesQueryVariables>;
export function useListResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListResourcesQuery | undefined, ListResourcesQueryVariables>;
export function useListResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListResourcesQuery, ListResourcesQueryVariables>(
    ListResourcesDocument,
    options,
  );
}
export type ListResourcesQueryHookResult = ReturnType<typeof useListResourcesQuery>;
export type ListResourcesLazyQueryHookResult = ReturnType<typeof useListResourcesLazyQuery>;
export type ListResourcesSuspenseQueryHookResult = ReturnType<typeof useListResourcesSuspenseQuery>;
export type ListResourcesQueryResult = Apollo.QueryResult<
  ListResourcesQuery,
  ListResourcesQueryVariables
>;
export const ListSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ScheduleFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cronExpression' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schedulePriority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListSchedulesQuery__
 *
 * To run a query within a React component, call `useListSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSchedulesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListSchedulesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListSchedulesQuery, ListSchedulesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSchedulesQuery, ListSchedulesQueryVariables>(
    ListSchedulesDocument,
    options,
  );
}
export function useListSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSchedulesQuery, ListSchedulesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSchedulesQuery, ListSchedulesQueryVariables>(
    ListSchedulesDocument,
    options,
  );
}
// @ts-ignore
export function useListSchedulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListSchedulesQuery, ListSchedulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListSchedulesQuery, ListSchedulesQueryVariables>;
export function useListSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSchedulesQuery, ListSchedulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListSchedulesQuery | undefined, ListSchedulesQueryVariables>;
export function useListSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSchedulesQuery, ListSchedulesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListSchedulesQuery, ListSchedulesQueryVariables>(
    ListSchedulesDocument,
    options,
  );
}
export type ListSchedulesQueryHookResult = ReturnType<typeof useListSchedulesQuery>;
export type ListSchedulesLazyQueryHookResult = ReturnType<typeof useListSchedulesLazyQuery>;
export type ListSchedulesSuspenseQueryHookResult = ReturnType<typeof useListSchedulesSuspenseQuery>;
export type ListSchedulesQueryResult = Apollo.QueryResult<
  ListSchedulesQuery,
  ListSchedulesQueryVariables
>;
export const ValidateMandatoryResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateMandatoryResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryRuleset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateMandatoryResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primaryRuleset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'primaryRuleset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configuredCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'missingResources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statuteRequirement' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rulesetRef' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useValidateMandatoryResourcesQuery__
 *
 * To run a query within a React component, call `useValidateMandatoryResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateMandatoryResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateMandatoryResourcesQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      primaryRuleset: // value for 'primaryRuleset'
 *   },
 * });
 */
export function useValidateMandatoryResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateMandatoryResourcesQuery,
    ValidateMandatoryResourcesQueryVariables
  > &
    ({ variables: ValidateMandatoryResourcesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidateMandatoryResourcesQuery, ValidateMandatoryResourcesQueryVariables>(
    ValidateMandatoryResourcesDocument,
    options,
  );
}
export function useValidateMandatoryResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateMandatoryResourcesQuery,
    ValidateMandatoryResourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValidateMandatoryResourcesQuery,
    ValidateMandatoryResourcesQueryVariables
  >(ValidateMandatoryResourcesDocument, options);
}
// @ts-ignore
export function useValidateMandatoryResourcesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidateMandatoryResourcesQuery,
    ValidateMandatoryResourcesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ValidateMandatoryResourcesQuery,
  ValidateMandatoryResourcesQueryVariables
>;
export function useValidateMandatoryResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateMandatoryResourcesQuery,
        ValidateMandatoryResourcesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ValidateMandatoryResourcesQuery | undefined,
  ValidateMandatoryResourcesQueryVariables
>;
export function useValidateMandatoryResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateMandatoryResourcesQuery,
        ValidateMandatoryResourcesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ValidateMandatoryResourcesQuery,
    ValidateMandatoryResourcesQueryVariables
  >(ValidateMandatoryResourcesDocument, options);
}
export type ValidateMandatoryResourcesQueryHookResult = ReturnType<
  typeof useValidateMandatoryResourcesQuery
>;
export type ValidateMandatoryResourcesLazyQueryHookResult = ReturnType<
  typeof useValidateMandatoryResourcesLazyQuery
>;
export type ValidateMandatoryResourcesSuspenseQueryHookResult = ReturnType<
  typeof useValidateMandatoryResourcesSuspenseQuery
>;
export type ValidateMandatoryResourcesQueryResult = Apollo.QueryResult<
  ValidateMandatoryResourcesQuery,
  ValidateMandatoryResourcesQueryVariables
>;
export const ExportAuditTrailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportAuditTrail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExportAuditTrailInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportAuditTrail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'exportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recordCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useExportAuditTrailQuery__
 *
 * To run a query within a React component, call `useExportAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportAuditTrailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportAuditTrailQuery(
  baseOptions: Apollo.QueryHookOptions<ExportAuditTrailQuery, ExportAuditTrailQueryVariables> &
    ({ variables: ExportAuditTrailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportAuditTrailQuery, ExportAuditTrailQueryVariables>(
    ExportAuditTrailDocument,
    options,
  );
}
export function useExportAuditTrailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExportAuditTrailQuery, ExportAuditTrailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportAuditTrailQuery, ExportAuditTrailQueryVariables>(
    ExportAuditTrailDocument,
    options,
  );
}
// @ts-ignore
export function useExportAuditTrailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportAuditTrailQuery,
    ExportAuditTrailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExportAuditTrailQuery, ExportAuditTrailQueryVariables>;
export function useExportAuditTrailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExportAuditTrailQuery, ExportAuditTrailQueryVariables>,
): Apollo.UseSuspenseQueryResult<ExportAuditTrailQuery | undefined, ExportAuditTrailQueryVariables>;
export function useExportAuditTrailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExportAuditTrailQuery, ExportAuditTrailQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportAuditTrailQuery, ExportAuditTrailQueryVariables>(
    ExportAuditTrailDocument,
    options,
  );
}
export type ExportAuditTrailQueryHookResult = ReturnType<typeof useExportAuditTrailQuery>;
export type ExportAuditTrailLazyQueryHookResult = ReturnType<typeof useExportAuditTrailLazyQuery>;
export type ExportAuditTrailSuspenseQueryHookResult = ReturnType<
  typeof useExportAuditTrailSuspenseQuery
>;
export type ExportAuditTrailQueryResult = Apollo.QueryResult<
  ExportAuditTrailQuery,
  ExportAuditTrailQueryVariables
>;
export const GetAuditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAudit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAudit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuditFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuditFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditQL' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'frameworkType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compliancePeriodStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compliancePeriodEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryQuestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueEventTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'findingsSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationsDetected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userActionCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primitiveTypesAccessed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'navigationPaths' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSpentSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessPatterns' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featuresUsed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featuresUnused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'adoptionRatePercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionYears' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'immutabilityRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signatureRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataLineage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportTemplateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportS3Url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generatedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueActors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueWorkflows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiConfidence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chaosExtractionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalWorkflowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousAuditId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subgraphReferences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastValidationTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAuditQuery__
 *
 * To run a query within a React component, call `useGetAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuditQuery(
  baseOptions: Apollo.QueryHookOptions<GetAuditQuery, GetAuditQueryVariables> &
    ({ variables: GetAuditQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
}
export function useGetAuditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
}
// @ts-ignore
export function useGetAuditSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAuditQuery, GetAuditQueryVariables>;
export function useGetAuditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAuditQuery | undefined, GetAuditQueryVariables>;
export function useGetAuditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
}
export type GetAuditQueryHookResult = ReturnType<typeof useGetAuditQuery>;
export type GetAuditLazyQueryHookResult = ReturnType<typeof useGetAuditLazyQuery>;
export type GetAuditSuspenseQueryHookResult = ReturnType<typeof useGetAuditSuspenseQuery>;
export type GetAuditQueryResult = Apollo.QueryResult<GetAuditQuery, GetAuditQueryVariables>;
export const GetAuditStatisticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAuditStatistics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditDateRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAuditStatistics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalActions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticalActionsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceViolationsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tamperDetectionCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actionsByType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAuditStatisticsQuery__
 *
 * To run a query within a React component, call `useGetAuditStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditStatisticsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetAuditStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAuditStatisticsQuery, GetAuditStatisticsQueryVariables> &
    ({ variables: GetAuditStatisticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditStatisticsQuery, GetAuditStatisticsQueryVariables>(
    GetAuditStatisticsDocument,
    options,
  );
}
export function useGetAuditStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAuditStatisticsQuery,
    GetAuditStatisticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditStatisticsQuery, GetAuditStatisticsQueryVariables>(
    GetAuditStatisticsDocument,
    options,
  );
}
// @ts-ignore
export function useGetAuditStatisticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAuditStatisticsQuery,
    GetAuditStatisticsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAuditStatisticsQuery, GetAuditStatisticsQueryVariables>;
export function useGetAuditStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAuditStatisticsQuery, GetAuditStatisticsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetAuditStatisticsQuery | undefined,
  GetAuditStatisticsQueryVariables
>;
export function useGetAuditStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAuditStatisticsQuery, GetAuditStatisticsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAuditStatisticsQuery, GetAuditStatisticsQueryVariables>(
    GetAuditStatisticsDocument,
    options,
  );
}
export type GetAuditStatisticsQueryHookResult = ReturnType<typeof useGetAuditStatisticsQuery>;
export type GetAuditStatisticsLazyQueryHookResult = ReturnType<
  typeof useGetAuditStatisticsLazyQuery
>;
export type GetAuditStatisticsSuspenseQueryHookResult = ReturnType<
  typeof useGetAuditStatisticsSuspenseQuery
>;
export type GetAuditStatisticsQueryResult = Apollo.QueryResult<
  GetAuditStatisticsQuery,
  GetAuditStatisticsQueryVariables
>;
export const GetAuditTrailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAuditTrail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditTrailFilter' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAuditTrail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'auditId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tamperDetected' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cryptographicHash' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tamperAlerts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'auditId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'detectedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAuditTrailQuery__
 *
 * To run a query within a React component, call `useGetAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditTrailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAuditTrailQuery(
  baseOptions: Apollo.QueryHookOptions<GetAuditTrailQuery, GetAuditTrailQueryVariables> &
    ({ variables: GetAuditTrailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditTrailQuery, GetAuditTrailQueryVariables>(
    GetAuditTrailDocument,
    options,
  );
}
export function useGetAuditTrailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAuditTrailQuery, GetAuditTrailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditTrailQuery, GetAuditTrailQueryVariables>(
    GetAuditTrailDocument,
    options,
  );
}
// @ts-ignore
export function useGetAuditTrailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuditTrailQuery, GetAuditTrailQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAuditTrailQuery, GetAuditTrailQueryVariables>;
export function useGetAuditTrailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAuditTrailQuery, GetAuditTrailQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetAuditTrailQuery | undefined, GetAuditTrailQueryVariables>;
export function useGetAuditTrailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAuditTrailQuery, GetAuditTrailQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAuditTrailQuery, GetAuditTrailQueryVariables>(
    GetAuditTrailDocument,
    options,
  );
}
export type GetAuditTrailQueryHookResult = ReturnType<typeof useGetAuditTrailQuery>;
export type GetAuditTrailLazyQueryHookResult = ReturnType<typeof useGetAuditTrailLazyQuery>;
export type GetAuditTrailSuspenseQueryHookResult = ReturnType<typeof useGetAuditTrailSuspenseQuery>;
export type GetAuditTrailQueryResult = Apollo.QueryResult<
  GetAuditTrailQuery,
  GetAuditTrailQueryVariables
>;
export const GetEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventApiGetEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables> &
    ({ variables: GetEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
}
export function useGetEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
}
// @ts-ignore
export function useGetEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetEventQuery, GetEventQueryVariables>;
export function useGetEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetEventQuery | undefined, GetEventQueryVariables>;
export function useGetEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
}
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventSuspenseQueryHookResult = ReturnType<typeof useGetEventSuspenseQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventsByEntityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventsByEntity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventApiGetEventsByEntity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventsByEntityQuery__
 *
 * To run a query within a React component, call `useGetEventsByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByEntityQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEventsByEntityQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventsByEntityQuery, GetEventsByEntityQueryVariables> &
    ({ variables: GetEventsByEntityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventsByEntityQuery, GetEventsByEntityQueryVariables>(
    GetEventsByEntityDocument,
    options,
  );
}
export function useGetEventsByEntityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventsByEntityQuery,
    GetEventsByEntityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventsByEntityQuery, GetEventsByEntityQueryVariables>(
    GetEventsByEntityDocument,
    options,
  );
}
// @ts-ignore
export function useGetEventsByEntitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventsByEntityQuery,
    GetEventsByEntityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventsByEntityQuery, GetEventsByEntityQueryVariables>;
export function useGetEventsByEntitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventsByEntityQuery, GetEventsByEntityQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetEventsByEntityQuery | undefined,
  GetEventsByEntityQueryVariables
>;
export function useGetEventsByEntitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventsByEntityQuery, GetEventsByEntityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventsByEntityQuery, GetEventsByEntityQueryVariables>(
    GetEventsByEntityDocument,
    options,
  );
}
export type GetEventsByEntityQueryHookResult = ReturnType<typeof useGetEventsByEntityQuery>;
export type GetEventsByEntityLazyQueryHookResult = ReturnType<typeof useGetEventsByEntityLazyQuery>;
export type GetEventsByEntitySuspenseQueryHookResult = ReturnType<
  typeof useGetEventsByEntitySuspenseQuery
>;
export type GetEventsByEntityQueryResult = Apollo.QueryResult<
  GetEventsByEntityQuery,
  GetEventsByEntityQueryVariables
>;
export const GetSafetyEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSafetyEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsGetSafetyEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AlertFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlertFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remediationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remediationRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSafetyEventQuery__
 *
 * To run a query within a React component, call `useGetSafetyEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSafetyEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSafetyEventQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetSafetyEventQuery(
  baseOptions: Apollo.QueryHookOptions<GetSafetyEventQuery, GetSafetyEventQueryVariables> &
    ({ variables: GetSafetyEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSafetyEventQuery, GetSafetyEventQueryVariables>(
    GetSafetyEventDocument,
    options,
  );
}
export function useGetSafetyEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSafetyEventQuery, GetSafetyEventQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSafetyEventQuery, GetSafetyEventQueryVariables>(
    GetSafetyEventDocument,
    options,
  );
}
// @ts-ignore
export function useGetSafetyEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSafetyEventQuery, GetSafetyEventQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetSafetyEventQuery, GetSafetyEventQueryVariables>;
export function useGetSafetyEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSafetyEventQuery, GetSafetyEventQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetSafetyEventQuery | undefined, GetSafetyEventQueryVariables>;
export function useGetSafetyEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSafetyEventQuery, GetSafetyEventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSafetyEventQuery, GetSafetyEventQueryVariables>(
    GetSafetyEventDocument,
    options,
  );
}
export type GetSafetyEventQueryHookResult = ReturnType<typeof useGetSafetyEventQuery>;
export type GetSafetyEventLazyQueryHookResult = ReturnType<typeof useGetSafetyEventLazyQuery>;
export type GetSafetyEventSuspenseQueryHookResult = ReturnType<
  typeof useGetSafetyEventSuspenseQuery
>;
export type GetSafetyEventQueryResult = Apollo.QueryResult<
  GetSafetyEventQuery,
  GetSafetyEventQueryVariables
>;
export const ListAuditsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAudits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nextToken' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listAudits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nextToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nextToken' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuditFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuditFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditQL' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'frameworkType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compliancePeriodStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compliancePeriodEnd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryQuestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueEventTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'findingsSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'violationsDetected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userActionCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primitiveTypesAccessed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'navigationPaths' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSpentSeconds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessPatterns' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featuresUsed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featuresUnused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'adoptionRatePercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionYears' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retentionExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'immutabilityRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signatureRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataLineage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'regulatoryFrameworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportTemplateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportS3Url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generatedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueActors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueWorkflows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiConfidence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chaosExtractionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvalWorkflowId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousAuditId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subgraphReferences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastValidationTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListAuditsQuery__
 *
 * To run a query within a React component, call `useListAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAuditsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListAuditsQuery(
  baseOptions: Apollo.QueryHookOptions<ListAuditsQuery, ListAuditsQueryVariables> &
    ({ variables: ListAuditsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAuditsQuery, ListAuditsQueryVariables>(ListAuditsDocument, options);
}
export function useListAuditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAuditsQuery, ListAuditsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAuditsQuery, ListAuditsQueryVariables>(
    ListAuditsDocument,
    options,
  );
}
// @ts-ignore
export function useListAuditsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListAuditsQuery, ListAuditsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAuditsQuery, ListAuditsQueryVariables>;
export function useListAuditsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListAuditsQuery, ListAuditsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAuditsQuery | undefined, ListAuditsQueryVariables>;
export function useListAuditsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListAuditsQuery, ListAuditsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListAuditsQuery, ListAuditsQueryVariables>(
    ListAuditsDocument,
    options,
  );
}
export type ListAuditsQueryHookResult = ReturnType<typeof useListAuditsQuery>;
export type ListAuditsLazyQueryHookResult = ReturnType<typeof useListAuditsLazyQuery>;
export type ListAuditsSuspenseQueryHookResult = ReturnType<typeof useListAuditsSuspenseQuery>;
export type ListAuditsQueryResult = Apollo.QueryResult<ListAuditsQuery, ListAuditsQueryVariables>;
export const ListEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlEventFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventApiListEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'performedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListEventsQuery__
 *
 * To run a query within a React component, call `useListEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListEventsQuery(
  baseOptions: Apollo.QueryHookOptions<ListEventsQuery, ListEventsQueryVariables> &
    ({ variables: ListEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEventsQuery, ListEventsQueryVariables>(ListEventsDocument, options);
}
export function useListEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListEventsQuery, ListEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEventsQuery, ListEventsQueryVariables>(
    ListEventsDocument,
    options,
  );
}
// @ts-ignore
export function useListEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListEventsQuery, ListEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEventsQuery, ListEventsQueryVariables>;
export function useListEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEventsQuery, ListEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEventsQuery | undefined, ListEventsQueryVariables>;
export function useListEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEventsQuery, ListEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEventsQuery, ListEventsQueryVariables>(
    ListEventsDocument,
    options,
  );
}
export type ListEventsQueryHookResult = ReturnType<typeof useListEventsQuery>;
export type ListEventsLazyQueryHookResult = ReturnType<typeof useListEventsLazyQuery>;
export type ListEventsSuspenseQueryHookResult = ReturnType<typeof useListEventsSuspenseQuery>;
export type ListEventsQueryResult = Apollo.QueryResult<ListEventsQuery, ListEventsQueryVariables>;
export const ListSafetyEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListSafetyEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyEventFilter' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsListSafetyEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AlertFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlertFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SafetyEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remediationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'remediationRequired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListSafetyEventsQuery__
 *
 * To run a query within a React component, call `useListSafetyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSafetyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSafetyEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListSafetyEventsQuery(
  baseOptions: Apollo.QueryHookOptions<ListSafetyEventsQuery, ListSafetyEventsQueryVariables> &
    ({ variables: ListSafetyEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSafetyEventsQuery, ListSafetyEventsQueryVariables>(
    ListSafetyEventsDocument,
    options,
  );
}
export function useListSafetyEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSafetyEventsQuery, ListSafetyEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSafetyEventsQuery, ListSafetyEventsQueryVariables>(
    ListSafetyEventsDocument,
    options,
  );
}
// @ts-ignore
export function useListSafetyEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListSafetyEventsQuery,
    ListSafetyEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListSafetyEventsQuery, ListSafetyEventsQueryVariables>;
export function useListSafetyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSafetyEventsQuery, ListSafetyEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListSafetyEventsQuery | undefined, ListSafetyEventsQueryVariables>;
export function useListSafetyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSafetyEventsQuery, ListSafetyEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListSafetyEventsQuery, ListSafetyEventsQueryVariables>(
    ListSafetyEventsDocument,
    options,
  );
}
export type ListSafetyEventsQueryHookResult = ReturnType<typeof useListSafetyEventsQuery>;
export type ListSafetyEventsLazyQueryHookResult = ReturnType<typeof useListSafetyEventsLazyQuery>;
export type ListSafetyEventsSuspenseQueryHookResult = ReturnType<
  typeof useListSafetyEventsSuspenseQuery
>;
export type ListSafetyEventsQueryResult = Apollo.QueryResult<
  ListSafetyEventsQuery,
  ListSafetyEventsQueryVariables
>;
export const GetAnalyticsByCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsByCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MetricCategory' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsByCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyticsFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyticsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Analytics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticalThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsByCategoryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetAnalyticsByCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsByCategoryQuery,
    GetAnalyticsByCategoryQueryVariables
  > &
    ({ variables: GetAnalyticsByCategoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsByCategoryQuery, GetAnalyticsByCategoryQueryVariables>(
    GetAnalyticsByCategoryDocument,
    options,
  );
}
export function useGetAnalyticsByCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsByCategoryQuery,
    GetAnalyticsByCategoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnalyticsByCategoryQuery, GetAnalyticsByCategoryQueryVariables>(
    GetAnalyticsByCategoryDocument,
    options,
  );
}
// @ts-ignore
export function useGetAnalyticsByCategorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsByCategoryQuery,
    GetAnalyticsByCategoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAnalyticsByCategoryQuery, GetAnalyticsByCategoryQueryVariables>;
export function useGetAnalyticsByCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsByCategoryQuery,
        GetAnalyticsByCategoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsByCategoryQuery | undefined,
  GetAnalyticsByCategoryQueryVariables
>;
export function useGetAnalyticsByCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsByCategoryQuery,
        GetAnalyticsByCategoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAnalyticsByCategoryQuery, GetAnalyticsByCategoryQueryVariables>(
    GetAnalyticsByCategoryDocument,
    options,
  );
}
export type GetAnalyticsByCategoryQueryHookResult = ReturnType<
  typeof useGetAnalyticsByCategoryQuery
>;
export type GetAnalyticsByCategoryLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsByCategoryLazyQuery
>;
export type GetAnalyticsByCategorySuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsByCategorySuspenseQuery
>;
export type GetAnalyticsByCategoryQueryResult = Apollo.QueryResult<
  GetAnalyticsByCategoryQuery,
  GetAnalyticsByCategoryQueryVariables
>;
export const GetAnalyticsByCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsByCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'analyticsCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsByCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'analyticsCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'analyticsCode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyticsFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyticsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Analytics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticalThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsByCodeQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsByCodeQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      analyticsCode: // value for 'analyticsCode'
 *   },
 * });
 */
export function useGetAnalyticsByCodeQuery(
  baseOptions: Apollo.QueryHookOptions<GetAnalyticsByCodeQuery, GetAnalyticsByCodeQueryVariables> &
    ({ variables: GetAnalyticsByCodeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsByCodeQuery, GetAnalyticsByCodeQueryVariables>(
    GetAnalyticsByCodeDocument,
    options,
  );
}
export function useGetAnalyticsByCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsByCodeQuery,
    GetAnalyticsByCodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnalyticsByCodeQuery, GetAnalyticsByCodeQueryVariables>(
    GetAnalyticsByCodeDocument,
    options,
  );
}
// @ts-ignore
export function useGetAnalyticsByCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsByCodeQuery,
    GetAnalyticsByCodeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAnalyticsByCodeQuery, GetAnalyticsByCodeQueryVariables>;
export function useGetAnalyticsByCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAnalyticsByCodeQuery, GetAnalyticsByCodeQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsByCodeQuery | undefined,
  GetAnalyticsByCodeQueryVariables
>;
export function useGetAnalyticsByCodeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAnalyticsByCodeQuery, GetAnalyticsByCodeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAnalyticsByCodeQuery, GetAnalyticsByCodeQueryVariables>(
    GetAnalyticsByCodeDocument,
    options,
  );
}
export type GetAnalyticsByCodeQueryHookResult = ReturnType<typeof useGetAnalyticsByCodeQuery>;
export type GetAnalyticsByCodeLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsByCodeLazyQuery
>;
export type GetAnalyticsByCodeSuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsByCodeSuspenseQuery
>;
export type GetAnalyticsByCodeQueryResult = Apollo.QueryResult<
  GetAnalyticsByCodeQuery,
  GetAnalyticsByCodeQueryVariables
>;
export const GetAnalyticsByQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsByQueue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsByQueue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyticsFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyticsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Analytics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticalThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsByQueueQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsByQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsByQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsByQueueQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      queueId: // value for 'queueId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAnalyticsByQueueQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsByQueueQuery,
    GetAnalyticsByQueueQueryVariables
  > &
    ({ variables: GetAnalyticsByQueueQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsByQueueQuery, GetAnalyticsByQueueQueryVariables>(
    GetAnalyticsByQueueDocument,
    options,
  );
}
export function useGetAnalyticsByQueueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsByQueueQuery,
    GetAnalyticsByQueueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnalyticsByQueueQuery, GetAnalyticsByQueueQueryVariables>(
    GetAnalyticsByQueueDocument,
    options,
  );
}
// @ts-ignore
export function useGetAnalyticsByQueueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsByQueueQuery,
    GetAnalyticsByQueueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAnalyticsByQueueQuery, GetAnalyticsByQueueQueryVariables>;
export function useGetAnalyticsByQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAnalyticsByQueueQuery, GetAnalyticsByQueueQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsByQueueQuery | undefined,
  GetAnalyticsByQueueQueryVariables
>;
export function useGetAnalyticsByQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAnalyticsByQueueQuery, GetAnalyticsByQueueQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAnalyticsByQueueQuery, GetAnalyticsByQueueQueryVariables>(
    GetAnalyticsByQueueDocument,
    options,
  );
}
export type GetAnalyticsByQueueQueryHookResult = ReturnType<typeof useGetAnalyticsByQueueQuery>;
export type GetAnalyticsByQueueLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsByQueueLazyQuery
>;
export type GetAnalyticsByQueueSuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsByQueueSuspenseQuery
>;
export type GetAnalyticsByQueueQueryResult = Apollo.QueryResult<
  GetAnalyticsByQueueQuery,
  GetAnalyticsByQueueQueryVariables
>;
export const GetAnalyticsDashboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsDashboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsDashboard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'performanceMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metricName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'complianceMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metricName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metricName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'systemMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metricName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adoptionMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metricName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'trendsPositive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trendsNegative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alertsTriggered' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsDashboardQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsDashboardQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetAnalyticsDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsDashboardQuery,
    GetAnalyticsDashboardQueryVariables
  > &
    ({ variables: GetAnalyticsDashboardQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsDashboardQuery, GetAnalyticsDashboardQueryVariables>(
    GetAnalyticsDashboardDocument,
    options,
  );
}
export function useGetAnalyticsDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsDashboardQuery,
    GetAnalyticsDashboardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnalyticsDashboardQuery, GetAnalyticsDashboardQueryVariables>(
    GetAnalyticsDashboardDocument,
    options,
  );
}
// @ts-ignore
export function useGetAnalyticsDashboardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsDashboardQuery,
    GetAnalyticsDashboardQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAnalyticsDashboardQuery, GetAnalyticsDashboardQueryVariables>;
export function useGetAnalyticsDashboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsDashboardQuery,
        GetAnalyticsDashboardQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsDashboardQuery | undefined,
  GetAnalyticsDashboardQueryVariables
>;
export function useGetAnalyticsDashboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsDashboardQuery,
        GetAnalyticsDashboardQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAnalyticsDashboardQuery, GetAnalyticsDashboardQueryVariables>(
    GetAnalyticsDashboardDocument,
    options,
  );
}
export type GetAnalyticsDashboardQueryHookResult = ReturnType<typeof useGetAnalyticsDashboardQuery>;
export type GetAnalyticsDashboardLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsDashboardLazyQuery
>;
export type GetAnalyticsDashboardSuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsDashboardSuspenseQuery
>;
export type GetAnalyticsDashboardQueryResult = Apollo.QueryResult<
  GetAnalyticsDashboardQuery,
  GetAnalyticsDashboardQueryVariables
>;
export const GetAnalyticsManifestStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsManifestStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'analyticsManifestStatus' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'builtAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filesIndexed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRowsIndexed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalSizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantsCovered' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphsCovered' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsManifestStatusQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsManifestStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsManifestStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsManifestStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalyticsManifestStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAnalyticsManifestStatusQuery,
    GetAnalyticsManifestStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsManifestStatusQuery, GetAnalyticsManifestStatusQueryVariables>(
    GetAnalyticsManifestStatusDocument,
    options,
  );
}
export function useGetAnalyticsManifestStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsManifestStatusQuery,
    GetAnalyticsManifestStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnalyticsManifestStatusQuery,
    GetAnalyticsManifestStatusQueryVariables
  >(GetAnalyticsManifestStatusDocument, options);
}
// @ts-ignore
export function useGetAnalyticsManifestStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsManifestStatusQuery,
    GetAnalyticsManifestStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsManifestStatusQuery,
  GetAnalyticsManifestStatusQueryVariables
>;
export function useGetAnalyticsManifestStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsManifestStatusQuery,
        GetAnalyticsManifestStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsManifestStatusQuery | undefined,
  GetAnalyticsManifestStatusQueryVariables
>;
export function useGetAnalyticsManifestStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsManifestStatusQuery,
        GetAnalyticsManifestStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAnalyticsManifestStatusQuery,
    GetAnalyticsManifestStatusQueryVariables
  >(GetAnalyticsManifestStatusDocument, options);
}
export type GetAnalyticsManifestStatusQueryHookResult = ReturnType<
  typeof useGetAnalyticsManifestStatusQuery
>;
export type GetAnalyticsManifestStatusLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsManifestStatusLazyQuery
>;
export type GetAnalyticsManifestStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsManifestStatusSuspenseQuery
>;
export type GetAnalyticsManifestStatusQueryResult = Apollo.QueryResult<
  GetAnalyticsManifestStatusQuery,
  GetAnalyticsManifestStatusQueryVariables
>;
export const GetAnalyticsSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPolicies' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalEvaluations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalMatched' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalErrors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgExecutionTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overallEffectiveness' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overallCacheHitRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsSummaryQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSummaryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetAnalyticsSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsSummaryQuery,
    GetAnalyticsSummaryQueryVariables
  > &
    ({ variables: GetAnalyticsSummaryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>(
    GetAnalyticsSummaryDocument,
    options,
  );
}
export function useGetAnalyticsSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsSummaryQuery,
    GetAnalyticsSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>(
    GetAnalyticsSummaryDocument,
    options,
  );
}
// @ts-ignore
export function useGetAnalyticsSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsSummaryQuery,
    GetAnalyticsSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>;
export function useGetAnalyticsSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsSummaryQuery | undefined,
  GetAnalyticsSummaryQueryVariables
>;
export function useGetAnalyticsSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>(
    GetAnalyticsSummaryDocument,
    options,
  );
}
export type GetAnalyticsSummaryQueryHookResult = ReturnType<typeof useGetAnalyticsSummaryQuery>;
export type GetAnalyticsSummaryLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsSummaryLazyQuery
>;
export type GetAnalyticsSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsSummarySuspenseQuery
>;
export type GetAnalyticsSummaryQueryResult = Apollo.QueryResult<
  GetAnalyticsSummaryQuery,
  GetAnalyticsSummaryQueryVariables
>;
export const GetAnalyticsTimeSeriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsTimeSeries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'policyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timeRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyticsTimeRange' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsTimeSeries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'policyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'policyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timeRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timeRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evaluationCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgExecutionTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cacheHitRate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsTimeSeriesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsTimeSeriesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      policyId: // value for 'policyId'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useGetAnalyticsTimeSeriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsTimeSeriesQuery,
    GetAnalyticsTimeSeriesQueryVariables
  > &
    ({ variables: GetAnalyticsTimeSeriesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsTimeSeriesQuery, GetAnalyticsTimeSeriesQueryVariables>(
    GetAnalyticsTimeSeriesDocument,
    options,
  );
}
export function useGetAnalyticsTimeSeriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsTimeSeriesQuery,
    GetAnalyticsTimeSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnalyticsTimeSeriesQuery, GetAnalyticsTimeSeriesQueryVariables>(
    GetAnalyticsTimeSeriesDocument,
    options,
  );
}
// @ts-ignore
export function useGetAnalyticsTimeSeriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsTimeSeriesQuery,
    GetAnalyticsTimeSeriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAnalyticsTimeSeriesQuery, GetAnalyticsTimeSeriesQueryVariables>;
export function useGetAnalyticsTimeSeriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsTimeSeriesQuery,
        GetAnalyticsTimeSeriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsTimeSeriesQuery | undefined,
  GetAnalyticsTimeSeriesQueryVariables
>;
export function useGetAnalyticsTimeSeriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsTimeSeriesQuery,
        GetAnalyticsTimeSeriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAnalyticsTimeSeriesQuery, GetAnalyticsTimeSeriesQueryVariables>(
    GetAnalyticsTimeSeriesDocument,
    options,
  );
}
export type GetAnalyticsTimeSeriesQueryHookResult = ReturnType<
  typeof useGetAnalyticsTimeSeriesQuery
>;
export type GetAnalyticsTimeSeriesLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsTimeSeriesLazyQuery
>;
export type GetAnalyticsTimeSeriesSuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsTimeSeriesSuspenseQuery
>;
export type GetAnalyticsTimeSeriesQueryResult = Apollo.QueryResult<
  GetAnalyticsTimeSeriesQuery,
  GetAnalyticsTimeSeriesQueryVariables
>;
export const GetAnalyticsWithAnomaliesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsWithAnomalies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsWithAnomalies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyticsFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyticsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Analytics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticalThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsWithAnomaliesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsWithAnomaliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsWithAnomaliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsWithAnomaliesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetAnalyticsWithAnomaliesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsWithAnomaliesQuery,
    GetAnalyticsWithAnomaliesQueryVariables
  > &
    ({ variables: GetAnalyticsWithAnomaliesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsWithAnomaliesQuery, GetAnalyticsWithAnomaliesQueryVariables>(
    GetAnalyticsWithAnomaliesDocument,
    options,
  );
}
export function useGetAnalyticsWithAnomaliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsWithAnomaliesQuery,
    GetAnalyticsWithAnomaliesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnalyticsWithAnomaliesQuery,
    GetAnalyticsWithAnomaliesQueryVariables
  >(GetAnalyticsWithAnomaliesDocument, options);
}
// @ts-ignore
export function useGetAnalyticsWithAnomaliesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsWithAnomaliesQuery,
    GetAnalyticsWithAnomaliesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsWithAnomaliesQuery,
  GetAnalyticsWithAnomaliesQueryVariables
>;
export function useGetAnalyticsWithAnomaliesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsWithAnomaliesQuery,
        GetAnalyticsWithAnomaliesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsWithAnomaliesQuery | undefined,
  GetAnalyticsWithAnomaliesQueryVariables
>;
export function useGetAnalyticsWithAnomaliesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsWithAnomaliesQuery,
        GetAnalyticsWithAnomaliesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAnalyticsWithAnomaliesQuery,
    GetAnalyticsWithAnomaliesQueryVariables
  >(GetAnalyticsWithAnomaliesDocument, options);
}
export type GetAnalyticsWithAnomaliesQueryHookResult = ReturnType<
  typeof useGetAnalyticsWithAnomaliesQuery
>;
export type GetAnalyticsWithAnomaliesLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsWithAnomaliesLazyQuery
>;
export type GetAnalyticsWithAnomaliesSuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsWithAnomaliesSuspenseQuery
>;
export type GetAnalyticsWithAnomaliesQueryResult = Apollo.QueryResult<
  GetAnalyticsWithAnomaliesQuery,
  GetAnalyticsWithAnomaliesQueryVariables
>;
export const GetAnalyticsWithThresholdBreachesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyticsWithThresholdBreaches' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyticsWithThresholdBreaches' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyticsFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyticsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Analytics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticalThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAnalyticsWithThresholdBreachesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsWithThresholdBreachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsWithThresholdBreachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsWithThresholdBreachesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetAnalyticsWithThresholdBreachesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnalyticsWithThresholdBreachesQuery,
    GetAnalyticsWithThresholdBreachesQueryVariables
  > &
    (
      | { variables: GetAnalyticsWithThresholdBreachesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAnalyticsWithThresholdBreachesQuery,
    GetAnalyticsWithThresholdBreachesQueryVariables
  >(GetAnalyticsWithThresholdBreachesDocument, options);
}
export function useGetAnalyticsWithThresholdBreachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnalyticsWithThresholdBreachesQuery,
    GetAnalyticsWithThresholdBreachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnalyticsWithThresholdBreachesQuery,
    GetAnalyticsWithThresholdBreachesQueryVariables
  >(GetAnalyticsWithThresholdBreachesDocument, options);
}
// @ts-ignore
export function useGetAnalyticsWithThresholdBreachesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnalyticsWithThresholdBreachesQuery,
    GetAnalyticsWithThresholdBreachesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsWithThresholdBreachesQuery,
  GetAnalyticsWithThresholdBreachesQueryVariables
>;
export function useGetAnalyticsWithThresholdBreachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsWithThresholdBreachesQuery,
        GetAnalyticsWithThresholdBreachesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAnalyticsWithThresholdBreachesQuery | undefined,
  GetAnalyticsWithThresholdBreachesQueryVariables
>;
export function useGetAnalyticsWithThresholdBreachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAnalyticsWithThresholdBreachesQuery,
        GetAnalyticsWithThresholdBreachesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAnalyticsWithThresholdBreachesQuery,
    GetAnalyticsWithThresholdBreachesQueryVariables
  >(GetAnalyticsWithThresholdBreachesDocument, options);
}
export type GetAnalyticsWithThresholdBreachesQueryHookResult = ReturnType<
  typeof useGetAnalyticsWithThresholdBreachesQuery
>;
export type GetAnalyticsWithThresholdBreachesLazyQueryHookResult = ReturnType<
  typeof useGetAnalyticsWithThresholdBreachesLazyQuery
>;
export type GetAnalyticsWithThresholdBreachesSuspenseQueryHookResult = ReturnType<
  typeof useGetAnalyticsWithThresholdBreachesSuspenseQuery
>;
export type GetAnalyticsWithThresholdBreachesQueryResult = Apollo.QueryResult<
  GetAnalyticsWithThresholdBreachesQuery,
  GetAnalyticsWithThresholdBreachesQueryVariables
>;
export const GetComplianceStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetComplianceStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'complianceStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rulesetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalProvisions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidencedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gapCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'compliancePercent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'provisions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedTaskGroups' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requiredEvidence' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'evidenceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'renewal' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskEvidenceCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'manualEvidenceCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetComplianceStatusQuery__
 *
 * To run a query within a React component, call `useGetComplianceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceStatusQuery({
 *   variables: {
 *      rulesetId: // value for 'rulesetId'
 *   },
 * });
 */
export function useGetComplianceStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetComplianceStatusQuery,
    GetComplianceStatusQueryVariables
  > &
    ({ variables: GetComplianceStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetComplianceStatusQuery, GetComplianceStatusQueryVariables>(
    GetComplianceStatusDocument,
    options,
  );
}
export function useGetComplianceStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetComplianceStatusQuery,
    GetComplianceStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetComplianceStatusQuery, GetComplianceStatusQueryVariables>(
    GetComplianceStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetComplianceStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetComplianceStatusQuery,
    GetComplianceStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetComplianceStatusQuery, GetComplianceStatusQueryVariables>;
export function useGetComplianceStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetComplianceStatusQuery, GetComplianceStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetComplianceStatusQuery | undefined,
  GetComplianceStatusQueryVariables
>;
export function useGetComplianceStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetComplianceStatusQuery, GetComplianceStatusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetComplianceStatusQuery, GetComplianceStatusQueryVariables>(
    GetComplianceStatusDocument,
    options,
  );
}
export type GetComplianceStatusQueryHookResult = ReturnType<typeof useGetComplianceStatusQuery>;
export type GetComplianceStatusLazyQueryHookResult = ReturnType<
  typeof useGetComplianceStatusLazyQuery
>;
export type GetComplianceStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetComplianceStatusSuspenseQuery
>;
export type GetComplianceStatusQueryResult = Apollo.QueryResult<
  GetComplianceStatusQuery,
  GetComplianceStatusQueryVariables
>;
export const GetRegulatoryQueueStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegulatoryQueueStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulatoryQueueStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'QueueStatsFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QueueStatsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlQueueStats' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoApproved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confidenceReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conflictReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safetyReview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'humanReviewPercentage' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegulatoryQueueStatsQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryQueueStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryQueueStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryQueueStatsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetRegulatoryQueueStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRegulatoryQueueStatsQuery,
    GetRegulatoryQueueStatsQueryVariables
  > &
    ({ variables: GetRegulatoryQueueStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegulatoryQueueStatsQuery, GetRegulatoryQueueStatsQueryVariables>(
    GetRegulatoryQueueStatsDocument,
    options,
  );
}
export function useGetRegulatoryQueueStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRegulatoryQueueStatsQuery,
    GetRegulatoryQueueStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegulatoryQueueStatsQuery, GetRegulatoryQueueStatsQueryVariables>(
    GetRegulatoryQueueStatsDocument,
    options,
  );
}
// @ts-ignore
export function useGetRegulatoryQueueStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRegulatoryQueueStatsQuery,
    GetRegulatoryQueueStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRegulatoryQueueStatsQuery,
  GetRegulatoryQueueStatsQueryVariables
>;
export function useGetRegulatoryQueueStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRegulatoryQueueStatsQuery,
        GetRegulatoryQueueStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRegulatoryQueueStatsQuery | undefined,
  GetRegulatoryQueueStatsQueryVariables
>;
export function useGetRegulatoryQueueStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRegulatoryQueueStatsQuery,
        GetRegulatoryQueueStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRegulatoryQueueStatsQuery,
    GetRegulatoryQueueStatsQueryVariables
  >(GetRegulatoryQueueStatsDocument, options);
}
export type GetRegulatoryQueueStatsQueryHookResult = ReturnType<
  typeof useGetRegulatoryQueueStatsQuery
>;
export type GetRegulatoryQueueStatsLazyQueryHookResult = ReturnType<
  typeof useGetRegulatoryQueueStatsLazyQuery
>;
export type GetRegulatoryQueueStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetRegulatoryQueueStatsSuspenseQuery
>;
export type GetRegulatoryQueueStatsQueryResult = Apollo.QueryResult<
  GetRegulatoryQueueStatsQuery,
  GetRegulatoryQueueStatsQueryVariables
>;
export const GetSearchAnalyticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSearchAnalytics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchAnalytics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topSearches' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'query' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgResults' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'zeroResultQueries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'query' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastSearched' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'avgDurationMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalSearches' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'searchVolume' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSearchAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetSearchAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchAnalyticsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetSearchAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSearchAnalyticsQuery, GetSearchAnalyticsQueryVariables> &
    ({ variables: GetSearchAnalyticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSearchAnalyticsQuery, GetSearchAnalyticsQueryVariables>(
    GetSearchAnalyticsDocument,
    options,
  );
}
export function useGetSearchAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSearchAnalyticsQuery,
    GetSearchAnalyticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSearchAnalyticsQuery, GetSearchAnalyticsQueryVariables>(
    GetSearchAnalyticsDocument,
    options,
  );
}
// @ts-ignore
export function useGetSearchAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSearchAnalyticsQuery,
    GetSearchAnalyticsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSearchAnalyticsQuery, GetSearchAnalyticsQueryVariables>;
export function useGetSearchAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSearchAnalyticsQuery, GetSearchAnalyticsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetSearchAnalyticsQuery | undefined,
  GetSearchAnalyticsQueryVariables
>;
export function useGetSearchAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSearchAnalyticsQuery, GetSearchAnalyticsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSearchAnalyticsQuery, GetSearchAnalyticsQueryVariables>(
    GetSearchAnalyticsDocument,
    options,
  );
}
export type GetSearchAnalyticsQueryHookResult = ReturnType<typeof useGetSearchAnalyticsQuery>;
export type GetSearchAnalyticsLazyQueryHookResult = ReturnType<
  typeof useGetSearchAnalyticsLazyQuery
>;
export type GetSearchAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useGetSearchAnalyticsSuspenseQuery
>;
export type GetSearchAnalyticsQueryResult = Apollo.QueryResult<
  GetSearchAnalyticsQuery,
  GetSearchAnalyticsQueryVariables
>;
export const GetSystemTenantStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSystemTenantStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemTenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionTier' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSystemTenantStatusQuery__
 *
 * To run a query within a React component, call `useGetSystemTenantStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemTenantStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemTenantStatusQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetSystemTenantStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSystemTenantStatusQuery,
    GetSystemTenantStatusQueryVariables
  > &
    ({ variables: GetSystemTenantStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSystemTenantStatusQuery, GetSystemTenantStatusQueryVariables>(
    GetSystemTenantStatusDocument,
    options,
  );
}
export function useGetSystemTenantStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSystemTenantStatusQuery,
    GetSystemTenantStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSystemTenantStatusQuery, GetSystemTenantStatusQueryVariables>(
    GetSystemTenantStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetSystemTenantStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSystemTenantStatusQuery,
    GetSystemTenantStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSystemTenantStatusQuery, GetSystemTenantStatusQueryVariables>;
export function useGetSystemTenantStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSystemTenantStatusQuery,
        GetSystemTenantStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSystemTenantStatusQuery | undefined,
  GetSystemTenantStatusQueryVariables
>;
export function useGetSystemTenantStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSystemTenantStatusQuery,
        GetSystemTenantStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSystemTenantStatusQuery, GetSystemTenantStatusQueryVariables>(
    GetSystemTenantStatusDocument,
    options,
  );
}
export type GetSystemTenantStatusQueryHookResult = ReturnType<typeof useGetSystemTenantStatusQuery>;
export type GetSystemTenantStatusLazyQueryHookResult = ReturnType<
  typeof useGetSystemTenantStatusLazyQuery
>;
export type GetSystemTenantStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetSystemTenantStatusSuspenseQuery
>;
export type GetSystemTenantStatusQueryResult = Apollo.QueryResult<
  GetSystemTenantStatusQuery,
  GetSystemTenantStatusQueryVariables
>;
export const ListAnalyticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAnalytics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listAnalytics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyticsFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyticsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Analytics' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metricUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticalThreshold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListAnalyticsQuery__
 *
 * To run a query within a React component, call `useListAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAnalyticsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<ListAnalyticsQuery, ListAnalyticsQueryVariables> &
    ({ variables: ListAnalyticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAnalyticsQuery, ListAnalyticsQueryVariables>(
    ListAnalyticsDocument,
    options,
  );
}
export function useListAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAnalyticsQuery, ListAnalyticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAnalyticsQuery, ListAnalyticsQueryVariables>(
    ListAnalyticsDocument,
    options,
  );
}
// @ts-ignore
export function useListAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListAnalyticsQuery, ListAnalyticsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAnalyticsQuery, ListAnalyticsQueryVariables>;
export function useListAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListAnalyticsQuery, ListAnalyticsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAnalyticsQuery | undefined, ListAnalyticsQueryVariables>;
export function useListAnalyticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListAnalyticsQuery, ListAnalyticsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListAnalyticsQuery, ListAnalyticsQueryVariables>(
    ListAnalyticsDocument,
    options,
  );
}
export type ListAnalyticsQueryHookResult = ReturnType<typeof useListAnalyticsQuery>;
export type ListAnalyticsLazyQueryHookResult = ReturnType<typeof useListAnalyticsLazyQuery>;
export type ListAnalyticsSuspenseQueryHookResult = ReturnType<typeof useListAnalyticsSuspenseQuery>;
export type ListAnalyticsQueryResult = Apollo.QueryResult<
  ListAnalyticsQuery,
  ListAnalyticsQueryVariables
>;
export const ListContractsByStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListContractsByStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlContractStatus' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listContractsByStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContractFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContractFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contract' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationAtPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'elapsedMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolutionTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalateAfterMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationChain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'breachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceRate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastBreachAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListContractsByStatusQuery__
 *
 * To run a query within a React component, call `useListContractsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContractsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContractsByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListContractsByStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListContractsByStatusQuery,
    ListContractsByStatusQueryVariables
  > &
    ({ variables: ListContractsByStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListContractsByStatusQuery, ListContractsByStatusQueryVariables>(
    ListContractsByStatusDocument,
    options,
  );
}
export function useListContractsByStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListContractsByStatusQuery,
    ListContractsByStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListContractsByStatusQuery, ListContractsByStatusQueryVariables>(
    ListContractsByStatusDocument,
    options,
  );
}
// @ts-ignore
export function useListContractsByStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListContractsByStatusQuery,
    ListContractsByStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListContractsByStatusQuery, ListContractsByStatusQueryVariables>;
export function useListContractsByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListContractsByStatusQuery,
        ListContractsByStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListContractsByStatusQuery | undefined,
  ListContractsByStatusQueryVariables
>;
export function useListContractsByStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListContractsByStatusQuery,
        ListContractsByStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListContractsByStatusQuery, ListContractsByStatusQueryVariables>(
    ListContractsByStatusDocument,
    options,
  );
}
export type ListContractsByStatusQueryHookResult = ReturnType<typeof useListContractsByStatusQuery>;
export type ListContractsByStatusLazyQueryHookResult = ReturnType<
  typeof useListContractsByStatusLazyQuery
>;
export type ListContractsByStatusSuspenseQueryHookResult = ReturnType<
  typeof useListContractsByStatusSuspenseQuery
>;
export type ListContractsByStatusQueryResult = Apollo.QueryResult<
  ListContractsByStatusQuery,
  ListContractsByStatusQueryVariables
>;
export const StatutoryDefinitionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatutoryDefinitions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statutoryDefinitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultDisplay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statuteRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chapter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirResource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ferpPrimitive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ferpRoleCategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalDefinition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acceptableAlternatives' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statutoryEdges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'edgeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statuteRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createsDelegation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conditional' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conditions' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStatutoryDefinitionsQuery__
 *
 * To run a query within a React component, call `useStatutoryDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatutoryDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatutoryDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatutoryDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StatutoryDefinitionsQuery,
    StatutoryDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StatutoryDefinitionsQuery, StatutoryDefinitionsQueryVariables>(
    StatutoryDefinitionsDocument,
    options,
  );
}
export function useStatutoryDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StatutoryDefinitionsQuery,
    StatutoryDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StatutoryDefinitionsQuery, StatutoryDefinitionsQueryVariables>(
    StatutoryDefinitionsDocument,
    options,
  );
}
// @ts-ignore
export function useStatutoryDefinitionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StatutoryDefinitionsQuery,
    StatutoryDefinitionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<StatutoryDefinitionsQuery, StatutoryDefinitionsQueryVariables>;
export function useStatutoryDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StatutoryDefinitionsQuery,
        StatutoryDefinitionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StatutoryDefinitionsQuery | undefined,
  StatutoryDefinitionsQueryVariables
>;
export function useStatutoryDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StatutoryDefinitionsQuery,
        StatutoryDefinitionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StatutoryDefinitionsQuery, StatutoryDefinitionsQueryVariables>(
    StatutoryDefinitionsDocument,
    options,
  );
}
export type StatutoryDefinitionsQueryHookResult = ReturnType<typeof useStatutoryDefinitionsQuery>;
export type StatutoryDefinitionsLazyQueryHookResult = ReturnType<
  typeof useStatutoryDefinitionsLazyQuery
>;
export type StatutoryDefinitionsSuspenseQueryHookResult = ReturnType<
  typeof useStatutoryDefinitionsSuspenseQuery
>;
export type StatutoryDefinitionsQueryResult = Apollo.QueryResult<
  StatutoryDefinitionsQuery,
  StatutoryDefinitionsQueryVariables
>;
export const StatutoryImpactAnalysisDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatutoryImpactAnalysis' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statuteSection' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statutoryImpactAnalysis' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statuteSection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'statuteSection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'statuteSection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAffected' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultDisplay' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'impactType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statuteRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'affectedEdges' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStatutoryImpactAnalysisQuery__
 *
 * To run a query within a React component, call `useStatutoryImpactAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatutoryImpactAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatutoryImpactAnalysisQuery({
 *   variables: {
 *      statuteSection: // value for 'statuteSection'
 *   },
 * });
 */
export function useStatutoryImpactAnalysisQuery(
  baseOptions: Apollo.QueryHookOptions<
    StatutoryImpactAnalysisQuery,
    StatutoryImpactAnalysisQueryVariables
  > &
    ({ variables: StatutoryImpactAnalysisQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StatutoryImpactAnalysisQuery, StatutoryImpactAnalysisQueryVariables>(
    StatutoryImpactAnalysisDocument,
    options,
  );
}
export function useStatutoryImpactAnalysisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StatutoryImpactAnalysisQuery,
    StatutoryImpactAnalysisQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StatutoryImpactAnalysisQuery, StatutoryImpactAnalysisQueryVariables>(
    StatutoryImpactAnalysisDocument,
    options,
  );
}
// @ts-ignore
export function useStatutoryImpactAnalysisSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StatutoryImpactAnalysisQuery,
    StatutoryImpactAnalysisQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  StatutoryImpactAnalysisQuery,
  StatutoryImpactAnalysisQueryVariables
>;
export function useStatutoryImpactAnalysisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StatutoryImpactAnalysisQuery,
        StatutoryImpactAnalysisQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StatutoryImpactAnalysisQuery | undefined,
  StatutoryImpactAnalysisQueryVariables
>;
export function useStatutoryImpactAnalysisSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StatutoryImpactAnalysisQuery,
        StatutoryImpactAnalysisQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StatutoryImpactAnalysisQuery,
    StatutoryImpactAnalysisQueryVariables
  >(StatutoryImpactAnalysisDocument, options);
}
export type StatutoryImpactAnalysisQueryHookResult = ReturnType<
  typeof useStatutoryImpactAnalysisQuery
>;
export type StatutoryImpactAnalysisLazyQueryHookResult = ReturnType<
  typeof useStatutoryImpactAnalysisLazyQuery
>;
export type StatutoryImpactAnalysisSuspenseQueryHookResult = ReturnType<
  typeof useStatutoryImpactAnalysisSuspenseQuery
>;
export type StatutoryImpactAnalysisQueryResult = Apollo.QueryResult<
  StatutoryImpactAnalysisQuery,
  StatutoryImpactAnalysisQueryVariables
>;
export const GetSubgraphRegistryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubgraphRegistry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSubgraphRegistry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'registeredSubgraphs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSubgraphRegistryQuery__
 *
 * To run a query within a React component, call `useGetSubgraphRegistryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubgraphRegistryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubgraphRegistryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetSubgraphRegistryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubgraphRegistryQuery,
    GetSubgraphRegistryQueryVariables
  > &
    ({ variables: GetSubgraphRegistryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubgraphRegistryQuery, GetSubgraphRegistryQueryVariables>(
    GetSubgraphRegistryDocument,
    options,
  );
}
export function useGetSubgraphRegistryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubgraphRegistryQuery,
    GetSubgraphRegistryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSubgraphRegistryQuery, GetSubgraphRegistryQueryVariables>(
    GetSubgraphRegistryDocument,
    options,
  );
}
// @ts-ignore
export function useGetSubgraphRegistrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSubgraphRegistryQuery,
    GetSubgraphRegistryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSubgraphRegistryQuery, GetSubgraphRegistryQueryVariables>;
export function useGetSubgraphRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSubgraphRegistryQuery, GetSubgraphRegistryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetSubgraphRegistryQuery | undefined,
  GetSubgraphRegistryQueryVariables
>;
export function useGetSubgraphRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSubgraphRegistryQuery, GetSubgraphRegistryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSubgraphRegistryQuery, GetSubgraphRegistryQueryVariables>(
    GetSubgraphRegistryDocument,
    options,
  );
}
export type GetSubgraphRegistryQueryHookResult = ReturnType<typeof useGetSubgraphRegistryQuery>;
export type GetSubgraphRegistryLazyQueryHookResult = ReturnType<
  typeof useGetSubgraphRegistryLazyQuery
>;
export type GetSubgraphRegistrySuspenseQueryHookResult = ReturnType<
  typeof useGetSubgraphRegistrySuspenseQuery
>;
export type GetSubgraphRegistryQueryResult = Apollo.QueryResult<
  GetSubgraphRegistryQuery,
  GetSubgraphRegistryQueryVariables
>;
export const HasSubgraphRegistryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HasSubgraphRegistry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasSubgraphRegistry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHasSubgraphRegistryQuery__
 *
 * To run a query within a React component, call `useHasSubgraphRegistryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSubgraphRegistryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSubgraphRegistryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useHasSubgraphRegistryQuery(
  baseOptions: Apollo.QueryHookOptions<
    HasSubgraphRegistryQuery,
    HasSubgraphRegistryQueryVariables
  > &
    ({ variables: HasSubgraphRegistryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HasSubgraphRegistryQuery, HasSubgraphRegistryQueryVariables>(
    HasSubgraphRegistryDocument,
    options,
  );
}
export function useHasSubgraphRegistryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasSubgraphRegistryQuery,
    HasSubgraphRegistryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HasSubgraphRegistryQuery, HasSubgraphRegistryQueryVariables>(
    HasSubgraphRegistryDocument,
    options,
  );
}
// @ts-ignore
export function useHasSubgraphRegistrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HasSubgraphRegistryQuery,
    HasSubgraphRegistryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<HasSubgraphRegistryQuery, HasSubgraphRegistryQueryVariables>;
export function useHasSubgraphRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HasSubgraphRegistryQuery, HasSubgraphRegistryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  HasSubgraphRegistryQuery | undefined,
  HasSubgraphRegistryQueryVariables
>;
export function useHasSubgraphRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HasSubgraphRegistryQuery, HasSubgraphRegistryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HasSubgraphRegistryQuery, HasSubgraphRegistryQueryVariables>(
    HasSubgraphRegistryDocument,
    options,
  );
}
export type HasSubgraphRegistryQueryHookResult = ReturnType<typeof useHasSubgraphRegistryQuery>;
export type HasSubgraphRegistryLazyQueryHookResult = ReturnType<
  typeof useHasSubgraphRegistryLazyQuery
>;
export type HasSubgraphRegistrySuspenseQueryHookResult = ReturnType<
  typeof useHasSubgraphRegistrySuspenseQuery
>;
export type HasSubgraphRegistryQueryResult = Apollo.QueryResult<
  HasSubgraphRegistryQuery,
  HasSubgraphRegistryQueryVariables
>;
export const ListEnabledSubgraphsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListEnabledSubgraphs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listEnabledSubgraphs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListEnabledSubgraphsQuery__
 *
 * To run a query within a React component, call `useListEnabledSubgraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEnabledSubgraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEnabledSubgraphsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useListEnabledSubgraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListEnabledSubgraphsQuery,
    ListEnabledSubgraphsQueryVariables
  > &
    ({ variables: ListEnabledSubgraphsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEnabledSubgraphsQuery, ListEnabledSubgraphsQueryVariables>(
    ListEnabledSubgraphsDocument,
    options,
  );
}
export function useListEnabledSubgraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEnabledSubgraphsQuery,
    ListEnabledSubgraphsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEnabledSubgraphsQuery, ListEnabledSubgraphsQueryVariables>(
    ListEnabledSubgraphsDocument,
    options,
  );
}
// @ts-ignore
export function useListEnabledSubgraphsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEnabledSubgraphsQuery,
    ListEnabledSubgraphsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEnabledSubgraphsQuery, ListEnabledSubgraphsQueryVariables>;
export function useListEnabledSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEnabledSubgraphsQuery,
        ListEnabledSubgraphsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListEnabledSubgraphsQuery | undefined,
  ListEnabledSubgraphsQueryVariables
>;
export function useListEnabledSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListEnabledSubgraphsQuery,
        ListEnabledSubgraphsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEnabledSubgraphsQuery, ListEnabledSubgraphsQueryVariables>(
    ListEnabledSubgraphsDocument,
    options,
  );
}
export type ListEnabledSubgraphsQueryHookResult = ReturnType<typeof useListEnabledSubgraphsQuery>;
export type ListEnabledSubgraphsLazyQueryHookResult = ReturnType<
  typeof useListEnabledSubgraphsLazyQuery
>;
export type ListEnabledSubgraphsSuspenseQueryHookResult = ReturnType<
  typeof useListEnabledSubgraphsSuspenseQuery
>;
export type ListEnabledSubgraphsQueryResult = Apollo.QueryResult<
  ListEnabledSubgraphsQuery,
  ListEnabledSubgraphsQueryVariables
>;
export const ListIntegrationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListIntegrations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listIntegrations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'IntegrationFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IntegrationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Integration' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'baseUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentHealthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'circuitBreakerState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListIntegrationsQuery__
 *
 * To run a query within a React component, call `useListIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIntegrationsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<ListIntegrationsQuery, ListIntegrationsQueryVariables> &
    ({ variables: ListIntegrationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListIntegrationsQuery, ListIntegrationsQueryVariables>(
    ListIntegrationsDocument,
    options,
  );
}
export function useListIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListIntegrationsQuery, ListIntegrationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListIntegrationsQuery, ListIntegrationsQueryVariables>(
    ListIntegrationsDocument,
    options,
  );
}
// @ts-ignore
export function useListIntegrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListIntegrationsQuery,
    ListIntegrationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListIntegrationsQuery, ListIntegrationsQueryVariables>;
export function useListIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListIntegrationsQuery, ListIntegrationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListIntegrationsQuery | undefined, ListIntegrationsQueryVariables>;
export function useListIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListIntegrationsQuery, ListIntegrationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListIntegrationsQuery, ListIntegrationsQueryVariables>(
    ListIntegrationsDocument,
    options,
  );
}
export type ListIntegrationsQueryHookResult = ReturnType<typeof useListIntegrationsQuery>;
export type ListIntegrationsLazyQueryHookResult = ReturnType<typeof useListIntegrationsLazyQuery>;
export type ListIntegrationsSuspenseQueryHookResult = ReturnType<
  typeof useListIntegrationsSuspenseQuery
>;
export type ListIntegrationsQueryResult = Apollo.QueryResult<
  ListIntegrationsQuery,
  ListIntegrationsQueryVariables
>;
export const ValidateSubgraphReferenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateSubgraphReference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ValidateSubgraphReferenceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateSubgraphReference' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useValidateSubgraphReferenceQuery__
 *
 * To run a query within a React component, call `useValidateSubgraphReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSubgraphReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSubgraphReferenceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateSubgraphReferenceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateSubgraphReferenceQuery,
    ValidateSubgraphReferenceQueryVariables
  > &
    ({ variables: ValidateSubgraphReferenceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidateSubgraphReferenceQuery, ValidateSubgraphReferenceQueryVariables>(
    ValidateSubgraphReferenceDocument,
    options,
  );
}
export function useValidateSubgraphReferenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateSubgraphReferenceQuery,
    ValidateSubgraphReferenceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValidateSubgraphReferenceQuery,
    ValidateSubgraphReferenceQueryVariables
  >(ValidateSubgraphReferenceDocument, options);
}
// @ts-ignore
export function useValidateSubgraphReferenceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidateSubgraphReferenceQuery,
    ValidateSubgraphReferenceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ValidateSubgraphReferenceQuery,
  ValidateSubgraphReferenceQueryVariables
>;
export function useValidateSubgraphReferenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateSubgraphReferenceQuery,
        ValidateSubgraphReferenceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ValidateSubgraphReferenceQuery | undefined,
  ValidateSubgraphReferenceQueryVariables
>;
export function useValidateSubgraphReferenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateSubgraphReferenceQuery,
        ValidateSubgraphReferenceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ValidateSubgraphReferenceQuery,
    ValidateSubgraphReferenceQueryVariables
  >(ValidateSubgraphReferenceDocument, options);
}
export type ValidateSubgraphReferenceQueryHookResult = ReturnType<
  typeof useValidateSubgraphReferenceQuery
>;
export type ValidateSubgraphReferenceLazyQueryHookResult = ReturnType<
  typeof useValidateSubgraphReferenceLazyQuery
>;
export type ValidateSubgraphReferenceSuspenseQueryHookResult = ReturnType<
  typeof useValidateSubgraphReferenceSuspenseQuery
>;
export type ValidateSubgraphReferenceQueryResult = Apollo.QueryResult<
  ValidateSubgraphReferenceQuery,
  ValidateSubgraphReferenceQueryVariables
>;
export const ListTransactionsByTenantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTransactionsByTenant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastEvaluatedKey' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listTransactionsByTenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastEvaluatedKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastEvaluatedKey' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TransactionFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Transaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'transactionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isolationLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'committedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListTransactionsByTenantQuery__
 *
 * To run a query within a React component, call `useListTransactionsByTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionsByTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionsByTenantQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      lastEvaluatedKey: // value for 'lastEvaluatedKey'
 *   },
 * });
 */
export function useListTransactionsByTenantQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTransactionsByTenantQuery,
    ListTransactionsByTenantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTransactionsByTenantQuery, ListTransactionsByTenantQueryVariables>(
    ListTransactionsByTenantDocument,
    options,
  );
}
export function useListTransactionsByTenantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTransactionsByTenantQuery,
    ListTransactionsByTenantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTransactionsByTenantQuery, ListTransactionsByTenantQueryVariables>(
    ListTransactionsByTenantDocument,
    options,
  );
}
// @ts-ignore
export function useListTransactionsByTenantSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTransactionsByTenantQuery,
    ListTransactionsByTenantQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListTransactionsByTenantQuery,
  ListTransactionsByTenantQueryVariables
>;
export function useListTransactionsByTenantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTransactionsByTenantQuery,
        ListTransactionsByTenantQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListTransactionsByTenantQuery | undefined,
  ListTransactionsByTenantQueryVariables
>;
export function useListTransactionsByTenantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTransactionsByTenantQuery,
        ListTransactionsByTenantQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTransactionsByTenantQuery,
    ListTransactionsByTenantQueryVariables
  >(ListTransactionsByTenantDocument, options);
}
export type ListTransactionsByTenantQueryHookResult = ReturnType<
  typeof useListTransactionsByTenantQuery
>;
export type ListTransactionsByTenantLazyQueryHookResult = ReturnType<
  typeof useListTransactionsByTenantLazyQuery
>;
export type ListTransactionsByTenantSuspenseQueryHookResult = ReturnType<
  typeof useListTransactionsByTenantSuspenseQuery
>;
export type ListTransactionsByTenantQueryResult = Apollo.QueryResult<
  ListTransactionsByTenantQuery,
  ListTransactionsByTenantQueryVariables
>;
export const SagaDefinitionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SagaDefinition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sagaId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sagaDefinition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sagaId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sagaId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SagaFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SagaFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SagaDefinitionGQL' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sagaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSagaDefinitionQuery__
 *
 * To run a query within a React component, call `useSagaDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSagaDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSagaDefinitionQuery({
 *   variables: {
 *      sagaId: // value for 'sagaId'
 *   },
 * });
 */
export function useSagaDefinitionQuery(
  baseOptions: Apollo.QueryHookOptions<SagaDefinitionQuery, SagaDefinitionQueryVariables> &
    ({ variables: SagaDefinitionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SagaDefinitionQuery, SagaDefinitionQueryVariables>(
    SagaDefinitionDocument,
    options,
  );
}
export function useSagaDefinitionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SagaDefinitionQuery, SagaDefinitionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SagaDefinitionQuery, SagaDefinitionQueryVariables>(
    SagaDefinitionDocument,
    options,
  );
}
// @ts-ignore
export function useSagaDefinitionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SagaDefinitionQuery, SagaDefinitionQueryVariables>,
): Apollo.UseSuspenseQueryResult<SagaDefinitionQuery, SagaDefinitionQueryVariables>;
export function useSagaDefinitionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SagaDefinitionQuery, SagaDefinitionQueryVariables>,
): Apollo.UseSuspenseQueryResult<SagaDefinitionQuery | undefined, SagaDefinitionQueryVariables>;
export function useSagaDefinitionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SagaDefinitionQuery, SagaDefinitionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SagaDefinitionQuery, SagaDefinitionQueryVariables>(
    SagaDefinitionDocument,
    options,
  );
}
export type SagaDefinitionQueryHookResult = ReturnType<typeof useSagaDefinitionQuery>;
export type SagaDefinitionLazyQueryHookResult = ReturnType<typeof useSagaDefinitionLazyQuery>;
export type SagaDefinitionSuspenseQueryHookResult = ReturnType<
  typeof useSagaDefinitionSuspenseQuery
>;
export type SagaDefinitionQueryResult = Apollo.QueryResult<
  SagaDefinitionQuery,
  SagaDefinitionQueryVariables
>;
export const SagaDefinitionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SagaDefinitions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sagaDefinitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SagaFields' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SagaFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SagaDefinitionGQL' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sagaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSagaDefinitionsQuery__
 *
 * To run a query within a React component, call `useSagaDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSagaDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSagaDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSagaDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>(
    SagaDefinitionsDocument,
    options,
  );
}
export function useSagaDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>(
    SagaDefinitionsDocument,
    options,
  );
}
// @ts-ignore
export function useSagaDefinitionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SagaDefinitionsQuery,
    SagaDefinitionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>;
export function useSagaDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SagaDefinitionsQuery | undefined, SagaDefinitionsQueryVariables>;
export function useSagaDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SagaDefinitionsQuery, SagaDefinitionsQueryVariables>(
    SagaDefinitionsDocument,
    options,
  );
}
export type SagaDefinitionsQueryHookResult = ReturnType<typeof useSagaDefinitionsQuery>;
export type SagaDefinitionsLazyQueryHookResult = ReturnType<typeof useSagaDefinitionsLazyQuery>;
export type SagaDefinitionsSuspenseQueryHookResult = ReturnType<
  typeof useSagaDefinitionsSuspenseQuery
>;
export type SagaDefinitionsQueryResult = Apollo.QueryResult<
  SagaDefinitionsQuery,
  SagaDefinitionsQueryVariables
>;
export const GetContractDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContract' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contractId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContract' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflowInstanceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflowInstanceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contractId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContractFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContractFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contract' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationAtPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'elapsedMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolutionTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalateAfterMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationChain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'breachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceRate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastBreachAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContractQuery__
 *
 * To run a query within a React component, call `useGetContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractQuery({
 *   variables: {
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractQuery(
  baseOptions: Apollo.QueryHookOptions<GetContractQuery, GetContractQueryVariables> &
    ({ variables: GetContractQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
}
export function useGetContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetContractQuery, GetContractQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContractQuery, GetContractQueryVariables>(
    GetContractDocument,
    options,
  );
}
// @ts-ignore
export function useGetContractSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetContractQuery, GetContractQueryVariables>;
export function useGetContractSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetContractQuery | undefined, GetContractQueryVariables>;
export function useGetContractSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContractQuery, GetContractQueryVariables>(
    GetContractDocument,
    options,
  );
}
export type GetContractQueryHookResult = ReturnType<typeof useGetContractQuery>;
export type GetContractLazyQueryHookResult = ReturnType<typeof useGetContractLazyQuery>;
export type GetContractSuspenseQueryHookResult = ReturnType<typeof useGetContractSuspenseQuery>;
export type GetContractQueryResult = Apollo.QueryResult<
  GetContractQuery,
  GetContractQueryVariables
>;
export const GetContractByExternalIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContractByExternalId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContractByExternalId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContractFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContractFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contract' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationAtPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'elapsedMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolutionTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalateAfterMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationChain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'breachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceRate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastBreachAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContractByExternalIdQuery__
 *
 * To run a query within a React component, call `useGetContractByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractByExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractByExternalIdQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useGetContractByExternalIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractByExternalIdQuery,
    GetContractByExternalIdQueryVariables
  > &
    ({ variables: GetContractByExternalIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContractByExternalIdQuery, GetContractByExternalIdQueryVariables>(
    GetContractByExternalIdDocument,
    options,
  );
}
export function useGetContractByExternalIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractByExternalIdQuery,
    GetContractByExternalIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContractByExternalIdQuery, GetContractByExternalIdQueryVariables>(
    GetContractByExternalIdDocument,
    options,
  );
}
// @ts-ignore
export function useGetContractByExternalIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractByExternalIdQuery,
    GetContractByExternalIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetContractByExternalIdQuery,
  GetContractByExternalIdQueryVariables
>;
export function useGetContractByExternalIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetContractByExternalIdQuery,
        GetContractByExternalIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetContractByExternalIdQuery | undefined,
  GetContractByExternalIdQueryVariables
>;
export function useGetContractByExternalIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetContractByExternalIdQuery,
        GetContractByExternalIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractByExternalIdQuery,
    GetContractByExternalIdQueryVariables
  >(GetContractByExternalIdDocument, options);
}
export type GetContractByExternalIdQueryHookResult = ReturnType<
  typeof useGetContractByExternalIdQuery
>;
export type GetContractByExternalIdLazyQueryHookResult = ReturnType<
  typeof useGetContractByExternalIdLazyQuery
>;
export type GetContractByExternalIdSuspenseQueryHookResult = ReturnType<
  typeof useGetContractByExternalIdSuspenseQuery
>;
export type GetContractByExternalIdQueryResult = Apollo.QueryResult<
  GetContractByExternalIdQuery,
  GetContractByExternalIdQueryVariables
>;
export const GetContractBySlugDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContractBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContractBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContractFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContractFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contract' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slaName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workflowInstanceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationActorIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationChannels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationAtPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'elapsedMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paused' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responseTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resolutionTimeMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'warningThresholdPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalateAfterMinutes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalationChain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'breachCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'complianceRate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastBreachAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'compressedId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContractBySlugQuery__
 *
 * To run a query within a React component, call `useGetContractBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetContractBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<GetContractBySlugQuery, GetContractBySlugQueryVariables> &
    ({ variables: GetContractBySlugQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContractBySlugQuery, GetContractBySlugQueryVariables>(
    GetContractBySlugDocument,
    options,
  );
}
export function useGetContractBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractBySlugQuery,
    GetContractBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContractBySlugQuery, GetContractBySlugQueryVariables>(
    GetContractBySlugDocument,
    options,
  );
}
// @ts-ignore
export function useGetContractBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractBySlugQuery,
    GetContractBySlugQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetContractBySlugQuery, GetContractBySlugQueryVariables>;
export function useGetContractBySlugSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContractBySlugQuery, GetContractBySlugQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetContractBySlugQuery | undefined,
  GetContractBySlugQueryVariables
>;
export function useGetContractBySlugSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetContractBySlugQuery, GetContractBySlugQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetContractBySlugQuery, GetContractBySlugQueryVariables>(
    GetContractBySlugDocument,
    options,
  );
}
export type GetContractBySlugQueryHookResult = ReturnType<typeof useGetContractBySlugQuery>;
export type GetContractBySlugLazyQueryHookResult = ReturnType<typeof useGetContractBySlugLazyQuery>;
export type GetContractBySlugSuspenseQueryHookResult = ReturnType<
  typeof useGetContractBySlugSuspenseQuery
>;
export type GetContractBySlugQueryResult = Apollo.QueryResult<
  GetContractBySlugQuery,
  GetContractBySlugQueryVariables
>;
export const GetDependencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDependency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dependencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dependencyApiGetDependency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dependencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dependencyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DependencyFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DependencyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Dependency' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dependencyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isConditional' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDependencyQuery__
 *
 * To run a query within a React component, call `useGetDependencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDependencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDependencyQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      dependencyId: // value for 'dependencyId'
 *   },
 * });
 */
export function useGetDependencyQuery(
  baseOptions: Apollo.QueryHookOptions<GetDependencyQuery, GetDependencyQueryVariables> &
    ({ variables: GetDependencyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDependencyQuery, GetDependencyQueryVariables>(
    GetDependencyDocument,
    options,
  );
}
export function useGetDependencyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDependencyQuery, GetDependencyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDependencyQuery, GetDependencyQueryVariables>(
    GetDependencyDocument,
    options,
  );
}
// @ts-ignore
export function useGetDependencySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDependencyQuery, GetDependencyQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDependencyQuery, GetDependencyQueryVariables>;
export function useGetDependencySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDependencyQuery, GetDependencyQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDependencyQuery | undefined, GetDependencyQueryVariables>;
export function useGetDependencySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDependencyQuery, GetDependencyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDependencyQuery, GetDependencyQueryVariables>(
    GetDependencyDocument,
    options,
  );
}
export type GetDependencyQueryHookResult = ReturnType<typeof useGetDependencyQuery>;
export type GetDependencyLazyQueryHookResult = ReturnType<typeof useGetDependencyLazyQuery>;
export type GetDependencySuspenseQueryHookResult = ReturnType<typeof useGetDependencySuspenseQuery>;
export type GetDependencyQueryResult = Apollo.QueryResult<
  GetDependencyQuery,
  GetDependencyQueryVariables
>;
export const ActiveSystemTenantsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActiveSystemTenants' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeSystemTenants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionTier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxWorkflows' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryContactName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryContactEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActiveSystemTenantsQuery__
 *
 * To run a query within a React component, call `useActiveSystemTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveSystemTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSystemTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveSystemTenantsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActiveSystemTenantsQuery,
    ActiveSystemTenantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActiveSystemTenantsQuery, ActiveSystemTenantsQueryVariables>(
    ActiveSystemTenantsDocument,
    options,
  );
}
export function useActiveSystemTenantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveSystemTenantsQuery,
    ActiveSystemTenantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActiveSystemTenantsQuery, ActiveSystemTenantsQueryVariables>(
    ActiveSystemTenantsDocument,
    options,
  );
}
// @ts-ignore
export function useActiveSystemTenantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActiveSystemTenantsQuery,
    ActiveSystemTenantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActiveSystemTenantsQuery, ActiveSystemTenantsQueryVariables>;
export function useActiveSystemTenantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveSystemTenantsQuery, ActiveSystemTenantsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ActiveSystemTenantsQuery | undefined,
  ActiveSystemTenantsQueryVariables
>;
export function useActiveSystemTenantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveSystemTenantsQuery, ActiveSystemTenantsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActiveSystemTenantsQuery, ActiveSystemTenantsQueryVariables>(
    ActiveSystemTenantsDocument,
    options,
  );
}
export type ActiveSystemTenantsQueryHookResult = ReturnType<typeof useActiveSystemTenantsQuery>;
export type ActiveSystemTenantsLazyQueryHookResult = ReturnType<
  typeof useActiveSystemTenantsLazyQuery
>;
export type ActiveSystemTenantsSuspenseQueryHookResult = ReturnType<
  typeof useActiveSystemTenantsSuspenseQuery
>;
export type ActiveSystemTenantsQueryResult = Apollo.QueryResult<
  ActiveSystemTenantsQuery,
  ActiveSystemTenantsQueryVariables
>;
export const ApplyStandardsPackQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplyStandardsPackQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplyStandardsPackInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyStandardsPack' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'packId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appliedRules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conflictsDetected' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'resolution' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useApplyStandardsPackQueryQuery__
 *
 * To run a query within a React component, call `useApplyStandardsPackQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyStandardsPackQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyStandardsPackQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyStandardsPackQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApplyStandardsPackQueryQuery,
    ApplyStandardsPackQueryQueryVariables
  > &
    ({ variables: ApplyStandardsPackQueryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApplyStandardsPackQueryQuery, ApplyStandardsPackQueryQueryVariables>(
    ApplyStandardsPackQueryDocument,
    options,
  );
}
export function useApplyStandardsPackQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplyStandardsPackQueryQuery,
    ApplyStandardsPackQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ApplyStandardsPackQueryQuery, ApplyStandardsPackQueryQueryVariables>(
    ApplyStandardsPackQueryDocument,
    options,
  );
}
// @ts-ignore
export function useApplyStandardsPackQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApplyStandardsPackQueryQuery,
    ApplyStandardsPackQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ApplyStandardsPackQueryQuery,
  ApplyStandardsPackQueryQueryVariables
>;
export function useApplyStandardsPackQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApplyStandardsPackQueryQuery,
        ApplyStandardsPackQueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ApplyStandardsPackQueryQuery | undefined,
  ApplyStandardsPackQueryQueryVariables
>;
export function useApplyStandardsPackQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApplyStandardsPackQueryQuery,
        ApplyStandardsPackQueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ApplyStandardsPackQueryQuery,
    ApplyStandardsPackQueryQueryVariables
  >(ApplyStandardsPackQueryDocument, options);
}
export type ApplyStandardsPackQueryQueryHookResult = ReturnType<
  typeof useApplyStandardsPackQueryQuery
>;
export type ApplyStandardsPackQueryLazyQueryHookResult = ReturnType<
  typeof useApplyStandardsPackQueryLazyQuery
>;
export type ApplyStandardsPackQuerySuspenseQueryHookResult = ReturnType<
  typeof useApplyStandardsPackQuerySuspenseQuery
>;
export type ApplyStandardsPackQueryQueryResult = Apollo.QueryResult<
  ApplyStandardsPackQueryQuery,
  ApplyStandardsPackQueryQueryVariables
>;
export const BeaconsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Beacons' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'beacons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'beaconId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beaconUuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'major' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zoneId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beaconType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'batteryMv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastRssi' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSeen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBeaconsQuery__
 *
 * To run a query within a React component, call `useBeaconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeaconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeaconsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useBeaconsQuery(
  baseOptions: Apollo.QueryHookOptions<BeaconsQuery, BeaconsQueryVariables> &
    ({ variables: BeaconsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BeaconsQuery, BeaconsQueryVariables>(BeaconsDocument, options);
}
export function useBeaconsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BeaconsQuery, BeaconsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BeaconsQuery, BeaconsQueryVariables>(BeaconsDocument, options);
}
// @ts-ignore
export function useBeaconsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<BeaconsQuery, BeaconsQueryVariables>,
): Apollo.UseSuspenseQueryResult<BeaconsQuery, BeaconsQueryVariables>;
export function useBeaconsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BeaconsQuery, BeaconsQueryVariables>,
): Apollo.UseSuspenseQueryResult<BeaconsQuery | undefined, BeaconsQueryVariables>;
export function useBeaconsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BeaconsQuery, BeaconsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<BeaconsQuery, BeaconsQueryVariables>(BeaconsDocument, options);
}
export type BeaconsQueryHookResult = ReturnType<typeof useBeaconsQuery>;
export type BeaconsLazyQueryHookResult = ReturnType<typeof useBeaconsLazyQuery>;
export type BeaconsSuspenseQueryHookResult = ReturnType<typeof useBeaconsSuspenseQuery>;
export type BeaconsQueryResult = Apollo.QueryResult<BeaconsQuery, BeaconsQueryVariables>;
export const ChainVerificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChainVerification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chainVerification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entriesVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstBrokenLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'genesisDeviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'genesisActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'genesisTimestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chainLength' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useChainVerificationQuery__
 *
 * To run a query within a React component, call `useChainVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useChainVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChainVerificationQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useChainVerificationQuery(
  baseOptions: Apollo.QueryHookOptions<ChainVerificationQuery, ChainVerificationQueryVariables> &
    ({ variables: ChainVerificationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChainVerificationQuery, ChainVerificationQueryVariables>(
    ChainVerificationDocument,
    options,
  );
}
export function useChainVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChainVerificationQuery,
    ChainVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChainVerificationQuery, ChainVerificationQueryVariables>(
    ChainVerificationDocument,
    options,
  );
}
// @ts-ignore
export function useChainVerificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChainVerificationQuery,
    ChainVerificationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ChainVerificationQuery, ChainVerificationQueryVariables>;
export function useChainVerificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChainVerificationQuery, ChainVerificationQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ChainVerificationQuery | undefined,
  ChainVerificationQueryVariables
>;
export function useChainVerificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChainVerificationQuery, ChainVerificationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChainVerificationQuery, ChainVerificationQueryVariables>(
    ChainVerificationDocument,
    options,
  );
}
export type ChainVerificationQueryHookResult = ReturnType<typeof useChainVerificationQuery>;
export type ChainVerificationLazyQueryHookResult = ReturnType<typeof useChainVerificationLazyQuery>;
export type ChainVerificationSuspenseQueryHookResult = ReturnType<
  typeof useChainVerificationSuspenseQuery
>;
export type ChainVerificationQueryResult = Apollo.QueryResult<
  ChainVerificationQuery,
  ChainVerificationQueryVariables
>;
export const ConfigEdgesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConfigEdges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'edgeType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'configEdges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'configId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'edgeType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'edgeType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edgeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inverseType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ring' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConfigEdgesQuery__
 *
 * To run a query within a React component, call `useConfigEdgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigEdgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigEdgesQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      edgeType: // value for 'edgeType'
 *   },
 * });
 */
export function useConfigEdgesQuery(
  baseOptions: Apollo.QueryHookOptions<ConfigEdgesQuery, ConfigEdgesQueryVariables> &
    ({ variables: ConfigEdgesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConfigEdgesQuery, ConfigEdgesQueryVariables>(ConfigEdgesDocument, options);
}
export function useConfigEdgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConfigEdgesQuery, ConfigEdgesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConfigEdgesQuery, ConfigEdgesQueryVariables>(
    ConfigEdgesDocument,
    options,
  );
}
// @ts-ignore
export function useConfigEdgesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ConfigEdgesQuery, ConfigEdgesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConfigEdgesQuery, ConfigEdgesQueryVariables>;
export function useConfigEdgesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigEdgesQuery, ConfigEdgesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConfigEdgesQuery | undefined, ConfigEdgesQueryVariables>;
export function useConfigEdgesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigEdgesQuery, ConfigEdgesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConfigEdgesQuery, ConfigEdgesQueryVariables>(
    ConfigEdgesDocument,
    options,
  );
}
export type ConfigEdgesQueryHookResult = ReturnType<typeof useConfigEdgesQuery>;
export type ConfigEdgesLazyQueryHookResult = ReturnType<typeof useConfigEdgesLazyQuery>;
export type ConfigEdgesSuspenseQueryHookResult = ReturnType<typeof useConfigEdgesSuspenseQuery>;
export type ConfigEdgesQueryResult = Apollo.QueryResult<
  ConfigEdgesQuery,
  ConfigEdgesQueryVariables
>;
export const ConfigReverseEdgesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConfigReverseEdges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'inverseType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'configReverseEdges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'configId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inverseType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'inverseType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edgeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inverseType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ring' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConfigReverseEdgesQuery__
 *
 * To run a query within a React component, call `useConfigReverseEdgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigReverseEdgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigReverseEdgesQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      inverseType: // value for 'inverseType'
 *   },
 * });
 */
export function useConfigReverseEdgesQuery(
  baseOptions: Apollo.QueryHookOptions<ConfigReverseEdgesQuery, ConfigReverseEdgesQueryVariables> &
    ({ variables: ConfigReverseEdgesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConfigReverseEdgesQuery, ConfigReverseEdgesQueryVariables>(
    ConfigReverseEdgesDocument,
    options,
  );
}
export function useConfigReverseEdgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConfigReverseEdgesQuery,
    ConfigReverseEdgesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConfigReverseEdgesQuery, ConfigReverseEdgesQueryVariables>(
    ConfigReverseEdgesDocument,
    options,
  );
}
// @ts-ignore
export function useConfigReverseEdgesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConfigReverseEdgesQuery,
    ConfigReverseEdgesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ConfigReverseEdgesQuery, ConfigReverseEdgesQueryVariables>;
export function useConfigReverseEdgesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigReverseEdgesQuery, ConfigReverseEdgesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ConfigReverseEdgesQuery | undefined,
  ConfigReverseEdgesQueryVariables
>;
export function useConfigReverseEdgesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigReverseEdgesQuery, ConfigReverseEdgesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConfigReverseEdgesQuery, ConfigReverseEdgesQueryVariables>(
    ConfigReverseEdgesDocument,
    options,
  );
}
export type ConfigReverseEdgesQueryHookResult = ReturnType<typeof useConfigReverseEdgesQuery>;
export type ConfigReverseEdgesLazyQueryHookResult = ReturnType<
  typeof useConfigReverseEdgesLazyQuery
>;
export type ConfigReverseEdgesSuspenseQueryHookResult = ReturnType<
  typeof useConfigReverseEdgesSuspenseQuery
>;
export type ConfigReverseEdgesQueryResult = Apollo.QueryResult<
  ConfigReverseEdgesQuery,
  ConfigReverseEdgesQueryVariables
>;
export const ConfigTypeRegistryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConfigTypeRegistry' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'configTypeRegistry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filenamePrefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filenameTemplate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filenamePattern' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idField' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacySk' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skVerbose' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skCompressed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceDirs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seedLoader' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dimensions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mapsTo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'examples' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConfigTypeRegistryQuery__
 *
 * To run a query within a React component, call `useConfigTypeRegistryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigTypeRegistryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigTypeRegistryQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigTypeRegistryQuery(
  baseOptions?: Apollo.QueryHookOptions<ConfigTypeRegistryQuery, ConfigTypeRegistryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConfigTypeRegistryQuery, ConfigTypeRegistryQueryVariables>(
    ConfigTypeRegistryDocument,
    options,
  );
}
export function useConfigTypeRegistryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConfigTypeRegistryQuery,
    ConfigTypeRegistryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConfigTypeRegistryQuery, ConfigTypeRegistryQueryVariables>(
    ConfigTypeRegistryDocument,
    options,
  );
}
// @ts-ignore
export function useConfigTypeRegistrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConfigTypeRegistryQuery,
    ConfigTypeRegistryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ConfigTypeRegistryQuery, ConfigTypeRegistryQueryVariables>;
export function useConfigTypeRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigTypeRegistryQuery, ConfigTypeRegistryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ConfigTypeRegistryQuery | undefined,
  ConfigTypeRegistryQueryVariables
>;
export function useConfigTypeRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConfigTypeRegistryQuery, ConfigTypeRegistryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConfigTypeRegistryQuery, ConfigTypeRegistryQueryVariables>(
    ConfigTypeRegistryDocument,
    options,
  );
}
export type ConfigTypeRegistryQueryHookResult = ReturnType<typeof useConfigTypeRegistryQuery>;
export type ConfigTypeRegistryLazyQueryHookResult = ReturnType<
  typeof useConfigTypeRegistryLazyQuery
>;
export type ConfigTypeRegistrySuspenseQueryHookResult = ReturnType<
  typeof useConfigTypeRegistrySuspenseQuery
>;
export type ConfigTypeRegistryQueryResult = Apollo.QueryResult<
  ConfigTypeRegistryQuery,
  ConfigTypeRegistryQueryVariables
>;
export const ElopementAlertsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ElopementAlerts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'unacknowledgedOnly' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'elopementAlerts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unacknowledgedOnly' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'unacknowledgedOnly' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectActorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beaconId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'triggerZoneId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSafeZoneId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledged' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useElopementAlertsQuery__
 *
 * To run a query within a React component, call `useElopementAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useElopementAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useElopementAlertsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *      unacknowledgedOnly: // value for 'unacknowledgedOnly'
 *   },
 * });
 */
export function useElopementAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<ElopementAlertsQuery, ElopementAlertsQueryVariables> &
    ({ variables: ElopementAlertsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ElopementAlertsQuery, ElopementAlertsQueryVariables>(
    ElopementAlertsDocument,
    options,
  );
}
export function useElopementAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ElopementAlertsQuery, ElopementAlertsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ElopementAlertsQuery, ElopementAlertsQueryVariables>(
    ElopementAlertsDocument,
    options,
  );
}
// @ts-ignore
export function useElopementAlertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ElopementAlertsQuery,
    ElopementAlertsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ElopementAlertsQuery, ElopementAlertsQueryVariables>;
export function useElopementAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ElopementAlertsQuery, ElopementAlertsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ElopementAlertsQuery | undefined, ElopementAlertsQueryVariables>;
export function useElopementAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ElopementAlertsQuery, ElopementAlertsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ElopementAlertsQuery, ElopementAlertsQueryVariables>(
    ElopementAlertsDocument,
    options,
  );
}
export type ElopementAlertsQueryHookResult = ReturnType<typeof useElopementAlertsQuery>;
export type ElopementAlertsLazyQueryHookResult = ReturnType<typeof useElopementAlertsLazyQuery>;
export type ElopementAlertsSuspenseQueryHookResult = ReturnType<
  typeof useElopementAlertsSuspenseQuery
>;
export type ElopementAlertsQueryResult = Apollo.QueryResult<
  ElopementAlertsQuery,
  ElopementAlertsQueryVariables
>;
export const EntityJourneyGraphDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityJourneyGraph' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsTaskEntityJourneyGraph' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalNodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intersectionInstanceIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nodeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actorRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceNodeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetNodeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'edgeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEntityJourneyGraphQuery__
 *
 * To run a query within a React component, call `useEntityJourneyGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityJourneyGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityJourneyGraphQuery({
 *   variables: {
 *      actorIds: // value for 'actorIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEntityJourneyGraphQuery(
  baseOptions: Apollo.QueryHookOptions<EntityJourneyGraphQuery, EntityJourneyGraphQueryVariables> &
    ({ variables: EntityJourneyGraphQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EntityJourneyGraphQuery, EntityJourneyGraphQueryVariables>(
    EntityJourneyGraphDocument,
    options,
  );
}
export function useEntityJourneyGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntityJourneyGraphQuery,
    EntityJourneyGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EntityJourneyGraphQuery, EntityJourneyGraphQueryVariables>(
    EntityJourneyGraphDocument,
    options,
  );
}
// @ts-ignore
export function useEntityJourneyGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntityJourneyGraphQuery,
    EntityJourneyGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EntityJourneyGraphQuery, EntityJourneyGraphQueryVariables>;
export function useEntityJourneyGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntityJourneyGraphQuery, EntityJourneyGraphQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  EntityJourneyGraphQuery | undefined,
  EntityJourneyGraphQueryVariables
>;
export function useEntityJourneyGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntityJourneyGraphQuery, EntityJourneyGraphQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EntityJourneyGraphQuery, EntityJourneyGraphQueryVariables>(
    EntityJourneyGraphDocument,
    options,
  );
}
export type EntityJourneyGraphQueryHookResult = ReturnType<typeof useEntityJourneyGraphQuery>;
export type EntityJourneyGraphLazyQueryHookResult = ReturnType<
  typeof useEntityJourneyGraphLazyQuery
>;
export type EntityJourneyGraphSuspenseQueryHookResult = ReturnType<
  typeof useEntityJourneyGraphSuspenseQuery
>;
export type EntityJourneyGraphQueryResult = Apollo.QueryResult<
  EntityJourneyGraphQuery,
  EntityJourneyGraphQueryVariables
>;
export const FormSchemaQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FormSchemaQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formSchema' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'helpText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumTier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'piiClassification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'auditRequired' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expression' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fields' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'submitLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cancelLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showProgress' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'views' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fetchQuery' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createMutation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updateMutation' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFormSchemaQueryQuery__
 *
 * To run a query within a React component, call `useFormSchemaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSchemaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSchemaQueryQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useFormSchemaQueryQuery(
  baseOptions: Apollo.QueryHookOptions<FormSchemaQueryQuery, FormSchemaQueryQueryVariables> &
    ({ variables: FormSchemaQueryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FormSchemaQueryQuery, FormSchemaQueryQueryVariables>(
    FormSchemaQueryDocument,
    options,
  );
}
export function useFormSchemaQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FormSchemaQueryQuery, FormSchemaQueryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FormSchemaQueryQuery, FormSchemaQueryQueryVariables>(
    FormSchemaQueryDocument,
    options,
  );
}
// @ts-ignore
export function useFormSchemaQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FormSchemaQueryQuery,
    FormSchemaQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FormSchemaQueryQuery, FormSchemaQueryQueryVariables>;
export function useFormSchemaQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FormSchemaQueryQuery, FormSchemaQueryQueryVariables>,
): Apollo.UseSuspenseQueryResult<FormSchemaQueryQuery | undefined, FormSchemaQueryQueryVariables>;
export function useFormSchemaQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FormSchemaQueryQuery, FormSchemaQueryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FormSchemaQueryQuery, FormSchemaQueryQueryVariables>(
    FormSchemaQueryDocument,
    options,
  );
}
export type FormSchemaQueryQueryHookResult = ReturnType<typeof useFormSchemaQueryQuery>;
export type FormSchemaQueryLazyQueryHookResult = ReturnType<typeof useFormSchemaQueryLazyQuery>;
export type FormSchemaQuerySuspenseQueryHookResult = ReturnType<
  typeof useFormSchemaQuerySuspenseQuery
>;
export type FormSchemaQueryQueryResult = Apollo.QueryResult<
  FormSchemaQueryQuery,
  FormSchemaQueryQueryVariables
>;
export const FormSchemasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FormSchemas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formSchemas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FormSchemaFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FormSchemaFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FormSchema' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFormSchemasQuery__
 *
 * To run a query within a React component, call `useFormSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSchemasQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *   },
 * });
 */
export function useFormSchemasQuery(
  baseOptions: Apollo.QueryHookOptions<FormSchemasQuery, FormSchemasQueryVariables> &
    ({ variables: FormSchemasQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FormSchemasQuery, FormSchemasQueryVariables>(FormSchemasDocument, options);
}
export function useFormSchemasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FormSchemasQuery, FormSchemasQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FormSchemasQuery, FormSchemasQueryVariables>(
    FormSchemasDocument,
    options,
  );
}
// @ts-ignore
export function useFormSchemasSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<FormSchemasQuery, FormSchemasQueryVariables>,
): Apollo.UseSuspenseQueryResult<FormSchemasQuery, FormSchemasQueryVariables>;
export function useFormSchemasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FormSchemasQuery, FormSchemasQueryVariables>,
): Apollo.UseSuspenseQueryResult<FormSchemasQuery | undefined, FormSchemasQueryVariables>;
export function useFormSchemasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FormSchemasQuery, FormSchemasQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FormSchemasQuery, FormSchemasQueryVariables>(
    FormSchemasDocument,
    options,
  );
}
export type FormSchemasQueryHookResult = ReturnType<typeof useFormSchemasQuery>;
export type FormSchemasLazyQueryHookResult = ReturnType<typeof useFormSchemasLazyQuery>;
export type FormSchemasSuspenseQueryHookResult = ReturnType<typeof useFormSchemasSuspenseQuery>;
export type FormSchemasQueryResult = Apollo.QueryResult<
  FormSchemasQuery,
  FormSchemasQueryVariables
>;
export const GetAssessmentAccumulatorSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAssessmentAccumulatorSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'residentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentAccumulatorSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'residentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'residentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'residentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldsWithDrift' } },
                { kind: 'Field', name: { kind: 'Name', value: 'majorDriftFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgConfidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'daysSinceAssessment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAssessmentAccumulatorSummaryQuery__
 *
 * To run a query within a React component, call `useGetAssessmentAccumulatorSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentAccumulatorSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentAccumulatorSummaryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      residentId: // value for 'residentId'
 *   },
 * });
 */
export function useGetAssessmentAccumulatorSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssessmentAccumulatorSummaryQuery,
    GetAssessmentAccumulatorSummaryQueryVariables
  > &
    (
      | { variables: GetAssessmentAccumulatorSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssessmentAccumulatorSummaryQuery,
    GetAssessmentAccumulatorSummaryQueryVariables
  >(GetAssessmentAccumulatorSummaryDocument, options);
}
export function useGetAssessmentAccumulatorSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentAccumulatorSummaryQuery,
    GetAssessmentAccumulatorSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssessmentAccumulatorSummaryQuery,
    GetAssessmentAccumulatorSummaryQueryVariables
  >(GetAssessmentAccumulatorSummaryDocument, options);
}
// @ts-ignore
export function useGetAssessmentAccumulatorSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssessmentAccumulatorSummaryQuery,
    GetAssessmentAccumulatorSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentAccumulatorSummaryQuery,
  GetAssessmentAccumulatorSummaryQueryVariables
>;
export function useGetAssessmentAccumulatorSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentAccumulatorSummaryQuery,
        GetAssessmentAccumulatorSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentAccumulatorSummaryQuery | undefined,
  GetAssessmentAccumulatorSummaryQueryVariables
>;
export function useGetAssessmentAccumulatorSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentAccumulatorSummaryQuery,
        GetAssessmentAccumulatorSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssessmentAccumulatorSummaryQuery,
    GetAssessmentAccumulatorSummaryQueryVariables
  >(GetAssessmentAccumulatorSummaryDocument, options);
}
export type GetAssessmentAccumulatorSummaryQueryHookResult = ReturnType<
  typeof useGetAssessmentAccumulatorSummaryQuery
>;
export type GetAssessmentAccumulatorSummaryLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentAccumulatorSummaryLazyQuery
>;
export type GetAssessmentAccumulatorSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetAssessmentAccumulatorSummarySuspenseQuery
>;
export type GetAssessmentAccumulatorSummaryQueryResult = Apollo.QueryResult<
  GetAssessmentAccumulatorSummaryQuery,
  GetAssessmentAccumulatorSummaryQueryVariables
>;
export const GetAssessmentAlertsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAssessmentAlerts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentAlerts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fieldId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driftSeverity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assessedLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'observedLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consistentDays' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAssessmentAlertsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentAlertsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetAssessmentAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssessmentAlertsQuery,
    GetAssessmentAlertsQueryVariables
  > &
    ({ variables: GetAssessmentAlertsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssessmentAlertsQuery, GetAssessmentAlertsQueryVariables>(
    GetAssessmentAlertsDocument,
    options,
  );
}
export function useGetAssessmentAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentAlertsQuery,
    GetAssessmentAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssessmentAlertsQuery, GetAssessmentAlertsQueryVariables>(
    GetAssessmentAlertsDocument,
    options,
  );
}
// @ts-ignore
export function useGetAssessmentAlertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssessmentAlertsQuery,
    GetAssessmentAlertsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAssessmentAlertsQuery, GetAssessmentAlertsQueryVariables>;
export function useGetAssessmentAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssessmentAlertsQuery, GetAssessmentAlertsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentAlertsQuery | undefined,
  GetAssessmentAlertsQueryVariables
>;
export function useGetAssessmentAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAssessmentAlertsQuery, GetAssessmentAlertsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAssessmentAlertsQuery, GetAssessmentAlertsQueryVariables>(
    GetAssessmentAlertsDocument,
    options,
  );
}
export type GetAssessmentAlertsQueryHookResult = ReturnType<typeof useGetAssessmentAlertsQuery>;
export type GetAssessmentAlertsLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentAlertsLazyQuery
>;
export type GetAssessmentAlertsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssessmentAlertsSuspenseQuery
>;
export type GetAssessmentAlertsQueryResult = Apollo.QueryResult<
  GetAssessmentAlertsQuery,
  GetAssessmentAlertsQueryVariables
>;
export const GetAssessmentDriftResultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAssessmentDriftResults' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'residentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentDriftResults' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'residentId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'residentId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fieldId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assessedValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assessedLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'observedValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'observedLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driftAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driftDirection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driftSeverity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consistentDays' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAssessmentDriftResultsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentDriftResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentDriftResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentDriftResultsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      residentId: // value for 'residentId'
 *   },
 * });
 */
export function useGetAssessmentDriftResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssessmentDriftResultsQuery,
    GetAssessmentDriftResultsQueryVariables
  > &
    ({ variables: GetAssessmentDriftResultsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssessmentDriftResultsQuery, GetAssessmentDriftResultsQueryVariables>(
    GetAssessmentDriftResultsDocument,
    options,
  );
}
export function useGetAssessmentDriftResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentDriftResultsQuery,
    GetAssessmentDriftResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssessmentDriftResultsQuery,
    GetAssessmentDriftResultsQueryVariables
  >(GetAssessmentDriftResultsDocument, options);
}
// @ts-ignore
export function useGetAssessmentDriftResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssessmentDriftResultsQuery,
    GetAssessmentDriftResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentDriftResultsQuery,
  GetAssessmentDriftResultsQueryVariables
>;
export function useGetAssessmentDriftResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentDriftResultsQuery,
        GetAssessmentDriftResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentDriftResultsQuery | undefined,
  GetAssessmentDriftResultsQueryVariables
>;
export function useGetAssessmentDriftResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentDriftResultsQuery,
        GetAssessmentDriftResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssessmentDriftResultsQuery,
    GetAssessmentDriftResultsQueryVariables
  >(GetAssessmentDriftResultsDocument, options);
}
export type GetAssessmentDriftResultsQueryHookResult = ReturnType<
  typeof useGetAssessmentDriftResultsQuery
>;
export type GetAssessmentDriftResultsLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentDriftResultsLazyQuery
>;
export type GetAssessmentDriftResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssessmentDriftResultsSuspenseQuery
>;
export type GetAssessmentDriftResultsQueryResult = Apollo.QueryResult<
  GetAssessmentDriftResultsQuery,
  GetAssessmentDriftResultsQueryVariables
>;
export const GetAssessmentFieldMappingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAssessmentFieldMappings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentFieldMappings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fieldId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assessedPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minorThreshold' } },
                { kind: 'Field', name: { kind: 'Name', value: 'majorThreshold' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAssessmentFieldMappingsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentFieldMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentFieldMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentFieldMappingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssessmentFieldMappingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAssessmentFieldMappingsQuery,
    GetAssessmentFieldMappingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssessmentFieldMappingsQuery, GetAssessmentFieldMappingsQueryVariables>(
    GetAssessmentFieldMappingsDocument,
    options,
  );
}
export function useGetAssessmentFieldMappingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentFieldMappingsQuery,
    GetAssessmentFieldMappingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssessmentFieldMappingsQuery,
    GetAssessmentFieldMappingsQueryVariables
  >(GetAssessmentFieldMappingsDocument, options);
}
// @ts-ignore
export function useGetAssessmentFieldMappingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssessmentFieldMappingsQuery,
    GetAssessmentFieldMappingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentFieldMappingsQuery,
  GetAssessmentFieldMappingsQueryVariables
>;
export function useGetAssessmentFieldMappingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentFieldMappingsQuery,
        GetAssessmentFieldMappingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentFieldMappingsQuery | undefined,
  GetAssessmentFieldMappingsQueryVariables
>;
export function useGetAssessmentFieldMappingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentFieldMappingsQuery,
        GetAssessmentFieldMappingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssessmentFieldMappingsQuery,
    GetAssessmentFieldMappingsQueryVariables
  >(GetAssessmentFieldMappingsDocument, options);
}
export type GetAssessmentFieldMappingsQueryHookResult = ReturnType<
  typeof useGetAssessmentFieldMappingsQuery
>;
export type GetAssessmentFieldMappingsLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentFieldMappingsLazyQuery
>;
export type GetAssessmentFieldMappingsSuspenseQueryHookResult = ReturnType<
  typeof useGetAssessmentFieldMappingsSuspenseQuery
>;
export type GetAssessmentFieldMappingsQueryResult = Apollo.QueryResult<
  GetAssessmentFieldMappingsQuery,
  GetAssessmentFieldMappingsQueryVariables
>;
export const GetConfigEdgesForCareGraphDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConfigEdgesForCareGraph' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'edgeType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'configEdges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'configId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'edgeType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'edgeType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edgeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inverseType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ring' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConfigEdgesForCareGraphQuery__
 *
 * To run a query within a React component, call `useGetConfigEdgesForCareGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigEdgesForCareGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigEdgesForCareGraphQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      edgeType: // value for 'edgeType'
 *   },
 * });
 */
export function useGetConfigEdgesForCareGraphQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConfigEdgesForCareGraphQuery,
    GetConfigEdgesForCareGraphQueryVariables
  > &
    ({ variables: GetConfigEdgesForCareGraphQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConfigEdgesForCareGraphQuery, GetConfigEdgesForCareGraphQueryVariables>(
    GetConfigEdgesForCareGraphDocument,
    options,
  );
}
export function useGetConfigEdgesForCareGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConfigEdgesForCareGraphQuery,
    GetConfigEdgesForCareGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConfigEdgesForCareGraphQuery,
    GetConfigEdgesForCareGraphQueryVariables
  >(GetConfigEdgesForCareGraphDocument, options);
}
// @ts-ignore
export function useGetConfigEdgesForCareGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConfigEdgesForCareGraphQuery,
    GetConfigEdgesForCareGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetConfigEdgesForCareGraphQuery,
  GetConfigEdgesForCareGraphQueryVariables
>;
export function useGetConfigEdgesForCareGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConfigEdgesForCareGraphQuery,
        GetConfigEdgesForCareGraphQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetConfigEdgesForCareGraphQuery | undefined,
  GetConfigEdgesForCareGraphQueryVariables
>;
export function useGetConfigEdgesForCareGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConfigEdgesForCareGraphQuery,
        GetConfigEdgesForCareGraphQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetConfigEdgesForCareGraphQuery,
    GetConfigEdgesForCareGraphQueryVariables
  >(GetConfigEdgesForCareGraphDocument, options);
}
export type GetConfigEdgesForCareGraphQueryHookResult = ReturnType<
  typeof useGetConfigEdgesForCareGraphQuery
>;
export type GetConfigEdgesForCareGraphLazyQueryHookResult = ReturnType<
  typeof useGetConfigEdgesForCareGraphLazyQuery
>;
export type GetConfigEdgesForCareGraphSuspenseQueryHookResult = ReturnType<
  typeof useGetConfigEdgesForCareGraphSuspenseQuery
>;
export type GetConfigEdgesForCareGraphQueryResult = Apollo.QueryResult<
  GetConfigEdgesForCareGraphQuery,
  GetConfigEdgesForCareGraphQueryVariables
>;
export const GetConfigTypeRegistryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConfigTypeRegistry' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'configTypeRegistry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filenamePrefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skVerbose' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skCompressed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filenameTemplate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filenamePattern' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idField' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceDirs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacySk' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seedLoader' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dimensions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mapsTo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'storage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'examples' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConfigTypeRegistryQuery__
 *
 * To run a query within a React component, call `useGetConfigTypeRegistryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigTypeRegistryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigTypeRegistryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigTypeRegistryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConfigTypeRegistryQuery,
    GetConfigTypeRegistryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConfigTypeRegistryQuery, GetConfigTypeRegistryQueryVariables>(
    GetConfigTypeRegistryDocument,
    options,
  );
}
export function useGetConfigTypeRegistryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConfigTypeRegistryQuery,
    GetConfigTypeRegistryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConfigTypeRegistryQuery, GetConfigTypeRegistryQueryVariables>(
    GetConfigTypeRegistryDocument,
    options,
  );
}
// @ts-ignore
export function useGetConfigTypeRegistrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConfigTypeRegistryQuery,
    GetConfigTypeRegistryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetConfigTypeRegistryQuery, GetConfigTypeRegistryQueryVariables>;
export function useGetConfigTypeRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConfigTypeRegistryQuery,
        GetConfigTypeRegistryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetConfigTypeRegistryQuery | undefined,
  GetConfigTypeRegistryQueryVariables
>;
export function useGetConfigTypeRegistrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConfigTypeRegistryQuery,
        GetConfigTypeRegistryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetConfigTypeRegistryQuery, GetConfigTypeRegistryQueryVariables>(
    GetConfigTypeRegistryDocument,
    options,
  );
}
export type GetConfigTypeRegistryQueryHookResult = ReturnType<typeof useGetConfigTypeRegistryQuery>;
export type GetConfigTypeRegistryLazyQueryHookResult = ReturnType<
  typeof useGetConfigTypeRegistryLazyQuery
>;
export type GetConfigTypeRegistrySuspenseQueryHookResult = ReturnType<
  typeof useGetConfigTypeRegistrySuspenseQuery
>;
export type GetConfigTypeRegistryQueryResult = Apollo.QueryResult<
  GetConfigTypeRegistryQuery,
  GetConfigTypeRegistryQueryVariables
>;
export const GetCoverageGapsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoverageGaps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulatoryCoverageGaps' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rulesetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rulesetId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coveredRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coveragePercent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gaps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'missingConfigs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expectedTrigger' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCoverageGapsQuery__
 *
 * To run a query within a React component, call `useGetCoverageGapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoverageGapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoverageGapsQuery({
 *   variables: {
 *      rulesetId: // value for 'rulesetId'
 *   },
 * });
 */
export function useGetCoverageGapsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCoverageGapsQuery, GetCoverageGapsQueryVariables> &
    ({ variables: GetCoverageGapsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoverageGapsQuery, GetCoverageGapsQueryVariables>(
    GetCoverageGapsDocument,
    options,
  );
}
export function useGetCoverageGapsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCoverageGapsQuery, GetCoverageGapsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoverageGapsQuery, GetCoverageGapsQueryVariables>(
    GetCoverageGapsDocument,
    options,
  );
}
// @ts-ignore
export function useGetCoverageGapsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCoverageGapsQuery,
    GetCoverageGapsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCoverageGapsQuery, GetCoverageGapsQueryVariables>;
export function useGetCoverageGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCoverageGapsQuery, GetCoverageGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCoverageGapsQuery | undefined, GetCoverageGapsQueryVariables>;
export function useGetCoverageGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCoverageGapsQuery, GetCoverageGapsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCoverageGapsQuery, GetCoverageGapsQueryVariables>(
    GetCoverageGapsDocument,
    options,
  );
}
export type GetCoverageGapsQueryHookResult = ReturnType<typeof useGetCoverageGapsQuery>;
export type GetCoverageGapsLazyQueryHookResult = ReturnType<typeof useGetCoverageGapsLazyQuery>;
export type GetCoverageGapsSuspenseQueryHookResult = ReturnType<
  typeof useGetCoverageGapsSuspenseQuery
>;
export type GetCoverageGapsQueryResult = Apollo.QueryResult<
  GetCoverageGapsQuery,
  GetCoverageGapsQueryVariables
>;
export const GetCoverageOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoverageOverview' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulatoryCoverageOverview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coveredRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gapCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coveragePercent' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCoverageOverviewQuery__
 *
 * To run a query within a React component, call `useGetCoverageOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoverageOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoverageOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoverageOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCoverageOverviewQuery,
    GetCoverageOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoverageOverviewQuery, GetCoverageOverviewQueryVariables>(
    GetCoverageOverviewDocument,
    options,
  );
}
export function useGetCoverageOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoverageOverviewQuery,
    GetCoverageOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoverageOverviewQuery, GetCoverageOverviewQueryVariables>(
    GetCoverageOverviewDocument,
    options,
  );
}
// @ts-ignore
export function useGetCoverageOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCoverageOverviewQuery,
    GetCoverageOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCoverageOverviewQuery, GetCoverageOverviewQueryVariables>;
export function useGetCoverageOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCoverageOverviewQuery, GetCoverageOverviewQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetCoverageOverviewQuery | undefined,
  GetCoverageOverviewQueryVariables
>;
export function useGetCoverageOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCoverageOverviewQuery, GetCoverageOverviewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCoverageOverviewQuery, GetCoverageOverviewQueryVariables>(
    GetCoverageOverviewDocument,
    options,
  );
}
export type GetCoverageOverviewQueryHookResult = ReturnType<typeof useGetCoverageOverviewQuery>;
export type GetCoverageOverviewLazyQueryHookResult = ReturnType<
  typeof useGetCoverageOverviewLazyQuery
>;
export type GetCoverageOverviewSuspenseQueryHookResult = ReturnType<
  typeof useGetCoverageOverviewSuspenseQuery
>;
export type GetCoverageOverviewQueryResult = Apollo.QueryResult<
  GetCoverageOverviewQuery,
  GetCoverageOverviewQueryVariables
>;
export const GetFilenameAbbreviationTablesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFilenameAbbreviationTables' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filenameAbbreviationTables' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'codes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFilenameAbbreviationTablesQuery__
 *
 * To run a query within a React component, call `useGetFilenameAbbreviationTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilenameAbbreviationTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilenameAbbreviationTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilenameAbbreviationTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFilenameAbbreviationTablesQuery,
    GetFilenameAbbreviationTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFilenameAbbreviationTablesQuery,
    GetFilenameAbbreviationTablesQueryVariables
  >(GetFilenameAbbreviationTablesDocument, options);
}
export function useGetFilenameAbbreviationTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFilenameAbbreviationTablesQuery,
    GetFilenameAbbreviationTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFilenameAbbreviationTablesQuery,
    GetFilenameAbbreviationTablesQueryVariables
  >(GetFilenameAbbreviationTablesDocument, options);
}
// @ts-ignore
export function useGetFilenameAbbreviationTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFilenameAbbreviationTablesQuery,
    GetFilenameAbbreviationTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFilenameAbbreviationTablesQuery,
  GetFilenameAbbreviationTablesQueryVariables
>;
export function useGetFilenameAbbreviationTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFilenameAbbreviationTablesQuery,
        GetFilenameAbbreviationTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFilenameAbbreviationTablesQuery | undefined,
  GetFilenameAbbreviationTablesQueryVariables
>;
export function useGetFilenameAbbreviationTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFilenameAbbreviationTablesQuery,
        GetFilenameAbbreviationTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFilenameAbbreviationTablesQuery,
    GetFilenameAbbreviationTablesQueryVariables
  >(GetFilenameAbbreviationTablesDocument, options);
}
export type GetFilenameAbbreviationTablesQueryHookResult = ReturnType<
  typeof useGetFilenameAbbreviationTablesQuery
>;
export type GetFilenameAbbreviationTablesLazyQueryHookResult = ReturnType<
  typeof useGetFilenameAbbreviationTablesLazyQuery
>;
export type GetFilenameAbbreviationTablesSuspenseQueryHookResult = ReturnType<
  typeof useGetFilenameAbbreviationTablesSuspenseQuery
>;
export type GetFilenameAbbreviationTablesQueryResult = Apollo.QueryResult<
  GetFilenameAbbreviationTablesQuery,
  GetFilenameAbbreviationTablesQueryVariables
>;
export const GetFormSchemaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFormSchema' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetFormSchemaInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsGetFormSchema' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schema' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ui' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFormSchemaQuery__
 *
 * To run a query within a React component, call `useGetFormSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSchemaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFormSchemaQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormSchemaQuery, GetFormSchemaQueryVariables> &
    ({ variables: GetFormSchemaQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFormSchemaQuery, GetFormSchemaQueryVariables>(
    GetFormSchemaDocument,
    options,
  );
}
export function useGetFormSchemaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormSchemaQuery, GetFormSchemaQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFormSchemaQuery, GetFormSchemaQueryVariables>(
    GetFormSchemaDocument,
    options,
  );
}
// @ts-ignore
export function useGetFormSchemaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormSchemaQuery, GetFormSchemaQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetFormSchemaQuery, GetFormSchemaQueryVariables>;
export function useGetFormSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetFormSchemaQuery, GetFormSchemaQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetFormSchemaQuery | undefined, GetFormSchemaQueryVariables>;
export function useGetFormSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetFormSchemaQuery, GetFormSchemaQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFormSchemaQuery, GetFormSchemaQueryVariables>(
    GetFormSchemaDocument,
    options,
  );
}
export type GetFormSchemaQueryHookResult = ReturnType<typeof useGetFormSchemaQuery>;
export type GetFormSchemaLazyQueryHookResult = ReturnType<typeof useGetFormSchemaLazyQuery>;
export type GetFormSchemaSuspenseQueryHookResult = ReturnType<typeof useGetFormSchemaSuspenseQuery>;
export type GetFormSchemaQueryResult = Apollo.QueryResult<
  GetFormSchemaQuery,
  GetFormSchemaQueryVariables
>;
export const GetFormSchemaOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFormSchemaOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formSchemaOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hiddenFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'readonlyFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelOverrides' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFormSchemaOverrideQuery__
 *
 * To run a query within a React component, call `useGetFormSchemaOverrideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSchemaOverrideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSchemaOverrideQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetFormSchemaOverrideQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormSchemaOverrideQuery,
    GetFormSchemaOverrideQueryVariables
  > &
    ({ variables: GetFormSchemaOverrideQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFormSchemaOverrideQuery, GetFormSchemaOverrideQueryVariables>(
    GetFormSchemaOverrideDocument,
    options,
  );
}
export function useGetFormSchemaOverrideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormSchemaOverrideQuery,
    GetFormSchemaOverrideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFormSchemaOverrideQuery, GetFormSchemaOverrideQueryVariables>(
    GetFormSchemaOverrideDocument,
    options,
  );
}
// @ts-ignore
export function useGetFormSchemaOverrideSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormSchemaOverrideQuery,
    GetFormSchemaOverrideQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetFormSchemaOverrideQuery, GetFormSchemaOverrideQueryVariables>;
export function useGetFormSchemaOverrideSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFormSchemaOverrideQuery,
        GetFormSchemaOverrideQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFormSchemaOverrideQuery | undefined,
  GetFormSchemaOverrideQueryVariables
>;
export function useGetFormSchemaOverrideSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFormSchemaOverrideQuery,
        GetFormSchemaOverrideQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFormSchemaOverrideQuery, GetFormSchemaOverrideQueryVariables>(
    GetFormSchemaOverrideDocument,
    options,
  );
}
export type GetFormSchemaOverrideQueryHookResult = ReturnType<typeof useGetFormSchemaOverrideQuery>;
export type GetFormSchemaOverrideLazyQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverrideLazyQuery
>;
export type GetFormSchemaOverrideSuspenseQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverrideSuspenseQuery
>;
export type GetFormSchemaOverrideQueryResult = Apollo.QueryResult<
  GetFormSchemaOverrideQuery,
  GetFormSchemaOverrideQueryVariables
>;
export const GetFormSchemaOverrideCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFormSchemaOverrideCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formSchemaOverrideCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFormSchemaOverrideCountQuery__
 *
 * To run a query within a React component, call `useGetFormSchemaOverrideCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSchemaOverrideCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSchemaOverrideCountQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetFormSchemaOverrideCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormSchemaOverrideCountQuery,
    GetFormSchemaOverrideCountQueryVariables
  > &
    ({ variables: GetFormSchemaOverrideCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFormSchemaOverrideCountQuery, GetFormSchemaOverrideCountQueryVariables>(
    GetFormSchemaOverrideCountDocument,
    options,
  );
}
export function useGetFormSchemaOverrideCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormSchemaOverrideCountQuery,
    GetFormSchemaOverrideCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFormSchemaOverrideCountQuery,
    GetFormSchemaOverrideCountQueryVariables
  >(GetFormSchemaOverrideCountDocument, options);
}
// @ts-ignore
export function useGetFormSchemaOverrideCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormSchemaOverrideCountQuery,
    GetFormSchemaOverrideCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFormSchemaOverrideCountQuery,
  GetFormSchemaOverrideCountQueryVariables
>;
export function useGetFormSchemaOverrideCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFormSchemaOverrideCountQuery,
        GetFormSchemaOverrideCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFormSchemaOverrideCountQuery | undefined,
  GetFormSchemaOverrideCountQueryVariables
>;
export function useGetFormSchemaOverrideCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFormSchemaOverrideCountQuery,
        GetFormSchemaOverrideCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFormSchemaOverrideCountQuery,
    GetFormSchemaOverrideCountQueryVariables
  >(GetFormSchemaOverrideCountDocument, options);
}
export type GetFormSchemaOverrideCountQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverrideCountQuery
>;
export type GetFormSchemaOverrideCountLazyQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverrideCountLazyQuery
>;
export type GetFormSchemaOverrideCountSuspenseQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverrideCountSuspenseQuery
>;
export type GetFormSchemaOverrideCountQueryResult = Apollo.QueryResult<
  GetFormSchemaOverrideCountQuery,
  GetFormSchemaOverrideCountQueryVariables
>;
export const GetFormSchemaOverridesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFormSchemaOverrides' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formSchemaOverrides' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraph' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraph' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraph' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hiddenFieldCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'readonlyFieldCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customFieldCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelOverrideCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mandatory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statuteRef' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFormSchemaOverridesQuery__
 *
 * To run a query within a React component, call `useGetFormSchemaOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSchemaOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSchemaOverridesQuery({
 *   variables: {
 *      subgraph: // value for 'subgraph'
 *   },
 * });
 */
export function useGetFormSchemaOverridesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFormSchemaOverridesQuery,
    GetFormSchemaOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFormSchemaOverridesQuery, GetFormSchemaOverridesQueryVariables>(
    GetFormSchemaOverridesDocument,
    options,
  );
}
export function useGetFormSchemaOverridesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormSchemaOverridesQuery,
    GetFormSchemaOverridesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFormSchemaOverridesQuery, GetFormSchemaOverridesQueryVariables>(
    GetFormSchemaOverridesDocument,
    options,
  );
}
// @ts-ignore
export function useGetFormSchemaOverridesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormSchemaOverridesQuery,
    GetFormSchemaOverridesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetFormSchemaOverridesQuery, GetFormSchemaOverridesQueryVariables>;
export function useGetFormSchemaOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFormSchemaOverridesQuery,
        GetFormSchemaOverridesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFormSchemaOverridesQuery | undefined,
  GetFormSchemaOverridesQueryVariables
>;
export function useGetFormSchemaOverridesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFormSchemaOverridesQuery,
        GetFormSchemaOverridesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFormSchemaOverridesQuery, GetFormSchemaOverridesQueryVariables>(
    GetFormSchemaOverridesDocument,
    options,
  );
}
export type GetFormSchemaOverridesQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverridesQuery
>;
export type GetFormSchemaOverridesLazyQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverridesLazyQuery
>;
export type GetFormSchemaOverridesSuspenseQueryHookResult = ReturnType<
  typeof useGetFormSchemaOverridesSuspenseQuery
>;
export type GetFormSchemaOverridesQueryResult = Apollo.QueryResult<
  GetFormSchemaOverridesQuery,
  GetFormSchemaOverridesQueryVariables
>;
export const GetRegistryOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryOverview' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryOverview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'registryVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configTypeCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dimensionTableCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalDimensionCodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valkeyIndexPattern' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasabiKeyPattern' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryOverviewQuery__
 *
 * To run a query within a React component, call `useGetRegistryOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegistryOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRegistryOverviewQuery,
    GetRegistryOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegistryOverviewQuery, GetRegistryOverviewQueryVariables>(
    GetRegistryOverviewDocument,
    options,
  );
}
export function useGetRegistryOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRegistryOverviewQuery,
    GetRegistryOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegistryOverviewQuery, GetRegistryOverviewQueryVariables>(
    GetRegistryOverviewDocument,
    options,
  );
}
// @ts-ignore
export function useGetRegistryOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRegistryOverviewQuery,
    GetRegistryOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetRegistryOverviewQuery, GetRegistryOverviewQueryVariables>;
export function useGetRegistryOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRegistryOverviewQuery, GetRegistryOverviewQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetRegistryOverviewQuery | undefined,
  GetRegistryOverviewQueryVariables
>;
export function useGetRegistryOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRegistryOverviewQuery, GetRegistryOverviewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRegistryOverviewQuery, GetRegistryOverviewQueryVariables>(
    GetRegistryOverviewDocument,
    options,
  );
}
export type GetRegistryOverviewQueryHookResult = ReturnType<typeof useGetRegistryOverviewQuery>;
export type GetRegistryOverviewLazyQueryHookResult = ReturnType<
  typeof useGetRegistryOverviewLazyQuery
>;
export type GetRegistryOverviewSuspenseQueryHookResult = ReturnType<
  typeof useGetRegistryOverviewSuspenseQuery
>;
export type GetRegistryOverviewQueryResult = Apollo.QueryResult<
  GetRegistryOverviewQuery,
  GetRegistryOverviewQueryVariables
>;
export const GetRegulatoryReadinessScoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegulatoryReadinessScore' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regulatoryReadinessScore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullyEvidencedRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partiallyEvidencedRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalEvidenceRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalEvidenceFound' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scorePct' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticalRulesTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticalRulesEvidenced' } },
                { kind: 'Field', name: { kind: 'Name', value: 'highRulesTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'highRulesEvidenced' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gaps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ruleText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'evidenceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'evidenceDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'foundDocumentIds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegulatoryReadinessScoreQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryReadinessScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryReadinessScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryReadinessScoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegulatoryReadinessScoreQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRegulatoryReadinessScoreQuery,
    GetRegulatoryReadinessScoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRegulatoryReadinessScoreQuery,
    GetRegulatoryReadinessScoreQueryVariables
  >(GetRegulatoryReadinessScoreDocument, options);
}
export function useGetRegulatoryReadinessScoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRegulatoryReadinessScoreQuery,
    GetRegulatoryReadinessScoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRegulatoryReadinessScoreQuery,
    GetRegulatoryReadinessScoreQueryVariables
  >(GetRegulatoryReadinessScoreDocument, options);
}
// @ts-ignore
export function useGetRegulatoryReadinessScoreSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRegulatoryReadinessScoreQuery,
    GetRegulatoryReadinessScoreQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetRegulatoryReadinessScoreQuery,
  GetRegulatoryReadinessScoreQueryVariables
>;
export function useGetRegulatoryReadinessScoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRegulatoryReadinessScoreQuery,
        GetRegulatoryReadinessScoreQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetRegulatoryReadinessScoreQuery | undefined,
  GetRegulatoryReadinessScoreQueryVariables
>;
export function useGetRegulatoryReadinessScoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRegulatoryReadinessScoreQuery,
        GetRegulatoryReadinessScoreQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRegulatoryReadinessScoreQuery,
    GetRegulatoryReadinessScoreQueryVariables
  >(GetRegulatoryReadinessScoreDocument, options);
}
export type GetRegulatoryReadinessScoreQueryHookResult = ReturnType<
  typeof useGetRegulatoryReadinessScoreQuery
>;
export type GetRegulatoryReadinessScoreLazyQueryHookResult = ReturnType<
  typeof useGetRegulatoryReadinessScoreLazyQuery
>;
export type GetRegulatoryReadinessScoreSuspenseQueryHookResult = ReturnType<
  typeof useGetRegulatoryReadinessScoreSuspenseQuery
>;
export type GetRegulatoryReadinessScoreQueryResult = Apollo.QueryResult<
  GetRegulatoryReadinessScoreQuery,
  GetRegulatoryReadinessScoreQueryVariables
>;
export const GetTenantBrandingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenantBranding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTenantBranding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondaryColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accentColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyTagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'terminology' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFerpBranding' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showHelpCenter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showSupportChat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTenantBrandingQuery__
 *
 * To run a query within a React component, call `useGetTenantBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantBrandingQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetTenantBrandingQuery(
  baseOptions: Apollo.QueryHookOptions<GetTenantBrandingQuery, GetTenantBrandingQueryVariables> &
    ({ variables: GetTenantBrandingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTenantBrandingQuery, GetTenantBrandingQueryVariables>(
    GetTenantBrandingDocument,
    options,
  );
}
export function useGetTenantBrandingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTenantBrandingQuery,
    GetTenantBrandingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTenantBrandingQuery, GetTenantBrandingQueryVariables>(
    GetTenantBrandingDocument,
    options,
  );
}
// @ts-ignore
export function useGetTenantBrandingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTenantBrandingQuery,
    GetTenantBrandingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTenantBrandingQuery, GetTenantBrandingQueryVariables>;
export function useGetTenantBrandingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTenantBrandingQuery, GetTenantBrandingQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetTenantBrandingQuery | undefined,
  GetTenantBrandingQueryVariables
>;
export function useGetTenantBrandingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTenantBrandingQuery, GetTenantBrandingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTenantBrandingQuery, GetTenantBrandingQueryVariables>(
    GetTenantBrandingDocument,
    options,
  );
}
export type GetTenantBrandingQueryHookResult = ReturnType<typeof useGetTenantBrandingQuery>;
export type GetTenantBrandingLazyQueryHookResult = ReturnType<typeof useGetTenantBrandingLazyQuery>;
export type GetTenantBrandingSuspenseQueryHookResult = ReturnType<
  typeof useGetTenantBrandingSuspenseQuery
>;
export type GetTenantBrandingQueryResult = Apollo.QueryResult<
  GetTenantBrandingQuery,
  GetTenantBrandingQueryVariables
>;
export const GetTenantBrandingAdminDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenantBrandingAdmin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTenantBranding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyTagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondaryColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accentColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'services' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accreditations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFerpBranding' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTenantBrandingAdminQuery__
 *
 * To run a query within a React component, call `useGetTenantBrandingAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantBrandingAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantBrandingAdminQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetTenantBrandingAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTenantBrandingAdminQuery,
    GetTenantBrandingAdminQueryVariables
  > &
    ({ variables: GetTenantBrandingAdminQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTenantBrandingAdminQuery, GetTenantBrandingAdminQueryVariables>(
    GetTenantBrandingAdminDocument,
    options,
  );
}
export function useGetTenantBrandingAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTenantBrandingAdminQuery,
    GetTenantBrandingAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTenantBrandingAdminQuery, GetTenantBrandingAdminQueryVariables>(
    GetTenantBrandingAdminDocument,
    options,
  );
}
// @ts-ignore
export function useGetTenantBrandingAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTenantBrandingAdminQuery,
    GetTenantBrandingAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTenantBrandingAdminQuery, GetTenantBrandingAdminQueryVariables>;
export function useGetTenantBrandingAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTenantBrandingAdminQuery,
        GetTenantBrandingAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTenantBrandingAdminQuery | undefined,
  GetTenantBrandingAdminQueryVariables
>;
export function useGetTenantBrandingAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTenantBrandingAdminQuery,
        GetTenantBrandingAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTenantBrandingAdminQuery, GetTenantBrandingAdminQueryVariables>(
    GetTenantBrandingAdminDocument,
    options,
  );
}
export type GetTenantBrandingAdminQueryHookResult = ReturnType<
  typeof useGetTenantBrandingAdminQuery
>;
export type GetTenantBrandingAdminLazyQueryHookResult = ReturnType<
  typeof useGetTenantBrandingAdminLazyQuery
>;
export type GetTenantBrandingAdminSuspenseQueryHookResult = ReturnType<
  typeof useGetTenantBrandingAdminSuspenseQuery
>;
export type GetTenantBrandingAdminQueryResult = Apollo.QueryResult<
  GetTenantBrandingAdminQuery,
  GetTenantBrandingAdminQueryVariables
>;
export const GetTenantBrandingBySubdomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenantBrandingBySubdomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subdomain' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTenantBrandingBySubdomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subdomain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subdomain' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondaryColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyTagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'terminology' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subdomain' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTenantBrandingBySubdomainQuery__
 *
 * To run a query within a React component, call `useGetTenantBrandingBySubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantBrandingBySubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantBrandingBySubdomainQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useGetTenantBrandingBySubdomainQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTenantBrandingBySubdomainQuery,
    GetTenantBrandingBySubdomainQueryVariables
  > &
    ({ variables: GetTenantBrandingBySubdomainQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTenantBrandingBySubdomainQuery,
    GetTenantBrandingBySubdomainQueryVariables
  >(GetTenantBrandingBySubdomainDocument, options);
}
export function useGetTenantBrandingBySubdomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTenantBrandingBySubdomainQuery,
    GetTenantBrandingBySubdomainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTenantBrandingBySubdomainQuery,
    GetTenantBrandingBySubdomainQueryVariables
  >(GetTenantBrandingBySubdomainDocument, options);
}
// @ts-ignore
export function useGetTenantBrandingBySubdomainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTenantBrandingBySubdomainQuery,
    GetTenantBrandingBySubdomainQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTenantBrandingBySubdomainQuery,
  GetTenantBrandingBySubdomainQueryVariables
>;
export function useGetTenantBrandingBySubdomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTenantBrandingBySubdomainQuery,
        GetTenantBrandingBySubdomainQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTenantBrandingBySubdomainQuery | undefined,
  GetTenantBrandingBySubdomainQueryVariables
>;
export function useGetTenantBrandingBySubdomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTenantBrandingBySubdomainQuery,
        GetTenantBrandingBySubdomainQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTenantBrandingBySubdomainQuery,
    GetTenantBrandingBySubdomainQueryVariables
  >(GetTenantBrandingBySubdomainDocument, options);
}
export type GetTenantBrandingBySubdomainQueryHookResult = ReturnType<
  typeof useGetTenantBrandingBySubdomainQuery
>;
export type GetTenantBrandingBySubdomainLazyQueryHookResult = ReturnType<
  typeof useGetTenantBrandingBySubdomainLazyQuery
>;
export type GetTenantBrandingBySubdomainSuspenseQueryHookResult = ReturnType<
  typeof useGetTenantBrandingBySubdomainSuspenseQuery
>;
export type GetTenantBrandingBySubdomainQueryResult = Apollo.QueryResult<
  GetTenantBrandingBySubdomainQuery,
  GetTenantBrandingBySubdomainQueryVariables
>;
export const GetUiSchemaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUiSchema' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'module' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'context' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Uicontext' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiSchema' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'module' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'module' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'context' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'context' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'module' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'component' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'helpText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mutation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetUiSchemaQuery__
 *
 * To run a query within a React component, call `useGetUiSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUiSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUiSchemaQuery({
 *   variables: {
 *      module: // value for 'module'
 *      entity: // value for 'entity'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetUiSchemaQuery(
  baseOptions: Apollo.QueryHookOptions<GetUiSchemaQuery, GetUiSchemaQueryVariables> &
    ({ variables: GetUiSchemaQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUiSchemaQuery, GetUiSchemaQueryVariables>(GetUiSchemaDocument, options);
}
export function useGetUiSchemaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUiSchemaQuery, GetUiSchemaQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUiSchemaQuery, GetUiSchemaQueryVariables>(
    GetUiSchemaDocument,
    options,
  );
}
// @ts-ignore
export function useGetUiSchemaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUiSchemaQuery, GetUiSchemaQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUiSchemaQuery, GetUiSchemaQueryVariables>;
export function useGetUiSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUiSchemaQuery, GetUiSchemaQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUiSchemaQuery | undefined, GetUiSchemaQueryVariables>;
export function useGetUiSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUiSchemaQuery, GetUiSchemaQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUiSchemaQuery, GetUiSchemaQueryVariables>(
    GetUiSchemaDocument,
    options,
  );
}
export type GetUiSchemaQueryHookResult = ReturnType<typeof useGetUiSchemaQuery>;
export type GetUiSchemaLazyQueryHookResult = ReturnType<typeof useGetUiSchemaLazyQuery>;
export type GetUiSchemaSuspenseQueryHookResult = ReturnType<typeof useGetUiSchemaSuspenseQuery>;
export type GetUiSchemaQueryResult = Apollo.QueryResult<
  GetUiSchemaQuery,
  GetUiSchemaQueryVariables
>;
export const GetUiSchemaVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUiSchemaVersion' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiSchemaVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currentVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minSupportedVersion' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetUiSchemaVersionQuery__
 *
 * To run a query within a React component, call `useGetUiSchemaVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUiSchemaVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUiSchemaVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUiSchemaVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUiSchemaVersionQuery, GetUiSchemaVersionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUiSchemaVersionQuery, GetUiSchemaVersionQueryVariables>(
    GetUiSchemaVersionDocument,
    options,
  );
}
export function useGetUiSchemaVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUiSchemaVersionQuery,
    GetUiSchemaVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUiSchemaVersionQuery, GetUiSchemaVersionQueryVariables>(
    GetUiSchemaVersionDocument,
    options,
  );
}
// @ts-ignore
export function useGetUiSchemaVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUiSchemaVersionQuery,
    GetUiSchemaVersionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetUiSchemaVersionQuery, GetUiSchemaVersionQueryVariables>;
export function useGetUiSchemaVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUiSchemaVersionQuery, GetUiSchemaVersionQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetUiSchemaVersionQuery | undefined,
  GetUiSchemaVersionQueryVariables
>;
export function useGetUiSchemaVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUiSchemaVersionQuery, GetUiSchemaVersionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUiSchemaVersionQuery, GetUiSchemaVersionQueryVariables>(
    GetUiSchemaVersionDocument,
    options,
  );
}
export type GetUiSchemaVersionQueryHookResult = ReturnType<typeof useGetUiSchemaVersionQuery>;
export type GetUiSchemaVersionLazyQueryHookResult = ReturnType<
  typeof useGetUiSchemaVersionLazyQuery
>;
export type GetUiSchemaVersionSuspenseQueryHookResult = ReturnType<
  typeof useGetUiSchemaVersionSuspenseQuery
>;
export type GetUiSchemaVersionQueryResult = Apollo.QueryResult<
  GetUiSchemaVersionQuery,
  GetUiSchemaVersionQueryVariables
>;
export const LegacyArchiveFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LegacyArchiveFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legacyArchiveFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clamavVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'viewUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canView' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDownload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warningLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warningMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useLegacyArchiveFileQuery__
 *
 * To run a query within a React component, call `useLegacyArchiveFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyArchiveFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyArchiveFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useLegacyArchiveFileQuery(
  baseOptions: Apollo.QueryHookOptions<LegacyArchiveFileQuery, LegacyArchiveFileQueryVariables> &
    ({ variables: LegacyArchiveFileQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LegacyArchiveFileQuery, LegacyArchiveFileQueryVariables>(
    LegacyArchiveFileDocument,
    options,
  );
}
export function useLegacyArchiveFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LegacyArchiveFileQuery,
    LegacyArchiveFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LegacyArchiveFileQuery, LegacyArchiveFileQueryVariables>(
    LegacyArchiveFileDocument,
    options,
  );
}
// @ts-ignore
export function useLegacyArchiveFileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LegacyArchiveFileQuery,
    LegacyArchiveFileQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LegacyArchiveFileQuery, LegacyArchiveFileQueryVariables>;
export function useLegacyArchiveFileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LegacyArchiveFileQuery, LegacyArchiveFileQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  LegacyArchiveFileQuery | undefined,
  LegacyArchiveFileQueryVariables
>;
export function useLegacyArchiveFileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LegacyArchiveFileQuery, LegacyArchiveFileQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LegacyArchiveFileQuery, LegacyArchiveFileQueryVariables>(
    LegacyArchiveFileDocument,
    options,
  );
}
export type LegacyArchiveFileQueryHookResult = ReturnType<typeof useLegacyArchiveFileQuery>;
export type LegacyArchiveFileLazyQueryHookResult = ReturnType<typeof useLegacyArchiveFileLazyQuery>;
export type LegacyArchiveFileSuspenseQueryHookResult = ReturnType<
  typeof useLegacyArchiveFileSuspenseQuery
>;
export type LegacyArchiveFileQueryResult = Apollo.QueryResult<
  LegacyArchiveFileQuery,
  LegacyArchiveFileQueryVariables
>;
export const LegacyArchiveFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LegacyArchiveFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legacyArchiveFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scanDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clamavVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'viewUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canView' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDownload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warningLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'warningMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useLegacyArchiveFilesQuery__
 *
 * To run a query within a React component, call `useLegacyArchiveFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyArchiveFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyArchiveFilesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLegacyArchiveFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<LegacyArchiveFilesQuery, LegacyArchiveFilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LegacyArchiveFilesQuery, LegacyArchiveFilesQueryVariables>(
    LegacyArchiveFilesDocument,
    options,
  );
}
export function useLegacyArchiveFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LegacyArchiveFilesQuery,
    LegacyArchiveFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LegacyArchiveFilesQuery, LegacyArchiveFilesQueryVariables>(
    LegacyArchiveFilesDocument,
    options,
  );
}
// @ts-ignore
export function useLegacyArchiveFilesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LegacyArchiveFilesQuery,
    LegacyArchiveFilesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LegacyArchiveFilesQuery, LegacyArchiveFilesQueryVariables>;
export function useLegacyArchiveFilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LegacyArchiveFilesQuery, LegacyArchiveFilesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  LegacyArchiveFilesQuery | undefined,
  LegacyArchiveFilesQueryVariables
>;
export function useLegacyArchiveFilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LegacyArchiveFilesQuery, LegacyArchiveFilesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LegacyArchiveFilesQuery, LegacyArchiveFilesQueryVariables>(
    LegacyArchiveFilesDocument,
    options,
  );
}
export type LegacyArchiveFilesQueryHookResult = ReturnType<typeof useLegacyArchiveFilesQuery>;
export type LegacyArchiveFilesLazyQueryHookResult = ReturnType<
  typeof useLegacyArchiveFilesLazyQuery
>;
export type LegacyArchiveFilesSuspenseQueryHookResult = ReturnType<
  typeof useLegacyArchiveFilesSuspenseQuery
>;
export type LegacyArchiveFilesQueryResult = Apollo.QueryResult<
  LegacyArchiveFilesQuery,
  LegacyArchiveFilesQueryVariables
>;
export const ListPoliciesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListPolicies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listPolicies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PolicyFields' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PolicyFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Policy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'policyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
          { kind: 'Field', name: { kind: 'Name', value: 'implementation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'auditLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListPoliciesQuery__
 *
 * To run a query within a React component, call `useListPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPoliciesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListPoliciesQuery(
  baseOptions: Apollo.QueryHookOptions<ListPoliciesQuery, ListPoliciesQueryVariables> &
    ({ variables: ListPoliciesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPoliciesQuery, ListPoliciesQueryVariables>(
    ListPoliciesDocument,
    options,
  );
}
export function useListPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPoliciesQuery, ListPoliciesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPoliciesQuery, ListPoliciesQueryVariables>(
    ListPoliciesDocument,
    options,
  );
}
// @ts-ignore
export function useListPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListPoliciesQuery, ListPoliciesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListPoliciesQuery, ListPoliciesQueryVariables>;
export function useListPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPoliciesQuery, ListPoliciesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListPoliciesQuery | undefined, ListPoliciesQueryVariables>;
export function useListPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPoliciesQuery, ListPoliciesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPoliciesQuery, ListPoliciesQueryVariables>(
    ListPoliciesDocument,
    options,
  );
}
export type ListPoliciesQueryHookResult = ReturnType<typeof useListPoliciesQuery>;
export type ListPoliciesLazyQueryHookResult = ReturnType<typeof useListPoliciesLazyQuery>;
export type ListPoliciesSuspenseQueryHookResult = ReturnType<typeof useListPoliciesSuspenseQuery>;
export type ListPoliciesQueryResult = Apollo.QueryResult<
  ListPoliciesQuery,
  ListPoliciesQueryVariables
>;
export const ListStandardsPacksForCuratorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListStandardsPacksForCurator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listStandardsPacks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'standard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicableDomains' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicableResourceTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListStandardsPacksForCuratorQuery__
 *
 * To run a query within a React component, call `useListStandardsPacksForCuratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStandardsPacksForCuratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStandardsPacksForCuratorQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useListStandardsPacksForCuratorQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListStandardsPacksForCuratorQuery,
    ListStandardsPacksForCuratorQueryVariables
  > &
    ({ variables: ListStandardsPacksForCuratorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListStandardsPacksForCuratorQuery,
    ListStandardsPacksForCuratorQueryVariables
  >(ListStandardsPacksForCuratorDocument, options);
}
export function useListStandardsPacksForCuratorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListStandardsPacksForCuratorQuery,
    ListStandardsPacksForCuratorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListStandardsPacksForCuratorQuery,
    ListStandardsPacksForCuratorQueryVariables
  >(ListStandardsPacksForCuratorDocument, options);
}
// @ts-ignore
export function useListStandardsPacksForCuratorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListStandardsPacksForCuratorQuery,
    ListStandardsPacksForCuratorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListStandardsPacksForCuratorQuery,
  ListStandardsPacksForCuratorQueryVariables
>;
export function useListStandardsPacksForCuratorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListStandardsPacksForCuratorQuery,
        ListStandardsPacksForCuratorQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListStandardsPacksForCuratorQuery | undefined,
  ListStandardsPacksForCuratorQueryVariables
>;
export function useListStandardsPacksForCuratorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListStandardsPacksForCuratorQuery,
        ListStandardsPacksForCuratorQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListStandardsPacksForCuratorQuery,
    ListStandardsPacksForCuratorQueryVariables
  >(ListStandardsPacksForCuratorDocument, options);
}
export type ListStandardsPacksForCuratorQueryHookResult = ReturnType<
  typeof useListStandardsPacksForCuratorQuery
>;
export type ListStandardsPacksForCuratorLazyQueryHookResult = ReturnType<
  typeof useListStandardsPacksForCuratorLazyQuery
>;
export type ListStandardsPacksForCuratorSuspenseQueryHookResult = ReturnType<
  typeof useListStandardsPacksForCuratorSuspenseQuery
>;
export type ListStandardsPacksForCuratorQueryResult = Apollo.QueryResult<
  ListStandardsPacksForCuratorQuery,
  ListStandardsPacksForCuratorQueryVariables
>;
export const ListWebhookEndpointsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListWebhookEndpoints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listWebhookEndpoints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'endpointId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'events' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListWebhookEndpointsQuery__
 *
 * To run a query within a React component, call `useListWebhookEndpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebhookEndpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebhookEndpointsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useListWebhookEndpointsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListWebhookEndpointsQuery,
    ListWebhookEndpointsQueryVariables
  > &
    ({ variables: ListWebhookEndpointsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(
    ListWebhookEndpointsDocument,
    options,
  );
}
export function useListWebhookEndpointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListWebhookEndpointsQuery,
    ListWebhookEndpointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(
    ListWebhookEndpointsDocument,
    options,
  );
}
// @ts-ignore
export function useListWebhookEndpointsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListWebhookEndpointsQuery,
    ListWebhookEndpointsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>;
export function useListWebhookEndpointsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWebhookEndpointsQuery,
        ListWebhookEndpointsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListWebhookEndpointsQuery | undefined,
  ListWebhookEndpointsQueryVariables
>;
export function useListWebhookEndpointsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListWebhookEndpointsQuery,
        ListWebhookEndpointsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(
    ListWebhookEndpointsDocument,
    options,
  );
}
export type ListWebhookEndpointsQueryHookResult = ReturnType<typeof useListWebhookEndpointsQuery>;
export type ListWebhookEndpointsLazyQueryHookResult = ReturnType<
  typeof useListWebhookEndpointsLazyQuery
>;
export type ListWebhookEndpointsSuspenseQueryHookResult = ReturnType<
  typeof useListWebhookEndpointsSuspenseQuery
>;
export type ListWebhookEndpointsQueryResult = Apollo.QueryResult<
  ListWebhookEndpointsQuery,
  ListWebhookEndpointsQueryVariables
>;
export const MyCapabilitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyCapabilities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'context' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CapabilityContext' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myCapabilities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'context' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'context' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'canCreate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canRead' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canUpdate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canApprove' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelegate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'granted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyCapabilitiesQuery__
 *
 * To run a query within a React component, call `useMyCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCapabilitiesQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useMyCapabilitiesQuery(
  baseOptions: Apollo.QueryHookOptions<MyCapabilitiesQuery, MyCapabilitiesQueryVariables> &
    ({ variables: MyCapabilitiesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>(
    MyCapabilitiesDocument,
    options,
  );
}
export function useMyCapabilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>(
    MyCapabilitiesDocument,
    options,
  );
}
// @ts-ignore
export function useMyCapabilitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>;
export function useMyCapabilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyCapabilitiesQuery | undefined, MyCapabilitiesQueryVariables>;
export function useMyCapabilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyCapabilitiesQuery, MyCapabilitiesQueryVariables>(
    MyCapabilitiesDocument,
    options,
  );
}
export type MyCapabilitiesQueryHookResult = ReturnType<typeof useMyCapabilitiesQuery>;
export type MyCapabilitiesLazyQueryHookResult = ReturnType<typeof useMyCapabilitiesLazyQuery>;
export type MyCapabilitiesSuspenseQueryHookResult = ReturnType<
  typeof useMyCapabilitiesSuspenseQuery
>;
export type MyCapabilitiesQueryResult = Apollo.QueryResult<
  MyCapabilitiesQuery,
  MyCapabilitiesQueryVariables
>;
export const MyCapabilitiesBatchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyCapabilitiesBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contexts' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CapabilityContext' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myCapabilitiesBatch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contexts' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contexts' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'canCreate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canRead' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canUpdate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canApprove' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelegate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'granted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyCapabilitiesBatchQuery__
 *
 * To run a query within a React component, call `useMyCapabilitiesBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCapabilitiesBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCapabilitiesBatchQuery({
 *   variables: {
 *      contexts: // value for 'contexts'
 *   },
 * });
 */
export function useMyCapabilitiesBatchQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyCapabilitiesBatchQuery,
    MyCapabilitiesBatchQueryVariables
  > &
    ({ variables: MyCapabilitiesBatchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyCapabilitiesBatchQuery, MyCapabilitiesBatchQueryVariables>(
    MyCapabilitiesBatchDocument,
    options,
  );
}
export function useMyCapabilitiesBatchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyCapabilitiesBatchQuery,
    MyCapabilitiesBatchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyCapabilitiesBatchQuery, MyCapabilitiesBatchQueryVariables>(
    MyCapabilitiesBatchDocument,
    options,
  );
}
// @ts-ignore
export function useMyCapabilitiesBatchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyCapabilitiesBatchQuery,
    MyCapabilitiesBatchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyCapabilitiesBatchQuery, MyCapabilitiesBatchQueryVariables>;
export function useMyCapabilitiesBatchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyCapabilitiesBatchQuery, MyCapabilitiesBatchQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MyCapabilitiesBatchQuery | undefined,
  MyCapabilitiesBatchQueryVariables
>;
export function useMyCapabilitiesBatchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyCapabilitiesBatchQuery, MyCapabilitiesBatchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyCapabilitiesBatchQuery, MyCapabilitiesBatchQueryVariables>(
    MyCapabilitiesBatchDocument,
    options,
  );
}
export type MyCapabilitiesBatchQueryHookResult = ReturnType<typeof useMyCapabilitiesBatchQuery>;
export type MyCapabilitiesBatchLazyQueryHookResult = ReturnType<
  typeof useMyCapabilitiesBatchLazyQuery
>;
export type MyCapabilitiesBatchSuspenseQueryHookResult = ReturnType<
  typeof useMyCapabilitiesBatchSuspenseQuery
>;
export type MyCapabilitiesBatchQueryResult = Apollo.QueryResult<
  MyCapabilitiesBatchQuery,
  MyCapabilitiesBatchQueryVariables
>;
export const MyInboxDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyInbox' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskStatus' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myInbox' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deepLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresMfa' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dualControl' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jitr' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ttlMins' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'assignees' } },
                { kind: 'Field', name: { kind: 'Name', value: 'watchers' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyInboxQuery__
 *
 * To run a query within a React component, call `useMyInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInboxQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMyInboxQuery(
  baseOptions?: Apollo.QueryHookOptions<MyInboxQuery, MyInboxQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyInboxQuery, MyInboxQueryVariables>(MyInboxDocument, options);
}
export function useMyInboxLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyInboxQuery, MyInboxQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyInboxQuery, MyInboxQueryVariables>(MyInboxDocument, options);
}
// @ts-ignore
export function useMyInboxSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyInboxQuery, MyInboxQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyInboxQuery, MyInboxQueryVariables>;
export function useMyInboxSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyInboxQuery, MyInboxQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyInboxQuery | undefined, MyInboxQueryVariables>;
export function useMyInboxSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyInboxQuery, MyInboxQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyInboxQuery, MyInboxQueryVariables>(MyInboxDocument, options);
}
export type MyInboxQueryHookResult = ReturnType<typeof useMyInboxQuery>;
export type MyInboxLazyQueryHookResult = ReturnType<typeof useMyInboxLazyQuery>;
export type MyInboxSuspenseQueryHookResult = ReturnType<typeof useMyInboxSuspenseQuery>;
export type MyInboxQueryResult = Apollo.QueryResult<MyInboxQuery, MyInboxQueryVariables>;
export const MyTraversalModeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyTraversalMode' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myTraversalMode' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActorOverride' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyTraversalModeQuery__
 *
 * To run a query within a React component, call `useMyTraversalModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTraversalModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTraversalModeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTraversalModeQuery(
  baseOptions?: Apollo.QueryHookOptions<MyTraversalModeQuery, MyTraversalModeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyTraversalModeQuery, MyTraversalModeQueryVariables>(
    MyTraversalModeDocument,
    options,
  );
}
export function useMyTraversalModeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyTraversalModeQuery, MyTraversalModeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyTraversalModeQuery, MyTraversalModeQueryVariables>(
    MyTraversalModeDocument,
    options,
  );
}
// @ts-ignore
export function useMyTraversalModeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyTraversalModeQuery,
    MyTraversalModeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyTraversalModeQuery, MyTraversalModeQueryVariables>;
export function useMyTraversalModeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyTraversalModeQuery, MyTraversalModeQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyTraversalModeQuery | undefined, MyTraversalModeQueryVariables>;
export function useMyTraversalModeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyTraversalModeQuery, MyTraversalModeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyTraversalModeQuery, MyTraversalModeQueryVariables>(
    MyTraversalModeDocument,
    options,
  );
}
export type MyTraversalModeQueryHookResult = ReturnType<typeof useMyTraversalModeQuery>;
export type MyTraversalModeLazyQueryHookResult = ReturnType<typeof useMyTraversalModeLazyQuery>;
export type MyTraversalModeSuspenseQueryHookResult = ReturnType<
  typeof useMyTraversalModeSuspenseQuery
>;
export type MyTraversalModeQueryResult = Apollo.QueryResult<
  MyTraversalModeQuery,
  MyTraversalModeQueryVariables
>;
export const MyViewLayerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyViewLayer' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'myViewLayer' } }],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyViewLayerQuery__
 *
 * To run a query within a React component, call `useMyViewLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyViewLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyViewLayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyViewLayerQuery(
  baseOptions?: Apollo.QueryHookOptions<MyViewLayerQuery, MyViewLayerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyViewLayerQuery, MyViewLayerQueryVariables>(MyViewLayerDocument, options);
}
export function useMyViewLayerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyViewLayerQuery, MyViewLayerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyViewLayerQuery, MyViewLayerQueryVariables>(
    MyViewLayerDocument,
    options,
  );
}
// @ts-ignore
export function useMyViewLayerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyViewLayerQuery, MyViewLayerQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyViewLayerQuery, MyViewLayerQueryVariables>;
export function useMyViewLayerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyViewLayerQuery, MyViewLayerQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyViewLayerQuery | undefined, MyViewLayerQueryVariables>;
export function useMyViewLayerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyViewLayerQuery, MyViewLayerQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyViewLayerQuery, MyViewLayerQueryVariables>(
    MyViewLayerDocument,
    options,
  );
}
export type MyViewLayerQueryHookResult = ReturnType<typeof useMyViewLayerQuery>;
export type MyViewLayerLazyQueryHookResult = ReturnType<typeof useMyViewLayerLazyQuery>;
export type MyViewLayerSuspenseQueryHookResult = ReturnType<typeof useMyViewLayerSuspenseQuery>;
export type MyViewLayerQueryResult = Apollo.QueryResult<
  MyViewLayerQuery,
  MyViewLayerQueryVariables
>;
export const MyWitnessRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyWitnessRequests' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myWitnessRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'witnessId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'witnessRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExpired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsRemaining' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyWitnessRequestsQuery__
 *
 * To run a query within a React component, call `useMyWitnessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWitnessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWitnessRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyWitnessRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<MyWitnessRequestsQuery, MyWitnessRequestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyWitnessRequestsQuery, MyWitnessRequestsQueryVariables>(
    MyWitnessRequestsDocument,
    options,
  );
}
export function useMyWitnessRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyWitnessRequestsQuery,
    MyWitnessRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyWitnessRequestsQuery, MyWitnessRequestsQueryVariables>(
    MyWitnessRequestsDocument,
    options,
  );
}
// @ts-ignore
export function useMyWitnessRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyWitnessRequestsQuery,
    MyWitnessRequestsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyWitnessRequestsQuery, MyWitnessRequestsQueryVariables>;
export function useMyWitnessRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyWitnessRequestsQuery, MyWitnessRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MyWitnessRequestsQuery | undefined,
  MyWitnessRequestsQueryVariables
>;
export function useMyWitnessRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyWitnessRequestsQuery, MyWitnessRequestsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyWitnessRequestsQuery, MyWitnessRequestsQueryVariables>(
    MyWitnessRequestsDocument,
    options,
  );
}
export type MyWitnessRequestsQueryHookResult = ReturnType<typeof useMyWitnessRequestsQuery>;
export type MyWitnessRequestsLazyQueryHookResult = ReturnType<typeof useMyWitnessRequestsLazyQuery>;
export type MyWitnessRequestsSuspenseQueryHookResult = ReturnType<
  typeof useMyWitnessRequestsSuspenseQuery
>;
export type MyWitnessRequestsQueryResult = Apollo.QueryResult<
  MyWitnessRequestsQuery,
  MyWitnessRequestsQueryVariables
>;
export const PendingWitnessRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PendingWitnessRequests' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingWitnessRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operatorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'witnessId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'witnessRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExpired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondsRemaining' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePendingWitnessRequestsQuery__
 *
 * To run a query within a React component, call `usePendingWitnessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingWitnessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingWitnessRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingWitnessRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PendingWitnessRequestsQuery,
    PendingWitnessRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PendingWitnessRequestsQuery, PendingWitnessRequestsQueryVariables>(
    PendingWitnessRequestsDocument,
    options,
  );
}
export function usePendingWitnessRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PendingWitnessRequestsQuery,
    PendingWitnessRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PendingWitnessRequestsQuery, PendingWitnessRequestsQueryVariables>(
    PendingWitnessRequestsDocument,
    options,
  );
}
// @ts-ignore
export function usePendingWitnessRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PendingWitnessRequestsQuery,
    PendingWitnessRequestsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PendingWitnessRequestsQuery, PendingWitnessRequestsQueryVariables>;
export function usePendingWitnessRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PendingWitnessRequestsQuery,
        PendingWitnessRequestsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PendingWitnessRequestsQuery | undefined,
  PendingWitnessRequestsQueryVariables
>;
export function usePendingWitnessRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PendingWitnessRequestsQuery,
        PendingWitnessRequestsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PendingWitnessRequestsQuery, PendingWitnessRequestsQueryVariables>(
    PendingWitnessRequestsDocument,
    options,
  );
}
export type PendingWitnessRequestsQueryHookResult = ReturnType<
  typeof usePendingWitnessRequestsQuery
>;
export type PendingWitnessRequestsLazyQueryHookResult = ReturnType<
  typeof usePendingWitnessRequestsLazyQuery
>;
export type PendingWitnessRequestsSuspenseQueryHookResult = ReturnType<
  typeof usePendingWitnessRequestsSuspenseQuery
>;
export type PendingWitnessRequestsQueryResult = Apollo.QueryResult<
  PendingWitnessRequestsQuery,
  PendingWitnessRequestsQueryVariables
>;
export const RecommendStandardsPacksForCuratorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RecommendStandardsPacksForCurator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workflow' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendStandardsPacks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenant' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workflow' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workflow' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'workflowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'detectedDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'detectedComplexity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                { kind: 'Field', name: { kind: 'Name', value: 'analysisTimestamp' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'packId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'packName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoApply' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRecommendStandardsPacksForCuratorQuery__
 *
 * To run a query within a React component, call `useRecommendStandardsPacksForCuratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendStandardsPacksForCuratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendStandardsPacksForCuratorQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      workflow: // value for 'workflow'
 *   },
 * });
 */
export function useRecommendStandardsPacksForCuratorQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecommendStandardsPacksForCuratorQuery,
    RecommendStandardsPacksForCuratorQueryVariables
  > &
    (
      | { variables: RecommendStandardsPacksForCuratorQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecommendStandardsPacksForCuratorQuery,
    RecommendStandardsPacksForCuratorQueryVariables
  >(RecommendStandardsPacksForCuratorDocument, options);
}
export function useRecommendStandardsPacksForCuratorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecommendStandardsPacksForCuratorQuery,
    RecommendStandardsPacksForCuratorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecommendStandardsPacksForCuratorQuery,
    RecommendStandardsPacksForCuratorQueryVariables
  >(RecommendStandardsPacksForCuratorDocument, options);
}
// @ts-ignore
export function useRecommendStandardsPacksForCuratorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecommendStandardsPacksForCuratorQuery,
    RecommendStandardsPacksForCuratorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecommendStandardsPacksForCuratorQuery,
  RecommendStandardsPacksForCuratorQueryVariables
>;
export function useRecommendStandardsPacksForCuratorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendStandardsPacksForCuratorQuery,
        RecommendStandardsPacksForCuratorQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecommendStandardsPacksForCuratorQuery | undefined,
  RecommendStandardsPacksForCuratorQueryVariables
>;
export function useRecommendStandardsPacksForCuratorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendStandardsPacksForCuratorQuery,
        RecommendStandardsPacksForCuratorQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecommendStandardsPacksForCuratorQuery,
    RecommendStandardsPacksForCuratorQueryVariables
  >(RecommendStandardsPacksForCuratorDocument, options);
}
export type RecommendStandardsPacksForCuratorQueryHookResult = ReturnType<
  typeof useRecommendStandardsPacksForCuratorQuery
>;
export type RecommendStandardsPacksForCuratorLazyQueryHookResult = ReturnType<
  typeof useRecommendStandardsPacksForCuratorLazyQuery
>;
export type RecommendStandardsPacksForCuratorSuspenseQueryHookResult = ReturnType<
  typeof useRecommendStandardsPacksForCuratorSuspenseQuery
>;
export type RecommendStandardsPacksForCuratorQueryResult = Apollo.QueryResult<
  RecommendStandardsPacksForCuratorQuery,
  RecommendStandardsPacksForCuratorQueryVariables
>;
export const RecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Recommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adoptedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dismissedCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'practiceRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceAssociation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceAssociationLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intelligenceLayer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adoptionStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recommendsConfigs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'improves' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mitigates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRecommendationsQuery__
 *
 * To run a query within a React component, call `useRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationsQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useRecommendationsQuery(
  baseOptions: Apollo.QueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables> &
    ({ variables: RecommendationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecommendationsQuery, RecommendationsQueryVariables>(
    RecommendationsDocument,
    options,
  );
}
export function useRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecommendationsQuery, RecommendationsQueryVariables>(
    RecommendationsDocument,
    options,
  );
}
// @ts-ignore
export function useRecommendationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecommendationsQuery,
    RecommendationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RecommendationsQuery, RecommendationsQueryVariables>;
export function useRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<RecommendationsQuery | undefined, RecommendationsQueryVariables>;
export function useRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecommendationsQuery, RecommendationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RecommendationsQuery, RecommendationsQueryVariables>(
    RecommendationsDocument,
    options,
  );
}
export type RecommendationsQueryHookResult = ReturnType<typeof useRecommendationsQuery>;
export type RecommendationsLazyQueryHookResult = ReturnType<typeof useRecommendationsLazyQuery>;
export type RecommendationsSuspenseQueryHookResult = ReturnType<
  typeof useRecommendationsSuspenseQuery
>;
export type RecommendationsQueryResult = Apollo.QueryResult<
  RecommendationsQuery,
  RecommendationsQueryVariables
>;
export const RegistryOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RegistryOverview' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryOverview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'registryVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configTypeCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dimensionTableCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalDimensionCodes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valkeyIndexPattern' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasabiKeyPattern' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRegistryOverviewQuery__
 *
 * To run a query within a React component, call `useRegistryOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistryOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<RegistryOverviewQuery, RegistryOverviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegistryOverviewQuery, RegistryOverviewQueryVariables>(
    RegistryOverviewDocument,
    options,
  );
}
export function useRegistryOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RegistryOverviewQuery, RegistryOverviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegistryOverviewQuery, RegistryOverviewQueryVariables>(
    RegistryOverviewDocument,
    options,
  );
}
// @ts-ignore
export function useRegistryOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RegistryOverviewQuery,
    RegistryOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RegistryOverviewQuery, RegistryOverviewQueryVariables>;
export function useRegistryOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RegistryOverviewQuery, RegistryOverviewQueryVariables>,
): Apollo.UseSuspenseQueryResult<RegistryOverviewQuery | undefined, RegistryOverviewQueryVariables>;
export function useRegistryOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RegistryOverviewQuery, RegistryOverviewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RegistryOverviewQuery, RegistryOverviewQueryVariables>(
    RegistryOverviewDocument,
    options,
  );
}
export type RegistryOverviewQueryHookResult = ReturnType<typeof useRegistryOverviewQuery>;
export type RegistryOverviewLazyQueryHookResult = ReturnType<typeof useRegistryOverviewLazyQuery>;
export type RegistryOverviewSuspenseQueryHookResult = ReturnType<
  typeof useRegistryOverviewSuspenseQuery
>;
export type RegistryOverviewQueryResult = Apollo.QueryResult<
  RegistryOverviewQuery,
  RegistryOverviewQueryVariables
>;
export const RequestEvidenceCertificateUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RequestEvidenceCertificateUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestEvidenceCertificateUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceremonyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceremonyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresInSeconds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRequestEvidenceCertificateUrlQuery__
 *
 * To run a query within a React component, call `useRequestEvidenceCertificateUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestEvidenceCertificateUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestEvidenceCertificateUrlQuery({
 *   variables: {
 *      ceremonyId: // value for 'ceremonyId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useRequestEvidenceCertificateUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    RequestEvidenceCertificateUrlQuery,
    RequestEvidenceCertificateUrlQueryVariables
  > &
    (
      | { variables: RequestEvidenceCertificateUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RequestEvidenceCertificateUrlQuery,
    RequestEvidenceCertificateUrlQueryVariables
  >(RequestEvidenceCertificateUrlDocument, options);
}
export function useRequestEvidenceCertificateUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RequestEvidenceCertificateUrlQuery,
    RequestEvidenceCertificateUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RequestEvidenceCertificateUrlQuery,
    RequestEvidenceCertificateUrlQueryVariables
  >(RequestEvidenceCertificateUrlDocument, options);
}
// @ts-ignore
export function useRequestEvidenceCertificateUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RequestEvidenceCertificateUrlQuery,
    RequestEvidenceCertificateUrlQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RequestEvidenceCertificateUrlQuery,
  RequestEvidenceCertificateUrlQueryVariables
>;
export function useRequestEvidenceCertificateUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RequestEvidenceCertificateUrlQuery,
        RequestEvidenceCertificateUrlQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RequestEvidenceCertificateUrlQuery | undefined,
  RequestEvidenceCertificateUrlQueryVariables
>;
export function useRequestEvidenceCertificateUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RequestEvidenceCertificateUrlQuery,
        RequestEvidenceCertificateUrlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RequestEvidenceCertificateUrlQuery,
    RequestEvidenceCertificateUrlQueryVariables
  >(RequestEvidenceCertificateUrlDocument, options);
}
export type RequestEvidenceCertificateUrlQueryHookResult = ReturnType<
  typeof useRequestEvidenceCertificateUrlQuery
>;
export type RequestEvidenceCertificateUrlLazyQueryHookResult = ReturnType<
  typeof useRequestEvidenceCertificateUrlLazyQuery
>;
export type RequestEvidenceCertificateUrlSuspenseQueryHookResult = ReturnType<
  typeof useRequestEvidenceCertificateUrlSuspenseQuery
>;
export type RequestEvidenceCertificateUrlQueryResult = Apollo.QueryResult<
  RequestEvidenceCertificateUrlQuery,
  RequestEvidenceCertificateUrlQueryVariables
>;
export const ResolveSigningTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResolveSigningToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveSigningToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ceremonyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participantIndex' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participantName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participantEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alreadySigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'branding' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryColor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldX' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldY' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldWidth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldHeight' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'participantIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useResolveSigningTokenQuery__
 *
 * To run a query within a React component, call `useResolveSigningTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveSigningTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveSigningTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResolveSigningTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResolveSigningTokenQuery,
    ResolveSigningTokenQueryVariables
  > &
    ({ variables: ResolveSigningTokenQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResolveSigningTokenQuery, ResolveSigningTokenQueryVariables>(
    ResolveSigningTokenDocument,
    options,
  );
}
export function useResolveSigningTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResolveSigningTokenQuery,
    ResolveSigningTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ResolveSigningTokenQuery, ResolveSigningTokenQueryVariables>(
    ResolveSigningTokenDocument,
    options,
  );
}
// @ts-ignore
export function useResolveSigningTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResolveSigningTokenQuery,
    ResolveSigningTokenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ResolveSigningTokenQuery, ResolveSigningTokenQueryVariables>;
export function useResolveSigningTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolveSigningTokenQuery, ResolveSigningTokenQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ResolveSigningTokenQuery | undefined,
  ResolveSigningTokenQueryVariables
>;
export function useResolveSigningTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolveSigningTokenQuery, ResolveSigningTokenQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ResolveSigningTokenQuery, ResolveSigningTokenQueryVariables>(
    ResolveSigningTokenDocument,
    options,
  );
}
export type ResolveSigningTokenQueryHookResult = ReturnType<typeof useResolveSigningTokenQuery>;
export type ResolveSigningTokenLazyQueryHookResult = ReturnType<
  typeof useResolveSigningTokenLazyQuery
>;
export type ResolveSigningTokenSuspenseQueryHookResult = ReturnType<
  typeof useResolveSigningTokenSuspenseQuery
>;
export type ResolveSigningTokenQueryResult = Apollo.QueryResult<
  ResolveSigningTokenQuery,
  ResolveSigningTokenQueryVariables
>;
export const SessionConflictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SessionConflicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sessionConflicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'conflictId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceAValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceBValue' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSessionConflictsQuery__
 *
 * To run a query within a React component, call `useSessionConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionConflictsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSessionConflictsQuery(
  baseOptions: Apollo.QueryHookOptions<SessionConflictsQuery, SessionConflictsQueryVariables> &
    ({ variables: SessionConflictsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SessionConflictsQuery, SessionConflictsQueryVariables>(
    SessionConflictsDocument,
    options,
  );
}
export function useSessionConflictsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SessionConflictsQuery, SessionConflictsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SessionConflictsQuery, SessionConflictsQueryVariables>(
    SessionConflictsDocument,
    options,
  );
}
// @ts-ignore
export function useSessionConflictsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SessionConflictsQuery,
    SessionConflictsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SessionConflictsQuery, SessionConflictsQueryVariables>;
export function useSessionConflictsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SessionConflictsQuery, SessionConflictsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SessionConflictsQuery | undefined, SessionConflictsQueryVariables>;
export function useSessionConflictsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SessionConflictsQuery, SessionConflictsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SessionConflictsQuery, SessionConflictsQueryVariables>(
    SessionConflictsDocument,
    options,
  );
}
export type SessionConflictsQueryHookResult = ReturnType<typeof useSessionConflictsQuery>;
export type SessionConflictsLazyQueryHookResult = ReturnType<typeof useSessionConflictsLazyQuery>;
export type SessionConflictsSuspenseQueryHookResult = ReturnType<
  typeof useSessionConflictsSuspenseQuery
>;
export type SessionConflictsQueryResult = Apollo.QueryResult<
  SessionConflictsQuery,
  SessionConflictsQueryVariables
>;
export const SubjectJourneyTimelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubjectJourneyTimeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formsTaskSubjectJourneyTimeline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalEvents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeEventCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'constellationId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instanceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'performerCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRegulated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'constellationName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSubjectJourneyTimelineQuery__
 *
 * To run a query within a React component, call `useSubjectJourneyTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectJourneyTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectJourneyTimelineQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSubjectJourneyTimelineQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubjectJourneyTimelineQuery,
    SubjectJourneyTimelineQueryVariables
  > &
    ({ variables: SubjectJourneyTimelineQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SubjectJourneyTimelineQuery, SubjectJourneyTimelineQueryVariables>(
    SubjectJourneyTimelineDocument,
    options,
  );
}
export function useSubjectJourneyTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubjectJourneyTimelineQuery,
    SubjectJourneyTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SubjectJourneyTimelineQuery, SubjectJourneyTimelineQueryVariables>(
    SubjectJourneyTimelineDocument,
    options,
  );
}
// @ts-ignore
export function useSubjectJourneyTimelineSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SubjectJourneyTimelineQuery,
    SubjectJourneyTimelineQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SubjectJourneyTimelineQuery, SubjectJourneyTimelineQueryVariables>;
export function useSubjectJourneyTimelineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubjectJourneyTimelineQuery,
        SubjectJourneyTimelineQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SubjectJourneyTimelineQuery | undefined,
  SubjectJourneyTimelineQueryVariables
>;
export function useSubjectJourneyTimelineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubjectJourneyTimelineQuery,
        SubjectJourneyTimelineQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SubjectJourneyTimelineQuery, SubjectJourneyTimelineQueryVariables>(
    SubjectJourneyTimelineDocument,
    options,
  );
}
export type SubjectJourneyTimelineQueryHookResult = ReturnType<
  typeof useSubjectJourneyTimelineQuery
>;
export type SubjectJourneyTimelineLazyQueryHookResult = ReturnType<
  typeof useSubjectJourneyTimelineLazyQuery
>;
export type SubjectJourneyTimelineSuspenseQueryHookResult = ReturnType<
  typeof useSubjectJourneyTimelineSuspenseQuery
>;
export type SubjectJourneyTimelineQueryResult = Apollo.QueryResult<
  SubjectJourneyTimelineQuery,
  SubjectJourneyTimelineQueryVariables
>;
export const SyncConflictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SyncConflicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GqlConflictStatus' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syncConflicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'conflictId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceAValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceBValue' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSyncConflictsQuery__
 *
 * To run a query within a React component, call `useSyncConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncConflictsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSyncConflictsQuery(
  baseOptions?: Apollo.QueryHookOptions<SyncConflictsQuery, SyncConflictsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SyncConflictsQuery, SyncConflictsQueryVariables>(
    SyncConflictsDocument,
    options,
  );
}
export function useSyncConflictsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SyncConflictsQuery, SyncConflictsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SyncConflictsQuery, SyncConflictsQueryVariables>(
    SyncConflictsDocument,
    options,
  );
}
// @ts-ignore
export function useSyncConflictsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SyncConflictsQuery, SyncConflictsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SyncConflictsQuery, SyncConflictsQueryVariables>;
export function useSyncConflictsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SyncConflictsQuery, SyncConflictsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SyncConflictsQuery | undefined, SyncConflictsQueryVariables>;
export function useSyncConflictsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SyncConflictsQuery, SyncConflictsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SyncConflictsQuery, SyncConflictsQueryVariables>(
    SyncConflictsDocument,
    options,
  );
}
export type SyncConflictsQueryHookResult = ReturnType<typeof useSyncConflictsQuery>;
export type SyncConflictsLazyQueryHookResult = ReturnType<typeof useSyncConflictsLazyQuery>;
export type SyncConflictsSuspenseQueryHookResult = ReturnType<typeof useSyncConflictsSuspenseQuery>;
export type SyncConflictsQueryResult = Apollo.QueryResult<
  SyncConflictsQuery,
  SyncConflictsQueryVariables
>;
export const SyncHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SyncHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deviceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syncHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deviceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deviceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entriesReceived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entriesGrafted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entriesConflicted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chainVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archiveKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceEnvironment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSyncHistoryQuery__
 *
 * To run a query within a React component, call `useSyncHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncHistoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useSyncHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<SyncHistoryQuery, SyncHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SyncHistoryQuery, SyncHistoryQueryVariables>(SyncHistoryDocument, options);
}
export function useSyncHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SyncHistoryQuery, SyncHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SyncHistoryQuery, SyncHistoryQueryVariables>(
    SyncHistoryDocument,
    options,
  );
}
// @ts-ignore
export function useSyncHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SyncHistoryQuery, SyncHistoryQueryVariables>,
): Apollo.UseSuspenseQueryResult<SyncHistoryQuery, SyncHistoryQueryVariables>;
export function useSyncHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SyncHistoryQuery, SyncHistoryQueryVariables>,
): Apollo.UseSuspenseQueryResult<SyncHistoryQuery | undefined, SyncHistoryQueryVariables>;
export function useSyncHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SyncHistoryQuery, SyncHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SyncHistoryQuery, SyncHistoryQueryVariables>(
    SyncHistoryDocument,
    options,
  );
}
export type SyncHistoryQueryHookResult = ReturnType<typeof useSyncHistoryQuery>;
export type SyncHistoryLazyQueryHookResult = ReturnType<typeof useSyncHistoryLazyQuery>;
export type SyncHistorySuspenseQueryHookResult = ReturnType<typeof useSyncHistorySuspenseQuery>;
export type SyncHistoryQueryResult = Apollo.QueryResult<
  SyncHistoryQuery,
  SyncHistoryQueryVariables
>;
export const TranslateTermDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TranslateTerm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TranslateTermInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'translateTerm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'originalTerm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'translatedTerm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTranslateTermQuery__
 *
 * To run a query within a React component, call `useTranslateTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslateTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslateTermQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTranslateTermQuery(
  baseOptions: Apollo.QueryHookOptions<TranslateTermQuery, TranslateTermQueryVariables> &
    ({ variables: TranslateTermQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TranslateTermQuery, TranslateTermQueryVariables>(
    TranslateTermDocument,
    options,
  );
}
export function useTranslateTermLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TranslateTermQuery, TranslateTermQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TranslateTermQuery, TranslateTermQueryVariables>(
    TranslateTermDocument,
    options,
  );
}
// @ts-ignore
export function useTranslateTermSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TranslateTermQuery, TranslateTermQueryVariables>,
): Apollo.UseSuspenseQueryResult<TranslateTermQuery, TranslateTermQueryVariables>;
export function useTranslateTermSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TranslateTermQuery, TranslateTermQueryVariables>,
): Apollo.UseSuspenseQueryResult<TranslateTermQuery | undefined, TranslateTermQueryVariables>;
export function useTranslateTermSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TranslateTermQuery, TranslateTermQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TranslateTermQuery, TranslateTermQueryVariables>(
    TranslateTermDocument,
    options,
  );
}
export type TranslateTermQueryHookResult = ReturnType<typeof useTranslateTermQuery>;
export type TranslateTermLazyQueryHookResult = ReturnType<typeof useTranslateTermLazyQuery>;
export type TranslateTermSuspenseQueryHookResult = ReturnType<typeof useTranslateTermSuspenseQuery>;
export type TranslateTermQueryResult = Apollo.QueryResult<
  TranslateTermQuery,
  TranslateTermQueryVariables
>;
export const UpdateEntityQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpdateEntityQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEntityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEntity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUpdateEntityQueryQuery__
 *
 * To run a query within a React component, call `useUpdateEntityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateEntityQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityQueryQuery(
  baseOptions: Apollo.QueryHookOptions<UpdateEntityQueryQuery, UpdateEntityQueryQueryVariables> &
    ({ variables: UpdateEntityQueryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UpdateEntityQueryQuery, UpdateEntityQueryQueryVariables>(
    UpdateEntityQueryDocument,
    options,
  );
}
export function useUpdateEntityQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpdateEntityQueryQuery,
    UpdateEntityQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UpdateEntityQueryQuery, UpdateEntityQueryQueryVariables>(
    UpdateEntityQueryDocument,
    options,
  );
}
// @ts-ignore
export function useUpdateEntityQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UpdateEntityQueryQuery,
    UpdateEntityQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UpdateEntityQueryQuery, UpdateEntityQueryQueryVariables>;
export function useUpdateEntityQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UpdateEntityQueryQuery, UpdateEntityQueryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  UpdateEntityQueryQuery | undefined,
  UpdateEntityQueryQueryVariables
>;
export function useUpdateEntityQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UpdateEntityQueryQuery, UpdateEntityQueryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UpdateEntityQueryQuery, UpdateEntityQueryQueryVariables>(
    UpdateEntityQueryDocument,
    options,
  );
}
export type UpdateEntityQueryQueryHookResult = ReturnType<typeof useUpdateEntityQueryQuery>;
export type UpdateEntityQueryLazyQueryHookResult = ReturnType<typeof useUpdateEntityQueryLazyQuery>;
export type UpdateEntityQuerySuspenseQueryHookResult = ReturnType<
  typeof useUpdateEntityQuerySuspenseQuery
>;
export type UpdateEntityQueryQueryResult = Apollo.QueryResult<
  UpdateEntityQueryQuery,
  UpdateEntityQueryQueryVariables
>;
export const ZonesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Zones' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'zones' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantNum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantNum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'zoneId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zoneType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beaconMajor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beaconMinorStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beaconMinorEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'safetyLevel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elopementRelevant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeBeaconCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useZonesQuery__
 *
 * To run a query within a React component, call `useZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesQuery({
 *   variables: {
 *      tenantNum: // value for 'tenantNum'
 *   },
 * });
 */
export function useZonesQuery(
  baseOptions: Apollo.QueryHookOptions<ZonesQuery, ZonesQueryVariables> &
    ({ variables: ZonesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
}
export function useZonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ZonesQuery, ZonesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
}
// @ts-ignore
export function useZonesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ZonesQuery, ZonesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ZonesQuery, ZonesQueryVariables>;
export function useZonesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesQuery, ZonesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ZonesQuery | undefined, ZonesQueryVariables>;
export function useZonesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesQuery, ZonesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
}
export type ZonesQueryHookResult = ReturnType<typeof useZonesQuery>;
export type ZonesLazyQueryHookResult = ReturnType<typeof useZonesLazyQuery>;
export type ZonesSuspenseQueryHookResult = ReturnType<typeof useZonesSuspenseQuery>;
export type ZonesQueryResult = Apollo.QueryResult<ZonesQuery, ZonesQueryVariables>;
export const HasCompletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HasCompleted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasCompleted' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateRef' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHasCompletedQuery__
 *
 * To run a query within a React component, call `useHasCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasCompletedQuery({
 *   variables: {
 *      templateRef: // value for 'templateRef'
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useHasCompletedQuery(
  baseOptions: Apollo.QueryHookOptions<HasCompletedQuery, HasCompletedQueryVariables> &
    ({ variables: HasCompletedQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HasCompletedQuery, HasCompletedQueryVariables>(
    HasCompletedDocument,
    options,
  );
}
export function useHasCompletedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HasCompletedQuery, HasCompletedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HasCompletedQuery, HasCompletedQueryVariables>(
    HasCompletedDocument,
    options,
  );
}
// @ts-ignore
export function useHasCompletedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<HasCompletedQuery, HasCompletedQueryVariables>,
): Apollo.UseSuspenseQueryResult<HasCompletedQuery, HasCompletedQueryVariables>;
export function useHasCompletedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HasCompletedQuery, HasCompletedQueryVariables>,
): Apollo.UseSuspenseQueryResult<HasCompletedQuery | undefined, HasCompletedQueryVariables>;
export function useHasCompletedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HasCompletedQuery, HasCompletedQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HasCompletedQuery, HasCompletedQueryVariables>(
    HasCompletedDocument,
    options,
  );
}
export type HasCompletedQueryHookResult = ReturnType<typeof useHasCompletedQuery>;
export type HasCompletedLazyQueryHookResult = ReturnType<typeof useHasCompletedLazyQuery>;
export type HasCompletedSuspenseQueryHookResult = ReturnType<typeof useHasCompletedSuspenseQuery>;
export type HasCompletedQueryResult = Apollo.QueryResult<
  HasCompletedQuery,
  HasCompletedQueryVariables
>;
export const CompletionGapsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompletionGaps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'requiredActorIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionGaps' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateRef' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requiredActorIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'requiredActorIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateRef' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCompletionGapsQuery__
 *
 * To run a query within a React component, call `useCompletionGapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletionGapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletionGapsQuery({
 *   variables: {
 *      templateRef: // value for 'templateRef'
 *      requiredActorIds: // value for 'requiredActorIds'
 *   },
 * });
 */
export function useCompletionGapsQuery(
  baseOptions: Apollo.QueryHookOptions<CompletionGapsQuery, CompletionGapsQueryVariables> &
    ({ variables: CompletionGapsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompletionGapsQuery, CompletionGapsQueryVariables>(
    CompletionGapsDocument,
    options,
  );
}
export function useCompletionGapsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompletionGapsQuery, CompletionGapsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompletionGapsQuery, CompletionGapsQueryVariables>(
    CompletionGapsDocument,
    options,
  );
}
// @ts-ignore
export function useCompletionGapsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CompletionGapsQuery, CompletionGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<CompletionGapsQuery, CompletionGapsQueryVariables>;
export function useCompletionGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CompletionGapsQuery, CompletionGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<CompletionGapsQuery | undefined, CompletionGapsQueryVariables>;
export function useCompletionGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CompletionGapsQuery, CompletionGapsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CompletionGapsQuery, CompletionGapsQueryVariables>(
    CompletionGapsDocument,
    options,
  );
}
export type CompletionGapsQueryHookResult = ReturnType<typeof useCompletionGapsQuery>;
export type CompletionGapsLazyQueryHookResult = ReturnType<typeof useCompletionGapsLazyQuery>;
export type CompletionGapsSuspenseQueryHookResult = ReturnType<
  typeof useCompletionGapsSuspenseQuery
>;
export type CompletionGapsQueryResult = Apollo.QueryResult<
  CompletionGapsQuery,
  CompletionGapsQueryVariables
>;
export const ActorCompletionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActorCompletions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actorCompletions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'templateRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActorCompletionsQuery__
 *
 * To run a query within a React component, call `useActorCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorCompletionsQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useActorCompletionsQuery(
  baseOptions: Apollo.QueryHookOptions<ActorCompletionsQuery, ActorCompletionsQueryVariables> &
    ({ variables: ActorCompletionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActorCompletionsQuery, ActorCompletionsQueryVariables>(
    ActorCompletionsDocument,
    options,
  );
}
export function useActorCompletionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActorCompletionsQuery, ActorCompletionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActorCompletionsQuery, ActorCompletionsQueryVariables>(
    ActorCompletionsDocument,
    options,
  );
}
// @ts-ignore
export function useActorCompletionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActorCompletionsQuery,
    ActorCompletionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActorCompletionsQuery, ActorCompletionsQueryVariables>;
export function useActorCompletionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActorCompletionsQuery, ActorCompletionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ActorCompletionsQuery | undefined, ActorCompletionsQueryVariables>;
export function useActorCompletionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActorCompletionsQuery, ActorCompletionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActorCompletionsQuery, ActorCompletionsQueryVariables>(
    ActorCompletionsDocument,
    options,
  );
}
export type ActorCompletionsQueryHookResult = ReturnType<typeof useActorCompletionsQuery>;
export type ActorCompletionsLazyQueryHookResult = ReturnType<typeof useActorCompletionsLazyQuery>;
export type ActorCompletionsSuspenseQueryHookResult = ReturnType<
  typeof useActorCompletionsSuspenseQuery
>;
export type ActorCompletionsQueryResult = Apollo.QueryResult<
  ActorCompletionsQuery,
  ActorCompletionsQueryVariables
>;
export const ActorCompletionCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActorCompletionCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actorCompletionCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActorCompletionCountQuery__
 *
 * To run a query within a React component, call `useActorCompletionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorCompletionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorCompletionCountQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useActorCompletionCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActorCompletionCountQuery,
    ActorCompletionCountQueryVariables
  > &
    ({ variables: ActorCompletionCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActorCompletionCountQuery, ActorCompletionCountQueryVariables>(
    ActorCompletionCountDocument,
    options,
  );
}
export function useActorCompletionCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActorCompletionCountQuery,
    ActorCompletionCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActorCompletionCountQuery, ActorCompletionCountQueryVariables>(
    ActorCompletionCountDocument,
    options,
  );
}
// @ts-ignore
export function useActorCompletionCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActorCompletionCountQuery,
    ActorCompletionCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActorCompletionCountQuery, ActorCompletionCountQueryVariables>;
export function useActorCompletionCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActorCompletionCountQuery,
        ActorCompletionCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActorCompletionCountQuery | undefined,
  ActorCompletionCountQueryVariables
>;
export function useActorCompletionCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActorCompletionCountQuery,
        ActorCompletionCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActorCompletionCountQuery, ActorCompletionCountQueryVariables>(
    ActorCompletionCountDocument,
    options,
  );
}
export type ActorCompletionCountQueryHookResult = ReturnType<typeof useActorCompletionCountQuery>;
export type ActorCompletionCountLazyQueryHookResult = ReturnType<
  typeof useActorCompletionCountLazyQuery
>;
export type ActorCompletionCountSuspenseQueryHookResult = ReturnType<
  typeof useActorCompletionCountSuspenseQuery
>;
export type ActorCompletionCountQueryResult = Apollo.QueryResult<
  ActorCompletionCountQuery,
  ActorCompletionCountQueryVariables
>;
export const TemplateCompletionCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TemplateCompletionCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'templateCompletionCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateRef' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTemplateCompletionCountQuery__
 *
 * To run a query within a React component, call `useTemplateCompletionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateCompletionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateCompletionCountQuery({
 *   variables: {
 *      templateRef: // value for 'templateRef'
 *   },
 * });
 */
export function useTemplateCompletionCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    TemplateCompletionCountQuery,
    TemplateCompletionCountQueryVariables
  > &
    ({ variables: TemplateCompletionCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TemplateCompletionCountQuery, TemplateCompletionCountQueryVariables>(
    TemplateCompletionCountDocument,
    options,
  );
}
export function useTemplateCompletionCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TemplateCompletionCountQuery,
    TemplateCompletionCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TemplateCompletionCountQuery, TemplateCompletionCountQueryVariables>(
    TemplateCompletionCountDocument,
    options,
  );
}
// @ts-ignore
export function useTemplateCompletionCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TemplateCompletionCountQuery,
    TemplateCompletionCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TemplateCompletionCountQuery,
  TemplateCompletionCountQueryVariables
>;
export function useTemplateCompletionCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TemplateCompletionCountQuery,
        TemplateCompletionCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TemplateCompletionCountQuery | undefined,
  TemplateCompletionCountQueryVariables
>;
export function useTemplateCompletionCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TemplateCompletionCountQuery,
        TemplateCompletionCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TemplateCompletionCountQuery,
    TemplateCompletionCountQueryVariables
  >(TemplateCompletionCountDocument, options);
}
export type TemplateCompletionCountQueryHookResult = ReturnType<
  typeof useTemplateCompletionCountQuery
>;
export type TemplateCompletionCountLazyQueryHookResult = ReturnType<
  typeof useTemplateCompletionCountLazyQuery
>;
export type TemplateCompletionCountSuspenseQueryHookResult = ReturnType<
  typeof useTemplateCompletionCountSuspenseQuery
>;
export type TemplateCompletionCountQueryResult = Apollo.QueryResult<
  TemplateCompletionCountQuery,
  TemplateCompletionCountQueryVariables
>;
export const ExpiringCredentialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExpiringCredentials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withinDays' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expiringCredentials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateRef' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'withinDays' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'withinDays' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateRef' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useExpiringCredentialsQuery__
 *
 * To run a query within a React component, call `useExpiringCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpiringCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpiringCredentialsQuery({
 *   variables: {
 *      templateRef: // value for 'templateRef'
 *      withinDays: // value for 'withinDays'
 *   },
 * });
 */
export function useExpiringCredentialsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExpiringCredentialsQuery,
    ExpiringCredentialsQueryVariables
  > &
    ({ variables: ExpiringCredentialsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpiringCredentialsQuery, ExpiringCredentialsQueryVariables>(
    ExpiringCredentialsDocument,
    options,
  );
}
export function useExpiringCredentialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpiringCredentialsQuery,
    ExpiringCredentialsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExpiringCredentialsQuery, ExpiringCredentialsQueryVariables>(
    ExpiringCredentialsDocument,
    options,
  );
}
// @ts-ignore
export function useExpiringCredentialsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExpiringCredentialsQuery,
    ExpiringCredentialsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExpiringCredentialsQuery, ExpiringCredentialsQueryVariables>;
export function useExpiringCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExpiringCredentialsQuery, ExpiringCredentialsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ExpiringCredentialsQuery | undefined,
  ExpiringCredentialsQueryVariables
>;
export function useExpiringCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExpiringCredentialsQuery, ExpiringCredentialsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExpiringCredentialsQuery, ExpiringCredentialsQueryVariables>(
    ExpiringCredentialsDocument,
    options,
  );
}
export type ExpiringCredentialsQueryHookResult = ReturnType<typeof useExpiringCredentialsQuery>;
export type ExpiringCredentialsLazyQueryHookResult = ReturnType<
  typeof useExpiringCredentialsLazyQuery
>;
export type ExpiringCredentialsSuspenseQueryHookResult = ReturnType<
  typeof useExpiringCredentialsSuspenseQuery
>;
export type ExpiringCredentialsQueryResult = Apollo.QueryResult<
  ExpiringCredentialsQuery,
  ExpiringCredentialsQueryVariables
>;
export const ExpiredCredentialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExpiredCredentials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expiredCredentials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateRef' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useExpiredCredentialsQuery__
 *
 * To run a query within a React component, call `useExpiredCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpiredCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpiredCredentialsQuery({
 *   variables: {
 *      templateRef: // value for 'templateRef'
 *   },
 * });
 */
export function useExpiredCredentialsQuery(
  baseOptions: Apollo.QueryHookOptions<ExpiredCredentialsQuery, ExpiredCredentialsQueryVariables> &
    ({ variables: ExpiredCredentialsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpiredCredentialsQuery, ExpiredCredentialsQueryVariables>(
    ExpiredCredentialsDocument,
    options,
  );
}
export function useExpiredCredentialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpiredCredentialsQuery,
    ExpiredCredentialsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExpiredCredentialsQuery, ExpiredCredentialsQueryVariables>(
    ExpiredCredentialsDocument,
    options,
  );
}
// @ts-ignore
export function useExpiredCredentialsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExpiredCredentialsQuery,
    ExpiredCredentialsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExpiredCredentialsQuery, ExpiredCredentialsQueryVariables>;
export function useExpiredCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExpiredCredentialsQuery, ExpiredCredentialsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ExpiredCredentialsQuery | undefined,
  ExpiredCredentialsQueryVariables
>;
export function useExpiredCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExpiredCredentialsQuery, ExpiredCredentialsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExpiredCredentialsQuery, ExpiredCredentialsQueryVariables>(
    ExpiredCredentialsDocument,
    options,
  );
}
export type ExpiredCredentialsQueryHookResult = ReturnType<typeof useExpiredCredentialsQuery>;
export type ExpiredCredentialsLazyQueryHookResult = ReturnType<
  typeof useExpiredCredentialsLazyQuery
>;
export type ExpiredCredentialsSuspenseQueryHookResult = ReturnType<
  typeof useExpiredCredentialsSuspenseQuery
>;
export type ExpiredCredentialsQueryResult = Apollo.QueryResult<
  ExpiredCredentialsQuery,
  ExpiredCredentialsQueryVariables
>;
export const ActiveCredentialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActiveCredentials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeCredentials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateRef' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateRef' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActiveCredentialsQuery__
 *
 * To run a query within a React component, call `useActiveCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCredentialsQuery({
 *   variables: {
 *      templateRef: // value for 'templateRef'
 *   },
 * });
 */
export function useActiveCredentialsQuery(
  baseOptions: Apollo.QueryHookOptions<ActiveCredentialsQuery, ActiveCredentialsQueryVariables> &
    ({ variables: ActiveCredentialsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActiveCredentialsQuery, ActiveCredentialsQueryVariables>(
    ActiveCredentialsDocument,
    options,
  );
}
export function useActiveCredentialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveCredentialsQuery,
    ActiveCredentialsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActiveCredentialsQuery, ActiveCredentialsQueryVariables>(
    ActiveCredentialsDocument,
    options,
  );
}
// @ts-ignore
export function useActiveCredentialsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActiveCredentialsQuery,
    ActiveCredentialsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActiveCredentialsQuery, ActiveCredentialsQueryVariables>;
export function useActiveCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveCredentialsQuery, ActiveCredentialsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ActiveCredentialsQuery | undefined,
  ActiveCredentialsQueryVariables
>;
export function useActiveCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActiveCredentialsQuery, ActiveCredentialsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActiveCredentialsQuery, ActiveCredentialsQueryVariables>(
    ActiveCredentialsDocument,
    options,
  );
}
export type ActiveCredentialsQueryHookResult = ReturnType<typeof useActiveCredentialsQuery>;
export type ActiveCredentialsLazyQueryHookResult = ReturnType<typeof useActiveCredentialsLazyQuery>;
export type ActiveCredentialsSuspenseQueryHookResult = ReturnType<
  typeof useActiveCredentialsSuspenseQuery
>;
export type ActiveCredentialsQueryResult = Apollo.QueryResult<
  ActiveCredentialsQuery,
  ActiveCredentialsQueryVariables
>;
export const ActorGapsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActorGaps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'requiredTemplateRefs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actorGaps' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requiredTemplateRefs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'requiredTemplateRefs' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActorGapsQuery__
 *
 * To run a query within a React component, call `useActorGapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorGapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorGapsQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      requiredTemplateRefs: // value for 'requiredTemplateRefs'
 *   },
 * });
 */
export function useActorGapsQuery(
  baseOptions: Apollo.QueryHookOptions<ActorGapsQuery, ActorGapsQueryVariables> &
    ({ variables: ActorGapsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActorGapsQuery, ActorGapsQueryVariables>(ActorGapsDocument, options);
}
export function useActorGapsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActorGapsQuery, ActorGapsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActorGapsQuery, ActorGapsQueryVariables>(ActorGapsDocument, options);
}
// @ts-ignore
export function useActorGapsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ActorGapsQuery, ActorGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ActorGapsQuery, ActorGapsQueryVariables>;
export function useActorGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActorGapsQuery, ActorGapsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ActorGapsQuery | undefined, ActorGapsQueryVariables>;
export function useActorGapsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActorGapsQuery, ActorGapsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActorGapsQuery, ActorGapsQueryVariables>(
    ActorGapsDocument,
    options,
  );
}
export type ActorGapsQueryHookResult = ReturnType<typeof useActorGapsQuery>;
export type ActorGapsLazyQueryHookResult = ReturnType<typeof useActorGapsLazyQuery>;
export type ActorGapsSuspenseQueryHookResult = ReturnType<typeof useActorGapsSuspenseQuery>;
export type ActorGapsQueryResult = Apollo.QueryResult<ActorGapsQuery, ActorGapsQueryVariables>;
export const GetArchitectProposalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArchitectProposal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'architectProposal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'proposalId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'proposalId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simulation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warningCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetArchitectProposalQuery__
 *
 * To run a query within a React component, call `useGetArchitectProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchitectProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchitectProposalQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useGetArchitectProposalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetArchitectProposalQuery,
    GetArchitectProposalQueryVariables
  > &
    ({ variables: GetArchitectProposalQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetArchitectProposalQuery, GetArchitectProposalQueryVariables>(
    GetArchitectProposalDocument,
    options,
  );
}
export function useGetArchitectProposalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetArchitectProposalQuery,
    GetArchitectProposalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetArchitectProposalQuery, GetArchitectProposalQueryVariables>(
    GetArchitectProposalDocument,
    options,
  );
}
// @ts-ignore
export function useGetArchitectProposalSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetArchitectProposalQuery,
    GetArchitectProposalQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetArchitectProposalQuery, GetArchitectProposalQueryVariables>;
export function useGetArchitectProposalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetArchitectProposalQuery,
        GetArchitectProposalQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetArchitectProposalQuery | undefined,
  GetArchitectProposalQueryVariables
>;
export function useGetArchitectProposalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetArchitectProposalQuery,
        GetArchitectProposalQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetArchitectProposalQuery, GetArchitectProposalQueryVariables>(
    GetArchitectProposalDocument,
    options,
  );
}
export type GetArchitectProposalQueryHookResult = ReturnType<typeof useGetArchitectProposalQuery>;
export type GetArchitectProposalLazyQueryHookResult = ReturnType<
  typeof useGetArchitectProposalLazyQuery
>;
export type GetArchitectProposalSuspenseQueryHookResult = ReturnType<
  typeof useGetArchitectProposalSuspenseQuery
>;
export type GetArchitectProposalQueryResult = Apollo.QueryResult<
  GetArchitectProposalQuery,
  GetArchitectProposalQueryVariables
>;
export const ListArchitectProposalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListArchitectProposals' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProposalStatus' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'architectProposals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simulation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warningCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListArchitectProposalsQuery__
 *
 * To run a query within a React component, call `useListArchitectProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListArchitectProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListArchitectProposalsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListArchitectProposalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListArchitectProposalsQuery,
    ListArchitectProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListArchitectProposalsQuery, ListArchitectProposalsQueryVariables>(
    ListArchitectProposalsDocument,
    options,
  );
}
export function useListArchitectProposalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListArchitectProposalsQuery,
    ListArchitectProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListArchitectProposalsQuery, ListArchitectProposalsQueryVariables>(
    ListArchitectProposalsDocument,
    options,
  );
}
// @ts-ignore
export function useListArchitectProposalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListArchitectProposalsQuery,
    ListArchitectProposalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListArchitectProposalsQuery, ListArchitectProposalsQueryVariables>;
export function useListArchitectProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListArchitectProposalsQuery,
        ListArchitectProposalsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListArchitectProposalsQuery | undefined,
  ListArchitectProposalsQueryVariables
>;
export function useListArchitectProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListArchitectProposalsQuery,
        ListArchitectProposalsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListArchitectProposalsQuery, ListArchitectProposalsQueryVariables>(
    ListArchitectProposalsDocument,
    options,
  );
}
export type ListArchitectProposalsQueryHookResult = ReturnType<
  typeof useListArchitectProposalsQuery
>;
export type ListArchitectProposalsLazyQueryHookResult = ReturnType<
  typeof useListArchitectProposalsLazyQuery
>;
export type ListArchitectProposalsSuspenseQueryHookResult = ReturnType<
  typeof useListArchitectProposalsSuspenseQuery
>;
export type ListArchitectProposalsQueryResult = Apollo.QueryResult<
  ListArchitectProposalsQuery,
  ListArchitectProposalsQueryVariables
>;
export const GetPendingArchitectProposalsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPendingArchitectProposals' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingArchitectProposals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simulation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warningCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'proposedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPendingArchitectProposalsQuery__
 *
 * To run a query within a React component, call `useGetPendingArchitectProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingArchitectProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingArchitectProposalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingArchitectProposalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPendingArchitectProposalsQuery,
    GetPendingArchitectProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPendingArchitectProposalsQuery,
    GetPendingArchitectProposalsQueryVariables
  >(GetPendingArchitectProposalsDocument, options);
}
export function useGetPendingArchitectProposalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingArchitectProposalsQuery,
    GetPendingArchitectProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPendingArchitectProposalsQuery,
    GetPendingArchitectProposalsQueryVariables
  >(GetPendingArchitectProposalsDocument, options);
}
// @ts-ignore
export function useGetPendingArchitectProposalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingArchitectProposalsQuery,
    GetPendingArchitectProposalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPendingArchitectProposalsQuery,
  GetPendingArchitectProposalsQueryVariables
>;
export function useGetPendingArchitectProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingArchitectProposalsQuery,
        GetPendingArchitectProposalsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPendingArchitectProposalsQuery | undefined,
  GetPendingArchitectProposalsQueryVariables
>;
export function useGetPendingArchitectProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingArchitectProposalsQuery,
        GetPendingArchitectProposalsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPendingArchitectProposalsQuery,
    GetPendingArchitectProposalsQueryVariables
  >(GetPendingArchitectProposalsDocument, options);
}
export type GetPendingArchitectProposalsQueryHookResult = ReturnType<
  typeof useGetPendingArchitectProposalsQuery
>;
export type GetPendingArchitectProposalsLazyQueryHookResult = ReturnType<
  typeof useGetPendingArchitectProposalsLazyQuery
>;
export type GetPendingArchitectProposalsSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingArchitectProposalsSuspenseQuery
>;
export type GetPendingArchitectProposalsQueryResult = Apollo.QueryResult<
  GetPendingArchitectProposalsQuery,
  GetPendingArchitectProposalsQueryVariables
>;
export const HtmlPdfTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HtmlPdfTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'htmlPdfTemplates' } }],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHtmlPdfTemplatesQuery__
 *
 * To run a query within a React component, call `useHtmlPdfTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHtmlPdfTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHtmlPdfTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHtmlPdfTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>(
    HtmlPdfTemplatesDocument,
    options,
  );
}
export function useHtmlPdfTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>(
    HtmlPdfTemplatesDocument,
    options,
  );
}
// @ts-ignore
export function useHtmlPdfTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HtmlPdfTemplatesQuery,
    HtmlPdfTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>;
export function useHtmlPdfTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<HtmlPdfTemplatesQuery | undefined, HtmlPdfTemplatesQueryVariables>;
export function useHtmlPdfTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HtmlPdfTemplatesQuery, HtmlPdfTemplatesQueryVariables>(
    HtmlPdfTemplatesDocument,
    options,
  );
}
export type HtmlPdfTemplatesQueryHookResult = ReturnType<typeof useHtmlPdfTemplatesQuery>;
export type HtmlPdfTemplatesLazyQueryHookResult = ReturnType<typeof useHtmlPdfTemplatesLazyQuery>;
export type HtmlPdfTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useHtmlPdfTemplatesSuspenseQuery
>;
export type HtmlPdfTemplatesQueryResult = Apollo.QueryResult<
  HtmlPdfTemplatesQuery,
  HtmlPdfTemplatesQueryVariables
>;
export const MyAccessibleSubgraphsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyAccessibleSubgraphs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myAccessibleSubgraphs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyAccessibleSubgraphsQuery__
 *
 * To run a query within a React component, call `useMyAccessibleSubgraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccessibleSubgraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccessibleSubgraphsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useMyAccessibleSubgraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyAccessibleSubgraphsQuery,
    MyAccessibleSubgraphsQueryVariables
  > &
    ({ variables: MyAccessibleSubgraphsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyAccessibleSubgraphsQuery, MyAccessibleSubgraphsQueryVariables>(
    MyAccessibleSubgraphsDocument,
    options,
  );
}
export function useMyAccessibleSubgraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyAccessibleSubgraphsQuery,
    MyAccessibleSubgraphsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyAccessibleSubgraphsQuery, MyAccessibleSubgraphsQueryVariables>(
    MyAccessibleSubgraphsDocument,
    options,
  );
}
// @ts-ignore
export function useMyAccessibleSubgraphsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyAccessibleSubgraphsQuery,
    MyAccessibleSubgraphsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MyAccessibleSubgraphsQuery, MyAccessibleSubgraphsQueryVariables>;
export function useMyAccessibleSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyAccessibleSubgraphsQuery,
        MyAccessibleSubgraphsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MyAccessibleSubgraphsQuery | undefined,
  MyAccessibleSubgraphsQueryVariables
>;
export function useMyAccessibleSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyAccessibleSubgraphsQuery,
        MyAccessibleSubgraphsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyAccessibleSubgraphsQuery, MyAccessibleSubgraphsQueryVariables>(
    MyAccessibleSubgraphsDocument,
    options,
  );
}
export type MyAccessibleSubgraphsQueryHookResult = ReturnType<typeof useMyAccessibleSubgraphsQuery>;
export type MyAccessibleSubgraphsLazyQueryHookResult = ReturnType<
  typeof useMyAccessibleSubgraphsLazyQuery
>;
export type MyAccessibleSubgraphsSuspenseQueryHookResult = ReturnType<
  typeof useMyAccessibleSubgraphsSuspenseQuery
>;
export type MyAccessibleSubgraphsQueryResult = Apollo.QueryResult<
  MyAccessibleSubgraphsQuery,
  MyAccessibleSubgraphsQueryVariables
>;
export const MyRoleIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyRoleIds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'myRoleIds' } }],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyRoleIdsQuery__
 *
 * To run a query within a React component, call `useMyRoleIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRoleIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRoleIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRoleIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<MyRoleIdsQuery, MyRoleIdsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyRoleIdsQuery, MyRoleIdsQueryVariables>(MyRoleIdsDocument, options);
}
export function useMyRoleIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyRoleIdsQuery, MyRoleIdsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyRoleIdsQuery, MyRoleIdsQueryVariables>(MyRoleIdsDocument, options);
}
// @ts-ignore
export function useMyRoleIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyRoleIdsQuery, MyRoleIdsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyRoleIdsQuery, MyRoleIdsQueryVariables>;
export function useMyRoleIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyRoleIdsQuery, MyRoleIdsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyRoleIdsQuery | undefined, MyRoleIdsQueryVariables>;
export function useMyRoleIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyRoleIdsQuery, MyRoleIdsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyRoleIdsQuery, MyRoleIdsQueryVariables>(
    MyRoleIdsDocument,
    options,
  );
}
export type MyRoleIdsQueryHookResult = ReturnType<typeof useMyRoleIdsQuery>;
export type MyRoleIdsLazyQueryHookResult = ReturnType<typeof useMyRoleIdsLazyQuery>;
export type MyRoleIdsSuspenseQueryHookResult = ReturnType<typeof useMyRoleIdsSuspenseQuery>;
export type MyRoleIdsQueryResult = Apollo.QueryResult<MyRoleIdsQuery, MyRoleIdsQueryVariables>;
export const FhirMedicationsBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FhirMedicationsBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedicationsBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFhirMedicationsBySubjectQuery__
 *
 * To run a query within a React component, call `useFhirMedicationsBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirMedicationsBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhirMedicationsBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useFhirMedicationsBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    FhirMedicationsBySubjectQuery,
    FhirMedicationsBySubjectQueryVariables
  > &
    ({ variables: FhirMedicationsBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FhirMedicationsBySubjectQuery, FhirMedicationsBySubjectQueryVariables>(
    FhirMedicationsBySubjectDocument,
    options,
  );
}
export function useFhirMedicationsBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FhirMedicationsBySubjectQuery,
    FhirMedicationsBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FhirMedicationsBySubjectQuery, FhirMedicationsBySubjectQueryVariables>(
    FhirMedicationsBySubjectDocument,
    options,
  );
}
// @ts-ignore
export function useFhirMedicationsBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FhirMedicationsBySubjectQuery,
    FhirMedicationsBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FhirMedicationsBySubjectQuery,
  FhirMedicationsBySubjectQueryVariables
>;
export function useFhirMedicationsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedicationsBySubjectQuery,
        FhirMedicationsBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FhirMedicationsBySubjectQuery | undefined,
  FhirMedicationsBySubjectQueryVariables
>;
export function useFhirMedicationsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedicationsBySubjectQuery,
        FhirMedicationsBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FhirMedicationsBySubjectQuery,
    FhirMedicationsBySubjectQueryVariables
  >(FhirMedicationsBySubjectDocument, options);
}
export type FhirMedicationsBySubjectQueryHookResult = ReturnType<
  typeof useFhirMedicationsBySubjectQuery
>;
export type FhirMedicationsBySubjectLazyQueryHookResult = ReturnType<
  typeof useFhirMedicationsBySubjectLazyQuery
>;
export type FhirMedicationsBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useFhirMedicationsBySubjectSuspenseQuery
>;
export type FhirMedicationsBySubjectQueryResult = Apollo.QueryResult<
  FhirMedicationsBySubjectQuery,
  FhirMedicationsBySubjectQueryVariables
>;
export const FhirAllergiesBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FhirAllergiesBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirAllergiesBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFhirAllergiesBySubjectQuery__
 *
 * To run a query within a React component, call `useFhirAllergiesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirAllergiesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhirAllergiesBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useFhirAllergiesBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    FhirAllergiesBySubjectQuery,
    FhirAllergiesBySubjectQueryVariables
  > &
    ({ variables: FhirAllergiesBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FhirAllergiesBySubjectQuery, FhirAllergiesBySubjectQueryVariables>(
    FhirAllergiesBySubjectDocument,
    options,
  );
}
export function useFhirAllergiesBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FhirAllergiesBySubjectQuery,
    FhirAllergiesBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FhirAllergiesBySubjectQuery, FhirAllergiesBySubjectQueryVariables>(
    FhirAllergiesBySubjectDocument,
    options,
  );
}
// @ts-ignore
export function useFhirAllergiesBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FhirAllergiesBySubjectQuery,
    FhirAllergiesBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FhirAllergiesBySubjectQuery, FhirAllergiesBySubjectQueryVariables>;
export function useFhirAllergiesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirAllergiesBySubjectQuery,
        FhirAllergiesBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FhirAllergiesBySubjectQuery | undefined,
  FhirAllergiesBySubjectQueryVariables
>;
export function useFhirAllergiesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirAllergiesBySubjectQuery,
        FhirAllergiesBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FhirAllergiesBySubjectQuery, FhirAllergiesBySubjectQueryVariables>(
    FhirAllergiesBySubjectDocument,
    options,
  );
}
export type FhirAllergiesBySubjectQueryHookResult = ReturnType<
  typeof useFhirAllergiesBySubjectQuery
>;
export type FhirAllergiesBySubjectLazyQueryHookResult = ReturnType<
  typeof useFhirAllergiesBySubjectLazyQuery
>;
export type FhirAllergiesBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useFhirAllergiesBySubjectSuspenseQuery
>;
export type FhirAllergiesBySubjectQueryResult = Apollo.QueryResult<
  FhirAllergiesBySubjectQuery,
  FhirAllergiesBySubjectQueryVariables
>;
export const FhirMedAdminsBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FhirMedAdminsBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedAdminsBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFhirMedAdminsBySubjectQuery__
 *
 * To run a query within a React component, call `useFhirMedAdminsBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirMedAdminsBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhirMedAdminsBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFhirMedAdminsBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    FhirMedAdminsBySubjectQuery,
    FhirMedAdminsBySubjectQueryVariables
  > &
    ({ variables: FhirMedAdminsBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FhirMedAdminsBySubjectQuery, FhirMedAdminsBySubjectQueryVariables>(
    FhirMedAdminsBySubjectDocument,
    options,
  );
}
export function useFhirMedAdminsBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FhirMedAdminsBySubjectQuery,
    FhirMedAdminsBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FhirMedAdminsBySubjectQuery, FhirMedAdminsBySubjectQueryVariables>(
    FhirMedAdminsBySubjectDocument,
    options,
  );
}
// @ts-ignore
export function useFhirMedAdminsBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FhirMedAdminsBySubjectQuery,
    FhirMedAdminsBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FhirMedAdminsBySubjectQuery, FhirMedAdminsBySubjectQueryVariables>;
export function useFhirMedAdminsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedAdminsBySubjectQuery,
        FhirMedAdminsBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FhirMedAdminsBySubjectQuery | undefined,
  FhirMedAdminsBySubjectQueryVariables
>;
export function useFhirMedAdminsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedAdminsBySubjectQuery,
        FhirMedAdminsBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FhirMedAdminsBySubjectQuery, FhirMedAdminsBySubjectQueryVariables>(
    FhirMedAdminsBySubjectDocument,
    options,
  );
}
export type FhirMedAdminsBySubjectQueryHookResult = ReturnType<
  typeof useFhirMedAdminsBySubjectQuery
>;
export type FhirMedAdminsBySubjectLazyQueryHookResult = ReturnType<
  typeof useFhirMedAdminsBySubjectLazyQuery
>;
export type FhirMedAdminsBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useFhirMedAdminsBySubjectSuspenseQuery
>;
export type FhirMedAdminsBySubjectQueryResult = Apollo.QueryResult<
  FhirMedAdminsBySubjectQuery,
  FhirMedAdminsBySubjectQueryVariables
>;
export const FhirMedDispensesBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FhirMedDispensesBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedDispensesBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFhirMedDispensesBySubjectQuery__
 *
 * To run a query within a React component, call `useFhirMedDispensesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirMedDispensesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhirMedDispensesBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useFhirMedDispensesBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    FhirMedDispensesBySubjectQuery,
    FhirMedDispensesBySubjectQueryVariables
  > &
    ({ variables: FhirMedDispensesBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FhirMedDispensesBySubjectQuery, FhirMedDispensesBySubjectQueryVariables>(
    FhirMedDispensesBySubjectDocument,
    options,
  );
}
export function useFhirMedDispensesBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FhirMedDispensesBySubjectQuery,
    FhirMedDispensesBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FhirMedDispensesBySubjectQuery,
    FhirMedDispensesBySubjectQueryVariables
  >(FhirMedDispensesBySubjectDocument, options);
}
// @ts-ignore
export function useFhirMedDispensesBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FhirMedDispensesBySubjectQuery,
    FhirMedDispensesBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FhirMedDispensesBySubjectQuery,
  FhirMedDispensesBySubjectQueryVariables
>;
export function useFhirMedDispensesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedDispensesBySubjectQuery,
        FhirMedDispensesBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FhirMedDispensesBySubjectQuery | undefined,
  FhirMedDispensesBySubjectQueryVariables
>;
export function useFhirMedDispensesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedDispensesBySubjectQuery,
        FhirMedDispensesBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FhirMedDispensesBySubjectQuery,
    FhirMedDispensesBySubjectQueryVariables
  >(FhirMedDispensesBySubjectDocument, options);
}
export type FhirMedDispensesBySubjectQueryHookResult = ReturnType<
  typeof useFhirMedDispensesBySubjectQuery
>;
export type FhirMedDispensesBySubjectLazyQueryHookResult = ReturnType<
  typeof useFhirMedDispensesBySubjectLazyQuery
>;
export type FhirMedDispensesBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useFhirMedDispensesBySubjectSuspenseQuery
>;
export type FhirMedDispensesBySubjectQueryResult = Apollo.QueryResult<
  FhirMedDispensesBySubjectQuery,
  FhirMedDispensesBySubjectQueryVariables
>;
export const FhirMedStatementsBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FhirMedStatementsBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirMedStatementsBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fhirJson' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFhirMedStatementsBySubjectQuery__
 *
 * To run a query within a React component, call `useFhirMedStatementsBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirMedStatementsBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhirMedStatementsBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useFhirMedStatementsBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    FhirMedStatementsBySubjectQuery,
    FhirMedStatementsBySubjectQueryVariables
  > &
    ({ variables: FhirMedStatementsBySubjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FhirMedStatementsBySubjectQuery, FhirMedStatementsBySubjectQueryVariables>(
    FhirMedStatementsBySubjectDocument,
    options,
  );
}
export function useFhirMedStatementsBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FhirMedStatementsBySubjectQuery,
    FhirMedStatementsBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FhirMedStatementsBySubjectQuery,
    FhirMedStatementsBySubjectQueryVariables
  >(FhirMedStatementsBySubjectDocument, options);
}
// @ts-ignore
export function useFhirMedStatementsBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FhirMedStatementsBySubjectQuery,
    FhirMedStatementsBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FhirMedStatementsBySubjectQuery,
  FhirMedStatementsBySubjectQueryVariables
>;
export function useFhirMedStatementsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedStatementsBySubjectQuery,
        FhirMedStatementsBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FhirMedStatementsBySubjectQuery | undefined,
  FhirMedStatementsBySubjectQueryVariables
>;
export function useFhirMedStatementsBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirMedStatementsBySubjectQuery,
        FhirMedStatementsBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FhirMedStatementsBySubjectQuery,
    FhirMedStatementsBySubjectQueryVariables
  >(FhirMedStatementsBySubjectDocument, options);
}
export type FhirMedStatementsBySubjectQueryHookResult = ReturnType<
  typeof useFhirMedStatementsBySubjectQuery
>;
export type FhirMedStatementsBySubjectLazyQueryHookResult = ReturnType<
  typeof useFhirMedStatementsBySubjectLazyQuery
>;
export type FhirMedStatementsBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useFhirMedStatementsBySubjectSuspenseQuery
>;
export type FhirMedStatementsBySubjectQueryResult = Apollo.QueryResult<
  FhirMedStatementsBySubjectQuery,
  FhirMedStatementsBySubjectQueryVariables
>;
export const FhirPrescriptionSchedulesBySubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FhirPrescriptionSchedulesBySubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fhirPrescriptionSchedulesBySubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subjectActorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subjectActorId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFhirPrescriptionSchedulesBySubjectQuery__
 *
 * To run a query within a React component, call `useFhirPrescriptionSchedulesBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirPrescriptionSchedulesBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhirPrescriptionSchedulesBySubjectQuery({
 *   variables: {
 *      subjectActorId: // value for 'subjectActorId'
 *   },
 * });
 */
export function useFhirPrescriptionSchedulesBySubjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    FhirPrescriptionSchedulesBySubjectQuery,
    FhirPrescriptionSchedulesBySubjectQueryVariables
  > &
    (
      | { variables: FhirPrescriptionSchedulesBySubjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FhirPrescriptionSchedulesBySubjectQuery,
    FhirPrescriptionSchedulesBySubjectQueryVariables
  >(FhirPrescriptionSchedulesBySubjectDocument, options);
}
export function useFhirPrescriptionSchedulesBySubjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FhirPrescriptionSchedulesBySubjectQuery,
    FhirPrescriptionSchedulesBySubjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FhirPrescriptionSchedulesBySubjectQuery,
    FhirPrescriptionSchedulesBySubjectQueryVariables
  >(FhirPrescriptionSchedulesBySubjectDocument, options);
}
// @ts-ignore
export function useFhirPrescriptionSchedulesBySubjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FhirPrescriptionSchedulesBySubjectQuery,
    FhirPrescriptionSchedulesBySubjectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FhirPrescriptionSchedulesBySubjectQuery,
  FhirPrescriptionSchedulesBySubjectQueryVariables
>;
export function useFhirPrescriptionSchedulesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirPrescriptionSchedulesBySubjectQuery,
        FhirPrescriptionSchedulesBySubjectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FhirPrescriptionSchedulesBySubjectQuery | undefined,
  FhirPrescriptionSchedulesBySubjectQueryVariables
>;
export function useFhirPrescriptionSchedulesBySubjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FhirPrescriptionSchedulesBySubjectQuery,
        FhirPrescriptionSchedulesBySubjectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FhirPrescriptionSchedulesBySubjectQuery,
    FhirPrescriptionSchedulesBySubjectQueryVariables
  >(FhirPrescriptionSchedulesBySubjectDocument, options);
}
export type FhirPrescriptionSchedulesBySubjectQueryHookResult = ReturnType<
  typeof useFhirPrescriptionSchedulesBySubjectQuery
>;
export type FhirPrescriptionSchedulesBySubjectLazyQueryHookResult = ReturnType<
  typeof useFhirPrescriptionSchedulesBySubjectLazyQuery
>;
export type FhirPrescriptionSchedulesBySubjectSuspenseQueryHookResult = ReturnType<
  typeof useFhirPrescriptionSchedulesBySubjectSuspenseQuery
>;
export type FhirPrescriptionSchedulesBySubjectQueryResult = Apollo.QueryResult<
  FhirPrescriptionSchedulesBySubjectQuery,
  FhirPrescriptionSchedulesBySubjectQueryVariables
>;
export const FoodServiceStationOrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceStationOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'station' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FoodServiceStation' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'station' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'station' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaTargetMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elapsedSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elapsedSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modifications' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceStationOrdersQuery__
 *
 * To run a query within a React component, call `useFoodServiceStationOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceStationOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceStationOrdersQuery({
 *   variables: {
 *      station: // value for 'station'
 *   },
 * });
 */
export function useFoodServiceStationOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    FoodServiceStationOrdersQuery,
    FoodServiceStationOrdersQueryVariables
  > &
    ({ variables: FoodServiceStationOrdersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FoodServiceStationOrdersQuery, FoodServiceStationOrdersQueryVariables>(
    FoodServiceStationOrdersDocument,
    options,
  );
}
export function useFoodServiceStationOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceStationOrdersQuery,
    FoodServiceStationOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FoodServiceStationOrdersQuery, FoodServiceStationOrdersQueryVariables>(
    FoodServiceStationOrdersDocument,
    options,
  );
}
// @ts-ignore
export function useFoodServiceStationOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceStationOrdersQuery,
    FoodServiceStationOrdersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceStationOrdersQuery,
  FoodServiceStationOrdersQueryVariables
>;
export function useFoodServiceStationOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceStationOrdersQuery,
        FoodServiceStationOrdersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceStationOrdersQuery | undefined,
  FoodServiceStationOrdersQueryVariables
>;
export function useFoodServiceStationOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceStationOrdersQuery,
        FoodServiceStationOrdersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FoodServiceStationOrdersQuery,
    FoodServiceStationOrdersQueryVariables
  >(FoodServiceStationOrdersDocument, options);
}
export type FoodServiceStationOrdersQueryHookResult = ReturnType<
  typeof useFoodServiceStationOrdersQuery
>;
export type FoodServiceStationOrdersLazyQueryHookResult = ReturnType<
  typeof useFoodServiceStationOrdersLazyQuery
>;
export type FoodServiceStationOrdersSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceStationOrdersSuspenseQuery
>;
export type FoodServiceStationOrdersQueryResult = Apollo.QueryResult<
  FoodServiceStationOrdersQuery,
  FoodServiceStationOrdersQueryVariables
>;
export const FoodServiceReadyForPickupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceReadyForPickup' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'readyForPickup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaTargetMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elapsedSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deliveryAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceReadyForPickupQuery__
 *
 * To run a query within a React component, call `useFoodServiceReadyForPickupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceReadyForPickupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceReadyForPickupQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoodServiceReadyForPickupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FoodServiceReadyForPickupQuery,
    FoodServiceReadyForPickupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FoodServiceReadyForPickupQuery, FoodServiceReadyForPickupQueryVariables>(
    FoodServiceReadyForPickupDocument,
    options,
  );
}
export function useFoodServiceReadyForPickupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceReadyForPickupQuery,
    FoodServiceReadyForPickupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FoodServiceReadyForPickupQuery,
    FoodServiceReadyForPickupQueryVariables
  >(FoodServiceReadyForPickupDocument, options);
}
// @ts-ignore
export function useFoodServiceReadyForPickupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceReadyForPickupQuery,
    FoodServiceReadyForPickupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceReadyForPickupQuery,
  FoodServiceReadyForPickupQueryVariables
>;
export function useFoodServiceReadyForPickupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceReadyForPickupQuery,
        FoodServiceReadyForPickupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceReadyForPickupQuery | undefined,
  FoodServiceReadyForPickupQueryVariables
>;
export function useFoodServiceReadyForPickupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceReadyForPickupQuery,
        FoodServiceReadyForPickupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FoodServiceReadyForPickupQuery,
    FoodServiceReadyForPickupQueryVariables
  >(FoodServiceReadyForPickupDocument, options);
}
export type FoodServiceReadyForPickupQueryHookResult = ReturnType<
  typeof useFoodServiceReadyForPickupQuery
>;
export type FoodServiceReadyForPickupLazyQueryHookResult = ReturnType<
  typeof useFoodServiceReadyForPickupLazyQuery
>;
export type FoodServiceReadyForPickupSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceReadyForPickupSuspenseQuery
>;
export type FoodServiceReadyForPickupQueryResult = Apollo.QueryResult<
  FoodServiceReadyForPickupQuery,
  FoodServiceReadyForPickupQueryVariables
>;
export const FoodServicePendingQcDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServicePendingQc' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pendingQc' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elapsedSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServicePendingQcQuery__
 *
 * To run a query within a React component, call `useFoodServicePendingQcQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServicePendingQcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServicePendingQcQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoodServicePendingQcQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FoodServicePendingQcQuery,
    FoodServicePendingQcQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FoodServicePendingQcQuery, FoodServicePendingQcQueryVariables>(
    FoodServicePendingQcDocument,
    options,
  );
}
export function useFoodServicePendingQcLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServicePendingQcQuery,
    FoodServicePendingQcQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FoodServicePendingQcQuery, FoodServicePendingQcQueryVariables>(
    FoodServicePendingQcDocument,
    options,
  );
}
// @ts-ignore
export function useFoodServicePendingQcSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServicePendingQcQuery,
    FoodServicePendingQcQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FoodServicePendingQcQuery, FoodServicePendingQcQueryVariables>;
export function useFoodServicePendingQcSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServicePendingQcQuery,
        FoodServicePendingQcQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServicePendingQcQuery | undefined,
  FoodServicePendingQcQueryVariables
>;
export function useFoodServicePendingQcSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServicePendingQcQuery,
        FoodServicePendingQcQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FoodServicePendingQcQuery, FoodServicePendingQcQueryVariables>(
    FoodServicePendingQcDocument,
    options,
  );
}
export type FoodServicePendingQcQueryHookResult = ReturnType<typeof useFoodServicePendingQcQuery>;
export type FoodServicePendingQcLazyQueryHookResult = ReturnType<
  typeof useFoodServicePendingQcLazyQuery
>;
export type FoodServicePendingQcSuspenseQueryHookResult = ReturnType<
  typeof useFoodServicePendingQcSuspenseQuery
>;
export type FoodServicePendingQcQueryResult = Apollo.QueryResult<
  FoodServicePendingQcQuery,
  FoodServicePendingQcQueryVariables
>;
export const FoodServiceAvailableDriversDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceAvailableDrivers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableDrivers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentDeliveryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationLat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationLng' } },
                { kind: 'Field', name: { kind: 'Name', value: 'distanceMiles' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceAvailableDriversQuery__
 *
 * To run a query within a React component, call `useFoodServiceAvailableDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceAvailableDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceAvailableDriversQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoodServiceAvailableDriversQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FoodServiceAvailableDriversQuery,
    FoodServiceAvailableDriversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FoodServiceAvailableDriversQuery,
    FoodServiceAvailableDriversQueryVariables
  >(FoodServiceAvailableDriversDocument, options);
}
export function useFoodServiceAvailableDriversLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceAvailableDriversQuery,
    FoodServiceAvailableDriversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FoodServiceAvailableDriversQuery,
    FoodServiceAvailableDriversQueryVariables
  >(FoodServiceAvailableDriversDocument, options);
}
// @ts-ignore
export function useFoodServiceAvailableDriversSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceAvailableDriversQuery,
    FoodServiceAvailableDriversQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceAvailableDriversQuery,
  FoodServiceAvailableDriversQueryVariables
>;
export function useFoodServiceAvailableDriversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceAvailableDriversQuery,
        FoodServiceAvailableDriversQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceAvailableDriversQuery | undefined,
  FoodServiceAvailableDriversQueryVariables
>;
export function useFoodServiceAvailableDriversSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceAvailableDriversQuery,
        FoodServiceAvailableDriversQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FoodServiceAvailableDriversQuery,
    FoodServiceAvailableDriversQueryVariables
  >(FoodServiceAvailableDriversDocument, options);
}
export type FoodServiceAvailableDriversQueryHookResult = ReturnType<
  typeof useFoodServiceAvailableDriversQuery
>;
export type FoodServiceAvailableDriversLazyQueryHookResult = ReturnType<
  typeof useFoodServiceAvailableDriversLazyQuery
>;
export type FoodServiceAvailableDriversSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceAvailableDriversSuspenseQuery
>;
export type FoodServiceAvailableDriversQueryResult = Apollo.QueryResult<
  FoodServiceAvailableDriversQuery,
  FoodServiceAvailableDriversQueryVariables
>;
export const FoodServiceDriverDeliveriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceDriverDeliveries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driverDeliveries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'driverId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'driverId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deliveryAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pickedUpAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'estimatedArrivalMinutes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceDriverDeliveriesQuery__
 *
 * To run a query within a React component, call `useFoodServiceDriverDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceDriverDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceDriverDeliveriesQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useFoodServiceDriverDeliveriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FoodServiceDriverDeliveriesQuery,
    FoodServiceDriverDeliveriesQueryVariables
  > &
    ({ variables: FoodServiceDriverDeliveriesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FoodServiceDriverDeliveriesQuery,
    FoodServiceDriverDeliveriesQueryVariables
  >(FoodServiceDriverDeliveriesDocument, options);
}
export function useFoodServiceDriverDeliveriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceDriverDeliveriesQuery,
    FoodServiceDriverDeliveriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FoodServiceDriverDeliveriesQuery,
    FoodServiceDriverDeliveriesQueryVariables
  >(FoodServiceDriverDeliveriesDocument, options);
}
// @ts-ignore
export function useFoodServiceDriverDeliveriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceDriverDeliveriesQuery,
    FoodServiceDriverDeliveriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceDriverDeliveriesQuery,
  FoodServiceDriverDeliveriesQueryVariables
>;
export function useFoodServiceDriverDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceDriverDeliveriesQuery,
        FoodServiceDriverDeliveriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceDriverDeliveriesQuery | undefined,
  FoodServiceDriverDeliveriesQueryVariables
>;
export function useFoodServiceDriverDeliveriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceDriverDeliveriesQuery,
        FoodServiceDriverDeliveriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FoodServiceDriverDeliveriesQuery,
    FoodServiceDriverDeliveriesQueryVariables
  >(FoodServiceDriverDeliveriesDocument, options);
}
export type FoodServiceDriverDeliveriesQueryHookResult = ReturnType<
  typeof useFoodServiceDriverDeliveriesQuery
>;
export type FoodServiceDriverDeliveriesLazyQueryHookResult = ReturnType<
  typeof useFoodServiceDriverDeliveriesLazyQuery
>;
export type FoodServiceDriverDeliveriesSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceDriverDeliveriesSuspenseQuery
>;
export type FoodServiceDriverDeliveriesQueryResult = Apollo.QueryResult<
  FoodServiceDriverDeliveriesQuery,
  FoodServiceDriverDeliveriesQueryVariables
>;
export const FoodServiceKitchenMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceKitchenMetrics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'kitchenMetrics' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ordersToday' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ordersInProgress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgPrepTimeMinutes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ordersByBrand' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationUtilization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ordersInQueue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'avgTimeSeconds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceKitchenMetricsQuery__
 *
 * To run a query within a React component, call `useFoodServiceKitchenMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceKitchenMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceKitchenMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoodServiceKitchenMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FoodServiceKitchenMetricsQuery,
    FoodServiceKitchenMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FoodServiceKitchenMetricsQuery, FoodServiceKitchenMetricsQueryVariables>(
    FoodServiceKitchenMetricsDocument,
    options,
  );
}
export function useFoodServiceKitchenMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceKitchenMetricsQuery,
    FoodServiceKitchenMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FoodServiceKitchenMetricsQuery,
    FoodServiceKitchenMetricsQueryVariables
  >(FoodServiceKitchenMetricsDocument, options);
}
// @ts-ignore
export function useFoodServiceKitchenMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceKitchenMetricsQuery,
    FoodServiceKitchenMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceKitchenMetricsQuery,
  FoodServiceKitchenMetricsQueryVariables
>;
export function useFoodServiceKitchenMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceKitchenMetricsQuery,
        FoodServiceKitchenMetricsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceKitchenMetricsQuery | undefined,
  FoodServiceKitchenMetricsQueryVariables
>;
export function useFoodServiceKitchenMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceKitchenMetricsQuery,
        FoodServiceKitchenMetricsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FoodServiceKitchenMetricsQuery,
    FoodServiceKitchenMetricsQueryVariables
  >(FoodServiceKitchenMetricsDocument, options);
}
export type FoodServiceKitchenMetricsQueryHookResult = ReturnType<
  typeof useFoodServiceKitchenMetricsQuery
>;
export type FoodServiceKitchenMetricsLazyQueryHookResult = ReturnType<
  typeof useFoodServiceKitchenMetricsLazyQuery
>;
export type FoodServiceKitchenMetricsSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceKitchenMetricsSuspenseQuery
>;
export type FoodServiceKitchenMetricsQueryResult = Apollo.QueryResult<
  FoodServiceKitchenMetricsQuery,
  FoodServiceKitchenMetricsQueryVariables
>;
export const FoodServiceOrderStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceOrderStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slaTargetMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elapsedSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deliveryAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'specialInstructions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elapsedSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetSeconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modifications' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceOrderStatusQuery__
 *
 * To run a query within a React component, call `useFoodServiceOrderStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceOrderStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceOrderStatusQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFoodServiceOrderStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    FoodServiceOrderStatusQuery,
    FoodServiceOrderStatusQueryVariables
  > &
    ({ variables: FoodServiceOrderStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FoodServiceOrderStatusQuery, FoodServiceOrderStatusQueryVariables>(
    FoodServiceOrderStatusDocument,
    options,
  );
}
export function useFoodServiceOrderStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceOrderStatusQuery,
    FoodServiceOrderStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FoodServiceOrderStatusQuery, FoodServiceOrderStatusQueryVariables>(
    FoodServiceOrderStatusDocument,
    options,
  );
}
// @ts-ignore
export function useFoodServiceOrderStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceOrderStatusQuery,
    FoodServiceOrderStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FoodServiceOrderStatusQuery, FoodServiceOrderStatusQueryVariables>;
export function useFoodServiceOrderStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceOrderStatusQuery,
        FoodServiceOrderStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceOrderStatusQuery | undefined,
  FoodServiceOrderStatusQueryVariables
>;
export function useFoodServiceOrderStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceOrderStatusQuery,
        FoodServiceOrderStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FoodServiceOrderStatusQuery, FoodServiceOrderStatusQueryVariables>(
    FoodServiceOrderStatusDocument,
    options,
  );
}
export type FoodServiceOrderStatusQueryHookResult = ReturnType<
  typeof useFoodServiceOrderStatusQuery
>;
export type FoodServiceOrderStatusLazyQueryHookResult = ReturnType<
  typeof useFoodServiceOrderStatusLazyQuery
>;
export type FoodServiceOrderStatusSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceOrderStatusSuspenseQuery
>;
export type FoodServiceOrderStatusQueryResult = Apollo.QueryResult<
  FoodServiceOrderStatusQuery,
  FoodServiceOrderStatusQueryVariables
>;
export const FoodServiceHaccpReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceHaccpReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'haccpReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tempLogComplianceRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sanitationComplianceRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criticalViolations' } },
                { kind: 'Field', name: { kind: 'Name', value: 'correctiveActionsTaken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tempLogs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'temperatureF' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recordedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recordedByActorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inRange' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'correctiveAction' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sanitationRecords' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskGroupRef' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taskGroupName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTasks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completionPercentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedByActorId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceHaccpReportQuery__
 *
 * To run a query within a React component, call `useFoodServiceHaccpReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceHaccpReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceHaccpReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useFoodServiceHaccpReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    FoodServiceHaccpReportQuery,
    FoodServiceHaccpReportQueryVariables
  > &
    ({ variables: FoodServiceHaccpReportQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FoodServiceHaccpReportQuery, FoodServiceHaccpReportQueryVariables>(
    FoodServiceHaccpReportDocument,
    options,
  );
}
export function useFoodServiceHaccpReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceHaccpReportQuery,
    FoodServiceHaccpReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FoodServiceHaccpReportQuery, FoodServiceHaccpReportQueryVariables>(
    FoodServiceHaccpReportDocument,
    options,
  );
}
// @ts-ignore
export function useFoodServiceHaccpReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceHaccpReportQuery,
    FoodServiceHaccpReportQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FoodServiceHaccpReportQuery, FoodServiceHaccpReportQueryVariables>;
export function useFoodServiceHaccpReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceHaccpReportQuery,
        FoodServiceHaccpReportQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceHaccpReportQuery | undefined,
  FoodServiceHaccpReportQueryVariables
>;
export function useFoodServiceHaccpReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceHaccpReportQuery,
        FoodServiceHaccpReportQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FoodServiceHaccpReportQuery, FoodServiceHaccpReportQueryVariables>(
    FoodServiceHaccpReportDocument,
    options,
  );
}
export type FoodServiceHaccpReportQueryHookResult = ReturnType<
  typeof useFoodServiceHaccpReportQuery
>;
export type FoodServiceHaccpReportLazyQueryHookResult = ReturnType<
  typeof useFoodServiceHaccpReportLazyQuery
>;
export type FoodServiceHaccpReportSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceHaccpReportSuspenseQuery
>;
export type FoodServiceHaccpReportQueryResult = Apollo.QueryResult<
  FoodServiceHaccpReportQuery,
  FoodServiceHaccpReportQueryVariables
>;
export const FoodServiceMyStationAssignmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceMyStationAssignment' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myStationAssignment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'station' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceMyStationAssignmentQuery__
 *
 * To run a query within a React component, call `useFoodServiceMyStationAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceMyStationAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceMyStationAssignmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoodServiceMyStationAssignmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FoodServiceMyStationAssignmentQuery,
    FoodServiceMyStationAssignmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FoodServiceMyStationAssignmentQuery,
    FoodServiceMyStationAssignmentQueryVariables
  >(FoodServiceMyStationAssignmentDocument, options);
}
export function useFoodServiceMyStationAssignmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceMyStationAssignmentQuery,
    FoodServiceMyStationAssignmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FoodServiceMyStationAssignmentQuery,
    FoodServiceMyStationAssignmentQueryVariables
  >(FoodServiceMyStationAssignmentDocument, options);
}
// @ts-ignore
export function useFoodServiceMyStationAssignmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceMyStationAssignmentQuery,
    FoodServiceMyStationAssignmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceMyStationAssignmentQuery,
  FoodServiceMyStationAssignmentQueryVariables
>;
export function useFoodServiceMyStationAssignmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceMyStationAssignmentQuery,
        FoodServiceMyStationAssignmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceMyStationAssignmentQuery | undefined,
  FoodServiceMyStationAssignmentQueryVariables
>;
export function useFoodServiceMyStationAssignmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceMyStationAssignmentQuery,
        FoodServiceMyStationAssignmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FoodServiceMyStationAssignmentQuery,
    FoodServiceMyStationAssignmentQueryVariables
  >(FoodServiceMyStationAssignmentDocument, options);
}
export type FoodServiceMyStationAssignmentQueryHookResult = ReturnType<
  typeof useFoodServiceMyStationAssignmentQuery
>;
export type FoodServiceMyStationAssignmentLazyQueryHookResult = ReturnType<
  typeof useFoodServiceMyStationAssignmentLazyQuery
>;
export type FoodServiceMyStationAssignmentSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceMyStationAssignmentSuspenseQuery
>;
export type FoodServiceMyStationAssignmentQueryResult = Apollo.QueryResult<
  FoodServiceMyStationAssignmentQuery,
  FoodServiceMyStationAssignmentQueryVariables
>;
export const FoodServiceDriverDailyStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FoodServiceDriverDailyStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driverId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driverDailyStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'driverId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'driverId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deliveriesCompleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tipsCents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avgDeliveryMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'milesDriven' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFoodServiceDriverDailyStatsQuery__
 *
 * To run a query within a React component, call `useFoodServiceDriverDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodServiceDriverDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodServiceDriverDailyStatsQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useFoodServiceDriverDailyStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FoodServiceDriverDailyStatsQuery,
    FoodServiceDriverDailyStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FoodServiceDriverDailyStatsQuery,
    FoodServiceDriverDailyStatsQueryVariables
  >(FoodServiceDriverDailyStatsDocument, options);
}
export function useFoodServiceDriverDailyStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FoodServiceDriverDailyStatsQuery,
    FoodServiceDriverDailyStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FoodServiceDriverDailyStatsQuery,
    FoodServiceDriverDailyStatsQueryVariables
  >(FoodServiceDriverDailyStatsDocument, options);
}
// @ts-ignore
export function useFoodServiceDriverDailyStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FoodServiceDriverDailyStatsQuery,
    FoodServiceDriverDailyStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceDriverDailyStatsQuery,
  FoodServiceDriverDailyStatsQueryVariables
>;
export function useFoodServiceDriverDailyStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceDriverDailyStatsQuery,
        FoodServiceDriverDailyStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FoodServiceDriverDailyStatsQuery | undefined,
  FoodServiceDriverDailyStatsQueryVariables
>;
export function useFoodServiceDriverDailyStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FoodServiceDriverDailyStatsQuery,
        FoodServiceDriverDailyStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FoodServiceDriverDailyStatsQuery,
    FoodServiceDriverDailyStatsQueryVariables
  >(FoodServiceDriverDailyStatsDocument, options);
}
export type FoodServiceDriverDailyStatsQueryHookResult = ReturnType<
  typeof useFoodServiceDriverDailyStatsQuery
>;
export type FoodServiceDriverDailyStatsLazyQueryHookResult = ReturnType<
  typeof useFoodServiceDriverDailyStatsLazyQuery
>;
export type FoodServiceDriverDailyStatsSuspenseQueryHookResult = ReturnType<
  typeof useFoodServiceDriverDailyStatsSuspenseQuery
>;
export type FoodServiceDriverDailyStatsQueryResult = Apollo.QueryResult<
  FoodServiceDriverDailyStatsQuery,
  FoodServiceDriverDailyStatsQueryVariables
>;
export const GetTenantSubgraphConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenantSubgraphConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTenantSubgraphConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabledSubgraphIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasLifeCritical' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allRoutes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'component' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredPermissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiresLifeCriticalAuth' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allNavItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'badge' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allEntityTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pluralName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graphqlType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayField' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifierFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formSchemaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'listSchemaId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'create' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'delete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'list' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allPermissionScopes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subgraphs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'subgraphId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTenantSubgraphConfigQuery__
 *
 * To run a query within a React component, call `useGetTenantSubgraphConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSubgraphConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSubgraphConfigQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetTenantSubgraphConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTenantSubgraphConfigQuery,
    GetTenantSubgraphConfigQueryVariables
  > &
    ({ variables: GetTenantSubgraphConfigQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTenantSubgraphConfigQuery, GetTenantSubgraphConfigQueryVariables>(
    GetTenantSubgraphConfigDocument,
    options,
  );
}
export function useGetTenantSubgraphConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTenantSubgraphConfigQuery,
    GetTenantSubgraphConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTenantSubgraphConfigQuery, GetTenantSubgraphConfigQueryVariables>(
    GetTenantSubgraphConfigDocument,
    options,
  );
}
// @ts-ignore
export function useGetTenantSubgraphConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTenantSubgraphConfigQuery,
    GetTenantSubgraphConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTenantSubgraphConfigQuery,
  GetTenantSubgraphConfigQueryVariables
>;
export function useGetTenantSubgraphConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTenantSubgraphConfigQuery,
        GetTenantSubgraphConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTenantSubgraphConfigQuery | undefined,
  GetTenantSubgraphConfigQueryVariables
>;
export function useGetTenantSubgraphConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTenantSubgraphConfigQuery,
        GetTenantSubgraphConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTenantSubgraphConfigQuery,
    GetTenantSubgraphConfigQueryVariables
  >(GetTenantSubgraphConfigDocument, options);
}
export type GetTenantSubgraphConfigQueryHookResult = ReturnType<
  typeof useGetTenantSubgraphConfigQuery
>;
export type GetTenantSubgraphConfigLazyQueryHookResult = ReturnType<
  typeof useGetTenantSubgraphConfigLazyQuery
>;
export type GetTenantSubgraphConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetTenantSubgraphConfigSuspenseQuery
>;
export type GetTenantSubgraphConfigQueryResult = Apollo.QueryResult<
  GetTenantSubgraphConfigQuery,
  GetTenantSubgraphConfigQueryVariables
>;
export const ListAllSubgraphMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAllSubgraphMetadata' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listAllSubgraphMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'navItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pluralName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graphqlType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListAllSubgraphMetadataQuery__
 *
 * To run a query within a React component, call `useListAllSubgraphMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllSubgraphMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllSubgraphMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAllSubgraphMetadataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListAllSubgraphMetadataQuery,
    ListAllSubgraphMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAllSubgraphMetadataQuery, ListAllSubgraphMetadataQueryVariables>(
    ListAllSubgraphMetadataDocument,
    options,
  );
}
export function useListAllSubgraphMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAllSubgraphMetadataQuery,
    ListAllSubgraphMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAllSubgraphMetadataQuery, ListAllSubgraphMetadataQueryVariables>(
    ListAllSubgraphMetadataDocument,
    options,
  );
}
// @ts-ignore
export function useListAllSubgraphMetadataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListAllSubgraphMetadataQuery,
    ListAllSubgraphMetadataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListAllSubgraphMetadataQuery,
  ListAllSubgraphMetadataQueryVariables
>;
export function useListAllSubgraphMetadataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListAllSubgraphMetadataQuery,
        ListAllSubgraphMetadataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListAllSubgraphMetadataQuery | undefined,
  ListAllSubgraphMetadataQueryVariables
>;
export function useListAllSubgraphMetadataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListAllSubgraphMetadataQuery,
        ListAllSubgraphMetadataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListAllSubgraphMetadataQuery,
    ListAllSubgraphMetadataQueryVariables
  >(ListAllSubgraphMetadataDocument, options);
}
export type ListAllSubgraphMetadataQueryHookResult = ReturnType<
  typeof useListAllSubgraphMetadataQuery
>;
export type ListAllSubgraphMetadataLazyQueryHookResult = ReturnType<
  typeof useListAllSubgraphMetadataLazyQuery
>;
export type ListAllSubgraphMetadataSuspenseQueryHookResult = ReturnType<
  typeof useListAllSubgraphMetadataSuspenseQuery
>;
export type ListAllSubgraphMetadataQueryResult = Apollo.QueryResult<
  ListAllSubgraphMetadataQuery,
  ListAllSubgraphMetadataQueryVariables
>;
export const GetSubgraphMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubgraphMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraphId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSubgraphMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraphId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraphId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'navItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pluralName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graphqlType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayField' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifierFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formSchemaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'listSchemaId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'create' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'delete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'list' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'component' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredPermissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiresLifeCriticalAuth' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissionScopes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scope' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSubgraphMetadataQuery__
 *
 * To run a query within a React component, call `useGetSubgraphMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubgraphMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubgraphMetadataQuery({
 *   variables: {
 *      subgraphId: // value for 'subgraphId'
 *   },
 * });
 */
export function useGetSubgraphMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubgraphMetadataQuery,
    GetSubgraphMetadataQueryVariables
  > &
    ({ variables: GetSubgraphMetadataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubgraphMetadataQuery, GetSubgraphMetadataQueryVariables>(
    GetSubgraphMetadataDocument,
    options,
  );
}
export function useGetSubgraphMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubgraphMetadataQuery,
    GetSubgraphMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSubgraphMetadataQuery, GetSubgraphMetadataQueryVariables>(
    GetSubgraphMetadataDocument,
    options,
  );
}
// @ts-ignore
export function useGetSubgraphMetadataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSubgraphMetadataQuery,
    GetSubgraphMetadataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSubgraphMetadataQuery, GetSubgraphMetadataQueryVariables>;
export function useGetSubgraphMetadataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSubgraphMetadataQuery, GetSubgraphMetadataQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetSubgraphMetadataQuery | undefined,
  GetSubgraphMetadataQueryVariables
>;
export function useGetSubgraphMetadataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSubgraphMetadataQuery, GetSubgraphMetadataQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSubgraphMetadataQuery, GetSubgraphMetadataQueryVariables>(
    GetSubgraphMetadataDocument,
    options,
  );
}
export type GetSubgraphMetadataQueryHookResult = ReturnType<typeof useGetSubgraphMetadataQuery>;
export type GetSubgraphMetadataLazyQueryHookResult = ReturnType<
  typeof useGetSubgraphMetadataLazyQuery
>;
export type GetSubgraphMetadataSuspenseQueryHookResult = ReturnType<
  typeof useGetSubgraphMetadataSuspenseQuery
>;
export type GetSubgraphMetadataQueryResult = Apollo.QueryResult<
  GetSubgraphMetadataQuery,
  GetSubgraphMetadataQueryVariables
>;
export const ListLifeCriticalSubgraphsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListLifeCriticalSubgraphs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listLifeCriticalSubgraphs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subgraphs' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useListLifeCriticalSubgraphsQuery__
 *
 * To run a query within a React component, call `useListLifeCriticalSubgraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLifeCriticalSubgraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLifeCriticalSubgraphsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useListLifeCriticalSubgraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListLifeCriticalSubgraphsQuery,
    ListLifeCriticalSubgraphsQueryVariables
  > &
    ({ variables: ListLifeCriticalSubgraphsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListLifeCriticalSubgraphsQuery, ListLifeCriticalSubgraphsQueryVariables>(
    ListLifeCriticalSubgraphsDocument,
    options,
  );
}
export function useListLifeCriticalSubgraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListLifeCriticalSubgraphsQuery,
    ListLifeCriticalSubgraphsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListLifeCriticalSubgraphsQuery,
    ListLifeCriticalSubgraphsQueryVariables
  >(ListLifeCriticalSubgraphsDocument, options);
}
// @ts-ignore
export function useListLifeCriticalSubgraphsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListLifeCriticalSubgraphsQuery,
    ListLifeCriticalSubgraphsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListLifeCriticalSubgraphsQuery,
  ListLifeCriticalSubgraphsQueryVariables
>;
export function useListLifeCriticalSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListLifeCriticalSubgraphsQuery,
        ListLifeCriticalSubgraphsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListLifeCriticalSubgraphsQuery | undefined,
  ListLifeCriticalSubgraphsQueryVariables
>;
export function useListLifeCriticalSubgraphsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListLifeCriticalSubgraphsQuery,
        ListLifeCriticalSubgraphsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListLifeCriticalSubgraphsQuery,
    ListLifeCriticalSubgraphsQueryVariables
  >(ListLifeCriticalSubgraphsDocument, options);
}
export type ListLifeCriticalSubgraphsQueryHookResult = ReturnType<
  typeof useListLifeCriticalSubgraphsQuery
>;
export type ListLifeCriticalSubgraphsLazyQueryHookResult = ReturnType<
  typeof useListLifeCriticalSubgraphsLazyQuery
>;
export type ListLifeCriticalSubgraphsSuspenseQueryHookResult = ReturnType<
  typeof useListLifeCriticalSubgraphsSuspenseQuery
>;
export type ListLifeCriticalSubgraphsQueryResult = Apollo.QueryResult<
  ListLifeCriticalSubgraphsQuery,
  ListLifeCriticalSubgraphsQueryVariables
>;
export const GetAllowedNavigationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllowedNavigation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'layer' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ViewLayer' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowedNavigation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'layer' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'layer' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'navItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'badge' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'component' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredPermissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiresLifeCriticalAuth' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedEntityTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pluralName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graphqlType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayField' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifierFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formSchemaId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'listSchemaId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'create' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'delete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'list' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'complianceFrameworks' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'userScopes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAllowedNavigationQuery__
 *
 * To run a query within a React component, call `useGetAllowedNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedNavigationQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      layer: // value for 'layer'
 *   },
 * });
 */
export function useGetAllowedNavigationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllowedNavigationQuery,
    GetAllowedNavigationQueryVariables
  > &
    ({ variables: GetAllowedNavigationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllowedNavigationQuery, GetAllowedNavigationQueryVariables>(
    GetAllowedNavigationDocument,
    options,
  );
}
export function useGetAllowedNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllowedNavigationQuery,
    GetAllowedNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllowedNavigationQuery, GetAllowedNavigationQueryVariables>(
    GetAllowedNavigationDocument,
    options,
  );
}
// @ts-ignore
export function useGetAllowedNavigationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAllowedNavigationQuery,
    GetAllowedNavigationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAllowedNavigationQuery, GetAllowedNavigationQueryVariables>;
export function useGetAllowedNavigationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllowedNavigationQuery,
        GetAllowedNavigationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAllowedNavigationQuery | undefined,
  GetAllowedNavigationQueryVariables
>;
export function useGetAllowedNavigationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAllowedNavigationQuery,
        GetAllowedNavigationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAllowedNavigationQuery, GetAllowedNavigationQueryVariables>(
    GetAllowedNavigationDocument,
    options,
  );
}
export type GetAllowedNavigationQueryHookResult = ReturnType<typeof useGetAllowedNavigationQuery>;
export type GetAllowedNavigationLazyQueryHookResult = ReturnType<
  typeof useGetAllowedNavigationLazyQuery
>;
export type GetAllowedNavigationSuspenseQueryHookResult = ReturnType<
  typeof useGetAllowedNavigationSuspenseQuery
>;
export type GetAllowedNavigationQueryResult = Apollo.QueryResult<
  GetAllowedNavigationQuery,
  GetAllowedNavigationQueryVariables
>;
export const CreateSubgraphMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSubgraphMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubgraphMetadataInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubgraphMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateSubgraphMetadataMutationFn = ApolloMutationFunction<
  CreateSubgraphMetadataMutation,
  CreateSubgraphMetadataMutationVariables
>;

/**
 * __useCreateSubgraphMetadataMutation__
 *
 * To run a mutation, you first call `useCreateSubgraphMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubgraphMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubgraphMetadataMutation, { data, loading, error }] = useCreateSubgraphMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubgraphMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubgraphMetadataMutation,
    CreateSubgraphMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubgraphMetadataMutation,
    CreateSubgraphMetadataMutationVariables
  >(CreateSubgraphMetadataDocument, options);
}
export type CreateSubgraphMetadataMutationHookResult = ReturnType<
  typeof useCreateSubgraphMetadataMutation
>;
export type CreateSubgraphMetadataMutationResult =
  Apollo.MutationResult<CreateSubgraphMetadataMutation>;
export type CreateSubgraphMetadataMutationOptions = ApolloBaseMutationOptions<
  CreateSubgraphMetadataMutation,
  CreateSubgraphMetadataMutationVariables
>;
export const CreateVersionSubgraphMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateVersionSubgraphMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraphId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubgraphMetadataInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVersionSubgraphMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraphId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraphId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subgraphId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLifeCritical' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateVersionSubgraphMetadataMutationFn = ApolloMutationFunction<
  CreateVersionSubgraphMetadataMutation,
  CreateVersionSubgraphMetadataMutationVariables
>;

/**
 * __useCreateVersionSubgraphMetadataMutation__
 *
 * To run a mutation, you first call `useCreateVersionSubgraphMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVersionSubgraphMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVersionSubgraphMetadataMutation, { data, loading, error }] = useCreateVersionSubgraphMetadataMutation({
 *   variables: {
 *      subgraphId: // value for 'subgraphId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVersionSubgraphMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVersionSubgraphMetadataMutation,
    CreateVersionSubgraphMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateVersionSubgraphMetadataMutation,
    CreateVersionSubgraphMetadataMutationVariables
  >(CreateVersionSubgraphMetadataDocument, options);
}
export type CreateVersionSubgraphMetadataMutationHookResult = ReturnType<
  typeof useCreateVersionSubgraphMetadataMutation
>;
export type CreateVersionSubgraphMetadataMutationResult =
  Apollo.MutationResult<CreateVersionSubgraphMetadataMutation>;
export type CreateVersionSubgraphMetadataMutationOptions = ApolloBaseMutationOptions<
  CreateVersionSubgraphMetadataMutation,
  CreateVersionSubgraphMetadataMutationVariables
>;
export const ArchiveSubgraphMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveSubgraphMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subgraphId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveSubgraphMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subgraphId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subgraphId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archivedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ArchiveSubgraphMetadataMutationFn = ApolloMutationFunction<
  ArchiveSubgraphMetadataMutation,
  ArchiveSubgraphMetadataMutationVariables
>;

/**
 * __useArchiveSubgraphMetadataMutation__
 *
 * To run a mutation, you first call `useArchiveSubgraphMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSubgraphMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSubgraphMetadataMutation, { data, loading, error }] = useArchiveSubgraphMetadataMutation({
 *   variables: {
 *      subgraphId: // value for 'subgraphId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveSubgraphMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveSubgraphMetadataMutation,
    ArchiveSubgraphMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveSubgraphMetadataMutation,
    ArchiveSubgraphMetadataMutationVariables
  >(ArchiveSubgraphMetadataDocument, options);
}
export type ArchiveSubgraphMetadataMutationHookResult = ReturnType<
  typeof useArchiveSubgraphMetadataMutation
>;
export type ArchiveSubgraphMetadataMutationResult =
  Apollo.MutationResult<ArchiveSubgraphMetadataMutation>;
export type ArchiveSubgraphMetadataMutationOptions = ApolloBaseMutationOptions<
  ArchiveSubgraphMetadataMutation,
  ArchiveSubgraphMetadataMutationVariables
>;
